var V3 = Object.defineProperty;
var K3 = (t, e, n) => e in t ? V3(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var S = (t, e, n) => K3(t, typeof e != "symbol" ? e + "" : e, n);
import * as N from "react";
import Ye, { memo as _e, forwardRef as dc, useState as pe, useMemo as yt, useEffect as ze, useRef as le, useSyncExternalStore as PA, createContext as Ii, useContext as Vn, useId as X3, useLayoutEffect as at, useCallback as re, Fragment as UA, useDebugValue as dy, createElement as J3, useImperativeHandle as q3 } from "react";
import * as op from "react-dom";
import tx, { flushSync as uy, createPortal as hy } from "react-dom";
var En = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function uc(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var gy = { exports: {} }, Kc = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rD;
function _3() {
  if (rD) return Kc;
  rD = 1;
  var t = Ye, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, c, d) {
    var u, h = {}, g = null, p = null;
    d !== void 0 && (g = "" + d), c.key !== void 0 && (g = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (u in c) i.call(c, u) && !s.hasOwnProperty(u) && (h[u] = c[u]);
    if (a && a.defaultProps) for (u in c = a.defaultProps, c) h[u] === void 0 && (h[u] = c[u]);
    return { $$typeof: e, type: a, key: g, ref: p, props: h, _owner: r.current };
  }
  return Kc.Fragment = n, Kc.jsx = o, Kc.jsxs = o, Kc;
}
var Xc = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sD;
function $3() {
  return sD || (sD = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Ye, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), f = Symbol.iterator, M = "@@iterator";
    function m(Y) {
      if (Y === null || typeof Y != "object")
        return null;
      var _ = f && Y[f] || Y[M];
      return typeof _ == "function" ? _ : null;
    }
    var y = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function I(Y) {
      {
        for (var _ = arguments.length, fe = new Array(_ > 1 ? _ - 1 : 0), Pe = 1; Pe < _; Pe++)
          fe[Pe - 1] = arguments[Pe];
        D("error", Y, fe);
      }
    }
    function D(Y, _, fe) {
      {
        var Pe = y.ReactDebugCurrentFrame, He = Pe.getStackAddendum();
        He !== "" && (_ += "%s", fe = fe.concat([He]));
        var pt = fe.map(function(tt) {
          return String(tt);
        });
        pt.unshift("Warning: " + _), Function.prototype.apply.call(console[Y], console, pt);
      }
    }
    var j = !1, w = !1, A = !1, b = !1, T = !1, E;
    E = Symbol.for("react.module.reference");
    function v(Y) {
      return !!(typeof Y == "string" || typeof Y == "function" || Y === i || Y === s || T || Y === r || Y === d || Y === u || b || Y === p || j || w || A || typeof Y == "object" && Y !== null && (Y.$$typeof === g || Y.$$typeof === h || Y.$$typeof === o || Y.$$typeof === a || Y.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Y.$$typeof === E || Y.getModuleId !== void 0));
    }
    function P(Y, _, fe) {
      var Pe = Y.displayName;
      if (Pe)
        return Pe;
      var He = _.displayName || _.name || "";
      return He !== "" ? fe + "(" + He + ")" : fe;
    }
    function C(Y) {
      return Y.displayName || "Context";
    }
    function z(Y) {
      if (Y == null)
        return null;
      if (typeof Y.tag == "number" && I("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Y == "function")
        return Y.displayName || Y.name || null;
      if (typeof Y == "string")
        return Y;
      switch (Y) {
        case i:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case r:
          return "StrictMode";
        case d:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof Y == "object")
        switch (Y.$$typeof) {
          case a:
            var _ = Y;
            return C(_) + ".Consumer";
          case o:
            var fe = Y;
            return C(fe._context) + ".Provider";
          case c:
            return P(Y, Y.render, "ForwardRef");
          case h:
            var Pe = Y.displayName || null;
            return Pe !== null ? Pe : z(Y.type) || "Memo";
          case g: {
            var He = Y, pt = He._payload, tt = He._init;
            try {
              return z(tt(pt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var O = Object.assign, R = 0, U, F, H, Z, te, oe, me;
    function he() {
    }
    he.__reactDisabledLog = !0;
    function ve() {
      {
        if (R === 0) {
          U = console.log, F = console.info, H = console.warn, Z = console.error, te = console.group, oe = console.groupCollapsed, me = console.groupEnd;
          var Y = {
            configurable: !0,
            enumerable: !0,
            value: he,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Y,
            log: Y,
            warn: Y,
            error: Y,
            group: Y,
            groupCollapsed: Y,
            groupEnd: Y
          });
        }
        R++;
      }
    }
    function ie() {
      {
        if (R--, R === 0) {
          var Y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: O({}, Y, {
              value: U
            }),
            info: O({}, Y, {
              value: F
            }),
            warn: O({}, Y, {
              value: H
            }),
            error: O({}, Y, {
              value: Z
            }),
            group: O({}, Y, {
              value: te
            }),
            groupCollapsed: O({}, Y, {
              value: oe
            }),
            groupEnd: O({}, Y, {
              value: me
            })
          });
        }
        R < 0 && I("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ue = y.ReactCurrentDispatcher, ge;
    function Re(Y, _, fe) {
      {
        if (ge === void 0)
          try {
            throw Error();
          } catch (He) {
            var Pe = He.stack.trim().match(/\n( *(at )?)/);
            ge = Pe && Pe[1] || "";
          }
        return `
` + ge + Y;
      }
    }
    var ye = !1, Be;
    {
      var We = typeof WeakMap == "function" ? WeakMap : Map;
      Be = new We();
    }
    function lt(Y, _) {
      if (!Y || ye)
        return "";
      {
        var fe = Be.get(Y);
        if (fe !== void 0)
          return fe;
      }
      var Pe;
      ye = !0;
      var He = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var pt;
      pt = Ue.current, Ue.current = null, ve();
      try {
        if (_) {
          var tt = function() {
            throw Error();
          };
          if (Object.defineProperty(tt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(tt, []);
            } catch (xn) {
              Pe = xn;
            }
            Reflect.construct(Y, [], tt);
          } else {
            try {
              tt.call();
            } catch (xn) {
              Pe = xn;
            }
            Y.call(tt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (xn) {
            Pe = xn;
          }
          Y();
        }
      } catch (xn) {
        if (xn && Pe && typeof xn.stack == "string") {
          for (var Je = xn.stack.split(`
`), ln = Pe.stack.split(`
`), kt = Je.length - 1, ft = ln.length - 1; kt >= 1 && ft >= 0 && Je[kt] !== ln[ft]; )
            ft--;
          for (; kt >= 1 && ft >= 0; kt--, ft--)
            if (Je[kt] !== ln[ft]) {
              if (kt !== 1 || ft !== 1)
                do
                  if (kt--, ft--, ft < 0 || Je[kt] !== ln[ft]) {
                    var ei = `
` + Je[kt].replace(" at new ", " at ");
                    return Y.displayName && ei.includes("<anonymous>") && (ei = ei.replace("<anonymous>", Y.displayName)), typeof Y == "function" && Be.set(Y, ei), ei;
                  }
                while (kt >= 1 && ft >= 0);
              break;
            }
        }
      } finally {
        ye = !1, Ue.current = pt, ie(), Error.prepareStackTrace = He;
      }
      var bs = Y ? Y.displayName || Y.name : "", qr = bs ? Re(bs) : "";
      return typeof Y == "function" && Be.set(Y, qr), qr;
    }
    function $(Y, _, fe) {
      return lt(Y, !1);
    }
    function X(Y) {
      var _ = Y.prototype;
      return !!(_ && _.isReactComponent);
    }
    function Ie(Y, _, fe) {
      if (Y == null)
        return "";
      if (typeof Y == "function")
        return lt(Y, X(Y));
      if (typeof Y == "string")
        return Re(Y);
      switch (Y) {
        case d:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof Y == "object")
        switch (Y.$$typeof) {
          case c:
            return $(Y.render);
          case h:
            return Ie(Y.type, _, fe);
          case g: {
            var Pe = Y, He = Pe._payload, pt = Pe._init;
            try {
              return Ie(pt(He), _, fe);
            } catch {
            }
          }
        }
      return "";
    }
    var je = Object.prototype.hasOwnProperty, Oe = {}, zt = y.ReactDebugCurrentFrame;
    function Dt(Y) {
      if (Y) {
        var _ = Y._owner, fe = Ie(Y.type, Y._source, _ ? _.type : null);
        zt.setExtraStackFrame(fe);
      } else
        zt.setExtraStackFrame(null);
    }
    function Xr(Y, _, fe, Pe, He) {
      {
        var pt = Function.call.bind(je);
        for (var tt in Y)
          if (pt(Y, tt)) {
            var Je = void 0;
            try {
              if (typeof Y[tt] != "function") {
                var ln = Error((Pe || "React class") + ": " + fe + " type `" + tt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Y[tt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ln.name = "Invariant Violation", ln;
              }
              Je = Y[tt](_, tt, Pe, fe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (kt) {
              Je = kt;
            }
            Je && !(Je instanceof Error) && (Dt(He), I("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Pe || "React class", fe, tt, typeof Je), Dt(null)), Je instanceof Error && !(Je.message in Oe) && (Oe[Je.message] = !0, Dt(He), I("Failed %s type: %s", fe, Je.message), Dt(null));
          }
      }
    }
    var Pf = Array.isArray;
    function Uc(Y) {
      return Pf(Y);
    }
    function Uf(Y) {
      {
        var _ = typeof Symbol == "function" && Symbol.toStringTag, fe = _ && Y[Symbol.toStringTag] || Y.constructor.name || "Object";
        return fe;
      }
    }
    function Rf(Y) {
      try {
        return qd(Y), !1;
      } catch {
        return !0;
      }
    }
    function qd(Y) {
      return "" + Y;
    }
    function _d(Y) {
      if (Rf(Y))
        return I("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Uf(Y)), qd(Y);
    }
    var Tr = y.ReactCurrentOwner, Rc = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Yc, wi, $o;
    $o = {};
    function $d(Y) {
      if (je.call(Y, "ref")) {
        var _ = Object.getOwnPropertyDescriptor(Y, "ref").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return Y.ref !== void 0;
    }
    function Yf(Y) {
      if (je.call(Y, "key")) {
        var _ = Object.getOwnPropertyDescriptor(Y, "key").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return Y.key !== void 0;
    }
    function eu(Y, _) {
      if (typeof Y.ref == "string" && Tr.current && _ && Tr.current.stateNode !== _) {
        var fe = z(Tr.current.type);
        $o[fe] || (I('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(Tr.current.type), Y.ref), $o[fe] = !0);
      }
    }
    function ea(Y, _) {
      {
        var fe = function() {
          Yc || (Yc = !0, I("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        fe.isReactWarning = !0, Object.defineProperty(Y, "key", {
          get: fe,
          configurable: !0
        });
      }
    }
    function tu(Y, _) {
      {
        var fe = function() {
          wi || (wi = !0, I("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        fe.isReactWarning = !0, Object.defineProperty(Y, "ref", {
          get: fe,
          configurable: !0
        });
      }
    }
    var nu = function(Y, _, fe, Pe, He, pt, tt) {
      var Je = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: Y,
        key: _,
        ref: fe,
        props: tt,
        // Record the component responsible for creating this element.
        _owner: pt
      };
      return Je._store = {}, Object.defineProperty(Je._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Je, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Pe
      }), Object.defineProperty(Je, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: He
      }), Object.freeze && (Object.freeze(Je.props), Object.freeze(Je)), Je;
    };
    function Qf(Y, _, fe, Pe, He) {
      {
        var pt, tt = {}, Je = null, ln = null;
        fe !== void 0 && (_d(fe), Je = "" + fe), Yf(_) && (_d(_.key), Je = "" + _.key), $d(_) && (ln = _.ref, eu(_, He));
        for (pt in _)
          je.call(_, pt) && !Rc.hasOwnProperty(pt) && (tt[pt] = _[pt]);
        if (Y && Y.defaultProps) {
          var kt = Y.defaultProps;
          for (pt in kt)
            tt[pt] === void 0 && (tt[pt] = kt[pt]);
        }
        if (Je || ln) {
          var ft = typeof Y == "function" ? Y.displayName || Y.name || "Unknown" : Y;
          Je && ea(tt, ft), ln && tu(tt, ft);
        }
        return nu(Y, Je, ln, He, Pe, Tr.current, tt);
      }
    }
    var $i = y.ReactCurrentOwner, Qc = y.ReactDebugCurrentFrame;
    function Ns(Y) {
      if (Y) {
        var _ = Y._owner, fe = Ie(Y.type, Y._source, _ ? _.type : null);
        Qc.setExtraStackFrame(fe);
      } else
        Qc.setExtraStackFrame(null);
    }
    var Zc;
    Zc = !1;
    function xo(Y) {
      return typeof Y == "object" && Y !== null && Y.$$typeof === e;
    }
    function As() {
      {
        if ($i.current) {
          var Y = z($i.current.type);
          if (Y)
            return `

Check the render method of \`` + Y + "`.";
        }
        return "";
      }
    }
    function Fc(Y) {
      return "";
    }
    var ta = {};
    function Bc(Y) {
      {
        var _ = As();
        if (!_) {
          var fe = typeof Y == "string" ? Y : Y.displayName || Y.name;
          fe && (_ = `

Check the top-level render call using <` + fe + ">.");
        }
        return _;
      }
    }
    function Ts(Y, _) {
      {
        if (!Y._store || Y._store.validated || Y.key != null)
          return;
        Y._store.validated = !0;
        var fe = Bc(_);
        if (ta[fe])
          return;
        ta[fe] = !0;
        var Pe = "";
        Y && Y._owner && Y._owner !== $i.current && (Pe = " It was passed a child from " + z(Y._owner.type) + "."), Ns(Y), I('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', fe, Pe), Ns(null);
      }
    }
    function iu(Y, _) {
      {
        if (typeof Y != "object")
          return;
        if (Uc(Y))
          for (var fe = 0; fe < Y.length; fe++) {
            var Pe = Y[fe];
            xo(Pe) && Ts(Pe, _);
          }
        else if (xo(Y))
          Y._store && (Y._store.validated = !0);
        else if (Y) {
          var He = m(Y);
          if (typeof He == "function" && He !== Y.entries)
            for (var pt = He.call(Y), tt; !(tt = pt.next()).done; )
              xo(tt.value) && Ts(tt.value, _);
        }
      }
    }
    function Zf(Y) {
      {
        var _ = Y.type;
        if (_ == null || typeof _ == "string")
          return;
        var fe;
        if (typeof _ == "function")
          fe = _.propTypes;
        else if (typeof _ == "object" && (_.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        _.$$typeof === h))
          fe = _.propTypes;
        else
          return;
        if (fe) {
          var Pe = z(_);
          Xr(fe, Y.props, "prop", Pe, Y);
        } else if (_.PropTypes !== void 0 && !Zc) {
          Zc = !0;
          var He = z(_);
          I("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", He || "Unknown");
        }
        typeof _.getDefaultProps == "function" && !_.getDefaultProps.isReactClassApproved && I("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ff(Y) {
      {
        for (var _ = Object.keys(Y.props), fe = 0; fe < _.length; fe++) {
          var Pe = _[fe];
          if (Pe !== "children" && Pe !== "key") {
            Ns(Y), I("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Pe), Ns(null);
            break;
          }
        }
        Y.ref !== null && (Ns(Y), I("Invalid attribute `ref` supplied to `React.Fragment`."), Ns(null));
      }
    }
    var ru = {};
    function su(Y, _, fe, Pe, He, pt) {
      {
        var tt = v(Y);
        if (!tt) {
          var Je = "";
          (Y === void 0 || typeof Y == "object" && Y !== null && Object.keys(Y).length === 0) && (Je += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ln = Fc();
          ln ? Je += ln : Je += As();
          var kt;
          Y === null ? kt = "null" : Uc(Y) ? kt = "array" : Y !== void 0 && Y.$$typeof === e ? (kt = "<" + (z(Y.type) || "Unknown") + " />", Je = " Did you accidentally export a JSX literal instead of a component?") : kt = typeof Y, I("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", kt, Je);
        }
        var ft = Qf(Y, _, fe, He, pt);
        if (ft == null)
          return ft;
        if (tt) {
          var ei = _.children;
          if (ei !== void 0)
            if (Pe)
              if (Uc(ei)) {
                for (var bs = 0; bs < ei.length; bs++)
                  iu(ei[bs], Y);
                Object.freeze && Object.freeze(ei);
              } else
                I("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              iu(ei, Y);
        }
        if (je.call(_, "key")) {
          var qr = z(Y), xn = Object.keys(_).filter(function(Gf) {
            return Gf !== "key";
          }), Wc = xn.length > 0 ? "{key: someKey, " + xn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ru[qr + Wc]) {
            var na = xn.length > 0 ? "{" + xn.join(": ..., ") + ": ...}" : "{}";
            I(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Wc, qr, na, qr), ru[qr + Wc] = !0;
          }
        }
        return Y === i ? Ff(ft) : Zf(ft), ft;
      }
    }
    function ou(Y, _, fe) {
      return su(Y, _, fe, !0);
    }
    function Gc(Y, _, fe) {
      return su(Y, _, fe, !1);
    }
    var Jr = Gc, Bf = ou;
    Xc.Fragment = i, Xc.jsx = Jr, Xc.jsxs = Bf;
  }()), Xc;
}
process.env.NODE_ENV === "production" ? gy.exports = _3() : gy.exports = $3();
var l = gy.exports, yl = {}, py, Jc = tx;
if (process.env.NODE_ENV === "production")
  py = yl.createRoot = Jc.createRoot, yl.hydrateRoot = Jc.hydrateRoot;
else {
  var hu = Jc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  py = yl.createRoot = function(t, e) {
    hu.usingClientEntryPoint = !0;
    try {
      return Jc.createRoot(t, e);
    } finally {
      hu.usingClientEntryPoint = !1;
    }
  }, yl.hydrateRoot = function(t, e, n) {
    hu.usingClientEntryPoint = !0;
    try {
      return Jc.hydrateRoot(t, e, n);
    } finally {
      hu.usingClientEntryPoint = !1;
    }
  };
}
const e5 = {
  document: {
    store: {
      "document:document": {
        gridSize: 10,
        name: "",
        meta: {},
        id: "document:document",
        typeName: "document"
      },
      "page:page": {
        meta: {},
        id: "page:page",
        name: "Page 1",
        index: "a1",
        typeName: "page"
      },
      "shape:grid-root": {
        x: 0,
        y: 0,
        rotation: 0,
        isLocked: !1,
        opacity: 1,
        meta: {},
        id: "shape:grid-root",
        type: "grid",
        props: {
          w: 3e3,
          h: 1500,
          gridSize: 16,
          rulerUnit: "cm",
          pixelToUnit: "64",
          showRuler: !0
        },
        parentId: "page:page",
        index: "a1",
        typeName: "shape"
      },
      "shape:legend-root": {
        x: 1610,
        y: 1028,
        rotation: 0,
        isLocked: !1,
        opacity: 1,
        meta: {},
        id: "shape:legend-root",
        parentId: "shape:grid-root",
        type: "legend",
        props: {
          w: 300,
          h: 50,
          legendWidth: 16,
          legendHeight: 16,
          legendCount: 1,
          legendSize: {
            w: 16,
            h: 16
          }
        },
        index: "a1",
        typeName: "shape"
      },
      "shape:NZ8Yz1jcL93CRvGczYQaq": {
        x: 0,
        y: 0,
        rotation: 0,
        isLocked: !1,
        opacity: 1,
        meta: {},
        id: "shape:NZ8Yz1jcL93CRvGczYQaq",
        parentId: "page:z2aWMuLZ0QbYM3pHOd9NZ",
        type: "grid",
        props: {
          w: 1920,
          h: 1088,
          gridSize: 16,
          rulerUnit: "m",
          pixelToUnit: "128"
        },
        index: "a1",
        typeName: "shape"
      },
      "shape:XtbN6piHk6ri2T7_GTU1g": {
        x: 1610,
        y: 1028,
        rotation: 0,
        isLocked: !1,
        opacity: 1,
        meta: {},
        id: "shape:XtbN6piHk6ri2T7_GTU1g",
        parentId: "shape:NZ8Yz1jcL93CRvGczYQaq",
        type: "legend",
        props: {
          w: 300,
          h: 50,
          legendWidth: 16,
          legendHeight: 16,
          legendCount: 1,
          legendSize: {
            w: 16,
            h: 16
          }
        },
        index: "a1",
        typeName: "shape"
      },
      "shape:L4hz-6-DDxZMTWdSaEM1t": {
        x: 128,
        y: 112,
        rotation: 0,
        isLocked: !1,
        opacity: 1,
        meta: {},
        id: "shape:L4hz-6-DDxZMTWdSaEM1t",
        type: "wall",
        props: {
          startPoints: [
            "a1"
          ],
          decorations: {},
          points: {
            a1: {
              id: "a1",
              index: "a1",
              x: 64,
              y: 16,
              wallType: "wall",
              before: null,
              next: [
                "a21zS"
              ]
            },
            a21zS: {
              id: "a21zS",
              index: "a21zS",
              before: "a1",
              next: [
                "a38mP"
              ],
              color: "black",
              thickness: "external",
              x: 1856,
              y: 16
            },
            a38mP: {
              id: "a38mP",
              index: "a38mP",
              before: "a21zS",
              next: [
                "a4BLd"
              ],
              color: "black",
              thickness: "internal",
              x: 1856,
              y: 912
            },
            a4BLd: {
              id: "a4BLd",
              index: "a4BLd",
              before: "a38mP",
              next: [
                "a5B7g"
              ],
              color: "black",
              thickness: "internal",
              x: 576,
              y: 912
            },
            a5B7g: {
              id: "a5B7g",
              index: "a5B7g",
              before: "a4BLd",
              next: [
                "a61Gu"
              ],
              color: "black",
              thickness: "partition",
              x: 576,
              y: 400
            },
            a61Gu: {
              id: "a61Gu",
              index: "a61Gu",
              before: "a5B7g",
              next: [
                "a75Uy"
              ],
              color: "black",
              thickness: "partition",
              x: 64,
              y: 400
            },
            a75Uy: {
              id: "a75Uy",
              index: "a75Uy",
              before: "a61Gu",
              next: [
                "a8BKv"
              ],
              color: "black",
              thickness: "external",
              x: 64,
              y: 208
            },
            a8BKv: {
              id: "a8BKv",
              index: "a8BKv",
              before: "a75Uy",
              next: [],
              color: "black",
              thickness: "external",
              x: 64,
              y: 16
            }
          }
        },
        parentId: "shape:grid-root",
        index: "a203f",
        typeName: "shape"
      }
    },
    schema: {
      schemaVersion: 2,
      sequences: {
        "com.tldraw.store": 4,
        "com.tldraw.asset": 1,
        "com.tldraw.camera": 1,
        "com.tldraw.document": 2,
        "com.tldraw.instance": 25,
        "com.tldraw.instance_page_state": 5,
        "com.tldraw.page": 1,
        "com.tldraw.instance_presence": 5,
        "com.tldraw.pointer": 1,
        "com.tldraw.shape": 4,
        "com.tldraw.asset.bookmark": 2,
        "com.tldraw.asset.image": 5,
        "com.tldraw.asset.video": 5,
        "com.tldraw.shape.group": 0,
        "com.tldraw.shape.text": 2,
        "com.tldraw.shape.bookmark": 2,
        "com.tldraw.shape.draw": 2,
        "com.tldraw.shape.geo": 9,
        "com.tldraw.shape.note": 8,
        "com.tldraw.shape.line": 5,
        "com.tldraw.shape.frame": 0,
        "com.tldraw.shape.arrow": 5,
        "com.tldraw.shape.highlight": 1,
        "com.tldraw.shape.embed": 4,
        "com.tldraw.shape.image": 4,
        "com.tldraw.shape.video": 2,
        "com.tldraw.shape.legend": 0,
        "com.tldraw.shape.grid": 0,
        "com.tldraw.shape.wall": 0,
        "com.tldraw.shape.floor-planner-meta": 0,
        "com.tldraw.binding.arrow": 0
      }
    }
  },
  session: {
    version: 0,
    currentPageId: "page:page",
    exportBackground: !0,
    isFocusMode: !1,
    isDebugMode: !1,
    isToolLocked: !1,
    isGridMode: !1,
    pageStates: [
      {
        pageId: "page:page",
        camera: {
          x: 243.56430014739757,
          y: 179.7145417249685,
          z: 0.5271163248156822
        },
        selectedShapeIds: [
          "shape:L4hz-6-DDxZMTWdSaEM1t"
        ],
        focusedGroupId: null
      }
    ]
  }
}, t5 = {
  page: {}
}, ra = {
  draw: e5,
  legend: t5
}, Hf = "__TLDRAW_LIBRARY_VERSIONS__";
function n5() {
  if (globalThis[Hf])
    return globalThis[Hf];
  const t = {
    versions: [],
    didWarn: !1,
    scheduledNotice: null
  };
  return Object.defineProperty(globalThis, Hf, {
    value: t,
    writable: !1,
    configurable: !1,
    enumerable: !1
  }), t;
}
function so(t, e, n) {
  if (!t || !e || !n)
    throw new Error("Missing name/version/module system in built version of tldraw library");
  const i = n5();
  if (i.versions.push({ name: t, version: e, modules: n }), !i.scheduledNotice)
    try {
      i.scheduledNotice = setTimeout(() => {
        i.scheduledNotice = null, oD(i);
      }, 100);
    } catch {
      oD(i);
    }
}
function oD(t) {
  if (!t.versions.length || t.didWarn) return;
  const e = t.versions.sort((a, c) => aD(a.version, c.version)), n = e[e.length - 1].version, i = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Map();
  for (const a of e) {
    if (r.has(a.name)) {
      i.delete(a.name), Vf(r, a.name, /* @__PURE__ */ new Set()).add(a.version);
      continue;
    }
    a.version === n ? i.add(a.name) : (i.delete(a.name), Vf(r, a.name, /* @__PURE__ */ new Set()).add(a.version));
  }
  if (r.size > 0) {
    const a = [
      `${$r("[tldraw]", ["bold", "bgRed", "textWhite"])} ${$r("You have multiple versions of tldraw libraries installed. This can lead to bugs and unexpected behavior.", ["textRed", "bold"])}`,
      "",
      `The latest version you have installed is ${$r(`v${n}`, ["bold", "textBlue"])}. The following libraries are on the latest version:`,
      ...Array.from(i, (c) => `  • ✅ ${$r(c, ["bold"])}`),
      "",
      "The following libraries are not on the latest version, or have multiple versions installed:",
      ...Array.from(r, ([c, d]) => {
        const u = Array.from(d).sort(aD).map((h) => $r(`v${h}`, h === n ? ["textGreen"] : ["textRed"]));
        return `  • ❌ ${$r(c, ["bold"])} (${u.join(", ")})`;
      })
    ];
    console.log(a.join(`
`)), t.didWarn = !0;
    return;
  }
  const s = /* @__PURE__ */ new Map();
  for (const a of e)
    Vf(s, a.name, { version: a.version, modules: [] }).modules.push(
      a.modules
    );
  const o = /* @__PURE__ */ new Map();
  for (const [a, c] of s)
    c.modules.length > 1 && o.set(a, c);
  if (o.size > 0) {
    const a = [
      `${$r("[tldraw]", ["bold", "bgRed", "textWhite"])} ${$r("You have multiple instances of some tldraw libraries active. This can lead to bugs and unexpected behavior. ", ["textRed", "bold"])}`,
      "",
      "This usually means that your bundler is misconfigured, and is importing the same library multiple times - usually once as an ES Module, and once as a CommonJS module.",
      "",
      "The following libraries have been imported multiple times:",
      ...Array.from(o, ([c, d]) => {
        const u = d.modules.map((h, g) => h === "esm" ? `      ${g + 1}. ES Modules` : `      ${g + 1}. CommonJS`).join(`
`);
        return `  • ❌ ${$r(c, ["bold"])} v${d.version}: 
${u}`;
      }),
      "",
      "You should configure your bundler to only import one version of each library."
    ];
    console.log(a.join(`
`)), t.didWarn = !0;
    return;
  }
}
function aD(t, e) {
  const n = t.match(/^(\d+)\.(\d+)\.(\d+)(?:-(\w+))?$/), i = e.match(/^(\d+)\.(\d+)\.(\d+)(?:-(\w+))?$/);
  return !n || !i ? t.localeCompare(e) : n[1] !== i[1] ? Number(n[1]) - Number(i[1]) : n[2] !== i[2] ? Number(n[2]) - Number(i[2]) : n[3] !== i[3] ? Number(n[3]) - Number(i[3]) : n[4] && i[4] ? n[4].localeCompare(i[4]) : n[4] ? 1 : i[4] ? -1 : 0;
}
const i5 = {
  bold: "1",
  textBlue: "94",
  textRed: "31",
  textGreen: "32",
  bgRed: "41",
  textWhite: "97"
};
function $r(t, e = []) {
  return `\x1B[${e.map((n) => i5[n]).join(";")}m${t}\x1B[m`;
}
function Vf(t, e, n) {
  return t.has(e) ? t.get(e) : (t.set(e, n), n);
}
var RA = "Expected a function", cD = NaN, r5 = "[object Symbol]", s5 = /^\s+|\s+$/g, o5 = /^[-+]0x[0-9a-f]+$/i, a5 = /^0b[01]+$/i, c5 = /^0o[0-7]+$/i, l5 = parseInt, d5 = typeof En == "object" && En && En.Object === Object && En, u5 = typeof self == "object" && self && self.Object === Object && self, h5 = d5 || u5 || Function("return this")(), g5 = Object.prototype, p5 = g5.toString, f5 = Math.max, M5 = Math.min, Kf = function() {
  return h5.Date.now();
};
function m5(t, e, n) {
  var i, r, s, o, a, c, d = 0, u = !1, h = !1, g = !0;
  if (typeof t != "function")
    throw new TypeError(RA);
  e = lD(e) || 0, dg(n) && (u = !!n.leading, h = "maxWait" in n, s = h ? f5(lD(n.maxWait) || 0, e) : s, g = "trailing" in n ? !!n.trailing : g);
  function p(A) {
    var b = i, T = r;
    return i = r = void 0, d = A, o = t.apply(T, b), o;
  }
  function f(A) {
    return d = A, a = setTimeout(y, e), u ? p(A) : o;
  }
  function M(A) {
    var b = A - c, T = A - d, E = e - b;
    return h ? M5(E, s - T) : E;
  }
  function m(A) {
    var b = A - c, T = A - d;
    return c === void 0 || b >= e || b < 0 || h && T >= s;
  }
  function y() {
    var A = Kf();
    if (m(A))
      return I(A);
    a = setTimeout(y, M(A));
  }
  function I(A) {
    return a = void 0, g && i ? p(A) : (i = r = void 0, o);
  }
  function D() {
    a !== void 0 && clearTimeout(a), d = 0, i = c = r = a = void 0;
  }
  function j() {
    return a === void 0 ? o : I(Kf());
  }
  function w() {
    var A = Kf(), b = m(A);
    if (i = arguments, r = this, c = A, b) {
      if (a === void 0)
        return f(c);
      if (h)
        return a = setTimeout(y, e), p(c);
    }
    return a === void 0 && (a = setTimeout(y, e)), o;
  }
  return w.cancel = D, w.flush = j, w;
}
function y5(t, e, n) {
  var i = !0, r = !0;
  if (typeof t != "function")
    throw new TypeError(RA);
  return dg(n) && (i = "leading" in n ? !!n.leading : i, r = "trailing" in n ? !!n.trailing : r), m5(t, e, {
    leading: i,
    maxWait: e,
    trailing: r
  });
}
function dg(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function I5(t) {
  return !!t && typeof t == "object";
}
function x5(t) {
  return typeof t == "symbol" || I5(t) && p5.call(t) == r5;
}
function lD(t) {
  if (typeof t == "number")
    return t;
  if (x5(t))
    return cD;
  if (dg(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = dg(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(s5, "");
  var n = a5.test(t);
  return n || c5.test(t) ? l5(t.slice(2), n ? 2 : 8) : o5.test(t) ? cD : +t;
}
var S5 = y5;
const nx = /* @__PURE__ */ uc(S5);
var j5 = 200, ix = "__lodash_hash_undefined__", D5 = 1 / 0, w5 = "[object Function]", N5 = "[object GeneratorFunction]", A5 = /[\\^$.*+?()[\]{}|]/g, T5 = /^\[object .+?Constructor\]$/, b5 = typeof En == "object" && En && En.Object === Object && En, v5 = typeof self == "object" && self && self.Object === Object && self, rx = b5 || v5 || Function("return this")();
function E5(t, e) {
  var n = t ? t.length : 0;
  return !!n && z5(t, e, 0) > -1;
}
function C5(t, e, n, i) {
  for (var r = t.length, s = n + -1; ++s < r; )
    if (e(t[s], s, t))
      return s;
  return -1;
}
function z5(t, e, n) {
  if (e !== e)
    return C5(t, L5, n);
  for (var i = n - 1, r = t.length; ++i < r; )
    if (t[i] === e)
      return i;
  return -1;
}
function L5(t) {
  return t !== t;
}
function k5(t, e) {
  return t.has(e);
}
function O5(t, e) {
  return t == null ? void 0 : t[e];
}
function P5(t) {
  var e = !1;
  if (t != null && typeof t.toString != "function")
    try {
      e = !!(t + "");
    } catch {
    }
  return e;
}
function YA(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(i) {
    n[++e] = i;
  }), n;
}
var U5 = Array.prototype, R5 = Function.prototype, QA = Object.prototype, Xf = rx["__core-js_shared__"], dD = function() {
  var t = /[^.]+$/.exec(Xf && Xf.keys && Xf.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}(), ZA = R5.toString, sx = QA.hasOwnProperty, Y5 = QA.toString, Q5 = RegExp(
  "^" + ZA.call(sx).replace(A5, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), Z5 = U5.splice, F5 = ox(rx, "Map"), Jf = ox(rx, "Set"), Wl = ox(Object, "create");
function Lo(t) {
  var e = -1, n = t ? t.length : 0;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
function B5() {
  this.__data__ = Wl ? Wl(null) : {};
}
function G5(t) {
  return this.has(t) && delete this.__data__[t];
}
function W5(t) {
  var e = this.__data__;
  if (Wl) {
    var n = e[t];
    return n === ix ? void 0 : n;
  }
  return sx.call(e, t) ? e[t] : void 0;
}
function H5(t) {
  var e = this.__data__;
  return Wl ? e[t] !== void 0 : sx.call(e, t);
}
function V5(t, e) {
  var n = this.__data__;
  return n[t] = Wl && e === void 0 ? ix : e, this;
}
Lo.prototype.clear = B5;
Lo.prototype.delete = G5;
Lo.prototype.get = W5;
Lo.prototype.has = H5;
Lo.prototype.set = V5;
function hc(t) {
  var e = -1, n = t ? t.length : 0;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
function K5() {
  this.__data__ = [];
}
function X5(t) {
  var e = this.__data__, n = ap(e, t);
  if (n < 0)
    return !1;
  var i = e.length - 1;
  return n == i ? e.pop() : Z5.call(e, n, 1), !0;
}
function J5(t) {
  var e = this.__data__, n = ap(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function q5(t) {
  return ap(this.__data__, t) > -1;
}
function _5(t, e) {
  var n = this.__data__, i = ap(n, t);
  return i < 0 ? n.push([t, e]) : n[i][1] = e, this;
}
hc.prototype.clear = K5;
hc.prototype.delete = X5;
hc.prototype.get = J5;
hc.prototype.has = q5;
hc.prototype.set = _5;
function gc(t) {
  var e = -1, n = t ? t.length : 0;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
function $5() {
  this.__data__ = {
    hash: new Lo(),
    map: new (F5 || hc)(),
    string: new Lo()
  };
}
function eU(t) {
  return cp(this, t).delete(t);
}
function tU(t) {
  return cp(this, t).get(t);
}
function nU(t) {
  return cp(this, t).has(t);
}
function iU(t, e) {
  return cp(this, t).set(t, e), this;
}
gc.prototype.clear = $5;
gc.prototype.delete = eU;
gc.prototype.get = tU;
gc.prototype.has = nU;
gc.prototype.set = iU;
function ug(t) {
  var e = -1, n = t ? t.length : 0;
  for (this.__data__ = new gc(); ++e < n; )
    this.add(t[e]);
}
function rU(t) {
  return this.__data__.set(t, ix), this;
}
function sU(t) {
  return this.__data__.has(t);
}
ug.prototype.add = ug.prototype.push = rU;
ug.prototype.has = sU;
function ap(t, e) {
  for (var n = t.length; n--; )
    if (gU(t[n][0], e))
      return n;
  return -1;
}
function oU(t) {
  if (!FA(t) || dU(t))
    return !1;
  var e = pU(t) || P5(t) ? Q5 : T5;
  return e.test(uU(t));
}
function aU(t, e, n) {
  var i = -1, r = E5, s = t.length, o = !0, a = [], c = a;
  if (s >= j5) {
    var d = cU(t);
    if (d)
      return YA(d);
    o = !1, r = k5, c = new ug();
  } else
    c = a;
  e:
    for (; ++i < s; ) {
      var u = t[i], h = u;
      if (u = u !== 0 ? u : 0, o && h === h) {
        for (var g = c.length; g--; )
          if (c[g] === h)
            continue e;
        a.push(u);
      } else r(c, h, n) || (c !== a && c.push(h), a.push(u));
    }
  return a;
}
var cU = Jf && 1 / YA(new Jf([, -0]))[1] == D5 ? function(t) {
  return new Jf(t);
} : fU;
function cp(t, e) {
  var n = t.__data__;
  return lU(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function ox(t, e) {
  var n = O5(t, e);
  return oU(n) ? n : void 0;
}
function lU(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function dU(t) {
  return !!dD && dD in t;
}
function uU(t) {
  if (t != null) {
    try {
      return ZA.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
function hU(t) {
  return t && t.length ? aU(t) : [];
}
function gU(t, e) {
  return t === e || t !== t && e !== e;
}
function pU(t) {
  var e = FA(t) ? Y5.call(t) : "";
  return e == w5 || e == N5;
}
function FA(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function fU() {
}
var MU = hU;
const mU = /* @__PURE__ */ uc(MU), Il = {
  Good: "#40C057",
  Mid: "#FFC078",
  Poor: "#E03131"
}, yU = Il.Good;
class BA {
  constructor() {
    S(this, "startTime", 0);
    S(this, "name", "");
    S(this, "frames", 0);
    S(this, "started", !1);
    S(this, "frame", null);
    // eslint-disable-next-line local/prefer-class-methods
    S(this, "recordFrame", () => {
      this.frames++, this.started && (this.frame = requestAnimationFrame(this.recordFrame));
    });
  }
  start(e) {
    this.name = e, this.frames = 0, this.started = !0, this.frame !== null && cancelAnimationFrame(this.frame), this.frame = requestAnimationFrame(this.recordFrame), this.startTime = performance.now();
  }
  stop() {
    this.started = !1, this.frame !== null && cancelAnimationFrame(this.frame);
    const e = (performance.now() - this.startTime) / 1e3, n = e === 0 ? 0 : Math.floor(this.frames / e), i = n > 55 ? Il.Good : n > 30 ? Il.Mid : Il.Poor, r = i === Il.Mid ? "black" : "white", s = this.name[0].toUpperCase() + this.name.slice(1);
    console.debug(
      `%cPerf%c ${s} %c${n}%c fps`,
      `color: white; background: ${yU};padding: 2px;border-radius: 3px;`,
      "font-weight: normal",
      `font-weight: bold; padding: 2px; background: ${i};color: ${r};`,
      "font-weight: normal"
    );
  }
  isStarted() {
    return this.started;
  }
}
function ax(t, e) {
  const n = [];
  e: for (const i of t) {
    for (const r of n)
      if (e ? e(i, r) : i === r)
        continue e;
    n.push(i);
  }
  return n;
}
function Ze(t) {
  return t.filter((e) => e != null);
}
function pn(t) {
  return t[t.length - 1];
}
function IU(t, e) {
  let n, i = 1 / 0;
  for (const r of t) {
    const s = e(r);
    s < i && (n = r, i = s);
  }
  return n;
}
function xU(t, e) {
  if (t === e) return !0;
  if (t.length !== e.length) return !1;
  for (let n = 0; n < t.length; n++)
    if (!Object.is(t[n], e[n]))
      return !1;
  return !0;
}
function GA(t) {
  const e = (...n) => {
    try {
      return t(...n);
    } catch (i) {
      throw i instanceof Error && Error.captureStackTrace && Error.captureStackTrace(i, e), i;
    }
  };
  return e;
}
const Hl = () => {
}, Rr = {
  ok(t) {
    return { ok: !0, value: t };
  },
  err(t) {
    return { ok: !1, error: t };
  }
};
function rn(t, e) {
  const n = e && t && typeof t == "object" && e in t ? t[e] : t;
  throw new Error(`Unknown switch case ${n}`);
}
const ct = GA(
  (t, e) => {
    if (!t)
      throw new Error(e || "Assertion Error");
  }
), oi = GA((t, e) => {
  if (t == null)
    throw new Error(e ?? "value must be defined");
  return t;
});
function cx() {
  let t, e;
  const n = new Promise((i, r) => {
    t = i, e = r;
  });
  return Object.assign(n, {
    resolve: t,
    reject: e
  });
}
function fy(t) {
  return new Promise((e) => setTimeout(e, t));
}
function di(...t) {
  if (t.length === 2) {
    const [e, n] = t;
    n.addInitializer(function() {
      ct(Reflect.isExtensible(this), "Cannot bind to a non-extensible class.");
      const r = e.bind(this), s = Reflect.defineProperty(this, n.name, {
        value: r,
        writable: !0,
        configurable: !0
      });
      ct(s, "Cannot bind a non-configurable class method.");
    });
  } else {
    const [e, n, i] = t;
    if (!i || typeof i.value != "function")
      throw new TypeError(
        `Only methods can be decorated with @bind. <${n}> is not a method!`
      );
    return {
      configurable: !0,
      get() {
        const r = i.value.bind(this);
        return Object.defineProperty(this, n, {
          value: r,
          configurable: !0,
          writable: !0
        }), r;
      }
    };
  }
}
class hr {
  constructor() {
    /** The map of items to their cached values. */
    S(this, "items", /* @__PURE__ */ new WeakMap());
  }
  /**
   * Get the cached value for a given record. If the record is not present in the map, the callback
   * will be used to create the value (with the result being stored in the cache for next time).
   *
   * @param item - The item to get.
   * @param cb - The callback to use to create the value when a cached value is not found.
   */
  get(e, n) {
    return this.items.has(e) || this.items.set(e, n(e)), this.items.get(e);
  }
}
function lp(t, e) {
  let n;
  const i = (...r) => (n || (n = {}, n.promise = new Promise((s, o) => {
    n.resolve = s, n.reject = o;
  })), clearTimeout(n.timeout), n.latestArgs = r, n.timeout = setTimeout(() => {
    const s = n;
    n = void 0;
    try {
      s.resolve(t(...s.latestArgs));
    } catch (o) {
      s.reject(o);
    }
  }, e), n.promise);
  return i.cancel = () => {
    n && clearTimeout(n.timeout);
  }, i;
}
const uD = /* @__PURE__ */ new WeakMap();
function lx(t, e) {
  if (typeof t != "object" || t === null) return;
  let n = uD.get(t);
  n || (n = { tags: {}, extras: {} }, uD.set(t, n)), e.tags && (n.tags = {
    ...n.tags,
    ...e.tags
  }), e.extras && (n.extras = {
    ...n.extras,
    ...e.extras
  });
}
async function gr(t, e) {
  return window.fetch(t, {
    // We want to make sure that the referrer is not sent to other domains.
    referrerPolicy: "strict-origin-when-cross-origin",
    ...e
  });
}
const Vl = (t, e) => {
  const n = new window.Image(t, e);
  return n.referrerPolicy = "strict-origin-when-cross-origin", n;
};
class us {
  /**
   * @param dataURL - The file as a string.
   *
   * from https://stackoverflow.com/a/53817185
   */
  static async dataUrlToArrayBuffer(e) {
    return gr(e).then(function(n) {
      return n.arrayBuffer();
    });
  }
  /**
   * Convert a file to a base64 encoded data url.
   *
   * @example
   *
   * ```ts
   * const A = FileHelpers.toDataUrl(myImageFile)
   * ```
   *
   * @param file - The file as a blob.
   */
  static async blobToDataUrl(e) {
    return await new Promise((n, i) => {
      if (e) {
        const r = new FileReader();
        r.onload = () => n(r.result), r.onerror = (s) => i(s), r.onabort = (s) => i(s), r.readAsDataURL(e);
      }
    });
  }
  /**
   * Convert a file to a unicode text string.
   *
   * @example
   *
   * ```ts
   * const A = FileHelpers.fileToDataUrl(myTextFile)
   * ```
   *
   * @param file - The file as a blob.
   */
  static async blobToText(e) {
    return await new Promise((n, i) => {
      if (e) {
        const r = new FileReader();
        r.onload = () => n(r.result), r.onerror = (s) => i(s), r.onabort = (s) => i(s), r.readAsText(e);
      }
    });
  }
}
function My(t) {
  let e = 0;
  for (let n = 0; n < t.length; n++)
    e = (e << 5) - e + t.charCodeAt(n), e |= 0;
  return e + "";
}
function hD(t) {
  const e = new DataView(t);
  let n = 0;
  for (let i = 0; i < e.byteLength; i++)
    n = (n << 5) - n + e.getUint8(i), n |= 0;
  return n + "";
}
/*!
 * MIT License: https://github.com/ai/nanoid/blob/main/LICENSE
 * Modified code originally from <https://github.com/ai/nanoid>
 * Copyright 2017 Andrey Sitnik <andrey@sitnik.ru>
 *
 * `nanoid` is currently only distributed as an ES module. Some tools (jest, playwright) don't
 * properly support ESM-only code yet, and tldraw itself is distributed as both an ES module and a
 * CommonJS module. By including nanoid here, we can make sure it works well in every environment
 * where tldraw is used. We can also remove some unused features like custom alphabets.
 */
const gD = globalThis.crypto, SU = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", jU = 128;
let wo, Da;
function DU(t) {
  !wo || wo.length < t ? (wo = new Uint8Array(t * jU), gD.getRandomValues(wo), Da = 0) : Da + t > wo.length && (gD.getRandomValues(wo), Da = 0), Da += t;
}
function wU(t = 21) {
  DU(t -= 0);
  let e = "";
  for (let n = Da - t; n < Da; n++)
    e += SU[wo[n] & 63];
  return e;
}
let NU = wU;
function ht(t) {
  return NU(t);
}
/*!
 * MIT License: https://github.com/vHeemstra/is-apng/blob/main/license
 * Copyright (c) Philip van Heemstra
 */
function AU(t) {
  const e = new Uint8Array(t);
  if (!e || !(typeof Buffer < "u" && Buffer.isBuffer(e) || e instanceof Uint8Array) || e.length < 16 || !(e[0] === 137 && e[1] === 80 && e[2] === 78 && e[3] === 71 && e[4] === 13 && e[5] === 10 && e[6] === 26 && e[7] === 10))
    return !1;
  function i(s, o, a, c, d = 1024) {
    if (!o)
      return -1;
    o = new RegExp(o, "g");
    const u = o.source.length, h = new TextDecoder(), g = s.length;
    if (typeof c > "u" && (c = g), a >= g || c <= 0 || a >= c)
      return -1;
    s = s.subarray(a, c);
    let p = -1, f = 0, M = 0, m = "";
    e: for (; f < s.length; ) {
      const y = f + d, I = s.subarray(f, y), D = h.decode(I, { stream: !0 }), j = m + D;
      let w, A = -1;
      for (; (w = o.exec(j)) !== null; ) {
        A = w.index - m.length, p = M + A;
        break e;
      }
      f = y, M += D.length;
      const b = A > -1 ? A + u : D.length - u;
      m = D.slice(b);
    }
    return p >= 0 && (p += a >= 0 ? a : g + a), p;
  }
  const r = i(e, "IDAT", 12);
  return r >= 12 ? i(e, "acTL", 8, r) >= 8 : !1;
}
const TU = (t) => new Uint8Array(t)[3] === 44;
/*!
 * MIT License
 * Modified code originally from <https://github.com/qzb/is-animated>
 * Copyright (c) 2016 Józef Sokołowski <j.k.sokolowski@gmail.com>
 */
function pD(t, e) {
  let n = 0;
  for (; t[e + n]; )
    n += t[e + n] + 1;
  return n + 1;
}
function bU(t) {
  return new TextDecoder("ascii").decode(t.slice(0, 3)) === "GIF";
}
function vU(t) {
  const e = new Uint8Array(t);
  let n, i, r = 0, s = 0;
  if (!bU(t))
    return !1;
  for (n = e[10] & 128, i = e[10] & 7, r += 6, r += 7, r += n ? 3 * Math.pow(2, i + 1) : 0; s < 2 && r < e.length; )
    switch (e[r]) {
      case 44:
        s += 1, n = e[r + 9] & 128, i = e[r + 9] & 7, r += 10, r += n ? 3 * Math.pow(2, i + 1) : 0, r += pD(e, r + 1) + 1;
        break;
      case 33:
        r += 2, r += pD(e, r);
        break;
      case 59:
        r = e.length;
        break;
      default:
        r = e.length;
        break;
    }
  return s > 1;
}
/*!
 * MIT License: https://github.com/alexgorbatchev/crc/blob/master/LICENSE
 * Copyright: 2014 Alex Gorbatchev
 * Code: crc32, https://github.com/alexgorbatchev/crc/blob/master/src/calculators/crc32.ts
 */
let my = [
  0,
  1996959894,
  3993919788,
  2567524794,
  124634137,
  1886057615,
  3915621685,
  2657392035,
  249268274,
  2044508324,
  3772115230,
  2547177864,
  162941995,
  2125561021,
  3887607047,
  2428444049,
  498536548,
  1789927666,
  4089016648,
  2227061214,
  450548861,
  1843258603,
  4107580753,
  2211677639,
  325883990,
  1684777152,
  4251122042,
  2321926636,
  335633487,
  1661365465,
  4195302755,
  2366115317,
  997073096,
  1281953886,
  3579855332,
  2724688242,
  1006888145,
  1258607687,
  3524101629,
  2768942443,
  901097722,
  1119000684,
  3686517206,
  2898065728,
  853044451,
  1172266101,
  3705015759,
  2882616665,
  651767980,
  1373503546,
  3369554304,
  3218104598,
  565507253,
  1454621731,
  3485111705,
  3099436303,
  671266974,
  1594198024,
  3322730930,
  2970347812,
  795835527,
  1483230225,
  3244367275,
  3060149565,
  1994146192,
  31158534,
  2563907772,
  4023717930,
  1907459465,
  112637215,
  2680153253,
  3904427059,
  2013776290,
  251722036,
  2517215374,
  3775830040,
  2137656763,
  141376813,
  2439277719,
  3865271297,
  1802195444,
  476864866,
  2238001368,
  4066508878,
  1812370925,
  453092731,
  2181625025,
  4111451223,
  1706088902,
  314042704,
  2344532202,
  4240017532,
  1658658271,
  366619977,
  2362670323,
  4224994405,
  1303535960,
  984961486,
  2747007092,
  3569037538,
  1256170817,
  1037604311,
  2765210733,
  3554079995,
  1131014506,
  879679996,
  2909243462,
  3663771856,
  1141124467,
  855842277,
  2852801631,
  3708648649,
  1342533948,
  654459306,
  3188396048,
  3373015174,
  1466479909,
  544179635,
  3110523913,
  3462522015,
  1591671054,
  702138776,
  2966460450,
  3352799412,
  1504918807,
  783551873,
  3082640443,
  3233442989,
  3988292384,
  2596254646,
  62317068,
  1957810842,
  3939845945,
  2647816111,
  81470997,
  1943803523,
  3814918930,
  2489596804,
  225274430,
  2053790376,
  3826175755,
  2466906013,
  167816743,
  2097651377,
  4027552580,
  2265490386,
  503444072,
  1762050814,
  4150417245,
  2154129355,
  426522225,
  1852507879,
  4275313526,
  2312317920,
  282753626,
  1742555852,
  4189708143,
  2394877945,
  397917763,
  1622183637,
  3604390888,
  2714866558,
  953729732,
  1340076626,
  3518719985,
  2797360999,
  1068828381,
  1219638859,
  3624741850,
  2936675148,
  906185462,
  1090812512,
  3747672003,
  2825379669,
  829329135,
  1181335161,
  3412177804,
  3160834842,
  628085408,
  1382605366,
  3423369109,
  3138078467,
  570562233,
  1426400815,
  3317316542,
  2998733608,
  733239954,
  1555261956,
  3268935591,
  3050360625,
  752459403,
  1541320221,
  2607071920,
  3965973030,
  1969922972,
  40735498,
  2617837225,
  3943577151,
  1913087877,
  83908371,
  2512341634,
  3803740692,
  2075208622,
  213261112,
  2463272603,
  3855990285,
  2094854071,
  198958881,
  2262029012,
  4057260610,
  1759359992,
  534414190,
  2176718541,
  4139329115,
  1873836001,
  414664567,
  2282248934,
  4279200368,
  1711684554,
  285281116,
  2405801727,
  4167216745,
  1634467795,
  376229701,
  2685067896,
  3608007406,
  1308918612,
  956543938,
  2808555105,
  3495958263,
  1231636301,
  1047427035,
  2932959818,
  3654703836,
  1088359270,
  936918e3,
  2847714899,
  3736837829,
  1202900863,
  817233897,
  3183342108,
  3401237130,
  1404277552,
  615818150,
  3134207493,
  3453421203,
  1423857449,
  601450431,
  3009837614,
  3294710456,
  1567103746,
  711928724,
  3020668471,
  3272380065,
  1510334235,
  755167117
];
typeof Int32Array < "u" && (my = new Int32Array(my));
const EU = (t, e) => {
  let n = ~~e ^ -1;
  for (let i = 0; i < t.length; i++)
    n = my[(n ^ t[i]) & 255] ^ n >>> 8;
  return n ^ -1;
}, fD = 4, MD = 4;
class zr {
  static isPng(e, n) {
    return e.getUint8(n + 0) === 137 && e.getUint8(n + 1) === 80 && e.getUint8(n + 2) === 78 && e.getUint8(n + 3) === 71 && e.getUint8(n + 4) === 13 && e.getUint8(n + 5) === 10 && e.getUint8(n + 6) === 26 && e.getUint8(n + 7) === 10;
  }
  static getChunkType(e, n) {
    return [
      String.fromCharCode(e.getUint8(n)),
      String.fromCharCode(e.getUint8(n + 1)),
      String.fromCharCode(e.getUint8(n + 2)),
      String.fromCharCode(e.getUint8(n + 3))
    ].join("");
  }
  static readChunks(e, n = 0) {
    const i = {};
    if (!zr.isPng(e, n))
      throw new Error("Not a PNG");
    for (n += 8; n <= e.buffer.byteLength; ) {
      const r = n, s = e.getInt32(n);
      n += 4;
      const o = zr.getChunkType(e, n);
      if (o === "IDAT" && i[o]) {
        n += s + fD + MD;
        continue;
      }
      if (o === "IEND")
        break;
      i[o] = {
        start: r,
        dataOffset: n + 4,
        size: s
      }, n += s + fD + MD;
    }
    return i;
  }
  static parsePhys(e, n) {
    return {
      ppux: e.getUint32(n),
      ppuy: e.getUint32(n + 4),
      unit: e.getUint8(n + 4)
    };
  }
  static findChunk(e, n) {
    return zr.readChunks(e)[n];
  }
  static setPhysChunk(e, n = 1, i) {
    let r = 46, s = 0;
    const o = zr.findChunk(e, "pHYs");
    o && (r = o.start, s = o.size);
    const a = zr.findChunk(e, "IDAT");
    a && (r = a.start, s = 0);
    const c = new ArrayBuffer(21), d = new DataView(c);
    d.setUint32(0, 9), d.setUint8(4, 112), d.setUint8(5, 72), d.setUint8(6, 89), d.setUint8(7, 115);
    const u = 2835.5;
    d.setInt32(8, u * n), d.setInt32(12, u * n), d.setInt8(16, 1);
    const h = new Uint8Array(c.slice(4, 17));
    d.setInt32(17, EU(h));
    const g = e.buffer.slice(0, r), p = e.buffer.slice(r + s);
    return new Blob([g, c, p], i);
  }
}
/*!
 * MIT License: https://github.com/sindresorhus/is-webp/blob/main/license
 * Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)
 */
function CU(t) {
  return !t || t.length < 12 ? !1 : t[8] === 87 && t[9] === 69 && t[10] === 66 && t[11] === 80;
}
function zU(t) {
  const e = new Uint8Array(t);
  return !CU(e) || !e || e.length < 21 ? !1 : (e[20] >> 1 & 1) === 1;
}
const WA = Object.freeze(["image/svg+xml"]), HA = Object.freeze([
  "image/jpeg",
  "image/png",
  "image/webp"
]), VA = Object.freeze([
  "image/gif",
  "image/apng",
  "image/avif"
]), dp = Object.freeze([
  ...HA,
  ...WA,
  ...VA
]), dx = Object.freeze([
  "video/mp4",
  "video/webm",
  "video/quicktime"
]), LU = [
  ...dp,
  ...dx
].join(",");
class bi {
  /**
   * Load a video from a url.
   * @public
   */
  static loadVideo(e) {
    return new Promise((n, i) => {
      const r = document.createElement("video");
      r.onloadeddata = () => n(r), r.onerror = (s) => {
        console.error(s), i(new Error("Could not load video"));
      }, r.crossOrigin = "anonymous", r.src = e;
    });
  }
  static async getVideoFrameAsDataUrl(e, n = 0) {
    const i = cx();
    let r = !1;
    const s = () => {
      if (!r)
        if (e.readyState >= e.HAVE_METADATA)
          r = !0, e.currentTime = n;
        else
          return;
      if (e.readyState >= e.HAVE_CURRENT_DATA) {
        const a = document.createElement("canvas");
        a.width = e.videoWidth, a.height = e.videoHeight;
        const c = a.getContext("2d");
        if (!c)
          throw new Error("Could not get 2d context");
        c.drawImage(e, 0, 0), i.resolve(a.toDataURL());
      }
    }, o = (a) => {
      console.error(a), i.reject(new Error("Could not get video frame"));
    };
    e.addEventListener("loadedmetadata", s), e.addEventListener("loadeddata", s), e.addEventListener("canplay", s), e.addEventListener("seeked", s), e.addEventListener("error", o), e.addEventListener("stalled", o), s();
    try {
      return await i;
    } finally {
      e.removeEventListener("loadedmetadata", s), e.removeEventListener("loadeddata", s), e.removeEventListener("canplay", s), e.removeEventListener("seeked", s), e.removeEventListener("error", o), e.removeEventListener("stalled", o);
    }
  }
  /**
   * Load an image from a url.
   * @public
   */
  static loadImage(e) {
    return new Promise((n, i) => {
      const r = Vl();
      r.onload = () => n(r), r.onerror = (s) => {
        console.error(s), i(new Error("Could not load image"));
      }, r.crossOrigin = "anonymous", r.referrerPolicy = "strict-origin-when-cross-origin", r.src = e;
    });
  }
  /**
   * Get the size of a video blob
   *
   * @param blob - A SharedBlob containing the video
   * @public
   */
  static async getVideoSize(e) {
    return bi.usingObjectURL(e, async (n) => {
      const i = await bi.loadVideo(n);
      return { w: i.videoWidth, h: i.videoHeight };
    });
  }
  /**
   * Get the size of an image blob
   *
   * @param blob - A Blob containing the image.
   * @public
   */
  static async getImageSize(e) {
    const n = await bi.usingObjectURL(e, bi.loadImage);
    try {
      if (e.type === "image/png") {
        const i = new DataView(await e.arrayBuffer());
        if (zr.isPng(i, 0)) {
          const r = zr.findChunk(i, "pHYs");
          if (r) {
            const s = zr.parsePhys(i, r.dataOffset);
            if (s.unit === 0 && s.ppux === s.ppuy) {
              const o = Math.max(s.ppux / 2834.5, 1);
              return {
                w: Math.round(n.naturalWidth / o),
                h: Math.round(n.naturalHeight / o)
              };
            }
          }
        }
      }
    } catch (i) {
      return console.error(i), { w: n.naturalWidth, h: n.naturalHeight };
    }
    return { w: n.naturalWidth, h: n.naturalHeight };
  }
  static async isAnimated(e) {
    return e.type === "image/gif" ? vU(await e.arrayBuffer()) : e.type === "image/avif" ? TU(await e.arrayBuffer()) : e.type === "image/webp" ? zU(await e.arrayBuffer()) : e.type === "image/apng" ? AU(await e.arrayBuffer()) : !1;
  }
  static isAnimatedImageType(e) {
    return VA.includes(e || "");
  }
  static isStaticImageType(e) {
    return HA.includes(e || "");
  }
  static isVectorImageType(e) {
    return WA.includes(e || "");
  }
  static isImageType(e) {
    return dp.includes(e);
  }
  static async usingObjectURL(e, n) {
    const i = URL.createObjectURL(e);
    try {
      return await n(i);
    } finally {
      URL.revokeObjectURL(i);
    }
  }
}
function et(t, e, n) {
  return t + (e - t) * n;
}
function xr(t = "") {
  let e = 0, n = 0, i = 0, r = 0;
  function s() {
    const o = e ^ e << 11;
    return e = n, n = i, i = r, r ^= (r >>> 19 ^ o ^ o >>> 8) >>> 0, r / 4294967296 * 2;
  }
  for (let o = 0; o < t.length + 64; o++)
    e ^= t.charCodeAt(o) | 0, s();
  return s;
}
function Ba(t, e, n, i = !1) {
  const [r, s] = e, [o, a] = n, c = o + (t - r) / (s - r) * (a - o);
  return i ? o < a ? Math.max(Math.min(c, a), o) : Math.max(Math.min(c, o), a) : c;
}
function cr(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function ui(t, e) {
  if (cr(t, e))
    return t[e];
}
function mD(t) {
  return Object.keys(t);
}
function Pt(t) {
  return Object.values(t);
}
function Mi(t) {
  return Object.entries(t);
}
function KA(t) {
  return Object.fromEntries(t);
}
function Cl(t, e) {
  const n = {};
  let i = !1;
  for (const [r, s] of Mi(t))
    e(r, s) ? n[r] = s : i = !0;
  return i ? n : t;
}
function ld(t, e) {
  const n = {};
  for (const [i, r] of Mi(t)) {
    const s = e(i, r);
    n[i] = s;
  }
  return n;
}
function XA(t, e) {
  if (t === e) return !0;
  const n = new Set(Object.keys(t)), i = new Set(Object.keys(e));
  if (n.size !== i.size) return !1;
  for (const r of n)
    if (!i.has(r) || !Object.is(t[r], e[r])) return !1;
  return !0;
}
function kU(t) {
  const e = OU(t.chars), n = PU(
    e,
    t.firstPositive,
    t.mostPositive,
    t.mostNegative
  ), i = t.jitterRange ?? Math.floor(Math.pow(e.length, 3) / 5), r = UU(i, e.length);
  return {
    chars: t.chars,
    byChar: e.byChar,
    byCode: e.byCode,
    length: e.length,
    first: e.byCode[0],
    last: e.byCode[e.length - 1],
    firstPositive: n.firstPositive,
    mostPositive: n.mostPositive,
    firstNegative: n.firstNegative,
    mostNegative: n.mostNegative,
    jitterRange: i,
    paddingDict: r
  };
}
function OU(t) {
  const e = {}, n = {}, i = t.length;
  for (let r = 0; r < i; r++) {
    const s = t[r];
    e[r] = s, n[s] = r;
  }
  return {
    byCode: e,
    byChar: n,
    length: i
  };
}
function PU(t, e, n, i) {
  const r = e ? t.byChar[e] : Math.ceil(t.length / 2), s = n ? t.byChar[n] : t.length - 1, o = i ? t.byChar[i] : 0;
  if (r === void 0 || s === void 0 || o === void 0)
    throw new Error("invalid charSet");
  if (s - r < 3)
    throw new Error(
      "mostPositive must be at least 3 characters away from neutral"
    );
  if (r - o < 3)
    throw new Error(
      "mostNegative must be at least 3 characters away from neutral"
    );
  return {
    firstPositive: t.byCode[r],
    mostPositive: t.byCode[s],
    firstNegative: t.byCode[r - 1],
    mostNegative: t.byCode[o]
  };
}
function UU(t, e) {
  const n = {};
  for (let i = 0; i < 100 && (n[i] = Math.pow(e, i), !(n[i] > t)); i++)
    ;
  return n;
}
var qf = null;
function up() {
  return qf || (qf = kU({
    // Base62 are all the alphanumeric characters, database and user friendly
    // For shorter strings and more room you could opt for more characters
    chars: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
    // This gives us nice human readable keys to start with a0 a1 etc
    firstPositive: "a",
    mostPositive: "z",
    mostNegative: "A"
  }));
}
function Gs(t, e, n) {
  const i = n.byChar[t], r = n.byChar[e];
  return Math.abs(i - r);
}
function ux(t, e) {
  const n = t[0];
  if (n > e.mostPositive || n < e.mostNegative)
    throw new Error("invalid firstChar on key");
  return n === e.mostPositive ? Gs(n, e.firstPositive, e) + 1 + hg(t.slice(1), "positive", e) : n === e.mostNegative ? Gs(n, e.firstNegative, e) + 1 + hg(t.slice(1), "negative", e) : n >= e.firstPositive ? Gs(n, e.firstPositive, e) + 2 : Gs(n, e.firstNegative, e) + 2;
}
function hg(t, e, n) {
  const i = t[0];
  if (i > n.mostPositive || i < n.mostNegative)
    throw new Error("invalid firstChar on key");
  return i === n.mostPositive && e === "positive" ? Gs(i, n.mostNegative, n) + 1 + hg(t.slice(1), e, n) : i === n.mostNegative && e === "negative" ? Gs(i, n.mostPositive, n) + 1 + hg(t.slice(1), e, n) : e === "positive" ? Gs(i, n.mostNegative, n) + 2 : Gs(i, n.mostPositive, n) + 2;
}
function hp(t, e, n, i, r) {
  const s = Math.max(t.length, e.length);
  return n === "start" ? [t.padStart(s, i), e.padStart(s, i)] : [t.padEnd(s, i), e.padEnd(s, i)];
}
function RU(t, e, n) {
  let [i, r] = hp(
    t,
    e,
    "end",
    n.first
  ), s = yy(i, r, n);
  s === 1 && (i = i.padEnd(i.length + 1, n.first), s = n.length);
  const o = _A(Math.floor(s / 2), n);
  return hx(i, o, n);
}
function yy(t, e, n) {
  const [i, r] = hp(t, e, "end", n.first).sort(), s = JA(r, i, n);
  return YU(s, n);
}
function hx(t, e, n) {
  const i = n.length, [r, s] = hp(t, e, "start", n.first), o = [];
  let a = 0;
  for (let c = r.length - 1; c >= 0; c--) {
    const d = n.byChar[r[c]], u = n.byChar[s[c]], h = d + u + a;
    a = Math.floor(h / i);
    const g = h % i;
    o.unshift(n.byCode[g]);
  }
  return a > 0 && o.unshift(n.byCode[a]), o.join("");
}
function JA(t, e, n) {
  const i = n.length, [r, s] = hp(t, e, "start", n.first), o = [];
  let a = 0;
  for (let c = r.length - 1; c >= 0; c--) {
    let d = n.byChar[r[c]];
    const u = n.byChar[s[c]] + a;
    d < u ? (a = 1, d += i) : a = 0;
    const h = d - u;
    o.unshift(n.byCode[h]);
  }
  if (a > 0)
    throw new Error(
      "Subtraction result is negative. Ensure a is greater than or equal to b."
    );
  for (; o.length > 1 && o[0] === n.byCode[0]; )
    o.shift();
  return o.join("");
}
function qA(t, e) {
  return hx(t, e.byCode[1], e);
}
function Iy(t, e) {
  return JA(t, e.byCode[1], e);
}
function _A(t, e) {
  if (t === 0)
    return e.byCode[0];
  let n = "";
  const i = e.length;
  for (; t > 0; )
    n = e.byCode[t % i] + n, t = Math.floor(t / i);
  return n;
}
function YU(t, e) {
  let n = 0;
  const i = t.length, r = e.length;
  for (let s = 0; s < i; s++)
    n += e.byChar[t[s]] * Math.pow(r, i - s - 1);
  return n;
}
function QU(t) {
  return t.firstPositive + t.byCode[0];
}
function ZU(t, e) {
  return ux(t, e) === t.length;
}
function yD(t, e) {
  gg(t, e);
}
function gg(t, e) {
  const n = tT(t, e), i = ux(n, e);
  if (i > t.length)
    throw new Error("invalid order key length: " + t);
  return t.slice(0, i);
}
function $A(t, e) {
  if (!ZU(t, e))
    throw new Error("invalid integer length: " + t);
}
function eT(t, e) {
  $A(t, e);
  const [n, i] = nT(t, e);
  if (i.split("").some((o) => o !== e.byCode[e.length - 1])) {
    const o = qA(i, e);
    return n + o;
  }
  const s = BU(n, e);
  return iT(s, "lower", e);
}
function FU(t, e) {
  $A(t, e);
  const [n, i] = nT(t, e);
  if (i.split("").some((o) => o !== e.byCode[0])) {
    const o = Iy(i, e);
    return n + o;
  }
  const s = GU(n, e);
  return iT(s, "upper", e);
}
function tT(t, e) {
  let n = 0;
  if (t[0] === e.mostPositive)
    for (; t[n] === e.mostPositive; )
      n = n + 1;
  if (t[0] === e.mostNegative)
    for (; t[n] === e.mostNegative; )
      n = n + 1;
  return t.slice(0, n + 1);
}
function nT(t, e) {
  const n = tT(t, e), i = t.slice(n.length);
  return [n, i];
}
function BU(t, e) {
  const n = t >= e.firstPositive, i = qA(t, e), r = t[t.length - 1] === e.mostPositive, s = i[i.length - 1] === e.mostPositive;
  return n && s ? i + e.mostNegative : !n && r ? t.slice(0, t.length - 1) : i;
}
function GU(t, e) {
  const n = t >= e.firstPositive, i = t[t.length - 1] === e.mostNegative;
  if (n && i) {
    const r = t.slice(0, t.length - 1);
    return Iy(r, e);
  }
  return !n && i ? t + e.mostPositive : Iy(t, e);
}
function iT(t, e, n) {
  const i = ux(t, n), r = e === "upper" ? n.byCode[n.length - 1] : n.byCode[0];
  return t + r.repeat(i - t.length);
}
function rT(t, e) {
  const n = _A(
    Math.floor(Math.random() * e.jitterRange),
    e
  );
  return hx(t, n, e);
}
function WU(t, e, n) {
  const i = t.padEnd(
    t.length + e,
    n.first
  );
  return rT(i, n);
}
function HU(t, e, n) {
  const i = gg(t, n), r = eT(i, n);
  let s = 0;
  if (e !== null) {
    const a = yy(t, e, n);
    a < n.jitterRange + 1 && (s = Math.max(s, ID(a, n)));
  }
  const o = yy(t, r, n);
  return o < n.jitterRange + 1 && (s = Math.max(
    s,
    ID(o, n)
  )), s;
}
function ID(t, e) {
  const n = e.jitterRange - t, i = Object.entries(e.paddingDict).find(
    ([r, s]) => s > n
  );
  return i ? parseInt(i[0]) : 0;
}
function sT(t, e, n = up()) {
  if (t !== null && yD(t, n), e !== null && yD(e, n), t === null && e === null)
    return QU(n);
  if (t === null) {
    const i = gg(e, n);
    return FU(i, n);
  }
  if (e === null) {
    const i = gg(t, n);
    return eT(i, n);
  }
  if (t >= e)
    throw new Error(t + " >= " + e);
  return RU(t, e, n);
}
function oT(t, e, n, i = up()) {
  return lT(
    t,
    e,
    n,
    i,
    sT,
    oT
  );
}
function aT(t, e, n = up()) {
  const i = sT(t, e, n), r = HU(i, e, n);
  return r ? WU(i, r, n) : rT(i, n);
}
function cT(t, e, n, i = up()) {
  return lT(
    t,
    e,
    n,
    i,
    aT,
    cT
  );
}
function lT(t, e, n, i, r, s) {
  if (n === 0)
    return [];
  if (n === 1)
    return [r(t, e, i)];
  if (e == null) {
    let c = r(t, e, i);
    const d = [c];
    for (let u = 0; u < n - 1; u++)
      c = r(c, e, i), d.push(c);
    return d;
  }
  if (t == null) {
    let c = r(t, e, i);
    const d = [c];
    for (let u = 0; u < n - 1; u++)
      c = r(t, c, i), d.push(c);
    return d.reverse(), d;
  }
  const o = Math.floor(n / 2), a = r(t, e, i);
  return [
    ...s(t, a, o, i),
    a,
    ...s(a, e, n - o - 1, i)
  ];
}
const pc = process.env.NODE_ENV === "test" ? oT : cT, dT = "a0";
function VU(t) {
  try {
    aT(t, null);
  } catch {
    throw new Error("invalid index: " + t);
  }
}
function Ga(t, e, n) {
  return pc(t ?? null, e ?? null, n);
}
function _f(t, e) {
  return pc(t ?? null, null, e);
}
function ko(t, e) {
  return pc(t ?? null, e ?? null, 1)[0];
}
function hi(t = null) {
  return pc(t, null, 1)[0];
}
function uT(t = null) {
  return pc(null, t, 1)[0];
}
function Wa(t, e = "a1") {
  return [e, ...pc(e, null, t)];
}
function Jt(t, e) {
  return t.index < e.index ? -1 : t.index > e.index ? 1 : 0;
}
function KU(t, e) {
  return t.id > e.id ? 1 : -1;
}
function gx(t) {
  try {
    return localStorage.getItem(t);
  } catch {
    return null;
  }
}
function px(t, e) {
  try {
    localStorage.setItem(t, e);
  } catch {
  }
}
function XU() {
  try {
    localStorage.clear();
  } catch {
  }
}
function hT(t) {
  try {
    return sessionStorage.getItem(t);
  } catch {
    return null;
  }
}
function fx(t, e) {
  try {
    sessionStorage.setItem(t, e);
  } catch {
  }
}
function gT(t) {
  try {
    sessionStorage.removeItem(t);
  } catch {
  }
}
function JU() {
  try {
    sessionStorage.clear();
  } catch {
  }
}
const qU = () => typeof process < "u" && process.env.NODE_ENV === "test" && // @ts-expect-error
!globalThis.__FORCE_RAF_IN_TESTS__, wa = [], _U = 60, fh = Math.ceil(1e3 / _U);
let qc, $f = 0, xy = 0;
const $U = () => {
  const t = wa.splice(0, wa.length);
  for (const e of t)
    e();
};
function pT() {
  if (qc)
    return;
  const t = Date.now(), e = t - xy;
  if ($f + e < fh) {
    qc = requestAnimationFrame(() => {
      qc = void 0, pT();
    });
    return;
  }
  qc = requestAnimationFrame(() => {
    qc = void 0, xy = t, $f = Math.min($f + e - fh, fh * 10), $U();
  });
}
let xD = !1;
function fT(t) {
  return qU() ? (t(), () => {
  }) : (wa.includes(t) || (wa.push(t), xD || (xD = !0, xy = Date.now() - fh - 1), pT()), () => {
    const e = wa.indexOf(t);
    e > -1 && wa.splice(e, 1);
  });
}
class eR {
  constructor() {
    S(this, "timeouts", /* @__PURE__ */ new Map());
    S(this, "intervals", /* @__PURE__ */ new Map());
    S(this, "rafs", /* @__PURE__ */ new Map());
    this.setTimeout = this.setTimeout.bind(this), this.setInterval = this.setInterval.bind(this), this.requestAnimationFrame = this.requestAnimationFrame.bind(this), this.dispose = this.dispose.bind(this);
  }
  /** @public */
  setTimeout(e, n, i, ...r) {
    const s = window.setTimeout(n, i, r), o = this.timeouts.get(e) ?? [];
    return this.timeouts.set(e, [...o, s]), s;
  }
  /** @public */
  setInterval(e, n, i, ...r) {
    const s = window.setInterval(n, i, r), o = this.intervals.get(e) ?? [];
    return this.intervals.set(e, [...o, s]), s;
  }
  /** @public */
  requestAnimationFrame(e, n) {
    const i = window.requestAnimationFrame(n), r = this.rafs.get(e) ?? [];
    return this.rafs.set(e, [...r, i]), i;
  }
  /** @public */
  dispose(e) {
    var n, i, r;
    (n = this.timeouts.get(e)) == null || n.forEach((s) => clearTimeout(s)), (i = this.intervals.get(e)) == null || i.forEach((s) => clearInterval(s)), (r = this.rafs.get(e)) == null || r.forEach((s) => cancelAnimationFrame(s)), this.timeouts.delete(e), this.intervals.delete(e), this.rafs.delete(e);
  }
  disposeAll() {
    for (const e of this.timeouts.keys())
      this.dispose(e);
  }
  forContext(e) {
    return {
      setTimeout: (n, i, ...r) => this.setTimeout(e, n, i, r),
      setInterval: (n, i, ...r) => this.setInterval(e, n, i, r),
      requestAnimationFrame: (n) => this.requestAnimationFrame(e, n),
      dispose: () => this.dispose(e)
    };
  }
}
const Le = (t, e) => {
  try {
    return new URL(t, e);
  } catch {
    return;
  }
};
function tR(t) {
  return t !== void 0;
}
function nR() {
  return typeof globalThis < "u" && globalThis.structuredClone ? [globalThis.structuredClone, !0] : typeof global < "u" && global.structuredClone ? [global.structuredClone, !0] : typeof window < "u" && window.structuredClone ? [window.structuredClone, !0] : [(t) => t && JSON.parse(JSON.stringify(t)), !1];
}
const MT = nR(), Ct = MT[0];
MT[1];
const mT = Object.getPrototypeOf(Ct({}));
so(
  "@tldraw/utils",
  "3.4.1",
  "esm"
);
var _c = function(t) {
  return t && t.Math === Math && t;
}, Kn = (
  // eslint-disable-next-line es/no-global-this -- safe
  _c(typeof globalThis == "object" && globalThis) || _c(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  _c(typeof self == "object" && self) || _c(typeof En == "object" && En) || _c(typeof En == "object" && En) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")()
), Mx = {}, Xn = function(t) {
  try {
    return !!t();
  } catch {
    return !0;
  }
}, iR = Xn, oo = !iR(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), rR = Xn, gp = !rR(function() {
  var t = (function() {
  }).bind();
  return typeof t != "function" || t.hasOwnProperty("prototype");
}), sR = gp, gu = Function.prototype.call, Ss = sR ? gu.bind(gu) : function() {
  return gu.apply(gu, arguments);
}, yT = {}, IT = {}.propertyIsEnumerable, xT = Object.getOwnPropertyDescriptor, oR = xT && !IT.call({ 1: 2 }, 1);
yT.f = oR ? function(e) {
  var n = xT(this, e);
  return !!n && n.enumerable;
} : IT;
var ST = function(t, e) {
  return {
    enumerable: !(t & 1),
    configurable: !(t & 2),
    writable: !(t & 4),
    value: e
  };
}, jT = gp, DT = Function.prototype, Sy = DT.call, aR = jT && DT.bind.bind(Sy, Sy), cn = jT ? aR : function(t) {
  return function() {
    return Sy.apply(t, arguments);
  };
}, wT = cn, cR = wT({}.toString), lR = wT("".slice), fc = function(t) {
  return lR(cR(t), 8, -1);
}, dR = cn, uR = Xn, hR = fc, eM = Object, gR = dR("".split), pR = uR(function() {
  return !eM("z").propertyIsEnumerable(0);
}) ? function(t) {
  return hR(t) === "String" ? gR(t, "") : eM(t);
} : eM, pp = function(t) {
  return t == null;
}, fR = pp, MR = TypeError, Mc = function(t) {
  if (fR(t)) throw new MR("Can't call method on " + t);
  return t;
}, mR = pR, yR = Mc, fp = function(t) {
  return mR(yR(t));
}, tM = typeof document == "object" && document.all, Jn = typeof tM > "u" && tM !== void 0 ? function(t) {
  return typeof t == "function" || t === tM;
} : function(t) {
  return typeof t == "function";
}, IR = Jn, mc = function(t) {
  return typeof t == "object" ? t !== null : IR(t);
}, nM = Kn, xR = Jn, SR = function(t) {
  return xR(t) ? t : void 0;
}, Mp = function(t, e) {
  return arguments.length < 2 ? SR(nM[t]) : nM[t] && nM[t][e];
}, jR = cn, NT = jR({}.isPrototypeOf), DR = Kn, SD = DR.navigator, jD = SD && SD.userAgent, wR = jD ? String(jD) : "", AT = Kn, iM = wR, DD = AT.process, wD = AT.Deno, ND = DD && DD.versions || wD && wD.version, AD = ND && ND.v8, sr, pg;
AD && (sr = AD.split("."), pg = sr[0] > 0 && sr[0] < 4 ? 1 : +(sr[0] + sr[1]));
!pg && iM && (sr = iM.match(/Edge\/(\d+)/), (!sr || sr[1] >= 74) && (sr = iM.match(/Chrome\/(\d+)/), sr && (pg = +sr[1])));
var NR = pg, TD = NR, AR = Xn, TR = Kn, bR = TR.String, TT = !!Object.getOwnPropertySymbols && !AR(function() {
  var t = Symbol("symbol detection");
  return !bR(t) || !(Object(t) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && TD && TD < 41;
}), vR = TT, bT = vR && !Symbol.sham && typeof Symbol.iterator == "symbol", ER = Mp, CR = Jn, zR = NT, LR = bT, kR = Object, vT = LR ? function(t) {
  return typeof t == "symbol";
} : function(t) {
  var e = ER("Symbol");
  return CR(e) && zR(e.prototype, kR(t));
}, OR = String, PR = function(t) {
  try {
    return OR(t);
  } catch {
    return "Object";
  }
}, UR = Jn, RR = PR, YR = TypeError, mx = function(t) {
  if (UR(t)) return t;
  throw new YR(RR(t) + " is not a function");
}, QR = mx, ZR = pp, yx = function(t, e) {
  var n = t[e];
  return ZR(n) ? void 0 : QR(n);
}, rM = Ss, sM = Jn, oM = mc, FR = TypeError, BR = function(t, e) {
  var n, i;
  if (e === "string" && sM(n = t.toString) && !oM(i = rM(n, t)) || sM(n = t.valueOf) && !oM(i = rM(n, t)) || e !== "string" && sM(n = t.toString) && !oM(i = rM(n, t))) return i;
  throw new FR("Can't convert object to primitive value");
}, ET = { exports: {} }, bD = Kn, GR = Object.defineProperty, Ix = function(t, e) {
  try {
    GR(bD, t, { value: e, configurable: !0, writable: !0 });
  } catch {
    bD[t] = e;
  }
  return e;
}, WR = Kn, HR = Ix, vD = "__core-js_shared__", ED = ET.exports = WR[vD] || HR(vD, {});
(ED.versions || (ED.versions = [])).push({
  version: "3.39.0",
  mode: "global",
  copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var xx = ET.exports, CD = xx, Sx = function(t, e) {
  return CD[t] || (CD[t] = e || {});
}, VR = Mc, KR = Object, dd = function(t) {
  return KR(VR(t));
}, XR = cn, JR = dd, qR = XR({}.hasOwnProperty), ao = Object.hasOwn || function(e, n) {
  return qR(JR(e), n);
}, _R = cn, $R = 0, eY = Math.random(), tY = _R(1 .toString), CT = function(t) {
  return "Symbol(" + (t === void 0 ? "" : t) + ")_" + tY(++$R + eY, 36);
}, nY = Kn, iY = Sx, zD = ao, rY = CT, sY = TT, oY = bT, Na = nY.Symbol, aM = iY("wks"), aY = oY ? Na.for || Na : Na && Na.withoutSetter || rY, js = function(t) {
  return zD(aM, t) || (aM[t] = sY && zD(Na, t) ? Na[t] : aY("Symbol." + t)), aM[t];
}, cY = Ss, LD = mc, kD = vT, lY = yx, dY = BR, uY = js, hY = TypeError, gY = uY("toPrimitive"), pY = function(t, e) {
  if (!LD(t) || kD(t)) return t;
  var n = lY(t, gY), i;
  if (n) {
    if (e === void 0 && (e = "default"), i = cY(n, t, e), !LD(i) || kD(i)) return i;
    throw new hY("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), dY(t, e);
}, fY = pY, MY = vT, zT = function(t) {
  var e = fY(t, "string");
  return MY(e) ? e : e + "";
}, mY = Kn, OD = mc, jy = mY.document, yY = OD(jy) && OD(jy.createElement), LT = function(t) {
  return yY ? jy.createElement(t) : {};
}, IY = oo, xY = Xn, SY = LT, kT = !IY && !xY(function() {
  return Object.defineProperty(SY("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), jY = oo, DY = Ss, wY = yT, NY = ST, AY = fp, TY = zT, bY = ao, vY = kT, PD = Object.getOwnPropertyDescriptor;
Mx.f = jY ? PD : function(e, n) {
  if (e = AY(e), n = TY(n), vY) try {
    return PD(e, n);
  } catch {
  }
  if (bY(e, n)) return NY(!DY(wY.f, e, n), e[n]);
};
var yc = {}, EY = oo, CY = Xn, OT = EY && CY(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), zY = mc, LY = String, kY = TypeError, Ho = function(t) {
  if (zY(t)) return t;
  throw new kY(LY(t) + " is not an object");
}, OY = oo, PY = kT, UY = OT, pu = Ho, UD = zT, RY = TypeError, cM = Object.defineProperty, YY = Object.getOwnPropertyDescriptor, lM = "enumerable", dM = "configurable", uM = "writable";
yc.f = OY ? UY ? function(e, n, i) {
  if (pu(e), n = UD(n), pu(i), typeof e == "function" && n === "prototype" && "value" in i && uM in i && !i[uM]) {
    var r = YY(e, n);
    r && r[uM] && (e[n] = i.value, i = {
      configurable: dM in i ? i[dM] : r[dM],
      enumerable: lM in i ? i[lM] : r[lM],
      writable: !1
    });
  }
  return cM(e, n, i);
} : cM : function(e, n, i) {
  if (pu(e), n = UD(n), pu(i), PY) try {
    return cM(e, n, i);
  } catch {
  }
  if ("get" in i || "set" in i) throw new RY("Accessors not supported");
  return "value" in i && (e[n] = i.value), e;
};
var QY = oo, ZY = yc, FY = ST, jx = QY ? function(t, e, n) {
  return ZY.f(t, e, FY(1, n));
} : function(t, e, n) {
  return t[e] = n, t;
}, PT = { exports: {} }, Dy = oo, BY = ao, UT = Function.prototype, GY = Dy && Object.getOwnPropertyDescriptor, WY = BY(UT, "name"), HY = WY && (!Dy || Dy && GY(UT, "name").configurable), VY = {
  CONFIGURABLE: HY
}, KY = cn, XY = Jn, wy = xx, JY = KY(Function.toString);
XY(wy.inspectSource) || (wy.inspectSource = function(t) {
  return JY(t);
});
var RT = wy.inspectSource, qY = Kn, _Y = Jn, RD = qY.WeakMap, $Y = _Y(RD) && /native code/.test(String(RD)), e9 = Sx, t9 = CT, YD = e9("keys"), YT = function(t) {
  return YD[t] || (YD[t] = t9(t));
}, Dx = {}, n9 = $Y, QT = Kn, i9 = jx, hM = ao, gM = xx, r9 = YT, s9 = Dx, QD = "Object already initialized", ZD = QT.TypeError, o9 = QT.WeakMap, Ny, fg, Ay, a9 = function(t) {
  return Ay(t) ? fg(t) : Ny(t, {});
};
if (n9 || gM.state) {
  var br = gM.state || (gM.state = new o9());
  br.get = br.get, br.has = br.has, br.set = br.set, Ny = function(t, e) {
    if (br.has(t)) throw new ZD(QD);
    return e.facade = t, br.set(t, e), e;
  }, fg = function(t) {
    return br.get(t) || {};
  }, Ay = function(t) {
    return br.has(t);
  };
} else {
  var sa = r9("state");
  s9[sa] = !0, Ny = function(t, e) {
    if (hM(t, sa)) throw new ZD(QD);
    return e.facade = t, i9(t, sa, e), e;
  }, fg = function(t) {
    return hM(t, sa) ? t[sa] : {};
  }, Ay = function(t) {
    return hM(t, sa);
  };
}
var ZT = {
  get: fg,
  enforce: a9
}, wx = cn, c9 = Xn, l9 = Jn, fu = ao, Ty = oo, d9 = VY.CONFIGURABLE, u9 = RT, FT = ZT, h9 = FT.enforce, g9 = FT.get, FD = String, Mh = Object.defineProperty, p9 = wx("".slice), f9 = wx("".replace), M9 = wx([].join), m9 = Ty && !c9(function() {
  return Mh(function() {
  }, "length", { value: 8 }).length !== 8;
}), y9 = String(String).split("String"), I9 = PT.exports = function(t, e, n) {
  p9(FD(e), 0, 7) === "Symbol(" && (e = "[" + f9(FD(e), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), n && n.getter && (e = "get " + e), n && n.setter && (e = "set " + e), (!fu(t, "name") || d9 && t.name !== e) && (Ty ? Mh(t, "name", { value: e, configurable: !0 }) : t.name = e), m9 && n && fu(n, "arity") && t.length !== n.arity && Mh(t, "length", { value: n.arity });
  try {
    n && fu(n, "constructor") && n.constructor ? Ty && Mh(t, "prototype", { writable: !1 }) : t.prototype && (t.prototype = void 0);
  } catch {
  }
  var i = h9(t);
  return fu(i, "source") || (i.source = M9(y9, typeof e == "string" ? e : "")), t;
};
Function.prototype.toString = I9(function() {
  return l9(this) && g9(this).source || u9(this);
}, "toString");
var x9 = PT.exports, S9 = Jn, j9 = yc, D9 = x9, w9 = Ix, BT = function(t, e, n, i) {
  i || (i = {});
  var r = i.enumerable, s = i.name !== void 0 ? i.name : e;
  if (S9(n) && D9(n, s, i), i.global)
    r ? t[e] = n : w9(e, n);
  else {
    try {
      i.unsafe ? t[e] && (r = !0) : delete t[e];
    } catch {
    }
    r ? t[e] = n : j9.f(t, e, {
      value: n,
      enumerable: !1,
      configurable: !i.nonConfigurable,
      writable: !i.nonWritable
    });
  }
  return t;
}, GT = {}, N9 = Math.ceil, A9 = Math.floor, T9 = Math.trunc || function(e) {
  var n = +e;
  return (n > 0 ? A9 : N9)(n);
}, b9 = T9, Vo = function(t) {
  var e = +t;
  return e !== e || e === 0 ? 0 : b9(e);
}, v9 = Vo, E9 = Math.max, C9 = Math.min, z9 = function(t, e) {
  var n = v9(t);
  return n < 0 ? E9(n + e, 0) : C9(n, e);
}, L9 = Vo, k9 = Math.min, WT = function(t) {
  var e = L9(t);
  return e > 0 ? k9(e, 9007199254740991) : 0;
}, O9 = WT, ud = function(t) {
  return O9(t.length);
}, P9 = fp, U9 = z9, R9 = ud, Y9 = function(t) {
  return function(e, n, i) {
    var r = P9(e), s = R9(r);
    if (s === 0) return !t && -1;
    var o = U9(i, s), a;
    if (t && n !== n) {
      for (; s > o; )
        if (a = r[o++], a !== a) return !0;
    } else for (; s > o; o++)
      if ((t || o in r) && r[o] === n) return t || o || 0;
    return !t && -1;
  };
}, Q9 = {
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: Y9(!1)
}, Z9 = cn, pM = ao, F9 = fp, B9 = Q9.indexOf, G9 = Dx, BD = Z9([].push), HT = function(t, e) {
  var n = F9(t), i = 0, r = [], s;
  for (s in n) !pM(G9, s) && pM(n, s) && BD(r, s);
  for (; e.length > i; ) pM(n, s = e[i++]) && (~B9(r, s) || BD(r, s));
  return r;
}, Nx = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], W9 = HT, H9 = Nx, V9 = H9.concat("length", "prototype");
GT.f = Object.getOwnPropertyNames || function(e) {
  return W9(e, V9);
};
var VT = {};
VT.f = Object.getOwnPropertySymbols;
var K9 = Mp, X9 = cn, J9 = GT, q9 = VT, _9 = Ho, $9 = X9([].concat), eQ = K9("Reflect", "ownKeys") || function(e) {
  var n = J9.f(_9(e)), i = q9.f;
  return i ? $9(n, i(e)) : n;
}, GD = ao, tQ = eQ, nQ = Mx, iQ = yc, rQ = function(t, e, n) {
  for (var i = tQ(e), r = iQ.f, s = nQ.f, o = 0; o < i.length; o++) {
    var a = i[o];
    !GD(t, a) && !(n && GD(n, a)) && r(t, a, s(e, a));
  }
}, sQ = Xn, oQ = Jn, aQ = /#|\.prototype\./, hd = function(t, e) {
  var n = lQ[cQ(t)];
  return n === uQ ? !0 : n === dQ ? !1 : oQ(e) ? sQ(e) : !!e;
}, cQ = hd.normalize = function(t) {
  return String(t).replace(aQ, ".").toLowerCase();
}, lQ = hd.data = {}, dQ = hd.NATIVE = "N", uQ = hd.POLYFILL = "P", hQ = hd, Mu = Kn, gQ = Mx.f, pQ = jx, fQ = BT, MQ = Ix, mQ = rQ, yQ = hQ, Ic = function(t, e) {
  var n = t.target, i = t.global, r = t.stat, s, o, a, c, d, u;
  if (i ? o = Mu : r ? o = Mu[n] || MQ(n, {}) : o = Mu[n] && Mu[n].prototype, o) for (a in e) {
    if (d = e[a], t.dontCallGetSet ? (u = gQ(o, a), c = u && u.value) : c = o[a], s = yQ(i ? a : n + (r ? "." : "#") + a, t.forced), !s && c !== void 0) {
      if (typeof d == typeof c) continue;
      mQ(d, c);
    }
    (t.sham || c && c.sham) && pQ(d, "sham", !0), fQ(o, a, d, t);
  }
}, KT = {}, IQ = HT, xQ = Nx, SQ = Object.keys || function(e) {
  return IQ(e, xQ);
}, jQ = oo, DQ = OT, wQ = yc, NQ = Ho, AQ = fp, TQ = SQ;
KT.f = jQ && !DQ ? Object.defineProperties : function(e, n) {
  NQ(e);
  for (var i = AQ(n), r = TQ(n), s = r.length, o = 0, a; s > o; ) wQ.f(e, a = r[o++], i[a]);
  return e;
};
var bQ = Mp, vQ = bQ("document", "documentElement"), EQ = Ho, CQ = KT, WD = Nx, zQ = Dx, LQ = vQ, kQ = LT, OQ = YT, HD = ">", VD = "<", by = "prototype", vy = "script", XT = OQ("IE_PROTO"), fM = function() {
}, JT = function(t) {
  return VD + vy + HD + t + VD + "/" + vy + HD;
}, KD = function(t) {
  t.write(JT("")), t.close();
  var e = t.parentWindow.Object;
  return t = null, e;
}, PQ = function() {
  var t = kQ("iframe"), e = "java" + vy + ":", n;
  return t.style.display = "none", LQ.appendChild(t), t.src = String(e), n = t.contentWindow.document, n.open(), n.write(JT("document.F=Object")), n.close(), n.F;
}, mu, mh = function() {
  try {
    mu = new ActiveXObject("htmlfile");
  } catch {
  }
  mh = typeof document < "u" ? document.domain && mu ? KD(mu) : PQ() : KD(mu);
  for (var t = WD.length; t--; ) delete mh[by][WD[t]];
  return mh();
};
zQ[XT] = !0;
var qT = Object.create || function(e, n) {
  var i;
  return e !== null ? (fM[by] = EQ(e), i = new fM(), fM[by] = null, i[XT] = e) : i = mh(), n === void 0 ? i : CQ.f(i, n);
}, UQ = js, RQ = qT, YQ = yc.f, Ey = UQ("unscopables"), Cy = Array.prototype;
Cy[Ey] === void 0 && YQ(Cy, Ey, {
  configurable: !0,
  value: RQ(null)
});
var Ax = function(t) {
  Cy[Ey][t] = !0;
}, QQ = Ic, ZQ = dd, FQ = ud, BQ = Vo, GQ = Ax;
QQ({ target: "Array", proto: !0 }, {
  at: function(e) {
    var n = ZQ(this), i = FQ(n), r = BQ(e), s = r >= 0 ? r : i + r;
    return s < 0 || s >= i ? void 0 : n[s];
  }
});
GQ("at");
var WQ = Kn, HQ = cn, gd = function(t, e) {
  return HQ(WQ[t].prototype[e]);
}, VQ = gd;
VQ("Array", "at");
var KQ = fc, _T = Array.isArray || function(e) {
  return KQ(e) === "Array";
}, XQ = TypeError, JQ = 9007199254740991, qQ = function(t) {
  if (t > JQ) throw XQ("Maximum allowed index exceeded");
  return t;
}, _Q = fc, $Q = cn, eZ = function(t) {
  if (_Q(t) === "Function") return $Q(t);
}, XD = eZ, tZ = mx, nZ = gp, iZ = XD(XD.bind), rZ = function(t, e) {
  return tZ(t), e === void 0 ? t : nZ ? iZ(t, e) : function() {
    return t.apply(e, arguments);
  };
}, sZ = _T, oZ = ud, aZ = qQ, cZ = rZ, $T = function(t, e, n, i, r, s, o, a) {
  for (var c = r, d = 0, u = o ? cZ(o, a) : !1, h, g; d < i; )
    d in n && (h = u ? u(n[d], d, e) : n[d], s > 0 && sZ(h) ? (g = oZ(h), c = $T(t, e, h, g, c, s - 1) - 1) : (aZ(c + 1), t[c] = h), c++), d++;
  return c;
}, eb = $T, lZ = js, dZ = lZ("toStringTag"), tb = {};
tb[dZ] = "z";
var uZ = String(tb) === "[object z]", hZ = uZ, gZ = Jn, yh = fc, pZ = js, fZ = pZ("toStringTag"), MZ = Object, mZ = yh(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", yZ = function(t, e) {
  try {
    return t[e];
  } catch {
  }
}, nb = hZ ? yh : function(t) {
  var e, n, i;
  return t === void 0 ? "Undefined" : t === null ? "Null" : typeof (n = yZ(e = MZ(t), fZ)) == "string" ? n : mZ ? yh(e) : (i = yh(e)) === "Object" && gZ(e.callee) ? "Arguments" : i;
}, IZ = cn, xZ = Xn, ib = Jn, SZ = nb, jZ = Mp, DZ = RT, rb = function() {
}, sb = jZ("Reflect", "construct"), Tx = /^\s*(?:class|function)\b/, wZ = IZ(Tx.exec), NZ = !Tx.test(rb), $c = function(e) {
  if (!ib(e)) return !1;
  try {
    return sb(rb, [], e), !0;
  } catch {
    return !1;
  }
}, ob = function(e) {
  if (!ib(e)) return !1;
  switch (SZ(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return NZ || !!wZ(Tx, DZ(e));
  } catch {
    return !0;
  }
};
ob.sham = !0;
var AZ = !sb || xZ(function() {
  var t;
  return $c($c.call) || !$c(Object) || !$c(function() {
    t = !0;
  }) || t;
}) ? ob : $c, JD = _T, TZ = AZ, bZ = mc, vZ = js, EZ = vZ("species"), qD = Array, CZ = function(t) {
  var e;
  return JD(t) && (e = t.constructor, TZ(e) && (e === qD || JD(e.prototype)) ? e = void 0 : bZ(e) && (e = e[EZ], e === null && (e = void 0))), e === void 0 ? qD : e;
}, zZ = CZ, ab = function(t, e) {
  return new (zZ(t))(e === 0 ? 0 : e);
}, LZ = Ic, kZ = eb, OZ = mx, PZ = dd, UZ = ud, RZ = ab;
LZ({ target: "Array", proto: !0 }, {
  flatMap: function(e) {
    var n = PZ(this), i = UZ(n), r;
    return OZ(e), r = RZ(n, 0), r.length = kZ(r, n, n, i, 0, 1, e, arguments.length > 1 ? arguments[1] : void 0), r;
  }
});
var YZ = Ax;
YZ("flatMap");
var QZ = gd;
QZ("Array", "flatMap");
var ZZ = Ic, FZ = eb, BZ = dd, GZ = ud, WZ = Vo, HZ = ab;
ZZ({ target: "Array", proto: !0 }, {
  flat: function() {
    var e = arguments.length ? arguments[0] : void 0, n = BZ(this), i = GZ(n), r = HZ(n, 0);
    return r.length = FZ(r, n, n, i, 0, e === void 0 ? 1 : WZ(e)), r;
  }
});
var VZ = Ax;
VZ("flat");
var KZ = gd;
KZ("Array", "flat");
var XZ = nb, JZ = String, pd = function(t) {
  if (XZ(t) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
  return JZ(t);
}, qZ = Ic, _Z = cn, $Z = Mc, eF = Vo, tF = pd, nF = Xn, iF = _Z("".charAt), rF = nF(function() {
  return "𠮷".at(-2) !== "\uD842";
});
qZ({ target: "String", proto: !0, forced: rF }, {
  at: function(e) {
    var n = tF($Z(this)), i = n.length, r = eF(e), s = r >= 0 ? r : i + r;
    return s < 0 || s >= i ? void 0 : iF(n, s);
  }
});
var sF = gd;
sF("String", "at");
var oF = Ho, cb = function() {
  var t = oF(this), e = "";
  return t.hasIndices && (e += "d"), t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.unicodeSets && (e += "v"), t.sticky && (e += "y"), e;
}, bx = Xn, aF = Kn, vx = aF.RegExp, lb = bx(function() {
  var t = vx("a", "y");
  return t.lastIndex = 2, t.exec("abcd") !== null;
});
lb || bx(function() {
  return !vx("a", "y").sticky;
});
var cF = lb || bx(function() {
  var t = vx("^r", "gy");
  return t.lastIndex = 2, t.exec("str") !== null;
}), lF = {
  BROKEN_CARET: cF
}, dF = Xn, uF = Kn, hF = uF.RegExp, gF = dF(function() {
  var t = hF(".", "s");
  return !(t.dotAll && t.test(`
`) && t.flags === "s");
}), pF = Xn, fF = Kn, MF = fF.RegExp, mF = pF(function() {
  var t = MF("(?<a>b)", "g");
  return t.exec("b").groups.a !== "b" || "b".replace(t, "$<a>c") !== "bc";
}), Aa = Ss, mp = cn, yF = pd, IF = cb, xF = lF, SF = Sx, jF = qT, DF = ZT.get, wF = gF, NF = mF, AF = SF("native-string-replace", String.prototype.replace), Mg = RegExp.prototype.exec, zy = Mg, TF = mp("".charAt), bF = mp("".indexOf), vF = mp("".replace), MM = mp("".slice), Ly = function() {
  var t = /a/, e = /b*/g;
  return Aa(Mg, t, "a"), Aa(Mg, e, "a"), t.lastIndex !== 0 || e.lastIndex !== 0;
}(), db = xF.BROKEN_CARET, ky = /()??/.exec("")[1] !== void 0, EF = Ly || ky || db || wF || NF;
EF && (zy = function(e) {
  var n = this, i = DF(n), r = yF(e), s = i.raw, o, a, c, d, u, h, g;
  if (s)
    return s.lastIndex = n.lastIndex, o = Aa(zy, s, r), n.lastIndex = s.lastIndex, o;
  var p = i.groups, f = db && n.sticky, M = Aa(IF, n), m = n.source, y = 0, I = r;
  if (f && (M = vF(M, "y", ""), bF(M, "g") === -1 && (M += "g"), I = MM(r, n.lastIndex), n.lastIndex > 0 && (!n.multiline || n.multiline && TF(r, n.lastIndex - 1) !== `
`) && (m = "(?: " + m + ")", I = " " + I, y++), a = new RegExp("^(?:" + m + ")", M)), ky && (a = new RegExp("^" + m + "$(?!\\s)", M)), Ly && (c = n.lastIndex), d = Aa(Mg, f ? a : n, I), f ? d ? (d.input = MM(d.input, y), d[0] = MM(d[0], y), d.index = n.lastIndex, n.lastIndex += d[0].length) : n.lastIndex = 0 : Ly && d && (n.lastIndex = n.global ? d.index + d[0].length : c), ky && d && d.length > 1 && Aa(AF, d[0], a, function() {
    for (u = 1; u < arguments.length - 2; u++)
      arguments[u] === void 0 && (d[u] = void 0);
  }), d && p)
    for (d.groups = h = jF(null), u = 0; u < p.length; u++)
      g = p[u], h[g[0]] = d[g[1]];
  return d;
});
var Ex = zy, CF = Ic, _D = Ex;
CF({ target: "RegExp", proto: !0, forced: /./.exec !== _D }, {
  exec: _D
});
var zF = gp, ub = Function.prototype, $D = ub.apply, e0 = ub.call, LF = typeof Reflect == "object" && Reflect.apply || (zF ? e0.bind($D) : function() {
  return e0.apply($D, arguments);
}), t0 = Ss, n0 = BT, kF = Ex, i0 = Xn, hb = js, OF = jx, PF = hb("species"), mM = RegExp.prototype, UF = function(t, e, n, i) {
  var r = hb(t), s = !i0(function() {
    var d = {};
    return d[r] = function() {
      return 7;
    }, ""[t](d) !== 7;
  }), o = s && !i0(function() {
    var d = !1, u = /a/;
    return t === "split" && (u = {}, u.constructor = {}, u.constructor[PF] = function() {
      return u;
    }, u.flags = "", u[r] = /./[r]), u.exec = function() {
      return d = !0, null;
    }, u[r](""), !d;
  });
  if (!s || !o || n) {
    var a = /./[r], c = e(r, ""[t], function(d, u, h, g, p) {
      var f = u.exec;
      return f === kF || f === mM.exec ? s && !p ? { done: !0, value: t0(a, u, h, g) } : { done: !0, value: t0(d, h, u, g) } : { done: !1 };
    });
    n0(String.prototype, t, c[0]), n0(mM, r, c[1]);
  }
  i && OF(mM[r], "sham", !0);
}, Cx = cn, RF = Vo, YF = pd, QF = Mc, ZF = Cx("".charAt), r0 = Cx("".charCodeAt), FF = Cx("".slice), BF = function(t) {
  return function(e, n) {
    var i = YF(QF(e)), r = RF(n), s = i.length, o, a;
    return r < 0 || r >= s ? t ? "" : void 0 : (o = r0(i, r), o < 55296 || o > 56319 || r + 1 === s || (a = r0(i, r + 1)) < 56320 || a > 57343 ? t ? ZF(i, r) : o : t ? FF(i, r, r + 2) : (o - 55296 << 10) + (a - 56320) + 65536);
  };
}, GF = {
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: BF(!0)
}, WF = GF.charAt, HF = function(t, e, n) {
  return e + (n ? WF(t, e).length : 1);
}, zx = cn, VF = dd, KF = Math.floor, yM = zx("".charAt), XF = zx("".replace), IM = zx("".slice), JF = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, qF = /\$([$&'`]|\d{1,2})/g, gb = function(t, e, n, i, r, s) {
  var o = n + t.length, a = i.length, c = qF;
  return r !== void 0 && (r = VF(r), c = JF), XF(s, c, function(d, u) {
    var h;
    switch (yM(u, 0)) {
      case "$":
        return "$";
      case "&":
        return t;
      case "`":
        return IM(e, 0, n);
      case "'":
        return IM(e, o);
      case "<":
        h = r[IM(u, 1, -1)];
        break;
      default:
        var g = +u;
        if (g === 0) return d;
        if (g > a) {
          var p = KF(g / 10);
          return p === 0 ? d : p <= a ? i[p - 1] === void 0 ? yM(u, 1) : i[p - 1] + yM(u, 1) : d;
        }
        h = i[g - 1];
    }
    return h === void 0 ? "" : h;
  });
}, s0 = Ss, _F = Ho, $F = Jn, eB = fc, tB = Ex, nB = TypeError, iB = function(t, e) {
  var n = t.exec;
  if ($F(n)) {
    var i = s0(n, t, e);
    return i !== null && _F(i), i;
  }
  if (eB(t) === "RegExp") return s0(tB, t, e);
  throw new nB("RegExp#exec called on incompatible receiver");
}, rB = LF, o0 = Ss, yp = cn, sB = UF, oB = Xn, aB = Ho, cB = Jn, lB = pp, dB = Vo, uB = WT, oa = pd, hB = Mc, gB = HF, pB = yx, fB = gb, MB = iB, mB = js, Oy = mB("replace"), yB = Math.max, IB = Math.min, xB = yp([].concat), xM = yp([].push), a0 = yp("".indexOf), c0 = yp("".slice), SB = function(t) {
  return t === void 0 ? t : String(t);
}, jB = function() {
  return "a".replace(/./, "$0") === "$0";
}(), l0 = function() {
  return /./[Oy] ? /./[Oy]("a", "$0") === "" : !1;
}(), DB = !oB(function() {
  var t = /./;
  return t.exec = function() {
    var e = [];
    return e.groups = { a: "7" }, e;
  }, "".replace(t, "$<a>") !== "7";
});
sB("replace", function(t, e, n) {
  var i = l0 ? "$" : "$0";
  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function(s, o) {
      var a = hB(this), c = lB(s) ? void 0 : pB(s, Oy);
      return c ? o0(c, s, a, o) : o0(e, oa(a), s, o);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function(r, s) {
      var o = aB(this), a = oa(r);
      if (typeof s == "string" && a0(s, i) === -1 && a0(s, "$<") === -1) {
        var c = n(e, o, a, s);
        if (c.done) return c.value;
      }
      var d = cB(s);
      d || (s = oa(s));
      var u = o.global, h;
      u && (h = o.unicode, o.lastIndex = 0);
      for (var g = [], p; p = MB(o, a), !(p === null || (xM(g, p), !u)); ) {
        var f = oa(p[0]);
        f === "" && (o.lastIndex = gB(a, uB(o.lastIndex), h));
      }
      for (var M = "", m = 0, y = 0; y < g.length; y++) {
        p = g[y];
        for (var I = oa(p[0]), D = yB(IB(dB(p.index), a.length), 0), j = [], w, A = 1; A < p.length; A++) xM(j, SB(p[A]));
        var b = p.groups;
        if (d) {
          var T = xB([I], j, D, a);
          b !== void 0 && xM(T, b), w = oa(rB(s, void 0, T));
        } else
          w = fB(I, a, D, j, b, s);
        D >= m && (M += c0(a, m, D) + w, m = D + I.length);
      }
      return M + c0(a, m);
    }
  ];
}, !DB || !jB || l0);
var wB = mc, NB = fc, AB = js, TB = AB("match"), bB = function(t) {
  var e;
  return wB(t) && ((e = t[TB]) !== void 0 ? !!e : NB(t) === "RegExp");
}, vB = Ss, EB = ao, CB = NT, zB = cb, d0 = RegExp.prototype, LB = function(t) {
  var e = t.flags;
  return e === void 0 && !("flags" in d0) && !EB(t, "flags") && CB(d0, t) ? vB(zB, t) : e;
}, kB = Ic, OB = Ss, Lx = cn, u0 = Mc, PB = Jn, UB = pp, RB = bB, el = pd, YB = yx, QB = LB, ZB = gb, FB = js, BB = FB("replace"), GB = TypeError, SM = Lx("".indexOf);
Lx("".replace);
var h0 = Lx("".slice), WB = Math.max;
kB({ target: "String", proto: !0 }, {
  replaceAll: function(e, n) {
    var i = u0(this), r, s, o, a, c, d, u, h, g, p, f = 0, M = "";
    if (!UB(e)) {
      if (r = RB(e), r && (s = el(u0(QB(e))), !~SM(s, "g")))
        throw new GB("`.replaceAll` does not allow non-global regexes");
      if (o = YB(e, BB), o) return OB(o, e, i, n);
    }
    for (a = el(i), c = el(e), d = PB(n), d || (n = el(n)), u = c.length, h = WB(1, u), g = SM(a, c); g !== -1; )
      p = d ? el(n(c, g, a)) : ZB(c, a, g, [], void 0, n), M += h0(a, f, g) + p, f = g + u, g = g + h > a.length ? -1 : SM(a, c, g + h);
    return f < a.length && (M += h0(a, f)), M;
  }
});
var HB = gd;
HB("String", "replaceAll");
function pb(t) {
  return t && typeof t == "object" && "parents" in t;
}
function fb(t) {
  for (let e = 0, n = t.parents.length; e < n; e++)
    if (t.parents[e].__unsafe__getWithoutCapture(!0), t.parents[e].lastChangedEpoch !== t.parentEpochs[e])
      return !0;
  return !1;
}
function mg(t, e) {
  if (t.children.remove(e) && t.children.isEmpty && pb(t))
    for (let n = 0, i = t.parents.length; n < i; n++)
      mg(t.parents[n], t);
}
function kx(t, e) {
  if (t.children.add(e) && pb(t))
    for (let n = 0, i = t.parents.length; n < i; n++)
      kx(t.parents[n], t);
}
function Mb(t, e) {
  return t === e || Object.is(t, e) || !!(t && e && typeof t.equals == "function" && t.equals(e));
}
function co(t, e) {
  const n = Symbol.for(`com.tldraw.state/${t}`), i = globalThis;
  return i[n] ?? (i[n] = e()), i[n];
}
const hs = co("empty_array", () => Object.freeze([])), g0 = 8;
class yg {
  constructor() {
    S(this, "arraySize", 0);
    S(this, "array", Array(g0));
    S(this, "set", null);
  }
  /**
   * Get whether this ArraySet has any elements.
   *
   * @returns True if this ArraySet has any elements, false otherwise.
   */
  // eslint-disable-next-line no-restricted-syntax
  get isEmpty() {
    if (this.array)
      return this.arraySize === 0;
    if (this.set)
      return this.set.size === 0;
    throw new Error("no set or array");
  }
  /**
   * Add an item to the ArraySet if it is not already present.
   *
   * @param elem - The element to add.
   */
  add(e) {
    if (this.array)
      return this.array.indexOf(e) !== -1 ? !1 : this.arraySize < g0 ? (this.array[this.arraySize] = e, this.arraySize++, !0) : (this.set = new Set(this.array), this.array = null, this.set.add(e), !0);
    if (this.set)
      return this.set.has(e) ? !1 : (this.set.add(e), !0);
    throw new Error("no set or array");
  }
  /**
   * Remove an item from the ArraySet if it is present.
   *
   * @param elem - The element to remove
   */
  remove(e) {
    if (this.array) {
      const n = this.array.indexOf(e);
      return n === -1 ? !1 : (this.array[n] = void 0, this.arraySize--, n !== this.arraySize && (this.array[n] = this.array[this.arraySize], this.array[this.arraySize] = void 0), !0);
    }
    if (this.set)
      return this.set.has(e) ? (this.set.delete(e), !0) : !1;
    throw new Error("no set or array");
  }
  /**
   * Run a callback for each element in the ArraySet.
   *
   * @param visitor - The callback to run for each element.
   */
  visit(e) {
    if (this.array) {
      for (let n = 0; n < this.arraySize; n++) {
        const i = this.array[n];
        typeof i < "u" && e(i);
      }
      return;
    }
    if (this.set) {
      this.set.forEach(e);
      return;
    }
    throw new Error("no set or array");
  }
  has(e) {
    return this.array ? this.array.indexOf(e) !== -1 : this.set.has(e);
  }
  clear() {
    this.set ? this.set.clear() : (this.arraySize = 0, this.array = []);
  }
  size() {
    return this.set ? this.set.size : this.arraySize;
  }
}
const vi = Symbol.for("com.tldraw.state/RESET_VALUE");
class mb {
  constructor(e) {
    S(this, "index", 0);
    // use a wrap around buffer to store the last N values
    S(this, "buffer");
    this.capacity = e, this.buffer = new Array(e);
  }
  /**
   * Add a diff to the history buffer.
   *
   * @param lastComputedEpoch - The epoch when the diff was computed.
   * @param currentEpoch - The current epoch.
   * @param diff - The diff to add, or else a reset value.
   */
  pushEntry(e, n, i) {
    if (i !== void 0) {
      if (i === vi) {
        this.clear();
        return;
      }
      this.buffer[this.index] = [e, n, i], this.index = (this.index + 1) % this.capacity;
    }
  }
  /**
   * Clear the history buffer.
   */
  clear() {
    this.index = 0, this.buffer.fill(void 0);
  }
  /**
   * Get the diffs since the given epoch.
   *
   * @param sinceEpoch - The epoch to get diffs since.
   * @returns An array of diffs or a flag to reset the history buffer.
   */
  getChangesSince(e) {
    const { index: n, capacity: i, buffer: r } = this;
    for (let s = 0; s < i; s++) {
      const o = (n - 1 + i - s) % i, a = r[o];
      if (!a)
        return vi;
      const [c, d] = a;
      if (s === 0 && e >= d)
        return [];
      if (c <= e && e < d) {
        const u = s + 1, h = new Array(u);
        for (let g = 0; g < u; g++)
          h[g] = r[(o + g) % i][2];
        return h;
      }
    }
    return vi;
  }
}
class VB {
  constructor(e, n) {
    S(this, "offset", 0);
    S(this, "maybeRemoved");
    this.below = e, this.child = n;
  }
}
const Lt = co("capture", () => ({ stack: null }));
function yu(t) {
  const e = Lt.stack;
  Lt.stack = null;
  try {
    return t();
  } finally {
    Lt.stack = e;
  }
}
function yb(t) {
  Lt.stack = new VB(Lt.stack, t), t.parentSet.clear();
}
function Ib() {
  const t = Lt.stack;
  if (Lt.stack = t.below, t.offset < t.child.parents.length) {
    for (let e = t.offset; e < t.child.parents.length; e++) {
      const n = t.child.parents[e];
      t.child.parentSet.has(n) || mg(n, t.child);
    }
    t.child.parents.length = t.offset, t.child.parentEpochs.length = t.offset;
  }
  if (t.maybeRemoved)
    for (let e = 0; e < t.maybeRemoved.length; e++) {
      const n = t.maybeRemoved[e];
      t.child.parentSet.has(n) || mg(n, t.child);
    }
}
function Ig(t) {
  if (Lt.stack) {
    if (Lt.stack.child.parentSet.has(t))
      return;
    if (Lt.stack.child.parentSet.add(t), Lt.stack.child.isActivelyListening && kx(t, Lt.stack.child), Lt.stack.offset < Lt.stack.child.parents.length) {
      const n = Lt.stack.child.parents[Lt.stack.offset];
      n !== t && (Lt.stack.maybeRemoved ? Lt.stack.maybeRemoved.push(n) : Lt.stack.maybeRemoved = [n]);
    }
    Lt.stack.child.parents[Lt.stack.offset] = t, Lt.stack.child.parentEpochs[Lt.stack.offset] = t.lastChangedEpoch, Lt.stack.offset++;
  }
}
const Ws = -1;
class KB {
  constructor(e, n, i) {
    S(this, "_isActivelyListening", !1);
    /** @internal */
    S(this, "lastTraversedEpoch", Ws);
    S(this, "lastReactedEpoch", Ws);
    S(this, "_scheduleCount", 0);
    /** @internal */
    S(this, "parentSet", new yg());
    /** @internal */
    S(this, "parentEpochs", []);
    /** @internal */
    S(this, "parents", []);
    S(this, "_scheduleEffect");
    /** @internal */
    // eslint-disable-next-line local/prefer-class-methods
    S(this, "maybeExecute", () => {
      this._isActivelyListening && this.execute();
    });
    this.name = e, this.runEffect = n, this._scheduleEffect = i == null ? void 0 : i.scheduleEffect;
  }
  /**
   * Whether this scheduler is attached and actively listening to its parents.
   * @public
   */
  // eslint-disable-next-line no-restricted-syntax
  get isActivelyListening() {
    return this._isActivelyListening;
  }
  /**
   * The number of times this effect has been scheduled.
   * @public
   */
  // eslint-disable-next-line no-restricted-syntax
  get scheduleCount() {
    return this._scheduleCount;
  }
  /** @internal */
  maybeScheduleEffect() {
    if (this._isActivelyListening && this.lastReactedEpoch !== ri()) {
      if (this.parents.length && !fb(this)) {
        this.lastReactedEpoch = ri();
        return;
      }
      this.scheduleEffect();
    }
  }
  /** @internal */
  scheduleEffect() {
    this._scheduleCount++, this._scheduleEffect ? this._scheduleEffect(this.maybeExecute) : this.execute();
  }
  /**
   * Makes this scheduler become 'actively listening' to its parents.
   * If it has been executed before it will immediately become eligible to receive 'maybeScheduleEffect' calls.
   * If it has not executed before it will need to be manually executed once to become eligible for scheduling, i.e. by calling [[EffectScheduler.execute]].
   * @public
   */
  attach() {
    this._isActivelyListening = !0;
    for (let e = 0, n = this.parents.length; e < n; e++)
      kx(this.parents[e], this);
  }
  /**
   * Makes this scheduler stop 'actively listening' to its parents.
   * It will no longer be eligible to receive 'maybeScheduleEffect' calls until [[EffectScheduler.attach]] is called again.
   */
  detach() {
    this._isActivelyListening = !1;
    for (let e = 0, n = this.parents.length; e < n; e++)
      mg(this.parents[e], this);
  }
  /**
   * Executes the effect immediately and returns the result.
   * @returns The result of the effect.
   */
  execute() {
    try {
      yb(this);
      const e = ri(), n = this.runEffect(this.lastReactedEpoch);
      return this.lastReactedEpoch = e, n;
    } finally {
      Ib();
    }
  }
}
const xc = co(
  "EffectScheduler",
  () => KB
);
function Yr(t, e, n) {
  const i = new xc(t, e, n);
  return i.attach(), i.scheduleEffect(), () => {
    i.detach();
  };
}
function XB(t, e, n) {
  const i = new xc(t, e, n);
  return {
    scheduler: i,
    start: (r) => {
      const s = (r == null ? void 0 : r.force) ?? !1;
      i.attach(), s ? i.scheduleEffect() : i.maybeScheduleEffect();
    },
    stop: () => {
      i.detach();
    }
  };
}
class JB {
  constructor(e) {
    S(this, "initialAtomValues", /* @__PURE__ */ new Map());
    this.parent = e;
  }
  /**
   * Get whether this transaction is a root (no parents).
   *
   * @public
   */
  // eslint-disable-next-line no-restricted-syntax
  get isRoot() {
    return this.parent === null;
  }
  /**
   * Commit the transaction's changes.
   *
   * @public
   */
  commit() {
    if (ot.globalIsReacting)
      for (const e of this.initialAtomValues.keys())
        Sb(e);
    else this.isRoot ? xb(this.initialAtomValues.keys()) : this.initialAtomValues.forEach((e, n) => {
      this.parent.initialAtomValues.has(n) || this.parent.initialAtomValues.set(n, e);
    });
  }
  /**
   * Abort the transaction.
   *
   * @public
   */
  abort() {
    ot.globalEpoch++, this.initialAtomValues.forEach((e, n) => {
      var i;
      n.set(e), (i = n.historyBuffer) == null || i.clear();
    }), this.commit();
  }
}
const ot = co("transactions", () => ({
  // The current epoch (global to all atoms).
  globalEpoch: Ws + 1,
  // Whether any transaction is reacting.
  globalIsReacting: !1,
  currentTransaction: null,
  cleanupReactors: null,
  reactionEpoch: Ws + 1
}));
function qB() {
  return ot.reactionEpoch;
}
function ri() {
  return ot.globalEpoch;
}
function _B() {
  return ot.globalIsReacting;
}
function Ox(t, e) {
  e.lastTraversedEpoch !== ot.globalEpoch && (e.lastTraversedEpoch = ot.globalEpoch, e instanceof xc ? t.add(e) : e.children.visit((n) => Ox(t, n)));
}
function xb(t) {
  var n;
  if (ot.globalIsReacting)
    throw new Error("flushChanges cannot be called during a reaction");
  const e = ot.currentTransaction;
  try {
    ot.currentTransaction = null, ot.globalIsReacting = !0, ot.reactionEpoch = ot.globalEpoch;
    const i = /* @__PURE__ */ new Set();
    for (const s of t)
      s.children.visit((o) => Ox(i, o));
    for (const s of i)
      s.maybeScheduleEffect();
    let r = 0;
    for (; (n = ot.cleanupReactors) != null && n.size; ) {
      if (r++ > 1e3)
        throw new Error("Reaction update depth limit exceeded");
      const s = ot.cleanupReactors;
      ot.cleanupReactors = null;
      for (const o of s)
        o.maybeScheduleEffect();
    }
  } finally {
    ot.cleanupReactors = null, ot.globalIsReacting = !1, ot.currentTransaction = e;
  }
}
function $B(t, e) {
  ot.currentTransaction ? ot.currentTransaction.initialAtomValues.has(t) || ot.currentTransaction.initialAtomValues.set(t, e) : ot.globalIsReacting ? Sb(t) : xb([t]);
}
function Sb(t) {
  const e = ot.cleanupReactors ?? (ot.cleanupReactors = /* @__PURE__ */ new Set());
  t.children.visit((n) => Ox(e, n));
}
function eG() {
  ot.globalEpoch++;
}
function tG(t) {
  const e = new JB(ot.currentTransaction);
  ot.currentTransaction = e;
  try {
    let n, i = !1;
    try {
      n = t(() => i = !0);
    } catch (r) {
      throw e.abort(), r;
    }
    return i ? e.abort() : e.commit(), n;
  } finally {
    ot.currentTransaction = ot.currentTransaction.parent;
  }
}
function Qr(t) {
  return ot.currentTransaction ? t() : tG(t);
}
class nG {
  constructor(e, n, i) {
    S(this, "isEqual");
    S(this, "computeDiff");
    S(this, "lastChangedEpoch", ri());
    S(this, "children", new yg());
    S(this, "historyBuffer");
    this.name = e, this.current = n, this.isEqual = (i == null ? void 0 : i.isEqual) ?? null, i && (i.historyLength && (this.historyBuffer = new mb(i.historyLength)), this.computeDiff = i.computeDiff);
  }
  __unsafe__getWithoutCapture(e) {
    return this.current;
  }
  get() {
    return Ig(this), this.current;
  }
  set(e, n) {
    var r, s;
    if (((r = this.isEqual) == null ? void 0 : r.call(this, this.current, e)) ?? Mb(this.current, e))
      return this.current;
    eG(), this.historyBuffer && this.historyBuffer.pushEntry(
      this.lastChangedEpoch,
      ri(),
      n ?? ((s = this.computeDiff) == null ? void 0 : s.call(this, this.current, e, this.lastChangedEpoch, ri())) ?? vi
    ), this.lastChangedEpoch = ri();
    const i = this.current;
    return this.current = e, $B(this, i), e;
  }
  update(e) {
    return this.set(e(this.current));
  }
  getDiffSince(e) {
    var n;
    return Ig(this), e >= this.lastChangedEpoch ? hs : ((n = this.historyBuffer) == null ? void 0 : n.getChangesSince(e)) ?? vi;
  }
}
const iG = co("Atom", () => nG);
function xt(t, e, n) {
  return new iG(t, e, n);
}
let p0 = !1;
function rG() {
  p0 || (p0 = !0, console.warn(
    `Using \`@computed\` as a decorator for getters is deprecated and will be removed in the near future. Please refactor to use \`@computed\` as a decorator for methods.

// Before
@computed
get foo() {
	return 'foo'
}

// After
@computed
getFoo() {
	return 'foo'
}
`
  ));
}
const xl = Symbol.for("com.tldraw.state/UNINITIALIZED");
function bo(t) {
  return t === xl;
}
const Py = co(
  "WithDiff",
  () => class {
    constructor(e, n) {
      this.value = e, this.diff = n;
    }
  }
);
function Sl(t, e) {
  return new Py(t, e);
}
class sG {
  constructor(e, n, i) {
    S(this, "lastChangedEpoch", Ws);
    S(this, "lastTraversedEpoch", Ws);
    /**
     * The epoch when the reactor was last checked.
     */
    S(this, "lastCheckedEpoch", Ws);
    S(this, "parentSet", new yg());
    S(this, "parents", []);
    S(this, "parentEpochs", []);
    S(this, "children", new yg());
    S(this, "historyBuffer");
    // The last-computed value of this signal.
    S(this, "state", xl);
    // If the signal throws an error we stash it so we can rethrow it on the next get()
    S(this, "error", null);
    S(this, "computeDiff");
    S(this, "isEqual");
    this.name = e, this.derive = n, i != null && i.historyLength && (this.historyBuffer = new mb(i.historyLength)), this.computeDiff = i == null ? void 0 : i.computeDiff, this.isEqual = (i == null ? void 0 : i.isEqual) ?? Mb;
  }
  // eslint-disable-next-line no-restricted-syntax
  get isActivelyListening() {
    return !this.children.isEmpty;
  }
  __unsafe__getWithoutCapture(e) {
    var r;
    const n = this.lastChangedEpoch === Ws, i = ri();
    if (!n && (this.lastCheckedEpoch === i || this.isActivelyListening && _B() && this.lastTraversedEpoch < qB() || !fb(this)))
      if (this.lastCheckedEpoch = i, this.error) {
        if (e)
          return this.state;
        throw this.error.thrownValue;
      } else
        return this.state;
    try {
      yb(this);
      const s = this.derive(this.state, this.lastCheckedEpoch), o = s instanceof Py ? s.value : s, a = this.state === xl;
      if (a || !this.isEqual(o, this.state)) {
        if (this.historyBuffer && !a) {
          const c = s instanceof Py ? s.diff : void 0;
          this.historyBuffer.pushEntry(
            this.lastChangedEpoch,
            ri(),
            c ?? ((r = this.computeDiff) == null ? void 0 : r.call(this, this.state, o, this.lastCheckedEpoch, ri())) ?? vi
          );
        }
        this.lastChangedEpoch = ri(), this.state = o;
      }
      return this.error = null, this.lastCheckedEpoch = ri(), this.state;
    } catch (s) {
      if (this.state !== xl && (this.state = xl, this.lastChangedEpoch = ri()), this.lastCheckedEpoch = ri(), this.historyBuffer && this.historyBuffer.clear(), this.error = { thrownValue: s }, !e) throw s;
      return this.state;
    } finally {
      Ib();
    }
  }
  get() {
    try {
      return this.__unsafe__getWithoutCapture();
    } finally {
      Ig(this);
    }
  }
  getDiffSince(e) {
    var n;
    return this.__unsafe__getWithoutCapture(!0), Ig(this), e >= this.lastChangedEpoch ? hs : ((n = this.historyBuffer) == null ? void 0 : n.getChangesSince(e)) ?? vi;
  }
}
const Ip = co("Computed", () => sG);
function oG(t = {}, e, n, i) {
  const r = i.value, s = Symbol.for("__@tldraw/state__computed__" + n);
  return i.value = function() {
    let o = this[s];
    return o || (o = new Ip(n, r.bind(this), t), Object.defineProperty(this, s, {
      enumerable: !1,
      configurable: !1,
      writable: !1,
      value: o
    })), o.get();
  }, i.value[jb] = !0, i;
}
function aG(t = {}, e, n, i) {
  const r = i.get, s = Symbol.for("__@tldraw/state__computed__" + n);
  return i.get = function() {
    let o = this[s];
    return o || (o = new Ip(n, r.bind(this), t), Object.defineProperty(this, s, {
      enumerable: !1,
      configurable: !1,
      writable: !1,
      value: o
    })), o.get();
  }, i;
}
function cG(t, e, n) {
  ct(n.kind === "method", "@computed can only be used on methods");
  const i = Symbol.for("__@tldraw/state__computed__" + String(n.name)), r = function() {
    let s = this[i];
    return s || (s = new Ip(String(n.name), e.bind(this), t), Object.defineProperty(this, i, {
      enumerable: !1,
      configurable: !1,
      writable: !1,
      value: s
    })), s.get();
  };
  return r[jb] = !0, r;
}
function f0(t = {}, e) {
  if (e.length === 2) {
    const [n, i] = e;
    return cG(t, n, i);
  } else {
    const [n, i, r] = e;
    return r.get ? (rG(), aG(t, n, i, r)) : oG(t, n, i, r);
  }
}
const jb = "@@__isComputedMethod__@@";
function K() {
  if (arguments.length === 1) {
    const t = arguments[0];
    return (...e) => f0(t, e);
  } else return typeof arguments[0] == "string" ? new Ip(arguments[0], arguments[1], arguments[2]) : f0(void 0, arguments);
}
const Db = 1, lG = co("apiVersion", () => Db);
if (lG !== Db)
  throw new Error(
    "You have multiple incompatible versions of @tldraw/state in your app. Please deduplicate the package."
  );
so(
  "@tldraw/state",
  "3.4.1",
  "esm"
);
function xp(t, e) {
  const n = Ye.useRef(e);
  n.current = e;
  const [i, r, s] = Ye.useMemo(() => {
    let o = null;
    const a = (u) => (o = u, () => {
      o = null;
    }), c = new xc(
      `useStateTracking(${t})`,
      // this is what `scheduler.execute()` will call
      () => {
        var u;
        return (u = n.current) == null ? void 0 : u.call(n);
      },
      // this is what will be invoked when @tldraw/state detects a change in an upstream reactive value
      {
        scheduleEffect() {
          o == null || o();
        }
      }
    );
    return [c, a, () => c.scheduleCount];
  }, [t]);
  return Ye.useSyncExternalStore(r, s, s), Ye.useEffect(() => (i.attach(), i.maybeScheduleEffect(), () => {
    i.detach();
  }), [i]), i.execute();
}
const M0 = {
  /**
   * This is a function call trap for functional components. When this is called, we know it means
   * React did run 'Component()', that means we can use any hooks here to setup our effect and
   * store.
   *
   * With the native Proxy, all other calls such as access/setting to/of properties will be
   * forwarded to the target Component, so we don't need to copy the Component's own or inherited
   * properties.
   *
   * @see https://github.com/facebook/react/blob/2d80a0cd690bb5650b6c8a6c079a87b5dc42bd15/packages/react-reconciler/src/ReactFiberHooks.old.js#L460
   */
  apply(t, e, n) {
    return xp(
      t.displayName ?? t.name ?? "tracked(???)",
      () => t.apply(e, n)
    );
  }
}, dG = Symbol.for("react.memo"), uG = Symbol.for("react.forward_ref");
function Vt(t) {
  let e = null;
  const n = t.$$typeof;
  return n === dG && (t = t.type, e = t.compare), n === uG ? _e(dc(new Proxy(t.render, M0))) : _e(new Proxy(t, M0), e);
}
function wb(t, e, n) {
  return pe(() => {
    const i = typeof e == "function" ? e() : e;
    return xt(`useAtom(${t})`, i, n);
  })[0];
}
function hG() {
  const t = arguments[0], e = arguments[1], n = arguments.length === 3 ? void 0 : arguments[2], i = arguments.length === 3 ? arguments[2] : arguments[3];
  return yt(() => K(`useComputed(${t})`, e, n), i);
}
function Vs(t, e, n = hs) {
  ze(() => {
    const i = new xc(t, e);
    return i.attach(), i.execute(), () => {
      i.detach();
    };
  }, n);
}
function G() {
  const t = arguments, e = t.length === 3 ? t[2] : [t[0]], n = t.length === 3 ? t[0] : `useValue(${t[0].name})`, i = le(!0);
  i.current = !0;
  const r = yt(() => t.length === 1 ? t[0] : K(n, () => {
    if (i.current)
      return t[1]();
    try {
      return t[1]();
    } catch {
      return {};
    }
  }), e);
  try {
    const { subscribe: s, getSnapshot: o } = yt(() => ({
      subscribe: (a) => Yr(`useValue(${n})`, () => {
        r.get(), a();
      }),
      getSnapshot: () => r.get()
    }), [r]);
    return PA(s, o, o);
  } finally {
    i.current = !1;
  }
}
so(
  "@tldraw/state-react",
  "3.4.1",
  "esm"
);
class Ih {
  constructor(e) {
    /**
     * The next value of the set.
     *
     * @internal
     */
    S(this, "nextValue");
    /**
     * The diff of the set.
     *
     * @internal
     */
    S(this, "diff");
    this.previousValue = e;
  }
  /**
   * Get the next value of the set.
   *
   * @public
   */
  get() {
    var i, r, s, o;
    const e = ((r = (i = this.diff) == null ? void 0 : i.removed) == null ? void 0 : r.size) ?? 0, n = ((o = (s = this.diff) == null ? void 0 : s.added) == null ? void 0 : o.size) ?? 0;
    if (!(e === 0 && n === 0))
      return { value: this.nextValue, diff: this.diff };
  }
  /**
   * Add an item to the set.
   *
   * @param item - The item to add.
   * @param wasAlreadyPresent - Whether the item was already present in the set.
   * @internal
   */
  _add(e, n) {
    var i, r;
    this.nextValue ?? (this.nextValue = new Set(this.previousValue)), this.nextValue.add(e), this.diff ?? (this.diff = {}), n ? (i = this.diff.removed) == null || i.delete(e) : ((r = this.diff).added ?? (r.added = /* @__PURE__ */ new Set()), this.diff.added.add(e));
  }
  /**
   * Add an item to the set.
   *
   * @param item - The item to add.
   * @public
   */
  add(e) {
    var r, s, o;
    const n = this.previousValue.has(e);
    if (n)
      return ((s = (r = this.diff) == null ? void 0 : r.removed) == null ? void 0 : s.has(e)) ? this._add(e, n) : void 0;
    (o = this.nextValue) != null && o.has(e) || this._add(e, n);
  }
  /**
   * Remove an item from the set.
   *
   * @param item - The item to remove.
   * @param wasAlreadyPresent - Whether the item was already present in the set.
   * @internal
   */
  _remove(e, n) {
    var i, r;
    this.nextValue ?? (this.nextValue = new Set(this.previousValue)), this.nextValue.delete(e), this.diff ?? (this.diff = {}), n ? ((i = this.diff).removed ?? (i.removed = /* @__PURE__ */ new Set()), this.diff.removed.add(e)) : (r = this.diff.added) == null || r.delete(e);
  }
  /**
   * Remove an item from the set.
   *
   * @param item - The item to remove.
   * @public
   */
  remove(e) {
    var r, s, o, a;
    const n = this.previousValue.has(e);
    if (!n)
      return ((s = (r = this.diff) == null ? void 0 : r.added) == null ? void 0 : s.has(e)) ? this._remove(e, n) : void 0;
    (a = (o = this.diff) == null ? void 0 : o.removed) != null && a.has(e) || this._remove(e, n);
  }
}
class Sp {
  constructor(e, n) {
    S(this, "createDefaultProperties");
    S(this, "validator");
    S(this, "ephemeralKeys");
    S(this, "ephemeralKeySet");
    S(this, "scope");
    this.typeName = e, this.createDefaultProperties = n.createDefaultProperties, this.validator = n.validator ?? { validate: (r) => r }, this.scope = n.scope ?? "document", this.ephemeralKeys = n.ephemeralKeys;
    const i = /* @__PURE__ */ new Set();
    if (n.ephemeralKeys)
      for (const [r, s] of Mi(n.ephemeralKeys))
        s && i.add(r);
    this.ephemeralKeySet = i;
  }
  /**
   * Create a new record of this type.
   *
   * @param properties - The properties of the record.
   * @returns The new record.
   */
  create(e) {
    const n = { ...this.createDefaultProperties(), id: this.createId() };
    for (const [i, r] of Object.entries(e))
      r !== void 0 && (n[i] = r);
    return n.typeName = this.typeName, n;
  }
  /**
   * Clone a record of this type.
   *
   * @param record - The record to clone.
   * @returns The cloned record.
   * @public
   */
  clone(e) {
    return { ...Ct(e), id: this.createId() };
  }
  /**
   * Create a new ID for this record type.
   *
   * @example
   *
   * ```ts
   * const id = recordType.createId()
   * ```
   *
   * @returns The new ID.
   * @public
   */
  createId(e) {
    return this.typeName + ":" + (e ?? ht());
  }
  /**
   * Create a new ID for this record type based on the given ID.
   *
   * @example
   *
   * ```ts
   * const id = recordType.createCustomId('myId')
   * ```
   *
   * @deprecated - Use `createId` instead.
   * @param id - The ID to base the new ID on.
   * @returns The new ID.
   */
  createCustomId(e) {
    return this.typeName + ":" + e;
  }
  /**
   * Takes an id like `user:123` and returns the part after the colon `123`
   *
   * @param id - The id
   * @returns
   */
  parseId(e) {
    if (!this.isId(e))
      throw new Error(`ID "${e}" is not a valid ID for type "${this.typeName}"`);
    return e.slice(this.typeName.length + 1);
  }
  /**
   * Check whether a record is an instance of this record type.
   *
   * @example
   *
   * ```ts
   * const result = recordType.isInstance(someRecord)
   * ```
   *
   * @param record - The record to check.
   * @returns Whether the record is an instance of this record type.
   */
  isInstance(e) {
    return (e == null ? void 0 : e.typeName) === this.typeName;
  }
  /**
   * Check whether an id is an id of this type.
   *
   * @example
   *
   * ```ts
   * const result = recordType.isIn('someId')
   * ```
   *
   * @param id - The id to check.
   * @returns Whether the id is an id of this type.
   */
  isId(e) {
    if (!e) return !1;
    for (let n = 0; n < this.typeName.length; n++)
      if (e[n] !== this.typeName[n]) return !1;
    return e[this.typeName.length] === ":";
  }
  /**
   * Create a new RecordType that has the same type name as this RecordType and includes the given
   * default properties.
   *
   * @example
   *
   * ```ts
   * const authorType = createRecordType('author', () => ({ living: true }))
   * const deadAuthorType = authorType.withDefaultProperties({ living: false })
   * ```
   *
   * @param createDefaultProperties - A function that returns the default properties of the new RecordType.
   * @returns The new RecordType.
   */
  withDefaultProperties(e) {
    return new Sp(this.typeName, {
      createDefaultProperties: e,
      validator: this.validator,
      scope: this.scope,
      ephemeralKeys: this.ephemeralKeys
    });
  }
  /**
   * Check that the passed in record passes the validations for this type. Returns its input
   * correctly typed if it does, but throws an error otherwise.
   */
  validate(e, n) {
    return n && this.validator.validateUsingKnownGoodVersion ? this.validator.validateUsingKnownGoodVersion(n, e) : this.validator.validate(e);
  }
}
function Gr(t, e) {
  return new Sp(t, {
    createDefaultProperties: () => ({}),
    validator: e.validator,
    scope: e.scope,
    ephemeralKeys: e.ephemeralKeys
  });
}
function xg() {
  return { added: {}, updated: {}, removed: {} };
}
function Sg(t) {
  const e = { added: t.removed, removed: t.added, updated: {} };
  for (const [n, i] of Object.values(t.updated))
    e.updated[n.id] = [i, n];
  return e;
}
function Nb(t) {
  return Object.keys(t.added).length === 0 && Object.keys(t.updated).length === 0 && Object.keys(t.removed).length === 0;
}
function Px(t) {
  const e = { added: {}, removed: {}, updated: {} };
  return zl(e, t), e;
}
function zl(t, e) {
  for (const n of e) {
    for (const [i, r] of Mi(n.added))
      if (t.removed[i]) {
        const s = t.removed[i];
        delete t.removed[i], s !== r && (t.updated[i] = [s, r]);
      } else
        t.added[i] = r;
    for (const [i, [r, s]] of Mi(n.updated)) {
      if (t.added[i]) {
        t.added[i] = s, delete t.updated[i], delete t.removed[i];
        continue;
      }
      if (t.updated[i]) {
        t.updated[i] = [t.updated[i][0], s], delete t.removed[i];
        continue;
      }
      t.updated[i] = n.updated[i], delete t.removed[i];
    }
    for (const [i, r] of Mi(n.removed))
      t.added[i] ? delete t.added[i] : t.updated[i] ? (t.removed[i] = t.updated[i][0], delete t.updated[i]) : t.removed[i] = r;
  }
}
var jg = { exports: {} };
jg.exports;
(function(t, e) {
  var n = 200, i = "__lodash_hash_undefined__", r = 1, s = 2, o = 9007199254740991, a = "[object Arguments]", c = "[object Array]", d = "[object AsyncFunction]", u = "[object Boolean]", h = "[object Date]", g = "[object Error]", p = "[object Function]", f = "[object GeneratorFunction]", M = "[object Map]", m = "[object Number]", y = "[object Null]", I = "[object Object]", D = "[object Promise]", j = "[object Proxy]", w = "[object RegExp]", A = "[object Set]", b = "[object String]", T = "[object Symbol]", E = "[object Undefined]", v = "[object WeakMap]", P = "[object ArrayBuffer]", C = "[object DataView]", z = "[object Float32Array]", O = "[object Float64Array]", R = "[object Int8Array]", U = "[object Int16Array]", F = "[object Int32Array]", H = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", te = "[object Uint16Array]", oe = "[object Uint32Array]", me = /[\\^$.*+?()[\]{}|]/g, he = /^\[object .+?Constructor\]$/, ve = /^(?:0|[1-9]\d*)$/, ie = {};
  ie[z] = ie[O] = ie[R] = ie[U] = ie[F] = ie[H] = ie[Z] = ie[te] = ie[oe] = !0, ie[a] = ie[c] = ie[P] = ie[u] = ie[C] = ie[h] = ie[g] = ie[p] = ie[M] = ie[m] = ie[I] = ie[w] = ie[A] = ie[b] = ie[v] = !1;
  var Ue = typeof En == "object" && En && En.Object === Object && En, ge = typeof self == "object" && self && self.Object === Object && self, Re = Ue || ge || Function("return this")(), ye = e && !e.nodeType && e, Be = ye && !0 && t && !t.nodeType && t, We = Be && Be.exports === ye, lt = We && Ue.process, $ = function() {
    try {
      return lt && lt.binding && lt.binding("util");
    } catch {
    }
  }(), X = $ && $.isTypedArray;
  function Ie(L, B) {
    for (var J = -1, xe = L == null ? 0 : L.length, Tt = 0, Ge = []; ++J < xe; ) {
      var Ft = L[J];
      B(Ft, J, L) && (Ge[Tt++] = Ft);
    }
    return Ge;
  }
  function je(L, B) {
    for (var J = -1, xe = B.length, Tt = L.length; ++J < xe; )
      L[Tt + J] = B[J];
    return L;
  }
  function Oe(L, B) {
    for (var J = -1, xe = L == null ? 0 : L.length; ++J < xe; )
      if (B(L[J], J, L))
        return !0;
    return !1;
  }
  function zt(L, B) {
    for (var J = -1, xe = Array(L); ++J < L; )
      xe[J] = B(J);
    return xe;
  }
  function Dt(L) {
    return function(B) {
      return L(B);
    };
  }
  function Xr(L, B) {
    return L.has(B);
  }
  function Pf(L, B) {
    return L == null ? void 0 : L[B];
  }
  function Uc(L) {
    var B = -1, J = Array(L.size);
    return L.forEach(function(xe, Tt) {
      J[++B] = [Tt, xe];
    }), J;
  }
  function Uf(L, B) {
    return function(J) {
      return L(B(J));
    };
  }
  function Rf(L) {
    var B = -1, J = Array(L.size);
    return L.forEach(function(xe) {
      J[++B] = xe;
    }), J;
  }
  var qd = Array.prototype, _d = Function.prototype, Tr = Object.prototype, Rc = Re["__core-js_shared__"], Yc = _d.toString, wi = Tr.hasOwnProperty, $o = function() {
    var L = /[^.]+$/.exec(Rc && Rc.keys && Rc.keys.IE_PROTO || "");
    return L ? "Symbol(src)_1." + L : "";
  }(), $d = Tr.toString, Yf = RegExp(
    "^" + Yc.call(wi).replace(me, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), eu = We ? Re.Buffer : void 0, ea = Re.Symbol, tu = Re.Uint8Array, nu = Tr.propertyIsEnumerable, Qf = qd.splice, $i = ea ? ea.toStringTag : void 0, Qc = Object.getOwnPropertySymbols, Ns = eu ? eu.isBuffer : void 0, Zc = Uf(Object.keys, Object), xo = ia(Re, "DataView"), As = ia(Re, "Map"), Fc = ia(Re, "Promise"), ta = ia(Re, "Set"), Bc = ia(Re, "WeakMap"), Ts = ia(Object, "create"), iu = So(xo), Zf = So(As), Ff = So(Fc), ru = So(ta), su = So(Bc), ou = ea ? ea.prototype : void 0, Gc = ou ? ou.valueOf : void 0;
  function Jr(L) {
    var B = -1, J = L == null ? 0 : L.length;
    for (this.clear(); ++B < J; ) {
      var xe = L[B];
      this.set(xe[0], xe[1]);
    }
  }
  function Bf() {
    this.__data__ = Ts ? Ts(null) : {}, this.size = 0;
  }
  function Y(L) {
    var B = this.has(L) && delete this.__data__[L];
    return this.size -= B ? 1 : 0, B;
  }
  function _(L) {
    var B = this.__data__;
    if (Ts) {
      var J = B[L];
      return J === i ? void 0 : J;
    }
    return wi.call(B, L) ? B[L] : void 0;
  }
  function fe(L) {
    var B = this.__data__;
    return Ts ? B[L] !== void 0 : wi.call(B, L);
  }
  function Pe(L, B) {
    var J = this.__data__;
    return this.size += this.has(L) ? 0 : 1, J[L] = Ts && B === void 0 ? i : B, this;
  }
  Jr.prototype.clear = Bf, Jr.prototype.delete = Y, Jr.prototype.get = _, Jr.prototype.has = fe, Jr.prototype.set = Pe;
  function He(L) {
    var B = -1, J = L == null ? 0 : L.length;
    for (this.clear(); ++B < J; ) {
      var xe = L[B];
      this.set(xe[0], xe[1]);
    }
  }
  function pt() {
    this.__data__ = [], this.size = 0;
  }
  function tt(L) {
    var B = this.__data__, J = au(B, L);
    if (J < 0)
      return !1;
    var xe = B.length - 1;
    return J == xe ? B.pop() : Qf.call(B, J, 1), --this.size, !0;
  }
  function Je(L) {
    var B = this.__data__, J = au(B, L);
    return J < 0 ? void 0 : B[J][1];
  }
  function ln(L) {
    return au(this.__data__, L) > -1;
  }
  function kt(L, B) {
    var J = this.__data__, xe = au(J, L);
    return xe < 0 ? (++this.size, J.push([L, B])) : J[xe][1] = B, this;
  }
  He.prototype.clear = pt, He.prototype.delete = tt, He.prototype.get = Je, He.prototype.has = ln, He.prototype.set = kt;
  function ft(L) {
    var B = -1, J = L == null ? 0 : L.length;
    for (this.clear(); ++B < J; ) {
      var xe = L[B];
      this.set(xe[0], xe[1]);
    }
  }
  function ei() {
    this.size = 0, this.__data__ = {
      hash: new Jr(),
      map: new (As || He)(),
      string: new Jr()
    };
  }
  function bs(L) {
    var B = cu(this, L).delete(L);
    return this.size -= B ? 1 : 0, B;
  }
  function qr(L) {
    return cu(this, L).get(L);
  }
  function xn(L) {
    return cu(this, L).has(L);
  }
  function Wc(L, B) {
    var J = cu(this, L), xe = J.size;
    return J.set(L, B), this.size += J.size == xe ? 0 : 1, this;
  }
  ft.prototype.clear = ei, ft.prototype.delete = bs, ft.prototype.get = qr, ft.prototype.has = xn, ft.prototype.set = Wc;
  function na(L) {
    var B = -1, J = L == null ? 0 : L.length;
    for (this.__data__ = new ft(); ++B < J; )
      this.add(L[B]);
  }
  function Gf(L) {
    return this.__data__.set(L, i), this;
  }
  function x3(L) {
    return this.__data__.has(L);
  }
  na.prototype.add = na.prototype.push = Gf, na.prototype.has = x3;
  function vs(L) {
    var B = this.__data__ = new He(L);
    this.size = B.size;
  }
  function S3() {
    this.__data__ = new He(), this.size = 0;
  }
  function j3(L) {
    var B = this.__data__, J = B.delete(L);
    return this.size = B.size, J;
  }
  function D3(L) {
    return this.__data__.get(L);
  }
  function w3(L) {
    return this.__data__.has(L);
  }
  function N3(L, B) {
    var J = this.__data__;
    if (J instanceof He) {
      var xe = J.__data__;
      if (!As || xe.length < n - 1)
        return xe.push([L, B]), this.size = ++J.size, this;
      J = this.__data__ = new ft(xe);
    }
    return J.set(L, B), this.size = J.size, this;
  }
  vs.prototype.clear = S3, vs.prototype.delete = j3, vs.prototype.get = D3, vs.prototype.has = w3, vs.prototype.set = N3;
  function A3(L, B) {
    var J = lu(L), xe = !J && Z3(L), Tt = !J && !xe && Wf(L), Ge = !J && !xe && !Tt && nD(L), Ft = J || xe || Tt || Ge, en = Ft ? zt(L.length, String) : [], dn = en.length;
    for (var Ot in L)
      wi.call(L, Ot) && !(Ft && // Safari 9 has enumerable `arguments.length` in strict mode.
      (Ot == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      Tt && (Ot == "offset" || Ot == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Ge && (Ot == "buffer" || Ot == "byteLength" || Ot == "byteOffset") || // Skip index properties.
      P3(Ot, dn))) && en.push(Ot);
    return en;
  }
  function au(L, B) {
    for (var J = L.length; J--; )
      if (_j(L[J][0], B))
        return J;
    return -1;
  }
  function T3(L, B, J) {
    var xe = B(L);
    return lu(L) ? xe : je(xe, J(L));
  }
  function Hc(L) {
    return L == null ? L === void 0 ? E : y : $i && $i in Object(L) ? k3(L) : Q3(L);
  }
  function Kj(L) {
    return Vc(L) && Hc(L) == a;
  }
  function Xj(L, B, J, xe, Tt) {
    return L === B ? !0 : L == null || B == null || !Vc(L) && !Vc(B) ? L !== L && B !== B : b3(L, B, J, xe, Xj, Tt);
  }
  function b3(L, B, J, xe, Tt, Ge) {
    var Ft = lu(L), en = lu(B), dn = Ft ? c : Es(L), Ot = en ? c : Es(B);
    dn = dn == a ? I : dn, Ot = Ot == a ? I : Ot;
    var Ni = dn == I, er = Ot == I, Sn = dn == Ot;
    if (Sn && Wf(L)) {
      if (!Wf(B))
        return !1;
      Ft = !0, Ni = !1;
    }
    if (Sn && !Ni)
      return Ge || (Ge = new vs()), Ft || nD(L) ? Jj(L, B, J, xe, Tt, Ge) : z3(L, B, dn, J, xe, Tt, Ge);
    if (!(J & r)) {
      var Qi = Ni && wi.call(L, "__wrapped__"), Zi = er && wi.call(B, "__wrapped__");
      if (Qi || Zi) {
        var Cs = Qi ? L.value() : L, _r = Zi ? B.value() : B;
        return Ge || (Ge = new vs()), Tt(Cs, _r, J, xe, Ge);
      }
    }
    return Sn ? (Ge || (Ge = new vs()), L3(L, B, J, xe, Tt, Ge)) : !1;
  }
  function v3(L) {
    if (!tD(L) || R3(L))
      return !1;
    var B = $j(L) ? Yf : he;
    return B.test(So(L));
  }
  function E3(L) {
    return Vc(L) && eD(L.length) && !!ie[Hc(L)];
  }
  function C3(L) {
    if (!Y3(L))
      return Zc(L);
    var B = [];
    for (var J in Object(L))
      wi.call(L, J) && J != "constructor" && B.push(J);
    return B;
  }
  function Jj(L, B, J, xe, Tt, Ge) {
    var Ft = J & r, en = L.length, dn = B.length;
    if (en != dn && !(Ft && dn > en))
      return !1;
    var Ot = Ge.get(L);
    if (Ot && Ge.get(B))
      return Ot == B;
    var Ni = -1, er = !0, Sn = J & s ? new na() : void 0;
    for (Ge.set(L, B), Ge.set(B, L); ++Ni < en; ) {
      var Qi = L[Ni], Zi = B[Ni];
      if (xe)
        var Cs = Ft ? xe(Zi, Qi, Ni, B, L, Ge) : xe(Qi, Zi, Ni, L, B, Ge);
      if (Cs !== void 0) {
        if (Cs)
          continue;
        er = !1;
        break;
      }
      if (Sn) {
        if (!Oe(B, function(_r, jo) {
          if (!Xr(Sn, jo) && (Qi === _r || Tt(Qi, _r, J, xe, Ge)))
            return Sn.push(jo);
        })) {
          er = !1;
          break;
        }
      } else if (!(Qi === Zi || Tt(Qi, Zi, J, xe, Ge))) {
        er = !1;
        break;
      }
    }
    return Ge.delete(L), Ge.delete(B), er;
  }
  function z3(L, B, J, xe, Tt, Ge, Ft) {
    switch (J) {
      case C:
        if (L.byteLength != B.byteLength || L.byteOffset != B.byteOffset)
          return !1;
        L = L.buffer, B = B.buffer;
      case P:
        return !(L.byteLength != B.byteLength || !Ge(new tu(L), new tu(B)));
      case u:
      case h:
      case m:
        return _j(+L, +B);
      case g:
        return L.name == B.name && L.message == B.message;
      case w:
      case b:
        return L == B + "";
      case M:
        var en = Uc;
      case A:
        var dn = xe & r;
        if (en || (en = Rf), L.size != B.size && !dn)
          return !1;
        var Ot = Ft.get(L);
        if (Ot)
          return Ot == B;
        xe |= s, Ft.set(L, B);
        var Ni = Jj(en(L), en(B), xe, Tt, Ge, Ft);
        return Ft.delete(L), Ni;
      case T:
        if (Gc)
          return Gc.call(L) == Gc.call(B);
    }
    return !1;
  }
  function L3(L, B, J, xe, Tt, Ge) {
    var Ft = J & r, en = qj(L), dn = en.length, Ot = qj(B), Ni = Ot.length;
    if (dn != Ni && !Ft)
      return !1;
    for (var er = dn; er--; ) {
      var Sn = en[er];
      if (!(Ft ? Sn in B : wi.call(B, Sn)))
        return !1;
    }
    var Qi = Ge.get(L);
    if (Qi && Ge.get(B))
      return Qi == B;
    var Zi = !0;
    Ge.set(L, B), Ge.set(B, L);
    for (var Cs = Ft; ++er < dn; ) {
      Sn = en[er];
      var _r = L[Sn], jo = B[Sn];
      if (xe)
        var iD = Ft ? xe(jo, _r, Sn, B, L, Ge) : xe(_r, jo, Sn, L, B, Ge);
      if (!(iD === void 0 ? _r === jo || Tt(_r, jo, J, xe, Ge) : iD)) {
        Zi = !1;
        break;
      }
      Cs || (Cs = Sn == "constructor");
    }
    if (Zi && !Cs) {
      var du = L.constructor, uu = B.constructor;
      du != uu && "constructor" in L && "constructor" in B && !(typeof du == "function" && du instanceof du && typeof uu == "function" && uu instanceof uu) && (Zi = !1);
    }
    return Ge.delete(L), Ge.delete(B), Zi;
  }
  function qj(L) {
    return T3(L, G3, O3);
  }
  function cu(L, B) {
    var J = L.__data__;
    return U3(B) ? J[typeof B == "string" ? "string" : "hash"] : J.map;
  }
  function ia(L, B) {
    var J = Pf(L, B);
    return v3(J) ? J : void 0;
  }
  function k3(L) {
    var B = wi.call(L, $i), J = L[$i];
    try {
      L[$i] = void 0;
      var xe = !0;
    } catch {
    }
    var Tt = $d.call(L);
    return xe && (B ? L[$i] = J : delete L[$i]), Tt;
  }
  var O3 = Qc ? function(L) {
    return L == null ? [] : (L = Object(L), Ie(Qc(L), function(B) {
      return nu.call(L, B);
    }));
  } : W3, Es = Hc;
  (xo && Es(new xo(new ArrayBuffer(1))) != C || As && Es(new As()) != M || Fc && Es(Fc.resolve()) != D || ta && Es(new ta()) != A || Bc && Es(new Bc()) != v) && (Es = function(L) {
    var B = Hc(L), J = B == I ? L.constructor : void 0, xe = J ? So(J) : "";
    if (xe)
      switch (xe) {
        case iu:
          return C;
        case Zf:
          return M;
        case Ff:
          return D;
        case ru:
          return A;
        case su:
          return v;
      }
    return B;
  });
  function P3(L, B) {
    return B = B ?? o, !!B && (typeof L == "number" || ve.test(L)) && L > -1 && L % 1 == 0 && L < B;
  }
  function U3(L) {
    var B = typeof L;
    return B == "string" || B == "number" || B == "symbol" || B == "boolean" ? L !== "__proto__" : L === null;
  }
  function R3(L) {
    return !!$o && $o in L;
  }
  function Y3(L) {
    var B = L && L.constructor, J = typeof B == "function" && B.prototype || Tr;
    return L === J;
  }
  function Q3(L) {
    return $d.call(L);
  }
  function So(L) {
    if (L != null) {
      try {
        return Yc.call(L);
      } catch {
      }
      try {
        return L + "";
      } catch {
      }
    }
    return "";
  }
  function _j(L, B) {
    return L === B || L !== L && B !== B;
  }
  var Z3 = Kj(/* @__PURE__ */ function() {
    return arguments;
  }()) ? Kj : function(L) {
    return Vc(L) && wi.call(L, "callee") && !nu.call(L, "callee");
  }, lu = Array.isArray;
  function F3(L) {
    return L != null && eD(L.length) && !$j(L);
  }
  var Wf = Ns || H3;
  function B3(L, B) {
    return Xj(L, B);
  }
  function $j(L) {
    if (!tD(L))
      return !1;
    var B = Hc(L);
    return B == p || B == f || B == d || B == j;
  }
  function eD(L) {
    return typeof L == "number" && L > -1 && L % 1 == 0 && L <= o;
  }
  function tD(L) {
    var B = typeof L;
    return L != null && (B == "object" || B == "function");
  }
  function Vc(L) {
    return L != null && typeof L == "object";
  }
  var nD = X ? Dt(X) : E3;
  function G3(L) {
    return F3(L) ? A3(L) : C3(L);
  }
  function W3() {
    return [];
  }
  function H3() {
    return !1;
  }
  t.exports = B3;
})(jg, jg.exports);
var gG = jg.exports;
const Ab = /* @__PURE__ */ uc(gG);
function pG(t) {
  if (t.length === 0) return /* @__PURE__ */ new Set();
  const e = t[0], n = t.slice(1), i = /* @__PURE__ */ new Set();
  for (const r of e)
    n.every((s) => s.has(r)) && i.add(r);
  return i;
}
function fG(t, e) {
  const n = {};
  for (const i of e)
    t.has(i) || (n.added ?? (n.added = /* @__PURE__ */ new Set()), n.added.add(i));
  for (const i of t)
    e.has(i) || (n.removed ?? (n.removed = /* @__PURE__ */ new Set()), n.removed.add(i));
  return n.added || n.removed ? n : void 0;
}
function m0(t, e) {
  for (const [n, i] of Object.entries(t)) {
    const r = i, s = e[n];
    if ("eq" in r && s !== r.eq || "neq" in r && s === r.neq || "gt" in r && (typeof s != "number" || s <= r.gt)) return !1;
  }
  return !0;
}
function y0(t, e, n) {
  const i = Object.fromEntries(Object.keys(n).map((r) => [r, /* @__PURE__ */ new Set()]));
  for (const [r, s] of Object.entries(n))
    if ("eq" in s) {
      const a = t.index(e, r).get().get(s.eq);
      if (a)
        for (const c of a)
          i[r].add(c);
    } else if ("neq" in s) {
      const o = t.index(e, r);
      for (const [a, c] of o.get())
        if (a !== s.neq)
          for (const d of c)
            i[r].add(d);
    } else if ("gt" in s) {
      const o = t.index(e, r);
      for (const [a, c] of o.get())
        if (a > s.gt)
          for (const d of c)
            i[r].add(d);
    }
  return pG(Object.values(i));
}
class MG {
  constructor(e, n) {
    /**
     * A cache of derivations (indexes).
     *
     * @internal
     */
    S(this, "indexCache", /* @__PURE__ */ new Map());
    /**
     * A cache of derivations (filtered histories).
     *
     * @internal
     */
    S(this, "historyCache", /* @__PURE__ */ new Map());
    this.atoms = e, this.history = n;
  }
  /**
   * Create a derivation that contains the history for a given type
   *
   * @param typeName - The name of the type to filter by.
   * @returns A derivation that returns the ids of all records of the given type.
   * @public
   */
  filterHistory(e) {
    if (this.historyCache.has(e))
      return this.historyCache.get(e);
    const n = K(
      "filterHistory:" + e,
      (i, r) => {
        if (bo(i))
          return this.history.get();
        const s = this.history.getDiffSince(r);
        if (s === vi) return this.history.get();
        const o = { added: {}, removed: {}, updated: {} };
        let a = 0, c = 0, d = 0;
        for (const u of s) {
          for (const h of Pt(u.added))
            if (h.typeName === e)
              if (o.removed[h.id]) {
                const g = o.removed[h.id];
                delete o.removed[h.id], c--, g !== h && (o.updated[h.id] = [g, h], d++);
              } else
                o.added[h.id] = h, a++;
          for (const [h, g] of Pt(u.updated))
            g.typeName === e && (o.added[g.id] ? o.added[g.id] = g : o.updated[g.id] ? o.updated[g.id] = [o.updated[g.id][0], g] : (o.updated[g.id] = [h, g], d++));
          for (const h of Pt(u.removed))
            h.typeName === e && (o.added[h.id] ? (delete o.added[h.id], a--) : o.updated[h.id] ? (o.removed[h.id] = o.updated[h.id][0], delete o.updated[h.id], d--, c++) : (o.removed[h.id] = h, c++));
        }
        return a || c || d ? Sl(this.history.get(), o) : i;
      },
      { historyLength: 100 }
    );
    return this.historyCache.set(e, n), n;
  }
  /**
   * Create a derivation that returns an index on a property for the given type.
   *
   * @param typeName - The name of the type.
   * @param property - The name of the property.
   * @public
   */
  index(e, n) {
    const i = e + ":" + n;
    if (this.indexCache.has(i))
      return this.indexCache.get(i);
    const r = this.__uncached_createIndex(e, n);
    return this.indexCache.set(i, r), r;
  }
  /**
   * Create a derivation that returns an index on a property for the given type.
   *
   * @param typeName - The name of the type?.
   * @param property - The name of the property?.
   * @internal
   */
  __uncached_createIndex(e, n) {
    const i = this.filterHistory(e), r = () => {
      i.get();
      const s = /* @__PURE__ */ new Map();
      for (const o of Pt(this.atoms.get())) {
        const a = o.get();
        if (a.typeName === e) {
          const c = a[n];
          s.has(c) || s.set(c, /* @__PURE__ */ new Set()), s.get(c).add(a.id);
        }
      }
      return s;
    };
    return K(
      "index:" + e + ":" + n,
      (s, o) => {
        if (bo(s)) return r();
        const a = i.getDiffSince(o);
        if (a === vi)
          return r();
        const c = /* @__PURE__ */ new Map(), d = (p, f) => {
          let M = c.get(p);
          M || (M = new Ih(
            s.get(p) ?? /* @__PURE__ */ new Set()
          )), M.add(f), c.set(p, M);
        }, u = (p, f) => {
          let M = c.get(p);
          M || (M = new Ih(s.get(p) ?? /* @__PURE__ */ new Set())), M.remove(f), c.set(p, M);
        };
        for (const p of a) {
          for (const f of Pt(p.added))
            if (f.typeName === e) {
              const M = f[n];
              d(M, f.id);
            }
          for (const [f, M] of Pt(p.updated))
            if (M.typeName === e) {
              const m = f[n], y = M[n];
              m !== y && (u(m, M.id), d(y, M.id));
            }
          for (const f of Pt(p.removed))
            if (f.typeName === e) {
              const M = f[n];
              u(M, f.id);
            }
        }
        let h, g;
        for (const [p, f] of c) {
          const M = f.get();
          M && (h || (h = new Map(s)), g || (g = /* @__PURE__ */ new Map()), M.value.size === 0 ? h.delete(p) : h.set(p, M.value), g.set(p, M.diff));
        }
        return h && g ? Sl(h, g) : s;
      },
      { historyLength: 100 }
    );
  }
  /**
   * Create a derivation that will return a signle record matching the given query.
   *
   * It will return undefined if there is no matching record
   *
   * @param typeName - The name of the type?
   * @param queryCreator - A function that returns the query expression.
   * @param name - (optinal) The name of the query.
   */
  record(e, n = () => ({}), i = "record:" + e + (n ? ":" + n.toString() : "")) {
    const r = this.ids(e, n, i);
    return K(i, () => {
      var s;
      for (const o of r.get())
        return (s = this.atoms.get()[o]) == null ? void 0 : s.get();
    });
  }
  /**
   * Create a derivation that will return an array of records matching the given query
   *
   * @param typeName - The name of the type?
   * @param queryCreator - A function that returns the query expression.
   * @param name - (optinal) The name of the query.
   */
  records(e, n = () => ({}), i = "records:" + e + (n ? ":" + n.toString() : "")) {
    const r = this.ids(e, n, "ids:" + i);
    return K(i, () => [...r.get()].map((s) => {
      const o = this.atoms.get()[s];
      if (!o)
        throw new Error("no atom found for record id: " + s);
      return o.get();
    }));
  }
  /**
   * Create a derivation that will return the ids of all records of the given type.
   *
   * @param typeName - The name of the type.
   * @param queryCreator - A function that returns the query expression.
   * @param name - (optinal) The name of the query.
   */
  ids(e, n = () => ({}), i = "ids:" + e + (n ? ":" + n.toString() : "")) {
    const r = this.filterHistory(e), s = () => {
      r.get();
      const c = n();
      return Object.keys(c).length === 0 ? new Set(
        Pt(this.atoms.get()).flatMap((d) => {
          const u = d.get();
          return u.typeName === e ? u.id : [];
        })
      ) : y0(this, e, c);
    }, o = (c) => {
      const d = s(), u = fG(c, d);
      return u ? Sl(d, u) : c;
    }, a = K("ids_query:" + i, n, {
      isEqual: Ab
    });
    return K(
      "query:" + i,
      (c, d) => {
        const u = a.get();
        if (bo(c))
          return s();
        if (d < a.lastChangedEpoch)
          return o(c);
        const h = r.getDiffSince(d);
        if (h === vi)
          return o(c);
        const g = new Ih(
          c
        );
        for (const f of h) {
          for (const M of Pt(f.added))
            M.typeName === e && m0(u, M) && g.add(M.id);
          for (const [M, m] of Pt(f.updated))
            m.typeName === e && (m0(u, m) ? g.add(m.id) : g.remove(m.id));
          for (const M of Pt(f.removed))
            M.typeName === e && g.remove(M.id);
        }
        const p = g.get();
        return p ? Sl(p.value, p.diff) : c;
      },
      { historyLength: 50 }
    );
  }
  exec(e, n) {
    const i = y0(this, e, n);
    if (i.size === 0)
      return hs;
    const r = this.atoms.get();
    return [...i].map((s) => r[s].get());
  }
}
class mG {
  constructor(e) {
    S(this, "_beforeCreateHandlers", {});
    S(this, "_afterCreateHandlers", {});
    S(this, "_beforeChangeHandlers", {});
    S(this, "_afterChangeHandlers", {});
    S(this, "_beforeDeleteHandlers", {});
    S(this, "_afterDeleteHandlers", {});
    S(this, "_operationCompleteHandlers", []);
    S(this, "_isEnabled", !0);
    this.store = e;
  }
  /** @internal */
  isEnabled() {
    return this._isEnabled;
  }
  /** @internal */
  setIsEnabled(e) {
    this._isEnabled = e;
  }
  /** @internal */
  handleBeforeCreate(e, n) {
    if (!this._isEnabled) return e;
    const i = this._beforeCreateHandlers[e.typeName];
    if (i) {
      let r = e;
      for (const s of i)
        r = s(r, n);
      return r;
    }
    return e;
  }
  /** @internal */
  handleAfterCreate(e, n) {
    if (!this._isEnabled) return;
    const i = this._afterCreateHandlers[e.typeName];
    if (i)
      for (const r of i)
        r(e, n);
  }
  /** @internal */
  handleBeforeChange(e, n, i) {
    if (!this._isEnabled) return n;
    const r = this._beforeChangeHandlers[n.typeName];
    if (r) {
      let s = n;
      for (const o of r)
        s = o(e, s, i);
      return s;
    }
    return n;
  }
  /** @internal */
  handleAfterChange(e, n, i) {
    if (!this._isEnabled) return;
    const r = this._afterChangeHandlers[n.typeName];
    if (r)
      for (const s of r)
        s(e, n, i);
  }
  /** @internal */
  handleBeforeDelete(e, n) {
    if (!this._isEnabled) return !0;
    const i = this._beforeDeleteHandlers[e.typeName];
    if (i) {
      for (const r of i)
        if (r(e, n) === !1)
          return !1;
    }
    return !0;
  }
  /** @internal */
  handleAfterDelete(e, n) {
    if (!this._isEnabled) return;
    const i = this._afterDeleteHandlers[e.typeName];
    if (i)
      for (const r of i)
        r(e, n);
  }
  /** @internal */
  handleOperationComplete(e) {
    if (this._isEnabled)
      for (const n of this._operationCompleteHandlers)
        n(e);
  }
  /**
   * Internal helper for registering a bunch of side effects at once and keeping them organized.
   * @internal
   */
  register(e) {
    const n = [];
    for (const [i, r] of Object.entries(e))
      r != null && r.beforeCreate && n.push(this.registerBeforeCreateHandler(i, r.beforeCreate)), r != null && r.afterCreate && n.push(this.registerAfterCreateHandler(i, r.afterCreate)), r != null && r.beforeChange && n.push(this.registerBeforeChangeHandler(i, r.beforeChange)), r != null && r.afterChange && n.push(this.registerAfterChangeHandler(i, r.afterChange)), r != null && r.beforeDelete && n.push(this.registerBeforeDeleteHandler(i, r.beforeDelete)), r != null && r.afterDelete && n.push(this.registerAfterDeleteHandler(i, r.afterDelete));
    return () => {
      for (const i of n) i();
    };
  }
  /**
   * Register a handler to be called before a record of a certain type is created. Return a
   * modified record from the handler to change the record that will be created.
   *
   * Use this handle only to modify the creation of the record itself. If you want to trigger a
   * side-effect on a different record (for example, moving one shape when another is created),
   * use {@link StoreSideEffects.registerAfterCreateHandler} instead.
   *
   * @example
   * ```ts
   * editor.sideEffects.registerBeforeCreateHandler('shape', (shape, source) => {
   *     // only modify shapes created by the user
   *     if (source !== 'user') return shape
   *
   *     //by default, arrow shapes have no label. Let's make sure they always have a label.
   *     if (shape.type === 'arrow') {
   *         return {...shape, props: {...shape.props, text: 'an arrow'}}
   *     }
   *
   *     // other shapes get returned unmodified
   *     return shape
   * })
   * ```
   *
   * @param typeName - The type of record to listen for
   * @param handler - The handler to call
   *
   * @returns A callback that removes the handler.
   */
  registerBeforeCreateHandler(e, n) {
    return this._beforeCreateHandlers[e] || (this._beforeCreateHandlers[e] = []), this._beforeCreateHandlers[e].push(n), () => Do(this._beforeCreateHandlers[e], n);
  }
  /**
   * Register a handler to be called after a record is created. This is useful for side-effects
   * that would update _other_ records. If you want to modify the record being created use
   * {@link StoreSideEffects.registerBeforeCreateHandler} instead.
   *
   * @example
   * ```ts
   * editor.sideEffects.registerAfterCreateHandler('page', (page, source) => {
   *     // Automatically create a shape when a page is created
   *     editor.createShape({
   *         id: createShapeId(),
   *         type: 'text',
   *         props: { text: page.name },
   *     })
   * })
   * ```
   *
   * @param typeName - The type of record to listen for
   * @param handler - The handler to call
   *
   * @returns A callback that removes the handler.
   */
  registerAfterCreateHandler(e, n) {
    return this._afterCreateHandlers[e] || (this._afterCreateHandlers[e] = []), this._afterCreateHandlers[e].push(n), () => Do(this._afterCreateHandlers[e], n);
  }
  /**
   * Register a handler to be called before a record is changed. The handler is given the old and
   * new record - you can return a modified record to apply a different update, or the old record
   * to block the update entirely.
   *
   * Use this handler only for intercepting updates to the record itself. If you want to update
   * other records in response to a change, use
   * {@link StoreSideEffects.registerAfterChangeHandler} instead.
   *
   * @example
   * ```ts
   * editor.sideEffects.registerBeforeChangeHandler('shape', (prev, next, source) => {
   *     if (next.isLocked && !prev.isLocked) {
   *         // prevent shapes from ever being locked:
   *         return prev
   *     }
   *     // other types of change are allowed
   *     return next
   * })
   * ```
   *
   * @param typeName - The type of record to listen for
   * @param handler - The handler to call
   *
   * @returns A callback that removes the handler.
   */
  registerBeforeChangeHandler(e, n) {
    return this._beforeChangeHandlers[e] || (this._beforeChangeHandlers[e] = []), this._beforeChangeHandlers[e].push(n), () => Do(this._beforeChangeHandlers[e], n);
  }
  /**
   * Register a handler to be called after a record is changed. This is useful for side-effects
   * that would update _other_ records - if you want to modify the record being changed, use
   * {@link StoreSideEffects.registerBeforeChangeHandler} instead.
   *
   * @example
   * ```ts
   * editor.sideEffects.registerAfterChangeHandler('shape', (prev, next, source) => {
   *     if (next.props.color === 'red') {
   *         // there can only be one red shape at a time:
   *         const otherRedShapes = editor.getCurrentPageShapes().filter(s => s.props.color === 'red' && s.id !== next.id)
   *         editor.updateShapes(otherRedShapes.map(s => ({...s, props: {...s.props, color: 'blue'}})))
   *     }
   * })
   * ```
   *
   * @param typeName - The type of record to listen for
   * @param handler - The handler to call
   *
   * @returns A callback that removes the handler.
   */
  registerAfterChangeHandler(e, n) {
    return this._afterChangeHandlers[e] || (this._afterChangeHandlers[e] = []), this._afterChangeHandlers[e].push(n), () => Do(this._afterChangeHandlers[e], n);
  }
  /**
   * Register a handler to be called before a record is deleted. The handler can return `false` to
   * prevent the deletion.
   *
   * Use this handler only for intercepting deletions of the record itself. If you want to do
   * something to other records in response to a deletion, use
   * {@link StoreSideEffects.registerAfterDeleteHandler} instead.
   *
   * @example
   * ```ts
   * editor.sideEffects.registerBeforeDeleteHandler('shape', (shape, source) => {
   *     if (shape.props.color === 'red') {
   *         // prevent red shapes from being deleted
   * 	       return false
   *     }
   * })
   * ```
   *
   * @param typeName - The type of record to listen for
   * @param handler - The handler to call
   *
   * @returns A callback that removes the handler.
   */
  registerBeforeDeleteHandler(e, n) {
    return this._beforeDeleteHandlers[e] || (this._beforeDeleteHandlers[e] = []), this._beforeDeleteHandlers[e].push(n), () => Do(this._beforeDeleteHandlers[e], n);
  }
  /**
   * Register a handler to be called after a record is deleted. This is useful for side-effects
   * that would update _other_ records - if you want to block the deletion of the record itself,
   * use {@link StoreSideEffects.registerBeforeDeleteHandler} instead.
   *
   * @example
   * ```ts
   * editor.sideEffects.registerAfterDeleteHandler('shape', (shape, source) => {
   *     // if the last shape in a frame is deleted, delete the frame too:
   *     const parentFrame = editor.getShape(shape.parentId)
   *     if (!parentFrame || parentFrame.type !== 'frame') return
   *
   *     const siblings = editor.getSortedChildIdsForParent(parentFrame)
   *     if (siblings.length === 0) {
   *         editor.deleteShape(parentFrame.id)
   *     }
   * })
   * ```
   *
   * @param typeName - The type of record to listen for
   * @param handler - The handler to call
   *
   * @returns A callback that removes the handler.
   */
  registerAfterDeleteHandler(e, n) {
    return this._afterDeleteHandlers[e] || (this._afterDeleteHandlers[e] = []), this._afterDeleteHandlers[e].push(n), () => Do(this._afterDeleteHandlers[e], n);
  }
  /**
   * Register a handler to be called when a store completes an atomic operation.
   *
   * @example
   * ```ts
   * let count = 0
   *
   * editor.sideEffects.registerOperationCompleteHandler(() => count++)
   *
   * editor.selectAll()
   * expect(count).toBe(1)
   *
   * editor.store.atomic(() => {
   *	editor.selectNone()
   * 	editor.selectAll()
   * })
   *
   * expect(count).toBe(2)
   * ```
   *
   * @param handler - The handler to call
   *
   * @returns A callback that removes the handler.
   *
   * @public
   */
  registerOperationCompleteHandler(e) {
    return this._operationCompleteHandlers.push(e), () => Do(this._operationCompleteHandlers, e);
  }
}
function Do(t, e) {
  const n = t.indexOf(e);
  n >= 0 && t.splice(n, 1);
}
function Dg(t) {
  if (process.env.NODE_ENV === "production")
    return t;
  const e = Object.getPrototypeOf(t);
  if (e && !(Array.isArray(t) || e === Object.prototype || e === null || e === mT))
    throw console.error("cannot include non-js data in a record", t), new Error("cannot include non-js data in a record");
  const n = Object.getOwnPropertyNames(t);
  for (const i of n) {
    const r = t[i];
    r && typeof r == "object" && Dg(r);
  }
  return Object.freeze(t);
}
class Ux {
  constructor(e) {
    /**
     * The random id of the store.
     */
    S(this, "id");
    /**
     * An atom containing the store's atoms.
     *
     * @internal
     * @readonly
     */
    S(this, "atoms", xt("store_atoms", {}));
    /**
     * An atom containing the store's history.
     *
     * @public
     * @readonly
     */
    S(this, "history", xt("history", 0, {
      historyLength: 1e3
    }));
    /**
     * A StoreQueries instance for this store.
     *
     * @public
     * @readonly
     */
    S(this, "query", new MG(this.atoms, this.history));
    /**
     * A set containing listeners that have been added to this store.
     *
     * @internal
     */
    S(this, "listeners", /* @__PURE__ */ new Set());
    /**
     * An array of history entries that have not yet been flushed.
     *
     * @internal
     */
    S(this, "historyAccumulator", new IG());
    /**
     * A reactor that responds to changes to the history by squashing the accumulated history and
     * notifying listeners of the changes.
     *
     * @internal
     */
    S(this, "historyReactor");
    S(this, "schema");
    S(this, "props");
    S(this, "scopedTypes");
    S(this, "sideEffects", new mG(this));
    S(this, "isMergingRemoteChanges", !1);
    S(this, "_integrityChecker");
    S(this, "_isPossiblyCorrupted", !1);
    S(this, "pendingAfterEvents", null);
    S(this, "_isInAtomicOp", !1);
    const { initialData: n, schema: i, id: r } = e;
    this.id = r ?? ht(), this.schema = i, this.props = e.props, n && this.atoms.set(
      KA(
        Mi(n).map(([s, o]) => [
          s,
          xt(
            "atom:" + s,
            Dg(this.schema.validateRecord(this, o, "initialize", null))
          )
        ])
      )
    ), this.historyReactor = XB(
      "Store.historyReactor",
      () => {
        this.history.get(), this._flushHistory();
      },
      { scheduleEffect: (s) => this.cancelHistoryReactor = fT(s) }
    ), this.scopedTypes = {
      document: new Set(
        Pt(this.schema.types).filter((s) => s.scope === "document").map((s) => s.typeName)
      ),
      session: new Set(
        Pt(this.schema.types).filter((s) => s.scope === "session").map((s) => s.typeName)
      ),
      presence: new Set(
        Pt(this.schema.types).filter((s) => s.scope === "presence").map((s) => s.typeName)
      )
    };
  }
  /**
   * Function to dispose of any in-flight timeouts.
   *
   * @internal
   */
  cancelHistoryReactor() {
  }
  _flushHistory() {
    if (this.historyAccumulator.hasChanges()) {
      const e = this.historyAccumulator.flush();
      for (const { changes: n, source: i } of e) {
        let r = null, s = null, o = null;
        for (const { onHistory: a, filters: c } of this.listeners)
          if (!(c.source !== "all" && c.source !== i))
            if (c.scope !== "all")
              if (c.scope === "document") {
                if (s ?? (s = this.filterChangesByScope(n, "document")), !s) continue;
                a({ changes: s, source: i });
              } else if (c.scope === "session") {
                if (r ?? (r = this.filterChangesByScope(n, "session")), !r) continue;
                a({ changes: r, source: i });
              } else {
                if (o ?? (o = this.filterChangesByScope(n, "presence")), !o) continue;
                a({ changes: o, source: i });
              }
            else
              a({ changes: n, source: i });
      }
    }
  }
  dispose() {
    this.cancelHistoryReactor();
  }
  /**
   * Filters out non-document changes from a diff. Returns null if there are no changes left.
   * @param change - the records diff
   * @param scope - the records scope
   * @returns
   */
  filterChangesByScope(e, n) {
    const i = {
      added: Cl(e.added, (r, s) => this.scopedTypes[n].has(s.typeName)),
      updated: Cl(e.updated, (r, s) => this.scopedTypes[n].has(s[1].typeName)),
      removed: Cl(e.removed, (r, s) => this.scopedTypes[n].has(s.typeName))
    };
    return Object.keys(i.added).length === 0 && Object.keys(i.updated).length === 0 && Object.keys(i.removed).length === 0 ? null : i;
  }
  /**
   * Update the history with a diff of changes.
   *
   * @param changes - The changes to add to the history.
   */
  updateHistory(e) {
    this.historyAccumulator.add({
      changes: e,
      source: this.isMergingRemoteChanges ? "remote" : "user"
    }), this.listeners.size === 0 && this.historyAccumulator.clear(), this.history.set(this.history.get() + 1, e);
  }
  validate(e) {
    this.allRecords().forEach((n) => this.schema.validateRecord(this, n, e, null));
  }
  /**
   * Add some records to the store. It's an error if they already exist.
   *
   * @param records - The records to add.
   * @param phaseOverride - The phase override.
   * @public
   */
  put(e, n) {
    this.atomic(() => {
      const i = {}, r = {}, s = this.atoms.__unsafe__getWithoutCapture();
      let o = null, a, c = !1;
      const d = this.isMergingRemoteChanges ? "remote" : "user";
      for (let u = 0, h = e.length; u < h; u++) {
        a = e[u];
        const g = (o ?? s)[a.id];
        if (g) {
          const p = g.__unsafe__getWithoutCapture();
          if (a = this.sideEffects.handleBeforeChange(p, a, d), this.schema.validateRecord(
            this,
            a,
            n ?? "updateRecord",
            p
          ) === p) continue;
          g.set(Dg(a)), c = !0;
          const M = g.__unsafe__getWithoutCapture();
          i[a.id] = [p, M], this.addDiffForAfterEvent(p, M);
        } else
          a = this.sideEffects.handleBeforeCreate(a, d), c = !0, a = this.schema.validateRecord(
            this,
            a,
            n ?? "createRecord",
            null
          ), r[a.id] = a, this.addDiffForAfterEvent(null, a), o || (o = { ...s }), o[a.id] = xt("atom:" + a.id, a);
      }
      o && this.atoms.set(o), c && this.updateHistory({
        added: r,
        updated: i,
        removed: {}
      });
    });
  }
  /**
   * Remove some records from the store via their ids.
   *
   * @param ids - The ids of the records to remove.
   * @public
   */
  remove(e) {
    this.atomic(() => {
      const n = /* @__PURE__ */ new Set(), i = this.isMergingRemoteChanges ? "remote" : "user";
      if (this.sideEffects.isEnabled())
        for (const s of e) {
          const o = this.atoms.__unsafe__getWithoutCapture()[s];
          o && this.sideEffects.handleBeforeDelete(o.get(), i) === !1 && n.add(s);
        }
      let r;
      this.atoms.update((s) => {
        let o;
        for (const a of e) {
          if (n.has(a) || !(a in s)) continue;
          o || (o = { ...s }), r || (r = {}), delete o[a];
          const c = s[a].get();
          r[a] = c, this.addDiffForAfterEvent(c, null);
        }
        return o ?? s;
      }), r && this.updateHistory({ added: {}, updated: {}, removed: r });
    });
  }
  /**
   * Get the value of a store record by its id.
   *
   * @param id - The id of the record to get.
   * @public
   */
  get(e) {
    var n;
    return (n = this.atoms.get()[e]) == null ? void 0 : n.get();
  }
  /**
   * Get the value of a store record by its id without updating its epoch.
   *
   * @param id - The id of the record to get.
   * @public
   */
  unsafeGetWithoutCapture(e) {
    var n;
    return (n = this.atoms.__unsafe__getWithoutCapture()[e]) == null ? void 0 : n.__unsafe__getWithoutCapture();
  }
  /**
   * Creates a JSON payload from the record store.
   *
   * @param scope - The scope of records to serialize. Defaults to 'document'.
   * @returns The record store snapshot as a JSON payload.
   */
  serialize(e = "document") {
    const n = {};
    for (const [i, r] of Mi(this.atoms.get())) {
      const s = r.get();
      (e === "all" || this.scopedTypes[e].has(s.typeName)) && (n[i] = s);
    }
    return n;
  }
  /**
   * Get a serialized snapshot of the store and its schema.
   *
   * ```ts
   * const snapshot = store.getStoreSnapshot()
   * store.loadStoreSnapshot(snapshot)
   * ```
   *
   * @param scope - The scope of records to serialize. Defaults to 'document'.
   *
   * @public
   */
  getStoreSnapshot(e = "document") {
    return {
      store: this.serialize(e),
      schema: this.schema.serialize()
    };
  }
  /**
   * @deprecated use `getSnapshot` from the 'tldraw' package instead.
   */
  getSnapshot(e = "document") {
    return console.warn(
      "[tldraw] `Store.getSnapshot` is deprecated and will be removed in a future release. Use `getSnapshot` from the `tldraw` package instead."
    ), this.getStoreSnapshot(e);
  }
  /**
   * Migrate a serialized snapshot of the store and its schema.
   *
   * ```ts
   * const snapshot = store.getSnapshot()
   * store.migrateSnapshot(snapshot)
   * ```
   *
   * @param snapshot - The snapshot to load.
   * @public
   */
  migrateSnapshot(e) {
    const n = this.schema.migrateStoreSnapshot(e);
    if (n.type === "error")
      throw new Error(`Failed to migrate snapshot: ${n.reason}`);
    return {
      store: n.value,
      schema: this.schema.serialize()
    };
  }
  /**
   * Load a serialized snapshot.
   *
   * ```ts
   * const snapshot = store.getStoreSnapshot()
   * store.loadStoreSnapshot(snapshot)
   * ```
   *
   * @param snapshot - The snapshot to load.
   * @public
   */
  loadStoreSnapshot(e) {
    const n = this.schema.migrateStoreSnapshot(e);
    if (n.type === "error")
      throw new Error(`Failed to migrate snapshot: ${n.reason}`);
    const i = this.sideEffects.isEnabled();
    try {
      this.sideEffects.setIsEnabled(!1), this.atomic(() => {
        this.clear(), this.put(Object.values(n.value)), this.ensureStoreIsUsable();
      });
    } finally {
      this.sideEffects.setIsEnabled(i);
    }
  }
  /**
   * @public
   * @deprecated use `loadSnapshot` from the 'tldraw' package instead.
   */
  loadSnapshot(e) {
    console.warn(
      "[tldraw] `Store.loadSnapshot` is deprecated and will be removed in a future release. Use `loadSnapshot` from the 'tldraw' package instead."
    ), this.loadStoreSnapshot(e);
  }
  /**
   * Get an array of all values in the store.
   *
   * @returns An array of all values in the store.
   * @public
   */
  allRecords() {
    return Pt(this.atoms.get()).map((e) => e.get());
  }
  /**
   * Removes all records from the store.
   *
   * @public
   */
  clear() {
    this.remove(mD(this.atoms.get()));
  }
  /**
   * Update a record. To update multiple records at once, use the `update` method of the
   * `TypedStore` class.
   *
   * @param id - The id of the record to update.
   * @param updater - A function that updates the record.
   */
  update(e, n) {
    const i = this.atoms.get()[e];
    if (!i) {
      console.error(`Record ${e} not found. This is probably an error`);
      return;
    }
    this.put([n(i.__unsafe__getWithoutCapture())]);
  }
  /**
   * Get whether the record store has a id.
   *
   * @param id - The id of the record to check.
   * @public
   */
  has(e) {
    return !!this.atoms.get()[e];
  }
  /**
   * Add a new listener to the store.
   *
   * @param onHistory - The listener to call when the store updates.
   * @param filters - Filters to apply to the listener.
   * @returns A function to remove the listener.
   */
  listen(e, n) {
    this._flushHistory();
    const i = {
      onHistory: e,
      filters: {
        source: (n == null ? void 0 : n.source) ?? "all",
        scope: (n == null ? void 0 : n.scope) ?? "all"
      }
    };
    return this.listeners.add(i), this.historyReactor.scheduler.isActivelyListening || this.historyReactor.start(), () => {
      this.listeners.delete(i), this.listeners.size === 0 && this.historyReactor.stop();
    };
  }
  /**
   * Merge changes from a remote source without triggering listeners.
   *
   * @param fn - A function that merges the external changes.
   * @public
   */
  mergeRemoteChanges(e) {
    if (this.isMergingRemoteChanges)
      return e();
    if (this._isInAtomicOp)
      throw new Error("Cannot merge remote changes while in atomic operation");
    try {
      this.isMergingRemoteChanges = !0, Qr(e);
    } finally {
      this.isMergingRemoteChanges = !1;
    }
  }
  /**
   * Run `fn` and return a {@link RecordsDiff} of the changes that occurred as a result.
   */
  extractingChanges(e) {
    const n = [], i = this.historyAccumulator.addInterceptor((r) => n.push(r.changes));
    try {
      return Qr(e), Px(n);
    } finally {
      i();
    }
  }
  applyDiff(e, {
    runCallbacks: n = !0,
    ignoreEphemeralKeys: i = !1
  } = {}) {
    this.atomic(() => {
      const r = Pt(e.added);
      for (const [o, a] of Pt(e.updated)) {
        const c = this.schema.getType(a.typeName);
        if (i && c.ephemeralKeySet.size) {
          const d = this.get(a.id);
          if (!d) {
            r.push(a);
            continue;
          }
          let u = null;
          for (const [h, g] of Object.entries(a))
            c.ephemeralKeySet.has(h) || Object.is(g, ui(d, h)) || (u || (u = { ...d }), u[h] = g);
          u && r.push(u);
        } else
          r.push(a);
      }
      const s = mD(e.removed);
      r.length && this.put(r), s.length && this.remove(s);
    }, n);
  }
  /**
   * Create a computed cache.
   *
   * @param name - The name of the derivation cache.
   * @param derive - A function used to derive the value of the cache.
   * @param isEqual - A function that determins equality between two records.
   * @public
   */
  createComputedCache(e, n, i) {
    const r = new hr();
    return {
      get: (s) => {
        const o = this.atoms.get()[s];
        if (o)
          return r.get(o, () => {
            const a = i ? K(o.name + ":equals", () => o.get(), { isEqual: i }) : o;
            return K(e + ":" + s, () => n(a.get()));
          }).get();
      }
    };
  }
  /**
   * Create a computed cache from a selector
   *
   * @param name - The name of the derivation cache.
   * @param selector - A function that returns a subset of the original shape
   * @param derive - A function used to derive the value of the cache.
   * @public
   */
  createSelectedComputedCache(e, n, i) {
    const r = new hr();
    return {
      get: (s) => {
        const o = this.atoms.get()[s];
        if (o)
          return r.get(o, () => {
            const a = K(
              e + ":" + s + ":selector",
              () => n(o.get())
            );
            return K(e + ":" + s, () => i(a.get()));
          }).get();
      }
    };
  }
  /** @internal */
  ensureStoreIsUsable() {
    this.atomic(() => {
      var e;
      this._integrityChecker ?? (this._integrityChecker = this.schema.createIntegrityChecker(this)), (e = this._integrityChecker) == null || e.call(this);
    });
  }
  /** @internal */
  markAsPossiblyCorrupted() {
    this._isPossiblyCorrupted = !0;
  }
  /** @internal */
  isPossiblyCorrupted() {
    return this._isPossiblyCorrupted;
  }
  addDiffForAfterEvent(e, n) {
    if (ct(this.pendingAfterEvents, "must be in event operation"), e === n || (e && n && ct(e.id === n.id), !e && !n)) return;
    const i = (e || n).id, r = this.pendingAfterEvents.get(i);
    r ? r.after = n : this.pendingAfterEvents.set(i, { before: e, after: n });
  }
  flushAtomicCallbacks() {
    let e = 0;
    const n = this.isMergingRemoteChanges ? "remote" : "user";
    for (; this.pendingAfterEvents; ) {
      const i = this.pendingAfterEvents;
      if (this.pendingAfterEvents = null, !!this.sideEffects.isEnabled()) {
        if (e++, e > 100)
          throw new Error("Maximum store update depth exceeded, bailing out");
        for (const { before: r, after: s } of i.values())
          r && s ? this.sideEffects.handleAfterChange(r, s, n) : r && !s ? this.sideEffects.handleAfterDelete(r, n) : !r && s && this.sideEffects.handleAfterCreate(s, n);
        this.pendingAfterEvents || this.sideEffects.handleOperationComplete(n);
      }
    }
  }
  /** @internal */
  atomic(e, n = !0) {
    return Qr(() => {
      if (this._isInAtomicOp)
        return this.pendingAfterEvents || (this.pendingAfterEvents = /* @__PURE__ */ new Map()), e();
      this.pendingAfterEvents = /* @__PURE__ */ new Map();
      const i = this.sideEffects.isEnabled();
      this.sideEffects.setIsEnabled(n ?? i), this._isInAtomicOp = !0;
      try {
        const r = e();
        return this.flushAtomicCallbacks(), r;
      } finally {
        this.pendingAfterEvents = null, this.sideEffects.setIsEnabled(i), this._isInAtomicOp = !1;
      }
    });
  }
  /** @internal */
  addHistoryInterceptor(e) {
    return this.historyAccumulator.addInterceptor(
      (n) => e(n, this.isMergingRemoteChanges ? "remote" : "user")
    );
  }
}
function yG(t) {
  if (t.length === 0) return [];
  const e = [];
  let n = [t[0]], i;
  for (let r = 1, s = t.length; r < s; r++)
    i = t[r], n[0].source !== i.source && (e.push(n), n = []), n.push(i);
  return e.push(n), Dg(
    e.map((r) => ({
      source: r[0].source,
      changes: Px(r.map((s) => s.changes))
    }))
  );
}
class IG {
  constructor() {
    S(this, "_history", []);
    S(this, "_interceptors", /* @__PURE__ */ new Set());
  }
  addInterceptor(e) {
    return this._interceptors.add(e), () => {
      this._interceptors.delete(e);
    };
  }
  add(e) {
    this._history.push(e);
    for (const n of this._interceptors)
      n(e);
  }
  flush() {
    const e = yG(this._history);
    return this._history = [], e;
  }
  clear() {
    this._history = [];
  }
  hasChanges() {
    return this._history.length > 0;
  }
}
function xG(t, e, n) {
  const i = new hr();
  return {
    get(r, s) {
      return i.get(r, () => (r instanceof Ux ? r : r.store).createComputedCache(t, (c) => e(r, c), n)).get(s);
    }
  };
}
function SG(t) {
  const e = [];
  for (let n = t.length - 1; n >= 0; n--) {
    const i = t[n];
    if ("id" in i)
      e.unshift(i);
    else {
      const r = i.dependsOn, s = e[0];
      s && (e[0] = {
        ...s,
        dependsOn: r.concat(s.dependsOn ?? [])
      });
    }
  }
  return e;
}
function Oa({
  sequence: t,
  sequenceId: e,
  retroactive: n = !0
}) {
  const i = {
    sequenceId: e,
    retroactive: n,
    sequence: SG(t)
  };
  return Tb(i), i;
}
function xi(t, e) {
  return Object.fromEntries(
    Mi(e).map(([n, i]) => [n, `${t}/${i}`])
  );
}
function Ri(t) {
  const e = t.sequenceId;
  return Oa({
    sequenceId: e,
    retroactive: t.retroactive ?? !0,
    sequence: t.sequence.map(
      (n) => "id" in n ? {
        ...n,
        scope: "record",
        filter: (i) => {
          var r, s;
          return i.typeName === t.recordType && (((r = n.filter) == null ? void 0 : r.call(n, i)) ?? !0) && (((s = t.filter) == null ? void 0 : s.call(t, i)) ?? !0);
        }
      } : n
    )
  });
}
function jG(t) {
  const e = new Map(t.map((s) => [s.id, s])), n = /* @__PURE__ */ new Set(), i = [];
  function r(s) {
    ct(!n.has(s.id), `Circular dependency in migrations: ${s.id}`), n.add(s.id);
    const { version: o, sequenceId: a } = wg(s.id), c = e.get(`${a}/${o - 1}`);
    if (c && r(c), s.dependsOn)
      for (const d of s.dependsOn) {
        const u = e.get(d);
        u && r(u);
      }
    e.delete(s.id), i.push(s);
  }
  for (const s of e.values())
    r(s);
  return i;
}
function wg(t) {
  const [e, n] = t.split("/");
  return { sequenceId: e, version: parseInt(n) };
}
function I0(t, e) {
  e && ct(
    t.startsWith(e + "/"),
    `Every migration in sequence '${e}' must have an id starting with '${e}/'. Got invalid id: '${t}'`
  ), ct(t.match(/^(.*?)\/(0|[1-9]\d*)$/), `Invalid migration id: '${t}'`);
}
function Tb(t) {
  if (ct(
    !t.sequenceId.includes("/"),
    `sequenceId cannot contain a '/', got ${t.sequenceId}`
  ), ct(t.sequenceId.length, "sequenceId must be a non-empty string"), t.sequence.length === 0)
    return;
  I0(t.sequence[0].id, t.sequenceId);
  let e = wg(t.sequence[0].id).version;
  ct(
    e === 1,
    `Expected the first migrationId to be '${t.sequenceId}/1' but got '${t.sequence[0].id}'`
  );
  for (let n = 1; n < t.sequence.length; n++) {
    const i = t.sequence[n].id;
    I0(i, t.sequenceId);
    const r = wg(i).version;
    ct(
      r === e + 1,
      `Migration id numbers must increase in increments of 1, expected ${t.sequenceId}/${e + 1} but got '${t.sequence[n].id}'`
    ), e = r;
  }
}
var Us = /* @__PURE__ */ ((t) => (t.IncompatibleSubtype = "incompatible-subtype", t.UnknownType = "unknown-type", t.TargetVersionTooNew = "target-version-too-new", t.TargetVersionTooOld = "target-version-too-old", t.MigrationError = "migration-error", t.UnrecognizedSubtype = "unrecognized-subtype", t))(Us || {});
function DG(t) {
  if (t.schemaVersion > 2 || t.schemaVersion < 1) return Rr.err("Bad schema version");
  if (t.schemaVersion === 2) return Rr.ok(t);
  const e = {
    schemaVersion: 2,
    sequences: {
      "com.tldraw.store": t.storeVersion
    }
  };
  for (const [n, i] of Object.entries(t.recordVersions))
    if (e.sequences[`com.tldraw.${n}`] = i.version, "subTypeKey" in i)
      for (const [r, s] of Object.entries(i.subTypeVersions))
        e.sequences[`com.tldraw.${n}.${r}`] = s;
  return Rr.ok(e);
}
class Rx {
  constructor(e, n) {
    S(this, "migrations", {});
    S(this, "sortedMigrations");
    var r;
    this.types = e, this.options = n;
    for (const s of n.migrations ?? [])
      ct(!this.migrations[s.sequenceId], `Duplicate migration sequenceId ${s.sequenceId}`), Tb(s), this.migrations[s.sequenceId] = s;
    const i = Object.values(this.migrations).flatMap((s) => s.sequence);
    this.sortedMigrations = jG(i);
    for (const s of this.sortedMigrations)
      if ((r = s.dependsOn) != null && r.length)
        for (const o of s.dependsOn) {
          const a = i.find((c) => c.id === o);
          ct(a, `Migration '${s.id}' depends on missing migration '${o}'`);
        }
  }
  static create(e, n) {
    return new Rx(e, n ?? {});
  }
  validateRecord(e, n, i, r) {
    try {
      const s = ui(this.types, n.typeName);
      if (!s)
        throw new Error(`Missing definition for record type ${n.typeName}`);
      return s.validate(n, r ?? void 0);
    } catch (s) {
      if (this.options.onValidationFailure)
        return this.options.onValidationFailure({
          store: e,
          record: n,
          phase: i,
          recordBefore: r,
          error: s
        });
      throw s;
    }
  }
  // TODO: use a weakmap to store the result of this function
  getMigrationsSince(e) {
    const n = DG(e);
    if (!n.ok)
      return n;
    const i = n.value, r = new Set(
      // start with any shared sequences
      Object.keys(i.sequences).filter((o) => this.migrations[o])
    );
    for (const o in this.migrations)
      i.sequences[o] === void 0 && this.migrations[o].retroactive && r.add(o);
    if (r.size === 0)
      return Rr.ok([]);
    const s = /* @__PURE__ */ new Set();
    for (const o of r) {
      const a = i.sequences[o];
      if (typeof a != "number" && this.migrations[o].retroactive || a === 0) {
        for (const u of this.migrations[o].sequence)
          s.add(u.id);
        continue;
      }
      const c = `${o}/${a}`, d = this.migrations[o].sequence.findIndex((u) => u.id === c);
      if (d === -1)
        return Rr.err("Incompatible schema?");
      for (const u of this.migrations[o].sequence.slice(d + 1))
        s.add(u.id);
    }
    return Rr.ok(this.sortedMigrations.filter(({ id: o }) => s.has(o)));
  }
  migratePersistedRecord(e, n, i = "up") {
    const r = this.getMigrationsSince(n);
    if (!r.ok)
      return console.error("Error migrating record", r.error), { type: "error", reason: Us.MigrationError };
    let s = r.value;
    if (s.length === 0)
      return { type: "success", value: e };
    if (s.some((o) => o.scope === "store"))
      return {
        type: "error",
        reason: i === "down" ? Us.TargetVersionTooOld : Us.TargetVersionTooNew
      };
    if (i === "down") {
      if (!s.every((o) => o.down))
        return {
          type: "error",
          reason: Us.TargetVersionTooOld
        };
      s = s.slice().reverse();
    }
    e = Ct(e);
    try {
      for (const o of s) {
        if (o.scope === "store") throw new Error(
          /* won't happen, just for TS */
        );
        if (!(o.filter ? o.filter(e) : !0)) continue;
        const c = o[i](e);
        c && (e = Ct(c));
      }
    } catch (o) {
      return console.error("Error migrating record", o), { type: "error", reason: Us.MigrationError };
    }
    return { type: "success", value: e };
  }
  migrateStoreSnapshot(e) {
    let { store: n } = e;
    const i = this.getMigrationsSince(e.schema);
    if (!i.ok)
      return console.error("Error migrating store", i.error), { type: "error", reason: Us.MigrationError };
    const r = i.value;
    if (r.length === 0)
      return { type: "success", value: n };
    n = Ct(n);
    try {
      for (const s of r)
        if (s.scope === "record")
          for (const [o, a] of Object.entries(n)) {
            if (!(s.filter ? s.filter(a) : !0)) continue;
            const d = s.up(a);
            d && (n[o] = Ct(d));
          }
        else if (s.scope === "store") {
          const o = s.up(n);
          o && (n = Ct(o));
        } else
          rn(s);
    } catch (s) {
      return console.error("Error migrating store", s), { type: "error", reason: Us.MigrationError };
    }
    return { type: "success", value: n };
  }
  /** @internal */
  createIntegrityChecker(e) {
    var n, i;
    return ((i = (n = this.options).createIntegrityChecker) == null ? void 0 : i.call(n, e)) ?? void 0;
  }
  serialize() {
    return {
      schemaVersion: 2,
      sequences: Object.fromEntries(
        Object.values(this.migrations).map(({ sequenceId: e, sequence: n }) => [
          e,
          n.length ? wg(n.at(-1).id).version : 0
        ])
      )
    };
  }
  /**
   * @deprecated This is only here for legacy reasons, don't use it unless you have david's blessing!
   */
  serializeEarliestVersion() {
    return {
      schemaVersion: 2,
      sequences: Object.fromEntries(
        Object.values(this.migrations).map(({ sequenceId: e }) => [e, 0])
      )
    };
  }
  /** @internal */
  getType(e) {
    const n = ui(this.types, e);
    return ct(n, "record type does not exists"), n;
  }
}
so(
  "@tldraw/store",
  "3.4.1",
  "esm"
);
function wG(t) {
  if (!t.length)
    return null;
  let e = "";
  for (const n of t)
    typeof n == "number" ? e += `.${n}` : n.startsWith("(") ? e.endsWith(")") ? e = `${e.slice(0, -1)}, ${n.slice(1)}` : e += n : e += `.${n}`;
  return e = e.replace(/id = [^,]+, /, "").replace(/id = [^)]+/, ""), e.startsWith(".") ? e.slice(1) : e;
}
class nt extends Error {
  constructor(n, i = []) {
    const r = wG(i), s = n.split(`
`).map((o, a) => a === 0 ? o : `  ${o}`).join(`
`);
    super(i ? `At ${r}: ${s}` : s);
    S(this, "name", "ValidationError");
    this.rawMessage = n, this.path = i;
  }
}
function mi(t, e) {
  try {
    return e();
  } catch (n) {
    throw n instanceof nt ? new nt(n.rawMessage, [t, ...n.path]) : new nt(n.toString(), [t]);
  }
}
function _s(t) {
  if (t === null) return "null";
  if (Array.isArray(t)) return "an array";
  const e = typeof t;
  switch (e) {
    case "bigint":
    case "boolean":
    case "function":
    case "number":
    case "string":
    case "symbol":
      return `a ${e}`;
    case "object":
      return `an ${e}`;
    case "undefined":
      return "undefined";
    default:
      rn(e);
  }
}
class qn {
  constructor(e, n) {
    this.validationFn = e, this.validateUsingKnownGoodVersionFn = n;
  }
  /**
   * Asserts that the passed value is of the correct type and returns it. The returned value is
   * guaranteed to be referentially equal to the passed value.
   */
  validate(e) {
    const n = this.validationFn(e);
    if (process.env.NODE_ENV !== "production" && !Object.is(e, n))
      throw new nt("Validator functions must return the same value they were passed");
    return n;
  }
  validateUsingKnownGoodVersion(e, n) {
    return Object.is(e, n) ? e : this.validateUsingKnownGoodVersionFn ? this.validateUsingKnownGoodVersionFn(e, n) : this.validate(n);
  }
  /** Checks that the passed value is of the correct type. */
  isValid(e) {
    try {
      return this.validate(e), !0;
    } catch {
      return !1;
    }
  }
  /**
   * Returns a new validator that also accepts null or undefined. The resulting value will always be
   * null.
   */
  nullable() {
    return EG(this);
  }
  /**
   * Returns a new validator that also accepts null or undefined. The resulting value will always be
   * null.
   */
  optional() {
    return vb(this);
  }
  /**
   * Refine this validation to a new type. The passed-in validation function should throw an error
   * if the value can't be converted to the new type, or return the new type otherwise.
   */
  refine(e) {
    return new qn(
      (n) => e(this.validate(n)),
      (n, i) => {
        const r = this.validateUsingKnownGoodVersion(n, i);
        return Object.is(n, r) ? n : e(r);
      }
    );
  }
  check(e, n) {
    return typeof e == "string" ? this.refine((i) => (mi(`(check ${e})`, () => n(i)), i)) : this.refine((i) => (e(i), i));
  }
}
class NG extends qn {
  constructor(e) {
    super(
      (n) => {
        const i = Uy.validate(n);
        for (let r = 0; r < i.length; r++)
          mi(r, () => e.validate(i[r]));
        return i;
      },
      (n, i) => {
        if (!e.validateUsingKnownGoodVersion) return this.validate(i);
        const r = Uy.validate(i);
        let s = n.length !== r.length;
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          if (o >= n.length) {
            s = !0, mi(o, () => e.validate(a));
            continue;
          }
          if (Object.is(n[o], a))
            continue;
          const c = mi(
            o,
            () => e.validateUsingKnownGoodVersion(n[o], a)
          );
          Object.is(c, n[o]) || (s = !0);
        }
        return s ? i : n;
      }
    ), this.itemValidator = e;
  }
  nonEmpty() {
    return this.check((e) => {
      if (e.length === 0)
        throw new nt("Expected a non-empty array");
    });
  }
  lengthGreaterThan1() {
    return this.check((e) => {
      if (e.length <= 1)
        throw new nt("Expected an array with length greater than 1");
    });
  }
}
class Ng extends qn {
  constructor(e, n = !1) {
    super(
      (i) => {
        if (typeof i != "object" || i === null)
          throw new nt(`Expected object, got ${_s(i)}`);
        for (const [r, s] of Object.entries(e))
          mi(r, () => {
            s.validate(ui(i, r));
          });
        if (!n) {
          for (const r of Object.keys(i))
            if (!cr(e, r))
              throw new nt("Unexpected property", [r]);
        }
        return i;
      },
      (i, r) => {
        if (typeof r != "object" || r === null)
          throw new nt(`Expected object, got ${_s(r)}`);
        let s = !1;
        for (const [o, a] of Object.entries(e)) {
          const c = ui(i, o), d = ui(r, o);
          if (Object.is(c, d))
            continue;
          const u = mi(o, () => {
            const h = a;
            return h.validateUsingKnownGoodVersion ? h.validateUsingKnownGoodVersion(c, d) : h.validate(d);
          });
          Object.is(u, c) || (s = !0);
        }
        if (!n) {
          for (const o of Object.keys(r))
            if (!cr(e, o))
              throw new nt("Unexpected property", [o]);
        }
        for (const o of Object.keys(i))
          if (!cr(r, o)) {
            s = !0;
            break;
          }
        return s ? r : i;
      }
    ), this.config = e, this.shouldAllowUnknownProperties = n;
  }
  allowUnknownProperties() {
    return new Ng(this.config, !0);
  }
  /**
   * Extend an object validator by adding additional properties.
   *
   * @example
   *
   * ```ts
   * const animalValidator = T.object({
   * 	name: T.string,
   * })
   * const catValidator = animalValidator.extend({
   * 	meowVolume: T.number,
   * })
   * ```
   */
  extend(e) {
    return new Ng({ ...this.config, ...e });
  }
}
class jp extends qn {
  constructor(e, n, i, r) {
    super(
      (s) => {
        this.expectObject(s);
        const { matchingSchema: o, variant: a } = this.getMatchingSchemaAndVariant(s);
        return o === void 0 ? this.unknownValueValidation(s, a) : mi(`(${e} = ${a})`, () => o.validate(s));
      },
      (s, o) => {
        this.expectObject(o), this.expectObject(s);
        const { matchingSchema: a, variant: c } = this.getMatchingSchemaAndVariant(o);
        return a === void 0 ? this.unknownValueValidation(o, c) : ui(s, e) !== ui(o, e) ? mi(`(${e} = ${c})`, () => a.validate(o)) : mi(`(${e} = ${c})`, () => a.validateUsingKnownGoodVersion ? a.validateUsingKnownGoodVersion(s, o) : a.validate(o));
      }
    ), this.key = e, this.config = n, this.unknownValueValidation = i, this.useNumberKeys = r;
  }
  expectObject(e) {
    if (typeof e != "object" || e === null)
      throw new nt(`Expected an object, got ${_s(e)}`, []);
  }
  getMatchingSchemaAndVariant(e) {
    const n = ui(e, this.key);
    if (!this.useNumberKeys && typeof n != "string")
      throw new nt(
        `Expected a string for key "${this.key}", got ${_s(n)}`
      );
    if (this.useNumberKeys && !Number.isFinite(Number(n)))
      throw new nt(`Expected a number for key "${this.key}", got "${n}"`);
    return { matchingSchema: cr(this.config, n) ? this.config[n] : void 0, variant: n };
  }
  validateUnknownVariants(e) {
    return new jp(this.key, this.config, e, this.useNumberKeys);
  }
}
class AG extends qn {
  constructor(e, n) {
    super(
      (i) => {
        if (typeof i != "object" || i === null)
          throw new nt(`Expected object, got ${_s(i)}`);
        for (const [r, s] of Object.entries(i))
          mi(r, () => {
            e.validate(r), n.validate(s);
          });
        return i;
      },
      (i, r) => {
        if (typeof r != "object" || r === null)
          throw new nt(`Expected object, got ${_s(r)}`);
        let s = !1;
        for (const [o, a] of Object.entries(r)) {
          if (!cr(i, o)) {
            s = !0, mi(o, () => {
              e.validate(o), n.validate(a);
            });
            continue;
          }
          const c = ui(i, o), d = a;
          if (Object.is(c, d))
            continue;
          const u = mi(o, () => n.validateUsingKnownGoodVersion ? n.validateUsingKnownGoodVersion(c, d) : n.validate(d));
          Object.is(u, c) || (s = !0);
        }
        for (const o of Object.keys(i))
          if (!cr(r, o)) {
            s = !0;
            break;
          }
        return s ? r : i;
      }
    ), this.keyValidator = e, this.valueValidator = n;
  }
}
function Yx(t) {
  return new qn((e) => {
    if (typeof e !== t)
      throw new nt(`Expected ${t}, got ${_s(e)}`);
    return e;
  });
}
const TG = new qn((t) => t), Ne = Yx("string"), we = Yx("number").check((t) => {
  if (Number.isNaN(t))
    throw new nt("Expected a number, got NaN");
  if (!Number.isFinite(t))
    throw new nt(`Expected a finite number, got ${t}`);
}), Ag = we.check((t) => {
  if (t < 0) throw new nt(`Expected a positive number, got ${t}`);
}), Ht = we.check((t) => {
  if (t <= 0) throw new nt(`Expected a non-zero positive number, got ${t}`);
}), bb = we.check((t) => {
  if (!Number.isInteger(t)) throw new nt(`Expected an integer, got ${t}`);
}), xh = bb.check((t) => {
  if (t < 0) throw new nt(`Expected a positive integer, got ${t}`);
}), bG = bb.check((t) => {
  if (t <= 0) throw new nt(`Expected a non-zero positive integer, got ${t}`);
}), qe = Yx("boolean");
function zn(t) {
  return new qn((e) => {
    if (e !== t)
      throw new nt(`Expected ${t}, got ${JSON.stringify(e)}`);
    return t;
  });
}
const Uy = new qn((t) => {
  if (!Array.isArray(t))
    throw new nt(`Expected an array, got ${_s(t)}`);
  return t;
});
function sn(t) {
  return new NG(t);
}
function Xe(t) {
  return new Ng(t);
}
function Ry(t) {
  return typeof t == "object" && t !== null && (Object.getPrototypeOf(t) === Object.prototype || Object.getPrototypeOf(t) === null || Object.getPrototypeOf(t) === mT);
}
function Yy(t) {
  return t === null || typeof t == "number" || typeof t == "string" || typeof t == "boolean" ? !0 : Array.isArray(t) ? t.every(Yy) : Ry(t) ? Object.values(t).every(Yy) : !1;
}
const fn = new qn(
  (t) => {
    if (Yy(t))
      return t;
    throw new nt(`Expected json serializable value, got ${typeof t}`);
  },
  (t, e) => {
    if (Array.isArray(t) && Array.isArray(e)) {
      let n = t.length !== e.length;
      for (let i = 0; i < e.length; i++) {
        if (i >= t.length) {
          n = !0, fn.validate(e[i]);
          continue;
        }
        const r = t[i], s = e[i];
        if (Object.is(r, s))
          continue;
        const o = fn.validateUsingKnownGoodVersion(r, s);
        Object.is(o, r) || (n = !0);
      }
      return n ? e : t;
    } else if (Ry(t) && Ry(e)) {
      let n = !1;
      for (const i of Object.keys(e)) {
        if (!cr(t, i)) {
          n = !0, fn.validate(e[i]);
          continue;
        }
        const r = t[i], s = e[i];
        if (Object.is(r, s))
          continue;
        const o = fn.validateUsingKnownGoodVersion(r, s);
        Object.is(o, r) || (n = !0);
      }
      for (const i of Object.keys(t))
        if (!cr(e, i)) {
          n = !0;
          break;
        }
      return n ? e : t;
    } else
      return fn.validate(e);
  }
);
function Ha(t, e) {
  return new AG(t, e);
}
function Qx(t, e) {
  return new jp(
    t,
    e,
    (n, i) => {
      throw new nt(
        `Expected one of ${Object.keys(e).map((r) => JSON.stringify(r)).join(" or ")}, got ${JSON.stringify(i)}`,
        [t]
      );
    },
    !1
  );
}
function vG(t, e) {
  return new jp(
    t,
    e,
    (n, i) => {
      throw new nt(
        `Expected one of ${Object.keys(e).map((r) => JSON.stringify(r)).join(" or ")}, got ${JSON.stringify(i)}`,
        [t]
      );
    },
    !0
  );
}
function Wr(t, e) {
  return new qn(
    (n) => mi(t, () => e.validate(n)),
    (n, i) => mi(t, () => e.validateUsingKnownGoodVersion ? e.validateUsingKnownGoodVersion(n, i) : e.validate(i))
  );
}
function Dp(t) {
  return new qn((e) => {
    if (!t.has(e)) {
      const n = Array.from(t, (i) => JSON.stringify(i)).join(" or ");
      throw new nt(`Expected ${n}, got ${e}`);
    }
    return e;
  });
}
function vb(t) {
  return new qn(
    (e) => {
      if (e !== void 0)
        return t.validate(e);
    },
    (e, n) => {
      if (!(e === void 0 && n === void 0) && n !== void 0)
        return t.validateUsingKnownGoodVersion && e !== void 0 ? t.validateUsingKnownGoodVersion(e, n) : t.validate(n);
    }
  );
}
function EG(t) {
  return new qn(
    (e) => e === null ? null : t.validate(e),
    (e, n) => n === null ? null : t.validateUsingKnownGoodVersion && e !== null ? t.validateUsingKnownGoodVersion(e, n) : t.validate(n)
  );
}
function wp(...t) {
  return Dp(new Set(t));
}
function Zx(t) {
  try {
    return new URL(t);
  } catch {
    if (t.startsWith("/") || t.startsWith("./"))
      try {
        return new URL(t, "http://example.com");
      } catch {
        throw new nt(`Expected a valid url, got ${JSON.stringify(t)}`);
      }
    throw new nt(`Expected a valid url, got ${JSON.stringify(t)}`);
  }
}
const CG = /* @__PURE__ */ new Set(["http:", "https:", "mailto:"]), Li = Ne.check((t) => {
  if (t === "") return;
  const e = Zx(t);
  if (!CG.has(e.protocol.toLowerCase()))
    throw new nt(
      `Expected a valid url, got ${JSON.stringify(t)} (invalid protocol)`
    );
}), zG = /* @__PURE__ */ new Set(["http:", "https:", "data:", "asset:"]), Oo = Ne.check((t) => {
  if (t === "") return;
  const e = Zx(t);
  if (!zG.has(e.protocol.toLowerCase()))
    throw new nt(
      `Expected a valid url, got ${JSON.stringify(t)} (invalid protocol)`
    );
});
Ne.check((t) => {
  if (t === "") return;
  if (!Zx(t).protocol.toLowerCase().match(/^https?:$/))
    throw new nt(
      `Expected a valid url, got ${JSON.stringify(t)} (invalid protocol)`
    );
});
const Va = Ne.refine((t) => {
  try {
    return VU(t), t;
  } catch {
    throw new nt(`Expected an index key, got ${JSON.stringify(t)}`);
  }
});
so(
  "@tldraw/validate",
  "3.4.1",
  "esm"
);
function Ei(t) {
  return Ne.refine((e) => {
    if (!e.startsWith(`${t}:`))
      throw new Error(`${t} ID must start with "${t}:"`);
    return e;
  });
}
const Np = Ei("asset");
function Fx(t, e) {
  return Xe({
    id: Np,
    typeName: zn("asset"),
    type: zn(t),
    props: e,
    meta: fn
  });
}
const Po = Xe({
  x: we,
  y: we,
  z: we.optional()
}), Ll = Xe({
  x: we,
  y: we,
  w: we,
  h: we
}), Eb = we.check((t) => {
  if (t < 0 || t > 1)
    throw new nt("Opacity must be between 0 and 1");
}), LG = Ne.refine((t) => {
  if (!t.startsWith("page:") && !t.startsWith("shape:"))
    throw new Error('Parent ID must start with "page:" or "shape:"');
  return t;
}), Bi = Ei("shape");
function kG(t, e, n) {
  return Xe({
    id: Bi,
    typeName: zn("shape"),
    x: we,
    y: we,
    rotation: we,
    index: Va,
    parentId: LG,
    type: zn(t),
    isLocked: qe,
    opacity: Eb,
    props: e ? Xe(e) : fn,
    meta: n ? Xe(n) : fn
  });
}
const OG = Ei("binding");
function PG(t, e, n) {
  return Xe({
    id: OG,
    typeName: zn("binding"),
    type: zn(t),
    fromId: Bi,
    toId: Bi,
    props: e ? Xe(e) : fn,
    meta: n ? Xe(n) : fn
  });
}
xi("com.tldraw.binding", {});
Ri({
  sequenceId: "com.tldraw.binding",
  recordType: "binding",
  sequence: []
});
function Ks(t) {
  return `binding:${ht()}`;
}
function UG(t) {
  return Gr("binding", {
    scope: "document",
    validator: Wr(
      "binding",
      Qx(
        "type",
        ld(
          t,
          (e, { props: n, meta: i }) => PG(e, n, i)
        )
      )
    )
  }).withDefaultProperties(() => ({
    meta: {}
  }));
}
class In {
  /** @internal */
  constructor(e, n, i) {
    this.id = e, this.defaultValue = n, this.type = i;
  }
  /**
   * Define a new {@link StyleProp}.
   *
   * @param uniqueId - Each StyleProp must have a unique ID. We recommend you prefix this with
   * your app/library name.
   * @param options -
   * - `defaultValue`: The default value for this style prop.
   *
   * - `type`: Optionally, describe what type of data you expect for this style prop.
   *
   * @example
   * ```ts
   * import {T} from '@tldraw/validate'
   * import {StyleProp} from '@tldraw/tlschema'
   *
   * const MyLineWidthProp = StyleProp.define('myApp:lineWidth', {
   *   defaultValue: 1,
   *   type: T.number,
   * })
   * ```
   * @public
   */
  static define(e, n) {
    const { defaultValue: i, type: r = TG } = n;
    return new In(e, i, r);
  }
  /**
   * Define a new {@link StyleProp} as a list of possible values.
   *
   * @param uniqueId - Each StyleProp must have a unique ID. We recommend you prefix this with
   * your app/library name.
   * @param options -
   * - `defaultValue`: The default value for this style prop.
   *
   * - `values`: An array of possible values of this style prop.
   *
   * @example
   * ```ts
   * import {StyleProp} from '@tldraw/tlschema'
   *
   * const MySizeProp = StyleProp.defineEnum('myApp:size', {
   *   defaultValue: 'medium',
   *   values: ['small', 'medium', 'large'],
   * })
   * ```
   */
  static defineEnum(e, n) {
    const { defaultValue: i, values: r } = n;
    return new RG(e, i, r);
  }
  setDefaultValue(e) {
    this.defaultValue = e;
  }
  validate(e) {
    return this.type.validate(e);
  }
  validateUsingKnownGoodVersion(e, n) {
    return this.type.validateUsingKnownGoodVersion ? this.type.validateUsingKnownGoodVersion(e, n) : this.validate(n);
  }
}
class RG extends In {
  /** @internal */
  constructor(e, n, i) {
    super(e, n, wp(...i)), this.values = i;
  }
}
const Iu = xi("com.tldraw.shape", {
  AddIsLocked: 1,
  HoistOpacity: 2,
  AddMeta: 3,
  AddWhite: 4
}), YG = Ri({
  sequenceId: "com.tldraw.shape",
  recordType: "shape",
  sequence: [
    {
      id: Iu.AddIsLocked,
      up: (t) => {
        t.isLocked = !1;
      },
      down: (t) => {
        delete t.isLocked;
      }
    },
    {
      id: Iu.HoistOpacity,
      up: (t) => {
        t.opacity = Number(t.props.opacity ?? "1"), delete t.props.opacity;
      },
      down: (t) => {
        const e = t.opacity;
        delete t.opacity, t.props.opacity = e < 0.175 ? "0.1" : e < 0.375 ? "0.25" : e < 0.625 ? "0.5" : e < 0.875 ? "0.75" : "1";
      }
    },
    {
      id: Iu.AddMeta,
      up: (t) => {
        t.meta = {};
      }
    },
    {
      id: Iu.AddWhite,
      up: (t) => {
      },
      down: (t) => {
        t.props.color === "white" && (t.props.color = "black");
      }
    }
  ]
});
function Ta(t) {
  return t ? t.typeName === "shape" : !1;
}
function si(t) {
  return t ? t.startsWith("shape:") : !1;
}
function Ee(t) {
  return `shape:${t ?? ht()}`;
}
function Cb(t) {
  const e = /* @__PURE__ */ new Map();
  for (const [n, i] of Object.entries(t))
    if (i instanceof In) {
      if (e.has(i))
        throw new Error(
          `Duplicate style prop ${i.id}. Each style prop can only be used once within a shape.`
        );
      e.set(i, n);
    }
  return e;
}
function Sr(t, e) {
  return ld(e, (n, i) => `com.tldraw.shape.${t}/${i}`);
}
function QG(t) {
  return Gr("shape", {
    scope: "document",
    validator: Wr(
      "shape",
      Qx(
        "type",
        ld(
          t,
          (e, { props: n, meta: i }) => kG(e, n, i)
        )
      )
    )
  }).withDefaultProperties(() => ({
    x: 0,
    y: 0,
    rotation: 0,
    isLocked: !1,
    opacity: 1,
    meta: {}
  }));
}
function x0(t, e) {
  const n = [];
  for (const [i, { migrations: r }] of Object.entries(e)) {
    const s = `com.tldraw.${t}.${i}`;
    r ? "sequenceId" in r ? (ct(
      s === r.sequenceId,
      `sequenceId mismatch for ${i} ${Sp} migrations. Expected '${s}', got '${r.sequenceId}'`
    ), n.push(r)) : "sequence" in r ? n.push(
      Oa({
        sequenceId: s,
        retroactive: !1,
        sequence: r.sequence.map(
          (o) => "id" in o ? zb(t, i, o) : o
        )
      })
    ) : n.push(
      Oa({
        sequenceId: s,
        retroactive: !1,
        sequence: Object.keys(r.migrators).map((o) => Number(o)).sort((o, a) => o - a).map(
          (o) => ({
            id: `${s}/${o}`,
            scope: "record",
            filter: (a) => a.typeName === t && a.type === i,
            up: (a) => {
              const c = r.migrators[o].up(a);
              if (c)
                return c;
            },
            down: (a) => {
              const c = r.migrators[o].down(a);
              if (c)
                return c;
            }
          })
        )
      })
    ) : n.push(
      Oa({
        sequenceId: s,
        retroactive: !1,
        sequence: []
      })
    );
  }
  return n;
}
function zb(t, e, n) {
  return {
    id: n.id,
    dependsOn: n.dependsOn,
    scope: "record",
    filter: (i) => i.typeName === t && i.type === e,
    up: (i) => {
      const r = n.up(i.props);
      r && (i.props = r);
    },
    down: typeof n.down == "function" ? (i) => {
      const r = n.down(i.props);
      r && (i.props = r);
    } : void 0
  };
}
const Lb = [
  "black",
  "grey",
  "light-violet",
  "violet",
  "blue",
  "light-blue",
  "yellow",
  "orange",
  "green",
  "light-green",
  "light-red",
  "red",
  "white"
], Tg = {
  lightMode: {
    id: "light",
    text: "#000000",
    background: "rgb(249, 250, 251)",
    solid: "#fcfffe",
    black: {
      solid: "#1d1d1d",
      fill: "#1d1d1d",
      note: {
        fill: "#FCE19C",
        text: "#000000"
      },
      semi: "#e8e8e8",
      pattern: "#494949",
      highlight: {
        srgb: "#fddd00",
        p3: "color(display-p3 0.972 0.8705 0.05)"
      }
    },
    blue: {
      solid: "#4465e9",
      fill: "#4465e9",
      note: {
        fill: "#8AA3FF",
        text: "#000000"
      },
      semi: "#dce1f8",
      pattern: "#6681ee",
      highlight: {
        srgb: "#10acff",
        p3: "color(display-p3 0.308 0.6632 0.9996)"
      }
    },
    green: {
      solid: "#099268",
      fill: "#099268",
      note: {
        fill: "#6FC896",
        text: "#000000"
      },
      semi: "#d3e9e3",
      pattern: "#39a785",
      highlight: {
        srgb: "#00ffc8",
        p3: "color(display-p3 0.2536 0.984 0.7981)"
      }
    },
    grey: {
      solid: "#9fa8b2",
      fill: "#9fa8b2",
      note: {
        fill: "#C0CAD3",
        text: "#000000"
      },
      semi: "#eceef0",
      pattern: "#bcc3c9",
      highlight: {
        srgb: "#cbe7f1",
        p3: "color(display-p3 0.8163 0.9023 0.9416)"
      }
    },
    "light-blue": {
      solid: "#4ba1f1",
      fill: "#4ba1f1",
      note: {
        fill: "#9BC4FD",
        text: "#000000"
      },
      semi: "#ddedfa",
      pattern: "#6fbbf8",
      highlight: {
        srgb: "#00f4ff",
        p3: "color(display-p3 0.1512 0.9414 0.9996)"
      }
    },
    "light-green": {
      solid: "#4cb05e",
      fill: "#4cb05e",
      note: {
        fill: "#98D08A",
        text: "#000000"
      },
      semi: "#dbf0e0",
      pattern: "#65cb78",
      highlight: {
        srgb: "#65f641",
        p3: "color(display-p3 0.563 0.9495 0.3857)"
      }
    },
    "light-red": {
      solid: "#f87777",
      fill: "#f87777",
      note: {
        fill: "#F7A5A1",
        text: "#000000"
      },
      semi: "#f4dadb",
      pattern: "#fe9e9e",
      highlight: {
        srgb: "#ff7fa3",
        p3: "color(display-p3 0.9988 0.5301 0.6397)"
      }
    },
    "light-violet": {
      solid: "#e085f4",
      fill: "#e085f4",
      note: {
        fill: "#DFB0F9",
        text: "#000000"
      },
      semi: "#f5eafa",
      pattern: "#e9acf8",
      highlight: {
        srgb: "#ff88ff",
        p3: "color(display-p3 0.9676 0.5652 0.9999)"
      }
    },
    orange: {
      solid: "#e16919",
      fill: "#e16919",
      note: {
        fill: "#FAA475",
        text: "#000000"
      },
      semi: "#f8e2d4",
      pattern: "#f78438",
      highlight: {
        srgb: "#ffa500",
        p3: "color(display-p3 0.9988 0.6905 0.266)"
      }
    },
    red: {
      solid: "#e03131",
      fill: "#e03131",
      note: {
        fill: "#FC8282",
        text: "#000000"
      },
      semi: "#f4dadb",
      pattern: "#e55959",
      highlight: {
        srgb: "#ff636e",
        p3: "color(display-p3 0.9992 0.4376 0.45)"
      }
    },
    violet: {
      solid: "#ae3ec9",
      fill: "#ae3ec9",
      note: {
        fill: "#DB91FD",
        text: "#000000"
      },
      semi: "#ecdcf2",
      pattern: "#bd63d3",
      highlight: {
        srgb: "#c77cff",
        p3: "color(display-p3 0.7469 0.5089 0.9995)"
      }
    },
    yellow: {
      solid: "#f1ac4b",
      fill: "#f1ac4b",
      note: {
        fill: "#FED49A",
        text: "#000000"
      },
      semi: "#f9f0e6",
      pattern: "#fecb92",
      highlight: {
        srgb: "#fddd00",
        p3: "color(display-p3 0.972 0.8705 0.05)"
      }
    },
    white: {
      solid: "#FFFFFF",
      fill: "#FFFFFF",
      semi: "#f5f5f5",
      pattern: "#f9f9f9",
      note: {
        fill: "#FFFFFF",
        text: "#000000"
      },
      highlight: {
        srgb: "#ffffff",
        p3: "color(display-p3 1 1 1)"
      }
    }
  },
  darkMode: {
    id: "dark",
    text: "hsl(210, 17%, 98%)",
    background: "hsl(240, 5%, 6.5%)",
    solid: "#010403",
    black: {
      solid: "#f2f2f2",
      fill: "#f2f2f2",
      note: {
        fill: "#2c2c2c",
        text: "#f2f2f2"
      },
      semi: "#2c3036",
      pattern: "#989898",
      highlight: {
        srgb: "#d2b700",
        p3: "color(display-p3 0.8078 0.7225 0.0312)"
      }
    },
    blue: {
      solid: "#4f72fc",
      // 3c60f0
      fill: "#4f72fc",
      note: {
        fill: "#2A3F98",
        text: "#f2f2f2"
      },
      semi: "#262d40",
      pattern: "#3a4b9e",
      highlight: {
        srgb: "#0079d2",
        p3: "color(display-p3 0.0032 0.4655 0.7991)"
      }
    },
    green: {
      solid: "#099268",
      fill: "#099268",
      note: {
        fill: "#014429",
        text: "#f2f2f2"
      },
      semi: "#253231",
      pattern: "#366a53",
      highlight: {
        srgb: "#009774",
        p3: "color(display-p3 0.0085 0.582 0.4604)"
      }
    },
    grey: {
      solid: "#9398b0",
      fill: "#9398b0",
      note: {
        fill: "#56595F",
        text: "#f2f2f2"
      },
      semi: "#33373c",
      pattern: "#7c8187",
      highlight: {
        srgb: "#9cb4cb",
        p3: "color(display-p3 0.6299 0.7012 0.7856)"
      }
    },
    "light-blue": {
      solid: "#4dabf7",
      fill: "#4dabf7",
      note: {
        fill: "#1F5495",
        text: "#f2f2f2"
      },
      semi: "#2a3642",
      pattern: "#4d7aa9",
      highlight: {
        srgb: "#00bdc8",
        p3: "color(display-p3 0.0023 0.7259 0.7735)"
      }
    },
    "light-green": {
      solid: "#40c057",
      fill: "#40c057",
      note: {
        fill: "#21581D",
        text: "#f2f2f2"
      },
      semi: "#2a3830",
      pattern: "#4e874e",
      highlight: {
        srgb: "#00a000",
        p3: "color(display-p3 0.2711 0.6172 0.0195)"
      }
    },
    "light-red": {
      solid: "#ff8787",
      fill: "#ff8787",
      note: {
        fill: "#923632",
        text: "#f2f2f2"
      },
      semi: "#3b3235",
      pattern: "#a56767",
      highlight: {
        srgb: "#db005b",
        p3: "color(display-p3 0.7849 0.0585 0.3589)"
      }
    },
    "light-violet": {
      solid: "#e599f7",
      fill: "#e599f7",
      note: {
        fill: "#762F8E",
        text: "#f2f2f2"
      },
      semi: "#383442",
      pattern: "#9770a9",
      highlight: {
        srgb: "#c400c7",
        p3: "color(display-p3 0.7024 0.0403 0.753)"
      }
    },
    orange: {
      solid: "#f76707",
      fill: "#f76707",
      note: {
        fill: "#843906",
        text: "#f2f2f2"
      },
      semi: "#3a2e2a",
      pattern: "#9f552d",
      highlight: {
        srgb: "#d07a00",
        p3: "color(display-p3 0.7699 0.4937 0.0085)"
      }
    },
    red: {
      solid: "#e03131",
      fill: "#e03131",
      note: {
        fill: "#89231A",
        text: "#f2f2f2"
      },
      semi: "#36292b",
      pattern: "#8f3734",
      highlight: {
        srgb: "#de002c",
        p3: "color(display-p3 0.7978 0.0509 0.2035)"
      }
    },
    violet: {
      solid: "#ae3ec9",
      fill: "#ae3ec9",
      note: {
        fill: "#681683",
        text: "#f2f2f2"
      },
      semi: "#31293c",
      pattern: "#763a8b",
      highlight: {
        srgb: "#9e00ee",
        p3: "color(display-p3 0.5651 0.0079 0.8986)"
      }
    },
    yellow: {
      solid: "#ffc034",
      fill: "#ffc034",
      note: {
        fill: "#98571B",
        text: "#f2f2f2"
      },
      semi: "#3c3934",
      pattern: "#fecb92",
      highlight: {
        srgb: "#d2b700",
        p3: "color(display-p3 0.8078 0.7225 0.0312)"
      }
    },
    white: {
      solid: "#f3f3f3",
      fill: "#f3f3f3",
      semi: "#f5f5f5",
      pattern: "#f9f9f9",
      note: {
        fill: "#eaeaea",
        text: "#1d1d1d"
      },
      highlight: {
        srgb: "#ffffff",
        p3: "color(display-p3 1 1 1)"
      }
    }
  }
};
function Hr(t) {
  return t.isDarkMode ? Tg.darkMode : Tg.lightMode;
}
const Ln = In.defineEnum("tldraw:color", {
  defaultValue: "black",
  values: Lb
}), Bx = In.defineEnum("tldraw:labelColor", {
  defaultValue: "black",
  values: Lb
}), Ms = In.defineEnum("tldraw:dash", {
  defaultValue: "draw",
  values: ["draw", "solid", "dashed", "dotted"]
}), ms = In.defineEnum("tldraw:fill", {
  defaultValue: "none",
  values: ["none", "semi", "solid", "pattern", "fill"]
}), ki = In.defineEnum("tldraw:font", {
  defaultValue: "draw",
  values: ["draw", "sans", "serif", "mono"]
}), kb = {
  draw: "'tldraw_draw', sans-serif",
  sans: "'tldraw_sans', sans-serif",
  serif: "'tldraw_serif', serif",
  mono: "'tldraw_mono', monospace"
}, Oi = In.defineEnum("tldraw:size", {
  defaultValue: "m",
  values: ["s", "m", "l", "xl"]
}), Ob = [
  "arrow",
  "triangle",
  "square",
  "dot",
  "pipe",
  "diamond",
  "inverted",
  "bar",
  "none"
], Uo = In.defineEnum("tldraw:arrowheadStart", {
  defaultValue: "none",
  values: Ob
}), $s = In.defineEnum("tldraw:arrowheadEnd", {
  defaultValue: "arrow",
  values: Ob
}), Pb = {
  labelColor: Bx,
  color: Ln,
  fill: ms,
  dash: Ms,
  size: Oi,
  arrowheadStart: Uo,
  arrowheadEnd: $s,
  font: ki,
  start: Po,
  end: Po,
  bend: we,
  text: Ne,
  labelPosition: we,
  scale: Ht
}, Ia = Sr("arrow", {
  AddLabelColor: 1,
  AddIsPrecise: 2,
  AddLabelPosition: 3,
  ExtractBindings: 4,
  AddScale: 5
});
function xu(t) {
  return zb("shape", "arrow", t);
}
const Ub = Oa({
  sequenceId: "com.tldraw.shape.arrow",
  retroactive: !1,
  sequence: [
    xu({
      id: Ia.AddLabelColor,
      up: (t) => {
        t.labelColor = "black";
      },
      down: "retired"
    }),
    xu({
      id: Ia.AddIsPrecise,
      up: ({ start: t, end: e }) => {
        t.type === "binding" && (t.isPrecise = !(t.normalizedAnchor.x === 0.5 && t.normalizedAnchor.y === 0.5)), e.type === "binding" && (e.isPrecise = !(e.normalizedAnchor.x === 0.5 && e.normalizedAnchor.y === 0.5));
      },
      down: ({ start: t, end: e }) => {
        t.type === "binding" && (t.isPrecise || (t.normalizedAnchor = { x: 0.5, y: 0.5 }), delete t.isPrecise), e.type === "binding" && (e.isPrecise || (e.normalizedAnchor = { x: 0.5, y: 0.5 }), delete e.isPrecise);
      }
    }),
    xu({
      id: Ia.AddLabelPosition,
      up: (t) => {
        t.labelPosition = 0.5;
      },
      down: (t) => {
        delete t.labelPosition;
      }
    }),
    {
      id: Ia.ExtractBindings,
      scope: "store",
      up: (t) => {
        const e = Object.values(t).filter(
          (n) => n.typeName === "shape" && n.type === "arrow"
        );
        for (const n of e) {
          const { start: i, end: r } = n.props;
          if (i.type === "binding") {
            const s = Ks(), o = {
              typeName: "binding",
              id: s,
              type: "arrow",
              fromId: n.id,
              toId: i.boundShapeId,
              meta: {},
              props: {
                terminal: "start",
                normalizedAnchor: i.normalizedAnchor,
                isExact: i.isExact,
                isPrecise: i.isPrecise
              }
            };
            t[s] = o, n.props.start = { x: 0, y: 0 };
          } else
            delete n.props.start.type;
          if (r.type === "binding") {
            const s = Ks(), o = {
              typeName: "binding",
              id: s,
              type: "arrow",
              fromId: n.id,
              toId: r.boundShapeId,
              meta: {},
              props: {
                terminal: "end",
                normalizedAnchor: r.normalizedAnchor,
                isExact: r.isExact,
                isPrecise: r.isPrecise
              }
            };
            t[s] = o, n.props.end = { x: 0, y: 0 };
          } else
            delete n.props.end.type;
        }
      }
    },
    xu({
      id: Ia.AddScale,
      up: (t) => {
        t.scale = 1;
      },
      down: (t) => {
        delete t.scale;
      }
    })
  ]
}), Rb = {
  terminal: wp("start", "end"),
  normalizedAnchor: Po,
  isExact: qe,
  isPrecise: qe
}, Yb = {
  sequence: [{ dependsOn: [Ia.ExtractBindings] }]
}, ZG = Wr(
  "camera",
  Xe({
    typeName: zn("camera"),
    id: Ei("camera"),
    x: we,
    y: we,
    z: we,
    meta: fn
  })
), FG = xi("com.tldraw.camera", {
  AddMeta: 1
}), BG = Ri({
  sequenceId: "com.tldraw.camera",
  recordType: "camera",
  sequence: [
    {
      id: FG.AddMeta,
      up: (t) => {
        t.meta = {};
      }
    }
  ]
}), kr = Gr("camera", {
  validator: ZG,
  scope: "session"
}).withDefaultProperties(
  () => ({
    x: 0,
    y: 0,
    z: 1,
    meta: {}
  })
), GG = /* @__PURE__ */ new Set([
  "none",
  "default",
  "pointer",
  "cross",
  "grab",
  "rotate",
  "grabbing",
  "resize-edge",
  "resize-corner",
  "text",
  "move",
  "ew-resize",
  "ns-resize",
  "nesw-resize",
  "nwse-resize",
  "nesw-rotate",
  "nwse-rotate",
  "swne-rotate",
  "senw-rotate",
  "zoom-in",
  "zoom-out"
]), Qb = Dp(GG), WG = Xe({
  type: Qb,
  rotation: we
}), HG = /* @__PURE__ */ new Set([
  "accent",
  "white",
  "black",
  "selection-stroke",
  "selection-fill",
  "laser",
  "muted-1"
]), VG = Dp(HG), KG = /* @__PURE__ */ new Set(["starting", "paused", "active", "stopping"]), Zb = Xe({
  id: Ne,
  points: sn(Po),
  size: Ag,
  color: VG,
  opacity: we,
  state: Dp(KG),
  delay: we,
  shrink: we,
  taper: qe
}), Kl = Ei("page"), XG = Wr(
  "page",
  Xe({
    typeName: zn("page"),
    id: Kl,
    name: Ne,
    index: Va,
    meta: fn
  })
), JG = xi("com.tldraw.page", {
  AddMeta: 1
}), qG = Ri({
  sequenceId: "com.tldraw.page",
  recordType: "page",
  sequence: [
    {
      id: JG.AddMeta,
      up: (t) => {
        t.meta = {};
      }
    }
  ]
}), kn = Gr("page", {
  validator: XG,
  scope: "document"
}).withDefaultProperties(() => ({
  meta: {}
}));
function ni(t) {
  return kn.isId(t);
}
const _G = {
  // This object defines keys that should be preserved across calls to loadSnapshot()
  id: !1,
  // meta
  typeName: !1,
  // meta
  currentPageId: !1,
  // does not preserve because who knows if the page still exists
  opacityForNextShape: !1,
  // does not preserve because it's a temporary state
  stylesForNextShape: !1,
  // does not preserve because it's a temporary state
  followingUserId: !1,
  // does not preserve because it's a temporary state
  highlightedUserIds: !1,
  // does not preserve because it's a temporary state
  brush: !1,
  // does not preserve because it's a temporary state
  cursor: !1,
  // does not preserve because it's a temporary state
  scribbles: !1,
  // does not preserve because it's a temporary state
  isFocusMode: !0,
  // preserves because it's a user preference
  isDebugMode: !0,
  // preserves because it's a user preference
  isToolLocked: !0,
  // preserves because it's a user preference
  exportBackground: !0,
  // preserves because it's a user preference
  screenBounds: !0,
  // preserves because it's capturing the user's screen state
  insets: !0,
  // preserves because it's capturing the user's screen state
  zoomBrush: !1,
  // does not preserve because it's a temporary state
  chatMessage: !1,
  // does not preserve because it's a temporary state
  isChatting: !1,
  // does not preserve because it's a temporary state
  isPenMode: !1,
  // does not preserve because it's a temporary state
  isGridMode: !0,
  // preserves because it's a user preference
  isFocused: !0,
  // preserves because obviously
  devicePixelRatio: !0,
  // preserves because it captures the user's screen state
  isCoarsePointer: !0,
  // preserves because it captures the user's screen state
  isHoveringCanvas: !1,
  // does not preserve because it's a temporary state
  openMenus: !1,
  // does not preserve because it's a temporary state
  isChangingStyle: !1,
  // does not preserve because it's a temporary state
  isReadonly: !0,
  // preserves because it's a config option
  meta: !1,
  // does not preserve because who knows what's in there, leave it up to sdk users to save and reinstate
  duplicateProps: !1
  //
};
function Fb(t) {
  return t ? Cl(t, (e) => _G[e]) : null;
}
Ei("instance");
function $G(t) {
  const e = {};
  for (const [i, r] of t)
    e[i] = vb(r);
  const n = Wr(
    "instance",
    Xe({
      typeName: zn("instance"),
      id: Ei("instance"),
      currentPageId: Kl,
      followingUserId: Ne.nullable(),
      brush: Ll.nullable(),
      opacityForNextShape: Eb,
      stylesForNextShape: Xe(e),
      cursor: WG,
      scribbles: sn(Zb),
      isFocusMode: qe,
      isDebugMode: qe,
      isToolLocked: qe,
      exportBackground: qe,
      screenBounds: Ll,
      insets: sn(qe),
      zoomBrush: Ll.nullable(),
      isPenMode: qe,
      isGridMode: qe,
      chatMessage: Ne,
      isChatting: qe,
      highlightedUserIds: sn(Ne),
      isFocused: qe,
      devicePixelRatio: we,
      isCoarsePointer: qe,
      isHoveringCanvas: qe.nullable(),
      openMenus: sn(Ne),
      isChangingStyle: qe,
      isReadonly: qe,
      meta: fn,
      duplicateProps: Xe({
        shapeIds: sn(Ei("shape")),
        offset: Xe({
          x: we,
          y: we
        })
      }).nullable()
    })
  );
  return Gr("instance", {
    validator: n,
    scope: "session",
    ephemeralKeys: {
      currentPageId: !1,
      meta: !1,
      followingUserId: !0,
      opacityForNextShape: !0,
      stylesForNextShape: !0,
      brush: !0,
      cursor: !0,
      scribbles: !0,
      isFocusMode: !0,
      isDebugMode: !0,
      isToolLocked: !0,
      exportBackground: !0,
      screenBounds: !0,
      insets: !0,
      zoomBrush: !0,
      isPenMode: !0,
      isGridMode: !0,
      chatMessage: !0,
      isChatting: !0,
      highlightedUserIds: !0,
      isFocused: !0,
      devicePixelRatio: !0,
      isCoarsePointer: !0,
      isHoveringCanvas: !0,
      openMenus: !0,
      isChangingStyle: !0,
      isReadonly: !0,
      duplicateProps: !0
    }
  }).withDefaultProperties(
    () => ({
      followingUserId: null,
      opacityForNextShape: 1,
      stylesForNextShape: {},
      brush: null,
      scribbles: [],
      cursor: {
        type: "default",
        rotation: 0
      },
      isFocusMode: !1,
      exportBackground: !1,
      isDebugMode: !1,
      isToolLocked: !1,
      screenBounds: { x: 0, y: 0, w: 1080, h: 720 },
      insets: [!1, !1, !1, !1],
      zoomBrush: null,
      isGridMode: !1,
      isPenMode: !1,
      chatMessage: "",
      isChatting: !1,
      highlightedUserIds: [],
      isFocused: !1,
      devicePixelRatio: typeof window > "u" ? 1 : window.devicePixelRatio,
      isCoarsePointer: !1,
      isHoveringCanvas: null,
      openMenus: [],
      isChangingStyle: !1,
      isReadonly: !1,
      meta: {},
      duplicateProps: null
    })
  );
}
const bt = xi("com.tldraw.instance", {
  AddTransparentExportBgs: 1,
  RemoveDialog: 2,
  AddToolLockMode: 3,
  RemoveExtraPropsForNextShape: 4,
  AddLabelColor: 5,
  AddFollowingUserId: 6,
  RemoveAlignJustify: 7,
  AddZoom: 8,
  AddVerticalAlign: 9,
  AddScribbleDelay: 10,
  RemoveUserId: 11,
  AddIsPenModeAndIsGridMode: 12,
  HoistOpacity: 13,
  AddChat: 14,
  AddHighlightedUserIds: 15,
  ReplacePropsForNextShapeWithStylesForNextShape: 16,
  AddMeta: 17,
  RemoveCursorColor: 18,
  AddLonelyProperties: 19,
  ReadOnlyReadonly: 20,
  AddHoveringCanvas: 21,
  AddScribbles: 22,
  AddInset: 23,
  AddDuplicateProps: 24,
  RemoveCanMoveCamera: 25
}), eW = Ri({
  sequenceId: "com.tldraw.instance",
  recordType: "instance",
  sequence: [
    {
      id: bt.AddTransparentExportBgs,
      up: (t) => ({ ...t, exportBackground: !0 })
    },
    {
      id: bt.RemoveDialog,
      up: ({ dialog: t, ...e }) => e
    },
    {
      id: bt.AddToolLockMode,
      up: (t) => ({ ...t, isToolLocked: !1 })
    },
    {
      id: bt.RemoveExtraPropsForNextShape,
      up: ({ propsForNextShape: t, ...e }) => ({
        ...e,
        propsForNextShape: Object.fromEntries(
          Object.entries(t).filter(
            ([n]) => [
              "color",
              "labelColor",
              "dash",
              "fill",
              "size",
              "font",
              "align",
              "verticalAlign",
              "icon",
              "geo",
              "arrowheadStart",
              "arrowheadEnd",
              "spline"
            ].includes(n)
          )
        )
      })
    },
    {
      id: bt.AddLabelColor,
      up: ({ propsForNextShape: t, ...e }) => ({
        ...e,
        propsForNextShape: {
          ...t,
          labelColor: "black"
        }
      })
    },
    {
      id: bt.AddFollowingUserId,
      up: (t) => ({ ...t, followingUserId: null })
    },
    {
      id: bt.RemoveAlignJustify,
      up: (t) => {
        let e = t.propsForNextShape.align;
        return e === "justify" && (e = "start"), {
          ...t,
          propsForNextShape: {
            ...t.propsForNextShape,
            align: e
          }
        };
      }
    },
    {
      id: bt.AddZoom,
      up: (t) => ({ ...t, zoomBrush: null })
    },
    {
      id: bt.AddVerticalAlign,
      up: (t) => ({
        ...t,
        propsForNextShape: {
          ...t.propsForNextShape,
          verticalAlign: "middle"
        }
      })
    },
    {
      id: bt.AddScribbleDelay,
      up: (t) => t.scribble !== null ? { ...t, scribble: { ...t.scribble, delay: 0 } } : { ...t }
    },
    {
      id: bt.RemoveUserId,
      up: ({ userId: t, ...e }) => e
    },
    {
      id: bt.AddIsPenModeAndIsGridMode,
      up: (t) => ({ ...t, isPenMode: !1, isGridMode: !1 })
    },
    {
      id: bt.HoistOpacity,
      up: ({ propsForNextShape: { opacity: t, ...e }, ...n }) => ({ ...n, opacityForNextShape: Number(t ?? "1"), propsForNextShape: e })
    },
    {
      id: bt.AddChat,
      up: (t) => ({ ...t, chatMessage: "", isChatting: !1 })
    },
    {
      id: bt.AddHighlightedUserIds,
      up: (t) => ({ ...t, highlightedUserIds: [] })
    },
    {
      id: bt.ReplacePropsForNextShapeWithStylesForNextShape,
      up: ({ propsForNextShape: t, ...e }) => ({ ...e, stylesForNextShape: {} })
    },
    {
      id: bt.AddMeta,
      up: (t) => ({
        ...t,
        meta: {}
      })
    },
    {
      id: bt.RemoveCursorColor,
      up: (t) => {
        const { color: e, ...n } = t.cursor;
        return {
          ...t,
          cursor: n
        };
      }
    },
    {
      id: bt.AddLonelyProperties,
      up: (t) => ({
        ...t,
        canMoveCamera: !0,
        isFocused: !1,
        devicePixelRatio: 1,
        isCoarsePointer: !1,
        openMenus: [],
        isChangingStyle: !1,
        isReadOnly: !1
      })
    },
    {
      id: bt.ReadOnlyReadonly,
      up: ({ isReadOnly: t, ...e }) => ({
        ...e,
        isReadonly: t
      })
    },
    {
      id: bt.AddHoveringCanvas,
      up: (t) => ({
        ...t,
        isHoveringCanvas: null
      })
    },
    {
      id: bt.AddScribbles,
      up: ({ scribble: t, ...e }) => ({
        ...e,
        scribbles: []
      })
    },
    {
      id: bt.AddInset,
      up: (t) => ({
        ...t,
        insets: [!1, !1, !1, !1]
      }),
      down: ({ insets: t, ...e }) => ({
        ...e
      })
    },
    {
      id: bt.AddDuplicateProps,
      up: (t) => ({
        ...t,
        duplicateProps: null
      }),
      down: ({ duplicateProps: t, ...e }) => ({
        ...e
      })
    },
    {
      id: bt.RemoveCanMoveCamera,
      up: ({ canMoveCamera: t, ...e }) => ({
        ...e
      }),
      down: (t) => ({ ...t, canMoveCamera: !0 })
    }
  ]
}), Qn = "instance:instance", tW = Wr(
  "instance_page_state",
  Xe({
    typeName: zn("instance_page_state"),
    id: Ei("instance_page_state"),
    pageId: Kl,
    selectedShapeIds: sn(Bi),
    hintingShapeIds: sn(Bi),
    erasingShapeIds: sn(Bi),
    hoveredShapeId: Bi.nullable(),
    editingShapeId: Bi.nullable(),
    croppingShapeId: Bi.nullable(),
    focusedGroupId: Bi.nullable(),
    meta: fn
  })
), tl = xi("com.tldraw.instance_page_state", {
  AddCroppingId: 1,
  RemoveInstanceIdAndCameraId: 2,
  AddMeta: 3,
  RenameProperties: 4,
  RenamePropertiesAgain: 5
}), nW = Ri({
  sequenceId: "com.tldraw.instance_page_state",
  recordType: "instance_page_state",
  sequence: [
    {
      id: tl.AddCroppingId,
      up(t) {
        t.croppingShapeId = null;
      }
    },
    {
      id: tl.RemoveInstanceIdAndCameraId,
      up(t) {
        delete t.instanceId, delete t.cameraId;
      }
    },
    {
      id: tl.AddMeta,
      up: (t) => {
        t.meta = {};
      }
    },
    {
      id: tl.RenameProperties,
      // this migration is cursed: it was written wrong and doesn't do anything.
      // rather than replace it, I've added another migration below that fixes it.
      up: (t) => {
      },
      down: (t) => {
      }
    },
    {
      id: tl.RenamePropertiesAgain,
      up: (t) => {
        t.selectedShapeIds = t.selectedIds, delete t.selectedIds, t.hintingShapeIds = t.hintingIds, delete t.hintingIds, t.erasingShapeIds = t.erasingIds, delete t.erasingIds, t.hoveredShapeId = t.hoveredId, delete t.hoveredId, t.editingShapeId = t.editingId, delete t.editingId, t.croppingShapeId = t.croppingShapeId ?? t.croppingId ?? null, delete t.croppingId, t.focusedGroupId = t.focusLayerId, delete t.focusLayerId;
      },
      down: (t) => {
        t.selectedIds = t.selectedShapeIds, delete t.selectedShapeIds, t.hintingIds = t.hintingShapeIds, delete t.hintingShapeIds, t.erasingIds = t.erasingShapeIds, delete t.erasingShapeIds, t.hoveredId = t.hoveredShapeId, delete t.hoveredShapeId, t.editingId = t.editingShapeId, delete t.editingShapeId, t.croppingId = t.croppingShapeId, delete t.croppingShapeId, t.focusLayerId = t.focusedGroupId, delete t.focusedGroupId;
      }
    }
  ]
}), ar = Gr(
  "instance_page_state",
  {
    validator: tW,
    scope: "session",
    ephemeralKeys: {
      pageId: !1,
      selectedShapeIds: !1,
      editingShapeId: !1,
      croppingShapeId: !1,
      meta: !1,
      hintingShapeIds: !0,
      erasingShapeIds: !0,
      hoveredShapeId: !0,
      focusedGroupId: !0
    }
  }
).withDefaultProperties(
  () => ({
    editingShapeId: null,
    croppingShapeId: null,
    selectedShapeIds: [],
    hoveredShapeId: null,
    erasingShapeIds: [],
    hintingShapeIds: [],
    focusedGroupId: null,
    meta: {}
  })
), iW = Wr(
  "pointer",
  Xe({
    typeName: zn("pointer"),
    id: Ei("pointer"),
    x: we,
    y: we,
    lastActivityTimestamp: we,
    meta: fn
  })
), rW = xi("com.tldraw.pointer", {
  AddMeta: 1
}), sW = Ri({
  sequenceId: "com.tldraw.pointer",
  recordType: "pointer",
  sequence: [
    {
      id: rW.AddMeta,
      up: (t) => {
        t.meta = {};
      }
    }
  ]
}), Gx = Gr("pointer", {
  validator: iW,
  scope: "session"
}).withDefaultProperties(
  () => ({
    x: 0,
    y: 0,
    lastActivityTimestamp: 0,
    meta: {}
  })
), bg = Gx.createId("pointer"), oW = Wr(
  "instance_presence",
  Xe({
    typeName: zn("instance_presence"),
    id: Ei("instance_presence"),
    userId: Ne,
    userName: Ne,
    lastActivityTimestamp: we,
    followingUserId: Ne.nullable(),
    cursor: Xe({
      x: we,
      y: we,
      type: Qb,
      rotation: we
    }),
    color: Ne,
    camera: Xe({
      x: we,
      y: we,
      z: we
    }),
    screenBounds: Ll,
    selectedShapeIds: sn(Ei("shape")),
    currentPageId: Ei("page"),
    brush: Ll.nullable(),
    scribbles: sn(Zb),
    chatMessage: Ne,
    meta: fn
  })
), nl = xi("com.tldraw.instance_presence", {
  AddScribbleDelay: 1,
  RemoveInstanceId: 2,
  AddChatMessage: 3,
  AddMeta: 4,
  RenameSelectedShapeIds: 5
}), aW = Ri({
  sequenceId: "com.tldraw.instance_presence",
  recordType: "instance_presence",
  sequence: [
    {
      id: nl.AddScribbleDelay,
      up: (t) => {
        t.scribble !== null && (t.scribble.delay = 0);
      }
    },
    {
      id: nl.RemoveInstanceId,
      up: (t) => {
        delete t.instanceId;
      }
    },
    {
      id: nl.AddChatMessage,
      up: (t) => {
        t.chatMessage = "";
      }
    },
    {
      id: nl.AddMeta,
      up: (t) => {
        t.meta = {};
      }
    },
    {
      id: nl.RenameSelectedShapeIds,
      up: (t) => {
      }
    }
  ]
}), cW = Gr(
  "instance_presence",
  {
    validator: oW,
    scope: "presence"
  }
).withDefaultProperties(() => ({
  lastActivityTimestamp: 0,
  followingUserId: null,
  color: "#FF0000",
  camera: {
    x: 0,
    y: 0,
    z: 1
  },
  cursor: {
    x: 0,
    y: 0,
    type: "default",
    rotation: 0
  },
  screenBounds: {
    x: 0,
    y: 0,
    w: 1,
    h: 1
  },
  selectedShapeIds: [],
  brush: null,
  scribbles: [],
  chatMessage: "",
  meta: {}
})), lW = Wr(
  "document",
  Xe({
    typeName: zn("document"),
    id: zn("document:document"),
    gridSize: we,
    name: Ne,
    meta: fn
  })
), S0 = xi("com.tldraw.document", {
  AddName: 1,
  AddMeta: 2
}), dW = Ri({
  sequenceId: "com.tldraw.document",
  recordType: "document",
  sequence: [
    {
      id: S0.AddName,
      up: (t) => {
        t.name = "";
      },
      down: (t) => {
        delete t.name;
      }
    },
    {
      id: S0.AddMeta,
      up: (t) => {
        t.meta = {};
      }
    }
  ]
}), Wx = Gr("document", {
  validator: lW,
  scope: "document"
}).withDefaultProperties(
  () => ({
    gridSize: 10,
    name: "",
    meta: {}
  })
), Qy = Wx.createId("document");
function uW(t, e) {
  return t.index < e.index ? -1 : t.index > e.index ? 1 : 0;
}
function j0(t) {
  t.typeName === "asset" && ("src" in t && (t.src = "<redacted>"), "src" in t.props && (t.props.src = "<redacted>"));
}
function hW({
  error: t,
  phase: e,
  record: n,
  recordBefore: i
}) {
  throw lx(t, {
    tags: {
      origin: "store.validateRecord",
      storePhase: e,
      isExistingValidationIssue: (
        // if we're initializing the store for the first time, we should
        // allow invalid records so people can load old buggy data:
        e === "initialize"
      )
    },
    extras: {
      recordBefore: i ? j0(Ct(i)) : void 0,
      recordAfter: j0(Ct(n))
    }
  }), t;
}
function gW() {
  return [
    kn.create({
      id: "page:page",
      name: "Page 1",
      index: "a1",
      meta: {}
    })
  ];
}
function pW(t) {
  const e = t.query.ids("page"), n = t.query.records("instance_page_state"), i = () => {
    if (!t.has(Qy))
      return t.put([Wx.create({ id: Qy, name: t.props.defaultName })]), i();
    if (!t.has(bg))
      return t.put([Gx.create({ id: bg })]), i();
    const r = e.get();
    if (r.size === 0)
      return t.put(gW()), i();
    const s = () => [...r].map((u) => t.get(u)).sort(uW)[0].id, o = t.get(Qn);
    if (o) {
      if (!r.has(o.currentPageId))
        return t.put([{ ...o, currentPageId: s() }]), i();
    } else return t.put([
      t.schema.types.instance.create({
        id: Qn,
        currentPageId: s(),
        exportBackground: !0
      })
    ]), i();
    const a = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
    for (const u of r) {
      const h = ar.createId(u);
      t.get(h) || a.add(h);
      const p = kr.createId(u);
      t.has(p) || c.add(p);
    }
    a.size > 0 && t.put(
      [...a].map(
        (u) => ar.create({
          id: u,
          pageId: ar.parseId(u)
        })
      )
    ), c.size > 0 && t.put([...c].map((u) => kr.create({ id: u })));
    const d = n.get();
    for (const u of d) {
      if (!r.has(u.pageId)) {
        t.remove([u.id]);
        continue;
      }
      if (u.croppingShapeId && !t.has(u.croppingShapeId))
        return t.put([{ ...u, croppingShapeId: null }]), i();
      if (u.focusedGroupId && !t.has(u.focusedGroupId))
        return t.put([{ ...u, focusedGroupId: null }]), i();
      if (u.hoveredShapeId && !t.has(u.hoveredShapeId))
        return t.put([{ ...u, hoveredShapeId: null }]), i();
      const h = u.selectedShapeIds.filter((f) => t.has(f));
      if (h.length !== u.selectedShapeIds.length)
        return t.put([{ ...u, selectedShapeIds: h }]), i();
      const g = u.hintingShapeIds.filter((f) => t.has(f));
      if (g.length !== u.hintingShapeIds.length)
        return t.put([{ ...u, hintingShapeIds: g }]), i();
      const p = u.erasingShapeIds.filter((f) => t.has(f));
      if (p.length !== u.erasingShapeIds.length)
        return t.put([{ ...u, erasingShapeIds: p }]), i();
    }
  };
  return i;
}
const fW = Fx(
  "bookmark",
  Xe({
    title: Ne,
    description: Ne,
    image: Ne,
    favicon: Ne,
    src: Oo.nullable()
  })
), D0 = xi("com.tldraw.asset.bookmark", {
  MakeUrlsValid: 1,
  AddFavicon: 2
}), MW = Ri({
  sequenceId: "com.tldraw.asset.bookmark",
  recordType: "asset",
  filter: (t) => t.type === "bookmark",
  sequence: [
    {
      id: D0.MakeUrlsValid,
      up: (t) => {
        Oo.isValid(t.props.src) || (t.props.src = "");
      },
      down: (t) => {
      }
    },
    {
      id: D0.AddFavicon,
      up: (t) => {
        Oo.isValid(t.props.favicon) || (t.props.favicon = "");
      },
      down: (t) => {
        delete t.props.favicon;
      }
    }
  ]
}), mW = Fx(
  "image",
  Xe({
    w: we,
    h: we,
    name: Ne,
    isAnimated: qe,
    mimeType: Ne.nullable(),
    src: Oo.nullable(),
    fileSize: Ht.optional()
  })
), il = xi("com.tldraw.asset.image", {
  AddIsAnimated: 1,
  RenameWidthHeight: 2,
  MakeUrlsValid: 3,
  AddFileSize: 4,
  MakeFileSizeOptional: 5
}), yW = Ri({
  sequenceId: "com.tldraw.asset.image",
  recordType: "asset",
  filter: (t) => t.type === "image",
  sequence: [
    {
      id: il.AddIsAnimated,
      up: (t) => {
        t.props.isAnimated = !1;
      },
      down: (t) => {
        delete t.props.isAnimated;
      }
    },
    {
      id: il.RenameWidthHeight,
      up: (t) => {
        t.props.w = t.props.width, t.props.h = t.props.height, delete t.props.width, delete t.props.height;
      },
      down: (t) => {
        t.props.width = t.props.w, t.props.height = t.props.h, delete t.props.w, delete t.props.h;
      }
    },
    {
      id: il.MakeUrlsValid,
      up: (t) => {
        Oo.isValid(t.props.src) || (t.props.src = "");
      },
      down: (t) => {
      }
    },
    {
      id: il.AddFileSize,
      up: (t) => {
        t.props.fileSize = -1;
      },
      down: (t) => {
        delete t.props.fileSize;
      }
    },
    {
      id: il.MakeFileSizeOptional,
      up: (t) => {
        t.props.fileSize === -1 && (t.props.fileSize = void 0);
      },
      down: (t) => {
        t.props.fileSize === void 0 && (t.props.fileSize = -1);
      }
    }
  ]
}), IW = Fx(
  "video",
  Xe({
    w: we,
    h: we,
    name: Ne,
    isAnimated: qe,
    mimeType: Ne.nullable(),
    src: Oo.nullable(),
    fileSize: we.optional()
  })
), rl = xi("com.tldraw.asset.video", {
  AddIsAnimated: 1,
  RenameWidthHeight: 2,
  MakeUrlsValid: 3,
  AddFileSize: 4,
  MakeFileSizeOptional: 5
}), xW = Ri({
  sequenceId: "com.tldraw.asset.video",
  recordType: "asset",
  filter: (t) => t.type === "video",
  sequence: [
    {
      id: rl.AddIsAnimated,
      up: (t) => {
        t.props.isAnimated = !1;
      },
      down: (t) => {
        delete t.props.isAnimated;
      }
    },
    {
      id: rl.RenameWidthHeight,
      up: (t) => {
        t.props.w = t.props.width, t.props.h = t.props.height, delete t.props.width, delete t.props.height;
      },
      down: (t) => {
        t.props.width = t.props.w, t.props.height = t.props.h, delete t.props.w, delete t.props.h;
      }
    },
    {
      id: rl.MakeUrlsValid,
      up: (t) => {
        Oo.isValid(t.props.src) || (t.props.src = "");
      },
      down: (t) => {
      }
    },
    {
      id: rl.AddFileSize,
      up: (t) => {
        t.props.fileSize = -1;
      },
      down: (t) => {
        delete t.props.fileSize;
      }
    },
    {
      id: rl.MakeFileSizeOptional,
      up: (t) => {
        t.props.fileSize === -1 && (t.props.fileSize = void 0);
      },
      down: (t) => {
        t.props.fileSize === void 0 && (t.props.fileSize = -1);
      }
    }
  ]
}), SW = Wr(
  "asset",
  Qx("type", {
    image: mW,
    video: IW,
    bookmark: fW
  })
), jW = xi("com.tldraw.asset", {
  AddMeta: 1
}), DW = Ri({
  sequenceId: "com.tldraw.asset",
  recordType: "asset",
  sequence: [
    {
      id: jW.AddMeta,
      up: (t) => {
        t.meta = {};
      }
    }
  ]
}), ci = Gr("asset", {
  validator: SW,
  scope: "document"
}).withDefaultProperties(() => ({
  meta: {}
})), Bb = {
  w: Ht,
  h: Ht,
  assetId: Np.nullable(),
  url: Li
}, w0 = Sr("bookmark", {
  NullAssetId: 1,
  MakeUrlsValid: 2
}), Gb = {
  sequence: [
    {
      id: w0.NullAssetId,
      up: (t) => {
        t.assetId === void 0 && (t.assetId = null);
      },
      down: "retired"
    },
    {
      id: w0.MakeUrlsValid,
      up: (t) => {
        Li.isValid(t.url) || (t.url = "");
      },
      down: (t) => {
      }
    }
  ]
}, Wb = Xe({
  type: wp("free", "straight"),
  points: sn(Po)
}), Hb = {
  color: Ln,
  fill: ms,
  dash: Ms,
  size: Oi,
  segments: sn(Wb),
  isComplete: qe,
  isClosed: qe,
  isPen: qe,
  scale: Ht
}, N0 = Sr("draw", {
  AddInPen: 1,
  AddScale: 2
}), Vb = {
  sequence: [
    {
      id: N0.AddInPen,
      up: (t) => {
        const { points: e } = t.segments[0];
        if (e.length === 0) {
          t.isPen = !1;
          return;
        }
        let n = !(e[0].z === 0 || e[0].z === 0.5);
        e[1] && (n = n && !(e[1].z === 0 || e[1].z === 0.5)), t.isPen = n;
      },
      down: "retired"
    },
    {
      id: N0.AddScale,
      up: (t) => {
        t.scale = 1;
      },
      down: (t) => {
        delete t.scale;
      }
    }
  ]
}, wW = /(^\/r\/[^/]+\/?$)/, NW = [
  {
    hostnames: ["beta.tldraw.com", "tldraw.com", "localhost:3000"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(wW))
        return t;
    }
  },
  {
    hostnames: ["figma.com"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/^\/embed\/?$/)) {
        const n = e.searchParams.get("url");
        if (n)
          return n;
      }
    }
  },
  {
    hostnames: ["google.*"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (!e) return;
      if (e.pathname.match(/^\/maps\/embed\/v1\/view\/?$/) && e.searchParams.has("center") && e.searchParams.get("zoom")) {
        const i = e.searchParams.get("zoom"), [r, s] = e.searchParams.get("center").split(",");
        return `https://www.google.com/maps/@${r},${s},${i}z`;
      }
    }
  },
  {
    hostnames: ["val.town"],
    fromEmbedUrl: (t) => {
      const e = Le(t), n = e && e.pathname.match(/\/embed\/(.+)\/?/);
      if (n)
        return `https://www.val.town/v/${n[1]}`;
    }
  },
  {
    hostnames: ["codesandbox.io"],
    fromEmbedUrl: (t) => {
      const e = Le(t), n = e && e.pathname.match(/\/embed\/([^/]+)\/?/);
      if (n)
        return `https://codesandbox.io/s/${n[1]}`;
    }
  },
  {
    hostnames: ["codepen.io"],
    fromEmbedUrl: (t) => {
      const e = /https:\/\/codepen.io\/([^/]+)\/embed\/([^/]+)/, n = t.match(e);
      if (n) {
        const [i, r, s] = n;
        return `https://codepen.io/${r}/pen/${s}`;
      }
    }
  },
  {
    hostnames: ["scratch.mit.edu"],
    fromEmbedUrl: (t) => {
      const e = /https:\/\/scratch.mit.edu\/projects\/embed\/([^/]+)/, n = t.match(e);
      if (n) {
        const [i, r] = n;
        return `https://scratch.mit.edu/projects/${r}`;
      }
    }
  },
  {
    hostnames: ["*.youtube.com", "youtube.com", "youtu.be"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (!e) return;
      if (e.hostname.replace(/^www./, "") === "youtube.com") {
        const i = e.pathname.match(/^\/embed\/([^/]+)\/?/);
        if (i)
          return `https://www.youtube.com/watch?v=${i[1]}`;
      }
    }
  },
  {
    hostnames: ["calendar.google.*"],
    fromEmbedUrl: (t) => {
      const e = Le(t), n = e == null ? void 0 : e.searchParams.get("src");
      if (e != null && e.pathname.match(/\/calendar\/embed/) && n) {
        e.pathname = "/calendar/u/0";
        const i = Array.from(e.searchParams.keys());
        for (const r of i)
          e.searchParams.delete(r);
        return e.searchParams.set("cid", n), e.href;
      }
    }
  },
  {
    hostnames: ["docs.google.*"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e != null && e.pathname.match(/^\/presentation/) && (e != null && e.pathname.match(/\/embed\/?$/))) {
        e.pathname = e.pathname.replace(/\/embed$/, "/pub");
        const n = Array.from(e.searchParams.keys());
        for (const i of n)
          e.searchParams.delete(i);
        return e.href;
      }
    }
  },
  {
    hostnames: ["gist.github.com"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/\/([^/]+)\/([^/]+)/))
        return t.split("/").pop() ? t : void 0;
    }
  },
  {
    hostnames: ["replit.com"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/\/@([^/]+)\/([^/]+)/) && e.searchParams.has("embed"))
        return e.searchParams.delete("embed"), e.href;
    }
  },
  {
    hostnames: ["felt.com"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/^\/embed\/map\//))
        return e.pathname = e.pathname.replace(/^\/embed/, ""), e.href;
    }
  },
  {
    hostnames: ["open.spotify.com"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/^\/embed\/(artist|album)\//))
        return e.origin + e.pathname.replace(/^\/embed/, "");
    }
  },
  {
    hostnames: ["vimeo.com", "player.vimeo.com"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.hostname === "player.vimeo.com") {
        const n = e.pathname.match(/^\/video\/([^/]+)\/?$/);
        if (n)
          return "https://vimeo.com/" + n[1];
      }
    }
  },
  {
    hostnames: ["excalidraw.com"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.hash.match(/#room=/))
        return t;
    }
  },
  {
    hostnames: ["observablehq.com"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/^\/embed\/@([^/]+)\/([^/]+)\/?$/))
        return `${e.origin}${e.pathname.replace("/embed", "")}#cell-*`;
      if (e && e.pathname.match(/^\/embed\/([^/]+)\/?$/))
        return `${e.origin}${e.pathname.replace("/embed", "/d")}#cell-*`;
    }
  },
  {
    hostnames: ["desmos.com"],
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.hostname === "www.desmos.com" && e.pathname.match(/^\/calculator\/([^/]+)\/?$/) && e.search === "?embed" && e.hash === "")
        return t.replace("?embed", "");
    }
  }
], Kb = {
  w: Ht,
  h: Ht,
  url: Ne
}, Su = Sr("embed", {
  GenOriginalUrlInEmbed: 1,
  RemoveDoesResize: 2,
  RemoveTmpOldUrl: 3,
  RemovePermissionOverrides: 4
}), Xb = {
  sequence: [
    {
      id: Su.GenOriginalUrlInEmbed,
      // add tmpOldUrl property
      up: (t) => {
        try {
          const e = t.url, n = new URL(e).host.replace("www.", "");
          let i;
          for (const r of NW)
            if (r.hostnames.includes(n))
              try {
                i = r.fromEmbedUrl(e);
              } catch (s) {
                console.warn(s);
              }
          t.tmpOldUrl = t.url, t.url = i ?? "";
        } catch {
          t.url = "", t.tmpOldUrl = t.url;
        }
      },
      down: "retired"
    },
    {
      id: Su.RemoveDoesResize,
      up: (t) => {
        delete t.doesResize;
      },
      down: "retired"
    },
    {
      id: Su.RemoveTmpOldUrl,
      up: (t) => {
        delete t.tmpOldUrl;
      },
      down: "retired"
    },
    {
      id: Su.RemovePermissionOverrides,
      up: (t) => {
        delete t.overridePermissions;
      },
      down: "retired"
    }
  ]
}, Jb = {
  w: Ht,
  h: Ht,
  name: Ne
}, qb = {
  sequence: []
}, Ka = In.defineEnum("tldraw:horizontalAlign", {
  defaultValue: "middle",
  values: ["start", "middle", "end", "start-legacy", "end-legacy", "middle-legacy"]
}), Xa = In.defineEnum("tldraw:verticalAlign", {
  defaultValue: "middle",
  values: ["start", "middle", "end"]
}), Fn = In.defineEnum("tldraw:geo", {
  defaultValue: "rectangle",
  values: [
    "cloud",
    "rectangle",
    "ellipse",
    "triangle",
    "diamond",
    "pentagon",
    "hexagon",
    "octagon",
    "star",
    "rhombus",
    "rhombus-2",
    "oval",
    "trapezoid",
    "arrow-right",
    "arrow-left",
    "arrow-up",
    "arrow-down",
    "x-box",
    "check-box",
    "heart"
  ]
}), _b = {
  geo: Fn,
  labelColor: Bx,
  color: Ln,
  fill: ms,
  dash: Ms,
  size: Oi,
  font: ki,
  align: Ka,
  verticalAlign: Xa,
  url: Li,
  w: Ht,
  h: Ht,
  growY: Ag,
  text: Ne,
  scale: Ht
}, es = Sr("geo", {
  AddUrlProp: 1,
  AddLabelColor: 2,
  RemoveJustify: 3,
  AddCheckBox: 4,
  AddVerticalAlign: 5,
  MigrateLegacyAlign: 6,
  AddCloud: 7,
  MakeUrlsValid: 8,
  AddScale: 9
}), $b = {
  sequence: [
    {
      id: es.AddUrlProp,
      up: (t) => {
        t.url = "";
      },
      down: "retired"
    },
    {
      id: es.AddLabelColor,
      up: (t) => {
        t.labelColor = "black";
      },
      down: "retired"
    },
    {
      id: es.RemoveJustify,
      up: (t) => {
        t.align === "justify" && (t.align = "start");
      },
      down: "retired"
    },
    {
      id: es.AddCheckBox,
      up: (t) => {
      },
      down: "retired"
    },
    {
      id: es.AddVerticalAlign,
      up: (t) => {
        t.verticalAlign = "middle";
      },
      down: "retired"
    },
    {
      id: es.MigrateLegacyAlign,
      up: (t) => {
        let e;
        switch (t.align) {
          case "start":
            e = "start-legacy";
            break;
          case "end":
            e = "end-legacy";
            break;
          default:
            e = "middle-legacy";
            break;
        }
        t.align = e;
      },
      down: "retired"
    },
    {
      id: es.AddCloud,
      up: (t) => {
      },
      down: "retired"
    },
    {
      id: es.MakeUrlsValid,
      up: (t) => {
        Li.isValid(t.url) || (t.url = "");
      },
      down: (t) => {
      }
    },
    {
      id: es.AddScale,
      up: (t) => {
        t.scale = 1;
      },
      down: (t) => {
        delete t.scale;
      }
    }
  ]
}, ev = {}, tv = { sequence: [] }, nv = {
  color: Ln,
  size: Oi,
  segments: sn(Wb),
  isComplete: qe,
  isPen: qe,
  scale: Ht
}, AW = Sr("highlight", {
  AddScale: 1
}), iv = {
  sequence: [
    {
      id: AW.AddScale,
      up: (t) => {
        t.scale = 1;
      },
      down: (t) => {
        delete t.scale;
      }
    }
  ]
}, TW = Xe({
  topLeft: Po,
  bottomRight: Po
}), rv = {
  w: Ht,
  h: Ht,
  playing: qe,
  url: Li,
  assetId: Np.nullable(),
  crop: TW.nullable(),
  flipX: qe,
  flipY: qe
}, ju = Sr("image", {
  AddUrlProp: 1,
  AddCropProp: 2,
  MakeUrlsValid: 3,
  AddFlipProps: 4
}), sv = {
  sequence: [
    {
      id: ju.AddUrlProp,
      up: (t) => {
        t.url = "";
      },
      down: "retired"
    },
    {
      id: ju.AddCropProp,
      up: (t) => {
        t.crop = null;
      },
      down: (t) => {
        delete t.crop;
      }
    },
    {
      id: ju.MakeUrlsValid,
      up: (t) => {
        Li.isValid(t.url) || (t.url = "");
      },
      down: (t) => {
      }
    },
    {
      id: ju.AddFlipProps,
      up: (t) => {
        t.flipX = !1, t.flipY = !1;
      },
      down: (t) => {
        delete t.flipX, delete t.flipY;
      }
    }
  ]
}, Ro = In.defineEnum("tldraw:spline", {
  defaultValue: "line",
  values: ["cubic", "line"]
}), bW = Xe({
  id: Ne,
  index: Va,
  x: we,
  y: we
}), ov = {
  color: Ln,
  dash: Ms,
  size: Oi,
  spline: Ro,
  points: Ha(Ne, bW),
  scale: Ht
}, sl = Sr("line", {
  AddSnapHandles: 1,
  RemoveExtraHandleProps: 2,
  HandlesToPoints: 3,
  PointIndexIds: 4,
  AddScale: 5
}), av = {
  sequence: [
    {
      id: sl.AddSnapHandles,
      up: (t) => {
        for (const e of Object.values(t.handles))
          e.canSnap = !0;
      },
      down: "retired"
    },
    {
      id: sl.RemoveExtraHandleProps,
      up: (t) => {
        t.handles = KA(
          Object.values(t.handles).map((e) => [
            e.index,
            {
              x: e.x,
              y: e.y
            }
          ])
        );
      },
      down: (t) => {
        const e = Object.entries(t.handles).map(([n, i]) => ({ index: n, ...i })).sort(Jt);
        t.handles = Object.fromEntries(
          e.map((n, i) => {
            const r = i === 0 ? "start" : i === e.length - 1 ? "end" : `handle:${n.index}`;
            return [
              r,
              {
                id: r,
                type: "vertex",
                canBind: !1,
                canSnap: !0,
                index: n.index,
                x: n.x,
                y: n.y
              }
            ];
          })
        );
      }
    },
    {
      id: sl.HandlesToPoints,
      up: (t) => {
        const e = Object.entries(t.handles).map(([n, { x: i, y: r }]) => ({ x: i, y: r, index: n })).sort(Jt);
        t.points = e.map(({ x: n, y: i }) => ({ x: n, y: i })), delete t.handles;
      },
      down: (t) => {
        const e = Wa(t.points.length);
        t.handles = Object.fromEntries(
          t.points.map((n, i) => [
            e[i],
            {
              x: n.x,
              y: n.y
            }
          ])
        ), delete t.points;
      }
    },
    {
      id: sl.PointIndexIds,
      up: (t) => {
        const e = Wa(t.points.length);
        t.points = Object.fromEntries(
          t.points.map((n, i) => {
            const r = e[i];
            return [
              r,
              {
                id: r,
                index: r,
                x: n.x,
                y: n.y
              }
            ];
          })
        );
      },
      down: (t) => {
        const e = Object.values(t.points).sort(Jt);
        t.points = e.map(({ x: n, y: i }) => ({ x: n, y: i }));
      }
    },
    {
      id: sl.AddScale,
      up: (t) => {
        t.scale = 1;
      },
      down: (t) => {
        delete t.scale;
      }
    }
  ]
}, cv = {
  color: Ln,
  labelColor: Bx,
  size: Oi,
  font: ki,
  fontSizeAdjustment: Ag,
  align: Ka,
  verticalAlign: Xa,
  growY: Ag,
  url: Li,
  text: Ne,
  scale: Ht
}, zs = Sr("note", {
  AddUrlProp: 1,
  RemoveJustify: 2,
  MigrateLegacyAlign: 3,
  AddVerticalAlign: 4,
  MakeUrlsValid: 5,
  AddFontSizeAdjustment: 6,
  AddScale: 7,
  AddLabelColor: 8
}), lv = {
  sequence: [
    {
      id: zs.AddUrlProp,
      up: (t) => {
        t.url = "";
      },
      down: "retired"
    },
    {
      id: zs.RemoveJustify,
      up: (t) => {
        t.align === "justify" && (t.align = "start");
      },
      down: "retired"
    },
    {
      id: zs.MigrateLegacyAlign,
      up: (t) => {
        switch (t.align) {
          case "start":
            t.align = "start-legacy";
            return;
          case "end":
            t.align = "end-legacy";
            return;
          default:
            t.align = "middle-legacy";
            return;
        }
      },
      down: "retired"
    },
    {
      id: zs.AddVerticalAlign,
      up: (t) => {
        t.verticalAlign = "middle";
      },
      down: "retired"
    },
    {
      id: zs.MakeUrlsValid,
      up: (t) => {
        Li.isValid(t.url) || (t.url = "");
      },
      down: (t) => {
      }
    },
    {
      id: zs.AddFontSizeAdjustment,
      up: (t) => {
        t.fontSizeAdjustment = 0;
      },
      down: (t) => {
        delete t.fontSizeAdjustment;
      }
    },
    {
      id: zs.AddScale,
      up: (t) => {
        t.scale = 1;
      },
      down: (t) => {
        delete t.scale;
      }
    },
    {
      id: zs.AddLabelColor,
      up: (t) => {
        t.labelColor = "black";
      },
      down: (t) => {
        delete t.labelColor;
      }
    }
  ]
}, Xl = In.defineEnum("tldraw:textAlign", {
  defaultValue: "start",
  values: ["start", "middle", "end"]
}), dv = {
  color: Ln,
  size: Oi,
  font: ki,
  textAlign: Xl,
  w: Ht,
  text: Ne,
  scale: Ht,
  autoSize: qe
}, A0 = Sr("text", {
  RemoveJustify: 1,
  AddTextAlign: 2
}), uv = {
  sequence: [
    {
      id: A0.RemoveJustify,
      up: (t) => {
        t.align === "justify" && (t.align = "start");
      },
      down: "retired"
    },
    {
      id: A0.AddTextAlign,
      up: (t) => {
        t.textAlign = t.align, delete t.align;
      },
      down: (t) => {
        t.align = t.textAlign, delete t.textAlign;
      }
    }
  ]
}, hv = {
  w: Ht,
  h: Ht,
  time: we,
  playing: qe,
  url: Li,
  assetId: Np.nullable()
}, T0 = Sr("video", {
  AddUrlProp: 1,
  MakeUrlsValid: 2
}), gv = {
  sequence: [
    {
      id: T0.AddUrlProp,
      up: (t) => {
        t.url = "";
      },
      down: "retired"
    },
    {
      id: T0.MakeUrlsValid,
      up: (t) => {
        Li.isValid(t.url) || (t.url = "");
      },
      down: (t) => {
      }
    }
  ]
}, Du = xi("com.tldraw.store", {
  RemoveCodeAndIconShapeTypes: 1,
  AddInstancePresenceType: 2,
  RemoveTLUserAndPresenceAndAddPointer: 3,
  RemoveUserDocument: 4
}), vW = Oa({
  sequenceId: "com.tldraw.store",
  retroactive: !1,
  sequence: [
    {
      id: Du.RemoveCodeAndIconShapeTypes,
      scope: "store",
      up: (t) => {
        for (const [e, n] of Mi(t))
          n.typeName === "shape" && (n.type === "icon" || n.type === "code") && delete t[e];
      }
    },
    {
      id: Du.AddInstancePresenceType,
      scope: "store",
      up(t) {
      }
    },
    {
      // remove user and presence records and add pointer records
      id: Du.RemoveTLUserAndPresenceAndAddPointer,
      scope: "store",
      up: (t) => {
        for (const [e, n] of Mi(t))
          n.typeName.match(/^(user|user_presence)$/) && delete t[e];
      }
    },
    {
      // remove user document records
      id: Du.RemoveUserDocument,
      scope: "store",
      up: (t) => {
        for (const [e, n] of Mi(t))
          n.typeName.match("user_document") && delete t[e];
      }
    }
  ]
}), EW = {
  arrow: { migrations: Ub, props: Pb },
  bookmark: { migrations: Gb, props: Bb },
  draw: { migrations: Vb, props: Hb },
  embed: { migrations: Xb, props: Kb },
  frame: { migrations: qb, props: Jb },
  geo: { migrations: $b, props: _b },
  group: { migrations: tv, props: ev },
  highlight: { migrations: iv, props: nv },
  image: { migrations: sv, props: rv },
  line: { migrations: av, props: ov },
  note: { migrations: lv, props: cv },
  text: { migrations: uv, props: dv },
  video: { migrations: gv, props: hv }
}, CW = {
  arrow: { migrations: Yb, props: Rb }
};
function zW({
  shapes: t = EW,
  bindings: e = CW,
  migrations: n
} = {}) {
  const i = /* @__PURE__ */ new Map();
  for (const a of Pt(t))
    for (const c of Cb(a.props ?? {}).keys()) {
      if (i.has(c.id) && i.get(c.id) !== c)
        throw new Error(`Multiple StyleProp instances with the same id: ${c.id}`);
      i.set(c.id, c);
    }
  const r = QG(t), s = UG(e), o = $G(i);
  return Rx.create(
    {
      asset: ci,
      binding: s,
      camera: kr,
      document: Wx,
      instance: o,
      instance_page_state: ar,
      page: kn,
      instance_presence: cW,
      pointer: Gx,
      shape: r
    },
    {
      migrations: [
        vW,
        DW,
        BG,
        dW,
        eW,
        nW,
        qG,
        aW,
        sW,
        YG,
        MW,
        yW,
        xW,
        ...x0("shape", t),
        ...x0("binding", e),
        ...n ?? []
      ],
      onValidationFailure: hW,
      createIntegrityChecker: pW
    }
  );
}
const Jl = [
  { locale: "id", label: "Bahasa Indonesia" },
  { locale: "ca", label: "Català" },
  { locale: "cs", label: "Čeština" },
  { locale: "da", label: "Danish" },
  { locale: "de", label: "Deutsch" },
  { locale: "en", label: "English" },
  { locale: "es", label: "Español" },
  { locale: "fr", label: "Français" },
  { locale: "gl", label: "Galego" },
  { locale: "hr", label: "Hrvatski" },
  { locale: "it", label: "Italiano" },
  { locale: "hu", label: "Magyar" },
  { locale: "no", label: "Norwegian" },
  { locale: "pl", label: "Polski" },
  { locale: "pt-br", label: "Português - Brasil" },
  { locale: "pt-pt", label: "Português - Europeu" },
  { locale: "ro", label: "Română" },
  { locale: "ru", label: "Russian" },
  { locale: "sl", label: "Slovenščina" },
  { locale: "fi", label: "Suomi" },
  { locale: "sv", label: "Svenska" },
  { locale: "vi", label: "Tiếng Việt" },
  { locale: "tr", label: "Türkçe" },
  { locale: "uk", label: "Ukrainian" },
  { locale: "he", label: "עברית" },
  { locale: "ar", label: "عربي" },
  { locale: "fa", label: "فارسی" },
  { locale: "ku", label: "کوردی" },
  { locale: "ne", label: "नेपाली" },
  { locale: "hi-in", label: "हिन्दी" },
  { locale: "te", label: "తెలుగు" },
  { locale: "th", label: "ภาษาไทย" },
  { locale: "my", label: "မြန်မာစာ" },
  { locale: "ko-kr", label: "한국어" },
  { locale: "ja", label: "日本語" },
  { locale: "zh-cn", label: "简体中文" },
  { locale: "zh-tw", label: "繁體中文 (台灣)" }
];
function LW() {
  const t = typeof window < "u" ? window.navigator.languages ?? ["en"] : ["en"];
  return kW(t);
}
function kW(t) {
  for (const e of t) {
    const n = OW(e);
    if (n)
      return n;
  }
  return "en";
}
const b0 = {
  zh: "zh-cn",
  pt: "pt-br",
  ko: "ko-kr",
  hi: "hi-in"
};
function OW(t) {
  const e = Jl.find((r) => r.locale === t.toLowerCase());
  if (e)
    return e.locale;
  const [n, i] = t.split(/[-_]/).map((r) => r.toLowerCase());
  if (i) {
    const r = Jl.find((s) => s.locale === n);
    if (r)
      return r.locale;
  }
  return n in b0 ? b0[n] : null;
}
so(
  "@tldraw/tlschema",
  "3.4.1",
  "esm"
);
var pv = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function n() {
      for (var s = "", o = 0; o < arguments.length; o++) {
        var a = arguments[o];
        a && (s = r(s, i(a)));
      }
      return s;
    }
    function i(s) {
      if (typeof s == "string" || typeof s == "number")
        return s;
      if (typeof s != "object")
        return "";
      if (Array.isArray(s))
        return n.apply(null, s);
      if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
        return s.toString();
      var o = "";
      for (var a in s)
        e.call(s, a) && s[a] && (o = r(o, a));
      return o;
    }
    function r(s, o) {
      return o ? s ? s + " " + o : s + o : s;
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(pv);
var PW = pv.exports;
const ce = /* @__PURE__ */ uc(PW), fv = "3.4.1", v0 = {
  major: "2024-09-13T14:36:29.063Z",
  minor: "2024-10-24T14:44:00.648Z"
}, UW = { error: null };
class Hx extends N.Component {
  constructor() {
    super(...arguments);
    S(this, "state", UW);
  }
  static getDerivedStateFromError(n) {
    return { error: n };
  }
  componentDidCatch(n) {
    var i, r;
    (r = (i = this.props).onError) == null || r.call(i, n);
  }
  render() {
    const { error: n } = this.state;
    if (n !== null) {
      const { fallback: i } = this.props;
      return /* @__PURE__ */ l.jsx(i, { error: n });
    }
    return this.props.children;
  }
}
function ql({
  children: t,
  fallback: e,
  ...n
}) {
  return e === null ? t : /* @__PURE__ */ l.jsx(Hx, { fallback: e, ...n, children: t });
}
function Vx(t, e) {
  return Ap(`${t}_${e}`);
}
function Sc(t) {
  return Ap(`${X3()}${t ?? ""}`);
}
function lr(t) {
  const e = oi(Vn(Mv));
  return Ap(`${e}_${t}`);
}
function Ap(t) {
  return t.replace(/:/g, "_");
}
const Mv = Ii(null);
function RW({ children: t }) {
  const e = Sc();
  return /* @__PURE__ */ l.jsx(Mv.Provider, { value: e, children: t });
}
const Kx = Ii(null);
function Q() {
  const t = Ye.useContext(Kx);
  if (!t)
    throw new Error(
      "useEditor must be used inside of the <Tldraw /> or <TldrawEditor /> components"
    );
  return t;
}
function Xx() {
  return Ye.useContext(Kx);
}
function Jx({
  editor: t,
  children: e
}) {
  return /* @__PURE__ */ l.jsx(Kx.Provider, { value: t, children: /* @__PURE__ */ l.jsx(RW, { children: e }) });
}
function YW() {
  return /* @__PURE__ */ l.jsx("div", { className: "tl-background" });
}
function Ko(t, e, n, i, r, s) {
  at(() => {
    const o = t.current;
    if (!o || e === void 0) return;
    let a = `translate(${e}px, ${n}px)`;
    i !== void 0 && (a += ` scale(${i})`), r !== void 0 && (a += ` rotate(${r}rad)`), s && (a += ` translate(${s.x}px, ${s.y}px)`), o.style.transform = a;
  });
}
const on = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => t * (2 - t),
  easeInOutQuad: (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => --t * t * t + 1,
  easeInOutCubic: (t) => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => 1 - --t * t * t * t,
  easeInOutQuart: (t) => t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t,
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => 1 + --t * t * t * t * t,
  easeInOutQuint: (t) => t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t,
  easeInSine: (t) => 1 - Math.cos(t * Math.PI / 2),
  easeOutSine: (t) => Math.sin(t * Math.PI / 2),
  easeInOutSine: (t) => -(Math.cos(Math.PI * t) - 1) / 2,
  easeInExpo: (t) => t <= 0 ? 0 : Math.pow(2, 10 * t - 10),
  easeOutExpo: (t) => t >= 1 ? 1 : 1 - Math.pow(2, -10 * t),
  easeInOutExpo: (t) => t <= 0 ? 0 : t >= 1 ? 1 : t < 0.5 ? Math.pow(2, 20 * t - 10) / 2 : (2 - Math.pow(2, -20 * t + 10)) / 2
};
class x {
  constructor(e = 0, n = 0, i = 1) {
    this.x = e, this.y = n, this.z = i;
  }
  // eslint-disable-next-line no-restricted-syntax
  get pressure() {
    return this.z;
  }
  set(e = this.x, n = this.y, i = this.z) {
    return this.x = e, this.y = n, this.z = i, this;
  }
  setTo({ x: e = 0, y: n = 0, z: i = 1 }) {
    return this.x = e, this.y = n, this.z = i, this;
  }
  rot(e) {
    if (e === 0) return this;
    const { x: n, y: i } = this, r = Math.sin(e), s = Math.cos(e);
    return this.x = n * s - i * r, this.y = n * r + i * s, this;
  }
  rotWith(e, n) {
    if (n === 0) return this;
    const i = this.x - e.x, r = this.y - e.y, s = Math.sin(n), o = Math.cos(n);
    return this.x = e.x + (i * o - r * s), this.y = e.y + (i * s + r * o), this;
  }
  clone() {
    const { x: e, y: n, z: i } = this;
    return new x(e, n, i);
  }
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }
  subXY(e, n) {
    return this.x -= e, this.y -= n, this;
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this;
  }
  add(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  addXY(e, n) {
    return this.x += e, this.y += n, this;
  }
  addScalar(e) {
    return this.x += e, this.y += e, this;
  }
  clamp(e, n) {
    return this.x = Math.max(this.x, e), this.y = Math.max(this.y, e), n !== void 0 && (this.x = Math.min(this.x, n), this.y = Math.min(this.y, n)), this;
  }
  div(e) {
    return this.x /= e, this.y /= e, this;
  }
  divV(e) {
    return this.x /= e.x, this.y /= e.y, this;
  }
  mul(e) {
    return this.x *= e, this.y *= e, this;
  }
  mulV(e) {
    return this.x *= e.x, this.y *= e.y, this;
  }
  abs() {
    return this.x = Math.abs(this.x), this.y = Math.abs(this.y), this;
  }
  nudge(e, n) {
    const i = x.Tan(e, this);
    return this.add(i.mul(n));
  }
  neg() {
    return this.x *= -1, this.y *= -1, this;
  }
  cross(e) {
    return this.x = this.y * e.z - this.z * e.y, this.y = this.z * e.x - this.x * e.z, this;
  }
  dpr(e) {
    return x.Dpr(this, e);
  }
  cpr(e) {
    return x.Cpr(this, e);
  }
  len2() {
    return x.Len2(this);
  }
  len() {
    return x.Len(this);
  }
  pry(e) {
    return x.Pry(this, e);
  }
  per() {
    const { x: e, y: n } = this;
    return this.x = n, this.y = -e, this;
  }
  uni() {
    return x.Uni(this);
  }
  tan(e) {
    return x.Tan(this, e);
  }
  dist(e) {
    return x.Dist(this, e);
  }
  distanceToLineSegment(e, n) {
    return x.DistanceToLineSegment(e, n, this);
  }
  slope(e) {
    return x.Slope(this, e);
  }
  snapToGrid(e) {
    return this.x = Math.round(this.x / e) * e, this.y = Math.round(this.y / e) * e, this;
  }
  angle(e) {
    return x.Angle(this, e);
  }
  toAngle() {
    return x.ToAngle(this);
  }
  lrp(e, n) {
    return this.x = this.x + (e.x - this.x) * n, this.y = this.y + (e.y - this.y) * n, this;
  }
  equals(e) {
    return x.Equals(this, e);
  }
  equalsXY(e, n) {
    return x.EqualsXY(this, e, n);
  }
  norm() {
    const e = this.len();
    return this.x = e === 0 ? 0 : this.x / e, this.y = e === 0 ? 0 : this.y / e, this;
  }
  toFixed() {
    return x.ToFixed(this);
  }
  toString() {
    return x.ToString(x.ToFixed(this));
  }
  toJson() {
    return x.ToJson(this);
  }
  toArray() {
    return x.ToArray(this);
  }
  static Add(e, n) {
    return new x(e.x + n.x, e.y + n.y);
  }
  static AddXY(e, n, i) {
    return new x(e.x + n, e.y + i);
  }
  static Sub(e, n) {
    return new x(e.x - n.x, e.y - n.y);
  }
  static SubXY(e, n, i) {
    return new x(e.x - n, e.y - i);
  }
  static AddScalar(e, n) {
    return new x(e.x + n, e.y + n);
  }
  static SubScalar(e, n) {
    return new x(e.x - n, e.y - n);
  }
  static Div(e, n) {
    return new x(e.x / n, e.y / n);
  }
  static Mul(e, n) {
    return new x(e.x * n, e.y * n);
  }
  static DivV(e, n) {
    return new x(e.x / n.x, e.y / n.y);
  }
  static MulV(e, n) {
    return new x(e.x * n.x, e.y * n.y);
  }
  static Neg(e) {
    return new x(-e.x, -e.y);
  }
  /**
   * Get the perpendicular vector to A.
   */
  static Per(e) {
    return new x(e.y, -e.x);
  }
  static Abs(e) {
    return new x(Math.abs(e.x), Math.abs(e.y));
  }
  // Get the distance between two points.
  static Dist(e, n) {
    return ((e.y - n.y) ** 2 + (e.x - n.x) ** 2) ** 0.5;
  }
  // Get whether a distance between two points is less than a number. This is faster to calulate than using `Vec.Dist(a, b) < n`.
  static DistMin(e, n, i) {
    return (e.x - n.x) * (e.x - n.x) + (e.y - n.y) * (e.y - n.y) < i ** 2;
  }
  // Get the squared distance between two points. This is faster to calculate (no square root) so useful for "minimum distance" checks where the actual measurement does not matter.
  static Dist2(e, n) {
    return (e.x - n.x) * (e.x - n.x) + (e.y - n.y) * (e.y - n.y);
  }
  /**
   * Dot product of two vectors which is used to calculate the angle between them.
   */
  static Dpr(e, n) {
    return e.x * n.x + e.y * n.y;
  }
  static Cross(e, n) {
    return new x(
      e.y * n.z - e.z * n.y,
      e.z * n.x - e.x * n.z
      // A.z = A.x * V.y - A.y * V.x
    );
  }
  /**
   * Cross product of two vectors which is used to calculate the area of a parallelogram.
   */
  static Cpr(e, n) {
    return e.x * n.y - n.x * e.y;
  }
  static Len2(e) {
    return e.x * e.x + e.y * e.y;
  }
  static Len(e) {
    return (e.x * e.x + e.y * e.y) ** 0.5;
  }
  /**
   * Get the projection of A onto B.
   */
  static Pry(e, n) {
    return x.Dpr(e, n) / x.Len(n);
  }
  /**
   * Get the unit vector of A.
   */
  static Uni(e) {
    return x.Div(e, x.Len(e));
  }
  static Tan(e, n) {
    return x.Uni(x.Sub(e, n));
  }
  static Min(e, n) {
    return new x(Math.min(e.x, n.x), Math.min(e.y, n.y));
  }
  static Max(e, n) {
    return new x(Math.max(e.x, n.x), Math.max(e.y, n.y));
  }
  static From({ x: e, y: n, z: i = 1 }) {
    return new x(e, n, i);
  }
  static FromArray(e) {
    return new x(e[0], e[1]);
  }
  static Rot(e, n = 0) {
    const i = Math.sin(n), r = Math.cos(n);
    return new x(e.x * r - e.y * i, e.x * i + e.y * r);
  }
  static RotWith(e, n, i) {
    const r = e.x - n.x, s = e.y - n.y, o = Math.sin(i), a = Math.cos(i);
    return new x(n.x + (r * a - s * o), n.y + (r * o + s * a));
  }
  /**
   * Get the nearest point on a line with a known unit vector that passes through point A
   *
   * ```ts
   * Vec.nearestPointOnLineThroughPoint(A, u, Point)
   * ```
   *
   * @param A - Any point on the line
   * @param u - The unit vector for the line.
   * @param P - A point not on the line to test.
   */
  static NearestPointOnLineThroughPoint(e, n, i) {
    return x.Mul(n, x.Sub(i, e).pry(n)).add(e);
  }
  static NearestPointOnLineSegment(e, n, i, r = !0) {
    if (x.Equals(e, i) || x.Equals(n, i)) return x.From(i);
    const s = x.Tan(n, e), o = x.Add(e, x.Mul(s, x.Sub(i, e).pry(s)));
    if (r) {
      if (o.x < Math.min(e.x, n.x)) return x.Cast(e.x < n.x ? e : n);
      if (o.x > Math.max(e.x, n.x)) return x.Cast(e.x > n.x ? e : n);
      if (o.y < Math.min(e.y, n.y)) return x.Cast(e.y < n.y ? e : n);
      if (o.y > Math.max(e.y, n.y)) return x.Cast(e.y > n.y ? e : n);
    }
    return o;
  }
  static DistanceToLineThroughPoint(e, n, i) {
    return x.Dist(i, x.NearestPointOnLineThroughPoint(e, n, i));
  }
  static DistanceToLineSegment(e, n, i, r = !0) {
    return x.Dist(i, x.NearestPointOnLineSegment(e, n, i, r));
  }
  static Snap(e, n = 1) {
    return new x(Math.round(e.x / n) * n, Math.round(e.y / n) * n);
  }
  static Cast(e) {
    return e instanceof x ? e : x.From(e);
  }
  static Slope(e, n) {
    return e.x === n.y ? NaN : (e.y - n.y) / (e.x - n.x);
  }
  static IsNaN(e) {
    return isNaN(e.x) || isNaN(e.y);
  }
  static Angle(e, n) {
    return Math.atan2(n.y - e.y, n.x - e.x);
  }
  /**
   * Linearly interpolate between two points.
   * @param A - The first point.
   * @param B - The second point.
   * @param t - The interpolation value between 0 and 1.
   * @returns The interpolated point.
   */
  static Lrp(e, n, i) {
    return x.Sub(n, e).mul(i).add(e);
  }
  static Med(e, n) {
    return new x((e.x + n.x) / 2, (e.y + n.y) / 2);
  }
  static Equals(e, n) {
    return Math.abs(e.x - n.x) < 1e-4 && Math.abs(e.y - n.y) < 1e-4;
  }
  static EqualsXY(e, n, i) {
    return e.x === n && e.y === i;
  }
  static Clockwise(e, n, i) {
    return (i.x - e.x) * (n.y - e.y) - (n.x - e.x) * (i.y - e.y) < 0;
  }
  static Rescale(e, n) {
    const i = x.Len(e);
    return new x(n * e.x / i, n * e.y / i);
  }
  static ScaleWithOrigin(e, n, i) {
    return x.Sub(e, i).mul(n).add(i);
  }
  static ToFixed(e) {
    return new x(cs(e.x), cs(e.y));
  }
  static ToInt(e) {
    return new x(
      parseInt(e.x.toFixed(0)),
      parseInt(e.y.toFixed(0)),
      parseInt((e.z ?? 0).toFixed(0))
    );
  }
  static ToCss(e) {
    return `${e.x},${e.y}`;
  }
  static Nudge(e, n, i) {
    return x.Add(e, x.Tan(n, e).mul(i));
  }
  static ToString(e) {
    return `${e.x}, ${e.y}`;
  }
  static ToAngle(e) {
    let n = Math.atan2(e.y, e.x);
    return n < 0 && (n += Math.PI * 2), n;
  }
  static FromAngle(e, n = 1) {
    return new x(Math.cos(e) * n, Math.sin(e) * n);
  }
  static ToArray(e) {
    return [e.x, e.y, e.z];
  }
  static ToJson(e) {
    const { x: n, y: i, z: r } = e;
    return { x: n, y: i, z: r };
  }
  static Average(e) {
    const n = e.length, i = new x(0, 0);
    if (n === 0)
      return i;
    for (let r = 0; r < n; r++)
      i.add(e[r]);
    return i.div(n);
  }
  static Clamp(e, n, i) {
    return i === void 0 ? new x(Math.min(Math.max(e.x, n)), Math.min(Math.max(e.y, n))) : new x(Math.min(Math.max(e.x, n), i), Math.min(Math.max(e.y, n), i));
  }
  /**
   * Get an array of points (with simulated pressure) between two points.
   *
   * @param A - The first point.
   * @param B - The second point.
   * @param steps - The number of points to return.
   */
  static PointsBetween(e, n, i = 6) {
    const r = [];
    for (let s = 0; s < i; s++) {
      const o = on.easeInQuad(s / (i - 1)), a = x.Lrp(e, n, o);
      a.z = Math.min(1, 0.5 + Math.abs(0.5 - QW(o)) * 0.65), r.push(a);
    }
    return r;
  }
  static SnapToGrid(e, n = 8) {
    return new x(Math.round(e.x / n) * n, Math.round(e.y / n) * n);
  }
}
const QW = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
function rt(t) {
  return `${k(t.x)},${k(t.y)} `;
}
function ai(t, e) {
  return `${k((t.x + e.x) / 2)},${k((t.y + e.y) / 2)} `;
}
const st = Math.PI, Nt = st / 2, gt = st * 2, ZW = Math.sin;
function hn(t, e, n) {
  return Math.max(e, typeof n < "u" ? Math.min(t, n) : t);
}
function wu(t, e = 1e10) {
  return t ? Math.round(t * e) / e : 0;
}
function Xs(t, e, n = 1e-6) {
  return Math.abs(t - e) <= n;
}
function mv(t, e) {
  const n = Math.pow(t - e, 2) / Math.pow(t + e, 2);
  return st * (t + e) * (1 + 3 * n / (10 + Math.sqrt(4 - 3 * n)));
}
function Js(t) {
  return t = t % gt, t < 0 ? t = t + gt : t === 0 && (t = 0), t;
}
function fd(t, e) {
  return t = Js(t), e = Js(e), t > e && (e += gt), e - t;
}
function yv(t, e) {
  return gt - fd(t, e);
}
function Sh(t, e) {
  const n = (e - t) % gt;
  return 2 * n % gt - n;
}
function Zy(t) {
  return (gt + t) % gt;
}
function vg(t, e) {
  const n = gt / e;
  let i = Math.floor((Zy(t) + n / 2) / n) * n % gt;
  return i < st && (i += gt), i > st && (i -= gt), i;
}
function Iv(t, e) {
  return t === e || Xs(t % (Math.PI / 2) - e % (Math.PI / 2), 0);
}
function FW(t) {
  return t * st / 180;
}
function BW(t) {
  return t * 180 / st;
}
function Yo(t, e, n) {
  return new x(t.x, t.y).add(x.FromAngle(n, e));
}
function jM(t, e, n) {
  const i = t / 2, r = e / 2, s = [];
  let o = 1 / 0, a = -1 / 0, c = 1 / 0, d = -1 / 0;
  for (let f = 0; f < n; f++) {
    const M = gt / n, m = -Nt + f * M, y = i + i * Math.cos(m), I = r + r * Math.sin(m);
    y < o && (o = y), I < c && (c = I), y > a && (a = y), I > d && (d = I), s.push(new x(y, I));
  }
  const u = a - o, h = d - c, g = t - u, p = e - h;
  if (g !== 0 || p !== 0)
    for (let f = 0; f < s.length; f++) {
      const M = s[f];
      M.x = (M.x - o) / u * t, M.y = (M.y - c) / h * e;
    }
  return s;
}
function ol(t, e, n, i) {
  return t < i && n < e;
}
function nr(t, e, n, i) {
  const r = Math.max(t, n), s = Math.min(e, i);
  return r <= s ? [r, s] : null;
}
function E0(t, e, n) {
  return (e.x - t.x) * (n.y - t.y) - (n.x - t.x) * (e.y - t.y);
}
function yi(t, e) {
  let n = 0, i, r;
  for (let s = 0; s < e.length; s++) {
    if (i = e[s], i.x === t.x && i.y === t.y || (r = e[(s + 1) % e.length], x.Dist(t, i) + x.Dist(t, r) === x.Dist(i, r))) return !0;
    i.y <= t.y ? r.y > t.y && E0(i, r, t) > 0 && (n += 1) : r.y <= t.y && E0(i, r, t) < 0 && (n -= 1);
  }
  return n !== 0;
}
function k(t) {
  return Math.round(t * 1e4) / 1e4;
}
function cs(t) {
  return Math.round(t * 100) / 100;
}
const C0 = (t) => Math.abs(t) < Number.MAX_SAFE_INTEGER;
function Fs(t, e, n) {
  return n < 0 ? fd(t, e) : yv(t, e);
}
function Fy(t, e, n, i) {
  let r;
  if (Math.abs(t) > st) {
    r = Sh(e, i);
    const s = Sh(i, n);
    return Math.abs(r) < Math.abs(s) ? r / t : (t - s) / t;
  } else {
    r = Sh(e, i);
    const s = r / t;
    return Math.sign(r) !== Math.sign(t) ? Math.abs(s) > 0.5 ? 1 : 0 : s;
  }
}
function GW(t, e, n, i) {
  const r = 2 * ((e - t) % gt) % gt - (e - t) % gt;
  return i ? (gt - Math.abs(r)) * (n ? 1 : -1) : r;
}
function qx(t, e, n) {
  const i = -2 * (t.x * (e.y - n.y) - t.y * (e.x - n.x) + e.x * n.y - n.x * e.y), r = ((t.x * t.x + t.y * t.y) * (n.y - e.y) + (e.x * e.x + e.y * e.y) * (t.y - n.y) + (n.x * n.x + n.y * n.y) * (e.y - t.y)) / i, s = ((t.x * t.x + t.y * t.y) * (e.x - n.x) + (e.x * e.x + e.y * e.y) * (n.x - t.x) + (n.x * n.x + n.y * n.y) * (t.x - e.x)) / i;
  return !Number.isFinite(r) || !Number.isFinite(s) ? null : new x(r, s);
}
function WW(t, e, n, i, r) {
  if (n === null)
    return [x.From(t), x.From(e)];
  const s = [], o = x.Angle(n, t), a = x.Angle(n, e), c = fd(o, a);
  for (let d = 0; d < r; d++) {
    const u = d / (r - 1), h = o + c * u, g = Yo(n, i, h);
    s.push(g);
  }
  return s;
}
const DM = ({ brush: t, color: e, opacity: n, className: i }) => {
  const r = le(null);
  Ko(r, t.x, t.y);
  const s = k(Math.max(1, t.w)), o = k(Math.max(1, t.h));
  return /* @__PURE__ */ l.jsx("svg", { className: "tl-overlays__item", ref: r, children: e ? /* @__PURE__ */ l.jsxs("g", { className: "tl-brush", opacity: n, children: [
    /* @__PURE__ */ l.jsx("rect", { width: s, height: o, fill: e, opacity: 0.75 }),
    /* @__PURE__ */ l.jsx("rect", { width: s, height: o, fill: "none", stroke: e, opacity: 0.1 })
  ] }) : /* @__PURE__ */ l.jsx("rect", { className: `tl-brush tl-brush__default ${i}`, width: s, height: o }) });
}, mt = {
  isSafari: !1,
  isIos: !1,
  isChromeForIos: !1,
  isFirefox: !1,
  isAndroid: !1,
  isWebview: !1,
  isDarwin: !1
};
typeof window < "u" && "navigator" in window && (mt.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), mt.isIos = !!navigator.userAgent.match(/iPad/i) || !!navigator.userAgent.match(/iPhone/i), mt.isChromeForIos = /crios.*safari/i.test(navigator.userAgent), mt.isFirefox = /firefox/i.test(navigator.userAgent), mt.isAndroid = /android/i.test(navigator.userAgent), mt.isDarwin = window.navigator.userAgent.toLowerCase().indexOf("mac") > -1);
const z0 = {
  isLocked: !1,
  wheelBehavior: "pan",
  panSpeed: 1,
  zoomSpeed: 1,
  zoomSteps: [0.1, 0.25, 0.5, 1, 2, 4, 8]
}, wM = {
  duration: 0,
  easing: on.easeInOutCubic
}, L0 = {
  CAMERA_MOVE: -10
}, xv = ["top", "right", "bottom", "left"], k0 = 0, _x = 2, Nu = 1, O0 = 5, HW = 128, VW = {}, Sv = ti(
  "pointerCaptureTrackingObject",
  // ideally we wouldn't store this mutable value in an atom but it's not
  // a big deal for debug values
  {
    defaults: { all: /* @__PURE__ */ new Map() },
    shouldStoreForSession: !1
  }
), Wt = {
  // --- DEBUG VALUES ---
  logPreventDefaults: ti("logPreventDefaults", {
    defaults: { all: !1 }
  }),
  logPointerCaptures: ti("logPointerCaptures", {
    defaults: { all: !1 }
  }),
  logElementRemoves: ti("logElementRemoves", {
    defaults: { all: !1 }
  }),
  debugSvg: ti("debugSvg", {
    defaults: { all: !1 }
  }),
  showFps: ti("showFps", {
    defaults: { all: !1 }
  }),
  measurePerformance: ti("measurePerformance", { defaults: { all: !1 } }),
  throwToBlob: ti("throwToBlob", {
    defaults: { all: !1 }
  }),
  reconnectOnPing: ti("reconnectOnPing", {
    defaults: { all: !1 }
  }),
  debugCursors: ti("debugCursors", {
    defaults: { all: !1 }
  }),
  forceSrgb: ti("forceSrgbColors", { defaults: { all: !1 } }),
  debugGeometry: ti("debugGeometry", { defaults: { all: !1 } }),
  hideShapes: ti("hideShapes", { defaults: { all: !1 } }),
  editOnType: ti("editOnType", { defaults: { all: !1 } })
};
if (typeof Element < "u") {
  const t = Element.prototype.removeChild;
  Yr("element removal logging", () => {
    Wt.logElementRemoves.get() ? Element.prototype.removeChild = function(e) {
      return console.warn("[tldraw] removing child:", e), t.call(this, e);
    } : Element.prototype.removeChild = t;
  });
}
function ti(t, {
  defaults: e,
  shouldStoreForSession: n = !0
}) {
  return KW({
    name: t,
    defaults: e,
    shouldStoreForSession: n
  });
}
function KW(t) {
  const e = JW(t), n = t.shouldStoreForSession ? XW(t.name) : null, i = xt(`debug:${t.name}`, n ?? e);
  return typeof window < "u" && (t.shouldStoreForSession && Yr(`debug:${t.name}`, () => {
    const r = i.get();
    r === e ? gT(`tldraw_debug:${t.name}`) : fx(`tldraw_debug:${t.name}`, JSON.stringify(r));
  }), Object.defineProperty(window, `tldraw${t.name.replace(/^[a-z]/, (r) => r.toUpperCase())}`, {
    get() {
      return i.get();
    },
    set(r) {
      i.set(r);
    },
    configurable: !0
  })), Object.assign(i, t);
}
function XW(t) {
  try {
    return JSON.parse(hT(`tldraw_debug:${t}`) ?? "null");
  } catch {
    return null;
  }
}
function NM(t) {
  try {
    return t();
  } catch {
    return null;
  }
}
function JW(t) {
  switch (NM(() => process.env.TLDRAW_ENV) ?? NM(() => process.env.VERCEL_PUBLIC_TLDRAW_ENV) ?? NM(() => process.env.NEXT_PUBLIC_TLDRAW_ENV) ?? // default to production because if we don't have one of these, this is probably a library use
  "production") {
    case "production":
      return t.defaults.production ?? t.defaults.all;
    case "preview":
    case "staging":
      return t.defaults.staging ?? t.defaults.all;
    default:
      return t.defaults.development ?? t.defaults.all;
  }
}
function Eg(t) {
  if (t instanceof HTMLElement) return t;
  if (t.parentElement) return Eg(t.parentElement);
  throw Error("Could not find a parent element of an HTML type!");
}
function Ke(t) {
  t.preventDefault(), Wt.logPreventDefaults.get() && console.warn("preventDefault called on event:", t);
}
function jc(t, e) {
  if (t.setPointerCapture(e.pointerId), Wt.logPointerCaptures.get()) {
    const n = Sv.get();
    n.set(t, (n.get(t) ?? 0) + 1), console.warn("setPointerCapture called on element:", t, e);
  }
}
function Dc(t, e) {
  if (t.hasPointerCapture(e.pointerId) && (t.releasePointerCapture(e.pointerId), Wt.logPointerCaptures.get())) {
    const n = Sv.get();
    n.get(t) === 1 ? n.delete(t) : n.has(t) ? n.set(t, n.get(t) - 1) : console.warn("Release without capture"), console.warn("releasePointerCapture called on element:", t, e);
  }
}
const Yt = (t) => t.stopPropagation(), wn = (t, e, n) => {
  t && t.style.setProperty(e, n);
}, bn = (t) => mt.isDarwin ? t.metaKey : t.ctrlKey || t.metaKey;
function gi(t) {
  return t.isKilled = !0, {
    point: {
      x: t.clientX,
      y: t.clientY,
      z: t.pressure
    },
    shiftKey: t.shiftKey,
    altKey: t.altKey,
    ctrlKey: t.metaKey || t.ctrlKey,
    metaKey: t.metaKey,
    accelKey: bn(t),
    pointerId: t.pointerId,
    button: t.button,
    isPen: t.pointerType === "pen"
  };
}
function $x() {
  const t = Q();
  return yt(
    function() {
      let i, r;
      function s(M) {
        if (!M.isKilled) {
          if (M.button === _x) {
            t.dispatch({
              type: "pointer",
              target: "canvas",
              name: "right_click",
              ...gi(M)
            });
            return;
          }
          M.button !== 0 && M.button !== 1 && M.button !== 5 || (jc(M.currentTarget, M), t.dispatch({
            type: "pointer",
            target: "canvas",
            name: "pointer_down",
            ...gi(M)
          }));
        }
      }
      function o(M) {
        M.isKilled || M.clientX === i && M.clientY === r || (i = M.clientX, r = M.clientY, t.dispatch({
          type: "pointer",
          target: "canvas",
          name: "pointer_move",
          ...gi(M)
        }));
      }
      function a(M) {
        M.isKilled || M.button !== 0 && M.button !== 1 && M.button !== 2 && M.button !== 5 || (i = M.clientX, r = M.clientY, Dc(M.currentTarget, M), t.dispatch({
          type: "pointer",
          target: "canvas",
          name: "pointer_up",
          ...gi(M)
        }));
      }
      function c(M) {
        if (M.isKilled || t.getInstanceState().isPenMode && M.pointerType !== "pen") return;
        const m = M.pointerType === "mouse" || M.pointerType === "pen";
        t.updateInstanceState({ isHoveringCanvas: m ? !0 : null });
      }
      function d(M) {
        if (M.isKilled || t.getInstanceState().isPenMode && M.pointerType !== "pen") return;
        const m = M.pointerType === "mouse" || M.pointerType === "pen";
        t.updateInstanceState({ isHoveringCanvas: m ? !1 : null });
      }
      function u(M) {
        M.isKilled = !0, Ke(M);
      }
      function h(M) {
        M.isKilled = !0, M.target instanceof HTMLElement && M.target.tagName !== "A" && M.target.tagName !== "TEXTAREA" && // When in EditingShape state, we are actually clicking on a 'DIV'
        // not A/TEXTAREA element yet. So, to preserve cursor position
        // for edit mode on mobile we need to not preventDefault.
        // TODO: Find out if we still need this preventDefault in general though.
        !(t.getEditingShape() && M.target.className.includes("tl-text-content")) && Ke(M);
      }
      function g(M) {
        Ke(M);
      }
      async function p(M) {
        var y, I;
        if (Ke(M), Yt(M), !((I = (y = M.dataTransfer) == null ? void 0 : y.files) != null && I.length)) return;
        const m = Array.from(M.dataTransfer.files);
        await t.putExternalContent({
          type: "files",
          files: m,
          point: t.screenToPage({ x: M.clientX, y: M.clientY }),
          ignoreParent: !1
        });
      }
      function f(M) {
        Yt(M);
      }
      return {
        onPointerDown: s,
        onPointerMove: o,
        onPointerUp: a,
        onPointerEnter: c,
        onPointerLeave: d,
        onDragOver: g,
        onDrop: p,
        onTouchStart: u,
        onTouchEnd: h,
        onClick: f
      };
    },
    [t]
  );
}
function qW() {
  const t = Q();
  ze(() => {
    let e = t.getInstanceState().isCoarsePointer;
    const n = (o) => {
      const a = o.pointerType !== "mouse";
      e !== a && (e = a, t.updateInstanceState({ isCoarsePointer: a }));
    };
    window.addEventListener("pointerdown", n, { capture: !0 });
    const i = window.matchMedia && window.matchMedia("(any-pointer: coarse)"), r = mt.isFirefox && !mt.isAndroid && !mt.isIos, s = () => {
      const o = r ? !1 : i.matches;
      e === o && (e = o, t.updateInstanceState({ isCoarsePointer: o }));
    };
    return i && (i.addEventListener("change", s), s()), () => {
      window.removeEventListener("pointerdown", n, { capture: !0 }), i && i.removeEventListener("change", s);
    };
  }, [t]);
}
const jv = Ii(null);
function _W({ container: t, children: e }) {
  return /* @__PURE__ */ l.jsx(jv.Provider, { value: t, children: e });
}
function qt() {
  return oi(Vn(jv), "useContainer used outside of <Tldraw />");
}
function $W() {
  const t = Q(), e = qt(), n = G("isFocused", () => t.getIsFocused(), [t]);
  ze(() => {
    if (!e) return;
    function i(r) {
      if (r.isSpecialRedispatchedEvent) return;
      Ke(r), Yt(r);
      const s = e.querySelector(".tl-canvas");
      if (!s) return;
      const o = new DragEvent(r.type, r);
      o.isSpecialRedispatchedEvent = !0, s.dispatchEvent(o);
    }
    return e.addEventListener("dragover", i), e.addEventListener("drop", i), () => {
      e.removeEventListener("dragover", i), e.removeEventListener("drop", i);
    };
  }, [e]), ze(() => {
    if (typeof window > "u" || !("matchMedia" in window)) return;
    let i = null;
    const r = () => {
      i != null && i();
      const s = `(resolution: ${window.devicePixelRatio}dppx)`, o = matchMedia(s), a = (c) => {
        c.type === "change" && r();
      };
      o.addEventListener ? o.addEventListener("change", r) : o.addListener && o.addListener(a), i = () => {
        o.removeEventListener ? o.removeEventListener("change", r) : o.removeListener && o.removeListener(a);
      }, t.updateInstanceState({ devicePixelRatio: window.devicePixelRatio });
    };
    return r(), () => {
      i == null || i();
    };
  }, [t]), ze(() => {
    if (!n) return;
    const i = (a) => {
      if (a.altKey && // todo: When should we allow the alt key to be used? Perhaps states should declare which keys matter to them?
      (t.isIn("zoom") || !t.getPath().endsWith(".idle")) && !Au(t) && Ke(a), a.isKilled) return;
      switch (a.isKilled = !0, a.key) {
        case "=":
        case "-":
        case "0": {
          if (a.metaKey || a.ctrlKey) {
            Ke(a);
            return;
          }
          break;
        }
        case "Tab": {
          if (Au(t))
            return;
          break;
        }
        case ",":
          return;
        case "Escape": {
          if ((t.getEditingShape() || t.getSelectedShapeIds().length > 0) && Ke(a), t.menus.getOpenMenus().length > 0) return;
          t.inputs.keys.has("Escape") || (t.inputs.keys.add("Escape"), t.cancel(), e.focus());
          return;
        }
        default:
          if (Au(t))
            return;
      }
      const c = {
        type: "keyboard",
        name: a.repeat ? "key_repeat" : "key_down",
        key: a.key,
        code: a.code,
        shiftKey: a.shiftKey,
        altKey: a.altKey,
        ctrlKey: a.metaKey || a.ctrlKey,
        metaKey: a.metaKey,
        accelKey: bn(a)
      };
      t.dispatch(c);
    }, r = (a) => {
      if (a.isKilled || (a.isKilled = !0, Au(t)) || a.key === ",")
        return;
      const c = {
        type: "keyboard",
        name: "key_up",
        key: a.key,
        code: a.code,
        shiftKey: a.shiftKey,
        altKey: a.altKey,
        ctrlKey: a.metaKey || a.ctrlKey,
        metaKey: a.metaKey,
        accelKey: bn(a)
      };
      t.dispatch(c);
    };
    function s(a) {
      var c, d;
      if (e.contains(a.target)) {
        const u = a.touches[0].pageX, h = a.touches[0].radiusX || 0;
        (u - h < 10 || u + h > t.getViewportScreenBounds().width - 10) && (((c = a.target) == null ? void 0 : c.tagName) === "BUTTON" && ((d = a.target) == null || d.click()), Ke(a));
      }
    }
    const o = (a) => {
      e.contains(a.target) && (a.ctrlKey || a.metaKey) && Ke(a);
    };
    return e.addEventListener("touchstart", s, { passive: !1 }), e.addEventListener("wheel", o, { passive: !1 }), document.addEventListener("gesturestart", Ke), document.addEventListener("gesturechange", Ke), document.addEventListener("gestureend", Ke), e.addEventListener("keydown", i), e.addEventListener("keyup", r), () => {
      e.removeEventListener("touchstart", s), e.removeEventListener("wheel", o), document.removeEventListener("gesturestart", Ke), document.removeEventListener("gesturechange", Ke), document.removeEventListener("gestureend", Ke), e.removeEventListener("keydown", i), e.removeEventListener("keyup", r);
    };
  }, [t, e, n]);
}
const eH = ["input", "select", "button", "textarea"];
function Au(t) {
  const { activeElement: e } = document;
  return t.menus.hasOpenMenus() || e && (e.getAttribute("contenteditable") || eH.indexOf(e.tagName.toLowerCase()) > -1);
}
const tH = ["textarea", "input"];
function nH(t) {
  const e = Q();
  ze(() => {
    const n = t.current;
    if (!n) return;
    const i = (r) => {
      var s;
      if (r instanceof PointerEvent && r.pointerType === "pen") {
        r.isKilled = !0;
        const { target: o } = r;
        if (tH.includes((s = o.tagName) == null ? void 0 : s.toLocaleLowerCase()) || e.isIn("select.editing_shape"))
          return;
        Ke(r);
      }
    };
    return n.addEventListener("touchstart", i), n.addEventListener("touchend", i), () => {
      n.removeEventListener("touchstart", i), n.removeEventListener("touchend", i);
    };
  }, [e, t]);
}
function iH(t, e, n) {
  return Math.max(e, Math.min(t, n));
}
const Mn = {
  toVector(t, e) {
    return t === void 0 && (t = e), Array.isArray(t) ? t : [t, t];
  },
  add(t, e) {
    return [t[0] + e[0], t[1] + e[1]];
  },
  sub(t, e) {
    return [t[0] - e[0], t[1] - e[1]];
  },
  addTo(t, e) {
    t[0] += e[0], t[1] += e[1];
  },
  subTo(t, e) {
    t[0] -= e[0], t[1] -= e[1];
  }
};
function P0(t, e, n) {
  return e === 0 || Math.abs(e) === 1 / 0 ? Math.pow(t, n * 5) : t * e * n / (e + n * t);
}
function U0(t, e, n, i = 0.15) {
  return i === 0 ? iH(t, e, n) : t < e ? -P0(e - t, n - e, i) + e : t > n ? +P0(t - n, n - e, i) + n : t;
}
function rH(t, [e, n], [i, r]) {
  const [[s, o], [a, c]] = t;
  return [U0(e, s, o, i), U0(n, a, c, r)];
}
function sH(t, e) {
  if (typeof t != "object" || t === null) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(t, e || "default");
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function oH(t) {
  var e = sH(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function An(t, e, n) {
  return e = oH(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function R0(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Ut(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? R0(Object(n), !0).forEach(function(i) {
      An(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : R0(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
const Dv = {
  pointer: {
    start: "down",
    change: "move",
    end: "up"
  },
  mouse: {
    start: "down",
    change: "move",
    end: "up"
  },
  touch: {
    start: "start",
    change: "move",
    end: "end"
  },
  gesture: {
    start: "start",
    change: "change",
    end: "end"
  }
};
function Y0(t) {
  return t ? t[0].toUpperCase() + t.slice(1) : "";
}
const aH = ["enter", "leave"];
function cH(t = !1, e) {
  return t && !aH.includes(e);
}
function lH(t, e = "", n = !1) {
  const i = Dv[t], r = i && i[e] || e;
  return "on" + Y0(t) + Y0(r) + (cH(n, r) ? "Capture" : "");
}
const dH = ["gotpointercapture", "lostpointercapture"];
function uH(t) {
  let e = t.substring(2).toLowerCase();
  const n = !!~e.indexOf("passive");
  n && (e = e.replace("passive", ""));
  const i = dH.includes(e) ? "capturecapture" : "capture", r = !!~e.indexOf(i);
  return r && (e = e.replace("capture", "")), {
    device: e,
    capture: r,
    passive: n
  };
}
function hH(t, e = "") {
  const n = Dv[t], i = n && n[e] || e;
  return t + i;
}
function wv(t) {
  return "touches" in t;
}
function gH(t) {
  return wv(t) ? "touch" : "pointerType" in t ? t.pointerType : "mouse";
}
function pH(t) {
  return Array.from(t.touches).filter((e) => {
    var n, i;
    return e.target === t.currentTarget || ((n = t.currentTarget) === null || n === void 0 || (i = n.contains) === null || i === void 0 ? void 0 : i.call(n, e.target));
  });
}
function By(t, e) {
  try {
    const n = e.clientX - t.clientX, i = e.clientY - t.clientY, r = (e.clientX + t.clientX) / 2, s = (e.clientY + t.clientY) / 2, o = Math.hypot(n, i);
    return {
      angle: -(Math.atan2(n, i) * 180) / Math.PI,
      distance: o,
      origin: [r, s]
    };
  } catch {
  }
  return null;
}
function fH(t) {
  return pH(t).map((e) => e.identifier);
}
function Q0(t, e) {
  const [n, i] = Array.from(t.touches).filter((r) => e.includes(r.identifier));
  return By(n, i);
}
const Z0 = 40, F0 = 800;
function Nv(t) {
  let {
    deltaX: e,
    deltaY: n,
    deltaMode: i
  } = t;
  return i === 1 ? (e *= Z0, n *= Z0) : i === 2 && (e *= F0, n *= F0), [e, n];
}
function MH(t) {
  const e = {};
  if ("buttons" in t && (e.buttons = t.buttons), "shiftKey" in t) {
    const {
      shiftKey: n,
      altKey: i,
      metaKey: r,
      ctrlKey: s
    } = t;
    Object.assign(e, {
      shiftKey: n,
      altKey: i,
      metaKey: r,
      ctrlKey: s
    });
  }
  return e;
}
function Cg(t, ...e) {
  return typeof t == "function" ? t(...e) : t;
}
function mH() {
}
function yH(...t) {
  return t.length === 0 ? mH : t.length === 1 ? t[0] : function() {
    let e;
    for (const n of t)
      e = n.apply(this, arguments) || e;
    return e;
  };
}
function B0(t, e) {
  return Object.assign({}, e, t || {});
}
const IH = 32;
class Av {
  constructor(e, n, i) {
    this.ctrl = e, this.args = n, this.key = i, this.state || (this.state = {}, this.computeValues([0, 0]), this.computeInitial(), this.init && this.init(), this.reset());
  }
  get state() {
    return this.ctrl.state[this.key];
  }
  set state(e) {
    this.ctrl.state[this.key] = e;
  }
  get shared() {
    return this.ctrl.state.shared;
  }
  get eventStore() {
    return this.ctrl.gestureEventStores[this.key];
  }
  get timeoutStore() {
    return this.ctrl.gestureTimeoutStores[this.key];
  }
  get config() {
    return this.ctrl.config[this.key];
  }
  get sharedConfig() {
    return this.ctrl.config.shared;
  }
  get handler() {
    return this.ctrl.handlers[this.key];
  }
  reset() {
    const {
      state: e,
      shared: n,
      ingKey: i,
      args: r
    } = this;
    n[i] = e._active = e.active = e._blocked = e._force = !1, e._step = [!1, !1], e.intentional = !1, e._movement = [0, 0], e._distance = [0, 0], e._direction = [0, 0], e._delta = [0, 0], e._bounds = [[-1 / 0, 1 / 0], [-1 / 0, 1 / 0]], e.args = r, e.axis = void 0, e.memo = void 0, e.elapsedTime = e.timeDelta = 0, e.direction = [0, 0], e.distance = [0, 0], e.overflow = [0, 0], e._movementBound = [!1, !1], e.velocity = [0, 0], e.movement = [0, 0], e.delta = [0, 0], e.timeStamp = 0;
  }
  start(e) {
    const n = this.state, i = this.config;
    n._active || (this.reset(), this.computeInitial(), n._active = !0, n.target = e.target, n.currentTarget = e.currentTarget, n.lastOffset = i.from ? Cg(i.from, n) : n.offset, n.offset = n.lastOffset, n.startTime = n.timeStamp = e.timeStamp);
  }
  computeValues(e) {
    const n = this.state;
    n._values = e, n.values = this.config.transform(e);
  }
  computeInitial() {
    const e = this.state;
    e._initial = e._values, e.initial = e.values;
  }
  compute(e) {
    const {
      state: n,
      config: i,
      shared: r
    } = this;
    n.args = this.args;
    let s = 0;
    if (e && (n.event = e, i.preventDefault && e.cancelable && n.event.preventDefault(), n.type = e.type, r.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size, r.locked = !!document.pointerLockElement, Object.assign(r, MH(e)), r.down = r.pressed = r.buttons % 2 === 1 || r.touches > 0, s = e.timeStamp - n.timeStamp, n.timeStamp = e.timeStamp, n.elapsedTime = n.timeStamp - n.startTime), n._active) {
      const A = n._delta.map(Math.abs);
      Mn.addTo(n._distance, A);
    }
    this.axisIntent && this.axisIntent(e);
    const [o, a] = n._movement, [c, d] = i.threshold, {
      _step: u,
      values: h
    } = n;
    if (i.hasCustomTransform ? (u[0] === !1 && (u[0] = Math.abs(o) >= c && h[0]), u[1] === !1 && (u[1] = Math.abs(a) >= d && h[1])) : (u[0] === !1 && (u[0] = Math.abs(o) >= c && Math.sign(o) * c), u[1] === !1 && (u[1] = Math.abs(a) >= d && Math.sign(a) * d)), n.intentional = u[0] !== !1 || u[1] !== !1, !n.intentional) return;
    const g = [0, 0];
    if (i.hasCustomTransform) {
      const [A, b] = h;
      g[0] = u[0] !== !1 ? A - u[0] : 0, g[1] = u[1] !== !1 ? b - u[1] : 0;
    } else
      g[0] = u[0] !== !1 ? o - u[0] : 0, g[1] = u[1] !== !1 ? a - u[1] : 0;
    this.restrictToAxis && !n._blocked && this.restrictToAxis(g);
    const p = n.offset, f = n._active && !n._blocked || n.active;
    f && (n.first = n._active && !n.active, n.last = !n._active && n.active, n.active = r[this.ingKey] = n._active, e && (n.first && ("bounds" in i && (n._bounds = Cg(i.bounds, n)), this.setup && this.setup()), n.movement = g, this.computeOffset()));
    const [M, m] = n.offset, [[y, I], [D, j]] = n._bounds;
    n.overflow = [M < y ? -1 : M > I ? 1 : 0, m < D ? -1 : m > j ? 1 : 0], n._movementBound[0] = n.overflow[0] ? n._movementBound[0] === !1 ? n._movement[0] : n._movementBound[0] : !1, n._movementBound[1] = n.overflow[1] ? n._movementBound[1] === !1 ? n._movement[1] : n._movementBound[1] : !1;
    const w = n._active ? i.rubberband || [0, 0] : [0, 0];
    if (n.offset = rH(n._bounds, n.offset, w), n.delta = Mn.sub(n.offset, p), this.computeMovement(), f && (!n.last || s > IH)) {
      n.delta = Mn.sub(n.offset, p);
      const A = n.delta.map(Math.abs);
      Mn.addTo(n.distance, A), n.direction = n.delta.map(Math.sign), n._direction = n._delta.map(Math.sign), !n.first && s > 0 && (n.velocity = [A[0] / s, A[1] / s], n.timeDelta = s);
    }
  }
  emit() {
    const e = this.state, n = this.shared, i = this.config;
    if (e._active || this.clean(), (e._blocked || !e.intentional) && !e._force && !i.triggerAllEvents) return;
    const r = this.handler(Ut(Ut(Ut({}, n), e), {}, {
      [this.aliasKey]: e.values
    }));
    r !== void 0 && (e.memo = r);
  }
  clean() {
    this.eventStore.clean(), this.timeoutStore.clean();
  }
}
function xH([t, e], n) {
  const i = Math.abs(t), r = Math.abs(e);
  if (i > r && i > n)
    return "x";
  if (r > i && r > n)
    return "y";
}
class SH extends Av {
  constructor(...e) {
    super(...e), An(this, "aliasKey", "xy");
  }
  reset() {
    super.reset(), this.state.axis = void 0;
  }
  init() {
    this.state.offset = [0, 0], this.state.lastOffset = [0, 0];
  }
  computeOffset() {
    this.state.offset = Mn.add(this.state.lastOffset, this.state.movement);
  }
  computeMovement() {
    this.state.movement = Mn.sub(this.state.offset, this.state.lastOffset);
  }
  axisIntent(e) {
    const n = this.state, i = this.config;
    if (!n.axis && e) {
      const r = typeof i.axisThreshold == "object" ? i.axisThreshold[gH(e)] : i.axisThreshold;
      n.axis = xH(n._movement, r);
    }
    n._blocked = (i.lockDirection || !!i.axis) && !n.axis || !!i.axis && i.axis !== n.axis;
  }
  restrictToAxis(e) {
    if (this.config.axis || this.config.lockDirection)
      switch (this.state.axis) {
        case "x":
          e[1] = 0;
          break;
        case "y":
          e[0] = 0;
          break;
      }
  }
}
const G0 = (t) => t, W0 = 0.15, eS = {
  enabled(t = !0) {
    return t;
  },
  eventOptions(t, e, n) {
    return Ut(Ut({}, n.shared.eventOptions), t);
  },
  preventDefault(t = !1) {
    return t;
  },
  triggerAllEvents(t = !1) {
    return t;
  },
  rubberband(t = 0) {
    switch (t) {
      case !0:
        return [W0, W0];
      case !1:
        return [0, 0];
      default:
        return Mn.toVector(t);
    }
  },
  from(t) {
    if (typeof t == "function") return t;
    if (t != null) return Mn.toVector(t);
  },
  transform(t, e, n) {
    const i = t || n.shared.transform;
    if (this.hasCustomTransform = !!i, process.env.NODE_ENV === "development") {
      const r = i || G0;
      return (s) => {
        const o = r(s);
        return (!isFinite(o[0]) || !isFinite(o[1])) && console.warn(`[@use-gesture]: config.transform() must produce a valid result, but it was: [${o[0]},${[1]}]`), o;
      };
    }
    return i || G0;
  },
  threshold(t) {
    return Mn.toVector(t, 0);
  }
};
process.env.NODE_ENV === "development" && Object.assign(eS, {
  domTarget(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `domTarget` option has been renamed to `target`.");
    return NaN;
  },
  lockDirection(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `lockDirection` option has been merged with `axis`. Use it as in `{ axis: 'lock' }`");
    return NaN;
  },
  initial(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `initial` option has been renamed to `from`.");
    return NaN;
  }
});
const jH = 0, Md = Ut(Ut({}, eS), {}, {
  axis(t, e, {
    axis: n
  }) {
    if (this.lockDirection = n === "lock", !this.lockDirection) return n;
  },
  axisThreshold(t = jH) {
    return t;
  },
  bounds(t = {}) {
    if (typeof t == "function")
      return (s) => Md.bounds(t(s));
    if ("current" in t)
      return () => t.current;
    if (typeof HTMLElement == "function" && t instanceof HTMLElement)
      return t;
    const {
      left: e = -1 / 0,
      right: n = 1 / 0,
      top: i = -1 / 0,
      bottom: r = 1 / 0
    } = t;
    return [[e, n], [i, r]];
  }
}), md = typeof window < "u" && window.document && window.document.createElement;
function Tv() {
  return md && "ontouchstart" in window;
}
function DH() {
  return Tv() || md && window.navigator.maxTouchPoints > 1;
}
function wH() {
  return md && "onpointerdown" in window;
}
function NH() {
  return md && "exitPointerLock" in window.document;
}
function AH() {
  try {
    return "constructor" in GestureEvent;
  } catch {
    return !1;
  }
}
const Wi = {
  isBrowser: md,
  gesture: AH(),
  touch: Tv(),
  touchscreen: DH(),
  pointer: wH(),
  pointerLock: NH()
}, TH = 250, bH = 180, vH = 0.5, EH = 50, CH = 250, zH = 10, H0 = {
  mouse: 0,
  touch: 0,
  pen: 8
}, LH = Ut(Ut({}, Md), {}, {
  device(t, e, {
    pointer: {
      touch: n = !1,
      lock: i = !1,
      mouse: r = !1
    } = {}
  }) {
    return this.pointerLock = i && Wi.pointerLock, Wi.touch && n ? "touch" : this.pointerLock ? "mouse" : Wi.pointer && !r ? "pointer" : Wi.touch ? "touch" : "mouse";
  },
  preventScrollAxis(t, e, {
    preventScroll: n
  }) {
    if (this.preventScrollDelay = typeof n == "number" ? n : n || n === void 0 && t ? TH : void 0, !(!Wi.touchscreen || n === !1))
      return t || (n !== void 0 ? "y" : void 0);
  },
  pointerCapture(t, e, {
    pointer: {
      capture: n = !0,
      buttons: i = 1,
      keys: r = !0
    } = {}
  }) {
    return this.pointerButtons = i, this.keys = r, !this.pointerLock && this.device === "pointer" && n;
  },
  threshold(t, e, {
    filterTaps: n = !1,
    tapsThreshold: i = 3,
    axis: r = void 0
  }) {
    const s = Mn.toVector(t, n ? i : r ? 1 : 0);
    return this.filterTaps = n, this.tapsThreshold = i, s;
  },
  swipe({
    velocity: t = vH,
    distance: e = EH,
    duration: n = CH
  } = {}) {
    return {
      velocity: this.transform(Mn.toVector(t)),
      distance: this.transform(Mn.toVector(e)),
      duration: n
    };
  },
  delay(t = 0) {
    switch (t) {
      case !0:
        return bH;
      case !1:
        return 0;
      default:
        return t;
    }
  },
  axisThreshold(t) {
    return t ? Ut(Ut({}, H0), t) : H0;
  },
  keyboardDisplacement(t = zH) {
    return t;
  }
});
process.env.NODE_ENV === "development" && Object.assign(LH, {
  useTouch(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `useTouch` option has been renamed to `pointer.touch`. Use it as in `{ pointer: { touch: true } }`.");
    return NaN;
  },
  experimental_preventWindowScrollY(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `experimental_preventWindowScrollY` option has been renamed to `preventScroll`.");
    return NaN;
  },
  swipeVelocity(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `swipeVelocity` option has been renamed to `swipe.velocity`. Use it as in `{ swipe: { velocity: 0.5 } }`.");
    return NaN;
  },
  swipeDistance(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `swipeDistance` option has been renamed to `swipe.distance`. Use it as in `{ swipe: { distance: 50 } }`.");
    return NaN;
  },
  swipeDuration(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `swipeDuration` option has been renamed to `swipe.duration`. Use it as in `{ swipe: { duration: 250 } }`.");
    return NaN;
  }
});
function bv(t) {
  const [e, n] = t.overflow, [i, r] = t._delta, [s, o] = t._direction;
  (e < 0 && i > 0 && s < 0 || e > 0 && i < 0 && s > 0) && (t._movement[0] = t._movementBound[0]), (n < 0 && r > 0 && o < 0 || n > 0 && r < 0 && o > 0) && (t._movement[1] = t._movementBound[1]);
}
const kH = 30, OH = 100;
class PH extends Av {
  constructor(...e) {
    super(...e), An(this, "ingKey", "pinching"), An(this, "aliasKey", "da");
  }
  init() {
    this.state.offset = [1, 0], this.state.lastOffset = [1, 0], this.state._pointerEvents = /* @__PURE__ */ new Map();
  }
  reset() {
    super.reset();
    const e = this.state;
    e._touchIds = [], e.canceled = !1, e.cancel = this.cancel.bind(this), e.turns = 0;
  }
  computeOffset() {
    const {
      type: e,
      movement: n,
      lastOffset: i
    } = this.state;
    e === "wheel" ? this.state.offset = Mn.add(n, i) : this.state.offset = [(1 + n[0]) * i[0], n[1] + i[1]];
  }
  computeMovement() {
    const {
      offset: e,
      lastOffset: n
    } = this.state;
    this.state.movement = [e[0] / n[0], e[1] - n[1]];
  }
  axisIntent() {
    const e = this.state, [n, i] = e._movement;
    if (!e.axis) {
      const r = Math.abs(n) * kH - Math.abs(i);
      r < 0 ? e.axis = "angle" : r > 0 && (e.axis = "scale");
    }
  }
  restrictToAxis(e) {
    this.config.lockDirection && (this.state.axis === "scale" ? e[1] = 0 : this.state.axis === "angle" && (e[0] = 0));
  }
  cancel() {
    const e = this.state;
    e.canceled || setTimeout(() => {
      e.canceled = !0, e._active = !1, this.compute(), this.emit();
    }, 0);
  }
  touchStart(e) {
    this.ctrl.setEventIds(e);
    const n = this.state, i = this.ctrl.touchIds;
    if (n._active && n._touchIds.every((s) => i.has(s)) || i.size < 2) return;
    this.start(e), n._touchIds = Array.from(i).slice(0, 2);
    const r = Q0(e, n._touchIds);
    r && this.pinchStart(e, r);
  }
  pointerStart(e) {
    if (e.buttons != null && e.buttons % 2 !== 1) return;
    this.ctrl.setEventIds(e), e.target.setPointerCapture(e.pointerId);
    const n = this.state, i = n._pointerEvents, r = this.ctrl.pointerIds;
    if (n._active && Array.from(i.keys()).every((o) => r.has(o)) || (i.size < 2 && i.set(e.pointerId, e), n._pointerEvents.size < 2)) return;
    this.start(e);
    const s = By(...Array.from(i.values()));
    s && this.pinchStart(e, s);
  }
  pinchStart(e, n) {
    const i = this.state;
    i.origin = n.origin, this.computeValues([n.distance, n.angle]), this.computeInitial(), this.compute(e), this.emit();
  }
  touchMove(e) {
    if (!this.state._active) return;
    const n = Q0(e, this.state._touchIds);
    n && this.pinchMove(e, n);
  }
  pointerMove(e) {
    const n = this.state._pointerEvents;
    if (n.has(e.pointerId) && n.set(e.pointerId, e), !this.state._active) return;
    const i = By(...Array.from(n.values()));
    i && this.pinchMove(e, i);
  }
  pinchMove(e, n) {
    const i = this.state, r = i._values[1], s = n.angle - r;
    let o = 0;
    Math.abs(s) > 270 && (o += Math.sign(s)), this.computeValues([n.distance, n.angle - 360 * o]), i.origin = n.origin, i.turns = o, i._movement = [i._values[0] / i._initial[0] - 1, i._values[1] - i._initial[1]], this.compute(e), this.emit();
  }
  touchEnd(e) {
    this.ctrl.setEventIds(e), this.state._active && this.state._touchIds.some((n) => !this.ctrl.touchIds.has(n)) && (this.state._active = !1, this.compute(e), this.emit());
  }
  pointerEnd(e) {
    const n = this.state;
    this.ctrl.setEventIds(e);
    try {
      e.target.releasePointerCapture(e.pointerId);
    } catch {
    }
    n._pointerEvents.has(e.pointerId) && n._pointerEvents.delete(e.pointerId), n._active && n._pointerEvents.size < 2 && (n._active = !1, this.compute(e), this.emit());
  }
  gestureStart(e) {
    e.cancelable && e.preventDefault();
    const n = this.state;
    n._active || (this.start(e), this.computeValues([e.scale, e.rotation]), n.origin = [e.clientX, e.clientY], this.compute(e), this.emit());
  }
  gestureMove(e) {
    if (e.cancelable && e.preventDefault(), !this.state._active) return;
    const n = this.state;
    this.computeValues([e.scale, e.rotation]), n.origin = [e.clientX, e.clientY];
    const i = n._movement;
    n._movement = [e.scale - 1, e.rotation], n._delta = Mn.sub(n._movement, i), this.compute(e), this.emit();
  }
  gestureEnd(e) {
    this.state._active && (this.state._active = !1, this.compute(e), this.emit());
  }
  wheel(e) {
    const n = this.config.modifierKey;
    n && (Array.isArray(n) ? !n.find((i) => e[i]) : !e[n]) || (this.state._active ? this.wheelChange(e) : this.wheelStart(e), this.timeoutStore.add("wheelEnd", this.wheelEnd.bind(this)));
  }
  wheelStart(e) {
    this.start(e), this.wheelChange(e);
  }
  wheelChange(e) {
    "uv" in e || (e.cancelable && e.preventDefault(), process.env.NODE_ENV === "development" && !e.defaultPrevented && console.warn("[@use-gesture]: To properly support zoom on trackpads, try using the `target` option.\n\nThis message will only appear in development mode."));
    const i = this.state;
    i._delta = [-Nv(e)[1] / OH * i.offset[0], 0], Mn.addTo(i._movement, i._delta), bv(i), this.state.origin = [e.clientX, e.clientY], this.compute(e), this.emit();
  }
  wheelEnd() {
    this.state._active && (this.state._active = !1, this.compute(), this.emit());
  }
  bind(e) {
    const n = this.config.device;
    n && (e(n, "start", this[n + "Start"].bind(this)), e(n, "change", this[n + "Move"].bind(this)), e(n, "end", this[n + "End"].bind(this)), e(n, "cancel", this[n + "End"].bind(this)), e("lostPointerCapture", "", this[n + "End"].bind(this))), this.config.pinchOnWheel && e("wheel", "", this.wheel.bind(this), {
      passive: !1
    });
  }
}
const UH = Ut(Ut({}, eS), {}, {
  device(t, e, {
    shared: n,
    pointer: {
      touch: i = !1
    } = {}
  }) {
    if (n.target && !Wi.touch && Wi.gesture) return "gesture";
    if (Wi.touch && i) return "touch";
    if (Wi.touchscreen) {
      if (Wi.pointer) return "pointer";
      if (Wi.touch) return "touch";
    }
  },
  bounds(t, e, {
    scaleBounds: n = {},
    angleBounds: i = {}
  }) {
    const r = (o) => {
      const a = B0(Cg(n, o), {
        min: -1 / 0,
        max: 1 / 0
      });
      return [a.min, a.max];
    }, s = (o) => {
      const a = B0(Cg(i, o), {
        min: -1 / 0,
        max: 1 / 0
      });
      return [a.min, a.max];
    };
    return typeof n != "function" && typeof i != "function" ? [r(), s()] : (o) => [r(o), s(o)];
  },
  threshold(t, e, n) {
    return this.lockDirection = n.axis === "lock", Mn.toVector(t, this.lockDirection ? [0.1, 3] : 0);
  },
  modifierKey(t) {
    return t === void 0 ? "ctrlKey" : t;
  },
  pinchOnWheel(t = !0) {
    return t;
  }
});
Ut(Ut({}, Md), {}, {
  mouseOnly: (t = !0) => t
});
class RH extends SH {
  constructor(...e) {
    super(...e), An(this, "ingKey", "wheeling");
  }
  wheel(e) {
    this.state._active || this.start(e), this.wheelChange(e), this.timeoutStore.add("wheelEnd", this.wheelEnd.bind(this));
  }
  wheelChange(e) {
    const n = this.state;
    n._delta = Nv(e), Mn.addTo(n._movement, n._delta), bv(n), this.compute(e), this.emit();
  }
  wheelEnd() {
    this.state._active && (this.state._active = !1, this.compute(), this.emit());
  }
  bind(e) {
    e("wheel", "", this.wheel.bind(this));
  }
}
const YH = Md;
Ut(Ut({}, Md), {}, {
  mouseOnly: (t = !0) => t
});
const tS = /* @__PURE__ */ new Map(), Gy = /* @__PURE__ */ new Map();
function QH(t) {
  tS.set(t.key, t.engine), Gy.set(t.key, t.resolver);
}
const ZH = {
  key: "pinch",
  engine: PH,
  resolver: UH
}, FH = {
  key: "wheel",
  engine: RH,
  resolver: YH
};
function BH(t, e) {
  if (t == null) return {};
  var n = {}, i = Object.keys(t), r, s;
  for (s = 0; s < i.length; s++)
    r = i[s], !(e.indexOf(r) >= 0) && (n[r] = t[r]);
  return n;
}
function GH(t, e) {
  if (t == null) return {};
  var n = BH(t, e), i, r;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(t);
    for (r = 0; r < s.length; r++)
      i = s[r], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (n[i] = t[i]);
  }
  return n;
}
const WH = {
  target(t) {
    if (t)
      return () => "current" in t ? t.current : t;
  },
  enabled(t = !0) {
    return t;
  },
  window(t = Wi.isBrowser ? window : void 0) {
    return t;
  },
  eventOptions({
    passive: t = !0,
    capture: e = !1
  } = {}) {
    return {
      passive: t,
      capture: e
    };
  },
  transform(t) {
    return t;
  }
}, HH = ["target", "eventOptions", "window", "enabled", "transform"];
function jh(t = {}, e) {
  const n = {};
  for (const [i, r] of Object.entries(e))
    switch (typeof r) {
      case "function":
        if (process.env.NODE_ENV === "development") {
          const s = r.call(n, t[i], i, t);
          Number.isNaN(s) || (n[i] = s);
        } else
          n[i] = r.call(n, t[i], i, t);
        break;
      case "object":
        n[i] = jh(t[i], r);
        break;
      case "boolean":
        r && (n[i] = t[i]);
        break;
    }
  return n;
}
function VH(t, e, n = {}) {
  const i = t, {
    target: r,
    eventOptions: s,
    window: o,
    enabled: a,
    transform: c
  } = i, d = GH(i, HH);
  if (n.shared = jh({
    target: r,
    eventOptions: s,
    window: o,
    enabled: a,
    transform: c
  }, WH), e) {
    const u = Gy.get(e);
    n[e] = jh(Ut({
      shared: n.shared
    }, d), u);
  } else
    for (const u in d) {
      const h = Gy.get(u);
      if (h)
        n[u] = jh(Ut({
          shared: n.shared
        }, d[u]), h);
      else if (process.env.NODE_ENV === "development" && !["drag", "pinch", "scroll", "wheel", "move", "hover"].includes(u)) {
        if (u === "domTarget")
          throw Error("[@use-gesture]: `domTarget` option has been renamed to `target`.");
        console.warn(`[@use-gesture]: Unknown config key \`${u}\` was used. Please read the documentation for further information.`);
      }
    }
  return n;
}
class vv {
  constructor(e, n) {
    An(this, "_listeners", /* @__PURE__ */ new Set()), this._ctrl = e, this._gestureKey = n;
  }
  add(e, n, i, r, s) {
    const o = this._listeners, a = hH(n, i), c = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {}, d = Ut(Ut({}, c), s);
    e.addEventListener(a, r, d);
    const u = () => {
      e.removeEventListener(a, r, d), o.delete(u);
    };
    return o.add(u), u;
  }
  clean() {
    this._listeners.forEach((e) => e()), this._listeners.clear();
  }
}
class KH {
  constructor() {
    An(this, "_timeouts", /* @__PURE__ */ new Map());
  }
  add(e, n, i = 140, ...r) {
    this.remove(e), this._timeouts.set(e, window.setTimeout(n, i, ...r));
  }
  remove(e) {
    const n = this._timeouts.get(e);
    n && window.clearTimeout(n);
  }
  clean() {
    this._timeouts.forEach((e) => void window.clearTimeout(e)), this._timeouts.clear();
  }
}
class XH {
  constructor(e) {
    An(this, "gestures", /* @__PURE__ */ new Set()), An(this, "_targetEventStore", new vv(this)), An(this, "gestureEventStores", {}), An(this, "gestureTimeoutStores", {}), An(this, "handlers", {}), An(this, "config", {}), An(this, "pointerIds", /* @__PURE__ */ new Set()), An(this, "touchIds", /* @__PURE__ */ new Set()), An(this, "state", {
      shared: {
        shiftKey: !1,
        metaKey: !1,
        ctrlKey: !1,
        altKey: !1
      }
    }), JH(this, e);
  }
  setEventIds(e) {
    if (wv(e))
      return this.touchIds = new Set(fH(e)), this.touchIds;
    if ("pointerId" in e)
      return e.type === "pointerup" || e.type === "pointercancel" ? this.pointerIds.delete(e.pointerId) : e.type === "pointerdown" && this.pointerIds.add(e.pointerId), this.pointerIds;
  }
  applyHandlers(e, n) {
    this.handlers = e, this.nativeHandlers = n;
  }
  applyConfig(e, n) {
    this.config = VH(e, n, this.config);
  }
  clean() {
    this._targetEventStore.clean();
    for (const e of this.gestures)
      this.gestureEventStores[e].clean(), this.gestureTimeoutStores[e].clean();
  }
  effect() {
    return this.config.shared.target && this.bind(), () => this._targetEventStore.clean();
  }
  bind(...e) {
    const n = this.config.shared, i = {};
    let r;
    if (!(n.target && (r = n.target(), !r))) {
      if (n.enabled) {
        for (const o of this.gestures) {
          const a = this.config[o], c = V0(i, a.eventOptions, !!r);
          if (a.enabled) {
            const d = tS.get(o);
            new d(this, e, o).bind(c);
          }
        }
        const s = V0(i, n.eventOptions, !!r);
        for (const o in this.nativeHandlers)
          s(o, "", (a) => this.nativeHandlers[o](Ut(Ut({}, this.state.shared), {}, {
            event: a,
            args: e
          })), void 0, !0);
      }
      for (const s in i)
        i[s] = yH(...i[s]);
      if (!r) return i;
      for (const s in i) {
        const {
          device: o,
          capture: a,
          passive: c
        } = uH(s);
        this._targetEventStore.add(r, o, "", i[s], {
          capture: a,
          passive: c
        });
      }
    }
  }
}
function aa(t, e) {
  t.gestures.add(e), t.gestureEventStores[e] = new vv(t, e), t.gestureTimeoutStores[e] = new KH();
}
function JH(t, e) {
  e.drag && aa(t, "drag"), e.wheel && aa(t, "wheel"), e.scroll && aa(t, "scroll"), e.move && aa(t, "move"), e.pinch && aa(t, "pinch"), e.hover && aa(t, "hover");
}
const V0 = (t, e, n) => (i, r, s, o = {}, a = !1) => {
  var c, d;
  const u = (c = o.capture) !== null && c !== void 0 ? c : e.capture, h = (d = o.passive) !== null && d !== void 0 ? d : e.passive;
  let g = a ? i : lH(i, r, u);
  n && h && (g += "Passive"), t[g] = t[g] || [], t[g].push(s);
}, qH = /^on(Drag|Wheel|Scroll|Move|Pinch|Hover)/;
function _H(t) {
  const e = {}, n = {}, i = /* @__PURE__ */ new Set();
  for (let r in t)
    qH.test(r) ? (i.add(RegExp.lastMatch), n[r] = t[r]) : e[r] = t[r];
  return [n, e, i];
}
function ca(t, e, n, i, r, s) {
  if (!t.has(n)) return;
  if (!tS.has(i)) {
    process.env.NODE_ENV === "development" && console.warn(`[@use-gesture]: You've created a custom handler that that uses the \`${i}\` gesture but isn't properly configured.

Please add \`${i}Action\` when creating your handler.`);
    return;
  }
  const o = n + "Start", a = n + "End", c = (d) => {
    let u;
    return d.first && o in e && e[o](d), n in e && (u = e[n](d)), d.last && a in e && e[a](d), u;
  };
  r[i] = c, s[i] = s[i] || {};
}
function $H(t, e) {
  const [n, i, r] = _H(t), s = {};
  return ca(r, n, "onDrag", "drag", s, e), ca(r, n, "onWheel", "wheel", s, e), ca(r, n, "onScroll", "scroll", s, e), ca(r, n, "onPinch", "pinch", s, e), ca(r, n, "onMove", "move", s, e), ca(r, n, "onHover", "hover", s, e), {
    handlers: s,
    config: e,
    nativeHandlers: i
  };
}
function e6(t, e = {}, n, i) {
  const r = Ye.useMemo(() => new XH(t), []);
  if (r.applyHandlers(t, i), r.applyConfig(e, n), Ye.useEffect(r.effect.bind(r)), Ye.useEffect(() => r.clean.bind(r), []), e.target === void 0)
    return r.bind.bind(r);
}
function t6(t) {
  return t.forEach(QH), function(n, i) {
    const {
      handlers: r,
      nativeHandlers: s,
      config: o
    } = $H(n, i || {});
    return e6(r, o, void 0, s);
  };
}
const K0 = 10, n6 = /Mac|iPod|iPhone|iPad/.test(
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  typeof window > "u" ? "node" : window.navigator.platform
);
function Ev(t) {
  let { deltaY: e, deltaX: n } = t, i = 0;
  return t.ctrlKey || t.altKey || t.metaKey ? i = (Math.abs(e) > K0 ? K0 * Math.sign(e) : e) / 100 : t.shiftKey && !n6 && (n = e, e = 0), { x: -n, y: -e, z: -i };
}
const i6 = t6([FH, ZH]);
let la;
const r6 = (t) => la === void 0 ? (la = t, !1) : t - la > 120 && t - la < 160 ? (la = t, !0) : (la = t, !1);
function s6(t) {
  const e = Q(), n = N.useMemo(() => {
    let i = "not sure";
    const r = ({ event: M }) => {
      if (!e.getInstanceState().isFocused || (i = "not sure", r6(Date.now())))
        return;
      const m = e.getEditingShapeId();
      if (m) {
        const D = e.getShape(m);
        if (D && e.getShapeUtil(D).canScroll(D)) {
          const w = e.getShapePageBounds(m);
          if (w != null && w.containsPoint(e.inputs.currentPagePoint))
            return;
        }
      }
      Ke(M), Yt(M);
      const y = Ev(M);
      if (y.x === 0 && y.y === 0) return;
      const I = {
        type: "wheel",
        name: "wheel",
        delta: y,
        point: new x(M.clientX, M.clientY),
        shiftKey: M.shiftKey,
        altKey: M.altKey,
        ctrlKey: M.metaKey || M.ctrlKey,
        metaKey: M.metaKey,
        accelKey: bn(M)
      };
      e.dispatch(I);
    };
    let s = 1, o = 1, a = 1, c = 0;
    const d = new x(), u = new x(), h = (M) => {
      const m = t.current;
      i = "not sure";
      const { event: y, origin: I, da: D } = M;
      y instanceof WheelEvent || (y.target === m || m != null && m.contains(y.target)) && (u.x = I[0], u.y = I[1], d.x = I[0], d.y = I[1], s = D[0], o = e.getZoomLevel(), e.dispatch({
        type: "pinch",
        name: "pinch_start",
        point: { x: I[0], y: I[1], z: e.getZoomLevel() },
        delta: { x: 0, y: 0 },
        shiftKey: y.shiftKey,
        altKey: y.altKey,
        ctrlKey: y.metaKey || y.ctrlKey,
        metaKey: y.metaKey,
        accelKey: bn(y)
      }));
    }, g = (M) => {
      if (M && (i = "zooming"), i === "zooming")
        return;
      const m = Math.abs(c - s), y = x.Dist(d, u);
      switch (i) {
        case "not sure": {
          m > 24 ? i = "zooming" : y > 16 && (i = "panning");
          break;
        }
        case "panning": {
          m > 64 && (i = "zooming");
          break;
        }
      }
    };
    return {
      onWheel: r,
      onPinchStart: h,
      onPinchEnd: (M) => {
        const m = t.current, { event: y, origin: I, offset: D } = M;
        if (y instanceof WheelEvent || !(y.target === m || m != null && m.contains(y.target))) return;
        const j = D[0];
        i = "not sure", e.timers.requestAnimationFrame(() => {
          e.dispatch({
            type: "pinch",
            name: "pinch_end",
            point: { x: I[0], y: I[1], z: j },
            delta: { x: I[0], y: I[1] },
            shiftKey: y.shiftKey,
            altKey: y.altKey,
            ctrlKey: y.metaKey || y.ctrlKey,
            metaKey: y.metaKey,
            accelKey: bn(y)
          });
        });
      },
      onPinch: (M) => {
        const m = t.current, { event: y, origin: I, offset: D, da: j } = M;
        if (y instanceof WheelEvent || !(y.target === m || m != null && m.contains(y.target))) return;
        const w = M.type === "gesturechange" || M.type === "gestureend";
        c = j[0];
        const A = I[0] - u.x, b = I[1] - u.y;
        switch (u.x = I[0], u.y = I[1], g(w), i) {
          case "zooming": {
            a = D[0], e.dispatch({
              type: "pinch",
              name: "pinch",
              point: { x: I[0], y: I[1], z: a },
              delta: { x: A, y: b },
              shiftKey: y.shiftKey,
              altKey: y.altKey,
              ctrlKey: y.metaKey || y.ctrlKey,
              metaKey: y.metaKey,
              accelKey: bn(y)
            });
            break;
          }
          case "panning": {
            e.dispatch({
              type: "pinch",
              name: "pinch",
              point: { x: I[0], y: I[1], z: o },
              delta: { x: A, y: b },
              shiftKey: y.shiftKey,
              altKey: y.altKey,
              ctrlKey: y.metaKey || y.ctrlKey,
              metaKey: y.metaKey,
              accelKey: bn(y)
            });
            break;
          }
        }
      }
    };
  }, [e, t]);
  i6(n, {
    target: t,
    eventOptions: { passive: !1 },
    pinch: {
      from: () => [e.getZoomLevel(), 0],
      // Return the camera z to use when pinch starts
      scaleBounds: () => {
        const i = e.getBaseZoom(), r = e.getCameraOptions().zoomSteps, s = r[0] * i, o = r[r.length - 1] * i;
        return { from: e.getZoomLevel(), max: o, min: s };
      }
    }
  });
}
function AM(t, e, n) {
  const i = t.getShape(e), r = t.getShapeHandles(i);
  return { shape: i, handle: r.find((s) => s.id === n) };
}
function o6(t, e) {
  const n = Q();
  return N.useMemo(() => {
    const i = (c) => {
      if (c.isKilled) return;
      const d = Eg(c.currentTarget);
      jc(d, c);
      const { shape: u, handle: h } = AM(n, t, e);
      h && n.dispatch({
        type: "pointer",
        target: "handle",
        handle: h,
        shape: u,
        name: "pointer_down",
        ...gi(c)
      });
    };
    let r, s;
    return {
      onPointerDown: i,
      onPointerMove: (c) => {
        if (c.isKilled || c.clientX === r && c.clientY === s) return;
        r = c.clientX, s = c.clientY;
        const { shape: d, handle: u } = AM(n, t, e);
        u && n.dispatch({
          type: "pointer",
          target: "handle",
          handle: u,
          shape: d,
          name: "pointer_move",
          ...gi(c)
        });
      },
      onPointerUp: (c) => {
        if (c.isKilled) return;
        const d = Eg(c.currentTarget);
        Dc(d, c);
        const { shape: u, handle: h } = AM(n, t, e);
        h && n.dispatch({
          type: "pointer",
          target: "handle",
          handle: h,
          shape: u,
          name: "pointer_up",
          ...gi(c)
        });
      }
    };
  }, [n, t, e]);
}
function a6(t) {
  const e = Q();
  at(() => {
    const n = nx(
      () => {
        t.current && e.updateViewportScreenBounds(t.current);
      },
      200,
      {
        trailing: !0
      }
    ), i = e.timers.setInterval(n, 1e3);
    window.addEventListener("resize", n);
    const r = new ResizeObserver((a) => {
      a[0].contentRect && n();
    }), s = t.current;
    let o = null;
    return s && (r.observe(s), o = c6(s), o.addEventListener("scroll", n)), () => {
      clearInterval(i), window.removeEventListener("resize", n), r.disconnect(), o == null || o.removeEventListener("scroll", n), n.cancel();
    };
  }, [e, t]);
}
/*!
 * Author: excalidraw
 * MIT License: https://github.com/excalidraw/excalidraw/blob/master/LICENSE
 * https://github.com/excalidraw/excalidraw/blob/48c3465b19f10ec755b3eb84e21a01a468e96e43/packages/excalidraw/utils.ts#L600
 */
const c6 = (t) => {
  let e = t.parentElement;
  for (; e; ) {
    if (e === document.body)
      return document;
    const { overflowY: n } = window.getComputedStyle(e);
    if (e.scrollHeight > e.clientHeight && (n === "auto" || n === "scroll" || n === "overlay"))
      return e;
    e = e.parentElement;
  }
  return document;
};
class ae {
  constructor(e = 0, n = 0, i = 0, r = 0) {
    S(this, "x", 0);
    S(this, "y", 0);
    S(this, "w", 0);
    S(this, "h", 0);
    this.x = e, this.y = n, this.w = i, this.h = r;
  }
  // eslint-disable-next-line no-restricted-syntax
  get point() {
    return new x(this.x, this.y);
  }
  // eslint-disable-next-line no-restricted-syntax
  set point(e) {
    this.x = e.x, this.y = e.y;
  }
  // eslint-disable-next-line no-restricted-syntax
  get minX() {
    return this.x;
  }
  // eslint-disable-next-line no-restricted-syntax
  set minX(e) {
    this.x = e;
  }
  // eslint-disable-next-line no-restricted-syntax
  get midX() {
    return this.x + this.w / 2;
  }
  // eslint-disable-next-line no-restricted-syntax
  get maxX() {
    return this.x + this.w;
  }
  // eslint-disable-next-line no-restricted-syntax
  get minY() {
    return this.y;
  }
  // eslint-disable-next-line no-restricted-syntax
  set minY(e) {
    this.y = e;
  }
  // eslint-disable-next-line no-restricted-syntax
  get midY() {
    return this.y + this.h / 2;
  }
  // eslint-disable-next-line no-restricted-syntax
  get maxY() {
    return this.y + this.h;
  }
  // eslint-disable-next-line no-restricted-syntax
  get width() {
    return this.w;
  }
  // eslint-disable-next-line no-restricted-syntax
  set width(e) {
    this.w = e;
  }
  // eslint-disable-next-line no-restricted-syntax
  get height() {
    return this.h;
  }
  // eslint-disable-next-line no-restricted-syntax
  set height(e) {
    this.h = e;
  }
  // eslint-disable-next-line no-restricted-syntax
  get aspectRatio() {
    return this.width / this.height;
  }
  // eslint-disable-next-line no-restricted-syntax
  get center() {
    return new x(this.midX, this.midY);
  }
  // eslint-disable-next-line no-restricted-syntax
  set center(e) {
    this.minX = e.x - this.width / 2, this.minY = e.y - this.height / 2;
  }
  // eslint-disable-next-line no-restricted-syntax
  get corners() {
    return [
      new x(this.minX, this.minY),
      new x(this.maxX, this.minY),
      new x(this.maxX, this.maxY),
      new x(this.minX, this.maxY)
    ];
  }
  // eslint-disable-next-line no-restricted-syntax
  get cornersAndCenter() {
    return [
      new x(this.minX, this.minY),
      new x(this.maxX, this.minY),
      new x(this.maxX, this.maxY),
      new x(this.minX, this.maxY),
      this.center
    ];
  }
  // eslint-disable-next-line no-restricted-syntax
  get sides() {
    const { corners: e } = this;
    return [
      [e[0], e[1]],
      [e[1], e[2]],
      [e[2], e[3]],
      [e[3], e[0]]
    ];
  }
  // eslint-disable-next-line no-restricted-syntax
  get size() {
    return new x(this.w, this.h);
  }
  toFixed() {
    return this.x = wu(this.x), this.y = wu(this.y), this.w = wu(this.w), this.h = wu(this.h), this;
  }
  setTo(e) {
    return this.x = e.x, this.y = e.y, this.w = e.w, this.h = e.h, this;
  }
  set(e = 0, n = 0, i = 0, r = 0) {
    return this.x = e, this.y = n, this.w = i, this.h = r, this;
  }
  expand(e) {
    const n = Math.min(this.minX, e.minX), i = Math.min(this.minY, e.minY), r = Math.max(this.maxX, e.maxX), s = Math.max(this.maxY, e.maxY);
    return this.x = n, this.y = i, this.w = r - n, this.h = s - i, this;
  }
  expandBy(e) {
    return this.x -= e, this.y -= e, this.w += e * 2, this.h += e * 2, this;
  }
  scale(e) {
    return this.x /= e, this.y /= e, this.w /= e, this.h /= e, this;
  }
  clone() {
    const { x: e, y: n, w: i, h: r } = this;
    return new ae(e, n, i, r);
  }
  translate(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  snapToGrid(e) {
    const n = Math.round(this.minX / e) * e, i = Math.round(this.minY / e) * e, r = Math.round(this.maxX / e) * e, s = Math.round(this.maxY / e) * e;
    this.minX = n, this.minY = i, this.width = Math.max(1, r - n), this.height = Math.max(1, s - i);
  }
  collides(e) {
    return ae.Collides(this, e);
  }
  contains(e) {
    return ae.Contains(this, e);
  }
  includes(e) {
    return ae.Includes(this, e);
  }
  containsPoint(e, n = 0) {
    return ae.ContainsPoint(this, e, n);
  }
  getHandlePoint(e) {
    switch (e) {
      case "top_left":
        return new x(this.minX, this.minY);
      case "top_right":
        return new x(this.maxX, this.minY);
      case "bottom_left":
        return new x(this.minX, this.maxY);
      case "bottom_right":
        return new x(this.maxX, this.maxY);
      case "top":
        return new x(this.midX, this.minY);
      case "right":
        return new x(this.maxX, this.midY);
      case "bottom":
        return new x(this.midX, this.maxY);
      case "left":
        return new x(this.minX, this.midY);
    }
  }
  toJson() {
    return { x: this.minX, y: this.minY, w: this.w, h: this.h };
  }
  resize(e, n, i) {
    const { minX: r, minY: s, maxX: o, maxY: a } = this;
    let { minX: c, minY: d, maxX: u, maxY: h } = this;
    switch (e) {
      case "left":
      case "top_left":
      case "bottom_left": {
        c += n;
        break;
      }
      case "right":
      case "top_right":
      case "bottom_right": {
        u += n;
        break;
      }
    }
    switch (e) {
      case "top":
      case "top_left":
      case "top_right": {
        d += i;
        break;
      }
      case "bottom":
      case "bottom_left":
      case "bottom_right": {
        h += i;
        break;
      }
    }
    const g = (u - c) / (o - r), p = (h - d) / (a - s), f = g < 0, M = p < 0;
    if (f) {
      const m = u;
      u = c, c = m;
    }
    if (M) {
      const m = h;
      h = d, d = m;
    }
    this.minX = c, this.minY = d, this.width = Math.abs(u - c), this.height = Math.abs(h - d);
  }
  union(e) {
    const n = Math.min(this.minX, e.x), i = Math.min(this.minY, e.y), r = Math.max(this.maxX, e.w + e.x), s = Math.max(this.maxY, e.h + e.y);
    return this.x = n, this.y = i, this.width = r - n, this.height = s - i, this;
  }
  static From(e) {
    return new ae(e.x, e.y, e.w, e.h);
  }
  static FromCenter(e, n) {
    return new ae(e.x - n.x / 2, e.y - n.y / 2, n.x, n.y);
  }
  static FromPoints(e) {
    if (e.length === 0) return new ae();
    let n = 1 / 0, i = 1 / 0, r = -1 / 0, s = -1 / 0, o;
    for (let a = 0, c = e.length; a < c; a++)
      o = e[a], n = Math.min(o.x, n), i = Math.min(o.y, i), r = Math.max(o.x, r), s = Math.max(o.y, s);
    return new ae(n, i, r - n, s - i);
  }
  static Expand(e, n) {
    const i = Math.min(n.minX, e.minX), r = Math.min(n.minY, e.minY), s = Math.max(n.maxX, e.maxX), o = Math.max(n.maxY, e.maxY);
    return new ae(i, r, s - i, o - r);
  }
  static ExpandBy(e, n) {
    return new ae(e.minX - n, e.minY - n, e.width + n * 2, e.height + n * 2);
  }
  static Collides(e, n) {
    return !(e.maxX < n.minX || e.minX > n.maxX || e.maxY < n.minY || e.minY > n.maxY);
  }
  static Contains(e, n) {
    return e.minX < n.minX && e.minY < n.minY && e.maxY > n.maxY && e.maxX > n.maxX;
  }
  static Includes(e, n) {
    return ae.Collides(e, n) || ae.Contains(e, n);
  }
  static ContainsPoint(e, n, i = 0) {
    return !(n.x < e.minX - i || n.y < e.minY - i || n.x > e.maxX + i || n.y > e.maxY + i);
  }
  static Common(e) {
    let n = 1 / 0, i = 1 / 0, r = -1 / 0, s = -1 / 0;
    for (let o = 0; o < e.length; o++) {
      const a = e[o];
      n = Math.min(n, a.minX), i = Math.min(i, a.minY), r = Math.max(r, a.maxX), s = Math.max(s, a.maxY);
    }
    return new ae(n, i, r - n, s - i);
  }
  static Sides(e, n = 0) {
    const { corners: i } = e;
    return [
      [i[0], i[1]],
      [i[1], i[2]],
      [i[2], i[3]],
      [i[3], i[0]]
    ];
  }
  static Resize(e, n, i, r, s = !1) {
    const { minX: o, minY: a, maxX: c, maxY: d } = e;
    let { minX: u, minY: h, maxX: g, maxY: p } = e;
    switch (n) {
      case "left":
      case "top_left":
      case "bottom_left": {
        u += i;
        break;
      }
      case "right":
      case "top_right":
      case "bottom_right": {
        g += i;
        break;
      }
    }
    switch (n) {
      case "top":
      case "top_left":
      case "top_right": {
        h += r;
        break;
      }
      case "bottom":
      case "bottom_left":
      case "bottom_right": {
        p += r;
        break;
      }
    }
    const f = (g - u) / (c - o), M = (p - h) / (d - a), m = f < 0, y = M < 0;
    if (s) {
      const D = (c - o) / (d - a), j = Math.abs(g - u), w = Math.abs(p - h), A = j * (M < 0 ? 1 : -1) * (1 / D), b = w * (f < 0 ? 1 : -1) * D, T = D < j / w;
      switch (n) {
        case "top_left": {
          T ? h = p + A : u = g + b;
          break;
        }
        case "top_right": {
          T ? h = p + A : g = u - b;
          break;
        }
        case "bottom_right": {
          T ? p = h - A : g = u - b;
          break;
        }
        case "bottom_left": {
          T ? p = h - A : u = g + b;
          break;
        }
        case "bottom":
        case "top": {
          const E = (u + g) / 2, v = w * D;
          u = E - v / 2, g = E + v / 2;
          break;
        }
        case "left":
        case "right": {
          const E = (h + p) / 2, v = j / D;
          h = E - v / 2, p = E + v / 2;
          break;
        }
      }
    }
    if (m) {
      const D = g;
      g = u, u = D;
    }
    if (y) {
      const D = p;
      p = h, h = D;
    }
    const I = new ae(u, h, Math.abs(g - u), Math.abs(p - h));
    return {
      box: I,
      scaleX: +(I.width / e.width * (f > 0 ? 1 : -1)).toFixed(5),
      scaleY: +(I.height / e.height * (M > 0 ? 1 : -1)).toFixed(5)
    };
  }
  equals(e) {
    return ae.Equals(this, e);
  }
  static Equals(e, n) {
    return n.x === e.x && n.y === e.y && n.w === e.w && n.h === e.h;
  }
  zeroFix() {
    return this.w = Math.max(1, this.w), this.h = Math.max(1, this.h), this;
  }
  static ZeroFix(e) {
    return new ae(e.x, e.y, Math.max(1, e.w), Math.max(1, e.h));
  }
}
function l6(t) {
  switch (t) {
    case "top":
      return "bottom";
    case "bottom":
      return "top";
    case "top_left":
      return "bottom_left";
    case "top_right":
      return "bottom_right";
    case "bottom_left":
      return "top_left";
    case "bottom_right":
      return "top_right";
    default:
      return t;
  }
}
function d6(t) {
  switch (t) {
    case "left":
      return "right";
    case "right":
      return "left";
    case "top_left":
      return "top_right";
    case "top_right":
      return "top_left";
    case "bottom_left":
      return "bottom_right";
    case "bottom_right":
      return "bottom_left";
    default:
      return t;
  }
}
function u6(t) {
  return t === "top_left" || t === "top_right" || t === "bottom_right" || t === "bottom_left";
}
class ne {
  constructor(e, n, i, r, s, o) {
    S(this, "a", 1);
    S(this, "b", 0);
    S(this, "c", 0);
    S(this, "d", 1);
    S(this, "e", 0);
    S(this, "f", 0);
    this.a = e, this.b = n, this.c = i, this.d = r, this.e = s, this.f = o;
  }
  equals(e) {
    return this === e || this.a === e.a && this.b === e.b && this.c === e.c && this.d === e.d && this.e === e.e && this.f === e.f;
  }
  identity() {
    return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.e = 0, this.f = 0, this;
  }
  multiply(e) {
    const n = e, { a: i, b: r, c: s, d: o, e: a, f: c } = this;
    return this.a = i * n.a + s * n.b, this.c = i * n.c + s * n.d, this.e = i * n.e + s * n.f + a, this.b = r * n.a + o * n.b, this.d = r * n.c + o * n.d, this.f = r * n.e + o * n.f + c, this;
  }
  rotate(e, n, i) {
    return e === 0 ? this : n === void 0 ? this.multiply(ne.Rotate(e)) : this.translate(n, i).multiply(ne.Rotate(e)).translate(-n, -i);
  }
  translate(e, n) {
    return this.multiply(ne.Translate(e, n));
  }
  scale(e, n) {
    return this.multiply(ne.Scale(e, n));
  }
  invert() {
    const { a: e, b: n, c: i, d: r, e: s, f: o } = this, a = e * r - n * i;
    return this.a = r / a, this.b = n / -a, this.c = i / -a, this.d = e / a, this.e = (r * s - i * o) / -a, this.f = (n * s - e * o) / a, this;
  }
  applyToPoint(e) {
    return ne.applyToPoint(this, e);
  }
  applyToPoints(e) {
    return ne.applyToPoints(this, e);
  }
  rotation() {
    return ne.Rotation(this);
  }
  point() {
    return ne.Point(this);
  }
  decomposed() {
    return ne.Decompose(this);
  }
  toCssString() {
    return ne.toCssString(this);
  }
  setTo(e) {
    return Object.assign(this, e), this;
  }
  decompose() {
    return ne.Decompose(this);
  }
  clone() {
    return new ne(this.a, this.b, this.c, this.d, this.e, this.f);
  }
  /* --------------------- Static --------------------- */
  static Identity() {
    return new ne(1, 0, 0, 1, 0, 0);
  }
  static Translate(e, n) {
    return new ne(1, 0, 0, 1, e, n);
  }
  static Rotate(e, n, i) {
    if (e === 0) return ne.Identity();
    const r = Math.cos(e), s = Math.sin(e), o = new ne(r, s, -s, r, 0, 0);
    return n === void 0 ? o : ne.Compose(ne.Translate(n, i), o, ne.Translate(-n, -i));
  }
  static Scale(e, n, i, r) {
    const s = new ne(e, 0, 0, n, 0, 0);
    return i === void 0 ? s : ne.Compose(ne.Translate(i, r), s, ne.Translate(-i, -r));
  }
  static Multiply(e, n) {
    return {
      a: e.a * n.a + e.c * n.b,
      c: e.a * n.c + e.c * n.d,
      e: e.a * n.e + e.c * n.f + e.e,
      b: e.b * n.a + e.d * n.b,
      d: e.b * n.c + e.d * n.d,
      f: e.b * n.e + e.d * n.f + e.f
    };
  }
  static Inverse(e) {
    const n = e.a * e.d - e.b * e.c;
    return {
      a: e.d / n,
      b: e.b / -n,
      c: e.c / -n,
      d: e.a / n,
      e: (e.d * e.e - e.c * e.f) / -n,
      f: (e.b * e.e - e.a * e.f) / n
    };
  }
  static Absolute(e) {
    const n = e.a * e.d - e.b * e.c;
    return {
      a: e.d / n,
      b: e.b / -n,
      c: e.c / -n,
      d: e.a / n,
      e: (e.d * e.e - e.c * e.f) / n,
      f: (e.b * e.e - e.a * e.f) / -n
    };
  }
  static Compose(...e) {
    const n = ne.Identity();
    for (let i = 0, r = e.length; i < r; i++)
      n.multiply(e[i]);
    return n;
  }
  static Point(e) {
    return new x(e.e, e.f);
  }
  static Rotation(e) {
    let n;
    if (e.a !== 0 || e.c !== 0) {
      const i = (e.a * e.a + e.c * e.c) ** 0.5;
      n = Math.acos(e.a / i) * (e.c > 0 ? -1 : 1);
    } else if (e.b !== 0 || e.d !== 0) {
      const i = (e.b * e.b + e.d * e.d) ** 0.5;
      n = Nt + Math.acos(e.b / i) * (e.d > 0 ? -1 : 1);
    } else
      n = 0;
    return Zy(n);
  }
  static Decompose(e) {
    let n, i, r;
    if (e.a !== 0 || e.c !== 0) {
      const s = (e.a * e.a + e.c * e.c) ** 0.5;
      n = s, i = (e.a * e.d - e.b * e.c) / s, r = Math.acos(e.a / s) * (e.c > 0 ? -1 : 1);
    } else if (e.b !== 0 || e.d !== 0) {
      const s = (e.b * e.b + e.d * e.d) ** 0.5;
      n = (e.a * e.d - e.b * e.c) / s, i = s, r = Nt + Math.acos(e.b / s) * (e.d > 0 ? -1 : 1);
    } else
      n = 0, i = 0, r = 0;
    return {
      x: e.e,
      y: e.f,
      scaleX: n,
      scaleY: i,
      rotation: Zy(r)
    };
  }
  static Smooth(e, n = 1e10) {
    return e.a = Math.round(e.a * n) / n, e.b = Math.round(e.b * n) / n, e.c = Math.round(e.c * n) / n, e.d = Math.round(e.d * n) / n, e.e = Math.round(e.e * n) / n, e.f = Math.round(e.f * n) / n, e;
  }
  static toCssString(e) {
    return `matrix(${k(e.a)}, ${k(e.b)}, ${k(
      e.c
    )}, ${k(e.d)}, ${k(e.e)}, ${k(e.f)})`;
  }
  static applyToPoint(e, n) {
    return new x(
      e.a * n.x + e.c * n.y + e.e,
      e.b * n.x + e.d * n.y + e.f,
      n.z
    );
  }
  static applyToXY(e, n, i) {
    return [e.a * n + e.c * i + e.e, e.b * n + e.d * i + e.f];
  }
  static applyToPoints(e, n) {
    return n.map(
      (i) => new x(e.a * i.x + e.c * i.y + e.e, e.b * i.x + e.d * i.y + e.f, i.z)
    );
  }
  static applyToBounds(e, n) {
    return new ae(e.e + n.minX, e.f + n.minY, n.width, n.height);
  }
  static From(e) {
    return new ne(e.a, e.b, e.c, e.d, e.e, e.f);
  }
  static Cast(e) {
    return e instanceof ne ? e : ne.From(e);
  }
}
class lo {
  constructor(e) {
    S(this, "isFilled", !1);
    S(this, "isClosed", !0);
    S(this, "isLabel", !1);
    S(this, "debugColor");
    S(this, "ignore");
    S(this, "_vertices");
    S(this, "_bounds");
    S(this, "_area");
    S(this, "_length");
    this.isFilled = e.isFilled, this.isClosed = e.isClosed, this.isLabel = e.isLabel ?? !1, this.debugColor = e.debugColor, this.ignore = e.ignore;
  }
  // hitTestPoint(point: Vec, margin = 0, hitInside = false) {
  // 	// We've removed the broad phase here; that should be done outside of the call
  // 	return this.distanceToPoint(point, hitInside) <= margin
  // }
  hitTestPoint(e, n = 0, i = !1) {
    return this.isClosed && (this.isFilled || i) && yi(e, this.vertices) ? !0 : x.Dist2(e, this.nearestPoint(e)) <= n * n;
  }
  distanceToPoint(e, n = !1) {
    return e.dist(this.nearestPoint(e)) * (this.isClosed && (this.isFilled || n) && yi(e, this.vertices) ? -1 : 1);
  }
  distanceToLineSegment(e, n) {
    if (e.equals(n)) return this.distanceToPoint(e);
    const { vertices: i } = this;
    let r, s = 1 / 0, o, a, c;
    for (let d = 0; d < i.length; d++)
      a = i[d], c = x.NearestPointOnLineSegment(e, n, a, !0), o = x.Dist2(a, c), o < s && (s = o, r = c);
    if (!r) throw Error("nearest point not found");
    return this.isClosed && this.isFilled && yi(r, this.vertices) ? -s : s;
  }
  hitTestLineSegment(e, n, i = 0) {
    return this.distanceToLineSegment(e, n) <= i;
  }
  nearestPointOnLineSegment(e, n) {
    const { vertices: i } = this;
    let r, s = 1 / 0, o, a, c;
    for (let d = 0; d < i.length; d++)
      a = i[d], c = x.NearestPointOnLineSegment(e, n, a, !0), o = x.Dist2(a, c), o < s && (s = o, r = c);
    if (!r) throw Error("nearest point not found");
    return r;
  }
  isPointInBounds(e, n = 0) {
    const { bounds: i } = this;
    return !(e.x < i.minX - n || e.y < i.minY - n || e.x > i.maxX + n || e.y > i.maxY + n);
  }
  // eslint-disable-next-line no-restricted-syntax
  get vertices() {
    return this._vertices || (this._vertices = this.getVertices()), this._vertices;
  }
  getBounds() {
    return ae.FromPoints(this.vertices);
  }
  // eslint-disable-next-line no-restricted-syntax
  get bounds() {
    return this._bounds || (this._bounds = this.getBounds()), this._bounds;
  }
  // eslint-disable-next-line no-restricted-syntax
  get center() {
    return this.bounds.center;
  }
  // eslint-disable-next-line no-restricted-syntax
  get area() {
    return this._area || (this._area = this.getArea()), this._area;
  }
  getArea() {
    if (!this.isClosed)
      return 0;
    const { vertices: e } = this;
    let n = 0;
    for (let i = 0, r = e.length; i < r; i++) {
      const s = e[i], o = e[(i + 1) % r];
      n += s.x * o.y - o.x * s.y;
    }
    return n / 2;
  }
  toSimpleSvgPath() {
    let e = "";
    const { vertices: n } = this, i = n.length;
    if (i === 0) return e;
    e += `M${n[0].x},${n[0].y}`;
    for (let r = 1; r < i; r++)
      e += `L${n[r].x},${n[r].y}`;
    return this.isClosed && (e += "Z"), e;
  }
  // eslint-disable-next-line no-restricted-syntax
  get length() {
    return this._length ? this._length : (this._length = this.getLength(), this._length);
  }
  getLength() {
    const { vertices: e } = this;
    let n, i = e[0], r = 0;
    for (let s = 1; s < e.length; s++)
      n = e[s], r += x.Dist2(i, n), i = n;
    return Math.sqrt(r);
  }
}
class Ki extends lo {
  constructor(n) {
    super({ ...n, isClosed: !0, isFilled: !1 });
    S(this, "children", []);
    S(this, "ignoredChildren", []);
    for (const i of n.children)
      i.ignore ? this.ignoredChildren.push(i) : this.children.push(i);
    if (this.children.length === 0) throw Error("Group2d must have at least one child");
  }
  getVertices() {
    return this.children.filter((n) => !n.isLabel).flatMap((n) => n.vertices);
  }
  nearestPoint(n) {
    let i = 1 / 0, r;
    const { children: s } = this;
    if (s.length === 0)
      throw Error("no children");
    let o, a;
    for (const c of s)
      o = c.nearestPoint(n), a = x.Dist2(o, n), a < i && (i = a, r = o);
    if (!r) throw Error("nearest point not found");
    return r;
  }
  distanceToPoint(n, i = !1) {
    return Math.min(...this.children.map((r, s) => r.distanceToPoint(n, i || s > 0)));
  }
  hitTestPoint(n, i, r) {
    return !!this.children.filter((s) => !s.isLabel).find((s) => s.hitTestPoint(n, i, r));
  }
  hitTestLineSegment(n, i, r) {
    return !!this.children.filter((s) => !s.isLabel).find((s) => s.hitTestLineSegment(n, i, r));
  }
  getArea() {
    return this.children[0].area;
  }
  toSimpleSvgPath() {
    let n = "";
    for (const r of this.children)
      n += r.toSimpleSvgPath();
    const i = ae.FromPoints(this.vertices).corners;
    for (let r = 0, s = i.length; r < s; r++) {
      const o = i[r], a = i[(r - 1 + s) % s], c = o.dist(a), d = i[(r + 1) % s], u = o.dist(d), h = o.clone().lrp(a, 4 / c), g = o, p = o.clone().lrp(d, 4 / u);
      n += `M${h.x},${h.y} L${g.x},${g.y} L${p.x},${p.y} `;
    }
    return n;
  }
  getLength() {
    return this.children.reduce((n, i) => i.isLabel ? n : n + i.length, 0);
  }
  getSvgPathData() {
    return this.children.map((n, i) => n.isLabel ? "" : n.getSvgPathData(i === 0)).join(" ");
  }
}
function h6(t = !0) {
  const [e, n] = pe(0), i = Q();
  ze(() => {
    if (!t) return;
    const r = () => n((s) => s + 1);
    return i.on("tick", r), () => {
      i.off("tick", r);
    };
  }, [i, t]);
}
const g6 = Vt(function({
  showStroke: e = !0,
  showVertices: n = !0,
  showClosestPointOnOutline: i = !0
}) {
  const r = Q();
  h6(i);
  const s = r.getZoomLevel(), o = r.getRenderingShapes(), {
    inputs: { currentPagePoint: a }
  } = r;
  return /* @__PURE__ */ l.jsx(
    "svg",
    {
      style: {
        position: "absolute",
        pointerEvents: "none",
        zIndex: 999999999,
        top: 0,
        left: 0,
        overflow: "visible"
      },
      children: o.map((c) => {
        const d = r.getShape(c.id);
        if (d.type === "group") return null;
        const u = r.getShapeGeometry(d), h = r.getShapePageTransform(d), g = r.getPointInShapeSpace(d, a), p = u.nearestPoint(g), f = u.distanceToPoint(g, !0), M = Math.abs(f) * s, m = f < 0, { vertices: y } = u;
        return /* @__PURE__ */ l.jsxs(
          "g",
          {
            transform: h.toCssString(),
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [
              e && /* @__PURE__ */ l.jsx(
                "g",
                {
                  stroke: u.debugColor ?? "red",
                  opacity: "1",
                  strokeWidth: 2 / s,
                  fill: "none",
                  children: /* @__PURE__ */ l.jsx(Cv, { geometry: u })
                }
              ),
              n && y.map((I, D) => /* @__PURE__ */ l.jsx(
                "circle",
                {
                  cx: I.x,
                  cy: I.y,
                  r: 2 / s,
                  fill: `hsl(${Ba(D, [0, y.length - 1], [120, 200])}, 100%, 50%)`,
                  stroke: "black",
                  strokeWidth: 1 / s
                },
                `v${D}`
              )),
              i && M < 150 && /* @__PURE__ */ l.jsx(
                "line",
                {
                  x1: p.x,
                  y1: p.y,
                  x2: g.x,
                  y2: g.y,
                  opacity: 1 - M / 150,
                  stroke: m ? "goldenrod" : "dodgerblue",
                  strokeWidth: 2 / s
                }
              )
            ]
          },
          c.id + "_outline"
        );
      })
    }
  );
});
function Cv({ geometry: t }) {
  return t instanceof Ki ? /* @__PURE__ */ l.jsx(l.Fragment, { children: [...t.children, ...t.ignoredChildren].map((e, n) => /* @__PURE__ */ l.jsx(Cv, { geometry: e }, n)) }) : /* @__PURE__ */ l.jsx("path", { d: t.toSimpleSvgPath() });
}
function zv(t) {
  return mU(t);
}
function Lv() {
  const t = Q(), e = hG(
    "userIds",
    () => zv(t.getCollaborators().map((n) => n.userId)).sort(),
    { isEqual: (n, i) => {
      var r;
      return n.join(",") === ((r = i.join) == null ? void 0 : r.call(i, ","));
    } },
    [t]
  );
  return G(e);
}
function Tp(t) {
  const e = Q();
  return G(
    `latestPresence:${t}`,
    () => e.getCollaborators().find((i) => i.userId === t),
    [e, t]
  ) ?? null;
}
const p6 = Vt(function() {
  return Lv().map((n) => /* @__PURE__ */ l.jsx(f6, { collaboratorId: n }, n));
}), f6 = Vt(function({
  collaboratorId: e
}) {
  const n = Q(), i = Tp(e), r = m6(n, i);
  if (!(i && i.currentPageId === n.getCurrentPageId()))
    return null;
  switch (r) {
    case "inactive": {
      const { followingUserId: s, highlightedUserIds: o } = n.getInstanceState();
      if (!(s === i.userId || o.includes(i.userId)))
        return null;
      break;
    }
    case "idle": {
      const { highlightedUserIds: s } = n.getInstanceState();
      if (i.followingUserId === n.user.getId() && !(i.chatMessage || s.includes(i.userId)))
        return null;
      break;
    }
  }
  return /* @__PURE__ */ l.jsx(M6, { latestPresence: i });
}), M6 = Vt(function({
  latestPresence: e
}) {
  const n = Q(), {
    CollaboratorBrush: i,
    CollaboratorScribble: r,
    CollaboratorCursor: s,
    CollaboratorHint: o,
    CollaboratorShapeIndicator: a
  } = At(), c = n.getZoomLevel(), d = n.getViewportPageBounds(), { userId: u, chatMessage: h, brush: g, scribbles: p, selectedShapeIds: f, userName: M, cursor: m, color: y } = e, I = !(m.x < d.minX - 12 / c || m.y < d.minY - 16 / c || m.x > d.maxX - 12 / c || m.y > d.maxY - 16 / c);
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    g && i ? /* @__PURE__ */ l.jsx(
      i,
      {
        className: "tl-collaborator__brush",
        brush: g,
        color: y,
        opacity: 0.1
      },
      u + "_brush"
    ) : null,
    I && s ? /* @__PURE__ */ l.jsx(
      s,
      {
        className: "tl-collaborator__cursor",
        point: m,
        color: y,
        zoom: c,
        name: M !== "New User" ? M : null,
        chatMessage: h
      },
      u + "_cursor"
    ) : o ? /* @__PURE__ */ l.jsx(
      o,
      {
        className: "tl-collaborator__cursor-hint",
        point: m,
        color: y,
        zoom: c,
        viewport: d
      },
      u + "_cursor_hint"
    ) : null,
    r && p.length ? /* @__PURE__ */ l.jsx(l.Fragment, { children: p.map((D) => /* @__PURE__ */ l.jsx(
      r,
      {
        className: "tl-collaborator__scribble",
        scribble: D,
        color: y,
        zoom: c,
        opacity: D.color === "laser" ? 0.5 : 0.1
      },
      u + "_scribble_" + D.id
    )) }) : null,
    a && f.filter((D) => !n.isShapeHidden(D)).map((D) => /* @__PURE__ */ l.jsx(
      a,
      {
        className: "tl-collaborator__shape-indicator",
        shapeId: D,
        color: y,
        opacity: 0.5
      },
      u + "_" + D
    ))
  ] });
});
function X0(t, e) {
  return e > t.options.collaboratorInactiveTimeoutMs ? "inactive" : e > t.options.collaboratorIdleTimeoutMs ? "idle" : "active";
}
function m6(t, e) {
  const n = le((e == null ? void 0 : e.lastActivityTimestamp) ?? -1), [i, r] = pe(
    () => X0(t, Date.now() - n.current)
  );
  return ze(() => {
    const s = t.timers.setInterval(() => {
      r(X0(t, Date.now() - n.current));
    }, t.options.collaboratorCheckIntervalMs);
    return () => clearInterval(s);
  }, [t]), e && (n.current = e.lastActivityTimestamp), i;
}
function y6() {
  const t = Q(), e = G("is menu open", () => t.menus.hasAnyOpenMenus(), [t]), [n, i] = pe(!1), r = e || n, s = $x(), o = le({
    isDown: !1,
    isDragging: !1,
    start: new x()
  }), a = re(
    (u) => {
      u.button === 0 && (i(!0), o.current = {
        isDown: !0,
        isDragging: !1,
        start: new x(u.clientX, u.clientY)
      }), t.menus.clearOpenMenus();
    },
    [t]
  ), c = re(
    (u) => {
      var h, g, p;
      if (o.current.isDown) {
        if (o.current.isDragging) {
          (h = s.onPointerMove) == null || h.call(s, u);
          return;
        }
        if (
          // We're pointing, but are we dragging?
          x.Dist2(o.current.start, new x(u.clientX, u.clientY)) > t.options.dragDistanceSquared
        ) {
          o.current = {
            ...o.current,
            isDown: !0,
            isDragging: !0
          };
          const { x: f, y: M } = o.current.start;
          (g = s.onPointerDown) == null || g.call(s, {
            ...u,
            clientX: f,
            clientY: M,
            button: 0
          }), (p = s.onPointerMove) == null || p.call(s, u);
        }
      }
    },
    [s, t]
  ), d = re(
    (u) => {
      var h;
      (h = s.onPointerUp) == null || h.call(s, u), i(!1), o.current = {
        isDown: !1,
        isDragging: !1,
        start: new x(u.clientX, u.clientY)
      };
    },
    [s]
  );
  return r && /* @__PURE__ */ l.jsx(
    "div",
    {
      className: "tlui-menu-click-capture",
      "data-testid": "menu-click-capture.content",
      ...s,
      onPointerDown: a,
      onPointerMove: c,
      onPointerUp: d
    }
  );
}
const kv = _e(function({
  id: e,
  shape: n,
  util: i,
  index: r,
  backgroundIndex: s,
  opacity: o
}) {
  const a = Q(), { ShapeErrorFallback: c } = At(), d = le(null), u = le(null), h = le({
    transform: "",
    clipPath: "none",
    width: 0,
    height: 0,
    x: 0,
    y: 0,
    isCulled: !1
  });
  Vs(
    "set shape stuff",
    () => {
      const f = a.getShape(e);
      if (!f) return;
      const M = h.current, m = a.getShapeClipPath(e) ?? "none";
      m !== M.clipPath && (wn(d.current, "clip-path", m), wn(u.current, "clip-path", m), M.clipPath = m);
      const y = a.getShapePageTransform(e), I = ne.toCssString(y), D = a.getShapeGeometry(f).bounds;
      I !== M.transform && (wn(d.current, "transform", I), wn(u.current, "transform", I), M.transform = I);
      const j = Math.max(D.width, 1), w = Math.max(D.height, 1);
      (j !== M.width || w !== M.height) && (wn(d.current, "width", j + "px"), wn(d.current, "height", w + "px"), wn(u.current, "width", j + "px"), wn(u.current, "height", w + "px"), M.width = j, M.height = w);
    },
    [a]
  ), Vs(
    "set opacity and z-index",
    () => {
      const f = d.current, M = u.current;
      wn(f, "opacity", o), wn(M, "opacity", o), wn(f, "z-index", r), wn(M, "z-index", s);
    },
    [o, r, s]
  ), Vs(
    "set display",
    () => {
      if (!a.getShape(e)) return;
      const m = a.getCulledShapes().has(e);
      m !== h.current.isCulled && (wn(d.current, "display", m ? "none" : "block"), wn(u.current, "display", m ? "none" : "block"), h.current.isCulled = m);
    },
    [a]
  );
  const g = re(
    (f) => a.annotateError(f, { origin: "shape", willCrashApp: !1 }),
    [a]
  );
  if (!n) return null;
  const p = "fill" in n.props && n.props.fill !== "none";
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    i.backgroundComponent && /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: u,
        className: "tl-shape tl-shape-background",
        "data-shape-type": n.type,
        "data-shape-id": n.id,
        draggable: !1,
        children: /* @__PURE__ */ l.jsx(ql, { fallback: c, onError: g, children: /* @__PURE__ */ l.jsx(Pv, { shape: n, util: i }) })
      }
    ),
    /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: d,
        className: "tl-shape",
        "data-shape-type": n.type,
        "data-shape-is-filled": p,
        "data-shape-id": n.id,
        draggable: !1,
        children: /* @__PURE__ */ l.jsx(ql, { fallback: c, onError: g, children: /* @__PURE__ */ l.jsx(Ov, { shape: n, util: i }) })
      }
    )
  ] });
}), Ov = _e(
  function({ shape: e, util: n }) {
    return xp(
      "InnerShape:" + e.type,
      () => (
        // always fetch the latest shape from the store even if the props/meta have not changed, to avoid
        // calling the render method with stale data.
        n.component(n.editor.store.unsafeGetWithoutCapture(e.id))
      )
    );
  },
  (t, e) => t.shape.props === e.shape.props && t.shape.meta === e.shape.meta
), Pv = _e(
  function({
    shape: e,
    util: n
  }) {
    return xp(
      "InnerShape:" + e.type,
      () => {
        var i;
        return (
          // always fetch the latest shape from the store even if the props/meta have not changed, to avoid
          // calling the render method with stale data.
          (i = n.backgroundComponent) == null ? void 0 : i.call(n, n.editor.store.unsafeGetWithoutCapture(e.id))
        );
      }
    );
  },
  (t, e) => t.shape.props === e.shape.props && t.shape.meta === e.shape.meta
);
function I6({ className: t }) {
  const e = Q(), { Background: n, SvgDefs: i, ShapeIndicators: r } = At(), s = le(null), o = le(null), a = le(null), c = qt();
  a6(s), $W(), qW(), s6(s), nH(s);
  const d = le({ lodDisableTextOutline: !1, allowTextOutline: !0 });
  Vs(
    "position layers",
    function() {
      const { x: I, y: D, z: j } = e.getCamera();
      if (d.current.allowTextOutline && mt.isSafari && (c.style.setProperty("--tl-text-outline", "none"), d.current.allowTextOutline = !1), d.current.allowTextOutline && j < e.options.textShadowLod !== d.current.lodDisableTextOutline) {
        const b = j < e.options.textShadowLod;
        c.style.setProperty(
          "--tl-text-outline",
          b ? "none" : "var(--tl-text-outline-reference)"
        ), d.current.lodDisableTextOutline = b;
      }
      const w = j >= 1 ? Ba(j, [1, 8], [0.125, 0.5], !0) : Ba(j, [0.1, 1], [-2, 0.125], !0), A = `scale(${k(j)}) translate(${k(
        I + w
      )}px,${k(D + w)}px)`;
      wn(o.current, "transform", A), wn(a.current, "transform", A);
    },
    [e, c]
  );
  const u = $x(), h = G(
    "shapeSvgDefs",
    () => {
      const y = /* @__PURE__ */ new Map();
      for (const I of Pt(e.shapeUtils)) {
        if (!I) return;
        const D = I.getCanvasSvgDefs();
        for (const { key: j, component: w } of D)
          y.has(j) || y.set(j, /* @__PURE__ */ l.jsx(w, {}, j));
      }
      return [...y.values()];
    },
    [e]
  ), g = G("debug_shapes", () => Wt.hideShapes.get(), [Wt]), p = G("debug_svg", () => Wt.debugSvg.get(), [Wt]), f = G("debug_geometry", () => Wt.debugGeometry.get(), [
    Wt
  ]), M = G(
    "isEditingAnything",
    () => e.getEditingShapeId() !== null,
    [e]
  ), m = G(
    "isSelectingAnything",
    () => !!e.getSelectedShapeIds().length,
    [e]
  );
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(
      "div",
      {
        ref: s,
        draggable: !1,
        "data-iseditinganything": M,
        "data-isselectinganything": m,
        className: ce("tl-canvas", t),
        "data-testid": "canvas",
        ...u,
        children: [
          /* @__PURE__ */ l.jsx("svg", { className: "tl-svg-context", children: /* @__PURE__ */ l.jsxs("defs", { children: [
            h,
            /* @__PURE__ */ l.jsx(L6, {}),
            /* @__PURE__ */ l.jsx(k6, {}),
            i && /* @__PURE__ */ l.jsx(i, {})
          ] }) }),
          n && /* @__PURE__ */ l.jsx("div", { className: "tl-background__wrapper", children: /* @__PURE__ */ l.jsx(n, {}) }),
          /* @__PURE__ */ l.jsx(S6, {}),
          /* @__PURE__ */ l.jsxs("div", { ref: o, className: "tl-html-layer tl-shapes", draggable: !1, children: [
            /* @__PURE__ */ l.jsx(R6, {}),
            /* @__PURE__ */ l.jsx(U6, {}),
            g ? null : p ? /* @__PURE__ */ l.jsx(v6, {}) : /* @__PURE__ */ l.jsx(C6, {})
          ] }),
          /* @__PURE__ */ l.jsx("div", { className: "tl-overlays", children: /* @__PURE__ */ l.jsxs("div", { ref: a, className: "tl-html-layer", children: [
            f ? /* @__PURE__ */ l.jsx(g6, {}) : null,
            /* @__PURE__ */ l.jsx(A6, {}),
            /* @__PURE__ */ l.jsx(D6, {}),
            /* @__PURE__ */ l.jsx(j6, {}),
            /* @__PURE__ */ l.jsx(w6, {}),
            r && /* @__PURE__ */ l.jsx(r, {}),
            /* @__PURE__ */ l.jsx(z6, {}),
            /* @__PURE__ */ l.jsx(N6, {}),
            /* @__PURE__ */ l.jsx(P6, {}),
            /* @__PURE__ */ l.jsx(p6, {})
          ] }) }),
          /* @__PURE__ */ l.jsx(Y6, {})
        ]
      }
    ),
    /* @__PURE__ */ l.jsx(y6, {}),
    /* @__PURE__ */ l.jsx(x6, {})
  ] });
}
function x6() {
  const { InFrontOfTheCanvas: t } = At();
  return t ? /* @__PURE__ */ l.jsx(t, {}) : null;
}
function S6() {
  const t = Q(), e = G("gridSize", () => t.getDocumentSettings().gridSize, [t]), { x: n, y: i, z: r } = G("camera", () => t.getCamera(), [t]), s = G("isGridMode", () => t.getInstanceState().isGridMode, [t]), { Grid: o } = At();
  return o && s ? /* @__PURE__ */ l.jsx(o, { x: n, y: i, z: r, size: e }) : null;
}
function j6() {
  const t = Q(), e = G("scribbles", () => t.getInstanceState().scribbles, [t]), n = G("zoomLevel", () => t.getZoomLevel(), [t]), { Scribble: i } = At();
  return i && e.length ? e.map((r) => /* @__PURE__ */ l.jsx(i, { className: "tl-user-scribble", scribble: r, zoom: n }, r.id)) : null;
}
function D6() {
  const t = Q(), e = G("brush", () => t.getInstanceState().brush, [t]), { Brush: n } = At();
  return n && e ? /* @__PURE__ */ l.jsx(n, { className: "tl-user-brush", brush: e }) : null;
}
function w6() {
  const t = Q(), e = G("zoomBrush", () => t.getInstanceState().zoomBrush, [t]), { ZoomBrush: n } = At();
  return n && e ? /* @__PURE__ */ l.jsx(n, { className: "tl-user-brush tl-zoom-brush", brush: e }) : null;
}
function N6() {
  const t = Q(), e = G("snapLines", () => t.snaps.getIndicators(), [t]), n = G("zoomLevel", () => t.getZoomLevel(), [t]), { SnapIndicator: i } = At();
  return i && e.length > 0 ? e.map((r) => /* @__PURE__ */ l.jsx(i, { className: "tl-user-snapline", line: r, zoom: n }, r.id)) : null;
}
function A6() {
  const t = Q(), e = G(
    "handles shapeIdWithHandles",
    () => {
      const { isReadonly: n, isChangingStyle: i } = t.getInstanceState();
      if (n || i) return !1;
      const r = t.getOnlySelectedShape();
      return !r || !t.getShapeHandles(r) ? !1 : r.id;
    },
    [t]
  );
  return e ? /* @__PURE__ */ l.jsx(T6, { shapeId: e }) : null;
}
function T6({ shapeId: t }) {
  const e = Q(), { Handles: n } = At(), i = G("zoomLevel", () => e.getZoomLevel(), [e]), r = G("coarse pointer", () => e.getInstanceState().isCoarsePointer, [
    e
  ]), s = G("handles transform", () => e.getShapePageTransform(t), [
    e,
    t
  ]), o = G(
    "handles",
    () => {
      const c = e.getShapeHandles(t);
      if (!c) return null;
      const d = (r ? e.options.coarseHandleRadius : e.options.handleRadius) / i * 2;
      return c.filter(
        (u) => (
          // if the handle isn't a virtual handle, we'll display it
          // but for virtual handles, we'll only display them if they're far enough away from vertex handles
          u.type !== "virtual" || !c.some(
            (h) => (
              // skip the handle we're checking against
              // and check that their distance isn't below the minimum distance
              h !== u && // only check against vertex handles
              h.type === "vertex" && x.Dist(u, h) < d
            )
          )
        )
      ).sort((u) => u.type === "vertex" ? 1 : -1);
    },
    [e, i, r, t]
  ), a = G("isHidden", () => e.isShapeHidden(t), [e, t]);
  return !n || !o || !s || a ? null : /* @__PURE__ */ l.jsx(n, { children: /* @__PURE__ */ l.jsx("g", { transform: ne.toCssString(s), children: o.map((c) => /* @__PURE__ */ l.jsx(
    b6,
    {
      shapeId: t,
      handle: c,
      zoom: i,
      isCoarse: r
    },
    c.id
  )) }) });
}
function b6({
  shapeId: t,
  handle: e,
  zoom: n,
  isCoarse: i
}) {
  const r = o6(t, e.id), { Handle: s } = At();
  return s ? /* @__PURE__ */ l.jsx("g", { "aria-label": "handle", transform: `translate(${e.x}, ${e.y})`, ...r, children: /* @__PURE__ */ l.jsx(s, { shapeId: t, handle: e, zoom: n, isCoarse: i }) }) : null;
}
function v6() {
  const t = Q();
  return G("rendering shapes", () => t.getRenderingShapes(), [t]).map((n) => /* @__PURE__ */ l.jsxs(UA, { children: [
    /* @__PURE__ */ l.jsx(kv, { ...n }),
    /* @__PURE__ */ l.jsx(O6, { id: n.id, mode: "iframe" })
  ] }, n.id + "_fragment"));
}
function E6() {
  const t = Q(), e = le(/* @__PURE__ */ new Set());
  return Vs(
    "reflow for culled shapes",
    () => {
      const n = t.getCulledShapes();
      if (e.current.size === n.size && [...n].every((r) => e.current.has(r)))
        return;
      e.current = n;
      const i = document.getElementsByClassName("tl-canvas");
      i.length !== 0 && i[0].offsetHeight;
    },
    [t]
  ), null;
}
function C6() {
  const t = Q(), e = G("rendering shapes", () => t.getRenderingShapes(), [t]);
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    e.map((n) => /* @__PURE__ */ l.jsx(kv, { ...n }, n.id + "_shape")),
    mt.isSafari && /* @__PURE__ */ l.jsx(E6, {})
  ] });
}
function z6() {
  const t = Q(), { ShapeIndicator: e } = At(), n = G("hinting shape ids", () => ax(t.getHintingShapeIds()), [t]);
  return !n.length || !e ? null : n.map((i) => /* @__PURE__ */ l.jsx(e, { className: "tl-user-indicator__hint", shapeId: i }, i + "_hinting"));
}
function L6() {
  return /* @__PURE__ */ l.jsxs("g", { id: lr("cursor"), children: [
    /* @__PURE__ */ l.jsxs("g", { fill: "rgba(0,0,0,.2)", transform: "translate(-11,-11)", children: [
      /* @__PURE__ */ l.jsx("path", { d: "m12 24.4219v-16.015l11.591 11.619h-6.781l-.411.124z" }),
      /* @__PURE__ */ l.jsx("path", { d: "m21.0845 25.0962-3.605 1.535-4.682-11.089 3.686-1.553z" })
    ] }),
    /* @__PURE__ */ l.jsxs("g", { fill: "white", transform: "translate(-12,-12)", children: [
      /* @__PURE__ */ l.jsx("path", { d: "m12 24.4219v-16.015l11.591 11.619h-6.781l-.411.124z" }),
      /* @__PURE__ */ l.jsx("path", { d: "m21.0845 25.0962-3.605 1.535-4.682-11.089 3.686-1.553z" })
    ] }),
    /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", transform: "translate(-12,-12)", children: [
      /* @__PURE__ */ l.jsx("path", { d: "m19.751 24.4155-1.844.774-3.1-7.374 1.841-.775z" }),
      /* @__PURE__ */ l.jsx("path", { d: "m13 10.814v11.188l2.969-2.866.428-.139h4.768z" })
    ] })
  ] });
}
function k6() {
  const t = lr("cursor_hint");
  return /* @__PURE__ */ l.jsx("path", { id: t, fill: "currentColor", d: "M -2,-5 2,0 -2,5 Z" });
}
function O6({ id: t, mode: e }) {
  const n = Q(), [i, r] = pe(null), s = G(
    "is in root",
    () => {
      const o = n.getShape(t);
      return (o == null ? void 0 : o.parentId) === n.getCurrentPageId();
    },
    [n, t]
  );
  return ze(() => {
    if (!s) return;
    let o = null;
    const a = Yr("shape to svg", async () => {
      const c = Math.random();
      o = c;
      const u = n.isShapeOfType(t, "frame") ? 0 : 10;
      let h = n.getShapePageBounds(t);
      if (!h) return;
      h = h.clone().expandBy(u);
      const g = await n.getSvgString([t], {
        padding: u,
        background: n.getInstanceState().exportBackground
      });
      if (o !== c || !g) return;
      const p = `data:image/svg+xml;utf8,${encodeURIComponent(g.svg)}`;
      r({ src: p, bounds: h });
    });
    return () => {
      o = null, a();
    };
  }, [n, t, s]), !s || !i ? null : e === "iframe" ? /* @__PURE__ */ l.jsx(
    "iframe",
    {
      src: i.src,
      width: i.bounds.width,
      height: i.bounds.height,
      referrerPolicy: "no-referrer",
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        border: "none",
        transform: `translate(${i.bounds.x}px, ${i.bounds.maxY + 12}px)`,
        outline: "1px solid black",
        maxWidth: "none"
      }
    }
  ) : /* @__PURE__ */ l.jsx(
    "img",
    {
      src: i.src,
      width: i.bounds.width,
      height: i.bounds.height,
      referrerPolicy: "no-referrer",
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        transform: `translate(${i.bounds.x}px, ${i.bounds.maxY + 12}px)`,
        outline: "1px solid black",
        maxWidth: "none"
      }
    }
  );
}
function P6() {
  const t = Q(), e = G("selection rotation", () => t.getSelectionRotation(), [
    t
  ]), n = G(
    "selection bounds",
    () => t.getSelectionRotatedPageBounds(),
    [t]
  ), { SelectionForeground: i } = At();
  return !n || !i ? null : /* @__PURE__ */ l.jsx(i, { bounds: n, rotation: e });
}
function U6() {
  const t = Q(), e = G("selection rotation", () => t.getSelectionRotation(), [
    t
  ]), n = G(
    "selection bounds",
    () => t.getSelectionRotatedPageBounds(),
    [t]
  ), { SelectionBackground: i } = At();
  return !n || !i ? null : /* @__PURE__ */ l.jsx(i, { bounds: n, rotation: e });
}
function R6() {
  const { OnTheCanvas: t } = At();
  return t ? /* @__PURE__ */ l.jsx(t, {}) : null;
}
function Y6() {
  const t = Q(), e = G("camera state", () => t.getCameraState(), [t]);
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: ce("tl-hit-test-blocker", {
        "tl-hit-test-blocker__hidden": e === "idle"
      })
    }
  );
}
function Q6({
  className: t,
  zoom: e,
  point: n,
  color: i,
  viewport: r,
  opacity: s = 1
}) {
  const o = le(null);
  Ko(
    o,
    hn(n.x, r.minX + 5 / e, r.maxX - 5 / e),
    hn(n.y, r.minY + 5 / e, r.maxY - 5 / e),
    1 / e,
    x.Angle(r.center, n)
  );
  const a = lr("cursor_hint");
  return /* @__PURE__ */ l.jsxs("svg", { ref: o, className: ce("tl-overlays__item", t), children: [
    /* @__PURE__ */ l.jsx(
      "use",
      {
        href: `#${a}`,
        color: i,
        strokeWidth: 3,
        stroke: "var(--color-background)"
      }
    ),
    /* @__PURE__ */ l.jsx("use", { href: `#${a}`, color: i, opacity: s })
  ] });
}
const J0 = _e(function({
  className: e,
  zoom: n,
  point: i,
  color: r,
  name: s,
  chatMessage: o
}) {
  const a = le(null);
  Ko(a, i == null ? void 0 : i.x, i == null ? void 0 : i.y, 1 / n);
  const c = lr("cursor");
  return i ? /* @__PURE__ */ l.jsxs("div", { ref: a, className: ce("tl-overlays__item", e), children: [
    /* @__PURE__ */ l.jsx("svg", { className: "tl-cursor", children: /* @__PURE__ */ l.jsx("use", { href: `#${c}`, color: r }) }),
    o ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      s && /* @__PURE__ */ l.jsx("div", { className: "tl-nametag-title", style: { color: r }, children: s }),
      /* @__PURE__ */ l.jsx("div", { className: "tl-nametag-chat", style: { backgroundColor: r }, children: o })
    ] }) : s && /* @__PURE__ */ l.jsx("div", { className: "tl-nametag", style: { backgroundColor: r }, children: s })
  ] }) : null;
});
function Z6({ x: t, y: e, z: n, size: i }) {
  const r = Sc("grid"), s = Q(), { gridSteps: o } = s.options;
  return /* @__PURE__ */ l.jsxs("svg", { className: "tl-grid", version: "1.1", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ l.jsx("defs", { children: o.map(({ min: a, mid: c, step: d }, u) => {
      const h = d * i * n, g = 0.5 + t * n, p = 0.5 + e * n, f = g > 0 ? g % h : h + g % h, M = p > 0 ? p % h : h + p % h, m = n < c ? Ba(n, [a, c], [0, 1]) : 1;
      return /* @__PURE__ */ l.jsx(
        "pattern",
        {
          id: Vx(r, `${d}`),
          width: h,
          height: h,
          patternUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ l.jsx("circle", { className: "tl-grid-dot", cx: f, cy: M, r: 1, opacity: m })
        },
        u
      );
    }) }),
    o.map(({ step: a }, c) => /* @__PURE__ */ l.jsx("rect", { width: "100%", height: "100%", fill: `url(#${r}_${a})` }, c))
  ] });
}
function F6({ handle: t, isCoarse: e, className: n, zoom: i }) {
  const r = Q(), s = (e ? r.options.coarseHandleRadius : r.options.handleRadius) / i;
  if (t.type === "clone") {
    const a = 3 / i, c = `M0,${-a} A${a},${a} 0 0,1 0,${a}`, d = xv.indexOf(t.id);
    return /* @__PURE__ */ l.jsxs("g", { className: ce(`tl-handle tl-handle__${t.type}`, n), children: [
      /* @__PURE__ */ l.jsx("circle", { className: "tl-handle__bg", r: s }),
      /* @__PURE__ */ l.jsx("path", { className: "tl-handle__fg", d: c, transform: `rotate(${-90 + 90 * d})` })
    ] });
  }
  const o = (t.type === "create" && e ? 3 : 4) / Math.max(i, 0.25);
  return /* @__PURE__ */ l.jsxs("g", { className: ce(`tl-handle tl-handle__${t.type}`, n), children: [
    /* @__PURE__ */ l.jsx("circle", { className: "tl-handle__bg", r: s }),
    /* @__PURE__ */ l.jsx("circle", { className: "tl-handle__fg", r: o })
  ] });
}
const B6 = ({ children: t }) => /* @__PURE__ */ l.jsx("svg", { className: "tl-user-handles tl-overlays__item", children: t }), G6 = () => {
  const { Spinner: t } = At();
  return /* @__PURE__ */ l.jsx(IS, { children: t ? /* @__PURE__ */ l.jsx(t, {}) : null });
};
function nS(t, e = !0) {
  const n = t.length;
  if (n < 2)
    return "";
  let i = t[0], r = t[1];
  if (n === 2)
    return `M${rt(i)}L${rt(r)}`;
  let s = "";
  for (let o = 2, a = n - 1; o < a; o++)
    i = t[o], r = t[o + 1], s += ai(i, r);
  return e ? `M${ai(t[0], t[1])}Q${rt(t[1])}${ai(
    t[1],
    t[2]
  )}T${s}${ai(t[n - 1], t[0])}${ai(t[0], t[1])}Z` : `M${rt(t[0])}Q${rt(t[1])}${ai(t[1], t[2])}${t.length > 3 ? "T" : ""}${s}L${rt(t[n - 1])}`;
}
function q0({ scribble: t, zoom: e, color: n, opacity: i, className: r }) {
  return t.points.length ? /* @__PURE__ */ l.jsx("svg", { className: r && ce("tl-overlays__item", r), children: /* @__PURE__ */ l.jsx(
    "path",
    {
      className: "tl-scribble",
      d: nS(t.points, !1),
      stroke: n ?? `var(--color-${t.color})`,
      fill: "none",
      strokeWidth: 8 / e,
      opacity: i ?? t.opacity
    }
  ) }) : null;
}
function Uv({ bounds: t, rotation: e }) {
  const n = N.useRef(null);
  return Ko(n, t.x, t.y, 1, e), N.useLayoutEffect(() => {
    const i = n.current;
    i && (i.style.width = k(Math.max(1, t.width)) + "px", i.style.height = k(Math.max(1, t.height)) + "px");
  }, [t.width, t.height]), /* @__PURE__ */ l.jsx("div", { ref: n, className: "tl-selection__bg", draggable: !1 });
}
function W6({ bounds: t, rotation: e }) {
  const n = Q(), i = le(null), r = G("only selected shape", () => n.getOnlySelectedShape(), [n]), s = r ? n.getShapeUtil(r).expandSelectionOutlinePx(r) : 0;
  return Ko(i, t == null ? void 0 : t.x, t == null ? void 0 : t.y, 1, e, {
    x: -s,
    y: -s
  }), t = t.clone().expandBy(s).zeroFix(), /* @__PURE__ */ l.jsx(
    "svg",
    {
      ref: i,
      className: "tl-overlays__item tl-selection__fg",
      "data-testid": "selection-foreground",
      children: /* @__PURE__ */ l.jsx(
        "rect",
        {
          className: ce("tl-selection__fg__outline"),
          width: k(t.width),
          height: k(t.height)
        }
      )
    }
  );
}
const H6 = () => /* @__PURE__ */ l.jsx("div", { className: "tl-shape-error-boundary" }), V6 = ({ shape: t, util: e }) => xp(
  "Indicator: " + t.type,
  () => (
    // always fetch the latest shape from the store even if the props/meta have not changed, to avoid
    // calling the render method with stale data.
    e.indicator(e.editor.store.unsafeGetWithoutCapture(t.id))
  )
), K6 = ({ editor: t, id: e }) => {
  const n = G("shape for indicator", () => t.store.get(e), [t, e]), { ShapeIndicatorErrorFallback: i } = At();
  return !n || n.isLocked ? null : /* @__PURE__ */ l.jsx(
    ql,
    {
      fallback: i,
      onError: (r) => t.annotateError(r, { origin: "react.shapeIndicator", willCrashApp: !1 }),
      children: /* @__PURE__ */ l.jsx(V6, { shape: n, util: t.getShapeUtil(n) }, n.id)
    }
  );
}, _0 = _e(function({
  shapeId: e,
  className: n,
  color: i,
  hidden: r,
  opacity: s
}) {
  const o = Q(), a = le(null);
  return Vs(
    "indicator transform",
    () => {
      const c = a.current;
      if (!c) return;
      const d = o.getShapePageTransform(e);
      d && c.style.setProperty("transform", d.toCssString());
    },
    [o, e]
  ), at(() => {
    const c = a.current;
    c && c.style.setProperty("display", r ? "none" : "block");
  }, [r]), /* @__PURE__ */ l.jsx("svg", { ref: a, className: ce("tl-overlays__item", n), children: /* @__PURE__ */ l.jsx("g", { className: "tl-shape-indicator", stroke: i ?? "var(--color-selected)", opacity: s, children: /* @__PURE__ */ l.jsx(K6, { editor: o, id: e }) }) });
}), X6 = () => /* @__PURE__ */ l.jsx("circle", { cx: 4, cy: 4, r: 8, strokeWidth: "1", stroke: "red" }), Rv = _e(function() {
  const e = Q(), n = le(/* @__PURE__ */ new Set()), i = G(
    "should display selected ids",
    () => {
      const o = n.current, a = /* @__PURE__ */ new Set();
      if (
        // We only show indicators when in the following states...
        e.isInAny(
          "select.idle",
          "select.brushing",
          "select.scribble_brushing",
          "select.editing_shape",
          "select.pointing_shape",
          "select.pointing_selection",
          "select.pointing_handle"
        ) && // ...but we hide indicators when we've just changed a style (so that the user can see the change)
        !e.getInstanceState().isChangingStyle
      ) {
        const c = e.getSelectedShapeIds();
        for (const d of c)
          a.add(d);
        if (e.isInAny("select.idle", "select.editing_shape")) {
          const d = e.getInstanceState();
          if (d.isHoveringCanvas && !d.isCoarsePointer) {
            const u = e.getHoveredShapeId();
            u && a.add(u);
          }
        }
      }
      if (o.size !== a.size)
        return n.current = a, a;
      for (const c of a)
        if (!o.has(c))
          return n.current = a, a;
      return o;
    },
    [e]
  ), r = G("rendering shapes", () => e.getRenderingShapes(), [e]), { ShapeIndicator: s } = At();
  return s ? r.map(({ id: o }) => /* @__PURE__ */ l.jsx(s, { shapeId: o, hidden: !i.has(o) }, o + "_indicator")) : null;
});
function J6({ points: t, zoom: e }) {
  const n = 2.5 / e, i = t.reduce((g, p) => Math.min(g, p.x), 1 / 0), r = t.reduce((g, p) => Math.max(g, p.x), -1 / 0), s = t.reduce((g, p) => Math.min(g, p.y), 1 / 0), o = t.reduce((g, p) => Math.max(g, p.y), -1 / 0), a = t.some((g) => g.x === i && g.y === s);
  let c, d, u, h;
  return a ? (c = i, d = s, u = r, h = o) : (c = i, d = o, u = r, h = s), /* @__PURE__ */ l.jsxs("g", { className: "tl-snap-indicator", stroke: "lime", children: [
    /* @__PURE__ */ l.jsx("line", { x1: c, y1: d, x2: u, y2: h }),
    t.map((g, p) => /* @__PURE__ */ l.jsx("g", { transform: `translate(${g.x},${g.y})`, children: /* @__PURE__ */ l.jsx(
      "path",
      {
        className: "tl-snap-point",
        d: `M ${-n},${-n} L ${n},${n} M ${-n},${n} L ${n},${-n}`
      }
    ) }, p))
  ] });
}
function q6({ gaps: t, direction: e, zoom: n }) {
  const i = 3.5 / n;
  let r = [-1 / 0, 1 / 0], s = null;
  const o = e === "horizontal";
  for (const c of t) {
    if (s = nr(
      r[0],
      r[1],
      o ? c.startEdge[0].y : c.startEdge[0].x,
      o ? c.startEdge[1].y : c.startEdge[1].x
    ), s)
      r = s;
    else
      continue;
    if (s = nr(
      r[0],
      r[1],
      o ? c.endEdge[0].y : c.endEdge[0].x,
      o ? c.endEdge[1].y : c.endEdge[1].x
    ), s)
      r = s;
    else
      continue;
  }
  if (r === null)
    return null;
  const a = (r[0] + r[1]) / 2;
  return /* @__PURE__ */ l.jsx("g", { className: "tl-snap-indicator", stroke: "cyan", children: t.map(({ startEdge: c, endEdge: d }, u) => /* @__PURE__ */ l.jsx(N.Fragment, { children: o ? (
    // horizontal gap
    /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "line",
        {
          x1: c[0].x,
          y1: a - 2 * i,
          x2: c[1].x,
          y2: a + 2 * i
        }
      ),
      /* @__PURE__ */ l.jsx(
        "line",
        {
          x1: d[0].x,
          y1: a - 2 * i,
          x2: d[1].x,
          y2: a + 2 * i
        }
      ),
      /* @__PURE__ */ l.jsx("line", { x1: c[0].x, y1: a, x2: d[0].x, y2: a }),
      /* @__PURE__ */ l.jsx(
        "line",
        {
          x1: (c[0].x + d[0].x) / 2,
          y1: a - i,
          x2: (c[0].x + d[0].x) / 2,
          y2: a + i
        }
      )
    ] })
  ) : (
    // vertical gap
    /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "line",
        {
          x1: a - 2 * i,
          y1: c[0].y,
          x2: a + 2 * i,
          y2: c[1].y
        }
      ),
      /* @__PURE__ */ l.jsx(
        "line",
        {
          x1: a - 2 * i,
          y1: d[0].y,
          x2: a + 2 * i,
          y2: d[1].y
        }
      ),
      /* @__PURE__ */ l.jsx("line", { x1: a, y1: c[0].y, x2: a, y2: d[0].y }),
      /* @__PURE__ */ l.jsx(
        "line",
        {
          x1: a - i,
          y1: (c[0].y + d[0].y) / 2,
          x2: a + i,
          y2: (c[0].y + d[0].y) / 2
        }
      )
    ] })
  ) }, u)) });
}
function _6({ className: t, line: e, zoom: n }) {
  return /* @__PURE__ */ l.jsx("svg", { className: ce("tl-overlays__item", t), children: e.type === "points" ? /* @__PURE__ */ l.jsx(J6, { ...e, zoom: n }) : e.type === "gaps" ? /* @__PURE__ */ l.jsx(q6, { ...e, zoom: n }) : null });
}
function iS() {
  return /* @__PURE__ */ l.jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", children: /* @__PURE__ */ l.jsxs("g", { strokeWidth: 2, fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ l.jsx("circle", { strokeOpacity: 0.25, cx: 8, cy: 8, r: 7, stroke: "currentColor" }),
    /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", d: "M15 8c0-4.5-4.5-7-7-7", stroke: "currentColor", children: /* @__PURE__ */ l.jsx(
      "animateTransform",
      {
        attributeName: "transform",
        type: "rotate",
        from: "0 8 8",
        to: "360 8 8",
        dur: "1s",
        repeatCount: "indefinite"
      }
    ) })
  ] }) });
}
const $6 = () => null;
function Yv(t, e) {
  const n = le(t);
  return e(t, n.current) ? n.current : (n.current = t, t);
}
const eV = (t, e) => (t ?? (t = null), e ?? (e = null), t === e ? !0 : !t || !e ? !1 : xU(t, e));
function Bs(t) {
  return Yv(t, eV);
}
const tV = (t, e) => (t ?? (t = null), e ?? (e = null), t === e ? !0 : !t || !e ? !1 : XA(t, e));
function wc(t) {
  return Yv(t, tV);
}
const Qv = Ii(null);
function nV({
  overrides: t = {},
  children: e
}) {
  const n = wc(t), i = yt(
    () => ({
      Background: YW,
      SvgDefs: $6,
      Brush: DM,
      ZoomBrush: DM,
      CollaboratorBrush: DM,
      Cursor: J0,
      CollaboratorCursor: J0,
      CollaboratorHint: Q6,
      CollaboratorShapeIndicator: _0,
      Grid: Z6,
      Scribble: q0,
      SnapIndicator: _6,
      Handles: B6,
      Handle: F6,
      CollaboratorScribble: q0,
      ErrorFallback: Fv,
      ShapeErrorFallback: H6,
      ShapeIndicatorErrorFallback: X6,
      Spinner: iS,
      SelectionBackground: Uv,
      SelectionForeground: W6,
      ShapeIndicators: Rv,
      ShapeIndicator: _0,
      OnTheCanvas: null,
      InFrontOfTheCanvas: null,
      Canvas: I6,
      LoadingScreen: G6,
      ...n
    }),
    [n]
  );
  return /* @__PURE__ */ l.jsx(Qv.Provider, { value: i, children: e });
}
function At() {
  const t = Vn(Qv);
  if (!t)
    throw new Error("useEditorComponents must be used inside of <EditorComponentsProvider />");
  return t;
}
const bp = {
  openWindow(t, e) {
    window.open(t, e, "noopener noreferrer");
  },
  refreshPage() {
    window.location.reload();
  },
  async hardReset() {
    var t;
    return await ((t = window.__tldraw__hardReset) == null ? void 0 : t.call(window));
  }
};
function Zv() {
  bp.hardReset();
}
function iV() {
  bp.refreshPage();
}
const rV = "https://github.com/tldraw/tldraw/issues/new", Fv = ({ error: t, editor: e }) => {
  const n = le(null), [i, r] = pe(process.env.NODE_ENV === "development"), [s, o] = pe(!1), [a, c] = pe(!1);
  let d = null;
  try {
    d = At().Canvas ?? null;
  } catch {
  }
  const u = t instanceof Error ? t.message : String(t), h = t instanceof Error ? t.stack : null, g = G(
    "isDarkMode",
    () => {
      try {
        if (e)
          return e.user.getIsDarkMode();
      } catch {
      }
      return null;
    },
    [e]
  ), [p, f] = pe(null);
  at(() => {
    var w;
    g !== null && f(g);
    let D = (w = n.current) == null ? void 0 : w.parentElement, j = !1;
    for (; D; ) {
      if (D.classList.contains("tl-theme__dark") || D.classList.contains("tl-theme__light")) {
        j = !0;
        break;
      }
      D = D.parentElement;
    }
    if (j) {
      f(null);
      return;
    }
    typeof window < "u" && "matchMedia" in window && f(window.matchMedia("(prefers-color-scheme: dark)").matches);
  }, [g]), ze(() => {
    if (s) {
      const D = e == null ? void 0 : e.timers.setTimeout(() => {
        o(!1);
      }, 2e3);
      return () => clearTimeout(D);
    }
  }, [s, e]);
  const M = () => {
    const D = document.createElement("textarea");
    D.value = h ?? u, document.body.appendChild(D), D.select(), document.execCommand("copy"), D.remove(), o(!0);
  }, m = () => {
    iV();
  }, y = async () => {
    Zv();
  }, I = new URL(rV);
  return I.searchParams.set("title", u), I.searchParams.set("labels", "bug"), I.searchParams.set(
    "body",
    `Hey, I ran into an error while using tldraw:

\`\`\`js
${h ?? u}
\`\`\`

My browser: ${navigator.userAgent}`
  ), /* @__PURE__ */ l.jsxs(
    "div",
    {
      ref: n,
      className: ce(
        "tl-container tl-error-boundary",
        // error-boundary is sometimes used outside of the theme
        // container, so we need to provide it with a theme for our
        // styles to work correctly
        p === null ? "" : p ? "tl-theme__dark" : "tl-theme__light"
      ),
      children: [
        /* @__PURE__ */ l.jsx("div", { className: "tl-error-boundary__overlay" }),
        e && // opportunistically attempt to render the canvas to reassure
        // the user that their document is still there. there's a good
        // chance this won't work (ie the error that we're currently
        // notifying the user about originates in the canvas) so it's
        // not a big deal if it doesn't work - in that case we just have
        // a plain grey background.
        /* @__PURE__ */ l.jsx(Hx, { onError: Hl, fallback: () => null, children: /* @__PURE__ */ l.jsx(Jx, { editor: e, children: /* @__PURE__ */ l.jsx("div", { className: "tl-overlay tl-error-boundary__canvas", children: d ? /* @__PURE__ */ l.jsx(d, {}) : null }) }) }),
        /* @__PURE__ */ l.jsx(
          "div",
          {
            className: ce("tl-modal", "tl-error-boundary__content", {
              "tl-error-boundary__content__expanded": i && !a
            }),
            children: a ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
              /* @__PURE__ */ l.jsx("h2", { children: "Are you sure?" }),
              /* @__PURE__ */ l.jsx("p", { children: "Resetting your data will delete your drawing and cannot be undone." }),
              /* @__PURE__ */ l.jsxs("div", { className: "tl-error-boundary__content__actions", children: [
                /* @__PURE__ */ l.jsx("button", { onClick: () => c(!1), children: "Cancel" }),
                /* @__PURE__ */ l.jsx("button", { className: "tl-error-boundary__reset", onClick: y, children: "Reset data" })
              ] })
            ] }) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
              /* @__PURE__ */ l.jsx("h2", { children: "Something's gone wrong." }),
              /* @__PURE__ */ l.jsxs("p", { children: [
                "Sorry, we encountered an error. Please refresh the page to continue. If you keep seeing this error, you can ",
                /* @__PURE__ */ l.jsx("a", { href: I.toString(), children: "create a GitHub issue" }),
                " or",
                " ",
                /* @__PURE__ */ l.jsx("a", { href: "https://discord.gg/Cq6cPsTfNy", children: "ask for help on Discord" }),
                "."
              ] }),
              i && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                "Message:",
                /* @__PURE__ */ l.jsx("h4", { children: /* @__PURE__ */ l.jsx("code", { children: u }) }),
                "Stack trace:",
                /* @__PURE__ */ l.jsxs("div", { className: "tl-error-boundary__content__error", children: [
                  /* @__PURE__ */ l.jsx("pre", { children: /* @__PURE__ */ l.jsx("code", { children: h ?? u }) }),
                  /* @__PURE__ */ l.jsx("button", { onClick: M, children: s ? "Copied!" : "Copy" })
                ] })
              ] }),
              /* @__PURE__ */ l.jsxs("div", { className: "tl-error-boundary__content__actions", children: [
                /* @__PURE__ */ l.jsx("button", { onClick: () => r(!i), children: i ? "Hide details" : "Show details" }),
                /* @__PURE__ */ l.jsxs("div", { className: "tl-error-boundary__content__actions__group", children: [
                  /* @__PURE__ */ l.jsx(
                    "button",
                    {
                      className: "tl-error-boundary__reset",
                      onClick: () => c(!0),
                      children: "Reset data"
                    }
                  ),
                  /* @__PURE__ */ l.jsx("button", { className: "tl-error-boundary__refresh", onClick: m, children: "Refresh Page" })
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
}, Bv = "TLDRAW_USER_DATA_v3", Gv = Xe({
  id: Ne,
  name: Ne.nullable().optional(),
  color: Ne.nullable().optional(),
  // N.B. These are duplicated in TLdrawAppUser.
  locale: Ne.nullable().optional(),
  animationSpeed: we.nullable().optional(),
  edgeScrollSpeed: we.nullable().optional(),
  colorScheme: wp("light", "dark", "system").optional(),
  isSnapMode: qe.nullable().optional(),
  isWrapMode: qe.nullable().optional(),
  isDynamicSizeMode: qe.nullable().optional(),
  isPasteAtCursorMode: qe.nullable().optional()
}), rs = {
  AddAnimationSpeed: 1,
  AddIsSnapMode: 2,
  MakeFieldsNullable: 3,
  AddEdgeScrollSpeed: 4,
  AddExcalidrawSelectMode: 5,
  AddDynamicSizeMode: 6,
  AllowSystemColorScheme: 7,
  AddPasteAtCursor: 8
}, rS = Math.max(...Object.values(rs));
function sV(t) {
  t.version < rs.AddAnimationSpeed && (t.user.animationSpeed = 1), t.version < rs.AddIsSnapMode && (t.user.isSnapMode = !1), t.version < rs.MakeFieldsNullable, t.version < rs.AddEdgeScrollSpeed && (t.user.edgeScrollSpeed = 1), t.version < rs.AddExcalidrawSelectMode && (t.user.isWrapMode = !1), t.version < rs.AllowSystemColorScheme && (t.user.isDarkMode === !0 ? t.user.colorScheme = "dark" : t.user.isDarkMode === !1 && (t.user.colorScheme = "light"), delete t.user.isDarkMode), t.version < rs.AddDynamicSizeMode && (t.user.isDynamicSizeMode = !1), t.version < rs.AddPasteAtCursor && (t.user.isPasteAtCursorMode = !1), t.version = rS;
}
const Wy = [
  "#FF802B",
  "#EC5E41",
  "#F2555A",
  "#F04F88",
  "#E34BA9",
  "#BD54C6",
  "#9D5BD2",
  "#7B66DC",
  "#02B1CC",
  "#11B3A3",
  "#39B178",
  "#55B467"
];
function Wv() {
  return Wy[Math.floor(Math.random() * Wy.length)];
}
function oV() {
  var t, e;
  return typeof window < "u" && "matchMedia" in window ? ((e = (t = window.matchMedia) == null ? void 0 : t.call(window, "(prefers-reduced-motion: reduce)")) == null ? void 0 : e.matches) ?? !1 : !1;
}
const ts = Object.freeze({
  name: "New User",
  locale: LW(),
  color: Wv(),
  // N.B. These are duplicated in TLdrawAppUser.
  edgeScrollSpeed: 1,
  animationSpeed: oV() ? 0 : 1,
  isSnapMode: !1,
  isWrapMode: !1,
  isDynamicSizeMode: !1,
  isPasteAtCursorMode: !1,
  colorScheme: "system"
});
function TM() {
  return {
    id: ht(),
    color: Wv()
  };
}
function Hv(t) {
  if (t === null || typeof t != "object" || !("version" in t) || !("user" in t) || typeof t.version != "number")
    return TM();
  const e = Ct(t);
  sV(e);
  try {
    return Gv.validate(e.user);
  } catch {
    return TM();
  }
}
function aV() {
  const t = JSON.parse(gx(Bv) || "null") ?? null;
  return Hv(t);
}
const vp = xt("globalUserData", null);
function cV() {
  px(
    Bv,
    JSON.stringify({
      version: rS,
      user: vp.get()
    })
  );
}
function Vv(t) {
  Gv.validate(t), vp.set(t), cV(), dV();
}
const lV = typeof process < "u" && process.env.NODE_ENV === "test", Pa = typeof BroadcastChannel < "u" && !lV ? new BroadcastChannel("tldraw-user-sync") : null;
Pa == null || Pa.addEventListener("message", (t) => {
  const e = t.data;
  (e == null ? void 0 : e.type) === Xv && (e == null ? void 0 : e.origin) !== Kv() && vp.set(Hv(e.data));
});
let bM = null;
function Kv() {
  return bM === null && (bM = ht()), bM;
}
const Xv = "tldraw-user-preferences-change";
function dV() {
  Pa == null || Pa.postMessage({
    type: Xv,
    origin: Kv(),
    data: {
      user: Jv(),
      version: rS
    }
  });
}
function Jv() {
  let t = vp.get();
  return t || (t = aV(), Vv(t)), t;
}
const uV = K(
  "defaultLocalStorageUserPrefs",
  () => Jv()
);
function qv(t = {}) {
  return {
    userPreferences: t.userPreferences ?? uV,
    setUserPreferences: t.setUserPreferences ?? Vv
  };
}
var _v = { exports: {} };
(function(t) {
  var e = Object.prototype.hasOwnProperty, n = "~";
  function i() {
  }
  Object.create && (i.prototype = /* @__PURE__ */ Object.create(null), new i().__proto__ || (n = !1));
  function r(c, d, u) {
    this.fn = c, this.context = d, this.once = u || !1;
  }
  function s(c, d, u, h, g) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var p = new r(u, h || c, g), f = n ? n + d : d;
    return c._events[f] ? c._events[f].fn ? c._events[f] = [c._events[f], p] : c._events[f].push(p) : (c._events[f] = p, c._eventsCount++), c;
  }
  function o(c, d) {
    --c._eventsCount === 0 ? c._events = new i() : delete c._events[d];
  }
  function a() {
    this._events = new i(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var d = [], u, h;
    if (this._eventsCount === 0) return d;
    for (h in u = this._events)
      e.call(u, h) && d.push(n ? h.slice(1) : h);
    return Object.getOwnPropertySymbols ? d.concat(Object.getOwnPropertySymbols(u)) : d;
  }, a.prototype.listeners = function(d) {
    var u = n ? n + d : d, h = this._events[u];
    if (!h) return [];
    if (h.fn) return [h.fn];
    for (var g = 0, p = h.length, f = new Array(p); g < p; g++)
      f[g] = h[g].fn;
    return f;
  }, a.prototype.listenerCount = function(d) {
    var u = n ? n + d : d, h = this._events[u];
    return h ? h.fn ? 1 : h.length : 0;
  }, a.prototype.emit = function(d, u, h, g, p, f) {
    var M = n ? n + d : d;
    if (!this._events[M]) return !1;
    var m = this._events[M], y = arguments.length, I, D;
    if (m.fn) {
      switch (m.once && this.removeListener(d, m.fn, void 0, !0), y) {
        case 1:
          return m.fn.call(m.context), !0;
        case 2:
          return m.fn.call(m.context, u), !0;
        case 3:
          return m.fn.call(m.context, u, h), !0;
        case 4:
          return m.fn.call(m.context, u, h, g), !0;
        case 5:
          return m.fn.call(m.context, u, h, g, p), !0;
        case 6:
          return m.fn.call(m.context, u, h, g, p, f), !0;
      }
      for (D = 1, I = new Array(y - 1); D < y; D++)
        I[D - 1] = arguments[D];
      m.fn.apply(m.context, I);
    } else {
      var j = m.length, w;
      for (D = 0; D < j; D++)
        switch (m[D].once && this.removeListener(d, m[D].fn, void 0, !0), y) {
          case 1:
            m[D].fn.call(m[D].context);
            break;
          case 2:
            m[D].fn.call(m[D].context, u);
            break;
          case 3:
            m[D].fn.call(m[D].context, u, h);
            break;
          case 4:
            m[D].fn.call(m[D].context, u, h, g);
            break;
          default:
            if (!I) for (w = 1, I = new Array(y - 1); w < y; w++)
              I[w - 1] = arguments[w];
            m[D].fn.apply(m[D].context, I);
        }
    }
    return !0;
  }, a.prototype.on = function(d, u, h) {
    return s(this, d, u, h, !1);
  }, a.prototype.once = function(d, u, h) {
    return s(this, d, u, h, !0);
  }, a.prototype.removeListener = function(d, u, h, g) {
    var p = n ? n + d : d;
    if (!this._events[p]) return this;
    if (!u)
      return o(this, p), this;
    var f = this._events[p];
    if (f.fn)
      f.fn === u && (!g || f.once) && (!h || f.context === h) && o(this, p);
    else {
      for (var M = 0, m = [], y = f.length; M < y; M++)
        (f[M].fn !== u || g && !f[M].once || h && f[M].context !== h) && m.push(f[M]);
      m.length ? this._events[p] = m.length === 1 ? m[0] : m : o(this, p);
    }
    return this;
  }, a.prototype.removeAllListeners = function(d) {
    var u;
    return d ? (u = n ? n + d : d, this._events[u] && o(this, u)) : (this._events = new i(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = n, a.EventEmitter = a, t.exports = a;
})(_v);
var hV = _v.exports;
const gV = /* @__PURE__ */ uc(hV), Ua = "TLDRAW_TAB_ID_v2", gs = globalThis.window;
function pV() {
  return gs ? ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    gs.navigator.platform
  ) || // iPad on iOS 13 detection
  mt.isDarwin && "ontouchend" in document : !1;
}
const zg = gs ? gs[Ua] ?? hT(Ua) ?? "TLDRAW_INSTANCE_STATE_V1_" + ht() : "<error>";
gs && (gs[Ua] = zg, pV() ? fx(Ua, zg) : gT(Ua));
gs == null || gs.addEventListener("beforeunload", () => {
  fx(Ua, zg);
});
const $v = {
  Initial: 0
}, Ep = Math.max(...Object.values($v));
function fV(t) {
  t.version < $v.Initial, t.version = Ep;
}
const e1 = Xe({
  version: we,
  currentPageId: Kl.optional(),
  isFocusMode: qe.optional(),
  exportBackground: qe.optional(),
  isDebugMode: qe.optional(),
  isToolLocked: qe.optional(),
  isGridMode: qe.optional(),
  pageStates: sn(
    Xe({
      pageId: Kl,
      camera: Xe({
        x: we,
        y: we,
        z: we
      }).optional(),
      selectedShapeIds: sn(Bi).optional(),
      focusedGroupId: Bi.nullable().optional()
    })
  ).optional()
});
function MV(t) {
  if (!t || typeof t != "object")
    return console.warn("Invalid instance state"), null;
  if (!("version" in t) || typeof t.version != "number")
    return console.warn("No version in instance state"), null;
  t.version !== Ep && (t = Ct(t), fV(t));
  try {
    return e1.validate(t);
  } catch (e) {
    return console.warn(e), null;
  }
}
function sS(t) {
  const e = t.query.ids("page");
  return K(
    "sessionStateSnapshot",
    () => {
      const n = t.get(Qn);
      if (!n) return null;
      const i = [...e.get()];
      return {
        version: Ep,
        currentPageId: n.currentPageId,
        exportBackground: n.exportBackground,
        isFocusMode: n.isFocusMode,
        isDebugMode: n.isDebugMode,
        isToolLocked: n.isToolLocked,
        isGridMode: n.isGridMode,
        pageStates: i.map((r) => {
          const s = t.get(ar.createId(r)), o = t.get(kr.createId(r));
          return {
            pageId: r,
            camera: {
              x: (o == null ? void 0 : o.x) ?? 0,
              y: (o == null ? void 0 : o.y) ?? 0,
              z: (o == null ? void 0 : o.z) ?? 1
            },
            selectedShapeIds: (s == null ? void 0 : s.selectedShapeIds) ?? [],
            focusedGroupId: (s == null ? void 0 : s.focusedGroupId) ?? null
          };
        })
      };
    },
    { isEqual: Ab }
  );
}
function Hy(t, e, n) {
  const i = MV(e);
  if (!i) return;
  const r = Fb(t.get(Qn)), s = n != null && n.forceOverwrite ? i : r, o = n != null && n.forceOverwrite ? r : i, a = t.schema.types.instance.create({
    id: Qn,
    ...r,
    // the integrity checker will ensure that the currentPageId is valid
    currentPageId: i.currentPageId,
    isDebugMode: (s == null ? void 0 : s.isDebugMode) ?? (o == null ? void 0 : o.isDebugMode),
    isFocusMode: (s == null ? void 0 : s.isFocusMode) ?? (o == null ? void 0 : o.isFocusMode),
    isToolLocked: (s == null ? void 0 : s.isToolLocked) ?? (o == null ? void 0 : o.isToolLocked),
    isGridMode: (s == null ? void 0 : s.isGridMode) ?? (o == null ? void 0 : o.isGridMode),
    exportBackground: (s == null ? void 0 : s.exportBackground) ?? (o == null ? void 0 : o.exportBackground)
  });
  t.atomic(() => {
    var c, d, u;
    for (const h of i.pageStates ?? []) {
      if (!t.has(h.pageId)) continue;
      const g = kr.createId(h.pageId), p = ar.createId(h.pageId), f = t.get(g), M = t.get(p);
      t.put([
        kr.create({
          id: g,
          x: ((c = h.camera) == null ? void 0 : c.x) ?? (f == null ? void 0 : f.x),
          y: ((d = h.camera) == null ? void 0 : d.y) ?? (f == null ? void 0 : f.y),
          z: ((u = h.camera) == null ? void 0 : u.z) ?? (f == null ? void 0 : f.z)
        }),
        ar.create({
          id: p,
          pageId: h.pageId,
          selectedShapeIds: h.selectedShapeIds ?? (M == null ? void 0 : M.selectedShapeIds),
          focusedGroupId: h.focusedGroupId ?? (M == null ? void 0 : M.focusedGroupId)
        })
      ]);
    }
    t.put([a]), t.ensureStoreIsUsable();
  });
}
function mV(t) {
  var r;
  const e = [];
  for (const s of Object.values(t))
    (r = s.typeName) != null && r.match(/^(instance.*|pointer|camera)$/) && e.push(s);
  const n = e.filter(
    (s) => s.typeName === "instance" && s.id !== Qn
  )[0];
  if (!n) return null;
  const i = {
    version: Ep,
    currentPageId: n.currentPageId,
    exportBackground: !!n.exportBackground,
    isFocusMode: !!n.isFocusMode,
    isDebugMode: !!n.isDebugMode,
    isToolLocked: !!n.isToolLocked,
    isGridMode: !1,
    pageStates: e.filter((s) => s.typeName === "instance_page_state" && s.instanceId === n.id).map((s) => {
      const o = t[s.cameraId] ?? { x: 0, y: 0, z: 1 };
      return {
        pageId: s.pageId,
        camera: {
          x: o.x,
          y: o.y,
          z: o.z
        },
        selectedShapeIds: s.selectedShapeIds,
        focusedGroupId: s.focusedGroupId
      };
    })
  };
  try {
    return e1.validate(i), i;
  } catch {
    return null;
  }
}
function t1(t, e, n) {
  let i = {};
  if ("store" in e) {
    const o = t.schema.migrateStoreSnapshot(e);
    if (o.type !== "success")
      throw new Error("Failed to migrate store snapshot: " + o.reason);
    i.document = {
      schema: t.schema.serialize(),
      store: Cl(
        o.value,
        (a, { typeName: c }) => t.scopedTypes.document.has(c)
      )
    };
  } else
    i = e;
  const r = Fb(t.get(Qn)), s = n1.get(t, sS).get();
  t.atomic(() => {
    i.document && t.loadStoreSnapshot(i.document), r && t.update(Qn, (o) => ({ ...o, ...r })), s && Hy(t, s), i.session && Hy(t, i.session, {
      forceOverwrite: n == null ? void 0 : n.forceOverwriteSessionState
    });
  });
}
const n1 = new hr();
function yV(t) {
  const n = n1.get(t, sS).get();
  if (!n)
    throw new Error("Session state is not ready yet");
  return {
    document: t.getStoreSnapshot(),
    session: n
  };
}
function i1(t) {
  const e = [], n = /* @__PURE__ */ new Set();
  for (const i of t) {
    if (n.has(i.type))
      throw new Error(`Binding type "${i.type}" is defined more than once`);
    e.push(i), n.add(i.type);
  }
  return e;
}
function Xi({ children: t, className: e = "", ...n }) {
  return /* @__PURE__ */ l.jsx("svg", { ...n, className: ce("tl-svg-container", e), children: t });
}
function oS(t, e, n, i) {
  const r = t.x - n.x, s = t.y - n.y, o = i.x - n.x, a = i.y - n.y, c = e.x - t.x, d = e.y - t.y, u = o * s - a * r, h = c * s - d * r, g = a * c - o * d;
  if (u === 0 || h === 0 || g === 0) return null;
  if (g !== 0) {
    const p = u / g, f = h / g;
    if (0 <= p && p <= 1 && 0 <= f && f <= 1)
      return x.AddXY(t, p * c, p * d);
  }
  return null;
}
function yd(t, e, n, i) {
  const r = (e.x - t.x) * (e.x - t.x) + (e.y - t.y) * (e.y - t.y), s = 2 * ((e.x - t.x) * (t.x - n.x) + (e.y - t.y) * (t.y - n.y)), o = n.x * n.x + n.y * n.y + t.x * t.x + t.y * t.y - 2 * (n.x * t.x + n.y * t.y) - i * i, a = s * s - 4 * r * o;
  if (a < 0 || a === 0) return null;
  const c = Math.sqrt(a), d = (-s + c) / (2 * r), u = (-s - c) / (2 * r);
  if ((d < 0 || d > 1) && (u < 0 || u > 1))
    return null;
  const h = [];
  return 0 <= d && d <= 1 && h.push(x.Lrp(t, e, d)), 0 <= u && u <= 1 && h.push(x.Lrp(t, e, u)), h.length === 0 ? null : h;
}
function IV(t, e, n) {
  const i = [];
  let r;
  for (let s = 0, o = n.length - 1; s < o; s++)
    r = oS(t, e, n[s], n[s + 1]), r && i.push(r);
  return i.length === 0 ? null : i;
}
function aS(t, e, n) {
  const i = [];
  let r;
  for (let s = 1, o = n.length; s < o + 1; s++)
    r = oS(
      t,
      e,
      n[s - 1],
      n[s % n.length]
    ), r && i.push(r);
  return i.length === 0 ? null : i;
}
function xV(t, e, n, i) {
  let r = n.x - t.x, s = n.y - t.y;
  const o = Math.sqrt(r * r + s * s), a = (o * o - i * i + e * e) / (2 * o), c = Math.sqrt(e * e - a * a);
  return r /= o, s /= o, [
    new x(t.x + r * a - s * c, t.y + s * a + r * c),
    new x(t.x + r * a + s * c, t.y + s * a - r * c)
  ];
}
function Vy(t, e, n) {
  const i = [];
  let r, s, o;
  for (let a = 0, c = n.length; a < c; a++)
    r = n[a], s = n[(a + 1) % n.length], o = yd(r, s, t, e), o && i.push(...o);
  return i.length === 0 ? null : i;
}
function $0(t, e, n) {
  const i = [];
  let r, s, o;
  for (let a = 1, c = n.length; a < c; a++)
    r = n[a - 1], s = n[a], o = yd(r, s, t, e), o && i.push(...o);
  return i.length === 0 ? null : i;
}
function Tu(t, e, n) {
  return (n.y - t.y) * (e.x - t.x) > (e.y - t.y) * (n.x - t.x);
}
function cS(t, e, n, i) {
  return Tu(t, n, i) !== Tu(e, n, i) && Tu(t, e, n) !== Tu(t, e, i);
}
function ew(t, e) {
  const n = /* @__PURE__ */ new Map();
  let i, r, s, o;
  for (let a = 0, c = t.length; a < c; a++)
    if (i = t[a], yi(i, e)) {
      const d = vM(i);
      n.has(d) || n.set(d, i);
    }
  for (let a = 0, c = e.length; a < c; a++)
    if (i = e[a], yi(i, t)) {
      const d = vM(i);
      n.has(d) || n.set(d, i);
    }
  for (let a = 0, c = t.length; a < c; a++) {
    i = t[a], r = t[(a + 1) % t.length];
    for (let d = 0, u = e.length; d < u; d++) {
      s = e[d], o = e[(d + 1) % e.length];
      const h = oS(i, r, s, o);
      if (h !== null) {
        const g = vM(h);
        n.has(g) || n.set(g, h);
      }
    }
  }
  return n.size === 0 ? null : SV([...n.values()]);
}
function vM(t) {
  return `${t.x},${t.y}`;
}
function SV(t) {
  const e = x.Average(t);
  return t.sort((n, i) => x.Angle(e, n) - x.Angle(e, i));
}
function r1(t, e) {
  let n, i, r, s;
  for (let o = 0, a = t.length; o < a; o++) {
    n = t[o], i = t[(o + 1) % a];
    for (let c = 0, d = e.length; c < d; c++)
      if (r = e[c], s = e[(c + 1) % d], cS(n, i, r, s)) return !0;
  }
  return !1;
}
function jV(t, e) {
  let n, i, r, s;
  for (let o = 0, a = t.length; o < a; o++) {
    n = t[o], i = t[(o + 1) % a];
    for (let c = 1, d = e.length; c < d; c++)
      if (r = e[c - 1], s = e[c], cS(n, i, r, s)) return !0;
  }
  return !1;
}
class ls extends lo {
  constructor(n) {
    super({ ...n, isClosed: !1, isFilled: !1 });
    S(this, "start");
    S(this, "end");
    S(this, "d");
    S(this, "u");
    S(this, "ul");
    const { start: i, end: r } = n;
    this.start = i, this.end = r, this.d = i.clone().sub(r), this.u = this.d.clone().uni(), this.ul = this.u.len();
  }
  getLength() {
    return this.d.len();
  }
  midPoint() {
    return this.start.lrp(this.end, 0.5);
  }
  getVertices() {
    return [this.start, this.end];
  }
  nearestPoint(n) {
    const { start: i, end: r, d: s, u: o, ul: a } = this;
    if (s.len() === 0 || a === 0) return i;
    const c = x.Sub(n, i).dpr(o) / a, d = i.x + o.x * c;
    if (d < Math.min(i.x, r.x)) return i.x < r.x ? i : r;
    if (d > Math.max(i.x, r.x)) return i.x > r.x ? i : r;
    const u = i.y + o.y * c;
    return u < Math.min(i.y, r.y) ? i.y < r.y ? i : r : u > Math.max(i.y, r.y) ? i.y > r.y ? i : r : new x(d, u);
  }
  hitTestLineSegment(n, i, r = 0) {
    return cS(n, i, this.start, this.end) || this.distanceToLineSegment(n, i) <= r;
  }
  getSvgPathData(n = !0) {
    const { start: i, end: r } = this;
    return `${n ? `M${i.toFixed()}` : ""} L${r.toFixed()}`;
  }
}
class Ds extends lo {
  constructor(n) {
    super({ isClosed: !1, isFilled: !1, ...n });
    S(this, "points");
    S(this, "_segments");
    const { points: i } = n;
    this.points = i;
  }
  // eslint-disable-next-line no-restricted-syntax
  get segments() {
    if (!this._segments) {
      this._segments = [];
      const { vertices: n } = this;
      for (let i = 0, r = n.length - 1; i < r; i++) {
        const s = n[i], o = n[i + 1];
        this._segments.push(new ls({ start: s, end: o }));
      }
      this.isClosed && this._segments.push(new ls({ start: n[n.length - 1], end: n[0] }));
    }
    return this._segments;
  }
  getLength() {
    return this.segments.reduce((n, i) => n + i.length, 0);
  }
  getVertices() {
    return this.points;
  }
  nearestPoint(n) {
    const { segments: i } = this;
    let r = this.points[0], s = 1 / 0, o, a;
    for (let c = 0; c < i.length; c++)
      o = i[c].nearestPoint(n), a = x.Dist2(o, n), a < s && (r = o, s = a);
    if (!r) throw Error("nearest point not found");
    return r;
  }
  hitTestLineSegment(n, i, r = 0) {
    const { segments: s } = this;
    for (let o = 0, a = s.length; o < a; o++)
      if (s[o].hitTestLineSegment(n, i, r))
        return !0;
    return !1;
  }
  getSvgPathData() {
    const { vertices: n } = this;
    return n.length < 2 ? "" : n.reduce((i, r, s) => s === 0 ? `M ${r.x} ${r.y}` : `${i} L ${r.x} ${r.y}`, "");
  }
}
class Gt extends Ds {
  constructor(e) {
    super({ ...e }), this.isClosed = !0;
  }
}
class Pi extends Gt {
  constructor(n) {
    const { x: i = 0, y: r = 0, width: s, height: o } = n;
    super({
      ...n,
      points: [
        new x(i, r),
        new x(i + s, r),
        new x(i + s, r + o),
        new x(i, r + o)
      ]
    });
    S(this, "x");
    S(this, "y");
    S(this, "w");
    S(this, "h");
    this.x = i, this.y = r, this.w = s, this.h = o;
  }
  getBounds() {
    return new ae(this.x, this.y, this.w, this.h);
  }
  getSvgPathData() {
    const { x: n, y: i, w: r, h: s } = this;
    return `M${n},${i} h${r} v${s} h-${r}z`;
  }
}
class Ci {
  constructor(e) {
    this.editor = e;
  }
  /**
   * Whether the shape can be snapped to by another shape.
   *
   * @public
   */
  canSnap(e) {
    return !0;
  }
  /**
   * Whether the shape can be scrolled while editing.
   *
   * @public
   */
  canScroll(e) {
    return !1;
  }
  /**
   * Whether the shape can be bound to. See {@link TLShapeUtilCanBindOpts} for details.
   *
   * @public
   */
  canBind(e) {
    return !0;
  }
  /**
   * Whether the shape can be double clicked to edit.
   *
   * @public
   */
  canEdit(e) {
    return !1;
  }
  /**
   * Whether the shape can be resized.
   *
   * @public
   */
  canResize(e) {
    return !0;
  }
  /**
   * Whether the shape can be edited in read-only mode.
   *
   * @public
   */
  canEditInReadOnly(e) {
    return !1;
  }
  /**
   * Whether the shape can be cropped.
   *
   * @public
   */
  canCrop(e) {
    return !1;
  }
  /**
   * Whether the shape participates in stacking, aligning, and distributing.
   *
   * @public
   */
  canBeLaidOut(e) {
    return !0;
  }
  /**
   * Does this shape provide a background for its children? If this is true,
   * then any children with a `renderBackground` method will have their
   * backgrounds rendered _above_ this shape. Otherwise, the children's
   * backgrounds will be rendered above either the next ancestor that provides
   * a background, or the canvas background.
   *
   * @internal
   */
  providesBackgroundForChildren(e) {
    return !1;
  }
  /**
   * Whether the shape should hide its resize handles when selected.
   *
   * @public
   */
  hideResizeHandles(e) {
    return !1;
  }
  /**
   * Whether the shape should hide its rotation handles when selected.
   *
   * @public
   */
  hideRotateHandle(e) {
    return !1;
  }
  /**
   * Whether the shape should hide its selection bounds background when selected.
   *
   * @public
   */
  hideSelectionBoundsBg(e) {
    return !1;
  }
  /**
   * Whether the shape should hide its selection bounds foreground when selected.
   *
   * @public
   */
  hideSelectionBoundsFg(e) {
    return !1;
  }
  /**
   * Whether the shape's aspect ratio is locked.
   *
   * @public
   */
  isAspectRatioLocked(e) {
    return !1;
  }
  /**
   * Get whether the shape can receive children of a given type.
   *
   * @param shape - The shape.
   * @param type - The shape type.
   * @public
   */
  canReceiveNewChildrenOfType(e, n) {
    return !1;
  }
  /**
   * Get whether the shape can receive children of a given type.
   *
   * @param shape - The shape type.
   * @param shapes - The shapes that are being dropped.
   * @public
   */
  canDropShapes(e, n) {
    return !1;
  }
  /** @internal */
  expandSelectionOutlinePx(e) {
    return 0;
  }
  /**
   * Return elements to be added to the \<defs\> section of the canvases SVG context. This can be
   * used to define SVG content (e.g. patterns & masks) that can be referred to by ID from svg
   * elements returned by `component`.
   *
   * Each def should have a unique `key`. If multiple defs from different shapes all have the same
   * key, only one will be used.
   */
  getCanvasSvgDefs() {
    return [];
  }
  /**
   * Get the geometry to use when snapping to this this shape in translate/resize operations. See
   * {@link BoundsSnapGeometry} for details.
   */
  getBoundsSnapGeometry(e) {
    return {};
  }
  /**
   * Get the geometry to use when snapping handles to this shape. See {@link HandleSnapGeometry}
   * for details.
   */
  getHandleSnapGeometry(e) {
    return {};
  }
  getText(e) {
  }
}
/**
 * Props allow you to define the shape's properties in a way that the editor can understand.
 * This has two main uses:
 *
 * 1. Validation. Shapes will be validated using these props to stop bad data from being saved.
 * 2. Styles. Each {@link @tldraw/tlschema#StyleProp} in the props can be set on many shapes at
 *    once, and will be remembered from one shape to the next.
 *
 * @example
 * ```tsx
 * import {T, TLBaseShape, TLDefaultColorStyle, DefaultColorStyle, ShapeUtil} from 'tldraw'
 *
 * type MyShape = TLBaseShape<'mine', {
 *      color: TLDefaultColorStyle,
 *      text: string,
 * }>
 *
 * class MyShapeUtil extends ShapeUtil<MyShape> {
 *     static props = {
 *         // we use tldraw's built-in color style:
 *         color: DefaultColorStyle,
 *         // validate that the text prop is a string:
 *         text: T.string,
 *     }
 * }
 * ```
 */
S(Ci, "props"), /**
 * Migrations allow you to make changes to a shape's props over time. Read the
 * {@link https://www.tldraw.dev/docs/persistence#Shape-props-migrations | shape prop migrations}
 * guide for more information.
 */
S(Ci, "migrations"), /**
 * The type of the shape util, which should match the shape's type.
 *
 * @public
 */
S(Ci, "type");
function or(t, e, n = {}) {
  const {
    closed: i = !1,
    snap: r = 1,
    start: s = "outset",
    end: o = "outset",
    lengthRatio: a = 2,
    style: c = "dashed",
    forceSolid: d = !1
  } = n;
  let u = 0, h = 0, g = 1, p = 0, f = 0;
  if (d)
    return {
      strokeDasharray: "none",
      strokeDashoffset: "none"
    };
  switch (c) {
    case "dashed": {
      g = 1, u = Math.min(e * a, t / 4);
      break;
    }
    case "dotted": {
      g = 100, u = e / g;
      break;
    }
    default:
      return {
        strokeDasharray: "none",
        strokeDashoffset: "none"
      };
  }
  return i || (s === "outset" ? (t += u / 2, f += u / 2) : s === "skip" && (t -= u, f -= u), o === "outset" ? t += u / 2 : o === "skip" && (t -= u)), h = Math.floor(t / u / (2 * g)), h -= h % r, h < 3 && c === "dashed" ? t / e < 4 ? (u = t, h = 1, p = 0) : (u = t * (1 / 3), p = t * (1 / 3)) : (u = t / h / (2 * g), i ? (f = u / 2, p = (t - h * u) / h) : p = (t - h * u) / Math.max(1, h - 1)), {
    strokeDasharray: [u, p].join(" "),
    strokeDashoffset: f.toString()
  };
}
function tw({ bounds: t, className: e }) {
  const n = Q(), i = G("zoom level", () => n.getZoomLevel(), [n]);
  return /* @__PURE__ */ l.jsx("g", { className: e, pointerEvents: "none", strokeLinecap: "round", strokeLinejoin: "round", children: t.sides.map((r, s) => {
    const { strokeDasharray: o, strokeDashoffset: a } = or(
      r[0].dist(r[1]),
      1 / i,
      {
        style: "dashed",
        lengthRatio: 4
      }
    );
    return /* @__PURE__ */ l.jsx(
      "line",
      {
        x1: r[0].x,
        y1: r[0].y,
        x2: r[1].x,
        y2: r[1].y,
        strokeDasharray: o,
        strokeDashoffset: a
      },
      s
    );
  }) });
}
class Dh extends Ci {
  hideSelectionBoundsFg() {
    return !0;
  }
  canBind() {
    return !1;
  }
  getDefaultProps() {
    return {};
  }
  getGeometry(e) {
    const n = this.editor.getSortedChildIdsForParent(e.id);
    return n.length === 0 ? new Pi({ width: 1, height: 1, isFilled: !1 }) : new Ki({
      children: n.map((i) => {
        const r = this.editor.getShape(i), s = this.editor.getShapeGeometry(i), o = this.editor.getShapeLocalTransform(r).applyToPoints(s.vertices);
        return s.isClosed ? new Gt({
          points: o,
          isFilled: !0
        }) : new Ds({
          points: o
        });
      })
    });
  }
  component(e) {
    const n = this.editor.getErasingShapeIds().includes(e.id), { hintingShapeIds: i } = this.editor.getCurrentPageState(), r = i.length > 0 && i.some(
      (a) => a !== e.id && this.editor.isShapeOfType(this.editor.getShape(a), "group")
    ), s = this.editor.getCurrentPageState().focusedGroupId !== e.id;
    if (!n && // always show the outline while we're erasing the group
    // show the outline while the group is focused unless something outside of the group is being hinted
    // this happens dropping shapes from a group onto some outside group
    (s || r))
      return null;
    const o = this.editor.getShapeGeometry(e).bounds;
    return /* @__PURE__ */ l.jsx(Xi, { children: /* @__PURE__ */ l.jsx(tw, { className: "tl-group", bounds: o }) });
  }
  indicator(e) {
    const n = this.editor.getShapeGeometry(e).bounds;
    return /* @__PURE__ */ l.jsx(tw, { className: "", bounds: n });
  }
  onChildrenChange(e) {
    const n = this.editor.getSortedChildIdsForParent(e.id);
    if (n.length === 0) {
      this.editor.getCurrentPageState().focusedGroupId === e.id && this.editor.popFocusedGroupId(), this.editor.deleteShapes([e.id]);
      return;
    } else if (n.length === 1) {
      this.editor.getCurrentPageState().focusedGroupId === e.id && this.editor.popFocusedGroupId(), this.editor.reparentShapes(n, e.parentId), this.editor.deleteShapes([e.id]);
      return;
    }
  }
}
S(Dh, "type", "group"), S(Dh, "props", ev), S(Dh, "migrations", tv);
const s1 = [
  // created by grouping interactions, probably the corest core shape that we have
  Dh
], DV = new Set(s1.map((t) => t.type));
function o1(t) {
  const e = [...s1], n = /* @__PURE__ */ new Set();
  for (const i of t) {
    if (DV.has(i.type))
      throw new Error(
        `Shape type "${i.type}" is a core shapes type and cannot be overridden`
      );
    if (n.has(i.type))
      throw new Error(`Shape type "${i.type}" is defined more than once`);
    e.push(i), n.add(i.type);
  }
  return e;
}
function a1(t, e) {
  const n = /* @__PURE__ */ new Map();
  return async function(r) {
    const s = n.get(r);
    if (s) return s;
    const o = (async () => {
      try {
        const a = await gr(r, e);
        return ct(a.ok), await t(a);
      } catch (a) {
        return console.error(a), null;
      }
    })();
    return n.set(r, o), o;
  };
}
const Cp = a1(async (t) => await us.blobToDataUrl(await t.blob())), wV = /@import\s+(?:"([^"]+)"|'([^']+)'|url\s*\(\s*(?:"([^"]+)"|'([^']+)'|([^'")]+))\s*\))([^;]+);/gi, NV = /@font-face\s*{([^}]+)}/gi, c1 = /url\s*\(\s*(?:"([^"]+)"|'([^']+)'|([^'")]+))\s*\)/gi, AV = /(?:^|;)\s*font-family\s*:\s*(?:([^'"][^;\n]+)|"([^"]+)"|'([^']+)')\s*(?:;|$)/gi;
function TV(t) {
  return Array.from(t.matchAll(wV), (e) => ({
    url: e[1] || e[2] || e[3] || e[4] || e[5],
    extras: e[6]
  }));
}
function l1(t, e) {
  return Array.from(t.matchAll(NV), (n) => {
    const i = n[1], r = Array.from(i.matchAll(c1), (o) => {
      var c;
      const a = o[1] || o[2] || o[3];
      return {
        original: a,
        resolved: ((c = Le(a, e)) == null ? void 0 : c.href) ?? null
      };
    }), s = new Set(
      Array.from(i.matchAll(AV), (o) => (o[1] || o[2] || o[3]).toLowerCase())
    );
    return { fontFace: i, urls: r, fontFamilies: s };
  });
}
function bV(t) {
  const e = /\s*(?:([^'"][^;\n\s,]+)|"([^"]+)"|'([^']+)')\s*/gi, n = /\s*,\s*/gi, i = /* @__PURE__ */ new Set();
  for (; ; ) {
    const r = e.exec(t);
    if (!r)
      break;
    const s = r[1] || r[2] || r[3];
    if (i.add(s.toLowerCase()), n.lastIndex = e.lastIndex, !n.exec(t))
      break;
    e.lastIndex = n.lastIndex;
  }
  return i;
}
function d1(t) {
  return !(t.startsWith("-") || t.startsWith("animation") || t.startsWith("transition") || t === "cursor" || t === "pointer-events" || t === "user-select" || t === "touch-action");
}
function vV(t, e) {
  return {
    imports: TV(t),
    fontFaces: l1(t, e)
  };
}
function EV(t) {
  return Array.from(t.matchAll(c1), (e) => ({
    original: e[0],
    url: e[1] || e[2] || e[3]
  }));
}
const CV = /* @__PURE__ */ new Set([
  "border-collapse",
  "border-spacing",
  "caption-side",
  "color",
  "cursor",
  "direction",
  "empty-cells",
  "font-family",
  "font-size",
  "font-style",
  "font-variant",
  "font-weight",
  "font-size-adjust",
  "font-stretch",
  "font",
  "letter-spacing",
  "line-height",
  "list-style-image",
  "list-style-position",
  "list-style-type",
  "list-style",
  "orphans",
  "quotes",
  "tab-size",
  "text-align",
  "text-align-last",
  "text-decoration-color",
  "text-indent",
  "text-justify",
  "text-shadow",
  "text-transform",
  "visibility",
  "white-space",
  "widows",
  "word-break",
  "word-spacing",
  "word-wrap"
]);
function u1(t) {
  return CV.has(t);
}
var zV = Object.create, h1 = Object.defineProperty, LV = Object.getOwnPropertyDescriptor, kV = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), g1 = (t) => {
  throw TypeError(t);
}, p1 = (t, e, n) => e in t ? h1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, OV = (t) => [, , , zV(null)], f1 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], M1 = (t) => t !== void 0 && typeof t != "function" ? g1("Function expected") : t, PV = (t, e, n, i, r) => ({ kind: f1[t], name: e, metadata: i, addInitializer: (s) => n._ ? g1("Already initialized") : r.push(M1(s || null)) }), UV = (t, e) => p1(e, kV("metadata"), t[3]), RV = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, YV = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = f1[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, LV(r, n)), y = i.length - 1; y >= 0; y--)
    c = PV(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, M1(o) && (m[f] = o);
  return m && h1(r, n, m), r;
}, bu = (t, e, n) => p1(t, typeof e != "symbol" ? e + "" : e, n), m1, zp;
m1 = [di];
class lS {
  constructor() {
    RV(zp, 5, this), bu(this, "fontFacesPromise", null), bu(this, "foundFontNames", /* @__PURE__ */ new Set()), bu(this, "fontFacesToEmbed", /* @__PURE__ */ new Set()), bu(this, "pendingPromises", []);
  }
  startFindingCurrentDocumentFontFaces() {
    ct(!this.fontFacesPromise, "FontEmbedder already started"), this.fontFacesPromise = QV();
  }
  onFontFamilyValue(e) {
    ct(this.fontFacesPromise, "FontEmbedder not started");
    const n = bV(e);
    for (const i of n) {
      if (this.foundFontNames.has(i)) return;
      this.foundFontNames.add(i), this.pendingPromises.push(
        this.fontFacesPromise.then((r) => {
          const s = r.filter((o) => o.fontFamilies.has(i));
          for (const o of s)
            if (!this.fontFacesToEmbed.has(o)) {
              this.fontFacesToEmbed.add(o);
              for (const a of o.urls)
                !a.resolved || a.embedded || (a.embedded = Cp(a.resolved));
            }
        })
      );
    }
  }
  async createCss() {
    await Promise.all(this.pendingPromises);
    let e = "";
    for (const n of this.fontFacesToEmbed) {
      let i = `@font-face {${n.fontFace}}`;
      for (const r of n.urls) {
        if (!r.embedded) continue;
        const s = await r.embedded;
        s && (i = i.replace(r.original, s));
      }
      e += i;
    }
    return e;
  }
}
zp = OV();
YV(zp, 1, "onFontFamilyValue", m1, lS);
UV(zp, lS);
async function QV() {
  const t = [];
  for (const e of document.styleSheets) {
    let n;
    try {
      n = e.cssRules;
    } catch {
    }
    if (n)
      for (const i of e.cssRules)
        i instanceof CSSFontFaceRule ? t.push(l1(i.cssText, e.href ?? document.baseURI)) : i instanceof CSSImportRule && t.push(Ky(i.href));
    else e.href && t.push(Ky(e.href));
  }
  return Ze(await Promise.all(t)).flat();
}
const Ky = a1(async (t) => {
  const e = vV(await t.text(), t.url), n = await Promise.all(
    e.imports.map(({ url: i }) => Ky(new URL(i, t.url).href))
  );
  return [...e.fontFaces, ...Ze(n).flat()];
});
function y1(t) {
  if (t.shadowRoot)
    return t.shadowRoot.childNodes;
  if (GV(t)) {
    const e = t.assignedNodes();
    if (e != null && e.length)
      return e;
  }
  return t.childNodes;
}
function* Xy(t) {
  for (const e of y1(t))
    ZV(e) && (yield e);
}
function Lp(t) {
  var e;
  return ((e = t.ownerDocument) == null ? void 0 : e.defaultView) ?? globalThis;
}
function ZV(t) {
  return t instanceof Lp(t).Element;
}
function FV(t) {
  return t instanceof Lp(t).ShadowRoot;
}
function BV(t) {
  return "getRootNode" in t && FV(t.getRootNode());
}
function GV(t) {
  return BV(t) && t instanceof Lp(t).HTMLSlotElement;
}
function WV(t) {
  return t.style;
}
function dS(t, e) {
  return Lp(t).getComputedStyle(t, e);
}
const vo = {};
class HV {
  constructor(e) {
    S(this, "styles", /* @__PURE__ */ new Map());
    S(this, "fonts", new lS());
    this.root = e;
  }
  readRootElementStyles(e) {
    this.readElementStyles(e, {
      shouldRespectDefaults: !1,
      shouldSkipInheritedParentStyles: !1
    });
    const n = Array.from(Xy(e));
    for (; n.length; ) {
      const i = n.pop();
      n.push(...Xy(i)), this.readElementStyles(i, {
        shouldRespectDefaults: !0,
        shouldSkipInheritedParentStyles: !0
      });
    }
  }
  readElementStyles(e, { shouldRespectDefaults: n = !0, shouldSkipInheritedParentStyles: i = !0 }) {
    var a;
    const r = n ? JV(e.tagName.toLowerCase()) : vo, s = i ? ((a = this.styles.get(e.parentElement)) == null ? void 0 : a.self) ?? vo : vo, o = {
      self: VV(e, { defaultStyles: r, parentStyles: s }),
      before: nw(e, "::before"),
      after: nw(e, "::after")
    };
    this.styles.set(e, o);
  }
  fetchResources() {
    const e = [];
    for (const n of this.styles.values())
      for (const i of Pt(n))
        if (i)
          for (const [r, s] of Object.entries(i)) {
            if (!s) continue;
            r === "font-family" && this.fonts.onFontFamilyValue(s);
            const o = EV(s);
            o.length !== 0 && e.push(
              ...o.map(async ({ url: a, original: c }) => {
                const d = await Cp(a) ?? "data:";
                i[r] = s.replace(c, `url("${d}")`);
              })
            );
          }
    return Promise.all(e);
  }
  // custom elements are tricky. if we serialize the dom as-is, the custom elements wont have
  // their shadow-dom contents serialized. after we've read all the styles, we need to unwrap the
  // contents of each custom elements shadow dom directly into the parent element itself.
  unwrapCustomElements() {
    const e = /* @__PURE__ */ new Set(), n = (i, r) => {
      if (e.has(i)) return;
      e.add(i);
      const s = i.shadowRoot;
      if (s) {
        const o = document.createElement("div");
        this.styles.set(o, this.styles.get(i)), o.setAttribute("data-tl-custom-element", i.tagName), (r ?? i.parentElement).appendChild(o);
        for (const a of s.childNodes)
          a instanceof Element ? n(a, o) : o.appendChild(a.cloneNode(!0));
        i.remove();
      } else if (r) {
        if (i.tagName.toLowerCase() === "style")
          return;
        const o = i.cloneNode(!1);
        this.styles.set(o, this.styles.get(i)), r.appendChild(o);
        for (const a of y1(i))
          a instanceof Element ? n(a, o) : o.appendChild(a.cloneNode(!0));
      }
    };
    for (const i of this.styles.keys())
      n(i, null);
  }
  embedStyles() {
    let e = "";
    for (const [n, i] of this.styles) {
      if (i.after || i.before) {
        const s = `pseudo-${ht()}`;
        n.classList.add(s), i.before && (e += `.${s}::before {${iw(i.before)}}
`), i.after && (e += `.${s}::after {${iw(i.after)}}
`);
      }
      const r = WV(n);
      for (const [s, o] of Object.entries(i.self))
        o && r.setProperty(s, o);
      r.fontKerning === "auto" && (r.fontKerning = "normal");
    }
    return e;
  }
  async getFontFaceCss() {
    return await this.fonts.createCss();
  }
  dispose() {
    XV();
  }
}
function VV(t, { defaultStyles: e, parentStyles: n }) {
  return t.computedStyleMap ? I1(t.computedStyleMap(), { defaultStyles: e, parentStyles: n }) : uS(dS(t), { defaultStyles: e, parentStyles: n });
}
function nw(t, e) {
  const n = dS(t, e), i = n.getPropertyValue("content");
  if (!(i === "" || i === "none"))
    return uS(n, { defaultStyles: vo, parentStyles: vo });
}
function I1(t, { defaultStyles: e, parentStyles: n }) {
  const i = {};
  for (const r of t.keys()) {
    if (!d1(r)) continue;
    const s = t.get(r).toString();
    e[r] !== s && (n[r] === s && u1(r) || (i[r] = s));
  }
  return i;
}
function uS(t, { defaultStyles: e, parentStyles: n }) {
  const i = {};
  for (const r of t) {
    if (!d1(r)) continue;
    const s = t.getPropertyValue(r);
    e[r] !== s && (n[r] === s && u1(r) || (i[r] = s));
  }
  return i;
}
function iw(t) {
  let e = "";
  for (const [n, i] of Object.entries(t))
    e += `${n}: ${i};`;
  return e;
}
let Ra;
const rw = {};
function KV() {
  if (!Ra) {
    const t = document.createElement("iframe");
    t.style.display = "none", document.body.appendChild(t);
    const e = oi(t.contentDocument, "frame must have a document"), n = document.createElementNS("http://www.w3.org/2000/svg", "svg"), i = document.createElementNS("http://www.w3.org/2000/svg", "foreignObject");
    n.appendChild(i), e.body.appendChild(n), Ra = { iframe: t, foreignObject: i, document: e };
  }
  return Ra;
}
function XV() {
  Ra && (document.body.removeChild(Ra.iframe), Ra = void 0);
}
const sw = { defaultStyles: vo, parentStyles: vo };
function JV(t) {
  let e = rw[t];
  if (!e) {
    const { foreignObject: n, document: i } = KV(), r = i.createElement(t);
    n.appendChild(r), e = r.computedStyleMap ? I1(r.computedStyleMap(), sw) : uS(dS(r), sw), n.removeChild(r), rw[t] = e;
  }
  return e;
}
function qV(t, e) {
  Array.from(t.attributes).forEach((i) => {
    e.setAttribute(i.name, i.value);
  });
}
function ow(t, e) {
  return t.replaceWith(e), e;
}
async function kl(t, e) {
  const n = document.createElement("img");
  e && qV(e, n), n.setAttribute("src", t ?? "data:"), n.setAttribute("decoding", "sync"), n.setAttribute("loading", "eager");
  try {
    await n.decode();
  } catch {
  }
  return n;
}
async function _V(t) {
  try {
    const e = t.toDataURL();
    return await kl(e, t);
  } catch {
    return await kl(null, t);
  }
}
async function $V(t) {
  try {
    const e = await bi.getVideoFrameAsDataUrl(t);
    return kl(e, t);
  } catch (e) {
    console.error("Could not get video frame", e);
  }
  if (t.poster) {
    const e = await Cp(t.poster);
    return kl(e, t);
  }
  return kl(null, t);
}
async function x1(t) {
  if (t instanceof HTMLCanvasElement)
    return ow(t, await _V(t));
  if (t instanceof HTMLVideoElement)
    return ow(t, await $V(t));
  if (t instanceof HTMLImageElement) {
    const e = t.currentSrc || t.src, n = await Cp(e);
    t.setAttribute("src", n ?? "data:"), t.setAttribute("decoding", "sync"), t.setAttribute("loading", "eager");
    try {
      await t.decode();
    } catch {
    }
    return t;
  } else t instanceof HTMLInputElement ? t.setAttribute("value", t.value) : t instanceof HTMLTextAreaElement && (t.textContent = t.value);
  await Promise.all(
    Array.from(Xy(t), (e) => x1(e))
  );
}
function kp(t) {
  const e = le();
  return at(() => {
    e.current = t;
  }), dy(t), re((...n) => {
    const i = e.current;
    return ct(i, "fn does not exist"), i(...n);
  }, []);
}
const hS = Ii(null);
function e8({
  context: t,
  editor: e,
  children: n
}) {
  return /* @__PURE__ */ l.jsx(Jx, { editor: e, children: /* @__PURE__ */ l.jsx(hS.Provider, { value: t, children: n }) });
}
function Id() {
  return Vn(hS);
}
function t8() {
  const t = Vn(hS), [e] = pe(cx);
  return ze(() => (t == null || t.waitUntil(e), () => {
    e.resolve();
  }), [e, t]), kp(() => {
    e.resolve();
  });
}
var n8 = Object.create, S1 = Object.defineProperty, i8 = Object.getOwnPropertyDescriptor, r8 = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), j1 = (t) => {
  throw TypeError(t);
}, D1 = (t, e, n) => e in t ? S1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, s8 = (t) => [, , , n8(null)], w1 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], N1 = (t) => t !== void 0 && typeof t != "function" ? j1("Function expected") : t, o8 = (t, e, n, i, r) => ({ kind: w1[t], name: e, metadata: i, addInitializer: (s) => n._ ? j1("Already initialized") : r.push(N1(s || null)) }), a8 = (t, e) => D1(e, r8("metadata"), t[3]), c8 = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, l8 = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = w1[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, i8(r, n)), y = i.length - 1; y >= 0; y--)
    c = o8(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, N1(o) && (m[f] = o);
  return m && S1(r, n, m), r;
}, aw = (t, e, n) => D1(t, typeof e != "symbol" ? e + "" : e, n), A1, Op;
A1 = [di];
class gS {
  constructor(e) {
    this.maxDelayTimeMs = e, c8(Op, 5, this), aw(this, "isResolved", !1), aw(this, "promisesToWaitFor", []);
  }
  waitUntil(e) {
    if (this.isResolved)
      throw new Error(
        "Cannot `waitUntil` - the export has already been resolved. Make sure to call `waitUntil` as soon as possible during an export - ie within the first react effect after rendering."
      );
    this.promisesToWaitFor.push(
      e.catch((n) => console.error("Error whilst waiting for export:", n))
    );
  }
  async resolvePromises() {
    let e = null;
    for (; this.promisesToWaitFor.length !== e; )
      e = this.promisesToWaitFor.length, await Promise.allSettled(this.promisesToWaitFor), await fy(0);
  }
  async resolve() {
    const e = fy(this.maxDelayTimeMs).then(() => "timeout"), n = this.resolvePromises().then(() => "resolved");
    await Promise.race([e, n]) === "timeout" && console.warn("[tldraw] Export delay timed out after ${this.maxDelayTimeMs}ms"), this.isResolved = !0;
  }
}
Op = s8();
l8(Op, 1, "waitUntil", A1, gS);
a8(Op, gS);
function d8(t, e, n = {}) {
  var y, I;
  if (!window.document) throw Error("No document");
  const {
    scale: i = 1,
    // should we include the background in the export? or is it transparent?
    background: r = !1,
    padding: s = t.options.defaultSvgPadding,
    preserveAspectRatio: o
  } = n, a = n.darkMode ?? t.user.getIsDarkMode(), c = t.getShapeAndDescendantIds(e), d = t.getUnorderedRenderingShapes(!1).filter(({ id: D }) => c.has(D));
  let u = null;
  if (n.bounds)
    u = n.bounds;
  else
    for (const { id: D } of d) {
      const j = t.getShapeMaskedPageBounds(D);
      j && (u ? u.union(j) : u = j.clone());
    }
  if (!u) return;
  const h = e.length === 1 && t.isShapeOfType(t.getShape(e[0]), "frame") ? e[0] : null;
  h || u.expandBy(s);
  const g = u.width * i, p = u.height * i;
  try {
    (I = (y = document.body).focus) == null || I.call(y);
  } catch {
  }
  const f = new gS(t.options.maxExportDelayMs), M = cx();
  return f.waitUntil(M), { jsx: /* @__PURE__ */ l.jsx(
    u8,
    {
      editor: t,
      preserveAspectRatio: o,
      scale: i,
      bbox: u,
      background: r,
      singleFrameShapeId: h,
      isDarkMode: a,
      renderingShapes: d,
      onMount: M.resolve,
      waitUntil: f.waitUntil
    }
  ), width: g, height: p, exportDelay: f };
}
function u8({
  editor: t,
  preserveAspectRatio: e,
  scale: n,
  bbox: i,
  background: r,
  singleFrameShapeId: s,
  isDarkMode: o,
  renderingShapes: a,
  onMount: c,
  waitUntil: d
}) {
  const u = Sc(), h = Hr({ isDarkMode: o }), [g, p] = pe({}), f = kp((D) => {
    cr(g, D.key) || d(
      (async () => {
        const j = await D.getElement();
        j && uy(() => p((w) => ({ ...w, [D.key]: j })));
      })()
    );
  }), M = yt(
    () => ({
      isDarkMode: o,
      waitUntil: d,
      addExportDef: f
    }),
    [o, d, f]
  ), [m, y] = pe(null), I = le(!1);
  return at(() => {
    if (I.current)
      throw new Error("SvgExport should only render once - do not use with react strict mode");
    I.current = !0, (async () => {
      const D = {}, j = a.map(
        async ({ id: A, opacity: b, index: T, backgroundIndex: E }) => {
          var z, O;
          if (A === s) return [];
          const v = t.getShape(A);
          if (t.isShapeOfType(v, "group")) return [];
          const P = [], C = t.getShapeUtil(v);
          if (C.toSvg || C.toBackgroundSvg) {
            const [R, U] = await Promise.all([
              (z = C.toSvg) == null ? void 0 : z.call(C, v, M),
              (O = C.toBackgroundSvg) == null ? void 0 : O.call(C, v, M)
            ]), F = t.getShapePageTransform(v);
            let H = F.toCssString();
            "scale" in v.props && v.props.scale !== 1 && (H = `${H} scale(${v.props.scale}, ${v.props.scale})`);
            const Z = t.getShapeMask(v.id), te = Z ? ne.From(ne.Inverse(F)).applyToPoints(Z) : null, oe = Vx(u, v.id);
            te && (D[oe] = /* @__PURE__ */ l.jsx("clipPath", { id: oe, children: /* @__PURE__ */ l.jsx("path", { d: `M${te.map(({ x: me, y: he }) => `${me},${he}`).join("L")}Z` }) })), R && P.push({
              zIndex: T,
              element: /* @__PURE__ */ l.jsx(
                "g",
                {
                  transform: H,
                  opacity: b,
                  clipPath: Z ? `url(#${oe})` : void 0,
                  children: R
                },
                `fg_${v.id}`
              )
            }), U && P.push({
              zIndex: E,
              element: /* @__PURE__ */ l.jsx(
                "g",
                {
                  transform: H,
                  opacity: b,
                  clipPath: Z ? `url(#${oe})` : void 0,
                  children: U
                },
                `bg_${v.id}`
              )
            });
          } else
            P.push({
              zIndex: T,
              element: /* @__PURE__ */ l.jsx(
                cw,
                {
                  shape: v,
                  util: C,
                  component: Ov,
                  className: "tl-shape",
                  bbox: i,
                  opacity: b
                },
                `fg_${v.id}`
              )
            }), C.backgroundComponent && P.push({
              zIndex: E,
              element: /* @__PURE__ */ l.jsx(
                cw,
                {
                  shape: v,
                  util: C,
                  component: Pv,
                  className: "tl-shape tl-shape-background",
                  bbox: i,
                  opacity: b
                },
                `bg_${v.id}`
              )
            });
          return P;
        }
      ), w = (await Promise.all(j)).flat();
      uy(() => {
        y(
          w.sort((A, b) => A.zIndex - b.zIndex).map(({ element: A }) => A)
        ), p((A) => ({ ...A, ...D }));
      });
    })();
  }, [i, t, M, u, a, s]), ze(() => {
    m !== null && c();
  }, [c, m]), /* @__PURE__ */ l.jsx(e8, { editor: t, context: M, children: /* @__PURE__ */ l.jsxs(
    "svg",
    {
      preserveAspectRatio: e,
      direction: "ltr",
      width: i.width * n,
      height: i.height * n,
      viewBox: `${i.minX} ${i.minY} ${i.width} ${i.height}`,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: {
        backgroundColor: r ? s ? h.solid : h.background : "transparent"
      },
      "data-color-mode": o ? "dark" : "light",
      className: `tl-container tl-theme__force-sRGB ${o ? "tl-theme__dark" : "tl-theme__light"}`,
      children: [
        /* @__PURE__ */ l.jsx("defs", { children: Object.entries(g).map(([D, j]) => /* @__PURE__ */ l.jsx(UA, { children: j }, D)) }),
        m
      ]
    }
  ) });
}
function cw({
  shape: t,
  util: e,
  className: n,
  component: i,
  bbox: r,
  opacity: s
}) {
  const o = Q(), a = ne.Translate(-r.minX, -r.minY).multiply(
    o.getShapePageTransform(t.id)
  ), c = o.getShapeGeometry(t.id).bounds, d = Math.max(c.width, 1), u = Math.max(c.height, 1);
  return /* @__PURE__ */ l.jsx(Hx, { fallback: () => null, children: /* @__PURE__ */ l.jsx(
    "foreignObject",
    {
      x: r.minX,
      y: r.minY,
      width: r.w,
      height: r.h,
      className: "tl-shape-foreign-object",
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          className: n,
          "data-shape-type": t.type,
          style: {
            clipPath: o.getShapeClipPath(t.id),
            transform: a.toCssString(),
            width: d,
            height: u,
            opacity: s
          },
          children: /* @__PURE__ */ l.jsx(i, { shape: t, util: e })
        }
      )
    }
  ) });
}
let h8 = 1;
async function g8(t, e, n = {}) {
  const i = d8(t, e, n);
  if (!i) return;
  const r = t.getContainer(), s = document.createElement("div");
  s.className = "tldraw-svg-export", s.inert = !0, s.tabIndex = -1, Object.assign(s.style, {
    position: "absolute",
    top: "0px",
    left: "0px",
    width: i.width + "px",
    height: i.height + "px",
    pointerEvents: "none",
    opacity: 0
  }), r.appendChild(s);
  const o = py(s, { identifierPrefix: `export_${h8++}_` });
  try {
    uy(() => {
      o.render(i.jsx);
    }), await i.exportDelay.resolve();
    const a = s.firstElementChild;
    return ct(a instanceof SVGSVGElement, "Expected an SVG element"), await p8(a), { svg: a, width: i.width, height: i.height };
  } finally {
    setTimeout(() => {
      o.unmount(), r.removeChild(s);
    }, 0);
  }
}
async function p8(t) {
  const e = [
    ...t.querySelectorAll("foreignObject.tl-shape-foreign-object > *")
  ];
  if (!e.length) return;
  const n = new HV(t);
  try {
    n.fonts.startFindingCurrentDocumentFontFaces(), await Promise.all(e.map((s) => x1(s)));
    for (const s of e)
      n.readRootElementStyles(s);
    await n.fetchResources();
    const i = await n.getFontFaceCss();
    n.unwrapCustomElements();
    const r = n.embedStyles();
    if (i || r) {
      const s = document.createElementNS("http://www.w3.org/2000/svg", "style");
      s.textContent = `${i}
${r}`, t.prepend(s);
    }
  } finally {
    n.dispose();
  }
}
const ir = {
  /**
   * A set of strings representing any open menus. When menus are open,
   * certain interactions will behave differently; for example, when a
   * draw tool is selected and a menu is open, a pointer-down will not
   * create a dot (because the user is probably trying to close the menu)
   * however a pointer-down event followed by a drag will begin drawing
   * a line (because the user is BOTH trying to close the menu AND start
   * drawing a line).
   *
   * @public
   */
  menus: xt("open menus", []),
  /**
   * Get the current open menus.
   *
   * @param contextId - An optional context to get menus for.
   *
   * @public
   */
  getOpenMenus(t) {
    return t ? this.menus.get().filter((e) => e.endsWith("-" + t)) : this.menus.get();
  },
  /**
   * Add an open menu.
   *
   * @example
   * ```ts
   * addOpenMenu('menu-id')
   * addOpenMenu('menu-id', myEditorId)
   * ```
   *
   * @param id - The id of the menu to add.
   * @param contextId - An optional context to add the menu to.
   *
   * @public
   */
  addOpenMenu(t, e = "") {
    const n = e ? `${t}-${e}` : t, i = new Set(this.menus.get());
    i.has(n) || (i.add(n), this.menus.set([...i]));
  },
  /**
   * Delete an open menu.
   *
   * @example
   * ```ts
   * deleteOpenMenu('menu-id')
   * deleteOpenMenu('menu-id', myEditorId)
   * ```
   *
   * @param id - The id of the menu to delete.
   * @param contextId - An optional context to delete the menu from.
   *
   * @public
   */
  deleteOpenMenu(t, e = "") {
    const n = e ? `${t}-${e}` : t, i = new Set(this.menus.get());
    i.has(n) && (i.delete(n), this.menus.set([...i]));
  },
  /**
   * Clear all open menus.
   *
   * @example
   * ```ts
   * clearOpenMenus()
   * clearOpenMenus(myEditorId)
   * ```
   *
   * @param contextId - An optional context to clear menus for.
   *
   * @public
   */
  clearOpenMenus(t) {
    this.menus.set(t ? this.menus.get().filter((e) => !e.endsWith("-" + t)) : []);
  },
  _hiddenMenus: [],
  /**
   * Hide all open menus. Restore them with the `showOpenMenus` method.
   *
   * @example
   * ```ts
   * hideOpenMenus()
   * hideOpenMenus(myEditorId)
   * ```
   *
   * @param contextId - An optional context to hide menus for.
   *
   * @public
   */
  hideOpenMenus(t) {
    if (this._hiddenMenus = [...this.getOpenMenus(t)], this._hiddenMenus.length !== 0)
      for (const e of this._hiddenMenus)
        this.deleteOpenMenu(e, t);
  },
  /**
   * Show all hidden menus.
   *
   * @example
   * ```ts
   * showOpenMenus()
   * showOpenMenus(myEditorId)
   * ```
   *
   * @param contextId - An optional context to show menus for.
   *
   * @public
   */
  showOpenMenus(t) {
    if (this._hiddenMenus.length !== 0) {
      for (const e of this._hiddenMenus)
        this.addOpenMenu(e, t);
      this._hiddenMenus = [];
    }
  },
  /**
   * Get whether a menu is open for a given context.
   *
   * @example
   * ```ts
   * isMenuOpem(id, myEditorId)
   * ```
   *
   * @param id - The id of the menu to check.
   * @param contextId - An optional context to check menus for.
   *
   * @public
   */
  isMenuOpen(t, e) {
    return this.getOpenMenus(e).includes(t);
  },
  /**
   * Get whether any menus are open for a given context.
   *
   * @example
   * ```ts
   * hasOpenMenus(myEditorId)
   * ```
   *
   * @param contextId - A context to check menus for.
   *
   * @public
   */
  hasOpenMenus(t) {
    return this.getOpenMenus(t).length > 0;
  },
  /**
   * Get whether any menus are open for any context.
   *
   * @example
   * ```ts
   * hasAnyOpenMenus()
   * ```
   *
   * @public
   */
  hasAnyOpenMenus() {
    return this.getOpenMenus().length > 0;
  },
  forContext(t) {
    return {
      getOpenMenus: () => this.getOpenMenus(t),
      addOpenMenu: (e) => this.addOpenMenu(e, t),
      deleteOpenMenu: (e) => this.deleteOpenMenu(e, t),
      clearOpenMenus: () => this.clearOpenMenus(t),
      // Gets whether any menus are open
      isMenuOpen: (e) => this.isMenuOpen(e, t),
      hasOpenMenus: () => this.hasOpenMenus(t),
      hasAnyOpenMenus: () => this.hasAnyOpenMenus()
    };
  }
}, Jy = new eR(), f8 = {
  maxShapesPerPage: 4e3,
  maxFilesAtOnce: 100,
  maxPages: 40,
  animationMediumMs: 320,
  followChaseViewportSnap: 2,
  doubleClickDurationMs: 450,
  multiClickDurationMs: 200,
  coarseDragDistanceSquared: 36,
  // 6 squared
  dragDistanceSquared: 16,
  // 4 squared
  defaultSvgPadding: 32,
  cameraSlideFriction: 0.09,
  maxPointsPerDrawShape: 500,
  gridSteps: [
    { min: -1, mid: 0.15, step: 64 },
    { min: 0.05, mid: 0.375, step: 16 },
    { min: 0.15, mid: 1, step: 4 },
    { min: 0.7, mid: 2.5, step: 1 }
  ],
  collaboratorInactiveTimeoutMs: 6e4,
  collaboratorIdleTimeoutMs: 3e3,
  collaboratorCheckIntervalMs: 1200,
  cameraMovingTimeoutMs: 64,
  hitTestMargin: 8,
  edgeScrollDelay: 200,
  edgeScrollEaseDuration: 200,
  edgeScrollSpeed: 25,
  edgeScrollDistance: 8,
  coarsePointerWidth: 12,
  coarseHandleRadius: 20,
  handleRadius: 12,
  longPressDurationMs: 500,
  textShadowLod: 0.35,
  adjacentShapeMargin: 10,
  flattenImageBoundsExpand: 64,
  flattenImageBoundsPadding: 16,
  laserDelayMs: 1200,
  maxExportDelayMs: 5e3,
  temporaryAssetPreviewLifetimeMs: 18e4,
  actionShortcutsLocation: "swap"
};
function lw(t, e) {
  if (!e) return !1;
  switch (t.type) {
    case "mixed":
      return e.type === "mixed";
    case "shared":
      return e.type === "shared" && t.value === e.value;
    default:
      throw rn(t);
  }
}
class M8 {
  constructor(e) {
    /** @internal */
    S(this, "map");
    this.map = new Map(e);
  }
  get(e) {
    return this.map.get(e);
  }
  getAsKnownValue(e) {
    const n = this.get(e);
    if (n && n.type !== "mixed")
      return n.value;
  }
  // eslint-disable-next-line no-restricted-syntax
  get size() {
    return this.map.size;
  }
  equals(e) {
    if (this.size !== e.size) return !1;
    const n = /* @__PURE__ */ new Set();
    for (const [i, r] of this) {
      if (!lw(r, e.get(i))) return !1;
      n.add(i);
    }
    for (const [i, r] of e)
      if (!n.has(i) && !lw(r, this.get(i)))
        return !1;
    return !0;
  }
  keys() {
    return this.map.keys();
  }
  values() {
    return this.map.values();
  }
  entries() {
    return this.map.entries();
  }
  [Symbol.iterator]() {
    return this.map[Symbol.iterator]();
  }
}
class qy extends M8 {
  set(e, n) {
    this.map.set(e, n);
  }
  applyValue(e, n) {
    const i = this.get(e);
    if (!i) {
      this.set(e, { type: "shared", value: n });
      return;
    }
    switch (i.type) {
      case "mixed":
        return;
      case "shared":
        i.value !== n && this.set(e, { type: "mixed" });
        return;
      default:
        rn(i, "type");
    }
  }
}
function m8(t, e, n) {
  return gr(t).then(function(i) {
    return i.arrayBuffer();
  }).then(function(i) {
    return new File([i], e, { type: n });
  });
}
const y8 = "https://cdn.tldraw.com";
function Hs() {
  return `${y8}/${fv}`;
}
function I8(t) {
  switch (t.type) {
    case "shapes":
      return `s${t.shapeIds.map((n) => EM(n.slice(6))).join(".")}`;
    case "page":
      return "p" + EM(kn.parseId(t.pageId));
    case "viewport": {
      const { bounds: e, pageId: n } = t;
      let i = `v${Math.round(e.x)}.${Math.round(e.y)}.${Math.round(e.w)}.${Math.round(e.h)}`;
      return n && (i += "." + EM(kn.parseId(n))), i;
    }
    default:
      rn(t);
  }
}
function x8(t) {
  switch (t[0]) {
    case "s":
      return { type: "shapes", shapeIds: t.slice(1).split(".").filter(Boolean).map((i) => Ee(decodeURIComponent(i))) };
    case "p":
      return { type: "page", pageId: kn.createId(decodeURIComponent(t.slice(1))) };
    case "v": {
      const [n, i, r, s, o] = t.slice(1).split(".");
      return {
        type: "viewport",
        bounds: new ae(Number(n), Number(i), Number(r), Number(s)),
        pageId: o ? kn.createId(decodeURIComponent(o)) : void 0
      };
    }
    default:
      throw Error("Invalid deep link string");
  }
}
function EM(t) {
  return encodeURIComponent(t).replace(/\./g, "%2E");
}
function S8(t, e) {
  var r;
  let n = t;
  const i = new Set(e);
  for (; i.has(n); )
    n = (r = /^.*(\d+)$/.exec(n)) != null && r[1] ? n.replace(/(\d+)(?=\D?)$/, (s) => (+s + 1).toString()) : `${n} 1`;
  return n;
}
function vu(t, e, n) {
  if (n.length === 0) return [];
  const i = /* @__PURE__ */ new Map();
  for (const s of Ze(n.map((o) => t.getShape(o)))) {
    const { parentId: o } = s;
    i.has(o) || i.set(o, {
      children: Ze(
        t.getSortedChildIdsForParent(o).map((a) => t.getShape(a))
      ),
      moving: /* @__PURE__ */ new Set()
    }), i.get(o).moving.add(s);
  }
  const r = [];
  switch (e) {
    case "toBack": {
      i.forEach(({ moving: s, children: o }) => j8(s, o, r));
      break;
    }
    case "toFront": {
      i.forEach(({ moving: s, children: o }) => D8(s, o, r));
      break;
    }
    case "forward": {
      i.forEach(({ moving: s, children: o }) => w8(s, o, r));
      break;
    }
    case "backward": {
      i.forEach(({ moving: s, children: o }) => N8(s, o, r));
      break;
    }
  }
  return r;
}
function j8(t, e, n) {
  const i = e.length;
  if (t.size === i) return;
  let r, s;
  for (let o = 0; o < i; o++) {
    const a = e[o];
    if (t.has(a))
      r = a.index, t.delete(a);
    else {
      s = a.index;
      break;
    }
  }
  if (t.size !== 0) {
    const o = Ga(r, s, t.size);
    n.push(
      ...Array.from(t.values()).sort(Jt).map((a, c) => ({ ...a, index: o[c] }))
    );
  }
}
function D8(t, e, n) {
  const i = e.length;
  if (t.size === i) return;
  let r, s;
  for (let o = i - 1; o > -1; o--) {
    const a = e[o];
    if (t.has(a))
      s = a.index, t.delete(a);
    else {
      r = a.index;
      break;
    }
  }
  if (t.size !== 0) {
    const o = Ga(r, s, t.size);
    n.push(
      ...Array.from(t.values()).sort(Jt).map((a, c) => ({ ...a, index: o[c] }))
    );
  }
}
function w8(t, e, n) {
  var s;
  const i = e.length;
  if (t.size === i) return;
  let r = { name: "skipping" };
  for (let o = 0; o < i; o++) {
    const a = t.has(e[o]);
    switch (r.name) {
      case "skipping": {
        if (!a) continue;
        r = { name: "selecting", selectIndex: o };
        break;
      }
      case "selecting": {
        if (a) continue;
        const { selectIndex: c } = r;
        Ga(e[o].index, (s = e[o + 1]) == null ? void 0 : s.index, o - c).forEach(
          (d, u) => n.push({ ...e[c + u], index: d })
        ), r = { name: "skipping" };
        break;
      }
    }
  }
}
function N8(t, e, n) {
  var s;
  const i = e.length;
  if (t.size === i) return;
  let r = { name: "skipping" };
  for (let o = i - 1; o > -1; o--) {
    const a = t.has(e[o]);
    switch (r.name) {
      case "skipping": {
        if (!a) continue;
        r = { name: "selecting", selectIndex: o };
        break;
      }
      case "selecting": {
        if (a) continue;
        Ga((s = e[o - 1]) == null ? void 0 : s.index, e[o].index, r.selectIndex - o).forEach(
          (c, d) => {
            n.push({ ...e[o + d + 1], index: c });
          }
        ), r = { name: "skipping" };
        break;
      }
    }
  }
}
function T1({
  editor: t,
  ids: e
}) {
  const n = Ze(e.map((o) => t.getShape(o))), i = t.getShapesSharedRotation(e), r = t.getShapesRotatedPageBounds(e);
  if (!r)
    return null;
  const s = r.center.clone().rotWith(r.point, i);
  return {
    pageCenter: s,
    initialCursorAngle: s.angle(t.inputs.originPagePoint),
    initialShapesRotation: i,
    shapeSnapshots: n.map((o) => ({
      shape: o,
      initialPagePoint: t.getShapePageTransform(o.id).point()
    }))
  };
}
function wh({
  delta: t,
  editor: e,
  snapshot: n,
  stage: i,
  centerOverride: r
}) {
  const { pageCenter: s, shapeSnapshots: o } = n;
  e.updateShapes(
    o.map(({ shape: c, initialPagePoint: d }) => {
      const u = si(c.parentId) ? e.getShapePageTransform(c.parentId) : ne.Identity(), h = x.RotWith(d, r ?? s, t), g = ne.applyToPoint(
        // use the current parent transform in case it has moved/resized since the start
        // (e.g. if rotating a shape at the edge of a group)
        ne.Inverse(u),
        h
      ), p = Js(c.rotation + t);
      return {
        id: c.id,
        type: c.type,
        x: g.x,
        y: g.y,
        rotation: p
      };
    })
  );
  const a = [];
  o.forEach(({ shape: c }) => {
    var g, p, f;
    const d = e.getShape(c.id);
    if (!d) return;
    const u = e.getShapeUtil(c);
    if (i === "start" || i === "one-off") {
      const M = (g = u.onRotateStart) == null ? void 0 : g.call(u, c);
      M && a.push(M);
    }
    const h = (p = u.onRotate) == null ? void 0 : p.call(u, c, d);
    if (h && a.push(h), i === "end" || i === "one-off") {
      const M = (f = u.onRotateEnd) == null ? void 0 : f.call(u, c, d);
      M && a.push(M);
    }
  }), a.length > 0 && e.updateShapes(a);
}
const A8 = (t) => {
  const { store: e } = t, n = e.query.filterHistory("binding"), i = e.query.records("binding");
  function r() {
    const s = i.get(), o = /* @__PURE__ */ new Map();
    for (const a of s) {
      const { fromId: c, toId: d } = a, u = o.get(c);
      u ? u.push(a) : o.set(c, [a]);
      const h = o.get(d);
      h ? h.push(a) : o.set(d, [a]);
    }
    return o;
  }
  return K("arrowBindingsIndex", (s, o) => {
    if (bo(s))
      return r();
    const a = s, c = n.getDiffSince(o);
    if (c === vi)
      return r();
    let d;
    function u(p) {
      d ?? (d = new Map(a));
      const f = d.get(p.fromId), M = f == null ? void 0 : f.filter((I) => I.id !== p.id);
      M != null && M.length ? d.set(p.fromId, M) : d.delete(p.fromId);
      const m = d.get(p.toId), y = m == null ? void 0 : m.filter((I) => I.id !== p.id);
      y != null && y.length ? d.set(p.toId, y) : d.delete(p.toId);
    }
    function h(p) {
      d ?? (d = new Map(a));
      let f = d.get(p);
      return f ? f === a.get(p) && (f = f.slice(0), d.set(p, f)) : (f = [], d.set(p, f)), f;
    }
    function g(p) {
      h(p.fromId).push(p), h(p.toId).push(p);
    }
    for (const p of c) {
      for (const f of Pt(p.added))
        g(f);
      for (const [f, M] of Pt(p.updated))
        u(f), g(M);
      for (const f of Pt(p.removed))
        u(f);
    }
    return d ?? a;
  });
};
function T8(t, e, n) {
  const i = t.getShapeMaskedPageBounds(e);
  return i === void 0 ? !0 : !n.includes(i);
}
const b8 = (t) => {
  function e(n) {
    const i = n.getCurrentPageShapeIds(), r = n.getViewportPageBounds(), s = /* @__PURE__ */ new Set();
    return i.forEach((o) => {
      T8(n, o, r) && s.add(o);
    }), s;
  }
  return K("getCulledShapes", (n) => {
    if (bo(n))
      return e(t);
    const i = e(t);
    if (n.size !== i.size) return i;
    for (const r of n)
      if (!i.has(r))
        return i;
    return n;
  });
}, v8 = (t) => {
  const e = t.query.ids("shape"), n = t.query.filterHistory("shape");
  function i() {
    const r = {}, s = e.get(), o = Array(s.size);
    return s.forEach((a) => o.push(t.get(a))), o.sort(Jt), o.forEach((a) => {
      r[a.parentId] || (r[a.parentId] = []), r[a.parentId].push(a.id);
    }), r;
  }
  return K(
    "parentsToChildrenWithIndexes",
    (r, s) => {
      if (bo(r))
        return i();
      const o = n.getDiffSince(s);
      if (o === vi)
        return i();
      if (o.length === 0) return r;
      let a = null;
      const c = (h) => {
        a || (a = { ...r }), a[h] ? a[h] === r[h] && (a[h] = [...a[h]]) : a[h] = [];
      }, d = /* @__PURE__ */ new Set();
      let u;
      for (let h = 0, g = o.length; h < g; h++) {
        u = o[h];
        for (const p of Object.values(u.added))
          Ta(p) && (c(p.parentId), a[p.parentId].push(p.id), d.add(a[p.parentId]));
        for (const [p, f] of Object.values(u.updated))
          if (Ta(f) && Ta(p)) {
            if (p.parentId !== f.parentId)
              c(p.parentId), c(f.parentId), a[p.parentId].splice(a[p.parentId].indexOf(f.id), 1), a[f.parentId].push(f.id), d.add(a[f.parentId]);
            else if (p.index !== f.index) {
              c(f.parentId);
              const M = a[f.parentId].indexOf(f.id);
              a[f.parentId][M] = f.id, d.add(a[f.parentId]);
            }
          }
        for (const p of Object.values(u.removed))
          Ta(p) && (c(p.parentId), a[p.parentId].splice(a[p.parentId].indexOf(p.id), 1));
      }
      for (const h of d) {
        const g = Ze(h.map((p) => t.get(p)));
        g.sort(Jt), h.splice(0, h.length, ...g.map((p) => p.id));
      }
      return a ?? r;
    }
  );
}, CM = (t, e, n) => {
  for (; !ni(n.parentId); ) {
    const i = t.get(n.parentId);
    if (!i) return !1;
    n = i;
  }
  return n.parentId === e;
}, E8 = (t, e) => {
  const n = t.query.ids("shape");
  let i = null;
  function r() {
    const s = e();
    return i = s, new Set(
      [...n.get()].filter((o) => CM(t, s, t.get(o)))
    );
  }
  return K("_shapeIdsInCurrentPage", (s, o) => {
    if (bo(s))
      return r();
    const a = e();
    if (a !== i)
      return r();
    const c = t.history.getDiffSince(o);
    if (c === vi)
      return r();
    const d = new Ih(
      s
    );
    for (const h of c) {
      for (const g of Object.values(h.added))
        Ta(g) && CM(t, a, g) && d.add(g.id);
      for (const [g, p] of Object.values(h.updated))
        Ta(p) && (CM(t, a, p) ? d.add(p.id) : d.remove(p.id));
      for (const g of Object.keys(h.removed))
        si(g) && d.remove(g);
    }
    const u = d.get();
    return u ? Sl(u.value, u.diff) : s;
  });
};
var C8 = Object.create, b1 = Object.defineProperty, z8 = Object.getOwnPropertyDescriptor, L8 = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), v1 = (t) => {
  throw TypeError(t);
}, E1 = (t, e, n) => e in t ? b1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, k8 = (t) => [, , , C8(null)], C1 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], z1 = (t) => t !== void 0 && typeof t != "function" ? v1("Function expected") : t, O8 = (t, e, n, i, r) => ({ kind: C1[t], name: e, metadata: i, addInitializer: (s) => n._ ? v1("Already initialized") : r.push(z1(s || null)) }), P8 = (t, e) => E1(e, L8("metadata"), t[3]), U8 = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, L1 = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = C1[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, z8(r, n)), y = i.length - 1; y >= 0; y--)
    c = O8(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, z1(o) && (m[f] = o);
  return m && b1(r, n, m), r;
}, da = (t, e, n) => E1(t, typeof e != "symbol" ? e + "" : e, n), k1, O1, xd;
const R8 = 40;
O1 = [di], k1 = [di];
class Pp {
  constructor(e) {
    this.editor = e, U8(xd, 5, this), da(this, "_clickId", ""), da(this, "_clickTimeout"), da(this, "_clickScreenPoint"), da(this, "_previousScreenPoint"), da(this, "_clickState", "idle"), da(this, "lastPointerInfo", {});
  }
  _getClickTimeout(e, n = ht()) {
    this._clickId = n, clearTimeout(this._clickTimeout), this._clickTimeout = this.editor.timers.setTimeout(
      () => {
        if (this._clickState === e && this._clickId === n) {
          switch (this._clickState) {
            case "pendingTriple": {
              this.editor.dispatch({
                ...this.lastPointerInfo,
                type: "click",
                name: "double_click",
                phase: "settle"
              });
              break;
            }
            case "pendingQuadruple": {
              this.editor.dispatch({
                ...this.lastPointerInfo,
                type: "click",
                name: "triple_click",
                phase: "settle"
              });
              break;
            }
            case "pendingOverflow": {
              this.editor.dispatch({
                ...this.lastPointerInfo,
                type: "click",
                name: "quadruple_click",
                phase: "settle"
              });
              break;
            }
          }
          this._clickState = "idle";
        }
      },
      e === "idle" || e === "pendingDouble" ? this.editor.options.doubleClickDurationMs : this.editor.options.multiClickDurationMs
    );
  }
  /**
   * The current click state.
   *
   * @public
   */
  // eslint-disable-next-line no-restricted-syntax
  get clickState() {
    return this._clickState;
  }
  handlePointerEvent(e) {
    switch (e.name) {
      case "pointer_down": {
        if (!this._clickState) return e;
        switch (this._clickScreenPoint = x.From(e.point), this._previousScreenPoint && x.Dist2(this._previousScreenPoint, this._clickScreenPoint) > R8 ** 2 && (this._clickState = "idle"), this._previousScreenPoint = this._clickScreenPoint, this.lastPointerInfo = e, this._clickState) {
          case "pendingDouble":
            return this._clickState = "pendingTriple", this._clickTimeout = this._getClickTimeout(this._clickState), {
              ...e,
              type: "click",
              name: "double_click",
              phase: "down"
            };
          case "pendingTriple":
            return this._clickState = "pendingQuadruple", this._clickTimeout = this._getClickTimeout(this._clickState), {
              ...e,
              type: "click",
              name: "triple_click",
              phase: "down"
            };
          case "pendingQuadruple":
            return this._clickState = "pendingOverflow", this._clickTimeout = this._getClickTimeout(this._clickState), {
              ...e,
              type: "click",
              name: "quadruple_click",
              phase: "down"
            };
          case "idle": {
            this._clickState = "pendingDouble";
            break;
          }
          case "pendingOverflow": {
            this._clickState = "overflow";
            break;
          }
        }
        return this._clickTimeout = this._getClickTimeout(this._clickState), e;
      }
      case "pointer_up": {
        if (!this._clickState) return e;
        switch (this._clickScreenPoint = x.From(e.point), this._clickState) {
          case "pendingTriple":
            return {
              ...this.lastPointerInfo,
              type: "click",
              name: "double_click",
              phase: "up"
            };
          case "pendingQuadruple":
            return {
              ...this.lastPointerInfo,
              type: "click",
              name: "triple_click",
              phase: "up"
            };
          case "pendingOverflow":
            return {
              ...this.lastPointerInfo,
              type: "click",
              name: "quadruple_click",
              phase: "up"
            };
        }
        return e;
      }
      case "pointer_move":
        return this._clickState !== "idle" && this._clickScreenPoint && x.Dist2(this._clickScreenPoint, this.editor.inputs.currentScreenPoint) > (this.editor.getInstanceState().isCoarsePointer ? this.editor.options.coarseDragDistanceSquared : this.editor.options.dragDistanceSquared) && this.cancelDoubleClickTimeout(), e;
    }
    return e;
  }
  cancelDoubleClickTimeout() {
    this._clickTimeout = clearTimeout(this._clickTimeout), this._clickState = "idle";
  }
}
xd = k8();
L1(xd, 1, "_getClickTimeout", O1, Pp);
L1(xd, 1, "cancelDoubleClickTimeout", k1, Pp);
P8(xd, Pp);
class Y8 {
  constructor(e) {
    S(this, "_isEdgeScrolling", !1);
    S(this, "_edgeScrollDuration", -1);
    this.editor = e;
  }
  /**
   * Update the camera position when the mouse is close to the edge of the screen.
   * Run this on every tick when in a state where edge scrolling is enabled.
   *
   * @public
   */
  updateEdgeScrolling(e) {
    const { editor: n } = this, i = this.getEdgeScroll();
    if (i.x === 0 && i.y === 0)
      this._isEdgeScrolling && (this._isEdgeScrolling = !1, this._edgeScrollDuration = 0);
    else if (this._isEdgeScrolling || (this._isEdgeScrolling = !0, this._edgeScrollDuration = 0), this._edgeScrollDuration += e, this._edgeScrollDuration > n.options.edgeScrollDelay) {
      const r = n.options.edgeScrollEaseDuration > 0 ? on.easeInCubic(
        Math.min(
          1,
          this._edgeScrollDuration / (n.options.edgeScrollDelay + n.options.edgeScrollEaseDuration)
        )
      ) : 1;
      this.moveCameraWhenCloseToEdge({
        x: i.x * r,
        y: i.y * r
      });
    }
  }
  /**
   * Helper function to get the scroll proximity factor for a given position.
   * @param position - The mouse position on the axis.
   * @param dimension - The component dimension on the axis.
   * @param isCoarse - Whether the pointer is coarse.
   * @param insetStart - Whether the pointer is inset at the start of the axis.
   * @param insetEnd - Whether the pointer is inset at the end of the axis.
   * @internal
   */
  getEdgeProximityFactors(e, n, i, r, s) {
    const { editor: o } = this, a = o.options.edgeScrollDistance, c = i ? o.options.coarsePointerWidth : 0, d = e - c, u = e + c, h = r ? 0 : a, g = s ? n : n - a;
    return d < h ? Math.min(1, (h - d) / a) : u > g ? -Math.min(1, (u - g) / a) : 0;
  }
  getEdgeScroll() {
    const { editor: e } = this, {
      inputs: {
        currentScreenPoint: { x: n, y: i }
      }
    } = e, r = e.getViewportScreenBounds(), {
      isCoarsePointer: s,
      insets: [o, a, c, d]
    } = e.getInstanceState(), u = this.getEdgeProximityFactors(n, r.w, s, d, a), h = this.getEdgeProximityFactors(i, r.h, s, o, c);
    return {
      x: u,
      y: h
    };
  }
  /**
   * Moves the camera when the mouse is close to the edge of the screen.
   * @public
   */
  moveCameraWhenCloseToEdge(e) {
    const { editor: n } = this;
    if (!n.inputs.isDragging || n.inputs.isPanning || n.getCameraOptions().isLocked || e.x === 0 && e.y === 0) return;
    const i = n.getViewportScreenBounds(), r = i.w < 1e3 ? 0.612 : 1, s = i.h < 1e3 ? 0.612 : 1, o = n.getZoomLevel(), a = n.user.getEdgeScrollSpeed() * n.options.edgeScrollSpeed, c = a * e.x * r / o, d = a * e.y * s / o, { x: u, y: h, z: g } = n.getCamera();
    n.setCamera(new x(u + c, h + d, g));
  }
}
class Q8 {
  constructor(e, n) {
    S(this, "disposeSideEffectListener");
    this.editor = e, this.disposeSideEffectListener = e.sideEffects.registerAfterChangeHandler(
      "instance",
      (r, s) => {
        r.isFocused !== s.isFocused && this.updateContainerClass();
      }
    );
    const i = e.getInstanceState().isFocused;
    n !== i && e.updateInstanceState({ isFocused: !!n }), this.updateContainerClass();
  }
  /**
   * The editor's focus state and the container's focus state
   * are not necessarily always in sync. For that reason we
   * can't rely on the css `:focus` or `:focus-within` selectors to style the
   * editor when it is in focus.
   *
   * For that reason we synchronize the editor's focus state with a
   * special class on the container: tl-container__focused
   */
  updateContainerClass() {
    const e = this.editor.getContainer();
    this.editor.getInstanceState().isFocused ? e.classList.add("tl-container__focused") : e.classList.remove("tl-container__focused");
  }
  focus() {
    this.editor.getContainer().focus();
  }
  blur() {
    this.editor.complete(), this.editor.getContainer().blur();
  }
  dispose() {
    var e;
    (e = this.disposeSideEffectListener) == null || e.call(this);
  }
}
function al(t) {
  return F8;
}
class Z8 {
  constructor() {
    S(this, "length", 0);
    S(this, "head", null);
    S(this, "tail", this);
  }
  push(e) {
    return new pS(e, this);
  }
  toArray() {
    return hs;
  }
  [Symbol.iterator]() {
    return {
      next() {
        return { value: void 0, done: !0 };
      }
    };
  }
}
const F8 = new Z8();
class pS {
  constructor(e, n) {
    S(this, "length");
    this.head = e, this.tail = n, this.length = n.length + 1;
  }
  push(e) {
    return new pS(e, this);
  }
  toArray() {
    return Array.from(this);
  }
  [Symbol.iterator]() {
    let e = this;
    return {
      next() {
        if (e.length) {
          const n = e.head;
          return e = e.tail, { value: n, done: !1 };
        } else
          return { value: void 0, done: !0 };
      }
    };
  }
}
class B8 {
  constructor(e) {
    S(this, "store");
    S(this, "dispose");
    S(this, "state", "recording");
    S(this, "pendingDiff", new W8());
    S(this, "stacks", xt(
      "HistoryManager.stacks",
      {
        undos: al(),
        redos: al()
      },
      {
        isEqual: (e, n) => e.undos === n.undos && e.redos === n.redos
      }
    ));
    S(this, "annotateError");
    /** @internal */
    S(this, "_isInBatch", !1);
    this.store = e.store, this.annotateError = e.annotateError ?? Hl, this.dispose = this.store.addHistoryInterceptor((n, i) => {
      if (i === "user")
        switch (this.state) {
          case "recording":
            this.pendingDiff.apply(n.changes), this.stacks.update(({ undos: r }) => ({ undos: r, redos: al() }));
            break;
          case "recordingPreserveRedoStack":
            this.pendingDiff.apply(n.changes);
            break;
          case "paused":
            break;
          default:
            rn(this.state);
        }
    });
  }
  flushPendingDiff() {
    if (this.pendingDiff.isEmpty()) return;
    const e = this.pendingDiff.clear();
    this.stacks.update(({ undos: n, redos: i }) => ({
      undos: n.push({ type: "diff", diff: e }),
      redos: i
    }));
  }
  getNumUndos() {
    return this.stacks.get().undos.length + (this.pendingDiff.isEmpty() ? 0 : 1);
  }
  getNumRedos() {
    return this.stacks.get().redos.length;
  }
  batch(e, n) {
    const i = this.state;
    i !== "paused" && (n != null && n.history) && (this.state = G8[n.history]);
    try {
      if (this._isInBatch)
        return Qr(e), this;
      this._isInBatch = !0;
      try {
        Qr(e);
      } catch (r) {
        throw this.annotateError(r), r;
      } finally {
        this._isInBatch = !1;
      }
      return this;
    } finally {
      this.state = i;
    }
  }
  // History
  _undo({ pushToRedoStack: e, toMark: n = void 0 }) {
    var r;
    const i = this.state;
    this.state = "paused";
    try {
      let { undos: s, redos: o } = this.stacks.get();
      const a = this.pendingDiff.clear(), c = Nb(a), d = Sg(a);
      e && !c && (o = o.push({ type: "diff", diff: a }));
      let u = !1;
      if (c)
        for (; ((r = s.head) == null ? void 0 : r.type) === "stop"; ) {
          const h = s.head;
          if (s = s.tail, e && (o = o.push(h)), h.id === n) {
            u = !0;
            break;
          }
        }
      if (!u)
        e: for (; s.head; ) {
          const h = s.head;
          switch (s = s.tail, e && (o = o.push(h)), h.type) {
            case "diff":
              zl(d, [Sg(h.diff)]);
              break;
            case "stop":
              if (!n) break e;
              if (h.id === n) {
                u = !0;
                break e;
              }
              break;
            default:
              rn(h);
          }
        }
      if (!u && n)
        return this;
      this.store.applyDiff(d, { ignoreEphemeralKeys: !0 }), this.store.ensureStoreIsUsable(), this.stacks.set({ undos: s, redos: o });
    } finally {
      this.state = i;
    }
    return this;
  }
  undo() {
    return this._undo({ pushToRedoStack: !0 }), this;
  }
  redo() {
    var n;
    const e = this.state;
    this.state = "paused";
    try {
      this.flushPendingDiff();
      let { undos: i, redos: r } = this.stacks.get();
      if (r.length === 0)
        return this;
      for (; ((n = r.head) == null ? void 0 : n.type) === "stop"; )
        i = i.push(r.head), r = r.tail;
      const s = xg();
      for (; r.head; ) {
        const o = r.head;
        if (i = i.push(o), r = r.tail, o.type === "diff")
          zl(s, [o.diff]);
        else
          break;
      }
      this.store.applyDiff(s, { ignoreEphemeralKeys: !0 }), this.store.ensureStoreIsUsable(), this.stacks.set({ undos: i, redos: r });
    } finally {
      this.state = e;
    }
    return this;
  }
  bail() {
    return this._undo({ pushToRedoStack: !1 }), this;
  }
  bailToMark(e) {
    return this._undo({ pushToRedoStack: !1, toMark: e }), this;
  }
  squashToMark(e) {
    var s;
    let n = this.stacks.get().undos;
    const i = [];
    for (; n.head && !(n.head.type === "stop" && n.head.id === e); )
      n.head.type === "diff" && i.push(n.head.diff), n = n.tail;
    if (!n.head || ((s = n.head) == null ? void 0 : s.id) !== e)
      return console.error("Could not find mark to squash to: ", e), this;
    if (i.length === 0)
      return this;
    const r = xg();
    return zl(r, i.reverse()), this.stacks.update(({ redos: o }) => ({
      undos: n.push({
        type: "diff",
        diff: r
      }),
      redos: o
    })), this;
  }
  /** @internal */
  _mark(e) {
    Qr(() => {
      this.flushPendingDiff(), this.stacks.update(({ undos: n, redos: i }) => ({ undos: n.push({ type: "stop", id: e }), redos: i }));
    });
  }
  clear() {
    this.stacks.set({ undos: al(), redos: al() }), this.pendingDiff.clear();
  }
  /** @internal */
  getMarkIdMatching(e) {
    let n = this.stacks.get().undos;
    for (; n.head; ) {
      if (n.head.type === "stop" && n.head.id.includes(e))
        return n.head.id;
      n = n.tail;
    }
    return null;
  }
  /** @internal */
  debug() {
    const { undos: e, redos: n } = this.stacks.get();
    return {
      undos: e.toArray(),
      redos: n.toArray(),
      pendingDiff: this.pendingDiff.debug(),
      state: this.state
    };
  }
}
const G8 = {
  record: "recording",
  "record-preserveRedoStack": "recordingPreserveRedoStack",
  ignore: "paused"
  /* Paused */
};
class W8 {
  constructor() {
    S(this, "diff", xg());
    S(this, "isEmptyAtom", xt("PendingDiff.isEmpty", !0));
  }
  clear() {
    const e = this.diff;
    return this.diff = xg(), this.isEmptyAtom.set(!0), e;
  }
  isEmpty() {
    return this.isEmptyAtom.get();
  }
  apply(e) {
    zl(this.diff, [e]), this.isEmptyAtom.set(Nb(this.diff));
  }
  debug() {
    return { diff: this.diff, isEmpty: this.isEmpty() };
  }
}
class H8 {
  constructor(e) {
    S(this, "scribbleItems", /* @__PURE__ */ new Map());
    S(this, "state", "paused");
    this.editor = e;
  }
  addScribble(e, n = ht()) {
    const i = {
      id: n,
      scribble: {
        id: n,
        size: 20,
        color: "accent",
        opacity: 0.8,
        delay: 0,
        points: [],
        shrink: 0.1,
        taper: !0,
        ...e,
        state: "starting"
      },
      timeoutMs: 0,
      delayRemaining: e.delay ?? 0,
      prev: null,
      next: null
    };
    return this.scribbleItems.set(n, i), i;
  }
  reset() {
    this.editor.updateInstanceState({ scribbles: [] }), this.scribbleItems.clear();
  }
  /**
   * Start stopping the scribble. The scribble won't be removed until its last point is cleared.
   *
   * @public
   */
  stop(e) {
    const n = this.scribbleItems.get(e);
    if (!n) throw Error(`Scribble with id ${e} not found`);
    return n.delayRemaining = Math.min(n.delayRemaining, 200), n.scribble.state = "stopping", n;
  }
  /**
   * Set the scribble's next point.
   *
   * @param id - The id of the scribble to add a point to.
   * @param x - The x coordinate of the point.
   * @param y - The y coordinate of the point.
   * @param z - The z coordinate of the point.
   * @public
   */
  addPoint(e, n, i, r = 0.5) {
    const s = this.scribbleItems.get(e);
    if (!s) throw Error(`Scribble with id ${e} not found`);
    const { prev: o } = s, a = { x: n, y: i, z: r };
    return (!o || x.Dist(o, a) >= 1) && (s.next = a), s;
  }
  /**
   * Update on each animation frame.
   *
   * @param elapsed - The number of milliseconds since the last tick.
   * @public
   */
  tick(e) {
    this.scribbleItems.size !== 0 && this.editor.run(() => {
      this.scribbleItems.forEach((n) => {
        if (n.scribble.state === "starting") {
          const { next: c, prev: d } = n;
          c && c !== d && (n.prev = c, n.scribble.points.push(c)), n.scribble.points.length > 8 && (n.scribble.state = "active");
          return;
        }
        n.delayRemaining > 0 && (n.delayRemaining = Math.max(0, n.delayRemaining - e)), n.timeoutMs += e, n.timeoutMs >= 16 && (n.timeoutMs = 0);
        const { delayRemaining: i, timeoutMs: r, prev: s, next: o, scribble: a } = n;
        switch (a.state) {
          case "active": {
            o && o !== s ? (n.prev = o, a.points.push(o), i === 0 && a.points.length > 8 && a.points.shift()) : r === 0 && (a.points.length > 1 ? a.points.shift() : n.delayRemaining = a.delay);
            break;
          }
          case "stopping": {
            if (n.delayRemaining === 0 && r === 0) {
              if (a.points.length === 1) {
                this.scribbleItems.delete(n.id);
                return;
              }
              a.shrink && (a.size = Math.max(1, a.size * (1 - a.shrink))), a.points.shift();
            }
            break;
          }
        }
      }), this.editor.updateInstanceState({
        scribbles: Array.from(this.scribbleItems.values()).map(({ scribble: n }) => ({
          ...n,
          points: [...n.points]
        })).slice(-5)
        // limit to three as a minor sanity check
      });
    });
  }
}
var V8 = Object.create, P1 = Object.defineProperty, K8 = Object.getOwnPropertyDescriptor, X8 = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), U1 = (t) => {
  throw TypeError(t);
}, R1 = (t, e, n) => e in t ? P1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, J8 = (t) => [, , , V8(null)], Y1 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], Q1 = (t) => t !== void 0 && typeof t != "function" ? U1("Function expected") : t, q8 = (t, e, n, i, r) => ({ kind: Y1[t], name: e, metadata: i, addInitializer: (s) => n._ ? U1("Already initialized") : r.push(Q1(s || null)) }), _8 = (t, e) => R1(e, X8("metadata"), t[3]), $8 = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, Up = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = Y1[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, K8(r, n)), y = i.length - 1; y >= 0; y--)
    c = q8(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, Q1(o) && (m[f] = o);
  return m && P1(r, n, m), r;
}, e7 = (t, e, n) => R1(t, e + "", n), Z1, F1, B1, G1, Xo;
const be = (t) => Math.round(t * 10 ** 8) / 10 ** 8;
function ss(t, e, n, i, r) {
  const s = t.filter(
    (a) => (i === "forward" ? a.startNode.id === e : a.endNode.id === e) && be(a.length) === be(n) && nr(
      a.breadthIntersection[0],
      a.breadthIntersection[1],
      r[0],
      r[1]
    )
  );
  if (s.length === 0) return [];
  const o = /* @__PURE__ */ new Set();
  return s.forEach((a) => {
    const c = i === "forward" ? a.endNode.id : a.startNode.id;
    if (!o.has(c)) {
      o.add(c);
      const d = ss(
        t,
        c,
        n,
        i,
        nr(
          a.breadthIntersection[0],
          a.breadthIntersection[1],
          r[0],
          r[1]
        )
      );
      s.push(...d);
    }
  }), s;
}
function t7(t) {
  t.sort((e, n) => n.gaps.length - e.gaps.length);
  for (let e = t.length - 1; e > 0; e--) {
    const n = t[e];
    for (let i = e - 1; i >= 0; i--) {
      const r = t[i];
      if (r.direction === n.direction && n.gaps.every(
        (s) => r.gaps.some(
          (o) => be(s.startEdge[0].x) === be(o.startEdge[0].x) && be(s.startEdge[0].y) === be(o.startEdge[0].y) && be(s.startEdge[1].x) === be(o.startEdge[1].x) && be(s.startEdge[1].y) === be(o.startEdge[1].y)
        ) && r.gaps.some(
          (o) => be(s.endEdge[0].x) === be(o.endEdge[0].x) && be(s.endEdge[0].y) === be(o.endEdge[0].y) && be(s.endEdge[1].x) === be(o.endEdge[1].x) && be(s.endEdge[1].y) === be(o.endEdge[1].y)
        )
      )) {
        t.splice(e, 1);
        break;
      }
    }
  }
}
G1 = [K], B1 = [K], F1 = [K], Z1 = [K];
class Nc {
  constructor(e) {
    this.manager = e, $8(Xo, 5, this), e7(this, "editor"), this.editor = e.editor;
  }
  getSnapPointsCache() {
    const { editor: e } = this;
    return e.store.createComputedCache("snapPoints", (n) => {
      const i = e.getShapePageTransform(n.id);
      if (!i) return;
      const s = e.getShapeUtil(n).getBoundsSnapGeometry(n).points ?? e.getShapeGeometry(n).bounds.cornersAndCenter;
      if (!(!i || !s))
        return s.map((o, a) => {
          const { x: c, y: d } = ne.applyToPoint(i, o);
          return { x: c, y: d, id: `${n.id}:${a}` };
        });
    });
  }
  getSnapPoints(e) {
    return this.getSnapPointsCache().get(e) ?? [];
  }
  getSnappablePoints() {
    const e = this.getSnapPointsCache(), n = this.manager.getSnappableShapes(), i = [];
    for (const r of n) {
      const s = e.get(r);
      s && i.push(...s);
    }
    return i;
  }
  getSnappableGapNodes() {
    return Array.from(this.manager.getSnappableShapes(), (e) => ({
      id: e,
      pageBounds: oi(this.editor.getShapePageBounds(e))
    }));
  }
  getVisibleGaps() {
    const e = [], n = [];
    let i, r;
    const s = this.getSnappableGapNodes().sort((a, c) => a.pageBounds.minX - c.pageBounds.minX);
    for (let a = 0; a < s.length; a++) {
      i = s[a];
      for (let c = a + 1; c < s.length; c++)
        r = s[c], // is there space between the boxes
        i.pageBounds.maxX < r.pageBounds.minX && // and they overlap in the y axis
        ol(
          i.pageBounds.minY,
          i.pageBounds.maxY,
          r.pageBounds.minY,
          r.pageBounds.maxY
        ) && e.push({
          startNode: i,
          endNode: r,
          startEdge: [
            new x(i.pageBounds.maxX, i.pageBounds.minY),
            new x(i.pageBounds.maxX, i.pageBounds.maxY)
          ],
          endEdge: [
            new x(r.pageBounds.minX, r.pageBounds.minY),
            new x(r.pageBounds.minX, r.pageBounds.maxY)
          ],
          length: r.pageBounds.minX - i.pageBounds.maxX,
          breadthIntersection: nr(
            i.pageBounds.minY,
            i.pageBounds.maxY,
            r.pageBounds.minY,
            r.pageBounds.maxY
          )
        });
    }
    const o = s.sort((a, c) => a.pageBounds.minY - c.pageBounds.minY);
    for (let a = 0; a < o.length; a++) {
      i = o[a];
      for (let c = a + 1; c < o.length; c++)
        r = o[c], // is there space between the boxes
        i.pageBounds.maxY < r.pageBounds.minY && // do they overlap in the x axis
        ol(
          i.pageBounds.minX,
          i.pageBounds.maxX,
          r.pageBounds.minX,
          r.pageBounds.maxX
        ) && n.push({
          startNode: i,
          endNode: r,
          startEdge: [
            new x(i.pageBounds.minX, i.pageBounds.maxY),
            new x(i.pageBounds.maxX, i.pageBounds.maxY)
          ],
          endEdge: [
            new x(r.pageBounds.minX, r.pageBounds.minY),
            new x(r.pageBounds.maxX, r.pageBounds.minY)
          ],
          length: r.pageBounds.minY - i.pageBounds.maxY,
          breadthIntersection: nr(
            i.pageBounds.minX,
            i.pageBounds.maxX,
            r.pageBounds.minX,
            r.pageBounds.maxX
          )
        });
    }
    return { horizontal: e, vertical: n };
  }
  snapTranslateShapes({
    lockedAxis: e,
    initialSelectionPageBounds: n,
    initialSelectionSnapPoints: i,
    dragDelta: r
  }) {
    var m, y;
    const s = this.manager.getSnapThreshold(), o = this.getSnappablePoints(), a = n.clone().translate(r), c = i.map(
      ({ x: I, y: D }, j) => ({
        id: "selection:" + j,
        x: I + r.x,
        y: D + r.y
      })
    ), d = o, u = [], h = [], g = new x(s, s);
    this.collectPointSnaps({
      minOffset: g,
      nearestSnapsX: u,
      nearestSnapsY: h,
      otherNodeSnapPoints: d,
      selectionSnapPoints: c
    }), this.collectGapSnaps({
      selectionPageBounds: a,
      nearestSnapsX: u,
      nearestSnapsY: h,
      minOffset: g
    });
    const p = new x(
      e === "x" ? 0 : ((m = u[0]) == null ? void 0 : m.nudge) ?? 0,
      e === "y" ? 0 : ((y = h[0]) == null ? void 0 : y.nudge) ?? 0
    );
    g.x = 0, g.y = 0, u.length = 0, h.length = 0, c.forEach((I) => {
      I.x += p.x, I.y += p.y;
    }), a.translate(p), this.collectPointSnaps({
      minOffset: g,
      nearestSnapsX: u,
      nearestSnapsY: h,
      otherNodeSnapPoints: d,
      selectionSnapPoints: c
    }), this.collectGapSnaps({
      selectionPageBounds: a,
      nearestSnapsX: u,
      nearestSnapsY: h,
      minOffset: g
    });
    const f = this.getPointSnapLines({
      nearestSnapsX: u,
      nearestSnapsY: h
    }), M = this.getGapSnapLines({
      selectionPageBounds: a,
      nearestSnapsX: u,
      nearestSnapsY: h
    });
    return this.manager.setIndicators([...M, ...f]), { nudge: p };
  }
  snapResizeShapes({
    initialSelectionPageBounds: e,
    dragDelta: n,
    handle: i,
    isAspectRatioLocked: r,
    isResizingFromCenter: s
  }) {
    var b, T;
    const o = this.manager.getSnapThreshold(), {
      box: a,
      scaleX: c,
      scaleY: d
    } = ae.Resize(
      e,
      i,
      s ? n.x * 2 : n.x,
      s ? n.y * 2 : n.y,
      r
    );
    let u = i;
    c < 0 && (u = d6(u)), d < 0 && (u = l6(u)), s && (a.center = e.center);
    const h = u === "top" || u === "bottom", g = u === "left" || u === "right", p = dw(u, a), f = this.getSnappablePoints(), M = [], m = [], y = new x(o, o);
    this.collectPointSnaps({
      minOffset: y,
      nearestSnapsX: M,
      nearestSnapsY: m,
      otherNodeSnapPoints: f,
      selectionSnapPoints: p
    });
    const I = new x(
      h ? 0 : ((b = M[0]) == null ? void 0 : b.nudge) ?? 0,
      g ? 0 : ((T = m[0]) == null ? void 0 : T.nudge) ?? 0
    );
    if (r && u6(u) && I.len() !== 0) {
      const E = M.length && m.length ? Math.abs(I.x) < Math.abs(I.y) ? "x" : "y" : M.length ? "x" : "y", v = e.aspectRatio;
      E === "x" ? (m.length = 0, I.y = I.x / v, (u === "bottom_left" || u === "top_right") && (I.y = -I.y)) : (M.length = 0, I.x = I.y * v, (u === "bottom_left" || u === "top_right") && (I.x = -I.x));
    }
    const D = x.Add(n, I), { box: j } = ae.Resize(
      e,
      i,
      s ? D.x * 2 : D.x,
      s ? D.y * 2 : D.y,
      r
    );
    s && (j.center = e.center);
    const w = dw("any", j);
    M.length = 0, m.length = 0, y.x = 0, y.y = 0, this.collectPointSnaps({
      minOffset: y,
      nearestSnapsX: M,
      nearestSnapsY: m,
      otherNodeSnapPoints: f,
      selectionSnapPoints: w
    });
    const A = this.getPointSnapLines({
      nearestSnapsX: M,
      nearestSnapsY: m
    });
    return this.manager.setIndicators([...A]), { nudge: I };
  }
  collectPointSnaps({
    selectionSnapPoints: e,
    otherNodeSnapPoints: n,
    minOffset: i,
    nearestSnapsX: r,
    nearestSnapsY: s
  }) {
    for (const o of e)
      for (const a of n) {
        const c = x.Sub(o, a), d = Math.abs(c.x), u = Math.abs(c.y);
        be(d) <= be(i.x) && (be(d) < be(i.x) && (r.length = 0), r.push({
          type: "points",
          points: { thisPoint: o, otherPoint: a },
          nudge: a.x - o.x
        }), i.x = d), be(u) <= be(i.y) && (be(u) < be(i.y) && (s.length = 0), s.push({
          type: "points",
          points: { thisPoint: o, otherPoint: a },
          nudge: a.y - o.y
        }), i.y = u);
      }
  }
  collectGapSnaps({
    selectionPageBounds: e,
    minOffset: n,
    nearestSnapsX: i,
    nearestSnapsY: r
  }) {
    const { horizontal: s, vertical: o } = this.getVisibleGaps();
    for (const a of s) {
      if (!ol(
        a.breadthIntersection[0],
        a.breadthIntersection[1],
        e.minY,
        e.maxY
      ))
        continue;
      const d = a.startEdge[0].x + a.length / 2 - e.center.x;
      if (a.length > e.width && be(Math.abs(d)) <= be(n.x)) {
        be(Math.abs(d)) < be(n.x) && (i.length = 0), n.x = Math.abs(d);
        const y = {
          type: "gap_center",
          gap: a,
          nudge: d
        }, I = i.find(({ type: j }) => j === "gap_center"), D = I && nr(
          a.breadthIntersection[0],
          a.breadthIntersection[1],
          I.gap.breadthIntersection[0],
          I.gap.breadthIntersection[1]
        );
        I && I.gap.length > a.length && D ? i[i.indexOf(I)] = y : (!I || !D) && i.push(y);
      }
      const h = a.startNode.pageBounds.minX - a.length, g = e.maxX, p = h - g;
      be(Math.abs(p)) <= be(n.x) && (be(Math.abs(p)) < be(n.x) && (i.length = 0), n.x = Math.abs(p), i.push({
        type: "gap_duplicate",
        gap: a,
        protrusionDirection: "left",
        nudge: p
      }));
      const f = a.endNode.pageBounds.maxX + a.length, M = e.minX, m = f - M;
      be(Math.abs(m)) <= be(n.x) && (be(Math.abs(m)) < be(n.x) && (i.length = 0), n.x = Math.abs(m), i.push({
        type: "gap_duplicate",
        gap: a,
        protrusionDirection: "right",
        nudge: m
      }));
    }
    for (const a of o) {
      if (!ol(
        a.breadthIntersection[0],
        a.breadthIntersection[1],
        e.minX,
        e.maxX
      ))
        continue;
      const d = a.startEdge[0].y + a.length / 2 - e.center.y;
      if (a.length > e.height && be(Math.abs(d)) <= be(n.y)) {
        be(Math.abs(d)) < be(n.y) && (r.length = 0), n.y = Math.abs(d);
        const y = {
          type: "gap_center",
          gap: a,
          nudge: d
        }, I = r.find(({ type: j }) => j === "gap_center"), D = I && ol(
          I.gap.breadthIntersection[0],
          I.gap.breadthIntersection[1],
          a.breadthIntersection[0],
          a.breadthIntersection[1]
        );
        I && I.gap.length > a.length && D ? r[r.indexOf(I)] = y : (!I || !D) && r.push(y);
        continue;
      }
      const h = a.startNode.pageBounds.minY - a.length, g = e.maxY, p = h - g;
      be(Math.abs(p)) <= be(n.y) && (be(Math.abs(p)) < be(n.y) && (r.length = 0), n.y = Math.abs(p), r.push({
        type: "gap_duplicate",
        gap: a,
        protrusionDirection: "top",
        nudge: p
      }));
      const f = a.endNode.pageBounds.maxY + a.length, M = e.minY, m = f - M;
      be(Math.abs(m)) <= be(n.y) && (be(Math.abs(m)) < be(n.y) && (r.length = 0), n.y = Math.abs(m), r.push({
        type: "gap_duplicate",
        gap: a,
        protrusionDirection: "bottom",
        nudge: m
      }));
    }
  }
  getPointSnapLines({
    nearestSnapsX: e,
    nearestSnapsY: n
  }) {
    const i = {}, r = {};
    if (e.length > 0) {
      for (const s of e)
        if (s.type === "points") {
          const o = be(s.points.otherPoint.x);
          i[o] || (i[o] = []), i[o].push(s.points);
        }
    }
    if (n.length > 0) {
      for (const s of n)
        if (s.type === "points") {
          const o = be(s.points.otherPoint.y);
          r[o] || (r[o] = []), r[o].push(s.points);
        }
    }
    return Object.values(i).concat(Object.values(r)).map((s) => ({
      id: ht(),
      type: "points",
      points: ax(
        s.map((o) => x.From(o.otherPoint)).concat(s.map((o) => x.From(o.thisPoint))),
        (o, a) => o.equals(a)
      )
    }));
  }
  getGapSnapLines({
    selectionPageBounds: e,
    nearestSnapsX: n,
    nearestSnapsY: i
  }) {
    const { vertical: r, horizontal: s } = this.getVisibleGaps(), o = {
      top: e.sides[0],
      right: e.sides[1],
      // need bottom and left to be sorted asc, which .sides is not.
      bottom: [e.corners[3], e.corners[2]],
      left: [e.corners[0], e.corners[3]]
    }, a = [];
    if (n.length > 0)
      for (const c of n) {
        if (c.type === "points") continue;
        const {
          gap: { breadthIntersection: d, startEdge: u, startNode: h, endNode: g, length: p, endEdge: f }
        } = c;
        switch (c.type) {
          case "gap_center": {
            const M = (p - e.width) / 2, m = nr(
              d[0],
              d[1],
              e.minY,
              e.maxY
            );
            a.push({
              type: "gaps",
              direction: "horizontal",
              id: ht(),
              gaps: [
                ...ss(
                  s,
                  h.id,
                  M,
                  "backward",
                  m
                ),
                {
                  startEdge: u,
                  endEdge: o.left
                },
                {
                  startEdge: o.right,
                  endEdge: f
                },
                ...ss(
                  s,
                  g.id,
                  M,
                  "forward",
                  m
                )
              ]
            });
            break;
          }
          case "gap_duplicate": {
            const M = nr(
              d[0],
              d[1],
              e.minY,
              e.maxY
            );
            a.push({
              type: "gaps",
              direction: "horizontal",
              id: ht(),
              gaps: c.protrusionDirection === "left" ? [
                {
                  startEdge: o.right,
                  endEdge: u.map(
                    (m) => m.clone().addXY(-h.pageBounds.width, 0)
                  )
                },
                { startEdge: u, endEdge: f },
                ...ss(
                  s,
                  g.id,
                  p,
                  "forward",
                  M
                )
              ] : [
                ...ss(
                  s,
                  h.id,
                  p,
                  "backward",
                  M
                ),
                { startEdge: u, endEdge: f },
                {
                  startEdge: f.map(
                    (m) => m.clone().addXY(c.gap.endNode.pageBounds.width, 0)
                  ),
                  endEdge: o.left
                }
              ]
            });
            break;
          }
        }
      }
    if (i.length > 0)
      for (const c of i) {
        if (c.type === "points") continue;
        const {
          gap: { breadthIntersection: d, startEdge: u, startNode: h, endNode: g, length: p, endEdge: f }
        } = c;
        switch (c.type) {
          case "gap_center": {
            const M = (p - e.height) / 2, m = nr(
              d[0],
              d[1],
              e.minX,
              e.maxX
            );
            a.push({
              type: "gaps",
              direction: "vertical",
              id: ht(),
              gaps: [
                ...ss(
                  r,
                  h.id,
                  M,
                  "backward",
                  m
                ),
                {
                  startEdge: u,
                  endEdge: o.top
                },
                {
                  startEdge: o.bottom,
                  endEdge: f
                },
                ...ss(
                  r,
                  c.gap.endNode.id,
                  M,
                  "forward",
                  m
                )
              ]
            });
            break;
          }
          case "gap_duplicate":
            {
              const M = nr(
                d[0],
                d[1],
                e.minX,
                e.maxX
              );
              a.push({
                type: "gaps",
                direction: "vertical",
                id: ht(),
                gaps: c.protrusionDirection === "top" ? [
                  {
                    startEdge: o.bottom,
                    endEdge: u.map(
                      (m) => m.clone().addXY(0, -h.pageBounds.height)
                    )
                  },
                  { startEdge: u, endEdge: f },
                  ...ss(
                    r,
                    g.id,
                    p,
                    "forward",
                    M
                  )
                ] : [
                  ...ss(
                    r,
                    h.id,
                    p,
                    "backward",
                    M
                  ),
                  { startEdge: u, endEdge: f },
                  {
                    startEdge: f.map(
                      (m) => m.clone().addXY(0, g.pageBounds.height)
                    ),
                    endEdge: o.top
                  }
                ]
              });
            }
            break;
        }
      }
    return t7(a), a;
  }
}
Xo = J8();
Up(Xo, 1, "getSnapPointsCache", G1, Nc);
Up(Xo, 1, "getSnappablePoints", B1, Nc);
Up(Xo, 1, "getSnappableGapNodes", F1, Nc);
Up(Xo, 1, "getVisibleGaps", Z1, Nc);
_8(Xo, Nc);
function dw(t, e) {
  const { minX: n, maxX: i, minY: r, maxY: s } = e, o = [];
  switch (t) {
    case "top":
    case "left":
    case "top_left":
    case "any":
      o.push({
        id: "top_left",
        handle: "top_left",
        x: n,
        y: r
      });
  }
  switch (t) {
    case "top":
    case "right":
    case "top_right":
    case "any":
      o.push({
        id: "top_right",
        handle: "top_right",
        x: i,
        y: r
      });
  }
  switch (t) {
    case "bottom":
    case "right":
    case "bottom_right":
    case "any":
      o.push({
        id: "bottom_right",
        handle: "bottom_right",
        x: i,
        y: s
      });
  }
  switch (t) {
    case "bottom":
    case "left":
    case "bottom_left":
    case "any":
      o.push({
        id: "bottom_left",
        handle: "bottom_left",
        x: n,
        y: s
      });
  }
  return o;
}
var n7 = Object.create, W1 = Object.defineProperty, i7 = Object.getOwnPropertyDescriptor, r7 = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), H1 = (t) => {
  throw TypeError(t);
}, V1 = (t, e, n) => e in t ? W1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, s7 = (t) => [, , , n7(null)], K1 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], X1 = (t) => t !== void 0 && typeof t != "function" ? H1("Function expected") : t, o7 = (t, e, n, i, r) => ({ kind: K1[t], name: e, metadata: i, addInitializer: (s) => n._ ? H1("Already initialized") : r.push(X1(s || null)) }), a7 = (t, e) => V1(e, r7("metadata"), t[3]), c7 = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, l7 = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = K1[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, i7(r, n)), y = i.length - 1; y >= 0; y--)
    c = o7(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, X1(o) && (m[f] = o);
  return m && W1(r, n, m), r;
}, d7 = (t, e, n) => V1(t, e + "", n), J1, Rp;
const u7 = () => null, h7 = () => [];
J1 = [K];
class fS {
  constructor(e) {
    this.manager = e, c7(Rp, 5, this), d7(this, "editor"), this.editor = e.editor;
  }
  getSnapGeometryCache() {
    const { editor: e } = this;
    return e.store.createComputedCache("handle snap geometry", (n) => {
      const i = e.getShapeUtil(n).getHandleSnapGeometry(n), r = i.getSelfSnapOutline ? i.getSelfSnapOutline.bind(i) : u7, s = i.getSelfSnapPoints ? i.getSelfSnapPoints.bind(i) : h7;
      return {
        outline: i.outline === void 0 ? e.getShapeGeometry(n) : i.outline,
        points: i.points ?? [],
        getSelfSnapOutline: r,
        getSelfSnapPoints: s
      };
    });
  }
  *iterateSnapPointsInPageSpace(e, n) {
    var r, s;
    const i = (r = this.getSnapGeometryCache().get(e)) == null ? void 0 : r.getSelfSnapPoints(n);
    if (i && i.length) {
      const o = oi(this.editor.getShapePageTransform(e));
      for (const a of i)
        yield o.applyToPoint(a);
    }
    for (const o of this.manager.getSnappableShapes()) {
      if (o === e) continue;
      const a = (s = this.getSnapGeometryCache().get(o)) == null ? void 0 : s.points;
      if (!a || !a.length) continue;
      const c = oi(this.editor.getShapePageTransform(o));
      for (const d of a)
        yield c.applyToPoint(d);
    }
  }
  *iterateSnapOutlines(e, n) {
    var r, s;
    const i = (r = this.getSnapGeometryCache().get(e)) == null ? void 0 : r.getSelfSnapOutline(n);
    i && (yield { shapeId: e, outline: i });
    for (const o of this.manager.getSnappableShapes()) {
      if (o === e) continue;
      const a = (s = this.getSnapGeometryCache().get(o)) == null ? void 0 : s.outline;
      a && (yield { shapeId: o, outline: a });
    }
  }
  getHandleSnapPosition({
    currentShapeId: e,
    handle: n,
    handleInPageSpace: i
  }) {
    const r = this.manager.getSnapThreshold();
    let s = r, o = null;
    for (const d of this.iterateSnapPointsInPageSpace(e, n))
      x.DistMin(i, d, s) && (s = x.Dist(i, d), o = d);
    if (o) return o;
    let a = r, c = null;
    for (const { shapeId: d, outline: u } of this.iterateSnapOutlines(e, n)) {
      const h = oi(this.editor.getShapePageTransform(d)), g = this.editor.getPointInShapeSpace(d, i), p = u.nearestPoint(g), f = h.applyToPoint(p);
      x.DistMin(i, f, a) && (a = x.Dist(i, f), c = f);
    }
    return c || null;
  }
  snapHandle({
    currentShapeId: e,
    handle: n
  }) {
    const r = oi(this.editor.getShapePageTransform(e)).applyToPoint(n), s = this.getHandleSnapPosition({ currentShapeId: e, handle: n, handleInPageSpace: r });
    return s ? (this.manager.setIndicators([
      {
        id: ht(),
        type: "points",
        points: [s]
      }
    ]), { nudge: x.Sub(s, r) }) : null;
  }
}
Rp = s7();
l7(Rp, 1, "getSnapGeometryCache", J1, fS);
a7(Rp, fS);
var g7 = Object.create, q1 = Object.defineProperty, p7 = Object.getOwnPropertyDescriptor, f7 = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), _1 = (t) => {
  throw TypeError(t);
}, $1 = (t, e, n) => e in t ? q1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, M7 = (t) => [, , , g7(null)], eE = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], tE = (t) => t !== void 0 && typeof t != "function" ? _1("Function expected") : t, m7 = (t, e, n, i, r) => ({ kind: eE[t], name: e, metadata: i, addInitializer: (s) => n._ ? _1("Already initialized") : r.push(tE(s || null)) }), y7 = (t, e) => $1(e, f7("metadata"), t[3]), I7 = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, MS = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = eE[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, p7(r, n)), y = i.length - 1; y >= 0; y--)
    c = m7(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, tE(o) && (m[f] = o);
  return m && q1(r, n, m), r;
}, zM = (t, e, n) => $1(t, typeof e != "symbol" ? e + "" : e, n), nE, iE, rE, Ac;
rE = [K], iE = [K], nE = [K];
class Sd {
  constructor(e) {
    this.editor = e, I7(Ac, 5, this), zM(this, "shapeBounds"), zM(this, "handles"), zM(this, "_snapIndicators", xt("snapLines", void 0)), this.shapeBounds = new Nc(this), this.handles = new fS(this);
  }
  getIndicators() {
    return this._snapIndicators.get() ?? hs;
  }
  clearIndicators() {
    this.getIndicators().length && this._snapIndicators.set(void 0);
  }
  setIndicators(e) {
    this._snapIndicators.set(e);
  }
  getSnapThreshold() {
    return 8 / this.editor.getZoomLevel();
  }
  getSnappableShapes() {
    const { editor: e } = this, n = e.getViewportPageBounds(), i = e.getSelectedShapeIds(), r = /* @__PURE__ */ new Set(), s = (o) => {
      if (si(o)) {
        const c = e.getShape(o);
        c && e.isShapeOfType(c, "frame") && r.add(o);
      }
      const a = e.getSortedChildIdsForParent(o);
      for (const c of a) {
        if (i.includes(c)) continue;
        const d = e.getShape(c);
        if (!d || !e.getShapeUtil(d).canSnap(d)) continue;
        const h = e.getShapePageBounds(c);
        if (h && n.includes(h)) {
          if (e.isShapeOfType(d, "group")) {
            s(c);
            continue;
          }
          r.add(c);
        }
      }
    };
    return s(this.getCurrentCommonAncestor() ?? e.getCurrentPageId()), r;
  }
  getCurrentCommonAncestor() {
    return this.editor.findCommonAncestor(this.editor.getSelectedShapes());
  }
}
Ac = M7();
MS(Ac, 1, "getSnapThreshold", rE, Sd);
MS(Ac, 1, "getSnappableShapes", iE, Sd);
MS(Ac, 1, "getCurrentCommonAncestor", nE, Sd);
y7(Ac, Sd);
const x7 = /\r?\n|\r/g;
function uw(t) {
  return t.replace(x7, `
`).split(`
`).map((e) => e || " ").join(`
`);
}
const S7 = {
  start: "left",
  "start-legacy": "left",
  middle: "center",
  "middle-legacy": "center",
  end: "right",
  "end-legacy": "right"
}, j7 = /\s/;
class D7 {
  constructor(e) {
    S(this, "baseElm");
    this.editor = e;
    const n = this.editor.getContainer(), i = document.createElement("div");
    i.classList.add("tl-text"), i.classList.add("tl-text-measure"), i.tabIndex = -1, n.appendChild(i), this.baseElm = i, e.disposables.add(() => {
      i.remove();
    });
  }
  measureText(e, n) {
    var o;
    const i = (o = this.baseElm) == null ? void 0 : o.cloneNode();
    this.baseElm.insertAdjacentElement("afterend", i), i.setAttribute("dir", "auto"), i.style.setProperty("unicode-bidi", "plaintext"), i.style.setProperty("font-family", n.fontFamily), i.style.setProperty("font-style", n.fontStyle), i.style.setProperty("font-weight", n.fontWeight), i.style.setProperty("font-size", n.fontSize + "px"), i.style.setProperty("line-height", n.lineHeight * n.fontSize + "px"), i.style.setProperty("max-width", n.maxWidth === null ? null : n.maxWidth + "px"), i.style.setProperty("min-width", n.minWidth === null ? null : n.minWidth + "px"), i.style.setProperty("padding", n.padding), i.style.setProperty(
      "overflow-wrap",
      n.disableOverflowWrapBreaking ? "normal" : "break-word"
    ), i.textContent = uw(e);
    const r = i.scrollWidth, s = i.getBoundingClientRect();
    return i.remove(), {
      x: 0,
      y: 0,
      w: s.width,
      h: s.height,
      scrollWidth: r
    };
  }
  /**
   * Given an html element, measure the position of each span of unbroken
   * word/white-space characters within any text nodes it contains.
   */
  measureElementTextNodeSpans(e, { shouldTruncateToFirstLine: n = !1 } = {}) {
    const i = [], r = e.getBoundingClientRect(), s = -r.left, o = -r.top, a = new Range(), c = e.childNodes[0];
    let d = 0, u = null, h = null, g = 0, p = 0, f = !1;
    for (const M of e.childNodes)
      if (M.nodeType === Node.TEXT_NODE)
        for (const m of M.textContent ?? "") {
          a.setStart(c, d), a.setEnd(c, d + m.length);
          const y = a.getClientRects(), I = y[y.length - 1], D = I.top + o, j = I.left + s, w = I.right + s, A = j < p, b = j7.test(m);
          if (
            // If we're at a word boundary...
            b !== h || // ...or we're on a different line...
            D !== g || // ...or we're at the start of the text and haven't created a span yet...
            !u
          ) {
            if (u) {
              if (n && D !== g) {
                f = !0;
                break;
              }
              i.push(u);
            }
            u = {
              box: { x: j, y: D, w: I.width, h: I.height },
              text: m
            }, p = j;
          } else
            A && (u.box.x = j), u.box.w = A ? u.box.w + I.width : w - u.box.x, u.text += m;
          m === `
` && (p = 0), h = b, g = D, d += m.length;
        }
    return u && i.push(u), { spans: i, didTruncate: f };
  }
  /**
   * Measure text into individual spans. Spans are created by rendering the
   * text, then dividing it up according to line breaks and word boundaries.
   *
   * It works by having the browser render the text, then measuring the
   * position of each character. You can use this to replicate the text-layout
   * algorithm of the current browser in e.g. an SVG export.
   */
  measureTextSpans(e, n) {
    var d;
    if (e === "") return [];
    const i = (d = this.baseElm) == null ? void 0 : d.cloneNode();
    this.baseElm.insertAdjacentElement("afterend", i);
    const r = Math.ceil(n.width - n.padding * 2);
    i.setAttribute("dir", "auto"), i.style.setProperty("unicode-bidi", "plaintext"), i.style.setProperty("width", `${r}px`), i.style.setProperty("height", "min-content"), i.style.setProperty("font-size", `${n.fontSize}px`), i.style.setProperty("font-family", n.fontFamily), i.style.setProperty("font-weight", n.fontWeight), i.style.setProperty("line-height", `${n.lineHeight * n.fontSize}px`), i.style.setProperty("text-align", S7[n.textAlign]);
    const s = n.overflow === "truncate-ellipsis" || n.overflow === "truncate-clip";
    s && (i.style.setProperty("overflow-wrap", "anywhere"), i.style.setProperty("word-break", "break-all"));
    const o = uw(e);
    i.textContent = o;
    const { spans: a, didTruncate: c } = this.measureElementTextNodeSpans(i, {
      shouldTruncateToFirstLine: s
    });
    if (n.overflow === "truncate-ellipsis" && c) {
      i.textContent = "…";
      const u = Math.ceil(this.measureElementTextNodeSpans(i).spans[0].box.w);
      i.style.setProperty("width", `${r - u}px`), i.textContent = o;
      const h = this.measureElementTextNodeSpans(i, {
        shouldTruncateToFirstLine: !0
      }).spans, g = h[h.length - 1];
      return h.push({
        text: "…",
        box: {
          x: Math.min(g.box.x + g.box.w, n.width - n.padding - u),
          y: g.box.y,
          w: u,
          h: g.box.h
        }
      }), h;
    }
    return i.remove(), a;
  }
}
var w7 = Object.create, sE = Object.defineProperty, N7 = Object.getOwnPropertyDescriptor, A7 = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), oE = (t) => {
  throw TypeError(t);
}, aE = (t, e, n) => e in t ? sE(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, T7 = (t) => [, , , w7(null)], cE = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], lE = (t) => t !== void 0 && typeof t != "function" ? oE("Function expected") : t, b7 = (t, e, n, i, r) => ({ kind: cE[t], name: e, metadata: i, addInitializer: (s) => n._ ? oE("Already initialized") : r.push(lE(s || null)) }), v7 = (t, e) => aE(e, A7("metadata"), t[3]), E7 = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, dE = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = cE[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, N7(r, n)), y = i.length - 1; y >= 0; y--)
    c = b7(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, lE(o) && (m[f] = o);
  return m && sE(r, n, m), r;
}, Eu = (t, e, n) => aE(t, typeof e != "symbol" ? e + "" : e, n), uE, hE, jd;
const hw = typeof process < "u" && process.env.NODE_ENV === "test" ? (
  // At test time we should use actual raf and not throttle, because throttle was set up to evaluate immediately during tests, which causes stack overflow
  // for the tick manager since it sets up a raf loop.
  function(e) {
    const n = requestAnimationFrame(e);
    return () => cancelAnimationFrame(n);
  }
) : fT;
hE = [di], uE = [di];
class Yp {
  constructor(e) {
    this.editor = e, E7(jd, 5, this), Eu(this, "cancelRaf"), Eu(this, "isPaused", !0), Eu(this, "now", 0), Eu(this, "prevPoint", new x()), this.editor.disposables.add(this.dispose), this.start();
  }
  start() {
    var e;
    this.isPaused = !1, (e = this.cancelRaf) == null || e.call(this), this.cancelRaf = hw(this.tick), this.now = Date.now();
  }
  tick() {
    if (this.isPaused)
      return;
    const e = Date.now(), n = e - this.now;
    this.now = e, this.updatePointerVelocity(n), this.editor.emit("frame", n), this.editor.emit("tick", n), this.cancelRaf = hw(this.tick);
  }
  dispose() {
    var e;
    this.isPaused = !0, (e = this.cancelRaf) == null || e.call(this);
  }
  updatePointerVelocity(e) {
    const {
      prevPoint: n,
      editor: {
        inputs: { currentScreenPoint: i, pointerVelocity: r }
      }
    } = this;
    if (e === 0) return;
    const s = x.Sub(i, n);
    this.prevPoint = i.clone();
    const o = s.len(), a = o ? s.div(o) : new x(0, 0), c = r.clone().lrp(a.mul(o / e), 0.5);
    Math.abs(c.x) < 0.01 && (c.x = 0), Math.abs(c.y) < 0.01 && (c.y = 0), r.equals(c) || (this.editor.inputs.pointerVelocity = c);
  }
}
jd = T7();
dE(jd, 1, "tick", hE, Yp);
dE(jd, 1, "dispose", uE, Yp);
v7(jd, Yp);
var C7 = Object.create, gE = Object.defineProperty, z7 = Object.getOwnPropertyDescriptor, L7 = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), pE = (t) => {
  throw TypeError(t);
}, fE = (t, e, n) => e in t ? gE(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, k7 = (t) => [, , , C7(null)], ME = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], mE = (t) => t !== void 0 && typeof t != "function" ? pE("Function expected") : t, O7 = (t, e, n, i, r) => ({ kind: ME[t], name: e, metadata: i, addInitializer: (s) => n._ ? pE("Already initialized") : r.push(mE(s || null)) }), P7 = (t, e) => fE(e, L7("metadata"), t[3]), U7 = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, qi = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = ME[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, z7(r, n)), y = i.length - 1; y >= 0; y--)
    c = O7(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, mE(o) && (m[f] = o);
  return m && gE(r, n, m), r;
}, R7 = (t, e, n) => fE(t, e + "", n), yE, IE, xE, SE, jE, DE, wE, NE, AE, TE, bE, vE, _n;
vE = [K], bE = [K], TE = [K], AE = [K], NE = [K], wE = [K], DE = [K], jE = [K], SE = [K], xE = [K], IE = [K], yE = [K];
class Si {
  constructor(e, n) {
    if (this.user = e, this.inferDarkMode = n, U7(_n, 5, this), R7(this, "systemColorScheme", xt("systemColorScheme", "light")), typeof window > "u" || !("matchMedia" in window)) return;
    const i = window.matchMedia("(prefers-color-scheme: dark)");
    i != null && i.matches && this.systemColorScheme.set("dark"), i == null || i.addEventListener("change", (r) => {
      r.matches ? this.systemColorScheme.set("dark") : this.systemColorScheme.set("light");
    });
  }
  updateUserPreferences(e) {
    this.user.setUserPreferences({
      ...this.user.userPreferences.get(),
      ...e
    });
  }
  getUserPreferences() {
    return {
      id: this.getId(),
      name: this.getName(),
      locale: this.getLocale(),
      color: this.getColor(),
      animationSpeed: this.getAnimationSpeed(),
      isSnapMode: this.getIsSnapMode(),
      colorScheme: this.user.userPreferences.get().colorScheme,
      isDarkMode: this.getIsDarkMode(),
      isWrapMode: this.getIsWrapMode(),
      isDynamicResizeMode: this.getIsDynamicResizeMode()
    };
  }
  getIsDarkMode() {
    switch (this.user.userPreferences.get().colorScheme) {
      case "dark":
        return !0;
      case "light":
        return !1;
      case "system":
        return this.systemColorScheme.get() === "dark";
      default:
        return this.inferDarkMode ? this.systemColorScheme.get() === "dark" : !1;
    }
  }
  getEdgeScrollSpeed() {
    return this.user.userPreferences.get().edgeScrollSpeed ?? ts.edgeScrollSpeed;
  }
  getAnimationSpeed() {
    return this.user.userPreferences.get().animationSpeed ?? ts.animationSpeed;
  }
  getId() {
    return this.user.userPreferences.get().id;
  }
  getName() {
    return this.user.userPreferences.get().name ?? ts.name;
  }
  getLocale() {
    return this.user.userPreferences.get().locale ?? ts.locale;
  }
  getColor() {
    return this.user.userPreferences.get().color ?? ts.color;
  }
  getIsSnapMode() {
    return this.user.userPreferences.get().isSnapMode ?? ts.isSnapMode;
  }
  getIsWrapMode() {
    return this.user.userPreferences.get().isWrapMode ?? ts.isWrapMode;
  }
  getIsDynamicResizeMode() {
    return this.user.userPreferences.get().isDynamicSizeMode ?? ts.isDynamicSizeMode;
  }
  getIsPasteAtCursorMode() {
    return this.user.userPreferences.get().isPasteAtCursorMode ?? ts.isPasteAtCursorMode;
  }
}
_n = k7();
qi(_n, 1, "getUserPreferences", vE, Si);
qi(_n, 1, "getIsDarkMode", bE, Si);
qi(_n, 1, "getEdgeScrollSpeed", TE, Si);
qi(_n, 1, "getAnimationSpeed", AE, Si);
qi(_n, 1, "getId", NE, Si);
qi(_n, 1, "getName", wE, Si);
qi(_n, 1, "getLocale", DE, Si);
qi(_n, 1, "getColor", jE, Si);
qi(_n, 1, "getIsSnapMode", SE, Si);
qi(_n, 1, "getIsWrapMode", xE, Si);
qi(_n, 1, "getIsDynamicResizeMode", IE, Si);
qi(_n, 1, "getIsPasteAtCursorMode", yE, Si);
P7(_n, Si);
const Y7 = {
  wheel: "onWheel",
  pointer_down: "onPointerDown",
  pointer_move: "onPointerMove",
  long_press: "onLongPress",
  pointer_up: "onPointerUp",
  right_click: "onRightClick",
  middle_click: "onMiddleClick",
  key_down: "onKeyDown",
  key_up: "onKeyUp",
  key_repeat: "onKeyRepeat",
  cancel: "onCancel",
  complete: "onComplete",
  interrupt: "onInterrupt",
  double_click: "onDoubleClick",
  triple_click: "onTripleClick",
  quadruple_click: "onQuadrupleClick",
  tick: "onTick"
}, Q7 = [
  "brushing",
  "cropping",
  "dragging",
  "dragging_handle",
  "drawing",
  "erasing",
  "lasering",
  "resizing",
  "rotating",
  "scribble_brushing",
  "translating"
];
class ee {
  constructor(e, n) {
    S(this, "performanceTracker");
    S(this, "id");
    S(this, "type");
    S(this, "shapeType");
    S(this, "initial");
    S(this, "children");
    S(this, "isLockable");
    S(this, "parent");
    S(this, "_path");
    S(this, "_current");
    S(this, "_isActive");
    /**
     * This is a hack / escape hatch that will tell the editor to
     * report a different state as active (in `getCurrentToolId()`) when
     * this state is active. This is usually used when a tool transitions
     * to a child of a different state for a certain interaction and then
     * returns to the original tool when that interaction completes; and
     * where we would want to show the original tool as active in the UI.
     *
     * @public
     */
    S(this, "_currentToolIdMask", xt("curent tool id mask", void 0));
    this.editor = e;
    const { id: i, children: r, initial: s, isLockable: o } = this.constructor;
    this.id = i, this._isActive = xt("toolIsActive" + this.id, !1), this._current = xt("toolState" + this.id, void 0), this._path = K("toolPath" + this.id, () => {
      const a = this.getCurrent();
      return this.id + (a ? `.${a.getPath()}` : "");
    }), this.parent = n ?? {}, this.parent ? r && s ? (this.type = "branch", this.initial = s, this.children = Object.fromEntries(
      r().map((a) => [a.id, new a(this.editor, this)])
    ), this._current.set(this.children[this.initial])) : this.type = "leaf" : (this.type = "root", r && s && (this.initial = s, this.children = Object.fromEntries(
      r().map((a) => [a.id, new a(this.editor, this)])
    ), this._current.set(this.children[this.initial]))), this.isLockable = o, this.performanceTracker = new BA();
  }
  /**
   * This node's path of active state nodes
   *
   * @public
   */
  getPath() {
    return this._path.get();
  }
  /**
   * This node's current active child node, if any.
   *
   * @public
   */
  getCurrent() {
    return this._current.get();
  }
  /**
   * Whether this node is active.
   *
   * @public
   */
  getIsActive() {
    return this._isActive.get();
  }
  /**
   * Transition to a new active child state node.
   *
   * @example
   * ```ts
   * parentState.transition('childStateA')
   * parentState.transition('childStateB', { myData: 4 })
   *```
   *
   * @param id - The id of the child state node to transition to.
   * @param info - Any data to pass to the `onEnter` and `onExit` handlers.
   *
   * @public
   */
  transition(e, n = {}) {
    var s;
    const i = e.split(".");
    let r = this;
    for (let o = 0; o < i.length; o++) {
      const a = i[o], c = r.getCurrent(), d = (s = r.children) == null ? void 0 : s[a];
      if (!d)
        throw Error(`${r.id} - no child state exists with the id ${a}.`);
      if ((c == null ? void 0 : c.id) !== d.id && (c == null || c.exit(n, a), r._current.set(d), d.enter(n, (c == null ? void 0 : c.id) || "initial"), !d.getIsActive()))
        break;
      r = d;
    }
    return this;
  }
  handleEvent(e) {
    var r;
    const n = Y7[e.name], i = this._current.__unsafe__getWithoutCapture();
    (r = this[n]) == null || r.call(this, e), this._isActive.__unsafe__getWithoutCapture() && i && i === this._current.__unsafe__getWithoutCapture() && i.handleEvent(e);
  }
  // todo: move this logic into transition
  enter(e, n) {
    var i;
    if (Wt.measurePerformance.get() && Q7.includes(this.id) && this.performanceTracker.start(this.id), this._isActive.set(!0), (i = this.onEnter) == null || i.call(this, e, n), this.children && this.initial && this.getIsActive()) {
      const r = this.children[this.initial];
      this._current.set(r), r.enter(e, n);
    }
  }
  // todo: move this logic into transition
  exit(e, n) {
    var i, r;
    Wt.measurePerformance.get() && this.performanceTracker.isStarted() && this.performanceTracker.stop(), this._isActive.set(!1), (i = this.onExit) == null || i.call(this, e, n), this.getIsActive() || (r = this.getCurrent()) == null || r.exit(e, n);
  }
  getCurrentToolIdMask() {
    return this._currentToolIdMask.get();
  }
  setCurrentToolIdMask(e) {
    this._currentToolIdMask.set(e);
  }
}
S(ee, "id"), S(ee, "initial"), S(ee, "children"), S(ee, "isLockable", !0);
class _y extends ee {
  static children() {
    return [];
  }
  onKeyDown(e) {
    var n;
    switch (e.code) {
      case "KeyZ": {
        if (!(e.shiftKey || e.ctrlKey)) {
          const i = this.getCurrent();
          i && ((n = i.getCurrent()) == null ? void 0 : n.id) === "idle" && this.children.zoom && this.editor.setCurrentTool("zoom", { ...e, onInteractionEnd: i.id });
        }
        break;
      }
    }
  }
}
S(_y, "id", "root"), S(_y, "initial", "");
var Z7 = Object.create, EE = Object.defineProperty, F7 = Object.getOwnPropertyDescriptor, CE = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), zE = (t) => {
  throw TypeError(t);
}, LE = (t, e, n) => e in t ? EE(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, B7 = (t) => [, , , Z7((t == null ? void 0 : t[CE("metadata")]) ?? null)], kE = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], OE = (t) => t !== void 0 && typeof t != "function" ? zE("Function expected") : t, G7 = (t, e, n, i, r) => ({ kind: kE[t], name: e, metadata: i, addInitializer: (s) => n._ ? zE("Already initialized") : r.push(OE(s || null)) }), W7 = (t, e) => LE(e, CE("metadata"), t[3]), H7 = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, Me = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = kE[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, F7(r, n)), y = i.length - 1; y >= 0; y--)
    c = G7(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, OE(o) && (m[f] = o);
  return m && EE(r, n, m), r;
}, Ae = (t, e, n) => LE(t, typeof e != "symbol" ? e + "" : e, n), PE, UE, RE, YE, QE, ZE, FE, BE, GE, WE, HE, VE, KE, XE, JE, qE, _E, $E, eC, tC, nC, iC, rC, sC, oC, aC, cC, lC, dC, uC, hC, gC, pC, fC, MC, mC, yC, IC, xC, SC, jC, DC, wC, NC, AC, TC, bC, vC, EC, CC, zC, LC, kC, OC, PC, UC, RC, YC, QC, ZC, FC, BC, GC, WC, HC, VC, KC, XC, JC, qC, _C, $C, $y, ue;
class de extends ($y = gV, $C = [K], _C = [K], qC = [K], JC = [K], XC = [K], KC = [K], VC = [K], HC = [K], WC = [K], GC = [K], BC = [K], FC = [K], ZC = [K], QC = [K], YC = [K], RC = [K], UC = [K], PC = [K], OC = [K], kC = [K], LC = [K], zC = [K], CC = [K], EC = [K], vC = [K], bC = [K], TC = [K], AC = [K], NC = [K], wC = [K], DC = [K], jC = [K], SC = [K], xC = [K], IC = [K], yC = [K], mC = [K], MC = [K], fC = [K], pC = [K], gC = [K], hC = [K], uC = [K], dC = [K], lC = [K], cC = [K], aC = [K], oC = [K], sC = [K], rC = [K], iC = [K], nC = [K], tC = [K], eC = [K], $E = [K], _E = [K], qE = [K], JE = [K], XE = [K], KE = [K], VE = [K], HE = [K], WE = [K], GE = [K], BE = [K({ isEqual: (e, n) => e.equals(n) })], FE = [K], ZE = [K], QE = [K], YE = [di], RE = [di], UE = [di], PE = [di], $y) {
  constructor({
    store: e,
    user: n,
    shapeUtils: i,
    bindingUtils: r,
    tools: s,
    getContainer: o,
    cameraOptions: a,
    initialState: c,
    autoFocus: d,
    inferDarkMode: u,
    options: h,
    isShapeHidden: g
  }) {
    var E;
    super(), H7(ue, 5, this), Ae(this, "_isShapeHiddenPredicate"), Ae(this, "options"), Ae(this, "contextId", ht()), Ae(this, "store"), Ae(this, "root"), Ae(this, "disposables", /* @__PURE__ */ new Set()), Ae(this, "isDisposed", !1), Ae(this, "_tickManager"), Ae(this, "snaps"), Ae(this, "timers", Jy.forContext(this.contextId)), Ae(this, "user"), Ae(this, "textMeasure"), Ae(this, "environment", mt), Ae(this, "scribbles"), Ae(this, "sideEffects"), Ae(this, "edgeScrollManager"), Ae(this, "focusManager"), Ae(this, "getContainer"), Ae(this, "shapeUtils"), Ae(this, "styleProps"), Ae(this, "bindingUtils"), Ae(this, "history"), Ae(this, "_shouldIgnoreShapeLock", !1), Ae(this, "_crashingError", null), Ae(this, "_isChangingStyleTimeout", -1), Ae(this, "menus", ir.forContext(this.contextId)), Ae(this, "_cameraOptions", xt("camera options", z0)), Ae(this, "_viewportAnimation", null), Ae(this, "_willSetInitialBounds", !0), Ae(this, "_isLockedOnFollowingUser", xt("isLockedOnFollowingUser", !1)), Ae(this, "_cameraState", xt("camera state", "idle")), Ae(this, "_cameraStateTimeoutRemaining", 0), Ae(this, "_currentPageShapeIds"), Ae(this, "_parentIdsToChildIds"), Ae(this, "animatingShapes", /* @__PURE__ */ new Map()), Ae(this, "externalAssetContentHandlers", {
      file: null,
      url: null
    }), Ae(this, "temporaryAssetPreview", /* @__PURE__ */ new Map()), Ae(this, "externalContentHandlers", {
      text: null,
      files: null,
      embed: null,
      "svg-text": null,
      url: null
    }), Ae(this, "inputs", {
      /** The most recent pointer down's position in the current page space. */
      originPagePoint: new x(),
      /** The most recent pointer down's position in screen space. */
      originScreenPoint: new x(),
      /** The previous pointer position in the current page space. */
      previousPagePoint: new x(),
      /** The previous pointer position in screen space. */
      previousScreenPoint: new x(),
      /** The most recent pointer position in the current page space. */
      currentPagePoint: new x(),
      /** The most recent pointer position in screen space. */
      currentScreenPoint: new x(),
      /** A set containing the currently pressed keys. */
      keys: /* @__PURE__ */ new Set(),
      /** A set containing the currently pressed buttons. */
      buttons: /* @__PURE__ */ new Set(),
      /** Whether the input is from a pe. */
      isPen: !1,
      /** Whether the shift key is currently pressed. */
      shiftKey: !1,
      /** Whether the meta key is currently pressed. */
      metaKey: !1,
      /** Whether the control or command key is currently pressed. */
      ctrlKey: !1,
      /** Whether the alt or option key is currently pressed. */
      altKey: !1,
      /** Whether the user is dragging. */
      isDragging: !1,
      /** Whether the user is pointing. */
      isPointing: !1,
      /** Whether the user is pinching. */
      isPinching: !1,
      /** Whether the user is editing. */
      isEditing: !1,
      /** Whether the user is panning. */
      isPanning: !1,
      /** Whether the user is spacebar panning. */
      isSpacebarPanning: !1,
      /** Velocity of mouse pointer, in pixels per millisecond */
      pointerVelocity: new x()
    }), Ae(this, "_clickManager", new Pp(this)), Ae(this, "_prevCursor", "default"), Ae(this, "_shiftKeyTimeout", -1), Ae(this, "_altKeyTimeout", -1), Ae(this, "_ctrlKeyTimeout", -1), Ae(this, "_metaKeyTimeout", -1), Ae(this, "_restoreToolId", "select"), Ae(this, "_pinchStart", 1), Ae(this, "_didPinch", !1), Ae(this, "_selectedShapeIdsAtPointerDown", []), Ae(this, "_longPressTimeout", -1), Ae(this, "capturedPointerId", null), Ae(this, "performanceTracker"), Ae(this, "performanceTrackerTimeout", -1), Ae(this, "_pendingEventsForNextTick", []), this._isShapeHiddenPredicate = g, this.options = { ...f8, ...h }, this.store = e, this.disposables.add(this.store.dispose.bind(this.store)), this.history = new B8({
      store: e,
      annotateError: (v) => {
        this.annotateError(v, { origin: "history.batch", willCrashApp: !0 }), this.crash(v);
      }
    }), this.snaps = new Sd(this), this.disposables.add(this.timers.dispose), this._cameraOptions.set({ ...z0, ...a }), this.user = new Si(n ?? qv(), u ?? !1), this.getContainer = o, this.textMeasure = new D7(this), this._tickManager = new Yp(this);
    class p extends _y {
    }
    S(p, "initial", c ?? ""), this.root = new p(this), this.root.children = {};
    const f = o1(i), M = {}, m = {}, y = /* @__PURE__ */ new Map();
    for (const v of f) {
      const P = new v(this);
      M[v.type] = P;
      const C = Cb(v.props ?? {});
      m[v.type] = C;
      for (const z of C.keys())
        if (!y.has(z.id))
          y.set(z.id, z);
        else if (y.get(z.id) !== z)
          throw Error(
            `Multiple style props with id "${z.id}" in use. Style prop IDs must be unique.`
          );
    }
    this.shapeUtils = M, this.styleProps = m;
    const I = i1(r), D = {};
    for (const v of I) {
      const P = new v(this);
      D[v.type] = P;
    }
    this.bindingUtils = D;
    for (const v of [...s]) {
      if (cr(this.root.children, v.id))
        throw Error(`Can't override tool with id "${v.id}"`);
      this.root.children[v.id] = new v(this, this.root);
    }
    this.scribbles = new H8(this);
    const j = (v, P) => {
      let C = null;
      const z = v.selectedShapeIds.filter(
        (U) => !P.has(U)
      );
      z.length !== v.selectedShapeIds.length && (C || (C = { ...v }), C.selectedShapeIds = z);
      const O = v.erasingShapeIds.filter(
        (U) => !P.has(U)
      );
      O.length !== v.erasingShapeIds.length && (C || (C = { ...v }), C.erasingShapeIds = O), v.hoveredShapeId && P.has(v.hoveredShapeId) && (C || (C = { ...v }), C.hoveredShapeId = null), v.editingShapeId && P.has(v.editingShapeId) && (C || (C = { ...v }), C.editingShapeId = null);
      const R = v.hintingShapeIds.filter(
        (U) => !P.has(U)
      );
      return R.length !== v.hintingShapeIds.length && (C || (C = { ...v }), C.hintingShapeIds = R), v.focusedGroupId && P.has(v.focusedGroupId) && (C || (C = { ...v }), C.focusedGroupId = null), C;
    };
    this.sideEffects = this.store.sideEffects;
    let w = /* @__PURE__ */ new Map();
    const A = /* @__PURE__ */ new Set(), b = /* @__PURE__ */ new Set();
    let T = /* @__PURE__ */ new Set();
    if (this.disposables.add(
      this.sideEffects.registerOperationCompleteHandler(() => {
        var v, P, C, z;
        A.clear();
        for (const O of b) {
          b.delete(O);
          const R = this.getShape(O);
          if (!R) continue;
          const U = this.getShapeUtil(R), F = (v = U.onChildrenChange) == null ? void 0 : v.call(U, R);
          F != null && F.length && this.updateShapes(F);
        }
        if (T.size) {
          const O = T;
          T = /* @__PURE__ */ new Set();
          for (const R of O) {
            const U = this.getBindingUtil(R);
            (P = U.onOperationComplete) == null || P.call(U);
          }
        }
        if (w.size) {
          const O = w;
          w = /* @__PURE__ */ new Map();
          for (const R of O.values())
            (z = (C = this.getBindingUtil(R.binding)).onAfterDelete) == null || z.call(C, R);
        }
        this.emit("update");
      })
    ), this.disposables.add(
      this.sideEffects.register({
        shape: {
          afterChange: (v, P) => {
            var C, z, O, R;
            for (const U of this.getBindingsInvolvingShape(P))
              T.add(U.type), U.fromId === P.id && ((z = (C = this.getBindingUtil(U)).onAfterChangeFromShape) == null || z.call(C, {
                binding: U,
                shapeBefore: v,
                shapeAfter: P
              })), U.toId === P.id && ((R = (O = this.getBindingUtil(U)).onAfterChangeToShape) == null || R.call(O, {
                binding: U,
                shapeBefore: v,
                shapeAfter: P
              }));
            if (v.parentId !== P.parentId) {
              const U = (F) => {
                var Z, te, oe, me;
                const H = this.getShape(F);
                if (H)
                  for (const he of this.getBindingsInvolvingShape(H))
                    T.add(he.type), he.fromId === H.id && ((te = (Z = this.getBindingUtil(he)).onAfterChangeFromShape) == null || te.call(Z, {
                      binding: he,
                      shapeBefore: H,
                      shapeAfter: H
                    })), he.toId === H.id && ((me = (oe = this.getBindingUtil(he)).onAfterChangeToShape) == null || me.call(oe, {
                      binding: he,
                      shapeBefore: H,
                      shapeAfter: H
                    }));
              };
              U(P.id), this.visitDescendants(P.id, U);
            }
            if (v.parentId !== P.parentId && ni(P.parentId)) {
              const U = /* @__PURE__ */ new Set([v.id]);
              this.visitDescendants(v.id, (F) => {
                U.add(F);
              });
              for (const F of this.getPageStates()) {
                if (F.pageId === P.parentId) continue;
                const H = j(F, U);
                H && this.store.put([H]);
              }
            }
            v.parentId && si(v.parentId) && b.add(v.parentId), P.parentId !== v.parentId && si(P.parentId) && b.add(P.parentId);
          },
          beforeDelete: (v) => {
            var O, R, U, F;
            if (A.has(v.id)) return;
            v.parentId && si(v.parentId) && b.add(v.parentId), A.add(v.id);
            const P = [];
            for (const H of this.getBindingsInvolvingShape(v)) {
              T.add(H.type), P.push(H.id);
              const Z = this.getBindingUtil(H);
              H.fromId === v.id ? ((O = Z.onBeforeIsolateToShape) == null || O.call(Z, { binding: H, removedShape: v }), (R = Z.onBeforeDeleteFromShape) == null || R.call(Z, { binding: H, shape: v })) : ((U = Z.onBeforeIsolateFromShape) == null || U.call(Z, { binding: H, removedShape: v }), (F = Z.onBeforeDeleteToShape) == null || F.call(Z, { binding: H, shape: v }));
            }
            P.length && this.deleteBindings(P);
            const C = /* @__PURE__ */ new Set([v.id]), z = Ze(
              this.getPageStates().map((H) => j(H, C))
            );
            z.length && this.store.put(z);
          }
        },
        binding: {
          beforeCreate: (v) => {
            var C, z;
            const P = (z = (C = this.getBindingUtil(v)).onBeforeCreate) == null ? void 0 : z.call(C, { binding: v });
            return P || v;
          },
          afterCreate: (v) => {
            var P, C;
            T.add(v.type), (C = (P = this.getBindingUtil(v)).onAfterCreate) == null || C.call(P, { binding: v });
          },
          beforeChange: (v, P) => {
            var z, O;
            const C = (O = (z = this.getBindingUtil(P)).onBeforeChange) == null ? void 0 : O.call(z, {
              bindingBefore: v,
              bindingAfter: P
            });
            return C || P;
          },
          afterChange: (v, P) => {
            var C, z;
            T.add(P.type), (z = (C = this.getBindingUtil(P)).onAfterChange) == null || z.call(C, { bindingBefore: v, bindingAfter: P });
          },
          beforeDelete: (v) => {
            var P, C;
            (C = (P = this.getBindingUtil(v)).onBeforeDelete) == null || C.call(P, { binding: v });
          },
          afterDelete: (v) => {
            var P, C;
            (C = (P = this.getBindingUtil(v)).onAfterDelete) == null || C.call(P, { binding: v }), T.add(v.type);
          }
        },
        page: {
          afterCreate: (v) => {
            const P = kr.createId(v.id), C = ar.createId(v.id);
            this.store.has(P) || this.store.put([kr.create({ id: P })]), this.store.has(C) || this.store.put([
              ar.create({ id: C, pageId: v.id })
            ]);
          },
          afterDelete: (v, P) => {
            var O, R;
            if (((O = this.getInstanceState()) == null ? void 0 : O.currentPageId) === v.id) {
              const U = (R = this.getPages().find((F) => F.id !== v.id)) == null ? void 0 : R.id;
              U ? this.store.put([{ ...this.getInstanceState(), currentPageId: U }]) : P === "user" && this.store.ensureStoreIsUsable();
            }
            const C = kr.createId(v.id), z = ar.createId(v.id);
            this.store.remove([C, z]);
          }
        },
        instance: {
          afterChange: (v, P, C) => {
            var z;
            if (!this.store.has(P.currentPageId)) {
              const O = this.store.has(v.currentPageId) ? v.currentPageId : (z = this.getPages()[0]) == null ? void 0 : z.id;
              O ? this.store.update(P.id, (R) => ({
                ...R,
                currentPageId: O
              })) : C === "user" && this.store.ensureStoreIsUsable();
            }
          }
        },
        instance_page_state: {
          afterChange: (v, P) => {
            if ((v == null ? void 0 : v.selectedShapeIds) !== (P == null ? void 0 : P.selectedShapeIds)) {
              const C = P.selectedShapeIds.filter((O) => {
                var U, F;
                let R = (U = this.getShape(O)) == null ? void 0 : U.parentId;
                for (; si(R); ) {
                  if (P.selectedShapeIds.includes(R))
                    return !1;
                  R = (F = this.getShape(R)) == null ? void 0 : F.parentId;
                }
                return !0;
              });
              let z = null;
              if (C.length > 0) {
                const O = this.findCommonAncestor(
                  Ze(C.map((R) => this.getShape(R))),
                  (R) => this.isShapeOfType(R, "group")
                );
                O && (z = O);
              } else
                P != null && P.focusedGroupId && (z = P.focusedGroupId);
              (C.length !== P.selectedShapeIds.length || z !== P.focusedGroupId) && this.store.put([
                {
                  ...P,
                  selectedShapeIds: C,
                  focusedGroupId: z ?? null
                }
              ]);
            }
          }
        }
      })
    ), this._currentPageShapeIds = E8(
      this.store,
      () => this.getCurrentPageId()
    ), this._parentIdsToChildIds = v8(this.store), this.disposables.add(
      this.store.listen((v) => {
        this.emit("change", v);
      })
    ), this.disposables.add(this.history.dispose), this.run(
      () => {
        this.store.ensureStoreIsUsable(), this._updateCurrentPageState({
          editingShapeId: null,
          hoveredShapeId: null,
          erasingShapeIds: []
        });
      },
      { history: "ignore" }
    ), c && this.root.children[c] === void 0)
      throw Error(`No state found for initialState "${c}".`);
    if (this.root.enter(void 0, "initial"), this.edgeScrollManager = new Y8(this), this.focusManager = new Q8(this, d), this.disposables.add(this.focusManager.dispose.bind(this.focusManager)), this.getInstanceState().followingUserId && this.stopFollowingUser(), this.on("tick", this._flushEventsForTick), this.timers.requestAnimationFrame(() => {
      this._tickManager.start();
    }), this.performanceTracker = new BA(), (E = this.store.props.collaboration) != null && E.mode) {
      const v = this.store.props.collaboration.mode;
      this.disposables.add(
        Yr("update collaboration mode", () => {
          this.store.put([{ ...this.getInstanceState(), isReadonly: v.get() === "readonly" }]);
        })
      );
    }
  }
  getIsShapeHiddenCache() {
    return this._isShapeHiddenPredicate ? this.store.createComputedCache("isShapeHidden", (e) => this.findShapeAncestor(e, (i) => this.isShapeHidden(i)) ? !0 : this._isShapeHiddenPredicate(e, this) ?? !1) : null;
  }
  isShapeHidden(e) {
    return this._isShapeHiddenPredicate ? !!this.getIsShapeHiddenCache().get(
      typeof e == "string" ? e : e.id
    ) : !1;
  }
  /**
   * Dispose the editor.
   *
   * @public
   */
  dispose() {
    this.disposables.forEach((e) => e()), this.disposables.clear(), this.isDisposed = !0;
  }
  getShapeUtil(e) {
    const n = typeof e == "string" ? e : e.type, i = ui(this.shapeUtils, n);
    return ct(i, `No shape util found for type "${n}"`), i;
  }
  getBindingUtil(e) {
    const n = typeof e == "string" ? e : e.type, i = ui(this.bindingUtils, n);
    return ct(i, `No binding util found for type "${n}"`), i;
  }
  /**
   * Undo to the last mark.
   *
   * @example
   * ```ts
   * editor.undo()
   * ```
   *
   * @public
   */
  undo() {
    return this._flushEventsForTick(0), this.complete(), this.history.undo(), this;
  }
  getCanUndo() {
    return this.history.getNumUndos() > 0;
  }
  /**
   * Redo to the next mark.
   *
   * @example
   * ```ts
   * editor.redo()
   * ```
   *
   * @public
   */
  redo() {
    return this._flushEventsForTick(0), this.complete(), this.history.redo(), this;
  }
  clearHistory() {
    return this.history.clear(), this;
  }
  getCanRedo() {
    return this.history.getNumRedos() > 0;
  }
  /**
   * Create a new "mark", or stopping point, in the undo redo history. Creating a mark will clear
   * any redos.
   *
   * @example
   * ```ts
   * editor.mark()
   * editor.mark('flip shapes')
   * ```
   *
   * @param markId - The mark's id, usually the reason for adding the mark.
   *
   * @public
   * @deprecated use {@link Editor.markHistoryStoppingPoint} instead
   */
  mark(e) {
    return console.warn(
      typeof e == "string" ? `[tldraw] \`editor.history.mark("${e}")\` is deprecated. Please use \`const myMarkId = editor.markHistoryStoppingPoint()\` instead.` : "[tldraw] `editor.mark()` is deprecated. Use `editor.markHistoryStoppingPoint()` instead."
    ), this.history._mark(e ?? ht()), this;
  }
  /**
   * Create a new "mark", or stopping point, in the undo redo history. Creating a mark will clear
   * any redos. You typically want to do this just before a user interaction begins or is handled.
   *
   * @example
   * ```ts
   * editor.markHistoryStoppingPoint()
   * editor.flipShapes(editor.getSelectedShapes())
   * ```
   * @example
   * ```ts
   * const beginRotateMark = editor.markHistoryStoppingPoint()
   * // if the use cancels the rotation, you can bail back to this mark
   * editor.bailToMark(beginRotateMark)
   * ```
   *
   * @public
   * @param name - The name of the mark, useful for debugging the undo/redo stacks
   * @returns a unique id for the mark that can be used with `squashToMark` or `bailToMark`.
   */
  markHistoryStoppingPoint(e) {
    const n = `[${e ?? "stop"}]_${ht()}`;
    return this.history._mark(n), n;
  }
  /**
   * @internal this is only used to implement some backwards-compatibility logic. Should be fine to delete after 6 months or whatever.
   */
  getMarkIdMatching(e) {
    return this.history.getMarkIdMatching(e);
  }
  /**
   * Coalesces all changes since the given mark into a single change, removing any intermediate marks.
   *
   * This is useful if you need to 'compress' the recent history to simplify the undo/redo experience of a complex interaction.
   *
   * @example
   * ```ts
   * const bumpShapesMark = editor.markHistoryStoppingPoint()
   * // ... some changes
   * editor.squashToMark(bumpShapesMark)
   * ```
   *
   * @param markId - The mark id to squash to.
   */
  squashToMark(e) {
    return this.history.squashToMark(e), this;
  }
  /**
   * Undo to the closest mark, discarding the changes so they cannot be redone.
   *
   * @example
   * ```ts
   * editor.bail()
   * ```
   *
   * @public
   */
  bail() {
    return this.history.bail(), this;
  }
  /**
   * Undo to the given mark, discarding the changes so they cannot be redone.
   *
   * @example
   * ```ts
   * const beginDrag = editor.markHistoryStoppingPoint()
   * // ... some changes
   * editor.bailToMark(beginDrag)
   * ```
   *
   * @public
   */
  bailToMark(e) {
    return this.history.bailToMark(e), this;
  }
  /**
   * Run a function in a transaction with optional options for context.
   * You can use the options to change the way that history is treated
   * or allow changes to locked shapes.
   *
   * @example
   * ```ts
   * // updating with
   * editor.run(() => {
   * 	editor.updateShape({ ...myShape, x: 100 })
   * }, { history: "ignore" })
   *
   * // forcing changes / deletions for locked shapes
   * editor.toggleLock([myShape])
   * editor.run(() => {
   * 	editor.updateShape({ ...myShape, x: 100 })
   * 	editor.deleteShape(myShape)
   * }, { ignoreShapeLock: true }, )
   * ```
   *
   * @param fn - The callback function to run.
   * @param opts - The options for the batch.
   *
   *
   * @public
   */
  run(e, n) {
    const i = this._shouldIgnoreShapeLock;
    this._shouldIgnoreShapeLock = (n == null ? void 0 : n.ignoreShapeLock) ?? i;
    try {
      this.history.batch(e, n);
    } finally {
      this._shouldIgnoreShapeLock = i;
    }
    return this;
  }
  /**
   * @deprecated Use `Editor.run` instead.
   */
  batch(e, n) {
    return this.run(e, n);
  }
  /* --------------------- Errors --------------------- */
  /** @internal */
  annotateError(e, {
    origin: n,
    willCrashApp: i,
    tags: r,
    extras: s
  }) {
    const o = this.createErrorAnnotations(n, i);
    return lx(e, {
      tags: { ...o.tags, ...r },
      extras: { ...o.extras, ...s }
    }), i && this.store.markAsPossiblyCorrupted(), this;
  }
  /** @internal */
  createErrorAnnotations(e, n) {
    try {
      const i = this.getEditingShapeId();
      return {
        tags: {
          origin: e,
          willCrashApp: n
        },
        extras: {
          activeStateNode: this.root.getPath(),
          selectedShapes: this.getSelectedShapes(),
          editingShape: i ? this.getShape(i) : void 0,
          inputs: this.inputs
        }
      };
    } catch {
      return {
        tags: {
          origin: e,
          willCrashApp: n
        },
        extras: {}
      };
    }
  }
  /**
   * We can't use an `atom` here because there's a chance that when `crashAndReportError` is called,
   * we're in a transaction that's about to be rolled back due to the same error we're currently
   * reporting.
   *
   * Instead, to listen to changes to this value, you need to listen to app's `crash` event.
   *
   * @internal
   */
  getCrashingError() {
    return this._crashingError;
  }
  /** @internal */
  crash(e) {
    return this._crashingError = e, this.store.markAsPossiblyCorrupted(), this.emit("crash", { error: e }), this;
  }
  getPath() {
    return this.root.getPath().split("root.")[1];
  }
  /**
   * Get whether a certain tool (or other state node) is currently active.
   *
   * @example
   * ```ts
   * editor.isIn('select')
   * editor.isIn('select.brushing')
   * ```
   *
   * @param path - The path of active states, separated by periods.
   *
   * @public
   */
  isIn(e) {
    const n = e.split(".").reverse();
    let i = this.root;
    for (; n.length > 0; ) {
      const r = n.pop();
      if (!r) return !0;
      const s = i.getCurrent();
      if ((s == null ? void 0 : s.id) === r) {
        if (n.length === 0) return !0;
        i = s;
        continue;
      } else return !1;
    }
    return !1;
  }
  /**
   * Get whether the state node is in any of the given active paths.
   *
   * @example
   * ```ts
   * state.isInAny('select', 'erase')
   * state.isInAny('select.brushing', 'erase.idle')
   * ```
   *
   * @public
   */
  isInAny(...e) {
    return e.some((n) => this.isIn(n));
  }
  /**
   * Set the selected tool.
   *
   * @example
   * ```ts
   * editor.setCurrentTool('hand')
   * editor.setCurrentTool('hand', { date: Date.now() })
   * ```
   *
   * @param id - The id of the tool to select.
   * @param info - Arbitrary data to pass along into the transition.
   *
   * @public
   */
  setCurrentTool(e, n = {}) {
    return this.root.transition(e, n), this;
  }
  getCurrentTool() {
    return this.root.getCurrent();
  }
  getCurrentToolId() {
    const e = this.getCurrentTool();
    return e ? e.getCurrentToolIdMask() ?? e.id : "";
  }
  /**
   * Get a descendant by its path.
   *
   * @example
   * ```ts
   * state.getStateDescendant('select')
   * state.getStateDescendant('select.brushing')
   * ```
   *
   * @param path - The descendant's path of state ids, separated by periods.
   *
   * @public
   */
  getStateDescendant(e) {
    var r;
    const n = e.split(".").reverse();
    let i = this.root;
    for (; n.length > 0; ) {
      const s = n.pop();
      if (!s) return i;
      const o = (r = i.children) == null ? void 0 : r[s];
      if (!o) return;
      i = o;
    }
    return i;
  }
  getDocumentSettings() {
    return this.store.get(Qy);
  }
  /**
   * Update the global document settings that apply to all users.
   *
   * @public
   **/
  updateDocumentSettings(e) {
    return this.run(
      () => {
        this.store.put([{ ...this.getDocumentSettings(), ...e }]);
      },
      { history: "ignore" }
    ), this;
  }
  getInstanceState() {
    return this.store.get(Qn);
  }
  /**
   * Update the instance's state.
   *
   * @param partial - A partial object to update the instance state with.
   * @param historyOptions - History batch options.
   *
   * @public
   */
  updateInstanceState(e, n) {
    return this._updateInstanceState(e, { history: "ignore", ...n }), e.isChangingStyle !== void 0 && (clearTimeout(this._isChangingStyleTimeout), e.isChangingStyle === !0 && (this._isChangingStyleTimeout = this.timers.setTimeout(() => {
      this._updateInstanceState({ isChangingStyle: !1 }, { history: "ignore" });
    }, 2e3))), this;
  }
  /** @internal */
  _updateInstanceState(e, n) {
    this.run(() => {
      this.store.put([
        {
          ...this.getInstanceState(),
          ...e
        }
      ]);
    }, n);
  }
  getOpenMenus() {
    return this.menus.getOpenMenus();
  }
  /**
   * @deprecated Use `editor.menus.addOpenMenu` instead.
   *
   * @public
   */
  addOpenMenu(e) {
    return this.menus.addOpenMenu(e), this;
  }
  /**
   * @deprecated Use `editor.menus.deleteOpenMenu` instead.
   *
   * @public
   */
  deleteOpenMenu(e) {
    return this.menus.deleteOpenMenu(e), this;
  }
  /**
   * @deprecated Use `editor.menus.clearOpenMenus` instead.
   *
   * @public
   */
  clearOpenMenus() {
    return this.menus.clearOpenMenus(), this;
  }
  getIsMenuOpen() {
    return this.menus.hasAnyOpenMenus();
  }
  /* --------------------- Cursor --------------------- */
  /**
   * Set the cursor.
   *
   * @param cursor - The cursor to set.
   * @public
   */
  setCursor(e) {
    return this.updateInstanceState({ cursor: { ...this.getInstanceState().cursor, ...e } }), this;
  }
  getPageStates() {
    return this._getPageStatesQuery().get();
  }
  _getPageStatesQuery() {
    return this.store.query.records("instance_page_state");
  }
  getCurrentPageState() {
    return this.store.get(this._getCurrentPageStateId());
  }
  _getCurrentPageStateId() {
    return ar.createId(this.getCurrentPageId());
  }
  /**
   * Update this instance's page state.
   *
   * @example
   * ```ts
   * editor.updateCurrentPageState({ id: 'page1', editingShapeId: 'shape:123' })
   * ```
   *
   * @param partial - The partial of the page state object containing the changes.
   *
   * @public
   */
  updateCurrentPageState(e) {
    return this._updateCurrentPageState(e), this;
  }
  _updateCurrentPageState(e) {
    this.store.update(e.id ?? this.getCurrentPageState().id, (n) => ({
      ...n,
      ...e
    }));
  }
  getSelectedShapeIds() {
    return this.getCurrentPageState().selectedShapeIds;
  }
  getSelectedShapes() {
    const { selectedShapeIds: e } = this.getCurrentPageState();
    return Ze(e.map((n) => this.store.get(n)));
  }
  /**
   * Select one or more shapes.
   *
   * @example
   * ```ts
   * editor.setSelectedShapes(['id1'])
   * editor.setSelectedShapes(['id1', 'id2'])
   * ```
   *
   * @param shapes - The shape (or shape ids) to select.
   *
   * @public
   */
  setSelectedShapes(e) {
    return this.run(
      () => {
        const n = e.map((s) => typeof s == "string" ? s : s.id), { selectedShapeIds: i } = this.getCurrentPageState(), r = new Set(i);
        if (n.length === r.size && n.every((s) => r.has(s))) return null;
        this.store.put([{ ...this.getCurrentPageState(), selectedShapeIds: n }]);
      },
      { history: "record-preserveRedoStack" }
    );
  }
  /**
   * Determine whether or not any of a shape's ancestors are selected.
   *
   * @param shape - The shape (or shape id) of the shape to check.
   *
   * @public
   */
  isAncestorSelected(e) {
    const n = typeof e == "string" ? e : (e == null ? void 0 : e.id) ?? null, i = this.getShape(n);
    if (!i) return !1;
    const r = this.getSelectedShapeIds();
    return !!this.findShapeAncestor(i, (s) => r.includes(s.id));
  }
  /**
   * Select one or more shapes.
   *
   * @example
   * ```ts
   * editor.select('id1')
   * editor.select('id1', 'id2')
   * ```
   *
   * @param shapes - The shape (or the shape ids) to select.
   *
   * @public
   */
  select(...e) {
    const n = typeof e[0] == "string" ? e : e.map((i) => i.id);
    return this.setSelectedShapes(n), this;
  }
  /**
   * Remove a shape from the existing set of selected shapes.
   *
   * @example
   * ```ts
   * editor.deselect(shape.id)
   * ```
   *
   * @public
   */
  deselect(...e) {
    const n = typeof e[0] == "string" ? e : e.map((r) => r.id), i = this.getSelectedShapeIds();
    return i.length > 0 && n.length > 0 && this.setSelectedShapes(i.filter((r) => !n.includes(r))), this;
  }
  /**
   * Select all direct children of the current page.
   *
   * @example
   * ```ts
   * editor.selectAll()
   * ```
   *
   * @public
   */
  selectAll() {
    const e = this.getSortedChildIdsForParent(this.getCurrentPageId());
    return e.length <= 0 ? this : (this.setSelectedShapes(this._getUnlockedShapeIds(e)), this);
  }
  /**
   * Clear the selection.
   *
   * @example
   * ```ts
   * editor.selectNone()
   * ```
   *
   * @public
   */
  selectNone() {
    return this.getSelectedShapeIds().length > 0 && this.setSelectedShapes([]), this;
  }
  getOnlySelectedShapeId() {
    var e;
    return ((e = this.getOnlySelectedShape()) == null ? void 0 : e.id) ?? null;
  }
  getOnlySelectedShape() {
    const e = this.getSelectedShapes();
    return e.length === 1 ? e[0] : null;
  }
  /**
   * @internal
   */
  getShapesPageBounds(e) {
    const n = Ze(e.map((i) => this.getShapePageBounds(i)));
    return n.length === 0 ? null : ae.Common(n);
  }
  getSelectionPageBounds() {
    return this.getShapesPageBounds(this.getSelectedShapeIds());
  }
  /**
   * @internal
   */
  getShapesSharedRotation(e) {
    let n = !1, i = 0;
    for (let r = 0, s = e.length; r < s; r++) {
      const o = this.getShapePageTransform(e[r]);
      if (o)
        if (n) {
          if (o.rotation() !== i)
            return 0;
        } else
          n = !0, i = o.rotation();
    }
    return i;
  }
  getSelectionRotation() {
    return this.getShapesSharedRotation(this.getSelectedShapeIds());
  }
  /**
   * @internal
   */
  getShapesRotatedPageBounds(e) {
    if (e.length === 0)
      return;
    const n = this.getShapesSharedRotation(e);
    if (n === 0)
      return this.getShapesPageBounds(e) ?? void 0;
    if (e.length === 1) {
      const r = this.getShapeGeometry(e[0]).bounds.clone(), s = this.getShapePageTransform(e[0]);
      return r.point = s.applyToPoint(r.point), r;
    }
    const i = ae.FromPoints(
      e.flatMap((r) => {
        const s = this.getShapePageTransform(r);
        return s ? s.applyToPoints(this.getShapeGeometry(r).bounds.corners) : [];
      }).map((r) => r.rot(-n))
    );
    return i.point = i.point.rot(n), i;
  }
  getSelectionRotatedPageBounds() {
    return this.getShapesRotatedPageBounds(this.getSelectedShapeIds());
  }
  getSelectionRotatedScreenBounds() {
    const e = this.getSelectionRotatedPageBounds();
    if (!e) return;
    const { x: n, y: i } = this.pageToScreen(e.point), r = this.getZoomLevel();
    return new ae(n, i, e.width * r, e.height * r);
  }
  getFocusedGroupId() {
    return this.getCurrentPageState().focusedGroupId ?? this.getCurrentPageId();
  }
  getFocusedGroup() {
    const e = this.getFocusedGroupId();
    return e ? this.getShape(e) : void 0;
  }
  /**
   * Set the current focused group shape.
   *
   * @param shape - The group shape id (or group shape's id) to set as the focused group shape.
   *
   * @public
   */
  setFocusedGroup(e) {
    const n = typeof e == "string" ? e : (e == null ? void 0 : e.id) ?? null;
    if (n !== null) {
      const i = this.getShape(n);
      if (!i)
        throw Error(`Editor.setFocusedGroup: Shape with id ${n} does not exist`);
      if (!this.isShapeOfType(i, "group"))
        throw Error(
          `Editor.setFocusedGroup: Cannot set focused group to shape of type ${i.type}`
        );
    }
    return n === this.getFocusedGroupId() ? this : this.run(
      () => {
        this.store.update(this.getCurrentPageState().id, (i) => ({ ...i, focusedGroupId: n }));
      },
      { history: "record-preserveRedoStack" }
    );
  }
  /**
   * Exit the current focused group, moving up to the next parent group if there is one.
   *
   * @public
   */
  popFocusedGroupId() {
    const e = this.getFocusedGroup();
    if (e) {
      const n = this.findShapeAncestor(
        e,
        (i) => this.isShapeOfType(i, "group")
      );
      this.setFocusedGroup((n == null ? void 0 : n.id) ?? null), this.select(e.id);
    } else
      this.setFocusedGroup(null), this.selectNone();
    return this;
  }
  getEditingShapeId() {
    return this.getCurrentPageState().editingShapeId;
  }
  getEditingShape() {
    const e = this.getEditingShapeId();
    return e ? this.getShape(e) : void 0;
  }
  /**
   * Set the current editing shape.
   *
   * @example
   * ```ts
   * editor.setEditingShape(myShape)
   * editor.setEditingShape(myShape.id)
   * ```
   *
   * @param shape - The shape (or shape id) to set as editing.
   *
   * @public
   */
  setEditingShape(e) {
    const n = typeof e == "string" ? e : (e == null ? void 0 : e.id) ?? null;
    if (n !== this.getEditingShapeId()) {
      if (n) {
        const i = this.getShape(n);
        if (i && this.getShapeUtil(i).canEdit(i))
          return this.run(
            () => {
              this._updateCurrentPageState({ editingShapeId: n });
            },
            { history: "ignore" }
          ), this;
      }
      this.run(
        () => {
          this._updateCurrentPageState({ editingShapeId: null });
        },
        { history: "ignore" }
      );
    }
    return this;
  }
  getHoveredShapeId() {
    return this.getCurrentPageState().hoveredShapeId;
  }
  getHoveredShape() {
    const e = this.getHoveredShapeId();
    return e ? this.getShape(e) : void 0;
  }
  /**
   * Set the editor's current hovered shape.
   *
   * @example
   * ```ts
   * editor.setHoveredShape(myShape)
   * editor.setHoveredShape(myShape.id)
   * ```
   *
   * @param shape - The shape (or shape id) to set as hovered.
   *
   * @public
   */
  setHoveredShape(e) {
    const n = typeof e == "string" ? e : (e == null ? void 0 : e.id) ?? null;
    return n === this.getHoveredShapeId() ? this : (this.run(
      () => {
        this.updateCurrentPageState({ hoveredShapeId: n });
      },
      { history: "ignore" }
    ), this);
  }
  getHintingShapeIds() {
    return this.getCurrentPageState().hintingShapeIds;
  }
  getHintingShape() {
    const e = this.getHintingShapeIds();
    return Ze(e.map((n) => this.getShape(n)));
  }
  /**
   * Set the editor's current hinting shapes.
   *
   * @example
   * ```ts
   * editor.setHintingShapes([myShape])
   * editor.setHintingShapes([myShape.id])
   * ```
   *
   * @param shapes - The shapes (or shape ids) to set as hinting.
   *
   * @public
   */
  setHintingShapes(e) {
    const n = typeof e[0] == "string" ? e : e.map((i) => i.id);
    return this.run(
      () => {
        this._updateCurrentPageState({ hintingShapeIds: ax(n) });
      },
      { history: "ignore" }
    ), this;
  }
  getErasingShapeIds() {
    return this.getCurrentPageState().erasingShapeIds;
  }
  getErasingShapes() {
    const e = this.getErasingShapeIds();
    return Ze(e.map((n) => this.getShape(n)));
  }
  /**
   * Set the editor's current erasing shapes.
   *
   * @example
   * ```ts
   * editor.setErasingShapes([myShape])
   * editor.setErasingShapes([myShape.id])
   * ```
   *
   * @param shapes - The shapes (or shape ids) to set as hinting.
   *
   * @public
   */
  setErasingShapes(e) {
    const n = typeof e[0] == "string" ? e : e.map((r) => r.id);
    n.sort();
    const i = this.getErasingShapeIds();
    return this.run(
      () => {
        if (n.length === i.length) {
          for (let r = 0; r < n.length; r++)
            if (n[r] !== i[r]) {
              this._updateCurrentPageState({ erasingShapeIds: n });
              break;
            }
        } else
          this._updateCurrentPageState({ erasingShapeIds: n });
      },
      { history: "ignore" }
    ), this;
  }
  // Cropping
  /**
   * The current cropping shape's id.
   *
   * @public
   */
  getCroppingShapeId() {
    return this.getCurrentPageState().croppingShapeId;
  }
  /**
   * Set the current cropping shape.
   *
   * @example
   * ```ts
   * editor.setCroppingShape(myShape)
   * editor.setCroppingShape(myShape.id)
   * ```
   *
   *
   * @param shape - The shape (or shape id) to set as cropping.
   *
   * @public
   */
  setCroppingShape(e) {
    const n = typeof e == "string" ? e : (e == null ? void 0 : e.id) ?? null;
    return n !== this.getCroppingShapeId() && this.run(
      () => {
        if (!n)
          this.updateCurrentPageState({ croppingShapeId: null });
        else {
          const i = this.getShape(n), r = this.getShapeUtil(i);
          i && r.canCrop(i) && this.updateCurrentPageState({ croppingShapeId: n });
        }
      },
      { history: "ignore" }
    ), this;
  }
  _unsafe_getCameraId() {
    return kr.createId(this.getCurrentPageId());
  }
  getCamera() {
    const e = this.store.get(this._unsafe_getCameraId());
    if (this._isLockedOnFollowingUser.get()) {
      const n = this.getCameraForFollowing();
      if (n)
        return { ...e, ...n };
    }
    return e;
  }
  getViewportPageBoundsForFollowing() {
    const e = this.getInstanceState().followingUserId;
    if (!e) return null;
    const n = this.getCollaborators().find((h) => h.userId === e);
    if (!n) return null;
    const { w: i, h: r } = n.screenBounds, { x: s, y: o, z: a } = n.camera, c = new ae(-s, -o, i / a, r / a), d = this.getViewportScreenBounds().clone(), u = d.width / d.height;
    return d.width = c.width, d.height = d.width / u, d.height < c.height && (d.height = c.height, d.width = d.height * u), d.center = c.center, d;
  }
  getCameraForFollowing() {
    const e = this.getViewportPageBoundsForFollowing();
    return e ? {
      x: -e.x,
      y: -e.y,
      z: this.getViewportScreenBounds().w / e.width
    } : null;
  }
  getZoomLevel() {
    return this.getCamera().z;
  }
  /**
   * Get the camera's initial or reset zoom level.
   *
   * @example
   * ```ts
   * editor.getInitialZoom()
   * ```
   *
   * @public */
  getInitialZoom() {
    const e = this.getCameraOptions();
    if (!e.constraints || e.constraints.initialZoom === "default") return 1;
    const { zx: n, zy: i } = pw(this, e);
    switch (e.constraints.initialZoom) {
      case "fit-min":
        return Math.max(n, i);
      case "fit-max":
        return Math.min(n, i);
      case "fit-x":
        return n;
      case "fit-y":
        return i;
      case "fit-min-100":
        return Math.min(1, Math.max(n, i));
      case "fit-max-100":
        return Math.min(1, Math.min(n, i));
      case "fit-x-100":
        return Math.min(1, n);
      case "fit-y-100":
        return Math.min(1, i);
      default:
        throw rn(e.constraints.initialZoom);
    }
  }
  /**
   * Get the camera's base level for calculating actual zoom levels based on the zoom steps.
   *
   * @example
   * ```ts
   * editor.getBaseZoom()
   * ```
   *
   * @public */
  getBaseZoom() {
    const e = this.getCameraOptions();
    if (!e.constraints || e.constraints.baseZoom === "default") return 1;
    const { zx: n, zy: i } = pw(this, e);
    switch (e.constraints.baseZoom) {
      case "fit-min":
        return Math.max(n, i);
      case "fit-max":
        return Math.min(n, i);
      case "fit-x":
        return n;
      case "fit-y":
        return i;
      case "fit-min-100":
        return Math.min(1, Math.max(n, i));
      case "fit-max-100":
        return Math.min(1, Math.min(n, i));
      case "fit-x-100":
        return Math.min(1, n);
      case "fit-y-100":
        return Math.min(1, i);
      default:
        throw rn(e.constraints.baseZoom);
    }
  }
  /**
   * Get the current camera options.
   *
   * @example
   * ```ts
   * editor.getCameraOptions()
   * ```
   *
   *  @public */
  getCameraOptions() {
    return this._cameraOptions.get();
  }
  /**
   * Set the camera options. Changing the options won't immediately change the camera itself, so you may want to call `setCamera` after changing the options.
   *
   * @example
   * ```ts
   * editor.setCameraOptions(myCameraOptions)
   * editor.setCamera(editor.getCamera())
   * ```
   *
   * @param opts - The camera options to set.
   *
   * @public */
  setCameraOptions(e) {
    var i;
    const n = Ct({
      ...this._cameraOptions.__unsafe__getWithoutCapture(),
      ...e
    });
    return ((i = n.zoomSteps) == null ? void 0 : i.length) < 1 && (n.zoomSteps = [1]), this._cameraOptions.set(n), this.setCamera(this.getCamera()), this;
  }
  /** @internal */
  getConstrainedCamera(e, n) {
    const i = this.getCamera();
    let { x: r, y: s, z: o = i.z } = e;
    if (!(n != null && n.force)) {
      const a = this.getCameraOptions(), c = a.zoomSteps[0], d = pn(a.zoomSteps), u = this.getViewportScreenBounds();
      if (a.constraints) {
        const { constraints: h } = a, g = Math.min(h.padding.y, u.w / 2), p = Math.min(h.padding.x, u.h / 2), f = ae.From(a.constraints.bounds), M = (u.w - p * 2) / f.w, m = (u.h - g * 2) / f.h, y = this.getBaseZoom(), I = d * y, D = c * y;
        if (n != null && n.reset && (o = this.getInitialZoom()), o < D || o > I) {
          const { x: C, y: z, z: O } = i, R = -C + u.w / O / 2, U = -z + u.h / O / 2;
          o = hn(o, D, I);
          const F = -C + u.w / o / 2, H = -z + u.h / o / 2;
          r = C + F - R, s = z + H - U;
        }
        const j = p / o - f.x, w = g / o - f.y, A = (u.w - p * 2) / o - f.w, b = (u.h - g * 2) / o - f.h, T = j + A * h.origin.x, E = w + b * h.origin.y, v = typeof h.behavior == "string" ? h.behavior : h.behavior.x, P = typeof h.behavior == "string" ? h.behavior : h.behavior.y;
        if (n != null && n.reset)
          r = T, s = E;
        else {
          switch (v) {
            case "fixed": {
              r = T;
              break;
            }
            case "contain": {
              o < M ? r = T : r = hn(r, j + A, j);
              break;
            }
            case "inside": {
              o < M ? r = hn(r, j, (u.w - p) / o - f.w) : r = hn(r, j + A, j);
              break;
            }
            case "outside": {
              r = hn(r, p / o - f.w, (u.w - p) / o);
              break;
            }
            case "free":
              break;
            default:
              throw rn(v);
          }
          switch (P) {
            case "fixed": {
              s = E;
              break;
            }
            case "contain": {
              o < m ? s = E : s = hn(s, w + b, w);
              break;
            }
            case "inside": {
              o < m ? s = hn(s, w, (u.h - g) / o - f.h) : s = hn(s, w + b, w);
              break;
            }
            case "outside": {
              s = hn(s, g / o - f.h, (u.h - g) / o);
              break;
            }
            case "free":
              break;
            default:
              throw rn(P);
          }
        }
      } else if (o > d || o < c) {
        const { x: h, y: g, z: p } = i;
        o = hn(o, c, d), r = h + (-h + u.w / o / 2) - (-h + u.w / p / 2), s = g + (-g + u.h / o / 2) - (-g + u.h / p / 2);
      }
    }
    return { x: r, y: s, z: o };
  }
  /** @internal */
  _setCamera(e, n) {
    const i = this.getCamera(), { x: r, y: s, z: o } = this.getConstrainedCamera(e, n);
    return i.x === r && i.y === s && i.z === o ? this : (Qr(() => {
      const a = { ...i, x: r, y: s, z: o };
      this.run(
        () => {
          this.store.put([a]);
        },
        { history: "ignore" }
      );
      const { currentScreenPoint: c, currentPagePoint: d } = this.inputs, { screenBounds: u } = this.store.unsafeGetWithoutCapture(Qn);
      if (c.x / o - r !== d.x || c.y / o - s !== d.y) {
        const h = {
          type: "pointer",
          target: "canvas",
          name: "pointer_move",
          // weird but true: we need to put the screen point back into client space
          point: x.AddXY(c, u.x, u.y),
          pointerId: L0.CAMERA_MOVE,
          ctrlKey: this.inputs.ctrlKey,
          altKey: this.inputs.altKey,
          shiftKey: this.inputs.shiftKey,
          metaKey: this.inputs.metaKey,
          accelKey: bn(this.inputs),
          button: 0,
          isPen: this.getInstanceState().isPenMode ?? !1
        };
        n != null && n.immediate ? this._flushEventForTick(h) : this.dispatch(h);
      }
      this._tickCameraState();
    }), this);
  }
  /**
   * Set the current camera.
   *
   * @example
   * ```ts
   * editor.setCamera({ x: 0, y: 0})
   * editor.setCamera({ x: 0, y: 0, z: 1.5})
   * editor.setCamera({ x: 0, y: 0, z: 1.5}, { animation: { duration: 1000, easing: (t) => t * t } })
   * ```
   *
   * @param point - The new camera position.
   * @param opts - The camera move options.
   *
   * @public
   */
  setCamera(e, n) {
    const { isLocked: i } = this._cameraOptions.__unsafe__getWithoutCapture();
    if (i && !(n != null && n.force)) return this;
    this.stopCameraAnimation(), this.getInstanceState().followingUserId && this.stopFollowingUser();
    const r = x.Cast(e);
    Number.isFinite(r.x) || (r.x = 0), Number.isFinite(r.y) || (r.y = 0), (r.z === void 0 || !Number.isFinite(r.z)) && (e.z = this.getZoomLevel());
    const s = this.getConstrainedCamera(r, n);
    if (n != null && n.animation) {
      const { width: o, height: a } = this.getViewportScreenBounds();
      this._animateToViewport(
        new ae(-s.x, -s.y, o / s.z, a / s.z),
        n
      );
    } else
      this._setCamera(s, {
        ...n,
        // we already did the constraining, so we don't need to do it again
        force: !0
      });
    return this;
  }
  /**
   * Center the camera on a point (in the current page space).
   *
   * @example
   * ```ts
   * editor.centerOnPoint({ x: 100, y: 100 })
   * editor.centerOnPoint({ x: 100, y: 100 }, { animation: { duration: 200 } })
   * ```
   *
   * @param point - The point in the current page space to center on.
   * @param opts - The camera move options.
   *
   * @public
   */
  centerOnPoint(e, n) {
    const { isLocked: i } = this.getCameraOptions();
    if (i && !(n != null && n.force)) return this;
    const { width: r, height: s } = this.getViewportPageBounds();
    return this.setCamera(new x(-(e.x - r / 2), -(e.y - s / 2), this.getCamera().z), n), this;
  }
  /**
   * Zoom the camera to fit the current page's content in the viewport.
   *
   * @example
   * ```ts
   * editor.zoomToFit()
   * editor.zoomToFit({ animation: { duration: 200 } })
   * ```
   *
   * @param opts - The camera move options.
   *
   * @public
   */
  zoomToFit(e) {
    const n = [...this.getCurrentPageShapeIds()];
    if (n.length <= 0) return this;
    const i = ae.Common(Ze(n.map((r) => this.getShapePageBounds(r))));
    return this.zoomToBounds(i, e), this;
  }
  /**
   * Set the zoom back to 100%.
   *
   * @example
   * ```ts
   * editor.resetZoom()
   * editor.resetZoom(editor.getViewportScreenCenter(), { animation: { duration: 200 } })
   * editor.resetZoom(editor.getViewportScreenCenter(), { animation: { duration: 200 } })
   * ```
   *
   * @param point - The screen point to zoom out on. Defaults to the viewport screen center.
   * @param opts - The camera move options.
   *
   * @public
   */
  resetZoom(e = this.getViewportScreenCenter(), n) {
    const { isLocked: i, constraints: r } = this.getCameraOptions();
    if (i && !(n != null && n.force)) return this;
    const s = this.getCamera(), { x: o, y: a, z: c } = s, { x: d, y: u } = e;
    let h = 1;
    if (r) {
      const g = this.getInitialZoom();
      c !== g && (h = g);
    }
    return this.setCamera(
      new x(o + (d / h - d) - (d / c - d), a + (u / h - u) - (u / c - u), h),
      n
    ), this;
  }
  /**
   * Zoom the camera in.
   *
   * @example
   * ```ts
   * editor.zoomIn()
   * editor.zoomIn(editor.getViewportScreenCenter(), { animation: { duration: 200 } })
   * editor.zoomIn(editor.inputs.currentScreenPoint, { animation: { duration: 200 } })
   * ```
   *
   * @param point - The screen point to zoom in on. Defaults to the screen center
   * @param opts - The camera move options.
   *
   * @public
   */
  zoomIn(e = this.getViewportScreenCenter(), n) {
    const { isLocked: i } = this.getCameraOptions();
    if (i && !(n != null && n.force)) return this;
    const { x: r, y: s, z: o } = this.getCamera(), { zoomSteps: a } = this.getCameraOptions();
    if (a !== null && a.length > 1) {
      const c = this.getBaseZoom();
      let d = pn(a) * c;
      for (let u = 1; u < a.length; u++) {
        const h = a[u - 1] * c, g = a[u] * c;
        if (!(g - o <= (g - h) / 2)) {
          d = g;
          break;
        }
      }
      this.setCamera(
        new x(
          r + (e.x / d - e.x) - (e.x / o - e.x),
          s + (e.y / d - e.y) - (e.y / o - e.y),
          d
        ),
        n
      );
    }
    return this;
  }
  /**
   * Zoom the camera out.
   *
   * @example
   * ```ts
   * editor.zoomOut()
   * editor.zoomOut(editor.getViewportScreenCenter(), { animation: { duration: 120 } })
   * editor.zoomOut(editor.inputs.currentScreenPoint, { animation: { duration: 120 } })
   * ```
   *
   * @param point - The point to zoom out on. Defaults to the viewport screen center.
   * @param opts - The camera move options.
   *
   * @public
   */
  zoomOut(e = this.getViewportScreenCenter(), n) {
    const { isLocked: i } = this.getCameraOptions();
    if (i && !(n != null && n.force)) return this;
    const { zoomSteps: r } = this.getCameraOptions();
    if (r !== null && r.length > 1) {
      const s = this.getBaseZoom(), { x: o, y: a, z: c } = this.getCamera();
      let d = r[0] * s;
      for (let u = r.length - 1; u > 0; u--) {
        const h = r[u - 1] * s, g = r[u] * s;
        if (!(g - c >= (g - h) / 2)) {
          d = h;
          break;
        }
      }
      this.setCamera(
        new x(
          o + (e.x / d - e.x) - (e.x / c - e.x),
          a + (e.y / d - e.y) - (e.y / c - e.y),
          d
        ),
        n
      );
    }
    return this;
  }
  /**
   * Zoom the camera to fit the current selection in the viewport.
   *
   * @example
   * ```ts
   * editor.zoomToSelection()
   * editor.zoomToSelection({ animation: { duration: 200 } })
   * ```
   *
   * @param opts - The camera move options.
   *
   * @public
   */
  zoomToSelection(e) {
    const { isLocked: n } = this.getCameraOptions();
    if (n && !(e != null && e.force)) return this;
    const i = this.getSelectionPageBounds();
    return i && this.zoomToBounds(i, {
      targetZoom: Math.max(1, this.getZoomLevel()),
      ...e
    }), this;
  }
  /**
   * Zoom the camera to fit a bounding box (in the current page space).
   *
   * @example
   * ```ts
   * editor.zoomToBounds(myBounds)
   * editor.zoomToBounds(myBounds, { animation: { duration: 200 } })
   * editor.zoomToBounds(myBounds, { animation: { duration: 200 }, inset: 0, targetZoom: 1 })
   * ```
   *
   * @param bounds - The bounding box.
   * @param opts - The camera move options, target zoom, or custom inset amount.
   *
   * @public
   */
  zoomToBounds(e, n) {
    const i = this._cameraOptions.__unsafe__getWithoutCapture();
    if (i.isLocked && !(n != null && n.force)) return this;
    const r = this.getViewportScreenBounds(), s = (n == null ? void 0 : n.inset) ?? Math.min(HW, r.width * 0.28), o = this.getBaseZoom(), a = i.zoomSteps[0], c = pn(i.zoomSteps);
    let d = hn(
      Math.min(
        (r.width - s) / e.w,
        (r.height - s) / e.h
      ),
      a * o,
      c * o
    );
    return (n == null ? void 0 : n.targetZoom) !== void 0 && (d = Math.min(n.targetZoom, d)), this.setCamera(
      new x(
        -e.x + (r.width - e.w * d) / 2 / d,
        -e.y + (r.height - e.h * d) / 2 / d,
        d
      ),
      n
    ), this;
  }
  /**
   * Stop the current camera animation, if any.
   *
   * @example
   * ```ts
   * editor.stopCameraAnimation()
   * ```
   *
   * @public
   */
  stopCameraAnimation() {
    return this.emit("stop-camera-animation"), this;
  }
  /** @internal */
  _animateViewport(e) {
    if (!this._viewportAnimation) return;
    this._viewportAnimation.elapsed += e;
    const { elapsed: n, easing: i, duration: r, start: s, end: o } = this._viewportAnimation;
    if (n > r) {
      this.off("tick", this._animateViewport), this._viewportAnimation = null, this._setCamera(new x(-o.x, -o.y, this.getViewportScreenBounds().width / o.width));
      return;
    }
    const a = r - n, c = i(1 - a / r), d = s.minX + (o.minX - s.minX) * c, u = s.minY + (o.minY - s.minY) * c, h = s.maxX + (o.maxX - s.maxX) * c;
    this._setCamera(new x(-d, -u, this.getViewportScreenBounds().width / (h - d)), {
      force: !0
    });
  }
  /** @internal */
  _animateToViewport(e, n = { animation: wM }) {
    const { animation: i, ...r } = n;
    if (!i) return;
    const { duration: s = 0, easing: o = on.easeInOutCubic } = i, a = this.user.getAnimationSpeed(), c = this.getViewportPageBounds();
    return this.stopCameraAnimation(), this.getInstanceState().followingUserId && this.stopFollowingUser(), s === 0 || a === 0 ? this._setCamera(
      new x(
        -e.x,
        -e.y,
        this.getViewportScreenBounds().width / e.width
      ),
      { ...r }
    ) : (this._viewportAnimation = {
      elapsed: 0,
      duration: s / a,
      easing: o,
      start: c.clone(),
      end: e.clone()
    }, this.once("stop-camera-animation", () => {
      this.off("tick", this._animateViewport), this._viewportAnimation = null;
    }), this.on("tick", this._animateViewport), this);
  }
  /**
   * Slide the camera in a certain direction.
   *
   * @example
   * ```ts
   * editor.slideCamera({ speed: 1, direction: { x: 1, y: 0 }, friction: 0.1 })
   * ```
   *
   * @param opts - Options for the slide
   * @public
   */
  slideCamera(e = {}) {
    const { isLocked: n } = this.getCameraOptions();
    if (n && !(e != null && e.force)) return this;
    if (this.user.getAnimationSpeed() === 0) return this;
    this.stopCameraAnimation();
    const {
      speed: r,
      friction: s = this.options.cameraSlideFriction,
      direction: o,
      speedThreshold: a = 0.01
    } = e;
    let c = Math.min(r, 1);
    const d = () => {
      this.off("tick", u), this.off("stop-camera-animation", d);
    };
    this.once("stop-camera-animation", d);
    const u = (h) => {
      const { x: g, y: p, z: f } = this.getCamera(), M = x.Mul(o, c * h / f);
      c *= 1 - s, c < a ? d() : this._setCamera(new x(g + M.x, p + M.y, f));
    };
    return this.on("tick", u), this;
  }
  /**
   * Animate the camera to a user's cursor position. This also briefly show the user's cursor if it's not currently visible.
   *
   * @example
   * ```ts
   * editor.zoomToUser(myUserId)
   * editor.zoomToUser(myUserId, { animation: { duration: 200 } })
   * ```
   *
   * @param userId - The id of the user to animate to.
   * @param opts - The camera move options.
   * @public
   */
  zoomToUser(e, n = { animation: { duration: 500 } }) {
    const i = this.getCollaborators().find((r) => r.userId === e);
    return i ? (this.run(() => {
      this.getInstanceState().followingUserId !== null && this.stopFollowingUser();
      const r = i.currentPageId === this.getCurrentPageId();
      r || this.setCurrentPage(i.currentPageId), n && n.animation && !r && (n.animation = void 0), this.centerOnPoint(i.cursor, n);
      const { highlightedUserIds: s } = this.getInstanceState();
      this.updateInstanceState({ highlightedUserIds: [...s, e] }), this.timers.setTimeout(() => {
        const o = [...this.getInstanceState().highlightedUserIds], a = o.indexOf(e);
        a < 0 || (o.splice(a, 1), this.updateInstanceState({ highlightedUserIds: o }));
      }, this.options.collaboratorIdleTimeoutMs);
    }), this) : this;
  }
  /**
   * Update the viewport. The viewport will measure the size and screen position of its container
   * element. This should be done whenever the container's position on the screen changes.
   *
   * @example
   * ```ts
   * editor.updateViewportScreenBounds(new Box(0, 0, 1280, 1024))
   * editor.updateViewportScreenBounds(new Box(0, 0, 1280, 1024), true)
   * ```
   *
   * @param screenBounds - The new screen bounds of the viewport.
   * @param center - Whether to preserve the viewport page center as the viewport changes.
   *
   * @public
   */
  updateViewportScreenBounds(e, n = !1) {
    if (e instanceof HTMLElement) {
      const a = e.getBoundingClientRect();
      e = new ae(
        a.left || a.x,
        a.top || a.y,
        Math.max(a.width, 1),
        Math.max(a.height, 1)
      );
    } else
      e.width = Math.max(e.width, 1), e.height = Math.max(e.height, 1);
    const i = [
      // top
      e.minY !== 0,
      // right
      !Xs(document.body.scrollWidth, e.maxX, 1),
      // bottom
      !Xs(document.body.scrollHeight, e.maxY, 1),
      // left
      e.minX !== 0
    ], { _willSetInitialBounds: r } = this;
    this._willSetInitialBounds = !1;
    const { screenBounds: s, insets: o } = this.getInstanceState();
    if (e.equals(s) && i.every((a, c) => a === o[c]))
      return this;
    if (r)
      this.updateInstanceState({ screenBounds: e.toJson(), insets: i }), this.setCamera(this.getCamera());
    else if (n && !this.getInstanceState().followingUserId) {
      const a = this.getViewportPageBounds().center;
      this.updateInstanceState({ screenBounds: e.toJson(), insets: i }), this.centerOnPoint(a);
    } else
      this.updateInstanceState({ screenBounds: e.toJson(), insets: i }), this._setCamera(x.From({ ...this.getCamera() }));
    return this._tickCameraState(), this;
  }
  getViewportScreenBounds() {
    const { x: e, y: n, w: i, h: r } = this.getInstanceState().screenBounds;
    return new ae(e, n, i, r);
  }
  getViewportScreenCenter() {
    const e = this.getViewportScreenBounds();
    return new x(
      e.midX - e.minX,
      e.midY - e.minY
    );
  }
  getViewportPageBounds() {
    const { w: e, h: n } = this.getViewportScreenBounds(), { x: i, y: r, z: s } = this.getCamera();
    return new ae(-i, -r, e / s, n / s);
  }
  /**
   * Convert a point in screen space to a point in the current page space.
   *
   * @example
   * ```ts
   * editor.screenToPage({ x: 100, y: 100 })
   * ```
   *
   * @param point - The point in screen space.
   *
   * @public
   */
  screenToPage(e) {
    const { screenBounds: n } = this.store.unsafeGetWithoutCapture(Qn), { x: i, y: r, z: s = 1 } = this.getCamera();
    return new x(
      (e.x - n.x) / s - i,
      (e.y - n.y) / s - r,
      e.z ?? 0.5
    );
  }
  /**
   * Convert a point in the current page space to a point in current screen space.
   *
   * @example
   * ```ts
   * editor.pageToScreen({ x: 100, y: 100 })
   * ```
   *
   * @param point - The point in page space.
   *
   * @public
   */
  pageToScreen(e) {
    const { screenBounds: n } = this.store.unsafeGetWithoutCapture(Qn), { x: i, y: r, z: s = 1 } = this.getCamera();
    return new x(
      (e.x + i) * s + n.x,
      (e.y + r) * s + n.y,
      e.z ?? 0.5
    );
  }
  /**
   * Convert a point in the current page space to a point in current viewport space.
   *
   * @example
   * ```ts
   * editor.pageToViewport({ x: 100, y: 100 })
   * ```
   *
   * @param point - The point in page space.
   *
   * @public
   */
  pageToViewport(e) {
    const { x: n, y: i, z: r = 1 } = this.getCamera();
    return new x((e.x + n) * r, (e.y + i) * r, e.z ?? 0.5);
  }
  _getCollaboratorsQuery() {
    return this.store.query.records("instance_presence", () => ({
      userId: { neq: this.user.getId() }
    }));
  }
  getCollaborators() {
    const e = this._getCollaboratorsQuery().get();
    return e.length ? [...new Set(e.map((i) => i.userId))].sort().map((i) => e.filter((s) => s.userId === i).sort((s, o) => o.lastActivityTimestamp - s.lastActivityTimestamp)[0]) : hs;
  }
  getCollaboratorsOnCurrentPage() {
    const e = this.getCurrentPageId();
    return this.getCollaborators().filter((n) => n.currentPageId === e);
  }
  /**
   * Start viewport-following a user.
   *
   * @example
   * ```ts
   * editor.startFollowingUser(myUserId)
   * ```
   *
   * @param userId - The id of the user to follow.
   *
   * @public
   */
  startFollowingUser(e) {
    this.stopFollowingUser();
    const n = this._getCollaboratorsQuery().get().filter((s) => s.userId === e);
    if (!n.length)
      return console.warn("User not found"), this;
    const i = this.user.getId();
    if (i || console.warn("You should set the userId for the current instance before following a user"), n.some((s) => s.followingUserId === i))
      return this;
    const r = K("latestLeaderPresence", () => this.getCollaborators().find((s) => s.userId === e));
    return Qr(() => {
      this.updateInstanceState({ followingUserId: e }, { history: "ignore" });
      const s = Yr("update current page", () => {
        const c = r.get();
        if (!c) {
          this.stopFollowingUser();
          return;
        }
        c.currentPageId !== this.getCurrentPageId() && this.getPage(c.currentPageId) && this.run(
          () => {
            this.store.put([
              { ...this.getInstanceState(), currentPageId: c.currentPageId }
            ]), this._isLockedOnFollowingUser.set(!0);
          },
          { history: "ignore" }
        );
      }), o = () => {
        s(), this._isLockedOnFollowingUser.set(!1), this.off("frame", a), this.off("stop-following", o);
      }, a = () => {
        if (!r.get()) {
          this.stopFollowingUser();
          return;
        }
        if (this._isLockedOnFollowingUser.get()) return;
        const d = this.user.getAnimationSpeed();
        if (d === 0) {
          this._isLockedOnFollowingUser.set(!0);
          return;
        }
        const u = this.getViewportPageBoundsForFollowing();
        if (!u) {
          this.stopFollowingUser();
          return;
        }
        const h = this.getViewportPageBounds(), g = Math.abs(u.minX - h.minX) + Math.abs(u.maxX - h.maxX), p = Math.abs(u.minY - h.minY) + Math.abs(u.maxY - h.maxY);
        if (g < this.options.followChaseViewportSnap && p < this.options.followChaseViewportSnap) {
          this._isLockedOnFollowingUser.set(!0);
          return;
        }
        const f = hn(d * 0.5, 0.1, 0.8), M = new ae(
          et(h.minX, u.minX, f),
          et(h.minY, u.minY, f),
          et(h.width, u.width, f),
          et(h.height, u.height, f)
        ), m = new x(
          -M.x,
          -M.y,
          this.getViewportScreenBounds().width / M.width
        );
        this.stopCameraAnimation(), this._setCamera(m);
      };
      this.once("stop-following", o), this.addListener("frame", a), a();
    }), this;
  }
  /**
   * Stop viewport-following a user.
   *
   * @example
   * ```ts
   * editor.stopFollowingUser()
   * ```
   * @public
   */
  stopFollowingUser() {
    return this.run(
      () => {
        this.store.put([this.getCamera()]), this._isLockedOnFollowingUser.set(!1), this.updateInstanceState({ followingUserId: null }), this.emit("stop-following");
      },
      { history: "ignore" }
    ), this;
  }
  /** @internal */
  getUnorderedRenderingShapes(e) {
    const n = [];
    let i = this.options.maxShapesPerPage * 2, r = this.options.maxShapesPerPage;
    const s = this.getErasingShapeIds(), o = (c, d, u) => {
      const h = this.getShape(c);
      if (!h || this.isShapeHidden(h)) return;
      d *= h.opacity;
      let g = !1;
      const p = this.getShapeUtil(h);
      e && (g = !u && s.includes(c), g && (d *= 0.32)), n.push({
        id: c,
        shape: h,
        util: p,
        index: i,
        backgroundIndex: r,
        opacity: d
      }), i += 1, r += 1;
      const f = this.getSortedChildIdsForParent(c);
      if (!f.length) return;
      let M = null;
      p.providesBackgroundForChildren(h) && (M = r, r = i, i += this.options.maxShapesPerPage);
      for (const m of f)
        o(m, d, u || g);
      M !== null && (r = M);
    }, a = e ? [this.getCurrentPage()] : this.getPages();
    for (const c of a)
      for (const d of this.getSortedChildIdsForParent(c.id))
        o(d, 1, !1);
    return n;
  }
  _decayCameraStateTimeout(e) {
    this._cameraStateTimeoutRemaining -= e, !(this._cameraStateTimeoutRemaining > 0) && (this.off("tick", this._decayCameraStateTimeout), this._cameraState.set("idle"));
  }
  _tickCameraState() {
    this._cameraStateTimeoutRemaining = this.options.cameraMovingTimeoutMs, this._cameraState.__unsafe__getWithoutCapture() === "idle" && (this._cameraState.set("moving"), this.on("tick", this._decayCameraStateTimeout));
  }
  /**
   * Whether the camera is moving or idle.
   *
   * @example
   * ```ts
   * editor.getCameraState()
   * ```
   *
   * @public
   */
  getCameraState() {
    return this._cameraState.get();
  }
  getRenderingShapes() {
    return this.getUnorderedRenderingShapes(!0).sort(KU);
  }
  _getAllPagesQuery() {
    return this.store.query.records("page");
  }
  getPages() {
    return this._getAllPagesQuery().get().sort(Jt);
  }
  /**
   * The current page.
   *
   * @example
   * ```ts
   * editor.getCurrentPage()
   * ```
   *
   * @public
   */
  getCurrentPage() {
    return this.getPage(this.getCurrentPageId());
  }
  getCurrentPageId() {
    return this.getInstanceState().currentPageId;
  }
  /**
   * Get a page.
   *
   * @example
   * ```ts
   * editor.getPage(myPage.id)
   * editor.getPage(myPage)
   * ```
   *
   * @param page - The page (or the page id) to get.
   *
   * @public
   */
  getPage(e) {
    return this.store.get(typeof e == "string" ? e : e.id);
  }
  /**
   * An array of all of the shapes on the current page.
   *
   * @example
   * ```ts
   * editor.getCurrentPageIds()
   * ```
   *
   * @public
   */
  getCurrentPageShapeIds() {
    return this._currentPageShapeIds.get();
  }
  getCurrentPageShapeIdsSorted() {
    return Array.from(this.getCurrentPageShapeIds()).sort();
  }
  /**
   * Get the ids of shapes on a page.
   *
   * @example
   * ```ts
   * const idsOnPage1 = editor.getPageShapeIds('page1')
   * const idsOnPage2 = editor.getPageShapeIds(myPage2)
   * ```
   *
   * @param page - The page (or the page id) to get the shape ids for.
   *
   * @public
   **/
  getPageShapeIds(e) {
    const n = typeof e == "string" ? e : e.id, i = this.store.query.exec("shape", { parentId: { eq: n } });
    return this.getShapeAndDescendantIds(i.map((r) => r.id));
  }
  /**
   * Set the current page.
   *
   * @example
   * ```ts
   * editor.setCurrentPage('page1')
   * editor.setCurrentPage(myPage1)
   * ```
   *
   * @param page - The page (or the page id) to set as the current page.
   *
   * @public
   */
  setCurrentPage(e) {
    const n = typeof e == "string" ? e : e.id;
    return this.store.has(n) ? (this.stopFollowingUser(), this.complete(), this.run(
      () => {
        this.store.put([{ ...this.getInstanceState(), currentPageId: n }]), this.setCamera(this.getCamera());
      },
      { history: "record-preserveRedoStack" }
    )) : (console.error("Tried to set the current page id to a page that doesn't exist."), this);
  }
  /**
   * Update a page.
   *
   * @example
   * ```ts
   * editor.updatePage({ id: 'page2', name: 'Page 2' })
   * ```
   *
   * @param partial - The partial of the shape to update.
   *
   * @public
   */
  updatePage(e) {
    return this.getIsReadonly() ? this : this.getPage(e.id) ? this.run(() => this.store.update(e.id, (i) => ({ ...i, ...e }))) : this;
  }
  /**
   * Create a page.
   *
   * @example
   * ```ts
   * editor.createPage(myPage)
   * editor.createPage({ name: 'Page 2' })
   * ```
   *
   * @param page - The page (or page partial) to create.
   *
   * @public
   */
  createPage(e) {
    return this.run(() => {
      if (this.getIsReadonly() || this.getPages().length >= this.options.maxPages) return;
      const n = this.getPages(), i = S8(
        e.name ?? "Page 1",
        n.map((o) => o.name)
      );
      let r = e.index;
      (!r || n.some((o) => o.index === r)) && (r = hi(n[n.length - 1].index));
      const s = kn.create({
        meta: {},
        ...e,
        name: i,
        index: r
      });
      this.store.put([s]);
    }), this;
  }
  /**
   * Delete a page.
   *
   * @example
   * ```ts
   * editor.deletePage('page1')
   * ```
   *
   * @param page - The page (or the page id) to delete.
   *
   * @public
   */
  deletePage(e) {
    const n = typeof e == "string" ? e : e.id;
    return this.run(() => {
      if (this.getIsReadonly()) return;
      const i = this.getPages();
      if (i.length === 1) return;
      const r = this.getPage(n);
      if (r) {
        if (n === this.getCurrentPageId()) {
          const s = i.findIndex((a) => a.id === n), o = i[s - 1] ?? i[s + 1];
          this.setCurrentPage(o.id);
        }
        this.store.remove([r.id]);
      }
    }), this;
  }
  /**
   * Duplicate a page.
   *
   * @param page - The page (or the page id) to duplicate. Defaults to the current page.
   * @param createId - The id of the new page. Defaults to a new id.
   *
   * @public
   */
  duplicatePage(e, n = kn.createId()) {
    if (this.getPages().length >= this.options.maxPages) return this;
    const i = typeof e == "string" ? e : e.id, r = this.getPage(i);
    if (!r) return this;
    const s = { ...this.getCamera() }, o = this.getContentFromCurrentPage(this.getSortedChildIdsForParent(r.id));
    return this.run(() => {
      var d;
      const a = this.getPages(), c = ko(r.index, (d = a[a.indexOf(r) + 1]) == null ? void 0 : d.index);
      if (this.createPage({ name: r.name + " Copy", id: n, index: c }), this.setCurrentPage(n), this.setCamera(s), o)
        return this.putContentOntoCurrentPage(o);
    }), this;
  }
  /**
   * Rename a page.
   *
   * @example
   * ```ts
   * editor.renamePage('page1', 'My Page')
   * ```
   *
   * @param page - The page (or the page id) to rename.
   * @param name - The new name.
   *
   * @public
   */
  renamePage(e, n) {
    const i = typeof e == "string" ? e : e.id;
    return this.getIsReadonly() ? this : (this.updatePage({ id: i, name: n }), this);
  }
  _getAllAssetsQuery() {
    return this.store.query.records("asset");
  }
  /**
   * Get all assets in the editor.
   *
   * @public
   */
  getAssets() {
    return this._getAllAssetsQuery().get();
  }
  /**
   * Create one or more assets.
   *
   * @example
   * ```ts
   * editor.createAssets([...myAssets])
   * ```
   *
   * @param assets - The assets to create.
   *
   * @public
   */
  createAssets(e) {
    return this.getIsReadonly() ? this : e.length <= 0 ? this : (this.run(() => this.store.put(e), { history: "ignore" }), this);
  }
  /**
   * Update one or more assets.
   *
   * @example
   * ```ts
   * editor.updateAssets([{ id: 'asset1', name: 'New name' }])
   * ```
   *
   * @param assets - The assets to update.
   *
   * @public
   */
  updateAssets(e) {
    return this.getIsReadonly() ? this : e.length <= 0 ? this : (this.run(
      () => {
        this.store.put(
          e.map((n) => ({
            ...this.store.get(n.id),
            ...n
          }))
        );
      },
      { history: "ignore" }
    ), this);
  }
  /**
   * Delete one or more assets.
   *
   * @example
   * ```ts
   * editor.deleteAssets(['asset1', 'asset2'])
   * ```
   *
   * @param assets - The assets (or asset ids) to delete.
   *
   * @public
   */
  deleteAssets(e) {
    if (this.getIsReadonly()) return this;
    const n = typeof e[0] == "string" ? e : e.map((i) => i.id);
    return n.length <= 0 ? this : (this.run(() => this.store.remove(n), { history: "ignore" }), this);
  }
  /**
   * Get an asset by its id.
   *
   * @example
   * ```ts
   * editor.getAsset('asset1')
   * ```
   *
   * @param asset - The asset (or asset id) to get.
   *
   * @public
   */
  getAsset(e) {
    return this.store.get(typeof e == "string" ? e : e.id);
  }
  async resolveAssetUrl(e, n) {
    if (!e) return null;
    const i = this.getAsset(e);
    if (!i) return null;
    const { screenScale: r = 1, shouldResolveToOriginal: s = !1 } = n, a = Math.max(0.125, ((u) => Math.pow(2, Math.ceil(Math.log2(u))))(r)), c = "connection" in navigator ? navigator.connection.effectiveType : null, d = this.getInstanceState().devicePixelRatio;
    return await this.store.props.assets.resolve(i, {
      screenScale: r || 1,
      steppedScreenScale: a,
      dpr: d,
      networkEffectiveType: c,
      shouldResolveToOriginal: s
    });
  }
  /**
   * Upload an asset to the store's asset service, returning a URL that can be used to resolve the
   * asset.
   */
  async uploadAsset(e, n) {
    return await this.store.props.assets.upload(e, n);
  }
  _getShapeGeometryCache() {
    return this.store.createComputedCache(
      "bounds",
      (e) => this.getShapeUtil(e).getGeometry(e),
      (e, n) => e.props === n.props
    );
  }
  /**
   * Get the geometry of a shape.
   *
   * @example
   * ```ts
   * editor.getShapeGeometry(myShape)
   * editor.getShapeGeometry(myShapeId)
   * ```
   *
   * @param shape - The shape (or shape id) to get the geometry for.
   *
   * @public
   */
  getShapeGeometry(e) {
    return this._getShapeGeometryCache().get(typeof e == "string" ? e : e.id);
  }
  _getShapeHandlesCache() {
    return this.store.createComputedCache("handles", (e) => {
      var n, i;
      return (i = (n = this.getShapeUtil(e)).getHandles) == null ? void 0 : i.call(n, e);
    });
  }
  /**
   * Get the handles (if any) for a shape.
   *
   * @example
   * ```ts
   * editor.getShapeHandles(myShape)
   * editor.getShapeHandles(myShapeId)
   * ```
   *
   * @param shape - The shape (or shape id) to get the handles for.
   * @public
   */
  getShapeHandles(e) {
    return this._getShapeHandlesCache().get(typeof e == "string" ? e : e.id);
  }
  /**
   * Get the local transform for a shape as a matrix model. This transform reflects both its
   * translation (x, y) from from either its parent's top left corner, if the shape's parent is
   * another shape, or else from the 0,0 of the page, if the shape's parent is the page; and the
   * shape's rotation.
   *
   * @example
   * ```ts
   * editor.getShapeLocalTransform(myShape)
   * ```
   *
   * @param shape - The shape to get the local transform for.
   *
   * @public
   */
  getShapeLocalTransform(e) {
    const n = typeof e == "string" ? e : e.id, i = this.getShape(n);
    if (!i) throw Error("Editor.getTransform: shape not found");
    return ne.Identity().translate(i.x, i.y).rotate(i.rotation);
  }
  _getShapePageTransformCache() {
    return this.store.createComputedCache("pageTransformCache", (e) => {
      if (ni(e.parentId))
        return this.getShapeLocalTransform(e);
      const n = this._getShapePageTransformCache().get(e.parentId) ?? ne.Identity();
      return ne.Compose(n, this.getShapeLocalTransform(e));
    });
  }
  /**
   * Get the local transform of a shape's parent as a matrix model.
   *
   * @example
   * ```ts
   * editor.getShapeParentTransform(myShape)
   * ```
   *
   * @param shape - The shape (or shape id) to get the parent transform for.
   *
   * @public
   */
  getShapeParentTransform(e) {
    const n = typeof e == "string" ? e : e.id, i = this.getShape(n);
    return !i || ni(i.parentId) ? ne.Identity() : this._getShapePageTransformCache().get(i.parentId) ?? ne.Identity();
  }
  /**
   * Get the transform of a shape in the current page space.
   *
   * @example
   * ```ts
   * editor.getShapePageTransform(myShape)
   * editor.getShapePageTransform(myShapeId)
   * ```
   *
   * @param shape - The shape (or shape id) to get the page transform for.
   *
   * @public
   */
  getShapePageTransform(e) {
    const n = typeof e == "string" ? e : e.id;
    return this._getShapePageTransformCache().get(n) ?? ne.Identity();
  }
  _getShapePageBoundsCache() {
    return this.store.createComputedCache("pageBoundsCache", (e) => {
      const n = this._getShapePageTransformCache().get(e.id);
      return n ? ae.FromPoints(
        ne.applyToPoints(n, this.getShapeGeometry(e).vertices)
      ) : new ae();
    });
  }
  /**
   * Get the bounds of a shape in the current page space.
   *
   * @example
   * ```ts
   * editor.getShapePageBounds(myShape)
   * editor.getShapePageBounds(myShapeId)
   * ```
   *
   * @param shape - The shape (or shape id) to get the bounds for.
   *
   * @public
   */
  getShapePageBounds(e) {
    return this._getShapePageBoundsCache().get(typeof e == "string" ? e : e.id);
  }
  _getShapeClipPathCache() {
    return this.store.createComputedCache("clipPathCache", (e) => {
      const n = this._getShapeMaskCache().get(e.id);
      if (!n) return;
      if (n.length === 0)
        return "polygon(0px 0px, 0px 0px, 0px 0px)";
      const i = this._getShapePageTransformCache().get(e.id);
      return i ? `polygon(${ne.applyToPoints(ne.Inverse(i), n).map((s) => `${s.x}px ${s.y}px`).join(",")})` : void 0;
    });
  }
  /**
   * Get the clip path for a shape.
   *
   * @example
   * ```ts
   * const clipPath = editor.getShapeClipPath(shape)
   * const clipPath = editor.getShapeClipPath(shape.id)
   * ```
   *
   * @param shape - The shape (or shape id) to get the clip path for.
   *
   * @returns The clip path or undefined.
   *
   * @public
   */
  getShapeClipPath(e) {
    return this._getShapeClipPathCache().get(typeof e == "string" ? e : e.id);
  }
  _getShapeMaskCache() {
    return this.store.createComputedCache("pageMaskCache", (e) => {
      if (ni(e.parentId)) return;
      const n = this.getShapeAncestors(e.id).filter(
        (r) => this.isShapeOfType(r, "frame")
      );
      return n.length === 0 ? void 0 : n.map(
        (r) => (
          // Apply the frame transform to the frame outline to get the frame outline in the current page space
          this._getShapePageTransformCache().get(r.id).applyToPoints(this.getShapeGeometry(r).vertices)
        )
      ).reduce((r, s) => {
        if (!(s && r)) return;
        const o = ew(r, s);
        return o ? o.map(x.Cast) : [];
      });
    });
  }
  /**
   * Get the mask (in the current page space) for a shape.
   *
   * @example
   * ```ts
   * const pageMask = editor.getShapeMask(shape.id)
   * ```
   *
   * @param shape - The shape (or the shape id) of the shape to get the mask for.
   *
   * @returns The mask for the shape.
   *
   * @public
   */
  getShapeMask(e) {
    return this._getShapeMaskCache().get(typeof e == "string" ? e : e.id);
  }
  /**
   * Get the bounds of a shape in the current page space, incorporating any masks. For example, if the
   * shape were the child of a frame and was half way out of the frame, the bounds would be the half
   * of the shape that was in the frame.
   *
   * @example
   * ```ts
   * editor.getShapeMaskedPageBounds(myShape)
   * editor.getShapeMaskedPageBounds(myShapeId)
   * ```
   *
   * @param shape - The shape to get the masked bounds for.
   *
   * @public
   */
  getShapeMaskedPageBounds(e) {
    return typeof e != "string" && (e = e.id), this._getShapeMaskedPageBoundsCache().get(e);
  }
  _getShapeMaskedPageBoundsCache() {
    return this.store.createComputedCache("shapeMaskedPageBoundsCache", (e) => {
      const n = this._getShapePageBoundsCache().get(e.id);
      if (!n) return;
      const i = this._getShapeMaskCache().get(e.id);
      if (i) {
        if (i.length === 0) return;
        const { corners: r } = n;
        if (r.every((o, a) => o && x.Equals(o, i[a]))) return n.clone();
        const s = ew(i, r);
        return s ? ae.FromPoints(s) : void 0;
      }
      return n;
    });
  }
  /**
   * Get the ancestors of a shape.
   *
   * @example
   * ```ts
   * const ancestors = editor.getShapeAncestors(myShape)
   * const ancestors = editor.getShapeAncestors(myShapeId)
   * ```
   *
   * @param shape - The shape (or shape id) to get the ancestors for.
   * @param acc - The accumulator.
   *
   * @public
   */
  getShapeAncestors(e, n = []) {
    const i = typeof e == "string" ? e : e.id, r = this.getShape(i);
    if (!r) return n;
    const s = r.parentId;
    if (ni(s))
      return n.reverse(), n;
    const o = this.store.get(s);
    return o ? (n.push(o), this.getShapeAncestors(o, n)) : n;
  }
  /**
   * Find the first ancestor matching the given predicate
   *
   * @example
   * ```ts
   * const ancestor = editor.findShapeAncestor(myShape)
   * const ancestor = editor.findShapeAncestor(myShape.id)
   * const ancestor = editor.findShapeAncestor(myShape.id, (shape) => shape.type === 'frame')
   * ```
   *
   * @param shape - The shape to check the ancestors for.
   * @param predicate - The predicate to match.
   *
   * @public
   */
  findShapeAncestor(e, n) {
    const i = typeof e == "string" ? e : e.id, r = this.getShape(i);
    if (!r) return;
    const s = r.parentId;
    if (ni(s)) return;
    const o = this.getShape(s);
    if (o)
      return n(o) ? o : this.findShapeAncestor(o, n);
  }
  /**
   * Returns true if the the given shape has the given ancestor.
   *
   * @param shape - The shape.
   * @param ancestorId - The id of the ancestor.
   *
   * @public
   */
  hasAncestor(e, n) {
    const i = typeof e == "string" ? e : e == null ? void 0 : e.id, r = i && this.getShape(i);
    return r ? r.parentId === n ? !0 : this.hasAncestor(this.getShapeParent(r), n) : !1;
  }
  /**
   * Get the common ancestor of two or more shapes that matches a predicate.
   *
   * @param shapes - The shapes (or shape ids) to check.
   * @param predicate - The predicate to match.
   */
  findCommonAncestor(e, n) {
    var c;
    if (e.length === 0)
      return;
    const i = typeof e[0] == "string" ? e : e.map((d) => d.id), r = Ze(i.map((d) => this.getShape(d)));
    if (r.length === 1) {
      const d = r[0].parentId;
      return ni(d) ? void 0 : n ? (c = this.findShapeAncestor(r[0], n)) == null ? void 0 : c.id : d;
    }
    const [s, ...o] = r;
    let a = this.getShapeParent(s);
    for (; a; ) {
      if (n && !n(a)) {
        a = this.getShapeParent(a);
        continue;
      }
      if (o.every((d) => this.hasAncestor(d, a.id)))
        return a.id;
      a = this.getShapeParent(a);
    }
  }
  isShapeOrAncestorLocked(e) {
    const n = typeof e == "string" ? this.getShape(e) : e;
    return n === void 0 ? !1 : n.isLocked ? !0 : this.isShapeOrAncestorLocked(this.getShapeParent(n));
  }
  _notVisibleShapes() {
    return b8(this);
  }
  getCulledShapes() {
    const e = this._notVisibleShapes().get(), n = this.getSelectedShapeIds(), i = this.getEditingShapeId(), r = new Set(e);
    return i && r.delete(i), n.forEach((s) => {
      r.delete(s);
    }), r;
  }
  getCurrentPageBounds() {
    let e;
    return this.getCurrentPageShapeIdsSorted().forEach((n) => {
      const i = this.getShapeMaskedPageBounds(n);
      i && (e ? e = e.expand(i) : e = i.clone());
    }), e;
  }
  /**
   * Get the top-most selected shape at the given point, ignoring groups.
   *
   * @param point - The point to check.
   *
   * @returns The top-most selected shape at the given point, or undefined if there is no shape at the point.
   */
  getSelectedShapeAtPoint(e) {
    const n = this.getSelectedShapeIds();
    return this.getCurrentPageShapesSorted().filter((i) => i.type !== "group" && n.includes(i.id)).reverse().find((i) => this.isPointInShape(i, e, { hitInside: !0, margin: 0 }));
  }
  /**
   * Get the shape at the current point.
   *
   * @param point - The point to check.
   * @param opts - Options for the check: `hitInside` to check if the point is inside the shape, `margin` to check if the point is within a margin of the shape, `hitFrameInside` to check if the point is inside the frame, and `filter` to filter the shapes to check.
   *
   * @returns The shape at the given point, or undefined if there is no shape at the point.
   */
  getShapeAtPoint(e, n = {}) {
    const i = this.getZoomLevel(), r = this.getViewportPageBounds(), {
      filter: s,
      margin: o = 0,
      hitLocked: a = !1,
      hitLabels: c = !1,
      hitInside: d = !1,
      hitFrameInside: u = !1
    } = n;
    let h = 1 / 0, g = null, p = 1 / 0, f = null;
    const M = (n.renderingOnly ? this.getCurrentPageRenderingShapesSorted() : this.getCurrentPageShapesSorted()).filter((m) => {
      if (m.isLocked && !a || this.isShapeHidden(m) || this.isShapeOfType(m, "group"))
        return !1;
      const y = this.getShapeMask(m);
      return y && !yi(e, y) ? !1 : s ? s(m) : !0;
    });
    for (let m = M.length - 1; m >= 0; m--) {
      const y = M[m], I = this.getShapeGeometry(y), D = I instanceof Ki, j = this.getPointInShapeSpace(y, e);
      if ((this.isShapeOfType(y, "arrow") || this.isShapeOfType(y, "geo") && y.props.fill === "none") && y.props.text.trim()) {
        for (const A of I.children)
          if (A.isLabel && A.isPointInBounds(j))
            return y;
      }
      if (this.isShapeOfType(y, "frame")) {
        const A = I.distanceToPoint(j, d);
        if (Math.abs(A) <= o)
          return f || y;
        if (I.hitTestPoint(j, 0, !0))
          return f || g || (u ? y : void 0);
        continue;
      }
      let w;
      if (D) {
        let A = 1 / 0;
        for (const b of I.children) {
          if (b.isLabel && !c) continue;
          const T = b.distanceToPoint(j, d);
          T < A && (A = T);
        }
        w = A;
      } else
        o === 0 && (I.bounds.w < 1 || I.bounds.h < 1) || I.bounds.containsPoint(j, o) ? w = I.distanceToPoint(j, d) : w = 1 / 0;
      if (I.isClosed) {
        if (w <= o) {
          if (I.isFilled || D && I.children[0].isFilled)
            return f || y;
          if (this.getShapePageBounds(y).contains(r)) continue;
          if (Math.abs(w) < o)
            Math.abs(w) < p && (p = Math.abs(w), f = y);
          else if (!f) {
            const { area: A } = I;
            A < h && (h = A, g = y);
          }
        }
      } else if (w < this.options.hitTestMargin / i)
        return y;
    }
    return f || g || void 0;
  }
  /**
   * Get the shapes, if any, at a given page point.
   *
   * @example
   * ```ts
   * editor.getShapesAtPoint({ x: 100, y: 100 })
   * editor.getShapesAtPoint({ x: 100, y: 100 }, { hitInside: true, exact: true })
   * ```
   *
   * @param point - The page point to test.
   * @param opts - The options for the hit point testing.
   *
   * @public
   */
  getShapesAtPoint(e, n = {}) {
    return this.getCurrentPageShapes().filter(
      (i) => !this.isShapeHidden(i) && this.isPointInShape(i, e, n)
    );
  }
  /**
   * Test whether a point (in the current page space) will will a shape. This method takes into account masks,
   * such as when a shape is the child of a frame and is partially clipped by the frame.
   *
   * @example
   * ```ts
   * editor.isPointInShape({ x: 100, y: 100 }, myShape)
   * ```
   *
   * @param shape - The shape to test against.
   * @param point - The page point to test (in the current page space).
   * @param opts - The options for the hit point testing.
   *
   * @public
   */
  isPointInShape(e, n, i = {}) {
    const { hitInside: r = !1, margin: s = 0 } = i, o = typeof e == "string" ? e : e.id, a = this.getShapeMask(o);
    return a && !yi(n, a) ? !1 : this.getShapeGeometry(o).hitTestPoint(
      this.getPointInShapeSpace(e, n),
      s,
      r
    );
  }
  /**
   * Convert a point in the current page space to a point in the local space of a shape. For example, if a
   * shape's page point were `{ x: 100, y: 100 }`, a page point at `{ x: 110, y: 110 }` would be at
   * `{ x: 10, y: 10 }` in the shape's local space.
   *
   * @example
   * ```ts
   * editor.getPointInShapeSpace(myShape, { x: 100, y: 100 })
   * ```
   *
   * @param shape - The shape to get the point in the local space of.
   * @param point - The page point to get in the local space of the shape.
   *
   * @public
   */
  getPointInShapeSpace(e, n) {
    const i = typeof e == "string" ? e : e.id;
    return this._getShapePageTransformCache().get(i).clone().invert().applyToPoint(n);
  }
  /**
   * Convert a delta in the current page space to a point in the local space of a shape's parent.
   *
   * @example
   * ```ts
   * editor.getPointInParentSpace(myShape.id, { x: 100, y: 100 })
   * ```
   *
   * @param shape - The shape to get the point in the local space of.
   * @param point - The page point to get in the local space of the shape.
   *
   * @public
   */
  getPointInParentSpace(e, n) {
    const i = typeof e == "string" ? e : e.id, r = this.getShape(i);
    if (!r) return new x(0, 0);
    if (ni(r.parentId)) return x.From(n);
    const s = this.getShapePageTransform(r.parentId);
    return s ? s.clone().invert().applyToPoint(n) : x.From(n);
  }
  getCurrentPageShapes() {
    return Array.from(this.getCurrentPageShapeIds(), (e) => this.store.get(e));
  }
  getCurrentPageShapesSorted() {
    const e = [], n = this.getSortedChildIdsForParent(this.getCurrentPageId());
    for (let i = 0, r = n.length; i < r; i++)
      e4(this, n[i], e);
    return e;
  }
  getCurrentPageRenderingShapesSorted() {
    const e = this.getCulledShapes();
    return this.getCurrentPageShapesSorted().filter(
      ({ id: n }) => !e.has(n) && !this.isShapeHidden(n)
    );
  }
  isShapeOfType(e, n) {
    const i = typeof e == "string" ? this.getShape(e) : e;
    return i ? i.type === n : !1;
  }
  /**
   * Get a shape by its id.
   *
   * @example
   * ```ts
   * editor.getShape('box1')
   * ```
   *
   * @param shape - The shape (or the id of the shape) to get.
   *
   * @public
   */
  getShape(e) {
    const n = typeof e == "string" ? e : e.id;
    if (si(n))
      return this.store.get(n);
  }
  /**
   * Get the parent shape for a given shape. Returns undefined if the shape is the direct child of
   * the page.
   *
   * @example
   * ```ts
   * editor.getShapeParent(myShape)
   * ```
   *
   * @public
   */
  getShapeParent(e) {
    const n = typeof e == "string" ? e : e == null ? void 0 : e.id;
    if (!n) return;
    const i = this.getShape(n);
    if (!(i === void 0 || !si(i.parentId)))
      return this.store.get(i.parentId);
  }
  /**
   * If siblingShape and targetShape are siblings, this returns targetShape. If targetShape has an
   * ancestor who is a sibling of siblingShape, this returns that ancestor. Otherwise, this returns
   * undefined.
   *
   * @internal
   */
  getShapeNearestSibling(e, n) {
    return n ? n.parentId === e.parentId ? n : this.findShapeAncestor(
      n,
      (r) => r.parentId === e.parentId
    ) : void 0;
  }
  /**
   * Get whether the given shape is the descendant of the given page.
   *
   * @example
   * ```ts
   * editor.isShapeInPage(myShape)
   * editor.isShapeInPage(myShape, 'page1')
   * ```
   *
   * @param shape - The shape to check.
   * @param pageId - The id of the page to check against. Defaults to the current page.
   *
   * @public
   */
  isShapeInPage(e, n = this.getCurrentPageId()) {
    const i = typeof e == "string" ? e : e.id, r = this.getShape(i);
    if (!r) return !1;
    let s = !1;
    if (r.parentId === n)
      s = !0;
    else {
      let o = this.getShape(r.parentId);
      e: for (; o; ) {
        if (o.parentId === n) {
          s = !0;
          break e;
        }
        o = this.getShape(o.parentId);
      }
    }
    return s;
  }
  /**
   * Get the id of the containing page for a given shape.
   *
   * @param shape - The shape to get the page id for.
   *
   * @returns The id of the page that contains the shape, or undefined if the shape is undefined.
   *
   * @public
   */
  getAncestorPageId(e) {
    const n = typeof e == "string" ? e : e == null ? void 0 : e.id, i = n && this.getShape(n);
    if (i)
      return ni(i.parentId) ? i.parentId : this.getAncestorPageId(this.getShape(i.parentId));
  }
  /**
   * Reparent shapes to a new parent. This operation preserves the shape's current page positions /
   * rotations.
   *
   * @example
   * ```ts
   * editor.reparentShapes([box1, box2], 'frame1')
   * editor.reparentShapes([box1.id, box2.id], 'frame1')
   * editor.reparentShapes([box1.id, box2.id], 'frame1', 4)
   * ```
   *
   * @param shapes - The shapes (or shape ids) of the shapes to reparent.
   * @param parentId - The id of the new parent shape.
   * @param insertIndex - The index to insert the children.
   *
   * @public
   */
  reparentShapes(e, n, i) {
    const r = typeof e[0] == "string" ? e : e.map((g) => g.id);
    if (r.length === 0) return this;
    const s = [], o = ni(n) ? ne.Identity() : this.getShapePageTransform(n), a = o.rotation();
    let c = [];
    const d = Ze(this.getSortedChildIdsForParent(n).map((g) => this.getShape(g)));
    if (i) {
      const g = d.find((p) => p.index === i);
      if (g) {
        const p = d[d.indexOf(g) + 1];
        p ? c = Ga(i, p.index, r.length) : c = _f(i, r.length);
      } else {
        const p = d.sort(Jt).find((f) => f.index > i);
        p ? c = Ga(i, p.index, r.length) : c = _f(i, r.length);
      }
    } else {
      const g = d.length && d[d.length - 1];
      c = g ? _f(g.index, r.length) : Wa(r.length);
    }
    const u = o.clone().invert(), h = Ze(r.map((g) => this.getShape(g)));
    return this.run(
      () => {
        for (let g = 0; g < h.length; g++) {
          const p = h[g], f = this.getShapePageTransform(p);
          if (!f) continue;
          const M = f.point();
          if (!M) continue;
          const m = u.applyToPoint(M), y = f.rotation() - a;
          s.push({
            id: p.id,
            type: p.type,
            parentId: n,
            x: m.x,
            y: m.y,
            rotation: y,
            index: c[g]
          });
        }
        this.updateShapes(s);
      },
      { ignoreShapeLock: !0 }
    ), this;
  }
  /**
   * Get the index above the highest child of a given parent.
   *
   * @param parent - The parent (or the id) of the parent.
   *
   * @returns The index.
   *
   * @public
   */
  getHighestIndexForParent(e) {
    const n = typeof e == "string" ? e : e.id, i = this._parentIdsToChildIds.get()[n];
    if (!i || i.length === 0)
      return "a1";
    const r = this.getShape(i[i.length - 1]);
    return hi(r.index);
  }
  /**
   * Get an array of all the children of a shape.
   *
   * @example
   * ```ts
   * editor.getSortedChildIdsForParent('frame1')
   * ```
   *
   * @param parent - The parent (or the id) of the parent shape.
   *
   * @public
   */
  getSortedChildIdsForParent(e) {
    const n = typeof e == "string" ? e : e.id, i = this._parentIdsToChildIds.get()[n];
    return i || hs;
  }
  /**
   * Run a visitor function for all descendants of a shape.
   *
   * @example
   * ```ts
   * editor.visitDescendants('frame1', myCallback)
   * ```
   *
   * @param parent - The parent (or the id) of the parent shape.
   * @param visitor - The visitor function.
   *
   * @public
   */
  visitDescendants(e, n) {
    const i = typeof e == "string" ? e : e.id, r = this.getSortedChildIdsForParent(i);
    for (const s of r)
      n(s) !== !1 && this.visitDescendants(s, n);
    return this;
  }
  /**
   * Get the shape ids of all descendants of the given shapes (including the shapes themselves). IDs are returned in z-index order.
   *
   * @param ids - The ids of the shapes to get descendants of.
   *
   * @returns The descendant ids.
   *
   * @public
   */
  getShapeAndDescendantIds(e) {
    const n = /* @__PURE__ */ new Set();
    for (const i of e.map((r) => this.getShape(r)).sort(Jt))
      n.add(i.id), this.visitDescendants(i, (r) => {
        n.add(r);
      });
    return n;
  }
  /**
   * Get the shape that some shapes should be dropped on at a given point.
   *
   * @param point - The point to find the parent for.
   * @param droppingShapes - The shapes that are being dropped.
   *
   * @returns The shape to drop on.
   *
   * @public
   */
  getDroppingOverShape(e, n = []) {
    const i = this.getCurrentPageShapesSorted();
    for (let r = i.length - 1; r >= 0; r--) {
      const s = i[r];
      if (
        // ignore hidden shapes
        this.isShapeHidden(s) || // don't allow dropping on selected shapes
        this.getSelectedShapeIds().includes(s.id) || // only allow shapes that can receive children
        !this.getShapeUtil(s).canDropShapes(s, n) || // don't allow dropping a shape on itself or one of it's children
        n.find((a) => a.id === s.id || this.hasAncestor(s, a.id))
      )
        continue;
      const o = this.getShapeMaskedPageBounds(s.id);
      if (o && o.containsPoint(e) && this.getShapeGeometry(s).hitTestPoint(this.getPointInShapeSpace(s, e), 0, !0))
        return s;
    }
  }
  /**
   * Get the shape that should be selected when you click on a given shape, assuming there is
   * nothing already selected. It will not return anything higher than or including the current
   * focus layer.
   *
   * @param shape - The shape to get the outermost selectable shape for.
   * @param filter - A function to filter the selectable shapes.
   *
   * @returns The outermost selectable shape.
   *
   * @public
   */
  getOutermostSelectableShape(e, n) {
    const i = typeof e == "string" ? e : e.id, r = this.getShape(i);
    let s = r, o = r;
    const a = this.getFocusedGroup();
    for (; o; ) {
      if (this.isShapeOfType(o, "group") && (a == null ? void 0 : a.id) !== o.id && !this.hasAncestor(a, o.id) && ((n == null ? void 0 : n(o)) ?? !0))
        s = o;
      else if ((a == null ? void 0 : a.id) === o.id)
        break;
      o = this.getShapeParent(o);
    }
    return s;
  }
  _getBindingsIndexCache() {
    const e = A8(this);
    return this.store.createComputedCache("bindingsIndex", (n) => e.get().get(n.id));
  }
  /**
   * Get a binding from the store by its ID if it exists.
   */
  getBinding(e) {
    return this.store.get(e);
  }
  /**
   * Get all bindings of a certain type _from_ a particular shape. These are the bindings whose
   * `fromId` matched the shape's ID.
   */
  getBindingsFromShape(e, n) {
    const i = typeof e == "string" ? e : e.id;
    return this.getBindingsInvolvingShape(i).filter(
      (r) => r.fromId === i && r.type === n
    );
  }
  /**
   * Get all bindings of a certain type _to_ a particular shape. These are the bindings whose
   * `toId` matches the shape's ID.
   */
  getBindingsToShape(e, n) {
    const i = typeof e == "string" ? e : e.id;
    return this.getBindingsInvolvingShape(i).filter(
      (r) => r.toId === i && r.type === n
    );
  }
  /**
   * Get all bindings involving a particular shape. This includes bindings where the shape is the
   * `fromId` or `toId`. If a type is provided, only bindings of that type are returned.
   */
  getBindingsInvolvingShape(e, n) {
    const i = typeof e == "string" ? e : e.id, r = this._getBindingsIndexCache().get(i) ?? hs;
    return n ? r.filter((s) => s.type === n) : r;
  }
  /**
   * Create bindings from a list of partial bindings. You can omit the ID and most props of a
   * binding, but the `type`, `toId`, and `fromId` must all be provided.
   */
  createBindings(e) {
    const n = [];
    for (const i of e) {
      const r = this.getShape(i.fromId), s = this.getShape(i.toId);
      if (!r || !s || !this.canBindShapes({ fromShape: r, toShape: s, binding: i })) continue;
      const a = this.getBindingUtil(i.type).getDefaultProps(), c = this.store.schema.types.binding.create({
        ...i,
        id: i.id ?? Ks(),
        props: {
          ...a,
          ...i.props
        }
      });
      n.push(c);
    }
    return this.store.put(n), this;
  }
  /**
   * Create a single binding from a partial. You can omit the ID and most props of a binding, but
   * the `type`, `toId`, and `fromId` must all be provided.
   */
  createBinding(e) {
    return this.createBindings([e]);
  }
  /**
   * Update bindings from a list of partial bindings. Each partial must include an ID, which will
   * be used to match the binding to it's existing record. If there is no existing record, that
   * binding is skipped. The changes from the partial are merged into the existing record.
   */
  updateBindings(e) {
    const n = [];
    for (const i of e) {
      if (!i) continue;
      const r = this.getBinding(i.id);
      if (!r) continue;
      const s = vr(r, i);
      if (s === r) continue;
      const o = this.getShape(s.fromId), a = this.getShape(s.toId);
      !o || !a || this.canBindShapes({ fromShape: o, toShape: a, binding: s }) && n.push(s);
    }
    return this.store.put(n), this;
  }
  /**
   * Update a binding from a partial binding. Each partial must include an ID, which will be used
   * to match the binding to it's existing record. If there is no existing record, that binding is
   * skipped. The changes from the partial are merged into the existing record.
   */
  updateBinding(e) {
    return this.updateBindings([e]);
  }
  /**
   * Delete several bindings by their IDs. If a binding ID doesn't exist, it's ignored.
   */
  deleteBindings(e, { isolateShapes: n = !1 } = {}) {
    const i = e.map((r) => typeof r == "string" ? r : r.id);
    return n ? this.store.atomic(() => {
      var r, s;
      for (const o of i) {
        const a = this.getBinding(o);
        if (!a) continue;
        const c = this.getBindingUtil(a);
        (r = c.onBeforeIsolateFromShape) == null || r.call(c, { binding: a, removedShape: this.getShape(a.toId) }), (s = c.onBeforeIsolateToShape) == null || s.call(c, { binding: a, removedShape: this.getShape(a.fromId) }), this.store.remove([o]);
      }
    }) : this.store.remove(i), this;
  }
  /**
   * Delete a binding by its ID. If the binding doesn't exist, it's ignored.
   */
  deleteBinding(e, n) {
    return this.deleteBindings([e], n);
  }
  canBindShapes({
    fromShape: e,
    toShape: n,
    binding: i
  }) {
    const r = typeof e == "string" ? e : e.type, s = typeof n == "string" ? n : n.type, o = typeof i == "string" ? i : i.type, a = { fromShapeType: r, toShapeType: s, bindingType: o };
    return r === s ? this.getShapeUtil(r).canBind(a) : this.getShapeUtil(r).canBind(a) && this.getShapeUtil(s).canBind(a);
  }
  /* -------------------- Commands -------------------- */
  /**
   * Rotate shapes by a delta in radians.
   *
   * @example
   * ```ts
   * editor.rotateShapesBy(editor.getSelectedShapeIds(), Math.PI)
   * editor.rotateShapesBy(editor.getSelectedShapeIds(), Math.PI / 2)
   * ```
   *
   * @param shapes - The shapes (or shape ids) of the shapes to move.
   * @param delta - The delta in radians to apply to the selection rotation.
   * @param opts - The options for the rotation.
   */
  rotateShapesBy(e, n, i) {
    const r = typeof e[0] == "string" ? e : e.map((o) => o.id);
    if (r.length <= 0) return this;
    const s = T1({ editor: this, ids: r });
    return s ? (wh({
      delta: n,
      snapshot: s,
      editor: this,
      stage: "one-off",
      centerOverride: i == null ? void 0 : i.center
    }), this) : this;
  }
  getChangesToTranslateShape(e, n) {
    var s, o, a;
    let i = e;
    const r = this.getShapeUtil(e);
    return i = vr(
      i,
      ((s = r.onTranslateStart) == null ? void 0 : s.call(r, i)) ?? void 0
    ), i = vr(i, {
      id: e.id,
      type: e.type,
      x: n.x,
      y: n.y
    }), i = vr(
      i,
      ((o = r.onTranslate) == null ? void 0 : o.call(r, e, i)) ?? void 0
    ), i = vr(
      i,
      ((a = r.onTranslateEnd) == null ? void 0 : a.call(r, e, i)) ?? void 0
    ), i;
  }
  /**
   * Move shapes by a delta.
   *
   * @example
   * ```ts
   * editor.nudgeShapes(['box1', 'box2'], { x: 8, y: 8 })
   * ```
   *
   * @param shapes - The shapes (or shape ids) to move.
   * @param offset - The offset to apply to the shapes.
   */
  nudgeShapes(e, n) {
    const i = typeof e[0] == "string" ? e : e.map((s) => s.id);
    if (i.length <= 0) return this;
    const r = [];
    for (const s of i) {
      const o = this.getShape(s), a = x.From(n), c = this.getShapeParentTransform(o);
      c && a.rot(-c.rotation()), r.push(this.getChangesToTranslateShape(o, a.add(o)));
    }
    return this.updateShapes(r), this;
  }
  /**
   * Duplicate shapes.
   *
   * @example
   * ```ts
   * editor.duplicateShapes(['box1', 'box2'], { x: 8, y: 8 })
   * editor.duplicateShapes(editor.getSelectedShapes(), { x: 8, y: 8 })
   * ```
   *
   * @param shapes - The shapes (or shape ids) to duplicate.
   * @param offset - The offset (in pixels) to apply to the duplicated shapes.
   *
   * @public
   */
  duplicateShapes(e, n) {
    return this.run(() => {
      const i = typeof e[0] == "string" ? e : e.map((g) => g.id);
      if (i.length <= 0) return this;
      const r = new Set(i), s = this.getShapeAndDescendantIds(i), o = [...s].reverse(), a = /* @__PURE__ */ new Map();
      for (const g of s)
        a.set(g, Ee());
      const { shapesToCreateWithOriginals: c, bindingsToCreate: d } = gw(
        this,
        s,
        (g) => {
          const p = [];
          for (const M of g) {
            const m = this.getBinding(M);
            if (!m) continue;
            const y = Ks();
            p.push({
              ...m,
              id: y,
              fromId: oi(a.get(m.fromId)),
              toId: oi(a.get(m.toId))
            });
          }
          const f = [];
          for (const M of o) {
            const m = oi(a.get(M)), y = this.getShape(M);
            if (!y) continue;
            let I = 0, D = 0;
            if (n && r.has(M)) {
              const j = this.getShapeParentTransform(y), w = new x(n.x, n.y).rot(-j.rotation());
              I = w.x, D = w.y;
            }
            f.push({
              shape: {
                ...y,
                id: m,
                x: y.x + I,
                y: y.y + D,
                // Use a dummy index for now, it will get updated outside of the `withIsolatedShapes`
                index: "a1",
                parentId: a.get(y.parentId) ?? y.parentId
              },
              originalShape: y
            });
          }
          return { shapesToCreateWithOriginals: f, bindingsToCreate: p };
        }
      );
      c.forEach(({ shape: g, originalShape: p }) => {
        const f = p.parentId, M = this.getSortedChildIdsForParent(f), m = M.indexOf(p.id), y = M[m + 1], I = y ? this.getShape(y) : void 0, D = ko(p.index, I == null ? void 0 : I.index);
        g.index = D;
      });
      const u = c.map(({ shape: g }) => g);
      if (u.length + this.getCurrentPageShapeIds().size > this.options.maxShapesPerPage) {
        Cu(this);
        return;
      }
      if (this.createShapes(u), this.createBindings(d), this.setSelectedShapes(Ze(i.map((g) => a.get(g)))), n !== void 0) {
        const g = this.getSelectionPageBounds(), p = this.getViewportPageBounds();
        g && !p.contains(g) && this.centerOnPoint(g.center, {
          animation: { duration: this.options.animationMediumMs }
        });
      }
    }), this;
  }
  /**
   * Move shapes to page.
   *
   * @example
   * ```ts
   * editor.moveShapesToPage(['box1', 'box2'], 'page1')
   * ```
   *
   * @param shapes - The shapes (or shape ids) of the shapes to move.
   * @param pageId - The id of the page where the shapes will be moved.
   *
   * @public
   */
  moveShapesToPage(e, n) {
    const i = typeof e[0] == "string" ? e : e.map((a) => a.id);
    if (i.length === 0) return this;
    if (this.getIsReadonly()) return this;
    const r = this.getCurrentPageId();
    if (n === r) return this;
    if (!this.store.has(n)) return this;
    const s = this.getContentFromCurrentPage(i);
    if (!s) return this;
    if (this.getPageShapeIds(n).size + s.shapes.length > this.options.maxShapesPerPage)
      return Cu(this, n), this;
    const o = this.getCamera().z;
    return this.run(() => {
      this.deleteShapes(i), this.setCurrentPage(n), this.setFocusedGroup(null), this.selectNone(), this.putContentOntoCurrentPage(s, {
        select: !0,
        preserveIds: !0,
        preservePosition: !0
      }), this.setCamera({ ...this.getCamera(), z: o }), this.centerOnPoint(this.getSelectionRotatedPageBounds().center);
    }), this;
  }
  /**
   * Toggle the lock state of one or more shapes. If there is a mix of locked and unlocked shapes, all shapes will be locked.
   *
   * @param shapes - The shapes (or shape ids) to toggle.
   *
   * @public
   */
  toggleLock(e) {
    const n = typeof e[0] == "string" ? e : e.map((o) => o.id);
    if (this.getIsReadonly() || n.length === 0) return this;
    let i = !0, r = !0;
    const s = [];
    for (const o of n) {
      const a = this.getShape(o);
      a && (s.push(a), a.isLocked ? r = !1 : i = !1);
    }
    return this.run(() => {
      r ? (this.updateShapes(
        s.map((o) => ({ id: o.id, type: o.type, isLocked: !0 }))
      ), this.setSelectedShapes([])) : i ? this.updateShapes(
        s.map((o) => ({ id: o.id, type: o.type, isLocked: !1 }))
      ) : this.updateShapes(
        s.map((o) => ({ id: o.id, type: o.type, isLocked: !0 }))
      );
    }), this;
  }
  /**
   * Send shapes to the back of the page's object list.
   *
   * @example
   * ```ts
   * editor.sendToBack(['id1', 'id2'])
   * editor.sendToBack(box1, box2)
   * ```
   *
   * @param shapes - The shapes (or shape ids) to move.
   *
   * @public
   */
  sendToBack(e) {
    const n = typeof e[0] == "string" ? e : e.map((r) => r.id), i = vu(this, "toBack", n);
    return i && this.updateShapes(i), this;
  }
  /**
   * Send shapes backward in the page's object list.
   *
   * @example
   * ```ts
   * editor.sendBackward(['id1', 'id2'])
   * editor.sendBackward([box1, box2])
   * ```
   *
   * @param shapes - The shapes (or shape ids) to move.
   *
   * @public
   */
  sendBackward(e) {
    const n = typeof e[0] == "string" ? e : e.map((r) => r.id), i = vu(this, "backward", n);
    return i && this.updateShapes(i), this;
  }
  /**
   * Bring shapes forward in the page's object list.
   *
   * @example
   * ```ts
   * editor.bringForward(['id1', 'id2'])
   * editor.bringForward(box1,  box2)
   * ```
   *
   * @param shapes - The shapes (or shape ids) to move.
   *
   * @public
   */
  bringForward(e) {
    const n = typeof e[0] == "string" ? e : e.map((r) => r.id), i = vu(this, "forward", n);
    return i && this.updateShapes(i), this;
  }
  /**
   * Bring shapes to the front of the page's object list.
   *
   * @example
   * ```ts
   * editor.bringToFront(['id1', 'id2'])
   * editor.bringToFront([box1, box2])
   * ```
   *
   * @param shapes - The shapes (or shape ids) to move.
   *
   * @public
   */
  bringToFront(e) {
    const n = typeof e[0] == "string" ? e : e.map((r) => r.id), i = vu(this, "toFront", n);
    return i && this.updateShapes(i), this;
  }
  /**
   * Flip shape positions.
   *
   * @example
   * ```ts
   * editor.flipShapes([box1, box2], 'horizontal', 32)
   * editor.flipShapes(editor.getSelectedShapeIds(), 'horizontal', 32)
   * ```
   *
   * @param shapes - The ids of the shapes to flip.
   * @param operation - Whether to flip horizontally or vertically.
   *
   * @public
   */
  flipShapes(e, n) {
    const i = typeof e[0] == "string" ? e : e.map((o) => o.id);
    if (this.getIsReadonly()) return this;
    let r = Ze(i.map((o) => this.getShape(o)));
    if (!r.length) return this;
    r = Ze(
      r.map((o) => this.isShapeOfType(o, "group") ? this.getSortedChildIdsForParent(o.id).map((a) => this.getShape(a)) : o).flat()
    );
    const s = ae.Common(
      Ze(r.map((o) => this.getShapePageBounds(o)))
    ).center;
    return this.run(() => {
      for (const o of r) {
        const a = this.getShapeGeometry(o).bounds, c = this.getShapePageTransform(o.id);
        c && this.resizeShape(
          o.id,
          { x: n === "horizontal" ? -1 : 1, y: n === "vertical" ? -1 : 1 },
          {
            initialBounds: a,
            initialPageTransform: c,
            initialShape: o,
            mode: "scale_shape",
            isAspectRatioLocked: this.getShapeUtil(o).isAspectRatioLocked(o),
            scaleOrigin: s,
            scaleAxisRotation: 0
          }
        );
      }
    }), this;
  }
  /**
   * Stack shape.
   *
   * @example
   * ```ts
   * editor.stackShapes([box1, box2], 'horizontal', 32)
   * editor.stackShapes(editor.getSelectedShapeIds(), 'horizontal', 32)
   * ```
   *
   * @param shapes - The shapes (or shape ids) to stack.
   * @param operation - Whether to stack horizontally or vertically.
   * @param gap - The gap to leave between shapes.
   *
   * @public
   */
  stackShapes(e, n, i) {
    const r = typeof e[0] == "string" ? e : e.map((M) => M.id);
    if (this.getIsReadonly()) return this;
    const s = r.map((M) => this.getShape(M)).filter((M) => M ? this.getShapeUtil(M).canBeLaidOut(M) : !1), o = s.length;
    if (i === 0 && o < 3 || o < 2) return this;
    const a = Object.fromEntries(
      s.map((M) => [M.id, this.getShapePageBounds(M)])
    );
    let c, d, u, h;
    n === "horizontal" ? (c = "x", d = "minX", u = "maxX", h = "width") : (c = "y", d = "minY", u = "maxY", h = "height");
    let g;
    if (i === 0) {
      const M = [];
      s.sort((y, I) => a[y.id][d] - a[I.id][d]);
      for (let y = 0; y < o - 1; y++) {
        const I = s[y], D = s[y + 1], j = a[I.id], A = a[D.id][d] - j[u], b = M.find((T) => T.gap === A);
        b ? b.count++ : M.push({ gap: A, count: 1 });
      }
      let m = 0;
      M.forEach((y) => {
        y.count > m && (m = y.count, g = y.gap);
      }), m === 1 && (g = Math.max(0, M.reduce((y, I) => y + I.gap * I.count, 0) / (o - 1)));
    } else
      g = i;
    const p = [];
    let f = a[s[0].id][u];
    return s.forEach((M, m) => {
      var w, A;
      if (m === 0) return;
      const y = { x: 0, y: 0 };
      y[c] = f + g - a[M.id][c];
      const I = this.getShapeParent(M), D = I ? x.Rot(y, -this.getShapePageTransform(I).decompose().rotation) : y, j = (A = (w = this.getShapeUtil(M)).onTranslateStart) == null ? void 0 : A.call(w, M);
      p.push(
        j ? {
          ...j,
          [c]: M[c] + D[c]
        } : {
          id: M.id,
          type: M.type,
          [c]: M[c] + D[c]
        }
      ), f += a[M.id][h] + g;
    }), this.updateShapes(p), this;
  }
  /**
   * Pack shapes into a grid centered on their current position. Based on potpack (https://github.com/mapbox/potpack).
   *
   * @example
   * ```ts
   * editor.packShapes([box1, box2], 32)
   * editor.packShapes(editor.getSelectedShapeIds(), 32)
   * ```
   *
   *
   * @param shapes - The shapes (or shape ids) to pack.
   * @param gap - The padding to apply to the packed shapes. Defaults to 16.
   */
  packShapes(e, n) {
    var A, b;
    const i = typeof e[0] == "string" ? e : e.map((T) => T.id);
    if (this.getIsReadonly()) return this;
    if (i.length < 2) return this;
    const r = i.map((T) => this.getShape(T)).filter((T) => T ? this.getShapeUtil(T).canBeLaidOut(T) : !1), s = {}, o = {};
    let a, c, d = 0;
    for (let T = 0; T < r.length; T++)
      a = r[T], c = this.getShapePageBounds(a), s[a.id] = c, o[a.id] = c.clone(), d += c.width * c.height;
    const u = ae.Common(Ze(Object.values(s))), h = u.width;
    r.sort((T, E) => s[E.id].height - s[T.id].height);
    const g = Math.max(Math.ceil(Math.sqrt(d / 0.95)), h), p = [new ae(u.x, u.y, g, 1 / 0)];
    let f = 0, M = 0, m, y;
    for (let T = 0; T < r.length; T++) {
      a = r[T], c = o[a.id];
      for (let E = p.length - 1; E >= 0; E--)
        if (m = p[E], !(c.width > m.width || c.height > m.height)) {
          c.x = m.x, c.y = m.y, M = Math.max(M, c.maxY), f = Math.max(f, c.maxX), c.width === m.width && c.height === m.height ? (y = p.pop(), E < p.length && (p[E] = y)) : c.height === m.height ? (m.x += c.width + n, m.width -= c.width + n) : c.width === m.width ? (m.y += c.height + n, m.height -= c.height + n) : (p.push(
            new ae(
              m.x + (c.width + n),
              m.y,
              m.width - (c.width + n),
              c.height
            )
          ), m.y += c.height + n, m.height -= c.height + n);
          break;
        }
    }
    const I = ae.Common(Object.values(o)), D = x.Sub(u.center, I.center);
    let j;
    const w = [];
    for (let T = 0; T < r.length; T++) {
      a = r[T], c = s[a.id], j = o[a.id];
      const E = x.Sub(j.point, c.point).add(D), v = this.getShapeParentTransform(a);
      v && E.rot(-v.rotation());
      const P = {
        id: a.id,
        type: a.type,
        x: a.x + E.x,
        y: a.y + E.y
      }, C = (b = (A = this.getShapeUtil(a)).onTranslateStart) == null ? void 0 : b.call(A, {
        ...a,
        ...P
      });
      C ? w.push({ ...P, ...C }) : w.push(P);
    }
    return w.length && this.updateShapes(w), this;
  }
  /**
   * Align shape positions.
   *
   * @example
   * ```ts
   * editor.alignShapes([box1, box2], 'left')
   * editor.alignShapes(editor.getSelectedShapeIds(), 'left')
   * ```
   *
   * @param shapes - The shapes (or shape ids) to align.
   * @param operation - The align operation to apply.
   *
   * @public
   */
  alignShapes(e, n) {
    const i = typeof e[0] == "string" ? e : e.map((c) => c.id);
    if (this.getIsReadonly()) return this;
    if (i.length < 2) return this;
    const r = Ze(i.map((c) => this.getShape(c))), s = Object.fromEntries(
      r.map((c) => [c.id, this.getShapePageBounds(c)])
    ), o = ae.Common(Ze(Object.values(s))), a = [];
    return r.forEach((c) => {
      const d = s[c.id];
      if (!d) return;
      const u = { x: 0, y: 0 };
      switch (n) {
        case "top": {
          u.y = o.minY - d.minY;
          break;
        }
        case "center-vertical": {
          u.y = o.midY - d.minY - d.height / 2;
          break;
        }
        case "bottom": {
          u.y = o.maxY - d.minY - d.height;
          break;
        }
        case "left": {
          u.x = o.minX - d.minX;
          break;
        }
        case "center-horizontal": {
          u.x = o.midX - d.minX - d.width / 2;
          break;
        }
        case "right": {
          u.x = o.maxX - d.minX - d.width;
          break;
        }
      }
      const h = this.getShapeParent(c), g = h ? x.Rot(u, -this.getShapePageTransform(h).decompose().rotation) : u;
      a.push(this.getChangesToTranslateShape(c, x.Add(c, g)));
    }), this.updateShapes(a), this;
  }
  /**
   * Distribute shape positions.
   *
   * @example
   * ```ts
   * editor.distributeShapes([box1, box2], 'horizontal')
   * editor.distributeShapes(editor.getSelectedShapeIds(), 'horizontal')
   * ```
   *
   * @param shapes - The shapes (or shape ids) to distribute.
   * @param operation - Whether to distribute shapes horizontally or vertically.
   *
   * @public
   */
  distributeShapes(e, n) {
    const i = typeof e[0] == "string" ? e : e.map((I) => I.id);
    if (this.getIsReadonly()) return this;
    if (i.length < 3) return this;
    const r = i.length, s = Ze(i.map((I) => this.getShape(I))), o = Object.fromEntries(
      s.map((I) => [I.id, this.getShapePageBounds(I)])
    );
    let a, c, d, u, h;
    n === "horizontal" ? (a = "x", c = "minX", d = "maxX", u = "midX", h = "width") : (a = "y", c = "minY", d = "maxY", u = "midY", h = "height");
    const g = [], p = s.sort(
      (I, D) => o[I.id][c] - o[D.id][c]
    )[0], f = s.sort((I, D) => o[D.id][d] - o[I.id][d])[0], M = o[p.id][u], m = (o[f.id][u] - M) / (r - 1), y = M + m;
    return s.filter((I) => I !== p && I !== f).sort((I, D) => o[I.id][u] - o[D.id][u]).forEach((I, D) => {
      const j = { x: 0, y: 0 };
      j[a] = y + m * D - o[I.id][h] / 2 - o[I.id][a];
      const w = this.getShapeParent(I), A = w ? x.Rot(j, -this.getShapePageTransform(w).rotation()) : j;
      g.push(this.getChangesToTranslateShape(I, x.Add(I, A)));
    }), this.updateShapes(g), this;
  }
  /**
   * Stretch shape sizes and positions to fill their common bounding box.
   *
   * @example
   * ```ts
   * editor.stretchShapes([box1, box2], 'horizontal')
   * editor.stretchShapes(editor.getSelectedShapeIds(), 'horizontal')
   * ```
   *
   * @param shapes - The shapes (or shape ids) to stretch.
   * @param operation - Whether to stretch shapes horizontally or vertically.
   *
   * @public
   */
  stretchShapes(e, n) {
    const i = typeof e[0] == "string" ? e : e.map((c) => c.id);
    if (this.getIsReadonly()) return this;
    if (i.length < 2) return this;
    const r = Ze(i.map((c) => this.getShape(c))), s = Object.fromEntries(i.map((c) => [c, this.getShapeGeometry(c).bounds])), o = Object.fromEntries(i.map((c) => [c, this.getShapePageBounds(c)])), a = ae.Common(Ze(Object.values(o)));
    switch (n) {
      case "vertical": {
        this.run(() => {
          for (const c of r) {
            if (this.getShapePageTransform(c).rotation() % gt) continue;
            const u = s[c.id], h = o[c.id], g = new x(0, a.minY - h.minY), p = this.getShapeParentTransform(c);
            p && g.rot(-p.rotation());
            const { x: f, y: M } = x.Add(g, c);
            this.updateShapes([{ id: c.id, type: c.type, x: f, y: M }]);
            const m = new x(1, a.height / h.height);
            this.resizeShape(c.id, m, {
              initialBounds: u,
              scaleOrigin: new x(h.center.x, a.minY),
              isAspectRatioLocked: this.getShapeUtil(c).isAspectRatioLocked(c),
              scaleAxisRotation: 0
            });
          }
        });
        break;
      }
      case "horizontal": {
        this.run(() => {
          for (const c of r) {
            const d = s[c.id], u = o[c.id];
            if (this.getShapePageTransform(c).rotation() % gt) continue;
            const g = new x(a.minX - u.minX, 0), p = this.getShapeParentTransform(c);
            p && g.rot(-p.rotation());
            const { x: f, y: M } = x.Add(g, c);
            this.updateShapes([{ id: c.id, type: c.type, x: f, y: M }]);
            const m = new x(a.width / u.width, 1);
            this.resizeShape(c.id, m, {
              initialBounds: d,
              scaleOrigin: new x(a.minX, u.center.y),
              isAspectRatioLocked: this.getShapeUtil(c).isAspectRatioLocked(c),
              scaleAxisRotation: 0
            });
          }
        });
        break;
      }
    }
    return this;
  }
  /**
   * Resize a shape.
   *
   * @param shape - The shape (or the shape id of the shape) to resize.
   * @param scale - The scale factor to apply to the shape.
   * @param opts - Additional options.
   *
   * @public
   */
  resizeShape(e, n, i = {}) {
    var p, f, M;
    const r = typeof e == "string" ? e : e.id;
    if (this.getIsReadonly()) return this;
    Number.isFinite(n.x) || (n = new x(1, n.y)), Number.isFinite(n.y) || (n = new x(n.x, 1));
    const s = i.initialShape ?? this.getShape(r);
    if (!s) return this;
    const o = i.scaleOrigin ?? ((p = this.getShapePageBounds(r)) == null ? void 0 : p.center);
    if (!o) return this;
    const a = i.initialPageTransform ? ne.Cast(i.initialPageTransform) : this.getShapePageTransform(r);
    if (!a) return this;
    const c = a.rotation();
    if (c == null) return this;
    const d = i.scaleAxisRotation ?? c, u = i.initialBounds ?? this.getShapeGeometry(r).bounds;
    if (!u) return this;
    const h = i.isAspectRatioLocked ?? this.getShapeUtil(s).isAspectRatioLocked(s);
    if (!Iv(c, d))
      return this._resizeUnalignedShape(r, n, {
        ...i,
        initialBounds: u,
        scaleOrigin: o,
        scaleAxisRotation: d,
        initialPageTransform: a,
        isAspectRatioLocked: h,
        initialShape: s
      });
    const g = this.getShapeUtil(s);
    if (h && (Math.abs(n.x) > Math.abs(n.y) ? n = new x(n.x, Math.sign(n.y) * Math.abs(n.x)) : n = new x(Math.sign(n.x) * Math.abs(n.y), n.y)), g.onResize && g.canResize(s)) {
      const m = this._scalePagePoint(
        ne.applyToPoint(a, new x(0, 0)),
        o,
        n,
        d
      ), y = this.getPointInParentSpace(s.id, m), I = new x(n.x, n.y), D = Xs(
        (c - d) % Math.PI,
        0
      );
      I.x = D ? n.x : n.y, I.y = D ? n.y : n.x;
      const j = ne.applyToPoint(a, new x()), { x: w, y: A } = this.getPointInParentSpace(s.id, j);
      let b = s;
      i.skipStartAndEndCallbacks || (b = vr(
        s,
        ((f = g.onResizeStart) == null ? void 0 : f.call(g, s)) ?? void 0
      )), b = vr(b, {
        id: r,
        type: s.type,
        x: y.x,
        y: y.y,
        ...g.onResize(
          { ...s, x: w, y: A },
          {
            newPoint: y,
            handle: i.dragHandle ?? "bottom_right",
            // don't set isSingle to true for children
            mode: i.mode ?? "scale_shape",
            scaleX: I.x,
            scaleY: I.y,
            initialBounds: u,
            initialShape: s
          }
        )
      }), i.skipStartAndEndCallbacks || (b = vr(
        b,
        ((M = g.onResizeEnd) == null ? void 0 : M.call(g, s, b)) ?? void 0
      )), this.updateShapes([b]);
    } else {
      const m = ne.applyToPoint(a, u.center), y = this._scalePagePoint(
        m,
        o,
        n,
        d
      ), I = this.getPointInParentSpace(
        s.id,
        m
      ), D = this.getPointInParentSpace(s.id, y), j = x.Sub(D, I);
      this.updateShapes([
        {
          id: r,
          type: s.type,
          x: s.x + j.x,
          y: s.y + j.y
        }
      ]);
    }
    return this;
  }
  /** @internal */
  _scalePagePoint(e, n, i, r) {
    const s = x.RotWith(e, n, -r).sub(n), o = x.MulV(s, i);
    return x.Add(o, n).rotWith(
      n,
      r
    );
  }
  /** @internal */
  _resizeUnalignedShape(e, n, i) {
    const { type: r } = i.initialShape, s = new x(n.x, n.y);
    if (Math.abs(n.x) > Math.abs(n.y) ? s.x = Math.sign(n.x) * Math.abs(n.y) : s.y = Math.sign(n.y) * Math.abs(n.x), this.resizeShape(e, s, {
      initialShape: i.initialShape,
      initialBounds: i.initialBounds,
      isAspectRatioLocked: i.isAspectRatioLocked
    }), Math.sign(n.x) * Math.sign(n.y) < 0) {
      let { rotation: m } = ne.Decompose(i.initialPageTransform);
      m -= 2 * m, this.updateShapes([{ id: e, type: r, rotation: m }]);
    }
    const o = ne.applyToPoint(
      i.initialPageTransform,
      i.initialBounds.center
    ), a = this._scalePagePoint(
      o,
      i.scaleOrigin,
      n,
      i.scaleAxisRotation
    ), c = this.getShapePageBounds(e), d = this.getShapePageTransform(e), u = c.center, h = d.point();
    if (!u || !h) return this;
    const g = x.Sub(a, u), p = x.Add(h, g), { x: f, y: M } = this.getPointInParentSpace(e, p);
    return this.updateShapes([{ id: e, type: r, x: f, y: M }]), this;
  }
  /**
   * Get the initial meta value for a shape.
   *
   * @example
   * ```ts
   * editor.getInitialMetaForShape = (shape) => {
   *   if (shape.type === 'note') {
   *     return { createdBy: myCurrentUser.id }
   *   }
   * }
   * ```
   *
   * @param shape - The shape to get the initial meta for.
   *
   * @public
   */
  getInitialMetaForShape(e) {
    return {};
  }
  /**
   * Create a single shape.
   *
   * @example
   * ```ts
   * editor.createShape(myShape)
   * editor.createShape({ id: 'box1', type: 'text', props: { text: "ok" } })
   * ```
   *
   * @param shape - The shape (or shape partial) to create.
   *
   * @public
   */
  createShape(e) {
    return this.createShapes([e]), this;
  }
  /**
   * Create shapes.
   *
   * @example
   * ```ts
   * editor.createShapes([myShape])
   * editor.createShapes([{ id: 'box1', type: 'text', props: { text: "ok" } }])
   * ```
   *
   * @param shapes - The shapes (or shape partials) to create.
   *
   * @public
   */
  createShapes(e) {
    if (!Array.isArray(e))
      throw Error("Editor.createShapes: must provide an array of shapes or shape partials");
    if (this.getIsReadonly()) return this;
    if (e.length <= 0) return this;
    const n = this.getCurrentPageShapeIds();
    if (e.length + n.size > this.options.maxShapesPerPage)
      return Cu(this), this;
    const r = this.getFocusedGroupId();
    return this.run(() => {
      var u, h;
      const s = this.getCurrentPageShapesSorted(), o = e.map((g) => {
        if (g.id || (g = { id: Ee(), ...g }), !g.parentId || !(this.store.has(g.parentId) || e.some((p) => p.id === g.parentId))) {
          let p = this.getFocusedGroupId();
          for (let M = s.length - 1; M >= 0; M--) {
            const m = s[M];
            if (!this.isShapeHidden(m) && this.getShapeUtil(m).canReceiveNewChildrenOfType(m, g.type) && this.isPointInShape(
              m,
              // If no parent is provided, then we can treat the
              // shape's provided x/y as being in the page's space.
              { x: g.x ?? 0, y: g.y ?? 0 },
              {
                margin: 0,
                hitInside: !0
              }
            )) {
              p = m.id;
              break;
            }
          }
          const f = g.parentId;
          if (p === g.id && (p = r), p !== f && (g = { ...g }, g.parentId = p, si(p))) {
            const M = this.getPointInShapeSpace(this.getShape(p), {
              x: g.x ?? 0,
              y: g.y ?? 0
            });
            g.x = M.x, g.y = M.y, g.rotation = -this.getShapePageTransform(p).rotation() + (g.rotation ?? 0);
          }
        }
        return g;
      }), a = /* @__PURE__ */ new Map(), c = [], { opacityForNextShape: d } = this.getInstanceState();
      for (const g of o) {
        const p = this.getShapeUtil(g);
        let f = g.index;
        if (!f) {
          const I = g.parentId ?? r;
          a.has(I) || a.set(I, this.getHighestIndexForParent(I)), f = a.get(I), a.set(I, hi(f));
        }
        const M = p.getDefaultProps();
        for (const [I, D] of this.styleProps[g.type])
          M[D] = this.getStyleForNextShape(I);
        let m = this.store.schema.types.shape.create({
          ...g,
          index: f,
          opacity: g.opacity ?? d,
          parentId: g.parentId ?? r,
          props: "props" in g ? { ...M, ...g.props } : M
        });
        if (m.index === void 0)
          throw Error("no index!");
        const y = (h = (u = this.getShapeUtil(m)).onBeforeCreate) == null ? void 0 : h.call(u, m);
        y && (m = y), c.push(m);
      }
      c.forEach((g) => {
        g.meta = {
          ...this.getInitialMetaForShape(g),
          ...g.meta
        };
      }), this.store.put(c);
    }), this;
  }
  /**
   * Animate a shape.
   *
   * @example
   * ```ts
   * editor.animateShape({ id: 'box1', type: 'box', x: 100, y: 100 })
   * editor.animateShape({ id: 'box1', type: 'box', x: 100, y: 100 }, { animation: { duration: 100, ease: t => t*t } })
   * ```
   *
   * @param partial - The shape partial to update.
   * @param opts - The animation's options.
   *
   * @public
   */
  animateShape(e, n = { animation: wM }) {
    return this.animateShapes([e], n);
  }
  /**
   * Animate shapes.
   *
   * @example
   * ```ts
   * editor.animateShapes([{ id: 'box1', type: 'box', x: 100, y: 100 }])
   * editor.animateShapes([{ id: 'box1', type: 'box', x: 100, y: 100 }], { animation: { duration: 100, ease: t => t*t } })
   * ```
   *
   * @param partials - The shape partials to update.
   * @param opts - The animation's options.
   *
   * @public
   */
  animateShapes(e, n = { animation: wM }) {
    if (!n.animation) return this;
    const { duration: i = 500, easing: r = on.linear } = n.animation, s = ht();
    let o = i, a;
    const c = [];
    let d, u;
    for (let g = 0, p = e.length; g < p; g++) {
      if (d = e[g], !d) continue;
      const f = this.getShape(d.id);
      f && (u = {
        start: Ct(f),
        end: vr(Ct(f), d)
      }, c.push(u), this.animatingShapes.set(f.id, s));
    }
    const h = (g) => {
      var m, y;
      if (o -= g, o < 0) {
        const { animatingShapes: I } = this, D = e.filter(
          (j) => j && I.get(j.id) === s
        );
        D.length && this.updateShapes(D), this.off("tick", h);
        return;
      }
      a = r(1 - o / i);
      const { animatingShapes: p } = this, f = [];
      let M;
      for (let I = 0, D = c.length; I < D; I++) {
        const { start: j, end: w } = c[I];
        M = p.get(j.id), M === s && f.push({
          ...w,
          x: j.x + (w.x - j.x) * a,
          y: j.y + (w.y - j.y) * a,
          opacity: j.opacity + (w.opacity - j.opacity) * a,
          rotation: j.rotation + (w.rotation - j.rotation) * a,
          props: ((y = (m = this.getShapeUtil(w)).getInterpolatedProps) == null ? void 0 : y.call(m, j, w, a)) ?? w.props
        });
      }
      this._updateShapes(f);
    };
    return this.on("tick", h), this;
  }
  groupShapes(e, n = {}) {
    var f;
    const { groupId: i = Ee(), select: r = !0 } = n;
    if (!Array.isArray(e))
      throw Error("Editor.groupShapes: must provide an array of shapes or shape ids");
    if (this.getIsReadonly()) return this;
    const s = typeof e[0] == "string" ? e : e.map((M) => M.id);
    if (s.length <= 1) return this;
    const o = Ze(
      (this._shouldIgnoreShapeLock ? s : this._getUnlockedShapeIds(s)).map(
        (M) => this.getShape(M)
      )
    ), a = o.sort(Jt).map((M) => M.id), c = ae.Common(Ze(o.map((M) => this.getShapePageBounds(M)))), { x: d, y: u } = c.point, h = this.findCommonAncestor(o) ?? this.getCurrentPageId();
    if (this.getCurrentToolId() !== "select") return this;
    this.isIn("select.idle") || this.cancel();
    const g = o.filter((M) => M.parentId === h).sort(Jt), p = (f = g[g.length - 1]) == null ? void 0 : f.index;
    return this.run(() => {
      this.createShapes([
        {
          id: i,
          type: "group",
          parentId: h,
          index: p,
          x: d,
          y: u,
          opacity: 1,
          props: {}
        }
      ]), this.reparentShapes(a, i), r && this.select(i);
    }), this;
  }
  ungroupShapes(e, n = {}) {
    if (this.getIsReadonly()) return this;
    const { select: i = !0 } = n, r = typeof e[0] == "string" ? e : e.map((c) => c.id), s = Ze(
      (this._shouldIgnoreShapeLock ? r : this._getUnlockedShapeIds(r)).map(
        (c) => this.getShape(c)
      )
    );
    if (s.length === 0) return this;
    if (this.getCurrentToolId() !== "select") return this;
    this.isIn("select.idle") || this.cancel();
    const o = /* @__PURE__ */ new Set(), a = [];
    return s.forEach((c) => {
      this.isShapeOfType(c, "group") ? a.push(c) : o.add(c.id);
    }), a.length === 0 ? this : (this.run(() => {
      let c;
      for (let d = 0, u = a.length; d < u; d++) {
        c = a[d];
        const h = this.getSortedChildIdsForParent(c.id);
        for (let g = 0, p = h.length; g < p; g++)
          o.add(h[g]);
        this.reparentShapes(h, c.parentId, c.index);
      }
      this.deleteShapes(a.map((d) => d.id)), i && this.select(...o);
    }), this);
  }
  /**
   * Update a shape using a partial of the shape.
   *
   * @example
   * ```ts
   * editor.updateShape({ id: 'box1', type: 'geo', props: { w: 100, h: 100 } })
   * ```
   *
   * @param partial - The shape partial to update.
   *
   * @public
   */
  updateShape(e) {
    return this.updateShapes([e]), this;
  }
  /**
   * Update shapes using partials of each shape.
   *
   * @example
   * ```ts
   * editor.updateShapes([{ id: 'box1', type: 'geo', props: { w: 100, h: 100 } }])
   * ```
   *
   * @param partials - The shape partials to update.
   *
   * @public
   */
  updateShapes(e) {
    const n = Array(e.length);
    for (let i = 0, r = e.length; i < r; i++) {
      const s = e[i];
      if (!s) continue;
      const o = this.getShape(s.id);
      if (o) {
        if (!this._shouldIgnoreShapeLock) {
          if (o.isLocked) {
            if (!(Object.hasOwn(s, "isLocked") && !s.isLocked))
              continue;
          } else if (this.isShapeOrAncestorLocked(o))
            continue;
        }
        this.animatingShapes.delete(s.id), n.push(s);
      }
    }
    return this._updateShapes(n), this;
  }
  /** @internal */
  _updateShapes(e) {
    this.getIsReadonly() || this.run(() => {
      var s, o;
      const n = [];
      let i, r;
      for (let a = 0, c = e.length; a < c; a++) {
        const d = e[a];
        d && (i = this.getShape(d.id), i && (r = vr(i, d), r !== i && (r = ((o = (s = this.getShapeUtil(i)).onBeforeUpdate) == null ? void 0 : o.call(s, i, r)) ?? r, n.push(r))));
      }
      this.store.put(n);
    });
  }
  /** @internal */
  _getUnlockedShapeIds(e) {
    return e.filter((n) => {
      var i;
      return !((i = this.getShape(n)) != null && i.isLocked);
    });
  }
  deleteShapes(e) {
    if (this.getIsReadonly()) return this;
    if (!Array.isArray(e))
      throw Error("Editor.deleteShapes: must provide an array of shapes or shapeIds");
    const n = typeof e[0] == "string" ? e : e.map((s) => s.id), i = this._shouldIgnoreShapeLock ? n : this._getUnlockedShapeIds(n);
    if (i.length === 0) return this;
    const r = new Set(i);
    for (const s of i)
      this.visitDescendants(s, (o) => {
        r.add(o);
      });
    return this.run(() => this.store.remove([...r]));
  }
  deleteShape(e) {
    return this.deleteShapes([typeof e == "string" ? e : e.id]), this;
  }
  /* --------------------- Styles --------------------- */
  /**
   * Get all the current styles among the users selected shapes
   *
   * @internal
   */
  _extractSharedStyles(e, n) {
    if (this.isShapeOfType(e, "group")) {
      const i = this._parentIdsToChildIds.get()[e.id];
      if (!i) return;
      for (let r = 0, s = i.length; r < s; r++)
        this._extractSharedStyles(this.getShape(i[r]), n);
    } else
      for (const [i, r] of this.styleProps[e.type])
        n.applyValue(i, ui(e.props, r));
  }
  _getSelectionSharedStyles() {
    const e = this.getSelectedShapes(), n = new qy();
    for (const i of e)
      this._extractSharedStyles(i, n);
    return n;
  }
  /**
   * Get the style for the next shape.
   *
   * @example
   * ```ts
   * const color = editor.getStyleForNextShape(DefaultColorStyle)
   * ```
   *
   * @param style - The style to get.
   *
   * @public */
  getStyleForNextShape(e) {
    const n = this.getInstanceState().stylesForNextShape[e.id];
    return n === void 0 ? e.defaultValue : n;
  }
  getShapeStyleIfExists(e, n) {
    const i = this.styleProps[e.type].get(n);
    if (i !== void 0)
      return ui(e.props, i);
  }
  getSharedStyles() {
    if (this.isIn("select") && this.getSelectedShapeIds().length > 0)
      return this._getSelectionSharedStyles();
    const e = this.root.getCurrent(), n = new qy();
    if (!e) return n;
    if (e.shapeType)
      for (const i of this.styleProps[e.shapeType].keys())
        n.applyValue(i, this.getStyleForNextShape(i));
    return n;
  }
  getSharedOpacity() {
    if (this.isIn("select") && this.getSelectedShapeIds().length > 0) {
      const e = [], n = (r) => {
        const s = this.getShape(r);
        if (s)
          if (this.isShapeOfType(s, "group"))
            for (const o of this.getSortedChildIdsForParent(s.id))
              n(o);
          else
            e.push(s);
      };
      for (const r of this.getSelectedShapeIds())
        n(r);
      let i = null;
      for (const r of e)
        if (i === null)
          i = r.opacity;
        else if (i !== r.opacity)
          return { type: "mixed" };
      if (i !== null) return { type: "shared", value: i };
    }
    return { type: "shared", value: this.getInstanceState().opacityForNextShape };
  }
  /**
   * Set the opacity for the next shapes. This will effect subsequently created shapes.
   *
   * @example
   * ```ts
   * editor.setOpacityForNextShapes(0.5)
   * ```
   *
   * @param opacity - The opacity to set. Must be a number between 0 and 1 inclusive.
   * @param historyOptions - The history options for the change.
   */
  setOpacityForNextShapes(e, n) {
    return this.updateInstanceState({ opacityForNextShape: e }, n), this;
  }
  /**
   * Set the current opacity. This will effect any selected shapes.
   *
   * @example
   * ```ts
   * editor.setOpacityForSelectedShapes(0.5)
   * ```
   *
   * @param opacity - The opacity to set. Must be a number between 0 and 1 inclusive.
   */
  setOpacityForSelectedShapes(e) {
    const n = this.getSelectedShapes();
    if (n.length > 0) {
      const i = [], r = (s) => {
        if (this.isShapeOfType(s, "group")) {
          const o = this.getSortedChildIdsForParent(s);
          for (const a of o)
            r(this.getShape(a));
        } else
          i.push(s);
      };
      for (const s of n)
        r(s);
      this.updateShapes(
        i.map((s) => ({
          id: s.id,
          type: s.type,
          opacity: e
        }))
      );
    }
    return this;
  }
  /**
   * Set the value of a {@link @tldraw/tlschema#StyleProp} for the next shapes. This change will be applied to subsequently created shapes.
   *
   * @example
   * ```ts
   * editor.setStyleForNextShapes(DefaultColorStyle, 'red')
   * editor.setStyleForNextShapes(DefaultColorStyle, 'red', { ephemeral: true })
   * ```
   *
   * @param style - The style to set.
   * @param value - The value to set.
   * @param historyOptions - The history options for the change.
   *
   * @public
   */
  setStyleForNextShapes(e, n, i) {
    const r = this.getInstanceState().stylesForNextShape;
    return this.updateInstanceState(
      { stylesForNextShape: { ...r, [e.id]: n } },
      i
    ), this;
  }
  /**
   * Set the value of a {@link @tldraw/tlschema#StyleProp}. This change will be applied to the currently selected shapes.
   *
   * @example
   * ```ts
   * editor.setStyleForSelectedShapes(DefaultColorStyle, 'red')
   * ```
   *
   * @param style - The style to set.
   * @param value - The value to set.
   *
   * @public
   */
  setStyleForSelectedShapes(e, n) {
    const i = this.getSelectedShapes();
    if (i.length > 0) {
      const r = [], s = (o) => {
        if (this.isShapeOfType(o, "group")) {
          const a = this.getSortedChildIdsForParent(o.id);
          for (const c of a)
            s(this.getShape(c));
        } else {
          const a = this.getShapeUtil(o), c = this.styleProps[o.type].get(e);
          if (c) {
            const d = {
              id: o.id,
              type: o.type,
              props: { [c]: n }
            };
            r.push({
              util: a,
              originalShape: o,
              updatePartial: d
            });
          }
        }
      };
      for (const o of i)
        s(o);
      this.updateShapes(r.map(({ updatePartial: o }) => o));
    }
    return this;
  }
  /**
   * Register an external asset handler. This handler will be called when the editor needs to
   * create an asset for some external content, like an image/video file or a bookmark URL. For
   * example, the 'file' type handler will be called when a user drops an image onto the canvas.
   *
   * The handler should extract any relevant metadata for the asset, upload it to blob storage
   * using {@link Editor.uploadAsset} if needed, and return the asset with the metadata & uploaded
   * URL.
   *
   * @example
   * ```ts
   * editor.registerExternalAssetHandler('file', myHandler)
   * ```
   *
   * @param type - The type of external content.
   * @param handler - The handler to use for this content type.
   *
   * @public
   */
  registerExternalAssetHandler(e, n) {
    return this.externalAssetContentHandlers[e] = n, this;
  }
  /**
   * Register a temporary preview of an asset. This is useful for showing a ghost image of
   * something that is being uploaded. Retrieve the placeholder with
   * {@link Editor.getTemporaryAssetPreview}. Placeholders last for 3 minutes by default, but this
   * can be configured using
   *
   * @example
   * ```ts
   * editor.createTemporaryAssetPreview(assetId, file)
   * ```
   *
   * @param assetId - The asset's id.
   * @param file - The raw file.
   *
   * @public
   */
  createTemporaryAssetPreview(e, n) {
    if (this.temporaryAssetPreview.has(e))
      return this.temporaryAssetPreview.get(e);
    const i = URL.createObjectURL(n);
    return this.temporaryAssetPreview.set(e, i), setTimeout(() => {
      this.temporaryAssetPreview.delete(e), URL.revokeObjectURL(i);
    }, this.options.temporaryAssetPreviewLifetimeMs), i;
  }
  /**
   * Get temporary preview of an asset. This is useful for showing a ghost
   * image of something that is being uploaded.
   *
   * @example
   * ```ts
   * editor.getTemporaryAssetPreview('someId')
   * ```
   *
   * @param assetId - The asset's id.
   *
   * @public
   */
  getTemporaryAssetPreview(e) {
    return this.temporaryAssetPreview.get(e);
  }
  /**
   * Get an asset for an external asset content type.
   *
   * @example
   * ```ts
   * const asset = await editor.getAssetForExternalContent({ type: 'file', file: myFile })
   * const asset = await editor.getAssetForExternalContent({ type: 'url', url: myUrl })
   * ```
   *
   * @param info - Info about the external content.
   * @returns The asset.
   */
  async getAssetForExternalContent(e) {
    var n, i;
    return await ((i = (n = this.externalAssetContentHandlers)[e.type]) == null ? void 0 : i.call(n, e));
  }
  hasExternalAssetHandler(e) {
    return !!this.externalAssetContentHandlers[e];
  }
  /**
   * Register an external content handler. This handler will be called when the editor receives
   * external content of the provided type. For example, the 'image' type handler will be called
   * when a user drops an image onto the canvas.
   *
   * @example
   * ```ts
   * editor.registerExternalContentHandler('text', myHandler)
   * ```
   * @example
   * ```ts
   * editor.registerExternalContentHandler<'embed', MyEmbedType>('embed', myHandler)
   * ```
   *
   * @param type - The type of external content.
   * @param handler - The handler to use for this content type.
   *
   * @public
   */
  registerExternalContentHandler(e, n) {
    return this.externalContentHandlers[e] = n, this;
  }
  /**
   * Handle external content, such as files, urls, embeds, or plain text which has been put into the app, for example by pasting external text or dropping external images onto canvas.
   *
   * @param info - Info about the external content.
   */
  async putExternalContent(e) {
    var n, i;
    return (i = (n = this.externalContentHandlers)[e.type]) == null ? void 0 : i.call(n, e);
  }
  /**
   * Get content that can be exported for the given shape ids.
   *
   * @param shapes - The shapes (or shape ids) to get content for.
   *
   * @returns The exported content.
   *
   * @public
   */
  getContentFromCurrentPage(e) {
    const n = typeof e[0] == "string" ? e : e.map((r) => r.id);
    if (!n || n.length === 0) return;
    const i = this.getShapeAndDescendantIds(n);
    return gw(this, i, (r) => {
      const s = [];
      for (const u of r) {
        const h = this.getBinding(u);
        h && s.push(h);
      }
      const o = [], a = [];
      for (const u of i) {
        const h = this.getShape(u);
        if (!h) continue;
        if (!i.has(h.parentId)) {
          const p = this.getShapePageTransform(h.id), f = p.point();
          a.push({
            ...h,
            x: f.x,
            y: f.y,
            rotation: p.rotation(),
            parentId: this.getCurrentPageId()
          }), o.push(h.id);
        } else
          a.push(h);
      }
      const c = [], d = /* @__PURE__ */ new Set();
      for (const u of a) {
        if (!("assetId" in u.props)) continue;
        const h = u.props.assetId;
        if (!h || d.has(h)) continue;
        d.add(h);
        const g = this.getAsset(h);
        g && c.push(g);
      }
      return {
        schema: this.store.schema.serialize(),
        shapes: a,
        rootShapeIds: o,
        bindings: s,
        assets: c
      };
    });
  }
  async resolveAssetsInContent(e) {
    if (!e) return;
    const n = [];
    return await Promise.allSettled(
      e.assets.map(async (i) => {
        var r, s;
        if ((i.type === "image" || i.type === "video") && !((r = i.props.src) != null && r.startsWith("data:image")) && !((s = i.props.src) != null && s.startsWith("http"))) {
          const o = Ct(i), a = await this.store.props.assets.resolve(i, {
            screenScale: 1,
            steppedScreenScale: 1,
            dpr: 1,
            networkEffectiveType: null,
            shouldResolveToOriginal: !0
          });
          o.props.src = await us.blobToDataUrl(
            await gr(a).then((c) => c.blob())
          ), n.push(o);
        } else
          n.push(i);
      })
    ), e.assets = n, e;
  }
  /**
   * Place content into the editor.
   *
   * @param content - The content.
   * @param opts - Options for placing the content.
   *
   * @public
   */
  putContentOntoCurrentPage(e, n = {}) {
    var v, P;
    if (this.getIsReadonly()) return this;
    if (!e.schema)
      throw Error(`Could not put content:
content is missing a schema.`);
    const { select: i = !1, preserveIds: r = !1, preservePosition: s = !1 } = n;
    let { point: o = void 0 } = n;
    const a = this.getCurrentPageId(), { rootShapeIds: c } = e, d = [], u = [], h = [], g = {
      store: {
        ...Object.fromEntries(e.assets.map((C) => [C.id, C])),
        ...Object.fromEntries(e.shapes.map((C) => [C.id, C])),
        ...Object.fromEntries(
          ((v = e.bindings) == null ? void 0 : v.map((C) => [C.id, C])) ?? []
        )
      },
      schema: e.schema
    }, p = this.store.schema.migrateStoreSnapshot(g);
    if (p.type === "error")
      throw Error("Could not put content: could not migrate content");
    for (const C of Object.values(p.value))
      switch (C.typeName) {
        case "asset": {
          d.push(C);
          break;
        }
        case "shape": {
          u.push(C);
          break;
        }
        case "binding": {
          h.push(C);
          break;
        }
      }
    const f = new Map(
      r ? u.map((C) => [C.id, C.id]) : u.map((C) => [C.id, Ee()])
    ), M = new Map(
      r ? h.map((C) => [C.id, C.id]) : h.map((C) => [C.id, Ks()])
    );
    let m = this.getCurrentPageId(), y = 1 / 0, I = [];
    for (const C of this.getSelectedShapes()) {
      if (y === 0) break;
      const z = this.isShapeOfType(C, "frame"), O = this.getShapeAncestors(C);
      z && O.push(C);
      const R = z ? O.length + 1 : O.length;
      if (R < y)
        y = R, I = O, m = z ? C.id : C.parentId;
      else if (R === y) {
        if (I.length !== O.length)
          throw Error(`Ancestors: ${I.length} !== ${O.length}`);
        if (I.length === 0) {
          m = a;
          break;
        } else {
          m = a;
          for (let U = 0; U < I.length && O[U] === I[U]; U++)
            m = O[U].id;
        }
      }
    }
    let D = !1;
    if (!ni(m)) {
      const C = this.getShape(m);
      if (C) {
        if (!this.getViewportPageBounds().includes(this.getShapePageBounds(C)))
          m = a;
        else if (c.length === 1) {
          const z = u.find((O) => O.id === c[0]);
          this.isShapeOfType(C, "frame") && this.isShapeOfType(z, "frame") && z.props.w === (C == null ? void 0 : C.props.w) && z.props.h === (C == null ? void 0 : C.props.h) && (D = !0);
        }
      } else
        m = a;
    }
    D || (D = f.has(m)), D && (m = this.getShape(m).parentId);
    let j = this.getHighestIndexForParent(m);
    const w = [], A = u.map((C) => {
      const z = f.get(C.id), O = { ...C, id: z };
      return c.includes(C.id) && (O.parentId = a, w.push(O)), f.has(O.parentId) ? O.parentId = f.get(C.parentId) : (c.push(O.id), O.index = j, j = hi(j)), O;
    });
    if (A.length + this.getCurrentPageShapeIds().size > this.options.maxShapesPerPage)
      return Cu(this), this;
    const b = h.map(
      (C) => ({
        ...C,
        id: oi(M.get(C.id)),
        fromId: oi(f.get(C.fromId)),
        toId: oi(f.get(C.toId))
      })
    ), T = [], E = [];
    for (const C of d)
      this.store.has(C.id) || ((C.type === "image" || C.type === "video") && ((P = C.props.src) != null && P.startsWith("data:image")) && (E.push(Ct(C)), C.props.src = null), T.push(C));
    return Promise.allSettled(
      E.map(async (C) => {
        const z = await m8(
          C.props.src,
          C.props.name,
          C.props.mimeType ?? "image/png"
        ), O = await this.getAssetForExternalContent({
          type: "file",
          file: z,
          assetId: C.id
        });
        if (!O) {
          this.deleteAssets([C.id]);
          return;
        }
        this.updateAssets([{ ...O, id: C.id }]);
      })
    ), this.run(() => {
      T.length > 0 && this.createAssets(T), this.createShapes(A), this.createBindings(b), i && this.select(...w.map((U) => U.id)), m !== a && this.reparentShapes(
        w.map((U) => U.id),
        m
      );
      const C = A.map((U) => this.getShape(U.id)), z = ae.Common(C.map((U) => this.getShapePageBounds(U)));
      if (o === void 0)
        if (ni(m)) {
          const U = this.getViewportPageBounds();
          s || U.includes(ae.From(z)) ? o = z.center : o = U.center;
        } else {
          const U = this.getShape(m);
          o = ne.applyToPoint(
            this.getShapePageTransform(U),
            this.getShapeGeometry(U).bounds.center
          );
        }
      if (w.length === 1) {
        const U = w[0];
        if (this.isShapeOfType(U, "frame"))
          for (; this.getShapesAtPoint(o).some(
            (F) => this.isShapeOfType(F, "frame") && F.props.w === U.props.w && F.props.h === U.props.h
          ); )
            o.x += z.w + 16;
      }
      const O = ae.Common(
        Ze(w.map(({ id: U }) => this.getShapePageBounds(U)))
      ).center, R = x.Sub(o, O);
      this.updateShapes(
        w.map(({ id: U }) => {
          const F = this.getShape(U), H = this.getShapeParentTransform(U).decompose().rotation, Z = x.Rot(R, -H);
          return { id: F.id, type: F.type, x: F.x + Z.x, y: F.y + Z.y };
        })
      );
    }), this;
  }
  /**
   * Get an exported SVG element of the given shapes.
   *
   * @param shapes - The shapes (or shape ids) to export.
   * @param opts - Options for the export.
   *
   * @returns The SVG element.
   *
   * @public
   */
  async getSvgElement(e, n = {}) {
    const i = typeof e[0] == "string" ? e : e.map((r) => r.id);
    if (i.length !== 0)
      return g8(this, i, n);
  }
  /**
   * Get an exported SVG string of the given shapes.
   *
   * @param shapes - The shapes (or shape ids) to export.
   * @param opts - Options for the export.
   *
   * @returns The SVG element.
   *
   * @public
   */
  async getSvgString(e, n = {}) {
    const i = await this.getSvgElement(e, n);
    return i ? {
      svg: new XMLSerializer().serializeToString(i.svg),
      width: i.width,
      height: i.height
    } : void 0;
  }
  /** @deprecated Use {@link Editor.getSvgString} or {@link Editor.getSvgElement} instead. */
  async getSvg(e, n = {}) {
    const i = await this.getSvgElement(e, n);
    if (i)
      return i.svg;
  }
  /**
   * Update the input points from a pointer, pinch, or wheel event.
   *
   * @param info - The event info.
   */
  _updateInputsFromEvent(e) {
    const {
      pointerVelocity: n,
      previousScreenPoint: i,
      previousPagePoint: r,
      currentScreenPoint: s,
      currentPagePoint: o
    } = this.inputs, { screenBounds: a } = this.store.unsafeGetWithoutCapture(Qn), { x: c, y: d, z: u } = yu(() => this.getCamera()), h = e.point.x - a.x, g = e.point.y - a.y, p = e.point.z ?? 0.5;
    i.setTo(s), r.setTo(o), s.set(h, g);
    const f = h / u - c, M = g / u - d;
    isFinite(f) && isFinite(M) && o.set(f, M, p), this.inputs.isPen = e.type === "pointer" && e.isPen, (e.name === "pointer_down" || this.inputs.isPinching) && (n.set(0, 0), this.inputs.originScreenPoint.setTo(s), this.inputs.originPagePoint.setTo(o)), this.run(
      () => {
        var m;
        this.store.put([
          {
            id: bg,
            typeName: "pointer",
            x: o.x,
            y: o.y,
            lastActivityTimestamp: (
              // If our pointer moved only because we're following some other user, then don't
              // update our last activity timestamp; otherwise, update it to the current timestamp.
              e.type === "pointer" && e.pointerId === L0.CAMERA_MOVE ? ((m = this.store.unsafeGetWithoutCapture(bg)) == null ? void 0 : m.lastActivityTimestamp) ?? this._tickManager.now : this._tickManager.now
            ),
            meta: {}
          }
        ]);
      },
      { history: "ignore" }
    );
  }
  /**
   * Dispatch a cancel event.
   *
   * @example
   * ```ts
   * editor.cancel()
   * ```
   *
   * @public
   */
  cancel() {
    return this.dispatch({ type: "misc", name: "cancel" }), this;
  }
  /**
   * Dispatch an interrupt event.
   *
   * @example
   * ```ts
   * editor.interrupt()
   * ```
   *
   * @public
   */
  interrupt() {
    return this.dispatch({ type: "misc", name: "interrupt" }), this;
  }
  /**
   * Dispatch a complete event.
   *
   * @example
   * ```ts
   * editor.complete()
   * ```
   *
   * @public
   */
  complete() {
    return this.dispatch({ type: "misc", name: "complete" }), this;
  }
  /**
   * Puts the editor into focused mode.
   *
   * This makes the editor eligible to receive keyboard events and some pointer events (move, wheel).
   *
   * @example
   * ```ts
   * editor.focus()
   * ```
   *
   * By default this also dispatches a 'focus' event to the container element. To prevent this, pass `focusContainer: false`.
   *
   * @example
   * ```ts
   * editor.focus({ focusContainer: false })
   * ```
   *
   * @public
   */
  focus({ focusContainer: e = !0 } = {}) {
    return this.getIsFocused() ? this : (e && this.focusManager.focus(), this.updateInstanceState({ isFocused: !0 }), this);
  }
  /**
   * Switches off the editor's focused mode.
   *
   * This makes the editor ignore keyboard events and some pointer events (move, wheel).
   *
   * @example
   * ```ts
   * editor.blur()
   * ```
   * By default this also dispatches a 'blur' event to the container element. To prevent this, pass `blurContainer: false`.
   *
   * @example
   * ```ts
   * editor.blur({ blurContainer: false })
   * ```
   *
   * @public
   */
  blur({ blurContainer: e = !0 } = {}) {
    return this.getIsFocused() ? (e ? this.focusManager.blur() : this.complete(), this.updateInstanceState({ isFocused: !1 }), this) : this;
  }
  getIsFocused() {
    return this.getInstanceState().isFocused;
  }
  getIsReadonly() {
    return this.getInstanceState().isReadonly;
  }
  /**
   * @public
   * @returns a snapshot of the store's UI and document state
   */
  getSnapshot() {
    return yV(this.store);
  }
  /**
   * Loads a snapshot into the editor.
   * @param snapshot - The snapshot to load.
   * @param opts - The options for loading the snapshot.
   * @returns
   */
  loadSnapshot(e, n) {
    return t1(this.store, e, n), this;
  }
  _zoomToFitPageContentAt100Percent() {
    const e = this.getCurrentPageBounds();
    e && this.zoomToBounds(e, { immediate: !0, targetZoom: this.getBaseZoom() });
  }
  _navigateToDeepLink(e) {
    this.run(() => {
      switch (e.type) {
        case "page": {
          const n = this.getPage(e.pageId);
          n && this.setCurrentPage(n), this._zoomToFitPageContentAt100Percent();
          return;
        }
        case "shapes": {
          const n = Ze(e.shapeIds.map((o) => this.getShape(o))), i = {};
          for (const o of n) {
            const a = this.getAncestorPageId(o);
            a && (i[a] ?? (i[a] = []), i[a].push(o));
          }
          const [r, s] = Object.entries(i).sort(
            ([o, a], [c, d]) => d.length - a.length
          )[0] ?? ["", []];
          if (!r || !s.length)
            this._zoomToFitPageContentAt100Percent();
          else {
            this.setCurrentPage(r);
            const o = ae.Common(s.map((a) => this.getShapePageBounds(a)));
            this.zoomToBounds(o, { immediate: !0, targetZoom: this.getBaseZoom() });
          }
          return;
        }
        case "viewport": {
          if (e.pageId) {
            if (!this.getPage(e.pageId)) {
              this._zoomToFitPageContentAt100Percent();
              return;
            }
            this.setCurrentPage(e.pageId);
          }
          this.zoomToBounds(e.bounds, { immediate: !0, inset: 0 });
          return;
        }
        default:
          rn(e);
      }
    });
  }
  /**
   * Handles navigating to the content specified by the query param in the given URL.
   *
   * Use {@link Editor#createDeepLink} to create a URL with a deep link query param.
   *
   * If no URL is provided, it will look for the param in the current `window.location.href`.
   *
   * @example
   * ```ts
   * editor.navigateToDeepLink()
   * ```
   *
   * The default parameter name is 'd'. You can override this by providing the `param` option.
   *
   * @example
   * ```ts
   * // disable page parameter and change viewport parameter to 'c'
   * editor.navigateToDeepLink({
   *   param: 'x',
   *   url: 'https://my-app.com/my-document?x=200.12.454.23.xyz123',
   * })
   * ```
   *
   * @param opts - Options for loading the state from the URL.
   */
  navigateToDeepLink(e) {
    if (e && "type" in e)
      return this._navigateToDeepLink(e), this;
    const i = new URL((e == null ? void 0 : e.url) ?? window.location.href).searchParams.get((e == null ? void 0 : e.param) ?? "d");
    if (!i)
      return this._zoomToFitPageContentAt100Percent(), this;
    try {
      this._navigateToDeepLink(x8(i));
    } catch (r) {
      console.warn(r), this._zoomToFitPageContentAt100Percent();
    }
    return this;
  }
  /**
   * Turns the given URL into a deep link by adding a query parameter.
   *
   * e.g. `https://my-app.com/my-document?d=100.100.200.200.xyz123`
   *
   * If no URL is provided, it will use the current `window.location.href`.
   *
   * @example
   * ```ts
   * // create a deep link to the current page + viewport
   * navigator.clipboard.writeText(editor.createDeepLink())
   * ```
   *
   * You can link to a particular set of shapes by providing a `to` parameter.
   *
   * @example
   * ```ts
   * // create a deep link to the set of currently selected shapes
   * navigator.clipboard.writeText(editor.createDeepLink({
   *   to: { type: 'selection', shapeIds: editor.getSelectedShapeIds() }
   * }))
   * ```
   *
   * The default query param is 'd'. You can override this by providing a `param` parameter.
   *
   * @example
   * ```ts
   * // Use `x` as the param name instead
   * editor.createDeepLink({ param: 'x' })
   * ```
   *
   * @param opts - Options for adding the state to the URL.
   * @returns the updated URL
   */
  createDeepLink(e) {
    const n = new URL((e == null ? void 0 : e.url) ?? window.location.href);
    return n.searchParams.set(
      (e == null ? void 0 : e.param) ?? "d",
      I8(
        (e == null ? void 0 : e.to) ?? {
          type: "viewport",
          pageId: this.options.maxPages === 1 ? void 0 : this.getCurrentPageId(),
          bounds: this.getViewportPageBounds()
        }
      )
    ), n;
  }
  /**
   * Register a listener for changes to a deep link for the current document.
   *
   * You'll typically want to use this indirectly via the {@link TldrawEditorBaseProps.deepLinks} prop on the `<Tldraw />` component.
   *
   * By default this will update `window.location` in place, but you can provide a custom callback
   * to handle state changes on your own.
   *
   * @example
   * ```ts
   * editor.registerDeepLinkListener({
   *   onChange(url) {
   *     window.history.replaceState({}, document.title, url.toString())
   *   }
   * })
   * ```
   *
   * You can also provide a custom URL to update, in which case you must also provide `onChange`.
   *
   * @example
   * ```ts
   * editor.registerDeepLinkListener({
   *   getUrl: () => `https://my-app.com/my-document`,
   *   onChange(url) {
   *     setShareUrl(url.toString())
   *   }
   * })
   * ```
   *
   * By default this will update with a debounce interval of 500ms, but you can provide a custom interval.
   *
   * @example
   * ```ts
   * editor.registerDeepLinkListener({ debounceMs: 1000 })
   * ```
   * The default parameter name is `d`. You can override this by providing a `param` option.
   *
   * @example
   * ```ts
   * editor.registerDeepLinkListener({ param: 'x' })
   * ```
   * @param opts - Options for setting up the listener.
   * @returns a function that will stop the listener.
   */
  registerDeepLinkListener(e) {
    if (e != null && e.getUrl && !(e != null && e.onChange))
      throw Error(
        "[tldraw:urlStateSync] If you specify getUrl, you must also specify the onChange callback."
      );
    const n = K("url with state", () => {
      var c, d;
      const o = ((c = e == null ? void 0 : e.getUrl) == null ? void 0 : c.call(e, this)) ?? window.location.href;
      return this.createDeepLink({
        param: e == null ? void 0 : e.param,
        url: o,
        to: (d = e == null ? void 0 : e.getTarget) == null ? void 0 : d.call(e, this)
      }).toString();
    }), i = (e == null ? void 0 : e.onChange) ?? (() => {
      var a;
      const o = this.createDeepLink({
        param: e == null ? void 0 : e.param,
        to: (a = e == null ? void 0 : e.getTarget) == null ? void 0 : a.call(e, this)
      });
      window.history.replaceState({}, document.title, o.toString());
    }), r = lp((o) => o(), (e == null ? void 0 : e.debounceMs) ?? 500), s = Yr(
      "update url on state change",
      () => i(new URL(n.get()), this),
      { scheduleEffect: r }
    );
    return () => {
      s(), r.cancel();
    };
  }
  /**
   * Prevent a double click event from firing the next time the user clicks
   *
   * @public
   */
  cancelDoubleClick() {
    this._clickManager.cancelDoubleClickTimeout();
  }
  _setShiftKeyTimeout() {
    this.inputs.shiftKey = !1, this.dispatch({
      type: "keyboard",
      name: "key_up",
      key: "Shift",
      shiftKey: this.inputs.shiftKey,
      ctrlKey: this.inputs.ctrlKey,
      altKey: this.inputs.altKey,
      metaKey: this.inputs.metaKey,
      accelKey: bn(this.inputs),
      code: "ShiftLeft"
    });
  }
  _setAltKeyTimeout() {
    this.inputs.altKey = !1, this.dispatch({
      type: "keyboard",
      name: "key_up",
      key: "Alt",
      shiftKey: this.inputs.shiftKey,
      ctrlKey: this.inputs.ctrlKey,
      altKey: this.inputs.altKey,
      metaKey: this.inputs.metaKey,
      accelKey: bn(this.inputs),
      code: "AltLeft"
    });
  }
  _setCtrlKeyTimeout() {
    this.inputs.ctrlKey = !1, this.dispatch({
      type: "keyboard",
      name: "key_up",
      key: "Ctrl",
      shiftKey: this.inputs.shiftKey,
      ctrlKey: this.inputs.ctrlKey,
      altKey: this.inputs.altKey,
      metaKey: this.inputs.metaKey,
      accelKey: bn(this.inputs),
      code: "ControlLeft"
    });
  }
  _setMetaKeyTimeout() {
    this.inputs.metaKey = !1, this.dispatch({
      type: "keyboard",
      name: "key_up",
      key: "Meta",
      shiftKey: this.inputs.shiftKey,
      ctrlKey: this.inputs.ctrlKey,
      altKey: this.inputs.altKey,
      metaKey: this.inputs.metaKey,
      accelKey: bn(this.inputs),
      code: "MetaLeft"
    });
  }
  /**
   * Dispatch an event to the editor.
   *
   * @example
   * ```ts
   * editor.dispatch(myPointerEvent)
   * ```
   *
   * @param info - The event info.
   *
   * @public
   */
  dispatch(e) {
    return this._pendingEventsForNextTick.push(e), e.type === "pointer" && e.name === "pointer_move" || e.type === "wheel" || e.type === "pinch" || this._flushEventsForTick(0), this;
  }
  _flushEventsForTick(e) {
    this.run(() => {
      if (this._pendingEventsForNextTick.length > 0) {
        const n = [...this._pendingEventsForNextTick];
        this._pendingEventsForNextTick.length = 0;
        for (const i of n)
          this._flushEventForTick(i);
      }
      e > 0 && this.root.handleEvent({ type: "misc", name: "tick", elapsed: e }), this.scribbles.tick(e);
    });
  }
  _flushEventForTick(e) {
    if (this.getCrashingError()) return this;
    const { inputs: n } = this, { type: i } = e;
    if (e.type === "misc") {
      (e.name === "cancel" || e.name === "complete") && (this.inputs.isDragging = !1, this.inputs.isPanning && (this.inputs.isPanning = !1, this.inputs.isSpacebarPanning = !1, this.setCursor({ type: this._prevCursor, rotation: 0 }))), this.root.handleEvent(e);
      return;
    }
    e.shiftKey ? (clearTimeout(this._shiftKeyTimeout), this._shiftKeyTimeout = -1, n.shiftKey = !0) : !e.shiftKey && n.shiftKey && this._shiftKeyTimeout === -1 && (this._shiftKeyTimeout = this.timers.setTimeout(this._setShiftKeyTimeout, 150)), e.altKey ? (clearTimeout(this._altKeyTimeout), this._altKeyTimeout = -1, n.altKey = !0) : !e.altKey && n.altKey && this._altKeyTimeout === -1 && (this._altKeyTimeout = this.timers.setTimeout(this._setAltKeyTimeout, 150)), e.ctrlKey ? (clearTimeout(this._ctrlKeyTimeout), this._ctrlKeyTimeout = -1, n.ctrlKey = !0) : !e.ctrlKey && n.ctrlKey && this._ctrlKeyTimeout === -1 && (this._ctrlKeyTimeout = this.timers.setTimeout(this._setCtrlKeyTimeout, 150)), e.metaKey ? (clearTimeout(this._metaKeyTimeout), this._metaKeyTimeout = -1, n.metaKey = !0) : !e.metaKey && n.metaKey && this._metaKeyTimeout === -1 && (this._metaKeyTimeout = this.timers.setTimeout(this._setMetaKeyTimeout, 150));
    const { originPagePoint: r, currentPagePoint: s } = n;
    n.isPointing || (n.isDragging = !1);
    const o = this.store.unsafeGetWithoutCapture(Qn), a = this.store.get(this._getCurrentPageStateId()), c = this._cameraOptions.__unsafe__getWithoutCapture();
    switch (i) {
      case "pinch": {
        if (c.isLocked) return;
        switch (clearTimeout(this._longPressTimeout), this._updateInputsFromEvent(e), e.name) {
          case "pinch_start": {
            if (n.isPinching) return;
            n.isEditing || (this._pinchStart = this.getCamera().z, this._selectedShapeIdsAtPointerDown.length || (this._selectedShapeIdsAtPointerDown = [...a.selectedShapeIds]), this._didPinch = !0, n.isPinching = !0, this.interrupt());
            return;
          }
          case "pinch": {
            if (!n.isPinching) return;
            const {
              point: { z: d = 1 },
              delta: { x: u, y: h }
            } = e, { x: g, y: p } = x.SubXY(
              e.point,
              o.screenBounds.x,
              o.screenBounds.y
            );
            this.stopCameraAnimation(), o.followingUserId && this.stopFollowingUser();
            const { x: f, y: M, z: m } = yu(() => this.getCamera()), { panSpeed: y, zoomSpeed: I } = c;
            this._setCamera(
              new x(
                f + u * y / m - g / m + g / (d * I),
                M + h * y / m - p / m + p / (d * I),
                d * I
              ),
              { immediate: !0 }
            );
            return;
          }
          case "pinch_end": {
            if (!n.isPinching) return this;
            n.isPinching = !1;
            const { _selectedShapeIdsAtPointerDown: d } = this;
            this.setSelectedShapes(this._selectedShapeIdsAtPointerDown), this._selectedShapeIdsAtPointerDown = [], this._didPinch && (this._didPinch = !1, d.length > 0 && this.once("tick", () => {
              this._didPinch || this.setSelectedShapes(d);
            }));
            return;
          }
        }
      }
      case "wheel": {
        if (c.isLocked) return;
        this._updateInputsFromEvent(e);
        const { panSpeed: d, zoomSpeed: u, wheelBehavior: h } = c;
        if (h !== "none") {
          this.stopCameraAnimation(), o.followingUserId && this.stopFollowingUser();
          const { x: g, y: p, z: f } = yu(() => this.getCamera()), { x: M, y: m, z: y = 0 } = e.delta;
          let I = h;
          switch (n.ctrlKey && (I = h === "pan" ? "zoom" : "pan"), I) {
            case "zoom": {
              const { x: D, y: j } = this.inputs.currentScreenPoint;
              let w = y;
              h === "zoom" && (Math.abs(m) > 10 ? w = 10 * Math.sign(m) / 100 : w = m / 100);
              const A = f + (w ?? 0) * u * f;
              this._setCamera(
                new x(
                  g + (D / A - D) - (D / f - D),
                  p + (j / A - j) - (j / f - j),
                  A
                ),
                { immediate: !0 }
              ), this.maybeTrackPerformance("Zooming");
              return;
            }
            case "pan": {
              this._setCamera(new x(g + M * d / f, p + m * d / f, f), {
                immediate: !0
              }), this.maybeTrackPerformance("Panning");
              return;
            }
          }
        }
        break;
      }
      case "pointer": {
        if (n.isPinching) return;
        this._updateInputsFromEvent(e);
        const { isPen: d } = e, { isPenMode: u } = o;
        switch (e.name) {
          case "pointer_down": {
            if (u && !d) return;
            if (this.inputs.isPanning || (this._longPressTimeout = this.timers.setTimeout(() => {
              this.dispatch({
                ...e,
                point: this.inputs.currentScreenPoint,
                name: "long_press"
              });
            }, this.options.longPressDurationMs)), this._selectedShapeIdsAtPointerDown = this.getSelectedShapeIds(), e.button === k0 && (this.capturedPointerId = e.pointerId), n.buttons.add(e.button), n.isPointing = !0, n.isDragging = !1, !u && d && this.updateInstanceState({ isPenMode: !0 }), e.button === O0 ? (this._restoreToolId = this.getCurrentToolId(), this.complete(), this.setCurrentTool("eraser")) : e.button === Nu && (this.inputs.isPanning || (this._prevCursor = this.getInstanceState().cursor.type), this.inputs.isPanning = !0, clearTimeout(this._longPressTimeout)), this.inputs.isPanning)
              return this.stopCameraAnimation(), this.setCursor({ type: "grabbing", rotation: 0 }), this;
            break;
          }
          case "pointer_move": {
            if (!d && u) return;
            const { x: h, y: g, z: p } = yu(() => this.getCamera());
            if (this.inputs.isPanning && this.inputs.isPointing) {
              const { currentScreenPoint: f, previousScreenPoint: M } = this.inputs, { panSpeed: m } = c, y = x.Sub(f, M);
              this.setCamera(
                new x(h + y.x * m / p, g + y.y * m / p, p),
                { immediate: !0 }
              ), this.maybeTrackPerformance("Panning");
              return;
            }
            n.isPointing && !n.isDragging && x.Dist2(r, s) * this.getZoomLevel() > (o.isCoarsePointer ? this.options.coarseDragDistanceSquared : this.options.dragDistanceSquared) / p && (n.isDragging = !0, clearTimeout(this._longPressTimeout));
            break;
          }
          case "pointer_up": {
            if (n.isDragging = !1, n.isPointing = !1, clearTimeout(this._longPressTimeout), n.buttons.delete(e.button), o.isPenMode && !d) return;
            if (this.capturedPointerId === e.pointerId && (this.capturedPointerId = null, e.button = 0), n.isPanning) {
              n.keys.has("Space") || (n.isPanning = !1, n.isSpacebarPanning = !1);
              const h = this.inputs.pointerVelocity, g = Math.min(2, h.len());
              switch (e.button) {
                case k0: {
                  this.setCursor({ type: "grab", rotation: 0 });
                  break;
                }
                case Nu:
                  this.inputs.keys.has(" ") ? this.setCursor({ type: "grab", rotation: 0 }) : this.setCursor({ type: this._prevCursor, rotation: 0 });
              }
              g > 0 && this.slideCamera({ speed: g, direction: h });
            } else
              e.button === O0 && (this.complete(), this.setCurrentTool(this._restoreToolId));
            break;
          }
        }
        break;
      }
      case "keyboard": {
        switch (e.key === "ShiftRight" && (e.key = "ShiftLeft"), e.key === "AltRight" && (e.key = "AltLeft"), e.code === "ControlRight" && (e.code = "ControlLeft"), e.code === "MetaRight" && (e.code = "MetaLeft"), e.name) {
          case "key_down": {
            if (n.keys.add(e.code), e.code === "Space" && !e.ctrlKey && (this.inputs.isPanning || (this._prevCursor = o.cursor.type), this.inputs.isPanning = !0, this.inputs.isSpacebarPanning = !0, clearTimeout(this._longPressTimeout), this.setCursor({ type: this.inputs.isPointing ? "grabbing" : "grab", rotation: 0 })), this.inputs.isSpacebarPanning) {
              let d;
              switch (e.code) {
                case "ArrowUp": {
                  d = new x(0, -1);
                  break;
                }
                case "ArrowRight": {
                  d = new x(1, 0);
                  break;
                }
                case "ArrowDown": {
                  d = new x(0, 1);
                  break;
                }
                case "ArrowLeft": {
                  d = new x(-1, 0);
                  break;
                }
              }
              if (d) {
                const u = this.getViewportPageBounds(), h = u.clone().translate(d.mulV({ x: u.w, y: u.h }));
                this._animateToViewport(h, { animation: { duration: 320 } });
              }
            }
            break;
          }
          case "key_up": {
            n.keys.delete(e.code), e.code === "Space" && (this.inputs.buttons.has(Nu) || (this.inputs.isPanning = !1, this.inputs.isSpacebarPanning = !1, this.setCursor({ type: this._prevCursor, rotation: 0 })));
            break;
          }
        }
        break;
      }
    }
    if (e.type === "pointer") {
      e.button === Nu ? e.name = "middle_click" : e.button === _x && (e.name = "right_click");
      const { isPenMode: d } = this.store.unsafeGetWithoutCapture(Qn);
      if (e.isPen === d) {
        const u = this._clickManager.handlePointerEvent(e);
        if (e.name !== u.name) {
          this.root.handleEvent(e), this.emit("event", e), this.root.handleEvent(u), this.emit("event", u);
          return;
        }
      }
    }
    return this.root.handleEvent(e), this.emit("event", e), e.type === "pointer" && e.name === "pointer_down" && this.menus.clearOpenMenus(), this;
  }
  /** @internal */
  maybeTrackPerformance(e) {
    Wt.measurePerformance.get() && (this.performanceTracker.isStarted() ? clearTimeout(this.performanceTrackerTimeout) : this.performanceTracker.start(e), this.performanceTrackerTimeout = this.timers.setTimeout(() => {
      this.performanceTracker.stop();
    }, 50));
  }
}
ue = B7($y);
Me(ue, 1, "getIsShapeHiddenCache", $C, de);
Me(ue, 1, "getCanUndo", _C, de);
Me(ue, 1, "getCanRedo", qC, de);
Me(ue, 1, "getPath", JC, de);
Me(ue, 1, "getCurrentTool", XC, de);
Me(ue, 1, "getCurrentToolId", KC, de);
Me(ue, 1, "getDocumentSettings", VC, de);
Me(ue, 1, "getInstanceState", HC, de);
Me(ue, 1, "getOpenMenus", WC, de);
Me(ue, 1, "getIsMenuOpen", GC, de);
Me(ue, 1, "getPageStates", BC, de);
Me(ue, 1, "_getPageStatesQuery", FC, de);
Me(ue, 1, "getCurrentPageState", ZC, de);
Me(ue, 1, "_getCurrentPageStateId", QC, de);
Me(ue, 1, "getSelectedShapeIds", YC, de);
Me(ue, 1, "getSelectedShapes", RC, de);
Me(ue, 1, "getOnlySelectedShapeId", UC, de);
Me(ue, 1, "getOnlySelectedShape", PC, de);
Me(ue, 1, "getSelectionPageBounds", OC, de);
Me(ue, 1, "getSelectionRotation", kC, de);
Me(ue, 1, "getSelectionRotatedPageBounds", LC, de);
Me(ue, 1, "getSelectionRotatedScreenBounds", zC, de);
Me(ue, 1, "getFocusedGroupId", CC, de);
Me(ue, 1, "getFocusedGroup", EC, de);
Me(ue, 1, "getEditingShapeId", vC, de);
Me(ue, 1, "getEditingShape", bC, de);
Me(ue, 1, "getHoveredShapeId", TC, de);
Me(ue, 1, "getHoveredShape", AC, de);
Me(ue, 1, "getHintingShapeIds", NC, de);
Me(ue, 1, "getHintingShape", wC, de);
Me(ue, 1, "getErasingShapeIds", DC, de);
Me(ue, 1, "getErasingShapes", jC, de);
Me(ue, 1, "_unsafe_getCameraId", SC, de);
Me(ue, 1, "getCamera", xC, de);
Me(ue, 1, "getViewportPageBoundsForFollowing", IC, de);
Me(ue, 1, "getCameraForFollowing", yC, de);
Me(ue, 1, "getZoomLevel", mC, de);
Me(ue, 1, "getViewportScreenBounds", MC, de);
Me(ue, 1, "getViewportScreenCenter", fC, de);
Me(ue, 1, "getViewportPageBounds", pC, de);
Me(ue, 1, "_getCollaboratorsQuery", gC, de);
Me(ue, 1, "getCollaborators", hC, de);
Me(ue, 1, "getCollaboratorsOnCurrentPage", uC, de);
Me(ue, 1, "getRenderingShapes", dC, de);
Me(ue, 1, "_getAllPagesQuery", lC, de);
Me(ue, 1, "getPages", cC, de);
Me(ue, 1, "getCurrentPageId", aC, de);
Me(ue, 1, "getCurrentPageShapeIdsSorted", oC, de);
Me(ue, 1, "_getAllAssetsQuery", sC, de);
Me(ue, 1, "_getShapeGeometryCache", rC, de);
Me(ue, 1, "_getShapeHandlesCache", iC, de);
Me(ue, 1, "_getShapePageTransformCache", nC, de);
Me(ue, 1, "_getShapePageBoundsCache", tC, de);
Me(ue, 1, "_getShapeClipPathCache", eC, de);
Me(ue, 1, "_getShapeMaskCache", $E, de);
Me(ue, 1, "_getShapeMaskedPageBoundsCache", _E, de);
Me(ue, 1, "_notVisibleShapes", qE, de);
Me(ue, 1, "getCulledShapes", JE, de);
Me(ue, 1, "getCurrentPageBounds", XE, de);
Me(ue, 1, "getCurrentPageShapes", KE, de);
Me(ue, 1, "getCurrentPageShapesSorted", VE, de);
Me(ue, 1, "getCurrentPageRenderingShapesSorted", HE, de);
Me(ue, 1, "_getBindingsIndexCache", WE, de);
Me(ue, 1, "_getSelectionSharedStyles", GE, de);
Me(ue, 1, "getSharedStyles", BE, de);
Me(ue, 1, "getSharedOpacity", FE, de);
Me(ue, 1, "getIsFocused", ZE, de);
Me(ue, 1, "getIsReadonly", QE, de);
Me(ue, 1, "_setShiftKeyTimeout", YE, de);
Me(ue, 1, "_setAltKeyTimeout", RE, de);
Me(ue, 1, "_setCtrlKeyTimeout", UE, de);
Me(ue, 1, "_setMetaKeyTimeout", PE, de);
W7(ue, de);
function Cu(t, e = t.getCurrentPageId()) {
  const n = t.getPage(e).name;
  t.emit("max-shapes", { name: n, pageId: e, count: t.options.maxShapesPerPage });
}
function vr(t, e) {
  if (!e) return t;
  let n = null;
  const i = Object.entries(e);
  for (let r = 0, s = i.length; r < s; r++) {
    const [o, a] = i[r];
    if (a !== void 0 && !(o === "id" || o === "type" || o === "typeName") && a !== t[o]) {
      if (n || (n = { ...t }), o === "props" || o === "meta") {
        n[o] = { ...t[o] };
        for (const [c, d] of Object.entries(a))
          d !== void 0 && (n[o][c] = d);
        continue;
      }
      n[o] = a;
    }
  }
  return n || t;
}
function e4(t, e, n) {
  const i = t.getShape(e);
  if (!i) return;
  n.push(i);
  const r = t.getSortedChildIdsForParent(e);
  for (let s = 0, o = r.length; s < o; s++)
    e4(t, r[s], n);
}
function gw(t, e, n) {
  let i;
  if (t.run(
    () => {
      const r = t.store.extractingChanges(() => {
        const s = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set();
        for (const a of e)
          if (t.getShape(a))
            for (const d of t.getBindingsInvolvingShape(a)) {
              const u = e.has(d.fromId), h = e.has(d.toId);
              if (u && h) {
                s.add(d.id);
                continue;
              }
              (!u || !h) && o.add(d.id);
            }
        t.deleteBindings([...o], { isolateShapes: !0 });
        try {
          i = Rr.ok(n(s));
        } catch (a) {
          i = Rr.err(a);
        }
      });
      t.store.applyDiff(Sg(r));
    },
    { history: "ignore" }
  ), i.ok)
    return i.value;
  throw i.error;
}
function pw(t, e) {
  if (!e.constraints) throw Error("Should have constraints here");
  const {
    padding: { x: n, y: i }
  } = e.constraints, r = t.getViewportScreenBounds(), s = ae.From(e.constraints.bounds), o = (r.w - n * 2) / s.w, a = (r.h - i * 2) / s.h;
  return { zx: o, zy: a };
}
function Tc() {
  const t = Q(), e = Id();
  return G("isDarkMode", () => (e == null ? void 0 : e.isDarkMode) ?? t.user.getIsDarkMode(), [
    e,
    t
  ]);
}
const fw = "<path d='m19.7432 17.0869-4.072 4.068 2.829 2.828-8.473-.013-.013-8.47 2.841 2.842 4.075-4.068 1.414-1.415-2.844-2.842h8.486v8.484l-2.83-2.827z' fill='%23fff'/><path d='m18.6826 16.7334-4.427 4.424 1.828 1.828-5.056-.016-.014-5.054 1.842 1.841 4.428-4.422 2.474-2.475-1.844-1.843h5.073v5.071l-1.83-1.828z' fill='%23000'/>", Mw = "<path d='m9 17.9907v.005l5.997 5.996.001-3.999h1.999 2.02v4l5.98-6.001-5.98-5.999.001 4.019-2.021.002h-2l.001-4.022zm1.411.003 3.587-3.588-.001 2.587h3.5 2.521v-2.585l3.565 3.586-3.564 3.585-.001-2.585h-2.521l-3.499-.001-.001 2.586z' fill='%23fff'/><path d='m17.4971 18.9932h2.521v2.586l3.565-3.586-3.565-3.585v2.605h-2.521-3.5v-2.607l-3.586 3.587 3.586 3.586v-2.587z' fill='%23000'/>", zu = '<path d="M22.4789 9.45728L25.9935 12.9942L22.4789 16.5283V14.1032C18.126 14.1502 14.6071 17.6737 14.5675 22.0283H17.05L13.513 25.543L9.97889 22.0283H12.5674C12.6071 16.5691 17.0214 12.1503 22.4789 12.1031L22.4789 9.45728Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.4789 7.03223L27.4035 12.9945L21.4789 18.9521V15.1868C18.4798 15.6549 16.1113 18.0273 15.649 21.0284H19.475L13.5128 26.953L7.55519 21.0284H11.6189C12.1243 15.8155 16.2679 11.6677 21.4789 11.1559L21.4789 7.03223ZM22.4789 12.1031C17.0214 12.1503 12.6071 16.5691 12.5674 22.0284H9.97889L13.513 25.543L17.05 22.0284H14.5675C14.5705 21.6896 14.5947 21.3558 14.6386 21.0284C15.1157 17.4741 17.9266 14.6592 21.4789 14.1761C21.8063 14.1316 22.1401 14.1069 22.4789 14.1032V16.5284L25.9935 12.9942L22.4789 9.45729L22.4789 12.1031Z" fill="white"/>';
function Ls(t, e, n, i, r, s = 16, o = 16) {
  const a = (-n - e) * (st / 180), c = Math.sin(a), d = Math.cos(a), u = 1 * d - 1 * c, h = 1 * c + 1 * d;
  return `url("data:image/svg+xml,<svg height='32' width='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' style='color: ${r};'><defs><filter id='shadow' y='-40%' x='-40%' width='180px' height='180%' color-interpolation-filters='sRGB'><feDropShadow dx='${u}' dy='${h}' stdDeviation='1.2' flood-opacity='.5'/></filter></defs><g fill='none' transform='rotate(${e + n} 16 16)${i ? " scale(-1,-1) translate(0, -32)" : ""}' filter='url(%23shadow)'>` + t.replaceAll('"', "'") + `</g></svg>") ${s} ${o}, pointer`;
}
const V7 = [
  "default",
  "pointer",
  "cross",
  "move",
  "grab",
  "grabbing",
  "text",
  "zoom-in",
  "zoom-out"
], K7 = {
  none: () => "none",
  "ew-resize": (t, e, n) => Ls(Mw, t, 0, e, n),
  "ns-resize": (t, e, n) => Ls(Mw, t, 90, e, n),
  "nesw-resize": (t, e, n) => Ls(fw, t, 0, e, n),
  "nwse-resize": (t, e, n) => Ls(fw, t, 90, e, n),
  "nwse-rotate": (t, e, n) => Ls(zu, t, 0, e, n),
  "nesw-rotate": (t, e, n) => Ls(zu, t, 90, e, n),
  "senw-rotate": (t, e, n) => Ls(zu, t, 180, e, n),
  "swne-rotate": (t, e, n) => Ls(zu, t, 270, e, n)
};
function Et(t, e = 0, n = "black") {
  return K7[t](BW(e), !1, n);
}
function X7() {
  const t = Q(), e = qt(), n = Tc();
  Vs(
    "useCursor",
    () => {
      const { type: i, rotation: r } = t.getInstanceState().cursor;
      if (V7.includes(i)) {
        e.style.setProperty("--tl-cursor", `var(--tl-cursor-${i})`);
        return;
      }
      e.style.setProperty(
        "--tl-cursor",
        Et(i, r, n ? "white" : "black")
      );
    },
    [t, e, n]
  );
}
function J7() {
  const t = Q(), e = qt(), n = Tc(), i = G(Wt.forceSrgb);
  Ye.useEffect(() => {
    n ? (e.setAttribute("data-color-mode", "dark"), e.classList.remove("tl-theme__light"), e.classList.add("tl-theme__dark")) : (e.setAttribute("data-color-mode", "light"), e.classList.remove("tl-theme__dark"), e.classList.add("tl-theme__light")), i ? e.classList.add("tl-theme__force-sRGB") : e.classList.remove("tl-theme__force-sRGB");
  }, [t, e, i, n]);
}
function q7() {
  const [t, e] = pe(0);
  ze(() => e((n) => n + 1), []);
}
const _7 = (t) => t.props.src, $7 = {
  upload: (t, e) => us.blobToDataUrl(e)
};
function eK(t) {
  return "schema" in t && t.schema ? t.schema : zW({
    shapes: "shapeUtils" in t && t.shapeUtils ? mw(o1(t.shapeUtils)) : void 0,
    bindings: "bindingUtils" in t && t.bindingUtils ? mw(i1(t.bindingUtils)) : void 0,
    migrations: "migrations" in t ? t.migrations : void 0
  });
}
function Lg({
  initialData: t,
  defaultName: e = "",
  id: n,
  assets: i = $7,
  onMount: r,
  collaboration: s,
  ...o
} = {}) {
  const a = eK(o), c = new Ux({
    id: n,
    schema: a,
    initialData: t,
    props: {
      defaultName: e,
      assets: {
        upload: i.upload,
        resolve: i.resolve ?? _7
      },
      onMount: (d) => {
        ct(d instanceof de), r == null || r(d);
      },
      collaboration: s
    }
  });
  if (o.snapshot) {
    if (t) throw new Error("Cannot provide both initialData and snapshot");
    t1(c, o.snapshot);
  }
  return c;
}
function mw(t) {
  return Object.fromEntries(
    t.map((e) => [
      e.type,
      {
        props: e.props,
        migrations: e.migrations
      }
    ])
  );
}
const tK = (t, e) => e.some((n) => t instanceof n);
let yw, Iw;
function nK() {
  return yw || (yw = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function iK() {
  return Iw || (Iw = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const t4 = /* @__PURE__ */ new WeakMap(), eI = /* @__PURE__ */ new WeakMap(), n4 = /* @__PURE__ */ new WeakMap(), LM = /* @__PURE__ */ new WeakMap(), mS = /* @__PURE__ */ new WeakMap();
function rK(t) {
  const e = new Promise((n, i) => {
    const r = () => {
      t.removeEventListener("success", s), t.removeEventListener("error", o);
    }, s = () => {
      n(ps(t.result)), r();
    }, o = () => {
      i(t.error), r();
    };
    t.addEventListener("success", s), t.addEventListener("error", o);
  });
  return e.then((n) => {
    n instanceof IDBCursor && t4.set(n, t);
  }).catch(() => {
  }), mS.set(e, t), e;
}
function sK(t) {
  if (eI.has(t))
    return;
  const e = new Promise((n, i) => {
    const r = () => {
      t.removeEventListener("complete", s), t.removeEventListener("error", o), t.removeEventListener("abort", o);
    }, s = () => {
      n(), r();
    }, o = () => {
      i(t.error || new DOMException("AbortError", "AbortError")), r();
    };
    t.addEventListener("complete", s), t.addEventListener("error", o), t.addEventListener("abort", o);
  });
  eI.set(t, e);
}
let tI = {
  get(t, e, n) {
    if (t instanceof IDBTransaction) {
      if (e === "done")
        return eI.get(t);
      if (e === "objectStoreNames")
        return t.objectStoreNames || n4.get(t);
      if (e === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return ps(t[e]);
  },
  set(t, e, n) {
    return t[e] = n, !0;
  },
  has(t, e) {
    return t instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in t;
  }
};
function oK(t) {
  tI = t(tI);
}
function aK(t) {
  return t === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(e, ...n) {
    const i = t.call(kM(this), e, ...n);
    return n4.set(i, e.sort ? e.sort() : [e]), ps(i);
  } : iK().includes(t) ? function(...e) {
    return t.apply(kM(this), e), ps(t4.get(this));
  } : function(...e) {
    return ps(t.apply(kM(this), e));
  };
}
function cK(t) {
  return typeof t == "function" ? aK(t) : (t instanceof IDBTransaction && sK(t), tK(t, nK()) ? new Proxy(t, tI) : t);
}
function ps(t) {
  if (t instanceof IDBRequest)
    return rK(t);
  if (LM.has(t))
    return LM.get(t);
  const e = cK(t);
  return e !== t && (LM.set(t, e), mS.set(e, t)), e;
}
const kM = (t) => mS.get(t);
function i4(t, e, { blocked: n, upgrade: i, blocking: r, terminated: s } = {}) {
  const o = indexedDB.open(t, e), a = ps(o);
  return i && o.addEventListener("upgradeneeded", (c) => {
    i(ps(o.result), c.oldVersion, c.newVersion, ps(o.transaction), c);
  }), n && o.addEventListener("blocked", (c) => n(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    c.oldVersion,
    c.newVersion,
    c
  )), a.then((c) => {
    s && c.addEventListener("close", () => s()), r && c.addEventListener("versionchange", (d) => r(d.oldVersion, d.newVersion, d));
  }).catch(() => {
  }), a;
}
function r4(t, { blocked: e } = {}) {
  const n = indexedDB.deleteDatabase(t);
  return e && n.addEventListener("blocked", (i) => e(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    i.oldVersion,
    i
  )), ps(n).then(() => {
  });
}
const lK = ["get", "getKey", "getAll", "getAllKeys", "count"], dK = ["put", "add", "delete", "clear"], OM = /* @__PURE__ */ new Map();
function xw(t, e) {
  if (!(t instanceof IDBDatabase && !(e in t) && typeof e == "string"))
    return;
  if (OM.get(e))
    return OM.get(e);
  const n = e.replace(/FromIndex$/, ""), i = e !== n, r = dK.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (i ? IDBIndex : IDBObjectStore).prototype) || !(r || lK.includes(n))
  )
    return;
  const s = async function(o, ...a) {
    const c = this.transaction(o, r ? "readwrite" : "readonly");
    let d = c.store;
    return i && (d = d.index(a.shift())), (await Promise.all([
      d[n](...a),
      r && c.done
    ]))[0];
  };
  return OM.set(e, s), s;
}
oK((t) => ({
  ...t,
  get: (e, n, i) => xw(e, n) || t.get(e, n, i),
  has: (e, n) => !!xw(e, n) || t.has(e, n)
}));
const uK = "TLDRAW_DOCUMENT_v2", hK = "TLDRAW_ASSET_STORE_v1", s4 = "TLDRAW_DB_NAME_INDEX_v2", $e = {
  Records: "records",
  Schema: "schema",
  SessionState: "session_state",
  Assets: "assets"
};
async function o4(t) {
  const e = uK + t;
  return pK(e), await i4(e, 4, {
    upgrade(n) {
      n.objectStoreNames.contains($e.Records) || n.createObjectStore($e.Records), n.objectStoreNames.contains($e.Schema) || n.createObjectStore($e.Schema), n.objectStoreNames.contains($e.SessionState) || n.createObjectStore($e.SessionState), n.objectStoreNames.contains($e.Assets) || n.createObjectStore($e.Assets);
    }
  });
}
async function gK(t) {
  const e = window.indexedDB.databases ? (await window.indexedDB.databases()).map((g) => g.name) : yS(), n = hK + t;
  if (!e.find((g) => g === n)) return;
  const r = await i4(n, 1, {
    upgrade(g) {
      g.objectStoreNames.contains("assets") || g.createObjectStore("assets");
    }
  });
  if (!r.objectStoreNames.contains("assets")) return;
  const s = r.transaction(["assets"], "readonly"), o = s.objectStore("assets"), a = await o.getAllKeys(), c = await Promise.all(
    a.map(async (g) => [g, await o.get(g)])
  );
  await s.done;
  const d = await o4(t), u = d.transaction([$e.Assets], "readwrite"), h = u.objectStore($e.Assets);
  for (const [g, p] of c)
    h.put(p, g);
  await u.done, r.close(), d.close(), await r4(n);
}
const Gl = class Gl {
  constructor(e) {
    S(this, "getDbPromise");
    S(this, "isClosed", !1);
    S(this, "pendingTransactionSet", /* @__PURE__ */ new Set());
    Gl.connectedInstances.add(this), this.getDbPromise = (async () => (await gK(e), await o4(e)))();
  }
  getDb() {
    return this.getDbPromise;
  }
  /**
   * Wait for any pending transactions to be completed. Useful for tests.
   *
   * @internal
   */
  pending() {
    return Promise.allSettled([this.getDbPromise, ...this.pendingTransactionSet]).then(Hl);
  }
  async close() {
    this.isClosed || (this.isClosed = !0, await this.pending(), (await this.getDb()).close(), Gl.connectedInstances.delete(this));
  }
  tx(e, n, i) {
    const r = (async () => {
      ct(!this.isClosed, "db is closed");
      const o = (await this.getDb()).transaction(n, e), a = o.done.catch((c) => {
        if (!this.isClosed)
          throw c;
      });
      try {
        return await i(o);
      } finally {
        this.isClosed ? o.abort() : await a;
      }
    })();
    return this.pendingTransactionSet.add(r), r.finally(() => this.pendingTransactionSet.delete(r)), r;
  }
  async load({ sessionId: e } = {}) {
    return await this.tx(
      "readonly",
      [$e.Records, $e.Schema, $e.SessionState],
      async (n) => {
        var c, d;
        const i = n.objectStore($e.Records), r = n.objectStore($e.Schema), s = n.objectStore($e.SessionState);
        let o = e ? (c = await s.get(e)) == null ? void 0 : c.snapshot : null;
        return o || (o = (d = (await s.getAll()).sort((h, g) => h.updatedAt - g.updatedAt).pop()) == null ? void 0 : d.snapshot), {
          records: await i.getAll(),
          schema: await r.get($e.Schema),
          sessionStateSnapshot: o
        };
      }
    );
  }
  async storeChanges({
    schema: e,
    changes: n,
    sessionId: i,
    sessionStateSnapshot: r
  }) {
    await this.tx("readwrite", [$e.Records, $e.Schema, $e.SessionState], async (s) => {
      const o = s.objectStore($e.Records), a = s.objectStore($e.Schema), c = s.objectStore($e.SessionState);
      for (const [d, u] of Object.entries(n.added))
        await o.put(u, d);
      for (const [d, u] of Object.values(n.updated))
        await o.put(u, u.id);
      for (const d of Object.keys(n.removed))
        await o.delete(d);
      a.put(e.serialize(), $e.Schema), r && i ? c.put(
        {
          snapshot: r,
          updatedAt: Date.now(),
          id: i
        },
        i
      ) : (r || i) && console.error("sessionStateSnapshot and instanceId must be provided together");
    });
  }
  async storeSnapshot({
    schema: e,
    snapshot: n,
    sessionId: i,
    sessionStateSnapshot: r
  }) {
    await this.tx("readwrite", [$e.Records, $e.Schema, $e.SessionState], async (s) => {
      const o = s.objectStore($e.Records), a = s.objectStore($e.Schema), c = s.objectStore($e.SessionState);
      await o.clear();
      for (const [d, u] of Object.entries(n))
        await o.put(u, d);
      a.put(e.serialize(), $e.Schema), r && i ? c.put(
        {
          snapshot: r,
          updatedAt: Date.now(),
          id: i
        },
        i
      ) : (r || i) && console.error("sessionStateSnapshot and instanceId must be provided together");
    });
  }
  async pruneSessions() {
    await this.tx("readwrite", [$e.SessionState], async (e) => {
      const n = e.objectStore($e.SessionState), i = (await n.getAll()).sort((s, o) => s.updatedAt - o.updatedAt);
      if (i.length < 10) {
        await e.done;
        return;
      }
      const r = i.slice(0, i.length - 10);
      for (const { id: s } of r)
        await n.delete(s);
    });
  }
  async getAsset(e) {
    return await this.tx("readonly", [$e.Assets], async (n) => await n.objectStore($e.Assets).get(e));
  }
  async storeAsset(e, n) {
    await this.tx("readwrite", [$e.Assets], async (i) => {
      await i.objectStore($e.Assets).put(n, e);
    });
  }
};
/** @internal */
S(Gl, "connectedInstances", /* @__PURE__ */ new Set());
let kg = Gl;
function yS() {
  const t = JSON.parse(gx(s4) || "[]") ?? [];
  return Array.isArray(t) ? t : [];
}
function pK(t) {
  const e = new Set(yS());
  e.add(t), px(s4, JSON.stringify([...e]));
}
function fK() {
  window.alert(
    `Oops! We could not save changes to your browser's storage. We now need to reload the page and try again.

Keep seeing this message?
• If you're using tldraw in a private or "incognito" window, try loading tldraw in a regular window or in a different browser.
• If your hard disk is full, try clearing up some space and then reload the page.`
  );
}
function MK() {
  window.alert(
    `Oops! We could not access your browser's storage—and the app won't work correctly without that. We now need to reload the page and try again.

Keep seeing this message?
• If you're using tldraw in a private or "incognito" window, try loading tldraw in a regular window or in a different browser.`
  );
}
const mK = 350, yK = 1e4, Sw = Symbol("UPDATE_INSTANCE_STATE"), IK = (t) => t;
class xK {
  constructor(e) {
    S(this, "onmessage");
  }
  postMessage(e) {
  }
  close() {
  }
}
const SK = typeof BroadcastChannel > "u" ? xK : BroadcastChannel;
class jK {
  constructor(e, {
    persistenceKey: n,
    sessionId: i = zg,
    onLoad: r,
    onLoadError: s
  }, o = new SK(`tldraw-tab-sync-${n}`)) {
    S(this, "disposables", /* @__PURE__ */ new Set());
    S(this, "diffQueue", []);
    S(this, "didDispose", !1);
    S(this, "shouldDoFullDBWrite", !0);
    S(this, "isReloading", !1);
    S(this, "persistenceKey");
    S(this, "sessionId");
    S(this, "serializedSchema");
    S(this, "isDebugging", !1);
    S(this, "documentTypes");
    S(this, "$sessionStateSnapshot");
    /** @internal */
    S(this, "db");
    S(this, "initTime", Date.now());
    S(this, "isPersisting", !1);
    S(this, "didLastWriteError", !1);
    // eslint-disable-next-line no-restricted-globals
    S(this, "scheduledPersistTimeout", null);
    this.store = e, this.channel = o, typeof window < "u" && (window.tlsync = this), this.persistenceKey = n, this.sessionId = i, this.db = new kg(n), this.disposables.add(() => this.db.close()), this.serializedSchema = this.store.schema.serialize(), this.$sessionStateSnapshot = sS(this.store), this.disposables.add(
      // Set up a subscription to changes from the store: When
      // the store changes (and if the change was made by the user)
      // then immediately send the diff to other tabs via postMessage
      // and schedule a persist.
      e.listen(
        ({ changes: a }) => {
          this.diffQueue.push(a), this.channel.postMessage(
            IK({
              type: "diff",
              storeId: this.store.id,
              changes: a,
              schema: this.serializedSchema
            })
          ), this.schedulePersist();
        },
        { source: "user", scope: "document" }
      )
    ), this.disposables.add(
      e.listen(
        () => {
          this.diffQueue.push(Sw), this.schedulePersist();
        },
        { scope: "session" }
      )
    ), this.connect(r, s), this.documentTypes = new Set(
      Object.values(this.store.schema.types).filter((a) => a.scope === "document").map((a) => a.typeName)
    );
  }
  debug(...e) {
    this.isDebugging && console.debug(...e);
  }
  async connect(e, n) {
    this.debug("connecting");
    let i;
    try {
      i = await this.db.load({ sessionId: this.sessionId });
    } catch (r) {
      n(r), MK();
      return;
    }
    if (this.debug("loaded data from store", i, "didDispose", this.didDispose), !this.didDispose)
      try {
        if (i) {
          const r = Object.fromEntries(i.records.map((a) => [a.id, a])), s = i.sessionStateSnapshot ?? mV(r), o = this.store.schema.migrateStoreSnapshot({
            store: r,
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            schema: i.schema ?? this.store.schema.serializeEarliestVersion()
          });
          if (o.type === "error") {
            console.error("failed to migrate store", o), n(new Error(`Failed to migrate store: ${o.reason}`));
            return;
          }
          this.store.mergeRemoteChanges(() => {
            this.store.put(
              Object.values(o.value).filter((a) => this.documentTypes.has(a.typeName)),
              "initialize"
            );
          }), s && Hy(this.store, s);
        }
        this.channel.onmessage = ({ data: r }) => {
          var a, c;
          this.debug("got message", r);
          const s = r, o = this.store.schema.getMigrationsSince(s.schema);
          if (o.ok) {
            if (o.value.length > 0) {
              this.debug("telling them to reload"), this.channel.postMessage({ type: "announce", schema: this.serializedSchema }), this.shouldDoFullDBWrite = !0, this.persistIfNeeded();
              return;
            }
          } else {
            if (Date.now() - this.initTime < 5e3) {
              n(new Error("Schema mismatch, please close other tabs and reload the page"));
              return;
            }
            this.debug("reloading"), this.isReloading = !0, (c = (a = window == null ? void 0 : window.location) == null ? void 0 : a.reload) == null || c.call(a);
            return;
          }
          s.type === "diff" && (this.debug("applying diff"), Qr(() => {
            this.store.mergeRemoteChanges(() => {
              this.store.applyDiff(s.changes), this.store.ensureStoreIsUsable();
            });
          }));
        }, this.channel.postMessage({ type: "announce", schema: this.serializedSchema }), this.disposables.add(() => {
          this.channel.close();
        }), e(this);
      } catch (r) {
        if (this.debug("error loading data from store", r), this.didDispose) return;
        n(r);
        return;
      }
  }
  close() {
    this.debug("closing"), this.didDispose = !0, this.disposables.forEach((e) => e());
  }
  /**
   * Schedule a persist. Persists don't happen immediately: they are throttled to avoid writing too
   * often, and will retry if failed.
   *
   * @internal
   */
  schedulePersist() {
    this.debug("schedulePersist", this.scheduledPersistTimeout), !this.scheduledPersistTimeout && (this.scheduledPersistTimeout = setTimeout(
      () => {
        this.scheduledPersistTimeout = null, this.persistIfNeeded();
      },
      this.didLastWriteError ? yK : mK
    ));
  }
  /**
   * Persist to IndexedDB only under certain circumstances:
   *
   * - If we're not already persisting
   * - If we're not reloading the page
   * - And we have something to persist (a full db write scheduled or changes in the diff queue)
   *
   * @internal
   */
  persistIfNeeded() {
    this.debug("persistIfNeeded", {
      isPersisting: this.isPersisting,
      isReloading: this.isReloading,
      shouldDoFullDBWrite: this.shouldDoFullDBWrite,
      diffQueueLength: this.diffQueue.length,
      storeIsPossiblyCorrupt: this.store.isPossiblyCorrupted()
    }), this.scheduledPersistTimeout && (clearTimeout(this.scheduledPersistTimeout), this.scheduledPersistTimeout = null), !this.isPersisting && (this.isReloading || this.store.isPossiblyCorrupted() || (this.shouldDoFullDBWrite || this.diffQueue.length > 0) && this.doPersist());
  }
  /**
   * Actually persist to IndexedDB. If the write fails, then we'll retry with a full db write after
   * a short delay.
   */
  async doPersist() {
    if (ct(!this.isPersisting, "persist already in progress"), this.didDispose) return;
    this.isPersisting = !0, this.debug("doPersist start");
    const e = this.diffQueue;
    this.diffQueue = [];
    try {
      if (this.shouldDoFullDBWrite)
        this.shouldDoFullDBWrite = !1, await this.db.storeSnapshot({
          schema: this.store.schema,
          snapshot: this.store.serialize(),
          sessionId: this.sessionId,
          sessionStateSnapshot: this.$sessionStateSnapshot.get()
        });
      else {
        const n = Px(
          e.filter((i) => i !== Sw)
        );
        await this.db.storeChanges({
          changes: n,
          schema: this.store.schema,
          sessionId: this.sessionId,
          sessionStateSnapshot: this.$sessionStateSnapshot.get()
        });
      }
      this.didLastWriteError = !1;
    } catch (n) {
      this.shouldDoFullDBWrite = !0, this.didLastWriteError = !0, console.error("failed to store changes in indexed db", n), fK(), typeof window < "u" && window.location.reload();
    }
    this.isPersisting = !1, this.debug("doPersist end"), this.schedulePersist();
  }
}
function a4(t) {
  const e = le(t), [n, i] = pe(t);
  n !== e.current && i(e.current);
  const r = re((s) => {
    typeof s == "function" ? e.current = s(e.current) : e.current = s, i(e.current);
  }, []);
  return [n, r];
}
function DK(t) {
  const [e, n] = a4({ status: "loading" });
  return t = wc(t), ze(() => {
    const { persistenceKey: i, sessionId: r, ...s } = t;
    if (!i) {
      n({
        status: "not-synced",
        store: Lg(s)
      });
      return;
    }
    n({ status: "loading" });
    const o = new hr(), a = {
      upload: async (h, g) => (await u.db.storeAsset(h.id, g), h.id),
      resolve: async (h) => h.props.src ? h.props.src.startsWith("asset:") ? await o.get(h, async () => {
        const g = await u.db.getAsset(h.id);
        return g ? URL.createObjectURL(g) : null;
      }) : h.props.src : null,
      ...s.assets
    }, c = Lg({ ...s, assets: a });
    let d = !1;
    const u = new jK(c, {
      sessionId: r,
      persistenceKey: i,
      onLoad() {
        d || n({ store: c, status: "synced-local" });
      },
      onLoadError(h) {
        d || n({ status: "error", error: h });
      }
    });
    return () => {
      d = !0, u.close();
    };
  }, [t, n]), e;
}
function wK() {
  const t = Q(), e = qt();
  N.useEffect(() => {
    const n = (s) => e.style.setProperty("--tl-zoom", s.toString()), i = lp(n, 100), r = new xc("useZoomCss", () => {
      t.getCurrentPageShapeIds().size < 300 ? n(t.getZoomLevel()) : i(t.getZoomLevel());
    });
    return r.attach(), r.execute(), () => {
      r.detach(), i.cancel();
    };
  }, [t, e]);
}
function nI(t) {
  const e = new ArrayBuffer(t.length), n = new Uint8Array(e);
  for (let i = 0, r = t.length; i < r; i++)
    n[i] = t.charCodeAt(i);
  return e;
}
function NK(t) {
  const e = atob(t), n = nI(e);
  return crypto.subtle.importKey(
    "spki",
    new Uint8Array(n),
    {
      name: "ECDSA",
      namedCurve: "P-256"
    },
    !0,
    ["verify"]
  );
}
const AK = 5, jl = {
  ANNUAL_LICENSE: 1,
  PERPETUAL_LICENSE: 2,
  INTERNAL_LICENSE: 4,
  WITH_WATERMARK: 8
}, TK = Math.max(...Object.values(jl)), Dl = {
  ID: 0,
  HOSTS: 1,
  FLAGS: 2,
  EXPIRY_DATE: 3
}, bK = Object.keys(Dl).length, PM = "sales@tldraw.com", vK = `${Hs()}/watermarks/watermark-track.svg`;
class Qp {
  constructor(e, n, i) {
    S(this, "publicKey", "MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEHJh0uUfxHtCGyerXmmatE368Hd9rI6LH9oPDQihnaCryRFWEVeOvf9U/SPbyxX74LFyJs5tYeAHq5Nc0Ax25LQ");
    S(this, "isDevelopment");
    S(this, "isTest");
    S(this, "isCryptoAvailable");
    S(this, "state", xt(
      "license state",
      "pending"
    ));
    S(this, "verbose", !0);
    this.isTest = process.env.NODE_ENV === "test", this.isDevelopment = this.getIsDevelopment(i), this.publicKey = n || this.publicKey, this.isCryptoAvailable = !!crypto.subtle, this.getLicenseFromKey(e).then((r) => {
      const s = EK(r);
      !this.isDevelopment && s && gr(vK), s ? this.state.set("unlicensed") : r.isLicensedWithWatermark ? this.state.set("licensed-with-watermark") : this.state.set("licensed");
    });
  }
  getIsDevelopment(e) {
    return e === "development" ? !0 : e === "production" ? !1 : window.location.protocol !== "https:";
  }
  async extractLicenseKey(e) {
    const [n, i] = e.split("."), [r, s] = n.split("/");
    if (!r.startsWith("tldraw-"))
      throw new Error(`Unsupported prefix '${r}'`);
    const o = await NK(this.publicKey);
    let a;
    try {
      a = await crypto.subtle.verify(
        {
          name: "ECDSA",
          hash: { name: "SHA-256" }
        },
        o,
        new Uint8Array(nI(atob(i))),
        new Uint8Array(nI(atob(s)))
      );
    } catch (d) {
      throw console.error(d), new Error("Could not perform signature validation");
    }
    if (!a)
      throw new Error("Invalid signature");
    let c;
    try {
      c = JSON.parse(atob(s));
    } catch {
      throw new Error("Could not parse object");
    }
    return c.length > bK && this.outputMessages([
      "License key contains some unknown properties.",
      "You may want to update tldraw packages to a newer version to get access to new functionality."
    ]), {
      id: c[Dl.ID],
      hosts: c[Dl.HOSTS],
      flags: c[Dl.FLAGS],
      expiryDate: c[Dl.EXPIRY_DATE]
    };
  }
  async getLicenseFromKey(e) {
    if (!e)
      return this.isDevelopment || this.outputNoLicenseKeyProvided(), { isLicenseParseable: !1, reason: "no-key-provided" };
    if (this.isDevelopment && !this.isCryptoAvailable)
      return this.verbose && (console.log(
        "tldraw: you seem to be in a development environment that does not support crypto. License not verified."
      ), console.log("You should check that this works in production separately.")), { isLicenseParseable: !1, reason: "has-key-development-mode" };
    let n = e.replace(/[\u200B-\u200D\uFEFF]/g, "");
    n = n.replace(/\r?\n|\r/g, "");
    try {
      const i = await this.extractLicenseKey(n), r = new Date(i.expiryDate), s = this.isFlagEnabled(i.flags, jl.ANNUAL_LICENSE), o = this.isFlagEnabled(i.flags, jl.PERPETUAL_LICENSE), a = {
        license: i,
        isLicenseParseable: !0,
        isDevelopment: this.isDevelopment,
        isDomainValid: this.isDomainValid(i),
        expiryDate: r,
        isAnnualLicense: s,
        isAnnualLicenseExpired: s && this.isAnnualLicenseExpired(r),
        isPerpetualLicense: o,
        isPerpetualLicenseExpired: o && this.isPerpetualLicenseExpired(r),
        isInternalLicense: this.isFlagEnabled(i.flags, jl.INTERNAL_LICENSE),
        isLicensedWithWatermark: this.isFlagEnabled(i.flags, jl.WITH_WATERMARK)
      };
      return this.outputLicenseInfoIfNeeded(a), a;
    } catch (i) {
      return this.outputInvalidLicenseKey(i.message), { isLicenseParseable: !1, reason: "invalid-license-key" };
    }
  }
  isDomainValid(e) {
    const n = window.location.hostname.toLowerCase();
    return e.hosts.some((i) => {
      const r = i.toLowerCase().trim();
      if (r === n || `www.${r}` === n || r === `www.${n}` || i === "*")
        return !0;
      if (i.includes("*")) {
        const s = new RegExp(i.replace(/\*/g, ".*?"));
        return s.test(n) || s.test(`www.${n}`);
      }
      return !1;
    });
  }
  getExpirationDateWithoutGracePeriod(e) {
    return new Date(e.getFullYear(), e.getMonth(), e.getDate());
  }
  getExpirationDateWithGracePeriod(e) {
    return new Date(
      e.getFullYear(),
      e.getMonth(),
      e.getDate() + AK + 1
      // Add 1 day to include the expiration day
    );
  }
  isAnnualLicenseExpired(e) {
    const n = this.getExpirationDateWithGracePeriod(e), i = /* @__PURE__ */ new Date() >= n;
    return !i && /* @__PURE__ */ new Date() >= this.getExpirationDateWithoutGracePeriod(e) && this.outputMessages([
      "tldraw license is about to expire, you are in a grace period.",
      `Please reach out to ${PM} if you would like to renew your license.`
    ]), i;
  }
  isPerpetualLicenseExpired(e) {
    const n = this.getExpirationDateWithGracePeriod(e), i = {
      major: new Date(v0.major),
      minor: new Date(v0.minor)
    };
    return i.major >= n || i.minor >= n;
  }
  isFlagEnabled(e, n) {
    return (e & n) === n;
  }
  outputNoLicenseKeyProvided() {
  }
  outputInvalidLicenseKey(e) {
    this.outputMessages(["Invalid tldraw license key", `Reason: ${e}`]);
  }
  outputLicenseInfoIfNeeded(e) {
    e.isAnnualLicenseExpired && this.outputMessages([
      "Your tldraw license has expired!",
      `Please reach out to ${PM} to renew.`
    ]), !e.isDomainValid && !e.isDevelopment && this.outputMessages([
      "This tldraw license key is not valid for this domain!",
      `Please reach out to ${PM} if you would like to use tldraw on other domains.`
    ]), e.license.flags >= TK * 2 && this.outputMessages([
      "This tldraw license contains some unknown flags.",
      "You may want to update tldraw packages to a newer version to get access to new functionality."
    ]);
  }
  outputMessages(e) {
    if (!this.isTest && this.verbose) {
      this.outputDelimiter();
      for (const n of e)
        console.log(
          `%c${n}`,
          "color: white; background: crimson; padding: 2px; border-radius: 3px;"
        );
      this.outputDelimiter();
    }
  }
  outputDelimiter() {
    console.log(
      "%c-------------------------------------------------------------------",
      "color: white; background: crimson; padding: 2px; border-radius: 3px;"
    );
  }
}
S(Qp, "className", "tl-watermark_SEE-LICENSE");
function EK(t) {
  if (!t.isLicenseParseable || !t.isDomainValid && !t.isDevelopment) return !0;
  if (t.isPerpetualLicenseExpired || t.isAnnualLicenseExpired) {
    if (t.isInternalLicense)
      throw new Error("License: Internal license expired.");
    return !0;
  }
  return !1;
}
const c4 = Ii({}), CK = () => Vn(c4);
function zK({
  licenseKey: t,
  children: e
}) {
  const [n] = pe(() => new Qp(t));
  return /* @__PURE__ */ l.jsx(c4.Provider, { value: n, children: e });
}
function uo(t) {
  if (!t) throw Error("usePassThroughWheelEvents must be passed a ref");
  const e = qt();
  ze(() => {
    function n(r) {
      if (r.isSpecialRedispatchedEvent) return;
      Ke(r);
      const s = e.querySelector(".tl-canvas");
      if (!s) return;
      const o = new WheelEvent("wheel", r);
      o.isSpecialRedispatchedEvent = !0, s.dispatchEvent(o);
    }
    const i = t.current;
    if (i)
      return i.addEventListener("wheel", n, { passive: !1 }), () => {
        i.removeEventListener("wheel", n);
      };
  }, [e, t]);
}
const LK = '<svg xmlns="http://www.w3.org/2000/svg" width="3001" height="1000" fill="none"><path fill="#000" d="M590.656 300.449c0 49.706-40.294 90-90 90-49.705 0-90-40.294-90-90 0-49.705 40.295-90 90-90 49.706 0 90 40.295 90 90M569.431 719.011c-15.247 32.821-56.006 91.589-98.338 91.438-32.004-.115-38.642-30.904-17.414-50.856 17.381-16.337 28.246-48.075 31.995-72.719.415-2.728-1.556-5.197-4.272-5.679-39.666-7.04-70.746-40.877-70.746-83.417 0-48.23 38.983-87.329 87.07-87.329 39.936 0 70.172 22.237 83.369 52.397 18.839 43.055 7.117 115.733-11.664 156.165M2613.29 385.681V239.319c0-11.363 9.22-20.569 20.59-20.569h8.26c11.37 0 20.59 9.206 20.59 20.569v36.911c0 8.629 7 15.625 15.63 15.625h35.25c8.63 0 15.63-6.996 15.63-15.625v-36.911c0-11.363 9.22-20.569 20.59-20.569h8.17c11.37 0 20.59 9.206 20.59 20.569v146.362c0 11.363-9.22 20.569-20.59 20.569h-8.17c-11.37 0-20.59-9.206-20.59-20.569v-36.999c0-8.63-7-15.625-15.63-15.625h-35.25c-8.63 0-15.63 6.995-15.63 15.625v36.999c0 11.363-9.22 20.569-20.59 20.569h-8.26c-11.37 0-20.59-9.206-20.59-20.569M2391.97 239.319v146.362c0 11.348-9.16 20.569-20.49 20.569h-8.2c-11.33 0-20.49-9.221-20.49-20.569V239.319c0-11.348 9.16-20.569 20.49-20.569h8.2c11.33 0 20.49 9.221 20.49 20.569M2098.23 391.43l-42.69-146.361c-3.85-13.171 6.06-26.319 19.79-26.319h10.6c9.59 0 17.93 6.611 20.08 15.952l17.01 73.045c1.48 6.348 10.47 6.478 12.14.176l19.47-73.838c2.38-9.04 10.57-15.335 19.93-15.335h12.1c9.37 0 17.56 6.3 19.94 15.346l19.49 74.067c1.66 6.305 10.65 6.178 12.13-.171l17.09-73.294c2.15-9.339 10.49-15.948 20.08-15.948h10.53c13.72 0 23.63 13.141 19.79 26.31l-42.63 146.361c-2.56 8.789-10.63 14.829-19.79 14.829h-15.68c-9.12 0-17.16-5.98-19.76-14.709l-21.17-71.059c-1.77-5.948-10.19-5.957-11.97-.012l-21.33 71.071c-2.6 8.729-10.64 14.709-19.76 14.709h-15.59c-9.17 0-17.23-6.035-19.8-14.82M2443.23 218.75h118.59c11.38 0 20.62 9.195 20.62 20.557s-9.24 20.556-20.62 20.556h-24.79c-5.53 0-10 4.477-10 10v115.818c0 11.368-9.25 20.569-20.63 20.569h-7.65c-11.39 0-20.63-9.201-20.63-20.569V269.863c0-5.523-4.48-10-10-10h-24.89c-11.37 0-20.61-9.195-20.61-20.556s9.24-20.557 20.61-20.557M1174.15 218.75h24.64c8.35 0 15.88 5.042 19.04 12.764l34.61 83.942c2.13 5.161 9.44 5.155 11.56-.01l34.43-83.932a20.58 20.58 0 0 1 19.04-12.764h24.64c11.37 0 20.58 9.208 20.58 20.569v146.362c0 11.361-9.21 20.569-20.58 20.569h-7.09c-11.36 0-20.58-9.208-20.58-20.569l-.12-50.645c-.01-6.888-9.53-8.688-12.06-2.283l-23.46 59.332a20.57 20.57 0 0 1-19.14 13.009h-3.03a20.57 20.57 0 0 1-19.15-13.046l-23.47-59.68c-2.52-6.416-12.05-4.623-12.06 2.271l-.13 51.042c0 11.361-9.21 20.569-20.57 20.569h-7.1c-11.36 0-20.57-9.208-20.57-20.569V239.319c0-11.361 9.21-20.569 20.57-20.569"/><path fill="#000" fill-rule="evenodd" d="m1449.94 391.836 6.12-19.392a6.255 6.255 0 0 1 5.96-4.369l50.22-.061a6.24 6.24 0 0 1 5.96 4.348l6.23 19.486c2.71 8.581 10.71 14.402 19.74 14.402h9.34c14.13 0 24.15-13.791 19.61-27.151l-49.74-146.361c-2.85-8.37-10.74-13.988-19.61-13.988h-33.16c-8.87 0-16.77 5.618-19.61 13.988l-49.74 146.361c-4.54 13.36 5.48 27.151 19.61 27.151h9.32c9.04 0 17.04-5.827 19.75-14.414m31.1-98.858c1.85-5.807 10.08-5.796 11.91.016l8.83 27.916c1.28 4.028-1.73 8.134-5.96 8.134h-17.74c-4.23 0-7.24-4.119-5.95-8.151zM1681.81 406.25c18.91 0 35.39-3.686 49.36-11.168 13.97-7.544 24.73-18.394 32.24-32.489 7.56-14.105 11.29-30.866 11.29-50.182 0-19.256-3.73-35.957-11.29-50.004-7.57-14.094-18.35-24.912-32.32-32.397-13.91-7.545-30.4-11.26-49.37-11.26h-49.5c-11.38 0-20.63 9.201-20.63 20.569v146.362c0 11.368 9.25 20.569 20.63 20.569zm23.13-47.701c-6.62 3.215-14.85 4.886-24.79 4.886-10.49 0-19-8.507-19-19v-64.34c0-10.149 8.23-18.376 18.38-18.376 10.18 0 18.56 1.703 25.23 4.974 6.59 3.149 11.63 8.315 15.08 15.633 3.45 7.269 5.28 17.268 5.28 30.162 0 12.891-1.82 22.951-5.28 30.347-3.39 7.319-8.36 12.509-14.9 15.714" clip-rule="evenodd"/><path fill="#000" d="M1804.21 385.681V239.319c0-11.361 9.21-20.569 20.58-20.569h91.28c11.36 0 20.57 9.202 20.57 20.557s-9.21 20.556-20.57 20.556h-54.64a7.807 7.807 0 0 0-7.81 7.813v16.366a7.806 7.806 0 0 0 7.81 7.812h48.13c11.37 0 20.58 9.246 20.58 20.602s-9.21 20.601-20.58 20.601h-48.13a7.806 7.806 0 0 0-7.81 7.812v16.455a7.807 7.807 0 0 0 7.81 7.813h54.64c11.36 0 20.57 9.202 20.57 20.556s-9.21 20.557-20.57 20.557h-91.28c-11.37 0-20.58-9.208-20.58-20.569"/><path fill="#000" fill-rule="evenodd" d="M2875.5 68.75h-2750c-31.066 0-56.25 25.184-56.25 56.25v750c0 31.066 25.184 56.25 56.25 56.25h2750c31.07 0 56.25-25.184 56.25-56.25V125c0-31.066-25.18-56.25-56.25-56.25M125.5 0C56.464 0 .5 55.964.5 125v750c0 69.036 55.965 125 125 125h2750c69.04 0 125-55.964 125-125V125c0-69.036-55.96-125-125-125z" clip-rule="evenodd"/><path fill="#000" d="M2476.06 804.813c-10.54 0-19.82-6.947-22.81-17.068L2390.79 575.7c-4.49-15.248 6.92-30.534 22.8-30.534h27.75c11.1 0 20.72 7.686 23.18 18.52L2489 671.402c2.07 9.093 14.93 9.321 17.32.308l28.83-108.844c2.76-10.435 12.19-17.7 22.98-17.7h25.17c10.8 0 20.25 7.293 22.99 17.755l28.27 107.739c2.36 9.001 15.18 8.829 17.3-.232l25.01-106.888c2.51-10.763 12.1-18.374 23.14-18.374h27.87c15.88 0 27.29 15.286 22.8 30.534l-62.46 212.045a23.78 23.78 0 0 1-22.81 17.068h-32.12c-10.39 0-19.58-6.763-22.69-16.696l-32.08-102.694c-2.62-8.397-14.51-8.331-17.04.095l-30.74 102.346c-3.02 10.061-12.27 16.949-22.76 16.949zM1742.44 804.813h-75.81c-13.09 0-23.71-10.656-23.71-23.801V568.967c0-13.145 10.62-23.801 23.71-23.801h74.8c26.6 0 49.59 5.198 68.95 15.594 19.45 10.312 34.44 25.187 44.96 44.627 10.61 19.355 15.91 42.556 15.91 69.602q0 40.57-15.78 69.73c-10.53 19.355-25.43 34.231-44.71 44.627-19.28 10.311-42.05 15.467-68.32 15.467m-29.3-83.642c0 13.145 10.61 23.801 23.71 23.801h3.06c12.8 0 23.7-2.07 32.71-6.212 9.09-4.141 16-11.283 20.71-21.426q7.2-15.213 7.2-42.345 0-27.13-7.32-42.344c-4.8-10.143-11.87-17.285-21.22-21.426-9.26-4.142-20.63-6.212-34.1-6.212h-1.04c-13.1 0-23.71 10.656-23.71 23.801zM1460.86 804.813c-13.12 0-23.76-10.656-23.76-23.801V568.967c0-13.145 10.64-23.801 23.76-23.801h22.84c13.13 0 23.76 10.656 23.76 23.801v155.247c0 13.145 10.64 23.801 23.76 23.801h57.27c13.12 0 23.76 10.656 23.76 23.801v9.196c0 13.145-10.64 23.801-23.76 23.801zM1204.45 601.964c-13.13 0-23.77-10.656-23.77-23.801v-9.196c0-13.145 10.64-23.801 23.77-23.801h177.89c13.13 0 23.78 10.656 23.78 23.801v9.196c0 13.145-10.65 23.801-23.78 23.801h-39.38c-8.21 0-14.86 6.66-14.86 14.875v164.173c0 13.145-10.64 23.801-23.78 23.801h-21.85c-13.13 0-23.78-10.656-23.78-23.801V616.839c0-8.215-6.65-14.875-14.86-14.875z"/><path fill="#000" fill-rule="evenodd" d="M2223.05 787.891c-3.02 10.047-12.27 16.922-22.74 16.922h-25.43c-16.19 0-27.64-15.862-22.57-31.261l69.88-212.045c3.21-9.753 12.31-16.341 22.56-16.341h61.84c10.25 0 19.35 6.588 22.56 16.341l69.87 212.045c5.08 15.399-6.37 31.261-22.56 31.261h-25.43c-10.48 0-19.72-6.875-22.74-16.922l-6.7-22.2a14.84 14.84 0 0 0-14.21-10.576h-63.42c-6.55 0-12.32 4.296-14.22 10.576zm76.13-96.945-14.13-48.436c-2.46-8.451-14.36-8.602-17.04-.217l-15.46 48.436c-1.84 5.759 2.45 11.645 8.48 11.645h29.6c5.94 0 10.22-5.715 8.55-11.428" clip-rule="evenodd"/><path fill="#000" d="M1939.6 804.813c-13.13 0-23.77-10.656-23.77-23.801V568.967c0-13.145 10.64-23.801 23.77-23.801h88.13c19.24 0 36.08 3.508 50.51 10.523s25.65 17.115 33.67 30.3q12.03 19.779 12.03 47.416c0 18.595-4.14 34.273-12.41 47.036-7.64 11.913-18.18 21.101-31.63 27.564-16.98 8.159-36 11.104-54.7 11.104h-43.07c-76.56 0 4.08-135.84 4.08-84.706v7.996c0 12.117 9.81 21.941 21.91 21.941 8.12 0 16.3-.345 24.04-3.043 5.91-2.113 10.43-5.451 13.55-10.015 3.2-4.565 4.81-10.523 4.81-17.877 0-7.437-1.61-13.481-4.81-18.129-3.12-4.733-7.64-8.199-13.55-10.396-7.05-2.766-14.67-3.423-22.18-3.423-13.13 0-23.77 10.656-23.77 23.801v47.71c0 11.825 11.14 16.003 19.91 20.752 12.31 6.671 7.58 25.389-6.42 25.389-7.45 0-13.49 6.048-13.49 13.508v48.395c0 13.145-10.63 23.801-23.76 23.801zm134.89-106.758 5.41 9.95 33.51 61.622c8.62 15.86-2.84 35.186-20.87 35.186h-22.27c-8.74 0-16.77-4.798-20.92-12.496l-35.05-65.04a15.52 15.52 0 0 0-13.66-8.168c-42.24 0 40.62-82.154 73.85-21.054M931.652 0h68.748v1000h-68.748z"/></svg>', kK = '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="1601" fill="none"><path fill="#000" d="M72 1319.8c0-10.73 7.071-20.18 17.372-23.22l215.823-63.62c15.519-4.57 31.078 7.05 31.078 23.22v28.26c0 11.31-7.824 21.1-18.85 23.61l-109.636 24.94c-9.254 2.1-9.487 15.2-.313 17.63l110.784 29.37a24.21 24.21 0 0 1 18.015 23.4v25.64c0 11-7.423 20.62-18.071 23.41l-109.659 28.79c-9.162 2.41-8.986 15.47.236 17.63l108.792 25.46c10.955 2.56 18.702 12.33 18.702 23.57v28.39c0 16.17-15.559 27.79-31.078 23.22l-215.823-63.62c-10.3-3.04-17.372-12.49-17.372-23.22v-32.72c0-10.59 6.883-19.95 16.994-23.11l104.523-32.67c8.547-2.67 8.479-14.79-.096-17.36l-104.17-31.3C79.01 1372.42 72 1363 72 1352.31zM72 572.638V495.43c0-13.336 10.846-24.147 24.225-24.147h215.823c13.379 0 24.225 10.811 24.225 24.147v76.179q0 40.645-15.872 70.228-15.743 29.712-45.422 45.79-29.55 16.206-70.843 16.206-41.292 0-70.971-16.078-29.55-16.077-45.422-45.532Q72 612.767 72 572.638m85.132-29.84c-13.379 0-24.225 10.81-24.225 24.146v3.122q0 19.55 6.323 33.313 6.323 13.89 21.807 21.094 15.485 7.332 43.099 7.331t43.1-7.46q15.484-7.33 21.807-21.608 6.323-14.15 6.323-34.728v-1.064c0-13.336-10.846-24.146-24.225-24.146zM72 285.858c0-13.363 10.846-24.197 24.225-24.197h215.823c13.379 0 24.225 10.834 24.225 24.197v23.27c0 13.364-10.846 24.197-24.225 24.197H154.035c-13.379 0-24.225 10.834-24.225 24.197v58.328c0 13.364-10.846 24.197-24.225 24.197h-9.36C82.845 440.047 72 429.214 72 415.85zM278.463 24.72c0-13.374 10.846-24.216 24.225-24.216h9.36c13.379 0 24.225 10.842 24.225 24.216v181.174c0 13.374-10.846 24.216-24.225 24.216h-9.36c-13.379 0-24.225-10.842-24.225-24.216v-40.108c0-8.359-6.779-15.135-15.141-15.135H96.225c-13.38 0-24.225-10.842-24.225-24.216v-22.256c0-13.374 10.846-24.216 24.225-24.216h167.097c8.362 0 15.141-6.776 15.141-15.135z"/><path fill="#000" fill-rule="evenodd" d="M89.224 1062.13C78.997 1059.04 72 1049.63 72 1038.96v-25.9c0-16.486 16.145-28.147 31.818-22.979l215.823 71.169a24.19 24.19 0 0 1 16.632 22.98v62.97c0 10.45-6.706 19.71-16.632 22.98l-215.823 71.17C88.145 1246.51 72 1234.86 72 1218.37v-25.9c0-10.67 6.997-20.08 17.224-23.17l22.595-6.81a15.13 15.13 0 0 0 10.765-14.48v-64.59a15.13 15.13 0 0 0-10.765-14.48zm98.672 77.53 49.299-14.39c8.601-2.51 8.755-14.62.22-17.35l-49.299-15.75c-5.861-1.88-11.852 2.49-11.852 8.64v30.14c0 6.05 5.817 10.41 11.632 8.71" clip-rule="evenodd"/><path fill="#000" d="M72 773.439c0-13.367 10.846-24.203 24.225-24.203h215.823c13.379 0 24.225 10.836 24.225 24.203v89.762q0 29.395-10.711 51.439-10.71 22.046-30.84 34.293t-48.261 12.248q-28.388 0-47.873-12.635-18.187-11.672-28.056-32.218c-8.303-17.289-11.301-36.661-11.301-55.705v-43.867c0-77.976 138.26 4.16 86.215 4.16h-8.138c-12.334 0-22.332 9.989-22.332 22.311 0 8.269.351 16.6 3.097 24.487q3.225 9.024 10.194 13.794 6.968 4.899 18.194 4.899 11.356 0 18.453-4.899 7.226-4.77 10.581-13.794c2.815-7.188 3.484-14.944 3.484-22.596 0-13.366-10.846-24.202-24.225-24.202h-48.56c-12.036 0-16.288 11.345-21.122 20.272-6.79 12.539-25.841 7.72-25.841-6.536 0-7.586-6.156-13.736-13.749-13.736H96.225C82.845 820.916 72 810.08 72 796.714zm108.66 137.378-10.128 5.511-62.72 34.131C91.67 959.243 72 947.569 72 929.205V906.52a24.2 24.2 0 0 1 12.719-21.299l66.199-35.696a15.82 15.82 0 0 0 8.313-13.921c0-43.012 83.618 41.371 21.429 75.213"/></svg>';
function OK(t) {
  return G("watermarkState", () => t.state.get(), [t]);
}
const PK = `data:image/svg+xml;utf8,${encodeURIComponent(LK)}`, UK = `data:image/svg+xml;utf8,${encodeURIComponent(kK)}`, RK = _e(function() {
  const e = CK(), n = Q(), i = G("is mobile", () => n.getViewportScreenBounds().width < 700, [
    n
  ]), r = OK(e);
  return ["licensed-with-watermark", "unlicensed"].includes(r) ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(QK, {}),
    /* @__PURE__ */ l.jsx(YK, { src: i ? UK : PK })
  ] }) : null;
}), YK = _e(function({ src: e }) {
  const n = Q(), i = G("debug mode", () => n.getInstanceState().isDebugMode, [n]), r = G("is mobile", () => n.getViewportScreenBounds().width < 700, [
    n
  ]), s = $x(), o = le(null);
  uo(o);
  const a = `url('${e}') center 100% / 100% no-repeat`, c = "https://tldraw.dev";
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: o,
      className: Qp.className,
      "data-debug": i,
      "data-mobile": r,
      draggable: !1,
      ...s,
      children: mt.isWebview ? /* @__PURE__ */ l.jsx(
        "a",
        {
          draggable: !1,
          role: "button",
          onPointerDown: (d) => {
            Yt(d), Ke(d);
          },
          onClick: () => bp.openWindow(c, "_blank"),
          style: { mask: a, WebkitMask: a }
        }
      ) : /* @__PURE__ */ l.jsx(
        "a",
        {
          href: c,
          target: "_blank",
          rel: "noreferrer",
          draggable: !1,
          onPointerDown: (d) => {
            Yt(d);
          },
          style: { mask: a, WebkitMask: a }
        }
      )
    }
  );
}), QK = _e(function() {
  const e = Qp.className, n = `/* ------------------- SEE LICENSE -------------------
The tldraw watermark is part of tldraw's license. It is shown for unlicensed
or "licensed-with-watermark" users. By using this library, you agree to
preserve the watermark's behavior, keeping it visible, unobscured, and
available to user-interaction.

To remove the watermark, please purchase a license at tldraw.dev.
*/

	.${e} {
		position: absolute;
		bottom: var(--space-2);
		right: var(--space-2);
		width: 96px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: var(--layer-watermark) !important;
		background-color: color-mix(in srgb, var(--color-background) 62%, transparent);
		opacity: 1;
		border-radius: 5px;
		pointer-events: all;
		padding: 2px;
		box-sizing: content-box;
	}

	.${e} > a {
		position: absolute;
		width: 96px;
		height: 32px;
		pointer-events: all;
		cursor: inherit;
		color: var(--color-text);
		opacity: .38;
		background-color: currentColor;
	}

	.${e}[data-debug='true'] {
		bottom: 46px;
	}

	.${e}[data-mobile='true'] {
		border-radius: 4px 0px 0px 4px;
		right: -2px;
		width: 8px;
		height: 48px;
	}

	.${e}[data-mobile='true'] > a {
		width: 8px;
		height: 32px;
	}

	@media (hover: hover) {
		.${e} > a {
			pointer-events: none;
		}

		.${e}:hover {
			background-color: var(--color-background);
			transition: background-color 0.2s ease-in-out;
			transition-delay: 0.32s;
		}

		.${e}:hover > a {
			animation: delayed_link 0.2s forwards ease-in-out;
			animation-delay: 0.32s;
		}
	}

	@keyframes delayed_link {
		0% {
			cursor: inherit;
			opacity: .38;
			pointer-events: none;
		}
		100% {
			cursor: pointer;
			opacity: 1;
			pointer-events: all;
		}
	}`;
  return /* @__PURE__ */ l.jsx("style", { children: n });
}), ZK = [], FK = [], BK = [], GK = "tl-container", WK = _e(function({
  store: e,
  components: n,
  className: i,
  user: r,
  options: s,
  ...o
}) {
  const [a, c] = pe(null), d = yt(() => r ?? qv(), [r]), u = (n == null ? void 0 : n.ErrorFallback) === void 0 ? Fv : n == null ? void 0 : n.ErrorFallback, h = {
    ...o,
    shapeUtils: o.shapeUtils ?? ZK,
    bindingUtils: o.bindingUtils ?? FK,
    tools: o.tools ?? BK,
    components: n,
    options: wc(s)
  };
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: c,
      "data-tldraw": fv,
      draggable: !1,
      className: ce(`${GK} tl-theme__light`, i),
      onPointerDown: Yt,
      tabIndex: -1,
      children: /* @__PURE__ */ l.jsx(
        ql,
        {
          fallback: u,
          onError: (g) => lx(g, { tags: { origin: "react.tldraw-before-app" } }),
          children: a && /* @__PURE__ */ l.jsx(zK, { licenseKey: o.licenseKey, children: /* @__PURE__ */ l.jsx(_W, { container: a, children: /* @__PURE__ */ l.jsx(nV, { overrides: n, children: e ? e instanceof Ux ? (
            // Store is ready to go, whether externally synced or not
            /* @__PURE__ */ l.jsx(d4, { ...h, store: e, user: d })
          ) : (
            // Store is a synced store, so handle syncing stages internally
            /* @__PURE__ */ l.jsx(l4, { ...h, store: e, user: d })
          ) : (
            // We have no store (it's undefined) so create one and possibly sync it
            /* @__PURE__ */ l.jsx(HK, { ...h, store: e, user: d })
          ) }) }) })
        }
      )
    }
  );
});
function HK(t) {
  const {
    defaultName: e,
    snapshot: n,
    initialData: i,
    shapeUtils: r,
    bindingUtils: s,
    persistenceKey: o,
    sessionId: a,
    user: c,
    assets: d
  } = t, u = DK({
    shapeUtils: r,
    bindingUtils: s,
    initialData: i,
    persistenceKey: o,
    sessionId: a,
    defaultName: e,
    snapshot: n,
    assets: d
  });
  return /* @__PURE__ */ l.jsx(l4, { ...t, store: u, user: c });
}
const l4 = _e(function({
  store: e,
  user: n,
  ...i
}) {
  const r = qt();
  at(() => {
    n.userPreferences.get().colorScheme === "dark" && (r.classList.remove("tl-theme__light"), r.classList.add("tl-theme__dark"));
  }, [r, n]);
  const { LoadingScreen: s } = At();
  switch (e.status) {
    case "error":
      throw e.error;
    case "loading":
      return s ? /* @__PURE__ */ l.jsx(s, {}) : null;
  }
  return /* @__PURE__ */ l.jsx(d4, { ...i, store: e.store, user: n });
}), UM = () => document.location.search.includes("tldraw_preserve_focus");
function d4({
  onMount: t,
  children: e,
  store: n,
  tools: i,
  shapeUtils: r,
  bindingUtils: s,
  user: o,
  initialState: a,
  autoFocus: c = !0,
  inferDarkMode: d,
  cameraOptions: u,
  options: h,
  licenseKey: g,
  deepLinks: p,
  isShapeHidden: f
}) {
  const { ErrorFallback: M } = At(), m = qt(), [y, I] = a4(null), D = le(null), j = wc(p === !0 ? {} : p), w = le({
    // for these, it's because they're only used when the editor first mounts:
    autoFocus: c && !UM(),
    inferDarkMode: d,
    initialState: a,
    // for these, it's because we keep them up to date in a separate effect:
    cameraOptions: u,
    deepLinks: j
  });
  at(() => {
    w.current = {
      autoFocus: c && !UM(),
      inferDarkMode: d,
      initialState: a,
      cameraOptions: u,
      deepLinks: j
    };
  }, [c, d, a, u, j]), at(
    () => {
      const { autoFocus: T, inferDarkMode: E, initialState: v, cameraOptions: P, deepLinks: C } = w.current, z = new de({
        store: n,
        shapeUtils: r,
        bindingUtils: s,
        tools: i,
        getContainer: () => m,
        user: o,
        initialState: v,
        // we should check for some kind of query parameter that turns off autofocus
        autoFocus: T,
        inferDarkMode: E,
        cameraOptions: P,
        options: h,
        licenseKey: g,
        isShapeHidden: f
      });
      return z.updateViewportScreenBounds(D.current ?? m), C && (C != null && C.getUrl ? z.navigateToDeepLink({ ...C, url: C.getUrl(z) }) : z.navigateToDeepLink(C)), I(z), () => {
        z.dispose();
      };
    },
    // if any of these change, we need to recreate the editor.
    [
      s,
      m,
      h,
      r,
      n,
      i,
      o,
      I,
      g,
      f
    ]
  ), at(() => {
    if (y && j)
      return y.registerDeepLinkListener(j);
  }, [y, j]), at(() => {
    y && u && y.setCameraOptions(u);
  }, [y, u]);
  const A = PA(
    re(
      (T) => y ? (y.on("crash", T), () => y.off("crash", T)) : () => {
      },
      [y]
    ),
    () => (y == null ? void 0 : y.getCrashingError()) ?? null
  );
  ze(
    function() {
      if (!y) return;
      function E() {
        y && y.focus();
      }
      function v() {
        y && y.blur();
      }
      if (c && UM())
        return y.getContainer().addEventListener("pointerdown", E), document.body.addEventListener("pointerdown", v), () => {
          var P;
          (P = y.getContainer()) == null || P.removeEventListener("pointerdown", E), document.body.removeEventListener("pointerdown", v);
        };
    },
    [y, c]
  );
  const { Canvas: b } = At();
  return y ? (
    // the top-level tldraw component also renders an error boundary almost
    // identical to this one. the reason we have two is because this one has
    // access to `App`, which means that here we can enrich errors with data
    // from app for reporting, and also still attempt to render the user's
    // document in the event of an error to reassure them that their work is
    // not lost.
    /* @__PURE__ */ l.jsx(ql, {
      fallback: M,
      onError: (T) => y.annotateError(T, { origin: "react.tldraw", willCrashApp: !0 }),
      children: A ? /* @__PURE__ */ l.jsx(KK, { crashingError: A }) : /* @__PURE__ */ l.jsx(Jx, { editor: y, children: /* @__PURE__ */ l.jsxs(VK, { onMount: t, children: [
        e ?? (b ? /* @__PURE__ */ l.jsx(b, {}) : null),
        /* @__PURE__ */ l.jsx(RK, {})
      ] }) })
    })
  ) : /* @__PURE__ */ l.jsx("div", { className: "tl-canvas", ref: D });
}
function VK({ children: t, onMount: e }) {
  return wK(), X7(), J7(), q7(), h4((n) => {
    const i = n.store.props.onMount(n), r = e == null ? void 0 : e(n);
    return () => {
      i == null || i(), r == null || r();
    };
  }), t;
}
function KK({ crashingError: t }) {
  throw t;
}
function IS({ children: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: "tl-loading", children: t });
}
function u4({ children: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: "tl-loading", children: t });
}
function h4(t) {
  const e = Q(), n = kp((i) => {
    let r;
    return i.run(
      () => {
        r = t == null ? void 0 : t(i), i.emit("mount");
      },
      { history: "ignore" }
    ), window.tldrawReady = !0, r;
  });
  Ye.useLayoutEffect(() => {
    if (e) return n == null ? void 0 : n(e);
  }, [e, n]);
}
function qs({ children: t, className: e = "", ...n }) {
  return /* @__PURE__ */ l.jsx("div", { ...n, className: ce("tl-html-container", e), children: t });
}
class Nh {
  constructor(e) {
    this.editor = e;
  }
}
S(Nh, "props"), S(Nh, "migrations"), /**
 * The type of the binding util, which should match the binding's type.
 *
 * @public
 */
S(Nh, "type");
function Zp(t, e, n = {}) {
  const { newPoint: i, handle: r, scaleX: s, scaleY: o } = e, { minWidth: a = 1, maxWidth: c = 1 / 0, minHeight: d = 1, maxHeight: u = 1 / 0 } = n;
  let h = t.props.w * s, g = t.props.h * o;
  const p = new x(0, 0);
  if (h > 0) {
    if (h < a) {
      switch (r) {
        case "top_left":
        case "left":
        case "bottom_left": {
          p.x = h - a;
          break;
        }
        case "top":
        case "bottom": {
          p.x = (h - a) / 2;
          break;
        }
        default:
          p.x = 0;
      }
      h = a;
    }
  } else if (p.x = h, h = -h, h < a) {
    switch (r) {
      case "top_left":
      case "left":
      case "bottom_left": {
        p.x = -h;
        break;
      }
      default:
        p.x = -a;
    }
    h = a;
  }
  if (g > 0) {
    if (g < d) {
      switch (r) {
        case "top_left":
        case "top":
        case "top_right": {
          p.y = g - d;
          break;
        }
        case "right":
        case "left": {
          p.y = (g - d) / 2;
          break;
        }
        default:
          p.y = 0;
      }
      g = d;
    }
  } else if (p.y = g, g = -g, g < d) {
    switch (r) {
      case "top_left":
      case "top":
      case "top_right": {
        p.y = -g;
        break;
      }
      default:
        p.y = -d;
    }
    g = d;
  }
  const { x: f, y: M } = p.rot(t.rotation).add(i);
  return {
    ...t,
    x: f,
    y: M,
    props: {
      w: Math.min(c, h),
      h: Math.min(u, g)
    }
  };
}
class ho extends Ci {
  getGeometry(e) {
    return new Pi({
      width: e.props.w,
      height: e.props.h,
      isFilled: !0
    });
  }
  onResize(e, n) {
    return Zp(e, n);
  }
  getHandleSnapGeometry(e) {
    return {
      points: this.getGeometry(e).bounds.cornersAndCenter
    };
  }
  getInterpolatedProps(e, n, i) {
    return {
      ...n.props,
      w: et(e.props.w, n.props.w, i),
      h: et(e.props.h, n.props.h, i)
    };
  }
}
var Am;
let XK = (Am = class extends ee {
  onPointerDown(e) {
    this.parent.transition("pointing", e);
  }
  onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 });
  }
  onCancel() {
    this.editor.setCurrentTool("select");
  }
}, S(Am, "id", "idle"), Am);
var Tm;
let JK = (Tm = class extends ee {
  onPointerMove(e) {
    if (this.editor.inputs.isDragging) {
      const { originPagePoint: n } = this.editor.inputs, i = this.parent.shapeType, r = Ee(), s = this.editor.markHistoryStoppingPoint(`creating_box:${r}`);
      this.editor.createShapes([
        {
          id: r,
          type: i,
          x: n.x,
          y: n.y,
          props: {
            w: 1,
            h: 1
          }
        }
      ]).select(r);
      const o = this.parent;
      this.editor.setCurrentTool(
        "select.resizing",
        {
          ...e,
          target: "selection",
          handle: "bottom_right",
          isCreating: !0,
          creatingMarkId: s,
          creationCursorOffset: { x: 1, y: 1 },
          onInteractionEnd: this.parent.id,
          onCreate: o.onCreate ? (a) => {
            var c;
            return (c = o.onCreate) == null ? void 0 : c.call(o, a);
          } : void 0
        }
        /** satisfies ResizingInfo, defined in main tldraw package 😧 */
      );
    }
  }
  onPointerUp() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.complete();
  }
  onInterrupt() {
    this.cancel();
  }
  complete() {
    const { originPagePoint: e } = this.editor.inputs, n = this.parent.shapeType, i = Ee();
    this.editor.markHistoryStoppingPoint(`creating_box:${i}`), this.editor.createShapes([
      {
        id: i,
        type: n,
        x: e.x,
        y: e.y
      }
    ]);
    const r = this.editor.getShape(i);
    if (!r) {
      this.cancel();
      return;
    }
    let { w: s, h: o } = r.props;
    const a = new x(s / 2, o / 2), c = this.editor.getShapeParentTransform(r);
    c && a.rot(-c.rotation());
    let d = 1;
    this.editor.user.getIsDynamicResizeMode() && (d = 1 / this.editor.getZoomLevel(), s *= d, o *= d, a.mul(d));
    const u = Ct(r);
    u.x = r.x - a.x, u.y = r.y - a.y, u.props.w = s, u.props.h = o, "scale" in r.props && (u.props.scale = d), this.editor.updateShape(u), this.editor.setSelectedShapes([i]), this.editor.getInstanceState().isToolLocked ? this.parent.transition("idle") : this.editor.setCurrentTool("select.idle");
  }
  cancel() {
    this.parent.transition("idle");
  }
}, S(Tm, "id", "pointing"), Tm);
class iI extends ee {
  static children() {
    return [XK, JK];
  }
}
S(iI, "id", "box"), S(iI, "initial", "idle");
function qK(t, e, n) {
  const i = le(!1), r = re(
    (o) => {
      i.current = o, o ? ir.addOpenMenu(t) : ir.deleteOpenMenu(t), e == null || e(o);
    },
    [t, e]
  ), s = G("is menu open", () => ir.getOpenMenus().includes(t), [t]);
  return ze(() => (i.current && (n == null || n("open-menu"), ir.addOpenMenu(t)), () => {
    i.current && (ir.deleteOpenMenu(t), ir.getOpenMenus().forEach((o) => {
      o.startsWith(t) && (n == null || n("close-menu"), ir.deleteOpenMenu(o));
    }), i.current = !1);
  }), [t, n]), [s, r];
}
function Fp(t) {
  const e = Q();
  return G("isEditing", () => e.getEditingShapeId() === t, [e, t]);
}
function Kt(t) {
  const e = Q();
  return yt(
    function() {
      const r = (d) => {
        if (d.isKilled) return;
        if (d.button === _x) {
          e.dispatch({
            type: "pointer",
            target: "selection",
            handle: t,
            name: "right_click",
            ...gi(d)
          });
          return;
        }
        if (d.button !== 0) return;
        const u = Eg(d.currentTarget);
        function h() {
          u.removeEventListener("pointerup", h), Dc(u, d);
        }
        jc(u, d), u.addEventListener("pointerup", h), e.dispatch({
          name: "pointer_down",
          type: "pointer",
          target: "selection",
          handle: t,
          ...gi(d)
        }), Yt(d);
      };
      let s, o;
      function a(d) {
        d.isKilled || d.button === 0 && (d.clientX === s && d.clientY === o || (s = d.clientX, o = d.clientY, e.dispatch({
          name: "pointer_move",
          type: "pointer",
          target: "selection",
          handle: t,
          ...gi(d)
        })));
      }
      return {
        onPointerDown: r,
        onPointerMove: a,
        onPointerUp: (d) => {
          d.isKilled || d.button === 0 && e.dispatch({
            name: "pointer_up",
            type: "pointer",
            target: "selection",
            handle: t,
            ...gi(d)
          });
        }
      };
    },
    [e, t]
  );
}
function _K(t) {
  const [e, n] = pe(() => ({ store: Lg(t), opts: t }));
  if (!XA(e.opts, t)) {
    const i = { store: Lg(t), opts: t };
    return n(i), i.store;
  }
  return e.store;
}
const $K = 20, eX = 8;
function xS(t, e = $K) {
  return Math.max(eX, Math.ceil(t / e));
}
class ba extends lo {
  constructor(n) {
    super({ ...n, isFilled: !1, isClosed: !1 });
    S(this, "_center");
    S(this, "radius");
    S(this, "start");
    S(this, "end");
    S(this, "largeArcFlag");
    S(this, "sweepFlag");
    S(this, "measure");
    S(this, "angleStart");
    S(this, "angleEnd");
    const { center: i, sweepFlag: r, largeArcFlag: s, start: o, end: a } = n;
    if (o.equals(a)) throw Error("Arc must have different start and end points.");
    this.angleStart = x.Angle(i, o), this.angleEnd = x.Angle(i, a), this.radius = x.Dist(i, o), this.measure = GW(this.angleStart, this.angleEnd, r, s), this.start = o, this.end = a, this.sweepFlag = r, this.largeArcFlag = s, this._center = i;
  }
  nearestPoint(n) {
    const { _center: i, measure: r, radius: s, angleEnd: o, angleStart: a, start: c, end: d } = this, u = Fy(r, a, o, i.angle(n));
    if (u <= 0) return c;
    if (u >= 1) return d;
    const h = i.clone().add(n.clone().sub(i).uni().mul(s));
    let g, p = 1 / 0, f;
    for (const M of [c, d, h])
      f = x.Dist2(n, M), f < p && (g = M, p = f);
    if (!g) throw Error("nearest point not found");
    return g;
  }
  hitTestLineSegment(n, i) {
    const { _center: r, radius: s, measure: o, angleStart: a, angleEnd: c } = this, d = yd(n, i, r, s);
    return d === null ? !1 : d.some((u) => {
      const h = Fy(o, a, c, r.angle(u));
      return h >= 0 && h <= 1;
    });
  }
  getVertices() {
    const { _center: n, measure: i, length: r, radius: s, angleStart: o } = this, a = [];
    for (let c = 0, d = xS(Math.abs(r)); c < d + 1; c++) {
      const u = c / d * i, h = o + u;
      a.push(Yo(n, s, h));
    }
    return a;
  }
  getSvgPathData(n = !0) {
    const { start: i, end: r, radius: s, largeArcFlag: o, sweepFlag: a } = this;
    return `${n ? `M${i.toFixed()}` : ""} A${s} ${s} 0 ${o} ${a} ${r.toFixed()}`;
  }
  getLength() {
    return this.measure * this.radius;
  }
}
class SS extends lo {
  constructor(n) {
    super({ isClosed: !0, ...n });
    S(this, "_center");
    S(this, "radius");
    S(this, "x");
    S(this, "y");
    this.config = n;
    const { x: i = 0, y: r = 0, radius: s } = n;
    this.x = i, this.y = r, this._center = new x(s + i, s + r), this.radius = s;
  }
  getBounds() {
    return new ae(this.x, this.y, this.radius * 2, this.radius * 2);
  }
  getVertices() {
    const { _center: n, radius: i } = this, r = gt * i, s = [];
    for (let o = 0, a = xS(r); o < a; o++) {
      const c = o / a * gt;
      s.push(Yo(n, i, c));
    }
    return s;
  }
  nearestPoint(n) {
    const { _center: i, radius: r } = this;
    return i.equals(n) ? x.AddXY(i, r, 0) : i.clone().add(n.clone().sub(i).uni().mul(r));
  }
  hitTestLineSegment(n, i, r = 0) {
    const { _center: s, radius: o } = this;
    return yd(n, i, s, o + r) !== null;
  }
  getSvgPathData() {
    const { _center: n, radius: i } = this;
    return `M${n.x + i},${n.y} a${i},${i} 0 1,0 ${i * 2},0a${i},${i} 0 1,0 -${i * 2},0`;
  }
}
class Tn extends Ds {
  constructor(n) {
    const { start: i, cp1: r, cp2: s, end: o } = n;
    super({ ...n, points: [i, o] });
    S(this, "a");
    S(this, "b");
    S(this, "c");
    S(this, "d");
    this.a = i, this.b = r, this.c = s, this.d = o;
  }
  getVertices() {
    const n = [], { a: i, b: r, c: s, d: o } = this;
    for (let a = 0, c = 10; a <= c; a++) {
      const d = a / c;
      n.push(
        new x(
          (1 - d) * (1 - d) * (1 - d) * i.x + 3 * ((1 - d) * (1 - d)) * d * r.x + 3 * (1 - d) * (d * d) * s.x + d * d * d * o.x,
          (1 - d) * (1 - d) * (1 - d) * i.y + 3 * ((1 - d) * (1 - d)) * d * r.y + 3 * (1 - d) * (d * d) * s.y + d * d * d * o.y
        )
      );
    }
    return n;
  }
  midPoint() {
    return Tn.GetAtT(this, 0.5);
  }
  nearestPoint(n) {
    let i, r = 1 / 0, s, o;
    for (const a of this.segments)
      o = a.nearestPoint(n), s = x.Dist2(o, n), s < r && (i = o, r = s);
    if (!i) throw Error("nearest point not found");
    return i;
  }
  getSvgPathData(n = !0) {
    const { a: i, b: r, c: s, d: o } = this;
    return `${n ? `M ${i.toFixed()} ` : ""} C${r.toFixed()} ${s.toFixed()} ${o.toFixed()}`;
  }
  static GetAtT(n, i) {
    const { a: r, b: s, c: o, d: a } = n;
    return new x(
      (1 - i) * (1 - i) * (1 - i) * r.x + 3 * ((1 - i) * (1 - i)) * i * s.x + 3 * (1 - i) * (i * i) * o.x + i * i * i * a.x,
      (1 - i) * (1 - i) * (1 - i) * r.y + 3 * ((1 - i) * (1 - i)) * i * s.y + 3 * (1 - i) * (i * i) * o.y + i * i * i * a.y
    );
  }
  getLength(n = 32) {
    let i, r = this.a, s = 0;
    for (let o = 1; o <= n; o++)
      i = Tn.GetAtT(this, o / n), s += x.Dist(r, i), r = i;
    return s;
  }
}
class tX extends lo {
  constructor(n) {
    super({ ...n, isClosed: !1, isFilled: !1 });
    S(this, "points");
    S(this, "_segments");
    const { points: i } = n;
    this.points = i;
  }
  // eslint-disable-next-line no-restricted-syntax
  get segments() {
    if (!this._segments) {
      this._segments = [];
      const { points: n } = this, i = n.length, r = i - 2, s = 1.25;
      for (let o = 0; o < i - 1; o++) {
        const a = o === 0 ? n[0] : n[o - 1], c = n[o], d = n[o + 1], u = o === r ? d : n[o + 2], h = c, g = o === 0 ? a : new x(c.x + (d.x - a.x) / 6 * s, c.y + (d.y - a.y) / 6 * s), p = o === r ? d : new x(d.x - (u.x - c.x) / 6 * s, d.y - (u.y - c.y) / 6 * s), f = d;
        this._segments.push(new Tn({ start: h, cp1: g, cp2: p, end: f }));
      }
    }
    return this._segments;
  }
  getLength() {
    return this.segments.reduce((n, i) => n + i.length, 0);
  }
  getVertices() {
    const n = this.segments.reduce((i, r) => i.concat(r.vertices), []);
    return n.push(this.points[this.points.length - 1]), n;
  }
  nearestPoint(n) {
    let i, r = 1 / 0, s, o;
    for (const a of this.segments)
      o = a.nearestPoint(n), s = x.Dist2(o, n), s < r && (i = o, r = s);
    if (!i) throw Error("nearest point not found");
    return i;
  }
  hitTestLineSegment(n, i) {
    return this.segments.some((r) => r.hitTestLineSegment(n, i));
  }
  getSvgPathData() {
    let n = this.segments.reduce((i, r, s) => i + r.getSvgPathData(s === 0), "");
    return this.isClosed && (n += "Z"), n;
  }
}
class nX extends lo {
  constructor(n) {
    super({ ...n, isClosed: !0 });
    S(this, "w");
    S(this, "h");
    S(this, "_edges");
    this.config = n;
    const { width: i, height: r } = n;
    this.w = i, this.h = r;
  }
  // eslint-disable-next-line no-restricted-syntax
  get edges() {
    if (!this._edges) {
      const { vertices: n } = this;
      this._edges = [];
      for (let i = 0, r = n.length; i < r; i++) {
        const s = n[i], o = n[(i + 1) % r];
        this._edges.push(new ls({ start: s, end: o }));
      }
    }
    return this._edges;
  }
  getVertices() {
    const n = Math.max(1, this.w), i = Math.max(1, this.h), r = n / 2, s = i / 2, o = Math.pow(r - s, 2) / Math.pow(r + s, 2), a = st * (r + s) * (1 + 3 * o / (10 + Math.sqrt(4 - 3 * o))), c = xS(a), d = gt / c, u = Math.cos(d), h = Math.sin(d);
    let g = 0, p = 1, f = 0, M = 1;
    const m = Array(c);
    for (let y = 0; y < c; y++)
      m[y] = new x(r + r * p, s + s * g), f = h * p + u * g, M = u * p - h * g, g = f, p = M;
    return m;
  }
  nearestPoint(n) {
    let i, r = 1 / 0, s, o;
    for (const a of this.edges)
      o = a.nearestPoint(n), s = x.Dist2(o, n), s < r && (i = o, r = s);
    if (!i) throw Error("nearest point not found");
    return i;
  }
  hitTestLineSegment(n, i) {
    return this.edges.some((r) => r.hitTestLineSegment(n, i));
  }
  getBounds() {
    return new ae(0, 0, this.w, this.h);
  }
  getLength() {
    const { w: n, h: i } = this, r = n / 2, s = i / 2, o = Math.max(0, r), a = Math.max(0, s);
    return mv(o, a);
  }
  getSvgPathData(n = !1) {
    const { w: i, h: r } = this, s = i / 2, o = r / 2, a = Math.max(0, s), c = Math.max(0, o);
    return `${n ? `M${s - a},${o}` : ""} a${a},${c},0,1,1,${a * 2},0a${a},${c},0,1,1,-${a * 2},0`;
  }
}
class iX extends lo {
  constructor(n) {
    super({ ...n, isClosed: !0 });
    S(this, "w");
    S(this, "h");
    S(this, "a");
    S(this, "b");
    S(this, "c");
    S(this, "d");
    this.config = n;
    const { width: i, height: r } = n;
    if (this.w = i, this.h = r, r > i) {
      const s = i / 2;
      this.a = new ba({
        start: new x(0, s),
        end: new x(i, s),
        center: new x(i / 2, s),
        sweepFlag: 1,
        largeArcFlag: 1
      }), this.b = new ls({ start: new x(i, s), end: new x(i, r - s) }), this.c = new ba({
        start: new x(i, r - s),
        end: new x(0, r - s),
        center: new x(i / 2, r - s),
        sweepFlag: 1,
        largeArcFlag: 1
      }), this.d = new ls({ start: new x(0, r - s), end: new x(0, s) });
    } else {
      const s = r / 2;
      this.a = new ba({
        start: new x(s, r),
        end: new x(s, 0),
        center: new x(s, s),
        sweepFlag: 1,
        largeArcFlag: 1
      }), this.b = new ls({ start: new x(s, 0), end: new x(i - s, 0) }), this.c = new ba({
        start: new x(i - s, 0),
        end: new x(i - s, r),
        center: new x(i - s, s),
        sweepFlag: 1,
        largeArcFlag: 1
      }), this.d = new ls({ start: new x(i - s, r), end: new x(s, r) });
    }
  }
  nearestPoint(n) {
    let i, r = 1 / 0, s, o;
    const { a, b: c, c: d, d: u } = this;
    for (const h of [a, c, d, u])
      o = h.nearestPoint(n), s = x.Dist2(o, n), s < r && (i = o, r = s);
    if (!i) throw Error("nearest point not found");
    return i;
  }
  hitTestLineSegment(n, i) {
    const { a: r, b: s, c: o, d: a } = this;
    return [r, s, o, a].some((c) => c.hitTestLineSegment(n, i));
  }
  getVertices() {
    const { a: n, b: i, c: r, d: s } = this;
    return [n, i, r, s].reduce((o, a) => (o.push(...a.vertices), o), []);
  }
  getBounds() {
    return new ae(0, 0, this.w, this.h);
  }
  getLength() {
    const { h: n, w: i } = this;
    return n > i ? (st * (i / 2) + (n - i)) * 2 : (st * (n / 2) + (i - n)) * 2;
  }
  getSvgPathData() {
    const { a: n, b: i, c: r, d: s } = this;
    return [n, i, r, s].map((o, a) => o.getSvgPathData(a === 0)).join(" ") + " Z";
  }
}
async function jw({ shouldReload: t = !0 } = {}) {
  JU();
  for (const e of kg.connectedInstances)
    await e.close();
  await Promise.all(yS().map((e) => r4(e))), XU(), t && window.location.reload();
}
typeof window < "u" && (process.env.NODE_ENV === "development" && (window.hardReset = jw), window.__tldraw__hardReset = jw);
function rX(t, e = "_blank") {
  bp.openWindow(t, e);
}
so(
  "@tldraw/editor",
  "3.4.1",
  "esm"
);
function se(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (t == null || t(r), n === !1 || !r.defaultPrevented)
      return e == null ? void 0 : e(r);
  };
}
function sX(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function Dd(...t) {
  return (e) => t.forEach((n) => sX(n, e));
}
function it(...t) {
  return N.useCallback(Dd(...t), t);
}
function oX(t, e) {
  const n = N.createContext(e), i = (s) => {
    const { children: o, ...a } = s, c = N.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ l.jsx(n.Provider, { value: c, children: o });
  };
  i.displayName = t + "Provider";
  function r(s) {
    const o = N.useContext(n);
    if (o) return o;
    if (e !== void 0) return e;
    throw new Error(`\`${s}\` must be used within \`${t}\``);
  }
  return [i, r];
}
function bc(t, e = []) {
  let n = [];
  function i(s, o) {
    const a = N.createContext(o), c = n.length;
    n = [...n, o];
    const d = (h) => {
      var y;
      const { scope: g, children: p, ...f } = h, M = ((y = g == null ? void 0 : g[t]) == null ? void 0 : y[c]) || a, m = N.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ l.jsx(M.Provider, { value: m, children: p });
    };
    d.displayName = s + "Provider";
    function u(h, g) {
      var M;
      const p = ((M = g == null ? void 0 : g[t]) == null ? void 0 : M[c]) || a, f = N.useContext(p);
      if (f) return f;
      if (o !== void 0) return o;
      throw new Error(`\`${h}\` must be used within \`${s}\``);
    }
    return [d, u];
  }
  const r = () => {
    const s = n.map((o) => N.createContext(o));
    return function(a) {
      const c = (a == null ? void 0 : a[t]) || s;
      return N.useMemo(
        () => ({ [`__scope${t}`]: { ...a, [t]: c } }),
        [a, c]
      );
    };
  };
  return r.scopeName = t, [i, aX(r, ...e)];
}
function aX(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const i = t.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(s) {
      const o = i.reduce((a, { useScope: c, scopeName: d }) => {
        const h = c(s)[`__scope${d}`];
        return { ...a, ...h };
      }, {});
      return N.useMemo(() => ({ [`__scope${e.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
var pr = globalThis != null && globalThis.document ? N.useLayoutEffect : () => {
}, cX = N.useId || (() => {
}), lX = 0;
function dr(t) {
  const [e, n] = N.useState(cX());
  return pr(() => {
    t || n((i) => i ?? String(lX++));
  }, [t]), t || (e ? `radix-${e}` : "");
}
function Bt(t) {
  const e = N.useRef(t);
  return N.useEffect(() => {
    e.current = t;
  }), N.useMemo(() => (...n) => {
    var i;
    return (i = e.current) == null ? void 0 : i.call(e, ...n);
  }, []);
}
function go({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  }
}) {
  const [i, r] = dX({ defaultProp: e, onChange: n }), s = t !== void 0, o = s ? t : i, a = Bt(n), c = N.useCallback(
    (d) => {
      if (s) {
        const h = typeof d == "function" ? d(t) : d;
        h !== t && a(h);
      } else
        r(d);
    },
    [s, t, r, a]
  );
  return [o, c];
}
function dX({
  defaultProp: t,
  onChange: e
}) {
  const n = N.useState(t), [i] = n, r = N.useRef(i), s = Bt(e);
  return N.useEffect(() => {
    r.current !== i && (s(i), r.current = i);
  }, [i, r, s]), n;
}
var eo = N.forwardRef((t, e) => {
  const { children: n, ...i } = t, r = N.Children.toArray(n), s = r.find(hX);
  if (s) {
    const o = s.props.children, a = r.map((c) => c === s ? N.Children.count(o) > 1 ? N.Children.only(null) : N.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ l.jsx(rI, { ...i, ref: e, children: N.isValidElement(o) ? N.cloneElement(o, void 0, a) : null });
  }
  return /* @__PURE__ */ l.jsx(rI, { ...i, ref: e, children: n });
});
eo.displayName = "Slot";
var rI = N.forwardRef((t, e) => {
  const { children: n, ...i } = t;
  if (N.isValidElement(n)) {
    const r = pX(n);
    return N.cloneElement(n, {
      ...gX(i, n.props),
      // @ts-ignore
      ref: e ? Dd(e, r) : r
    });
  }
  return N.Children.count(n) > 1 ? N.Children.only(null) : null;
});
rI.displayName = "SlotClone";
var uX = ({ children: t }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: t });
function hX(t) {
  return N.isValidElement(t) && t.type === uX;
}
function gX(t, e) {
  const n = { ...e };
  for (const i in e) {
    const r = t[i], s = e[i];
    /^on[A-Z]/.test(i) ? r && s ? n[i] = (...a) => {
      s(...a), r(...a);
    } : r && (n[i] = r) : i === "style" ? n[i] = { ...r, ...s } : i === "className" && (n[i] = [r, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function pX(t) {
  var i, r;
  let e = (i = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (r = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var fX = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Fe = fX.reduce((t, e) => {
  const n = N.forwardRef((i, r) => {
    const { asChild: s, ...o } = i, a = s ? eo : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(a, { ...o, ref: r });
  });
  return n.displayName = `Primitive.${e}`, { ...t, [e]: n };
}, {});
function wd(t, e) {
  t && op.flushSync(() => t.dispatchEvent(e));
}
function g4(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Bt(t);
  N.useEffect(() => {
    const i = (r) => {
      r.key === "Escape" && n(r);
    };
    return e.addEventListener("keydown", i, { capture: !0 }), () => e.removeEventListener("keydown", i, { capture: !0 });
  }, [n, e]);
}
var MX = "DismissableLayer", sI = "dismissableLayer.update", mX = "dismissableLayer.pointerDownOutside", yX = "dismissableLayer.focusOutside", Dw, p4 = N.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Nd = N.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: r,
      onFocusOutside: s,
      onInteractOutside: o,
      onDismiss: a,
      ...c
    } = t, d = N.useContext(p4), [u, h] = N.useState(null), g = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = N.useState({}), f = it(e, (b) => h(b)), M = Array.from(d.layers), [m] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), y = M.indexOf(m), I = u ? M.indexOf(u) : -1, D = d.layersWithOutsidePointerEventsDisabled.size > 0, j = I >= y, w = xX((b) => {
      const T = b.target, E = [...d.branches].some((v) => v.contains(T));
      !j || E || (r == null || r(b), o == null || o(b), b.defaultPrevented || a == null || a());
    }, g), A = SX((b) => {
      const T = b.target;
      [...d.branches].some((v) => v.contains(T)) || (s == null || s(b), o == null || o(b), b.defaultPrevented || a == null || a());
    }, g);
    return g4((b) => {
      I === d.layers.size - 1 && (i == null || i(b), !b.defaultPrevented && a && (b.preventDefault(), a()));
    }, g), N.useEffect(() => {
      if (u)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Dw = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), ww(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = Dw);
        };
    }, [u, g, n, d]), N.useEffect(() => () => {
      u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), ww());
    }, [u, d]), N.useEffect(() => {
      const b = () => p({});
      return document.addEventListener(sI, b), () => document.removeEventListener(sI, b);
    }, []), /* @__PURE__ */ l.jsx(
      Fe.div,
      {
        ...c,
        ref: f,
        style: {
          pointerEvents: D ? j ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: se(t.onFocusCapture, A.onFocusCapture),
        onBlurCapture: se(t.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: se(
          t.onPointerDownCapture,
          w.onPointerDownCapture
        )
      }
    );
  }
);
Nd.displayName = MX;
var IX = "DismissableLayerBranch", f4 = N.forwardRef((t, e) => {
  const n = N.useContext(p4), i = N.useRef(null), r = it(e, i);
  return N.useEffect(() => {
    const s = i.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ l.jsx(Fe.div, { ...t, ref: r });
});
f4.displayName = IX;
function xX(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Bt(t), i = N.useRef(!1), r = N.useRef(() => {
  });
  return N.useEffect(() => {
    const s = (a) => {
      if (a.target && !i.current) {
        let c = function() {
          M4(
            mX,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: a };
        a.pointerType === "touch" ? (e.removeEventListener("click", r.current), r.current = c, e.addEventListener("click", r.current, { once: !0 })) : c();
      } else
        e.removeEventListener("click", r.current);
      i.current = !1;
    }, o = window.setTimeout(() => {
      e.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(o), e.removeEventListener("pointerdown", s), e.removeEventListener("click", r.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function SX(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Bt(t), i = N.useRef(!1);
  return N.useEffect(() => {
    const r = (s) => {
      s.target && !i.current && M4(yX, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", r), () => e.removeEventListener("focusin", r);
  }, [e, n]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function ww() {
  const t = new CustomEvent(sI);
  document.dispatchEvent(t);
}
function M4(t, e, n, { discrete: i }) {
  const r = n.originalEvent.target, s = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && r.addEventListener(t, e, { once: !0 }), i ? wd(r, s) : r.dispatchEvent(s);
}
var jX = Nd, DX = f4, RM = "focusScope.autoFocusOnMount", YM = "focusScope.autoFocusOnUnmount", Nw = { bubbles: !1, cancelable: !0 }, wX = "FocusScope", Ad = N.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: i = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: s,
    ...o
  } = t, [a, c] = N.useState(null), d = Bt(r), u = Bt(s), h = N.useRef(null), g = it(e, (M) => c(M)), p = N.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  N.useEffect(() => {
    if (i) {
      let M = function(D) {
        if (p.paused || !a) return;
        const j = D.target;
        a.contains(j) ? h.current = j : Rs(h.current, { select: !0 });
      }, m = function(D) {
        if (p.paused || !a) return;
        const j = D.relatedTarget;
        j !== null && (a.contains(j) || Rs(h.current, { select: !0 }));
      }, y = function(D) {
        if (document.activeElement === document.body)
          for (const w of D)
            w.removedNodes.length > 0 && Rs(a);
      };
      document.addEventListener("focusin", M), document.addEventListener("focusout", m);
      const I = new MutationObserver(y);
      return a && I.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", M), document.removeEventListener("focusout", m), I.disconnect();
      };
    }
  }, [i, a, p.paused]), N.useEffect(() => {
    if (a) {
      Tw.add(p);
      const M = document.activeElement;
      if (!a.contains(M)) {
        const y = new CustomEvent(RM, Nw);
        a.addEventListener(RM, d), a.dispatchEvent(y), y.defaultPrevented || (NX(EX(m4(a)), { select: !0 }), document.activeElement === M && Rs(a));
      }
      return () => {
        a.removeEventListener(RM, d), setTimeout(() => {
          const y = new CustomEvent(YM, Nw);
          a.addEventListener(YM, u), a.dispatchEvent(y), y.defaultPrevented || Rs(M ?? document.body, { select: !0 }), a.removeEventListener(YM, u), Tw.remove(p);
        }, 0);
      };
    }
  }, [a, d, u, p]);
  const f = N.useCallback(
    (M) => {
      if (!n && !i || p.paused) return;
      const m = M.key === "Tab" && !M.altKey && !M.ctrlKey && !M.metaKey, y = document.activeElement;
      if (m && y) {
        const I = M.currentTarget, [D, j] = AX(I);
        D && j ? !M.shiftKey && y === j ? (M.preventDefault(), n && Rs(D, { select: !0 })) : M.shiftKey && y === D && (M.preventDefault(), n && Rs(j, { select: !0 })) : y === I && M.preventDefault();
      }
    },
    [n, i, p.paused]
  );
  return /* @__PURE__ */ l.jsx(Fe.div, { tabIndex: -1, ...o, ref: g, onKeyDown: f });
});
Ad.displayName = wX;
function NX(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const i of t)
    if (Rs(i, { select: e }), document.activeElement !== n) return;
}
function AX(t) {
  const e = m4(t), n = Aw(e, t), i = Aw(e.reverse(), t);
  return [n, i];
}
function m4(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => {
      const r = i.tagName === "INPUT" && i.type === "hidden";
      return i.disabled || i.hidden || r ? NodeFilter.FILTER_SKIP : i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function Aw(t, e) {
  for (const n of t)
    if (!TX(n, { upTo: e })) return n;
}
function TX(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function bX(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Rs(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && bX(t) && e && t.select();
  }
}
var Tw = vX();
function vX() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = bw(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = bw(t, e), (n = t[0]) == null || n.resume();
    }
  };
}
function bw(t, e) {
  const n = [...t], i = n.indexOf(e);
  return i !== -1 && n.splice(i, 1), n;
}
function EX(t) {
  return t.filter((e) => e.tagName !== "A");
}
var CX = "Portal", Td = N.forwardRef((t, e) => {
  var a;
  const { container: n, ...i } = t, [r, s] = N.useState(!1);
  pr(() => s(!0), []);
  const o = n || r && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return o ? tx.createPortal(/* @__PURE__ */ l.jsx(Fe.div, { ...i, ref: e }), o) : null;
});
Td.displayName = CX;
function zX(t, e) {
  return N.useReducer((n, i) => e[n][i] ?? n, t);
}
var jr = (t) => {
  const { present: e, children: n } = t, i = LX(e), r = typeof n == "function" ? n({ present: i.isPresent }) : N.Children.only(n), s = it(i.ref, kX(r));
  return typeof n == "function" || i.isPresent ? N.cloneElement(r, { ref: s }) : null;
};
jr.displayName = "Presence";
function LX(t) {
  const [e, n] = N.useState(), i = N.useRef({}), r = N.useRef(t), s = N.useRef("none"), o = t ? "mounted" : "unmounted", [a, c] = zX(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return N.useEffect(() => {
    const d = Lu(i.current);
    s.current = a === "mounted" ? d : "none";
  }, [a]), pr(() => {
    const d = i.current, u = r.current;
    if (u !== t) {
      const g = s.current, p = Lu(d);
      t ? c("MOUNT") : p === "none" || (d == null ? void 0 : d.display) === "none" ? c("UNMOUNT") : c(u && g !== p ? "ANIMATION_OUT" : "UNMOUNT"), r.current = t;
    }
  }, [t, c]), pr(() => {
    if (e) {
      let d;
      const u = e.ownerDocument.defaultView ?? window, h = (p) => {
        const M = Lu(i.current).includes(p.animationName);
        if (p.target === e && M && (c("ANIMATION_END"), !r.current)) {
          const m = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", d = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = m);
          });
        }
      }, g = (p) => {
        p.target === e && (s.current = Lu(i.current));
      };
      return e.addEventListener("animationstart", g), e.addEventListener("animationcancel", h), e.addEventListener("animationend", h), () => {
        u.clearTimeout(d), e.removeEventListener("animationstart", g), e.removeEventListener("animationcancel", h), e.removeEventListener("animationend", h);
      };
    } else
      c("ANIMATION_END");
  }, [e, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: N.useCallback((d) => {
      d && (i.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function Lu(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function kX(t) {
  var i, r;
  let e = (i = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (r = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var QM = 0;
function jS() {
  N.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? vw()), document.body.insertAdjacentElement("beforeend", t[1] ?? vw()), QM++, () => {
      QM === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), QM--;
    };
  }, []);
}
function vw() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var vn = function() {
  return vn = Object.assign || function(e) {
    for (var n, i = 1, r = arguments.length; i < r; i++) {
      n = arguments[i];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, vn.apply(this, arguments);
};
function DS(t, e) {
  var n = {};
  for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, i = Object.getOwnPropertySymbols(t); r < i.length; r++)
      e.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[r]) && (n[i[r]] = t[i[r]]);
  return n;
}
function y4(t, e, n) {
  if (n || arguments.length === 2) for (var i = 0, r = e.length, s; i < r; i++)
    (s || !(i in e)) && (s || (s = Array.prototype.slice.call(e, 0, i)), s[i] = e[i]);
  return t.concat(s || Array.prototype.slice.call(e));
}
var Ol = "right-scroll-bar-position", Pl = "width-before-scroll-bar", OX = "with-scroll-bars-hidden", PX = "--removed-body-scroll-bar-size";
function ZM(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function UX(t, e) {
  var n = pe(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(i) {
          var r = n.value;
          r !== i && (n.value = i, n.callback(i, r));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
var RX = typeof window < "u" ? N.useLayoutEffect : N.useEffect, Ew = /* @__PURE__ */ new WeakMap();
function I4(t, e) {
  var n = UX(null, function(i) {
    return t.forEach(function(r) {
      return ZM(r, i);
    });
  });
  return RX(function() {
    var i = Ew.get(n);
    if (i) {
      var r = new Set(i), s = new Set(t), o = n.current;
      r.forEach(function(a) {
        s.has(a) || ZM(a, null);
      }), s.forEach(function(a) {
        r.has(a) || ZM(a, o);
      });
    }
    Ew.set(n, t);
  }, [t]), n;
}
function YX(t) {
  return t;
}
function QX(t, e) {
  e === void 0 && (e = YX);
  var n = [], i = !1, r = {
    read: function() {
      if (i)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(s) {
      var o = e(s, i);
      return n.push(o), function() {
        n = n.filter(function(a) {
          return a !== o;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (i = !0; n.length; ) {
        var o = n;
        n = [], o.forEach(s);
      }
      n = {
        push: function(a) {
          return s(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      i = !0;
      var o = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(s), o = n;
      }
      var c = function() {
        var u = o;
        o = [], u.forEach(s);
      }, d = function() {
        return Promise.resolve().then(c);
      };
      d(), n = {
        push: function(u) {
          o.push(u), d();
        },
        filter: function(u) {
          return o = o.filter(u), n;
        }
      };
    }
  };
  return r;
}
function x4(t) {
  t === void 0 && (t = {});
  var e = QX(null);
  return e.options = vn({ async: !0, ssr: !1 }, t), e;
}
var S4 = function(t) {
  var e = t.sideCar, n = DS(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var i = e.read();
  if (!i)
    throw new Error("Sidecar medium not found");
  return N.createElement(i, vn({}, n));
};
S4.isSideCarExport = !0;
function j4(t, e) {
  return t.useMedium(e), S4;
}
var D4 = x4(), FM = function() {
}, Bp = N.forwardRef(function(t, e) {
  var n = N.useRef(null), i = N.useState({
    onScrollCapture: FM,
    onWheelCapture: FM,
    onTouchMoveCapture: FM
  }), r = i[0], s = i[1], o = t.forwardProps, a = t.children, c = t.className, d = t.removeScrollBar, u = t.enabled, h = t.shards, g = t.sideCar, p = t.noIsolation, f = t.inert, M = t.allowPinchZoom, m = t.as, y = m === void 0 ? "div" : m, I = t.gapMode, D = DS(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), j = g, w = I4([n, e]), A = vn(vn({}, D), r);
  return N.createElement(
    N.Fragment,
    null,
    u && N.createElement(j, { sideCar: D4, removeScrollBar: d, shards: h, noIsolation: p, inert: f, setCallbacks: s, allowPinchZoom: !!M, lockRef: n, gapMode: I }),
    o ? N.cloneElement(N.Children.only(a), vn(vn({}, A), { ref: w })) : N.createElement(y, vn({}, A, { className: c, ref: w }), a)
  );
});
Bp.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Bp.classNames = {
  fullWidth: Pl,
  zeroRight: Ol
};
var ZX = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function FX() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = ZX();
  return e && t.setAttribute("nonce", e), t;
}
function BX(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function GX(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var WX = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = FX()) && (BX(e, n), GX(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, HX = function() {
  var t = WX();
  return function(e, n) {
    N.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, wS = function() {
  var t = HX(), e = function(n) {
    var i = n.styles, r = n.dynamic;
    return t(i, r), null;
  };
  return e;
}, VX = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, BM = function(t) {
  return parseInt(t || "", 10) || 0;
}, KX = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], i = e[t === "padding" ? "paddingTop" : "marginTop"], r = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [BM(n), BM(i), BM(r)];
}, XX = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return VX;
  var e = KX(t), n = document.documentElement.clientWidth, i = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, i - n + e[2] - e[0])
  };
}, JX = wS(), Ya = "data-scroll-locked", qX = function(t, e, n, i) {
  var r = t.left, s = t.top, o = t.right, a = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(OX, ` {
   overflow: hidden `).concat(i, `;
   padding-right: `).concat(a, "px ").concat(i, `;
  }
  body[`).concat(Ya, `] {
    overflow: hidden `).concat(i, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(i, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(i, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(i, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ol, ` {
    right: `).concat(a, "px ").concat(i, `;
  }
  
  .`).concat(Pl, ` {
    margin-right: `).concat(a, "px ").concat(i, `;
  }
  
  .`).concat(Ol, " .").concat(Ol, ` {
    right: 0 `).concat(i, `;
  }
  
  .`).concat(Pl, " .").concat(Pl, ` {
    margin-right: 0 `).concat(i, `;
  }
  
  body[`).concat(Ya, `] {
    `).concat(PX, ": ").concat(a, `px;
  }
`);
}, Cw = function() {
  var t = parseInt(document.body.getAttribute(Ya) || "0", 10);
  return isFinite(t) ? t : 0;
}, _X = function() {
  N.useEffect(function() {
    return document.body.setAttribute(Ya, (Cw() + 1).toString()), function() {
      var t = Cw() - 1;
      t <= 0 ? document.body.removeAttribute(Ya) : document.body.setAttribute(Ya, t.toString());
    };
  }, []);
}, w4 = function(t) {
  var e = t.noRelative, n = t.noImportant, i = t.gapMode, r = i === void 0 ? "margin" : i;
  _X();
  var s = N.useMemo(function() {
    return XX(r);
  }, [r]);
  return N.createElement(JX, { styles: qX(s, !e, r, n ? "" : "!important") });
}, oI = !1;
if (typeof window < "u")
  try {
    var ku = Object.defineProperty({}, "passive", {
      get: function() {
        return oI = !0, !0;
      }
    });
    window.addEventListener("test", ku, ku), window.removeEventListener("test", ku, ku);
  } catch {
    oI = !1;
  }
var ua = oI ? {} : !1, $X = function(t) {
  return t.tagName === "TEXTAREA";
}, N4 = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !$X(t) && n[e] === "visible")
  );
}, eJ = function(t) {
  return N4(t, "overflowY");
}, tJ = function(t) {
  return N4(t, "overflowX");
}, zw = function(t, e) {
  var n = e.ownerDocument, i = e;
  do {
    typeof ShadowRoot < "u" && i instanceof ShadowRoot && (i = i.host);
    var r = A4(t, i);
    if (r) {
      var s = T4(t, i), o = s[1], a = s[2];
      if (o > a)
        return !0;
    }
    i = i.parentNode;
  } while (i && i !== n.body);
  return !1;
}, nJ = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, i = t.clientHeight;
  return [
    e,
    n,
    i
  ];
}, iJ = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, i = t.clientWidth;
  return [
    e,
    n,
    i
  ];
}, A4 = function(t, e) {
  return t === "v" ? eJ(e) : tJ(e);
}, T4 = function(t, e) {
  return t === "v" ? nJ(e) : iJ(e);
}, rJ = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, sJ = function(t, e, n, i, r) {
  var s = rJ(t, window.getComputedStyle(e).direction), o = s * i, a = n.target, c = e.contains(a), d = !1, u = o > 0, h = 0, g = 0;
  do {
    var p = T4(t, a), f = p[0], M = p[1], m = p[2], y = M - m - s * f;
    (f || y) && A4(t, a) && (h += y, g += f), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (e.contains(a) || e === a)
  );
  return (u && (Math.abs(h) < 1 || !r) || !u && (Math.abs(g) < 1 || !r)) && (d = !0), d;
}, Ou = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, Lw = function(t) {
  return [t.deltaX, t.deltaY];
}, kw = function(t) {
  return t && "current" in t ? t.current : t;
}, oJ = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, aJ = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, cJ = 0, ha = [];
function lJ(t) {
  var e = N.useRef([]), n = N.useRef([0, 0]), i = N.useRef(), r = N.useState(cJ++)[0], s = N.useState(wS)[0], o = N.useRef(t);
  N.useEffect(function() {
    o.current = t;
  }, [t]), N.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var M = y4([t.lockRef.current], (t.shards || []).map(kw), !0).filter(Boolean);
      return M.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), M.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var a = N.useCallback(function(M, m) {
    if ("touches" in M && M.touches.length === 2 || M.type === "wheel" && M.ctrlKey)
      return !o.current.allowPinchZoom;
    var y = Ou(M), I = n.current, D = "deltaX" in M ? M.deltaX : I[0] - y[0], j = "deltaY" in M ? M.deltaY : I[1] - y[1], w, A = M.target, b = Math.abs(D) > Math.abs(j) ? "h" : "v";
    if ("touches" in M && b === "h" && A.type === "range")
      return !1;
    var T = zw(b, A);
    if (!T)
      return !0;
    if (T ? w = b : (w = b === "v" ? "h" : "v", T = zw(b, A)), !T)
      return !1;
    if (!i.current && "changedTouches" in M && (D || j) && (i.current = w), !w)
      return !0;
    var E = i.current || w;
    return sJ(E, m, M, E === "h" ? D : j, !0);
  }, []), c = N.useCallback(function(M) {
    var m = M;
    if (!(!ha.length || ha[ha.length - 1] !== s)) {
      var y = "deltaY" in m ? Lw(m) : Ou(m), I = e.current.filter(function(w) {
        return w.name === m.type && (w.target === m.target || m.target === w.shadowParent) && oJ(w.delta, y);
      })[0];
      if (I && I.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!I) {
        var D = (o.current.shards || []).map(kw).filter(Boolean).filter(function(w) {
          return w.contains(m.target);
        }), j = D.length > 0 ? a(m, D[0]) : !o.current.noIsolation;
        j && m.cancelable && m.preventDefault();
      }
    }
  }, []), d = N.useCallback(function(M, m, y, I) {
    var D = { name: M, delta: m, target: y, should: I, shadowParent: dJ(y) };
    e.current.push(D), setTimeout(function() {
      e.current = e.current.filter(function(j) {
        return j !== D;
      });
    }, 1);
  }, []), u = N.useCallback(function(M) {
    n.current = Ou(M), i.current = void 0;
  }, []), h = N.useCallback(function(M) {
    d(M.type, Lw(M), M.target, a(M, t.lockRef.current));
  }, []), g = N.useCallback(function(M) {
    d(M.type, Ou(M), M.target, a(M, t.lockRef.current));
  }, []);
  N.useEffect(function() {
    return ha.push(s), t.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", c, ua), document.addEventListener("touchmove", c, ua), document.addEventListener("touchstart", u, ua), function() {
      ha = ha.filter(function(M) {
        return M !== s;
      }), document.removeEventListener("wheel", c, ua), document.removeEventListener("touchmove", c, ua), document.removeEventListener("touchstart", u, ua);
    };
  }, []);
  var p = t.removeScrollBar, f = t.inert;
  return N.createElement(
    N.Fragment,
    null,
    f ? N.createElement(s, { styles: aJ(r) }) : null,
    p ? N.createElement(w4, { gapMode: t.gapMode }) : null
  );
}
function dJ(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const uJ = j4(D4, lJ);
var Gp = N.forwardRef(function(t, e) {
  return N.createElement(Bp, vn({}, t, { ref: e, sideCar: uJ }));
});
Gp.classNames = Bp.classNames;
var hJ = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, ga = /* @__PURE__ */ new WeakMap(), Pu = /* @__PURE__ */ new WeakMap(), Uu = {}, GM = 0, b4 = function(t) {
  return t && (t.host || b4(t.parentNode));
}, gJ = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var i = b4(n);
    return i && t.contains(i) ? i : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, pJ = function(t, e, n, i) {
  var r = gJ(e, Array.isArray(t) ? t : [t]);
  Uu[n] || (Uu[n] = /* @__PURE__ */ new WeakMap());
  var s = Uu[n], o = [], a = /* @__PURE__ */ new Set(), c = new Set(r), d = function(h) {
    !h || a.has(h) || (a.add(h), d(h.parentNode));
  };
  r.forEach(d);
  var u = function(h) {
    !h || c.has(h) || Array.prototype.forEach.call(h.children, function(g) {
      if (a.has(g))
        u(g);
      else
        try {
          var p = g.getAttribute(i), f = p !== null && p !== "false", M = (ga.get(g) || 0) + 1, m = (s.get(g) || 0) + 1;
          ga.set(g, M), s.set(g, m), o.push(g), M === 1 && f && Pu.set(g, !0), m === 1 && g.setAttribute(n, "true"), f || g.setAttribute(i, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", g, y);
        }
    });
  };
  return u(e), a.clear(), GM++, function() {
    o.forEach(function(h) {
      var g = ga.get(h) - 1, p = s.get(h) - 1;
      ga.set(h, g), s.set(h, p), g || (Pu.has(h) || h.removeAttribute(i), Pu.delete(h)), p || h.removeAttribute(n);
    }), GM--, GM || (ga = /* @__PURE__ */ new WeakMap(), ga = /* @__PURE__ */ new WeakMap(), Pu = /* @__PURE__ */ new WeakMap(), Uu = {});
  };
}, Wp = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var i = Array.from(Array.isArray(t) ? t : [t]), r = hJ(t);
  return r ? (i.push.apply(i, Array.from(r.querySelectorAll("[aria-live]"))), pJ(i, r, n, "aria-hidden")) : function() {
    return null;
  };
}, NS = "Dialog", [v4, Fme] = bc(NS), [fJ, Dr] = v4(NS), E4 = (t) => {
  const {
    __scopeDialog: e,
    children: n,
    open: i,
    defaultOpen: r,
    onOpenChange: s,
    modal: o = !0
  } = t, a = N.useRef(null), c = N.useRef(null), [d = !1, u] = go({
    prop: i,
    defaultProp: r,
    onChange: s
  });
  return /* @__PURE__ */ l.jsx(
    fJ,
    {
      scope: e,
      triggerRef: a,
      contentRef: c,
      contentId: dr(),
      titleId: dr(),
      descriptionId: dr(),
      open: d,
      onOpenChange: u,
      onOpenToggle: N.useCallback(() => u((h) => !h), [u]),
      modal: o,
      children: n
    }
  );
};
E4.displayName = NS;
var C4 = "DialogTrigger", MJ = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...i } = t, r = Dr(C4, n), s = it(e, r.triggerRef);
    return /* @__PURE__ */ l.jsx(
      Fe.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": bS(r.open),
        ...i,
        ref: s,
        onClick: se(t.onClick, r.onOpenToggle)
      }
    );
  }
);
MJ.displayName = C4;
var AS = "DialogPortal", [mJ, z4] = v4(AS, {
  forceMount: void 0
}), L4 = (t) => {
  const { __scopeDialog: e, forceMount: n, children: i, container: r } = t, s = Dr(AS, e);
  return /* @__PURE__ */ l.jsx(mJ, { scope: e, forceMount: n, children: N.Children.map(i, (o) => /* @__PURE__ */ l.jsx(jr, { present: n || s.open, children: /* @__PURE__ */ l.jsx(Td, { asChild: !0, container: r, children: o }) })) });
};
L4.displayName = AS;
var Og = "DialogOverlay", k4 = N.forwardRef(
  (t, e) => {
    const n = z4(Og, t.__scopeDialog), { forceMount: i = n.forceMount, ...r } = t, s = Dr(Og, t.__scopeDialog);
    return s.modal ? /* @__PURE__ */ l.jsx(jr, { present: i || s.open, children: /* @__PURE__ */ l.jsx(yJ, { ...r, ref: e }) }) : null;
  }
);
k4.displayName = Og;
var yJ = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...i } = t, r = Dr(Og, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ l.jsx(Gp, { as: eo, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ l.jsx(
        Fe.div,
        {
          "data-state": bS(r.open),
          ...i,
          ref: e,
          style: { pointerEvents: "auto", ...i.style }
        }
      ) })
    );
  }
), Qo = "DialogContent", O4 = N.forwardRef(
  (t, e) => {
    const n = z4(Qo, t.__scopeDialog), { forceMount: i = n.forceMount, ...r } = t, s = Dr(Qo, t.__scopeDialog);
    return /* @__PURE__ */ l.jsx(jr, { present: i || s.open, children: s.modal ? /* @__PURE__ */ l.jsx(IJ, { ...r, ref: e }) : /* @__PURE__ */ l.jsx(xJ, { ...r, ref: e }) });
  }
);
O4.displayName = Qo;
var IJ = N.forwardRef(
  (t, e) => {
    const n = Dr(Qo, t.__scopeDialog), i = N.useRef(null), r = it(e, n.contentRef, i);
    return N.useEffect(() => {
      const s = i.current;
      if (s) return Wp(s);
    }, []), /* @__PURE__ */ l.jsx(
      P4,
      {
        ...t,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: se(t.onCloseAutoFocus, (s) => {
          var o;
          s.preventDefault(), (o = n.triggerRef.current) == null || o.focus();
        }),
        onPointerDownOutside: se(t.onPointerDownOutside, (s) => {
          const o = s.detail.originalEvent, a = o.button === 0 && o.ctrlKey === !0;
          (o.button === 2 || a) && s.preventDefault();
        }),
        onFocusOutside: se(
          t.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), xJ = N.forwardRef(
  (t, e) => {
    const n = Dr(Qo, t.__scopeDialog), i = N.useRef(!1), r = N.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      P4,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var o, a;
          (o = t.onCloseAutoFocus) == null || o.call(t, s), s.defaultPrevented || (i.current || (a = n.triggerRef.current) == null || a.focus(), s.preventDefault()), i.current = !1, r.current = !1;
        },
        onInteractOutside: (s) => {
          var c, d;
          (c = t.onInteractOutside) == null || c.call(t, s), s.defaultPrevented || (i.current = !0, s.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const o = s.target;
          ((d = n.triggerRef.current) == null ? void 0 : d.contains(o)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && r.current && s.preventDefault();
        }
      }
    );
  }
), P4 = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, trapFocus: i, onOpenAutoFocus: r, onCloseAutoFocus: s, ...o } = t, a = Dr(Qo, n), c = N.useRef(null), d = it(e, c);
    return jS(), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        Ad,
        {
          asChild: !0,
          loop: !0,
          trapped: i,
          onMountAutoFocus: r,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ l.jsx(
            Nd,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": bS(a.open),
              ...o,
              ref: d,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        /* @__PURE__ */ l.jsx(jJ, { titleId: a.titleId }),
        /* @__PURE__ */ l.jsx(wJ, { contentRef: c, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), TS = "DialogTitle", U4 = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...i } = t, r = Dr(TS, n);
    return /* @__PURE__ */ l.jsx(Fe.h2, { id: r.titleId, ...i, ref: e });
  }
);
U4.displayName = TS;
var R4 = "DialogDescription", SJ = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...i } = t, r = Dr(R4, n);
    return /* @__PURE__ */ l.jsx(Fe.p, { id: r.descriptionId, ...i, ref: e });
  }
);
SJ.displayName = R4;
var Y4 = "DialogClose", Q4 = N.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...i } = t, r = Dr(Y4, n);
    return /* @__PURE__ */ l.jsx(
      Fe.button,
      {
        type: "button",
        ...i,
        ref: e,
        onClick: se(t.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
Q4.displayName = Y4;
function bS(t) {
  return t ? "open" : "closed";
}
var Z4 = "DialogTitleWarning", [Bme, F4] = oX(Z4, {
  contentName: Qo,
  titleName: TS,
  docsSlug: "dialog"
}), jJ = ({ titleId: t }) => {
  const e = F4(Z4), n = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return N.useEffect(() => {
    t && (document.getElementById(t) || console.error(n));
  }, [n, t]), null;
}, DJ = "DialogDescriptionWarning", wJ = ({ contentRef: t, descriptionId: e }) => {
  const i = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${F4(DJ).contentName}}.`;
  return N.useEffect(() => {
    var s;
    const r = (s = t.current) == null ? void 0 : s.getAttribute("aria-describedby");
    e && r && (document.getElementById(e) || console.warn(i));
  }, [i, t, e]), null;
}, NJ = E4, AJ = L4, TJ = k4, bJ = O4;
const B4 = () => {
}, G4 = N.createContext(null);
function vJ({ onEvent: t, children: e }) {
  return /* @__PURE__ */ l.jsx(G4.Provider, { value: t ?? B4, children: e });
}
function Zt() {
  return N.useContext(G4) ?? B4;
}
const W4 = Ii(null);
function EJ({ context: t, children: e }) {
  const n = Zt(), i = wb("dialogs", []), r = yt(() => ({
    dialogs: i,
    addDialog(s) {
      const o = s.id ?? ht();
      return i.update((a) => [...a.filter((c) => c.id !== s.id), { ...s, id: o }]), n("open-menu", { source: "dialog", id: o }), ir.addOpenMenu(o, t), o;
    },
    removeDialog(s) {
      var a;
      const o = i.get().find((c) => c.id === s);
      return o && ((a = o.onClose) == null || a.call(o), n("close-menu", { source: "dialog", id: s }), ir.deleteOpenMenu(s, t), i.update((c) => c.filter((d) => d !== o))), s;
    },
    clearDialogs() {
      const s = i.get();
      s.length !== 0 && (s.forEach((o) => {
        var a;
        (a = o.onClose) == null || a.call(o), n("close-menu", { source: "dialog", id: o.id }), ir.deleteOpenMenu(o.id, t);
      }), i.set([]));
    }
  }), [n, i, t]);
  return /* @__PURE__ */ l.jsx(W4.Provider, { value: r, children: e });
}
function po() {
  const t = Vn(W4);
  if (!t)
    throw new Error("useDialogs must be used within a DialogsProvider");
  return t;
}
const CJ = ({ id: t, component: e, onClose: n }) => {
  const { removeDialog: i } = po(), r = qt(), s = re(
    (o) => {
      if (!o) {
        if (n)
          try {
            n();
          } catch (a) {
            console.warn(a);
          }
        i(t);
      }
    },
    [t, n, i]
  );
  return /* @__PURE__ */ l.jsx(NJ, { onOpenChange: s, defaultOpen: !0, children: /* @__PURE__ */ l.jsx(AJ, { container: r, children: /* @__PURE__ */ l.jsx(
    TJ,
    {
      dir: "ltr",
      className: "tlui-dialog__overlay",
      onClick: (o) => {
        o.target === o.currentTarget && s(!1);
      },
      children: /* @__PURE__ */ l.jsx(bJ, { dir: "ltr", className: "tlui-dialog__content", "aria-describedby": void 0, children: /* @__PURE__ */ l.jsx(e, { onClose: () => s(!1) }) })
    }
  ) }) });
}, zJ = _e(function() {
  const { dialogs: e } = po();
  return G("dialogs", () => e.get(), [e]).map((i) => /* @__PURE__ */ l.jsx(CJ, { ...i }, i.id));
});
function bd(t, e = []) {
  let n = [];
  function i(s, o) {
    const a = N.createContext(o), c = n.length;
    n = [...n, o];
    function d(h) {
      const { scope: g, children: p, ...f } = h, M = (g == null ? void 0 : g[t][c]) || a, m = N.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ l.jsx(M.Provider, { value: m, children: p });
    }
    function u(h, g) {
      const p = (g == null ? void 0 : g[t][c]) || a, f = N.useContext(p);
      if (f) return f;
      if (o !== void 0) return o;
      throw new Error(`\`${h}\` must be used within \`${s}\``);
    }
    return d.displayName = s + "Provider", [d, u];
  }
  const r = () => {
    const s = n.map((o) => N.createContext(o));
    return function(a) {
      const c = (a == null ? void 0 : a[t]) || s;
      return N.useMemo(
        () => ({ [`__scope${t}`]: { ...a, [t]: c } }),
        [a, c]
      );
    };
  };
  return r.scopeName = t, [i, LJ(r, ...e)];
}
function LJ(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const i = t.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(s) {
      const o = i.reduce((a, { useScope: c, scopeName: d }) => {
        const h = c(s)[`__scope${d}`];
        return { ...a, ...h };
      }, {});
      return N.useMemo(() => ({ [`__scope${e.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function vd(t) {
  const e = t + "CollectionProvider", [n, i] = bd(e), [r, s] = n(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (p) => {
    const { scope: f, children: M } = p, m = Ye.useRef(null), y = Ye.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l.jsx(r, { scope: f, itemMap: y, collectionRef: m, children: M });
  };
  o.displayName = e;
  const a = t + "CollectionSlot", c = Ye.forwardRef(
    (p, f) => {
      const { scope: M, children: m } = p, y = s(a, M), I = it(f, y.collectionRef);
      return /* @__PURE__ */ l.jsx(eo, { ref: I, children: m });
    }
  );
  c.displayName = a;
  const d = t + "CollectionItemSlot", u = "data-radix-collection-item", h = Ye.forwardRef(
    (p, f) => {
      const { scope: M, children: m, ...y } = p, I = Ye.useRef(null), D = it(f, I), j = s(d, M);
      return Ye.useEffect(() => (j.itemMap.set(I, { ref: I, ...y }), () => void j.itemMap.delete(I))), /* @__PURE__ */ l.jsx(eo, { [u]: "", ref: D, children: m });
    }
  );
  h.displayName = d;
  function g(p) {
    const f = s(t + "CollectionConsumer", p);
    return Ye.useCallback(() => {
      const m = f.collectionRef.current;
      if (!m) return [];
      const y = Array.from(m.querySelectorAll(`[${u}]`));
      return Array.from(f.itemMap.values()).sort(
        (j, w) => y.indexOf(j.ref.current) - y.indexOf(w.ref.current)
      );
    }, [f.collectionRef, f.itemMap]);
  }
  return [
    { Provider: o, Slot: c, ItemSlot: h },
    g,
    i
  ];
}
var kJ = "VisuallyHidden", vS = N.forwardRef(
  (t, e) => /* @__PURE__ */ l.jsx(
    Fe.span,
    {
      ...t,
      ref: e,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...t.style
      }
    }
  )
);
vS.displayName = kJ;
var ES = "ToastProvider", [CS, OJ, PJ] = vd("Toast"), [H4, Gme] = bc("Toast", [PJ]), [UJ, Hp] = H4(ES), V4 = (t) => {
  const {
    __scopeToast: e,
    label: n = "Notification",
    duration: i = 5e3,
    swipeDirection: r = "right",
    swipeThreshold: s = 50,
    children: o
  } = t, [a, c] = N.useState(null), [d, u] = N.useState(0), h = N.useRef(!1), g = N.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${ES}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ l.jsx(CS.Provider, { scope: e, children: /* @__PURE__ */ l.jsx(
    UJ,
    {
      scope: e,
      label: n,
      duration: i,
      swipeDirection: r,
      swipeThreshold: s,
      toastCount: d,
      viewport: a,
      onViewportChange: c,
      onToastAdd: N.useCallback(() => u((p) => p + 1), []),
      onToastRemove: N.useCallback(() => u((p) => p - 1), []),
      isFocusedToastEscapeKeyDownRef: h,
      isClosePausedRef: g,
      children: o
    }
  ) });
};
V4.displayName = ES;
var K4 = "ToastViewport", RJ = ["F8"], aI = "toast.viewportPause", cI = "toast.viewportResume", X4 = N.forwardRef(
  (t, e) => {
    const {
      __scopeToast: n,
      hotkey: i = RJ,
      label: r = "Notifications ({hotkey})",
      ...s
    } = t, o = Hp(K4, n), a = OJ(n), c = N.useRef(null), d = N.useRef(null), u = N.useRef(null), h = N.useRef(null), g = it(e, h, o.onViewportChange), p = i.join("+").replace(/Key/g, "").replace(/Digit/g, ""), f = o.toastCount > 0;
    N.useEffect(() => {
      const m = (y) => {
        var D;
        i.length !== 0 && i.every((j) => y[j] || y.code === j) && ((D = h.current) == null || D.focus());
      };
      return document.addEventListener("keydown", m), () => document.removeEventListener("keydown", m);
    }, [i]), N.useEffect(() => {
      const m = c.current, y = h.current;
      if (f && m && y) {
        const I = () => {
          if (!o.isClosePausedRef.current) {
            const A = new CustomEvent(aI);
            y.dispatchEvent(A), o.isClosePausedRef.current = !0;
          }
        }, D = () => {
          if (o.isClosePausedRef.current) {
            const A = new CustomEvent(cI);
            y.dispatchEvent(A), o.isClosePausedRef.current = !1;
          }
        }, j = (A) => {
          !m.contains(A.relatedTarget) && D();
        }, w = () => {
          m.contains(document.activeElement) || D();
        };
        return m.addEventListener("focusin", I), m.addEventListener("focusout", j), m.addEventListener("pointermove", I), m.addEventListener("pointerleave", w), window.addEventListener("blur", I), window.addEventListener("focus", D), () => {
          m.removeEventListener("focusin", I), m.removeEventListener("focusout", j), m.removeEventListener("pointermove", I), m.removeEventListener("pointerleave", w), window.removeEventListener("blur", I), window.removeEventListener("focus", D);
        };
      }
    }, [f, o.isClosePausedRef]);
    const M = N.useCallback(
      ({ tabbingDirection: m }) => {
        const I = a().map((D) => {
          const j = D.ref.current, w = [j, ...qJ(j)];
          return m === "forwards" ? w : w.reverse();
        });
        return (m === "forwards" ? I.reverse() : I).flat();
      },
      [a]
    );
    return N.useEffect(() => {
      const m = h.current;
      if (m) {
        const y = (I) => {
          var w, A, b;
          const D = I.altKey || I.ctrlKey || I.metaKey;
          if (I.key === "Tab" && !D) {
            const T = document.activeElement, E = I.shiftKey;
            if (I.target === m && E) {
              (w = d.current) == null || w.focus();
              return;
            }
            const C = M({ tabbingDirection: E ? "backwards" : "forwards" }), z = C.findIndex((O) => O === T);
            WM(C.slice(z + 1)) ? I.preventDefault() : E ? (A = d.current) == null || A.focus() : (b = u.current) == null || b.focus();
          }
        };
        return m.addEventListener("keydown", y), () => m.removeEventListener("keydown", y);
      }
    }, [a, M]), /* @__PURE__ */ l.jsxs(
      DX,
      {
        ref: c,
        role: "region",
        "aria-label": r.replace("{hotkey}", p),
        tabIndex: -1,
        style: { pointerEvents: f ? void 0 : "none" },
        children: [
          f && /* @__PURE__ */ l.jsx(
            lI,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const m = M({
                  tabbingDirection: "forwards"
                });
                WM(m);
              }
            }
          ),
          /* @__PURE__ */ l.jsx(CS.Slot, { scope: n, children: /* @__PURE__ */ l.jsx(Fe.ol, { tabIndex: -1, ...s, ref: g }) }),
          f && /* @__PURE__ */ l.jsx(
            lI,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const m = M({
                  tabbingDirection: "backwards"
                });
                WM(m);
              }
            }
          )
        ]
      }
    );
  }
);
X4.displayName = K4;
var J4 = "ToastFocusProxy", lI = N.forwardRef(
  (t, e) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: i, ...r } = t, s = Hp(J4, n);
    return /* @__PURE__ */ l.jsx(
      vS,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...r,
        ref: e,
        style: { position: "fixed" },
        onFocus: (o) => {
          var d;
          const a = o.relatedTarget;
          !((d = s.viewport) != null && d.contains(a)) && i();
        }
      }
    );
  }
);
lI.displayName = J4;
var Vp = "Toast", YJ = "toast.swipeStart", QJ = "toast.swipeMove", ZJ = "toast.swipeCancel", FJ = "toast.swipeEnd", q4 = N.forwardRef(
  (t, e) => {
    const { forceMount: n, open: i, defaultOpen: r, onOpenChange: s, ...o } = t, [a = !0, c] = go({
      prop: i,
      defaultProp: r,
      onChange: s
    });
    return /* @__PURE__ */ l.jsx(jr, { present: n || a, children: /* @__PURE__ */ l.jsx(
      WJ,
      {
        open: a,
        ...o,
        ref: e,
        onClose: () => c(!1),
        onPause: Bt(t.onPause),
        onResume: Bt(t.onResume),
        onSwipeStart: se(t.onSwipeStart, (d) => {
          d.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: se(t.onSwipeMove, (d) => {
          const { x: u, y: h } = d.detail.delta;
          d.currentTarget.setAttribute("data-swipe", "move"), d.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), d.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${h}px`);
        }),
        onSwipeCancel: se(t.onSwipeCancel, (d) => {
          d.currentTarget.setAttribute("data-swipe", "cancel"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), d.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), d.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: se(t.onSwipeEnd, (d) => {
          const { x: u, y: h } = d.detail.delta;
          d.currentTarget.setAttribute("data-swipe", "end"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), d.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), d.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${h}px`), c(!1);
        })
      }
    ) });
  }
);
q4.displayName = Vp;
var [BJ, GJ] = H4(Vp, {
  onClose() {
  }
}), WJ = N.forwardRef(
  (t, e) => {
    const {
      __scopeToast: n,
      type: i = "foreground",
      duration: r,
      open: s,
      onClose: o,
      onEscapeKeyDown: a,
      onPause: c,
      onResume: d,
      onSwipeStart: u,
      onSwipeMove: h,
      onSwipeCancel: g,
      onSwipeEnd: p,
      ...f
    } = t, M = Hp(Vp, n), [m, y] = N.useState(null), I = it(e, (O) => y(O)), D = N.useRef(null), j = N.useRef(null), w = r || M.duration, A = N.useRef(0), b = N.useRef(w), T = N.useRef(0), { onToastAdd: E, onToastRemove: v } = M, P = Bt(() => {
      var R;
      (m == null ? void 0 : m.contains(document.activeElement)) && ((R = M.viewport) == null || R.focus()), o();
    }), C = N.useCallback(
      (O) => {
        !O || O === 1 / 0 || (window.clearTimeout(T.current), A.current = (/* @__PURE__ */ new Date()).getTime(), T.current = window.setTimeout(P, O));
      },
      [P]
    );
    N.useEffect(() => {
      const O = M.viewport;
      if (O) {
        const R = () => {
          C(b.current), d == null || d();
        }, U = () => {
          const F = (/* @__PURE__ */ new Date()).getTime() - A.current;
          b.current = b.current - F, window.clearTimeout(T.current), c == null || c();
        };
        return O.addEventListener(aI, U), O.addEventListener(cI, R), () => {
          O.removeEventListener(aI, U), O.removeEventListener(cI, R);
        };
      }
    }, [M.viewport, w, c, d, C]), N.useEffect(() => {
      s && !M.isClosePausedRef.current && C(w);
    }, [s, w, M.isClosePausedRef, C]), N.useEffect(() => (E(), () => v()), [E, v]);
    const z = N.useMemo(() => m ? rz(m) : null, [m]);
    return M.viewport ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      z && /* @__PURE__ */ l.jsx(
        HJ,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": i === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: z
        }
      ),
      /* @__PURE__ */ l.jsx(BJ, { scope: n, onClose: P, children: op.createPortal(
        /* @__PURE__ */ l.jsx(CS.ItemSlot, { scope: n, children: /* @__PURE__ */ l.jsx(
          jX,
          {
            asChild: !0,
            onEscapeKeyDown: se(a, () => {
              M.isFocusedToastEscapeKeyDownRef.current || P(), M.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ l.jsx(
              Fe.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": s ? "open" : "closed",
                "data-swipe-direction": M.swipeDirection,
                ...f,
                ref: I,
                style: { userSelect: "none", touchAction: "none", ...t.style },
                onKeyDown: se(t.onKeyDown, (O) => {
                  O.key === "Escape" && (a == null || a(O.nativeEvent), O.nativeEvent.defaultPrevented || (M.isFocusedToastEscapeKeyDownRef.current = !0, P()));
                }),
                onPointerDown: se(t.onPointerDown, (O) => {
                  O.button === 0 && (D.current = { x: O.clientX, y: O.clientY });
                }),
                onPointerMove: se(t.onPointerMove, (O) => {
                  if (!D.current) return;
                  const R = O.clientX - D.current.x, U = O.clientY - D.current.y, F = !!j.current, H = ["left", "right"].includes(M.swipeDirection), Z = ["left", "up"].includes(M.swipeDirection) ? Math.min : Math.max, te = H ? Z(0, R) : 0, oe = H ? 0 : Z(0, U), me = O.pointerType === "touch" ? 10 : 2, he = { x: te, y: oe }, ve = { originalEvent: O, delta: he };
                  F ? (j.current = he, Ru(QJ, h, ve, {
                    discrete: !1
                  })) : Ow(he, M.swipeDirection, me) ? (j.current = he, Ru(YJ, u, ve, {
                    discrete: !1
                  }), O.target.setPointerCapture(O.pointerId)) : (Math.abs(R) > me || Math.abs(U) > me) && (D.current = null);
                }),
                onPointerUp: se(t.onPointerUp, (O) => {
                  const R = j.current, U = O.target;
                  if (U.hasPointerCapture(O.pointerId) && U.releasePointerCapture(O.pointerId), j.current = null, D.current = null, R) {
                    const F = O.currentTarget, H = { originalEvent: O, delta: R };
                    Ow(R, M.swipeDirection, M.swipeThreshold) ? Ru(FJ, p, H, {
                      discrete: !0
                    }) : Ru(
                      ZJ,
                      g,
                      H,
                      {
                        discrete: !0
                      }
                    ), F.addEventListener("click", (Z) => Z.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        M.viewport
      ) })
    ] }) : null;
  }
), HJ = (t) => {
  const { __scopeToast: e, children: n, ...i } = t, r = Hp(Vp, e), [s, o] = N.useState(!1), [a, c] = N.useState(!1);
  return XJ(() => o(!0)), N.useEffect(() => {
    const d = window.setTimeout(() => c(!0), 1e3);
    return () => window.clearTimeout(d);
  }, []), a ? null : /* @__PURE__ */ l.jsx(Td, { asChild: !0, children: /* @__PURE__ */ l.jsx(vS, { ...i, children: s && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    r.label,
    " ",
    n
  ] }) }) });
}, VJ = "ToastTitle", _4 = N.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...i } = t;
    return /* @__PURE__ */ l.jsx(Fe.div, { ...i, ref: e });
  }
);
_4.displayName = VJ;
var KJ = "ToastDescription", $4 = N.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...i } = t;
    return /* @__PURE__ */ l.jsx(Fe.div, { ...i, ref: e });
  }
);
$4.displayName = KJ;
var ez = "ToastAction", tz = N.forwardRef(
  (t, e) => {
    const { altText: n, ...i } = t;
    return n.trim() ? /* @__PURE__ */ l.jsx(iz, { altText: n, asChild: !0, children: /* @__PURE__ */ l.jsx(zS, { ...i, ref: e }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${ez}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
tz.displayName = ez;
var nz = "ToastClose", zS = N.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...i } = t, r = GJ(nz, n);
    return /* @__PURE__ */ l.jsx(iz, { asChild: !0, children: /* @__PURE__ */ l.jsx(
      Fe.button,
      {
        type: "button",
        ...i,
        ref: e,
        onClick: se(t.onClick, r.onClose)
      }
    ) });
  }
);
zS.displayName = nz;
var iz = N.forwardRef((t, e) => {
  const { __scopeToast: n, altText: i, ...r } = t;
  return /* @__PURE__ */ l.jsx(
    Fe.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": i || void 0,
      ...r,
      ref: e
    }
  );
});
function rz(t) {
  const e = [];
  return Array.from(t.childNodes).forEach((i) => {
    if (i.nodeType === i.TEXT_NODE && i.textContent && e.push(i.textContent), JJ(i)) {
      const r = i.ariaHidden || i.hidden || i.style.display === "none", s = i.dataset.radixToastAnnounceExclude === "";
      if (!r)
        if (s) {
          const o = i.dataset.radixToastAnnounceAlt;
          o && e.push(o);
        } else
          e.push(...rz(i));
    }
  }), e;
}
function Ru(t, e, n, { discrete: i }) {
  const r = n.originalEvent.currentTarget, s = new CustomEvent(t, { bubbles: !0, cancelable: !0, detail: n });
  e && r.addEventListener(t, e, { once: !0 }), i ? wd(r, s) : r.dispatchEvent(s);
}
var Ow = (t, e, n = 0) => {
  const i = Math.abs(t.x), r = Math.abs(t.y), s = i > r;
  return e === "left" || e === "right" ? s && i > n : !s && r > n;
};
function XJ(t = () => {
}) {
  const e = Bt(t);
  pr(() => {
    let n = 0, i = 0;
    return n = window.requestAnimationFrame(() => i = window.requestAnimationFrame(e)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(i);
    };
  }, [e]);
}
function JJ(t) {
  return t.nodeType === t.ELEMENT_NODE;
}
function qJ(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => {
      const r = i.tagName === "INPUT" && i.type === "hidden";
      return i.disabled || i.hidden || r ? NodeFilter.FILTER_SKIP : i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function WM(t) {
  const e = document.activeElement;
  return t.some((n) => n === e ? !0 : (n.focus(), document.activeElement !== e));
}
var _J = q4, $J = _4, eq = $4, tq = tz, Pw = zS;
const sz = Ii(null);
function nq({ children: t }) {
  const e = wb("toasts", []), n = yt(() => ({
    toasts: e,
    addToast(i) {
      const r = i.id ?? ht();
      return e.update((s) => [...s.filter((o) => o.id !== i.id), { ...i, id: r }]), r;
    },
    removeToast(i) {
      return e.update((r) => r.filter((s) => s.id !== i)), i;
    },
    clearToasts() {
      e.set([]);
    }
  }), [e]);
  return /* @__PURE__ */ l.jsx(V4, { children: /* @__PURE__ */ l.jsx(sz.Provider, { value: n, children: t }) });
}
function Vr() {
  const t = Vn(sz);
  if (!t)
    throw new Error("useToasts must be used within a ToastsProvider");
  return t;
}
const oz = Ii(null);
function iq({
  assetUrls: t,
  children: e
}) {
  return ze(() => {
    for (const n of Object.values(t.icons)) {
      const i = Vl();
      i.src = n, i.decode();
    }
    for (const n of Object.values(t.embedIcons)) {
      const i = Vl();
      i.src = n, i.decode();
    }
  }, [t]), /* @__PURE__ */ l.jsx(oz.Provider, { value: t, children: e });
}
function Kp() {
  const t = Vn(oz);
  if (!t)
    throw new Error("useAssetUrls must be used within an AssetUrlsProvider");
  return t;
}
const dI = {
  "action.convert-to-bookmark": "Convert to Bookmark",
  "action.convert-to-embed": "Convert to Embed",
  "action.open-embed-link": "Open link",
  "action.align-bottom": "Align bottom",
  "action.align-center-horizontal": "Align horizontally",
  "action.align-center-vertical": "Align vertically",
  "action.align-center-horizontal.short": "Align H",
  "action.align-center-vertical.short": "Align V",
  "action.align-left": "Align left",
  "action.align-right": "Align right",
  "action.align-top": "Align top",
  "action.back-to-content": "Back to content",
  "action.bring-forward": "Bring forward",
  "action.bring-to-front": "Bring to front",
  "action.copy-as-json.short": "JSON",
  "action.copy-as-json": "Copy as JSON",
  "action.copy-as-png.short": "PNG",
  "action.copy-as-png": "Copy as PNG",
  "action.copy-as-svg.short": "SVG",
  "action.copy-as-svg": "Copy as SVG",
  "action.copy": "Copy",
  "action.cut": "Cut",
  "action.delete": "Delete",
  "action.unlock-all": "Unlock all",
  "action.distribute-horizontal": "Distribute horizontally",
  "action.distribute-vertical": "Distribute vertically",
  "action.distribute-horizontal.short": "Distribute H",
  "action.distribute-vertical.short": "Distribute V",
  "action.duplicate": "Duplicate",
  "action.edit-link": "Edit link",
  "action.exit-pen-mode": "Exit pen mode",
  "action.export-as-json.short": "JSON",
  "action.export-as-json": "Export as JSON",
  "action.export-as-png.short": "PNG",
  "action.export-as-png": "Export as PNG",
  "action.export-as-svg.short": "SVG",
  "action.export-as-svg": "Export as SVG",
  "action.export-all-as-json.short": "JSON",
  "action.export-all-as-json": "Export as JSON",
  "action.export-all-as-png.short": "PNG",
  "action.export-all-as-png": "Export as PNG",
  "action.export-all-as-svg.short": "SVG",
  "action.export-all-as-svg": "Export as SVG",
  "action.fit-frame-to-content": "Fit to content",
  "action.flip-horizontal": "Flip horizontally",
  "action.flip-vertical": "Flip vertically",
  "action.flip-horizontal.short": "Flip H",
  "action.flip-vertical.short": "Flip V",
  "action.fork-project": "Fork this project",
  "action.fork-project-on-tldraw": "Fork project on tldraw",
  "action.group": "Group",
  "action.insert-embed": "Insert embed",
  "action.insert-media": "Upload media",
  "action.leave-shared-project": "Leave shared project",
  "action.new-project": "New project",
  "action.new-shared-project": "New shared project",
  "action.open-cursor-chat": "Cursor chat",
  "action.open-file": "Open file",
  "action.pack": "Pack",
  "action.paste": "Paste",
  "action.paste-error-title": "Pasting failed",
  "action.paste-error-description": "Could not paste due to missing clipboard permissions. Please enable the permissions and try again.",
  "action.print": "Print",
  "action.redo": "Redo",
  "action.remove-frame": "Remove frame",
  "action.rename": "Rename",
  "action.rotate-ccw": "Rotate counterclockwise",
  "action.rotate-cw": "Rotate clockwise",
  "action.save-copy": "Save a copy",
  "action.select-all": "Select all",
  "action.select-none": "Select none",
  "action.send-backward": "Send backward",
  "action.send-to-back": "Send to back",
  "action.share-project": "Share this project",
  "action.stack-horizontal": "Stack horizontally",
  "action.stack-vertical": "Stack vertically",
  "action.stack-horizontal.short": "Stack H",
  "action.stack-vertical.short": "Stack V",
  "action.stop-following": "Stop following",
  "action.stretch-horizontal": "Stretch horizontally",
  "action.stretch-vertical": "Stretch vertically",
  "action.stretch-horizontal.short": "Stretch H",
  "action.stretch-vertical.short": "Stretch V",
  "action.toggle-auto-size": "Toggle auto size",
  "action.toggle-dark-mode.menu": "Dark mode",
  "action.toggle-dark-mode": "Toggle dark mode",
  "action.toggle-paste-at-cursor.menu": "Paste at cursor",
  "action.toggle-paste-at-cursor": "Toggle paste at cursor",
  "action.toggle-wrap-mode.menu": "Select on wrap",
  "action.toggle-wrap-mode": "Toggle Select on wrap",
  "action.toggle-reduce-motion.menu": "Reduce motion",
  "action.toggle-reduce-motion": "Toggle reduce motion",
  "action.toggle-edge-scrolling.menu": "Edge scrolling",
  "action.toggle-edge-scrolling": "Toggle edge scrolling",
  "action.toggle-debug-mode.menu": "Debug mode",
  "action.toggle-debug-mode": "Toggle debug mode",
  "action.toggle-focus-mode.menu": "Focus mode",
  "action.toggle-focus-mode": "Toggle focus mode",
  "action.toggle-dynamic-size-mode.menu": "Dynamic size",
  "action.toggle-dynamic-size-mode": "Toggle dynamic size",
  "action.toggle-grid.menu": "Show grid",
  "action.toggle-grid": "Toggle grid",
  "action.toggle-lock": "Toggle locked",
  "action.flatten-to-image": "Flatten",
  "action.toggle-snap-mode.menu": "Always snap",
  "action.toggle-snap-mode": "Toggle always snap",
  "action.toggle-tool-lock.menu": "Tool lock",
  "action.toggle-tool-lock": "Toggle tool lock",
  "action.toggle-transparent.context-menu": "Transparent",
  "action.toggle-transparent.menu": "Transparent",
  "action.toggle-transparent": "Toggle transparent background",
  "action.undo": "Undo",
  "action.ungroup": "Ungroup",
  "action.zoom-in": "Zoom in",
  "action.zoom-out": "Zoom out",
  "action.zoom-to-100": "Zoom to 100%",
  "action.zoom-to-fit": "Zoom to fit",
  "action.zoom-to-selection": "Zoom to selection",
  "assets.files.size-too-big": "File size is too big",
  "assets.files.type-not-allowed": "File type is not allowed",
  "assets.files.upload-failed": "Upload failed",
  "assets.url.failed": "Couldn't load URL preview",
  "theme.dark": "Dark",
  "theme.light": "Light",
  "theme.system": "System",
  "color-style.white": "White",
  "color-style.black": "Black",
  "color-style.blue": "Blue",
  "color-style.green": "Green",
  "color-style.grey": "Grey",
  "color-style.light-blue": "Light blue",
  "color-style.light-green": "Light green",
  "color-style.light-red": "Light red",
  "color-style.light-violet": "Light violet",
  "color-style.orange": "Orange",
  "color-style.red": "Red",
  "color-style.violet": "Violet",
  "color-style.yellow": "Yellow",
  "fill-style.none": "None",
  "document.default-name": "Untitled",
  "fill-style.semi": "Semi",
  "fill-style.solid": "Solid",
  "fill-style.pattern": "Pattern",
  "fill-style.fill": "Fill",
  "dash-style.dashed": "Dashed",
  "dash-style.dotted": "Dotted",
  "dash-style.draw": "Draw",
  "dash-style.solid": "Solid",
  "size-style.s": "Small",
  "size-style.m": "Medium",
  "size-style.l": "Large",
  "size-style.xl": "Extra large",
  "opacity-style.0.1": "10%",
  "opacity-style.0.25": "25%",
  "opacity-style.0.5": "50%",
  "opacity-style.0.75": "75%",
  "opacity-style.1": "100%",
  "font-style.draw": "Draw",
  "font-style.sans": "Sans",
  "font-style.serif": "Serif",
  "font-style.mono": "Mono",
  "align-style.start": "Start",
  "align-style.middle": "Middle",
  "align-style.end": "End",
  "align-style.justify": "Justify",
  "verticalAlign-style.start": "Top",
  "verticalAlign-style.middle": "Middle",
  "verticalAlign-style.end": "Bottom",
  "geo-style.arrow-down": "Arrow down",
  "geo-style.arrow-left": "Arrow left",
  "geo-style.arrow-right": "Arrow right",
  "geo-style.arrow-up": "Arrow up",
  "geo-style.diamond": "Diamond",
  "geo-style.ellipse": "Ellipse",
  "geo-style.hexagon": "Hexagon",
  "geo-style.octagon": "Octagon",
  "geo-style.oval": "Oval",
  "geo-style.cloud": "Cloud",
  "geo-style.pentagon": "Pentagon",
  "geo-style.rectangle": "Rectangle",
  "geo-style.rhombus-2": "Rhombus 2",
  "geo-style.rhombus": "Rhombus",
  "geo-style.star": "Star",
  "geo-style.trapezoid": "Trapezoid",
  "geo-style.triangle": "Triangle",
  "geo-style.x-box": "X box",
  "geo-style.check-box": "Check box",
  "arrowheadStart-style.none": "None",
  "arrowheadStart-style.arrow": "Arrow",
  "arrowheadStart-style.bar": "Bar",
  "arrowheadStart-style.diamond": "Diamond",
  "arrowheadStart-style.dot": "Dot",
  "arrowheadStart-style.inverted": "Inverted",
  "arrowheadStart-style.pipe": "Pipe",
  "arrowheadStart-style.square": "Square",
  "arrowheadStart-style.triangle": "Triangle",
  "arrowheadEnd-style.none": "None",
  "arrowheadEnd-style.arrow": "Arrow",
  "arrowheadEnd-style.bar": "Bar",
  "arrowheadEnd-style.diamond": "Diamond",
  "arrowheadEnd-style.dot": "Dot",
  "arrowheadEnd-style.inverted": "Inverted",
  "arrowheadEnd-style.pipe": "Pipe",
  "arrowheadEnd-style.square": "Square",
  "arrowheadEnd-style.triangle": "Triangle",
  "spline-style.line": "Line",
  "spline-style.cubic": "Cubic",
  "tool.select": "Select",
  "tool.hand": "Hand",
  "tool.draw": "Draw",
  "tool.eraser": "Eraser",
  "tool.arrow-down": "Arrow down",
  "tool.arrow-left": "Arrow left",
  "tool.arrow-right": "Arrow right",
  "tool.arrow-up": "Arrow up",
  "tool.arrow": "Arrow",
  "tool.cloud": "Cloud",
  "tool.diamond": "Diamond",
  "tool.ellipse": "Ellipse",
  "tool.hexagon": "Hexagon",
  "tool.highlight": "Highlight",
  "tool.line": "Line",
  "tool.octagon": "Octagon",
  "tool.oval": "Oval",
  "tool.pentagon": "Pentagon",
  "tool.rectangle": "Rectangle",
  "tool.rhombus": "Rhombus",
  "tool.star": "Star",
  "tool.trapezoid": "Trapezoid",
  "tool.triangle": "Triangle",
  "tool.x-box": "X box",
  "tool.check-box": "Check box",
  "tool.asset": "Asset",
  "tool.frame": "Frame",
  "tool.note": "Note",
  "tool.laser": "Laser",
  "tool.embed": "Embed",
  "tool.text": "Text",
  "tool.pointer-down": "Pointer down",
  "menu.title": "Menu",
  "menu.theme": "Theme",
  "menu.copy-as": "Copy as",
  "menu.edit": "Edit",
  "menu.export-as": "Export as",
  "menu.file": "File",
  "menu.language": "Language",
  "menu.preferences": "Preferences",
  "menu.help": "Help",
  "menu.view": "View",
  "context-menu.edit": "Edit",
  "context-menu.arrange": "Arrange",
  "context-menu.copy-as": "Copy as",
  "context-menu.export-as": "Export as",
  "context-menu.export-all-as": "Export",
  "context-menu.move-to-page": "Move to page",
  "context-menu.reorder": "Reorder",
  "page-menu.title": "Pages",
  "page-menu.create-new-page": "Create new page",
  "page-menu.max-page-count-reached": "Max pages reached",
  "page-menu.new-page-initial-name": "Page 1",
  "page-menu.edit-start": "Edit",
  "page-menu.edit-done": "Done",
  "page-menu.go-to-page": "Go to page",
  "page-menu.submenu.rename": "Rename",
  "page-menu.submenu.duplicate-page": "Duplicate",
  "page-menu.submenu.title": "Menu",
  "page-menu.submenu.move-down": "Move down",
  "page-menu.submenu.move-up": "Move up",
  "page-menu.submenu.delete": "Delete",
  "share-menu.title": "Share",
  "share-menu.save-note": "Download this project to your computer as a .tldr file.",
  "share-menu.fork-note": "Create a new shared project based on this snapshot.",
  "share-menu.share-project": "Share this project",
  "share-menu.default-project-name": "Shared Project",
  "share-menu.copy-link": "Copy editor link",
  "share-menu.readonly-link": "Read-only",
  "share-menu.create-snapshot-link": "Copy snapshot link",
  "share-menu.snapshot-link-note": "Capture and share this project as a read-only snapshot link.",
  "share-menu.copy-readonly-link": "Copy viewer link",
  "share-menu.offline-note": "Create a new shared project based on your current project.",
  "share-menu.copy-link-note": "Anyone with the link will be able to view and edit this project.",
  "share-menu.copy-readonly-link-note": "Anyone with the link will be able to access this project.",
  "share-menu.project-too-large": "Sorry, this project can't be shared because it's too large. We're working on it!",
  "share-menu.upload-failed": "Sorry, we couldn't upload your project at the moment. Please try again or let us know if the problem persists.",
  "share-menu.creating-project": "Creating the new project…",
  "share-menu.copied": "Copied link",
  "document-name-menu.copy-link": "Copy link",
  "status.offline": "Offline",
  "status.online": "Online",
  "people-menu.title": "People",
  "people-menu.change-name": "Change name",
  "people-menu.change-color": "Change color",
  "people-menu.follow": "Following",
  "people-menu.following": "Following",
  "people-menu.leading": "Following You",
  "people-menu.user": "(You)",
  "people-menu.invite": "Invite others",
  "help-menu.title": "Help and resources",
  "help-menu.about": "About tldraw",
  "help-menu.docs": "Documentation & API",
  "help-menu.discord": "Discord",
  "help-menu.github": "GitHub",
  "help-menu.keyboard-shortcuts": "Keyboard shortcuts",
  "help-menu.twitter": "Twitter",
  "help-menu.terms": "Terms of service",
  "help-menu.privacy": "Privacy policy",
  "actions-menu.title": "Actions",
  "edit-link-dialog.title": "Edit link",
  "edit-link-dialog.invalid-url": "A link must be a valid URL.",
  "edit-link-dialog.detail": "Links will open in a new tab.",
  "edit-link-dialog.url": "URL",
  "edit-link-dialog.clear": "Clear",
  "edit-link-dialog.save": "Continue",
  "edit-link-dialog.cancel": "Cancel",
  "embed-dialog.title": "Insert embed",
  "embed-dialog.back": "Back",
  "embed-dialog.create": "Create",
  "embed-dialog.cancel": "Cancel",
  "embed-dialog.url": "URL",
  "embed-dialog.instruction": "Paste in the site's URL to create the embed.",
  "embed-dialog.invalid-url": "We could not create an embed from that URL.",
  "edit-pages-dialog.move-down": "Move down",
  "edit-pages-dialog.move-up": "Move up",
  "shortcuts-dialog.title": "Keyboard shortcuts",
  "shortcuts-dialog.edit": "Edit",
  "shortcuts-dialog.file": "File",
  "shortcuts-dialog.preferences": "Preferences",
  "shortcuts-dialog.tools": "Tools",
  "shortcuts-dialog.transform": "Transform",
  "shortcuts-dialog.view": "View",
  "shortcuts-dialog.collaboration": "Collaboration",
  "home-project-dialog.title": "Home project",
  "home-project-dialog.description": "This is your local home project. It's just for you!",
  "rename-project-dialog.title": "Rename project",
  "rename-project-dialog.cancel": "Cancel",
  "rename-project-dialog.rename": "Rename",
  "home-project-dialog.ok": "Ok",
  "style-panel.title": "Styles",
  "style-panel.align": "Align",
  "style-panel.label-align": "Label align",
  "style-panel.vertical-align": "Vertical align",
  "style-panel.position": "Position",
  "style-panel.arrowheads": "Arrows",
  "style-panel.arrowhead-start": "Start",
  "style-panel.arrowhead-end": "End",
  "style-panel.color": "Color",
  "style-panel.dash": "Dash",
  "style-panel.fill": "Fill",
  "style-panel.font": "Font",
  "style-panel.geo": "Shape",
  "style-panel.mixed": "Mixed",
  "style-panel.opacity": "Opacity",
  "style-panel.size": "Size",
  "style-panel.spline": "Spline",
  "tool-panel.drawing": "Drawing",
  "tool-panel.shapes": "Shapes",
  "tool-panel.more": "More",
  "debug-panel.more": "More",
  "navigation-zone.toggle-minimap": "Toggle minimap",
  "navigation-zone.zoom": "Zoom",
  "focus-mode.toggle-focus-mode": "Toggle focus mode",
  "toast.close": "Close",
  "file-system.file-open-error.title": "Could not open file",
  "file-system.file-open-error.not-a-tldraw-file": "The file you tried to open doesn't look like a tldraw file.",
  "file-system.file-open-error.file-format-version-too-new": "The file you tried to open is from a newer version of tldraw. Please reload the page and try again.",
  "file-system.file-open-error.generic-corrupted-file": "The file you tried to open is corrupted.",
  "file-system.confirm-open.title": "Overwrite current project?",
  "file-system.confirm-open.description": "Opening a file will replace your current project and any unsaved changes will be lost. Are you sure you want to continue?",
  "file-system.confirm-open.cancel": "Cancel",
  "file-system.confirm-open.open": "Open file",
  "file-system.confirm-open.dont-show-again": "Don't ask again",
  "file-system.confirm-clear.title": "Clear current project?",
  "file-system.confirm-clear.description": "Creating a new project will clear your current project and any unsaved changes will be lost. Are you sure you want to continue?",
  "file-system.confirm-clear.cancel": "Cancel",
  "file-system.confirm-clear.continue": "Continue",
  "file-system.confirm-clear.dont-show-again": "Don't ask again",
  "file-system.shared-document-file-open-error.title": "Could not open file",
  "file-system.shared-document-file-open-error.description": "Opening files from shared projects is not supported.",
  "sharing.confirm-leave.title": "Leave current project?",
  "sharing.confirm-leave.description": "Are you sure you want to leave this shared project? You can return to it by navigating to its URL.",
  "sharing.confirm-leave.cancel": "Cancel",
  "sharing.confirm-leave.leave": "Leave",
  "sharing.confirm-leave.dont-show-again": "Don't ask again",
  "toast.error.export-fail.title": "Failed export",
  "toast.error.export-fail.desc": "Failed to export image",
  "toast.error.copy-fail.title": "Failed copy",
  "toast.error.copy-fail.desc": "Failed to copy image",
  "context.pages.new-page": "New page",
  "vscode.file-open.desc": "We've updated this document to work with the current version of tldraw. If you'd like to keep the original version (which will work on old.tldraw.com), click below to create a backup.",
  "vscode.file-open.open": "Continue",
  "vscode.file-open.backup": "Backup",
  "vscode.file-open.backup-saved": "Backup saved",
  "vscode.file-open.backup-failed": "Backup failed: this is not a .tldr file.",
  "vscode.file-open.dont-show-again": "Don't ask again",
  "cursor-chat.type-to-chat": "Type to chat..."
}, rq = /* @__PURE__ */ new Set(["ar", "fa", "he", "ur", "ku"]), pa = {
  locale: "en",
  label: "English",
  messages: dI,
  dir: "ltr"
};
async function sq(t, e) {
  if (!(await gr(e.translations.en)).ok)
    return console.warn("No main translations found."), pa;
  if (t === "en")
    return pa;
  const i = Jl.find((a) => a.locale === t);
  if (!i)
    return console.warn(`No translation found for locale ${t}`), pa;
  const s = await (await gr(e.translations[i.locale])).json();
  if (!s)
    return console.warn(`No messages found for locale ${t}`), pa;
  const o = [];
  for (const a in pa.messages)
    s[a] || o.push(a);
  return o.length > 0 && process.env.NODE_ENV === "development" && console.warn(`Language ${t}: missing messages for keys:
${o.join(`
`)}`), {
    locale: t,
    label: i.label,
    dir: rq.has(i.locale) ? "rtl" : "ltr",
    messages: { ...pa.messages, ...s }
  };
}
const az = N.createContext(null);
function cz() {
  const t = N.useContext(az);
  if (!t)
    throw new Error("useCurrentTranslation must be used inside of <TldrawUiContextProvider />");
  return t;
}
function oq({
  overrides: t,
  locale: e,
  children: n
}) {
  const i = Kp(), [r, s] = N.useState(() => t && t.en ? {
    locale: "en",
    label: "English",
    dir: "ltr",
    messages: { ...dI, ...t.en }
  } : {
    locale: "en",
    label: "English",
    dir: "ltr",
    messages: dI
  });
  return N.useEffect(() => {
    let o = !1;
    async function a() {
      const c = await sq(e, i);
      c && !o && (t && t[e] ? s({
        ...c,
        messages: { ...c.messages, ...t[e] }
      }) : s(c));
    }
    return a(), () => {
      o = !0;
    };
  }, [i, e, t]), /* @__PURE__ */ l.jsx(az.Provider, { value: r, children: n });
}
function ke() {
  const t = cz();
  return N.useCallback(
    function(n) {
      return t.messages[n] ?? n;
    },
    [t]
  );
}
const q = N.forwardRef(
  function({ children: e, type: n, ...i }, r) {
    return /* @__PURE__ */ l.jsx(
      "button",
      {
        ref: r,
        type: "button",
        draggable: !1,
        ...i,
        className: ce("tlui-button", `tlui-button__${n}`, i.className),
        children: e
      }
    );
  }
);
function St({ children: t }) {
  return /* @__PURE__ */ l.jsx("span", { className: "tlui-button__label", children: t });
}
const Ui = _e(function({
  small: e,
  invertIcon: n,
  icon: i,
  color: r,
  className: s,
  ...o
}) {
  const a = Kp(), c = a.icons[i] ?? a.icons["question-mark-circle"], d = le(null);
  return at(() => {
    c || console.error(`Icon not found: ${i}. Add it to the assetUrls.icons object.`), d != null && d.current && (d.current.style.webkitMask = `url(${c}) center 100% / 100% no-repeat`);
  }, [d, c, i]), i === "none" ? /* @__PURE__ */ l.jsx(
    "div",
    {
      className: ce(
        "tlui-icon tlui-icon__placeholder",
        { "tlui-icon__small": e },
        s
      )
    }
  ) : /* @__PURE__ */ l.jsx(
    "div",
    {
      ...o,
      ref: d,
      className: ce("tlui-icon", { "tlui-icon__small": e }, s),
      style: {
        color: r,
        mask: `url(${c}) center 100% / 100% no-repeat`,
        transform: n ? "scale(-1, 1)" : void 0
      }
    }
  );
}), aq = 4e3, cq = {
  success: "check-circle",
  warning: "warning-triangle",
  error: "cross-circle",
  info: "info-circle"
};
function lq({ toast: t }) {
  const { removeToast: e } = Vr(), n = ke(), i = (o) => {
    o || e(t.id);
  }, r = t.actions && t.actions.length > 0, s = t.icon || t.severity && cq[t.severity];
  return /* @__PURE__ */ l.jsxs(
    _J,
    {
      onOpenChange: i,
      className: "tlui-toast__container",
      duration: t.keepOpen ? 1 / 0 : aq,
      "data-severity": t.severity,
      children: [
        s && /* @__PURE__ */ l.jsx("div", { className: "tlui-toast__icon", children: /* @__PURE__ */ l.jsx(Ui, { icon: s }) }),
        /* @__PURE__ */ l.jsxs("div", { className: "tlui-toast__main", children: [
          /* @__PURE__ */ l.jsxs("div", { className: "tlui-toast__content", children: [
            t.title && /* @__PURE__ */ l.jsx($J, { className: "tlui-toast__title", children: t.title }),
            t.description && /* @__PURE__ */ l.jsx(eq, { className: "tlui-toast__description", children: t.description })
          ] }),
          t.actions && /* @__PURE__ */ l.jsxs("div", { className: "tlui-toast__actions", children: [
            t.actions.map((o, a) => /* @__PURE__ */ l.jsx(tq, { altText: o.label, asChild: !0, onClick: o.onClick, children: /* @__PURE__ */ l.jsx(q, { type: o.type, children: /* @__PURE__ */ l.jsx(St, { children: o.label }) }) }, a)),
            /* @__PURE__ */ l.jsx(Pw, { asChild: !0, children: /* @__PURE__ */ l.jsx(
              q,
              {
                type: "normal",
                className: "tlui-toast__close",
                style: { marginLeft: "auto" },
                children: /* @__PURE__ */ l.jsx(St, { children: t.closeLabel ?? n("toast.close") })
              }
            ) })
          ] })
        ] }),
        !r && /* @__PURE__ */ l.jsx(Pw, { asChild: !0, children: /* @__PURE__ */ l.jsx(q, { type: "normal", className: "tlui-toast__close", children: /* @__PURE__ */ l.jsx(St, { children: t.closeLabel ?? n("toast.close") }) }) })
      ]
    }
  );
}
const dq = _e(function() {
  const { toasts: e } = Vr(), n = G("toasts", () => e.get(), []);
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    n.map((i) => /* @__PURE__ */ l.jsx(lq, { toast: i }, i.id)),
    /* @__PURE__ */ l.jsx(X4, { className: "tlui-toast__viewport" })
  ] });
});
function It(t, e) {
  var r;
  const n = /* @__PURE__ */ new Set();
  for (const s of e) {
    const o = t.getShape(s);
    if (!o) continue;
    t.getShapeUtil(o).onDragShapesOut && n.add(o);
    const a = t.getShape(o.parentId);
    a && t.getShapeUtil(a).onDragShapesOut && n.add(a);
  }
  const i = /* @__PURE__ */ new Map();
  for (const s of n) {
    const o = lz(t, s);
    o.length && i.set(s, o);
  }
  for (const [s, o] of i) {
    const a = t.getShapeUtil(s), c = Ze(o.map((d) => t.getShape(d)));
    (r = a.onDragShapesOut) == null || r.call(a, s, c);
  }
}
function lz(t, e) {
  const n = t.getSortedChildIdsForParent(e.id);
  if (n.length === 0) return [];
  const i = t.getShapePageBounds(e);
  if (!i) return [];
  let r, s, o;
  const a = [];
  for (const c of n) {
    const d = t.getShapePageBounds(c);
    if (!d)
      continue;
    if (!i.includes(d)) {
      a.push(c);
      continue;
    }
    r ?? (r = t.getShapeGeometry(e)), s ?? (s = t.getShapePageTransform(e)), o ?? (o = s.applyToPoints(r.vertices));
    const u = t.getShapePageTransform(c).clone().invert().applyToPoints(o), { vertices: h, isClosed: g } = t.getShapeGeometry(c);
    if (!h.some((p) => yi(p, u))) {
      if (g) {
        if (r1(u, h))
          continue;
      } else if (jV(u, h))
        continue;
      a.push(c);
    }
  }
  return a;
}
function Pg(t, e, n = !1) {
  t.select(e), t.setEditingShape(e), t.setCurrentTool("select.editing_shape", {
    target: "shape",
    shape: e
  }), n && t.emit("select-all-text", { shapeId: e.id }), dz(t);
}
const uq = 16;
function dz(t) {
  const e = t.getSelectionPageBounds(), n = t.getViewportPageBounds();
  if (e && !n.contains(e)) {
    const i = e.clone().expandBy(uq / t.getZoomLevel()).expand(n), r = n.clone().translate({
      x: (i.center.x - n.center.x) * 2,
      y: (i.center.y - n.center.y) * 2
    });
    t.zoomToBounds(r, {
      animation: {
        duration: t.options.animationMediumMs
      },
      inset: 0
    });
  }
}
function hq(t, e) {
  const n = Ze(
    e.map((r) => t.getShape(r)).filter((r) => r && t.isShapeOfType(r, "frame"))
  );
  if (!n.length) return;
  const i = [];
  t.run(() => {
    n.map((r) => {
      const s = t.getSortedChildIdsForParent(r.id);
      s.length && (t.reparentShapes(s, r.parentId, r.index), i.push(...s));
    }), t.setSelectedShapes(i), t.deleteShapes(e);
  });
}
const gq = 50;
function pq(t, e, n = {}) {
  const i = t.getShape(e);
  if (!i) return;
  const r = t.getSortedChildIdsForParent(i.id), s = Ze(r.map((p) => t.getShape(p)));
  if (!s.length) return;
  const o = ae.FromPoints(
    s.flatMap((p) => {
      const f = t.getShapeGeometry(p.id);
      return t.getShapeLocalTransform(p).applyToPoints(f.vertices);
    })
  ), { padding: a = gq } = n, c = o.w + 2 * a, d = o.h + 2 * a, u = a - o.minX, h = a - o.minY;
  if (u === 0 && h === 0 && i.props.w === c && i.props.h === d) return;
  const g = new x(u, h).rot(i.rotation);
  t.run(() => {
    const p = r.map((f) => {
      const M = t.getShape(f);
      return {
        id: M.id,
        type: M.type,
        x: M.x + u,
        y: M.y + h
      };
    });
    p.push({
      id: i.id,
      type: i.type,
      x: i.x - g.x,
      y: i.y - g.y,
      props: {
        w: c,
        h: d
      }
    }), t.updateShapes(p);
  });
}
function Te({ icon: t, small: e, invertIcon: n }) {
  return /* @__PURE__ */ l.jsx(Ui, { className: "tlui-button__icon", icon: t, small: e, invertIcon: n });
}
function Ed({ className: t, children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: ce("tlui-dialog__header", t), children: e });
}
function Cd({ className: t, children: e }) {
  return /* @__PURE__ */ l.jsx(U4, { dir: "ltr", className: ce("tlui-dialog__header__title", t), children: e });
}
function zd() {
  return /* @__PURE__ */ l.jsx("div", { className: "tlui-dialog__header__close", children: /* @__PURE__ */ l.jsx(Q4, { "data-testid": "dialog.close", dir: "ltr", asChild: !0, children: /* @__PURE__ */ l.jsx(
    q,
    {
      type: "icon",
      "aria-label": "Close",
      onTouchEnd: (t) => t.target.click(),
      children: /* @__PURE__ */ l.jsx(Te, { small: !0, icon: "cross-2" })
    }
  ) }) });
}
function Ja({ className: t, children: e, style: n }) {
  return /* @__PURE__ */ l.jsx("div", { className: ce("tlui-dialog__body", t), style: n, children: e });
}
function Xp({ className: t, children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: ce("tlui-dialog__footer", t), children: e });
}
const Ld = N.forwardRef(
  function({
    className: e,
    label: n,
    icon: i,
    iconLeft: r,
    autoSelect: s = !1,
    autoFocus: o = !1,
    defaultValue: a,
    placeholder: c,
    onComplete: d,
    onValueChange: u,
    onCancel: h,
    onFocus: g,
    onBlur: p,
    shouldManuallyMaintainScrollPositionWhenFocused: f = !1,
    children: M,
    value: m
  }, y) {
    const I = Xx(), D = N.useRef(null);
    N.useImperativeHandle(y, () => D.current);
    const j = ke(), w = N.useRef(a ?? ""), A = N.useRef(a ?? ""), [b, T] = N.useState(!1), E = N.useCallback(
      (z) => {
        T(!0);
        const O = z.currentTarget;
        A.current = O.value, I ? I.timers.requestAnimationFrame(() => {
          s && O.select();
        }) : Jy.requestAnimationFrame("anon", () => {
          s && O.select();
        }), g == null || g();
      },
      [s, I, g]
    ), v = N.useCallback(
      (z) => {
        const O = z.currentTarget.value;
        A.current = O, u == null || u(O);
      },
      [u]
    ), P = N.useCallback(
      (z) => {
        switch (z.key) {
          case "Enter": {
            z.currentTarget.blur(), Yt(z), d == null || d(z.currentTarget.value);
            break;
          }
          case "Escape": {
            z.currentTarget.value = w.current, h == null || h(z.currentTarget.value), z.currentTarget.blur(), Yt(z);
            break;
          }
        }
      },
      [d, h]
    ), C = N.useCallback(
      (z) => {
        T(!1);
        const O = z.currentTarget.value;
        p == null || p(O);
      },
      [p]
    );
    return N.useEffect(() => {
      if (!mt.isIos) return;
      const z = window.visualViewport;
      if (b && f && z) {
        const O = () => {
          var R;
          (R = D.current) == null || R.scrollIntoView({ block: "center" });
        };
        return z.addEventListener("resize", O), z.addEventListener("scroll", O), I ? I.timers.requestAnimationFrame(() => {
          var R;
          (R = D.current) == null || R.scrollIntoView({ block: "center" });
        }) : Jy.requestAnimationFrame("anon", () => {
          var R;
          (R = D.current) == null || R.scrollIntoView({ block: "center" });
        }), () => {
          z.removeEventListener("resize", O), z.removeEventListener("scroll", O);
        };
      }
    }, [b, I, f]), /* @__PURE__ */ l.jsxs("div", { draggable: !1, className: "tlui-input__wrapper", children: [
      M,
      n && /* @__PURE__ */ l.jsx("label", { children: j(n) }),
      r && /* @__PURE__ */ l.jsx(Ui, { icon: r, className: "tlui-icon-left", small: !0 }),
      /* @__PURE__ */ l.jsx(
        "input",
        {
          ref: D,
          className: ce("tlui-input", e),
          type: "text",
          defaultValue: a,
          onKeyDownCapture: P,
          onChange: v,
          onFocus: E,
          onBlur: C,
          autoFocus: o,
          placeholder: c,
          value: m
        }
      ),
      i && /* @__PURE__ */ l.jsx(Ui, { icon: i, small: !!n })
    ] });
  }
);
function Uw(t) {
  return Li.isValid(t) ? { isValid: !0, hasProtocol: !0 } : Li.isValid("https://" + t) ? { isValid: !0, hasProtocol: !1 } : { isValid: !1, hasProtocol: !1 };
}
const fq = Vt(function({ onClose: e }) {
  const i = Q().getOnlySelectedShape();
  return i && "url" in i.props && typeof i.props.url == "string" ? /* @__PURE__ */ l.jsx(Mq, { onClose: e, selectedShape: i }) : null;
}), Mq = Vt(function({
  onClose: e,
  selectedShape: n
}) {
  const i = Q(), r = ke(), s = le(null);
  ze(() => {
    i.timers.requestAnimationFrame(() => {
      var f;
      return (f = s.current) == null ? void 0 : f.focus();
    });
  }, [i]);
  const o = le(n.props.url), [a, c] = pe(() => {
    const f = Uw(n.props.url), M = f.isValid === !0 ? f.hasProtocol ? n.props.url : "https://" + n.props.url : "https://";
    return {
      actual: M,
      safe: M,
      valid: !0
    };
  }), d = re((f) => {
    const M = f.replace(/https?:\/\/(https?:\/\/)/, (I, D) => D), m = Uw(M), y = m.isValid === !0 ? m.hasProtocol ? M : "https://" + M : "https://";
    c({
      actual: M,
      safe: y,
      valid: m.isValid
    });
  }, []), u = re(() => {
    const f = i.getOnlySelectedShape();
    f && (i.updateShapes([
      { id: f.id, type: f.type, props: { url: "" } }
    ]), e());
  }, [i, e]), h = re(() => {
    const f = i.getOnlySelectedShape();
    f && (f && "url" in f.props && f.props.url !== a.safe && i.updateShapes([
      {
        id: f.id,
        type: f.type,
        props: { url: a.safe }
      }
    ]), e());
  }, [i, e, a]), g = re(() => {
    e();
  }, [e]);
  if (!n)
    return e(), null;
  const p = o.current && !a.valid;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(Ed, { children: [
      /* @__PURE__ */ l.jsx(Cd, { children: r("edit-link-dialog.title") }),
      /* @__PURE__ */ l.jsx(zd, {})
    ] }),
    /* @__PURE__ */ l.jsx(Ja, { children: /* @__PURE__ */ l.jsxs("div", { className: "tlui-edit-link-dialog", children: [
      /* @__PURE__ */ l.jsx(
        Ld,
        {
          ref: s,
          className: "tlui-edit-link-dialog__input",
          label: "edit-link-dialog.url",
          autoFocus: !0,
          value: a.actual,
          onValueChange: d,
          onComplete: h,
          onCancel: g
        }
      ),
      /* @__PURE__ */ l.jsx("div", { children: a.valid ? r("edit-link-dialog.detail") : r("edit-link-dialog.invalid-url") })
    ] }) }),
    /* @__PURE__ */ l.jsxs(Xp, { className: "tlui-dialog__footer__actions", children: [
      /* @__PURE__ */ l.jsx(q, { type: "normal", onClick: g, onTouchEnd: g, children: /* @__PURE__ */ l.jsx(St, { children: r("edit-link-dialog.cancel") }) }),
      p ? /* @__PURE__ */ l.jsx(q, { type: "danger", onTouchEnd: u, onClick: u, children: /* @__PURE__ */ l.jsx(St, { children: r("edit-link-dialog.clear") }) }) : /* @__PURE__ */ l.jsx(
        q,
        {
          type: "primary",
          disabled: !a.valid,
          onTouchEnd: h,
          onClick: h,
          children: /* @__PURE__ */ l.jsx(St, { children: r("edit-link-dialog.save") })
        }
      )
    ] })
  ] });
}), Rw = /(^\/r\/[^/]+\/?$)/, LS = [
  {
    type: "tldraw",
    title: "tldraw",
    hostnames: ["beta.tldraw.com", "tldraw.com", "localhost:3000"],
    minWidth: 300,
    minHeight: 300,
    width: 720,
    height: 500,
    doesResize: !0,
    overridePermissions: {
      "allow-top-navigation": !0
    },
    toEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(Rw))
        return t;
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(Rw))
        return t;
    }
  },
  {
    type: "figma",
    title: "Figma",
    hostnames: ["figma.com"],
    width: 720,
    height: 500,
    doesResize: !0,
    toEmbedUrl: (t) => {
      if (t.match(
        // eslint-disable-next-line no-useless-escape
        /https:\/\/([\w\.-]+\.)?figma.com\/(file|proto)\/([0-9a-zA-Z]{22,128})(?:\/.*)?$/
      ) && !t.includes("figma.com/embed"))
        return `https://www.figma.com/embed?embed_host=share&url=${t}`;
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/^\/embed\/?$/)) {
        const n = e.searchParams.get("url");
        if (n)
          return n;
      }
    }
  },
  {
    type: "google_maps",
    title: "Google Maps",
    hostnames: ["google.*"],
    width: 720,
    height: 500,
    doesResize: !0,
    overridePermissions: {
      "allow-presentation": !0
    },
    toEmbedUrl: (t) => {
      if (t.includes("/maps/")) {
        const e = t.match(/@(.*),(.*),(.*)z/);
        let n;
        if (e) {
          const [, i, r, s] = e;
          n = `https://${new URL(t).host.replace("www.", "")}/maps/embed/v1/view?key=${process.env.NEXT_PUBLIC_GC_API_KEY}&center=${i},${r}&zoom=${s}`;
        } else
          n = "";
        return n;
      }
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (!e) return;
      if (e.pathname.match(/^\/maps\/embed\/v1\/view\/?$/) && e.searchParams.has("center") && e.searchParams.get("zoom")) {
        const i = e.searchParams.get("zoom"), [r, s] = e.searchParams.get("center").split(",");
        return `https://www.google.com/maps/@${r},${s},${i}z`;
      }
    }
  },
  {
    type: "val_town",
    title: "Val Town",
    hostnames: ["val.town"],
    minWidth: 260,
    minHeight: 100,
    width: 720,
    height: 500,
    doesResize: !0,
    toEmbedUrl: (t) => {
      const e = Le(t), n = e && e.pathname.match(/\/v\/(.+)\/?/);
      if (n)
        return `https://www.val.town/embed/${n[1]}`;
    },
    fromEmbedUrl: (t) => {
      const e = Le(t), n = e && e.pathname.match(/\/embed\/(.+)\/?/);
      if (n)
        return `https://www.val.town/v/${n[1]}`;
    }
  },
  {
    type: "codesandbox",
    title: "CodeSandbox",
    hostnames: ["codesandbox.io"],
    minWidth: 300,
    minHeight: 300,
    width: 720,
    height: 500,
    doesResize: !0,
    toEmbedUrl: (t) => {
      const e = Le(t), n = e && e.pathname.match(/\/s\/([^/]+)\/?/);
      if (n)
        return `https://codesandbox.io/embed/${n[1]}`;
    },
    fromEmbedUrl: (t) => {
      const e = Le(t), n = e && e.pathname.match(/\/embed\/([^/]+)\/?/);
      if (n)
        return `https://codesandbox.io/s/${n[1]}`;
    }
  },
  {
    type: "codepen",
    title: "Codepen",
    hostnames: ["codepen.io"],
    minWidth: 300,
    minHeight: 300,
    width: 520,
    height: 400,
    doesResize: !0,
    toEmbedUrl: (t) => {
      const e = /https:\/\/codepen.io\/([^/]+)\/pen\/([^/]+)/, n = t.match(e);
      if (n) {
        const [i, r, s] = n;
        return `https://codepen.io/${r}/embed/${s}`;
      }
    },
    fromEmbedUrl: (t) => {
      const e = /https:\/\/codepen.io\/([^/]+)\/embed\/([^/]+)/, n = t.match(e);
      if (n) {
        const [i, r, s] = n;
        return `https://codepen.io/${r}/pen/${s}`;
      }
    }
  },
  {
    type: "scratch",
    title: "Scratch",
    hostnames: ["scratch.mit.edu"],
    width: 520,
    height: 400,
    doesResize: !1,
    toEmbedUrl: (t) => {
      const e = /https?:\/\/scratch.mit.edu\/projects\/([^/]+)/, n = t.match(e);
      if (n) {
        const [i, r] = n;
        return `https://scratch.mit.edu/projects/embed/${r}`;
      }
    },
    fromEmbedUrl: (t) => {
      const e = /https:\/\/scratch.mit.edu\/projects\/embed\/([^/]+)/, n = t.match(e);
      if (n) {
        const [i, r] = n;
        return `https://scratch.mit.edu/projects/${r}`;
      }
    }
  },
  {
    type: "youtube",
    title: "YouTube",
    hostnames: ["*.youtube.com", "youtube.com", "youtu.be"],
    width: 800,
    height: 450,
    doesResize: !0,
    overridePermissions: {
      "allow-presentation": !0,
      "allow-popups-to-escape-sandbox": !0
    },
    isAspectRatioLocked: !0,
    toEmbedUrl: (t) => {
      const e = Le(t);
      if (!e) return;
      const n = e.hostname.replace(/^www./, "");
      if (n === "youtu.be")
        return `https://www.youtube.com/embed/${e.pathname.split("/").filter(Boolean)[0]}`;
      if ((n === "youtube.com" || n === "m.youtube.com") && e.pathname.match(/^\/watch/))
        return `https://www.youtube.com/embed/${e.searchParams.get("v")}`;
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (!e) return;
      if (e.hostname.replace(/^www./, "") === "youtube.com") {
        const i = e.pathname.match(/^\/embed\/([^/]+)\/?/);
        if (i)
          return `https://www.youtube.com/watch?v=${i[1]}`;
      }
    }
  },
  {
    type: "google_calendar",
    title: "Google Calendar",
    hostnames: ["calendar.google.*"],
    width: 720,
    height: 500,
    minWidth: 460,
    minHeight: 360,
    doesResize: !0,
    instructionLink: "https://support.google.com/calendar/answer/41207?hl=en",
    overridePermissions: {
      "allow-popups-to-escape-sandbox": !0
    },
    toEmbedUrl: (t) => {
      const e = Le(t), n = e == null ? void 0 : e.searchParams.get("cid");
      if (e != null && e.pathname.match(/\/calendar\/u\/0/) && n) {
        e.pathname = "/calendar/embed";
        const i = Array.from(e.searchParams.keys());
        for (const r of i)
          e.searchParams.delete(r);
        return e.searchParams.set("src", n), e.href;
      }
    },
    fromEmbedUrl: (t) => {
      const e = Le(t), n = e == null ? void 0 : e.searchParams.get("src");
      if (e != null && e.pathname.match(/\/calendar\/embed/) && n) {
        e.pathname = "/calendar/u/0";
        const i = Array.from(e.searchParams.keys());
        for (const r of i)
          e.searchParams.delete(r);
        return e.searchParams.set("cid", n), e.href;
      }
    }
  },
  {
    type: "google_slides",
    title: "Google Slides",
    hostnames: ["docs.google.*"],
    width: 720,
    height: 500,
    minWidth: 460,
    minHeight: 360,
    doesResize: !0,
    overridePermissions: {
      "allow-popups-to-escape-sandbox": !0
    },
    toEmbedUrl: (t) => {
      const e = Le(t);
      if (e != null && e.pathname.match(/^\/presentation/) && (e != null && e.pathname.match(/\/pub\/?$/))) {
        e.pathname = e.pathname.replace(/\/pub$/, "/embed");
        const n = Array.from(e.searchParams.keys());
        for (const i of n)
          e.searchParams.delete(i);
        return e.href;
      }
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e != null && e.pathname.match(/^\/presentation/) && (e != null && e.pathname.match(/\/embed\/?$/))) {
        e.pathname = e.pathname.replace(/\/embed$/, "/pub");
        const n = Array.from(e.searchParams.keys());
        for (const i of n)
          e.searchParams.delete(i);
        return e.href;
      }
    }
  },
  {
    type: "github_gist",
    title: "GitHub Gist",
    hostnames: ["gist.github.com"],
    width: 720,
    height: 500,
    doesResize: !0,
    toEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/\/([^/]+)\/([^/]+)/))
        return t.split("/").pop() ? t : void 0;
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/\/([^/]+)\/([^/]+)/))
        return t.split("/").pop() ? t : void 0;
    }
  },
  {
    type: "replit",
    title: "Replit",
    hostnames: ["replit.com"],
    width: 720,
    height: 500,
    doesResize: !0,
    toEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/\/@([^/]+)\/([^/]+)/))
        return `${t}?embed=true`;
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/\/@([^/]+)\/([^/]+)/) && e.searchParams.has("embed"))
        return e.searchParams.delete("embed"), e.href;
    }
  },
  {
    type: "felt",
    title: "Felt",
    hostnames: ["felt.com"],
    width: 720,
    height: 500,
    doesResize: !0,
    toEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/^\/map\//))
        return e.origin + "/embed" + e.pathname;
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/^\/embed\/map\//))
        return e.pathname = e.pathname.replace(/^\/embed/, ""), e.href;
    }
  },
  {
    type: "spotify",
    title: "Spotify",
    hostnames: ["open.spotify.com"],
    width: 720,
    height: 500,
    minHeight: 500,
    overrideOutlineRadius: 12,
    doesResize: !0,
    toEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/^\/(artist|album)\//))
        return e.origin + "/embed" + e.pathname;
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/^\/embed\/(artist|album)\//))
        return e.origin + e.pathname.replace(/^\/embed/, "");
    }
  },
  {
    type: "vimeo",
    title: "Vimeo",
    hostnames: ["vimeo.com", "player.vimeo.com"],
    width: 640,
    height: 360,
    doesResize: !0,
    isAspectRatioLocked: !0,
    toEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.hostname === "vimeo.com" && e.pathname.match(/^\/[0-9]+/))
        return "https://player.vimeo.com/video/" + e.pathname.split("/")[1] + "?title=0&byline=0";
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.hostname === "player.vimeo.com") {
        const n = e.pathname.match(/^\/video\/([^/]+)\/?$/);
        if (n)
          return "https://vimeo.com/" + n[1];
      }
    }
  },
  {
    type: "excalidraw",
    title: "Excalidraw",
    hostnames: ["excalidraw.com"],
    width: 720,
    height: 500,
    doesResize: !0,
    isAspectRatioLocked: !0,
    toEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.hash.match(/#room=/))
        return t;
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.hash.match(/#room=/))
        return t;
    }
  },
  {
    type: "observable",
    title: "Observable",
    hostnames: ["observablehq.com"],
    width: 720,
    height: 500,
    doesResize: !0,
    isAspectRatioLocked: !1,
    backgroundColor: "#fff",
    toEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/^\/@([^/]+)\/([^/]+)\/?$/))
        return `${e.origin}/embed${e.pathname}?cell=*`;
      if (e && e.pathname.match(/^\/d\/([^/]+)\/?$/)) {
        const n = e.pathname.replace(/^\/d/, "");
        return `${e.origin}/embed${n}?cell=*`;
      }
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.pathname.match(/^\/embed\/@([^/]+)\/([^/]+)\/?$/))
        return `${e.origin}${e.pathname.replace("/embed", "")}#cell-*`;
      if (e && e.pathname.match(/^\/embed\/([^/]+)\/?$/))
        return `${e.origin}${e.pathname.replace("/embed", "/d")}#cell-*`;
    }
  },
  {
    type: "desmos",
    title: "Desmos",
    hostnames: ["desmos.com"],
    width: 700,
    height: 450,
    doesResize: !0,
    toEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.hostname === "www.desmos.com" && e.pathname.match(/^\/calculator\/([^/]+)\/?$/) && e.search === "" && e.hash === "")
        return `${t}?embed`;
    },
    fromEmbedUrl: (t) => {
      const e = Le(t);
      if (e && e.hostname === "www.desmos.com" && e.pathname.match(/^\/calculator\/([^/]+)\/?$/) && e.search === "?embed" && e.hash === "")
        return t.replace("?embed", "");
    }
  }
], mq = {
  // ========================================================================================
  // Disabled permissions
  // ========================================================================================
  // [MDN] Experimental: Allows for downloads to occur without a gesture from the user.
  // [REASON] Disabled because otherwise the <iframe/> can trick the user on behalf of us to perform an action.
  "allow-downloads-without-user-activation": !1,
  // [MDN] Allows for downloads to occur with a gesture from the user.
  // [REASON] Disabled because otherwise the <iframe/> can trick the user on behalf of us to perform an action.
  "allow-downloads": !1,
  // [MDN] Lets the resource open modal windows.
  // [REASON] The <iframe/> could 'window.prompt("Enter your tldraw password")'.
  "allow-modals": !1,
  // [MDN] Lets the resource lock the screen orientation.
  // [REASON] Would interfere with the tldraw interface.
  "allow-orientation-lock": !1,
  // [MDN] Lets the resource use the Pointer Lock API.
  // [REASON] Maybe we should allow this for games embeds (scratch/codepen/codesandbox).
  "allow-pointer-lock": !1,
  // [MDN] Allows popups (such as window.open(), target="_blank", or showModalDialog()). If this keyword is not used, the popup will silently fail to open.
  // [REASON] We want to allow embeds to link back to their original sites (e.g. YouTube).
  "allow-popups": !0,
  // [MDN] Lets the sandboxed document open new windows without those windows inheriting the sandboxing. For example, this can safely sandbox an advertisement without forcing the same restrictions upon the page the ad links to.
  // [REASON] We shouldn't allow popups as a embed could pretend to be us by opening a mocked version of tldraw. This is very unobvious when it is performed as an action within our app.
  "allow-popups-to-escape-sandbox": !1,
  // [MDN] Lets the resource start a presentation session.
  // [REASON] Prevents embed from navigating away from tldraw and pretending to be us.
  "allow-presentation": !1,
  // [MDN] Experimental: Lets the resource request access to the parent's storage capabilities with the Storage Access API.
  // [REASON] We don't want anyone else to access our storage.
  "allow-storage-access-by-user-activation": !1,
  // [MDN] Lets the resource navigate the top-level browsing context (the one named _top).
  // [REASON] Prevents embed from navigating away from tldraw and pretending to be us.
  "allow-top-navigation": !1,
  // [MDN] Lets the resource navigate the top-level browsing context, but only if initiated by a user gesture.
  // [REASON] Prevents embed from navigating away from tldraw and pretending to be us.
  "allow-top-navigation-by-user-activation": !1,
  // ========================================================================================
  // Enabled permissions
  // ========================================================================================
  // [MDN] Lets the resource run scripts (but not create popup windows).
  "allow-scripts": !0,
  // [MDN] If this token is not used, the resource is treated as being from a special origin that always fails the same-origin policy (potentially preventing access to data storage/cookies and some JavaScript APIs).
  "allow-same-origin": !0,
  // [MDN] Allows the resource to submit forms. If this keyword is not used, form submission is blocked.
  "allow-forms": !0
}, yq = LS.map(
  (t) => t.type
);
function Iq(t) {
  return yq.includes(t);
}
function xq(t) {
  return "icon" in t;
}
function uz() {
  return Q().getShapeUtil("embed");
}
function kS() {
  const t = uz();
  return (e) => t ? t.getEmbedDefinition(e) : void 0;
}
function Sq() {
  const t = uz();
  return t ? t.getEmbedDefinitions() : [];
}
const hz = Vt(function({ onClose: e }) {
  const n = Q(), i = ke(), r = Kp(), [s, o] = pe(null), [a, c] = pe(""), [d, u] = pe(null), [h, g] = pe(!1), p = le(-1), f = Sq(), M = kS();
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(Ed, { children: [
      /* @__PURE__ */ l.jsx(Cd, { children: s ? `${i("embed-dialog.title")} — ${s.title}` : i("embed-dialog.title") }),
      /* @__PURE__ */ l.jsx(zd, {})
    ] }),
    s ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsxs(Ja, { className: "tlui-embed-dialog__enter", children: [
        /* @__PURE__ */ l.jsx(
          Ld,
          {
            className: "tlui-embed-dialog__input",
            label: "embed-dialog.url",
            placeholder: "https://example.com",
            autoFocus: !0,
            onValueChange: (m) => {
              c(m);
              const y = M(m);
              u(
                y && y.definition.type === s.type ? y : null
              ), g(!1), clearTimeout(p.current), p.current = n.timers.setTimeout(
                () => g(!y),
                320
              );
            }
          }
        ),
        a === "" ? /* @__PURE__ */ l.jsxs("div", { className: "tlui-embed-dialog__instruction", children: [
          /* @__PURE__ */ l.jsx("span", { children: i("embed-dialog.instruction") }),
          " ",
          s.instructionLink && /* @__PURE__ */ l.jsxs(
            "a",
            {
              target: "_blank",
              rel: "noopener noreferrer",
              href: s.instructionLink,
              className: "tlui-embed-dialog__instruction__link",
              children: [
                "Learn more.",
                /* @__PURE__ */ l.jsx(Ui, { icon: "external-link", small: !0 })
              ]
            }
          )
        ] }) : /* @__PURE__ */ l.jsx("div", { className: "tlui-embed-dialog__warning", children: h ? i("embed-dialog.invalid-url") : " " })
      ] }),
      /* @__PURE__ */ l.jsxs(Xp, { className: "tlui-dialog__footer__actions", children: [
        /* @__PURE__ */ l.jsx(
          q,
          {
            type: "normal",
            onClick: () => {
              o(null), u(null), c("");
            },
            children: /* @__PURE__ */ l.jsx(St, { children: i("embed-dialog.back") })
          }
        ),
        /* @__PURE__ */ l.jsx("div", { className: "tlui-embed__spacer" }),
        /* @__PURE__ */ l.jsx(q, { type: "normal", onClick: e, children: /* @__PURE__ */ l.jsx(St, { children: i("embed-dialog.cancel") }) }),
        /* @__PURE__ */ l.jsx(
          q,
          {
            type: "primary",
            disabled: !d,
            onClick: () => {
              d && (n.putExternalContent({
                type: "embed",
                url: a,
                point: n.getViewportPageBounds().center,
                embed: d.definition
              }), e());
            },
            children: /* @__PURE__ */ l.jsx(St, { children: i("embed-dialog.create") })
          }
        )
      ] })
    ] }) : /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(Ja, { className: "tlui-embed-dialog__list", children: f.map((m) => {
      const y = Iq(m.type) ? r.embedIcons[m.type] : xq(m) ? m.icon : void 0;
      return /* @__PURE__ */ l.jsxs(q, { type: "menu", onClick: () => o(m), children: [
        /* @__PURE__ */ l.jsx(St, { children: m.title }),
        y && /* @__PURE__ */ l.jsx(
          "div",
          {
            className: "tlui-embed-dialog__item__image",
            style: { backgroundImage: `url(${y})` }
          }
        )
      ] }, m.type);
    }) }) })
  ] });
});
var OS = { exports: {} };
OS.exports;
(function(t) {
  var e = function() {
    var n = String.fromCharCode, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$", s = {};
    function o(c, d) {
      if (!s[c]) {
        s[c] = {};
        for (var u = 0; u < c.length; u++)
          s[c][c.charAt(u)] = u;
      }
      return s[c][d];
    }
    var a = {
      compressToBase64: function(c) {
        if (c == null) return "";
        var d = a._compress(c, 6, function(u) {
          return i.charAt(u);
        });
        switch (d.length % 4) {
          default:
          case 0:
            return d;
          case 1:
            return d + "===";
          case 2:
            return d + "==";
          case 3:
            return d + "=";
        }
      },
      decompressFromBase64: function(c) {
        return c == null ? "" : c == "" ? null : a._decompress(c.length, 32, function(d) {
          return o(i, c.charAt(d));
        });
      },
      compressToUTF16: function(c) {
        return c == null ? "" : a._compress(c, 15, function(d) {
          return n(d + 32);
        }) + " ";
      },
      decompressFromUTF16: function(c) {
        return c == null ? "" : c == "" ? null : a._decompress(c.length, 16384, function(d) {
          return c.charCodeAt(d) - 32;
        });
      },
      //compress into uint8array (UCS-2 big endian format)
      compressToUint8Array: function(c) {
        for (var d = a.compress(c), u = new Uint8Array(d.length * 2), h = 0, g = d.length; h < g; h++) {
          var p = d.charCodeAt(h);
          u[h * 2] = p >>> 8, u[h * 2 + 1] = p % 256;
        }
        return u;
      },
      //decompress from uint8array (UCS-2 big endian format)
      decompressFromUint8Array: function(c) {
        if (c == null)
          return a.decompress(c);
        for (var d = new Array(c.length / 2), u = 0, h = d.length; u < h; u++)
          d[u] = c[u * 2] * 256 + c[u * 2 + 1];
        var g = [];
        return d.forEach(function(p) {
          g.push(n(p));
        }), a.decompress(g.join(""));
      },
      //compress into a string that is already URI encoded
      compressToEncodedURIComponent: function(c) {
        return c == null ? "" : a._compress(c, 6, function(d) {
          return r.charAt(d);
        });
      },
      //decompress from an output of compressToEncodedURIComponent
      decompressFromEncodedURIComponent: function(c) {
        return c == null ? "" : c == "" ? null : (c = c.replace(/ /g, "+"), a._decompress(c.length, 32, function(d) {
          return o(r, c.charAt(d));
        }));
      },
      compress: function(c) {
        return a._compress(c, 16, function(d) {
          return n(d);
        });
      },
      _compress: function(c, d, u) {
        if (c == null) return "";
        var h, g, p = {}, f = {}, M = "", m = "", y = "", I = 2, D = 3, j = 2, w = [], A = 0, b = 0, T;
        for (T = 0; T < c.length; T += 1)
          if (M = c.charAt(T), Object.prototype.hasOwnProperty.call(p, M) || (p[M] = D++, f[M] = !0), m = y + M, Object.prototype.hasOwnProperty.call(p, m))
            y = m;
          else {
            if (Object.prototype.hasOwnProperty.call(f, y)) {
              if (y.charCodeAt(0) < 256) {
                for (h = 0; h < j; h++)
                  A = A << 1, b == d - 1 ? (b = 0, w.push(u(A)), A = 0) : b++;
                for (g = y.charCodeAt(0), h = 0; h < 8; h++)
                  A = A << 1 | g & 1, b == d - 1 ? (b = 0, w.push(u(A)), A = 0) : b++, g = g >> 1;
              } else {
                for (g = 1, h = 0; h < j; h++)
                  A = A << 1 | g, b == d - 1 ? (b = 0, w.push(u(A)), A = 0) : b++, g = 0;
                for (g = y.charCodeAt(0), h = 0; h < 16; h++)
                  A = A << 1 | g & 1, b == d - 1 ? (b = 0, w.push(u(A)), A = 0) : b++, g = g >> 1;
              }
              I--, I == 0 && (I = Math.pow(2, j), j++), delete f[y];
            } else
              for (g = p[y], h = 0; h < j; h++)
                A = A << 1 | g & 1, b == d - 1 ? (b = 0, w.push(u(A)), A = 0) : b++, g = g >> 1;
            I--, I == 0 && (I = Math.pow(2, j), j++), p[m] = D++, y = String(M);
          }
        if (y !== "") {
          if (Object.prototype.hasOwnProperty.call(f, y)) {
            if (y.charCodeAt(0) < 256) {
              for (h = 0; h < j; h++)
                A = A << 1, b == d - 1 ? (b = 0, w.push(u(A)), A = 0) : b++;
              for (g = y.charCodeAt(0), h = 0; h < 8; h++)
                A = A << 1 | g & 1, b == d - 1 ? (b = 0, w.push(u(A)), A = 0) : b++, g = g >> 1;
            } else {
              for (g = 1, h = 0; h < j; h++)
                A = A << 1 | g, b == d - 1 ? (b = 0, w.push(u(A)), A = 0) : b++, g = 0;
              for (g = y.charCodeAt(0), h = 0; h < 16; h++)
                A = A << 1 | g & 1, b == d - 1 ? (b = 0, w.push(u(A)), A = 0) : b++, g = g >> 1;
            }
            I--, I == 0 && (I = Math.pow(2, j), j++), delete f[y];
          } else
            for (g = p[y], h = 0; h < j; h++)
              A = A << 1 | g & 1, b == d - 1 ? (b = 0, w.push(u(A)), A = 0) : b++, g = g >> 1;
          I--, I == 0 && (I = Math.pow(2, j), j++);
        }
        for (g = 2, h = 0; h < j; h++)
          A = A << 1 | g & 1, b == d - 1 ? (b = 0, w.push(u(A)), A = 0) : b++, g = g >> 1;
        for (; ; )
          if (A = A << 1, b == d - 1) {
            w.push(u(A));
            break;
          } else b++;
        return w.join("");
      },
      decompress: function(c) {
        return c == null ? "" : c == "" ? null : a._decompress(c.length, 32768, function(d) {
          return c.charCodeAt(d);
        });
      },
      _decompress: function(c, d, u) {
        var h = [], g = 4, p = 4, f = 3, M = "", m = [], y, I, D, j, w, A, b, T = { val: u(0), position: d, index: 1 };
        for (y = 0; y < 3; y += 1)
          h[y] = y;
        for (D = 0, w = Math.pow(2, 2), A = 1; A != w; )
          j = T.val & T.position, T.position >>= 1, T.position == 0 && (T.position = d, T.val = u(T.index++)), D |= (j > 0 ? 1 : 0) * A, A <<= 1;
        switch (D) {
          case 0:
            for (D = 0, w = Math.pow(2, 8), A = 1; A != w; )
              j = T.val & T.position, T.position >>= 1, T.position == 0 && (T.position = d, T.val = u(T.index++)), D |= (j > 0 ? 1 : 0) * A, A <<= 1;
            b = n(D);
            break;
          case 1:
            for (D = 0, w = Math.pow(2, 16), A = 1; A != w; )
              j = T.val & T.position, T.position >>= 1, T.position == 0 && (T.position = d, T.val = u(T.index++)), D |= (j > 0 ? 1 : 0) * A, A <<= 1;
            b = n(D);
            break;
          case 2:
            return "";
        }
        for (h[3] = b, I = b, m.push(b); ; ) {
          if (T.index > c)
            return "";
          for (D = 0, w = Math.pow(2, f), A = 1; A != w; )
            j = T.val & T.position, T.position >>= 1, T.position == 0 && (T.position = d, T.val = u(T.index++)), D |= (j > 0 ? 1 : 0) * A, A <<= 1;
          switch (b = D) {
            case 0:
              for (D = 0, w = Math.pow(2, 8), A = 1; A != w; )
                j = T.val & T.position, T.position >>= 1, T.position == 0 && (T.position = d, T.val = u(T.index++)), D |= (j > 0 ? 1 : 0) * A, A <<= 1;
              h[p++] = n(D), b = p - 1, g--;
              break;
            case 1:
              for (D = 0, w = Math.pow(2, 16), A = 1; A != w; )
                j = T.val & T.position, T.position >>= 1, T.position == 0 && (T.position = d, T.val = u(T.index++)), D |= (j > 0 ? 1 : 0) * A, A <<= 1;
              h[p++] = n(D), b = p - 1, g--;
              break;
            case 2:
              return m.join("");
          }
          if (g == 0 && (g = Math.pow(2, f), f++), h[b])
            M = h[b];
          else if (b === p)
            M = I + I.charAt(0);
          else
            return null;
          m.push(M), h[p++] = I + M.charAt(0), g--, I = M, g == 0 && (g = Math.pow(2, f), f++);
        }
      }
    };
    return a;
  }();
  t != null ? t.exports = e : typeof angular < "u" && angular != null && angular.module("LZString", []).factory("LZString", function() {
    return e;
  });
})(OS);
var jq = OS.exports;
const gz = /* @__PURE__ */ uc(jq);
async function Dq(t, e, n) {
  var y, I, D;
  const { elements: i, files: r } = e, s = {
    shapes: [],
    bindings: [],
    rootShapeIds: [],
    assets: [],
    schema: t.store.schema.serialize()
  }, o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), c = t.getCurrentPageId(), d = /* @__PURE__ */ new Map(), u = [], h = /* @__PURE__ */ new Set();
  i.forEach((j) => {
    if (d.set(j.id, Ee()), j.boundElements !== null)
      for (const w of j.boundElements)
        w.type === "text" && h.add(w.id);
  });
  let g = dT;
  for (const j of i) {
    if (h.has(j.id))
      continue;
    const w = d.get(j.id), A = {
      id: w,
      typeName: "shape",
      parentId: c,
      index: g,
      x: j.x,
      y: j.y,
      rotation: 0,
      isLocked: j.locked,
      opacity: wq(j.opacity),
      meta: {}
    };
    switch (j.angle !== 0 && a.set(w, j.angle), j.groupIds && j.groupIds.length > 0 ? o.has(j.groupIds[0]) ? (y = o.get(j.groupIds[0])) == null || y.push(w) : o.set(j.groupIds[0], [w]) : u.push(w), j.type) {
      case "rectangle":
      case "ellipse":
      case "diamond": {
        let b = "", T = "middle";
        if (j.boundElements !== null) {
          for (const v of j.boundElements)
            if (v.type === "text") {
              const P = i.find((C) => C.id === v.id);
              P && (b = P.text, T = Cq[P.textAlign]);
            }
        }
        const E = j.backgroundColor === "transparent" ? j.strokeColor : j.backgroundColor;
        s.shapes.push({
          ...A,
          type: "geo",
          props: {
            geo: j.type,
            url: j.link ?? "",
            w: j.width,
            h: j.height,
            size: Yu[j.strokeWidth] ?? "draw",
            color: cl[E] ?? "black",
            text: b,
            align: T,
            dash: Qu(j),
            fill: kq(j)
          }
        });
        break;
      }
      case "freedraw": {
        s.shapes.push({
          ...A,
          type: "draw",
          props: {
            dash: Qu(j),
            size: Yu[j.strokeWidth],
            color: cl[j.strokeColor] ?? "black",
            segments: [
              {
                type: "free",
                points: j.points.map(([b, T, E = 0.5]) => ({
                  x: b,
                  y: T,
                  z: E
                }))
              }
            ]
          }
        });
        break;
      }
      case "line": {
        if (j.points.slice().length < 2)
          break;
        const T = Wa(j.points.length);
        s.shapes.push({
          ...A,
          type: "line",
          props: {
            dash: Qu(j),
            size: Yu[j.strokeWidth],
            color: cl[j.strokeColor] ?? "black",
            spline: j.roundness ? "cubic" : "line",
            points: {
              ...Object.fromEntries(
                j.points.map(([E, v], P) => {
                  const C = T[P];
                  return [C, { id: C, index: C, x: E, y: v }];
                })
              )
            }
          }
        });
        break;
      }
      case "arrow": {
        let b = "";
        if (j.boundElements !== null) {
          for (const C of j.boundElements)
            if (C.type === "text") {
              const z = i.find((O) => O.id === C.id);
              z && (b = z.text);
            }
        }
        const T = j.points[0], E = j.points[j.points.length - 1], v = d.get((I = j.startBinding) == null ? void 0 : I.elementId), P = d.get((D = j.endBinding) == null ? void 0 : D.elementId);
        s.shapes.push({
          ...A,
          type: "arrow",
          props: {
            text: b,
            bend: Lq(j, T, E),
            dash: Qu(j),
            size: Yu[j.strokeWidth] ?? "m",
            color: cl[j.strokeColor] ?? "black",
            start: { x: T[0], y: T[1] },
            end: { x: E[0], y: E[1] },
            arrowheadEnd: Yw[j.endArrowhead] ?? "none",
            arrowheadStart: Yw[j.startArrowhead] ?? "none"
          }
        }), v && s.bindings.push({
          id: Ks(),
          typeName: "binding",
          type: "arrow",
          fromId: w,
          toId: v,
          props: {
            terminal: "start",
            normalizedAnchor: { x: 0.5, y: 0.5 },
            isPrecise: !1,
            isExact: !1
          },
          meta: {}
        }), P && s.bindings.push({
          id: Ks(),
          typeName: "binding",
          type: "arrow",
          fromId: w,
          toId: P,
          props: {
            terminal: "end",
            normalizedAnchor: { x: 0.5, y: 0.5 },
            isPrecise: !1,
            isExact: !1
          },
          meta: {}
        });
        break;
      }
      case "text": {
        const { size: b, scale: T } = Aq(j.fontSize);
        s.shapes.push({
          ...A,
          type: "text",
          props: {
            size: b,
            scale: T,
            font: Tq[j.fontFamily] ?? "draw",
            color: cl[j.strokeColor] ?? "black",
            text: j.text,
            textAlign: zq[j.textAlign]
          }
        });
        break;
      }
      case "image": {
        const b = r[j.fileId];
        if (!b) break;
        const T = ci.createId();
        s.assets.push({
          id: T,
          typeName: "asset",
          type: "image",
          props: {
            w: j.width,
            h: j.height,
            fileSize: b.size,
            name: j.id ?? "Untitled",
            isAnimated: !1,
            mimeType: b.mimeType,
            src: b.dataURL
          },
          meta: {}
        }), s.shapes.push({
          ...A,
          type: "image",
          props: {
            w: j.width,
            h: j.height,
            assetId: T
          }
        });
      }
    }
    g = hi(g);
  }
  const p = n ?? (t.inputs.shiftKey ? t.inputs.currentPagePoint : void 0);
  t.markHistoryStoppingPoint("paste"), t.putContentOntoCurrentPage(s, {
    point: p,
    select: !1,
    preserveIds: !0
  });
  for (const j of o.values())
    if (j.length > 1) {
      t.groupShapes(j);
      const w = t.getShape(j[0]);
      w != null && w.parentId && si(w.parentId) && u.push(w.parentId);
    }
  for (const [j, w] of a)
    t.select(j), t.rotateShapesBy([j], w);
  const f = Ze(u.map((j) => t.getShape(j))), M = ae.Common(f.map((j) => t.getShapePageBounds(j))), m = t.getViewportPageBounds().center;
  t.updateShapes(
    f.map((j) => {
      const w = {
        x: (j.x ?? 0) - (M.x + M.w / 2),
        y: (j.y ?? 0) - (M.y + M.h / 2)
      };
      return {
        id: j.id,
        type: j.type,
        x: m.x + w.x,
        y: m.y + w.y
      };
    })
  ), t.setSelectedShapes(u);
}
const wq = (t) => {
  const e = t / 100;
  return e < 0.2 ? 0.1 : e < 0.4 ? 0.25 : e < 0.6 ? 0.5 : e < 0.8 ? 0.75 : 1;
}, Yu = {
  1: "s",
  2: "m",
  3: "l",
  4: "xl"
}, Nq = {
  16: "s",
  20: "m",
  28: "l",
  36: "xl"
};
function Aq(t) {
  const e = Nq[t];
  return e ? { size: e, scale: 1 } : t < 16 ? { size: "s", scale: t / 16 } : t > 36 ? { size: "xl", scale: t / 36 } : { size: "m", scale: 1 };
}
const Tq = {
  1: "draw",
  2: "sans",
  3: "mono"
}, bq = {
  gray: ["#f8f9fa", "#e9ecef", "#ced4da", "#868e96", "#343a40"],
  red: ["#fff5f5", "#ffc9c9", "#ff8787", "#fa5252", "#e03131"],
  pink: ["#fff0f6", "#fcc2d7", "#f783ac", "#e64980", "#c2255c"],
  grape: ["#f8f0fc", "#eebefa", "#da77f2", "#be4bdb", "#9c36b5"],
  violet: ["#f3f0ff", "#d0bfff", "#9775fa", "#7950f2", "#6741d9"],
  indigo: ["#edf2ff", "#bac8ff", "#748ffc", "#4c6ef5", "#3b5bdb"],
  blue: ["#e7f5ff", "#a5d8ff", "#4dabf7", "#228be6", "#1971c2"],
  cyan: ["#e3fafc", "#99e9f2", "#3bc9db", "#15aabf", "#0c8599"],
  teal: ["#e6fcf5", "#96f2d7", "#38d9a9", "#12b886", "#099268"],
  green: ["#ebfbee", "#b2f2bb", "#69db7c", "#40c057", "#2f9e44"],
  lime: ["#f4fce3", "#d8f5a2", "#a9e34b", "#82c91e", "#66a80f"],
  yellow: ["#fff9db", "#ffec99", "#ffd43b", "#fab005", "#f08c00"],
  orange: ["#fff4e6", "#ffd8a8", "#ffa94d", "#fd7e14", "#e8590c"]
};
function Er(t, e, n) {
  const i = [0, 1, 2, 3, 4].map((r) => bq[t][r]);
  return Object.fromEntries(i.map((r, s) => [r, s < 3 ? e : n]));
}
const cl = {
  ...Er("gray", "grey", "black"),
  ...Er("red", "light-red", "red"),
  ...Er("pink", "light-red", "red"),
  ...Er("grape", "light-violet", "violet"),
  ...Er("blue", "light-blue", "blue"),
  ...Er("cyan", "light-blue", "blue"),
  ...Er("teal", "light-green", "green"),
  ...Er("green", "light-green", "green"),
  ...Er("yellow", "yellow", "orange"),
  ...Er("orange", "yellow", "orange"),
  "#ffffff": "white",
  "#000000": "black"
}, vq = {
  solid: "draw",
  dashed: "dashed",
  dotted: "dotted"
}, Eq = {
  "cross-hatch": "pattern",
  hachure: "pattern",
  solid: "solid"
}, Cq = {
  left: "start",
  center: "middle",
  right: "end"
}, zq = {
  left: "start",
  center: "middle",
  right: "end"
}, Yw = {
  arrow: "arrow",
  dot: "dot",
  triangle: "triangle",
  bar: "pipe"
};
function Lq(t, e, n) {
  let i = 0;
  if (t.points.length > 2) {
    const r = new x(e[0], e[1]), s = new x(n[0], n[1]), o = new x(t.points[1][0], t.points[1][1]), a = x.Sub(s, r), c = x.Per(a), d = x.Med(s, r), u = x.Sub(d, c), h = x.Add(d, c), g = x.NearestPointOnLineSegment(u, h, o, !1);
    i = x.Dist(g, d), x.Clockwise(g, s, d) && (i *= -1);
  }
  return i;
}
const Qu = (t) => {
  let e = vq[t.strokeStyle] ?? "draw";
  return e === "draw" && t.roughness === 0 && (e = "solid"), e;
}, kq = (t) => t.backgroundColor === "transparent" ? "none" : Eq[t.fillStyle] ?? "solid";
async function Oq(t, e, n, i) {
  const s = (await Promise.all(e.map(async (o) => await (await gr(o)).blob()))).map((o) => new File([o], "tldrawFile", { type: o.type }));
  t.markHistoryStoppingPoint("paste"), await t.putExternalContent({
    type: "files",
    files: s,
    point: n,
    ignoreParent: !1,
    sources: i
  }), e.forEach((o) => URL.revokeObjectURL(o));
}
function Pq(t, e, n) {
  const i = t.getSelectionPageBounds();
  t.markHistoryStoppingPoint("paste"), t.putContentOntoCurrentPage(e, {
    point: n,
    select: !0
  });
  const r = t.getSelectionPageBounds();
  i && r && (i != null && i.collides(r)) && (t.updateInstanceState({ isChangingStyle: !0 }), t.timers.setTimeout(() => {
    t.updateInstanceState({ isChangingStyle: !1 });
  }, 150));
}
async function uI(t, e, n, i) {
  return t.markHistoryStoppingPoint("paste"), await t.putExternalContent({
    type: "url",
    point: n,
    url: e,
    sources: i
  });
}
function Uq(t) {
  const e = document.implementation.createHTMLDocument("");
  return e.documentElement.innerHTML = t.trim(), e.body.textContent || e.body.innerText || "";
}
const Rq = (t) => {
  try {
    const e = new URL(t);
    return e.protocol === "http:" || e.protocol === "https:";
  } catch {
    return !1;
  }
}, Yq = (t) => {
  const e = t.split(/[\n\s]/);
  for (const n of e)
    try {
      const i = new URL(n);
      if (!(i.protocol === "http:" || i.protocol === "https:"))
        return;
    } catch {
      return;
    }
  return zv(e);
}, Qq = (t) => /^<svg/.test(t), Zq = ["input", "select", "textarea"];
function HM(t) {
  const { activeElement: e } = document;
  return t.menus.hasAnyOpenMenus() || e && (e.getAttribute("contenteditable") || Zq.indexOf(e.tagName.toLowerCase()) > -1);
}
const Fq = (t) => t.types.find((e) => e.match(/^image\//)), VM = (t, e, n, i) => {
  const r = Yq(e);
  if (r)
    for (const s of r)
      uI(t, s, n);
  else Rq(e) ? uI(t, e, n) : Qq(e) ? (t.markHistoryStoppingPoint("paste"), t.putExternalContent({
    type: "svg-text",
    text: e,
    point: n,
    sources: i
  })) : (t.markHistoryStoppingPoint("paste"), t.putExternalContent({
    type: "text",
    text: e,
    point: n,
    sources: i
  }));
}, Bq = async (t, e, n) => {
  if (t.getEditingShapeId() !== null) return;
  if (!e)
    throw Error("No clipboard data");
  const i = [];
  for (const r of Object.values(e.items))
    switch (r.kind) {
      case "file": {
        i.push({
          type: "file",
          source: new Promise((s) => s(r.getAsFile()))
        });
        break;
      }
      case "string": {
        r.type === "text/html" ? i.push({
          type: "html",
          source: new Promise((s) => r.getAsString(s))
        }) : r.type === "text/plain" ? i.push({
          type: "text",
          source: new Promise((s) => r.getAsString(s))
        }) : i.push({ type: r.type, source: new Promise((s) => r.getAsString(s)) });
        break;
      }
    }
  fz(t, i, n);
}, pz = async (t, e, n) => {
  const i = [];
  for (const r of e) {
    if (Fq(r))
      for (const s of r.types)
        s.match(/^image\//) && i.push({ type: "blob", source: r.getType(s) });
    r.types.includes("text/html") && i.push({
      type: "html",
      source: (async () => {
        const s = await r.getType("text/html");
        return await us.blobToText(s);
      })()
    }), r.types.includes("text/uri-list") && i.push({
      type: "url",
      source: (async () => {
        const s = await r.getType("text/uri-list");
        return await us.blobToText(s);
      })()
    }), r.types.includes("text/plain") && i.push({
      type: "text",
      source: (async () => {
        const s = await r.getType("text/plain");
        return await us.blobToText(s);
      })()
    });
  }
  return await fz(t, i, n);
};
async function fz(t, e, n) {
  const i = e.filter(
    (s) => (s.type === "file" || s.type === "blob") && s.source !== null
  );
  if (i.length) {
    if (i.length > t.options.maxFilesAtOnce)
      throw Error("Too many files");
    const o = (await Promise.all(i.map((a) => a.source))).filter(Boolean).map(
      (a) => URL.createObjectURL(a)
    );
    return await Oq(t, o, n);
  }
  const r = await Promise.all(
    e.filter((s) => s.type !== "file").map(
      (s) => new Promise((o) => {
        const a = s;
        if (a.type === "file") {
          o({ type: "error", data: null, reason: "unexpected file" });
          return;
        }
        a.source.then((c) => {
          var u;
          const d = (u = c.match(/<div data-tldraw[^>]*>(.*)<\/div>/)) == null ? void 0 : u[1];
          if (d)
            try {
              const h = gz.decompressFromBase64(d);
              if (h === null) {
                o({
                  type: "error",
                  data: h,
                  reason: "found tldraw data comment but could not parse base64"
                });
                return;
              } else {
                const g = JSON.parse(h);
                if (g.type !== "application/tldraw" && o({
                  type: "error",
                  data: g,
                  reason: `found tldraw data comment but JSON was of a different type: ${g.type}`
                }), typeof g.data == "string") {
                  o({
                    type: "error",
                    data: g,
                    reason: "found tldraw json but data was a string instead of a TLClipboardModel object"
                  });
                  return;
                }
                o({ type: "tldraw", data: g.data });
                return;
              }
            } catch {
              o({
                type: "error",
                data: d,
                reason: "found tldraw json but data was a string instead of a TLClipboardModel object"
              });
              return;
            }
          else {
            if (a.type === "html") {
              o({ type: "text", data: c, subtype: "html" });
              return;
            }
            if (a.type === "url") {
              o({ type: "text", data: c, subtype: "url" });
              return;
            }
            try {
              const h = JSON.parse(c);
              if (h.type === "excalidraw/clipboard") {
                o({ type: "excalidraw", data: h });
                return;
              } else {
                o({ type: "text", data: c, subtype: "json" });
                return;
              }
            } catch {
              o({ type: "text", data: c, subtype: "text" });
              return;
            }
          }
          o({ type: "error", data: c, reason: "unhandled case" });
        });
      })
    )
  );
  for (const s of r)
    if (s.type === "tldraw") {
      Pq(t, s.data, n);
      return;
    }
  for (const s of r)
    if (s.type === "excalidraw") {
      Dq(t, s.data, n);
      return;
    }
  for (const s of r)
    if (s.type === "text" && s.subtype === "html") {
      const a = new DOMParser().parseFromString(s.data, "text/html").querySelector("body");
      if (a && Array.from(a.children).filter((d) => d.nodeType === 1).length === 1 && a.firstElementChild && a.firstElementChild.tagName === "A" && a.firstElementChild.hasAttribute("href") && a.firstElementChild.getAttribute("href") !== "") {
        const d = a.firstElementChild.getAttribute("href");
        VM(t, d, n, r);
        return;
      }
      if (!r.some((d) => d.type === "text" && d.subtype !== "html") && s.data.trim()) {
        VM(t, Uq(s.data), n, r);
        return;
      }
    }
  for (const s of r)
    if (s.type === "text" && s.subtype === "url") {
      uI(t, s.data, n, r);
      return;
    }
  for (const s of r)
    if (s.type === "text" && s.subtype === "text" && s.data.trim()) {
      VM(t, s.data, n, r);
      return;
    }
}
const Ug = async (t) => {
  var i;
  const e = await t.resolveAssetsInContent(
    t.getContentFromCurrentPage(t.getSelectedShapeIds())
  );
  if (!e) {
    navigator && navigator.clipboard && navigator.clipboard.writeText("");
    return;
  }
  const n = gz.compressToBase64(
    JSON.stringify({
      type: "application/tldraw",
      kind: "content",
      data: e
    })
  );
  if (!(typeof navigator > "u")) {
    const r = e.shapes.map((s) => t.getShapeUtil(s).getText(s)).filter(tR);
    if ((i = navigator.clipboard) != null && i.write) {
      const s = new Blob([`<div data-tldraw>${n}</div>`], {
        type: "text/html"
      });
      let o = r.join(" ");
      o === "" && (o = " "), navigator.clipboard.write([
        new ClipboardItem({
          "text/html": s,
          // What is this second blob used for?
          "text/plain": new Blob([o], { type: "text/plain" })
        })
      ]);
    } else navigator.clipboard.writeText && navigator.clipboard.writeText(`<div data-tldraw>${n}</div>`);
  }
};
function Gq() {
  const t = Q(), e = Zt(), n = re(
    async function(o) {
      t.getSelectedShapeIds().length !== 0 && (await Ug(t), e("copy", { source: o }));
    },
    [t, e]
  ), i = re(
    async function(o) {
      t.getSelectedShapeIds().length !== 0 && (await Ug(t), t.deleteShapes(t.getSelectedShapeIds()), e("cut", { source: o }));
    },
    [t, e]
  ), r = re(
    async function(o, a, c) {
      t.getEditingShapeId() === null && (Array.isArray(o) && o[0] instanceof ClipboardItem ? (pz(t, o, c), e("paste", { source: "menu" })) : navigator.clipboard.read().then((d) => {
        r(d, a, c);
      }));
    },
    [t, e]
  );
  return {
    copy: n,
    cut: i,
    paste: r
  };
}
function Wq() {
  const t = Q(), e = Zt(), n = G("editor.isFocused", () => t.getInstanceState().isFocused, [
    t
  ]);
  ze(() => {
    if (!n) return;
    const i = async (c) => {
      t.getSelectedShapeIds().length === 0 || t.getEditingShapeId() !== null || HM(t) || (Ke(c), await Ug(t), e("copy", { source: "kbd" }));
    };
    async function r(c) {
      t.getSelectedShapeIds().length === 0 || t.getEditingShapeId() !== null || HM(t) || (Ke(c), await Ug(t), t.deleteShapes(t.getSelectedShapeIds()), e("cut", { source: "kbd" }));
    }
    let s = !1;
    const o = (c) => {
      c.button === 1 && (s = !0, t.timers.requestAnimationFrame(() => {
        s = !1;
      }));
    }, a = (c) => {
      if (s) {
        Yt(c);
        return;
      }
      if (t.getEditingShapeId() !== null || HM(t)) return;
      let d, u = !1;
      t.inputs.shiftKey && (u = !0), t.user.getIsPasteAtCursorMode() && (u = !u), u && (d = t.inputs.currentPagePoint), c.clipboardData && !t.inputs.shiftKey ? Bq(t, c.clipboardData, d) : navigator.clipboard.read().then((h) => {
        Array.isArray(h) && h[0] instanceof ClipboardItem && pz(t, h, d);
      }), Ke(c), e("paste", { source: "kbd" });
    };
    return document.addEventListener("copy", i), document.addEventListener("cut", r), document.addEventListener("paste", a), document.addEventListener("pointerup", o), () => {
      document.removeEventListener("copy", i), document.removeEventListener("cut", r), document.removeEventListener("paste", a), document.removeEventListener("pointerup", o);
    };
  }, [t, e, n]);
}
/*!
 * canvas-size
 * v1.2.6
 * https://github.com/jhildenbiddle/canvas-size
 * (c) 2015-2023 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
function Hq(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var i, r, s, o, a = [], c = !0, d = !1;
    try {
      if (s = (n = n.call(t)).next, e === 0) {
        if (Object(n) !== n) return;
        c = !1;
      } else for (; !(c = (i = s.call(n)).done) && (a.push(i.value), a.length !== e); c = !0) ;
    } catch (u) {
      d = !0, r = u;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (d) throw r;
      }
    }
    return a;
  }
}
function Qw(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Ai(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Qw(Object(n), !0).forEach(function(i) {
      Vq(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Qw(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function Vq(t, e, n) {
  return e = n_(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function Kq(t, e) {
  if (t == null) return {};
  var n = {}, i = Object.keys(t), r, s;
  for (s = 0; s < i.length; s++)
    r = i[s], !(e.indexOf(r) >= 0) && (n[r] = t[r]);
  return n;
}
function Xq(t, e) {
  if (t == null) return {};
  var n = Kq(t, e), i, r;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(t);
    for (r = 0; r < s.length; r++)
      i = s[r], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (n[i] = t[i]);
  }
  return n;
}
function Zw(t, e) {
  return qq(t) || Hq(t, e) || Mz(t, e) || e_();
}
function Zu(t) {
  return Jq(t) || _q(t) || Mz(t) || $q();
}
function Jq(t) {
  if (Array.isArray(t)) return hI(t);
}
function qq(t) {
  if (Array.isArray(t)) return t;
}
function _q(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Mz(t, e) {
  if (t) {
    if (typeof t == "string") return hI(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return hI(t, e);
  }
}
function hI(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
  return i;
}
function $q() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function e_() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function t_(t, e) {
  if (typeof t != "object" || t === null) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(t, e || "default");
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function n_(t) {
  var e = t_(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Ul(t) {
  var e = t.sizes.shift(), n = Math.max(Math.ceil(e[0]), 1), i = Math.max(Math.ceil(e[1]), 1), r = [n - 1, i - 1, 1, 1], s = Date.now(), o = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope, a, c;
  o ? (a = new OffscreenCanvas(1, 1), c = new OffscreenCanvas(n, i)) : (a = document.createElement("canvas"), a.width = 1, a.height = 1, c = document.createElement("canvas"), c.width = n, c.height = i);
  var d = a.getContext("2d"), u = c.getContext("2d");
  u && (u.fillRect.apply(u, r), d.drawImage(c, n - 1, i - 1, 1, 1, 0, 0, 1, 1));
  var h = d && d.getImageData(0, 0, 1, 1).data[3] !== 0, g = Date.now() - s;
  return [a, c].forEach(function(p) {
    p.height = 0, p.width = 0;
  }), o ? (postMessage({
    width: n,
    height: i,
    benchmark: g,
    isTestPass: h
  }), !h && t.sizes.length && Ul(t)) : h ? t.onSuccess(n, i, g) : (t.onError(n, i, g), t.sizes.length && Ul(t)), h;
}
var KM = {
  area: [16384, 14188, 11402, 11180, 10836, 8192, 4096, 1],
  height: [8388607, 65535, 32767, 16384, 8192, 4096, 1],
  width: [4194303, 65535, 32767, 16384, 8192, 4096, 1]
}, i_ = ["onError", "onSuccess"], va = {
  max: null,
  min: 1,
  sizes: [],
  step: 1024,
  usePromise: !1,
  useWorker: !1,
  onError: Function.prototype,
  onSuccess: Function.prototype
}, ll = {};
function XM(t) {
  var e = t.width === t.height, n = t.height === 1, i = t.width === 1, r = [];
  if (!t.width || !t.height)
    t.sizes.forEach(function(u) {
      var h = e || n ? u : 1, g = e || i ? u : 1;
      r.push([h, g]);
    });
  else
    for (var s = t.min || va.min, o = t.step || va.step, a = Math.max(t.width, t.height); a >= s; ) {
      var c = e || n ? a : 1, d = e || i ? a : 1;
      r.push([c, d]), a -= o;
    }
  return r;
}
function Fu(t) {
  var e = window && "HTMLCanvasElement" in window, n = window && "OffscreenCanvas" in window, i = Date.now(), r = t.onError, s = t.onSuccess, o = Xq(t, i_), a = null;
  if (!e)
    return !1;
  if (t.useWorker && n) {
    var c = `
            var canvasTest = `.concat(Ul.toString(), `;
            onmessage = function(e) {
                canvasTest(e.data);
            };
        `), d = new Blob([c], {
      type: "application/javascript"
    }), u = URL.createObjectURL(d);
    a = new Worker(u), URL.revokeObjectURL(u), a.onmessage = function(h) {
      var g = h.data, p = g.width, f = g.height, M = g.benchmark, m = g.isTestPass;
      m ? (ll[i].onSuccess(p, f, M), delete ll[i]) : ll[i].onError(p, f, M);
    };
  }
  if (t.usePromise)
    return new Promise(function(h, g) {
      var p = Ai(Ai({}, t), {}, {
        onError: function(y, I, D) {
          var j;
          if (t.sizes.length === 0)
            j = !0;
          else {
            var w = t.sizes.slice(-1), A = Zw(w, 1), b = Zw(A[0], 2), T = b[0], E = b[1];
            j = y === T && I === E;
          }
          r(y, I, D), j && g({
            width: y,
            height: I,
            benchmark: D
          });
        },
        onSuccess: function(y, I, D) {
          s(y, I, D), h({
            width: y,
            height: I,
            benchmark: D
          });
        }
      });
      if (a) {
        var f = p.onError, M = p.onSuccess;
        ll[i] = {
          onError: f,
          onSuccess: M
        }, a.postMessage(o);
      } else
        Ul(p);
    });
  if (a)
    ll[i] = {
      onError: r,
      onSuccess: s
    }, a.postMessage(o);
  else
    return Ul(t);
}
var JM = {
  maxArea: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = XM({
      width: e.max,
      height: e.max,
      min: e.min,
      step: e.step,
      sizes: Zu(KM.area)
    }), i = Ai(Ai(Ai({}, va), e), {}, {
      sizes: n
    });
    return Fu(i);
  },
  maxHeight: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = XM({
      width: 1,
      height: e.max,
      min: e.min,
      step: e.step,
      sizes: Zu(KM.height)
    }), i = Ai(Ai(Ai({}, va), e), {}, {
      sizes: n
    });
    return Fu(i);
  },
  maxWidth: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = XM({
      width: e.max,
      height: 1,
      min: e.min,
      step: e.step,
      sizes: Zu(KM.width)
    }), i = Ai(Ai(Ai({}, va), e), {}, {
      sizes: n
    });
    return Fu(i);
  },
  test: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = Ai(Ai({}, va), e);
    return n.sizes = Zu(n.sizes), n.width && n.height && (n.sizes = [[n.width, n.height]]), Fu(n);
  }
};
let qM = null;
function r_() {
  return qM || (qM = s_()), qM;
}
async function s_() {
  const t = await JM.maxWidth({ usePromise: !0 }), e = await JM.maxHeight({ usePromise: !0 }), n = await JM.maxArea({ usePromise: !0 });
  return {
    maxWidth: t.width,
    maxHeight: e.height,
    maxArea: n.width * n.height
  };
}
const Fw = 8192, o_ = 4096 * 4096;
async function a_(t, e) {
  if (t <= Fw && e <= Fw && t * e <= o_)
    return [t, e];
  const { maxWidth: n, maxHeight: i, maxArea: r } = await r_(), s = t / e;
  if (t > n && (t = n, e = t / s), e > i && (e = i, t = e * s), t * e > r) {
    const o = Math.sqrt(r / (t * e));
    t *= o, e *= o;
  }
  return [t, e];
}
async function PS(t, e, n) {
  const { type: i, quality: r, scale: s, width: o, height: a } = n;
  let [c, d] = await a_(
    o * s,
    a * s
  );
  c = Math.floor(c), d = Math.floor(d);
  const u = c / o, h = await us.blobToDataUrl(new Blob([e], { type: "image/svg+xml" })), g = await new Promise((f) => {
    const M = Vl();
    M.crossOrigin = "anonymous", M.onload = async () => {
      mt.isSafari && await fy(250);
      const m = document.createElement("canvas"), y = m.getContext("2d");
      m.width = c, m.height = d, y.imageSmoothingEnabled = !0, y.imageSmoothingQuality = "high", y.drawImage(M, 0, 0, c, d), URL.revokeObjectURL(h), f(m);
    }, M.onerror = () => {
      f(null);
    }, M.src = h;
  });
  if (!g) return null;
  const p = await new Promise(
    (f) => g.toBlob(
      (M) => {
        (!M || Wt.throwToBlob.get()) && f(null), f(M);
      },
      "image/" + i,
      r
    )
  );
  if (!p) return null;
  if (i === "png") {
    const f = new DataView(await p.arrayBuffer());
    return zr.setPhysChunk(f, u, {
      type: "image/" + i
    });
  } else
    return p;
}
async function mz(t, e, n) {
  const i = await t.getSvgString(e != null && e.length ? e : [...t.getCurrentPageShapeIds()], {
    scale: 1,
    background: t.getInstanceState().exportBackground,
    ...n
  });
  if (!i)
    throw new Error("Could not construct SVG.");
  return i;
}
async function gI(t, e, n, i = {}) {
  var r;
  switch (n) {
    case "svg":
      return (r = await mz(t, e, i)) == null ? void 0 : r.svg;
    case "json": {
      const s = await t.resolveAssetsInContent(t.getContentFromCurrentPage(e));
      return JSON.stringify(s);
    }
    default:
      rn(n);
  }
}
async function Jp({
  editor: t,
  ids: e,
  format: n,
  opts: i = {}
}) {
  switch (n) {
    case "svg":
      return new Blob([await gI(t, e, "svg", i)], { type: "text/plain" });
    case "json":
      return new Blob([await gI(t, e, "json", i)], { type: "text/plain" });
    case "jpeg":
    case "png":
    case "webp": {
      const r = await mz(t, e, i);
      if (!r) throw new Error("Could not construct image.");
      const s = await PS(t, r.svg, {
        type: n,
        quality: 1,
        scale: 2,
        width: r.width,
        height: r.height
      });
      if (!s)
        throw new Error("Could not construct image.");
      return s;
    }
    default:
      rn(n);
  }
}
const c_ = {
  jpeg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  json: "text/plain",
  svg: "text/plain"
};
function l_(t, e, n, i = {}) {
  return {
    blobPromise: Jp({ editor: t, ids: e, format: n, opts: i }),
    mimeType: c_[n]
  };
}
function d_(t, e, n = "svg", i = {}) {
  if (!window.navigator.clipboard) return Promise.reject(new Error("Copy not supported"));
  if (window.navigator.clipboard.write) {
    const { blobPromise: r, mimeType: s } = l_(t, e, n, i);
    return r.catch((o) => {
      console.error(o);
    }), window.navigator.clipboard.write([new ClipboardItem({ [s]: r })]).catch((o) => (console.error(o), r.then((a) => window.navigator.clipboard.write([new ClipboardItem({ [s]: a })]))));
  }
  switch (n) {
    case "json":
    case "svg":
      return u_(async () => gI(t, e, n, i));
    case "jpeg":
    case "png":
      throw new Error("Copy not supported");
    default:
      rn(n);
  }
}
async function u_(t) {
  var e, n;
  await ((n = (e = navigator.clipboard) == null ? void 0 : e.writeText) == null ? void 0 : n.call(e, await t()));
}
function h_() {
  const t = Q(), { addToast: e } = Vr(), n = ke();
  return re(
    (i, r = "svg") => {
      d_(t, i, r).catch(() => {
        e({
          id: "copy-fail",
          severity: "warning",
          title: n("toast.error.copy-fail.title"),
          description: n("toast.error.copy-fail.desc")
        });
      });
    },
    [t, e, n]
  );
}
async function g_(t, e, n = "png", i, r = {}) {
  if (!i && (i = `shapes at ${Bw()}`, e.length === 1)) {
    const a = t.getShape(e[0]);
    t.isShapeOfType(a, "frame") ? i = a.props.name ?? "frame" : i = `${Ap(a.id)} at ${Bw()}`;
  }
  i += `.${n}`;
  const s = await Jp({ editor: t, ids: e, format: n, opts: r }), o = new File([s], i, { type: s.type });
  p_(o);
}
function Bw() {
  const t = /* @__PURE__ */ new Date(), e = String(t.getFullYear()).slice(2), n = String(t.getMonth() + 1).padStart(2, "0"), i = String(t.getDate()).padStart(2, "0"), r = String(t.getHours()).padStart(2, "0"), s = String(t.getMinutes()).padStart(2, "0"), o = String(t.getSeconds()).padStart(2, "0");
  return `${e}-${n}-${i} ${r}.${s}.${o}`;
}
function p_(t) {
  const e = document.createElement("a"), n = URL.createObjectURL(t);
  e.href = n, e.download = t.name, e.click(), URL.revokeObjectURL(n);
}
function f_() {
  const t = Q(), { addToast: e } = Vr(), n = ke();
  return re(
    (i, r = "png", s) => {
      g_(t, i, r, s, {
        scale: 1,
        background: t.getInstanceState().exportBackground
      }).catch((o) => {
        console.error(o.message), e({
          id: "export-fail",
          title: n("toast.error.export-fail.title"),
          description: n("toast.error.export-fail.desc"),
          severity: "error"
        });
      });
    },
    [t, e, n]
  );
}
async function M_(t, e, n) {
  const i = Ze(
    e.map((a) => {
      const c = t.getShape(a);
      if (!(!c || t.getShapeUtil(c.type).toSvg === void 0))
        return c;
    })
  );
  if (i.length === 0) return;
  if (i.length === 1) {
    const a = i[0];
    if (!a || t.isShapeOfType(a, "image")) return;
  }
  const r = [];
  if (n !== void 0) {
    const a = i.map((c) => ({
      shape: c,
      bounds: t.getShapeMaskedPageBounds(c).clone().expandBy(n)
    }));
    for (let c = 0; c < a.length; c++) {
      const d = a[c];
      if (c === 0) {
        r[0] = {
          shapes: [d.shape],
          bounds: d.bounds
        };
        continue;
      }
      let u = !1;
      for (const h of r)
        if (h.bounds.includes(d.bounds)) {
          h.shapes.push(d.shape), h.bounds.expand(d.bounds), u = !0;
          break;
        }
      u || r.push({
        shapes: [d.shape],
        bounds: d.bounds
      });
    }
  } else {
    const a = ae.Common(i.map((c) => t.getShapeMaskedPageBounds(c)));
    r.push({
      shapes: i,
      bounds: a
    });
  }
  const s = t.options.flattenImageBoundsPadding;
  for (const a of r) {
    n !== void 0 && a.bounds.expandBy(-n);
    const c = await t.getSvgString(a.shapes, {
      padding: s
    });
    if (!(c != null && c.svg)) continue;
    const d = new Blob([c.svg], { type: "image/svg+xml" }), u = await t.getAssetForExternalContent({
      type: "file",
      file: new File([d], "asset.svg", { type: "image/svg+xml" })
    });
    u && (a.asset = u);
  }
  const o = [];
  return Qr(() => {
    for (const a of r) {
      const { asset: c, bounds: d, shapes: u } = a;
      if (!c) continue;
      const h = t.findCommonAncestor(u) ?? t.getCurrentPageId();
      if (!h) continue;
      let g = "a1";
      for (const y of u)
        if (y.parentId === h) {
          y.index > g && (g = y.index);
          break;
        }
      let p, f, M;
      if (si(h)) {
        const y = t.getShape(h);
        if (!y) continue;
        const I = t.getPointInShapeSpace(y, {
          x: d.x,
          y: d.y
        });
        M = t.getShapePageTransform(h).rotation(), I.sub(new x(s, s).rot(-M)), p = I.x, f = I.y;
      } else
        p = d.x - s, f = d.y - s, M = 0;
      t.deleteShapes(u), t.createAssets([{ ...c, id: c.id }]);
      const m = Ee();
      t.createShape({
        id: m,
        type: "image",
        index: g,
        parentId: h,
        x: p,
        y: f,
        rotation: -M,
        props: {
          assetId: c.id,
          w: d.w + s * 2,
          h: d.h + s * 2
        }
      }), o.push(m);
    }
  }), o;
}
const yz = Ye.createContext([]);
function Iz() {
  const t = Q(), e = le(), n = Bs(Ye.useContext(yz));
  return ze(() => {
    const i = window.document.createElement("input");
    i.type = "file", i.accept = (n == null ? void 0 : n.join(",")) ?? LU, i.multiple = !0, e.current = i;
    async function r(s) {
      const o = s.target.files;
      !o || o.length === 0 || (t.markHistoryStoppingPoint("insert media"), await t.putExternalContent({
        type: "files",
        files: Array.from(o),
        point: t.getViewportPageBounds().center,
        ignoreParent: !1
      }), i.value = "");
    }
    return i.addEventListener("change", r), () => {
      e.current = void 0, i.removeEventListener("change", r);
    };
  }, [t, n]), re(() => {
    var i;
    (i = e.current) == null || i.click();
  }, [e]);
}
function qp() {
  return Q().store.props.collaboration !== void 0;
}
function m_() {
  const t = Q();
  return G(
    "sync status",
    () => {
      var e;
      return (e = t.store.props.collaboration) != null && e.status ? t.store.props.collaboration.status.get() : null;
    },
    [t]
  );
}
function y_() {
  const t = Q(), e = le(null), n = le(null);
  return re(
    async function() {
      const r = document.createElement("div"), s = document.createElement("style"), o = (y, I) => {
        y && (y.innerHTML = ""), I && document.head.contains(I) && document.head.removeChild(I), y && document.body.contains(y) && document.body.removeChild(y);
      };
      o(e.current, n.current), e.current = r, n.current = s;
      const a = `tl-print-surface-${ht()}`;
      r.className = a, s.innerHTML = `
			.${a} {
				display: none;
			}

			.${a} svg {
				max-width: 100%;
				height: 100%;
				display: block;
			}

			@media print {				  
				html, body {
					min-height: 100%;
					height: 100%;
					margin: 0;
				}

				body {
					position: relative;
				}

				body > * {
					display: none;
				}

				.tldraw__editor {
					display: none;
				}

				.${a} {
					display: block !important;
					background: white;
					min-height: 100%;
					height: 100%;
					max-width: 100%;
				}

				.${a}__item {
					padding: 10mm;
					display: flex;
					min-height: 100%;
					flex-direction: column;
					page-break-after: always;
					position: relative;
					overflow: hidden;
					height: 100%;
				}

				.${a}__item__main {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: center;
					max-height: 100%;
				}

				.${a}__item__header {
					display: none;
				}

				.${a}__item__footer {
					display: none;
					text-align: right;
				}

				.${a}__item__footer__hide {
					display: none;
				}

				
			}

		`;
      const c = () => {
        document.head.appendChild(s), document.body.appendChild(r);
      }, d = () => {
        t.once("tick", () => {
          o(r, s);
        });
      };
      window.addEventListener("beforeprint", c), window.addEventListener("afterprint", d);
      function u(y, I, D) {
        try {
          r.innerHTML += `<div class="${a}__item">
        <div class="${a}__item__header">
          ${y.replace(/</g, "&lt;").replace(/>/g, "&gt;")}
        </div>
        <div class="${a}__item__main">
          ${D}
        </div>
        <div class="${a}__item__footer ${a}__item__footer__${I ? "" : "hide"}">
          ${I ?? ""}
        </div>
      </div>`;
        } catch (j) {
          console.error(j);
        }
      }
      function h() {
        mt.isChromeForIos ? (c(), window.print()) : mt.isSafari ? (c(), document.execCommand("print", !1)) : window.print();
      }
      const g = t.getSelectedShapeIds(), p = t.getCurrentPageId(), f = t.getPages(), m = {
        scale: 1,
        background: !1,
        darkMode: !1,
        preserveAspectRatio: "xMidYMid meet"
      };
      if (t.getSelectedShapeIds().length > 0) {
        const y = await t.getSvgString(g, m);
        if (y) {
          const I = f.find((D) => D.id === p);
          u(`tldraw — ${I == null ? void 0 : I.name}`, null, y.svg), h();
        }
      } else {
        const y = t.getCurrentPage(), I = await t.getSvgString(
          t.getSortedChildIdsForParent(y.id),
          m
        );
        I && (u(`tldraw — ${y.name}`, null, I.svg), h());
      }
      window.removeEventListener("beforeprint", c), window.removeEventListener("afterprint", d);
    },
    [t]
  );
}
const xz = N.createContext(null);
function I_(t) {
  return Object.fromEntries(t.map((e) => [e.id, e]));
}
function fa(t, e) {
  if (t.getSelectedShapes().length === 0)
    return t.getDocumentSettings().name || e;
}
function x_({ overrides: t, children: e }) {
  const n = Q(), i = qp(), { addDialog: r, clearDialogs: s } = po(), { clearToasts: o, addToast: a } = Vr(), c = ke(), d = Iz(), u = y_(), { cut: h, copy: g, paste: p } = Gq(), f = h_(), M = f_(), m = c("document.default-name"), y = kS(), I = Zt(), D = N.useMemo(() => {
    function j() {
      return n.isIn("select") || (n.complete(), n.setCurrentTool("select")), !1;
    }
    function w() {
      return n.isIn("select") && n.getSelectedShapeIds().length > 0;
    }
    const A = [
      {
        id: "edit-link",
        label: "action.edit-link",
        icon: "link",
        onSelect(T) {
          w() && (j() || (I("edit-link", { source: T }), n.markHistoryStoppingPoint("edit-link"), r({ component: fq })));
        }
      },
      {
        id: "insert-embed",
        label: "action.insert-embed",
        kbd: "$i",
        onSelect(T) {
          I("insert-embed", { source: T }), r({ component: hz });
        }
      },
      {
        id: "insert-media",
        label: "action.insert-media",
        kbd: "$u",
        onSelect(T) {
          I("insert-media", { source: T }), d();
        }
      },
      {
        id: "undo",
        label: "action.undo",
        icon: "undo",
        kbd: "$z",
        onSelect(T) {
          I("undo", { source: T }), n.undo();
        }
      },
      {
        id: "redo",
        label: "action.redo",
        icon: "redo",
        kbd: "$!z",
        onSelect(T) {
          I("redo", { source: T }), n.redo();
        }
      },
      {
        id: "export-as-svg",
        label: {
          default: "action.export-as-svg",
          menu: "action.export-as-svg.short",
          "context-menu": "action.export-as-svg.short"
        },
        readonlyOk: !0,
        onSelect(T) {
          let E = n.getSelectedShapeIds();
          E.length === 0 && (E = Array.from(n.getCurrentPageShapeIds().values())), E.length !== 0 && (I("export-as", { format: "svg", source: T }), M(E, "svg", fa(n, m)));
        }
      },
      {
        id: "export-as-png",
        label: {
          default: "action.export-as-png",
          menu: "action.export-as-png.short",
          "context-menu": "action.export-as-png.short"
        },
        readonlyOk: !0,
        onSelect(T) {
          let E = n.getSelectedShapeIds();
          E.length === 0 && (E = Array.from(n.getCurrentPageShapeIds().values())), E.length !== 0 && (I("export-as", { format: "png", source: T }), M(E, "png", fa(n, m)));
        }
      },
      {
        id: "export-as-json",
        label: {
          default: "action.export-as-json",
          menu: "action.export-as-json.short",
          "context-menu": "action.export-as-json.short"
        },
        readonlyOk: !0,
        onSelect(T) {
          let E = n.getSelectedShapeIds();
          E.length === 0 && (E = Array.from(n.getCurrentPageShapeIds().values())), E.length !== 0 && (I("export-as", { format: "json", source: T }), M(E, "json", fa(n, m)));
        }
      },
      {
        id: "export-all-as-svg",
        label: {
          default: "action.export-all-as-svg",
          menu: "action.export-all-as-svg.short",
          "context-menu": "action.export-all-as-svg.short"
        },
        readonlyOk: !0,
        onSelect(T) {
          let E = n.getSelectedShapeIds();
          E.length === 0 && (E = Array.from(n.getCurrentPageShapeIds().values())), E.length !== 0 && (I("export-all-as", { format: "svg", source: T }), M(
            Array.from(n.getCurrentPageShapeIds()),
            "svg",
            fa(n, m)
          ));
        }
      },
      {
        id: "export-all-as-png",
        label: {
          default: "action.export-all-as-png",
          menu: "action.export-all-as-png.short",
          "context-menu": "action.export-all-as-png.short"
        },
        readonlyOk: !0,
        onSelect(T) {
          const E = Array.from(n.getCurrentPageShapeIds().values());
          E.length !== 0 && (I("export-all-as", { format: "png", source: T }), M(E, "png", fa(n, m)));
        }
      },
      {
        id: "export-all-as-json",
        label: {
          default: "action.export-all-as-json",
          menu: "action.export-all-as-json.short",
          "context-menu": "action.export-all-as-json.short"
        },
        readonlyOk: !0,
        onSelect(T) {
          const E = Array.from(n.getCurrentPageShapeIds().values());
          E.length !== 0 && (I("export-all-as", { format: "json", source: T }), M(E, "json", fa(n, m)));
        }
      },
      {
        id: "copy-as-svg",
        label: {
          default: "action.copy-as-svg",
          menu: "action.copy-as-svg.short",
          "context-menu": "action.copy-as-svg.short"
        },
        kbd: "$!c",
        readonlyOk: !0,
        onSelect(T) {
          let E = n.getSelectedShapeIds();
          E.length === 0 && (E = Array.from(n.getCurrentPageShapeIds().values())), E.length !== 0 && (I("copy-as", { format: "svg", source: T }), f(E, "svg"));
        }
      },
      {
        id: "copy-as-png",
        label: {
          default: "action.copy-as-png",
          menu: "action.copy-as-png.short",
          "context-menu": "action.copy-as-png.short"
        },
        readonlyOk: !0,
        onSelect(T) {
          let E = n.getSelectedShapeIds();
          E.length === 0 && (E = Array.from(n.getCurrentPageShapeIds().values())), E.length !== 0 && (I("copy-as", { format: "png", source: T }), f(E, "png"));
        }
      },
      {
        id: "copy-as-json",
        label: {
          default: "action.copy-as-json",
          menu: "action.copy-as-json.short",
          "context-menu": "action.copy-as-json.short"
        },
        readonlyOk: !0,
        onSelect(T) {
          let E = n.getSelectedShapeIds();
          E.length === 0 && (E = Array.from(n.getCurrentPageShapeIds().values())), E.length !== 0 && (I("copy-as", { format: "json", source: T }), f(E, "json"));
        }
      },
      {
        id: "toggle-auto-size",
        label: "action.toggle-auto-size",
        onSelect(T) {
          if (!w() || j()) return;
          I("toggle-auto-size", { source: T }), n.markHistoryStoppingPoint("toggling auto size");
          const E = n.getSelectedShapes().filter(
            (v) => n.isShapeOfType(v, "text") && v.props.autoSize === !1
          );
          n.updateShapes(
            E.map((v) => ({
              id: v.id,
              type: v.type,
              props: {
                ...v.props,
                w: 8,
                autoSize: !0
              }
            }))
          ), It(
            n,
            E.map((v) => v.id)
          );
        }
      },
      {
        id: "open-embed-link",
        label: "action.open-embed-link",
        readonlyOk: !0,
        onSelect(T) {
          I("open-embed-link", { source: T });
          const E = n.getSelectedShapeIds(), v = "No embed shapes selected";
          if (E.length !== 1) {
            console.error(v);
            return;
          }
          const P = n.getShape(E[0]);
          if (!P || !n.isShapeOfType(P, "embed")) {
            console.error(v);
            return;
          }
          rX(P.props.url, "_blank");
        }
      },
      {
        id: "select-zoom-tool",
        readonlyOk: !0,
        kbd: "z",
        onSelect(T) {
          var E, v;
          if (((E = n.root.getCurrent()) == null ? void 0 : E.id) !== "zoom" && (I("zoom-tool", { source: T }), !(n.inputs.shiftKey || n.inputs.ctrlKey))) {
            const P = n.root.getCurrent();
            P && ((v = P.getCurrent()) == null ? void 0 : v.id) === "idle" && n.setCurrentTool("zoom", { onInteractionEnd: P.id, maskAs: "zoom" });
          }
        }
      },
      {
        id: "convert-to-bookmark",
        label: "action.convert-to-bookmark",
        onSelect(T) {
          w() && (j() || n.run(() => {
            I("convert-to-bookmark", { source: T });
            const E = n.getSelectedShapes(), v = [], P = [];
            for (const C of E) {
              if (!C || !n.isShapeOfType(C, "embed") || !C.props.url)
                continue;
              const z = new x(C.x, C.y);
              z.rot(-C.rotation), z.add(new x(C.props.w / 2 - 300 / 2, C.props.h / 2 - 320 / 2)), z.rot(C.rotation);
              const O = {
                id: Ee(),
                type: "bookmark",
                rotation: C.rotation,
                x: z.x,
                y: z.y,
                opacity: 1,
                props: {
                  url: C.props.url
                }
              };
              v.push(O), P.push(C.id);
            }
            n.markHistoryStoppingPoint("convert shapes to bookmark"), n.deleteShapes(P), n.createShapes(v);
          }));
        }
      },
      {
        id: "convert-to-embed",
        label: "action.convert-to-embed",
        onSelect(T) {
          w() && (j() || (I("convert-to-embed", { source: T }), n.run(() => {
            const E = n.getSelectedShapeIds(), v = Ze(E.map((z) => n.getShape(z))), P = [], C = [];
            for (const z of v) {
              if (!n.isShapeOfType(z, "bookmark")) continue;
              const { url: O } = z.props, R = y(O);
              if (!R || !R.definition) continue;
              const { width: U, height: F } = R.definition, H = new x(z.x, z.y);
              H.rot(-z.rotation), H.add(new x(z.props.w / 2 - U / 2, z.props.h / 2 - F / 2)), H.rot(z.rotation);
              const Z = {
                id: Ee(),
                type: "embed",
                x: H.x,
                y: H.y,
                rotation: z.rotation,
                props: {
                  url: O,
                  w: U,
                  h: F
                }
              };
              P.push(Z), C.push(z.id);
            }
            n.markHistoryStoppingPoint("convert shapes to embed"), n.deleteShapes(C), n.createShapes(P);
          })));
        }
      },
      {
        id: "duplicate",
        kbd: "$d",
        label: "action.duplicate",
        icon: "duplicate",
        onSelect(T) {
          if (!w() || j()) return;
          I("duplicate-shapes", { source: T });
          const E = n.getInstanceState();
          let v, P;
          if (E.duplicateProps)
            v = E.duplicateProps.shapeIds, P = E.duplicateProps.offset;
          else {
            v = n.getSelectedShapeIds();
            const C = ae.Common(Ze(v.map((z) => n.getShapePageBounds(z))));
            P = n.getCameraOptions().isLocked ? {
              // same as the adjacent note margin
              x: n.options.adjacentShapeMargin,
              y: n.options.adjacentShapeMargin
            } : {
              x: C.width + n.options.adjacentShapeMargin,
              y: 0
            };
          }
          n.markHistoryStoppingPoint("duplicate shapes"), n.duplicateShapes(v, P), E.duplicateProps && n.updateInstanceState({
            duplicateProps: {
              ...E.duplicateProps,
              shapeIds: n.getSelectedShapeIds()
            }
          });
        }
      },
      {
        id: "ungroup",
        label: "action.ungroup",
        kbd: "$!g",
        icon: "ungroup",
        onSelect(T) {
          w() && (j() || (I("ungroup-shapes", { source: T }), n.markHistoryStoppingPoint("ungroup"), n.ungroupShapes(n.getSelectedShapeIds())));
        }
      },
      {
        id: "group",
        label: "action.group",
        kbd: "$g",
        icon: "group",
        onSelect(T) {
          if (!w() || j()) return;
          I("group-shapes", { source: T });
          const E = n.getOnlySelectedShape();
          E && n.isShapeOfType(E, "group") ? (n.markHistoryStoppingPoint("ungroup"), n.ungroupShapes(n.getSelectedShapeIds())) : (n.markHistoryStoppingPoint("group"), n.groupShapes(n.getSelectedShapeIds()));
        }
      },
      {
        id: "remove-frame",
        label: "action.remove-frame",
        kbd: "$!f",
        onSelect(T) {
          if (!w()) return;
          I("remove-frame", { source: T });
          const E = n.getSelectedShapes();
          E.length > 0 && E.every((v) => n.isShapeOfType(v, "frame")) && (n.markHistoryStoppingPoint("remove-frame"), hq(
            n,
            E.map((v) => v.id)
          ));
        }
      },
      {
        id: "fit-frame-to-content",
        label: "action.fit-frame-to-content",
        onSelect(T) {
          if (!w()) return;
          I("fit-frame-to-content", { source: T });
          const E = n.getOnlySelectedShape();
          E && n.isShapeOfType(E, "frame") && (n.markHistoryStoppingPoint("fit-frame-to-content"), pq(n, E.id));
        }
      },
      {
        id: "align-left",
        label: "action.align-left",
        kbd: "?A",
        icon: "align-left",
        onSelect(T) {
          if (!w() || j()) return;
          I("align-shapes", { operation: "left", source: T }), n.markHistoryStoppingPoint("align left");
          const E = n.getSelectedShapeIds();
          n.alignShapes(E, "left"), It(n, E);
        }
      },
      {
        id: "align-center-horizontal",
        label: {
          default: "action.align-center-horizontal",
          "context-menu": "action.align-center-horizontal.short"
        },
        kbd: "?H",
        icon: "align-center-horizontal",
        onSelect(T) {
          if (!w() || j()) return;
          I("align-shapes", { operation: "center-horizontal", source: T }), n.markHistoryStoppingPoint("align center horizontal");
          const E = n.getSelectedShapeIds();
          n.alignShapes(E, "center-horizontal"), It(n, E);
        }
      },
      {
        id: "align-right",
        label: "action.align-right",
        kbd: "?D",
        icon: "align-right",
        onSelect(T) {
          if (!w() || j()) return;
          I("align-shapes", { operation: "right", source: T }), n.markHistoryStoppingPoint("align right");
          const E = n.getSelectedShapeIds();
          n.alignShapes(E, "right"), It(n, E);
        }
      },
      {
        id: "align-center-vertical",
        label: {
          default: "action.align-center-vertical",
          "context-menu": "action.align-center-vertical.short"
        },
        kbd: "?V",
        icon: "align-center-vertical",
        onSelect(T) {
          if (!w() || j()) return;
          I("align-shapes", { operation: "center-vertical", source: T }), n.markHistoryStoppingPoint("align center vertical");
          const E = n.getSelectedShapeIds();
          n.alignShapes(E, "center-vertical"), It(n, E);
        }
      },
      {
        id: "align-top",
        label: "action.align-top",
        icon: "align-top",
        kbd: "?W",
        onSelect(T) {
          if (!w() || j()) return;
          I("align-shapes", { operation: "top", source: T }), n.markHistoryStoppingPoint("align top");
          const E = n.getSelectedShapeIds();
          n.alignShapes(E, "top"), It(n, E);
        }
      },
      {
        id: "align-bottom",
        label: "action.align-bottom",
        icon: "align-bottom",
        kbd: "?S",
        onSelect(T) {
          if (!w() || j()) return;
          I("align-shapes", { operation: "bottom", source: T }), n.markHistoryStoppingPoint("align bottom");
          const E = n.getSelectedShapeIds();
          n.alignShapes(E, "bottom"), It(n, E);
        }
      },
      {
        id: "distribute-horizontal",
        label: {
          default: "action.distribute-horizontal",
          "context-menu": "action.distribute-horizontal.short"
        },
        icon: "distribute-horizontal",
        kbd: "?!h",
        onSelect(T) {
          if (!w() || j()) return;
          I("distribute-shapes", { operation: "horizontal", source: T }), n.markHistoryStoppingPoint("distribute horizontal");
          const E = n.getSelectedShapeIds();
          n.distributeShapes(E, "horizontal"), It(n, E);
        }
      },
      {
        id: "distribute-vertical",
        label: {
          default: "action.distribute-vertical",
          "context-menu": "action.distribute-vertical.short"
        },
        icon: "distribute-vertical",
        kbd: "?!V",
        onSelect(T) {
          if (!w() || j()) return;
          I("distribute-shapes", { operation: "vertical", source: T }), n.markHistoryStoppingPoint("distribute vertical");
          const E = n.getSelectedShapeIds();
          n.distributeShapes(E, "vertical"), It(n, E);
        }
      },
      {
        id: "stretch-horizontal",
        label: {
          default: "action.stretch-horizontal",
          "context-menu": "action.stretch-horizontal.short"
        },
        icon: "stretch-horizontal",
        onSelect(T) {
          if (!w() || j()) return;
          I("stretch-shapes", { operation: "horizontal", source: T }), n.markHistoryStoppingPoint("stretch horizontal");
          const E = n.getSelectedShapeIds();
          n.stretchShapes(E, "horizontal"), It(n, E);
        }
      },
      {
        id: "stretch-vertical",
        label: {
          default: "action.stretch-vertical",
          "context-menu": "action.stretch-vertical.short"
        },
        icon: "stretch-vertical",
        onSelect(T) {
          if (!w() || j()) return;
          I("stretch-shapes", { operation: "vertical", source: T }), n.markHistoryStoppingPoint("stretch vertical");
          const E = n.getSelectedShapeIds();
          n.stretchShapes(E, "vertical"), It(n, E);
        }
      },
      {
        id: "flip-horizontal",
        label: {
          default: "action.flip-horizontal",
          "context-menu": "action.flip-horizontal.short"
        },
        kbd: "!h",
        onSelect(T) {
          if (!w() || j()) return;
          I("flip-shapes", { operation: "horizontal", source: T }), n.markHistoryStoppingPoint("flip horizontal");
          const E = n.getSelectedShapeIds();
          n.flipShapes(E, "horizontal"), It(n, E);
        }
      },
      {
        id: "flip-vertical",
        label: { default: "action.flip-vertical", "context-menu": "action.flip-vertical.short" },
        kbd: "!v",
        onSelect(T) {
          if (!w() || j()) return;
          I("flip-shapes", { operation: "vertical", source: T }), n.markHistoryStoppingPoint("flip vertical");
          const E = n.getSelectedShapeIds();
          n.flipShapes(E, "vertical"), It(n, E);
        }
      },
      {
        id: "pack",
        label: "action.pack",
        icon: "pack",
        onSelect(T) {
          if (!w() || j()) return;
          I("pack-shapes", { source: T }), n.markHistoryStoppingPoint("pack");
          const E = n.getSelectedShapeIds();
          n.packShapes(E, n.options.adjacentShapeMargin), It(n, E);
        }
      },
      {
        id: "stack-vertical",
        label: {
          default: "action.stack-vertical",
          "context-menu": "action.stack-vertical.short"
        },
        icon: "stack-vertical",
        onSelect(T) {
          if (!w() || j()) return;
          I("stack-shapes", { operation: "vertical", source: T }), n.markHistoryStoppingPoint("stack-vertical");
          const E = n.getSelectedShapeIds();
          n.stackShapes(E, "vertical", 16), It(n, E);
        }
      },
      {
        id: "stack-horizontal",
        label: {
          default: "action.stack-horizontal",
          "context-menu": "action.stack-horizontal.short"
        },
        icon: "stack-horizontal",
        onSelect(T) {
          if (!w() || j()) return;
          I("stack-shapes", { operation: "horizontal", source: T }), n.markHistoryStoppingPoint("stack-horizontal");
          const E = n.getSelectedShapeIds();
          n.stackShapes(E, "horizontal", 16), It(n, E);
        }
      },
      {
        id: "bring-to-front",
        label: "action.bring-to-front",
        kbd: "]",
        icon: "bring-to-front",
        onSelect(T) {
          w() && (j() || (I("reorder-shapes", { operation: "toFront", source: T }), n.markHistoryStoppingPoint("bring to front"), n.bringToFront(n.getSelectedShapeIds())));
        }
      },
      {
        id: "bring-forward",
        label: "action.bring-forward",
        icon: "bring-forward",
        kbd: "?]",
        onSelect(T) {
          w() && (j() || (I("reorder-shapes", { operation: "forward", source: T }), n.markHistoryStoppingPoint("bring forward"), n.bringForward(n.getSelectedShapeIds())));
        }
      },
      {
        id: "send-backward",
        label: "action.send-backward",
        icon: "send-backward",
        kbd: "?[",
        onSelect(T) {
          w() && (j() || (I("reorder-shapes", { operation: "backward", source: T }), n.markHistoryStoppingPoint("send backward"), n.sendBackward(n.getSelectedShapeIds())));
        }
      },
      {
        id: "send-to-back",
        label: "action.send-to-back",
        icon: "send-to-back",
        kbd: "[",
        onSelect(T) {
          w() && (j() || (I("reorder-shapes", { operation: "toBack", source: T }), n.markHistoryStoppingPoint("send to back"), n.sendToBack(n.getSelectedShapeIds())));
        }
      },
      {
        id: "cut",
        label: "action.cut",
        kbd: "$x",
        onSelect(T) {
          w() && (j() || (n.markHistoryStoppingPoint("cut"), h(T)));
        }
      },
      {
        id: "copy",
        label: "action.copy",
        kbd: "$c",
        readonlyOk: !0,
        onSelect(T) {
          w() && (j() || g(T));
        }
      },
      {
        id: "paste",
        label: "action.paste",
        kbd: "$v",
        onSelect(T) {
          var E;
          (E = navigator.clipboard) == null || E.read().then((v) => {
            p(
              v,
              T,
              T === "context-menu" ? n.inputs.currentPagePoint : void 0
            );
          }).catch(() => {
            a({
              title: c("action.paste-error-title"),
              description: c("action.paste-error-description"),
              severity: "error"
            });
          });
        }
      },
      {
        id: "select-all",
        label: "action.select-all",
        kbd: "$a",
        readonlyOk: !0,
        onSelect(T) {
          n.run(() => {
            j() || (I("select-all-shapes", { source: T }), n.markHistoryStoppingPoint("select all kbd"), n.selectAll());
          });
        }
      },
      {
        id: "select-none",
        label: "action.select-none",
        readonlyOk: !0,
        onSelect(T) {
          w() && (j() || (I("select-none-shapes", { source: T }), n.markHistoryStoppingPoint("select none"), n.selectNone()));
        }
      },
      {
        id: "delete",
        label: "action.delete",
        kbd: "⌫,del,backspace",
        icon: "trash",
        onSelect(T) {
          w() && (j() || (I("delete-shapes", { source: T }), n.markHistoryStoppingPoint("delete"), n.deleteShapes(n.getSelectedShapeIds())));
        }
      },
      {
        id: "rotate-cw",
        label: "action.rotate-cw",
        icon: "rotate-cw",
        onSelect(T) {
          if (!w() || j()) return;
          I("rotate-cw", { source: T }), n.markHistoryStoppingPoint("rotate-cw");
          const E = n.getSelectionRotation() % (Nt / 2), v = Xs(E, 0) || Xs(E, Nt / 2), P = n.getSelectedShapeIds();
          n.rotateShapesBy(P, Nt / 2 - (v ? 0 : E)), It(n, P);
        }
      },
      {
        id: "rotate-ccw",
        label: "action.rotate-ccw",
        icon: "rotate-ccw",
        onSelect(T) {
          if (!w() || j()) return;
          I("rotate-ccw", { source: T }), n.markHistoryStoppingPoint("rotate-ccw");
          const E = n.getSelectionRotation() % (Nt / 2), v = Xs(E, 0), P = n.getSelectedShapeIds();
          n.rotateShapesBy(P, v ? -(Nt / 2) : -E), It(n, P);
        }
      },
      {
        id: "zoom-in",
        label: "action.zoom-in",
        kbd: "$=,=",
        readonlyOk: !0,
        onSelect(T) {
          I("zoom-in", { source: T }), n.zoomIn(void 0, {
            animation: { duration: n.options.animationMediumMs }
          });
        }
      },
      {
        id: "zoom-out",
        label: "action.zoom-out",
        kbd: "$-,-",
        readonlyOk: !0,
        onSelect(T) {
          I("zoom-out", { source: T }), n.zoomOut(void 0, {
            animation: { duration: n.options.animationMediumMs }
          });
        }
      },
      {
        id: "zoom-to-100",
        label: "action.zoom-to-100",
        icon: "reset-zoom",
        kbd: "!0",
        readonlyOk: !0,
        onSelect(T) {
          I("reset-zoom", { source: T }), n.resetZoom(void 0, {
            animation: { duration: n.options.animationMediumMs }
          });
        }
      },
      {
        id: "zoom-to-fit",
        label: "action.zoom-to-fit",
        kbd: "!1",
        readonlyOk: !0,
        onSelect(T) {
          I("zoom-to-fit", { source: T }), n.zoomToFit({ animation: { duration: n.options.animationMediumMs } });
        }
      },
      {
        id: "zoom-to-selection",
        label: "action.zoom-to-selection",
        kbd: "!2",
        readonlyOk: !0,
        onSelect(T) {
          w() && (j() || (I("zoom-to-selection", { source: T }), n.zoomToSelection({ animation: { duration: n.options.animationMediumMs } })));
        }
      },
      {
        id: "toggle-snap-mode",
        label: {
          default: "action.toggle-snap-mode",
          menu: "action.toggle-snap-mode.menu"
        },
        onSelect(T) {
          I("toggle-snap-mode", { source: T }), n.user.updateUserPreferences({ isSnapMode: !n.user.getIsSnapMode() });
        },
        checkbox: !0
      },
      {
        id: "toggle-dark-mode",
        label: {
          default: "action.toggle-dark-mode",
          menu: "action.toggle-dark-mode.menu"
        },
        kbd: "$/",
        readonlyOk: !0,
        onSelect(T) {
          const E = n.user.getIsDarkMode() ? "light" : "dark";
          I("color-scheme", { source: T, value: E }), n.user.updateUserPreferences({
            colorScheme: E
          });
        },
        checkbox: !0
      },
      {
        id: "toggle-wrap-mode",
        label: {
          default: "action.toggle-wrap-mode",
          menu: "action.toggle-wrap-mode.menu"
        },
        readonlyOk: !0,
        onSelect(T) {
          I("toggle-wrap-mode", { source: T }), n.user.updateUserPreferences({
            isWrapMode: !n.user.getIsWrapMode()
          });
        },
        checkbox: !0
      },
      {
        id: "toggle-dynamic-size-mode",
        label: {
          default: "action.toggle-dynamic-size-mode",
          menu: "action.toggle-dynamic-size-mode.menu"
        },
        readonlyOk: !1,
        onSelect(T) {
          I("toggle-dynamic-size-mode", { source: T }), n.user.updateUserPreferences({
            isDynamicSizeMode: !n.user.getIsDynamicResizeMode()
          });
        },
        checkbox: !0
      },
      {
        id: "toggle-paste-at-cursor",
        label: {
          default: "action.toggle-paste-at-cursor",
          menu: "action.toggle-paste-at-cursor.menu"
        },
        readonlyOk: !1,
        onSelect(T) {
          I("toggle-paste-at-cursor", { source: T }), n.user.updateUserPreferences({
            isPasteAtCursorMode: !n.user.getIsPasteAtCursorMode()
          });
        },
        checkbox: !0
      },
      {
        id: "toggle-reduce-motion",
        label: {
          default: "action.toggle-reduce-motion",
          menu: "action.toggle-reduce-motion.menu"
        },
        readonlyOk: !0,
        onSelect(T) {
          I("toggle-reduce-motion", { source: T }), n.user.updateUserPreferences({
            animationSpeed: n.user.getAnimationSpeed() === 0 ? 1 : 0
          });
        },
        checkbox: !0
      },
      {
        id: "toggle-edge-scrolling",
        label: {
          default: "action.toggle-edge-scrolling",
          menu: "action.toggle-edge-scrolling.menu"
        },
        readonlyOk: !0,
        onSelect(T) {
          I("toggle-edge-scrolling", { source: T }), n.user.updateUserPreferences({
            edgeScrollSpeed: n.user.getEdgeScrollSpeed() === 0 ? 1 : 0
          });
        },
        checkbox: !0
      },
      {
        id: "toggle-transparent",
        label: {
          default: "action.toggle-transparent",
          menu: "action.toggle-transparent.menu",
          "context-menu": "action.toggle-transparent.context-menu"
        },
        readonlyOk: !0,
        onSelect(T) {
          I("toggle-transparent", { source: T }), n.updateInstanceState({
            exportBackground: !n.getInstanceState().exportBackground
          });
        },
        checkbox: !0
      },
      {
        id: "toggle-tool-lock",
        label: {
          default: "action.toggle-tool-lock",
          menu: "action.toggle-tool-lock.menu"
        },
        kbd: "q",
        onSelect(T) {
          I("toggle-tool-lock", { source: T }), n.updateInstanceState({ isToolLocked: !n.getInstanceState().isToolLocked });
        },
        checkbox: !0
      },
      {
        id: "unlock-all",
        label: "action.unlock-all",
        onSelect(T) {
          I("unlock-all", { source: T });
          const E = [];
          for (const v of n.getCurrentPageShapes())
            v.isLocked && E.push({ id: v.id, type: v.type, isLocked: !1 });
          E.length > 0 && n.updateShapes(E);
        }
      },
      {
        id: "toggle-focus-mode",
        label: {
          default: "action.toggle-focus-mode",
          menu: "action.toggle-focus-mode.menu"
        },
        readonlyOk: !0,
        kbd: "$.",
        checkbox: !0,
        onSelect(T) {
          n.timers.requestAnimationFrame(() => {
            n.run(() => {
              I("toggle-focus-mode", { source: T }), s(), o(), n.updateInstanceState({ isFocusMode: !n.getInstanceState().isFocusMode });
            });
          });
        }
      },
      {
        id: "toggle-grid",
        label: {
          default: "action.toggle-grid",
          menu: "action.toggle-grid.menu"
        },
        readonlyOk: !0,
        kbd: "$'",
        onSelect(T) {
          I("toggle-grid-mode", { source: T }), n.updateInstanceState({ isGridMode: !n.getInstanceState().isGridMode });
        },
        checkbox: !0
      },
      {
        id: "toggle-debug-mode",
        label: {
          default: "action.toggle-debug-mode",
          menu: "action.toggle-debug-mode.menu"
        },
        readonlyOk: !0,
        onSelect(T) {
          I("toggle-debug-mode", { source: T }), n.updateInstanceState({
            isDebugMode: !n.getInstanceState().isDebugMode
          });
        },
        checkbox: !0
      },
      {
        id: "print",
        label: "action.print",
        kbd: "$p",
        readonlyOk: !0,
        onSelect(T) {
          I("print", { source: T }), u();
        }
      },
      {
        id: "exit-pen-mode",
        label: "action.exit-pen-mode",
        icon: "cross-2",
        readonlyOk: !0,
        onSelect(T) {
          I("exit-pen-mode", { source: T }), n.updateInstanceState({ isPenMode: !1 });
        }
      },
      {
        id: "stop-following",
        label: "action.stop-following",
        icon: "cross-2",
        readonlyOk: !0,
        onSelect(T) {
          I("stop-following", { source: T }), n.stopFollowingUser();
        }
      },
      {
        id: "back-to-content",
        label: "action.back-to-content",
        icon: "arrow-left",
        readonlyOk: !0,
        onSelect(T) {
          I("zoom-to-content", { source: T });
          const E = n.getSelectionPageBounds() ?? n.getCurrentPageBounds();
          E && n.zoomToBounds(E, {
            targetZoom: Math.min(1, n.getZoomLevel()),
            animation: { duration: 220 }
          });
        }
      },
      {
        id: "toggle-lock",
        label: "action.toggle-lock",
        kbd: "!l",
        onSelect(T) {
          n.markHistoryStoppingPoint("locking"), I("toggle-lock", { source: T }), n.toggleLock(n.getSelectedShapeIds());
        }
      },
      {
        id: "move-to-new-page",
        label: "context.pages.new-page",
        onSelect(T) {
          const E = kn.createId(), v = n.getSelectedShapeIds();
          n.run(() => {
            n.markHistoryStoppingPoint("move_shapes_to_page"), n.createPage({ name: c("page-menu.new-page-initial-name"), id: E }), n.moveShapesToPage(v, E);
          }), I("move-to-new-page", { source: T });
        }
      },
      {
        id: "select-white-color",
        label: "color-style.white",
        kbd: "?t",
        onSelect(T) {
          const E = Ln;
          n.run(() => {
            n.markHistoryStoppingPoint("change-color"), n.isIn("select") && n.setStyleForSelectedShapes(E, "white"), n.setStyleForNextShapes(E, "white");
          }), I("set-style", { source: T, id: E.id, value: "white" });
        }
      },
      {
        id: "select-fill-fill",
        label: "fill-style.fill",
        kbd: "?f",
        onSelect(T) {
          const E = ms;
          n.run(() => {
            n.markHistoryStoppingPoint("change-fill"), n.isIn("select") && n.setStyleForSelectedShapes(E, "fill"), n.setStyleForNextShapes(E, "fill");
          }), I("set-style", { source: T, id: E.id, value: "fill" });
        }
      },
      {
        id: "flatten-to-image",
        label: "action.flatten-to-image",
        kbd: "!f",
        onSelect: async (T) => {
          const E = n.getSelectedShapeIds();
          if (E.length === 0) return;
          n.markHistoryStoppingPoint("flattening to image"), I("flatten-to-image", { source: T });
          const v = await M_(
            n,
            E,
            n.options.flattenImageBoundsExpand
          );
          v != null && v.length && n.setSelectedShapes(v);
        }
      }
    ];
    i && A.push({
      id: "open-cursor-chat",
      label: "action.open-cursor-chat",
      readonlyOk: !0,
      kbd: "/",
      onSelect(T) {
        I("open-cursor-chat", { source: T }), !n.getInstanceState().isCoarsePointer && n.timers.requestAnimationFrame(() => {
          n.updateInstanceState({ isChatting: !0 });
        });
      }
    });
    const b = I_(A);
    return t ? t(n, b, void 0) : b;
  }, [
    n,
    I,
    t,
    r,
    a,
    d,
    M,
    f,
    h,
    g,
    p,
    s,
    o,
    u,
    c,
    m,
    i,
    y
  ]);
  return /* @__PURE__ */ l.jsx(xz.Provider, { value: D, children: e });
}
function _t() {
  const t = N.useContext(xz);
  if (!t)
    throw new Error("useTools must be used within a ToolProvider");
  return t;
}
function _l(t, e) {
  return t ? typeof t == "string" ? t : e ? t[e] ?? t.default : void 0 : void 0;
}
var S_ = N.createContext(void 0);
function _p(t) {
  const e = N.useContext(S_);
  return t || e || "ltr";
}
const j_ = ["top", "right", "bottom", "left"], Or = Math.min, Ti = Math.max, Rg = Math.round, Bu = Math.floor, to = (t) => ({
  x: t,
  y: t
}), D_ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, w_ = {
  start: "end",
  end: "start"
};
function pI(t, e, n) {
  return Ti(t, Or(e, n));
}
function ys(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Is(t) {
  return t.split("-")[0];
}
function vc(t) {
  return t.split("-")[1];
}
function US(t) {
  return t === "x" ? "y" : "x";
}
function RS(t) {
  return t === "y" ? "height" : "width";
}
function no(t) {
  return ["top", "bottom"].includes(Is(t)) ? "y" : "x";
}
function YS(t) {
  return US(no(t));
}
function N_(t, e, n) {
  n === void 0 && (n = !1);
  const i = vc(t), r = YS(t), s = RS(r);
  let o = r === "x" ? i === (n ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (o = Yg(o)), [o, Yg(o)];
}
function A_(t) {
  const e = Yg(t);
  return [fI(t), e, fI(e)];
}
function fI(t) {
  return t.replace(/start|end/g, (e) => w_[e]);
}
function T_(t, e, n) {
  const i = ["left", "right"], r = ["right", "left"], s = ["top", "bottom"], o = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? r : i : e ? i : r;
    case "left":
    case "right":
      return e ? s : o;
    default:
      return [];
  }
}
function b_(t, e, n, i) {
  const r = vc(t);
  let s = T_(Is(t), n === "start", i);
  return r && (s = s.map((o) => o + "-" + r), e && (s = s.concat(s.map(fI)))), s;
}
function Yg(t) {
  return t.replace(/left|right|bottom|top/g, (e) => D_[e]);
}
function v_(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Sz(t) {
  return typeof t != "number" ? v_(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Qg(t) {
  const {
    x: e,
    y: n,
    width: i,
    height: r
  } = t;
  return {
    width: i,
    height: r,
    top: n,
    left: e,
    right: e + i,
    bottom: n + r,
    x: e,
    y: n
  };
}
function Gw(t, e, n) {
  let {
    reference: i,
    floating: r
  } = t;
  const s = no(e), o = YS(e), a = RS(o), c = Is(e), d = s === "y", u = i.x + i.width / 2 - r.width / 2, h = i.y + i.height / 2 - r.height / 2, g = i[a] / 2 - r[a] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: u,
        y: i.y - r.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: i.y + i.height
      };
      break;
    case "right":
      p = {
        x: i.x + i.width,
        y: h
      };
      break;
    case "left":
      p = {
        x: i.x - r.width,
        y: h
      };
      break;
    default:
      p = {
        x: i.x,
        y: i.y
      };
  }
  switch (vc(e)) {
    case "start":
      p[o] -= g * (n && d ? -1 : 1);
      break;
    case "end":
      p[o] += g * (n && d ? -1 : 1);
      break;
  }
  return p;
}
const E_ = async (t, e, n) => {
  const {
    placement: i = "bottom",
    strategy: r = "absolute",
    middleware: s = [],
    platform: o
  } = n, a = s.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(e));
  let d = await o.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: u,
    y: h
  } = Gw(d, i, c), g = i, p = {}, f = 0;
  for (let M = 0; M < a.length; M++) {
    const {
      name: m,
      fn: y
    } = a[M], {
      x: I,
      y: D,
      data: j,
      reset: w
    } = await y({
      x: u,
      y: h,
      initialPlacement: i,
      placement: g,
      strategy: r,
      middlewareData: p,
      rects: d,
      platform: o,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = I ?? u, h = D ?? h, p = {
      ...p,
      [m]: {
        ...p[m],
        ...j
      }
    }, w && f <= 50 && (f++, typeof w == "object" && (w.placement && (g = w.placement), w.rects && (d = w.rects === !0 ? await o.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : w.rects), {
      x: u,
      y: h
    } = Gw(d, g, c)), M = -1);
  }
  return {
    x: u,
    y: h,
    placement: g,
    strategy: r,
    middlewareData: p
  };
};
async function $l(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: i,
    y: r,
    platform: s,
    rects: o,
    elements: a,
    strategy: c
  } = t, {
    boundary: d = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: h = "floating",
    altBoundary: g = !1,
    padding: p = 0
  } = ys(e, t), f = Sz(p), m = a[g ? h === "floating" ? "reference" : "floating" : h], y = Qg(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(m))) == null || n ? m : m.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: d,
    rootBoundary: u,
    strategy: c
  })), I = h === "floating" ? {
    x: i,
    y: r,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, D = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), j = await (s.isElement == null ? void 0 : s.isElement(D)) ? await (s.getScale == null ? void 0 : s.getScale(D)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = Qg(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: I,
    offsetParent: D,
    strategy: c
  }) : I);
  return {
    top: (y.top - w.top + f.top) / j.y,
    bottom: (w.bottom - y.bottom + f.bottom) / j.y,
    left: (y.left - w.left + f.left) / j.x,
    right: (w.right - y.right + f.right) / j.x
  };
}
const C_ = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: i,
      placement: r,
      rects: s,
      platform: o,
      elements: a,
      middlewareData: c
    } = e, {
      element: d,
      padding: u = 0
    } = ys(t, e) || {};
    if (d == null)
      return {};
    const h = Sz(u), g = {
      x: n,
      y: i
    }, p = YS(r), f = RS(p), M = await o.getDimensions(d), m = p === "y", y = m ? "top" : "left", I = m ? "bottom" : "right", D = m ? "clientHeight" : "clientWidth", j = s.reference[f] + s.reference[p] - g[p] - s.floating[f], w = g[p] - s.reference[p], A = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(d));
    let b = A ? A[D] : 0;
    (!b || !await (o.isElement == null ? void 0 : o.isElement(A))) && (b = a.floating[D] || s.floating[f]);
    const T = j / 2 - w / 2, E = b / 2 - M[f] / 2 - 1, v = Or(h[y], E), P = Or(h[I], E), C = v, z = b - M[f] - P, O = b / 2 - M[f] / 2 + T, R = pI(C, O, z), U = !c.arrow && vc(r) != null && O !== R && s.reference[f] / 2 - (O < C ? v : P) - M[f] / 2 < 0, F = U ? O < C ? O - C : O - z : 0;
    return {
      [p]: g[p] + F,
      data: {
        [p]: R,
        centerOffset: O - R - F,
        ...U && {
          alignmentOffset: F
        }
      },
      reset: U
    };
  }
}), z_ = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, i;
      const {
        placement: r,
        middlewareData: s,
        rects: o,
        initialPlacement: a,
        platform: c,
        elements: d
      } = e, {
        mainAxis: u = !0,
        crossAxis: h = !0,
        fallbackPlacements: g,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: f = "none",
        flipAlignment: M = !0,
        ...m
      } = ys(t, e);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const y = Is(r), I = no(a), D = Is(a) === a, j = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), w = g || (D || !M ? [Yg(a)] : A_(a)), A = f !== "none";
      !g && A && w.push(...b_(a, M, f, j));
      const b = [a, ...w], T = await $l(e, m), E = [];
      let v = ((i = s.flip) == null ? void 0 : i.overflows) || [];
      if (u && E.push(T[y]), h) {
        const O = N_(r, o, j);
        E.push(T[O[0]], T[O[1]]);
      }
      if (v = [...v, {
        placement: r,
        overflows: E
      }], !E.every((O) => O <= 0)) {
        var P, C;
        const O = (((P = s.flip) == null ? void 0 : P.index) || 0) + 1, R = b[O];
        if (R)
          return {
            data: {
              index: O,
              overflows: v
            },
            reset: {
              placement: R
            }
          };
        let U = (C = v.filter((F) => F.overflows[0] <= 0).sort((F, H) => F.overflows[1] - H.overflows[1])[0]) == null ? void 0 : C.placement;
        if (!U)
          switch (p) {
            case "bestFit": {
              var z;
              const F = (z = v.filter((H) => {
                if (A) {
                  const Z = no(H.placement);
                  return Z === I || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Z === "y";
                }
                return !0;
              }).map((H) => [H.placement, H.overflows.filter((Z) => Z > 0).reduce((Z, te) => Z + te, 0)]).sort((H, Z) => H[1] - Z[1])[0]) == null ? void 0 : z[0];
              F && (U = F);
              break;
            }
            case "initialPlacement":
              U = a;
              break;
          }
        if (r !== U)
          return {
            reset: {
              placement: U
            }
          };
      }
      return {};
    }
  };
};
function Ww(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Hw(t) {
  return j_.some((e) => t[e] >= 0);
}
const L_ = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: i = "referenceHidden",
        ...r
      } = ys(t, e);
      switch (i) {
        case "referenceHidden": {
          const s = await $l(e, {
            ...r,
            elementContext: "reference"
          }), o = Ww(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: Hw(o)
            }
          };
        }
        case "escaped": {
          const s = await $l(e, {
            ...r,
            altBoundary: !0
          }), o = Ww(s, n.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: Hw(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function k_(t, e) {
  const {
    placement: n,
    platform: i,
    elements: r
  } = t, s = await (i.isRTL == null ? void 0 : i.isRTL(r.floating)), o = Is(n), a = vc(n), c = no(n) === "y", d = ["left", "top"].includes(o) ? -1 : 1, u = s && c ? -1 : 1, h = ys(e, t);
  let {
    mainAxis: g,
    crossAxis: p,
    alignmentAxis: f
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...h
  };
  return a && typeof f == "number" && (p = a === "end" ? f * -1 : f), c ? {
    x: p * u,
    y: g * d
  } : {
    x: g * d,
    y: p * u
  };
}
const O_ = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, i;
      const {
        x: r,
        y: s,
        placement: o,
        middlewareData: a
      } = e, c = await k_(e, t);
      return o === ((n = a.offset) == null ? void 0 : n.placement) && (i = a.arrow) != null && i.alignmentOffset ? {} : {
        x: r + c.x,
        y: s + c.y,
        data: {
          ...c,
          placement: o
        }
      };
    }
  };
}, P_ = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: i,
        placement: r
      } = e, {
        mainAxis: s = !0,
        crossAxis: o = !1,
        limiter: a = {
          fn: (m) => {
            let {
              x: y,
              y: I
            } = m;
            return {
              x: y,
              y: I
            };
          }
        },
        ...c
      } = ys(t, e), d = {
        x: n,
        y: i
      }, u = await $l(e, c), h = no(Is(r)), g = US(h);
      let p = d[g], f = d[h];
      if (s) {
        const m = g === "y" ? "top" : "left", y = g === "y" ? "bottom" : "right", I = p + u[m], D = p - u[y];
        p = pI(I, p, D);
      }
      if (o) {
        const m = h === "y" ? "top" : "left", y = h === "y" ? "bottom" : "right", I = f + u[m], D = f - u[y];
        f = pI(I, f, D);
      }
      const M = a.fn({
        ...e,
        [g]: p,
        [h]: f
      });
      return {
        ...M,
        data: {
          x: M.x - n,
          y: M.y - i
        }
      };
    }
  };
}, U_ = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: i,
        placement: r,
        rects: s,
        middlewareData: o
      } = e, {
        offset: a = 0,
        mainAxis: c = !0,
        crossAxis: d = !0
      } = ys(t, e), u = {
        x: n,
        y: i
      }, h = no(r), g = US(h);
      let p = u[g], f = u[h];
      const M = ys(a, e), m = typeof M == "number" ? {
        mainAxis: M,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...M
      };
      if (c) {
        const D = g === "y" ? "height" : "width", j = s.reference[g] - s.floating[D] + m.mainAxis, w = s.reference[g] + s.reference[D] - m.mainAxis;
        p < j ? p = j : p > w && (p = w);
      }
      if (d) {
        var y, I;
        const D = g === "y" ? "width" : "height", j = ["top", "left"].includes(Is(r)), w = s.reference[h] - s.floating[D] + (j && ((y = o.offset) == null ? void 0 : y[h]) || 0) + (j ? 0 : m.crossAxis), A = s.reference[h] + s.reference[D] + (j ? 0 : ((I = o.offset) == null ? void 0 : I[h]) || 0) - (j ? m.crossAxis : 0);
        f < w ? f = w : f > A && (f = A);
      }
      return {
        [g]: p,
        [h]: f
      };
    }
  };
}, R_ = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      const {
        placement: n,
        rects: i,
        platform: r,
        elements: s
      } = e, {
        apply: o = () => {
        },
        ...a
      } = ys(t, e), c = await $l(e, a), d = Is(n), u = vc(n), h = no(n) === "y", {
        width: g,
        height: p
      } = i.floating;
      let f, M;
      d === "top" || d === "bottom" ? (f = d, M = u === (await (r.isRTL == null ? void 0 : r.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (M = d, f = u === "end" ? "top" : "bottom");
      const m = p - c.top - c.bottom, y = g - c.left - c.right, I = Or(p - c[f], m), D = Or(g - c[M], y), j = !e.middlewareData.shift;
      let w = I, A = D;
      if (h ? A = u || j ? Or(D, y) : y : w = u || j ? Or(I, m) : m, j && !u) {
        const T = Ti(c.left, 0), E = Ti(c.right, 0), v = Ti(c.top, 0), P = Ti(c.bottom, 0);
        h ? A = g - 2 * (T !== 0 || E !== 0 ? T + E : Ti(c.left, c.right)) : w = p - 2 * (v !== 0 || P !== 0 ? v + P : Ti(c.top, c.bottom));
      }
      await o({
        ...e,
        availableWidth: A,
        availableHeight: w
      });
      const b = await r.getDimensions(s.floating);
      return g !== b.width || p !== b.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ec(t) {
  return jz(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function zi(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function ws(t) {
  var e;
  return (e = (jz(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function jz(t) {
  return t instanceof Node || t instanceof zi(t).Node;
}
function fr(t) {
  return t instanceof Element || t instanceof zi(t).Element;
}
function Zr(t) {
  return t instanceof HTMLElement || t instanceof zi(t).HTMLElement;
}
function Vw(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof zi(t).ShadowRoot;
}
function kd(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: i,
    display: r
  } = Mr(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && !["inline", "contents"].includes(r);
}
function Y_(t) {
  return ["table", "td", "th"].includes(Ec(t));
}
function $p(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function QS(t) {
  const e = ZS(), n = fr(t) ? Mr(t) : t;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((i) => (n.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (n.contain || "").includes(i));
}
function Q_(t) {
  let e = io(t);
  for (; Zr(e) && !qa(e); ) {
    if (QS(e))
      return e;
    if ($p(e))
      return null;
    e = io(e);
  }
  return null;
}
function ZS() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function qa(t) {
  return ["html", "body", "#document"].includes(Ec(t));
}
function Mr(t) {
  return zi(t).getComputedStyle(t);
}
function ef(t) {
  return fr(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function io(t) {
  if (Ec(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Vw(t) && t.host || // Fallback.
    ws(t)
  );
  return Vw(e) ? e.host : e;
}
function Dz(t) {
  const e = io(t);
  return qa(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Zr(e) && kd(e) ? e : Dz(e);
}
function ed(t, e, n) {
  var i;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = Dz(t), s = r === ((i = t.ownerDocument) == null ? void 0 : i.body), o = zi(r);
  if (s) {
    const a = MI(o);
    return e.concat(o, o.visualViewport || [], kd(r) ? r : [], a && n ? ed(a) : []);
  }
  return e.concat(r, ed(r, [], n));
}
function MI(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function wz(t) {
  const e = Mr(t);
  let n = parseFloat(e.width) || 0, i = parseFloat(e.height) || 0;
  const r = Zr(t), s = r ? t.offsetWidth : n, o = r ? t.offsetHeight : i, a = Rg(n) !== s || Rg(i) !== o;
  return a && (n = s, i = o), {
    width: n,
    height: i,
    $: a
  };
}
function FS(t) {
  return fr(t) ? t : t.contextElement;
}
function Qa(t) {
  const e = FS(t);
  if (!Zr(e))
    return to(1);
  const n = e.getBoundingClientRect(), {
    width: i,
    height: r,
    $: s
  } = wz(e);
  let o = (s ? Rg(n.width) : n.width) / i, a = (s ? Rg(n.height) : n.height) / r;
  return (!o || !Number.isFinite(o)) && (o = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: o,
    y: a
  };
}
const Z_ = /* @__PURE__ */ to(0);
function Nz(t) {
  const e = zi(t);
  return !ZS() || !e.visualViewport ? Z_ : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function F_(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== zi(t) ? !1 : e;
}
function Zo(t, e, n, i) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), s = FS(t);
  let o = to(1);
  e && (i ? fr(i) && (o = Qa(i)) : o = Qa(t));
  const a = F_(s, n, i) ? Nz(s) : to(0);
  let c = (r.left + a.x) / o.x, d = (r.top + a.y) / o.y, u = r.width / o.x, h = r.height / o.y;
  if (s) {
    const g = zi(s), p = i && fr(i) ? zi(i) : i;
    let f = g, M = MI(f);
    for (; M && i && p !== f; ) {
      const m = Qa(M), y = M.getBoundingClientRect(), I = Mr(M), D = y.left + (M.clientLeft + parseFloat(I.paddingLeft)) * m.x, j = y.top + (M.clientTop + parseFloat(I.paddingTop)) * m.y;
      c *= m.x, d *= m.y, u *= m.x, h *= m.y, c += D, d += j, f = zi(M), M = MI(f);
    }
  }
  return Qg({
    width: u,
    height: h,
    x: c,
    y: d
  });
}
function B_(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: i,
    strategy: r
  } = t;
  const s = r === "fixed", o = ws(i), a = e ? $p(e.floating) : !1;
  if (i === o || a && s)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = to(1);
  const u = to(0), h = Zr(i);
  if ((h || !h && !s) && ((Ec(i) !== "body" || kd(o)) && (c = ef(i)), Zr(i))) {
    const g = Zo(i);
    d = Qa(i), u.x = g.x + i.clientLeft, u.y = g.y + i.clientTop;
  }
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - c.scrollLeft * d.x + u.x,
    y: n.y * d.y - c.scrollTop * d.y + u.y
  };
}
function G_(t) {
  return Array.from(t.getClientRects());
}
function Az(t) {
  return Zo(ws(t)).left + ef(t).scrollLeft;
}
function W_(t) {
  const e = ws(t), n = ef(t), i = t.ownerDocument.body, r = Ti(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), s = Ti(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
  let o = -n.scrollLeft + Az(t);
  const a = -n.scrollTop;
  return Mr(i).direction === "rtl" && (o += Ti(e.clientWidth, i.clientWidth) - r), {
    width: r,
    height: s,
    x: o,
    y: a
  };
}
function H_(t, e) {
  const n = zi(t), i = ws(t), r = n.visualViewport;
  let s = i.clientWidth, o = i.clientHeight, a = 0, c = 0;
  if (r) {
    s = r.width, o = r.height;
    const d = ZS();
    (!d || d && e === "fixed") && (a = r.offsetLeft, c = r.offsetTop);
  }
  return {
    width: s,
    height: o,
    x: a,
    y: c
  };
}
function V_(t, e) {
  const n = Zo(t, !0, e === "fixed"), i = n.top + t.clientTop, r = n.left + t.clientLeft, s = Zr(t) ? Qa(t) : to(1), o = t.clientWidth * s.x, a = t.clientHeight * s.y, c = r * s.x, d = i * s.y;
  return {
    width: o,
    height: a,
    x: c,
    y: d
  };
}
function Kw(t, e, n) {
  let i;
  if (e === "viewport")
    i = H_(t, n);
  else if (e === "document")
    i = W_(ws(t));
  else if (fr(e))
    i = V_(e, n);
  else {
    const r = Nz(t);
    i = {
      ...e,
      x: e.x - r.x,
      y: e.y - r.y
    };
  }
  return Qg(i);
}
function Tz(t, e) {
  const n = io(t);
  return n === e || !fr(n) || qa(n) ? !1 : Mr(n).position === "fixed" || Tz(n, e);
}
function K_(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let i = ed(t, [], !1).filter((a) => fr(a) && Ec(a) !== "body"), r = null;
  const s = Mr(t).position === "fixed";
  let o = s ? io(t) : t;
  for (; fr(o) && !qa(o); ) {
    const a = Mr(o), c = QS(o);
    !c && a.position === "fixed" && (r = null), (s ? !c && !r : !c && a.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || kd(o) && !c && Tz(t, o)) ? i = i.filter((u) => u !== o) : r = a, o = io(o);
  }
  return e.set(t, i), i;
}
function X_(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: i,
    strategy: r
  } = t;
  const o = [...n === "clippingAncestors" ? $p(e) ? [] : K_(e, this._c) : [].concat(n), i], a = o[0], c = o.reduce((d, u) => {
    const h = Kw(e, u, r);
    return d.top = Ti(h.top, d.top), d.right = Or(h.right, d.right), d.bottom = Or(h.bottom, d.bottom), d.left = Ti(h.left, d.left), d;
  }, Kw(e, a, r));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function J_(t) {
  const {
    width: e,
    height: n
  } = wz(t);
  return {
    width: e,
    height: n
  };
}
function q_(t, e, n) {
  const i = Zr(e), r = ws(e), s = n === "fixed", o = Zo(t, !0, s, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = to(0);
  if (i || !i && !s)
    if ((Ec(e) !== "body" || kd(r)) && (a = ef(e)), i) {
      const h = Zo(e, !0, s, e);
      c.x = h.x + e.clientLeft, c.y = h.y + e.clientTop;
    } else r && (c.x = Az(r));
  const d = o.left + a.scrollLeft - c.x, u = o.top + a.scrollTop - c.y;
  return {
    x: d,
    y: u,
    width: o.width,
    height: o.height
  };
}
function _M(t) {
  return Mr(t).position === "static";
}
function Xw(t, e) {
  return !Zr(t) || Mr(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function bz(t, e) {
  const n = zi(t);
  if ($p(t))
    return n;
  if (!Zr(t)) {
    let r = io(t);
    for (; r && !qa(r); ) {
      if (fr(r) && !_M(r))
        return r;
      r = io(r);
    }
    return n;
  }
  let i = Xw(t, e);
  for (; i && Y_(i) && _M(i); )
    i = Xw(i, e);
  return i && qa(i) && _M(i) && !QS(i) ? n : i || Q_(t) || n;
}
const __ = async function(t) {
  const e = this.getOffsetParent || bz, n = this.getDimensions, i = await n(t.floating);
  return {
    reference: q_(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: i.width,
      height: i.height
    }
  };
};
function $_(t) {
  return Mr(t).direction === "rtl";
}
const e$ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: B_,
  getDocumentElement: ws,
  getClippingRect: X_,
  getOffsetParent: bz,
  getElementRects: __,
  getClientRects: G_,
  getDimensions: J_,
  getScale: Qa,
  isElement: fr,
  isRTL: $_
};
function t$(t, e) {
  let n = null, i;
  const r = ws(t);
  function s() {
    var a;
    clearTimeout(i), (a = n) == null || a.disconnect(), n = null;
  }
  function o(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), s();
    const {
      left: d,
      top: u,
      width: h,
      height: g
    } = t.getBoundingClientRect();
    if (a || e(), !h || !g)
      return;
    const p = Bu(u), f = Bu(r.clientWidth - (d + h)), M = Bu(r.clientHeight - (u + g)), m = Bu(d), I = {
      rootMargin: -p + "px " + -f + "px " + -M + "px " + -m + "px",
      threshold: Ti(0, Or(1, c)) || 1
    };
    let D = !0;
    function j(w) {
      const A = w[0].intersectionRatio;
      if (A !== c) {
        if (!D)
          return o();
        A ? o(!1, A) : i = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      D = !1;
    }
    try {
      n = new IntersectionObserver(j, {
        ...I,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(j, I);
    }
    n.observe(t);
  }
  return o(!0), s;
}
function n$(t, e, n, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: s = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = i, d = FS(t), u = r || s ? [...d ? ed(d) : [], ...ed(e)] : [];
  u.forEach((y) => {
    r && y.addEventListener("scroll", n, {
      passive: !0
    }), s && y.addEventListener("resize", n);
  });
  const h = d && a ? t$(d, n) : null;
  let g = -1, p = null;
  o && (p = new ResizeObserver((y) => {
    let [I] = y;
    I && I.target === d && p && (p.unobserve(e), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var D;
      (D = p) == null || D.observe(e);
    })), n();
  }), d && !c && p.observe(d), p.observe(e));
  let f, M = c ? Zo(t) : null;
  c && m();
  function m() {
    const y = Zo(t);
    M && (y.x !== M.x || y.y !== M.y || y.width !== M.width || y.height !== M.height) && n(), M = y, f = requestAnimationFrame(m);
  }
  return n(), () => {
    var y;
    u.forEach((I) => {
      r && I.removeEventListener("scroll", n), s && I.removeEventListener("resize", n);
    }), h == null || h(), (y = p) == null || y.disconnect(), p = null, c && cancelAnimationFrame(f);
  };
}
const i$ = O_, r$ = P_, s$ = z_, o$ = R_, a$ = L_, Jw = C_, c$ = U_, l$ = (t, e, n) => {
  const i = /* @__PURE__ */ new Map(), r = {
    platform: e$,
    ...n
  }, s = {
    ...r.platform,
    _c: i
  };
  return E_(t, e, {
    ...r,
    platform: s
  });
};
var Ah = typeof document < "u" ? at : ze;
function Zg(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, i, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (i = n; i-- !== 0; )
        if (!Zg(t[i], e[i]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (i = n; i-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[i]))
        return !1;
    for (i = n; i-- !== 0; ) {
      const s = r[i];
      if (!(s === "_owner" && t.$$typeof) && !Zg(t[s], e[s]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function vz(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function qw(t, e) {
  const n = vz(t);
  return Math.round(e * n) / n;
}
function _w(t) {
  const e = N.useRef(t);
  return Ah(() => {
    e.current = t;
  }), e;
}
function d$(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: i = [],
    platform: r,
    elements: {
      reference: s,
      floating: o
    } = {},
    transform: a = !0,
    whileElementsMounted: c,
    open: d
  } = t, [u, h] = N.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [g, p] = N.useState(i);
  Zg(g, i) || p(i);
  const [f, M] = N.useState(null), [m, y] = N.useState(null), I = N.useCallback((F) => {
    F !== A.current && (A.current = F, M(F));
  }, []), D = N.useCallback((F) => {
    F !== b.current && (b.current = F, y(F));
  }, []), j = s || f, w = o || m, A = N.useRef(null), b = N.useRef(null), T = N.useRef(u), E = c != null, v = _w(c), P = _w(r), C = N.useCallback(() => {
    if (!A.current || !b.current)
      return;
    const F = {
      placement: e,
      strategy: n,
      middleware: g
    };
    P.current && (F.platform = P.current), l$(A.current, b.current, F).then((H) => {
      const Z = {
        ...H,
        isPositioned: !0
      };
      z.current && !Zg(T.current, Z) && (T.current = Z, op.flushSync(() => {
        h(Z);
      }));
    });
  }, [g, e, n, P]);
  Ah(() => {
    d === !1 && T.current.isPositioned && (T.current.isPositioned = !1, h((F) => ({
      ...F,
      isPositioned: !1
    })));
  }, [d]);
  const z = N.useRef(!1);
  Ah(() => (z.current = !0, () => {
    z.current = !1;
  }), []), Ah(() => {
    if (j && (A.current = j), w && (b.current = w), j && w) {
      if (v.current)
        return v.current(j, w, C);
      C();
    }
  }, [j, w, C, v, E]);
  const O = N.useMemo(() => ({
    reference: A,
    floating: b,
    setReference: I,
    setFloating: D
  }), [I, D]), R = N.useMemo(() => ({
    reference: j,
    floating: w
  }), [j, w]), U = N.useMemo(() => {
    const F = {
      position: n,
      left: 0,
      top: 0
    };
    if (!R.floating)
      return F;
    const H = qw(R.floating, u.x), Z = qw(R.floating, u.y);
    return a ? {
      ...F,
      transform: "translate(" + H + "px, " + Z + "px)",
      ...vz(R.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: H,
      top: Z
    };
  }, [n, a, R.floating, u.x, u.y]);
  return N.useMemo(() => ({
    ...u,
    update: C,
    refs: O,
    elements: R,
    floatingStyles: U
  }), [u, C, O, R, U]);
}
const u$ = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: i,
        padding: r
      } = typeof t == "function" ? t(n) : t;
      return i && e(i) ? i.current != null ? Jw({
        element: i.current,
        padding: r
      }).fn(n) : {} : i ? Jw({
        element: i,
        padding: r
      }).fn(n) : {};
    }
  };
}, h$ = (t, e) => ({
  ...i$(t),
  options: [t, e]
}), g$ = (t, e) => ({
  ...r$(t),
  options: [t, e]
}), p$ = (t, e) => ({
  ...c$(t),
  options: [t, e]
}), f$ = (t, e) => ({
  ...s$(t),
  options: [t, e]
}), M$ = (t, e) => ({
  ...o$(t),
  options: [t, e]
}), m$ = (t, e) => ({
  ...a$(t),
  options: [t, e]
}), y$ = (t, e) => ({
  ...u$(t),
  options: [t, e]
});
var I$ = "Arrow", Ez = N.forwardRef((t, e) => {
  const { children: n, width: i = 10, height: r = 5, ...s } = t;
  return /* @__PURE__ */ l.jsx(
    Fe.svg,
    {
      ...s,
      ref: e,
      width: i,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? n : /* @__PURE__ */ l.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Ez.displayName = I$;
var x$ = Ez;
function Cz(t) {
  const [e, n] = N.useState(void 0);
  return pr(() => {
    if (t) {
      n({ width: t.offsetWidth, height: t.offsetHeight });
      const i = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const s = r[0];
        let o, a;
        if ("borderBoxSize" in s) {
          const c = s.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          o = d.inlineSize, a = d.blockSize;
        } else
          o = t.offsetWidth, a = t.offsetHeight;
        n({ width: o, height: a });
      });
      return i.observe(t, { box: "border-box" }), () => i.unobserve(t);
    } else
      n(void 0);
  }, [t]), e;
}
var BS = "Popper", [zz, Cc] = bd(BS), [S$, Lz] = zz(BS), kz = (t) => {
  const { __scopePopper: e, children: n } = t, [i, r] = N.useState(null);
  return /* @__PURE__ */ l.jsx(S$, { scope: e, anchor: i, onAnchorChange: r, children: n });
};
kz.displayName = BS;
var Oz = "PopperAnchor", Pz = N.forwardRef(
  (t, e) => {
    const { __scopePopper: n, virtualRef: i, ...r } = t, s = Lz(Oz, n), o = N.useRef(null), a = it(e, o);
    return N.useEffect(() => {
      s.onAnchorChange((i == null ? void 0 : i.current) || o.current);
    }), i ? null : /* @__PURE__ */ l.jsx(Fe.div, { ...r, ref: a });
  }
);
Pz.displayName = Oz;
var GS = "PopperContent", [j$, D$] = zz(GS), Uz = N.forwardRef(
  (t, e) => {
    var ge, Re, ye, Be, We, lt;
    const {
      __scopePopper: n,
      side: i = "bottom",
      sideOffset: r = 0,
      align: s = "center",
      alignOffset: o = 0,
      arrowPadding: a = 0,
      avoidCollisions: c = !0,
      collisionBoundary: d = [],
      collisionPadding: u = 0,
      sticky: h = "partial",
      hideWhenDetached: g = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: f,
      ...M
    } = t, m = Lz(GS, n), [y, I] = N.useState(null), D = it(e, ($) => I($)), [j, w] = N.useState(null), A = Cz(j), b = (A == null ? void 0 : A.width) ?? 0, T = (A == null ? void 0 : A.height) ?? 0, E = i + (s !== "center" ? "-" + s : ""), v = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, P = Array.isArray(d) ? d : [d], C = P.length > 0, z = {
      padding: v,
      boundary: P.filter(N$),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: C
    }, { refs: O, floatingStyles: R, placement: U, isPositioned: F, middlewareData: H } = d$({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: E,
      whileElementsMounted: (...$) => n$(...$, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: m.anchor
      },
      middleware: [
        h$({ mainAxis: r + T, alignmentAxis: o }),
        c && g$({
          mainAxis: !0,
          crossAxis: !1,
          limiter: h === "partial" ? p$() : void 0,
          ...z
        }),
        c && f$({ ...z }),
        M$({
          ...z,
          apply: ({ elements: $, rects: X, availableWidth: Ie, availableHeight: je }) => {
            const { width: Oe, height: zt } = X.reference, Dt = $.floating.style;
            Dt.setProperty("--radix-popper-available-width", `${Ie}px`), Dt.setProperty("--radix-popper-available-height", `${je}px`), Dt.setProperty("--radix-popper-anchor-width", `${Oe}px`), Dt.setProperty("--radix-popper-anchor-height", `${zt}px`);
          }
        }),
        j && y$({ element: j, padding: a }),
        A$({ arrowWidth: b, arrowHeight: T }),
        g && m$({ strategy: "referenceHidden", ...z })
      ]
    }), [Z, te] = Qz(U), oe = Bt(f);
    pr(() => {
      F && (oe == null || oe());
    }, [F, oe]);
    const me = (ge = H.arrow) == null ? void 0 : ge.x, he = (Re = H.arrow) == null ? void 0 : Re.y, ve = ((ye = H.arrow) == null ? void 0 : ye.centerOffset) !== 0, [ie, Ue] = N.useState();
    return pr(() => {
      y && Ue(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: O.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...R,
          transform: F ? R.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ie,
          "--radix-popper-transform-origin": [
            (Be = H.transformOrigin) == null ? void 0 : Be.x,
            (We = H.transformOrigin) == null ? void 0 : We.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((lt = H.hide) == null ? void 0 : lt.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ l.jsx(
          j$,
          {
            scope: n,
            placedSide: Z,
            onArrowChange: w,
            arrowX: me,
            arrowY: he,
            shouldHideArrow: ve,
            children: /* @__PURE__ */ l.jsx(
              Fe.div,
              {
                "data-side": Z,
                "data-align": te,
                ...M,
                ref: D,
                style: {
                  ...M.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: F ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Uz.displayName = GS;
var Rz = "PopperArrow", w$ = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Yz = N.forwardRef(function(e, n) {
  const { __scopePopper: i, ...r } = e, s = D$(Rz, i), o = w$[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ l.jsx(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [o]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ l.jsx(
          x$,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Yz.displayName = Rz;
function N$(t) {
  return t !== null;
}
var A$ = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var m, y, I;
    const { placement: n, rects: i, middlewareData: r } = e, o = ((m = r.arrow) == null ? void 0 : m.centerOffset) !== 0, a = o ? 0 : t.arrowWidth, c = o ? 0 : t.arrowHeight, [d, u] = Qz(n), h = { start: "0%", center: "50%", end: "100%" }[u], g = (((y = r.arrow) == null ? void 0 : y.x) ?? 0) + a / 2, p = (((I = r.arrow) == null ? void 0 : I.y) ?? 0) + c / 2;
    let f = "", M = "";
    return d === "bottom" ? (f = o ? h : `${g}px`, M = `${-c}px`) : d === "top" ? (f = o ? h : `${g}px`, M = `${i.floating.height + c}px`) : d === "right" ? (f = `${-c}px`, M = o ? h : `${p}px`) : d === "left" && (f = `${i.floating.width + c}px`, M = o ? h : `${p}px`), { data: { x: f, y: M } };
  }
});
function Qz(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
var Od = kz, tf = Pz, WS = Uz, HS = Yz, $M = "rovingFocusGroup.onEntryFocus", T$ = { bubbles: !1, cancelable: !0 }, nf = "RovingFocusGroup", [mI, Zz, b$] = vd(nf), [v$, rf] = bd(
  nf,
  [b$]
), [E$, C$] = v$(nf), Fz = N.forwardRef(
  (t, e) => /* @__PURE__ */ l.jsx(mI.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ l.jsx(mI.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ l.jsx(z$, { ...t, ref: e }) }) })
);
Fz.displayName = nf;
var z$ = N.forwardRef((t, e) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: i,
    loop: r = !1,
    dir: s,
    currentTabStopId: o,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: c,
    onEntryFocus: d,
    preventScrollOnEntryFocus: u = !1,
    ...h
  } = t, g = N.useRef(null), p = it(e, g), f = _p(s), [M = null, m] = go({
    prop: o,
    defaultProp: a,
    onChange: c
  }), [y, I] = N.useState(!1), D = Bt(d), j = Zz(n), w = N.useRef(!1), [A, b] = N.useState(0);
  return N.useEffect(() => {
    const T = g.current;
    if (T)
      return T.addEventListener($M, D), () => T.removeEventListener($M, D);
  }, [D]), /* @__PURE__ */ l.jsx(
    E$,
    {
      scope: n,
      orientation: i,
      dir: f,
      loop: r,
      currentTabStopId: M,
      onItemFocus: N.useCallback(
        (T) => m(T),
        [m]
      ),
      onItemShiftTab: N.useCallback(() => I(!0), []),
      onFocusableItemAdd: N.useCallback(
        () => b((T) => T + 1),
        []
      ),
      onFocusableItemRemove: N.useCallback(
        () => b((T) => T - 1),
        []
      ),
      children: /* @__PURE__ */ l.jsx(
        Fe.div,
        {
          tabIndex: y || A === 0 ? -1 : 0,
          "data-orientation": i,
          ...h,
          ref: p,
          style: { outline: "none", ...t.style },
          onMouseDown: se(t.onMouseDown, () => {
            w.current = !0;
          }),
          onFocus: se(t.onFocus, (T) => {
            const E = !w.current;
            if (T.target === T.currentTarget && E && !y) {
              const v = new CustomEvent($M, T$);
              if (T.currentTarget.dispatchEvent(v), !v.defaultPrevented) {
                const P = j().filter((U) => U.focusable), C = P.find((U) => U.active), z = P.find((U) => U.id === M), R = [C, z, ...P].filter(
                  Boolean
                ).map((U) => U.ref.current);
                Wz(R, u);
              }
            }
            w.current = !1;
          }),
          onBlur: se(t.onBlur, () => I(!1))
        }
      )
    }
  );
}), Bz = "RovingFocusGroupItem", Gz = N.forwardRef(
  (t, e) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: i = !0,
      active: r = !1,
      tabStopId: s,
      ...o
    } = t, a = dr(), c = s || a, d = C$(Bz, n), u = d.currentTabStopId === c, h = Zz(n), { onFocusableItemAdd: g, onFocusableItemRemove: p } = d;
    return N.useEffect(() => {
      if (i)
        return g(), () => p();
    }, [i, g, p]), /* @__PURE__ */ l.jsx(
      mI.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: i,
        active: r,
        children: /* @__PURE__ */ l.jsx(
          Fe.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": d.orientation,
            ...o,
            ref: e,
            onMouseDown: se(t.onMouseDown, (f) => {
              i ? d.onItemFocus(c) : f.preventDefault();
            }),
            onFocus: se(t.onFocus, () => d.onItemFocus(c)),
            onKeyDown: se(t.onKeyDown, (f) => {
              if (f.key === "Tab" && f.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (f.target !== f.currentTarget) return;
              const M = O$(f, d.orientation, d.dir);
              if (M !== void 0) {
                if (f.metaKey || f.ctrlKey || f.altKey || f.shiftKey) return;
                f.preventDefault();
                let y = h().filter((I) => I.focusable).map((I) => I.ref.current);
                if (M === "last") y.reverse();
                else if (M === "prev" || M === "next") {
                  M === "prev" && y.reverse();
                  const I = y.indexOf(f.currentTarget);
                  y = d.loop ? P$(y, I + 1) : y.slice(I + 1);
                }
                setTimeout(() => Wz(y));
              }
            })
          }
        )
      }
    );
  }
);
Gz.displayName = Bz;
var L$ = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function k$(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function O$(t, e, n) {
  const i = k$(t.key, n);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(i)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(i)))
    return L$[i];
}
function Wz(t, e = !1) {
  const n = document.activeElement;
  for (const i of t)
    if (i === n || (i.focus({ preventScroll: e }), document.activeElement !== n)) return;
}
function P$(t, e) {
  return t.map((n, i) => t[(e + i) % t.length]);
}
var Hz = Fz, Vz = Gz, yI = ["Enter", " "], U$ = ["ArrowDown", "PageUp", "Home"], Kz = ["ArrowUp", "PageDown", "End"], R$ = [...U$, ...Kz], Y$ = {
  ltr: [...yI, "ArrowRight"],
  rtl: [...yI, "ArrowLeft"]
}, Q$ = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Pd = "Menu", [td, Z$, F$] = vd(Pd), [Jo, Xz] = bc(Pd, [
  F$,
  Cc,
  rf
]), Ud = Cc(), Jz = rf(), [qz, fo] = Jo(Pd), [B$, Rd] = Jo(Pd), _z = (t) => {
  const { __scopeMenu: e, open: n = !1, children: i, dir: r, onOpenChange: s, modal: o = !0 } = t, a = Ud(e), [c, d] = N.useState(null), u = N.useRef(!1), h = Bt(s), g = _p(r);
  return N.useEffect(() => {
    const p = () => {
      u.current = !0, document.addEventListener("pointerdown", f, { capture: !0, once: !0 }), document.addEventListener("pointermove", f, { capture: !0, once: !0 });
    }, f = () => u.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", f, { capture: !0 }), document.removeEventListener("pointermove", f, { capture: !0 });
    };
  }, []), /* @__PURE__ */ l.jsx(Od, { ...a, children: /* @__PURE__ */ l.jsx(
    qz,
    {
      scope: e,
      open: n,
      onOpenChange: h,
      content: c,
      onContentChange: d,
      children: /* @__PURE__ */ l.jsx(
        B$,
        {
          scope: e,
          onClose: N.useCallback(() => h(!1), [h]),
          isUsingKeyboardRef: u,
          dir: g,
          modal: o,
          children: i
        }
      )
    }
  ) });
};
_z.displayName = Pd;
var G$ = "MenuAnchor", VS = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t, r = Ud(n);
    return /* @__PURE__ */ l.jsx(tf, { ...r, ...i, ref: e });
  }
);
VS.displayName = G$;
var KS = "MenuPortal", [W$, $z] = Jo(KS, {
  forceMount: void 0
}), eL = (t) => {
  const { __scopeMenu: e, forceMount: n, children: i, container: r } = t, s = fo(KS, e);
  return /* @__PURE__ */ l.jsx(W$, { scope: e, forceMount: n, children: /* @__PURE__ */ l.jsx(jr, { present: n || s.open, children: /* @__PURE__ */ l.jsx(Td, { asChild: !0, container: r, children: i }) }) });
};
eL.displayName = KS;
var Hi = "MenuContent", [H$, XS] = Jo(Hi), tL = N.forwardRef(
  (t, e) => {
    const n = $z(Hi, t.__scopeMenu), { forceMount: i = n.forceMount, ...r } = t, s = fo(Hi, t.__scopeMenu), o = Rd(Hi, t.__scopeMenu);
    return /* @__PURE__ */ l.jsx(td.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ l.jsx(jr, { present: i || s.open, children: /* @__PURE__ */ l.jsx(td.Slot, { scope: t.__scopeMenu, children: o.modal ? /* @__PURE__ */ l.jsx(V$, { ...r, ref: e }) : /* @__PURE__ */ l.jsx(K$, { ...r, ref: e }) }) }) });
  }
), V$ = N.forwardRef(
  (t, e) => {
    const n = fo(Hi, t.__scopeMenu), i = N.useRef(null), r = it(e, i);
    return N.useEffect(() => {
      const s = i.current;
      if (s) return Wp(s);
    }, []), /* @__PURE__ */ l.jsx(
      JS,
      {
        ...t,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: se(
          t.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), K$ = N.forwardRef((t, e) => {
  const n = fo(Hi, t.__scopeMenu);
  return /* @__PURE__ */ l.jsx(
    JS,
    {
      ...t,
      ref: e,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), JS = N.forwardRef(
  (t, e) => {
    const {
      __scopeMenu: n,
      loop: i = !1,
      trapFocus: r,
      onOpenAutoFocus: s,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: a,
      onEntryFocus: c,
      onEscapeKeyDown: d,
      onPointerDownOutside: u,
      onFocusOutside: h,
      onInteractOutside: g,
      onDismiss: p,
      disableOutsideScroll: f,
      ...M
    } = t, m = fo(Hi, n), y = Rd(Hi, n), I = Ud(n), D = Jz(n), j = Z$(n), [w, A] = N.useState(null), b = N.useRef(null), T = it(e, b, m.onContentChange), E = N.useRef(0), v = N.useRef(""), P = N.useRef(0), C = N.useRef(null), z = N.useRef("right"), O = N.useRef(0), R = f ? Gp : N.Fragment, U = f ? { as: eo, allowPinchZoom: !0 } : void 0, F = (Z) => {
      var ge, Re;
      const te = v.current + Z, oe = j().filter((ye) => !ye.disabled), me = document.activeElement, he = (ge = oe.find((ye) => ye.ref.current === me)) == null ? void 0 : ge.textValue, ve = oe.map((ye) => ye.textValue), ie = oee(ve, te, he), Ue = (Re = oe.find((ye) => ye.textValue === ie)) == null ? void 0 : Re.ref.current;
      (function ye(Be) {
        v.current = Be, window.clearTimeout(E.current), Be !== "" && (E.current = window.setTimeout(() => ye(""), 1e3));
      })(te), Ue && setTimeout(() => Ue.focus());
    };
    N.useEffect(() => () => window.clearTimeout(E.current), []), jS();
    const H = N.useCallback((Z) => {
      var oe, me;
      return z.current === ((oe = C.current) == null ? void 0 : oe.side) && cee(Z, (me = C.current) == null ? void 0 : me.area);
    }, []);
    return /* @__PURE__ */ l.jsx(
      H$,
      {
        scope: n,
        searchRef: v,
        onItemEnter: N.useCallback(
          (Z) => {
            H(Z) && Z.preventDefault();
          },
          [H]
        ),
        onItemLeave: N.useCallback(
          (Z) => {
            var te;
            H(Z) || ((te = b.current) == null || te.focus(), A(null));
          },
          [H]
        ),
        onTriggerLeave: N.useCallback(
          (Z) => {
            H(Z) && Z.preventDefault();
          },
          [H]
        ),
        pointerGraceTimerRef: P,
        onPointerGraceIntentChange: N.useCallback((Z) => {
          C.current = Z;
        }, []),
        children: /* @__PURE__ */ l.jsx(R, { ...U, children: /* @__PURE__ */ l.jsx(
          Ad,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: se(s, (Z) => {
              var te;
              Z.preventDefault(), (te = b.current) == null || te.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: o,
            children: /* @__PURE__ */ l.jsx(
              Nd,
              {
                asChild: !0,
                disableOutsidePointerEvents: a,
                onEscapeKeyDown: d,
                onPointerDownOutside: u,
                onFocusOutside: h,
                onInteractOutside: g,
                onDismiss: p,
                children: /* @__PURE__ */ l.jsx(
                  Hz,
                  {
                    asChild: !0,
                    ...D,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: i,
                    currentTabStopId: w,
                    onCurrentTabStopIdChange: A,
                    onEntryFocus: se(c, (Z) => {
                      y.isUsingKeyboardRef.current || Z.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ l.jsx(
                      WS,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": yL(m.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...I,
                        ...M,
                        ref: T,
                        style: { outline: "none", ...M.style },
                        onKeyDown: se(M.onKeyDown, (Z) => {
                          const oe = Z.target.closest("[data-radix-menu-content]") === Z.currentTarget, me = Z.ctrlKey || Z.altKey || Z.metaKey, he = Z.key.length === 1;
                          oe && (Z.key === "Tab" && Z.preventDefault(), !me && he && F(Z.key));
                          const ve = b.current;
                          if (Z.target !== ve || !R$.includes(Z.key)) return;
                          Z.preventDefault();
                          const Ue = j().filter((ge) => !ge.disabled).map((ge) => ge.ref.current);
                          Kz.includes(Z.key) && Ue.reverse(), ree(Ue);
                        }),
                        onBlur: se(t.onBlur, (Z) => {
                          Z.currentTarget.contains(Z.target) || (window.clearTimeout(E.current), v.current = "");
                        }),
                        onPointerMove: se(
                          t.onPointerMove,
                          nd((Z) => {
                            const te = Z.target, oe = O.current !== Z.clientX;
                            if (Z.currentTarget.contains(te) && oe) {
                              const me = Z.clientX > O.current ? "right" : "left";
                              z.current = me, O.current = Z.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
tL.displayName = Hi;
var X$ = "MenuGroup", qS = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t;
    return /* @__PURE__ */ l.jsx(Fe.div, { role: "group", ...i, ref: e });
  }
);
qS.displayName = X$;
var J$ = "MenuLabel", nL = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t;
    return /* @__PURE__ */ l.jsx(Fe.div, { ...i, ref: e });
  }
);
nL.displayName = J$;
var Fg = "MenuItem", $w = "menu.itemSelect", sf = N.forwardRef(
  (t, e) => {
    const { disabled: n = !1, onSelect: i, ...r } = t, s = N.useRef(null), o = Rd(Fg, t.__scopeMenu), a = XS(Fg, t.__scopeMenu), c = it(e, s), d = N.useRef(!1), u = () => {
      const h = s.current;
      if (!n && h) {
        const g = new CustomEvent($w, { bubbles: !0, cancelable: !0 });
        h.addEventListener($w, (p) => i == null ? void 0 : i(p), { once: !0 }), wd(h, g), g.defaultPrevented ? d.current = !1 : o.onClose();
      }
    };
    return /* @__PURE__ */ l.jsx(
      iL,
      {
        ...r,
        ref: c,
        disabled: n,
        onClick: se(t.onClick, u),
        onPointerDown: (h) => {
          var g;
          (g = t.onPointerDown) == null || g.call(t, h), d.current = !0;
        },
        onPointerUp: se(t.onPointerUp, (h) => {
          var g;
          d.current || (g = h.currentTarget) == null || g.click();
        }),
        onKeyDown: se(t.onKeyDown, (h) => {
          const g = a.searchRef.current !== "";
          n || g && h.key === " " || yI.includes(h.key) && (h.currentTarget.click(), h.preventDefault());
        })
      }
    );
  }
);
sf.displayName = Fg;
var iL = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, disabled: i = !1, textValue: r, ...s } = t, o = XS(Fg, n), a = Jz(n), c = N.useRef(null), d = it(e, c), [u, h] = N.useState(!1), [g, p] = N.useState("");
    return N.useEffect(() => {
      const f = c.current;
      f && p((f.textContent ?? "").trim());
    }, [s.children]), /* @__PURE__ */ l.jsx(
      td.ItemSlot,
      {
        scope: n,
        disabled: i,
        textValue: r ?? g,
        children: /* @__PURE__ */ l.jsx(Vz, { asChild: !0, ...a, focusable: !i, children: /* @__PURE__ */ l.jsx(
          Fe.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": i || void 0,
            "data-disabled": i ? "" : void 0,
            ...s,
            ref: d,
            onPointerMove: se(
              t.onPointerMove,
              nd((f) => {
                i ? o.onItemLeave(f) : (o.onItemEnter(f), f.defaultPrevented || f.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: se(
              t.onPointerLeave,
              nd((f) => o.onItemLeave(f))
            ),
            onFocus: se(t.onFocus, () => h(!0)),
            onBlur: se(t.onBlur, () => h(!1))
          }
        ) })
      }
    );
  }
), q$ = "MenuCheckboxItem", rL = N.forwardRef(
  (t, e) => {
    const { checked: n = !1, onCheckedChange: i, ...r } = t;
    return /* @__PURE__ */ l.jsx(lL, { scope: t.__scopeMenu, checked: n, children: /* @__PURE__ */ l.jsx(
      sf,
      {
        role: "menuitemcheckbox",
        "aria-checked": Bg(n) ? "mixed" : n,
        ...r,
        ref: e,
        "data-state": ej(n),
        onSelect: se(
          r.onSelect,
          () => i == null ? void 0 : i(Bg(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
rL.displayName = q$;
var sL = "MenuRadioGroup", [_$, $$] = Jo(
  sL,
  { value: void 0, onValueChange: () => {
  } }
), oL = N.forwardRef(
  (t, e) => {
    const { value: n, onValueChange: i, ...r } = t, s = Bt(i);
    return /* @__PURE__ */ l.jsx(_$, { scope: t.__scopeMenu, value: n, onValueChange: s, children: /* @__PURE__ */ l.jsx(qS, { ...r, ref: e }) });
  }
);
oL.displayName = sL;
var aL = "MenuRadioItem", cL = N.forwardRef(
  (t, e) => {
    const { value: n, ...i } = t, r = $$(aL, t.__scopeMenu), s = n === r.value;
    return /* @__PURE__ */ l.jsx(lL, { scope: t.__scopeMenu, checked: s, children: /* @__PURE__ */ l.jsx(
      sf,
      {
        role: "menuitemradio",
        "aria-checked": s,
        ...i,
        ref: e,
        "data-state": ej(s),
        onSelect: se(
          i.onSelect,
          () => {
            var o;
            return (o = r.onValueChange) == null ? void 0 : o.call(r, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
cL.displayName = aL;
var _S = "MenuItemIndicator", [lL, eee] = Jo(
  _S,
  { checked: !1 }
), dL = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, forceMount: i, ...r } = t, s = eee(_S, n);
    return /* @__PURE__ */ l.jsx(
      jr,
      {
        present: i || Bg(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ l.jsx(
          Fe.span,
          {
            ...r,
            ref: e,
            "data-state": ej(s.checked)
          }
        )
      }
    );
  }
);
dL.displayName = _S;
var tee = "MenuSeparator", uL = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t;
    return /* @__PURE__ */ l.jsx(
      Fe.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...i,
        ref: e
      }
    );
  }
);
uL.displayName = tee;
var nee = "MenuArrow", hL = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t, r = Ud(n);
    return /* @__PURE__ */ l.jsx(HS, { ...r, ...i, ref: e });
  }
);
hL.displayName = nee;
var $S = "MenuSub", [iee, gL] = Jo($S), pL = (t) => {
  const { __scopeMenu: e, children: n, open: i = !1, onOpenChange: r } = t, s = fo($S, e), o = Ud(e), [a, c] = N.useState(null), [d, u] = N.useState(null), h = Bt(r);
  return N.useEffect(() => (s.open === !1 && h(!1), () => h(!1)), [s.open, h]), /* @__PURE__ */ l.jsx(Od, { ...o, children: /* @__PURE__ */ l.jsx(
    qz,
    {
      scope: e,
      open: i,
      onOpenChange: h,
      content: d,
      onContentChange: u,
      children: /* @__PURE__ */ l.jsx(
        iee,
        {
          scope: e,
          contentId: dr(),
          triggerId: dr(),
          trigger: a,
          onTriggerChange: c,
          children: n
        }
      )
    }
  ) });
};
pL.displayName = $S;
var wl = "MenuSubTrigger", fL = N.forwardRef(
  (t, e) => {
    const n = fo(wl, t.__scopeMenu), i = Rd(wl, t.__scopeMenu), r = gL(wl, t.__scopeMenu), s = XS(wl, t.__scopeMenu), o = N.useRef(null), { pointerGraceTimerRef: a, onPointerGraceIntentChange: c } = s, d = { __scopeMenu: t.__scopeMenu }, u = N.useCallback(() => {
      o.current && window.clearTimeout(o.current), o.current = null;
    }, []);
    return N.useEffect(() => u, [u]), N.useEffect(() => {
      const h = a.current;
      return () => {
        window.clearTimeout(h), c(null);
      };
    }, [a, c]), /* @__PURE__ */ l.jsx(VS, { asChild: !0, ...d, children: /* @__PURE__ */ l.jsx(
      iL,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": yL(n.open),
        ...t,
        ref: Dd(e, r.onTriggerChange),
        onClick: (h) => {
          var g;
          (g = t.onClick) == null || g.call(t, h), !(t.disabled || h.defaultPrevented) && (h.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: se(
          t.onPointerMove,
          nd((h) => {
            s.onItemEnter(h), !h.defaultPrevented && !t.disabled && !n.open && !o.current && (s.onPointerGraceIntentChange(null), o.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: se(
          t.onPointerLeave,
          nd((h) => {
            var p, f;
            u();
            const g = (p = n.content) == null ? void 0 : p.getBoundingClientRect();
            if (g) {
              const M = (f = n.content) == null ? void 0 : f.dataset.side, m = M === "right", y = m ? -5 : 5, I = g[m ? "left" : "right"], D = g[m ? "right" : "left"];
              s.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: h.clientX + y, y: h.clientY },
                  { x: I, y: g.top },
                  { x: D, y: g.top },
                  { x: D, y: g.bottom },
                  { x: I, y: g.bottom }
                ],
                side: M
              }), window.clearTimeout(a.current), a.current = window.setTimeout(
                () => s.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (s.onTriggerLeave(h), h.defaultPrevented) return;
              s.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: se(t.onKeyDown, (h) => {
          var p;
          const g = s.searchRef.current !== "";
          t.disabled || g && h.key === " " || Y$[i.dir].includes(h.key) && (n.onOpenChange(!0), (p = n.content) == null || p.focus(), h.preventDefault());
        })
      }
    ) });
  }
);
fL.displayName = wl;
var ML = "MenuSubContent", mL = N.forwardRef(
  (t, e) => {
    const n = $z(Hi, t.__scopeMenu), { forceMount: i = n.forceMount, ...r } = t, s = fo(Hi, t.__scopeMenu), o = Rd(Hi, t.__scopeMenu), a = gL(ML, t.__scopeMenu), c = N.useRef(null), d = it(e, c);
    return /* @__PURE__ */ l.jsx(td.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ l.jsx(jr, { present: i || s.open, children: /* @__PURE__ */ l.jsx(td.Slot, { scope: t.__scopeMenu, children: /* @__PURE__ */ l.jsx(
      JS,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...r,
        ref: d,
        align: "start",
        side: o.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var h;
          o.isUsingKeyboardRef.current && ((h = c.current) == null || h.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: se(t.onFocusOutside, (u) => {
          u.target !== a.trigger && s.onOpenChange(!1);
        }),
        onEscapeKeyDown: se(t.onEscapeKeyDown, (u) => {
          o.onClose(), u.preventDefault();
        }),
        onKeyDown: se(t.onKeyDown, (u) => {
          var p;
          const h = u.currentTarget.contains(u.target), g = Q$[o.dir].includes(u.key);
          h && g && (s.onOpenChange(!1), (p = a.trigger) == null || p.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
mL.displayName = ML;
function yL(t) {
  return t ? "open" : "closed";
}
function Bg(t) {
  return t === "indeterminate";
}
function ej(t) {
  return Bg(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
function ree(t) {
  const e = document.activeElement;
  for (const n of t)
    if (n === e || (n.focus(), document.activeElement !== e)) return;
}
function see(t, e) {
  return t.map((n, i) => t[(e + i) % t.length]);
}
function oee(t, e, n) {
  const r = e.length > 1 && Array.from(e).every((d) => d === e[0]) ? e[0] : e, s = n ? t.indexOf(n) : -1;
  let o = see(t, Math.max(s, 0));
  r.length === 1 && (o = o.filter((d) => d !== n));
  const c = o.find(
    (d) => d.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function aee(t, e) {
  const { x: n, y: i } = t;
  let r = !1;
  for (let s = 0, o = e.length - 1; s < e.length; o = s++) {
    const a = e[s].x, c = e[s].y, d = e[o].x, u = e[o].y;
    c > i != u > i && n < (d - a) * (i - c) / (u - c) + a && (r = !r);
  }
  return r;
}
function cee(t, e) {
  if (!e) return !1;
  const n = { x: t.clientX, y: t.clientY };
  return aee(n, e);
}
function nd(t) {
  return (e) => e.pointerType === "mouse" ? t(e) : void 0;
}
var lee = _z, dee = VS, uee = eL, hee = tL, gee = qS, pee = nL, fee = sf, Mee = rL, mee = oL, yee = cL, Iee = dL, xee = uL, See = hL, jee = pL, Dee = fL, wee = mL, tj = "ContextMenu", [Nee, Wme] = bc(tj, [
  Xz
]), On = Xz(), [Aee, IL] = Nee(tj), xL = (t) => {
  const { __scopeContextMenu: e, children: n, onOpenChange: i, dir: r, modal: s = !0 } = t, [o, a] = N.useState(!1), c = On(e), d = Bt(i), u = N.useCallback(
    (h) => {
      a(h), d(h);
    },
    [d]
  );
  return /* @__PURE__ */ l.jsx(
    Aee,
    {
      scope: e,
      open: o,
      onOpenChange: u,
      modal: s,
      children: /* @__PURE__ */ l.jsx(
        lee,
        {
          ...c,
          dir: r,
          open: o,
          onOpenChange: u,
          modal: s,
          children: n
        }
      )
    }
  );
};
xL.displayName = tj;
var SL = "ContextMenuTrigger", jL = N.forwardRef(
  (t, e) => {
    const { __scopeContextMenu: n, disabled: i = !1, ...r } = t, s = IL(SL, n), o = On(n), a = N.useRef({ x: 0, y: 0 }), c = N.useRef({
      getBoundingClientRect: () => DOMRect.fromRect({ width: 0, height: 0, ...a.current })
    }), d = N.useRef(0), u = N.useCallback(
      () => window.clearTimeout(d.current),
      []
    ), h = (g) => {
      a.current = { x: g.clientX, y: g.clientY }, s.onOpenChange(!0);
    };
    return N.useEffect(() => u, [u]), N.useEffect(() => void (i && u()), [i, u]), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(dee, { ...o, virtualRef: c }),
      /* @__PURE__ */ l.jsx(
        Fe.span,
        {
          "data-state": s.open ? "open" : "closed",
          "data-disabled": i ? "" : void 0,
          ...r,
          ref: e,
          style: { WebkitTouchCallout: "none", ...t.style },
          onContextMenu: i ? t.onContextMenu : se(t.onContextMenu, (g) => {
            u(), h(g), g.preventDefault();
          }),
          onPointerDown: i ? t.onPointerDown : se(
            t.onPointerDown,
            Gu((g) => {
              u(), d.current = window.setTimeout(() => h(g), 700);
            })
          ),
          onPointerMove: i ? t.onPointerMove : se(t.onPointerMove, Gu(u)),
          onPointerCancel: i ? t.onPointerCancel : se(t.onPointerCancel, Gu(u)),
          onPointerUp: i ? t.onPointerUp : se(t.onPointerUp, Gu(u))
        }
      )
    ] });
  }
);
jL.displayName = SL;
var Tee = "ContextMenuPortal", nj = (t) => {
  const { __scopeContextMenu: e, ...n } = t, i = On(e);
  return /* @__PURE__ */ l.jsx(uee, { ...i, ...n });
};
nj.displayName = Tee;
var DL = "ContextMenuContent", wL = N.forwardRef(
  (t, e) => {
    const { __scopeContextMenu: n, ...i } = t, r = IL(DL, n), s = On(n), o = N.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      hee,
      {
        ...s,
        ...i,
        ref: e,
        side: "right",
        sideOffset: 2,
        align: "start",
        onCloseAutoFocus: (a) => {
          var c;
          (c = t.onCloseAutoFocus) == null || c.call(t, a), !a.defaultPrevented && o.current && a.preventDefault(), o.current = !1;
        },
        onInteractOutside: (a) => {
          var c;
          (c = t.onInteractOutside) == null || c.call(t, a), !a.defaultPrevented && !r.modal && (o.current = !0);
        },
        style: {
          ...t.style,
          "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
wL.displayName = DL;
var bee = "ContextMenuGroup", NL = N.forwardRef(
  (t, e) => {
    const { __scopeContextMenu: n, ...i } = t, r = On(n);
    return /* @__PURE__ */ l.jsx(gee, { ...r, ...i, ref: e });
  }
);
NL.displayName = bee;
var vee = "ContextMenuLabel", Eee = N.forwardRef(
  (t, e) => {
    const { __scopeContextMenu: n, ...i } = t, r = On(n);
    return /* @__PURE__ */ l.jsx(pee, { ...r, ...i, ref: e });
  }
);
Eee.displayName = vee;
var Cee = "ContextMenuItem", AL = N.forwardRef(
  (t, e) => {
    const { __scopeContextMenu: n, ...i } = t, r = On(n);
    return /* @__PURE__ */ l.jsx(fee, { ...r, ...i, ref: e });
  }
);
AL.displayName = Cee;
var zee = "ContextMenuCheckboxItem", TL = N.forwardRef((t, e) => {
  const { __scopeContextMenu: n, ...i } = t, r = On(n);
  return /* @__PURE__ */ l.jsx(Mee, { ...r, ...i, ref: e });
});
TL.displayName = zee;
var Lee = "ContextMenuRadioGroup", kee = N.forwardRef((t, e) => {
  const { __scopeContextMenu: n, ...i } = t, r = On(n);
  return /* @__PURE__ */ l.jsx(mee, { ...r, ...i, ref: e });
});
kee.displayName = Lee;
var Oee = "ContextMenuRadioItem", Pee = N.forwardRef((t, e) => {
  const { __scopeContextMenu: n, ...i } = t, r = On(n);
  return /* @__PURE__ */ l.jsx(yee, { ...r, ...i, ref: e });
});
Pee.displayName = Oee;
var Uee = "ContextMenuItemIndicator", Ree = N.forwardRef((t, e) => {
  const { __scopeContextMenu: n, ...i } = t, r = On(n);
  return /* @__PURE__ */ l.jsx(Iee, { ...r, ...i, ref: e });
});
Ree.displayName = Uee;
var Yee = "ContextMenuSeparator", Qee = N.forwardRef((t, e) => {
  const { __scopeContextMenu: n, ...i } = t, r = On(n);
  return /* @__PURE__ */ l.jsx(xee, { ...r, ...i, ref: e });
});
Qee.displayName = Yee;
var Zee = "ContextMenuArrow", Fee = N.forwardRef(
  (t, e) => {
    const { __scopeContextMenu: n, ...i } = t, r = On(n);
    return /* @__PURE__ */ l.jsx(See, { ...r, ...i, ref: e });
  }
);
Fee.displayName = Zee;
var Bee = "ContextMenuSub", bL = (t) => {
  const { __scopeContextMenu: e, children: n, onOpenChange: i, open: r, defaultOpen: s } = t, o = On(e), [a, c] = go({
    prop: r,
    defaultProp: s,
    onChange: i
  });
  return /* @__PURE__ */ l.jsx(jee, { ...o, open: a, onOpenChange: c, children: n });
};
bL.displayName = Bee;
var Gee = "ContextMenuSubTrigger", vL = N.forwardRef((t, e) => {
  const { __scopeContextMenu: n, ...i } = t, r = On(n);
  return /* @__PURE__ */ l.jsx(Dee, { ...r, ...i, ref: e });
});
vL.displayName = Gee;
var Wee = "ContextMenuSubContent", EL = N.forwardRef((t, e) => {
  const { __scopeContextMenu: n, ...i } = t, r = On(n);
  return /* @__PURE__ */ l.jsx(
    wee,
    {
      ...r,
      ...i,
      ref: e,
      style: {
        ...t.style,
        "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
EL.displayName = Wee;
function Gu(t) {
  return (e) => e.pointerType !== "mouse" ? t(e) : void 0;
}
var Hee = xL, Vee = jL, Kee = nj, Xee = wL, Jee = TL, qee = "DismissableLayer", II = "dismissableLayer.update", _ee = "dismissableLayer.pointerDownOutside", $ee = "dismissableLayer.focusOutside", eN, CL = N.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), zL = N.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: r,
      onFocusOutside: s,
      onInteractOutside: o,
      onDismiss: a,
      ...c
    } = t, d = N.useContext(CL), [u, h] = N.useState(null), g = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = N.useState({}), f = it(e, (b) => h(b)), M = Array.from(d.layers), [m] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), y = M.indexOf(m), I = u ? M.indexOf(u) : -1, D = d.layersWithOutsidePointerEventsDisabled.size > 0, j = I >= y, w = nte((b) => {
      const T = b.target, E = [...d.branches].some((v) => v.contains(T));
      !j || E || (r == null || r(b), o == null || o(b), b.defaultPrevented || a == null || a());
    }, g), A = ite((b) => {
      const T = b.target;
      [...d.branches].some((v) => v.contains(T)) || (s == null || s(b), o == null || o(b), b.defaultPrevented || a == null || a());
    }, g);
    return g4((b) => {
      I === d.layers.size - 1 && (i == null || i(b), !b.defaultPrevented && a && (b.preventDefault(), a()));
    }, g), N.useEffect(() => {
      if (u)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (eN = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), tN(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = eN);
        };
    }, [u, g, n, d]), N.useEffect(() => () => {
      u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), tN());
    }, [u, d]), N.useEffect(() => {
      const b = () => p({});
      return document.addEventListener(II, b), () => document.removeEventListener(II, b);
    }, []), /* @__PURE__ */ l.jsx(
      Fe.div,
      {
        ...c,
        ref: f,
        style: {
          pointerEvents: D ? j ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: se(t.onFocusCapture, A.onFocusCapture),
        onBlurCapture: se(t.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: se(
          t.onPointerDownCapture,
          w.onPointerDownCapture
        )
      }
    );
  }
);
zL.displayName = qee;
var ete = "DismissableLayerBranch", tte = N.forwardRef((t, e) => {
  const n = N.useContext(CL), i = N.useRef(null), r = it(e, i);
  return N.useEffect(() => {
    const s = i.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ l.jsx(Fe.div, { ...t, ref: r });
});
tte.displayName = ete;
function nte(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Bt(t), i = N.useRef(!1), r = N.useRef(() => {
  });
  return N.useEffect(() => {
    const s = (a) => {
      if (a.target && !i.current) {
        let c = function() {
          LL(
            _ee,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: a };
        a.pointerType === "touch" ? (e.removeEventListener("click", r.current), r.current = c, e.addEventListener("click", r.current, { once: !0 })) : c();
      } else
        e.removeEventListener("click", r.current);
      i.current = !1;
    }, o = window.setTimeout(() => {
      e.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(o), e.removeEventListener("pointerdown", s), e.removeEventListener("click", r.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function ite(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Bt(t), i = N.useRef(!1);
  return N.useEffect(() => {
    const r = (s) => {
      s.target && !i.current && LL($ee, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", r), () => e.removeEventListener("focusin", r);
  }, [e, n]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function tN() {
  const t = new CustomEvent(II);
  document.dispatchEvent(t);
}
function LL(t, e, n, { discrete: i }) {
  const r = n.originalEvent.target, s = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && r.addEventListener(t, e, { once: !0 }), i ? wd(r, s) : r.dispatchEvent(s);
}
var em = 0;
function rte() {
  N.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? nN()), document.body.insertAdjacentElement("beforeend", t[1] ?? nN()), em++, () => {
      em === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), em--;
    };
  }, []);
}
function nN() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", t;
}
var ste = "Portal", kL = N.forwardRef((t, e) => {
  var a;
  const { container: n, ...i } = t, [r, s] = N.useState(!1);
  pr(() => s(!0), []);
  const o = n || r && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return o ? tx.createPortal(/* @__PURE__ */ l.jsx(Fe.div, { ...i, ref: e }), o) : null;
});
kL.displayName = ste;
function ote(t, e) {
  return N.useReducer((n, i) => e[n][i] ?? n, t);
}
var Yd = (t) => {
  const { present: e, children: n } = t, i = ate(e), r = typeof n == "function" ? n({ present: i.isPresent }) : N.Children.only(n), s = it(i.ref, cte(r));
  return typeof n == "function" || i.isPresent ? N.cloneElement(r, { ref: s }) : null;
};
Yd.displayName = "Presence";
function ate(t) {
  const [e, n] = N.useState(), i = N.useRef({}), r = N.useRef(t), s = N.useRef("none"), o = t ? "mounted" : "unmounted", [a, c] = ote(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return N.useEffect(() => {
    const d = Wu(i.current);
    s.current = a === "mounted" ? d : "none";
  }, [a]), pr(() => {
    const d = i.current, u = r.current;
    if (u !== t) {
      const g = s.current, p = Wu(d);
      t ? c("MOUNT") : p === "none" || (d == null ? void 0 : d.display) === "none" ? c("UNMOUNT") : c(u && g !== p ? "ANIMATION_OUT" : "UNMOUNT"), r.current = t;
    }
  }, [t, c]), pr(() => {
    if (e) {
      const d = (h) => {
        const p = Wu(i.current).includes(h.animationName);
        h.target === e && p && op.flushSync(() => c("ANIMATION_END"));
      }, u = (h) => {
        h.target === e && (s.current = Wu(i.current));
      };
      return e.addEventListener("animationstart", u), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d), () => {
        e.removeEventListener("animationstart", u), e.removeEventListener("animationcancel", d), e.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [e, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: N.useCallback((d) => {
      d && (i.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function Wu(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function cte(t) {
  var i, r;
  let e = (i = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (r = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var OL = x4(), tm = function() {
}, of = N.forwardRef(function(t, e) {
  var n = N.useRef(null), i = N.useState({
    onScrollCapture: tm,
    onWheelCapture: tm,
    onTouchMoveCapture: tm
  }), r = i[0], s = i[1], o = t.forwardProps, a = t.children, c = t.className, d = t.removeScrollBar, u = t.enabled, h = t.shards, g = t.sideCar, p = t.noIsolation, f = t.inert, M = t.allowPinchZoom, m = t.as, y = m === void 0 ? "div" : m, I = t.gapMode, D = DS(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), j = g, w = I4([n, e]), A = vn(vn({}, D), r);
  return N.createElement(
    N.Fragment,
    null,
    u && N.createElement(j, { sideCar: OL, removeScrollBar: d, shards: h, noIsolation: p, inert: f, setCallbacks: s, allowPinchZoom: !!M, lockRef: n, gapMode: I }),
    o ? N.cloneElement(N.Children.only(a), vn(vn({}, A), { ref: w })) : N.createElement(y, vn({}, A, { className: c, ref: w }), a)
  );
});
of.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
of.classNames = {
  fullWidth: Pl,
  zeroRight: Ol
};
var xI = !1;
if (typeof window < "u")
  try {
    var Hu = Object.defineProperty({}, "passive", {
      get: function() {
        return xI = !0, !0;
      }
    });
    window.addEventListener("test", Hu, Hu), window.removeEventListener("test", Hu, Hu);
  } catch {
    xI = !1;
  }
var Ma = xI ? {} : !1, lte = function(t) {
  return t.tagName === "TEXTAREA";
}, PL = function(t, e) {
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !lte(t) && n[e] === "visible")
  );
}, dte = function(t) {
  return PL(t, "overflowY");
}, ute = function(t) {
  return PL(t, "overflowX");
}, iN = function(t, e) {
  var n = e.ownerDocument, i = e;
  do {
    typeof ShadowRoot < "u" && i instanceof ShadowRoot && (i = i.host);
    var r = UL(t, i);
    if (r) {
      var s = RL(t, i), o = s[1], a = s[2];
      if (o > a)
        return !0;
    }
    i = i.parentNode;
  } while (i && i !== n.body);
  return !1;
}, hte = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, i = t.clientHeight;
  return [
    e,
    n,
    i
  ];
}, gte = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, i = t.clientWidth;
  return [
    e,
    n,
    i
  ];
}, UL = function(t, e) {
  return t === "v" ? dte(e) : ute(e);
}, RL = function(t, e) {
  return t === "v" ? hte(e) : gte(e);
}, pte = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, fte = function(t, e, n, i, r) {
  var s = pte(t, window.getComputedStyle(e).direction), o = s * i, a = n.target, c = e.contains(a), d = !1, u = o > 0, h = 0, g = 0;
  do {
    var p = RL(t, a), f = p[0], M = p[1], m = p[2], y = M - m - s * f;
    (f || y) && UL(t, a) && (h += y, g += f), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (e.contains(a) || e === a)
  );
  return (u && (Math.abs(h) < 1 || !r) || !u && (Math.abs(g) < 1 || !r)) && (d = !0), d;
}, Vu = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, rN = function(t) {
  return [t.deltaX, t.deltaY];
}, sN = function(t) {
  return t && "current" in t ? t.current : t;
}, Mte = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, mte = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, yte = 0, ma = [];
function Ite(t) {
  var e = N.useRef([]), n = N.useRef([0, 0]), i = N.useRef(), r = N.useState(yte++)[0], s = N.useState(wS)[0], o = N.useRef(t);
  N.useEffect(function() {
    o.current = t;
  }, [t]), N.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var M = y4([t.lockRef.current], (t.shards || []).map(sN), !0).filter(Boolean);
      return M.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), M.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var a = N.useCallback(function(M, m) {
    if ("touches" in M && M.touches.length === 2)
      return !o.current.allowPinchZoom;
    var y = Vu(M), I = n.current, D = "deltaX" in M ? M.deltaX : I[0] - y[0], j = "deltaY" in M ? M.deltaY : I[1] - y[1], w, A = M.target, b = Math.abs(D) > Math.abs(j) ? "h" : "v";
    if ("touches" in M && b === "h" && A.type === "range")
      return !1;
    var T = iN(b, A);
    if (!T)
      return !0;
    if (T ? w = b : (w = b === "v" ? "h" : "v", T = iN(b, A)), !T)
      return !1;
    if (!i.current && "changedTouches" in M && (D || j) && (i.current = w), !w)
      return !0;
    var E = i.current || w;
    return fte(E, m, M, E === "h" ? D : j, !0);
  }, []), c = N.useCallback(function(M) {
    var m = M;
    if (!(!ma.length || ma[ma.length - 1] !== s)) {
      var y = "deltaY" in m ? rN(m) : Vu(m), I = e.current.filter(function(w) {
        return w.name === m.type && (w.target === m.target || m.target === w.shadowParent) && Mte(w.delta, y);
      })[0];
      if (I && I.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!I) {
        var D = (o.current.shards || []).map(sN).filter(Boolean).filter(function(w) {
          return w.contains(m.target);
        }), j = D.length > 0 ? a(m, D[0]) : !o.current.noIsolation;
        j && m.cancelable && m.preventDefault();
      }
    }
  }, []), d = N.useCallback(function(M, m, y, I) {
    var D = { name: M, delta: m, target: y, should: I, shadowParent: xte(y) };
    e.current.push(D), setTimeout(function() {
      e.current = e.current.filter(function(j) {
        return j !== D;
      });
    }, 1);
  }, []), u = N.useCallback(function(M) {
    n.current = Vu(M), i.current = void 0;
  }, []), h = N.useCallback(function(M) {
    d(M.type, rN(M), M.target, a(M, t.lockRef.current));
  }, []), g = N.useCallback(function(M) {
    d(M.type, Vu(M), M.target, a(M, t.lockRef.current));
  }, []);
  N.useEffect(function() {
    return ma.push(s), t.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", c, Ma), document.addEventListener("touchmove", c, Ma), document.addEventListener("touchstart", u, Ma), function() {
      ma = ma.filter(function(M) {
        return M !== s;
      }), document.removeEventListener("wheel", c, Ma), document.removeEventListener("touchmove", c, Ma), document.removeEventListener("touchstart", u, Ma);
    };
  }, []);
  var p = t.removeScrollBar, f = t.inert;
  return N.createElement(
    N.Fragment,
    null,
    f ? N.createElement(s, { styles: mte(r) }) : null,
    p ? N.createElement(w4, { gapMode: t.gapMode }) : null
  );
}
function xte(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const Ste = j4(OL, Ite);
var YL = N.forwardRef(function(t, e) {
  return N.createElement(of, vn({}, t, { ref: e, sideCar: Ste }));
});
YL.classNames = of.classNames;
var SI = ["Enter", " "], jte = ["ArrowDown", "PageUp", "Home"], QL = ["ArrowUp", "PageDown", "End"], Dte = [...jte, ...QL], wte = {
  ltr: [...SI, "ArrowRight"],
  rtl: [...SI, "ArrowLeft"]
}, Nte = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Qd = "Menu", [id, Ate, Tte] = vd(Qd), [qo, ZL] = bd(Qd, [
  Tte,
  Cc,
  rf
]), Zd = Cc(), FL = rf(), [BL, Mo] = qo(Qd), [bte, Fd] = qo(Qd), GL = (t) => {
  const { __scopeMenu: e, open: n = !1, children: i, dir: r, onOpenChange: s, modal: o = !0 } = t, a = Zd(e), [c, d] = N.useState(null), u = N.useRef(!1), h = Bt(s), g = _p(r);
  return N.useEffect(() => {
    const p = () => {
      u.current = !0, document.addEventListener("pointerdown", f, { capture: !0, once: !0 }), document.addEventListener("pointermove", f, { capture: !0, once: !0 });
    }, f = () => u.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", f, { capture: !0 }), document.removeEventListener("pointermove", f, { capture: !0 });
    };
  }, []), /* @__PURE__ */ l.jsx(Od, { ...a, children: /* @__PURE__ */ l.jsx(
    BL,
    {
      scope: e,
      open: n,
      onOpenChange: h,
      content: c,
      onContentChange: d,
      children: /* @__PURE__ */ l.jsx(
        bte,
        {
          scope: e,
          onClose: N.useCallback(() => h(!1), [h]),
          isUsingKeyboardRef: u,
          dir: g,
          modal: o,
          children: i
        }
      )
    }
  ) });
};
GL.displayName = Qd;
var vte = "MenuAnchor", ij = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t, r = Zd(n);
    return /* @__PURE__ */ l.jsx(tf, { ...r, ...i, ref: e });
  }
);
ij.displayName = vte;
var rj = "MenuPortal", [Ete, WL] = qo(rj, {
  forceMount: void 0
}), HL = (t) => {
  const { __scopeMenu: e, forceMount: n, children: i, container: r } = t, s = Mo(rj, e);
  return /* @__PURE__ */ l.jsx(Ete, { scope: e, forceMount: n, children: /* @__PURE__ */ l.jsx(Yd, { present: n || s.open, children: /* @__PURE__ */ l.jsx(kL, { asChild: !0, container: r, children: i }) }) });
};
HL.displayName = rj;
var Vi = "MenuContent", [Cte, sj] = qo(Vi), VL = N.forwardRef(
  (t, e) => {
    const n = WL(Vi, t.__scopeMenu), { forceMount: i = n.forceMount, ...r } = t, s = Mo(Vi, t.__scopeMenu), o = Fd(Vi, t.__scopeMenu);
    return /* @__PURE__ */ l.jsx(id.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ l.jsx(Yd, { present: i || s.open, children: /* @__PURE__ */ l.jsx(id.Slot, { scope: t.__scopeMenu, children: o.modal ? /* @__PURE__ */ l.jsx(zte, { ...r, ref: e }) : /* @__PURE__ */ l.jsx(Lte, { ...r, ref: e }) }) }) });
  }
), zte = N.forwardRef(
  (t, e) => {
    const n = Mo(Vi, t.__scopeMenu), i = N.useRef(null), r = it(e, i);
    return N.useEffect(() => {
      const s = i.current;
      if (s) return Wp(s);
    }, []), /* @__PURE__ */ l.jsx(
      oj,
      {
        ...t,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: se(
          t.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), Lte = N.forwardRef((t, e) => {
  const n = Mo(Vi, t.__scopeMenu);
  return /* @__PURE__ */ l.jsx(
    oj,
    {
      ...t,
      ref: e,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), oj = N.forwardRef(
  (t, e) => {
    const {
      __scopeMenu: n,
      loop: i = !1,
      trapFocus: r,
      onOpenAutoFocus: s,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: a,
      onEntryFocus: c,
      onEscapeKeyDown: d,
      onPointerDownOutside: u,
      onFocusOutside: h,
      onInteractOutside: g,
      onDismiss: p,
      disableOutsideScroll: f,
      ...M
    } = t, m = Mo(Vi, n), y = Fd(Vi, n), I = Zd(n), D = FL(n), j = Ate(n), [w, A] = N.useState(null), b = N.useRef(null), T = it(e, b, m.onContentChange), E = N.useRef(0), v = N.useRef(""), P = N.useRef(0), C = N.useRef(null), z = N.useRef("right"), O = N.useRef(0), R = f ? YL : N.Fragment, U = f ? { as: eo, allowPinchZoom: !0 } : void 0, F = (Z) => {
      var ge, Re;
      const te = v.current + Z, oe = j().filter((ye) => !ye.disabled), me = document.activeElement, he = (ge = oe.find((ye) => ye.ref.current === me)) == null ? void 0 : ge.textValue, ve = oe.map((ye) => ye.textValue), ie = Wte(ve, te, he), Ue = (Re = oe.find((ye) => ye.textValue === ie)) == null ? void 0 : Re.ref.current;
      (function ye(Be) {
        v.current = Be, window.clearTimeout(E.current), Be !== "" && (E.current = window.setTimeout(() => ye(""), 1e3));
      })(te), Ue && setTimeout(() => Ue.focus());
    };
    N.useEffect(() => () => window.clearTimeout(E.current), []), rte();
    const H = N.useCallback((Z) => {
      var oe, me;
      return z.current === ((oe = C.current) == null ? void 0 : oe.side) && Vte(Z, (me = C.current) == null ? void 0 : me.area);
    }, []);
    return /* @__PURE__ */ l.jsx(
      Cte,
      {
        scope: n,
        searchRef: v,
        onItemEnter: N.useCallback(
          (Z) => {
            H(Z) && Z.preventDefault();
          },
          [H]
        ),
        onItemLeave: N.useCallback(
          (Z) => {
            var te;
            H(Z) || ((te = b.current) == null || te.focus(), A(null));
          },
          [H]
        ),
        onTriggerLeave: N.useCallback(
          (Z) => {
            H(Z) && Z.preventDefault();
          },
          [H]
        ),
        pointerGraceTimerRef: P,
        onPointerGraceIntentChange: N.useCallback((Z) => {
          C.current = Z;
        }, []),
        children: /* @__PURE__ */ l.jsx(R, { ...U, children: /* @__PURE__ */ l.jsx(
          Ad,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: se(s, (Z) => {
              var te;
              Z.preventDefault(), (te = b.current) == null || te.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: o,
            children: /* @__PURE__ */ l.jsx(
              zL,
              {
                asChild: !0,
                disableOutsidePointerEvents: a,
                onEscapeKeyDown: d,
                onPointerDownOutside: u,
                onFocusOutside: h,
                onInteractOutside: g,
                onDismiss: p,
                children: /* @__PURE__ */ l.jsx(
                  Hz,
                  {
                    asChild: !0,
                    ...D,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: i,
                    currentTabStopId: w,
                    onCurrentTabStopIdChange: A,
                    onEntryFocus: se(c, (Z) => {
                      y.isUsingKeyboardRef.current || Z.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ l.jsx(
                      WS,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": dk(m.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...I,
                        ...M,
                        ref: T,
                        style: { outline: "none", ...M.style },
                        onKeyDown: se(M.onKeyDown, (Z) => {
                          const oe = Z.target.closest("[data-radix-menu-content]") === Z.currentTarget, me = Z.ctrlKey || Z.altKey || Z.metaKey, he = Z.key.length === 1;
                          oe && (Z.key === "Tab" && Z.preventDefault(), !me && he && F(Z.key));
                          const ve = b.current;
                          if (Z.target !== ve || !Dte.includes(Z.key)) return;
                          Z.preventDefault();
                          const Ue = j().filter((ge) => !ge.disabled).map((ge) => ge.ref.current);
                          QL.includes(Z.key) && Ue.reverse(), Bte(Ue);
                        }),
                        onBlur: se(t.onBlur, (Z) => {
                          Z.currentTarget.contains(Z.target) || (window.clearTimeout(E.current), v.current = "");
                        }),
                        onPointerMove: se(
                          t.onPointerMove,
                          rd((Z) => {
                            const te = Z.target, oe = O.current !== Z.clientX;
                            if (Z.currentTarget.contains(te) && oe) {
                              const me = Z.clientX > O.current ? "right" : "left";
                              z.current = me, O.current = Z.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
VL.displayName = Vi;
var kte = "MenuGroup", aj = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t;
    return /* @__PURE__ */ l.jsx(Fe.div, { role: "group", ...i, ref: e });
  }
);
aj.displayName = kte;
var Ote = "MenuLabel", KL = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t;
    return /* @__PURE__ */ l.jsx(Fe.div, { ...i, ref: e });
  }
);
KL.displayName = Ote;
var Gg = "MenuItem", oN = "menu.itemSelect", af = N.forwardRef(
  (t, e) => {
    const { disabled: n = !1, onSelect: i, ...r } = t, s = N.useRef(null), o = Fd(Gg, t.__scopeMenu), a = sj(Gg, t.__scopeMenu), c = it(e, s), d = N.useRef(!1), u = () => {
      const h = s.current;
      if (!n && h) {
        const g = new CustomEvent(oN, { bubbles: !0, cancelable: !0 });
        h.addEventListener(oN, (p) => i == null ? void 0 : i(p), { once: !0 }), wd(h, g), g.defaultPrevented ? d.current = !1 : o.onClose();
      }
    };
    return /* @__PURE__ */ l.jsx(
      XL,
      {
        ...r,
        ref: c,
        disabled: n,
        onClick: se(t.onClick, u),
        onPointerDown: (h) => {
          var g;
          (g = t.onPointerDown) == null || g.call(t, h), d.current = !0;
        },
        onPointerUp: se(t.onPointerUp, (h) => {
          var g;
          d.current || (g = h.currentTarget) == null || g.click();
        }),
        onKeyDown: se(t.onKeyDown, (h) => {
          const g = a.searchRef.current !== "";
          n || g && h.key === " " || SI.includes(h.key) && (h.currentTarget.click(), h.preventDefault());
        })
      }
    );
  }
);
af.displayName = Gg;
var XL = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, disabled: i = !1, textValue: r, ...s } = t, o = sj(Gg, n), a = FL(n), c = N.useRef(null), d = it(e, c), [u, h] = N.useState(!1), [g, p] = N.useState("");
    return N.useEffect(() => {
      const f = c.current;
      f && p((f.textContent ?? "").trim());
    }, [s.children]), /* @__PURE__ */ l.jsx(
      id.ItemSlot,
      {
        scope: n,
        disabled: i,
        textValue: r ?? g,
        children: /* @__PURE__ */ l.jsx(Vz, { asChild: !0, ...a, focusable: !i, children: /* @__PURE__ */ l.jsx(
          Fe.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": i || void 0,
            "data-disabled": i ? "" : void 0,
            ...s,
            ref: d,
            onPointerMove: se(
              t.onPointerMove,
              rd((f) => {
                i ? o.onItemLeave(f) : (o.onItemEnter(f), f.defaultPrevented || f.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: se(
              t.onPointerLeave,
              rd((f) => o.onItemLeave(f))
            ),
            onFocus: se(t.onFocus, () => h(!0)),
            onBlur: se(t.onBlur, () => h(!1))
          }
        ) })
      }
    );
  }
), Pte = "MenuCheckboxItem", JL = N.forwardRef(
  (t, e) => {
    const { checked: n = !1, onCheckedChange: i, ...r } = t;
    return /* @__PURE__ */ l.jsx(tk, { scope: t.__scopeMenu, checked: n, children: /* @__PURE__ */ l.jsx(
      af,
      {
        role: "menuitemcheckbox",
        "aria-checked": Wg(n) ? "mixed" : n,
        ...r,
        ref: e,
        "data-state": dj(n),
        onSelect: se(
          r.onSelect,
          () => i == null ? void 0 : i(Wg(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
JL.displayName = Pte;
var qL = "MenuRadioGroup", [Ute, Rte] = qo(
  qL,
  { value: void 0, onValueChange: () => {
  } }
), _L = N.forwardRef(
  (t, e) => {
    const { value: n, onValueChange: i, ...r } = t, s = Bt(i);
    return /* @__PURE__ */ l.jsx(Ute, { scope: t.__scopeMenu, value: n, onValueChange: s, children: /* @__PURE__ */ l.jsx(aj, { ...r, ref: e }) });
  }
);
_L.displayName = qL;
var $L = "MenuRadioItem", ek = N.forwardRef(
  (t, e) => {
    const { value: n, ...i } = t, r = Rte($L, t.__scopeMenu), s = n === r.value;
    return /* @__PURE__ */ l.jsx(tk, { scope: t.__scopeMenu, checked: s, children: /* @__PURE__ */ l.jsx(
      af,
      {
        role: "menuitemradio",
        "aria-checked": s,
        ...i,
        ref: e,
        "data-state": dj(s),
        onSelect: se(
          i.onSelect,
          () => {
            var o;
            return (o = r.onValueChange) == null ? void 0 : o.call(r, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
ek.displayName = $L;
var cj = "MenuItemIndicator", [tk, Yte] = qo(
  cj,
  { checked: !1 }
), nk = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, forceMount: i, ...r } = t, s = Yte(cj, n);
    return /* @__PURE__ */ l.jsx(
      Yd,
      {
        present: i || Wg(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ l.jsx(
          Fe.span,
          {
            ...r,
            ref: e,
            "data-state": dj(s.checked)
          }
        )
      }
    );
  }
);
nk.displayName = cj;
var Qte = "MenuSeparator", ik = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t;
    return /* @__PURE__ */ l.jsx(
      Fe.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...i,
        ref: e
      }
    );
  }
);
ik.displayName = Qte;
var Zte = "MenuArrow", rk = N.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t, r = Zd(n);
    return /* @__PURE__ */ l.jsx(HS, { ...r, ...i, ref: e });
  }
);
rk.displayName = Zte;
var lj = "MenuSub", [Fte, sk] = qo(lj), ok = (t) => {
  const { __scopeMenu: e, children: n, open: i = !1, onOpenChange: r } = t, s = Mo(lj, e), o = Zd(e), [a, c] = N.useState(null), [d, u] = N.useState(null), h = Bt(r);
  return N.useEffect(() => (s.open === !1 && h(!1), () => h(!1)), [s.open, h]), /* @__PURE__ */ l.jsx(Od, { ...o, children: /* @__PURE__ */ l.jsx(
    BL,
    {
      scope: e,
      open: i,
      onOpenChange: h,
      content: d,
      onContentChange: u,
      children: /* @__PURE__ */ l.jsx(
        Fte,
        {
          scope: e,
          contentId: dr(),
          triggerId: dr(),
          trigger: a,
          onTriggerChange: c,
          children: n
        }
      )
    }
  ) });
};
ok.displayName = lj;
var Nl = "MenuSubTrigger", ak = N.forwardRef(
  (t, e) => {
    const n = Mo(Nl, t.__scopeMenu), i = Fd(Nl, t.__scopeMenu), r = sk(Nl, t.__scopeMenu), s = sj(Nl, t.__scopeMenu), o = N.useRef(null), { pointerGraceTimerRef: a, onPointerGraceIntentChange: c } = s, d = { __scopeMenu: t.__scopeMenu }, u = N.useCallback(() => {
      o.current && window.clearTimeout(o.current), o.current = null;
    }, []);
    return N.useEffect(() => u, [u]), N.useEffect(() => {
      const h = a.current;
      return () => {
        window.clearTimeout(h), c(null);
      };
    }, [a, c]), /* @__PURE__ */ l.jsx(ij, { asChild: !0, ...d, children: /* @__PURE__ */ l.jsx(
      XL,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": dk(n.open),
        ...t,
        ref: Dd(e, r.onTriggerChange),
        onClick: (h) => {
          var g;
          (g = t.onClick) == null || g.call(t, h), !(t.disabled || h.defaultPrevented) && (h.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: se(
          t.onPointerMove,
          rd((h) => {
            s.onItemEnter(h), !h.defaultPrevented && !t.disabled && !n.open && !o.current && (s.onPointerGraceIntentChange(null), o.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: se(
          t.onPointerLeave,
          rd((h) => {
            var p, f;
            u();
            const g = (p = n.content) == null ? void 0 : p.getBoundingClientRect();
            if (g) {
              const M = (f = n.content) == null ? void 0 : f.dataset.side, m = M === "right", y = m ? -5 : 5, I = g[m ? "left" : "right"], D = g[m ? "right" : "left"];
              s.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: h.clientX + y, y: h.clientY },
                  { x: I, y: g.top },
                  { x: D, y: g.top },
                  { x: D, y: g.bottom },
                  { x: I, y: g.bottom }
                ],
                side: M
              }), window.clearTimeout(a.current), a.current = window.setTimeout(
                () => s.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (s.onTriggerLeave(h), h.defaultPrevented) return;
              s.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: se(t.onKeyDown, (h) => {
          var p;
          const g = s.searchRef.current !== "";
          t.disabled || g && h.key === " " || wte[i.dir].includes(h.key) && (n.onOpenChange(!0), (p = n.content) == null || p.focus(), h.preventDefault());
        })
      }
    ) });
  }
);
ak.displayName = Nl;
var ck = "MenuSubContent", lk = N.forwardRef(
  (t, e) => {
    const n = WL(Vi, t.__scopeMenu), { forceMount: i = n.forceMount, ...r } = t, s = Mo(Vi, t.__scopeMenu), o = Fd(Vi, t.__scopeMenu), a = sk(ck, t.__scopeMenu), c = N.useRef(null), d = it(e, c);
    return /* @__PURE__ */ l.jsx(id.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ l.jsx(Yd, { present: i || s.open, children: /* @__PURE__ */ l.jsx(id.Slot, { scope: t.__scopeMenu, children: /* @__PURE__ */ l.jsx(
      oj,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...r,
        ref: d,
        align: "start",
        side: o.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var h;
          o.isUsingKeyboardRef.current && ((h = c.current) == null || h.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: se(t.onFocusOutside, (u) => {
          u.target !== a.trigger && s.onOpenChange(!1);
        }),
        onEscapeKeyDown: se(t.onEscapeKeyDown, (u) => {
          o.onClose(), u.preventDefault();
        }),
        onKeyDown: se(t.onKeyDown, (u) => {
          var p;
          const h = u.currentTarget.contains(u.target), g = Nte[o.dir].includes(u.key);
          h && g && (s.onOpenChange(!1), (p = a.trigger) == null || p.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
lk.displayName = ck;
function dk(t) {
  return t ? "open" : "closed";
}
function Wg(t) {
  return t === "indeterminate";
}
function dj(t) {
  return Wg(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
function Bte(t) {
  const e = document.activeElement;
  for (const n of t)
    if (n === e || (n.focus(), document.activeElement !== e)) return;
}
function Gte(t, e) {
  return t.map((n, i) => t[(e + i) % t.length]);
}
function Wte(t, e, n) {
  const r = e.length > 1 && Array.from(e).every((d) => d === e[0]) ? e[0] : e, s = n ? t.indexOf(n) : -1;
  let o = Gte(t, Math.max(s, 0));
  r.length === 1 && (o = o.filter((d) => d !== n));
  const c = o.find(
    (d) => d.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function Hte(t, e) {
  const { x: n, y: i } = t;
  let r = !1;
  for (let s = 0, o = e.length - 1; s < e.length; o = s++) {
    const a = e[s].x, c = e[s].y, d = e[o].x, u = e[o].y;
    c > i != u > i && n < (d - a) * (i - c) / (u - c) + a && (r = !r);
  }
  return r;
}
function Vte(t, e) {
  if (!e) return !1;
  const n = { x: t.clientX, y: t.clientY };
  return Hte(n, e);
}
function rd(t) {
  return (e) => e.pointerType === "mouse" ? t(e) : void 0;
}
var Kte = GL, Xte = ij, Jte = HL, qte = VL, _te = aj, $te = KL, ene = af, tne = JL, nne = _L, ine = ek, rne = nk, sne = ik, one = rk, ane = ok, cne = ak, lne = lk, uj = "DropdownMenu", [dne, Hme] = bd(
  uj,
  [ZL]
), Pn = ZL(), [une, uk] = dne(uj), hk = (t) => {
  const {
    __scopeDropdownMenu: e,
    children: n,
    dir: i,
    open: r,
    defaultOpen: s,
    onOpenChange: o,
    modal: a = !0
  } = t, c = Pn(e), d = N.useRef(null), [u = !1, h] = go({
    prop: r,
    defaultProp: s,
    onChange: o
  });
  return /* @__PURE__ */ l.jsx(
    une,
    {
      scope: e,
      triggerId: dr(),
      triggerRef: d,
      contentId: dr(),
      open: u,
      onOpenChange: h,
      onOpenToggle: N.useCallback(() => h((g) => !g), [h]),
      modal: a,
      children: /* @__PURE__ */ l.jsx(Kte, { ...c, open: u, onOpenChange: h, dir: i, modal: a, children: n })
    }
  );
};
hk.displayName = uj;
var gk = "DropdownMenuTrigger", pk = N.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, disabled: i = !1, ...r } = t, s = uk(gk, n), o = Pn(n);
    return /* @__PURE__ */ l.jsx(Xte, { asChild: !0, ...o, children: /* @__PURE__ */ l.jsx(
      Fe.button,
      {
        type: "button",
        id: s.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": s.open,
        "aria-controls": s.open ? s.contentId : void 0,
        "data-state": s.open ? "open" : "closed",
        "data-disabled": i ? "" : void 0,
        disabled: i,
        ...r,
        ref: Dd(e, s.triggerRef),
        onPointerDown: se(t.onPointerDown, (a) => {
          !i && a.button === 0 && a.ctrlKey === !1 && (s.onOpenToggle(), s.open || a.preventDefault());
        }),
        onKeyDown: se(t.onKeyDown, (a) => {
          i || (["Enter", " "].includes(a.key) && s.onOpenToggle(), a.key === "ArrowDown" && s.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(a.key) && a.preventDefault());
        })
      }
    ) });
  }
);
pk.displayName = gk;
var hne = "DropdownMenuPortal", fk = (t) => {
  const { __scopeDropdownMenu: e, ...n } = t, i = Pn(e);
  return /* @__PURE__ */ l.jsx(Jte, { ...i, ...n });
};
fk.displayName = hne;
var Mk = "DropdownMenuContent", mk = N.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...i } = t, r = uk(Mk, n), s = Pn(n), o = N.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      qte,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...s,
        ...i,
        ref: e,
        onCloseAutoFocus: se(t.onCloseAutoFocus, (a) => {
          var c;
          o.current || (c = r.triggerRef.current) == null || c.focus(), o.current = !1, a.preventDefault();
        }),
        onInteractOutside: se(t.onInteractOutside, (a) => {
          const c = a.detail.originalEvent, d = c.button === 0 && c.ctrlKey === !0, u = c.button === 2 || d;
          (!r.modal || u) && (o.current = !0);
        }),
        style: {
          ...t.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
mk.displayName = Mk;
var gne = "DropdownMenuGroup", yk = N.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...i } = t, r = Pn(n);
    return /* @__PURE__ */ l.jsx(_te, { ...r, ...i, ref: e });
  }
);
yk.displayName = gne;
var pne = "DropdownMenuLabel", fne = N.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...i } = t, r = Pn(n);
    return /* @__PURE__ */ l.jsx($te, { ...r, ...i, ref: e });
  }
);
fne.displayName = pne;
var Mne = "DropdownMenuItem", Ik = N.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...i } = t, r = Pn(n);
    return /* @__PURE__ */ l.jsx(ene, { ...r, ...i, ref: e });
  }
);
Ik.displayName = Mne;
var mne = "DropdownMenuCheckboxItem", xk = N.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Pn(n);
  return /* @__PURE__ */ l.jsx(tne, { ...r, ...i, ref: e });
});
xk.displayName = mne;
var yne = "DropdownMenuRadioGroup", Ine = N.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Pn(n);
  return /* @__PURE__ */ l.jsx(nne, { ...r, ...i, ref: e });
});
Ine.displayName = yne;
var xne = "DropdownMenuRadioItem", Sne = N.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Pn(n);
  return /* @__PURE__ */ l.jsx(ine, { ...r, ...i, ref: e });
});
Sne.displayName = xne;
var jne = "DropdownMenuItemIndicator", Dne = N.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Pn(n);
  return /* @__PURE__ */ l.jsx(rne, { ...r, ...i, ref: e });
});
Dne.displayName = jne;
var wne = "DropdownMenuSeparator", Nne = N.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Pn(n);
  return /* @__PURE__ */ l.jsx(sne, { ...r, ...i, ref: e });
});
Nne.displayName = wne;
var Ane = "DropdownMenuArrow", Tne = N.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...i } = t, r = Pn(n);
    return /* @__PURE__ */ l.jsx(one, { ...r, ...i, ref: e });
  }
);
Tne.displayName = Ane;
var bne = (t) => {
  const { __scopeDropdownMenu: e, children: n, open: i, onOpenChange: r, defaultOpen: s } = t, o = Pn(e), [a = !1, c] = go({
    prop: i,
    defaultProp: s,
    onChange: r
  });
  return /* @__PURE__ */ l.jsx(ane, { ...o, open: a, onOpenChange: c, children: n });
}, vne = "DropdownMenuSubTrigger", Sk = N.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Pn(n);
  return /* @__PURE__ */ l.jsx(cne, { ...r, ...i, ref: e });
});
Sk.displayName = vne;
var Ene = "DropdownMenuSubContent", jk = N.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Pn(n);
  return /* @__PURE__ */ l.jsx(
    lne,
    {
      ...r,
      ...i,
      ref: e,
      style: {
        ...t.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
jk.displayName = Ene;
var cf = hk, lf = pk, Bd = fk, df = mk, Cne = yk, zne = Ik, Lne = xk, kne = bne, One = Sk, Pne = jk;
function ji() {
  const t = Xx();
  return G("isReadonlyMode", () => !!(t != null && t.getIsReadonly()), [t]);
}
const nm = [0, 389, 436, 476, 580, 640, 840, 1023];
var Qt = /* @__PURE__ */ ((t) => (t[t.ZERO = 0] = "ZERO", t[t.MOBILE_XXS = 1] = "MOBILE_XXS", t[t.MOBILE_XS = 2] = "MOBILE_XS", t[t.MOBILE_SM = 3] = "MOBILE_SM", t[t.MOBILE = 4] = "MOBILE", t[t.TABLET_SM = 5] = "TABLET_SM", t[t.TABLET = 6] = "TABLET", t[t.DESKTOP = 7] = "DESKTOP", t))(Qt || {});
const Dk = Ye.createContext(null);
function Une({ forceMobile: t = !1, children: e }) {
  const n = Q(), i = G(
    "breakpoint",
    () => {
      const { width: r } = n.getViewportScreenBounds(), s = t ? Qt.MOBILE_SM : nm.length - 1;
      for (let o = 0; o < s; o++)
        if (r > nm[o] && r <= nm[o + 1])
          return o;
      return s;
    },
    [n]
  );
  return /* @__PURE__ */ l.jsx(Dk.Provider, { value: i, children: e });
}
function Un() {
  const t = Vn(Dk);
  if (t === null)
    throw new Error("useBreakpoint must be used inside of the <BreakpointProvider /> component");
  return t;
}
const Rne = mt.isDarwin ? "⌘" : "Ctrl", Yne = mt.isDarwin ? "⌥" : "Alt";
function wk(t) {
  return t === "," ? [","] : t.split(",")[0].split("").map((e) => {
    const n = e.replace(/\$/g, Rne).replace(/\?/g, Yne).replace(/!/g, "⇧");
    return n[0].toUpperCase() + n.slice(1);
  });
}
function jI(t) {
  return "— " + wk(t).join(" ");
}
function Rl({ children: t, visibleOnMobileLayout: e = !1 }) {
  const n = Un();
  return !e && n < Qt.MOBILE ? null : /* @__PURE__ */ l.jsx("kbd", { className: "tlui-kbd", children: wk(t).map((i, r) => /* @__PURE__ */ l.jsx("span", { children: i }, r)) });
}
const Nk = Ii(null);
function uf() {
  const t = Vn(Nk);
  if (!t)
    throw new Error("useTldrawUiMenuContext must be used within a TldrawUiMenuContextProvider");
  return t;
}
function yn({
  type: t,
  sourceId: e,
  children: n
}) {
  return /* @__PURE__ */ l.jsx(Nk.Provider, { value: { type: t, sourceId: e }, children: n });
}
function hf({
  id: t,
  kbd: e,
  label: n,
  readonlyOk: i,
  onSelect: r,
  toggle: s = !1,
  disabled: o = !1,
  checked: a = !1
}) {
  const { type: c, sourceId: d } = uf(), u = ji(), h = ke();
  if (u && !i) return null;
  const g = _l(n, c), p = g ? h(g) : void 0;
  switch (c) {
    case "menu":
      return /* @__PURE__ */ l.jsxs(
        Lne,
        {
          dir: "ltr",
          className: "tlui-button tlui-button__menu tlui-button__checkbox",
          title: p,
          onSelect: (f) => {
            r == null || r(d), Ke(f);
          },
          disabled: o,
          checked: a,
          children: [
            /* @__PURE__ */ l.jsx(
              Ui,
              {
                small: !0,
                icon: s ? a ? "toggle-on" : "toggle-off" : a ? "check" : "none"
              }
            ),
            p && /* @__PURE__ */ l.jsx("span", { className: "tlui-button__label", draggable: !1, children: p }),
            e && /* @__PURE__ */ l.jsx(Rl, { children: e })
          ]
        }
      );
    case "context-menu":
      return /* @__PURE__ */ l.jsxs(
        Jee,
        {
          className: "tlui-button tlui-button__menu tlui-button__checkbox",
          dir: "ltr",
          title: p,
          onSelect: (f) => {
            r(d), Ke(f);
          },
          disabled: o,
          checked: a,
          children: [
            /* @__PURE__ */ l.jsx(
              Ui,
              {
                small: !0,
                icon: s ? a ? "toggle-on" : "toggle-off" : a ? "check" : "none"
              }
            ),
            p && /* @__PURE__ */ l.jsx("span", { className: "tlui-button__label", draggable: !1, children: p }),
            e && /* @__PURE__ */ l.jsx(Rl, { children: e })
          ]
        },
        t
      );
    default:
      return null;
  }
}
function wr({
  actionId: t = "",
  ...e
}) {
  const i = _t()[t];
  return i ? /* @__PURE__ */ l.jsx(hf, { ...i, ...e }) : null;
}
function aN(t) {
  return /* @__PURE__ */ l.jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", ...t, children: /* @__PURE__ */ l.jsxs("g", { strokeWidth: 2, fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ l.jsx("circle", { strokeOpacity: 0.25, cx: 8, cy: 8, r: 7, stroke: "currentColor" }),
    /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", d: "M15 8c0-4.5-4.5-7-7-7", stroke: "currentColor", children: /* @__PURE__ */ l.jsx(
      "animateTransform",
      {
        attributeName: "transform",
        type: "rotate",
        from: "0 8 8",
        to: "360 8 8",
        dur: "1s",
        repeatCount: "indefinite"
      }
    ) })
  ] }) });
}
function Nr(t, e) {
  const n = Xx(), i = re(
    (o) => {
      o && (n == null || n.complete()), e == null || e(o);
    },
    [n, e]
  ), r = Zt(), s = re(
    (o) => {
      r(o, { source: "unknown", id: t });
    },
    [t, r]
  );
  return qK(n ? `${t}-${n.contextId}` : t, i, s);
}
function mr({
  id: t,
  children: e,
  modal: n = !1,
  debugOpen: i = !1
}) {
  const [r, s] = Nr(t);
  return /* @__PURE__ */ l.jsx(
    cf,
    {
      open: i || r,
      dir: "ltr",
      modal: n,
      onOpenChange: s,
      children: e
    }
  );
}
function yr({ children: t, ...e }) {
  return /* @__PURE__ */ l.jsx(
    lf,
    {
      dir: "ltr",
      asChild: !0,
      onTouchEnd: (n) => Ke(n),
      ...e,
      children: t
    }
  );
}
function Ir({
  className: t,
  side: e = "bottom",
  align: n = "start",
  sideOffset: i = 8,
  alignOffset: r = 8,
  children: s
}) {
  const o = qt();
  return /* @__PURE__ */ l.jsx(Bd, { container: o, children: /* @__PURE__ */ l.jsx(
    df,
    {
      className: ce("tlui-menu", t),
      side: e,
      sideOffset: i,
      align: n,
      alignOffset: r,
      collisionPadding: 4,
      children: s
    }
  ) });
}
function Qne({ id: t, children: e }) {
  const [n, i] = Nr(t);
  return /* @__PURE__ */ l.jsx(kne, { open: n, onOpenChange: i, children: e });
}
function Zne({
  id: t,
  label: e,
  title: n,
  disabled: i
}) {
  return /* @__PURE__ */ l.jsx(One, { dir: "ltr", asChild: !0, disabled: i, children: /* @__PURE__ */ l.jsxs(
    q,
    {
      "data-testid": t,
      type: "menu",
      className: "tlui-menu__submenu__trigger",
      disabled: i,
      title: n,
      children: [
        /* @__PURE__ */ l.jsx(St, { children: e }),
        /* @__PURE__ */ l.jsx(Te, { icon: "chevron-right", small: !0 })
      ]
    }
  ) });
}
function Fne({
  id: t,
  alignOffset: e = -1,
  sideOffset: n = -6,
  size: i = "small",
  children: r
}) {
  const s = qt();
  return /* @__PURE__ */ l.jsx(Bd, { container: s, children: /* @__PURE__ */ l.jsx(
    Pne,
    {
      "data-testid": t,
      className: "tlui-menu tlui-menu__submenu__content",
      alignOffset: e,
      sideOffset: n,
      collisionPadding: 4,
      "data-size": i,
      children: r
    }
  ) });
}
function Bne({ children: t }) {
  return /* @__PURE__ */ l.jsx(Cne, { dir: "ltr", className: "tlui-menu__group", children: t });
}
function ro({ noClose: t, children: e }) {
  return /* @__PURE__ */ l.jsx(zne, { dir: "ltr", asChild: !0, onClick: t ? Ke : void 0, children: e });
}
function Qe({
  disabled: t = !1,
  spinner: e = !1,
  readonlyOk: n = !1,
  id: i,
  kbd: r,
  label: s,
  icon: o,
  onSelect: a,
  noClose: c,
  isSelected: d
}) {
  const { type: u, sourceId: h } = uf(), g = ke(), [p, f] = pe(!1);
  if (ji() && !n) return null;
  const m = _l(s, u), y = r ? jI(r) : void 0, I = m ? g(m) : void 0, D = I && y ? `${I} ${y}` : I;
  switch (u) {
    case "menu":
      return /* @__PURE__ */ l.jsx(ro, { children: /* @__PURE__ */ l.jsxs(
        q,
        {
          type: "menu",
          "data-testid": `${h}.${i}`,
          disabled: t,
          title: D,
          onClick: (j) => {
            c && Ke(j), p ? f(!1) : a(h);
          },
          children: [
            /* @__PURE__ */ l.jsx(St, { children: I }),
            r && /* @__PURE__ */ l.jsx(Rl, { children: r })
          ]
        }
      ) });
    case "context-menu":
      return t ? null : /* @__PURE__ */ l.jsxs(
        AL,
        {
          dir: "ltr",
          title: D,
          draggable: !1,
          className: "tlui-button tlui-button__menu",
          "data-testid": `${h}.${i}`,
          onSelect: (j) => {
            c && Ke(j), p ? f(!1) : a(h);
          },
          children: [
            /* @__PURE__ */ l.jsx("span", { className: "tlui-button__label", draggable: !1, children: I }),
            r && /* @__PURE__ */ l.jsx(Rl, { children: r }),
            e && /* @__PURE__ */ l.jsx(aN, {})
          ]
        }
      );
    case "panel":
      return /* @__PURE__ */ l.jsxs(
        q,
        {
          "data-testid": `${h}.${i}`,
          type: "menu",
          title: D,
          disabled: t,
          onClick: () => a(h),
          children: [
            /* @__PURE__ */ l.jsx(St, { children: I }),
            e ? /* @__PURE__ */ l.jsx(aN, {}) : o && /* @__PURE__ */ l.jsx(Te, { icon: o })
          ]
        }
      );
    case "small-icons":
    case "icons":
      return /* @__PURE__ */ l.jsx(
        q,
        {
          "data-testid": `${h}.${i}`,
          type: "icon",
          title: D,
          disabled: t,
          onClick: () => a(h),
          children: /* @__PURE__ */ l.jsx(Te, { icon: o, small: u === "small-icons" })
        }
      );
    case "keyboard-shortcuts":
      return r ? /* @__PURE__ */ l.jsxs("div", { className: "tlui-shortcuts-dialog__key-pair", "data-testid": `${h}.${i}`, children: [
        /* @__PURE__ */ l.jsx("div", { className: "tlui-shortcuts-dialog__key-pair__key", children: I }),
        /* @__PURE__ */ l.jsx("div", { className: "tlui-shortcuts-dialog__key-pair__value", children: /* @__PURE__ */ l.jsx(Rl, { visibleOnMobileLayout: !0, children: r }) })
      ] }) : (console.warn(
        `Menu item '${s}' isn't shown in the keyboard shortcuts dialog because it doesn't have a keyboard shortcut.`
      ), null);
    case "helper-buttons":
      return /* @__PURE__ */ l.jsxs(q, { type: "low", onClick: () => a(h), children: [
        /* @__PURE__ */ l.jsx(Te, { icon: o }),
        /* @__PURE__ */ l.jsx(St, { children: I })
      ] });
    case "toolbar":
      return /* @__PURE__ */ l.jsx(
        q,
        {
          type: "tool",
          "data-testid": `tools.${i}`,
          "aria-label": m,
          "data-value": i,
          onClick: () => a("toolbar"),
          title: D,
          disabled: t,
          onTouchStart: (j) => {
            Ke(j), a("toolbar");
          },
          role: "radio",
          "aria-checked": d ? "true" : "false",
          children: /* @__PURE__ */ l.jsx(Te, { icon: o })
        }
      );
    case "toolbar-overflow":
      return /* @__PURE__ */ l.jsx(ro, { "aria-label": s, children: /* @__PURE__ */ l.jsx(
        q,
        {
          type: "icon",
          className: "tlui-button-grid__button",
          onClick: () => {
            a("toolbar");
          },
          "data-testid": `tools.more.${i}`,
          title: D,
          disabled: t,
          role: "radio",
          "aria-checked": d ? "true" : "false",
          "data-value": i,
          children: /* @__PURE__ */ l.jsx(Te, { icon: o })
        }
      ) });
    default:
      throw rn(u);
  }
}
function V({ actionId: t = "", ...e }) {
  const i = _t()[t];
  return i ? /* @__PURE__ */ l.jsx(Qe, { ...i, ...e }) : null;
}
const Ak = N.createContext(null);
function Gne({ overrides: t, children: e }) {
  const n = Q(), i = Zt(), { addDialog: r } = po(), s = Iz(), o = N.useMemo(() => {
    const a = [
      {
        id: "select",
        label: "tool.select",
        icon: "tool-pointer",
        kbd: "v",
        readonlyOk: !0,
        onSelect(d) {
          if (n.isIn("select")) {
            const u = n.root.getCurrent();
            u.exit({}, u.id), u.enter({}, u.id);
          }
          n.setCurrentTool("select"), i("select-tool", { source: d, id: "select" });
        }
      },
      {
        id: "hand",
        label: "tool.hand",
        icon: "tool-hand",
        kbd: "h",
        readonlyOk: !0,
        onSelect(d) {
          n.setCurrentTool("hand"), i("select-tool", { source: d, id: "hand" });
        }
      },
      {
        id: "eraser",
        label: "tool.eraser",
        icon: "tool-eraser",
        kbd: "e",
        onSelect(d) {
          n.setCurrentTool("eraser"), i("select-tool", { source: d, id: "eraser" });
        }
      },
      {
        id: "draw",
        label: "tool.draw",
        icon: "tool-pencil",
        kbd: "d,b,x",
        onSelect(d) {
          n.setCurrentTool("draw"), i("select-tool", { source: d, id: "draw" });
        }
      },
      ...[...Fn.values].map((d) => ({
        id: d,
        label: `tool.${d}`,
        meta: {
          geo: d
        },
        kbd: d === "rectangle" ? "r" : d === "ellipse" ? "o" : void 0,
        icon: "geo-" + d,
        onSelect(u) {
          n.run(() => {
            n.setStyleForNextShapes(Fn, d), n.setCurrentTool("geo"), i("select-tool", { source: u, id: `geo-${d}` });
          });
        }
      })),
      {
        id: "arrow",
        label: "tool.arrow",
        icon: "tool-arrow",
        kbd: "a",
        onSelect(d) {
          n.setCurrentTool("arrow"), i("select-tool", { source: d, id: "arrow" });
        }
      },
      {
        id: "line",
        label: "tool.line",
        icon: "tool-line",
        kbd: "l",
        onSelect(d) {
          n.setCurrentTool("line"), i("select-tool", { source: d, id: "line" });
        }
      },
      {
        id: "frame",
        label: "tool.frame",
        icon: "tool-frame",
        kbd: "f",
        onSelect(d) {
          n.setCurrentTool("frame"), i("select-tool", { source: d, id: "frame" });
        }
      },
      {
        id: "text",
        label: "tool.text",
        icon: "tool-text",
        kbd: "t",
        onSelect(d) {
          n.setCurrentTool("text"), i("select-tool", { source: d, id: "text" });
        }
      },
      {
        id: "asset",
        label: "tool.asset",
        icon: "tool-media",
        kbd: "$u",
        onSelect(d) {
          s(), i("select-tool", { source: d, id: "media" });
        }
      },
      {
        id: "note",
        label: "tool.note",
        icon: "tool-note",
        kbd: "n",
        onSelect(d) {
          n.setCurrentTool("note"), i("select-tool", { source: d, id: "note" });
        }
      },
      {
        id: "laser",
        label: "tool.laser",
        readonlyOk: !0,
        icon: "tool-laser",
        kbd: "k",
        onSelect(d) {
          n.setCurrentTool("laser"), i("select-tool", { source: d, id: "laser" });
        }
      },
      {
        id: "embed",
        label: "tool.embed",
        icon: "dot",
        onSelect(d) {
          r({ component: hz }), i("select-tool", { source: d, id: "embed" });
        }
      },
      {
        id: "highlight",
        label: "tool.highlight",
        icon: "tool-highlight",
        // TODO: pick a better shortcut
        kbd: "!d",
        onSelect(d) {
          n.setCurrentTool("highlight"), i("select-tool", { source: d, id: "highlight" });
        }
      }
    ];
    a.push();
    const c = Object.fromEntries(a.map((d) => [d.id, d]));
    return t ? t(n, c, { insertMedia: s }) : c;
  }, [t, n, i, s, r]);
  return /* @__PURE__ */ l.jsx(Ak.Provider, { value: o, children: e });
}
function mo() {
  const t = N.useContext(Ak);
  if (!t)
    throw new Error("useTools must be used within a ToolProvider");
  return t;
}
function ii({ toolId: t = "", ...e }) {
  const i = mo()[t];
  return i ? /* @__PURE__ */ l.jsx(Qe, { ...i, ...e }) : null;
}
function Wne({ children: t }) {
  const e = Q();
  return G(
    "shouldDisplayHandles",
    () => {
      if (e.isInAny("select.idle", "select.pointing_handle", "select.pointing_shape"))
        return !0;
      if (e.isInAny("select.editing_shape")) {
        const i = e.getOnlySelectedShape();
        return i && e.isShapeOfType(i, "note");
      }
      return !1;
    },
    [e]
  ) ? /* @__PURE__ */ l.jsx("svg", { className: "tl-user-handles tl-overlays__item", children: t }) : null;
}
const { PI: Hne } = Math, Za = Hne + 1e-4;
function Tk(t, e = {}) {
  const { size: n = 16, smoothing: i = 0.5 } = e;
  if (t.length === 0 || n <= 0)
    return { left: [], right: [] };
  const r = t[0], s = t[t.length - 1], o = s.runningLength, a = Math.pow(n * i, 2), c = [], d = [];
  let u = t[0].vector, h = t[0].point, g = h, p = h, f = g, M = !1, m;
  for (let y = 0; y < t.length; y++) {
    m = t[y];
    const { point: I, vector: D } = t[y], j = m.vector.dpr(u), w = (y < t.length - 1 ? t[y + 1] : t[y]).vector, A = y < t.length - 1 ? w.dpr(m.vector) : 1, b = j < 0 && !M, T = A !== null && A < 0.2;
    if (b || T) {
      if (A > -0.62 && o - m.runningLength > m.radius) {
        const v = u.clone().mul(m.radius);
        u.clone().cpr(w) < 0 ? (p = x.Add(I, v), f = x.Sub(I, v)) : (p = x.Sub(I, v), f = x.Add(I, v)), c.push(p), d.push(f);
      } else {
        const v = u.clone().mul(m.radius).per(), P = x.Sub(m.input, v);
        for (let C = 1 / 13, z = 0; z < 1; z += C)
          p = x.RotWith(P, m.input, Za * z), c.push(p), f = x.RotWith(P, m.input, Za + Za * -z), d.push(f);
      }
      h = p, g = f, T && (M = !0);
      continue;
    }
    if (M = !1, m === r || m === s) {
      const v = x.Per(D).mul(m.radius);
      c.push(x.Sub(I, v)), d.push(x.Add(I, v));
      continue;
    }
    const E = x.Lrp(w, D, A).per().mul(m.radius);
    p = x.Sub(I, E), (y <= 1 || x.Dist2(h, p) > a) && (c.push(p), h = p), f = x.Add(I, E), (y <= 1 || x.Dist2(g, f) > a) && (d.push(f), g = f), u = D;
  }
  return {
    left: c,
    right: d
  };
}
function hj(t, e = {}) {
  const { size: n = 16, start: i = {}, end: r = {}, last: s = !1 } = e, { cap: o = !0 } = i, { cap: a = !0 } = r;
  if (t.length === 0 || n <= 0)
    return [];
  const c = t[0], d = t[t.length - 1], u = d.runningLength, h = i.taper === !1 ? 0 : i.taper === !0 ? Math.max(n, u) : i.taper, g = r.taper === !1 ? 0 : r.taper === !0 ? Math.max(n, u) : r.taper, { left: p, right: f } = Tk(t, e), M = c.point, m = t.length > 1 ? t[t.length - 1].point : x.AddXY(c.point, 1, 1);
  if (t.length === 1 && (!(h || g) || s)) {
    const j = x.Add(
      M,
      x.Sub(M, m).uni().per().mul(-c.radius)
    ), w = [];
    for (let A = 1 / 13, b = A; b <= 1; b += A)
      w.push(x.RotWith(j, M, Za * 2 * b));
    return w;
  }
  const y = [];
  if (!(h || g && t.length === 1)) if (o)
    for (let j = 1 / 8, w = j; w <= 1; w += j) {
      const A = x.RotWith(f[0], M, Za * w);
      y.push(A);
    }
  else {
    const j = x.Sub(p[0], f[0]), w = x.Mul(j, 0.5), A = x.Mul(j, 0.51);
    y.push(
      x.Sub(M, w),
      x.Sub(M, A),
      x.Add(M, A),
      x.Add(M, w)
    );
  }
  const I = [], D = d.vector.clone().per().neg();
  if (g || h && t.length === 1)
    I.push(m);
  else if (a) {
    const j = x.Add(m, x.Mul(D, d.radius));
    for (let w = 1 / 29, A = w; A < 1; A += w)
      I.push(x.RotWith(j, m, Za * 3 * A));
  } else
    I.push(
      x.Add(m, x.Mul(D, d.radius)),
      x.Add(m, x.Mul(D, d.radius * 0.99)),
      x.Sub(m, x.Mul(D, d.radius * 0.99)),
      x.Sub(m, x.Mul(D, d.radius))
    );
  return p.concat(I, f.reverse(), y);
}
const Vne = 0.025, Kne = 0.01;
function Fr(t, e = {}) {
  var m;
  const { streamline: n = 0.5, size: i = 16, simulatePressure: r = !1 } = e;
  if (t.length === 0) return [];
  const s = 0.15 + (1 - n) * 0.85;
  let o = t.map(x.From), a = 0;
  if (!r) {
    let y = o[0];
    for (; y && !(y.z >= Vne); )
      o.shift(), y = o[0];
  }
  if (!r) {
    let y = o[o.length - 1];
    for (; y && !(y.z >= Kne); )
      o.pop(), y = o[o.length - 1];
  }
  if (o.length === 0)
    return [
      {
        point: x.From(t[0]),
        input: x.From(t[0]),
        pressure: r ? 0.5 : 0.15,
        vector: new x(1, 1),
        distance: 0,
        runningLength: 0,
        radius: 1
      }
    ];
  let c = o[1];
  for (; c && !(x.Dist2(c, o[0]) > (i / 3) ** 2); )
    o[0].z = Math.max(o[0].z, c.z), o.splice(1, 1), c = o[1];
  const d = o.pop();
  for (c = o[o.length - 1]; c && !(x.Dist2(c, d) > (i / 3) ** 2); )
    o.pop(), c = o[o.length - 1], a++;
  o.push(d);
  const u = e.last || !e.simulatePressure || o.length > 1 && x.Dist2(o[o.length - 1], o[o.length - 2]) < i ** 2 || a > 0;
  if (o.length === 2 && e.simulatePressure) {
    const y = o[1];
    o = o.slice(0, -1);
    for (let I = 1; I < 5; I++) {
      const D = x.Lrp(o[0], y, I / 4);
      D.z = (o[0].z + (y.z - o[0].z)) * I / 4, o.push(D);
    }
  }
  const h = [
    {
      point: o[0],
      input: o[0],
      pressure: r ? 0.5 : o[0].z,
      vector: new x(1, 1),
      distance: 0,
      runningLength: 0,
      radius: 1
    }
  ];
  let g = 0, p = h[0], f, M;
  u && n > 0 && o.push(o[o.length - 1].clone());
  for (let y = 1, I = o.length; y < I; y++)
    f = !s || e.last && y === I - 1 ? o[y].clone() : o[y].clone().lrp(p.point, 1 - s), !p.point.equals(f) && (M = x.Dist(f, p.point), g += M, !(y < 4 && g < i) && (p = {
      input: o[y],
      // The adjusted point
      point: f,
      // The input pressure (or .5 if not specified)
      pressure: r ? 0.5 : o[y].z,
      // The vector from the current point to the previous point
      vector: x.Sub(p.point, f).uni(),
      // The distance between the current point and the previous point
      distance: M,
      // The total distance so far
      runningLength: g,
      // The stroke point's radius
      radius: 1
    }, h.push(p)));
  if ((m = h[1]) != null && m.vector && (h[0].vector = h[1].vector.clone()), g < 1) {
    const y = Math.max(0.5, ...h.map((I) => I.pressure));
    h.forEach((I) => I.pressure = y);
  }
  return h;
}
const { min: ks } = Math, im = 0.275;
function gf(t, e) {
  const {
    size: n = 16,
    thinning: i = 0.5,
    simulatePressure: r = !0,
    easing: s = (m) => m,
    start: o = {},
    end: a = {}
  } = e, { easing: c = on.easeOutQuad } = o, { easing: d = on.easeOutCubic } = a, u = t[t.length - 1].runningLength;
  let h, g = t[0].pressure, p;
  if (!r && u < n) {
    const m = t.reduce((y, I) => Math.max(y, I.pressure), 0.5);
    return t.forEach((y) => {
      y.pressure = m, y.radius = n * s(0.5 - i * (0.5 - y.pressure));
    }), t;
  } else {
    let m;
    for (let y = 0, I = t.length; y < I && (p = t[y], !(p.runningLength > n * 5)); y++) {
      const D = ks(1, p.distance / n);
      if (r) {
        const j = ks(1, 1 - D);
        m = ks(1, g + (j - g) * (D * im));
      } else
        m = ks(1, g + (p.pressure - g) * 0.5);
      g = g + (m - g) * 0.5;
    }
    for (let y = 0; y < t.length; y++) {
      if (p = t[y], i) {
        let { pressure: I } = p;
        const D = ks(1, p.distance / n);
        if (r) {
          const j = ks(1, 1 - D);
          I = ks(1, g + (j - g) * (D * im));
        } else
          I = ks(
            1,
            g + (I - g) * (D * im)
          );
        p.radius = n * s(0.5 - i * (0.5 - I)), g = I;
      } else
        p.radius = n / 2;
      h === void 0 && (h = p.radius);
    }
  }
  const f = o.taper === !1 ? 0 : o.taper === !0 ? Math.max(n, u) : o.taper, M = a.taper === !1 ? 0 : a.taper === !0 ? Math.max(n, u) : a.taper;
  if (f || M)
    for (let m = 0; m < t.length; m++) {
      p = t[m];
      const { runningLength: y } = p, I = y < f ? c(y / f) : 1, D = u - y < M ? d((u - y) / M) : 1;
      p.radius = Math.max(0.01, p.radius * Math.min(I, D));
    }
  return t;
}
function Xne(t, e = {}) {
  return hj(
    gf(Fr(t, e), e),
    e
  );
}
function cN({ scribble: t, zoom: e, color: n, opacity: i, className: r }) {
  if (!t.points.length) return null;
  const s = Xne(t.points, {
    size: t.size / e,
    start: { taper: t.taper, easing: on.linear },
    last: t.state === "stopping",
    simulatePressure: !1,
    streamline: 0.32
  });
  let o;
  if (s.length < 4) {
    const a = t.size / e / 2, { x: c, y: d } = t.points[t.points.length - 1];
    o = `M ${c - a},${d} a ${a},${a} 0 1,0 ${a * 2},0 a ${a},${a} 0 1,0 ${-a * 2},0`;
  } else
    o = nS(s);
  return /* @__PURE__ */ l.jsx("svg", { className: r && ce("tl-overlays__item", r), children: /* @__PURE__ */ l.jsx(
    "path",
    {
      className: "tl-scribble",
      d: o,
      fill: n ?? `var(--color-${t.color})`,
      opacity: i ?? t.opacity
    }
  ) });
}
const Jne = ({ bounds: t, rotation: e }) => {
  const n = Q();
  return G(
    "should display",
    () => n.isInAny(
      "select.idle",
      "select.brushing",
      "select.scribble_brushing",
      "select.pointing_shape",
      "select.pointing_selection",
      "text.resizing"
    ),
    [n]
  ) ? /* @__PURE__ */ l.jsx(Uv, { bounds: t, rotation: e }) : null;
};
function qne({
  size: t,
  width: e,
  height: n,
  hideAlternateHandles: i
}) {
  const r = k(t / 3), s = r / 2;
  return /* @__PURE__ */ l.jsxs("svg", { className: "tl-overlays__item", children: [
    /* @__PURE__ */ l.jsx(
      "polyline",
      {
        className: "tl-corner-crop-handle",
        points: `
						${k(0 - s)},${k(t)} 
						${k(0 - s)},${k(0 - s)} 
						${k(t)},${k(0 - s)}`,
        strokeWidth: r,
        "data-testid": "selection.crop.top_left",
        "aria-label": "top_left handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "line",
      {
        className: ce("tl-corner-crop-edge-handle", {
          "tl-hidden": i
        }),
        x1: k(e / 2 - t),
        y1: k(0 - s),
        x2: k(e / 2 + t),
        y2: k(0 - s),
        strokeWidth: r,
        "data-testid": "selection.crop.top",
        "aria-label": "top handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "polyline",
      {
        className: ce("tl-corner-crop-handle", {
          "tl-hidden": i
        }),
        points: `
						${k(e - t)},${k(0 - s)} 
						${k(e + s)},${k(0 - s)} 
						${k(e + s)},${k(t)}`,
        strokeWidth: r,
        "data-testid": "selection.crop.top_right",
        "aria-label": "top_right handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "line",
      {
        className: ce("tl-corner-crop-edge-handle", {
          "tl-hidden": i
        }),
        x1: k(e + s),
        y1: k(n / 2 - t),
        x2: k(e + s),
        y2: k(n / 2 + t),
        strokeWidth: r,
        "data-testid": "selection.crop.right",
        "aria-label": "right handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "polyline",
      {
        className: "tl-corner-crop-handle",
        points: `
						${k(e + s)},${k(n - t)} 
						${k(e + s)},${k(n + s)}
						${k(e - t)},${k(n + s)}`,
        strokeWidth: r,
        "data-testid": "selection.crop.bottom_right",
        "aria-label": "bottom_right handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "line",
      {
        className: ce("tl-corner-crop-edge-handle", {
          "tl-hidden": i
        }),
        x1: k(e / 2 - t),
        y1: k(n + s),
        x2: k(e / 2 + t),
        y2: k(n + s),
        strokeWidth: r,
        "data-testid": "selection.crop.bottom",
        "aria-label": "bottom handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "polyline",
      {
        className: ce("tl-corner-crop-handle", {
          "tl-hidden": i
        }),
        points: `
						${k(0 + t)},${k(n + s)} 
						${k(0 - s)},${k(n + s)}
						${k(0 - s)},${k(n - t)}`,
        strokeWidth: r,
        "data-testid": "selection.crop.bottom_left",
        "aria-label": "bottom_left handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "line",
      {
        className: ce("tl-corner-crop-edge-handle", {
          "tl-hidden": i
        }),
        x1: k(0 - s),
        y1: k(n / 2 - t),
        x2: k(0 - s),
        y2: k(n / 2 + t),
        strokeWidth: r,
        "data-testid": "selection.crop.left",
        "aria-label": "left handle"
      }
    )
  ] });
}
const _ne = Vt(function({
  bounds: e,
  rotation: n
}) {
  const i = Q(), r = le(null), s = ji(), o = Kt("top"), a = Kt("right"), c = Kt("bottom"), d = Kt("left"), u = Kt("top_left"), h = Kt("top_right"), g = Kt("bottom_right"), p = Kt("bottom_left"), f = i.getInstanceState().cursor.type === "default", M = i.getInstanceState().isCoarsePointer, m = i.getOnlySelectedShape(), y = m && i.isShapeOrAncestorLocked(m), I = m ? i.getShapeUtil(m).expandSelectionOutlinePx(m) : 0;
  if (Ko(r, e == null ? void 0 : e.x, e == null ? void 0 : e.y, 1, i.getSelectionRotation(), {
    x: -I,
    y: -I
  }), m && i.isShapeHidden(m) || !e) return null;
  e = e.clone().expandBy(I).zeroFix();
  const D = i.getZoomLevel(), j = i.getInstanceState().isChangingStyle, w = e.width, A = e.height, b = 8 / D, T = w < b * 2, E = A < b * 2, v = w < b * 4, P = A < b * 4, C = w < b * 5, z = A < b * 5, O = M ? 1.75 : 1, R = 6 / D * O, U = (v ? R / 2 : R) * (O * 0.75), F = (P ? R / 2 : R) * (O * 0.75), H = (m ? !i.getShapeUtil(m).hideSelectionBoundsFg(m) : !0) && !j;
  let Z = H && i.isInAny(
    "select.idle",
    "select.brushing",
    "select.scribble_brushing",
    "select.pointing_canvas",
    "select.pointing_selection",
    "select.pointing_shape",
    "select.crop.idle",
    "select.crop.pointing_crop",
    "select.crop.pointing_crop_handle",
    "select.pointing_resize_handle"
  ) || H && i.isIn("select.resizing") && m && i.isShapeOfType(m, "text");
  m && Z && mt.isFirefox && i.isShapeOfType(m, "embed") && (Z = !1);
  const te = i.isInAny(
    "select.crop.idle",
    "select.crop.pointing_crop",
    "select.crop.pointing_crop_handle"
  ) && !j && !s, oe = i.isInAny(
    "select.idle",
    "select.pointing_selection",
    "select.pointing_shape",
    "select.crop.idle"
  ) && !j && !s, me = !M && !(T || E) && (oe || te) && (m ? !i.getShapeUtil(m).hideRotateHandle(m) : !0) && !y, he = M && (!v || !P) && (oe || te) && (m ? !i.getShapeUtil(m).hideRotateHandle(m) : !0) && !y, ve = oe && (m ? i.getShapeUtil(m).canResize(m) && !i.getShapeUtil(m).hideResizeHandles(m) : !0) && !te && !y, ie = T || E, Ue = T && E, ge = C || z, Re = ve || te, ye = !me, Be = !oe || !he, We = !oe || !Re, lt = !oe || !Re || ie, $ = !oe || !Re || ie, X = !oe || !Re || Ue && !te;
  let Ie = !0, je = !0;
  if (te)
    Ie = ge, je = ge;
  else if (ve) {
    Ie = ie || Ue || M;
    const Dt = M && m && m.type === "text";
    je = Ie && !Dt;
  }
  const Oe = Math.min(24 / D, A - F * 3), zt = oe && M && m && i.isShapeOfType(m, "text") && Oe * D >= 4;
  return /* @__PURE__ */ l.jsx("svg", { className: "tl-overlays__item tl-selection__fg", "data-testid": "selection-foreground", children: /* @__PURE__ */ l.jsxs("g", { ref: r, children: [
    Z && /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: "tl-selection__fg__outline",
        width: k(w),
        height: k(A)
      }
    ),
    /* @__PURE__ */ l.jsx(
      Ku,
      {
        "data-testid": "selection.rotate.top-left",
        cx: 0,
        cy: 0,
        targetSize: R,
        corner: "top_left_rotate",
        cursor: f ? Et("nwse-rotate", n) : void 0,
        isHidden: ye
      }
    ),
    /* @__PURE__ */ l.jsx(
      Ku,
      {
        "data-testid": "selection.rotate.top-right",
        cx: w + R * 3,
        cy: 0,
        targetSize: R,
        corner: "top_right_rotate",
        cursor: f ? Et("nesw-rotate", n) : void 0,
        isHidden: ye
      }
    ),
    /* @__PURE__ */ l.jsx(
      Ku,
      {
        "data-testid": "selection.rotate.bottom-left",
        cx: 0,
        cy: A + R * 3,
        targetSize: R,
        corner: "bottom_left_rotate",
        cursor: f ? Et("swne-rotate", n) : void 0,
        isHidden: ye
      }
    ),
    /* @__PURE__ */ l.jsx(
      Ku,
      {
        "data-testid": "selection.rotate.bottom-right",
        cx: w + R * 3,
        cy: A + R * 3,
        targetSize: R,
        corner: "bottom_right_rotate",
        cursor: f ? Et("senw-rotate", n) : void 0,
        isHidden: ye
      }
    ),
    /* @__PURE__ */ l.jsx(
      eie,
      {
        "data-testid": "selection.rotate.mobile",
        cx: v ? -R * 1.5 : w / 2,
        cy: v ? A / 2 : -R * 1.5,
        size: b,
        isHidden: Be
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": Ie
        }),
        "data-testid": "selection.resize.top",
        "aria-label": "top target",
        pointerEvents: "all",
        x: 0,
        y: k(0 - (P ? F * 2 : F)),
        width: k(w),
        height: k(Math.max(1, F * 2)),
        style: f ? { cursor: Et("ns-resize", n) } : void 0,
        ...o
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": je
        }),
        "data-testid": "selection.resize.right",
        "aria-label": "right target",
        pointerEvents: "all",
        x: k(w - (v ? 0 : U)),
        y: 0,
        height: k(A),
        width: k(Math.max(1, U * 2)),
        style: f ? { cursor: Et("ew-resize", n) } : void 0,
        ...a
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": Ie
        }),
        "data-testid": "selection.resize.bottom",
        "aria-label": "bottom target",
        pointerEvents: "all",
        x: 0,
        y: k(A - (P ? 0 : F)),
        width: k(w),
        height: k(Math.max(1, F * 2)),
        style: f ? { cursor: Et("ns-resize", n) } : void 0,
        ...c
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": je
        }),
        "data-testid": "selection.resize.left",
        "aria-label": "left target",
        pointerEvents: "all",
        x: k(0 - (v ? U * 2 : U)),
        y: 0,
        height: k(A),
        width: k(Math.max(1, U * 2)),
        style: f ? { cursor: Et("ew-resize", n) } : void 0,
        ...d
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": We
        }),
        "data-testid": "selection.target.top-left",
        "aria-label": "top-left target",
        pointerEvents: "all",
        x: k(0 - (v ? U * 2 : U * 1.5)),
        y: k(0 - (P ? F * 2 : F * 1.5)),
        width: k(U * 3),
        height: k(F * 3),
        style: f ? { cursor: Et("nwse-resize", n) } : void 0,
        ...u
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": lt
        }),
        "data-testid": "selection.target.top-right",
        "aria-label": "top-right target",
        pointerEvents: "all",
        x: k(w - (v ? 0 : U * 1.5)),
        y: k(0 - (P ? F * 2 : F * 1.5)),
        width: k(U * 3),
        height: k(F * 3),
        style: f ? { cursor: Et("nesw-resize", n) } : void 0,
        ...h
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": X
        }),
        "data-testid": "selection.target.bottom-right",
        "aria-label": "bottom-right target",
        pointerEvents: "all",
        x: k(w - (v ? U : U * 1.5)),
        y: k(A - (P ? F : F * 1.5)),
        width: k(U * 3),
        height: k(F * 3),
        style: f ? { cursor: Et("nwse-resize", n) } : void 0,
        ...g
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": $
        }),
        "data-testid": "selection.target.bottom-left",
        "aria-label": "bottom-left target",
        pointerEvents: "all",
        x: k(0 - (v ? U * 3 : U * 1.5)),
        y: k(A - (P ? 0 : F * 1.5)),
        width: k(U * 3),
        height: k(F * 3),
        style: f ? { cursor: Et("nesw-resize", n) } : void 0,
        ...p
      }
    ),
    ve && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.resize.top-left",
          className: ce("tl-corner-handle", {
            "tl-hidden": We
          }),
          "aria-label": "top_left handle",
          x: k(0 - b / 2),
          y: k(0 - b / 2),
          width: k(b),
          height: k(b)
        }
      ),
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.resize.top-right",
          className: ce("tl-corner-handle", {
            "tl-hidden": lt
          }),
          "aria-label": "top_right handle",
          x: k(w - b / 2),
          y: k(0 - b / 2),
          width: k(b),
          height: k(b)
        }
      ),
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.resize.bottom-right",
          className: ce("tl-corner-handle", {
            "tl-hidden": X
          }),
          "aria-label": "bottom_right handle",
          x: k(w - b / 2),
          y: k(A - b / 2),
          width: k(b),
          height: k(b)
        }
      ),
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.resize.bottom-left",
          className: ce("tl-corner-handle", {
            "tl-hidden": $
          }),
          "aria-label": "bottom_left handle",
          x: k(0 - b / 2),
          y: k(A - b / 2),
          width: k(b),
          height: k(b)
        }
      )
    ] }),
    zt && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.text-resize.left.handle",
          className: "tl-text-handle",
          "aria-label": "bottom_left handle",
          x: k(0 - b / 4),
          y: k(A / 2 - Oe / 2),
          rx: b / 4,
          width: k(b / 2),
          height: k(Oe)
        }
      ),
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.text-resize.right.handle",
          className: "tl-text-handle",
          "aria-label": "bottom_left handle",
          rx: b / 4,
          x: k(w - b / 4),
          y: k(A / 2 - Oe / 2),
          width: k(b / 2),
          height: k(Oe)
        }
      )
    ] }),
    te && /* @__PURE__ */ l.jsx(
      qne,
      {
        size: b,
        width: w,
        height: A,
        hideAlternateHandles: ge
      }
    )
  ] }) });
}), Ku = function({
  cx: e,
  cy: n,
  targetSize: i,
  corner: r,
  cursor: s,
  isHidden: o,
  "data-testid": a
}) {
  const c = Kt(r);
  return /* @__PURE__ */ l.jsx(
    "rect",
    {
      className: ce("tl-transparent", "tl-rotate-corner", { "tl-hidden": o }),
      "data-testid": a,
      "aria-label": `${r} target`,
      pointerEvents: "all",
      x: k(e - i * 3),
      y: k(n - i * 3),
      width: k(Math.max(1, i * 3)),
      height: k(Math.max(1, i * 3)),
      cursor: s,
      ...c
    }
  );
}, $ne = Math.sqrt(Math.PI), eie = function({
  cx: e,
  cy: n,
  size: i,
  isHidden: r,
  "data-testid": s
}) {
  const o = Kt("mobile_rotate"), a = Q(), c = G("zoom level", () => a.getZoomLevel(), [a]), d = Math.max(14 * (1 / c), 20 / Math.max(1, c));
  return /* @__PURE__ */ l.jsxs("g", { children: [
    /* @__PURE__ */ l.jsx(
      "circle",
      {
        "data-testid": s,
        pointerEvents: "all",
        className: ce("tl-transparent", "tl-mobile-rotate__bg", { "tl-hidden": r }),
        cx: e,
        cy: n,
        r: d,
        ...o
      }
    ),
    /* @__PURE__ */ l.jsx(
      "circle",
      {
        className: ce("tl-mobile-rotate__fg", { "tl-hidden": r }),
        cx: e,
        cy: n,
        r: i / $ne
      }
    )
  ] });
};
function tie() {
  const t = Q();
  return G(
    "is in a valid select state",
    () => t.isInAny(
      "select.idle",
      "select.brushing",
      "select.scribble_brushing",
      "select.editing_shape",
      "select.pointing_shape",
      "select.pointing_selection",
      "select.pointing_handle"
    ),
    [t]
  ) ? /* @__PURE__ */ l.jsx(Rv, {}) : null;
}
function DI(t, e, n) {
  const { arrowheadStart: i, arrowheadEnd: r } = e.props, s = Ea(t, e, n), o = s.start.clone(), a = s.end.clone(), c = x.Med(o, a);
  if (x.Equals(o, a))
    return {
      bindings: n,
      isStraight: !0,
      start: {
        handle: o,
        point: o,
        arrowhead: e.props.arrowheadStart
      },
      end: {
        handle: a,
        point: a,
        arrowhead: e.props.arrowheadEnd
      },
      middle: c,
      isValid: !1,
      length: 0
    };
  const d = x.Sub(a, o).uni(), u = Hg(t, e, "start"), h = Hg(t, e, "end"), g = t.getShapePageTransform(e);
  lN(
    a,
    // <-- will be mutated
    s.start,
    g,
    h
  ), lN(
    o,
    // <-- will be mutated
    s.end,
    g,
    u
  );
  let p = 0, f = 0, M = 0, m = 0, y = Ca * e.props.scale;
  const I = u && h && u.shape === h.shape, D = u && h ? gj(t, u.shape.id, h.shape.id) : "safe";
  D === "safe" && u && h && !I && !u.isExact && !h.isExact && (h.didIntersect && !u.didIntersect ? u.isClosed && o.setTo(a.clone().add(d.clone().mul(Ca * e.props.scale))) : h.didIntersect || h.isClosed && a.setTo(o.clone().sub(d.clone().mul(Ca * e.props.scale))));
  const j = x.Sub(a, o), w = x.Len(j) ? j.uni() : x.From(j), A = !x.Equals(w, d);
  I || (D !== "start-contains-end" && u && i !== "none" && !u.isExact && (M = Ur[e.props.size] / 2 + ("size" in u.shape.props ? Ur[u.shape.props.size] / 2 : 0), p = (Vg + M) * e.props.scale, y += M * e.props.scale), D !== "end-contains-start" && h && r !== "none" && !h.isExact && (m = Ur[e.props.size] / 2 + ("size" in h.shape.props ? Ur[h.shape.props.size] / 2 : 0), f = (Vg + m) * e.props.scale, y += m * e.props.scale));
  const b = o.clone().add(w.clone().mul(p * (A ? -1 : 1))), T = a.clone().sub(w.clone().mul(f * (A ? -1 : 1)));
  x.DistMin(b, T, y) && (p !== 0 && f !== 0 ? (p *= -1.5, f *= -1.5) : p !== 0 ? p *= -1 : f !== 0 && (f *= -1)), o.add(w.clone().mul(p * (A ? -1 : 1))), a.sub(w.clone().mul(f * (A ? -1 : 1))), A ? (u && h && a.setTo(x.Add(o, w.clone().mul(-Ca * e.props.scale))), c.setTo(x.Med(s.start, s.end))) : c.setTo(x.Med(o, a));
  const E = x.Dist(o, a);
  return {
    bindings: n,
    isStraight: !0,
    start: {
      handle: s.start,
      point: o,
      arrowhead: e.props.arrowheadStart
    },
    end: {
      handle: s.end,
      point: a,
      arrowhead: e.props.arrowheadEnd
    },
    middle: c,
    isValid: E > 0,
    length: E
  };
}
function lN(t, e, n, i) {
  if (i === void 0 || i.isExact)
    return;
  const r = ne.applyToPoint(n, e), s = ne.applyToPoint(n, t), o = ne.applyToPoint(ne.Inverse(i.transform), r), a = ne.applyToPoint(ne.Inverse(i.transform), s), c = i.isClosed, u = (c ? aS : IV)(o, a, i.outline);
  let h;
  if (u !== null && (h = u.sort((f, M) => x.Dist2(f, o) - x.Dist2(M, o))[0] ?? (c ? void 0 : a)), h === void 0)
    return;
  const g = ne.applyToPoint(i.transform, h), p = ne.applyToPoint(ne.Inverse(n), g);
  t.setTo(p), i.didIntersect = !0;
}
function nie(t, e, n) {
  const { arrowheadEnd: i, arrowheadStart: r } = e.props, s = e.props.bend;
  if (Math.abs(s) > Math.abs(e.props.bend * (aie * e.props.scale)))
    return DI(t, e, n);
  const o = Ea(t, e, n), a = x.Med(o.start, o.end), c = x.Sub(o.end, o.start), d = x.Len(c) ? c.uni() : x.From(c), u = x.Add(a, d.per().mul(-s)), h = Hg(t, e, "start"), g = Hg(t, e, "end"), p = o.start.clone(), f = o.end.clone(), M = u.clone();
  if (x.Equals(p, f))
    return {
      bindings: n,
      isStraight: !0,
      start: {
        handle: p,
        point: p,
        arrowhead: e.props.arrowheadStart
      },
      end: {
        handle: f,
        point: f,
        arrowhead: e.props.arrowheadEnd
      },
      middle: M,
      isValid: !1,
      length: 0
    };
  const m = e.props.bend < 0, y = m ? fd : yv, I = dN(p, f, M), D = x.Angle(I.center, p), j = x.Angle(I.center, f), w = y(D, j);
  if (I.length === 0 || I.size === 0 || !C0(I.length) || !C0(I.size))
    return DI(t, e, n);
  const A = p.clone(), b = f.clone(), T = M.clone(), E = t.getShapePageTransform(e);
  let v = 0, P = 0, C = Ca * e.props.scale;
  if (h && !h.isExact) {
    const te = ne.applyToPoint(E, A), oe = ne.applyToPoint(E, I.center), me = ne.applyToPoint(E, b), he = ne.Inverse(h.transform), ve = ne.applyToPoint(he, te), ie = ne.applyToPoint(he, oe), Ue = ne.applyToPoint(he, me), { isClosed: ge } = h, Re = ge ? Vy : $0;
    let ye, Be = Re(ie, I.radius, h.outline);
    if (Be) {
      const We = ie.angle(ve), lt = ie.angle(Ue), $ = y(We, lt);
      Be = Be.filter(
        (Ie) => y(We, ie.angle(Ie)) <= $
      );
      const X = $ * 0.25;
      Be.sort(
        ge ? (Ie, je) => Math.abs(y(We, ie.angle(Ie)) - X) < Math.abs(y(We, ie.angle(je)) - X) ? -1 : 1 : (Ie, je) => y(We, ie.angle(Ie)) < y(We, ie.angle(je)) ? -1 : 1
      ), ye = Be[0] ?? (ge ? void 0 : ve);
    } else
      ye = ge ? void 0 : ve;
    if (ye && (A.setTo(
      t.getPointInShapeSpace(e, ne.applyToPoint(h.transform, ye))
    ), h.didIntersect = !0, r !== "none")) {
      const We = Ur[e.props.size] / 2 + ("size" in h.shape.props ? Ur[h.shape.props.size] / 2 : 0);
      v = (Vg + We) * e.props.scale, C += We * e.props.scale;
    }
  }
  if (g && !g.isExact) {
    const te = ne.applyToPoint(E, A), oe = ne.applyToPoint(E, b), me = ne.applyToPoint(E, I.center), he = ne.Inverse(g.transform), ve = ne.applyToPoint(he, te), ie = ne.applyToPoint(he, me), Ue = ne.applyToPoint(he, oe), ge = g.isClosed, Re = ge ? Vy : $0;
    let ye, Be = Re(ie, I.radius, g.outline);
    if (Be) {
      const We = ie.angle(ve), lt = ie.angle(Ue), $ = y(We, lt), X = $ * 0.75;
      Be = Be.filter(
        (Ie) => y(We, ie.angle(Ie)) <= $
      ), Be.sort(
        ge ? (Ie, je) => Math.abs(y(We, ie.angle(Ie)) - X) < Math.abs(y(We, ie.angle(je)) - X) ? -1 : 1 : (Ie, je) => y(We, ie.angle(Ie)) < y(We, ie.angle(je)) ? -1 : 1
      ), Be[0] ? ye = Be[0] : ye = ge ? void 0 : Ue;
    } else
      ye = ge ? void 0 : Ue;
    if (ye && (b.setTo(
      t.getPointInShapeSpace(e, ne.applyToPoint(g.transform, ye))
    ), g.didIntersect = !0, i !== "none")) {
      const We = Ur[e.props.size] / 2 + ("size" in g.shape.props ? Ur[g.shape.props.size] / 2 : 0);
      P = (Vg + We) * e.props.scale, C += We * e.props.scale;
    }
  }
  let z = x.Angle(I.center, A), O = x.Angle(I.center, b), R = y(z, O), U = R * I.radius;
  const F = A.clone(), H = b.clone();
  if (v !== 0 && F.setTo(I.center).add(
    x.FromAngle(z + R * (v / U * (m ? 1 : -1))).mul(I.radius)
  ), P !== 0 && H.setTo(I.center).add(
    x.FromAngle(O + R * (P / U * (m ? -1 : 1))).mul(I.radius)
  ), x.DistMin(F, H, C) && (v !== 0 && P !== 0 ? (v *= -1.5, P *= -1.5) : v !== 0 ? v *= -2 : P !== 0 && (P *= -2)), v !== 0 && A.setTo(I.center).add(
    x.FromAngle(z + R * (v / U * (m ? 1 : -1))).mul(I.radius)
  ), P !== 0 && b.setTo(I.center).add(
    x.FromAngle(O + R * (P / U * (m ? -1 : 1))).mul(I.radius)
  ), h && g && !h.isExact && !g.isExact) {
    z = x.Angle(I.center, A), O = x.Angle(I.center, b), R = y(z, O), U = R * I.radius;
    const te = gj(
      t,
      h.shape.id,
      g.shape.id
    );
    te === "double-bound" && U < 30 ? (A.setTo(p), b.setTo(f), T.setTo(M)) : te === "safe" && (h && !h.didIntersect && A.setTo(p), (g && !g.didIntersect || y(D, z) > y(D, O)) && b.setTo(I.center).add(
      x.FromAngle(
        z + R * (Math.min(0.9, Ca * e.props.scale / U) * (m ? 1 : -1))
      ).mul(I.radius)
    ));
  }
  iie(
    I.center,
    I.radius,
    A,
    b,
    T,
    w,
    m
  ), A.equals(b) && (A.setTo(T.clone().addXY(1, 1)), b.setTo(T.clone().subXY(1, 1))), p.setTo(A), f.setTo(b), M.setTo(T);
  const Z = dN(p, f, M);
  return {
    bindings: n,
    isStraight: !1,
    start: {
      point: p,
      handle: o.start,
      arrowhead: e.props.arrowheadStart
    },
    end: {
      point: f,
      handle: o.end,
      arrowhead: e.props.arrowheadEnd
    },
    middle: M,
    handleArc: I,
    bodyArc: Z,
    isValid: Z.length !== 0 && isFinite(Z.center.x) && isFinite(Z.center.y)
  };
}
function dN(t, e, n) {
  const i = qx(t, e, n) ?? x.Med(t, e), r = x.Dist(i, t), s = +x.Clockwise(t, n, e), o = ((t.y - e.y) ** 2 + (t.x - e.x) ** 2) ** 0.5, a = ((e.y - n.y) ** 2 + (e.x - n.x) ** 2) ** 0.5, c = ((n.y - t.y) ** 2 + (n.x - t.x) ** 2) ** 0.5, d = Math.acos((a * a + c * c - o * o) / (2 * a * c)) * 2, u = +(st > d), h = (gt - d) * (s ? 1 : -1), g = h * r;
  return {
    center: i,
    radius: r,
    size: h,
    length: g,
    largeArcFlag: u,
    sweepFlag: s
  };
}
function iie(t, e, n, i, r, s, o) {
  const a = x.Angle(t, n), c = x.Angle(t, i);
  let d = fd(a, c);
  if (o || (d = gt - d), r.setTo(t).add(x.FromAngle(a + d * (0.5 * (o ? 1 : -1))).mul(e)), d > s) {
    r.rotWith(t, st);
    const u = i.clone();
    i.setTo(n), n.setTo(u);
  }
}
const rie = 8;
function sie(t) {
  return Math.abs(t.props.bend) < rie * t.props.scale;
}
function Hg(t, e, n) {
  const i = t.getBindingsFromShape(e, "arrow").find((c) => c.props.terminal === n);
  if (!i) return;
  const r = t.getShape(i.toId);
  if (!r) return;
  const s = t.getShapePageTransform(r), o = t.getShapeGeometry(r), a = o instanceof Ki ? o.children[0].vertices : o.vertices;
  return {
    shape: r,
    transform: s,
    isClosed: o.isClosed,
    isExact: i.props.isExact,
    didIntersect: !1,
    outline: a
  };
}
function uN(t, e, n, i) {
  const r = t.getShape(n.toId);
  if (r) {
    const { point: s, size: o } = t.getShapeGeometry(r).bounds, a = x.Add(
      s,
      x.MulV(
        // if the parent is the bound shape, then it's ALWAYS precise
        n.props.isPrecise || i ? n.props.normalizedAnchor : { x: 0.5, y: 0.5 },
        o
      )
    ), c = ne.applyToPoint(t.getShapePageTransform(r), a);
    return ne.applyToPoint(ne.Inverse(e), c);
  } else
    return new x(0, 0);
}
function li(t, e) {
  const n = t.getBindingsFromShape(e, "arrow");
  return {
    start: n.find((i) => i.props.terminal === "start"),
    end: n.find((i) => i.props.terminal === "end")
  };
}
const oie = xG("arrow info", (t, e) => {
  const n = li(t, e);
  return sie(e) ? DI(t, e, n) : nie(t, e, n);
});
function Pr(t, e) {
  const n = typeof e == "string" ? e : e.id;
  return oie.get(t, n);
}
function Ea(t, e, n) {
  var a, c;
  const i = t.getShapePageTransform(e), r = gj(
    t,
    (a = n.start) == null ? void 0 : a.toId,
    (c = n.end) == null ? void 0 : c.toId
  ), s = n.start ? uN(
    t,
    i,
    n.start,
    r === "double-bound" || r === "start-contains-end"
  ) : x.From(e.props.start), o = n.end ? uN(
    t,
    i,
    n.end,
    r === "double-bound" || r === "end-contains-start"
  ) : x.From(e.props.end);
  return { start: s, end: o };
}
function dl(t, e, n, i) {
  const r = typeof e == "string" ? e : e.id, s = typeof n == "string" ? n : n.id, o = t.getBindingsFromShape(r, "arrow").filter((c) => c.props.terminal === i.terminal);
  o.length > 1 && t.deleteBindings(o.slice(1));
  const a = o[0];
  a ? t.updateBinding({
    ...a,
    toId: s,
    props: i
  }) : t.createBinding({
    type: "arrow",
    fromId: r,
    toId: s,
    props: i
  });
}
function Th(t, e, n) {
  const i = t.getBindingsFromShape(e, "arrow").filter((r) => r.props.terminal === n);
  t.deleteBindings(i);
}
const Ca = 10, Vg = 10, aie = 10, Ur = {
  s: 2,
  m: 3.5,
  l: 5,
  xl: 10
};
function gj(t, e, n) {
  if (!e || !n) return "safe";
  if (e === n) return "double-bound";
  const i = t.getShapePageBounds(e), r = t.getShapePageBounds(n);
  if (i && r) {
    if (i.contains(r)) return "start-contains-end";
    if (r.contains(i)) return "end-contains-start";
  }
  return "safe";
}
class bh extends Nh {
  getDefaultProps() {
    return {
      isPrecise: !1,
      isExact: !1,
      normalizedAnchor: { x: 0.5, y: 0.5 }
    };
  }
  // when the binding itself changes
  onAfterCreate({ binding: e }) {
    const n = this.editor.getShape(e.fromId);
    n && rm(this.editor, n);
  }
  // when the binding itself changes
  onAfterChange({ bindingAfter: e }) {
    const n = this.editor.getShape(e.fromId);
    n && rm(this.editor, n);
  }
  // when the arrow itself changes
  onAfterChangeFromShape({
    shapeAfter: e
  }) {
    rm(this.editor, e);
  }
  // when the shape an arrow is bound to changes
  onAfterChangeToShape({ binding: e }) {
    bk(this.editor, e.fromId);
  }
  // when the arrow is isolated we need to update it's x,y positions
  onBeforeIsolateFromShape({
    binding: e
  }) {
    const n = this.editor.getShape(e.fromId);
    n && Kg({
      editor: this.editor,
      arrow: n,
      terminal: e.props.terminal
    });
  }
}
S(bh, "type", "arrow"), S(bh, "props", Rb), S(bh, "migrations", Yb);
function bk(t, e) {
  var m;
  const n = t.getShape(e);
  if (!n) return;
  const i = li(t, n), { start: r, end: s } = i, o = r ? t.getShape(r.toId) : void 0, a = s ? t.getShape(s.toId) : void 0, c = t.getAncestorPageId(n);
  if (!c) return;
  let d;
  if (o && a)
    d = t.findCommonAncestor([o, a]) ?? c;
  else if (o || a) {
    const y = (m = o || a) == null ? void 0 : m.parentId;
    y && y === n.parentId ? d = n.parentId : d = c;
  } else
    return;
  d && d !== n.parentId && t.reparentShapes([e], d);
  const u = t.getShape(e);
  if (!u) throw Error("no reparented arrow");
  const h = t.getShapeNearestSibling(u, o), g = t.getShapeNearestSibling(u, a);
  let p;
  if (h && g)
    p = h.index > g.index ? h : g;
  else if (h && !g)
    p = h;
  else if (g && !h)
    p = g;
  else
    return;
  let f;
  const M = t.getSortedChildIdsForParent(p.parentId).map((y) => t.getShape(y)).filter((y) => y.index > p.index);
  if (M.length) {
    const y = M.find((I) => I.type !== "arrow");
    if (
      // ...then, if we're above the last shape we want to be above...
      u.index > p.index && // ...but below the next non-arrow sibling...
      (!y || u.index < y.index)
    )
      return;
    f = ko(p.index, M[0].index);
  } else
    f = hi(p.index);
  f !== u.index && t.updateShapes([{ id: e, type: "arrow", index: f }]);
}
function rm(t, e) {
  const n = li(t, e);
  for (const i of ["start", "end"]) {
    const r = n[i];
    if (!r) continue;
    const s = t.getShape(r.toId), o = t.getAncestorPageId(e) === t.getAncestorPageId(s);
    (!s || !o) && Kg({ editor: t, arrow: e, terminal: i, unbind: !0 });
  }
  bk(t, e.id);
}
function Kg({
  editor: t,
  arrow: e,
  terminal: n,
  unbind: i = !1,
  useHandle: r = !1
}) {
  const s = Pr(t, e);
  if (!s)
    throw new Error("expected arrow info");
  const o = r ? s.start.handle : s.start.point, a = r ? s.end.handle : s.end.point, c = n === "start" ? o : a, d = {
    id: e.id,
    type: "arrow",
    props: {
      [n]: { x: c.x, y: c.y },
      bend: e.props.bend
    }
  };
  if (!s.isStraight) {
    const u = n === "start" ? o : s.start.handle, h = n === "end" ? a : s.end.handle, g = x.Med(u, h), p = x.Sub(u, h).per().uni().mul(s.handleArc.radius * 2 * Math.sign(e.props.bend)), f = yd(
      s.handleArc.center,
      x.Add(g, p),
      s.handleArc.center,
      s.handleArc.radius
    );
    ct((f == null ? void 0 : f.length) === 1);
    const M = x.Dist(g, f[0]) * Math.sign(e.props.bend);
    Xs(M, d.props.bend) || (d.props.bend = M);
  }
  t.updateShape(d), i && Th(t, e, n);
}
const vk = [bh], Cn = {
  lineHeight: 1.35,
  fontWeight: "normal",
  fontVariant: "normal",
  fontStyle: "normal",
  padding: "0px"
}, mn = {
  s: 2,
  m: 3.5,
  l: 5,
  xl: 10
}, _a = {
  s: 18,
  m: 24,
  l: 36,
  xl: 44
}, fs = {
  s: 18,
  m: 22,
  l: 26,
  xl: 32
}, cie = {
  s: 18,
  m: 20,
  l: 24,
  xl: 28
}, xs = {
  draw: "var(--tl-font-draw)",
  sans: "var(--tl-font-sans)",
  serif: "var(--tl-font-serif)",
  mono: "var(--tl-font-mono)"
}, lie = 20, Xg = 4.25, Gi = 16;
function die(t, e) {
  const n = t.w / e.w, i = t.h / e.h;
  return n <= 1 && i <= 1 ? t : n > i ? {
    w: t.w / n,
    h: t.h / n
  } : {
    w: t.w / i,
    h: t.h / i
  };
}
/*!
 * MIT License
 * Adapted (mostly copied) the work of https://github.com/fregante/text-field-edit
 * Copyright (c) Federico Brigante <opensource@bfred.it> (bfred.it)
 */
const za = "  ", Yn = class Yn {
  static insertTextFirefox(e, n) {
    e.setRangeText(
      n,
      e.selectionStart || 0,
      e.selectionEnd || 0,
      "end"
      // Without this, the cursor is either at the beginning or text remains selected
    ), e.dispatchEvent(
      new InputEvent("input", {
        data: n,
        inputType: "insertText",
        isComposing: !1
        // TODO: fix @types/jsdom, this shouldn't be required
      })
    );
  }
  /**
   * Inserts text at the cursor’s position, replacing any selection, with **undo** support and by
   * firing the input event.
   */
  static insert(e, n) {
    const i = e.ownerDocument, r = i.activeElement;
    r !== e && e.focus(), i.execCommand("insertText", !1, n) || Yn.insertTextFirefox(e, n), r === i.body ? e.blur() : r instanceof HTMLElement && r !== e && r.focus();
  }
  /**
   * Replaces the entire content, equivalent to field.value = text but with **undo** support and by
   * firing the input event.
   */
  static set(e, n) {
    e.select(), Yn.insert(e, n);
  }
  /** Get the selected text in a field or an empty string if nothing is selected. */
  static getSelection(e) {
    const { selectionStart: n, selectionEnd: i } = e;
    return e.value.slice(
      n || void 0,
      i || void 0
    );
  }
  /**
   * Adds the wrappingText before and after field’s selection (or cursor). If endWrappingText is
   * provided, it will be used instead of wrappingText at on the right.
   */
  static wrapSelection(e, n, i) {
    const { selectionStart: r, selectionEnd: s } = e, o = Yn.getSelection(e);
    Yn.insert(e, n + o + (i ?? n)), e.selectionStart = (r || 0) + n.length, e.selectionEnd = (s || 0) + n.length;
  }
  /** Finds and replaces strings and regex in the field’s value. */
  static replace(e, n, i) {
    let r = 0;
    e.value.replace(n, (...s) => {
      const o = r + s[s.length - 2], a = s[0].length;
      e.selectionStart = o, e.selectionEnd = o + a;
      const c = typeof i == "string" ? i : i(...s);
      return Yn.insert(e, c), e.selectionStart = o, r += c.length - a, c;
    });
  }
  static findLineEnd(e, n) {
    const i = e.lastIndexOf(`
`, n - 1) + 1;
    return e.charAt(i) !== "	" ? n : i + 1;
  }
  static indent(e) {
    var a;
    const { selectionStart: n, selectionEnd: i, value: r } = e, s = r.slice(n, i), o = (a = /\n/g.exec(s)) == null ? void 0 : a.length;
    if (o && o > 0) {
      const c = r.lastIndexOf(`
`, n - 1) + 1, d = e.value.slice(c, i - 1), u = d.replace(
        /^|\n/g,
        // Match all line starts
        `$&${za}`
      ), h = u.length - d.length;
      e.setSelectionRange(c, i - 1), Yn.insert(e, u), e.setSelectionRange(n + 1, i + h);
    } else
      Yn.insert(e, za);
  }
  // The first line should always be unindented
  // The last line should only be unindented if the selection includes any characters after \n
  static unindent(e) {
    const { selectionStart: n, selectionEnd: i, value: r } = e, s = r.lastIndexOf(`
`, n - 1) + 1, o = Yn.findLineEnd(r, i), a = e.value.slice(s, o), c = a.replace(/(^|\n)(\t| {1,2})/g, "$1"), d = a.length - c.length;
    e.setSelectionRange(s, o), Yn.insert(e, c);
    const u = /\t| {1,2}/.exec(r.slice(s, n)), h = u ? u[0].length : 0, g = n - h;
    e.setSelectionRange(
      n - h,
      Math.max(g, i - d)
    );
  }
  static indentCE(e) {
    var c;
    const n = window.getSelection(), i = e.innerText, r = Xu(e) ?? 0, s = Xu(e) ?? 0, o = i.slice(r, s), a = (c = /\n/g.exec(o)) == null ? void 0 : c.length;
    if (a && a > 0) {
      const d = i.lastIndexOf(`
`, r - 1) + 1, u = i.slice(d, s - 1), g = u.replace(
        /^|\n/g,
        // Match all line starts
        `$&${za}`
      ).length - u.length;
      n && n.setBaseAndExtent(
        e,
        r + 1,
        e,
        s + g
      );
    } else {
      const d = window.getSelection();
      e.innerText = i.slice(0, r) + za + i.slice(r), d == null || d.setBaseAndExtent(e, r + 1, e, r + 2);
    }
  }
  static unindentCE(e) {
    const n = window.getSelection(), i = e.innerText, r = Xu(e) ?? 0, s = Xu(e) ?? 0, o = i.lastIndexOf(`
`, r - 1) + 1, a = Yn.findLineEnd(i, s), c = i.slice(o, a), d = c.replace(/(^|\n)(\t| {1,2})/g, "$1"), u = c.length - d.length;
    if (n) {
      n.setBaseAndExtent(e, o, e, a);
      const h = /\t| {1,2}/.exec(i.slice(o, r)), g = h ? h[0].length : 0, p = r - g;
      n.setBaseAndExtent(
        e,
        r - g,
        e,
        Math.max(p, s - u)
      );
    }
  }
  static normalizeText(e) {
    return e.replace(Yn.fixNewLines, `
`);
  }
  static normalizeTextForDom(e) {
    return e.replace(Yn.fixNewLines, `
`).split(`
`).map((n) => n || " ").join(`
`);
  }
};
S(Yn, "fixNewLines", /\r?\n|\r/g);
let $a = Yn;
function Xu(t) {
  if (typeof window.getSelection > "u") return;
  const e = window.getSelection();
  if (!e) return;
  let n = 0;
  if (e.rangeCount !== 0) {
    const i = e.getRangeAt(0), r = i.cloneRange();
    r.selectNodeContents(t), r.setEnd(i.endContainer, i.endOffset), n = r.toString().length;
  }
  return n;
}
const uie = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
function Ek(t) {
  return uie.test(t);
}
function hie(t) {
  return t.replace(/\t/g, za);
}
function gie(t) {
  const e = t.split(`
`);
  for (; e[0] && e[0].trim().length === 0; )
    e.shift();
  let n = 1 / 0;
  for (const i of e)
    if (i.trim().length > 0) {
      const r = i.length - i.trimStart().length;
      n = Math.min(n, r);
    }
  return e.map((i) => i.slice(n)).join(`
`);
}
const Ck = {
  "&amp;": "&",
  "&quot;": '"',
  "&apos;": "'",
  "&#34;": '"',
  "&#38;": "&",
  "&#39;": "'",
  "&#8211;": "–",
  "&#8212;": "—",
  "&#8216;": "‘",
  "&#8217;": "’",
  "&#8220;": "“",
  "&#8221;": "”",
  "&#8230;": "…"
}, pie = new RegExp(Object.keys(Ck).join("|"), "g");
function fie(t) {
  return t.replace(pie, (e) => Ck[e]);
}
function Mie(t) {
  return t.replace(/[ \t]+$/gm, "").replace(/\n+$/, "");
}
function mie(t) {
  return Mie(gie(hie(t)));
}
function yie(t, {
  maxImageDimension: e,
  maxAssetSize: n,
  acceptedImageMimeTypes: i,
  acceptedVideoMimeTypes: r
}, { toasts: s, msg: o }) {
  t.registerExternalAssetHandler("file", async ({ file: a, assetId: c }) => {
    const d = i.includes(a.type), u = r.includes(a.type);
    !d && !u && s.addToast({
      title: o("assets.files.type-not-allowed"),
      severity: "error"
    }), ct(d || u, `File type not allowed: ${a.type}`), a.size > n && s.addToast({
      title: o("assets.files.size-too-big"),
      severity: "error"
    }), ct(
      a.size <= n,
      `File size too big: ${(a.size / 1024).toFixed()}kb > ${(n / 1024).toFixed()}kb`
    );
    const h = hD(await a.arrayBuffer());
    c = c ?? ci.createId(h);
    const g = await hN(a, c, d, u);
    if (isFinite(e)) {
      const p = { w: g.props.w, h: g.props.h }, f = die(p, { w: e, h: e });
      p !== f && bi.isStaticImageType(a.type) && (g.props.w = f.w, g.props.h = f.h);
    }
    return g.props.src = await t.uploadAsset(g, a), ci.create(g);
  }), t.registerExternalAssetHandler("url", async ({ url: a }) => {
    var d, u, h, g, p;
    let c;
    try {
      const M = await (await gr(a, {
        method: "GET",
        mode: "no-cors"
      })).text(), m = new DOMParser().parseFromString(M, "text/html");
      c = {
        image: ((d = m.head.querySelector('meta[property="og:image"]')) == null ? void 0 : d.getAttribute("content")) ?? "",
        favicon: ((u = m.head.querySelector('link[rel="apple-touch-icon"]')) == null ? void 0 : u.getAttribute("href")) ?? ((h = m.head.querySelector('link[rel="icon"]')) == null ? void 0 : h.getAttribute("href")) ?? "",
        title: ((g = m.head.querySelector('meta[property="og:title"]')) == null ? void 0 : g.getAttribute("content")) ?? a,
        description: ((p = m.head.querySelector('meta[property="og:description"]')) == null ? void 0 : p.getAttribute("content")) ?? ""
      }, c.image.startsWith("http") || (c.image = new URL(c.image, a).href), c.favicon.startsWith("http") || (c.favicon = new URL(c.favicon, a).href);
    } catch (f) {
      console.error(f), s.addToast({
        title: o("assets.url.failed"),
        severity: "error"
      }), c = { image: "", favicon: "", title: "", description: "" };
    }
    return {
      id: ci.createId(My(a)),
      typeName: "asset",
      type: "bookmark",
      props: {
        src: a,
        description: c.description,
        image: c.image,
        favicon: c.favicon,
        title: c.title
      },
      meta: {}
    };
  }), t.registerExternalContentHandler("svg-text", async ({ point: a, text: c }) => {
    const d = a ?? (t.inputs.shiftKey ? t.inputs.currentPagePoint : t.getViewportPageBounds().center), u = new DOMParser().parseFromString(c, "image/svg+xml").querySelector("svg");
    if (!u)
      throw new Error("No <svg/> element present");
    let h = parseFloat(u.getAttribute("width") || "0"), g = parseFloat(u.getAttribute("height") || "0");
    if (!(h && g)) {
      document.body.appendChild(u);
      const f = u.getBoundingClientRect();
      document.body.removeChild(u), h = f.width, g = f.height;
    }
    const p = await t.getAssetForExternalContent({
      type: "file",
      file: new File([c], "asset.svg", { type: "image/svg+xml" })
    });
    if (!p) throw Error("Could not create an asset");
    gN(t, [p], d);
  }), t.registerExternalContentHandler(
    "embed",
    ({ point: a, url: c, embed: d }) => {
      const u = a ?? (t.inputs.shiftKey ? t.inputs.currentPagePoint : t.getViewportPageBounds().center), { width: h, height: g } = d, p = Ee(), f = {
        id: p,
        type: "embed",
        x: u.x - (h || 450) / 2,
        y: u.y - (g || 450) / 2,
        props: {
          w: h,
          h: g,
          url: c
        }
      };
      t.createShapes([f]).select(p);
    }
  ), t.registerExternalContentHandler("files", async ({ point: a, files: c }) => {
    if (c.length > t.options.maxFilesAtOnce)
      throw Error("Too many files");
    const d = a ?? (t.inputs.shiftKey ? t.inputs.currentPagePoint : t.getViewportPageBounds().center), u = new x(d.x, d.y), h = [], g = [];
    for (const p of c) {
      if (p.size > n) {
        s.addToast({
          title: o("assets.files.size-too-big"),
          severity: "error"
        }), console.warn(
          `File size too big: ${(p.size / 1024).toFixed()}kb > ${(n / 1024).toFixed()}kb`
        );
        continue;
      }
      if (!p.type) {
        s.addToast({
          title: o("assets.files.upload-failed"),
          severity: "error"
        }), console.error("No mime type");
        continue;
      }
      if (!i.concat(r).includes(p.type)) {
        s.addToast({
          title: o("assets.files.type-not-allowed"),
          severity: "error"
        }), console.warn(`${p.name} not loaded - Mime type not allowed ${p.type}.`);
        continue;
      }
      const f = i.includes(p.type), M = r.includes(p.type), m = hD(await p.arrayBuffer()), y = ci.createId(m), I = await hN(p, y, f, M);
      let D;
      f && (D = t.createTemporaryAssetPreview(y, p)), h.push(I), g.push({ asset: I, file: p, temporaryAssetPreview: D });
    }
    Promise.allSettled(
      g.map(async (p) => {
        try {
          const f = await t.getAssetForExternalContent({
            type: "file",
            file: p.file
          });
          if (!f)
            throw Error("Could not create an asset");
          t.updateAssets([{ ...f, id: p.asset.id }]);
        } catch (f) {
          s.addToast({
            title: o("assets.files.upload-failed"),
            severity: "error"
          }), console.error(f);
          return;
        }
      })
    ), gN(t, h, u);
  }), t.registerExternalContentHandler("text", async ({ point: a, text: c }) => {
    const d = a ?? (t.inputs.shiftKey ? t.inputs.currentPagePoint : t.getViewportPageBounds().center), u = t.getShapeUtil("text").getDefaultProps(), h = mie(c), g = t.getOnlySelectedShape();
    if (g && "text" in g.props) {
      t.updateShapes([
        {
          id: g.id,
          type: g.type,
          props: {
            text: h
          }
        }
      ]);
      return;
    }
    let p, f, M, m = "middle";
    const y = h.split(`
`).length > 1, I = Ek(h);
    y && (m = y ? I ? "end" : "start" : "middle");
    const D = t.textMeasure.measureText(h, {
      ...Cn,
      fontFamily: xs[u.font],
      fontSize: _a[u.size],
      maxWidth: null
    }), j = Math.min(
      y ? t.getViewportPageBounds().width * 0.9 : 920,
      Math.max(200, t.getViewportPageBounds().width * 0.9)
    );
    if (D.w > j) {
      const w = t.textMeasure.measureText(h, {
        ...Cn,
        fontFamily: xs[u.font],
        fontSize: _a[u.size],
        maxWidth: j
      });
      p = w.w, f = w.h, M = !1, m = I ? "end" : "start";
    } else
      p = D.w, f = D.h, M = !0;
    d.y - f / 2 < t.getViewportPageBounds().minY + 40 && (d.y = t.getViewportPageBounds().minY + 40 + f / 2), t.createShapes([
      {
        id: Ee(),
        type: "text",
        x: d.x - p / 2,
        y: d.y - f / 2,
        props: {
          text: h,
          // if the text has more than one line, align it to the left
          textAlign: m,
          autoSize: M,
          w: p
        }
      }
    ]);
  }), t.registerExternalContentHandler("url", async ({ point: a, url: c }) => {
    const d = t.getShapeUtil("embed"), u = d == null ? void 0 : d.getEmbedDefinition(c);
    if (u)
      return t.putExternalContent({
        type: "embed",
        url: u.url,
        point: a,
        embed: u.definition
      });
    const h = a ?? (t.inputs.shiftKey ? t.inputs.currentPagePoint : t.getViewportPageBounds().center), g = ci.createId(My(c)), p = Iie(t, c, h);
    let f = t.getAsset(g), M = !1;
    if (!f) {
      M = !0;
      try {
        const m = await t.getAssetForExternalContent({ type: "url", url: c });
        if (!m) throw Error("Could not create an asset");
        f = m;
      } catch {
        s.addToast({
          title: o("assets.url.failed"),
          severity: "error"
        });
        return;
      }
    }
    t.run(() => {
      M && t.createAssets([f]), t.updateShapes([
        {
          id: p.id,
          type: p.type,
          props: {
            assetId: f.id
          }
        }
      ]);
    });
  });
}
async function hN(t, e, n, i) {
  let r = t.type;
  t.type === "video/quicktime" && (r = "video/mp4");
  const s = n ? await bi.getImageSize(t) : await bi.getVideoSize(t), o = await bi.isAnimated(t) || i;
  return {
    id: e,
    type: n ? "image" : "video",
    typeName: "asset",
    props: {
      name: t.name,
      src: "",
      w: s.w,
      h: s.h,
      fileSize: t.size,
      mimeType: r,
      isAnimated: o
    },
    meta: {}
  };
}
async function gN(t, e, n) {
  if (!e.length) return [];
  const i = x.From(n), r = [];
  for (let s = 0; s < e.length; s++) {
    const o = e[s];
    switch (o.type) {
      case "image": {
        r.push({
          id: Ee(),
          type: "image",
          x: i.x,
          y: i.y,
          opacity: 1,
          props: {
            assetId: o.id,
            w: o.props.w,
            h: o.props.h
          }
        }), i.x += o.props.w;
        break;
      }
      case "video":
        r.push({
          id: Ee(),
          type: "video",
          x: i.x,
          y: i.y,
          opacity: 1,
          props: {
            assetId: o.id,
            w: o.props.w,
            h: o.props.h
          }
        }), i.x += o.props.w;
    }
  }
  return t.run(() => {
    const s = e.filter((o) => !t.getAsset(o.id));
    s.length && t.createAssets(s), t.createShapes(r).select(...r.map((o) => o.id)), zk(t, n);
  }), r.map((s) => s.id);
}
function zk(t, e) {
  const n = t.getViewportPageBounds();
  let i = t.getSelectionPageBounds();
  if (i) {
    const r = i.center.sub(e);
    t.updateShapes(
      t.getSelectedShapes().map((s) => {
        const o = t.getShapeParentTransform(s).decompose().rotation, a = x.Rot(r, -o);
        return {
          id: s.id,
          type: s.type,
          x: s.x - a.x,
          y: s.y - a.y
        };
      })
    );
  }
  i = t.getSelectionPageBounds(), i && !n.contains(i) && t.zoomToSelection({ animation: { duration: t.options.animationMediumMs } });
}
function Iie(t, e, n) {
  const i = {
    id: Ee(),
    type: "bookmark",
    x: n.x - 150,
    y: n.y - 160,
    opacity: 1,
    props: {
      assetId: null,
      url: e
    }
  };
  return t.run(() => {
    t.createShapes([i]).select(i.id), zk(t, n);
  }), t.getShape(i.id);
}
var bm;
let xie = (bm = class extends ee {
  onPointerDown(e) {
    this.parent.transition("pointing", e);
  }
  onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 });
  }
  onCancel() {
    this.editor.setCurrentTool("select");
  }
  onKeyUp(e) {
    var n;
    if (e.key === "Enter") {
      if (this.editor.getIsReadonly()) return null;
      const i = this.editor.getOnlySelectedShape();
      i && this.editor.getShapeUtil(i).canEdit(i) && (this.editor.setCurrentTool("select"), this.editor.setEditingShape(i.id), (n = this.editor.root.getCurrent()) == null || n.transition("editing_shape", {
        ...e,
        target: "shape",
        shape: i
      }));
    }
  }
}, S(bm, "id", "idle"), bm);
var vm;
let Sie = (vm = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "shape");
    S(this, "markId", "");
    S(this, "preciseTimeout", -1);
    S(this, "didTimeout", !1);
  }
  onEnter() {
    this.markId = "", this.didTimeout = !1;
    const n = this.editor.getShapeAtPoint(this.editor.inputs.currentPagePoint, {
      filter: (i) => !i.isLocked && this.editor.canBindShapes({ fromShape: "arrow", toShape: i, binding: "arrow" }),
      margin: 0,
      hitInside: !0,
      renderingOnly: !0
    });
    n ? this.editor.setHintingShapes([n.id]) : this.createArrowShape(), this.startPreciseTimeout();
  }
  onExit() {
    this.shape = void 0, this.editor.setHintingShapes([]), this.clearPreciseTimeout();
  }
  onPointerMove() {
    if (this.editor.inputs.isDragging) {
      if (this.shape || this.createArrowShape(), !this.shape) throw Error("expected shape");
      this.updateArrowShapeEndHandle(), this.editor.setCurrentTool("select.dragging_handle", {
        shape: this.shape,
        handle: { id: "end", type: "vertex", index: "a3", x: 0, y: 0 },
        isCreating: !0,
        creatingMarkId: this.markId || void 0,
        onInteractionEnd: "arrow"
      });
    }
  }
  onPointerUp() {
    this.cancel();
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.cancel();
  }
  onInterrupt() {
    this.cancel();
  }
  cancel() {
    this.shape && this.editor.bailToMark(this.markId), this.editor.setHintingShapes([]), this.parent.transition("idle");
  }
  createArrowShape() {
    var u;
    const { originPagePoint: n } = this.editor.inputs, i = Ee();
    this.markId = this.editor.markHistoryStoppingPoint(`creating_arrow:${i}`), this.editor.createShape({
      id: i,
      type: "arrow",
      x: n.x,
      y: n.y,
      props: {
        scale: this.editor.user.getIsDynamicResizeMode() ? 1 / this.editor.getZoomLevel() : 1
      }
    });
    const r = this.editor.getShape(i);
    if (!r) throw Error("expected shape");
    const s = this.editor.getShapeHandles(r);
    if (!s) throw Error("expected handles for arrow");
    const o = this.editor.getShapeUtil("arrow"), a = this.shape, c = s.find((h) => h.id === "start"), d = (u = o.onHandleDrag) == null ? void 0 : u.call(o, r, {
      handle: { ...c, x: 0, y: 0 },
      isPrecise: !0,
      initial: a
    });
    d && this.editor.updateShapes([d]), this.shape = this.editor.getShape(i), this.editor.select(i);
  }
  updateArrowShapeEndHandle() {
    var r, s;
    const n = this.shape;
    if (!n) throw Error("expected shape");
    const i = this.editor.getShapeHandles(n);
    if (!i) throw Error("expected handles for arrow");
    {
      const o = this.editor.getShapeUtil("arrow"), a = this.shape, c = i.find((u) => u.id === "start"), d = (r = o.onHandleDrag) == null ? void 0 : r.call(o, n, {
        handle: { ...c, x: 0, y: 0 },
        isPrecise: this.didTimeout,
        // sure about that?
        initial: a
      });
      d && this.editor.updateShapes([d]);
    }
    {
      const o = this.editor.getShapeUtil("arrow"), a = this.shape, c = this.editor.getPointInShapeSpace(n, this.editor.inputs.currentPagePoint), d = i.find((h) => h.id === "end"), u = (s = o.onHandleDrag) == null ? void 0 : s.call(o, this.editor.getShape(n), {
        handle: { ...d, x: c.x, y: c.y },
        isPrecise: !1,
        // sure about that?
        initial: a
      });
      u && this.editor.updateShapes([u]);
    }
    this.shape = this.editor.getShape(n.id);
  }
  startPreciseTimeout() {
    this.preciseTimeout = this.editor.timers.setTimeout(() => {
      this.getIsActive() && (this.didTimeout = !0);
    }, 320);
  }
  clearPreciseTimeout() {
    clearTimeout(this.preciseTimeout);
  }
}, S(vm, "id", "pointing"), vm);
class wI extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "arrow");
  }
  static children() {
    return [xie, Sie];
  }
}
S(wI, "id", "arrow"), S(wI, "initial", "idle");
var Em;
let Lk = (Em = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
    S(this, "initialShape");
    S(this, "shapeType", this.parent.id === "highlight" ? "highlight" : "draw");
    S(this, "util", this.editor.getShapeUtil(this.shapeType));
    S(this, "isPen", !1);
    S(this, "isPenOrStylus", !1);
    S(this, "segmentMode", "free");
    S(this, "didJustShiftClickToExtendPreviousShapeLine", !1);
    S(this, "pagePointWhereCurrentSegmentChanged", {});
    S(this, "pagePointWhereNextSegmentChanged", null);
    S(this, "lastRecordedPoint", {});
    S(this, "mergeNextPoint", !1);
    S(this, "currentLineLength", 0);
    S(this, "markId", null);
  }
  onEnter(n) {
    this.markId = null, this.info = n, this.lastRecordedPoint = this.editor.inputs.currentPagePoint.clone(), this.startShape();
  }
  onPointerMove() {
    const { inputs: n } = this.editor;
    if (this.isPen && !n.isPen && this.markId) {
      this.editor.bailToMark(this.markId), this.startShape();
      return;
    }
    this.isPenOrStylus ? x.Dist(n.currentPagePoint, this.lastRecordedPoint) >= 1 / this.editor.getZoomLevel() ? (this.lastRecordedPoint = n.currentPagePoint.clone(), this.mergeNextPoint = !1) : this.mergeNextPoint = !0 : this.mergeNextPoint = !1, this.updateDrawingShape();
  }
  onKeyDown(n) {
    if (n.key === "Shift")
      switch (this.segmentMode) {
        case "free": {
          this.segmentMode = "starting_straight", this.pagePointWhereNextSegmentChanged = this.editor.inputs.currentPagePoint.clone();
          break;
        }
        case "starting_free":
          this.segmentMode = "starting_straight";
      }
    this.updateDrawingShape();
  }
  onKeyUp(n) {
    if (n.key === "Shift")
      switch (this.editor.snaps.clearIndicators(), this.segmentMode) {
        case "straight": {
          this.segmentMode = "starting_free", this.pagePointWhereNextSegmentChanged = this.editor.inputs.currentPagePoint.clone();
          break;
        }
        case "starting_straight": {
          this.pagePointWhereNextSegmentChanged = null, this.segmentMode = "free";
          break;
        }
      }
    this.updateDrawingShape();
  }
  onExit() {
    this.editor.snaps.clearIndicators(), this.pagePointWhereCurrentSegmentChanged = this.editor.inputs.currentPagePoint.clone();
  }
  canClose() {
    return this.shapeType !== "highlight";
  }
  getIsClosed(n, i, r) {
    if (!this.canClose()) return !1;
    const s = mn[i], o = n[0].points[0], a = n[n.length - 1], c = a.points[a.points.length - 1];
    return o !== c && this.currentLineLength > s * 4 * r && x.DistMin(o, c, s * 2 * r);
  }
  startShape() {
    const {
      inputs: { originPagePoint: n, isPen: i }
    } = this.editor;
    this.markId = this.editor.markHistoryStoppingPoint("draw start");
    const { z: r = 0.5 } = this.info.point;
    this.isPen = i, this.isPenOrStylus = i || r > 0 && r < 0.5 || r > 0.5 && r < 1;
    const s = this.isPenOrStylus ? r * 1.25 : 0.5;
    if (this.segmentMode = this.editor.inputs.shiftKey ? "straight" : "free", this.didJustShiftClickToExtendPreviousShapeLine = !1, this.lastRecordedPoint = n.clone(), this.initialShape) {
      const a = this.editor.getShape(this.initialShape.id);
      if (a && this.segmentMode === "straight") {
        this.didJustShiftClickToExtendPreviousShapeLine = !0;
        const c = pn(a.props.segments);
        if (!c) throw Error("Expected a previous segment!");
        const d = pn(c.points);
        if (!d) throw Error("Expected a previous point!");
        const { x: u, y: h } = this.editor.getPointInShapeSpace(a, n).toFixed(), g = {
          type: this.segmentMode,
          points: [
            {
              x: d.x,
              y: d.y,
              z: +s.toFixed(2)
            },
            {
              x: u,
              y: h,
              z: +s.toFixed(2)
            }
          ]
        }, p = ne.applyToPoint(
          this.editor.getShapePageTransform(a.id),
          d
        );
        this.pagePointWhereCurrentSegmentChanged = p, this.pagePointWhereNextSegmentChanged = null;
        const f = [...a.props.segments, g];
        this.currentLineLength < mn[a.props.size] * 4 && (this.currentLineLength = this.getLineLength(f));
        const M = {
          id: a.id,
          type: this.shapeType,
          props: {
            segments: f
          }
        };
        this.canClose() && (M.props.isClosed = this.getIsClosed(
          f,
          a.props.size,
          a.props.scale
        )), this.editor.updateShapes([M]);
        return;
      }
    }
    this.pagePointWhereCurrentSegmentChanged = n.clone();
    const o = Ee();
    this.editor.createShapes([
      {
        id: o,
        type: this.shapeType,
        x: n.x,
        y: n.y,
        props: {
          isPen: this.isPenOrStylus,
          scale: this.editor.user.getIsDynamicResizeMode() ? 1 / this.editor.getZoomLevel() : 1,
          segments: [
            {
              type: this.segmentMode,
              points: [
                {
                  x: 0,
                  y: 0,
                  z: +s.toFixed(2)
                }
              ]
            }
          ]
        }
      }
    ]), this.currentLineLength = 0, this.initialShape = this.editor.getShape(o);
  }
  updateDrawingShape() {
    const { initialShape: n } = this, { inputs: i } = this.editor;
    if (!n) return;
    const {
      id: r,
      props: { size: s, scale: o }
    } = n, a = this.editor.getShape(r);
    if (!a) return;
    const { segments: c } = a.props, { x: d, y: u, z: h } = this.editor.getPointInShapeSpace(a, i.currentPagePoint).toFixed(), g = this.isPenOrStylus ? +(i.currentPagePoint.z * 1.25).toFixed(2) : 0.5, p = { x: d, y: u, z: g };
    switch (this.segmentMode) {
      case "starting_straight": {
        const { pagePointWhereNextSegmentChanged: f } = this;
        if (f === null)
          throw Error("We should have a point where the segment changed");
        if (x.Dist2(f, i.currentPagePoint) > this.editor.options.dragDistanceSquared) {
          this.pagePointWhereCurrentSegmentChanged = this.pagePointWhereNextSegmentChanged.clone(), this.pagePointWhereNextSegmentChanged = null, this.segmentMode = "straight";
          const m = pn(c);
          if (!m) throw Error("Expected a previous segment!");
          const y = pn(m.points);
          if (!y) throw Error("Expected a previous last point!");
          let I;
          const D = this.editor.getPointInShapeSpace(a, this.pagePointWhereCurrentSegmentChanged).toFixed().toJson();
          if (m.type === "straight") {
            this.currentLineLength += x.Dist(y, D), I = {
              type: "straight",
              points: [{ ...y }, D]
            };
            const w = this.editor.getShapePageTransform(a);
            this.pagePointWhereCurrentSegmentChanged = ne.applyToPoint(w, y);
          } else
            I = {
              type: "straight",
              points: [D, p]
            };
          const j = {
            id: r,
            type: this.shapeType,
            props: {
              segments: [...c, I]
            }
          };
          this.canClose() && (j.props.isClosed = this.getIsClosed(
            c,
            s,
            o
          )), this.editor.updateShapes([j]);
        }
        break;
      }
      case "starting_free": {
        const { pagePointWhereNextSegmentChanged: f } = this;
        if (f === null)
          throw Error("We should have a point where the segment changed");
        if (x.Dist2(f, i.currentPagePoint) > this.editor.options.dragDistanceSquared) {
          this.pagePointWhereCurrentSegmentChanged = this.pagePointWhereNextSegmentChanged.clone(), this.pagePointWhereNextSegmentChanged = null, this.segmentMode = "free";
          const m = c.slice(), y = m[m.length - 1], I = pn(y.points);
          if (!I)
            throw Error("No previous point!");
          const D = {
            type: "free",
            points: [
              ...x.PointsBetween(I, p, 6).map((A) => ({
                x: cs(A.x),
                y: cs(A.y),
                z: cs(A.z)
              }))
            ]
          }, j = [...m, D];
          this.currentLineLength < mn[a.props.size] * 4 && (this.currentLineLength = this.getLineLength(j));
          const w = {
            id: r,
            type: this.shapeType,
            props: {
              segments: j
            }
          };
          this.canClose() && (w.props.isClosed = this.getIsClosed(
            j,
            s,
            o
          )), this.editor.updateShapes([w]);
        }
        break;
      }
      case "straight": {
        const f = c.slice(), M = f[f.length - 1], { pagePointWhereCurrentSegmentChanged: m } = this, { ctrlKey: y, currentPagePoint: I } = this.editor.inputs;
        if (!m)
          throw Error("We should have a point where the segment changed");
        let D, j = !1;
        this.didJustShiftClickToExtendPreviousShapeLine ? this.editor.inputs.isDragging && (j = !y, this.didJustShiftClickToExtendPreviousShapeLine = !1) : j = !y;
        let w = this.editor.getPointInShapeSpace(a, I).toFixed().toJson(), A = !1, b;
        if ((this.editor.user.getIsSnapMode() ? !y : y) && f.length > 2) {
          let v, P = 8 / this.editor.getZoomLevel();
          for (let C = 0, z = c.length - 2; C < z; C++) {
            const O = c[C];
            if (!O) break;
            if (O.type === "free") continue;
            const R = O.points[0], U = pn(O.points);
            if (!(R && U)) continue;
            const F = x.NearestPointOnLineSegment(
              R,
              U,
              w
            );
            if (x.DistMin(F, w, P)) {
              v = F.toFixed().toJson(), P = x.Dist(F, w), b = O;
              break;
            }
          }
          v && (A = !0, w = v);
        }
        if (A && b) {
          const v = this.editor.getShapePageTransform(a), P = b.points[0], C = pn(b.points);
          if (!C) throw Error("Expected a last point!");
          const z = ne.applyToPoint(v, P), O = ne.applyToPoint(v, C), R = ne.applyToPoint(v, w);
          this.editor.snaps.setIndicators([
            {
              id: ht(),
              type: "points",
              points: [z, R, O]
            }
          ]);
        } else {
          if (this.editor.snaps.clearIndicators(), j) {
            const v = x.Angle(m, I), C = vg(v, 24) - v;
            D = x.RotWith(
              I,
              m,
              C
            );
          } else
            D = I;
          w = this.editor.getPointInShapeSpace(a, D).toFixed().toJson();
        }
        this.currentLineLength += x.Dist(M.points[0], w), f[f.length - 1] = {
          ...M,
          type: "straight",
          points: [M.points[0], w]
        };
        const E = {
          id: r,
          type: this.shapeType,
          props: {
            segments: f
          }
        };
        this.canClose() && (E.props.isClosed = this.getIsClosed(
          c,
          s,
          o
        )), this.editor.updateShapes([E]);
        break;
      }
      case "free": {
        const f = c.slice(), M = f[f.length - 1], m = [...M.points];
        if (m.length && this.mergeNextPoint) {
          const { z: I } = m[m.length - 1];
          m[m.length - 1] = {
            x: p.x,
            y: p.y,
            z: I ? Math.max(I, p.z) : p.z
          };
        } else
          this.currentLineLength += x.Dist(m[m.length - 1], p), m.push(p);
        f[f.length - 1] = {
          ...M,
          points: m
        }, this.currentLineLength < mn[a.props.size] * 4 && (this.currentLineLength = this.getLineLength(f));
        const y = {
          id: r,
          type: this.shapeType,
          props: {
            segments: f
          }
        };
        if (this.canClose() && (y.props.isClosed = this.getIsClosed(
          f,
          s,
          o
        )), this.editor.updateShapes([y]), m.length > this.editor.options.maxPointsPerDrawShape) {
          this.editor.updateShapes([{ id: r, type: this.shapeType, props: { isComplete: !0 } }]);
          const I = Ee(), D = this.editor.getShape(r).props;
          this.editor.createShapes([
            {
              id: I,
              type: this.shapeType,
              x: cs(i.currentPagePoint.x),
              y: cs(i.currentPagePoint.y),
              props: {
                isPen: this.isPenOrStylus,
                scale: D.scale,
                segments: [
                  {
                    type: "free",
                    points: [{ x: 0, y: 0, z: this.isPenOrStylus ? +(h * 1.25).toFixed() : 0.5 }]
                  }
                ]
              }
            }
          ]), this.initialShape = Ct(this.editor.getShape(I)), this.mergeNextPoint = !1, this.lastRecordedPoint = i.currentPagePoint.clone(), this.currentLineLength = 0;
        }
        break;
      }
    }
  }
  getLineLength(n) {
    let i = 0;
    for (const r of n)
      for (let s = 0; s < r.points.length - 1; s++) {
        const o = r.points[s], a = r.points[s + 1];
        i += x.Dist2(a, o);
      }
    return Math.sqrt(i);
  }
  onPointerUp() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.complete();
  }
  onInterrupt() {
    this.editor.inputs.isDragging || (this.markId && this.editor.bailToMark(this.markId), this.cancel());
  }
  complete() {
    const { initialShape: n } = this;
    n && (this.editor.updateShapes([
      { id: n.id, type: n.type, props: { isComplete: !0 } }
    ]), this.parent.transition("idle"));
  }
  cancel() {
    this.parent.transition("idle", this.info);
  }
}, S(Em, "id", "drawing"), Em);
var Cm;
let kk = (Cm = class extends ee {
  onPointerDown(e) {
    this.parent.transition("drawing", e);
  }
  onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 });
  }
  onCancel() {
    this.editor.setCurrentTool("select");
  }
}, S(Cm, "id", "idle"), Cm);
class vh extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "draw");
  }
  static children() {
    return [kk, Lk];
  }
  onExit() {
    const n = this.children.drawing;
    n.initialShape = void 0;
  }
}
S(vh, "id", "draw"), S(vh, "initial", "idle"), S(vh, "isLockable", !1);
class NI extends iI {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "frame");
  }
  onCreate(n) {
    if (!n) return;
    const i = this.editor.getShapePageBounds(n), r = [], s = this.editor.getShapeAncestors(n).map((o) => o.id);
    this.editor.getSortedChildIdsForParent(n.parentId).map((o) => {
      const a = this.editor.getShape(o);
      if (!a || a.id === n.id || a.isLocked) return;
      const c = this.editor.getShapePageBounds(a);
      c && i.contains(c) && jie(a, s, n) && r.push(a.id);
    }), this.editor.reparentShapes(r, n.id), this.editor.getInstanceState().isToolLocked ? this.editor.setCurrentTool("frame") : this.editor.setCurrentTool("select.idle");
  }
}
S(NI, "id", "frame"), S(NI, "initial", "idle");
function jie(t, e, n) {
  return e.includes(t.id) ? !1 : t.parentId === n.parentId;
}
var zm;
let Die = (zm = class extends ee {
  onPointerDown(e) {
    this.parent.transition("pointing", e);
  }
  onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 });
  }
  onKeyUp(e) {
    var n;
    if (e.key === "Enter") {
      if (this.editor.getIsReadonly()) return null;
      const i = this.editor.getOnlySelectedShape();
      i && this.editor.getShapeUtil(i).canEdit(i) && (this.editor.setCurrentTool("select"), this.editor.setEditingShape(i.id), (n = this.editor.root.getCurrent()) == null || n.transition("editing_shape", {
        ...e,
        target: "shape",
        shape: i
      }));
    }
  }
  onCancel() {
    this.editor.setCurrentTool("select");
  }
}, S(zm, "id", "idle"), zm);
var Lm;
let wie = (Lm = class extends ee {
  onPointerUp() {
    this.complete();
  }
  onPointerMove(e) {
    if (this.editor.inputs.isDragging) {
      const { originPagePoint: n } = this.editor.inputs, i = Ee(), r = this.editor.markHistoryStoppingPoint(`creating_geo:${i}`);
      this.editor.createShapes([
        {
          id: i,
          type: "geo",
          x: n.x,
          y: n.y,
          props: {
            w: 1,
            h: 1,
            geo: this.editor.getStyleForNextShape(Fn),
            scale: this.editor.user.getIsDynamicResizeMode() ? 1 / this.editor.getZoomLevel() : 1
          }
        }
      ]).select(i).setCurrentTool("select.resizing", {
        ...e,
        target: "selection",
        handle: "bottom_right",
        isCreating: !0,
        creatingMarkId: r,
        creationCursorOffset: { x: 1, y: 1 },
        onInteractionEnd: "geo"
      });
    }
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.complete();
  }
  onInterrupt() {
    this.cancel();
  }
  complete() {
    const { originPagePoint: e } = this.editor.inputs, n = Ee();
    this.editor.markHistoryStoppingPoint(`creating_geo:${n}`);
    const i = this.editor.user.getIsDynamicResizeMode() ? 1 / this.editor.getZoomLevel() : 1, r = this.editor.getStyleForNextShape(Fn), s = r === "star" ? { w: 200, h: 190 } : r === "cloud" ? { w: 300, h: 180 } : { w: 200, h: 200 };
    this.editor.createShapes([
      {
        id: n,
        type: "geo",
        x: e.x,
        y: e.y,
        props: {
          geo: this.editor.getStyleForNextShape(Fn),
          scale: i,
          ...s
        }
      }
    ]);
    const o = this.editor.getShape(n);
    if (!o) return;
    const { w: a, h: c } = o.props, d = new x(a / 2, c / 2).mul(i), u = this.editor.getShapeParentTransform(o);
    u && d.rot(-u.rotation()), this.editor.select(n), this.editor.updateShape({
      id: o.id,
      type: "geo",
      x: o.x - d.x,
      y: o.y - d.y,
      props: {
        geo: this.editor.getStyleForNextShape(Fn),
        w: a * i,
        h: c * i
      }
    }), this.editor.getInstanceState().isToolLocked ? this.parent.transition("idle") : this.editor.setCurrentTool("select", {});
  }
  cancel() {
    this.parent.transition("idle");
  }
}, S(Lm, "id", "pointing"), Lm);
class AI extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "geo");
  }
  static children() {
    return [Die, wie];
  }
}
S(AI, "id", "geo"), S(AI, "initial", "idle");
class Eh extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "highlight");
  }
  static children() {
    return [kk, Lk];
  }
  onExit() {
    const n = this.children.drawing;
    n.initialShape = void 0;
  }
}
S(Eh, "id", "highlight"), S(Eh, "initial", "idle"), S(Eh, "isLockable", !1);
var km;
let Nie = (km = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeId", "");
  }
  onEnter(n) {
    this.shapeId = n.shapeId, this.editor.setCursor({ type: "cross", rotation: 0 });
  }
  onPointerDown() {
    this.parent.transition("pointing", { shapeId: this.shapeId });
  }
  onCancel() {
    this.editor.setCurrentTool("select");
  }
}, S(km, "id", "idle"), km);
const pN = 2;
var Om;
let Aie = (Om = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "shape", {});
    S(this, "markId");
  }
  onEnter(n) {
    const { inputs: i } = this.editor, { currentPagePoint: r } = i;
    this.markId = void 0;
    const s = n.shapeId && this.editor.getShape(n.shapeId);
    if (s && i.shiftKey) {
      this.markId = this.editor.markHistoryStoppingPoint(`creating_line:${s.id}`), this.shape = s;
      const o = this.editor.getShapeHandles(this.shape);
      if (!o) return;
      const a = o.filter((p) => p.type === "vertex").sort(Jt), c = a[a.length - 1], d = a[a.length - 2], u = ne.applyToPoint(
        this.editor.getShapeParentTransform(this.shape),
        new x(this.shape.x, this.shape.y)
      ), h = x.Sub(r, u).addXY(0.1, 0.1), g = Ct(this.shape.props.points);
      if (x.DistMin(c, d, pN) || x.DistMin(h, c, pN))
        g[c.id] = {
          id: c.id,
          index: c.index,
          x: h.x,
          y: h.y
        };
      else {
        const p = hi(c.index);
        g[p] = {
          id: p,
          index: p,
          x: h.x,
          y: h.y
        };
      }
      this.editor.updateShapes([
        {
          id: this.shape.id,
          type: this.shape.type,
          props: {
            points: g
          }
        }
      ]);
    } else {
      const o = Ee();
      this.markId = this.editor.markHistoryStoppingPoint(`creating_line:${o}`), this.editor.createShapes([
        {
          id: o,
          type: "line",
          x: r.x,
          y: r.y,
          props: {
            scale: this.editor.user.getIsDynamicResizeMode() ? 1 / this.editor.getZoomLevel() : 1
          }
        }
      ]), this.editor.select(o), this.shape = this.editor.getShape(o);
    }
  }
  onPointerMove() {
    if (this.shape && this.editor.inputs.isDragging) {
      const n = this.editor.getShapeHandles(this.shape);
      if (!n)
        throw this.markId && this.editor.bailToMark(this.markId), Error("No handles found");
      const i = pn(n);
      this.editor.setCurrentTool("select.dragging_handle", {
        shape: this.shape,
        isCreating: !0,
        creatingMarkId: this.markId,
        // remove the offset that we added to the handle when we created it
        handle: { ...i, x: i.x - 0.1, y: i.y - 0.1 },
        onInteractionEnd: "line"
      });
    }
  }
  onPointerUp() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.complete();
  }
  onInterrupt() {
    this.parent.transition("idle"), this.markId && this.editor.bailToMark(this.markId), this.editor.snaps.clearIndicators();
  }
  complete() {
    this.parent.transition("idle", { shapeId: this.shape.id }), this.editor.snaps.clearIndicators();
  }
  cancel() {
    this.markId && this.editor.bailToMark(this.markId), this.parent.transition("idle", { shapeId: this.shape.id }), this.editor.snaps.clearIndicators();
  }
}, S(Om, "id", "pointing"), Om);
class TI extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "line");
  }
  static children() {
    return [Nie, Aie];
  }
}
S(TI, "id", "line"), S(TI, "initial", "idle");
var Pm;
let Tie = (Pm = class extends ee {
  onPointerDown(e) {
    this.parent.transition("pointing", e);
  }
  onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 });
  }
  onCancel() {
    this.editor.setCurrentTool("select");
  }
}, S(Pm, "id", "idle"), Pm);
const bie = 0, Mt = 200, pf = new x(Mt / 2, Mt / 2), Ok = 10, vie = (t) => [
  [
    ["a1"],
    new x(Mt * 0.5, Mt * -0.5 - t.options.adjacentShapeMargin)
  ],
  // t
  [
    ["a2"],
    new x(Mt * 1.5 + t.options.adjacentShapeMargin, Mt * 0.5)
  ],
  // r
  [
    ["a3"],
    new x(Mt * 0.5, Mt * 1.5 + t.options.adjacentShapeMargin)
  ],
  // b
  [
    ["a4"],
    new x(Mt * -0.5 - t.options.adjacentShapeMargin, Mt * 0.5)
  ]
  // l
];
function Eie(t, e) {
  if (e === 1) return vie(t);
  const n = Mt * e, i = t.options.adjacentShapeMargin * e;
  return [
    [["a1"], new x(n * 0.5, n * -0.5 - i)],
    // t
    [["a2"], new x(n * 1.5 + i, n * 0.5)],
    // r
    [["a3"], new x(n * 0.5, n * 1.5 + i)],
    // b
    [["a4"], new x(n * -0.5 - i, n * 0.5)]
    // l
  ];
}
function Pk(t, e, n, i, r, s) {
  return Object.fromEntries(
    Eie(t, s).map(([o, a], c) => {
      const d = a.clone();
      return c === 0 && r ? d.y -= r : c === 2 && i && (d.y += i), [o, d.rot(n).add(e)];
    })
  );
}
function Uk(t, e, n, i) {
  const r = new Set(t.getSelectedShapeIds()), s = (Mt + t.options.adjacentShapeMargin + i) ** 2, o = /* @__PURE__ */ new Map(), a = [];
  for (const u of t.getCurrentPageShapes()) {
    if (!t.isShapeOfType(u, "note") || n !== u.props.scale || r.has(u.id))
      continue;
    const h = t.getShapePageTransform(u.id);
    e === h.rotation() && (o.set(u, t.getShapePageBounds(u).center), a.push(
      ...Object.values(
        Pk(
          t,
          h.point(),
          e,
          u.props.growY,
          i,
          n
        )
      )
    ));
  }
  const c = a.length;
  let d;
  for (const [u, h] of o)
    for (let g = 0; g < c; g++)
      d = a[g], d && (x.Dist2(h, d) > s || t.isPointInShape(u, d) && (a[g] = void 0));
  return Ze(a);
}
function Rk(t, e, n, i, r = !1) {
  let s;
  const o = t.getCurrentPageShapesSorted(), a = (Mt + t.options.adjacentShapeMargin ** 2) ** e.props.scale;
  for (let c = o.length - 1; c >= 0; c--) {
    const d = o[c];
    if (d.type === "note" && d.id !== e.id) {
      const u = t.getShapePageBounds(d);
      if (u && x.Dist2(u.center, n) < a && t.isPointInShape(d, n)) {
        s = d;
        break;
      }
    }
  }
  if (t.complete(), !s || r) {
    t.markHistoryStoppingPoint("creating note shape");
    const c = Ee();
    t.createShape({
      id: c,
      type: "note",
      x: n.x,
      y: n.y,
      rotation: i,
      opacity: e.opacity,
      props: {
        // Use the props of the shape we're cloning
        ...e.props,
        // ...except for these values, which should reset to their defaults
        text: "",
        growY: 0,
        fontSizeAdjustment: 0,
        url: ""
      }
    });
    const d = t.getShape(c);
    if (!d) return;
    const u = t.getPointInParentSpace(
      d,
      x.Sub(
        n,
        x.Rot(pf.clone().mul(d.props.scale), i)
      )
    );
    t.updateShape({
      id: c,
      type: "note",
      x: u.x,
      y: u.y
    }), s = t.getShape(c);
  }
  return dz(t), s;
}
var Um;
let Cie = (Um = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "dragged", !1);
    S(this, "info", {});
    S(this, "markId", "");
    S(this, "shape", {});
  }
  onEnter() {
    const { editor: n } = this, i = Ee();
    this.markId = n.markHistoryStoppingPoint(`creating_note:${i}`);
    const r = this.editor.inputs.originPagePoint.clone(), s = zie(
      this.editor,
      r,
      this.editor.user.getIsDynamicResizeMode() ? 1 / this.editor.getZoomLevel() : 1
    );
    s && r.sub(s), this.shape = Lie(this.editor, i, r);
  }
  onPointerMove(n) {
    this.editor.inputs.isDragging && this.editor.setCurrentTool("select.translating", {
      ...n,
      target: "shape",
      shape: this.shape,
      onInteractionEnd: "note",
      isCreating: !0,
      creatingMarkId: this.markId,
      onCreate: () => {
        this.editor.setEditingShape(this.shape.id), this.editor.setCurrentTool("select.editing_shape");
      }
    });
  }
  onPointerUp() {
    this.complete();
  }
  onInterrupt() {
    this.cancel();
  }
  onComplete() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  complete() {
    this.editor.getInstanceState().isToolLocked ? this.parent.transition("idle") : (this.editor.setEditingShape(this.shape.id), this.editor.setCurrentTool("select.editing_shape", {
      ...this.info,
      target: "shape",
      shape: this.shape
    }));
  }
  cancel() {
    this.editor.bailToMark(this.markId), this.parent.transition("idle", this.info);
  }
}, S(Um, "id", "pointing"), Um);
function zie(t, e, n) {
  let i = Ok / t.getZoomLevel(), r;
  for (const s of Uk(t, 0, n, 0)) {
    const o = x.Sub(e, s), a = o.len();
    a < i && (i = a, r = o);
  }
  return r;
}
function Lie(t, e, n) {
  t.createShape({
    id: e,
    type: "note",
    x: n.x,
    y: n.y,
    props: {
      scale: t.user.getIsDynamicResizeMode() ? 1 / t.getZoomLevel() : 1
    }
  }).select(e);
  const i = t.getShape(e), r = t.getShapeGeometry(i).bounds;
  return t.updateShapes([
    {
      id: e,
      type: "note",
      x: i.x - r.width / 2,
      y: i.y - r.height / 2
    }
  ]), t.getShape(e);
}
class bI extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "note");
  }
  static children() {
    return [Tie, Cie];
  }
}
S(bI, "id", "note"), S(bI, "initial", "idle");
function kie(t) {
  const e = t.getShapeAtPoint(t.inputs.currentPagePoint, {
    hitInside: !1,
    hitLabels: !1,
    margin: t.options.hitTestMargin / t.getZoomLevel(),
    renderingOnly: !0
  });
  if (!e) return t.setHoveredShape(null);
  let n;
  const i = t.getOutermostSelectableShape(e);
  return i === e || i.id === t.getFocusedGroupId() || t.getSelectedShapeIds().includes(i.id) ? n = e : n = i, t.setHoveredShape(n.id);
}
const ds = nx(
  kie,
  process.env.NODE_ENV === "test" ? 0 : 32
);
var Rm;
let Oie = (Rm = class extends ee {
  onPointerMove(e) {
    switch (e.target) {
      case "shape":
      case "canvas":
        ds(this.editor);
    }
  }
  onPointerDown(e) {
    this.parent.transition("pointing", e);
  }
  onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 });
  }
  onExit() {
    ds.cancel();
  }
  onKeyDown(e) {
    var n;
    if (e.key === "Enter") {
      if (this.editor.getIsReadonly()) return null;
      const i = this.editor.getOnlySelectedShape();
      i && this.editor.getShapeUtil(i).canEdit(i) && (this.editor.setCurrentTool("select"), this.editor.setEditingShape(i.id), (n = this.editor.root.getCurrent()) == null || n.transition("editing_shape", {
        ...e,
        target: "shape",
        shape: i
      }));
    }
  }
  onCancel() {
    this.editor.setCurrentTool("select");
  }
}, S(Rm, "id", "idle"), Rm);
var Ym;
let Pie = (Ym = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "shape");
    S(this, "markId", "");
    S(this, "enterTime", 0);
  }
  onEnter() {
    this.enterTime = Date.now();
  }
  onExit() {
    this.editor.setHintingShapes([]);
  }
  onPointerMove(n) {
    if (Date.now() - this.enterTime < 150) return;
    const { editor: i } = this, { isPointing: r } = i.inputs;
    if (!r) return;
    const { originPagePoint: s, currentPagePoint: o } = i.inputs, a = Math.abs(s.x - o.x), d = Math.sqrt(
      i.getInstanceState().isCoarsePointer ? i.options.coarseDragDistanceSquared : i.options.dragDistanceSquared
    ) * 6 / i.getZoomLevel();
    if (a > d) {
      const u = Ee();
      this.markId = i.markHistoryStoppingPoint(`creating_text:${u}`);
      const h = this.createTextShape(u, s, !1, a);
      if (!h) {
        this.cancel();
        return;
      }
      this.shape = i.getShape(h), i.select(u), i.setCurrentTool("select.resizing", {
        ...n,
        target: "selection",
        handle: "right",
        isCreating: !0,
        creatingMarkId: this.markId,
        // Make sure the cursor offset takes into account how far we've already dragged
        creationCursorOffset: { x: a, y: 1 },
        onInteractionEnd: "text",
        onCreate: () => {
          i.setEditingShape(h.id);
        }
      });
    }
  }
  onPointerUp() {
    this.complete();
  }
  onComplete() {
    this.cancel();
  }
  onCancel() {
    this.cancel();
  }
  onInterrupt() {
    this.cancel();
  }
  complete() {
    this.editor.markHistoryStoppingPoint("creating text shape");
    const n = Ee(), { originPagePoint: i } = this.editor.inputs;
    this.createTextShape(n, i, !0, 20) && (this.editor.select(n), this.editor.setEditingShape(n));
  }
  cancel() {
    this.parent.transition("idle"), this.editor.bailToMark(this.markId);
  }
  createTextShape(n, i, r, s) {
    this.editor.createShape({
      id: n,
      type: "text",
      x: i.x,
      y: i.y,
      props: {
        text: "",
        autoSize: r,
        w: s,
        scale: this.editor.user.getIsDynamicResizeMode() ? 1 / this.editor.getZoomLevel() : 1
      }
    });
    const o = this.editor.getShape(n);
    if (!o) {
      this.cancel();
      return;
    }
    const a = this.editor.getShapePageBounds(o), c = new x();
    if (r)
      switch (o.props.textAlign) {
        case "start": {
          c.x = 0;
          break;
        }
        case "middle": {
          c.x = -a.width / 2;
          break;
        }
        case "end": {
          c.x = -a.width;
          break;
        }
      }
    else
      c.x = 0;
    if (c.y = -a.height / 2, si(o.parentId)) {
      const d = this.editor.getShapeParentTransform(o);
      c.rot(-d.rotation());
    }
    return this.editor.updateShape({
      ...o,
      x: o.x + c.x,
      y: o.y + c.y
    }), o;
  }
}, S(Ym, "id", "pointing"), Ym);
class vI extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "text");
  }
  static children() {
    return [Oie, Pie];
  }
}
S(vI, "id", "text"), S(vI, "initial", "idle");
const Uie = [
  vI,
  vh,
  AI,
  bI,
  TI,
  NI,
  wI,
  Eh
];
function $n() {
  return Hr({ isDarkMode: Tc() });
}
function ff(t) {
  return {
    key: `${ki.id}:${t}`,
    async getElement() {
      const e = Rie(t);
      if (!e) return null;
      const n = e.$$_url, i = e.$$_fontface;
      if (!n || !i) return null;
      const r = await (await gr(n)).blob(), s = await us.blobToDataUrl(r), o = i.replace(n, s);
      return /* @__PURE__ */ l.jsx("style", { children: o });
    }
  };
}
function Rie(t) {
  const e = kb[t];
  for (const n of document.fonts)
    if (e.includes(n.family))
      return n;
  return null;
}
function pj(t) {
  return {
    key: `${ki.id}:${t}`,
    async getElement() {
      return t !== "pattern" ? null : /* @__PURE__ */ l.jsx(Yie, {});
    }
  };
}
function Yie() {
  const t = Mj(), e = Sc(), n = $n(), i = 8 / 12;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs("mask", { id: e, children: [
      /* @__PURE__ */ l.jsx("rect", { x: "0", y: "0", width: "8", height: "8", fill: "white" }),
      /* @__PURE__ */ l.jsxs("g", { strokeLinecap: "round", stroke: "black", children: [
        /* @__PURE__ */ l.jsx("line", { x1: i * 1, y1: i * 3, x2: i * 3, y2: i * 1 }),
        /* @__PURE__ */ l.jsx("line", { x1: i * 5, y1: i * 7, x2: i * 7, y2: i * 5 }),
        /* @__PURE__ */ l.jsx("line", { x1: i * 9, y1: i * 11, x2: i * 11, y2: i * 9 })
      ] })
    ] }),
    /* @__PURE__ */ l.jsx(
      "pattern",
      {
        id: t(1, n.id),
        width: "8",
        height: "8",
        patternUnits: "userSpaceOnUse",
        children: /* @__PURE__ */ l.jsx("rect", { x: "0", y: "0", width: "8", height: "8", fill: n.solid, mask: `url(#${e})` })
      }
    )
  ] });
}
function fj() {
  return {
    key: `${ki.id}:pattern`,
    component: Bie
  };
}
const Al = 8, fN = (t, e, n) => new Promise((i, r) => {
  const s = Al * e * t, o = document.createElement("canvas");
  o.width = s, o.height = s;
  const a = o.getContext("2d");
  if (!a) return;
  a.fillStyle = n ? Tg.darkMode.solid : Tg.lightMode.solid, a.fillRect(0, 0, s, s), a.globalCompositeOperation = "destination-out", a.lineCap = "round", a.lineWidth = 1.25 * e * t;
  const c = 8 / 12, d = (u) => u * e * t;
  a.beginPath(), a.moveTo(d(c * 1), d(c * 3)), a.lineTo(d(c * 3), d(c * 1)), a.moveTo(d(c * 5), d(c * 7)), a.lineTo(d(c * 7), d(c * 5)), a.moveTo(d(c * 9), d(c * 11)), a.lineTo(d(c * 11), d(c * 9)), a.stroke(), o.toBlob((u) => {
    !u || Wt.throwToBlob.get() ? r() : i(u);
  });
}), MN = (t, e) => {
  const n = document.createElement("canvas");
  n.width = t[0], n.height = t[1];
  const i = n.getContext("2d");
  return i ? (e(i), n.toDataURL()) : "";
};
let sm = null;
function Qie() {
  return sm || (sm = {
    white: MN([1, 1], (t) => {
      t.fillStyle = "#f8f9fa", t.fillRect(0, 0, 1, 1);
    }),
    black: MN([1, 1], (t) => {
      t.fillStyle = "#212529", t.fillRect(0, 0, 1, 1);
    })
  }), sm;
}
function Yk(t) {
  return Math.ceil(Math.log2(Math.max(1, t)));
}
function Mj() {
  const t = lr("hash_pattern");
  return re(
    (e, n) => {
      const i = Yk(e);
      return Vx(t, `${n}_${i}`);
    },
    [t]
  );
}
function Qk(t) {
  const e = [], i = Yk(t);
  for (let r = 0; r <= i; r++)
    e.push(Math.pow(2, r));
  return e;
}
function Zie(t) {
  const e = Qie();
  return Qk(t).flatMap((n) => [
    { zoom: n, url: e.white, theme: "light" },
    { zoom: n, url: e.black, theme: "dark" }
  ]);
}
function Fie() {
  const t = Q(), e = G("devicePixelRatio", () => t.getInstanceState().devicePixelRatio, [
    t
  ]), n = G("maxZoom", () => Math.ceil(pn(t.getCameraOptions().zoomSteps)), [
    t
  ]), [i, r] = pe(!1), [s, o] = pe(
    () => Zie(n)
  ), a = Mj();
  return ze(() => {
    if (process.env.NODE_ENV === "test") {
      r(!0);
      return;
    }
    const d = Promise.all(
      Qk(n).flatMap((h) => [
        fN(e, h, !1).then((g) => ({
          zoom: h,
          theme: "light",
          url: URL.createObjectURL(g)
        })),
        fN(e, h, !0).then((g) => ({
          zoom: h,
          theme: "dark",
          url: URL.createObjectURL(g)
        }))
      ])
    );
    let u = !1;
    return d.then((h) => {
      u || (o(h), r(!0));
    }), () => {
      u = !0, r(!1), d.then((h) => {
        for (const { url: g } of h)
          URL.revokeObjectURL(g);
      });
    };
  }, [e, n]), { defs: /* @__PURE__ */ l.jsx(l.Fragment, { children: s.map((d) => {
    const u = a(d.zoom, d.theme);
    return /* @__PURE__ */ l.jsx(
      "pattern",
      {
        id: u,
        width: Al,
        height: Al,
        patternUnits: "userSpaceOnUse",
        children: /* @__PURE__ */ l.jsx("image", { href: d.url, width: Al, height: Al })
      },
      u
    );
  }) }), isReady: i };
}
function Bie() {
  const t = Q(), e = le(null), { defs: n, isReady: i } = Fie();
  return ze(() => {
    if (i && mt.isSafari) {
      const r = Zk(e.current);
      r && t.timers.requestAnimationFrame(() => {
        r.style.display = "none", t.timers.requestAnimationFrame(() => {
          r.style.display = "";
        });
      });
    }
  }, [t, i]), /* @__PURE__ */ l.jsx("g", { ref: e, "data-testid": i ? "ready-pattern-fill-defs" : void 0, children: n });
}
function Zk(t) {
  return t.classList.contains("tl-html-layer") ? t : t.parentElement ? Zk(t.parentElement) : null;
}
const Nn = Ye.memo(function({
  theme: e,
  d: n,
  color: i,
  fill: r,
  scale: s
}) {
  switch (r) {
    case "none":
      return null;
    case "solid":
      return /* @__PURE__ */ l.jsx("path", { fill: e[i].semi, d: n });
    case "semi":
      return /* @__PURE__ */ l.jsx("path", { fill: e.solid, d: n });
    case "fill":
      return /* @__PURE__ */ l.jsx("path", { fill: e[i].fill, d: n });
    case "pattern":
      return /* @__PURE__ */ l.jsx(Gie, { theme: e, color: i, fill: r, d: n, scale: s });
  }
});
function Gie({ d: t, color: e, theme: n }) {
  const i = Q(), r = Id(), s = G("zoomLevel", () => i.getZoomLevel(), [i]), o = Mj(), a = i.getZoomLevel() <= 0.18;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx("path", { fill: n[e].pattern, d: t }),
    /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: r ? `url(#${o(1, n.id)})` : a ? n[e].semi : `url(#${o(s, n.id)})`,
        d: t
      }
    )
  ] });
}
function Wie(t) {
  return t.replace(/\s/g, " ");
}
function EI(t, e, n) {
  const { padding: i = 0 } = n;
  if (e.length === 0) return null;
  const r = ae.From(e[0].box);
  for (const { box: d } of e)
    r.union(d);
  const s = i + (n.offsetX ?? 0), o = (n.offsetY ?? 0) + n.fontSize / 2 + (n.verticalTextAlign === "start" ? i : n.verticalTextAlign === "end" ? n.height - i - r.height : (Math.ceil(n.height) - r.height) / 2);
  let a = null;
  const c = [];
  for (const { text: d, box: u } of e)
    a !== null && u.y > a && c.push(
      /* @__PURE__ */ l.jsx(
        "tspan",
        {
          alignmentBaseline: "mathematical",
          x: s,
          y: u.y + o,
          children: `
`
        },
        c.length
      )
    ), c.push(
      /* @__PURE__ */ l.jsx(
        "tspan",
        {
          alignmentBaseline: "mathematical",
          x: u.x + s,
          y: u.y + o,
          unicodeBidi: "plaintext",
          children: Wie(d)
        },
        c.length
      )
    ), a = u.y;
  return /* @__PURE__ */ l.jsx(
    "text",
    {
      fontSize: n.fontSize,
      fontFamily: n.fontFamily,
      fontStyle: n.fontStyle,
      fontWeight: n.fontWeight,
      dominantBaseline: "mathematical",
      alignmentBaseline: "mathematical",
      stroke: n.stroke,
      strokeWidth: n.strokeWidth,
      fill: n.fill,
      children: c
    }
  );
}
function Hie(t, e, n, i) {
  if ((t === "start-legacy" || t === "end-legacy") && n.length !== 0) {
    const r = ae.From(n[0].box);
    for (const { box: s } of n)
      r.union(s);
    if (t === "start-legacy")
      return (i - 2 * e - r.width) / 2;
    if (t === "end-legacy")
      return -(i - 2 * e - r.width) / 2;
  }
}
function Vie(t) {
  return t === "start-legacy" || t === "middle-legacy" || t === "end-legacy";
}
function Mf({
  fontSize: t,
  font: e,
  align: n,
  verticalAlign: i,
  text: r,
  labelColor: s,
  bounds: o,
  padding: a = 16,
  stroke: c = !0
}) {
  const d = Q(), u = $n(), h = {
    fontSize: t,
    fontFamily: kb[e],
    textAlign: n,
    verticalTextAlign: i,
    width: Math.ceil(o.width),
    height: Math.ceil(o.height),
    padding: a,
    lineHeight: Cn.lineHeight,
    fontStyle: "normal",
    fontWeight: "normal",
    overflow: "wrap",
    offsetX: 0,
    offsetY: 0,
    fill: s,
    stroke: void 0,
    strokeWidth: void 0
  }, g = d.textMeasure.measureTextSpans(r, h), p = Hie(n, a, g, o.width);
  p && (h.offsetX = p), h.offsetX += o.x, h.offsetY += o.y;
  const f = EI(d, g, h);
  let M = null;
  return c && (h.fill = u.background, h.stroke = u.background, h.strokeWidth = 2, M = EI(d, g, h)), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    M,
    f
  ] });
}
const Kie = dc(function({
  isEditing: e,
  text: n,
  handleFocus: i,
  handleChange: r,
  handleKeyDown: s,
  handleBlur: o,
  handleInputPointerDown: a,
  handleDoubleClick: c
}, d) {
  return /* @__PURE__ */ l.jsx(
    "textarea",
    {
      ref: d,
      className: "tl-text tl-text-input",
      name: "text",
      tabIndex: -1,
      readOnly: !e,
      autoComplete: "off",
      autoCapitalize: "off",
      autoCorrect: "off",
      autoSave: "off",
      placeholder: "",
      spellCheck: "true",
      wrap: "off",
      dir: "auto",
      defaultValue: n,
      onFocus: i,
      onChange: r,
      onKeyDown: s,
      onBlur: o,
      onTouchEnd: Yt,
      onContextMenu: e ? Yt : void 0,
      onPointerDown: a,
      onDoubleClick: c,
      onDragStart: Ke
    }
  );
});
function Xie(t, e, n) {
  const i = Q(), r = le(null), s = G("isEditing", () => i.getEditingShapeId() === t, [i]), o = G("isEditingAnything", () => !!i.getEditingShapeId(), [
    i
  ]);
  ze(() => {
    function u(h) {
      var g;
      h.shapeId === t && ((g = r.current) == null || g.select());
    }
    return i.on("select-all-text", u), () => {
      i.off("select-all-text", u);
    };
  }, [i, t, s]), ze(() => {
    var u, h, g, p;
    s && (document.activeElement !== r.current && ((u = r.current) == null || u.focus()), i.getInstanceState().isCoarsePointer && ((h = r.current) == null || h.select()), mt.isSafari && ((g = r.current) == null || g.blur(), (p = r.current) == null || p.focus()));
  }, [i, s]);
  const a = re(
    (u) => {
      if (i.getEditingShapeId() === t)
        switch (u.key) {
          case "Enter": {
            (u.ctrlKey || u.metaKey) && i.complete();
            break;
          }
        }
    },
    [i, t]
  ), c = re(
    (u) => {
      if (i.getEditingShapeId() !== t) return;
      let h = $a.normalizeText(u.currentTarget.value);
      const g = h.replace(/\t/g, za);
      if (g !== h) {
        const p = u.currentTarget.selectionStart;
        u.currentTarget.value = g, u.currentTarget.selectionStart = p + (g.length - h.length), u.currentTarget.selectionEnd = p + (g.length - h.length), h = g;
      }
      i.updateShape({
        id: t,
        type: e,
        props: { text: h }
      });
    },
    [i, t, e]
  ), d = re(
    (u) => {
      i.dispatch({
        ...gi(u),
        type: "pointer",
        name: "pointer_down",
        target: "shape",
        shape: i.getShape(t)
      }), Yt(u);
    },
    [i, t]
  );
  return {
    rInput: r,
    handleFocus: Hl,
    handleBlur: Hl,
    handleKeyDown: a,
    handleChange: c,
    handleInputPointerDown: d,
    handleDoubleClick: Yt,
    isEmpty: n.trim().length === 0,
    isEditing: s,
    isEditingAnything: o
  };
}
const mf = Ye.memo(function({
  shapeId: e,
  type: n,
  text: i,
  labelColor: r,
  font: s,
  fontSize: o,
  lineHeight: a,
  align: c,
  verticalAlign: d,
  wrap: u,
  isSelected: h,
  padding: g = 0,
  onKeyDown: p,
  classNamePrefix: f,
  style: M,
  textWidth: m,
  textHeight: y
}) {
  const { rInput: I, isEmpty: D, isEditing: j, isEditingAnything: w, ...A } = Xie(
    e,
    n,
    i
  ), [b, T] = pe(i);
  ze(() => {
    j || T(i);
  }, [j, i]);
  const E = $a.normalizeTextForDom(i), v = E.length > 0, P = Vie(c);
  if (!j && !v)
    return null;
  const C = f || "tl-text";
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: `${C}-label tl-text-wrapper`,
      "data-font": s,
      "data-align": c,
      "data-hastext": !D,
      "data-isediting": j,
      "data-iseditinganything": w,
      "data-textwrap": !!u,
      "data-isselected": h,
      style: {
        justifyContent: c === "middle" || P ? "center" : c,
        alignItems: d === "middle" ? "center" : d,
        padding: g,
        ...M
      },
      children: /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: `${C}-label__inner tl-text-content__wrapper`,
          style: {
            fontSize: o,
            lineHeight: Math.floor(o * a) + "px",
            minHeight: Math.floor(o * a) + "px",
            minWidth: Math.ceil(m || 0),
            color: r,
            width: m ? Math.ceil(m) : void 0,
            height: y ? Math.ceil(y) : void 0
          },
          children: [
            /* @__PURE__ */ l.jsx("div", { className: `${C} tl-text tl-text-content`, dir: "auto", children: E.split(`
`).map((z, O) => /* @__PURE__ */ l.jsx("div", { dir: "auto", children: z }, O)) }),
            (w || h) && /* @__PURE__ */ l.jsx(
              Kie,
              {
                ref: I,
                text: i,
                isEditing: j,
                ...A,
                handleKeyDown: p ?? A.handleKeyDown
              },
              b
            )
          ]
        }
      )
    }
  );
}), Jie = new hr();
function qie(t) {
  return Jie.get(t, () => t.store.createComputedCache("arrowLabelSize", (e) => {
    const n = Pr(t, e);
    let i = 0, r = 0;
    const s = n.isStraight ? new ls({
      start: x.From(n.start.point),
      end: x.From(n.end.point)
    }) : new ba({
      center: x.Cast(n.handleArc.center),
      start: x.Cast(n.start.point),
      end: x.Cast(n.end.point),
      sweepFlag: n.bodyArc.sweepFlag,
      largeArcFlag: n.bodyArc.largeArcFlag
    });
    if (e.props.text.trim()) {
      const o = s.bounds, a = CI(e), { w: c, h: d } = t.textMeasure.measureText(e.props.text, {
        ...Cn,
        fontFamily: xs[e.props.font],
        fontSize: a,
        maxWidth: null
      });
      i = c, r = d;
      let u = !1;
      if (o.width > o.height ? (i = Math.max(Math.min(c, 64), Math.min(o.width - 64, c)), u = !0) : i > 16 * a && (i = 16 * a, u = !0), u) {
        const { w: h, h: g } = t.textMeasure.measureText(
          e.props.text,
          {
            ...Cn,
            fontFamily: xs[e.props.font],
            fontSize: a,
            maxWidth: i
          }
        );
        i = h, r = g;
      }
    }
    return new x(i, r).addScalar(Xg * 2 * e.props.scale);
  }));
}
function mj(t, e) {
  return e.props.text.trim() === "" ? new x(0, 0).addScalar(Xg * 2 * e.props.scale) : qie(t).get(e.id) ?? new x(0, 0);
}
function Fk(t) {
  const e = mn[t.props.size];
  return (lie + (e - mn.s) * 2 + (e === mn.xl ? 20 : 0)) * t.props.scale;
}
function _ie(t, e, n) {
  const i = mj(t, e), r = Fk(e), s = x.Nudge(n.start.point, n.end.point, r), o = x.Nudge(n.end.point, n.start.point, r), a = aS(
    s,
    o,
    ae.FromCenter(n.middle, i).corners
  );
  if (!a || a.length !== 2)
    return { start: 0.5, end: 0.5 };
  let [c, d] = a;
  x.Dist2(c, s) > x.Dist2(d, s) && ([d, c] = a);
  const u = s.add(x.Sub(n.middle, c)), h = o.add(x.Sub(n.middle, d)), g = x.Dist(n.start.point, u) / n.length, p = x.Dist(n.start.point, h) / n.length;
  return { start: g, end: p };
}
function $ie(t, e, n) {
  const i = mj(t, e), r = Fk(e), s = Math.sign(e.props.bend), o = r / n.handleArc.radius * s, a = x.Angle(n.bodyArc.center, n.start.point) - o, c = x.Angle(n.bodyArc.center, n.end.point) + o, d = Yo(n.bodyArc.center, n.bodyArc.radius, a), u = Yo(n.bodyArc.center, n.bodyArc.radius, c), h = [], g = yN(
    n.bodyArc.center,
    n.bodyArc.radius,
    a,
    c,
    s,
    ae.FromCenter(d, i).corners
  );
  h.push(
    new Gt({
      points: ae.FromCenter(d, i).corners,
      debugColor: "lime",
      isFilled: !1,
      ignore: !0
    })
  );
  const p = yN(
    n.bodyArc.center,
    n.bodyArc.radius,
    a,
    c,
    s,
    ae.FromCenter(u, i).corners
  );
  h.push(
    new Gt({
      points: ae.FromCenter(u, i).corners,
      debugColor: "lime",
      isFilled: !1,
      ignore: !0
    })
  );
  for (const b of [
    ...g ?? [],
    ...p ?? [],
    d,
    u
  ])
    h.push(
      new SS({
        x: b.x - 3,
        y: b.y - 3,
        radius: 3,
        isFilled: !1,
        debugColor: "magenta",
        ignore: !0
      })
    );
  const f = (g && IN(n.start.point, g)) ?? n.middle, M = (p && IN(n.end.point, p)) ?? n.middle, m = x.Angle(n.bodyArc.center, n.start.point), y = x.Angle(n.bodyArc.center, n.end.point), I = x.Angle(n.bodyArc.center, f), D = x.Angle(n.bodyArc.center, M);
  if (Fs(m, I, s) > Fs(m, D, s))
    return { start: 0.5, end: 0.5, dbg: h };
  const j = Fs(m, y, s), w = Fs(m, I, s) / j, A = Fs(m, D, s) / j;
  return { start: w, end: A, dbg: h };
}
function Ch(t, e) {
  let n;
  const i = [], r = Pr(t, e), s = {
    hasStartBinding: !!r.bindings.start,
    hasEndBinding: !!r.bindings.end,
    hasStartArrowhead: r.start.arrowhead !== "none",
    hasEndArrowhead: r.end.arrowhead !== "none"
  };
  if (r.isStraight) {
    const a = _ie(t, e, r), c = mN(t, e, a, s);
    n = x.Lrp(r.start.point, r.end.point, c);
  } else {
    const a = $ie(t, e, r);
    a.dbg && i.push(...a.dbg);
    const c = mN(t, e, a, s), d = ere(
      x.Angle(r.bodyArc.center, r.start.point),
      x.Angle(r.bodyArc.center, r.end.point),
      Math.sign(e.props.bend),
      c
    );
    n = Yo(r.bodyArc.center, r.bodyArc.radius, d);
  }
  const o = mj(t, e);
  return { box: ae.FromCenter(n, o), debugGeom: i };
}
function mN(t, e, n, i) {
  const { hasEndArrowhead: r, hasEndBinding: s, hasStartBinding: o, hasStartArrowhead: a } = i, c = Hk(t, e);
  let d = hn(
    e.props.labelPosition,
    a || o ? n.start : 0,
    r || s ? n.end : 1
  );
  const u = Math.min(0.02, 500 / c * 0.02);
  return d = d >= 0.5 - u && d <= 0.5 + u ? 0.5 : d, d;
}
function yN(t, e, n, i, r, s) {
  const o = Vy(t, e, s), a = Fs(n, i, r);
  return o == null ? void 0 : o.filter((c) => {
    const d = Fs(n, x.Angle(t, c), r);
    return d >= 0 && d <= a;
  });
}
function IN(t, e) {
  let n = null, i = -1 / 0;
  for (const r of e) {
    const s = x.Dist2(t, r);
    s > i && (n = r, i = s);
  }
  return n;
}
function ere(t, e, n, i) {
  const r = Fs(t, e, n);
  return t + r * i * n * -1;
}
function CI(t) {
  return cie[t.props.size] * t.props.scale;
}
function tre(t, e, n) {
  const i = e === "end" ? t.end.point : t.start.point, r = e === "end" ? t.start.point : t.end.point, s = t.isStraight ? x.Dist(r, i) : Math.abs(t.bodyArc.length), o = Math.max(Math.min(s / 5, n * 3), n);
  let a;
  if (t.isStraight)
    a = x.Nudge(i, r, o);
  else {
    const c = xV(i, o, t.handleArc.center, t.handleArc.radius);
    a = e === "end" ? t.handleArc.sweepFlag ? c[0] : c[1] : t.handleArc.sweepFlag ? c[1] : c[0];
  }
  return x.IsNaN(a) && (a = t.start.point), {
    point: i,
    int: a
  };
}
function nre({ point: t, int: e }) {
  const n = x.RotWith(e, t, st / 6), i = x.RotWith(e, t, -st / 6);
  return `M ${n.x} ${n.y} L ${t.x} ${t.y} L ${i.x} ${i.y}`;
}
function ire({ point: t, int: e }) {
  const n = x.RotWith(e, t, st / 6), i = x.RotWith(e, t, -st / 6);
  return `M ${n.x} ${n.y} L ${i.x} ${i.y} L ${t.x} ${t.y} Z`;
}
function rre({ point: t, int: e }) {
  const n = x.Sub(e, t).div(2), i = x.Add(t, x.Rot(n, Nt)), r = x.Sub(t, x.Rot(n, Nt));
  return `M ${i.x} ${i.y} L ${e.x} ${e.y} L ${r.x} ${r.y} Z`;
}
function sre({ point: t, int: e }) {
  const n = x.Lrp(t, e, 0.45), i = x.Dist(n, t);
  return `M ${n.x - i},${n.y}
  a ${i},${i} 0 1,0 ${i * 2},0
  a ${i},${i} 0 1,0 -${i * 2},0 `;
}
function ore({ point: t, int: e }) {
  const n = x.Lrp(t, e, 0.75), i = x.RotWith(n, t, st / 4), r = x.RotWith(n, t, -st / 4), s = x.Lrp(i, r, 0.5);
  return s.add(x.Sub(s, t)), `M ${s.x} ${s.y} L ${r.x} ${r.y} ${t.x} ${t.y} L ${i.x} ${i.y} Z`;
}
function are({ int: t, point: e }) {
  const n = x.Lrp(e, t, 0.85), i = x.Sub(n, e).div(2), r = x.Add(e, x.Rot(i, Nt)), s = x.Sub(e, x.Rot(i, Nt)), o = x.Add(n, x.Rot(i, Nt)), a = x.Sub(n, x.Rot(i, Nt));
  return `M ${r.x} ${r.y} L ${o.x} ${o.y} L ${a.x} ${a.y} L ${s.x} ${s.y} Z`;
}
function cre({ int: t, point: e }) {
  const n = x.Sub(t, e).div(2), i = x.Add(e, x.Rot(n, Nt)), r = x.Sub(e, x.Rot(n, Nt));
  return `M ${i.x} ${i.y} L ${r.x} ${r.y}`;
}
function Jg(t, e, n) {
  const i = e === "end" ? t.end.arrowhead : t.start.arrowhead;
  if (i === "none") return;
  const r = tre(t, e, n);
  if (r) {
    switch (i) {
      case "bar":
        return cre(r);
      case "square":
        return are(r);
      case "diamond":
        return ore(r);
      case "dot":
        return sre(r);
      case "inverted":
        return rre(r);
      case "arrow":
        return nre(r);
      case "triangle":
        return ire(r);
    }
    return "";
  }
}
function lre(t) {
  const {
    start: e,
    end: n,
    handleArc: { radius: i, largeArcFlag: r, sweepFlag: s }
  } = t;
  return `M${e.handle.x},${e.handle.y} A${i} ${i} 0 ${r} ${s} ${n.handle.x},${n.handle.y}`;
}
function Bk(t) {
  const {
    start: e,
    end: n,
    bodyArc: { radius: i, largeArcFlag: r, sweepFlag: s }
  } = t;
  return `M${e.point.x},${e.point.y} A${i} ${i} 0 ${r} ${s} ${n.point.x},${n.point.y}`;
}
function Gk(t, e) {
  return `M${t.x},${t.y}L${e.x},${e.y}`;
}
function dre(t) {
  return Gk(t.start.handle, t.end.handle);
}
function Wk(t) {
  return Gk(t.start.point, t.end.point);
}
class zh extends Ci {
  constructor() {
    super(...arguments);
    S(this, "_resizeInitialBindings", new hr());
  }
  canEdit() {
    return !0;
  }
  canBind({ toShapeType: n }) {
    return n !== "arrow";
  }
  canSnap() {
    return !1;
  }
  hideResizeHandles() {
    return !0;
  }
  hideRotateHandle() {
    return !0;
  }
  hideSelectionBoundsBg() {
    return !0;
  }
  hideSelectionBoundsFg() {
    return !0;
  }
  canBeLaidOut(n) {
    const i = li(this.editor, n);
    return !i.start && !i.end;
  }
  getDefaultProps() {
    return {
      dash: "draw",
      size: "m",
      fill: "none",
      color: "black",
      labelColor: "black",
      bend: 0,
      start: { x: 0, y: 0 },
      end: { x: 2, y: 0 },
      arrowheadStart: "none",
      arrowheadEnd: "arrow",
      text: "",
      labelPosition: 0.5,
      font: "draw",
      scale: 1
    };
  }
  getGeometry(n) {
    const i = Pr(this.editor, n), r = [], s = i.isStraight ? new ls({
      start: x.From(i.start.point),
      end: x.From(i.end.point)
    }) : new ba({
      center: x.Cast(i.handleArc.center),
      start: x.Cast(i.start.point),
      end: x.Cast(i.end.point),
      sweepFlag: i.bodyArc.sweepFlag,
      largeArcFlag: i.bodyArc.largeArcFlag
    });
    let o;
    if (n.props.text.trim()) {
      const a = Ch(this.editor, n);
      r.push(...a.debugGeom), o = new Pi({
        x: a.box.x,
        y: a.box.y,
        width: a.box.w,
        height: a.box.h,
        isFilled: !0,
        isLabel: !0
      });
    }
    return new Ki({
      children: [...o ? [s, o] : [s], ...r]
    });
  }
  getHandles(n) {
    const i = Pr(this.editor, n);
    return [
      {
        id: "start",
        type: "vertex",
        index: "a0",
        x: i.start.handle.x,
        y: i.start.handle.y
      },
      {
        id: "middle",
        type: "virtual",
        index: "a2",
        x: i.middle.x,
        y: i.middle.y
      },
      {
        id: "end",
        type: "vertex",
        index: "a3",
        x: i.end.handle.x,
        y: i.end.handle.y
      }
    ].filter(Boolean);
  }
  getText(n) {
    return n.props.text;
  }
  onHandleDrag(n, { handle: i, isPrecise: r }) {
    const s = i.id, o = li(this.editor, n);
    if (s === "middle") {
      const { start: A, end: b } = Ea(this.editor, n, o), T = x.Sub(b, A), E = x.Per(T), v = x.Med(b, A), P = x.Sub(v, E), C = x.Add(v, E), z = x.NearestPointOnLineSegment(P, C, i, !1);
      let O = x.Dist(z, v);
      return x.Clockwise(z, b, v) && (O *= -1), { id: n.id, type: n.type, props: { bend: O } };
    }
    const a = { id: n.id, type: "arrow", props: {} }, c = o[s], u = o[s === "start" ? "end" : "start"];
    if (this.editor.inputs.ctrlKey)
      return Th(this.editor, n, s), a.props[s] = {
        x: i.x,
        y: i.y
      }, a;
    const h = this.editor.getShapePageTransform(n.id).applyToPoint(i), g = this.editor.getShapeAtPoint(h, {
      hitInside: !0,
      hitFrameInside: !0,
      margin: 0,
      filter: (A) => !A.isLocked && this.editor.canBindShapes({ fromShape: n, toShape: A, binding: "arrow" })
    });
    if (!g)
      return Th(this.editor, n, s), a.props[s] = {
        x: i.x,
        y: i.y
      }, a;
    const p = this.editor.getShapeGeometry(g), f = ae.ZeroFix(p.bounds), m = this.editor.getShapePageTransform(a.id).applyToPoint(i), y = this.editor.getPointInShapeSpace(g, m);
    let I = r;
    I || (!c || c && g.id !== c.toId) && (I = this.editor.inputs.pointerVelocity.len() < 0.5), r || (p.isClosed || (I = !0), u && g.id === u.toId && u.props.isPrecise && (I = !0));
    const D = {
      x: (y.x - f.minX) / f.width,
      y: (y.y - f.minY) / f.height
    };
    I && x.Dist(y, f.center) < Math.max(4, Math.min(Math.min(f.width, f.height) * 0.15, 16)) / this.editor.getZoomLevel() && (D.x = 0.5, D.y = 0.5);
    const j = {
      terminal: s,
      normalizedAnchor: D,
      isPrecise: I,
      isExact: this.editor.inputs.altKey
    };
    dl(this.editor, n, g.id, j), this.editor.setHintingShapes([g.id]);
    const w = li(this.editor, n);
    return w.start && w.end && w.start.toId === w.end.toId && x.Equals(w.start.props.normalizedAnchor, w.end.props.normalizedAnchor) && dl(this.editor, n, w.end.toId, {
      ...w.end.props,
      normalizedAnchor: {
        x: w.end.props.normalizedAnchor.x + 0.05,
        y: w.end.props.normalizedAnchor.y
      }
    }), a;
  }
  onTranslateStart(n) {
    const i = li(this.editor, n), r = Ea(this.editor, n, i), s = this.editor.getShapePageTransform(n.id), o = this.editor.getSelectedShapeIds();
    if (!(i.start && (o.includes(i.start.toId) || this.editor.isAncestorSelected(i.start.toId)) || i.end && (o.includes(i.end.toId) || this.editor.isAncestorSelected(i.end.toId)))) {
      SN.set(n, {
        pagePosition: s.applyToPoint(n),
        terminalBindings: ld(r, (a, c) => {
          const d = i[a];
          return d ? {
            binding: d,
            shapePosition: c,
            pagePosition: s.applyToPoint(c)
          } : null;
        })
      }), i.start && (Kg({
        editor: this.editor,
        arrow: n,
        terminal: "start",
        useHandle: !0
      }), n = this.editor.getShape(n.id)), i.end && Kg({
        editor: this.editor,
        arrow: n,
        terminal: "end",
        useHandle: !0
      });
      for (const a of [
        "start",
        "end"
        /* END */
      ]) {
        const c = i[a];
        c && this.editor.updateBinding({
          ...c,
          props: { ...c.props, isPrecise: !0 }
        });
      }
    }
  }
  onTranslate(n, i) {
    const r = SN.get(n);
    if (!r) return;
    const s = this.editor.getShapePageTransform(i.id), o = x.Sub(
      s.applyToPoint(i),
      r.pagePosition
    );
    for (const a of Object.values(r.terminalBindings)) {
      if (!a) continue;
      const c = x.Add(a.pagePosition, x.Mul(o, 0.5)), d = this.editor.getShapeAtPoint(c, {
        hitInside: !0,
        hitFrameInside: !0,
        margin: 0,
        filter: (u) => !u.isLocked && this.editor.canBindShapes({ fromShape: i, toShape: u, binding: "arrow" })
      });
      if ((d == null ? void 0 : d.id) === a.binding.toId) {
        const u = ae.ZeroFix(this.editor.getShapeGeometry(d).bounds), h = this.editor.getPointInShapeSpace(d, c), g = {
          x: (h.x - u.minX) / u.width,
          y: (h.y - u.minY) / u.height
        };
        dl(this.editor, i, d.id, {
          ...a.binding.props,
          normalizedAnchor: g,
          isPrecise: !0
        });
      } else
        Th(this.editor, i, a.binding.props.terminal);
    }
  }
  onResize(n, i) {
    const { scaleX: r, scaleY: s } = i, o = this._resizeInitialBindings.get(
      n,
      () => li(this.editor, n)
    ), a = Ea(this.editor, n, o), { start: c, end: d } = Ct(n.props);
    let { bend: u } = n.props;
    o.start || (c.x = a.start.x * r, c.y = a.start.y * s), o.end || (d.x = a.end.x * r, d.y = a.end.y * s);
    const h = Math.abs(r), g = Math.abs(s), p = o != null && o.start ? x.From(o.start.props.normalizedAnchor) : null, f = o != null && o.end ? x.From(o.end.props.normalizedAnchor) : null;
    return r < 0 && s >= 0 ? (u !== 0 && (u *= -1, u *= Math.max(h, g)), p && (p.x = 1 - p.x), f && (f.x = 1 - f.x)) : r >= 0 && s < 0 ? (u !== 0 && (u *= -1, u *= Math.max(h, g)), p && (p.y = 1 - p.y), f && (f.y = 1 - f.y)) : r >= 0 && s >= 0 ? u !== 0 && (u *= Math.max(h, g)) : r < 0 && s < 0 && (u !== 0 && (u *= Math.max(h, g)), p && (p.x = 1 - p.x, p.y = 1 - p.y), f && (f.x = 1 - f.x, f.y = 1 - f.y)), o.start && p && dl(this.editor, n, o.start.toId, {
      ...o.start.props,
      normalizedAnchor: p.toJson()
    }), o.end && f && dl(this.editor, n, o.end.toId, {
      ...o.end.props,
      normalizedAnchor: f.toJson()
    }), {
      props: {
        start: c,
        end: d,
        bend: u
      }
    };
  }
  onDoubleClickHandle(n, i) {
    switch (i.id) {
      case "start":
        return {
          id: n.id,
          type: n.type,
          props: {
            ...n.props,
            arrowheadStart: n.props.arrowheadStart === "none" ? "arrow" : "none"
          }
        };
      case "end":
        return {
          id: n.id,
          type: n.type,
          props: {
            ...n.props,
            arrowheadEnd: n.props.arrowheadEnd === "none" ? "arrow" : "none"
          }
        };
    }
  }
  component(n) {
    const i = $n(), r = this.editor.getOnlySelectedShape(), s = this.editor.isInAny(
      "select.idle",
      "select.pointing_handle",
      "select.dragging_handle",
      "select.translating",
      "arrow.dragging"
    ) && !this.editor.getIsReadonly(), o = Pr(this.editor, n);
    if (!(o != null && o.isValid)) return null;
    const a = Ch(this.editor, n), c = n.id === this.editor.getOnlySelectedShapeId(), u = this.editor.getEditingShapeId() === n.id || n.props.text;
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(Xi, { style: { minWidth: 50, minHeight: 50 }, children: /* @__PURE__ */ l.jsx(
        xN,
        {
          shape: n,
          shouldDisplayHandles: s && (r == null ? void 0 : r.id) === n.id
        }
      ) }),
      u && /* @__PURE__ */ l.jsx(
        mf,
        {
          shapeId: n.id,
          classNamePrefix: "tl-arrow",
          type: "arrow",
          font: n.props.font,
          fontSize: CI(n),
          lineHeight: Cn.lineHeight,
          align: "middle",
          verticalAlign: "middle",
          text: n.props.text,
          labelColor: i[n.props.labelColor].solid,
          textWidth: a.box.w - Xg * 2 * n.props.scale,
          isSelected: c,
          padding: 0,
          style: {
            transform: `translate(${a.box.center.x}px, ${a.box.center.y}px)`
          }
        }
      )
    ] });
  }
  indicator(n) {
    const i = Fp(n.id), r = lr(n.id + "_clip"), s = Pr(this.editor, n);
    if (!s) return null;
    const { start: o, end: a } = Ea(this.editor, n, s == null ? void 0 : s.bindings), c = this.editor.getShapeGeometry(n), d = c.bounds, u = n.props.text.trim() ? c.children[1] : null;
    if (x.Equals(o, a)) return null;
    const h = mn[n.props.size] * n.props.scale, g = s.start.arrowhead && Jg(s, "start", h), p = s.end.arrowhead && Jg(s, "end", h), f = s.isStraight ? Wk(s) : Bk(s), M = g && s.start.arrowhead !== "arrow" || p && s.end.arrowhead !== "arrow" || !!u;
    if (i && u)
      return /* @__PURE__ */ l.jsx(
        "rect",
        {
          x: k(u.x),
          y: k(u.y),
          width: u.w,
          height: u.h,
          rx: 3.5 * n.props.scale,
          ry: 3.5 * n.props.scale
        }
      );
    const m = !(s.start.arrowhead === "none" || s.start.arrowhead === "arrow"), y = !(s.end.arrowhead === "none" || s.end.arrowhead === "arrow");
    return /* @__PURE__ */ l.jsxs("g", { children: [
      M && /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx(
        Vk,
        {
          hasText: n.props.text.trim().length > 0,
          bounds: d,
          labelBounds: u ? u.getBounds() : new ae(0, 0, 0, 0),
          as: m && g ? g : "",
          ae: y && p ? p : ""
        }
      ) }),
      /* @__PURE__ */ l.jsxs(
        "g",
        {
          style: {
            clipPath: M ? `url(#${r})` : void 0,
            WebkitClipPath: M ? `url(#${r})` : void 0
          },
          children: [
            M && /* @__PURE__ */ l.jsx(
              "rect",
              {
                x: d.minX - 100,
                y: d.minY - 100,
                width: d.width + 200,
                height: d.height + 200,
                opacity: 0
              }
            ),
            /* @__PURE__ */ l.jsx("path", { d: f })
          ]
        }
      ),
      g && /* @__PURE__ */ l.jsx("path", { d: g }),
      p && /* @__PURE__ */ l.jsx("path", { d: p }),
      u && /* @__PURE__ */ l.jsx(
        "rect",
        {
          x: k(u.x),
          y: k(u.y),
          width: u.w,
          height: u.h,
          rx: 3.5,
          ry: 3.5
        }
      )
    ] });
  }
  onEditEnd(n) {
    const {
      id: i,
      type: r,
      props: { text: s }
    } = n;
    s.trimEnd() !== n.props.text && this.editor.updateShapes([
      {
        id: i,
        type: r,
        props: {
          text: s.trimEnd()
        }
      }
    ]);
  }
  toSvg(n, i) {
    i.addExportDef(pj(n.props.fill)), n.props.text && i.addExportDef(ff(n.props.font));
    const r = Hr(i), s = 1 / n.props.scale;
    return /* @__PURE__ */ l.jsxs("g", { transform: `scale(${s})`, children: [
      /* @__PURE__ */ l.jsx(xN, { shape: n, shouldDisplayHandles: !1 }),
      /* @__PURE__ */ l.jsx(
        Mf,
        {
          fontSize: CI(n),
          font: n.props.font,
          align: "middle",
          verticalAlign: "middle",
          text: n.props.text,
          labelColor: r[n.props.labelColor].solid,
          bounds: Ch(this.editor, n).box.clone().expandBy(-Xg * n.props.scale),
          padding: 0
        }
      )
    ] });
  }
  getCanvasSvgDefs() {
    return [
      fj(),
      {
        key: "arrow:dot",
        component: ure
      },
      {
        key: "arrow:cross",
        component: hre
      }
    ];
  }
  getInterpolatedProps(n, i, r) {
    return {
      ...r > 0.5 ? i.props : n.props,
      scale: et(n.props.scale, i.props.scale, r),
      start: {
        x: et(n.props.start.x, i.props.start.x, r),
        y: et(n.props.start.y, i.props.start.y, r)
      },
      end: {
        x: et(n.props.end.x, i.props.end.x, r),
        y: et(n.props.end.y, i.props.end.y, r)
      },
      bend: et(n.props.bend, i.props.bend, r),
      labelPosition: et(n.props.labelPosition, i.props.labelPosition, r)
    };
  }
}
S(zh, "type", "arrow"), S(zh, "props", Pb), S(zh, "migrations", Ub);
function Hk(t, e) {
  const n = Pr(t, e);
  return n.isStraight ? x.Dist(n.start.handle, n.end.handle) : Math.abs(n.handleArc.length);
}
const xN = Vt(function({
  shape: e,
  shouldDisplayHandles: n
}) {
  const i = Q(), r = $n(), s = Pr(i, e), o = ae.ZeroFix(i.getShapeGeometry(e).bounds), a = li(i, e), c = G(
    "force solid",
    () => i.getZoomLevel() < 0.2,
    [i]
  ), d = lr(e.id + "_clip"), u = lr("arrowhead-dot"), h = lr("arrowhead-cross");
  if (!(s != null && s.isValid)) return null;
  const g = mn[e.props.size] * e.props.scale, p = s.start.arrowhead && Jg(s, "start", g), f = s.end.arrowhead && Jg(s, "end", g), M = s.isStraight ? Wk(s) : Bk(s);
  let m = null;
  if (n) {
    const A = 2 / i.getZoomLevel(), { strokeDasharray: b, strokeDashoffset: T } = or(
      Hk(i, e),
      A,
      {
        end: "skip",
        start: "skip",
        lengthRatio: 2.5
      }
    );
    m = a.start || a.end ? /* @__PURE__ */ l.jsx(
      "path",
      {
        className: "tl-arrow-hint",
        d: s.isStraight ? dre(s) : lre(s),
        strokeDasharray: b,
        strokeDashoffset: T,
        strokeWidth: A,
        markerStart: a.start ? a.start.props.isExact ? "" : a.start.props.isPrecise ? `url(#${h})` : `url(#${u})` : "",
        markerEnd: a.end ? a.end.props.isExact ? "" : a.end.props.isPrecise ? `url(#${h})` : `url(#${u})` : "",
        opacity: 0.16
      }
    ) : null;
  }
  const { strokeDasharray: y, strokeDashoffset: I } = or(
    s.isStraight ? s.length : Math.abs(s.bodyArc.length),
    g,
    {
      style: e.props.dash,
      forceSolid: c
    }
  ), D = Ch(i, e), j = !(s.start.arrowhead === "none" || s.start.arrowhead === "arrow"), w = !(s.end.arrowhead === "none" || s.end.arrowhead === "arrow");
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: d, children: /* @__PURE__ */ l.jsx(
      Vk,
      {
        hasText: e.props.text.trim().length > 0,
        bounds: o,
        labelBounds: D.box,
        as: j && p ? p : "",
        ae: w && f ? f : ""
      }
    ) }) }),
    /* @__PURE__ */ l.jsxs(
      "g",
      {
        fill: "none",
        stroke: r[e.props.color].solid,
        strokeWidth: g,
        strokeLinejoin: "round",
        strokeLinecap: "round",
        pointerEvents: "none",
        children: [
          m,
          /* @__PURE__ */ l.jsxs(
            "g",
            {
              style: {
                clipPath: `url(#${d})`,
                WebkitClipPath: `url(#${d})`
              },
              children: [
                /* @__PURE__ */ l.jsx(
                  "rect",
                  {
                    x: k(o.minX - 100),
                    y: k(o.minY - 100),
                    width: k(o.width + 200),
                    height: k(o.height + 200),
                    opacity: 0
                  }
                ),
                /* @__PURE__ */ l.jsx("path", { d: M, strokeDasharray: y, strokeDashoffset: I })
              ]
            }
          ),
          p && j && e.props.fill !== "none" && /* @__PURE__ */ l.jsx(
            Nn,
            {
              theme: r,
              d: p,
              color: e.props.color,
              fill: e.props.fill,
              scale: e.props.scale
            }
          ),
          f && w && e.props.fill !== "none" && /* @__PURE__ */ l.jsx(
            Nn,
            {
              theme: r,
              d: f,
              color: e.props.color,
              fill: e.props.fill,
              scale: e.props.scale
            }
          ),
          p && /* @__PURE__ */ l.jsx("path", { d: p }),
          f && /* @__PURE__ */ l.jsx("path", { d: f })
        ]
      }
    )
  ] });
});
function Vk({
  hasText: t,
  bounds: e,
  labelBounds: n,
  as: i,
  ae: r
}) {
  const s = `M${k(e.minX - 100)},${k(e.minY - 100)} h${e.width + 200} v${e.height + 200} h-${e.width + 200} Z`, o = `M${k(n.minX)},${k(n.minY)} v${n.height} h${n.width} v-${n.height} Z`;
  return /* @__PURE__ */ l.jsx("path", { d: `${s}${t ? o : ""}${i}${r}` });
}
const SN = /* @__PURE__ */ new WeakMap();
function ure() {
  const t = lr("arrowhead-dot");
  return /* @__PURE__ */ l.jsx("marker", { id: t, className: "tl-arrow-hint", refX: "3.0", refY: "3.0", orient: "0", children: /* @__PURE__ */ l.jsx("circle", { cx: "3", cy: "3", r: "2", strokeDasharray: "100%" }) });
}
function hre() {
  const t = lr("arrowhead-cross");
  return /* @__PURE__ */ l.jsxs("marker", { id: t, className: "tl-arrow-hint", refX: "3.0", refY: "3.0", orient: "auto", children: [
    /* @__PURE__ */ l.jsx("line", { x1: "1.5", y1: "1.5", x2: "4.5", y2: "4.5", strokeDasharray: "100%" }),
    /* @__PURE__ */ l.jsx("line", { x1: "1.5", y1: "4.5", x2: "4.5", y2: "1.5", strokeDasharray: "100%" })
  ] });
}
const jN = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' fill='none'%3E%3Cpath stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M13 5H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6M19 5h6m0 0v6m0-6L13 17'/%3E%3C/svg%3E";
function ec({ url: t }) {
  const e = Q(), n = G("zoomLevel", () => e.getZoomLevel() < 0.32, [e]);
  return /* @__PURE__ */ l.jsx(
    "a",
    {
      className: ce("tl-hyperlink-button", {
        "tl-hyperlink-button__hidden": n
      }),
      href: t,
      target: "_blank",
      rel: "noopener noreferrer",
      onPointerDown: Yt,
      onPointerUp: Yt,
      title: t,
      draggable: !1,
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          className: "tl-hyperlink__icon",
          style: {
            mask: `url("${jN}") center 100% / 100% no-repeat`,
            WebkitMask: `url("${jN}") center 100% / 100% no-repeat`
          }
        }
      )
    }
  );
}
const DN = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' fill='none'%3E%3Cpath stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M13 5H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6M19 5h6m0 0v6m0-6L13 17'/%3E%3C/svg%3E", gre = [
  {
    offsetX: 0,
    offsetY: 2,
    blur: 4,
    spread: 0,
    color: "#00000029"
  },
  {
    offsetX: 0,
    offsetY: 3,
    blur: 6,
    spread: 0,
    color: "#0000001f"
  }
];
function qg(t) {
  return gre.map((n) => {
    const { offsetX: i, offsetY: r, blur: s, spread: o, color: a } = n, c = new x(i, r), { x: d, y: u } = c.rot(-t);
    return `${d}px ${u}px ${s}px ${o}px ${a}`;
  }).join(", ");
}
const pre = 300, Kk = 320, fre = 46, Mre = 101;
class Lh extends ho {
  canResize() {
    return !1;
  }
  hideSelectionBoundsFg() {
    return !0;
  }
  getText(e) {
    return e.props.url;
  }
  getDefaultProps() {
    return {
      url: "",
      w: pre,
      h: Kk,
      assetId: null
    };
  }
  component(e) {
    return /* @__PURE__ */ l.jsx(mre, { shape: e, util: this });
  }
  indicator(e) {
    return /* @__PURE__ */ l.jsx(
      "rect",
      {
        width: k(e.props.w),
        height: k(e.props.h),
        rx: "6",
        ry: "6"
      }
    );
  }
  onBeforeCreate(e) {
    return wN(this.editor, e);
  }
  onBeforeUpdate(e, n) {
    if (e.props.url !== n.props.url)
      if (Li.isValid(n.props.url))
        Ire(this.editor, n);
      else
        return { ...n, props: { ...n.props, url: e.props.url } };
    if (e.props.assetId !== n.props.assetId)
      return wN(this.editor, n);
  }
  getInterpolatedProps(e, n, i) {
    return {
      ...i > 0.5 ? n.props : e.props,
      w: et(e.props.w, n.props.w, i),
      h: et(e.props.h, n.props.h, i)
    };
  }
}
S(Lh, "type", "bookmark"), S(Lh, "props", Bb), S(Lh, "migrations", Gb);
function mre({
  shape: t,
  util: e
}) {
  const n = t.props.assetId ? e.editor.getAsset(t.props.assetId) : null, i = !!Id() && mt.isSafari, r = e.editor.getShapePageTransform(t).rotation(), s = yre(t), [o, a] = pe(!0), c = () => a(!1);
  return /* @__PURE__ */ l.jsx(qs, { children: /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: ce(
        "tl-bookmark__container",
        i && "tl-bookmark__container--safariExport"
      ),
      style: {
        boxShadow: i ? void 0 : qg(r),
        maxHeight: t.props.h
      },
      children: [
        (!n || n.props.image) && /* @__PURE__ */ l.jsxs("div", { className: "tl-bookmark__image_container", children: [
          n ? /* @__PURE__ */ l.jsx(
            "img",
            {
              className: "tl-bookmark__image",
              draggable: !1,
              referrerPolicy: "strict-origin-when-cross-origin",
              src: n == null ? void 0 : n.props.image,
              alt: (n == null ? void 0 : n.props.title) || ""
            }
          ) : /* @__PURE__ */ l.jsx("div", { className: "tl-bookmark__placeholder" }),
          (n == null ? void 0 : n.props.image) && /* @__PURE__ */ l.jsx(ec, { url: t.props.url })
        ] }),
        /* @__PURE__ */ l.jsxs("div", { className: "tl-bookmark__copy_container", children: [
          n != null && n.props.title ? /* @__PURE__ */ l.jsx("h2", { className: "tl-bookmark__heading", children: fie(n.props.title) }) : null,
          n != null && n.props.description && (n != null && n.props.image) ? /* @__PURE__ */ l.jsx("p", { className: "tl-bookmark__description", children: n.props.description }) : null,
          /* @__PURE__ */ l.jsxs(
            "a",
            {
              className: "tl-bookmark__link",
              href: t.props.url || "",
              target: "_blank",
              rel: "noopener noreferrer",
              onPointerDown: Yt,
              onPointerUp: Yt,
              onClick: Yt,
              children: [
                o && (n != null && n.props.favicon) ? /* @__PURE__ */ l.jsx(
                  "img",
                  {
                    className: "tl-bookmark__favicon",
                    src: n == null ? void 0 : n.props.favicon,
                    referrerPolicy: "strict-origin-when-cross-origin",
                    onError: c,
                    alt: `favicon of ${s}`
                  }
                ) : /* @__PURE__ */ l.jsx(
                  "div",
                  {
                    className: "tl-hyperlink__icon",
                    style: {
                      mask: `url("${DN}") center 100% / 100% no-repeat`,
                      WebkitMask: `url("${DN}") center 100% / 100% no-repeat`
                    }
                  }
                ),
                /* @__PURE__ */ l.jsx("span", { children: s })
              ]
            }
          )
        ] })
      ]
    }
  ) });
}
function wN(t, e) {
  const n = e.props.assetId ? t.getAsset(e.props.assetId) : null;
  let i = Kk;
  return n && (n.props.image || (n.props.title ? i = Mre : i = fre)), {
    ...e,
    props: {
      ...e.props,
      h: i
    }
  };
}
const yre = (t) => {
  try {
    return new URL(t.props.url).hostname.replace(/^www\./, "");
  } catch {
    return t.props.url;
  }
};
function Ire(t, e) {
  const { url: n } = e.props, i = ci.createId(My(n));
  t.getAsset(i) ? e.props.assetId !== i && t.updateShapes([
    {
      id: e.id,
      type: e.type,
      props: { assetId: i }
    }
  ]) : (t.updateShapes([
    {
      id: e.id,
      type: e.type,
      props: { assetId: null }
    }
  ]), xre(t, e));
}
const xre = lp(async (t, e) => {
  if (t.isDisposed) return;
  const { url: n } = e.props, i = await t.getAssetForExternalContent({ type: "url", url: n });
  i && t.run(() => {
    t.createAssets([i]), t.updateShapes([
      {
        id: e.id,
        type: e.type,
        props: { assetId: i.id }
      }
    ]);
  });
}, 500);
function Fo(t, e = !1) {
  const n = t.length;
  if (n < 2)
    return "";
  let i = t[0].point, r = t[1].point;
  if (n === 2)
    return `M${rt(i)}L${rt(r)}`;
  let s = "";
  for (let o = 2, a = n - 1; o < a; o++)
    i = t[o].point, r = t[o + 1].point, s += ai(i, r);
  return e ? `M${ai(t[0].point, t[1].point)}Q${rt(t[1].point)}${ai(
    t[1].point,
    t[2].point
  )}T${s}${ai(t[n - 1].point, t[0].point)}${ai(
    t[0].point,
    t[1].point
  )}Z` : `M${rt(t[0].point)}Q${rt(t[1].point)}${ai(
    t[1].point,
    t[2].point
  )}${t.length > 3 ? "T" : ""}${s}L${rt(t[n - 1].point)}`;
}
function Sre(t, e = {}) {
  const { start: n = {}, end: i = {} } = e, { cap: r = !0 } = n, { cap: s = !0 } = i;
  ct(!n.taper && !i.taper, "cap taper not supported here"), ct(!n.easing && !i.easing, "cap easing not supported here"), ct(r && s, "cap must be true");
  const o = Fr(t, e);
  gf(o, e);
  const a = jre(o);
  let c = "";
  for (const d of a)
    c += wre(d, e);
  return c;
}
function jre(t) {
  if (t.length <= 2) return [t];
  const e = [];
  let n = [t[0]], i = x.Sub(t[1].point, t[0].point).uni(), r, s, o, a, c;
  for (let d = 1, u = t.length; d < u - 1; d++) {
    if (o = t[d - 1], a = t[d], c = t[d + 1], r = x.Sub(c.point, a.point).uni(), s = x.Dpr(i, r), i = r, s < -0.8) {
      const h = {
        ...a,
        point: a.input
      };
      n.push(h), e.push(om(n)), n = [h];
      continue;
    }
    if (n.push(a), !(s > 0.7) && (x.Dist2(o.point, a.point) + x.Dist2(a.point, c.point)) / ((o.radius + a.radius + c.radius) / 3) ** 2 < 1.5) {
      n.push(a), e.push(om(n)), n = [a];
      continue;
    }
  }
  return n.push(t[t.length - 1]), e.push(om(n)), e;
}
function om(t) {
  const e = t[0];
  let n;
  for (; t.length > 2 && (n = t[1], x.Dist2(e.point, n.point) < ((e.radius + n.radius) / 2 * 0.5) ** 2); )
    t.splice(1, 1);
  const i = t[t.length - 1];
  let r;
  for (; t.length > 2 && (r = t[t.length - 2], x.Dist2(i.point, r.point) < ((i.radius + r.radius) / 2 * 0.5) ** 2); )
    t.splice(t.length - 2, 1);
  return t.length > 1 && (t[0] = {
    ...t[0],
    vector: x.Sub(t[0].point, t[1].point).uni()
  }, t[t.length - 1] = {
    ...t[t.length - 1],
    vector: x.Sub(
      t[t.length - 2].point,
      t[t.length - 1].point
    ).uni()
  }), t;
}
function Dre(t, e, n) {
  return "M " + t + " " + e + " m -" + n + ", 0 a " + n + "," + n + " 0 1,1 " + n * 2 + ",0 a " + n + "," + n + " 0 1,1 -" + n * 2 + ",0";
}
function wre(t, e = {}) {
  if (t.length === 0) return "";
  if (t.length === 1)
    return Dre(t[0].point.x, t[0].point.y, t[0].radius);
  const { left: n, right: i } = Tk(t, e);
  i.reverse();
  let r = `M${rt(n[0])}T`;
  for (let s = 1; s < n.length; s++)
    r += ai(n[s - 1], n[s]);
  {
    const s = t[t.length - 1], o = s.radius, a = s.vector.clone().per().neg(), c = x.Add(s.point, x.Mul(a, o)), d = x.Add(s.point, x.Mul(a, -o));
    r += `${rt(c)}A${k(o)},${k(
      o
    )} 0 0 1 ${rt(d)}T`;
  }
  for (let s = 1; s < i.length; s++)
    r += ai(i[s - 1], i[s]);
  {
    const s = t[0], o = s.radius, a = s.vector.clone().per(), c = x.Add(s.point, x.Mul(a, o)), d = x.Add(s.point, x.Mul(a, -o));
    r += `${rt(c)}A${k(o)},${k(
      o
    )} 0 0 1 ${rt(d)}Z`;
  }
  return r;
}
const Xk = (t, e, n) => {
  const i = [], r = [];
  t.forEach((d) => i.push(...d.points)), e.forEach((d) => r.push(...d.points));
  const s = Math.max(i.length, r.length), o = [], a = [];
  for (let d = 0; d < s; d++)
    o.push(i[d] || i[i.length - 1]), a.push(r[d] || r[r.length - 1]);
  return [
    {
      type: "free",
      points: o.map((d, u) => {
        let h = 0.5;
        return a[u].z !== void 0 && d.z !== void 0 && (h = et(d.z, a[u].z, n)), {
          x: et(d.x, a[u].x, n),
          y: et(d.y, a[u].y, n),
          z: h
        };
      })
    }
  ];
}, Nre = (t) => t * 0.65 + ZW(t * st / 2) * 0.35, Are = (t) => ({
  size: t,
  thinning: 0.5,
  streamline: Ba(t, [9, 16], [0.64, 0.74], !0),
  // 0.62 + ((1 + strokeWidth) / 8) * 0.06,
  smoothing: 0.62,
  easing: on.easeOutSine,
  simulatePressure: !0
}), Tre = (t) => ({
  size: 1 + t * 1.2,
  thinning: 0.62,
  streamline: 0.62,
  smoothing: 0.62,
  simulatePressure: !1,
  easing: Nre
}), NN = (t) => ({
  size: t,
  thinning: 0,
  streamline: Ba(t, [9, 16], [0.64, 0.74], !0),
  // 0.62 + ((1 + strokeWidth) / 8) * 0.06,
  smoothing: 0.62,
  simulatePressure: !1,
  easing: on.linear
}), bre = (t) => ({
  size: t,
  thinning: 0,
  streamline: 0.62,
  smoothing: 0.62,
  simulatePressure: !1,
  easing: on.linear
});
function yj({
  strokeWidth: t,
  showAsComplete: e
}) {
  return {
    size: 1 + t,
    thinning: 0,
    streamline: 0.5,
    smoothing: 0.5,
    simulatePressure: !1,
    easing: on.easeOutSine,
    last: e
  };
}
function zI(t, e, n, i) {
  const r = t.isComplete || n;
  return i ? t.isPen ? { ...bre(e), last: r } : { ...NN(e), last: r } : t.dash === "draw" ? t.isPen ? { ...Tre(e), last: r } : { ...Are(e), last: r } : { ...NN(e), last: r };
}
function tc(t) {
  const e = [];
  for (const n of t)
    if (n.type === "free" || n.points.length < 2)
      e.push(...n.points.map(x.Cast));
    else {
      const i = Math.max(
        4,
        Math.floor(x.Dist(n.points[0], n.points[1]) / 16)
      );
      e.push(...x.PointsBetween(n.points[0], n.points[1], i));
    }
  return e;
}
function vre(t, e, n) {
  return {
    draw: "none",
    solid: "none",
    dotted: `${n} ${e * 2}`,
    dashed: `${e * 2} ${e * 2}`
  }[t.props.dash];
}
class kh extends Ci {
  hideResizeHandles(e) {
    return am(e);
  }
  hideRotateHandle(e) {
    return am(e);
  }
  hideSelectionBoundsFg(e) {
    return am(e);
  }
  getDefaultProps() {
    return {
      segments: [],
      color: "black",
      fill: "none",
      dash: "draw",
      size: "m",
      isComplete: !1,
      isClosed: !1,
      isPen: !1,
      scale: 1
    };
  }
  getGeometry(e) {
    const n = tc(e.props.segments), i = (mn[e.props.size] + 1) * e.props.scale;
    if (e.props.segments.length === 1) {
      const s = ae.FromPoints(n);
      if (s.width < i * 2 && s.height < i * 2)
        return new SS({
          x: -i,
          y: -i,
          radius: i,
          isFilled: !0
        });
    }
    const r = Fr(
      n,
      zI(e.props, i, e.props.isPen, !0)
    ).map((s) => s.point);
    return e.props.isClosed ? new Gt({
      points: r,
      isFilled: e.props.fill !== "none"
    }) : new Ds({
      points: r
    });
  }
  component(e) {
    return /* @__PURE__ */ l.jsx(Xi, { children: /* @__PURE__ */ l.jsx(AN, { shape: e }) });
  }
  indicator(e) {
    var u;
    const n = tc(e.props.segments);
    let i = (mn[e.props.size] + 1) * e.props.scale;
    const r = this.editor.getZoomLevel();
    !(r < 0.5 && r < 1.5 / i) && !e.props.isPen && e.props.dash === "draw" && n.length === 1 && (i += xr(e.id)() * (i / 6));
    const o = e.props.isComplete || ((u = pn(e.props.segments)) == null ? void 0 : u.type) === "straight", a = zI(e.props, i, o, !0), c = Fr(n, a), d = c.length > 1 ? Fo(c, e.props.isClosed) : Jk(n[0], i);
    return /* @__PURE__ */ l.jsx("path", { d });
  }
  toSvg(e, n) {
    n.addExportDef(pj(e.props.fill));
    const i = 1 / e.props.scale;
    return /* @__PURE__ */ l.jsx("g", { transform: `scale(${i})`, children: /* @__PURE__ */ l.jsx(AN, { shape: e, zoomOverride: 1 }) });
  }
  getCanvasSvgDefs() {
    return [fj()];
  }
  onResize(e, n) {
    const { scaleX: i, scaleY: r } = n, s = [];
    for (const o of e.props.segments)
      s.push({
        ...o,
        points: o.points.map(({ x: a, y: c, z: d }) => ({
          x: cs(i * a),
          y: cs(r * c),
          z: d
        }))
      });
    return {
      props: {
        segments: s
      }
    };
  }
  expandSelectionOutlinePx(e) {
    const n = e.props.dash === "draw" ? 1.6 : 1;
    return mn[e.props.size] * n / 2 * e.props.scale;
  }
  getInterpolatedProps(e, n, i) {
    return {
      ...i > 0.5 ? n.props : e.props,
      segments: Xk(e.props.segments, n.props.segments, i),
      scale: et(e.props.scale, n.props.scale, i)
    };
  }
}
S(kh, "type", "draw"), S(kh, "props", Hb), S(kh, "migrations", Vb);
function Jk(t, e) {
  const n = (e + 1) * 0.5;
  return `M ${t.x} ${t.y} m -${n}, 0 a ${n},${n} 0 1,0 ${n * 2},0 a ${n},${n} 0 1,0 -${n * 2},0`;
}
function am(t) {
  return t.props.segments.length === 1 && t.props.segments[0].points.length < 2;
}
function AN({ shape: t, zoomOverride: e }) {
  var p;
  const n = $n(), i = Q(), r = tc(t.props.segments), s = t.props.isComplete || ((p = pn(t.props.segments)) == null ? void 0 : p.type) === "straight";
  let o = (mn[t.props.size] + 1) * t.props.scale;
  const a = G(
    "force solid",
    () => {
      const f = e ?? i.getZoomLevel();
      return f < 0.5 && f < 1.5 / o;
    },
    [i, o, e]
  ), c = G(
    "dot adjustment",
    () => (e ?? i.getZoomLevel()) < 0.2 ? 0 : 0.1,
    [i, e]
  );
  !a && !t.props.isPen && t.props.dash === "draw" && r.length === 1 && (o += xr(t.id)() * (o / 6));
  const d = zI(t.props, o, s, a);
  if (!a && t.props.dash === "draw")
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      t.props.isClosed && t.props.fill && r.length > 1 ? /* @__PURE__ */ l.jsx(
        Nn,
        {
          d: Fo(
            Fr(r, d),
            t.props.isClosed
          ),
          theme: n,
          color: t.props.color,
          fill: t.props.isClosed ? t.props.fill : "none",
          scale: t.props.scale
        }
      ) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          d: Sre(r, d),
          strokeLinecap: "round",
          fill: n[t.props.color].solid
        }
      )
    ] });
  const u = Fr(r, d), h = u.length < 2, g = h ? Jk(r[0], 0) : Fo(u, t.props.isClosed);
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      Nn,
      {
        d: g,
        theme: n,
        color: t.props.color,
        fill: h || t.props.isClosed ? t.props.fill : "none",
        scale: t.props.scale
      }
    ),
    /* @__PURE__ */ l.jsx(
      "path",
      {
        d: g,
        strokeLinecap: "round",
        fill: h ? n[t.props.color].solid : "none",
        stroke: n[t.props.color].solid,
        strokeWidth: o,
        strokeDasharray: h ? "none" : vre(t, o, c),
        strokeDashoffset: "0"
      }
    )
  ] });
}
function Ere(t) {
  if (typeof t != "string")
    throw new TypeError("Expected a string");
  return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function Cre(t, e) {
  const n = Le(e);
  if (!n) return;
  const i = n.host.replace("www.", "");
  for (const r of t)
    if (qk(r.hostnames, i)) {
      const s = r.fromEmbedUrl(e);
      if (s)
        return {
          definition: r,
          url: s,
          embedUrl: e
        };
    }
}
const zre = (t) => t.split("*").map((e) => Ere(e)).join(".+"), qk = (t, e) => !!t.find((n) => {
  const i = new RegExp(zre(n));
  return e.match(i);
});
function Lre(t, e) {
  const n = Le(e);
  if (!n) return;
  const i = n.host.replace("www.", "");
  for (const r of t)
    if (qk(r.hostnames, i)) {
      const s = r.toEmbedUrl(e);
      if (s)
        return {
          definition: r,
          embedUrl: s,
          url: e
        };
    }
}
function kre(t, e) {
  try {
    return Lre(t, e) ?? Cre(t, e);
  } catch {
    return;
  }
}
const Ore = (t) => Object.entries(t).filter(([e, n]) => n).map(([e]) => e).join(" ");
class Oh extends ho {
  constructor() {
    super(...arguments);
    S(this, "embedDefinitions", LS);
  }
  setEmbedDefinitions(n) {
    this.embedDefinitions = n;
  }
  getEmbedDefinitions() {
    return this.embedDefinitions;
  }
  getEmbedDefinition(n) {
    return kre(this.embedDefinitions, n);
  }
  getText(n) {
    return n.props.url;
  }
  hideSelectionBoundsFg(n) {
    return !this.canResize(n);
  }
  canEdit() {
    return !0;
  }
  canResize(n) {
    var i, r;
    return !!((r = (i = this.getEmbedDefinition(n.props.url)) == null ? void 0 : i.definition) != null && r.doesResize);
  }
  canEditInReadOnly() {
    return !0;
  }
  getDefaultProps() {
    return {
      w: 300,
      h: 300,
      url: ""
    };
  }
  isAspectRatioLocked(n) {
    const i = this.getEmbedDefinition(n.props.url);
    return (i == null ? void 0 : i.definition.isAspectRatioLocked) ?? !1;
  }
  onResize(n, i) {
    const r = this.isAspectRatioLocked(n), s = this.getEmbedDefinition(n.props.url);
    let o = (s == null ? void 0 : s.definition.minWidth) ?? 200, a = (s == null ? void 0 : s.definition.minHeight) ?? 200;
    if (r) {
      const c = n.props.w / n.props.h;
      c > 1 ? o *= c : a /= c;
    }
    return Zp(n, i, { minWidth: o, minHeight: a });
  }
  component(n) {
    const i = Id(), { w: r, h: s, url: o } = n.props, a = Fp(n.id), c = this.getEmbedDefinition(o), d = G(
      "is hovering",
      () => {
        const { editingShapeId: f, hoveredShapeId: M } = this.editor.getCurrentPageState();
        if (f && M !== f) {
          const m = this.editor.getShape(f);
          if (m && this.editor.isShapeOfType(m, "embed"))
            return !0;
        }
        return !1;
      },
      []
    ), u = this.editor.getShapePageTransform(n).rotation();
    if (i)
      return /* @__PURE__ */ l.jsx(qs, { className: "tl-embed-container", id: n.id, children: /* @__PURE__ */ l.jsx(
        "div",
        {
          className: "tl-embed",
          style: {
            border: 0,
            boxShadow: qg(u),
            borderRadius: (c == null ? void 0 : c.definition.overrideOutlineRadius) ?? 8,
            background: (c == null ? void 0 : c.definition.backgroundColor) ?? "var(--color-background)",
            width: r,
            height: s
          }
        }
      ) });
    const h = a || d;
    if (typeof window < "u" && (window !== window.top || window.self !== window.parent) && (c == null ? void 0 : c.definition.type) === "tldraw") return null;
    if ((c == null ? void 0 : c.definition.type) === "github_gist") {
      const f = c.url.split("/").pop();
      if (!f) throw Error("No gist id!");
      return /* @__PURE__ */ l.jsx(qs, { className: "tl-embed-container", id: n.id, children: /* @__PURE__ */ l.jsx(
        Pre,
        {
          id: f,
          width: k(r),
          height: k(s),
          isInteractive: h,
          pageRotation: u
        }
      ) });
    }
    const p = Ore({
      ...mq,
      ...(c == null ? void 0 : c.definition.overridePermissions) ?? {}
    });
    return /* @__PURE__ */ l.jsx(qs, { className: "tl-embed-container", id: n.id, children: c != null && c.definition ? /* @__PURE__ */ l.jsx(
      "iframe",
      {
        className: "tl-embed",
        sandbox: p,
        src: c.embedUrl,
        width: k(r),
        height: k(s),
        draggable: !1,
        frameBorder: "0",
        referrerPolicy: "no-referrer-when-downgrade",
        style: {
          border: 0,
          pointerEvents: h ? "auto" : "none",
          // Fix for safari <https://stackoverflow.com/a/49150908>
          zIndex: h ? "" : "-1",
          boxShadow: qg(u),
          borderRadius: (c == null ? void 0 : c.definition.overrideOutlineRadius) ?? 8,
          background: c == null ? void 0 : c.definition.backgroundColor
        }
      }
    ) : null });
  }
  indicator(n) {
    const i = this.getEmbedDefinition(n.props.url);
    return /* @__PURE__ */ l.jsx(
      "rect",
      {
        width: k(n.props.w),
        height: k(n.props.h),
        rx: (i == null ? void 0 : i.definition.overrideOutlineRadius) ?? 8,
        ry: (i == null ? void 0 : i.definition.overrideOutlineRadius) ?? 8
      }
    );
  }
  getInterpolatedProps(n, i, r) {
    return {
      ...r > 0.5 ? i.props : n.props,
      w: et(n.props.w, i.props.w, r),
      h: et(n.props.h, i.props.h, r)
    };
  }
}
S(Oh, "type", "embed"), S(Oh, "props", Kb), S(Oh, "migrations", Xb);
function Pre({
  id: t,
  file: e,
  isInteractive: n,
  width: i,
  height: r,
  style: s,
  pageRotation: o
}) {
  return /* @__PURE__ */ l.jsx(
    "iframe",
    {
      className: "tl-embed",
      draggable: !1,
      width: k(i),
      height: k(r),
      frameBorder: "0",
      scrolling: "no",
      seamless: !0,
      referrerPolicy: "no-referrer-when-downgrade",
      style: {
        ...s,
        pointerEvents: n ? "all" : "none",
        // Fix for safari <https://stackoverflow.com/a/49150908>
        zIndex: n ? "" : "-1",
        boxShadow: qg(o)
      },
      srcDoc: `
			<html>
				<head>
					<base target="_blank">
				</head>
				<body>
					<script src=${`https://gist.github.com/${t}.js${e ? `?file=${e}` : ""}`}><\/script>
					<style type="text/css">
						* { margin: 0px; }
						table { height: 100%; background-color: red; }
						.gist { background-color: none; height: 100%;  }
						.gist .gist-file { height: calc(100vh - 2px); padding: 0px; display: grid; grid-template-rows: 1fr auto; }
					</style>
				</body>
			</html>`
    }
  );
}
const Ure = dc(({ id: t, name: e, isEditing: n }, i) => {
  const r = Q(), s = re(
    (c) => {
      c.key === "Enter" && !c.nativeEvent.isComposing && (Yt(c), c.currentTarget.blur(), r.setEditingShape(null));
    },
    [r]
  ), o = re(
    (c) => {
      const d = r.getShape(t);
      if (!d) return;
      const u = d.props.name, h = c.currentTarget.value.trim();
      u !== h && r.updateShapes([
        {
          id: t,
          type: "frame",
          props: { name: h }
        }
      ]);
    },
    [t, r]
  ), a = re(
    (c) => {
      const d = r.getShape(t);
      if (!d) return;
      const u = d.props.name, h = c.currentTarget.value;
      u !== h && r.updateShapes([
        {
          id: t,
          type: "frame",
          props: { name: h }
        }
      ]);
    },
    [t, r]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: `tl-frame-label ${n ? "tl-frame-label__editing" : ""}`, children: [
    /* @__PURE__ */ l.jsx(
      "input",
      {
        className: "tl-frame-name-input",
        ref: i,
        style: { display: n ? void 0 : "none" },
        value: e,
        autoFocus: !0,
        onKeyDown: s,
        onBlur: o,
        onChange: a
      }
    ),
    _k(e, "Frame") + "​"
  ] });
}), Rre = function({
  id: e,
  name: n,
  width: i,
  height: r
}) {
  const s = Q(), o = G(
    "shape rotation",
    () => Js(s.getShapePageTransform(e).rotation()),
    [s, e]
  ), a = Fp(e), c = le(null), d = re(
    (f) => {
      const M = gi(f);
      f.preventDefault(), s.getEditingShapeId() !== e && s.dispatch({
        type: "pointer",
        name: "pointer_down",
        target: "shape",
        shape: s.getShape(e),
        ...M
      });
    },
    [s, e]
  );
  ze(() => {
    const f = c.current;
    f && a && (f.focus(), f.select());
  }, [c, a]);
  const h = ((o + Math.PI / 4) * (2 / Math.PI) + 4) % 4, g = ["top", "left", "bottom", "right"][Math.floor(h)];
  let p;
  switch (g) {
    case "top":
      p = "";
      break;
    case "right":
      p = `translate(${k(i)}px, 0px) rotate(90deg)`;
      break;
    case "bottom":
      p = `translate(${k(i)}px, ${k(
        r
      )}px) rotate(180deg)`;
      break;
    case "left":
      p = `translate(0px, ${k(r)}px) rotate(270deg)`;
      break;
  }
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: "tl-frame-heading",
      style: {
        overflow: a ? "visible" : "hidden",
        maxWidth: `calc(var(--tl-zoom) * ${Math.ceil(g === "top" || g === "bottom" ? i : r)}px + var(--space-5))`,
        bottom: "100%",
        transform: `${p} scale(var(--tl-scale)) translateX(calc(-1 * var(--space-3))`
      },
      onPointerDown: d,
      children: /* @__PURE__ */ l.jsx("div", { className: "tl-frame-heading-hit-area", children: /* @__PURE__ */ l.jsx(Ure, { ref: c, id: e, name: n, isEditing: a }) })
    }
  );
};
function _k(t, e) {
  return t.match(/^\s*$/) ? e : t;
}
class Ph extends ho {
  canEdit() {
    return !0;
  }
  getDefaultProps() {
    return { w: 160 * 2, h: 90 * 2, name: "" };
  }
  getGeometry(e) {
    return new Pi({
      width: e.props.w,
      height: e.props.h,
      isFilled: !1
    });
  }
  getText(e) {
    return e.props.name;
  }
  component(e) {
    const n = this.editor.getShapeGeometry(e).bounds, i = $n(), r = G(
      "is creating this shape",
      () => {
        const s = this.editor.getStateDescendant("select.resizing");
        if (!s || !s.getIsActive()) return !1;
        const o = s == null ? void 0 : s.info;
        return o ? o.isCreating && this.editor.getOnlySelectedShapeId() === e.id : !1;
      },
      [e.id]
    );
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(Xi, { children: /* @__PURE__ */ l.jsx(
        "rect",
        {
          className: ce("tl-frame__body", { "tl-frame__creating": r }),
          width: n.width,
          height: n.height,
          fill: i.solid,
          stroke: i.text
        }
      ) }),
      r ? null : /* @__PURE__ */ l.jsx(
        Rre,
        {
          id: e.id,
          name: e.props.name,
          width: n.width,
          height: n.height
        }
      )
    ] });
  }
  toSvg(e, n) {
    const i = Hr({ isDarkMode: n.isDarkMode }), o = ((Js(
      this.editor.getShapePageTransform(e.id).rotation()
    ) + Math.PI / 4) * (2 / Math.PI) + 4) % 4, a = Math.floor(o);
    let c;
    switch (a) {
      case 0:
        c = "";
        break;
      case 3:
        c = `translate(${k(e.props.w)}, 0) rotate(90)`;
        break;
      case 2:
        c = `translate(${k(e.props.w)}, ${k(
          e.props.h
        )}) rotate(180)`;
        break;
      case 1:
        c = `translate(0, ${k(e.props.h)}) rotate(270)`;
        break;
      default:
        throw Error("labelSide out of bounds");
    }
    const d = {
      fontSize: 12,
      fontFamily: "Inter, sans-serif",
      textAlign: "start",
      width: e.props.w,
      height: 32,
      padding: 0,
      lineHeight: 1,
      fontStyle: "normal",
      fontWeight: "normal",
      overflow: "truncate-ellipsis",
      verticalTextAlign: "middle",
      fill: i.text
    }, u = this.editor.textMeasure.measureTextSpans(
      _k(e.props.name, "Frame") + "​",
      d
    ), h = u[0], g = pn(u), p = g.box.w + g.box.x - h.box.x, f = EI(this.editor, u, {
      offsetY: -d.height - 2,
      ...d
    });
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          width: e.props.w,
          height: e.props.h,
          fill: i.solid,
          stroke: i.black.solid,
          strokeWidth: 1,
          rx: 1,
          ry: 1
        }
      ),
      /* @__PURE__ */ l.jsxs("g", { transform: c, children: [
        /* @__PURE__ */ l.jsx(
          "rect",
          {
            x: -8,
            y: -d.height - 4,
            width: p + 16,
            height: d.height,
            fill: i.background,
            rx: 4,
            ry: 4
          }
        ),
        f
      ] })
    ] });
  }
  indicator(e) {
    const n = this.editor.getShapeGeometry(e).bounds;
    return /* @__PURE__ */ l.jsx(
      "rect",
      {
        width: k(n.width),
        height: k(n.height),
        className: "tl-frame-indicator"
      }
    );
  }
  canReceiveNewChildrenOfType(e, n) {
    return !e.isLocked;
  }
  providesBackgroundForChildren() {
    return !0;
  }
  canDropShapes(e, n) {
    return !e.isLocked;
  }
  onDragShapesOver(e, n) {
    n.every((i) => i.parentId === e.id) || this.editor.reparentShapes(n, e.id);
  }
  onDragShapesOut(e, n) {
    const i = this.editor.getShape(e.parentId);
    i && this.editor.isShapeOfType(i, "group") ? this.editor.reparentShapes(n, i.id) : this.editor.reparentShapes(n, this.editor.getCurrentPageId());
  }
  onResize(e, n) {
    return Zp(e, n);
  }
  getInterpolatedProps(e, n, i) {
    return {
      ...i > 0.5 ? n.props : e.props,
      w: et(e.props.w, n.props.w, i),
      h: et(e.props.h, n.props.h, i)
    };
  }
}
S(Ph, "type", "frame"), S(Ph, "props", Jb), S(Ph, "migrations", qb);
function TN(t, e) {
  return t > e ? (st * (e / 2) + (t - e)) * 2 : (st * (t / 2) + (e - t)) * 2;
}
function $k(t, e) {
  return Ij(t, e).map((n, i) => n.getSvgPathData(i === 0)).join(" ") + " Z";
}
function Yre(t, e, n, i) {
  const r = t / 4, s = e / 4, o = xr(i), a = n * 0.75, c = (I) => I.addXY(o() * a, o() * a), d = new x(t / 2, e), u = new x(0, s * 1.2), h = new x(t / 2, s * 0.9), g = new x(t, s * 1.2), p = c(new x(t / 2, e)), f = c(new x(0, s * 1.2)), M = c(new x(t / 2, s * 0.9)), m = c(new x(t, s * 1.2));
  return [
    new Tn({
      start: d,
      cp1: new x(r * 1.5, s * 3),
      cp2: new x(0, s * 2.5),
      end: u
    }),
    new Tn({
      start: u,
      cp1: new x(0, -s * 0.32),
      cp2: new x(r * 1.85, -s * 0.32),
      end: h
    }),
    new Tn({
      start: h,
      cp1: new x(r * 2.15, -s * 0.32),
      cp2: new x(t, -s * 0.32),
      end: g
    }),
    new Tn({
      start: g,
      cp1: new x(t, s * 2.5),
      cp2: new x(r * 2.5, s * 3),
      end: p
    }),
    new Tn({
      start: p,
      cp1: new x(r * 1.5, s * 3),
      cp2: new x(0, s * 2.5),
      end: f
    }),
    new Tn({
      start: f,
      cp1: new x(0, -s * 0.32),
      cp2: new x(r * 1.85, -s * 0.32),
      end: M
    }),
    new Tn({
      start: M,
      cp1: new x(r * 2.15, -s * 0.32),
      cp2: new x(t, -s * 0.32),
      end: m
    }),
    new Tn({
      start: m,
      cp1: new x(t, s * 2.5),
      cp2: new x(r * 2.5, s * 3),
      end: d
    })
  ].map((I, D) => I.getSvgPathData(D === 0)).join(" ") + " Z";
}
function Ij(t, e) {
  const n = t / 4, i = e / 4;
  return [
    new Tn({
      start: new x(t / 2, e),
      cp1: new x(n * 1.5, i * 3),
      cp2: new x(0, i * 2.5),
      end: new x(0, i * 1.2)
    }),
    new Tn({
      start: new x(0, i * 1.2),
      cp1: new x(0, -i * 0.32),
      cp2: new x(n * 1.85, -i * 0.32),
      end: new x(t / 2, i * 0.9)
    }),
    new Tn({
      start: new x(t / 2, i * 0.9),
      cp1: new x(n * 2.15, -i * 0.32),
      cp2: new x(t, -i * 0.32),
      end: new x(t, i * 1.2)
    }),
    new Tn({
      start: new x(t, i * 1.2),
      cp1: new x(t, i * 2.5),
      cp2: new x(n * 2.5, i * 3),
      end: new x(t / 2, e)
    })
  ];
}
function Qre(t) {
  return {
    size: 1 + t,
    thinning: 0.25,
    end: { taper: t },
    start: { taper: t },
    streamline: 0,
    smoothing: 1,
    simulatePressure: !1
  };
}
function Zre(t, e, n, i) {
  const r = xr(t), s = e / 2, o = n / 2, a = mv(s, o), c = [], d = gt * r(), u = gt + Nt / 2 + Math.abs(r()) * Nt, h = Math.max(16, a / 10);
  for (let g = 0; g < h; g++) {
    const p = g / (h - 1), f = d + p * u, M = Math.cos(f), m = Math.sin(f);
    c.push(
      new x(
        s * M + e * 0.5 + 0.05 * r(),
        o * m + n / 2 + 0.05 * r(),
        Math.min(
          1,
          0.5 + Math.abs(0.5 - (r() > 0 ? on.easeInOutSine(p) : on.easeInExpo(p))) / 2
        )
      )
    );
  }
  return Fr(c, Qre(i));
}
function Fre(t, e, n, i) {
  return Fo(Zre(t, e, n, i));
}
function LI(t) {
  let e = "M";
  const n = t.length;
  let i, r, s;
  for (let o = 0, a = n; o < a; o += 3)
    i = t[o], r = t[o + 1], s = t[o + 2], e += `${rt(i)}L${rt(r)}Q${rt(s)}`;
  return e += `${rt(t[0])}`, e;
}
function kI(t, e, n, i, r) {
  const s = [], o = xr(t);
  let a = e[0], c;
  const d = e.length;
  for (let u = 0, h = d * r; u < h; u++) {
    c = x.AddXY(e[(u + 1) % d], o() * n, o() * n);
    const g = x.Sub(c, a), p = x.Len(g), f = x.Div(g, p).mul(Math.min(p / 4, i));
    s.push(x.Add(a, f), x.Add(c, f.neg()), c), a = c;
  }
  return s;
}
function Bre(t, e, n) {
  const i = Math.min(t, e) / 2, r = Math.max(t, e) - i * 2, o = (Math.PI * (i * 2) + 2 * r) / n, a = t > e ? [
    {
      type: "straight",
      start: new x(i, 0),
      delta: new x(1, 0)
    },
    {
      type: "arc",
      center: new x(t - i, i),
      startAngle: -st / 2
    },
    {
      type: "straight",
      start: new x(t - i, e),
      delta: new x(-1, 0)
    },
    {
      type: "arc",
      center: new x(i, i),
      startAngle: st / 2
    }
  ] : [
    {
      type: "straight",
      start: new x(t, i),
      delta: new x(0, 1)
    },
    {
      type: "arc",
      center: new x(i, e - i),
      startAngle: 0
    },
    {
      type: "straight",
      start: new x(0, e - i),
      delta: new x(0, -1)
    },
    {
      type: "arc",
      center: new x(i, i),
      startAngle: st
    }
  ];
  let c = 0;
  const d = [];
  for (let u = 0; u < n; u++) {
    const h = a[0];
    h.type === "straight" ? d.push(x.Add(h.start, x.Mul(h.delta, c))) : d.push(
      Yo(h.center, i, h.startAngle + c / i)
    ), c += o;
    let g = h.type === "straight" ? r : st * i;
    for (; c > g; )
      c -= g, a.push(a.shift()), g = a[0].type === "straight" ? r : st * i;
  }
  return d;
}
const Gre = {
  s: 50,
  m: 70,
  l: 100,
  xl: 130
}, Wre = 0.2;
function yf(t, e, n, i, r) {
  const s = xr(n), o = TN(t, e), a = Math.max(
    Math.ceil(o / Gre[i]),
    6,
    Math.ceil(o / Math.min(t, e))
  ), c = o / a * Wre, d = Math.max(t - c * 2, 1), u = Math.max(e - c * 2, 1), g = TN(d, u) / a, p = (t - d) / 2, f = (e - u) / 2, M = Bre(d, u, a).map((j) => j.addXY(p, f)), m = t < 20 ? 0 : c * 0.3, y = e < 20 ? 0 : c * 0.3, I = M.slice(0);
  for (let j = 0; j < Math.floor(a / 2); j++)
    I[j] = x.AddXY(
      I[j],
      s() * m * r,
      s() * y * r
    ), I[a - j - 1] = x.AddXY(
      I[a - j - 1],
      s() * m * r,
      s() * y * r
    );
  const D = [];
  for (let j = 0; j < I.length; j++) {
    const w = j === I.length - 1 ? 0 : j + 1, A = I[j], b = I[w], T = M[j], E = M[w], v = x.Dist(T, E), P = g - v, z = x.Dist(A, b) / v, O = (Math.max(p, f) + P) * z, R = x.Lrp(T, E, 0.5).add(
      x.Sub(E, T).uni().per().mul(O)
    );
    R.x < 0 ? R.x = 0 : R.x > t && (R.x = t), R.y < 0 ? R.y = 0 : R.y > e && (R.y = e);
    const U = qx(A, b, R), F = x.Dist(
      U || x.Average([A, b]),
      A
    );
    D.push({
      leftPoint: A,
      rightPoint: b,
      arcPoint: R,
      center: U,
      radius: F
    });
  }
  return D;
}
function Hre(t, e, n, i, r) {
  const s = [], o = yf(t, e, n, i, r);
  for (const { center: a, radius: c, leftPoint: d, rightPoint: u } of o)
    s.push(...WW(d, u, a, c, 10));
  return s;
}
function OI(t, e, n, i, r) {
  const s = yf(t, e, n, i, r);
  let o = `M${s[0].leftPoint.toFixed()}`;
  for (const { leftPoint: a, rightPoint: c, radius: d, center: u } of s) {
    if (u === null) {
      o += ` L${c.toFixed()}`;
      continue;
    }
    const h = x.Clockwise(a, c, u) ? "0" : "1";
    o += ` A${k(d)},${k(d)} 0 ${h},1 ${c.toFixed()}`;
  }
  return o += " Z", o;
}
const Vre = {
  s: 0.5,
  m: 0.7,
  l: 0.9,
  xl: 1.6
};
function Kre(t, e, n, i, r) {
  const s = xr(n), o = Vre[i] * r, a = yf(t, e, n, i, r), u = a.reduce((f, M) => f + x.Dist2(M.leftPoint, M.rightPoint), 0) / a.length > (o * 15) ** 2 ? (f) => x.AddXY(f, s() * o * 2, s() * o * 2) : (f) => f;
  let h = `M${a[0].leftPoint.toFixed()}`, g = u(a[0].leftPoint), p = `M${g.toFixed()}`;
  for (const { leftPoint: f, center: M, rightPoint: m, radius: y, arcPoint: I } of a) {
    if (M === null) {
      h += ` L${m.toFixed()}`;
      const T = u(m);
      p += ` L${T.toFixed()}`, g = T;
      continue;
    }
    const D = x.Clockwise(f, m, M) ? "0" : "1";
    h += ` A${k(y)},${k(y)} 0 ${D},1 ${m.toFixed()}`;
    const j = u(m), w = u(I), A = qx(g, j, w);
    if (!A) {
      p += ` L${j.toFixed()}`, g = j;
      continue;
    }
    const b = Math.abs(x.Dist(A, g));
    p += ` A${k(b)},${k(
      b
    )} 0 ${D},1 ${j.toFixed()}`, g = j;
  }
  return h + p + " Z";
}
function PI(t, e) {
  switch (t.geo) {
    case "x-box":
      return Xre(t.w, t.h, e, t.dash);
    case "check-box":
      return Jre(t.w, t.h);
    default:
      return;
  }
}
function Xre(t, e, n, i) {
  const r = i === "draw" ? 0.62 : 0;
  if (i === "dashed")
    return [
      [new x(0, 0), new x(t / 2, e / 2)],
      [new x(t, e), new x(t / 2, e / 2)],
      [new x(0, e), new x(t / 2, e / 2)],
      [new x(t, 0), new x(t / 2, e / 2)]
    ];
  const s = (a) => Math.max(0, Math.min(t, a)), o = (a) => Math.max(0, Math.min(e, a));
  return [
    [
      new x(s(n * r), o(n * r)),
      new x(s(t - n * r), o(e - n * r))
    ],
    [
      new x(s(n * r), o(e - n * r)),
      new x(s(t - n * r), o(n * r))
    ]
  ];
}
function Jre(t, e) {
  const n = Math.min(t, e) * 0.82, i = (t - n) / 2, r = (e - n) / 2, s = (a) => Math.max(0, Math.min(t, a)), o = (a) => Math.max(0, Math.min(e, a));
  return [
    [
      new x(s(i + n * 0.25), o(r + n * 0.52)),
      new x(s(i + n * 0.45), o(r + n * 0.82))
    ],
    [
      new x(s(i + n * 0.45), o(r + n * 0.82)),
      new x(s(i + n * 0.82), o(r + n * 0.22))
    ]
  ];
}
function bN({
  shape: t,
  shouldScale: e,
  forceSolid: n
}) {
  const i = e ? t.props.scale : 1, r = Q(), s = $n(), { id: o, props: a } = t, { w: c, color: d, fill: u, dash: h, growY: g, size: p, scale: f } = a, M = mn[p] * i, m = a.h + g;
  switch (a.geo) {
    case "cloud":
      if (h === "solid") {
        const y = OI(c, m, o, p, f);
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(Nn, { theme: s, d: y, color: d, fill: u, scale: i }),
          /* @__PURE__ */ l.jsx("path", { d: y, stroke: s[d].solid, strokeWidth: M, fill: "none" })
        ] });
      } else if (h === "draw") {
        const y = Kre(c, m, o, p, f);
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(Nn, { theme: s, d: y, color: d, fill: u, scale: i }),
          /* @__PURE__ */ l.jsx("path", { d: y, stroke: s[d].solid, strokeWidth: M, fill: "none" })
        ] });
      } else {
        const y = OI(c, m, o, p, f), I = yf(c, m, o, p, f);
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(Nn, { theme: s, d: y, color: d, fill: u, scale: i }),
          /* @__PURE__ */ l.jsx(
            "g",
            {
              strokeWidth: M,
              stroke: s[d].solid,
              fill: "none",
              pointerEvents: "all",
              children: I.map(({ leftPoint: D, rightPoint: j, center: w, radius: A }, b) => {
                const T = w ? A * Js(
                  Js(x.Angle(w, j)) - Js(x.Angle(w, D))
                ) : x.Dist(D, j), { strokeDasharray: E, strokeDashoffset: v } = or(
                  T,
                  M,
                  {
                    style: h,
                    start: "outset",
                    end: "outset",
                    forceSolid: n
                  }
                );
                return /* @__PURE__ */ l.jsx(
                  "path",
                  {
                    d: w ? `M${D.x},${D.y}A${A},${A},0,0,1,${j.x},${j.y}` : `M${D.x},${D.y}L${j.x},${j.y}`,
                    strokeDasharray: E,
                    strokeDashoffset: v
                  },
                  b
                );
              })
            }
          )
        ] });
      }
    case "ellipse": {
      const y = e ? (
        // cached
        r.getShapeGeometry(t)
      ) : (
        // not cached
        r.getShapeUtil(t).getGeometry(t)
      ), I = y.getSvgPathData(!0);
      if (h === "dashed" || h === "dotted") {
        const D = y.length, { strokeDasharray: j, strokeDashoffset: w } = or(
          D < 64 ? D * 2 : D,
          M,
          {
            style: h,
            snap: 4,
            closed: !0,
            forceSolid: n
          }
        );
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(Nn, { theme: s, d: I, color: d, fill: u, scale: i }),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: I,
              strokeWidth: M,
              fill: "none",
              stroke: s[d].solid,
              strokeDasharray: j,
              strokeDashoffset: w
            }
          )
        ] });
      } else {
        const j = (e ? (
          // cached
          r.getShapeGeometry(t)
        ) : (
          // not cached
          r.getShapeUtil(t).getGeometry(t)
        )).getSvgPathData(!0);
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(Nn, { theme: s, d: j, color: d, fill: u, scale: i }),
          /* @__PURE__ */ l.jsx("path", { d: j, stroke: s[d].solid, strokeWidth: M, fill: "none" })
        ] });
      }
    }
    case "oval": {
      const y = e ? (
        // cached
        r.getShapeGeometry(t)
      ) : (
        // not cached
        r.getShapeUtil(t).getGeometry(t)
      ), I = y.getSvgPathData(!0);
      if (h === "dashed" || h === "dotted") {
        const D = y.getLength(), { strokeDasharray: j, strokeDashoffset: w } = or(
          D < 64 ? D * 2 : D,
          M,
          {
            style: h,
            snap: 4,
            start: "outset",
            end: "outset",
            closed: !0,
            forceSolid: n
          }
        );
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(Nn, { theme: s, d: I, color: d, fill: u, scale: i }),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: I,
              strokeWidth: M,
              fill: "none",
              stroke: s[d].solid,
              strokeDasharray: j,
              strokeDashoffset: w
            }
          )
        ] });
      } else
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(Nn, { theme: s, d: I, color: d, fill: u, scale: i }),
          /* @__PURE__ */ l.jsx("path", { d: I, stroke: s[d].solid, strokeWidth: M, fill: "none" })
        ] });
    }
    case "heart":
      if (h === "dashed" || h === "dotted" || h === "solid") {
        const y = $k(c, m), I = Ij(c, m);
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(Nn, { theme: s, d: y, color: d, fill: u, scale: i }),
          I.map((D, j) => {
            const { strokeDasharray: w, strokeDashoffset: A } = or(
              D.length,
              M,
              {
                style: h,
                snap: 1,
                start: "outset",
                end: "outset",
                closed: !0,
                forceSolid: n
              }
            );
            return /* @__PURE__ */ l.jsx(
              "path",
              {
                d: D.getSvgPathData(),
                strokeWidth: M,
                fill: "none",
                stroke: s[d].solid,
                strokeDasharray: w,
                strokeDashoffset: A,
                pointerEvents: "all"
              },
              `curve_${j}`
            );
          })
        ] });
      } else {
        const y = Yre(c, m, M, t.id);
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(Nn, { theme: s, d: y, color: d, fill: u, scale: i }),
          /* @__PURE__ */ l.jsx("path", { d: y, stroke: s[d].solid, strokeWidth: M, fill: "none" })
        ] });
      }
    default: {
      const y = e ? (
        // cached
        r.getShapeGeometry(t)
      ) : (
        // not cached
        r.getShapeUtil(t).getGeometry(t)
      ), I = y instanceof Ki ? y.children[0].vertices : y.vertices, D = PI(t.props, M);
      if (h === "solid") {
        let j = "M" + I[0] + "L" + I.slice(1) + "Z";
        if (D)
          for (const [w, A] of D)
            j += `M${w.x},${w.y}L${A.x},${A.y}`;
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(Nn, { theme: s, d: j, color: d, fill: u, scale: i }),
          /* @__PURE__ */ l.jsx("path", { d: j, stroke: s[d].solid, strokeWidth: M, fill: "none" })
        ] });
      } else if (h === "dashed" || h === "dotted") {
        const j = "M" + I[0] + "L" + I.slice(1) + "Z";
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(Nn, { theme: s, d: j, color: d, fill: u, scale: i }),
          /* @__PURE__ */ l.jsxs(
            "g",
            {
              strokeWidth: M,
              stroke: s[d].solid,
              fill: "none",
              pointerEvents: "all",
              children: [
                Array.from(Array(I.length)).map((w, A) => {
                  const b = x.ToFixed(I[A]), T = x.ToFixed(I[(A + 1) % I.length]), E = x.Dist(b, T), { strokeDasharray: v, strokeDashoffset: P } = or(
                    E,
                    M,
                    {
                      style: h,
                      start: "outset",
                      end: "outset",
                      forceSolid: n
                    }
                  );
                  return /* @__PURE__ */ l.jsx(
                    "line",
                    {
                      x1: b.x,
                      y1: b.y,
                      x2: T.x,
                      y2: T.y,
                      strokeDasharray: v,
                      strokeDashoffset: P
                    },
                    A
                  );
                }),
                D && D.map(([w, A], b) => {
                  const T = x.Dist(w, A), { strokeDasharray: E, strokeDashoffset: v } = or(
                    T,
                    M,
                    {
                      style: h,
                      start: "skip",
                      end: "skip",
                      snap: h === "dotted" ? 4 : void 0,
                      forceSolid: n
                    }
                  );
                  return /* @__PURE__ */ l.jsx(
                    "path",
                    {
                      d: `M${w.x},${w.y}L${A.x},${A.y}`,
                      stroke: s[d].solid,
                      strokeWidth: M,
                      fill: "none",
                      strokeDasharray: E,
                      strokeDashoffset: v
                    },
                    `line_fg_${b}`
                  );
                })
              ]
            }
          )
        ] });
      } else if (h === "draw") {
        let j = LI(
          kI(o, I, M / 3, M * 2, 2)
        );
        if (D)
          for (const [A, b] of D)
            j += `M${A.toFixed()}L${b.toFixed()}`;
        const w = LI(
          kI(o, I, 0, M * 2, 1)
        );
        return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(
            Nn,
            {
              theme: s,
              d: w,
              color: d,
              fill: u,
              scale: i
            }
          ),
          /* @__PURE__ */ l.jsx("path", { d: j, stroke: s[d].solid, strokeWidth: M, fill: "none" })
        ] });
      }
    }
  }
}
const vN = 17 * 3;
class Uh extends ho {
  canEdit() {
    return !0;
  }
  getDefaultProps() {
    return {
      w: 100,
      h: 100,
      geo: "rectangle",
      color: "black",
      labelColor: "black",
      fill: "none",
      dash: "draw",
      size: "m",
      font: "draw",
      text: "",
      align: "middle",
      verticalAlign: "middle",
      growY: 0,
      url: "",
      scale: 1
    };
  }
  getGeometry(e) {
    const n = Math.max(1, e.props.w), i = Math.max(1, e.props.h + e.props.growY), r = n / 2, s = i / 2, o = e.props.fill !== "none";
    let a;
    switch (e.props.geo) {
      case "cloud": {
        a = new Gt({
          points: Hre(n, i, e.id, e.props.size, e.props.scale),
          isFilled: o
        });
        break;
      }
      case "triangle": {
        a = new Gt({
          points: [new x(r, 0), new x(n, i), new x(0, i)],
          isFilled: o
        });
        break;
      }
      case "diamond": {
        a = new Gt({
          points: [new x(r, 0), new x(n, s), new x(r, i), new x(0, s)],
          isFilled: o
        });
        break;
      }
      case "pentagon": {
        a = new Gt({
          points: jM(n, i, 5),
          isFilled: o
        });
        break;
      }
      case "hexagon": {
        a = new Gt({
          points: jM(n, i, 6),
          isFilled: o
        });
        break;
      }
      case "octagon": {
        a = new Gt({
          points: jM(n, i, 8),
          isFilled: o
        });
        break;
      }
      case "ellipse": {
        a = new nX({
          width: n,
          height: i,
          isFilled: o
        });
        break;
      }
      case "oval": {
        a = new iX({
          width: n,
          height: i,
          isFilled: o
        });
        break;
      }
      case "star": {
        const I = gt / 5 / 2, D = Math.floor(5 / 4) * 2, j = 5 * 2 - D, w = 0, A = Math.floor(5 / 2) * 2, b = Math.cos(-Nt + D * I) * n / 2, T = Math.cos(-Nt + j * I) * n / 2, E = Math.sin(-Nt + w * I) * i / 2, v = Math.sin(-Nt + A * I) * i / 2, P = n - Math.abs(b - T), C = i - Math.abs(v - E), z = n / 2 + T - (n / 2 - b), O = i / 2 + E - (i / 2 - v), R = 1, U = (n - z) / 2, F = (i - O) / 2, H = (n + P) / 2, Z = (i + C) / 2, te = H * R / 2, oe = Z * R / 2;
        a = new Gt({
          points: Array.from(Array(5 * 2)).map((me, he) => {
            const ve = -Nt + he * I;
            return new x(
              U + (he % 2 ? te : H) * Math.cos(ve),
              F + (he % 2 ? oe : Z) * Math.sin(ve)
            );
          }),
          isFilled: o
        });
        break;
      }
      case "rhombus": {
        const y = Math.min(n * 0.38, i * 0.38);
        a = new Gt({
          points: [new x(y, 0), new x(n, 0), new x(n - y, i), new x(0, i)],
          isFilled: o
        });
        break;
      }
      case "rhombus-2": {
        const y = Math.min(n * 0.38, i * 0.38);
        a = new Gt({
          points: [new x(0, 0), new x(n - y, 0), new x(n, i), new x(y, i)],
          isFilled: o
        });
        break;
      }
      case "trapezoid": {
        const y = Math.min(n * 0.38, i * 0.38);
        a = new Gt({
          points: [new x(y, 0), new x(n - y, 0), new x(n, i), new x(0, i)],
          isFilled: o
        });
        break;
      }
      case "arrow-right": {
        const y = Math.min(n, i) * 0.38, I = i * 0.16;
        a = new Gt({
          points: [
            new x(0, I),
            new x(n - y, I),
            new x(n - y, 0),
            new x(n, i / 2),
            new x(n - y, i),
            new x(n - y, i - I),
            new x(0, i - I)
          ],
          isFilled: o
        });
        break;
      }
      case "arrow-left": {
        const y = Math.min(n, i) * 0.38, I = i * 0.16;
        a = new Gt({
          points: [
            new x(y, 0),
            new x(y, I),
            new x(n, I),
            new x(n, i - I),
            new x(y, i - I),
            new x(y, i),
            new x(0, i / 2)
          ],
          isFilled: o
        });
        break;
      }
      case "arrow-up": {
        const y = n * 0.16, I = Math.min(n, i) * 0.38;
        a = new Gt({
          points: [
            new x(n / 2, 0),
            new x(n, I),
            new x(n - y, I),
            new x(n - y, i),
            new x(y, i),
            new x(y, I),
            new x(0, I)
          ],
          isFilled: o
        });
        break;
      }
      case "arrow-down": {
        const y = n * 0.16, I = Math.min(n, i) * 0.38;
        a = new Gt({
          points: [
            new x(y, 0),
            new x(n - y, 0),
            new x(n - y, i - I),
            new x(n, i - I),
            new x(n / 2, i),
            new x(0, i - I),
            new x(y, i - I)
          ],
          isFilled: o
        });
        break;
      }
      case "check-box":
      case "x-box":
      case "rectangle": {
        a = new Pi({
          width: n,
          height: i,
          isFilled: o
        });
        break;
      }
      case "heart": {
        const I = Ij(n, i).reduce((D, j) => (D.push(...j.vertices), D), []);
        a = new Gt({
          points: I,
          isFilled: o
        });
        break;
      }
      default:
        rn(e.props.geo);
    }
    const c = Ju(this.editor, e), d = n / e.props.scale, u = i / e.props.scale, h = Math.min(100, d / 2), g = Math.min(
      fs[e.props.size] * Cn.lineHeight + Gi * 2,
      u / 2
    ), p = Math.min(
      d,
      Math.max(c.w, Math.min(h, Math.max(1, d - 8)))
    ), f = Math.min(
      u,
      Math.max(c.h, Math.min(g, Math.max(1, u - 8)))
    ), M = PI(e.props, mn[e.props.size] * e.props.scale), m = M ? M.map((y) => new Ds({ points: y })) : [];
    return new Ki({
      children: [
        a,
        new Pi({
          x: e.props.align === "start" ? 0 : e.props.align === "end" ? (d - p) * e.props.scale : (d - p) / 2 * e.props.scale,
          y: e.props.verticalAlign === "start" ? 0 : e.props.verticalAlign === "end" ? (u - f) * e.props.scale : (u - f) / 2 * e.props.scale,
          width: p * e.props.scale,
          height: f * e.props.scale,
          isFilled: !0,
          isLabel: !0
        }),
        ...m
      ]
    });
  }
  getHandleSnapGeometry(e) {
    const n = this.getGeometry(e), i = n.children[0];
    switch (e.props.geo) {
      case "arrow-down":
      case "arrow-left":
      case "arrow-right":
      case "arrow-up":
      case "check-box":
      case "diamond":
      case "hexagon":
      case "octagon":
      case "pentagon":
      case "rectangle":
      case "rhombus":
      case "rhombus-2":
      case "star":
      case "trapezoid":
      case "triangle":
      case "x-box":
        return { outline: i, points: [...i.getVertices(), n.bounds.center] };
      case "cloud":
      case "ellipse":
      case "heart":
      case "oval":
        return { outline: i, points: [n.bounds.center] };
      default:
        rn(e.props.geo);
    }
  }
  getText(e) {
    return e.props.text;
  }
  onEditEnd(e) {
    const {
      id: n,
      type: i,
      props: { text: r }
    } = e;
    r.trimEnd() !== e.props.text && this.editor.updateShapes([
      {
        id: n,
        type: i,
        props: {
          text: r.trimEnd()
        }
      }
    ]);
  }
  component(e) {
    const { id: n, type: i, props: r } = e, { fill: s, font: o, align: a, verticalAlign: c, size: d, text: u } = r, h = $n(), { editor: g } = this, p = G(
      "isGeoOnlySelected",
      () => e.id === g.getOnlySelectedShapeId(),
      []
    ), M = g.getEditingShapeId() !== null || e.props.text, m = G(
      "force solid",
      () => g.getZoomLevel() < 0.2,
      [g]
    );
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(Xi, { children: /* @__PURE__ */ l.jsx(bN, { shape: e, shouldScale: !0, forceSolid: m }) }),
      M && /* @__PURE__ */ l.jsx(
        qs,
        {
          style: {
            overflow: "hidden",
            width: e.props.w,
            height: e.props.h + r.growY
          },
          children: /* @__PURE__ */ l.jsx(
            mf,
            {
              shapeId: n,
              type: i,
              font: o,
              fontSize: fs[d] * e.props.scale,
              lineHeight: Cn.lineHeight,
              padding: Gi * e.props.scale,
              fill: s,
              align: a,
              verticalAlign: c,
              text: u,
              isSelected: p,
              labelColor: h[r.labelColor].solid,
              wrap: !0
            }
          )
        }
      ),
      e.props.url && /* @__PURE__ */ l.jsx(ec, { url: e.props.url })
    ] });
  }
  indicator(e) {
    const { id: n, props: i } = e, { w: r, size: s } = i, o = i.h + i.growY, a = mn[s], c = this.editor.getShapeGeometry(e);
    switch (i.geo) {
      case "ellipse":
        return i.dash === "draw" ? /* @__PURE__ */ l.jsx("path", { d: Fre(n, r, o, a) }) : /* @__PURE__ */ l.jsx("path", { d: c.getSvgPathData(!0) });
      case "heart":
        return /* @__PURE__ */ l.jsx("path", { d: $k(r, o) });
      case "oval":
        return /* @__PURE__ */ l.jsx("path", { d: c.getSvgPathData(!0) });
      case "cloud":
        return /* @__PURE__ */ l.jsx("path", { d: OI(r, o, n, s, e.props.scale) });
      default: {
        const d = this.editor.getShapeGeometry(e), u = d instanceof Ki ? d.children[0].vertices : d.vertices;
        let h;
        if (i.dash === "draw") {
          const p = kI(
            n,
            u,
            0,
            a * 2 * e.props.scale,
            1
          );
          h = LI(p);
        } else
          h = "M" + u[0] + "L" + u.slice(1) + "Z";
        const g = PI(e.props, a);
        if (g)
          for (const [p, f] of g)
            h += `M${p.x},${p.y}L${f.x},${f.y}`;
        return /* @__PURE__ */ l.jsx("path", { d: h });
      }
    }
  }
  toSvg(e, n) {
    const i = {
      ...e,
      props: {
        ...e.props,
        w: e.props.w / e.props.scale,
        h: e.props.h / e.props.scale
      }
    }, r = i.props;
    n.addExportDef(pj(r.fill));
    let s;
    if (r.text) {
      n.addExportDef(ff(r.font));
      const o = Hr(n), a = new ae(0, 0, r.w, r.h + r.growY);
      s = /* @__PURE__ */ l.jsx(
        Mf,
        {
          fontSize: fs[r.size],
          font: r.font,
          align: r.align,
          verticalAlign: r.verticalAlign,
          text: r.text,
          labelColor: o[r.labelColor].solid,
          bounds: a,
          padding: 16
        }
      );
    }
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(bN, { shouldScale: !1, shape: i, forceSolid: !1 }),
      s
    ] });
  }
  getCanvasSvgDefs() {
    return [fj()];
  }
  onResize(e, { handle: n, newPoint: i, scaleX: r, scaleY: s, initialShape: o }) {
    const a = o.props.w / o.props.scale, c = o.props.h / o.props.scale, d = o.props.growY / o.props.scale;
    let u = a * r, h = (c + d) * s, g = 0, p = 0;
    const f = vN;
    if (e.props.text.trim()) {
      let j = Math.max(Math.abs(u), f), w = Math.max(Math.abs(h), f);
      j < f && w === f && (j = f), j === f && w < f && (w = f);
      const A = Ju(this.editor, {
        props: {
          ...e.props,
          w: j * e.props.scale
        }
      }), b = Math.max(Math.abs(u), A.w) * Math.sign(u), T = Math.max(Math.abs(h), A.h) * Math.sign(h);
      g = Math.abs(b) - Math.abs(u), p = Math.abs(T) - Math.abs(h), u = b, h = T;
    }
    const M = u * e.props.scale, m = h * e.props.scale, y = new x(0, 0);
    r < 0 && (y.x += M), (n === "left" || n === "top_left" || n === "bottom_left") && (y.x += r < 0 ? g : -g), s < 0 && (y.y += m), (n === "top" || n === "top_left" || n === "top_right") && (y.y += s < 0 ? p : -p);
    const { x: I, y: D } = y.rot(e.rotation).add(i);
    return {
      x: I,
      y: D,
      props: {
        w: Math.max(Math.abs(M), 1),
        h: Math.max(Math.abs(m), 1),
        growY: 0
      }
    };
  }
  onBeforeCreate(e) {
    if (!e.props.text)
      return e.props.growY ? {
        ...e,
        props: {
          ...e.props,
          growY: 0
        }
      } : void 0;
    const n = e.props.h / e.props.scale, i = Ju(this.editor, e).h;
    let r = null;
    if (i > n ? r = i - n : e.props.growY && (r = 0), r !== null)
      return {
        ...e,
        props: {
          ...e.props,
          // scale the growY
          growY: r * e.props.scale
        }
      };
  }
  onBeforeUpdate(e, n) {
    const i = e.props.text, r = n.props.text;
    if (i === r && e.props.font === n.props.font && e.props.size === n.props.size)
      return;
    if (i && !r)
      return {
        ...n,
        props: {
          ...n.props,
          growY: 0
        }
      };
    const s = e.props.w / e.props.scale, o = e.props.h / e.props.scale, a = e.props.growY / e.props.scale, c = Ju(this.editor, n);
    if (!i && r && r.length === 1) {
      let u = Math.max(s, c.w), h = Math.max(o, c.h);
      const g = vN;
      return s < g && o < g && (u = Math.max(u, g), h = Math.max(h, g), u = Math.max(u, h), h = Math.max(u, h)), {
        ...n,
        props: {
          ...n.props,
          // Scale the results
          w: u * n.props.scale,
          h: h * n.props.scale,
          growY: 0
        }
      };
    }
    let d = null;
    if (c.h > o ? d = c.h - o : a && (d = 0), d !== null) {
      const u = n.props.w / n.props.scale;
      return {
        ...n,
        props: {
          ...n.props,
          // Scale the results
          growY: d * n.props.scale,
          w: Math.max(u, c.w) * n.props.scale
        }
      };
    }
    if (c.w > s)
      return {
        ...n,
        props: {
          ...n.props,
          // Scale the results
          w: c.w * n.props.scale
        }
      };
  }
  onDoubleClick(e) {
    if (this.editor.inputs.altKey)
      switch (e.props.geo) {
        case "rectangle":
          return {
            ...e,
            props: {
              geo: "check-box"
            }
          };
        case "check-box":
          return {
            ...e,
            props: {
              geo: "rectangle"
            }
          };
      }
  }
  getInterpolatedProps(e, n, i) {
    return {
      ...i > 0.5 ? n.props : e.props,
      w: et(e.props.w, n.props.w, i),
      h: et(e.props.h, n.props.h, i),
      scale: et(e.props.scale, n.props.scale, i)
    };
  }
}
S(Uh, "type", "geo"), S(Uh, "props", _b), S(Uh, "migrations", $b);
function Ju(t, e) {
  const { text: n, font: i, size: r, w: s } = e.props;
  if (!n)
    return { w: 0, h: 0 };
  const o = t.textMeasure.measureText("w", {
    ...Cn,
    fontFamily: xs[i],
    fontSize: fs[r],
    maxWidth: 100
    // ?
  }), a = {
    s: 2,
    m: 3.5,
    l: 5,
    xl: 10
  }, c = t.textMeasure.measureText(n, {
    ...Cn,
    fontFamily: xs[i],
    fontSize: fs[r],
    minWidth: o.w,
    maxWidth: Math.max(
      // Guard because a DOM nodes can't be less 0
      0,
      // A 'w' width that we're setting as the min-width
      Math.ceil(o.w + a[r]),
      // The actual text size
      Math.ceil(s / e.props.scale - Gi * 2)
    )
  });
  return {
    w: c.w + Gi * 2,
    h: c.h + Gi * 2
  };
}
function qre() {
  const [t, e] = pe(!1);
  return ze(() => {
    const i = CSS.supports("color", "color(display-p3 1 1 1)"), r = matchMedia("(color-gamut: p3)");
    e(i && r.matches);
    const s = () => e(i && r.matches);
    return r.addEventListener("change", s), () => r.removeEventListener("change", s);
  }, []), G(Wt.forceSrgb) || !t ? "srgb" : "p3";
}
const EN = 0.35, CN = 0.82;
class Rh extends Ci {
  hideResizeHandles(e) {
    return qu(e);
  }
  hideRotateHandle(e) {
    return qu(e);
  }
  hideSelectionBoundsFg(e) {
    return qu(e);
  }
  getDefaultProps() {
    return {
      segments: [],
      color: "black",
      size: "m",
      isComplete: !1,
      isPen: !1,
      scale: 1
    };
  }
  getGeometry(e) {
    const n = No(e);
    if (qu(e))
      return new SS({
        x: -n / 2,
        y: -n / 2,
        radius: n / 2,
        isFilled: !0
      });
    const { strokePoints: i, sw: r } = zN(e, n, !0), s = yj({ strokeWidth: r, showAsComplete: !0 });
    return gf(i, s), new Gt({
      points: hj(i, s),
      isFilled: !0
    });
  }
  component(e) {
    const n = cm(this.editor, e), i = No(e);
    return /* @__PURE__ */ l.jsx(Xi, { children: /* @__PURE__ */ l.jsx(
      _u,
      {
        shape: e,
        forceSolid: n,
        strokeWidth: i,
        opacity: EN
      }
    ) });
  }
  backgroundComponent(e) {
    const n = cm(this.editor, e), i = No(e);
    return /* @__PURE__ */ l.jsx(Xi, { children: /* @__PURE__ */ l.jsx(
      _u,
      {
        shape: e,
        forceSolid: n,
        strokeWidth: i,
        opacity: CN
      }
    ) });
  }
  indicator(e) {
    const n = cm(this.editor, e), i = No(e), { strokePoints: r, sw: s } = zN(e, i, n), o = tc(e.props.segments);
    let a;
    return r.length < 2 ? a = $re(o[0], s) : a = Fo(r, !1), /* @__PURE__ */ l.jsx("path", { d: a });
  }
  toSvg(e) {
    const n = No(e), i = n < 1.5, r = 1 / e.props.scale;
    return /* @__PURE__ */ l.jsx("g", { transform: `scale(${r})`, children: /* @__PURE__ */ l.jsx(
      _u,
      {
        forceSolid: i,
        strokeWidth: n,
        shape: e,
        opacity: EN
      }
    ) });
  }
  toBackgroundSvg(e) {
    const n = No(e), i = n < 1.5, r = 1 / e.props.scale;
    return /* @__PURE__ */ l.jsx("g", { transform: `scale(${r})`, children: /* @__PURE__ */ l.jsx(
      _u,
      {
        forceSolid: i,
        strokeWidth: n,
        shape: e,
        opacity: CN
      }
    ) });
  }
  onResize(e, n) {
    const { scaleX: i, scaleY: r } = n, s = [];
    for (const o of e.props.segments)
      s.push({
        ...o,
        points: o.points.map(({ x: a, y: c, z: d }) => ({
          x: i * a,
          y: r * c,
          z: d
        }))
      });
    return {
      props: {
        segments: s
      }
    };
  }
  getInterpolatedProps(e, n, i) {
    return {
      ...i > 0.5 ? n.props : e.props,
      ...n.props,
      segments: Xk(e.props.segments, n.props.segments, i),
      scale: et(e.props.scale, n.props.scale, i)
    };
  }
}
S(Rh, "type", "highlight"), S(Rh, "props", nv), S(Rh, "migrations", iv);
function _re(t) {
  return `M ${t.x} ${t.y} m -${0.1}, 0 a ${0.1},${0.1} 0 1,0 ${0.1 * 2},0 a ${0.1},${0.1} 0 1,0 -${0.1 * 2},0`;
}
function $re(t, e) {
  const n = e / 2;
  return `M ${t.x} ${t.y} m -${n}, 0 a ${n},${n} 0 1,0 ${n * 2},0 a ${n},${n} 0 1,0 -${n * 2},0`;
}
function zN(t, e, n) {
  var c;
  const i = tc(t.props.segments), r = t.props.isComplete || ((c = pn(t.props.segments)) == null ? void 0 : c.type) === "straight";
  let s = e;
  !n && !t.props.isPen && i.length === 1 && (s += xr(t.id)() * (e / 6));
  const o = yj({
    strokeWidth: s,
    showAsComplete: r
  });
  return { strokePoints: Fr(i, o), sw: s };
}
function No(t) {
  return _a[t.props.size] * 1.12 * t.props.scale;
}
function qu(t) {
  return t.props.segments.length === 1 && t.props.segments[0].points.length < 2;
}
function _u({
  strokeWidth: t,
  forceSolid: e,
  shape: n,
  opacity: i
}) {
  var g;
  const r = $n(), s = tc(n.props.segments);
  let o = t;
  !e && !n.props.isPen && s.length === 1 && (o += xr(n.id)() * (o / 6));
  const a = yj({
    strokeWidth: o,
    showAsComplete: n.props.isComplete || ((g = pn(n.props.segments)) == null ? void 0 : g.type) === "straight"
  }), c = Fr(s, a), d = c.length > 1 ? Fo(c, !1) : _re(n.props.segments[0].points[0]), u = qre(), h = r[n.props.color].highlight[u];
  return /* @__PURE__ */ l.jsx(
    "path",
    {
      d,
      strokeLinecap: "round",
      fill: "none",
      pointerEvents: "all",
      stroke: h,
      strokeWidth: o,
      opacity: i
    }
  );
}
function cm(t, e) {
  return G(
    "forceSolid",
    () => {
      const n = No(e), i = t.getZoomLevel();
      return n / i < 1.5;
    },
    [t]
  );
}
function eO() {
  return /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: "15",
      height: "15",
      viewBox: "0 0 30 30",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ l.jsx("path", { d: "M3,11 L3,3 11,3", strokeWidth: "2" }),
        /* @__PURE__ */ l.jsx("path", { d: "M19,27 L27,27 L27,19", strokeWidth: "2" }),
        /* @__PURE__ */ l.jsx("path", { d: "M27,3 L3,27", strokeWidth: "2" })
      ]
    }
  );
}
function tO({
  shapeId: t,
  assetId: e
}) {
  const n = Q(), i = !!Id(), r = t8(), [s, o] = pe(() => ({
    asset: e ? n.getAsset(e) ?? null : null,
    url: null
  })), a = le(!1), c = le(null);
  return ze(() => {
    if (!e) return;
    let d = !1, u;
    const h = Yr("update state", () => {
      if (!i && n.getCulledShapes().has(t)) return;
      const g = n.getAsset(e);
      if (!g) return;
      const p = n.getShape(t);
      if (!p) return;
      if (!g.props.src) {
        const M = n.getTemporaryAssetPreview(g.id);
        if (M) {
          c.current !== M && (c.current = M, o((m) => ({ ...m, isPlaceholder: !0, url: M })), r());
          return;
        }
      }
      const f = n.getZoomLevel() * (p.props.w / g.props.w);
      a.current ? (LN(n, e, f, i, (M) => {
        d || c.current !== M && (c.current = M, o(() => ({ asset: g, url: M })));
      }), u = LN.cancel) : nO(n, e, f, i, (M) => {
        d || (a.current = !0, c.current = M, o(() => ({ asset: g, url: M })));
      });
    });
    return () => {
      h(), u == null || u(), d = !0;
    };
  }, [n, e, i, r, t]), s;
}
function nO(t, e, n, i, r) {
  t.resolveAssetUrl(e, {
    screenScale: n,
    shouldResolveToOriginal: i
  }).then((s) => {
    r(s);
  });
}
const LN = lp(nO, 500);
function iO() {
  const [t, e] = pe(!1);
  return ze(() => {
    if (typeof window > "u" || !("matchMedia" in window)) return;
    const n = window.matchMedia("(prefers-reduced-motion: reduce)"), i = () => {
      e(n.matches);
    };
    return i(), n.addEventListener("change", i), () => n.removeEventListener("change", i);
  }, []), t;
}
async function ese(t) {
  const n = await (await gr(t)).blob();
  return us.blobToDataUrl(n);
}
class Yh extends ho {
  isAspectRatioLocked() {
    return !0;
  }
  canCrop() {
    return !0;
  }
  getDefaultProps() {
    return {
      w: 100,
      h: 100,
      assetId: null,
      playing: !0,
      url: "",
      crop: null,
      flipX: !1,
      flipY: !1
    };
  }
  onResize(e, n) {
    let i = Zp(e, n);
    const { flipX: r, flipY: s } = n.initialShape.props, { scaleX: o, scaleY: a, mode: c } = n;
    if (i = {
      ...i,
      props: {
        ...i.props,
        flipX: o < 0 !== r,
        flipY: a < 0 !== s
      }
    }, !e.props.crop) return i;
    const d = (
      // We used the flip horizontally feature
      // We resized the shape past it's bounds, so it flipped
      c === "scale_shape" && o === -1 || c === "resize_bounds" && r !== i.props.flipX
    ), u = (
      // We used the flip vertically feature
      // We resized the shape past it's bounds, so it flipped
      c === "scale_shape" && a === -1 || c === "resize_bounds" && s !== i.props.flipY
    ), { topLeft: h, bottomRight: g } = e.props.crop;
    return i.props.crop = {
      topLeft: {
        x: d ? 1 - g.x : h.x,
        y: u ? 1 - g.y : h.y
      },
      bottomRight: {
        x: d ? 1 - h.x : g.x,
        y: u ? 1 - h.y : g.y
      }
    }, i;
  }
  component(e) {
    return /* @__PURE__ */ l.jsx(tse, { shape: e });
  }
  indicator(e) {
    return this.editor.getCroppingShapeId() === e.id ? null : /* @__PURE__ */ l.jsx("rect", { width: k(e.props.w), height: k(e.props.h) });
  }
  async toSvg(e) {
    if (!e.props.assetId || !this.editor.getAsset(e.props.assetId)) return null;
    let i = await this.editor.resolveAssetUrl(e.props.assetId, {
      shouldResolveToOriginal: !0
    });
    return i ? ((i.startsWith("blob:") || i.startsWith("http") || i.startsWith("/") || i.startsWith("./")) && (i = await ese(i) || ""), /* @__PURE__ */ l.jsx(ise, { shape: e, src: i })) : null;
  }
  onDoubleClickEdge(e) {
    const n = e.props;
    if (!n || this.editor.getCroppingShapeId() !== e.id)
      return;
    const i = Ct(n.crop) || {
      topLeft: { x: 0, y: 0 },
      bottomRight: { x: 1, y: 1 }
    }, r = 1 / (i.bottomRight.x - i.topLeft.x) * e.props.w, s = 1 / (i.bottomRight.y - i.topLeft.y) * e.props.h, o = new x(i.topLeft.x * r, i.topLeft.y * s).rot(e.rotation), a = {
      id: e.id,
      type: e.type,
      x: e.x - o.x,
      y: e.y - o.y,
      props: {
        crop: {
          topLeft: { x: 0, y: 0 },
          bottomRight: { x: 1, y: 1 }
        },
        w: r,
        h: s
      }
    };
    this.editor.updateShapes([a]);
  }
  getInterpolatedProps(e, n, i) {
    function r(s, o) {
      var h, g, p, f;
      if (s.props.crop === null && o.props.crop === null) return null;
      const a = ((h = s.props.crop) == null ? void 0 : h.topLeft) || { x: 0, y: 0 }, c = ((g = s.props.crop) == null ? void 0 : g.bottomRight) || { x: 1, y: 1 }, d = ((p = o.props.crop) == null ? void 0 : p.topLeft) || { x: 0, y: 0 }, u = ((f = o.props.crop) == null ? void 0 : f.bottomRight) || { x: 1, y: 1 };
      return {
        topLeft: { x: et(a.x, d.x, i), y: et(a.y, d.y, i) },
        bottomRight: { x: et(c.x, u.x, i), y: et(c.y, u.y, i) }
      };
    }
    return {
      ...i > 0.5 ? n.props : e.props,
      w: et(e.props.w, n.props.w, i),
      h: et(e.props.h, n.props.h, i),
      crop: r(e, n)
    };
  }
}
S(Yh, "type", "image"), S(Yh, "props", rv), S(Yh, "migrations", sv);
const tse = _e(function({ shape: e }) {
  var y;
  const n = Q(), { asset: i, url: r } = tO({
    shapeId: e.id,
    assetId: e.props.assetId
  }), s = iO(), [o, a] = pe(""), [c, d] = pe(null), u = nse(n, e);
  ze(() => {
    if (r && u) {
      let I = !1;
      const D = Vl();
      return D.onload = () => {
        if (I) return;
        const j = document.createElement("canvas");
        j.width = D.width, j.height = D.height;
        const w = j.getContext("2d");
        w && (w.drawImage(D, 0, 0), a(j.toDataURL()), d(r));
      }, D.crossOrigin = "anonymous", D.src = r, () => {
        I = !0;
      };
    }
  }, [n, u, s, r]);
  const h = G(
    "show crop preview",
    () => e.id === n.getOnlySelectedShapeId() && n.getCroppingShapeId() === e.id && n.isIn("select.crop"),
    [n, e.id]
  ), g = s && (((y = i == null ? void 0 : i.props.mimeType) == null ? void 0 : y.includes("video")) || u), p = rO(e), f = r === c ? null : r, M = g ? o : c;
  if (!r && !(i != null && i.props.src))
    return /* @__PURE__ */ l.jsxs(
      qs,
      {
        id: e.id,
        style: {
          overflow: "hidden",
          width: e.props.w,
          height: e.props.h,
          color: "var(--color-text-3)",
          backgroundColor: "var(--color-low)",
          border: "1px solid var(--color-low-border)"
        },
        children: [
          /* @__PURE__ */ l.jsx(
            "div",
            {
              className: ce("tl-image-container", i && "tl-image-container-loading"),
              style: p,
              children: i ? null : /* @__PURE__ */ l.jsx(eO, {})
            }
          ),
          "url" in e.props && e.props.url && /* @__PURE__ */ l.jsx(ec, { url: e.props.url })
        ]
      }
    );
  const m = u ? "anonymous" : void 0;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    h && M && /* @__PURE__ */ l.jsx("div", { style: p, children: /* @__PURE__ */ l.jsx(
      "img",
      {
        className: "tl-image",
        style: { ...Yl(e), opacity: 0.1 },
        crossOrigin: m,
        src: M,
        referrerPolicy: "strict-origin-when-cross-origin",
        draggable: !1
      }
    ) }),
    /* @__PURE__ */ l.jsxs(
      qs,
      {
        id: e.id,
        style: { overflow: "hidden", width: e.props.w, height: e.props.h },
        children: [
          /* @__PURE__ */ l.jsxs("div", { className: ce("tl-image-container"), style: p, children: [
            M && /* @__PURE__ */ l.jsx(
              "img",
              {
                className: "tl-image",
                style: Yl(e),
                crossOrigin: m,
                src: M,
                referrerPolicy: "strict-origin-when-cross-origin",
                draggable: !1
              },
              M
            ),
            f && /* @__PURE__ */ l.jsx(
              "img",
              {
                className: "tl-image",
                style: Yl(e),
                crossOrigin: m,
                src: f,
                referrerPolicy: "strict-origin-when-cross-origin",
                draggable: !1,
                onLoad: () => d(f)
              },
              f
            )
          ] }),
          e.props.url && /* @__PURE__ */ l.jsx(ec, { url: e.props.url })
        ]
      }
    )
  ] });
});
function nse(t, e) {
  const n = e.props.assetId ? t.getAsset(e.props.assetId) : void 0;
  return n ? "mimeType" in n.props && bi.isAnimatedImageType(n == null ? void 0 : n.props.mimeType) || "isAnimated" in n.props && n.props.isAnimated : !1;
}
function rO(t) {
  const e = t.props.crop, n = e == null ? void 0 : e.topLeft;
  if (!n)
    return {
      width: t.props.w,
      height: t.props.h
    };
  const i = 1 / (e.bottomRight.x - e.topLeft.x) * t.props.w, r = 1 / (e.bottomRight.y - e.topLeft.y) * t.props.h, s = -n.x * i, o = -n.y * r;
  return {
    transform: `translate(${s}px, ${o}px)`,
    width: i,
    height: r
  };
}
function Yl(t, e) {
  const { flipX: n, flipY: i } = t.props;
  if (!n && !i) return;
  const r = `scale(${n ? -1 : 1}, ${i ? -1 : 1})`;
  return {
    transform: `${e ? `translate(${n ? e.width : 0}px, ${i ? e.height : 0}px)` : ""} ${r}`,
    // in SVG, flipping around the center doesn't work so we use explicit width/height
    transformOrigin: e ? "0 0" : "center center"
  };
}
function ise({ shape: t, src: e }) {
  const n = Sc(), i = rO(t), r = t.props.crop;
  if (i.transform && r) {
    const { transform: s, width: o, height: a } = i, c = (r.bottomRight.x - r.topLeft.x) * o, d = (r.bottomRight.y - r.topLeft.y) * a, u = [
      new x(0, 0),
      new x(c, 0),
      new x(c, d),
      new x(0, d)
    ], h = Yl(t, { width: o, height: a });
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: n, children: /* @__PURE__ */ l.jsx("polygon", { points: u.map((g) => `${g.x},${g.y}`).join(" ") }) }) }),
      /* @__PURE__ */ l.jsx("g", { clipPath: `url(#${n})`, children: /* @__PURE__ */ l.jsx(
        "image",
        {
          href: e,
          width: o,
          height: a,
          style: h ? { ...h, transform: `${s} ${h.transform}` } : { transform: s }
        }
      ) })
    ] });
  } else
    return /* @__PURE__ */ l.jsx(
      "image",
      {
        href: e,
        width: t.props.w,
        height: t.props.h,
        style: Yl(t, { width: t.props.w, height: t.props.h })
      }
    );
}
function sO(t) {
  return {
    size: t,
    thinning: 0.4,
    streamline: 0,
    smoothing: 0.5,
    simulatePressure: !0,
    last: !0
  };
}
function oO(t, e, n) {
  const i = e.vertices, r = sO(n);
  return Fr(i, r);
}
function rse(t, e, n) {
  const i = sO(n);
  return hj(
    gf(oO(t, e, n), i),
    i
  );
}
function sse(t, e, n) {
  const i = rse(t, e, n);
  return nS(i);
}
function ose(t, e, n) {
  if (t.props.dash === "draw") {
    const i = oO(t, e, n);
    return Fo(i);
  }
  return e.getSvgPathData();
}
function aO(t, e, n) {
  let i = `M ${rt(e[0])}L`, r = `M ${rt(e[0])}L`;
  const s = n / 3, o = n * 2, a = xr(t);
  let c = e[0], d, u = e[0], h;
  const g = e.length;
  for (let p = 0, f = g - 1; p < f; p++) {
    d = e[p + 1], h = x.AddXY(e[p + 1], a() * s, a() * s);
    const M = x.Sub(d, c), m = x.Len(M), y = x.Div(M, m).mul(Math.min(m / 4, o)), I = x.Add(c, y), D = x.Add(d, y.neg()), j = x.Sub(h, u), w = x.Len(j), A = x.Div(j, w).mul(Math.min(w / 4, o)), b = x.Add(u, A), T = x.Add(h, A.neg());
    p === f - 1 ? (i += `${rt(I)}L ${rt(d)}`, r += `${rt(b)}L ${rt(h)}`) : (i += `${rt(I)}L ${rt(D)}Q ${rt(d)}`, r += `${rt(b)}L ${rt(T)}Q ${rt(h)}`, c = d, u = h);
  }
  return [i, i + r];
}
const ase = new hr();
class Qh extends Ci {
  hideResizeHandles() {
    return !0;
  }
  hideRotateHandle() {
    return !0;
  }
  hideSelectionBoundsFg() {
    return !0;
  }
  hideSelectionBoundsBg() {
    return !0;
  }
  getDefaultProps() {
    const [e, n] = Wa(2);
    return {
      dash: "draw",
      size: "m",
      color: "black",
      spline: "line",
      points: {
        [e]: { id: e, index: e, x: 0, y: 0 },
        [n]: { id: n, index: n, x: 0.1, y: 0.1 }
      },
      scale: 1
    };
  }
  getGeometry(e) {
    return bl(e);
  }
  getHandles(e) {
    return ase.get(e.props, () => {
      const n = bl(e), i = Tl(e), r = i.map((s) => ({
        ...s,
        id: s.index,
        type: "vertex",
        canSnap: !0
      }));
      for (let s = 0; s < i.length - 1; s++) {
        const o = ko(i[s].index, i[s + 1].index), c = n.segments[s].midPoint();
        r.push({
          id: o,
          type: "create",
          index: o,
          x: c.x,
          y: c.y,
          canSnap: !0
        });
      }
      return r.sort(Jt);
    });
  }
  //   Events
  onResize(e, n) {
    const { scaleX: i, scaleY: r } = n;
    return {
      props: {
        points: ld(e.props.points, (s, { id: o, index: a, x: c, y: d }) => ({
          id: o,
          index: a,
          x: c * i,
          y: d * r
        }))
      }
    };
  }
  onBeforeCreate(e) {
    const {
      props: { points: n }
    } = e, i = Object.keys(n);
    if (i.length < 2)
      return;
    const r = n[i[0]];
    if (i.every((o) => {
      const a = n[o];
      return a.x === r.x && a.y === r.y;
    })) {
      const o = i[i.length - 1];
      return n[o] = {
        ...n[o],
        x: n[o].x + 0.1,
        y: n[o].y + 0.1
      }, e;
    }
  }
  onHandleDrag(e, { handle: n }) {
    if (n.type === "vertex")
      return {
        ...e,
        props: {
          ...e.props,
          points: {
            ...e.props.points,
            [n.id]: { id: n.id, index: n.index, x: n.x, y: n.y }
          }
        }
      };
  }
  component(e) {
    return /* @__PURE__ */ l.jsx(Xi, { children: /* @__PURE__ */ l.jsx(kN, { shape: e }) });
  }
  indicator(e) {
    const n = Ur[e.props.size] * e.props.scale, i = bl(e), { dash: r } = e.props;
    let s;
    if (e.props.spline === "line") {
      const o = i.points;
      if (r === "solid" || r === "dotted" || r === "dashed")
        s = "M" + o[0] + "L" + o.slice(1);
      else {
        const [a] = aO(e.id, o, n);
        s = a;
      }
    } else
      s = ose(e, i, n);
    return /* @__PURE__ */ l.jsx("path", { d: s });
  }
  toSvg(e) {
    return /* @__PURE__ */ l.jsx(kN, { shouldScale: !0, shape: e });
  }
  getHandleSnapGeometry(e) {
    const n = Tl(e);
    return {
      points: n,
      getSelfSnapPoints: (i) => {
        const r = this.getHandles(e).filter((s) => s.type === "vertex").findIndex((s) => s.id === i.id);
        return n.filter((s, o) => Math.abs(o - r) > 1).map(x.From);
      },
      getSelfSnapOutline: (i) => {
        const r = this.getHandles(e).filter((o) => o.type === "vertex").findIndex((o) => o.id === i.id), s = bl(e).segments.filter(
          (o, a) => a !== r - 1 && a !== r
        );
        return s.length ? new Ki({ children: s }) : null;
      }
    };
  }
  getInterpolatedProps(e, n, i) {
    const r = Tl(e), s = Tl(n), o = [], a = [];
    let c = dT;
    if (r.length > s.length)
      for (let d = 0; d < r.length; d++)
        o[d] = { ...r[d] }, s[d] === void 0 ? a[d] = { ...s[s.length - 1], id: c } : a[d] = { ...s[d], id: c }, c = hi(c);
    else if (s.length > r.length)
      for (let d = 0; d < s.length; d++)
        a[d] = { ...s[d] }, r[d] === void 0 ? o[d] = {
          ...r[r.length - 1],
          id: c
        } : o[d] = { ...r[d], id: c }, c = hi(c);
    else
      for (let d = 0; d < s.length; d++)
        o[d] = r[d], a[d] = s[d];
    return {
      ...i > 0.5 ? n.props : e.props,
      points: Object.fromEntries(
        o.map((d, u) => {
          const h = a[u];
          return [
            d.id,
            {
              ...d,
              x: et(d.x, h.x, i),
              y: et(d.y, h.y, i)
            }
          ];
        })
      ),
      scale: et(e.props.scale, n.props.scale, i)
    };
  }
}
S(Qh, "type", "line"), S(Qh, "props", ov), S(Qh, "migrations", av);
function Tl(t) {
  return Object.values(t.props.points).sort(Jt);
}
function bl(t) {
  const e = Tl(t).map(x.From);
  switch (t.props.spline) {
    case "cubic":
      return new tX({ points: e });
    case "line":
      return new Ds({ points: e });
  }
}
function kN({
  shape: t,
  shouldScale: e = !1,
  forceSolid: n = !1
}) {
  const i = $n(), r = bl(t), { dash: s, color: o, size: a } = t.props, c = 1 / t.props.scale, d = e ? c : 1, u = Ur[a] * t.props.scale;
  if (t.props.spline === "line") {
    if (s === "solid") {
      const h = r.points, g = "M" + h[0] + "L" + h.slice(1);
      return /* @__PURE__ */ l.jsx(
        "path",
        {
          d: g,
          stroke: i[o].solid,
          strokeWidth: u,
          fill: "none",
          transform: `scale(${d})`
        }
      );
    }
    if (s === "dashed" || s === "dotted")
      return /* @__PURE__ */ l.jsx("g", { stroke: i[o].solid, strokeWidth: u, transform: `scale(${d})`, children: r.segments.map((h, g) => {
        const { strokeDasharray: p, strokeDashoffset: f } = n ? { strokeDasharray: "none", strokeDashoffset: "none" } : or(h.length, u, {
          style: s,
          start: g > 0 ? "outset" : "none",
          end: g < r.segments.length - 1 ? "outset" : "none"
        });
        return /* @__PURE__ */ l.jsx(
          "path",
          {
            strokeDasharray: p,
            strokeDashoffset: f,
            d: h.getSvgPathData(!0),
            fill: "none"
          },
          g
        );
      }) });
    if (s === "draw") {
      const h = r.points, [g, p] = aO(t.id, h, u);
      return /* @__PURE__ */ l.jsx(
        "path",
        {
          d: p,
          stroke: i[o].solid,
          strokeWidth: u,
          fill: "none",
          transform: `scale(${d})`
        }
      );
    }
  }
  if (t.props.spline === "cubic") {
    const h = r.getSvgPathData();
    if (s === "solid")
      return /* @__PURE__ */ l.jsx(
        "path",
        {
          strokeWidth: u,
          stroke: i[o].solid,
          fill: "none",
          d: h,
          transform: `scale(${d})`
        }
      );
    if (s === "dashed" || s === "dotted")
      return /* @__PURE__ */ l.jsx("g", { stroke: i[o].solid, strokeWidth: u, transform: `scale(${d})`, children: r.segments.map((g, p) => {
        const { strokeDasharray: f, strokeDashoffset: M } = or(
          g.length,
          u,
          {
            style: s,
            start: p > 0 ? "outset" : "none",
            end: p < r.segments.length - 1 ? "outset" : "none",
            forceSolid: n
          }
        );
        return /* @__PURE__ */ l.jsx(
          "path",
          {
            strokeDasharray: f,
            strokeDashoffset: M,
            d: g.getSvgPathData(),
            fill: "none"
          },
          p
        );
      }) });
    if (s === "draw")
      return /* @__PURE__ */ l.jsx(
        "path",
        {
          d: sse(t, r, u),
          strokeWidth: 1,
          stroke: i[o].solid,
          fill: i[o].solid,
          transform: `scale(${d})`
        }
      );
  }
}
class Zh extends Ci {
  canEdit() {
    return !0;
  }
  hideResizeHandles() {
    return !0;
  }
  hideSelectionBoundsFg() {
    return !1;
  }
  getDefaultProps() {
    return {
      color: "black",
      size: "m",
      text: "",
      font: "draw",
      align: "middle",
      verticalAlign: "middle",
      labelColor: "black",
      growY: 0,
      fontSizeAdjustment: 0,
      url: "",
      scale: 1
    };
  }
  getGeometry(e) {
    const { labelHeight: n, labelWidth: i } = cO(this.editor, e), { scale: r } = e.props, s = n * r, o = i * r, a = Mt * r, c = $u(e);
    return new Ki({
      children: [
        new Pi({ width: a, height: c, isFilled: !0 }),
        new Pi({
          x: e.props.align === "start" ? 0 : e.props.align === "end" ? a - o : (a - o) / 2,
          y: e.props.verticalAlign === "start" ? 0 : e.props.verticalAlign === "end" ? c - s : (c - s) / 2,
          width: o,
          height: s,
          isFilled: !0,
          isLabel: !0
        })
      ]
    });
  }
  getHandles(e) {
    const { scale: n } = e.props;
    if (this.editor.getInstanceState().isCoarsePointer) return [];
    const r = this.editor.getZoomLevel();
    if (r * n < 0.25) return [];
    const s = $u(e), o = Mt * n, a = bie / r * n;
    return r * n < 0.5 ? [
      {
        id: "bottom",
        index: "a3",
        type: "clone",
        x: o / 2,
        y: s + a
      }
    ] : [
      {
        id: "top",
        index: "a1",
        type: "clone",
        x: o / 2,
        y: -a
      },
      {
        id: "right",
        index: "a2",
        type: "clone",
        x: o + a,
        y: s / 2
      },
      {
        id: "bottom",
        index: "a3",
        type: "clone",
        x: o / 2,
        y: s + a
      },
      {
        id: "left",
        index: "a4",
        type: "clone",
        x: -a,
        y: s / 2
      }
    ];
  }
  getText(e) {
    return e.props.text;
  }
  component(e) {
    const {
      id: n,
      type: i,
      props: {
        labelColor: r,
        scale: s,
        color: o,
        font: a,
        size: c,
        align: d,
        text: u,
        verticalAlign: h,
        fontSizeAdjustment: g
      }
    } = e, p = dse(n), f = $n(), M = Mt * s, m = $u(e), y = G(
      "shape rotation",
      () => {
        var j;
        return ((j = this.editor.getShapePageTransform(n)) == null ? void 0 : j.rotation()) ?? 0;
      },
      [this.editor]
    ), I = G("zoom", () => this.editor.getZoomLevel() < 0.35 / s, [
      s,
      this.editor
    ]), D = e.id === this.editor.getOnlySelectedShapeId();
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "div",
        {
          id: n,
          className: "tl-note__container",
          style: {
            width: M,
            height: m,
            backgroundColor: f[o].note.fill,
            borderBottom: I ? `${3 * s}px solid rgb(15, 23, 31, .2)` : "none",
            boxShadow: I ? "none" : use(e.id, y, s)
          },
          children: /* @__PURE__ */ l.jsx(
            mf,
            {
              shapeId: n,
              type: i,
              font: a,
              fontSize: (g || fs[c]) * s,
              lineHeight: Cn.lineHeight,
              align: d,
              verticalAlign: h,
              text: u,
              isNote: !0,
              isSelected: D,
              labelColor: r === "black" ? f[o].note.text : f[r].fill,
              wrap: !0,
              padding: 16 * s,
              onKeyDown: p
            }
          )
        }
      ),
      "url" in e.props && e.props.url && /* @__PURE__ */ l.jsx(ec, { url: e.props.url })
    ] });
  }
  indicator(e) {
    const { scale: n } = e.props;
    return /* @__PURE__ */ l.jsx(
      "rect",
      {
        rx: n,
        width: k(Mt * n),
        height: k($u(e))
      }
    );
  }
  toSvg(e, n) {
    e.props.text && n.addExportDef(ff(e.props.font));
    const i = Hr({ isDarkMode: n.isDarkMode }), r = hse(e);
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx("rect", { x: 5, y: 5, rx: 1, width: Mt - 10, height: r.h, fill: "rgba(0,0,0,.1)" }),
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          rx: 1,
          width: Mt,
          height: r.h,
          fill: i[e.props.color].note.fill
        }
      ),
      /* @__PURE__ */ l.jsx(
        Mf,
        {
          fontSize: e.props.fontSizeAdjustment || fs[e.props.size],
          font: e.props.font,
          align: e.props.align,
          verticalAlign: e.props.verticalAlign,
          text: e.props.text,
          labelColor: i[e.props.color].note.text,
          bounds: r,
          stroke: !1
        }
      )
    ] });
  }
  onBeforeCreate(e) {
    return ON(this.editor, e);
  }
  onBeforeUpdate(e, n) {
    if (!(e.props.text === n.props.text && e.props.font === n.props.font && e.props.size === n.props.size))
      return ON(this.editor, n);
  }
  onEditEnd(e) {
    const {
      id: n,
      type: i,
      props: { text: r }
    } = e;
    r.trimEnd() !== e.props.text && this.editor.updateShapes([
      {
        id: n,
        type: i,
        props: {
          text: r.trimEnd()
        }
      }
    ]);
  }
  getInterpolatedProps(e, n, i) {
    return {
      ...i > 0.5 ? n.props : e.props,
      scale: et(e.props.scale, n.props.scale, i)
    };
  }
}
S(Zh, "type", "note"), S(Zh, "props", cv), S(Zh, "migrations", lv);
function ON(t, e) {
  const { labelHeight: n, fontSizeAdjustment: i } = cO(t, e), r = Math.max(0, n - Mt);
  if (r !== e.props.growY || i !== e.props.fontSizeAdjustment)
    return {
      ...e,
      props: {
        ...e.props,
        growY: r,
        fontSizeAdjustment: i
      }
    };
}
function cse(t, e) {
  const { text: n } = e.props;
  if (!n)
    return { labelHeight: fs[e.props.size] * Cn.lineHeight + Gi * 2, labelWidth: 100, fontSizeAdjustment: 0 };
  const i = fs[e.props.size];
  let r = 0, s = 0, o = Mt, a = Mt;
  const c = 1;
  do {
    r = Math.min(i, i - s);
    const d = t.textMeasure.measureText(n, {
      ...Cn,
      fontFamily: xs[e.props.font],
      fontSize: r,
      maxWidth: Mt - Gi * 2 - c,
      disableOverflowWrapBreaking: !0
    });
    if (o = d.h + Gi * 2, a = d.w + Gi * 2, r <= 14) {
      const u = t.textMeasure.measureText(n, {
        ...Cn,
        fontFamily: xs[e.props.font],
        fontSize: r,
        maxWidth: Mt - Gi * 2 - c
      });
      o = u.h + Gi * 2, a = u.w + Gi * 2;
      break;
    }
    if (d.scrollWidth.toFixed(0) === d.w.toFixed(0))
      break;
  } while (s++ < 50);
  return {
    labelHeight: o,
    labelWidth: a,
    fontSizeAdjustment: r
  };
}
const lse = new hr();
function cO(t, e) {
  return lse.get(e, () => cse(t, e));
}
function dse(t) {
  const e = Q(), n = cz();
  return re(
    (i) => {
      const r = e.getShape(t);
      if (!r) return;
      const s = i.key === "Tab", o = (i.metaKey || i.ctrlKey) && i.key === "Enter";
      if (s || o) {
        i.preventDefault();
        const a = e.getShapePageTransform(t), c = a.rotation(), d = !!(n.dir === "rtl" || Ek(r.props.text)), u = (Mt + e.options.adjacentShapeMargin + // If we're growing down, we need to account for the current shape's growY
        (o && !i.shiftKey ? r.props.growY : 0)) * r.props.scale, h = new x(
          s ? i.shiftKey != d ? -1 : 1 : 0,
          o ? i.shiftKey ? -1 : 1 : 0
        ).mul(u).add(pf.clone().mul(r.props.scale)).rot(c).add(a.point()), g = Rk(e, r, h, c);
        g && (e.markHistoryStoppingPoint("editing adjacent shape"), Pg(
          e,
          g,
          !0
          /* selectAll */
        ));
      }
    },
    [t, e, n.dir]
  );
}
function $u(t) {
  return (Mt + t.props.growY) * t.props.scale;
}
function use(t, e, n) {
  const i = xr(t), r = Math.abs(i()) + 0.5, s = Math.cos(e), o = 5 * n, a = 4 * n, c = 6 * n, d = 7 * n;
  return `0px ${o - r}px ${o}px -${o}px rgba(15, 23, 31, .6),
	0px ${(a + r * d) * Math.max(0, s)}px ${c + r * d}px -${a + r * c}px rgba(15, 23, 31, ${(0.3 + r * 0.1).toFixed(2)}), 
	0px ${48 * n}px ${10 * n}px -${10 * n}px inset rgba(15, 23, 44, ${((0.022 + i() * 5e-3) * ((1 + s) / 2)).toFixed(2)})`;
}
function hse(t) {
  return new ae(0, 0, Mt, Mt + t.props.growY);
}
function gse(t, {
  initialBounds: e,
  scaleX: n,
  scaleY: i,
  newPoint: r
}) {
  const s = Math.max(0.01, Math.min(Math.abs(n), Math.abs(i))), o = new x(0, 0);
  n < 0 && (o.x = -(e.width * s)), i < 0 && (o.y = -(e.height * s));
  const { x: a, y: c } = x.Add(r, o.rot(t.rotation));
  return {
    x: a,
    y: c,
    props: {
      scale: s * t.props.scale
    }
  };
}
const pse = new hr();
class Fh extends Ci {
  getDefaultProps() {
    return {
      color: "black",
      size: "m",
      w: 8,
      text: "",
      font: "draw",
      textAlign: "start",
      autoSize: !0,
      scale: 1
    };
  }
  getMinDimensions(e) {
    return pse.get(e.props, (n) => PN(this.editor, n));
  }
  getGeometry(e) {
    const { scale: n } = e.props, { width: i, height: r } = this.getMinDimensions(e);
    return new Pi({
      width: i * n,
      height: r * n,
      isFilled: !0,
      isLabel: !0
    });
  }
  getText(e) {
    return e.props.text;
  }
  canEdit() {
    return !0;
  }
  isAspectRatioLocked() {
    return !0;
  }
  // WAIT NO THIS IS HARD CODED IN THE RESIZE HANDLER
  component(e) {
    const {
      id: n,
      props: { font: i, size: r, text: s, color: o, scale: a, textAlign: c }
    } = e, { width: d, height: u } = this.getMinDimensions(e), h = e.id === this.editor.getOnlySelectedShapeId(), g = $n(), p = fse(n);
    return /* @__PURE__ */ l.jsx(
      mf,
      {
        shapeId: n,
        classNamePrefix: "tl-text-shape",
        type: "text",
        font: i,
        fontSize: _a[r],
        lineHeight: Cn.lineHeight,
        align: c,
        verticalAlign: "middle",
        text: s,
        labelColor: g[o].solid,
        isSelected: h,
        textWidth: d,
        textHeight: u,
        style: {
          transform: `scale(${a})`,
          transformOrigin: "top left"
        },
        wrap: !0,
        onKeyDown: p
      }
    );
  }
  indicator(e) {
    const n = this.editor.getShapeGeometry(e).bounds, i = Q();
    return e.props.autoSize && i.getEditingShapeId() === e.id ? null : /* @__PURE__ */ l.jsx("rect", { width: k(n.width), height: k(n.height) });
  }
  toSvg(e, n) {
    e.props.text && n.addExportDef(ff(e.props.font));
    const i = this.editor.getShapeGeometry(e).bounds, r = i.width / (e.props.scale ?? 1), s = i.height / (e.props.scale ?? 1), o = Hr(n);
    return /* @__PURE__ */ l.jsx(
      Mf,
      {
        fontSize: _a[e.props.size],
        font: e.props.font,
        align: e.props.textAlign,
        verticalAlign: "middle",
        text: e.props.text,
        labelColor: o[e.props.color].solid,
        bounds: new ae(0, 0, r, s),
        padding: 0
      }
    );
  }
  onResize(e, n) {
    const { newPoint: i, initialBounds: r, initialShape: s, scaleX: o, handle: a } = n;
    if (n.mode === "scale_shape" || a !== "right" && a !== "left")
      return {
        id: e.id,
        type: e.type,
        ...gse(e, n)
      };
    {
      const c = Math.max(1, Math.abs(r.width * o)), { x: d, y: u } = o < 0 ? x.Sub(i, x.FromAngle(e.rotation).mul(c)) : i;
      return {
        id: e.id,
        type: e.type,
        x: d,
        y: u,
        props: {
          w: c / s.props.scale,
          autoSize: !1
        }
      };
    }
  }
  onEditEnd(e) {
    const {
      id: n,
      type: i,
      props: { text: r }
    } = e, s = e.props.text.trimEnd();
    s.length === 0 ? this.editor.deleteShapes([e.id]) : s !== e.props.text && this.editor.updateShapes([
      {
        id: n,
        type: i,
        props: {
          text: r.trimEnd()
        }
      }
    ]);
  }
  onBeforeUpdate(e, n) {
    if (!n.props.autoSize) return;
    const i = e.props.size !== n.props.size || e.props.textAlign !== n.props.textAlign || e.props.font !== n.props.font || e.props.scale !== 1 && n.props.scale === 1, r = e.props.text !== n.props.text;
    if (!i && !r) return;
    const s = this.getMinDimensions(e), o = PN(this.editor, n.props), a = s.width * e.props.scale, c = s.height * e.props.scale, d = o.width * n.props.scale, u = o.height * n.props.scale;
    let h;
    switch (n.props.textAlign) {
      case "middle": {
        h = new x((d - a) / 2, r ? 0 : (u - c) / 2);
        break;
      }
      case "end": {
        h = new x(d - a, r ? 0 : (u - c) / 2);
        break;
      }
      default: {
        if (r) break;
        h = new x(0, (u - c) / 2);
        break;
      }
    }
    if (h) {
      h.rot(n.rotation);
      const { x: g, y: p } = n;
      return {
        ...n,
        x: g - h.x,
        y: p - h.y,
        props: { ...n.props, w: d }
      };
    } else
      return {
        ...n,
        props: { ...n.props, w: d }
      };
  }
  // 	todo: The edge doubleclicking feels like a mistake more often than
  //  not, especially on multiline text. Removed June 16 2024
  // override onDoubleClickEdge = (shape: TLTextShape) => {
  // 	// If the shape has a fixed width, set it to autoSize.
  // 	if (!shape.props.autoSize) {
  // 		return {
  // 			id: shape.id,
  // 			type: shape.type,
  // 			props: {
  // 				autoSize: true,
  // 			},
  // 		}
  // 	}
  // 	// If the shape is scaled, reset the scale to 1.
  // 	if (shape.props.scale !== 1) {
  // 		return {
  // 			id: shape.id,
  // 			type: shape.type,
  // 			props: {
  // 				scale: 1,
  // 			},
  // 		}
  // 	}
  // }
}
S(Fh, "type", "text"), S(Fh, "props", dv), S(Fh, "migrations", uv);
function PN(t, e) {
  const { font: n, text: i, autoSize: r, size: s, w: o } = e, a = r ? 16 : Math.max(16, o), c = _a[s], d = r ? null : (
    // `measureText` floors the number so we need to do the same here to avoid issues.
    Math.floor(Math.max(a, o))
  ), u = t.textMeasure.measureText(i, {
    ...Cn,
    fontFamily: xs[n],
    fontSize: c,
    maxWidth: d
  });
  return r && (u.w += 1), {
    width: Math.max(a, u.w),
    height: Math.max(c, u.h)
  };
}
function fse(t) {
  const e = Q();
  return re(
    (n) => {
      if (e.getEditingShapeId() === t)
        switch (n.key) {
          case "Enter": {
            (n.ctrlKey || n.metaKey) && e.complete();
            break;
          }
          case "Tab": {
            Ke(n), n.shiftKey ? $a.unindent(n.currentTarget) : $a.indent(n.currentTarget);
            break;
          }
        }
    },
    [e, t]
  );
}
class Bh extends ho {
  canEdit() {
    return !0;
  }
  isAspectRatioLocked() {
    return !0;
  }
  getDefaultProps() {
    return {
      w: 100,
      h: 100,
      assetId: null,
      time: 0,
      playing: !0,
      url: ""
    };
  }
  component(e) {
    const { asset: n, url: i } = tO({
      shapeId: e.id,
      assetId: e.props.assetId
    });
    return /* @__PURE__ */ l.jsx(Mse, { editor: this.editor, shape: e, asset: n, url: i });
  }
  indicator(e) {
    return /* @__PURE__ */ l.jsx("rect", { width: k(e.props.w), height: k(e.props.h) });
  }
  async toSvg(e) {
    const n = await mse(this.editor, e);
    return n ? /* @__PURE__ */ l.jsx("image", { href: n, width: e.props.w, height: e.props.h }) : null;
  }
}
S(Bh, "type", "video"), S(Bh, "props", hv), S(Bh, "migrations", gv);
const Mse = _e(function({
  editor: e,
  shape: n,
  asset: i,
  url: r
}) {
  const s = e.getShapeGeometry(n).bounds.w * e.getZoomLevel() >= 110, o = Fp(n.id), a = iO(), { Spinner: c } = At(), d = le(null), [u, h] = pe(!1), [g, p] = pe(!1);
  ze(() => {
    const M = () => p(document.fullscreenElement === d.current);
    return document.addEventListener("fullscreenchange", M), () => document.removeEventListener("fullscreenchange", M);
  });
  const f = re((M) => {
    M.currentTarget && h(!0);
  }, []);
  return ze(() => {
    const M = d.current;
    M && o && document.activeElement !== M && M.focus();
  }, [o, u]), ze(() => {
    if (a) {
      const M = d.current;
      if (!M) return;
      M.pause(), M.currentTime = 0;
    }
  }, [d, a]), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      qs,
      {
        id: n.id,
        style: {
          color: "var(--color-text-3)",
          backgroundColor: i ? "transparent" : "var(--color-low)",
          border: i ? "none" : "1px solid var(--color-low-border)"
        },
        children: /* @__PURE__ */ l.jsx("div", { className: "tl-counter-scaled", children: /* @__PURE__ */ l.jsx("div", { className: "tl-video-container", children: i ? c && !i.props.src ? /* @__PURE__ */ l.jsx(c, {}) : r ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(
            "video",
            {
              ref: d,
              style: o ? { pointerEvents: "all" } : u ? void 0 : { display: "none" },
              className: ce("tl-video", `tl-video-shape-${n.id.split(":")[1]}`, {
                "tl-video-is-fullscreen": g
              }),
              width: "100%",
              height: "100%",
              draggable: !1,
              playsInline: !0,
              autoPlay: !0,
              muted: !0,
              loop: !0,
              disableRemotePlayback: !0,
              disablePictureInPicture: !0,
              controls: o && s,
              onLoadedData: f,
              hidden: !u,
              children: /* @__PURE__ */ l.jsx("source", { src: r })
            }
          ),
          !u && c && /* @__PURE__ */ l.jsx(c, {})
        ] }) : null : /* @__PURE__ */ l.jsx(eO, {}) }) })
      }
    ),
    "url" in n.props && n.props.url && /* @__PURE__ */ l.jsx(ec, { url: n.props.url })
  ] });
});
async function mse(t, e) {
  const n = await t.resolveAssetUrl(e.props.assetId, {
    shouldResolveToOriginal: !0
  });
  if (!n) return null;
  const i = await bi.loadVideo(n);
  return bi.getVideoFrameAsDataUrl(i, 0);
}
const lO = [
  Fh,
  Lh,
  kh,
  Uh,
  Zh,
  Qh,
  Ph,
  zh,
  Rh,
  Oh,
  Yh,
  Bh
];
function yse(t) {
  return t.sideEffects.register({
    instance_page_state: {
      afterChange: (e, n) => {
        if (e.croppingShapeId !== n.croppingShapeId) {
          const i = t.isIn("select.crop");
          !e.croppingShapeId && n.croppingShapeId ? i || t.setCurrentTool("select.crop.idle") : e.croppingShapeId && !n.croppingShapeId && i && t.setCurrentTool("select.idle");
        }
        if (e.editingShapeId !== n.editingShapeId)
          if (!e.editingShapeId && n.editingShapeId) {
            if (!t.isIn("select.editing_shape")) {
              const i = t.getEditingShape();
              i && i.type === "text" && t.isInAny("text.pointing", "select.resizing") && t.getInstanceState().isToolLocked ? t.setCurrentTool("select.editing_shape", {
                isCreatingTextWhileToolLocked: !0
              }) : t.setCurrentTool("select.editing_shape");
            }
          } else e.editingShapeId && !n.editingShapeId && t.isIn("select.editing_shape") && t.setCurrentTool("select.idle");
      }
    }
  });
}
var Qm;
let Ise = (Qm = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
    S(this, "scribbleId", "id");
    S(this, "markId", "");
    S(this, "excludedShapeIds", /* @__PURE__ */ new Set());
  }
  onEnter(n) {
    this.markId = this.editor.markHistoryStoppingPoint("erase scribble begin"), this.info = n;
    const { originPagePoint: i } = this.editor.inputs;
    this.excludedShapeIds = new Set(
      this.editor.getCurrentPageShapes().filter((s) => {
        if (this.editor.isShapeOrAncestorLocked(s)) return !0;
        if (this.editor.isShapeOfType(s, "group") || this.editor.isShapeOfType(s, "frame")) {
          const o = this.editor.getPointInShapeSpace(s, i);
          return this.editor.getShapeGeometry(s).bounds.containsPoint(o);
        }
        return !1;
      }).map((s) => s.id)
    );
    const r = this.editor.scribbles.addScribble({
      color: "muted-1",
      size: 12
    });
    this.scribbleId = r.id, this.update();
  }
  pushPointToScribble() {
    const { x: n, y: i } = this.editor.inputs.currentPagePoint;
    this.editor.scribbles.addPoint(this.scribbleId, n, i);
  }
  onExit() {
    this.editor.scribbles.stop(this.scribbleId);
  }
  onPointerMove() {
    this.update();
  }
  onPointerUp() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.complete();
  }
  update() {
    const { editor: n, excludedShapeIds: i } = this, r = n.getErasingShapeIds(), s = n.getZoomLevel(), o = n.getCurrentPageRenderingShapesSorted(), {
      inputs: { currentPagePoint: a, previousPagePoint: c }
    } = n;
    this.pushPointToScribble();
    const d = new Set(r), u = this.editor.options.hitTestMargin / s;
    for (const h of o) {
      if (n.isShapeOfType(h, "group")) continue;
      const g = n.getShapeMask(h.id);
      if (g && !yi(a, g))
        continue;
      const p = n.getShapeGeometry(h), f = n.getShapePageTransform(h);
      if (!p || !f) continue;
      const M = f.clone().invert(), m = M.applyToPoint(c), y = M.applyToPoint(a), { bounds: I } = p;
      I.minX - u > Math.max(m.x, y.x) || I.minY - u > Math.max(m.y, y.y) || I.maxX + u < Math.min(m.x, y.x) || I.maxY + u < Math.min(m.y, y.y) || p.hitTestLineSegment(m, y, u) && d.add(n.getOutermostSelectableShape(h).id);
    }
    this.editor.setErasingShapes([...d].filter((h) => !i.has(h)));
  }
  complete() {
    const { editor: n } = this;
    n.deleteShapes(n.getCurrentPageState().erasingShapeIds), n.setErasingShapes([]), this.parent.transition("idle");
  }
  cancel() {
    const { editor: n } = this;
    n.setErasingShapes([]), n.bailToMark(this.markId), this.parent.transition("idle", this.info);
  }
}, S(Qm, "id", "erasing"), Qm);
var Zm;
let xse = (Zm = class extends ee {
  onPointerDown(e) {
    this.parent.transition("pointing", e);
  }
  onCancel() {
    this.editor.setCurrentTool("select");
  }
}, S(Zm, "id", "idle"), Zm);
var Fm;
let Sse = (Fm = class extends ee {
  onEnter() {
    const e = this.editor.getZoomLevel(), n = this.editor.getCurrentPageRenderingShapesSorted(), {
      inputs: { currentPagePoint: i }
    } = this.editor, r = /* @__PURE__ */ new Set(), s = r.size;
    for (let o = n.length, a = o - 1; a >= 0; a--) {
      const c = n[a];
      if (!(this.editor.isShapeOrAncestorLocked(c) || this.editor.isShapeOfType(c, "group")) && this.editor.isPointInShape(c, i, {
        hitInside: !1,
        margin: this.editor.options.hitTestMargin / e
      })) {
        const d = this.editor.getOutermostSelectableShape(c);
        if (this.editor.isShapeOfType(d, "frame") && r.size > s)
          break;
        r.add(d.id);
      }
    }
    this.editor.setErasingShapes([...r]);
  }
  onLongPress(e) {
    this.startErasing(e);
  }
  onPointerMove(e) {
    this.editor.inputs.isDragging && this.startErasing(e);
  }
  onPointerUp() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.complete();
  }
  onInterrupt() {
    this.cancel();
  }
  startErasing(e) {
    this.parent.transition("erasing", e);
  }
  complete() {
    const e = this.editor.getErasingShapeIds();
    e.length && (this.editor.markHistoryStoppingPoint("erase end"), this.editor.deleteShapes(e)), this.editor.setErasingShapes([]), this.parent.transition("idle");
  }
  cancel() {
    this.editor.setErasingShapes([]), this.parent.transition("idle");
  }
}, S(Fm, "id", "pointing"), Fm);
var Ml;
let jse = (Ml = class extends ee {
  static children() {
    return [xse, Sse, Ise];
  }
  onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 });
  }
}, S(Ml, "id", "eraser"), S(Ml, "initial", "idle"), S(Ml, "isLockable", !1), Ml);
class dO extends ee {
  constructor() {
    super(...arguments);
    S(this, "initialCamera", new x());
  }
  onEnter() {
    this.initialCamera = x.From(this.editor.getCamera()), this.update();
  }
  onPointerMove() {
    this.update();
  }
  onPointerUp() {
    this.complete();
  }
  onCancel() {
    this.parent.transition("idle");
  }
  onComplete() {
    this.complete();
  }
  update() {
    const { initialCamera: n, editor: i } = this, { currentScreenPoint: r, originScreenPoint: s } = i.inputs, o = x.Sub(r, s).div(i.getZoomLevel());
    o.len2() !== 0 && i.setCamera(n.clone().add(o));
  }
  complete() {
    const { editor: n } = this, { pointerVelocity: i } = n.inputs, r = Math.min(i.len(), 2);
    r > 0.1 && this.editor.slideCamera({ speed: r, direction: i }), this.parent.transition("idle");
  }
}
S(dO, "id", "dragging");
var Bm;
let Dse = (Bm = class extends ee {
  onEnter() {
    this.editor.setCursor({ type: "grab", rotation: 0 });
  }
  onPointerDown(e) {
    this.parent.transition("pointing", e);
  }
  onCancel() {
    this.editor.setCurrentTool("select");
  }
}, S(Bm, "id", "idle"), Bm);
var Gm;
let wse = (Gm = class extends ee {
  onEnter() {
    this.editor.stopCameraAnimation(), this.editor.setCursor({ type: "grabbing", rotation: 0 });
  }
  onLongPress() {
    this.startDragging();
  }
  onPointerMove() {
    this.editor.inputs.isDragging && this.startDragging();
  }
  startDragging() {
    this.parent.transition("dragging");
  }
  onPointerUp() {
    this.complete();
  }
  onCancel() {
    this.complete();
  }
  onComplete() {
    this.complete();
  }
  onInterrupt() {
    this.complete();
  }
  complete() {
    this.parent.transition("idle");
  }
}, S(Gm, "id", "pointing"), Gm);
class Gh extends ee {
  static children() {
    return [Dse, wse, dO];
  }
  onDoubleClick(e) {
    if (e.phase === "settle") {
      const { currentScreenPoint: n } = this.editor.inputs;
      this.editor.zoomIn(n, {
        animation: { duration: 220, easing: on.easeOutQuint }
      });
    }
  }
  onTripleClick(e) {
    if (e.phase === "settle") {
      const { currentScreenPoint: n } = this.editor.inputs;
      this.editor.zoomOut(n, {
        animation: { duration: 320, easing: on.easeOutQuint }
      });
    }
  }
  onQuadrupleClick(e) {
    if (e.phase === "settle") {
      const n = this.editor.getZoomLevel(), {
        inputs: { currentScreenPoint: i }
      } = this.editor;
      n === 1 ? this.editor.zoomToFit({ animation: { duration: 400, easing: on.easeOutQuint } }) : this.editor.resetZoom(i, {
        animation: { duration: 320, easing: on.easeOutQuint }
      });
    }
  }
}
S(Gh, "id", "hand"), S(Gh, "initial", "idle"), S(Gh, "isLockable", !1);
var Wm;
let Nse = (Wm = class extends ee {
  onPointerDown(e) {
    this.parent.transition("lasering", e);
  }
}, S(Wm, "id", "idle"), Wm);
class uO extends ee {
  constructor() {
    super(...arguments);
    S(this, "scribbleId", "id");
  }
  onEnter() {
    const n = this.editor.scribbles.addScribble({
      color: "laser",
      opacity: 0.7,
      size: 4,
      delay: this.editor.options.laserDelayMs,
      shrink: 0.05,
      taper: !0
    });
    this.scribbleId = n.id, this.pushPointToScribble();
  }
  onExit() {
    this.editor.scribbles.stop(this.scribbleId);
  }
  onPointerMove() {
    this.pushPointToScribble();
  }
  onPointerUp() {
    this.complete();
  }
  pushPointToScribble() {
    const { x: n, y: i } = this.editor.inputs.currentPagePoint;
    this.editor.scribbles.addPoint(this.scribbleId, n, i);
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.complete();
  }
  complete() {
    this.parent.transition("idle");
  }
  cancel() {
    this.parent.transition("idle");
  }
}
S(uO, "id", "lasering");
class Wh extends ee {
  static children() {
    return [Nse, uO];
  }
  onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 });
  }
}
S(Wh, "id", "laser"), S(Wh, "initial", "idle"), S(Wh, "isLockable", !1);
class hO extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
    S(this, "initialSelectedShapeIds", []);
    S(this, "excludedShapeIds", /* @__PURE__ */ new Set());
    S(this, "isWrapMode", !1);
    // The shape that the brush started on
    S(this, "initialStartShape", null);
  }
  onEnter(n) {
    const { altKey: i, currentPagePoint: r } = this.editor.inputs;
    if (this.isWrapMode = this.editor.user.getIsWrapMode(), i) {
      this.parent.transition("scribble_brushing", n);
      return;
    }
    this.excludedShapeIds = new Set(
      this.editor.getCurrentPageShapes().filter(
        (s) => this.editor.isShapeOfType(s, "group") || this.editor.isShapeOrAncestorLocked(s)
      ).map((s) => s.id)
    ), this.info = n, this.initialSelectedShapeIds = this.editor.getSelectedShapeIds().slice(), this.initialStartShape = this.editor.getShapesAtPoint(r)[0], this.hitTestShapes();
  }
  onExit() {
    this.initialSelectedShapeIds = [], this.editor.updateInstanceState({ brush: null });
  }
  onTick({ elapsed: n }) {
    const { editor: i } = this;
    i.edgeScrollManager.updateEdgeScrolling(n);
  }
  onPointerMove() {
    this.hitTestShapes();
  }
  onPointerUp() {
    this.complete();
  }
  onComplete() {
    this.complete();
  }
  onCancel(n) {
    this.editor.setSelectedShapes(this.initialSelectedShapeIds), this.parent.transition("idle", n);
  }
  onKeyDown(n) {
    this.editor.inputs.altKey ? this.parent.transition("scribble_brushing", n) : this.hitTestShapes();
  }
  onKeyUp() {
    this.hitTestShapes();
  }
  complete() {
    this.hitTestShapes(), this.parent.transition("idle");
  }
  hitTestShapes() {
    const { editor: n, excludedShapeIds: i, isWrapMode: r } = this, {
      inputs: { originPagePoint: s, currentPagePoint: o, shiftKey: a, ctrlKey: c }
    } = n, d = new Set(a ? this.initialSelectedShapeIds : []), u = r ? !c : c, h = ae.FromPoints([s, o]), { corners: g } = h;
    let p, f, M, m, y, I;
    const D = n.getCurrentPageRenderingShapesSorted(), j = n.getCurrentPageId();
    e: for (let b = 0, T = D.length; b < T; b++) {
      if (M = D[b], i.has(M.id) || d.has(M.id) || (m = n.getShapePageBounds(M), !m)) continue e;
      if (h.contains(m)) {
        this.handleHit(M, o, j, d, g);
        continue e;
      }
      if (u || n.isShapeOfType(M, "frame"))
        continue e;
      if (h.collides(m)) {
        if (y = n.getShapePageTransform(M), !y) continue e;
        I = y.clone().invert().applyToPoints(g);
        const E = n.getShapeGeometry(M);
        t: for (let v = 0; v < 4; v++)
          if (p = I[v], f = I[(v + 1) % 4], E.hitTestLineSegment(p, f, 0)) {
            this.handleHit(M, o, j, d, g);
            break t;
          }
      }
    }
    const w = n.getInstanceState().brush;
    (!w || !h.equals(w)) && n.updateInstanceState({ brush: { ...h.toJson() } });
    const A = n.getSelectedShapeIds();
    (A.length !== d.size || A.some((b) => !d.has(b))) && n.setSelectedShapes(Array.from(d));
  }
  onInterrupt() {
    this.editor.updateInstanceState({ brush: null });
  }
  handleHit(n, i, r, s, o) {
    if (n.parentId === r) {
      s.add(n.id);
      return;
    }
    const a = this.editor.getOutermostSelectableShape(n), c = this.editor.getShapeMask(a.id);
    c && !r1(c, o) && !yi(i, c) || s.add(a.id);
  }
}
S(hO, "id", "brushing");
const nc = {
  bottom: "ns-resize",
  top: "ns-resize",
  left: "ew-resize",
  right: "ew-resize",
  bottom_left: "nesw-resize",
  bottom_right: "nwse-resize",
  top_left: "nwse-resize",
  top_right: "nesw-resize",
  bottom_left_rotate: "swne-rotate",
  bottom_right_rotate: "senw-rotate",
  top_left_rotate: "nwse-rotate",
  top_right_rotate: "nesw-rotate",
  mobile_rotate: "grabbing"
};
class gO extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
  }
  updateCursor() {
    const n = this.editor.getSelectedShapes(), i = nc[this.info.handle];
    this.editor.setCursor({
      type: i,
      rotation: n.length === 1 ? this.editor.getSelectionRotation() : 0
    });
  }
  onEnter(n) {
    this.info = n, this.updateCursor();
  }
  onPointerMove() {
    this.editor.inputs.isDragging && this.startResizing();
  }
  onLongPress() {
    this.startResizing();
  }
  startResizing() {
    this.editor.getIsReadonly() || this.parent.transition("resizing", this.info);
  }
  onPointerUp() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.cancel();
  }
  onInterrupt() {
    this.cancel();
  }
  complete() {
    this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, {}) : this.parent.transition("idle");
  }
  cancel() {
    this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, {}) : this.parent.transition("idle");
  }
}
S(gO, "id", "pointing_resize_handle");
const Fi = 8;
class xj extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
    S(this, "markId", "");
    S(this, "snapshot", {});
  }
  onEnter(n) {
    this.info = n, this.markId = this.editor.markHistoryStoppingPoint("cropping"), this.snapshot = this.createSnapshot(), this.updateShapes();
  }
  onPointerMove() {
    this.updateShapes();
  }
  onPointerUp() {
    this.complete();
  }
  onComplete() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  updateCursor() {
    if (!this.editor.getSelectedShapes()[0]) return;
    const i = nc[this.info.handle];
    this.editor.setCursor({ type: i, rotation: this.editor.getSelectionRotation() });
  }
  getDefaultCrop() {
    return {
      topLeft: { x: 0, y: 0 },
      bottomRight: { x: 1, y: 1 }
    };
  }
  updateShapes() {
    const { shape: n, cursorHandleOffset: i } = this.snapshot;
    if (!n || !this.editor.getShapeUtil("image")) return;
    const s = n.props, o = this.editor.inputs.currentPagePoint.clone().sub(i), a = this.editor.inputs.originPagePoint.clone().sub(i), c = o.clone().sub(a).rot(-n.rotation), d = s.crop ?? this.getDefaultCrop(), u = Ct(d), h = new x(n.x, n.y), g = new x(0, 0), p = 1 / (d.bottomRight.x - d.topLeft.x) * s.w, f = 1 / (d.bottomRight.y - d.topLeft.y) * s.h;
    let M = !1;
    switch (this.info.handle) {
      case "top":
      case "top_left":
      case "top_right": {
        if (f < Fi) break;
        M = !0, u.topLeft.y = u.topLeft.y + c.y / f, f * (u.bottomRight.y - u.topLeft.y) < Fi ? (u.topLeft.y = u.bottomRight.y - Fi / f, g.y = (u.topLeft.y - d.topLeft.y) * f) : u.topLeft.y <= 0 ? (u.topLeft.y = 0, g.y = (u.topLeft.y - d.topLeft.y) * f) : g.y = c.y;
        break;
      }
      case "bottom":
      case "bottom_left":
      case "bottom_right": {
        if (f < Fi) break;
        M = !0, u.bottomRight.y = Math.min(1, u.bottomRight.y + c.y / f), f * (u.bottomRight.y - u.topLeft.y) < Fi && (u.bottomRight.y = u.topLeft.y + Fi / f);
        break;
      }
    }
    switch (this.info.handle) {
      case "left":
      case "top_left":
      case "bottom_left": {
        if (p < Fi) break;
        M = !0, u.topLeft.x = u.topLeft.x + c.x / p, p * (u.bottomRight.x - u.topLeft.x) < Fi ? (u.topLeft.x = u.bottomRight.x - Fi / p, g.x = (u.topLeft.x - d.topLeft.x) * p) : u.topLeft.x <= 0 ? (u.topLeft.x = 0, g.x = (u.topLeft.x - d.topLeft.x) * p) : g.x = c.x;
        break;
      }
      case "right":
      case "top_right":
      case "bottom_right": {
        if (p < Fi) break;
        M = !0, u.bottomRight.x = Math.min(1, u.bottomRight.x + c.x / p), p * (u.bottomRight.x - u.topLeft.x) < Fi && (u.bottomRight.x = u.topLeft.x + Fi / p);
        break;
      }
    }
    if (!M) return;
    h.add(g.rot(n.rotation));
    const m = {
      id: n.id,
      type: n.type,
      x: h.x,
      y: h.y,
      props: {
        crop: u,
        w: (u.bottomRight.x - u.topLeft.x) * p,
        h: (u.bottomRight.y - u.topLeft.y) * f
      }
    };
    this.editor.updateShapes([m]), this.updateCursor();
  }
  complete() {
    this.updateShapes(), It(this.editor, [this.snapshot.shape.id]), this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, this.info) : (this.editor.setCroppingShape(null), this.editor.setCurrentTool("select.idle"));
  }
  cancel() {
    this.editor.bailToMark(this.markId), this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, this.info) : (this.editor.setCroppingShape(null), this.editor.setCurrentTool("select.idle"));
  }
  createSnapshot() {
    const n = this.editor.getSelectionRotation(), {
      inputs: { originPagePoint: i }
    } = this.editor, r = this.editor.getOnlySelectedShape(), s = this.editor.getSelectionRotatedPageBounds(), o = x.RotWith(
      s.getHandlePoint(this.info.handle),
      s.point,
      n
    ), a = x.Sub(i, o);
    return {
      shape: r,
      cursorHandleOffset: a
    };
  }
}
S(xj, "id", "cropping");
function pO(t, e = !1) {
  const n = t.getZoomLevel(), {
    inputs: { currentPagePoint: i }
  } = t;
  return (
    // hovered shape at point
    // selected shape at point
    t.getShapeAtPoint(i, {
      hitInside: !1,
      hitLabels: e,
      margin: t.options.hitTestMargin / n,
      renderingOnly: !0
    }) ?? t.getSelectedShapeAtPoint(i)
  );
}
function fO(t, e, n) {
  if (!e)
    throw Error("Needs to translate a cropped shape!");
  const { crop: i } = e.props;
  if (!i)
    return;
  const r = t.inputs.shiftKey ? Math.abs(n.x) < Math.abs(n.y) ? "x" : "y" : null;
  r === "x" ? n.x = 0 : r === "y" && (n.y = 0), n.rot(-e.rotation);
  const s = 1 / (i.bottomRight.x - i.topLeft.x) * e.props.w, o = 1 / (i.bottomRight.y - i.topLeft.y) * e.props.h, a = i.bottomRight.y - i.topLeft.y, c = i.bottomRight.x - i.topLeft.x, d = Ct(i);
  return d.topLeft.x = Math.min(1 - c, Math.max(0, d.topLeft.x - n.x / s)), d.topLeft.y = Math.min(1 - a, Math.max(0, d.topLeft.y - n.y / o)), d.bottomRight.x = d.topLeft.x + c, d.bottomRight.y = d.topLeft.y + a, {
    id: e.id,
    type: e.type,
    props: {
      crop: d
    }
  };
}
var Hm;
let Ase = (Hm = class extends ee {
  onEnter() {
    this.editor.setCursor({ type: "default", rotation: 0 });
    const e = this.editor.getOnlySelectedShape();
    e && this.editor.setCroppingShape(e.id);
  }
  onExit() {
    this.editor.setCursor({ type: "default", rotation: 0 });
  }
  onCancel() {
    this.editor.setCroppingShape(null), this.editor.setCurrentTool("select.idle", {});
  }
  onPointerDown(e) {
    var n;
    if (e.accelKey) {
      this.cancel(), this.editor.root.handleEvent(e);
      return;
    }
    switch (e.target) {
      case "canvas": {
        const i = pO(this.editor);
        if (i && !this.editor.isShapeOfType(i, "group")) {
          this.onPointerDown({
            ...e,
            shape: i,
            target: "shape"
          });
          return;
        }
        this.cancel(), this.editor.root.handleEvent(e);
        break;
      }
      case "shape": {
        if (e.shape.id === this.editor.getCroppingShapeId()) {
          this.editor.setCurrentTool("select.crop.pointing_crop", e);
          return;
        } else
          (n = this.editor.getShapeUtil(e.shape)) != null && n.canCrop(e.shape) ? (this.editor.setCroppingShape(e.shape.id), this.editor.setSelectedShapes([e.shape.id]), this.editor.setCurrentTool("select.crop.pointing_crop", e)) : (this.cancel(), this.editor.root.handleEvent(e));
        break;
      }
      case "selection": {
        switch (e.handle) {
          case "mobile_rotate":
          case "top_left_rotate":
          case "top_right_rotate":
          case "bottom_left_rotate":
          case "bottom_right_rotate": {
            this.editor.setCurrentTool("select.pointing_rotate_handle", {
              ...e,
              onInteractionEnd: "select.crop.idle"
            });
            break;
          }
          case "top":
          case "right":
          case "bottom":
          case "left":
          case "top_left":
          case "top_right":
          case "bottom_left":
          case "bottom_right": {
            this.editor.setCurrentTool("select.crop.pointing_crop_handle", {
              ...e,
              onInteractionEnd: "select.crop.idle"
            });
            break;
          }
          default:
            this.cancel();
        }
        break;
      }
    }
  }
  onDoubleClick(e) {
    var s;
    if (this.editor.inputs.shiftKey || e.phase !== "up") return;
    const n = this.editor.getCroppingShapeId();
    if (!n) return;
    const i = this.editor.getShape(n);
    if (!i) return;
    const r = this.editor.getShapeUtil(i);
    if (r) {
      if (e.target === "selection") {
        (s = r.onDoubleClickEdge) == null || s.call(r, i);
        return;
      }
      this.cancel(), this.editor.root.handleEvent(e);
    }
  }
  onKeyDown() {
    this.nudgeCroppingImage(!1);
  }
  onKeyRepeat() {
    this.nudgeCroppingImage(!0);
  }
  onKeyUp(e) {
    switch (e.code) {
      case "Enter": {
        this.editor.setCroppingShape(null), this.editor.setCurrentTool("select.idle", {});
        break;
      }
    }
  }
  cancel() {
    this.editor.setCroppingShape(null), this.editor.setCurrentTool("select.idle", {});
  }
  nudgeCroppingImage(e = !1) {
    const {
      editor: {
        inputs: { keys: n }
      }
    } = this, i = n.has("ShiftLeft"), r = new x(0, 0);
    if (n.has("ArrowLeft") && (r.x += 1), n.has("ArrowRight") && (r.x -= 1), n.has("ArrowUp") && (r.y += 1), n.has("ArrowDown") && (r.y -= 1), r.equals(new x(0, 0))) return;
    i && r.mul(10);
    const s = this.editor.getShape(this.editor.getCroppingShapeId());
    if (!s) return;
    const o = fO(this.editor, s, r);
    o && (e || this.editor.markHistoryStoppingPoint("translate crop"), this.editor.updateShapes([o]));
  }
}, S(Hm, "id", "idle"), Hm);
class MO extends ee {
  onCancel() {
    this.editor.setCurrentTool("select.crop.idle", {});
  }
  onPointerMove(e) {
    this.editor.inputs.isDragging && this.editor.setCurrentTool("select.crop.translating_crop", e);
  }
  onPointerUp(e) {
    this.editor.setCurrentTool("select.crop.idle", e);
  }
}
S(MO, "id", "pointing_crop");
class Sj extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
  }
  onEnter(n) {
    this.info = n, this.parent.setCurrentToolIdMask(n.onInteractionEnd);
    const i = this.editor.getSelectedShapes()[0];
    if (!i) return;
    const r = nc[this.info.handle];
    this.editor.setCursor({ type: r, rotation: this.editor.getSelectionRotation() }), this.editor.setCroppingShape(i.id);
  }
  onExit() {
    this.editor.setCursor({ type: "default", rotation: 0 }), this.parent.setCurrentToolIdMask(void 0);
  }
  onPointerMove() {
    this.editor.inputs.isDragging && this.startCropping();
  }
  onLongPress() {
    this.startCropping();
  }
  startCropping() {
    this.editor.getIsReadonly() || this.parent.transition("cropping", {
      ...this.info,
      onInteractionEnd: this.info.onInteractionEnd
    });
  }
  onPointerUp() {
    this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, this.info) : (this.editor.setCroppingShape(null), this.editor.setCurrentTool("select.idle"));
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.cancel();
  }
  onInterrupt() {
    this.cancel();
  }
  cancel() {
    this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, this.info) : (this.editor.setCroppingShape(null), this.editor.setCurrentTool("select.idle"));
  }
}
S(Sj, "id", "pointing_crop_handle");
class mO extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
    S(this, "markId", "");
    S(this, "snapshot", {});
  }
  onEnter(n) {
    this.info = n, this.snapshot = this.createSnapshot(), this.markId = this.editor.markHistoryStoppingPoint("translating_crop"), this.editor.setCursor({ type: "move", rotation: 0 }), this.updateShapes();
  }
  onExit() {
    this.editor.setCursor({ type: "default", rotation: 0 });
  }
  onPointerMove() {
    this.updateShapes();
  }
  onPointerUp() {
    this.complete();
  }
  onComplete() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  onKeyDown(n) {
    switch (n.key) {
      case "Alt":
      case "Shift": {
        this.updateShapes();
        return;
      }
    }
  }
  onKeyUp(n) {
    switch (n.key) {
      case "Enter": {
        this.complete();
        return;
      }
      case "Alt":
      case "Shift":
        this.updateShapes();
    }
  }
  complete() {
    this.updateShapes(), this.editor.setCurrentTool("select.crop.idle", this.info);
  }
  cancel() {
    this.editor.bailToMark(this.markId), this.editor.setCurrentTool("select.crop.idle", this.info);
  }
  createSnapshot() {
    return { shape: this.editor.getOnlySelectedShape() };
  }
  updateShapes() {
    const n = this.snapshot.shape;
    if (!n) return;
    const { originPagePoint: i, currentPagePoint: r } = this.editor.inputs, s = r.clone().sub(i), o = fO(this.editor, n, s);
    o && this.editor.updateShapes([o]);
  }
}
S(mO, "id", "translating_crop");
class UI extends ee {
  constructor() {
    super(...arguments);
    S(this, "markId", "");
    S(this, "didExit", !1);
  }
  static children() {
    return [Ase, mO, MO, Sj, xj];
  }
  onEnter() {
    this.didExit = !1, this.markId = this.editor.markHistoryStoppingPoint("crop");
  }
  onExit() {
    this.didExit || (this.didExit = !0, this.editor.squashToMark(this.markId));
  }
  onCancel() {
    this.didExit || (this.didExit = !0, this.editor.bailToMark(this.markId));
  }
}
S(UI, "id", "crop"), S(UI, "initial", "idle");
class yO extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeId", "");
    S(this, "initialHandle", {});
    S(this, "initialAdjacentHandle", null);
    S(this, "initialPagePoint", {});
    S(this, "markId", "");
    S(this, "initialPageTransform");
    S(this, "initialPageRotation");
    S(this, "info", {});
    S(this, "isPrecise", !1);
    S(this, "isPreciseId", null);
    S(this, "pointingId", null);
    // Only relevant to arrows
    S(this, "exactTimeout", -1);
  }
  onEnter(n) {
    const { shape: i, isCreating: r, creatingMarkId: s, handle: o } = n;
    if (this.info = n, this.parent.setCurrentToolIdMask(n.onInteractionEnd), this.shapeId = i.id, this.markId = "", r)
      if (s)
        this.markId = s;
      else {
        const d = this.editor.getMarkIdMatching(
          `creating:${this.editor.getOnlySelectedShapeId()}`
        );
        d && (this.markId = d);
      }
    else
      this.markId = this.editor.markHistoryStoppingPoint("dragging handle");
    if (this.initialHandle = Ct(o), this.editor.isShapeOfType(i, "line") && this.initialHandle.type === "create") {
      this.editor.updateShape({
        ...i,
        props: {
          points: {
            ...i.props.points,
            [o.index]: { id: o.index, index: o.index, x: o.x, y: o.y }
          }
        }
      });
      const u = this.editor.getShapeHandles(i).find((h) => h.index === o.index);
      this.initialHandle = Ct(u);
    }
    this.initialPageTransform = this.editor.getShapePageTransform(i), this.initialPageRotation = this.initialPageTransform.rotation(), this.initialPagePoint = this.editor.inputs.originPagePoint.clone(), this.editor.setCursor({ type: r ? "cross" : "grabbing", rotation: 0 });
    const a = this.editor.getShapeHandles(i).sort(Jt), c = a.findIndex((d) => d.id === n.handle.id);
    this.initialAdjacentHandle = null;
    for (let d = c + 1; d < a.length; d++) {
      const u = a[d];
      if (u.type === "vertex" && u.id !== "middle" && u.id !== n.handle.id) {
        this.initialAdjacentHandle = u;
        break;
      }
    }
    if (!this.initialAdjacentHandle)
      for (let d = a.length - 1; d >= 0; d--) {
        const u = a[d];
        if (u.type === "vertex" && u.id !== "middle" && u.id !== n.handle.id) {
          this.initialAdjacentHandle = u;
          break;
        }
      }
    if (this.editor.isShapeOfType(i, "arrow")) {
      const d = li(this.editor, i)[n.handle.id];
      this.isPrecise = !1, d ? (this.editor.setHintingShapes([d.toId]), this.isPrecise = d.props.isPrecise, this.isPrecise ? this.isPreciseId = d.toId : this.resetExactTimeout()) : this.editor.setHintingShapes([]);
    }
    this.update(), this.editor.select(this.shapeId);
  }
  // Only relevant to arrows
  resetExactTimeout() {
    this.exactTimeout !== -1 && this.clearExactTimeout(), this.exactTimeout = this.editor.timers.setTimeout(() => {
      this.getIsActive() && !this.isPrecise && (this.isPrecise = !0, this.isPreciseId = this.pointingId, this.update()), this.exactTimeout = -1;
    }, 750);
  }
  // Only relevant to arrows
  clearExactTimeout() {
    this.exactTimeout !== -1 && (clearTimeout(this.exactTimeout), this.exactTimeout = -1);
  }
  onPointerMove() {
    this.update();
  }
  onKeyDown() {
    this.update();
  }
  onKeyUp() {
    this.update();
  }
  onPointerUp() {
    this.complete();
  }
  onComplete() {
    this.update(), this.complete();
  }
  onCancel() {
    this.cancel();
  }
  onExit() {
    this.parent.setCurrentToolIdMask(void 0), this.editor.setHintingShapes([]), this.editor.snaps.clearIndicators(), this.editor.setCursor({ type: "default", rotation: 0 });
  }
  complete() {
    this.editor.snaps.clearIndicators(), It(this.editor, [this.shapeId]);
    const { onInteractionEnd: n } = this.info;
    if (this.editor.getInstanceState().isToolLocked && n) {
      this.editor.setCurrentTool(n, { shapeId: this.shapeId });
      return;
    }
    this.parent.transition("idle");
  }
  cancel() {
    this.editor.bailToMark(this.markId), this.editor.snaps.clearIndicators();
    const { onInteractionEnd: n } = this.info;
    if (n) {
      this.editor.setCurrentTool(n, { shapeId: this.shapeId });
      return;
    }
    this.parent.transition("idle");
  }
  update() {
    var b;
    const { editor: n, shapeId: i, initialPagePoint: r } = this, { initialHandle: s, initialPageRotation: o, initialAdjacentHandle: a } = this, c = this.editor.getHintingShapeIds(), d = this.editor.user.getIsSnapMode(), {
      snaps: u,
      inputs: { currentPagePoint: h, shiftKey: g, ctrlKey: p, altKey: f, pointerVelocity: M }
    } = n, m = this.info.shape, y = n.getShape(i);
    if (!y) return;
    const I = n.getShapeUtil(y);
    let D = h.clone().sub(r).rot(-o).add(s);
    if (g && a && s.id !== "middle") {
      const T = x.Angle(a, D), v = vg(T, 24) - T;
      D = x.RotWith(D, a, v);
    }
    n.snaps.clearIndicators();
    let j = { ...s, x: D.x, y: D.y };
    if (s.canSnap && (d ? !p : p)) {
      if (!n.getShapePageTransform(y.id)) throw Error("Expected a page transform");
      const E = u.handles.snapHandle({ currentShapeId: i, handle: j });
      E && (E.nudge.rot(-n.getShapeParentTransform(y).rotation()), D.add(E.nudge), j = { ...s, x: D.x, y: D.y });
    }
    const w = (b = I.onHandleDrag) == null ? void 0 : b.call(I, y, {
      handle: j,
      isPrecise: this.isPrecise || f,
      initial: m
    }), A = { id: y.id, type: y.type, ...w };
    if (s.type === "vertex" && this.editor.isShapeOfType(y, "arrow")) {
      const T = li(n, y)[s.id];
      T ? c[0] !== T.toId && (n.setHintingShapes([T.toId]), this.pointingId = T.toId, this.isPrecise = M.len() < 0.5 || f, this.isPreciseId = this.isPrecise ? T.toId : null, this.resetExactTimeout()) : c.length > 0 && (n.setHintingShapes([]), this.pointingId = null, this.isPrecise = !1, this.isPreciseId = null, this.resetExactTimeout());
    }
    w && n.updateShapes([A]);
  }
}
S(yO, "id", "dragging_handle");
function IO(t) {
  return t.isLabel ? [t] : t instanceof Ki ? t.children.filter((e) => e.isLabel) : [];
}
class xO extends ee {
  constructor() {
    super(...arguments);
    S(this, "hitShapeForPointerUp", null);
    S(this, "info", {});
  }
  onEnter(n) {
    const i = this.editor.getEditingShape();
    if (!i) throw Error("Entered editing state without an editing shape");
    this.hitShapeForPointerUp = null, this.info = n, n.isCreatingTextWhileToolLocked && this.parent.setCurrentToolIdMask("text"), ds(this.editor), this.editor.select(i);
  }
  onExit() {
    var s;
    const { editingShapeId: n } = this.editor.getCurrentPageState();
    if (!n) return;
    this.editor.setEditingShape(null), ds.cancel();
    const i = this.editor.getShape(n), r = this.editor.getShapeUtil(i);
    (s = r.onEditEnd) == null || s.call(r, i), this.info.isCreatingTextWhileToolLocked && (this.parent.setCurrentToolIdMask(void 0), this.editor.setCurrentTool("text", {}));
  }
  onPointerMove(n) {
    if (this.hitShapeForPointerUp && this.editor.inputs.isDragging) {
      if (this.editor.getIsReadonly() || this.hitShapeForPointerUp.isLocked) return;
      this.editor.select(this.hitShapeForPointerUp), this.parent.transition("translating", n), this.hitShapeForPointerUp = null;
      return;
    }
    switch (n.target) {
      case "shape":
      case "canvas": {
        ds(this.editor);
        return;
      }
    }
  }
  onPointerDown(n) {
    switch (this.hitShapeForPointerUp = null, n.target) {
      case "shape": {
        const { shape: i } = n, r = this.editor.getEditingShape();
        if (!r)
          throw Error("Expected an editing shape!");
        const s = this.editor.getShapeUtil(i).getGeometry(i), o = IO(s), a = o.length === 1 ? o[0] : void 0, c = this.editor.isShapeOfType(r, "text") && r.props.text.trim() === "";
        if (a && !c) {
          const d = this.editor.getPointInShapeSpace(
            i,
            this.editor.inputs.currentPagePoint
          );
          if (a.bounds.containsPoint(d, 0) && a.hitTestPoint(d)) {
            if (i.id === r.id)
              return;
            this.hitShapeForPointerUp = i, this.editor.markHistoryStoppingPoint("editing on pointer up"), this.editor.select(i.id);
            return;
          }
        } else {
          if (i.id === r.id)
            this.editor.isShapeOfType(i, "frame") && (this.editor.setEditingShape(null), this.parent.transition("idle", n));
          else {
            this.parent.transition("pointing_shape", n);
            return;
          }
          return;
        }
        break;
      }
    }
    this.parent.transition("idle", n), this.editor.root.handleEvent(n);
  }
  onPointerUp(n) {
    const i = this.hitShapeForPointerUp;
    if (!i) return;
    this.hitShapeForPointerUp = null;
    const r = this.editor.getShapeUtil(i);
    if (!i.isLocked) {
      if (this.editor.getIsReadonly() && !r.canEditInReadOnly(i)) {
        this.parent.transition("pointing_shape", n);
        return;
      }
      this.editor.select(i.id), this.editor.setEditingShape(i.id), ds(this.editor);
    }
  }
  onComplete(n) {
    this.parent.transition("idle", n);
  }
  onCancel(n) {
    this.parent.transition("idle", n);
  }
}
S(xO, "id", "editing_shape");
function UN(t) {
  const e = t.getOnlySelectedShape();
  return !!(e && !t.isShapeOrAncestorLocked(e) && t.getShapeUtil(e).canCrop(e));
}
function _g(t, e) {
  const n = t.getSelectedShapeIds(), { currentPagePoint: i } = t.inputs, { shiftKey: r, altKey: s, accelKey: o } = e, a = r || o, c = t.getShapeAtPoint(i, {
    hitInside: !1,
    margin: t.options.hitTestMargin / t.getZoomLevel(),
    hitLabels: !0,
    renderingOnly: !0,
    filter: (d) => !d.isLocked
  });
  if (c) {
    const d = t.getOutermostSelectableShape(c);
    if (a && !s)
      t.cancelDoubleClick(), n.includes(d.id) ? (t.markHistoryStoppingPoint("deselecting shape"), t.deselect(d)) : (t.markHistoryStoppingPoint("shift selecting shape"), t.setSelectedShapes([...n, d.id]));
    else {
      let u;
      d === c || d.id === t.getFocusedGroupId() || n.includes(d.id) ? u = c : u = d, u && !n.includes(u.id) && (t.markHistoryStoppingPoint("selecting shape"), t.select(u.id));
    }
  } else {
    if (a)
      return;
    {
      n.length > 0 && (t.markHistoryStoppingPoint("selecting none"), t.selectNone());
      const d = t.getFocusedGroupId();
      if (si(d)) {
        const u = t.getShape(d);
        t.isPointInShape(u, i, { margin: 0, hitInside: !0 }) || t.setFocusedGroup(null);
      }
    }
  }
}
const Tse = [
  "Delete",
  "Backspace",
  "[",
  "]",
  "Enter",
  " ",
  "Shift",
  "Tab"
];
var Vm;
let bse = (Vm = class extends ee {
  onEnter() {
    this.parent.setCurrentToolIdMask(void 0), ds(this.editor), this.editor.setCursor({ type: "default", rotation: 0 });
  }
  onExit() {
    ds.cancel();
  }
  onPointerMove() {
    ds(this.editor);
  }
  onPointerDown(e) {
    const n = e.ctrlKey && UN(this.editor);
    switch (e.target) {
      case "canvas": {
        const i = pO(this.editor);
        if (i && !i.isLocked) {
          this.onPointerDown({
            ...e,
            shape: i,
            target: "shape"
          });
          return;
        }
        const r = this.editor.getSelectedShapeIds(), s = this.editor.getOnlySelectedShape(), {
          inputs: { currentPagePoint: o }
        } = this.editor;
        if ((r.length > 1 || s && !this.editor.getShapeUtil(s).hideSelectionBoundsBg(s)) && RN(this.editor, o)) {
          this.onPointerDown({
            ...e,
            target: "selection"
          });
          return;
        }
        this.parent.transition("pointing_canvas", e);
        break;
      }
      case "shape": {
        const { shape: i } = e;
        if (this.isOverArrowLabelTest(i)) {
          this.parent.transition("pointing_arrow_label", e);
          break;
        }
        if (this.editor.isShapeOrAncestorLocked(i)) {
          this.parent.transition("pointing_canvas", e);
          break;
        }
        this.parent.transition("pointing_shape", e);
        break;
      }
      case "handle": {
        if (this.editor.getIsReadonly()) break;
        this.editor.inputs.altKey ? this.parent.transition("pointing_shape", e) : this.parent.transition("pointing_handle", e);
        break;
      }
      case "selection": {
        switch (e.handle) {
          case "mobile_rotate":
          case "top_left_rotate":
          case "top_right_rotate":
          case "bottom_left_rotate":
          case "bottom_right_rotate": {
            if (n)
              this.parent.transition("crop.pointing_crop_handle", e);
            else {
              if (e.accelKey) {
                this.parent.transition("brushing", e);
                break;
              }
              this.parent.transition("pointing_rotate_handle", e);
            }
            break;
          }
          case "top":
          case "right":
          case "bottom":
          case "left":
          case "top_left":
          case "top_right":
          case "bottom_left":
          case "bottom_right": {
            if (n)
              this.parent.transition("crop.pointing_crop_handle", e);
            else {
              if (e.accelKey) {
                this.parent.transition("brushing", e);
                break;
              }
              this.parent.transition("pointing_resize_handle", e);
            }
            break;
          }
          default: {
            const i = this.editor.getHoveredShape();
            if (i && !this.editor.getSelectedShapeIds().includes(i.id) && !i.isLocked) {
              this.onPointerDown({
                ...e,
                shape: i,
                target: "shape"
              });
              return;
            }
            this.parent.transition("pointing_selection", e);
          }
        }
        break;
      }
    }
  }
  onDoubleClick(e) {
    var n, i, r, s;
    if (!(this.editor.inputs.shiftKey || e.phase !== "up") && !(e.ctrlKey || e.shiftKey))
      switch (e.target) {
        case "canvas": {
          const o = this.editor.getHoveredShape(), a = o && !this.editor.isShapeOfType(o, "group") ? o : this.editor.getSelectedShapeAtPoint(this.editor.inputs.currentPagePoint) ?? this.editor.getShapeAtPoint(this.editor.inputs.currentPagePoint, {
            margin: this.editor.options.hitTestMargin / this.editor.getZoomLevel(),
            hitInside: !1
          }), c = this.editor.getFocusedGroupId();
          if (a) {
            if (this.editor.isShapeOfType(a, "group")) {
              _g(this.editor, e);
              return;
            } else {
              const d = this.editor.getShape(a.parentId);
              if (d && this.editor.isShapeOfType(d, "group") && !(c && d.id === c)) {
                _g(this.editor, e);
                return;
              }
            }
            this.onDoubleClick({
              ...e,
              shape: a,
              target: "shape"
            });
            return;
          }
          this.editor.inputs.shiftKey || this.handleDoubleClickOnCanvas(e);
          break;
        }
        case "selection": {
          if (this.editor.getIsReadonly()) break;
          const o = this.editor.getOnlySelectedShape();
          if (o) {
            const a = this.editor.getShapeUtil(o);
            if (!this.canInteractWithShapeInReadOnly(o))
              return;
            if (e.handle === "right" || e.handle === "left" || e.handle === "top" || e.handle === "bottom") {
              const c = (n = a.onDoubleClickEdge) == null ? void 0 : n.call(a, o);
              if (c) {
                this.editor.markHistoryStoppingPoint("double click edge"), this.editor.updateShapes([c]), It(this.editor, [o.id]);
                return;
              }
            }
            if (a.canCrop(o) && !this.editor.isShapeOrAncestorLocked(o)) {
              this.parent.transition("crop", e);
              return;
            }
            this.shouldStartEditingShape(o) && this.startEditingShape(
              o,
              e,
              !0
              /* select all */
            );
          }
          break;
        }
        case "shape": {
          const { shape: o } = e, a = this.editor.getShapeUtil(o);
          if (o.type !== "video" && o.type !== "embed" && this.editor.getIsReadonly()) break;
          if (a.onDoubleClick) {
            const c = (i = a.onDoubleClick) == null ? void 0 : i.call(a, o);
            if (c) {
              this.editor.updateShapes([c]);
              return;
            }
          }
          if (a.canCrop(o) && !this.editor.isShapeOrAncestorLocked(o)) {
            this.editor.markHistoryStoppingPoint("select and crop"), this.editor.select((r = e.shape) == null ? void 0 : r.id), this.parent.transition("crop", e);
            return;
          }
          this.shouldStartEditingShape(o) ? this.startEditingShape(
            o,
            e,
            !0
            /* select all */
          ) : this.handleDoubleClickOnCanvas(e);
          break;
        }
        case "handle": {
          if (this.editor.getIsReadonly()) break;
          const { shape: o, handle: a } = e, c = this.editor.getShapeUtil(o), d = (s = c.onDoubleClickHandle) == null ? void 0 : s.call(c, o, a);
          d ? this.editor.updateShapes([d]) : this.shouldStartEditingShape(o) && this.startEditingShape(
            o,
            e,
            !0
            /* select all */
          );
        }
      }
  }
  onRightClick(e) {
    switch (e.target) {
      case "canvas": {
        const n = this.editor.getHoveredShape(), i = n && !this.editor.isShapeOfType(n, "group") ? n : this.editor.getShapeAtPoint(this.editor.inputs.currentPagePoint, {
          margin: this.editor.options.hitTestMargin / this.editor.getZoomLevel(),
          hitInside: !1,
          hitLabels: !0,
          hitLocked: !0,
          hitFrameInside: !1,
          renderingOnly: !0
        });
        if (i) {
          this.onRightClick({
            ...e,
            shape: i,
            target: "shape"
          });
          return;
        }
        const r = this.editor.getSelectedShapeIds(), s = this.editor.getOnlySelectedShape(), {
          inputs: { currentPagePoint: o }
        } = this.editor;
        if ((r.length > 1 || s && !this.editor.getShapeUtil(s).hideSelectionBoundsBg(s)) && RN(this.editor, o)) {
          this.onRightClick({
            ...e,
            target: "selection"
          });
          return;
        }
        this.editor.selectNone();
        break;
      }
      case "shape": {
        const { selectedShapeIds: n } = this.editor.getCurrentPageState(), { shape: i } = e, r = this.editor.getOutermostSelectableShape(
          i,
          (s) => !n.includes(s.id)
        );
        !n.includes(r.id) && !this.editor.findShapeAncestor(
          r,
          (s) => n.includes(s.id)
        ) && (this.editor.markHistoryStoppingPoint("selecting shape"), this.editor.setSelectedShapes([r.id]));
        break;
      }
    }
  }
  onCancel() {
    this.editor.getFocusedGroupId() !== this.editor.getCurrentPageId() && this.editor.getSelectedShapeIds().length > 0 ? this.editor.popFocusedGroupId() : (this.editor.markHistoryStoppingPoint("clearing selection"), this.editor.selectNone());
  }
  onKeyDown(e) {
    switch (e.code) {
      case "ArrowLeft":
      case "ArrowRight":
      case "ArrowUp":
      case "ArrowDown": {
        this.nudgeSelectedShapes(!1);
        return;
      }
    }
    if (Wt.editOnType.get() && !Tse.includes(e.key) && !e.altKey && !e.ctrlKey) {
      const n = this.editor.getOnlySelectedShape();
      if (n && // If it's a note shape, then edit on type
      this.editor.isShapeOfType(n, "note") && // If it's not locked or anything
      this.shouldStartEditingShape(n)) {
        this.startEditingShape(
          n,
          {
            ...e,
            target: "shape",
            shape: n
          },
          !0
          /* select all */
        );
        return;
      }
    }
  }
  onKeyRepeat(e) {
    switch (e.code) {
      case "ArrowLeft":
      case "ArrowRight":
      case "ArrowUp":
      case "ArrowDown": {
        this.nudgeSelectedShapes(!0);
        break;
      }
    }
  }
  onKeyUp(e) {
    switch (e.code) {
      case "Enter": {
        const n = this.editor.getSelectedShapes();
        if (n.every((r) => this.editor.isShapeOfType(r, "group"))) {
          this.editor.setSelectedShapes(
            n.flatMap((r) => this.editor.getSortedChildIdsForParent(r.id))
          );
          return;
        }
        const i = this.editor.getOnlySelectedShape();
        if (i && this.shouldStartEditingShape(i)) {
          this.startEditingShape(
            i,
            {
              ...e,
              target: "shape",
              shape: i
            },
            !0
            /* select all */
          );
          return;
        }
        UN(this.editor) && this.parent.transition("crop", e);
        break;
      }
    }
  }
  shouldStartEditingShape(e = this.editor.getOnlySelectedShape()) {
    return !e || this.editor.isShapeOrAncestorLocked(e) && e.type !== "embed" || !this.canInteractWithShapeInReadOnly(e) ? !1 : this.editor.getShapeUtil(e).canEdit(e);
  }
  startEditingShape(e, n, i) {
    this.editor.isShapeOrAncestorLocked(e) && e.type !== "embed" || (this.editor.markHistoryStoppingPoint("editing shape"), Pg(this.editor, e, i), this.parent.transition("editing_shape", n));
  }
  isOverArrowLabelTest(e) {
    if (!e) return !1;
    const n = this.editor.getPointInShapeSpace(
      e,
      this.editor.inputs.currentPagePoint
    );
    if (this.editor.isShapeOfType(e, "arrow")) {
      const i = this.editor.getShapeGeometry(e).children[1];
      if (i && yi(n, i.vertices))
        return !0;
    }
    return !1;
  }
  handleDoubleClickOnCanvas(e) {
    if (this.editor.getIsReadonly()) return;
    this.editor.markHistoryStoppingPoint("creating text shape");
    const n = Ee(), { x: i, y: r } = this.editor.inputs.currentPagePoint;
    this.editor.createShapes([
      {
        id: n,
        type: "text",
        x: i,
        y: r,
        props: {
          text: "",
          autoSize: !0
        }
      }
    ]);
    const s = this.editor.getShape(n);
    if (!s) return;
    const o = this.editor.getShapeUtil(s);
    this.editor.getIsReadonly() && !o.canEditInReadOnly(s) || (this.editor.setEditingShape(n), this.editor.select(n), this.parent.transition("editing_shape", e));
  }
  nudgeSelectedShapes(e = !1) {
    const {
      editor: {
        inputs: { keys: n }
      }
    } = this, i = n.has("ShiftLeft"), r = new x(0, 0);
    if (n.has("ArrowLeft") && (r.x -= 1), n.has("ArrowRight") && (r.x += 1), n.has("ArrowUp") && (r.y -= 1), n.has("ArrowDown") && (r.y += 1), r.equals(new x(0, 0))) return;
    e || this.editor.markHistoryStoppingPoint("nudge shapes");
    const { gridSize: s } = this.editor.getDocumentSettings(), o = this.editor.getInstanceState().isGridMode ? i ? s * Cse : s : i ? vse : Ese, a = this.editor.getSelectedShapeIds();
    this.editor.nudgeShapes(a, r.mul(o)), It(this.editor, a);
  }
  canInteractWithShapeInReadOnly(e) {
    return !!(!this.editor.getIsReadonly() || this.editor.getShapeUtil(e).canEditInReadOnly(e));
  }
}, S(Vm, "id", "idle"), Vm);
const vse = 10, Ese = 1, Cse = 5;
function RN(t, e) {
  const n = t.getSelectionRotatedPageBounds();
  if (!n) return !1;
  const i = t.getSelectionRotation();
  return i ? yi(
    e,
    n.corners.map((r) => x.RotWith(r, n.point, i))
  ) : n.containsPoint(e);
}
class SO extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeId", "");
    S(this, "markId", "");
    S(this, "wasAlreadySelected", !1);
    S(this, "didDrag", !1);
    S(this, "didCtrlOnEnter", !1);
    S(this, "info", {});
    S(this, "_labelDragOffset", new x(0, 0));
  }
  updateCursor() {
    this.editor.setCursor({ type: "grabbing", rotation: 0 });
  }
  onEnter(n) {
    const { shape: i } = n;
    this.parent.setCurrentToolIdMask(n.onInteractionEnd), this.info = n, this.shapeId = i.id, this.didDrag = !1, this.didCtrlOnEnter = n.accelKey, this.wasAlreadySelected = this.editor.getOnlySelectedShapeId() === i.id, this.updateCursor();
    const s = this.editor.getShapeGeometry(i).children[1];
    if (!s)
      throw Error(`Expected to find an arrow label geometry for shape: ${i.id}`);
    const { currentPagePoint: o } = this.editor.inputs, a = this.editor.getPointInShapeSpace(i, o);
    this._labelDragOffset = x.Sub(s.center, a), this.markId = this.editor.markHistoryStoppingPoint("label-drag start"), this.editor.setSelectedShapes([this.shapeId]);
  }
  onExit() {
    this.parent.setCurrentToolIdMask(void 0), this.editor.setCursor({ type: "default", rotation: 0 });
  }
  onPointerMove() {
    const { isDragging: n } = this.editor.inputs;
    if (!n) return;
    if (this.didCtrlOnEnter) {
      this.parent.transition("brushing", this.info);
      return;
    }
    const i = this.editor.getShape(this.shapeId);
    if (!i) return;
    const r = Pr(this.editor, i), s = this.editor.getShapeGeometry(i), o = s.children[0], a = this.editor.getPointInShapeSpace(
      i,
      this.editor.inputs.currentPagePoint
    ), c = o.nearestPoint(
      x.Add(a, this._labelDragOffset)
    );
    let d;
    if (r.isStraight) {
      const u = x.Dist(r.start.point, r.end.point);
      d = 1 - x.Dist(r.end.point, c) / u;
    } else {
      const { _center: u, measure: h, angleEnd: g, angleStart: p } = s.children[0];
      d = Fy(h, p, g, u.angle(c));
    }
    isNaN(d) && (d = 0.5), this.didDrag = !0, this.editor.updateShape({
      id: i.id,
      type: i.type,
      props: { labelPosition: d }
    });
  }
  onPointerUp() {
    const n = this.editor.getShape(this.shapeId);
    n && (this.didDrag || !this.wasAlreadySelected ? this.complete() : this.editor.getIsReadonly() || (this.editor.setEditingShape(n.id), this.editor.setCurrentTool("select.editing_shape")));
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.cancel();
  }
  onInterrupt() {
    this.cancel();
  }
  complete() {
    this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, {}) : this.parent.transition("idle");
  }
  cancel() {
    this.editor.bailToMark(this.markId), this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, {}) : this.parent.transition("idle");
  }
}
S(SO, "id", "pointing_arrow_label");
class jO extends ee {
  onEnter(e) {
    e.shiftKey || e.accelKey || this.editor.getSelectedShapeIds().length > 0 && (this.editor.markHistoryStoppingPoint("selecting none"), this.editor.selectNone());
  }
  onPointerMove(e) {
    this.editor.inputs.isDragging && this.parent.transition("brushing", e);
  }
  onPointerUp(e) {
    _g(this.editor, e), this.complete();
  }
  onComplete() {
    this.complete();
  }
  onInterrupt() {
    this.parent.transition("idle");
  }
  complete() {
    this.parent.transition("idle");
  }
}
S(jO, "id", "pointing_canvas");
class DO extends ee {
  constructor() {
    super(...arguments);
    S(this, "didCtrlOnEnter", !1);
    S(this, "info", {});
  }
  onEnter(n) {
    this.info = n, this.didCtrlOnEnter = n.accelKey;
    const { shape: i } = n;
    if (this.editor.isShapeOfType(i, "arrow")) {
      const r = li(this.editor, i)[n.handle.id];
      r && this.editor.setHintingShapes([r.toId]);
    }
    this.editor.setCursor({ type: "grabbing", rotation: 0 });
  }
  onExit() {
    this.editor.setHintingShapes([]), this.editor.setCursor({ type: "default", rotation: 0 });
  }
  onPointerUp() {
    const { shape: n, handle: i } = this.info;
    if (this.editor.isShapeOfType(n, "note")) {
      const { editor: r } = this, s = YN(r, n, i, !1);
      if (s) {
        Pg(
          r,
          s,
          !0
          /* selectAll */
        );
        return;
      }
    }
    this.parent.transition("idle", this.info);
  }
  onPointerMove(n) {
    const { editor: i } = this;
    i.inputs.isDragging && (this.didCtrlOnEnter ? this.parent.transition("brushing", n) : this.startDraggingHandle());
  }
  onLongPress() {
    this.startDraggingHandle();
  }
  startDraggingHandle() {
    const { editor: n } = this;
    if (n.getIsReadonly()) return;
    const { shape: i, handle: r } = this.info;
    if (n.isShapeOfType(i, "note")) {
      const s = YN(n, i, r, !0);
      if (s) {
        const o = n.getPointInParentSpace(s, n.inputs.originPagePoint).sub(x.Rot(pf.clone().mul(i.props.scale), s.rotation));
        n.updateShape({ ...s, x: o.x, y: o.y }), n.setHoveredShape(s.id).select(s.id).setCurrentTool("select.translating", {
          ...this.info,
          target: "shape",
          shape: n.getShape(s),
          onInteractionEnd: "note",
          isCreating: !0,
          onCreate: () => {
            Pg(
              n,
              s,
              !0
              /* selectAll */
            );
          }
        });
        return;
      }
    }
    this.parent.transition("dragging_handle", this.info);
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.cancel();
  }
  onInterrupt() {
    this.cancel();
  }
  cancel() {
    this.parent.transition("idle");
  }
}
S(DO, "id", "pointing_handle");
function YN(t, e, n, i) {
  const r = t.getShapePageTransform(e.id), s = r.point(), o = r.rotation(), c = Pk(
    t,
    s,
    o,
    e.props.growY,
    0,
    e.props.scale
  )[n.index];
  if (c)
    return Rk(t, e, c, o, i);
}
class wO extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
  }
  updateCursor() {
    this.editor.setCursor({
      type: nc[this.info.handle],
      rotation: this.editor.getSelectionRotation()
    });
  }
  onEnter(n) {
    this.parent.setCurrentToolIdMask(n.onInteractionEnd), this.info = n, this.updateCursor();
  }
  onExit() {
    this.parent.setCurrentToolIdMask(void 0), this.editor.setCursor({ type: "default", rotation: 0 });
  }
  onPointerMove() {
    this.editor.inputs.isDragging && this.startRotating();
  }
  onLongPress() {
    this.startRotating();
  }
  startRotating() {
    this.editor.getIsReadonly() || this.parent.transition("rotating", this.info);
  }
  onPointerUp() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.cancel();
  }
  onInterrupt() {
    this.cancel();
  }
  complete() {
    this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, {}) : this.parent.transition("idle");
  }
  cancel() {
    this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, {}) : this.parent.transition("idle");
  }
}
S(wO, "id", "pointing_rotate_handle");
class NO extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
  }
  onEnter(n) {
    this.info = n;
  }
  onPointerUp(n) {
    _g(this.editor, n), this.parent.transition("idle", n);
  }
  onPointerMove(n) {
    this.editor.inputs.isDragging && this.startTranslating(n);
  }
  onLongPress(n) {
    this.startTranslating(n);
  }
  startTranslating(n) {
    this.editor.getIsReadonly() || this.parent.transition("translating", n);
  }
  onDoubleClick(n) {
    var s, o;
    const i = this.editor.getHoveredShape(), r = i && !this.editor.isShapeOfType(i, "group") ? i : this.editor.getShapeAtPoint(this.editor.inputs.currentPagePoint, {
      hitInside: !0,
      margin: 0,
      renderingOnly: !0
    });
    if (r) {
      this.parent.transition("idle"), (o = (s = this.parent).onDoubleClick) == null || o.call(s, {
        ...n,
        target: "shape",
        shape: this.editor.getShape(r)
      });
      return;
    }
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.cancel();
  }
  onInterrupt() {
    this.cancel();
  }
  cancel() {
    this.parent.transition("idle");
  }
}
S(NO, "id", "pointing_selection");
class AO extends ee {
  constructor() {
    super(...arguments);
    S(this, "hitShape", {});
    S(this, "hitShapeForPointerUp", {});
    S(this, "isDoubleClick", !1);
    S(this, "didCtrlOnEnter", !1);
    S(this, "didSelectOnEnter", !1);
  }
  onEnter(n) {
    const i = this.editor.getSelectedShapeIds(), r = this.editor.getSelectionRotatedPageBounds(), s = this.editor.getFocusedGroupId(), {
      inputs: { currentPagePoint: o }
    } = this.editor, { shiftKey: a, altKey: c, accelKey: d } = n;
    this.hitShape = n.shape, this.isDoubleClick = !1, this.didCtrlOnEnter = d;
    const u = this.editor.getOutermostSelectableShape(n.shape), h = this.editor.findShapeAncestor(
      u,
      (g) => i.includes(g.id)
    );
    if (this.didCtrlOnEnter || // If the shape has an onClick handler
    this.editor.getShapeUtil(n.shape).onClick || // ...or if the shape is the focused layer (e.g. group)
    u.id === s || // ...or if the shape is within the selection
    i.includes(u.id) || // ...or if an ancestor of the shape is selected
    h || // ...or if the current point is NOT within the selection bounds
    i.length > 1 && (r != null && r.containsPoint(o))) {
      this.didSelectOnEnter = !1, this.hitShapeForPointerUp = u;
      return;
    }
    this.didSelectOnEnter = !0, a && !c ? (this.editor.cancelDoubleClick(), i.includes(u.id) || (this.editor.markHistoryStoppingPoint("shift selecting shape"), this.editor.setSelectedShapes([...i, u.id]))) : (this.editor.markHistoryStoppingPoint("selecting shape"), this.editor.setSelectedShapes([u.id]));
  }
  onPointerUp(n) {
    var u;
    const i = this.editor.getSelectedShapeIds(), r = this.editor.getFocusedGroupId(), s = this.editor.getZoomLevel(), {
      inputs: { currentPagePoint: o }
    } = this.editor, a = n.shiftKey || n.accelKey, c = this.editor.getShapeAtPoint(o, {
      margin: this.editor.options.hitTestMargin / s,
      hitInside: !0,
      renderingOnly: !0
    }) ?? this.hitShape, d = c ? this.editor.getOutermostSelectableShape(c) : this.hitShapeForPointerUp;
    if (d) {
      const h = this.editor.getShapeUtil(d);
      if (h.onClick) {
        const g = (u = h.onClick) == null ? void 0 : u.call(h, d);
        if (g) {
          this.editor.markHistoryStoppingPoint("shape on click"), this.editor.updateShapes([g]), this.parent.transition("idle", n);
          return;
        }
      }
      if (d.id === r) {
        i.length > 0 ? (this.editor.markHistoryStoppingPoint("clearing shape ids"), this.editor.setSelectedShapes([])) : this.editor.popFocusedGroupId(), this.parent.transition("idle", n);
        return;
      }
    }
    if (!this.didSelectOnEnter) {
      const h = this.editor.getOutermostSelectableShape(
        c,
        // if a group is selected, we want to stop before reaching that group
        // so we can drill down into the group
        (g) => !i.includes(g.id)
      );
      if (i.includes(h.id))
        if (a)
          this.editor.markHistoryStoppingPoint("deselecting on pointer up"), this.editor.deselect(d);
        else if (i.includes(d.id)) {
          if (i.length === 1) {
            const g = this.editor.getShapeUtil(d).getGeometry(d), p = IO(g), f = p.length === 1 ? p[0] : void 0;
            if (f) {
              const M = this.editor.getPointInShapeSpace(
                d,
                o
              );
              if (f.bounds.containsPoint(M, 0) && f.hitTestPoint(M)) {
                this.editor.run(() => {
                  this.editor.markHistoryStoppingPoint("editing on pointer up"), this.editor.select(d.id);
                  const m = this.editor.getShapeUtil(d);
                  this.editor.getIsReadonly() && !m.canEditInReadOnly(d) || (this.editor.setEditingShape(d.id), this.editor.setCurrentTool("select.editing_shape"), this.isDoubleClick && this.editor.emit("select-all-text", { shapeId: d.id }));
                });
                return;
              }
            }
          }
          this.editor.markHistoryStoppingPoint("selecting on pointer up"), this.editor.select(d.id);
        } else
          this.editor.markHistoryStoppingPoint("selecting on pointer up"), this.editor.select(d);
      else if (a) {
        const g = this.editor.getShapeAncestors(h);
        this.editor.markHistoryStoppingPoint("shift deselecting on pointer up"), this.editor.setSelectedShapes([
          ...this.editor.getSelectedShapeIds().filter((p) => !g.find((f) => f.id === p)),
          h.id
        ]);
      } else
        this.editor.markHistoryStoppingPoint("selecting on pointer up"), this.editor.setSelectedShapes([h.id]);
    }
    this.parent.transition("idle", n);
  }
  onDoubleClick() {
    this.isDoubleClick = !0;
  }
  onPointerMove(n) {
    this.editor.inputs.isDragging && (this.didCtrlOnEnter ? this.parent.transition("brushing", n) : this.startTranslating(n));
  }
  onLongPress(n) {
    this.startTranslating(n);
  }
  startTranslating(n) {
    this.editor.getIsReadonly() || (this.editor.focus(), this.parent.transition("translating", n));
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.cancel();
  }
  onInterrupt() {
    this.cancel();
  }
  cancel() {
    this.parent.transition("idle");
  }
}
S(AO, "id", "pointing_shape");
class TO extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
    S(this, "markId", "");
    // A switch to detect when the user is holding ctrl
    S(this, "didHoldCommand", !1);
    // we transition into the resizing state from the geo pointing state, which starts with a shape of size w: 1, h: 1,
    // so if the user drags x: +50, y: +50 after mouseDown, the shape will be w: 51, h: 51, which is too many pixels, alas
    // so we allow passing a further offset into this state to negate such issues
    S(this, "creationCursorOffset", { x: 0, y: 0 });
    S(this, "snapshot", {});
  }
  onEnter(n) {
    const { isCreating: i = !1, creatingMarkId: r, creationCursorOffset: s = { x: 0, y: 0 } } = n;
    if (this.info = n, this.didHoldCommand = !1, this.parent.setCurrentToolIdMask(n.onInteractionEnd), this.creationCursorOffset = s, this.snapshot = this._createSnapshot(), this.markId = "", i)
      if (r)
        this.markId = r;
      else {
        const o = this.editor.getMarkIdMatching(
          `creating:${this.editor.getOnlySelectedShapeId()}`
        );
        o && (this.markId = o);
      }
    else
      this.markId = this.editor.markHistoryStoppingPoint("starting resizing");
    i && this.editor.setCursor({ type: "cross", rotation: 0 }), this.handleResizeStart(), this.updateShapes();
  }
  onTick({ elapsed: n }) {
    const { editor: i } = this;
    i.edgeScrollManager.updateEdgeScrolling(n);
  }
  onPointerMove() {
    this.updateShapes();
  }
  onKeyDown() {
    this.updateShapes();
  }
  onKeyUp() {
    this.updateShapes();
  }
  onPointerUp() {
    this.complete();
  }
  onComplete() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  cancel() {
    this.editor.bailToMark(this.markId), this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, {}) : this.parent.transition("idle");
  }
  complete() {
    var n, i;
    if (It(this.editor, this.snapshot.selectedShapeIds), this.handleResizeEnd(), this.info.isCreating && this.info.onCreate) {
      (i = (n = this.info).onCreate) == null || i.call(n, this.editor.getOnlySelectedShape());
      return;
    }
    if (this.editor.getInstanceState().isToolLocked && this.info.onInteractionEnd) {
      this.editor.setCurrentTool(this.info.onInteractionEnd, {});
      return;
    }
    this.parent.transition("idle");
  }
  handleResizeStart() {
    const { shapeSnapshots: n } = this.snapshot, i = [];
    n.forEach(({ shape: r }) => {
      var a;
      const s = this.editor.getShapeUtil(r), o = (a = s.onResizeStart) == null ? void 0 : a.call(s, r);
      o && i.push(o);
    }), i.length > 0 && this.editor.updateShapes(i);
  }
  handleResizeEnd() {
    const { shapeSnapshots: n } = this.snapshot, i = [];
    n.forEach(({ shape: r }) => {
      var c;
      const s = this.editor.getShape(r.id), o = this.editor.getShapeUtil(r), a = (c = o.onResizeEnd) == null ? void 0 : c.call(o, r, s);
      a && i.push(a);
    }), i.length > 0 && this.editor.updateShapes(i);
  }
  updateShapes() {
    const { altKey: n, shiftKey: i } = this.editor.inputs, {
      frames: r,
      shapeSnapshots: s,
      selectionBounds: o,
      cursorHandleOffset: a,
      selectedShapeIds: c,
      selectionRotation: d,
      canShapesDeform: u
    } = this.snapshot;
    let h = i || !u;
    if (s.size === 1) {
      const T = [...s.values()][0];
      this.editor.isShapeOfType(T.shape, "text") && (h = !(this.info.handle === "left" || this.info.handle === "right"));
    }
    const { ctrlKey: g } = this.editor.inputs, p = this.editor.inputs.currentPagePoint.clone().sub(a).sub(this.creationCursorOffset), f = this.editor.inputs.originPagePoint.clone().sub(a);
    if (this.editor.getInstanceState().isGridMode && !g) {
      const { gridSize: T } = this.editor.getDocumentSettings();
      p.snapToGrid(T);
    }
    const M = this.info.handle, m = QN(M, Math.PI);
    if (this.editor.snaps.clearIndicators(), (this.editor.user.getIsSnapMode() ? !g : g) && d % Nt === 0) {
      const { nudge: T } = this.editor.snaps.shapeBounds.snapResizeShapes({
        dragDelta: x.Sub(p, f),
        initialSelectionPageBounds: this.snapshot.initialSelectionPageBounds,
        handle: QN(M, d),
        isAspectRatioLocked: h,
        isResizingFromCenter: n
      });
      p.add(T);
    }
    const I = x.RotWith(
      n ? o.center : o.getHandlePoint(m),
      o.point,
      d
    ), D = x.Sub(p, I).rot(
      -d
    ), j = x.Sub(f, I).rot(
      -d
    ), w = x.DivV(D, j);
    Number.isFinite(w.x) || (w.x = 1), Number.isFinite(w.y) || (w.y = 1);
    const A = M === "top" || M === "bottom", b = M === "left" || M === "right";
    h ? b ? w.y = Math.abs(w.x) : A ? w.x = Math.abs(w.y) : Math.abs(w.x) > Math.abs(w.y) ? w.y = Math.abs(w.x) * (w.y < 0 ? -1 : 1) : w.x = Math.abs(w.y) * (w.x < 0 ? -1 : 1) : (A && (w.x = 1), b && (w.y = 1)), this.info.isCreating || this.updateCursor({
      dragHandle: M,
      isFlippedX: w.x < 0,
      isFlippedY: w.y < 0,
      rotation: d
    });
    for (const T of s.keys()) {
      const E = s.get(T);
      this.editor.resizeShape(T, w, {
        initialShape: E.shape,
        initialBounds: E.bounds,
        initialPageTransform: E.pageTransform,
        dragHandle: M,
        mode: c.length === 1 && T === c[0] ? "resize_bounds" : "scale_shape",
        scaleOrigin: I,
        isAspectRatioLocked: h,
        scaleAxisRotation: d,
        skipStartAndEndCallbacks: !0
      });
    }
    if (this.editor.inputs.ctrlKey) {
      this.didHoldCommand = !0;
      for (const { id: T, children: E } of r) {
        if (!E.length) continue;
        const v = s.get(T).shape, P = this.editor.getShape(T);
        if (!(v && P)) continue;
        const C = P.x - v.x, z = P.y - v.y, O = new x(C, z).rot(-v.rotation);
        if (O.x !== 0 || O.y !== 0)
          for (const R of E)
            this.editor.updateShape({
              id: R.id,
              type: R.type,
              x: R.x - O.x,
              y: R.y - O.y
            });
      }
    } else if (this.didHoldCommand) {
      this.didHoldCommand = !1;
      for (const { children: T } of r)
        if (T.length)
          for (const E of T)
            this.editor.updateShape({
              id: E.id,
              type: E.type,
              x: E.x,
              y: E.y
            });
    }
  }
  // ---
  updateCursor({
    dragHandle: n,
    isFlippedX: i,
    isFlippedY: r,
    rotation: s
  }) {
    const o = { ...this.editor.getInstanceState().cursor };
    switch (n) {
      case "top_left":
      case "bottom_right": {
        o.type = "nwse-resize", i !== r && (o.type = "nesw-resize");
        break;
      }
      case "top_right":
      case "bottom_left": {
        o.type = "nesw-resize", i !== r && (o.type = "nwse-resize");
        break;
      }
    }
    o.rotation = s, this.editor.setCursor(o);
  }
  onExit() {
    this.parent.setCurrentToolIdMask(void 0), this.editor.setCursor({ type: "default", rotation: 0 }), this.editor.snaps.clearIndicators();
  }
  _createSnapshot() {
    const n = this.editor.getSelectedShapeIds(), i = this.editor.getSelectionRotation(), {
      inputs: { originPagePoint: r }
    } = this.editor, s = this.editor.getSelectionRotatedPageBounds(), o = x.RotWith(
      s.getHandlePoint(this.info.handle),
      s.point,
      i
    ), a = x.Sub(r, o), c = /* @__PURE__ */ new Map(), d = [];
    n.forEach((h) => {
      const g = this.editor.getShape(h);
      if (g) {
        if (g.type === "frame" && d.push({
          id: h,
          children: Ze(
            this.editor.getSortedChildIdsForParent(g).map((p) => this.editor.getShape(p))
          )
        }), c.set(g.id, this._createShapeSnapshot(g)), this.editor.isShapeOfType(g, "frame") && n.length === 1)
          return;
        this.editor.visitDescendants(g.id, (p) => {
          const f = this.editor.getShape(p);
          if (f && (c.set(f.id, this._createShapeSnapshot(f)), this.editor.isShapeOfType(f, "frame")))
            return !1;
        });
      }
    });
    const u = ![...c.values()].some(
      (h) => !Iv(h.pageRotation, i) || h.isAspectRatioLocked
    );
    return {
      shapeSnapshots: c,
      selectionBounds: s,
      cursorHandleOffset: a,
      selectionRotation: i,
      selectedShapeIds: n,
      canShapesDeform: u,
      initialSelectionPageBounds: this.editor.getSelectionPageBounds(),
      frames: d
    };
  }
  _createShapeSnapshot(n) {
    const i = this.editor.getShapePageTransform(n), r = this.editor.getShapeUtil(n);
    return {
      shape: n,
      bounds: this.editor.getShapeGeometry(n).bounds,
      pageTransform: i,
      pageRotation: ne.Decompose(i).rotation,
      isAspectRatioLocked: r.isAspectRatioLocked(n)
    };
  }
}
S(TO, "id", "resizing");
const lm = [
  "top",
  "top_right",
  "right",
  "bottom_right",
  "bottom",
  "bottom_left",
  "left",
  "top_left"
];
function QN(t, e) {
  e = e % gt;
  const n = Math.round(e / (st / 4)), i = lm.indexOf(t);
  return lm[(i + n) % lm.length];
}
const ZN = Math.PI / 180;
class bO extends ee {
  constructor() {
    super(...arguments);
    S(this, "snapshot", {});
    S(this, "info", {});
    S(this, "markId", "");
  }
  onEnter(n) {
    this.info = n, this.parent.setCurrentToolIdMask(n.onInteractionEnd), this.markId = this.editor.markHistoryStoppingPoint("rotate start");
    const i = T1({
      editor: this.editor,
      ids: this.editor.getSelectedShapeIds()
    });
    if (!i) return this.parent.transition("idle", this.info);
    this.snapshot = i;
    const r = this._getRotationFromPointerPosition({
      snapToNearestDegree: !1
    });
    wh({
      editor: this.editor,
      delta: this._getRotationFromPointerPosition({ snapToNearestDegree: !1 }),
      snapshot: this.snapshot,
      stage: "start"
    }), this.editor.setCursor({
      type: nc[this.info.handle],
      rotation: r + this.snapshot.initialShapesRotation
    });
  }
  onExit() {
    this.editor.setCursor({ type: "default", rotation: 0 }), this.parent.setCurrentToolIdMask(void 0), this.snapshot = {};
  }
  onPointerMove() {
    this.update();
  }
  onKeyDown() {
    this.update();
  }
  onKeyUp() {
    this.update();
  }
  onPointerUp() {
    this.complete();
  }
  onComplete() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  // ---
  update() {
    const n = this._getRotationFromPointerPosition({
      snapToNearestDegree: !1
    });
    wh({
      editor: this.editor,
      delta: n,
      snapshot: this.snapshot,
      stage: "update"
    }), this.editor.setCursor({
      type: nc[this.info.handle],
      rotation: n + this.snapshot.initialShapesRotation
    });
  }
  cancel() {
    this.editor.bailToMark(this.markId), this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, this.info) : this.parent.transition("idle", this.info);
  }
  complete() {
    wh({
      editor: this.editor,
      delta: this._getRotationFromPointerPosition({ snapToNearestDegree: !0 }),
      snapshot: this.snapshot,
      stage: "end"
    }), It(
      this.editor,
      this.snapshot.shapeSnapshots.map((n) => n.shape.id)
    ), this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd, this.info) : this.parent.transition("idle", this.info);
  }
  _getRotationFromPointerPosition({ snapToNearestDegree: n }) {
    const i = this.editor.getSelectionRotation(), r = this.editor.getSelectionRotatedPageBounds(), {
      inputs: { shiftKey: s, currentPagePoint: o }
    } = this.editor, { initialCursorAngle: a, initialShapesRotation: c } = this.snapshot;
    if (!r) return c;
    const u = r.center.clone().rotWith(r.point, i).angle(o) - a;
    let h = c + u;
    if (s)
      h = vg(h, 24);
    else if (n && (h = Math.round(h / ZN) * ZN, this.editor.getInstanceState().isCoarsePointer)) {
      const g = vg(h, 4), p = Sh(h, g);
      Math.abs(p) < FW(5) && (h = g);
    }
    return h - c;
  }
}
S(bO, "id", "rotating");
class vO extends ee {
  constructor() {
    super(...arguments);
    S(this, "hits", /* @__PURE__ */ new Set());
    S(this, "size", 0);
    S(this, "scribbleId", "id");
    S(this, "initialSelectedShapeIds", /* @__PURE__ */ new Set());
    S(this, "newlySelectedShapeIds", /* @__PURE__ */ new Set());
  }
  onEnter() {
    this.initialSelectedShapeIds = new Set(
      this.editor.inputs.shiftKey ? this.editor.getSelectedShapeIds() : []
    ), this.newlySelectedShapeIds = /* @__PURE__ */ new Set(), this.size = 0, this.hits.clear();
    const n = this.editor.scribbles.addScribble({
      color: "selection-stroke",
      opacity: 0.32,
      size: 12
    });
    this.scribbleId = n.id, this.updateScribbleSelection(!0), this.editor.updateInstanceState({ brush: null });
  }
  onExit() {
    this.editor.scribbles.stop(this.scribbleId);
  }
  onPointerMove() {
    this.updateScribbleSelection(!0);
  }
  onPointerUp() {
    this.complete();
  }
  onKeyDown() {
    this.updateScribbleSelection(!1);
  }
  onKeyUp() {
    this.editor.inputs.altKey ? this.updateScribbleSelection(!1) : this.parent.transition("brushing");
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.complete();
  }
  pushPointToScribble() {
    const { x: n, y: i } = this.editor.inputs.currentPagePoint;
    this.editor.scribbles.addPoint(this.scribbleId, n, i);
  }
  updateScribbleSelection(n) {
    const { editor: i } = this, r = this.editor.getCurrentPageRenderingShapesSorted(), {
      inputs: { shiftKey: s, originPagePoint: o, previousPagePoint: a, currentPagePoint: c }
    } = this.editor, { newlySelectedShapeIds: d, initialSelectedShapeIds: u } = this;
    n && this.pushPointToScribble();
    const h = r;
    let g, p, f, M;
    const m = 0;
    for (let D = 0, j = h.length; D < j; D++) {
      if (g = h[D], i.isShapeOfType(g, "group") || d.has(g.id) || i.isShapeOrAncestorLocked(g) || (p = i.getShapeGeometry(g), i.isShapeOfType(g, "frame") && p.bounds.containsPoint(i.getPointInShapeSpace(g, o))))
        continue;
      const w = i.getShapePageTransform(g);
      if (!p || !w) continue;
      const A = w.clone().invert();
      f = A.applyToPoint(a), M = A.applyToPoint(c);
      const { bounds: b } = p;
      if (!(b.minX - m > Math.max(f.x, M.x) || b.minY - m > Math.max(f.y, M.y) || b.maxX + m < Math.min(f.x, M.x) || b.maxY + m < Math.min(f.y, M.y)) && p.hitTestLineSegment(f, M, m)) {
        const T = this.editor.getOutermostSelectableShape(g), E = this.editor.getShapeMask(T.id);
        if (E && aS(
          a,
          c,
          E
        ) !== null && !yi(c, E))
          continue;
        d.add(T.id);
      }
    }
    const y = i.getSelectedShapeIds(), I = new Set(
      s ? [...d, ...u] : [...d]
    );
    (y.length !== I.size || y.some((D) => !I.has(D))) && this.editor.setSelectedShapes(Array.from(I));
  }
  complete() {
    this.updateScribbleSelection(!0), this.parent.transition("idle");
  }
  cancel() {
    this.editor.setSelectedShapes([...this.initialSelectedShapeIds]), this.parent.transition("idle");
  }
}
S(vO, "id", "scribble_brushing");
var zse = Object.create, EO = Object.defineProperty, Lse = Object.getOwnPropertyDescriptor, kse = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), CO = (t) => {
  throw TypeError(t);
}, zO = (t, e, n) => e in t ? EO(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Ose = (t) => [, , , zse(null)], LO = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], kO = (t) => t !== void 0 && typeof t != "function" ? CO("Function expected") : t, Pse = (t, e, n, i, r) => ({ kind: LO[t], name: e, metadata: i, addInitializer: (s) => n._ ? CO("Already initialized") : r.push(kO(s || null)) }), Use = (t, e) => zO(e, kse("metadata"), t[3]), Rse = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, Yse = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = LO[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, Lse(r, n)), y = i.length - 1; y >= 0; y--)
    c = Pse(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, kO(o) && (m[f] = o);
  return m && EO(r, n, m), r;
}, dm = (t, e, n) => zO(t, typeof e != "symbol" ? e + "" : e, n), OO, If;
const Qse = 20, Zse = 100;
OO = [di];
class jj {
  constructor(e) {
    this.editor = e, Rse(If, 5, this), dm(this, "prevDroppingShapeId", null), dm(this, "droppingNodeTimer", null), dm(this, "first", !0), e.disposables.add(this.dispose);
  }
  updateDroppingNode(e, n) {
    var i;
    this.first && (this.editor.setHintingShapes(
      e.map((r) => this.editor.findShapeAncestor(r, (s) => s.type !== "group")).filter((r) => r)
    ), this.prevDroppingShapeId = ((i = this.editor.getDroppingOverShape(this.editor.inputs.originPagePoint, e)) == null ? void 0 : i.id) ?? null, this.first = !1), this.droppingNodeTimer === null ? this.setDragTimer(e, Qse, n) : this.editor.inputs.pointerVelocity.len() > 0.5 && (clearTimeout(this.droppingNodeTimer), this.setDragTimer(e, Zse, n));
  }
  setDragTimer(e, n, i) {
    this.droppingNodeTimer = this.editor.timers.setTimeout(() => {
      this.editor.run(() => {
        this.handleDrag(this.editor.inputs.currentPagePoint, e, i);
      }), this.droppingNodeTimer = null;
    }, n);
  }
  handleDrag(e, n, i) {
    var c, d, u, h, g;
    n = Ze(n.map((p) => this.editor.getShape(p.id)));
    const r = ((c = this.editor.getDroppingOverShape(e, n)) == null ? void 0 : c.id) ?? null;
    if (r === this.prevDroppingShapeId) {
      this.hintParents(n);
      return;
    }
    const { prevDroppingShapeId: s } = this, o = s && this.editor.getShape(s), a = r && this.editor.getShape(r);
    o && ((u = (d = this.editor.getShapeUtil(o)).onDragShapesOut) == null || u.call(d, o, n)), a && ((g = (h = this.editor.getShapeUtil(a)).onDragShapesOver) == null || g.call(h, a, n)), this.hintParents(n), i == null || i(), this.prevDroppingShapeId = r;
  }
  hintParents(e) {
    const n = /* @__PURE__ */ new Map();
    for (const r of e) {
      const s = this.editor.findShapeAncestor(r, (o) => o.type !== "group");
      s && (n.has(s.id) || n.set(s.id, []), n.get(s.id).push(r.id));
    }
    const i = [];
    for (const [r, s] of n) {
      const o = this.editor.getShape(r);
      o && lz(this.editor, o).length < s.length && i.push(o.id);
    }
    this.editor.setHintingShapes(i);
  }
  dropShapes(e) {
    var i, r;
    const { prevDroppingShapeId: n } = this;
    if (this.handleDrag(this.editor.inputs.currentPagePoint, e), n) {
      const s = this.editor.getShape(n);
      if (!s) return;
      (r = (i = this.editor.getShapeUtil(s)).onDropShapesOver) == null || r.call(i, s, e);
    }
  }
  clear() {
    this.prevDroppingShapeId = null, this.droppingNodeTimer !== null && clearTimeout(this.droppingNodeTimer), this.droppingNodeTimer = null, this.editor.setHintingShapes([]), this.first = !0;
  }
  dispose() {
    this.clear();
  }
}
If = Ose();
Yse(If, 1, "dispose", OO, jj);
Use(If, jj);
var Fse = Object.create, PO = Object.defineProperty, Bse = Object.getOwnPropertyDescriptor, UO = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), RO = (t) => {
  throw TypeError(t);
}, YO = (t, e, n) => e in t ? PO(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Gse = (t) => [, , , Fse((t == null ? void 0 : t[UO("metadata")]) ?? null)], QO = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], ZO = (t) => t !== void 0 && typeof t != "function" ? RO("Function expected") : t, Wse = (t, e, n, i, r) => ({ kind: QO[t], name: e, metadata: i, addInitializer: (s) => n._ ? RO("Already initialized") : r.push(ZO(s || null)) }), Hse = (t, e) => YO(e, UO("metadata"), t[3]), Vse = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, Kse = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = QO[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, Bse(r, n)), y = i.length - 1; y >= 0; y--)
    c = Wse(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, ZO(o) && (m[f] = o);
  return m && PO(r, n, m), r;
}, Ys = (t, e, n) => YO(t, typeof e != "symbol" ? e + "" : e, n), FO, RI, xf;
class Sf extends (RI = ee, FO = [di], RI) {
  constructor() {
    super(...arguments), Vse(xf, 5, this), Ys(this, "info", {}), Ys(this, "selectionSnapshot", {}), Ys(this, "snapshot", {}), Ys(this, "markId", ""), Ys(this, "isCloning", !1), Ys(this, "isCreating", !1), Ys(this, "dragAndDropManager", new jj(this.editor));
  }
  onCreate(e) {
  }
  onEnter(e) {
    var s;
    const { isCreating: n = !1, creatingMarkId: i, onCreate: r = () => {
    } } = e;
    if (!((s = this.editor.getSelectedShapeIds()) != null && s.length)) {
      this.parent.transition("idle");
      return;
    }
    if (this.info = e, this.parent.setCurrentToolIdMask(e.onInteractionEnd), this.isCreating = n, this.markId = "", n)
      if (i)
        this.markId = i;
      else {
        const o = this.editor.getMarkIdMatching(
          `creating:${this.editor.getOnlySelectedShapeId()}`
        );
        o && (this.markId = o);
      }
    else
      this.markId = this.editor.markHistoryStoppingPoint("translating");
    if (this.onCreate = r, this.isCloning = !1, this.info = e, this.editor.setCursor({ type: "move", rotation: 0 }), this.selectionSnapshot = FN(this.editor), !this.isCreating && this.editor.inputs.altKey) {
      this.startCloning();
      return;
    }
    this.snapshot = this.selectionSnapshot, this.handleStart(), this.updateShapes();
  }
  onExit() {
    this.parent.setCurrentToolIdMask(void 0), this.selectionSnapshot = {}, this.snapshot = {}, this.editor.snaps.clearIndicators(), this.editor.setCursor({ type: "default", rotation: 0 }), this.dragAndDropManager.clear();
  }
  onTick({ elapsed: e }) {
    const { editor: n } = this;
    this.dragAndDropManager.updateDroppingNode(
      this.snapshot.movingShapes,
      this.updateParentTransforms
    ), n.edgeScrollManager.updateEdgeScrolling(e);
  }
  onPointerMove() {
    this.updateShapes();
  }
  onKeyDown() {
    if (this.editor.inputs.altKey && !this.isCloning) {
      this.startCloning();
      return;
    }
    this.updateShapes();
  }
  onKeyUp() {
    if (!this.editor.inputs.altKey && this.isCloning) {
      this.stopCloning();
      return;
    }
    this.updateShapes();
  }
  onPointerUp() {
    this.complete();
  }
  onComplete() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  startCloning() {
    this.isCreating || (this.isCloning = !0, this.reset(), this.markId = this.editor.markHistoryStoppingPoint("translate cloning"), this.editor.duplicateShapes(Array.from(this.editor.getSelectedShapeIds())), this.snapshot = FN(this.editor), this.handleStart(), this.updateShapes());
  }
  stopCloning() {
    this.isCloning = !1, this.snapshot = this.selectionSnapshot, this.reset(), this.markId = this.editor.markHistoryStoppingPoint("translate"), this.updateShapes();
  }
  reset() {
    this.editor.bailToMark(this.markId);
  }
  complete() {
    var e;
    this.updateShapes(), this.dragAndDropManager.dropShapes(this.snapshot.movingShapes), It(
      this.editor,
      this.snapshot.movingShapes.map((n) => n.id)
    ), this.handleEnd(), this.editor.getInstanceState().isToolLocked && this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd) : this.isCreating ? (e = this.onCreate) == null || e.call(this, this.editor.getOnlySelectedShape()) : this.parent.transition("idle");
  }
  cancel() {
    this.reset(), this.info.onInteractionEnd ? this.editor.setCurrentTool(this.info.onInteractionEnd) : this.parent.transition("idle", this.info);
  }
  handleStart() {
    const { movingShapes: e } = this.snapshot, n = [];
    e.forEach((i) => {
      var o;
      const r = this.editor.getShapeUtil(i), s = (o = r.onTranslateStart) == null ? void 0 : o.call(r, i);
      s && n.push(s);
    }), n.length > 0 && this.editor.updateShapes(n), this.editor.setHoveredShape(null);
  }
  handleEnd() {
    const { movingShapes: e } = this.snapshot;
    if (this.isCloning && e.length > 0) {
      const i = x.Average(
        e.map((s) => this.editor.getShapePageTransform(s.id).point())
      ), r = x.Sub(i, this.selectionSnapshot.averagePagePoint);
      x.IsNaN(r) || this.editor.updateInstanceState({
        duplicateProps: {
          shapeIds: e.map((s) => s.id),
          offset: { x: r.x, y: r.y }
        }
      });
    }
    const n = [];
    e.forEach((i) => {
      var a;
      const r = this.editor.getShape(i.id), s = this.editor.getShapeUtil(i), o = (a = s.onTranslateEnd) == null ? void 0 : a.call(s, i, r);
      o && n.push(o);
    }), n.length > 0 && this.editor.updateShapes(n);
  }
  updateShapes() {
    const { snapshot: e } = this;
    this.dragAndDropManager.updateDroppingNode(e.movingShapes, this.updateParentTransforms), Xse({
      editor: this.editor,
      snapshot: e
    });
    const { movingShapes: n } = e, i = [];
    n.forEach((r) => {
      var c;
      const s = this.editor.getShape(r.id), o = this.editor.getShapeUtil(r), a = (c = o.onTranslate) == null ? void 0 : c.call(o, r, s);
      a && i.push(a);
    }), i.length > 0 && this.editor.updateShapes(i);
  }
  updateParentTransforms() {
    const {
      editor: e,
      snapshot: { shapeSnapshots: n }
    } = this;
    n.forEach((i) => {
      const r = e.getShape(i.shape.id);
      if (!r) return null;
      const s = ni(r.parentId) ? null : ne.Inverse(e.getShapePageTransform(r.parentId));
      i.parentTransform = s;
    });
  }
}
xf = Gse(RI);
Kse(xf, 1, "updateParentTransforms", FO, Sf);
Hse(xf, Sf);
Ys(Sf, "id", "translating");
function FN(t) {
  var h;
  const e = [], n = [], i = t.getSelectedShapeIds(), r = Ze(
    i.map((g) => {
      const p = t.getShape(g);
      if (!p) return null;
      e.push(p);
      const f = t.getShapePageTransform(g), M = f.point(), m = f.rotation();
      n.push(M);
      const y = kn.isId(p.parentId) ? null : ne.Inverse(t.getShapePageTransform(p.parentId));
      return {
        shape: p,
        pagePoint: M,
        pageRotation: m,
        parentTransform: y
      };
    })
  ), s = t.getOnlySelectedShape();
  let o = [];
  if (s)
    o = t.snaps.shapeBounds.getSnapPoints(s.id);
  else {
    const g = t.getSelectionPageBounds();
    g && (o = g.cornersAndCenter.map((p, f) => ({
      id: "selection:" + f,
      x: p.x,
      y: p.y
    })));
  }
  let a, c;
  const { originPagePoint: d } = t.inputs, u = r.filter(
    (g) => t.isShapeOfType(g.shape, "note") && t.isPointInShape(g.shape, d)
  );
  if (u.length !== 0) if (u.length === 1)
    c = u[0];
  else {
    const g = t.getCurrentPageShapesSorted();
    c = (h = u.map((p) => ({
      snapshot: p,
      index: g.findIndex((f) => f.id === p.shape.id)
    })).sort((p, f) => f.index - p.index)[0]) == null ? void 0 : h.snapshot;
  }
  return c && (a = Uk(
    t,
    c.pageRotation,
    c.shape.props.scale,
    c.shape.props.growY ?? 0
  )), {
    averagePagePoint: x.Average(n),
    movingShapes: e,
    shapeSnapshots: r,
    initialPageBounds: t.getSelectionPageBounds(),
    initialSnapPoints: o,
    noteAdjacentPositions: a,
    noteSnapshot: c
  };
}
function Xse({
  editor: t,
  snapshot: e
}) {
  const { inputs: n } = t, {
    noteSnapshot: i,
    noteAdjacentPositions: r,
    initialPageBounds: s,
    initialSnapPoints: o,
    shapeSnapshots: a,
    averagePagePoint: c
  } = e, d = t.getInstanceState().isGridMode, u = t.getDocumentSettings().gridSize, h = x.Sub(n.currentPagePoint, n.originPagePoint), g = t.inputs.shiftKey ? Math.abs(h.x) < Math.abs(h.y) ? "x" : "y" : null;
  if (g === "x" ? h.x = 0 : g === "y" && (h.y = 0), t.snaps.clearIndicators(), (t.user.getIsSnapMode() ? !n.ctrlKey : n.ctrlKey) && t.inputs.pointerVelocity.len() < 0.5) {
    const { nudge: m } = t.snaps.shapeBounds.snapTranslateShapes({
      dragDelta: h,
      initialSelectionPageBounds: s,
      lockedAxis: g,
      initialSelectionSnapPoints: o
    });
    h.add(m);
  } else if (i && r) {
    const { scale: m } = i.shape.props, y = i.pagePoint.clone().add(h).add(pf.clone().mul(m).rot(i.pageRotation));
    let I = Ok / t.getZoomLevel(), D = new x(0, 0);
    for (const j of r) {
      const w = x.Sub(y, j), A = w.len();
      A < I && (I = A, D = w);
    }
    h.sub(D);
  }
  const f = x.Add(c, h);
  d && !n.ctrlKey && f.snapToGrid(u);
  const M = x.Sub(f, c);
  t.updateShapes(
    Ze(
      a.map(({ shape: m, pagePoint: y, parentTransform: I }) => {
        const D = x.Add(y, M), j = I ? ne.applyToPoint(I, D) : D;
        return {
          id: m.id,
          type: m.type,
          x: j.x,
          y: j.y
        };
      })
    )
  );
}
class Hh extends ee {
  constructor() {
    super(...arguments);
    S(this, "reactor");
  }
  static children() {
    return [
      UI,
      xj,
      bse,
      jO,
      AO,
      Sf,
      hO,
      vO,
      Sj,
      NO,
      gO,
      xO,
      TO,
      bO,
      wO,
      SO,
      DO,
      yO
    ];
  }
  // We want to clean up the duplicate props when the selection changes
  cleanUpDuplicateProps() {
    const n = this.editor.getSelectedShapeIds(), i = this.editor.getInstanceState();
    if (!i.duplicateProps) return;
    const r = new Set(i.duplicateProps.shapeIds);
    n.length === r.size && n.every((s) => r.has(s)) || this.editor.updateInstanceState({
      duplicateProps: null
    });
  }
  onEnter() {
    this.reactor = Yr("clean duplicate props", () => {
      try {
        this.cleanUpDuplicateProps();
      } catch (n) {
        typeof process < "u" && process.env.NODE_ENV === "test" || console.error(n);
      }
    });
  }
  onExit() {
    var n;
    (n = this.reactor) == null || n.call(this), this.editor.getCurrentPageState().editingShapeId && this.editor.setEditingShape(null);
  }
}
S(Hh, "id", "select"), S(Hh, "initial", "idle"), S(Hh, "isLockable", !1);
var Km;
let Jse = (Km = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
  }
  onEnter(n) {
    this.info = n;
  }
  onPointerDown() {
    this.parent.transition("pointing", this.info);
  }
}, S(Km, "id", "idle"), Km);
class BO extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
  }
  onEnter(n) {
    this.info = n;
  }
  onPointerUp() {
    this.complete();
  }
  onPointerMove() {
    this.editor.inputs.isDragging && this.parent.transition("zoom_brushing", this.info);
  }
  onCancel() {
    this.cancel();
  }
  complete() {
    const { currentScreenPoint: n } = this.editor.inputs;
    this.editor.inputs.altKey ? this.editor.zoomOut(n, { animation: { duration: 220 } }) : this.editor.zoomIn(n, { animation: { duration: 220 } }), this.parent.transition("idle", this.info);
  }
  cancel() {
    this.parent.transition("idle", this.info);
  }
}
S(BO, "id", "pointing");
class GO extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
    S(this, "zoomBrush", new ae());
  }
  onEnter(n) {
    this.info = n, this.update();
  }
  onExit() {
    this.editor.updateInstanceState({ zoomBrush: null });
  }
  onPointerMove() {
    this.update();
  }
  onPointerUp() {
    this.complete();
  }
  onCancel() {
    this.cancel();
  }
  update() {
    const {
      inputs: { originPagePoint: n, currentPagePoint: i }
    } = this.editor;
    this.zoomBrush.setTo(ae.FromPoints([n, i])), this.editor.updateInstanceState({ zoomBrush: this.zoomBrush.toJson() });
  }
  cancel() {
    this.parent.transition("idle", this.info);
  }
  complete() {
    const { zoomBrush: n } = this, i = 8 / this.editor.getZoomLevel();
    if (n.width < i && n.height < i) {
      const r = this.editor.inputs.currentScreenPoint;
      this.editor.inputs.altKey ? this.editor.zoomOut(r, { animation: { duration: 220 } }) : this.editor.zoomIn(r, { animation: { duration: 220 } });
    } else {
      const r = this.editor.inputs.altKey ? this.editor.getZoomLevel() / 2 : void 0;
      this.editor.zoomToBounds(n, { targetZoom: r, animation: { duration: 220 } });
    }
    this.parent.transition("idle", this.info);
  }
}
S(GO, "id", "zoom_brushing");
class Vh extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
  }
  static children() {
    return [Jse, GO, BO];
  }
  onEnter(n) {
    this.info = n, this.parent.setCurrentToolIdMask(n.onInteractionEnd), this.updateCursor();
  }
  onExit() {
    this.parent.setCurrentToolIdMask(void 0), this.editor.updateInstanceState({ zoomBrush: null, cursor: { type: "default", rotation: 0 } }), this.parent.setCurrentToolIdMask(void 0);
  }
  onKeyDown() {
    this.updateCursor();
  }
  onKeyUp(n) {
    this.updateCursor(), n.code === "KeyZ" && this.complete();
  }
  onInterrupt() {
    this.complete();
  }
  complete() {
    this.info.onInteractionEnd && this.info.onInteractionEnd !== "select" ? this.editor.setCurrentTool(this.info.onInteractionEnd, this.info) : this.parent.transition("select");
  }
  updateCursor() {
    this.editor.inputs.altKey ? this.editor.setCursor({ type: "zoom-out", rotation: 0 }) : this.editor.setCursor({ type: "zoom-in", rotation: 0 });
  }
}
S(Vh, "id", "zoom"), S(Vh, "initial", "idle"), S(Vh, "isLockable", !1);
const qse = [jse, Gh, Wh, Vh, Hh];
function _se() {
  const t = Q(), e = G("follow", () => t.getInstanceState().followingUserId, [
    t
  ]);
  return e ? /* @__PURE__ */ l.jsx($se, { userId: e }) : null;
}
function $se({ userId: t }) {
  const e = Tp(t);
  return e ? /* @__PURE__ */ l.jsx("div", { className: "tlui-following-indicator", style: { borderColor: e.color } }) : null;
}
let YI = {
  fonts: {
    draw: `${Hs()}/fonts/Shantell_Sans-Tldrawish.woff2`,
    serif: `${Hs()}/fonts/IBMPlexSerif-Medium.woff2`,
    sansSerif: `${Hs()}/fonts/IBMPlexSans-Medium.woff2`,
    monospace: `${Hs()}/fonts/IBMPlexMono-Medium.woff2`
  }
};
function WO(t) {
  return yt(() => t ? {
    fonts: { ...YI.fonts, ...t == null ? void 0 : t.fonts }
  } : YI, [t]);
}
const eoe = [
  "align-bottom",
  "align-center-horizontal",
  "align-center-vertical",
  "align-left",
  "align-right",
  "align-top",
  "arrow-left",
  "arrowhead-arrow",
  "arrowhead-bar",
  "arrowhead-diamond",
  "arrowhead-dot",
  "arrowhead-none",
  "arrowhead-square",
  "arrowhead-triangle-inverted",
  "arrowhead-triangle",
  "blob",
  "bring-forward",
  "bring-to-front",
  "broken",
  "check-circle",
  "check",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "chevrons-ne",
  "chevrons-sw",
  "clipboard-copied",
  "clipboard-copy",
  "color",
  "cross-2",
  "cross-circle",
  "dash-dashed",
  "dash-dotted",
  "dash-draw",
  "dash-solid",
  "disconnected",
  "discord",
  "distribute-horizontal",
  "distribute-vertical",
  "dot",
  "dots-horizontal",
  "dots-vertical",
  "drag-handle-dots",
  "duplicate",
  "edit",
  "external-link",
  "fill-fill",
  "fill-none",
  "fill-pattern",
  "fill-semi",
  "fill-solid",
  "follow",
  "following",
  "font-draw",
  "font-mono",
  "font-sans",
  "font-serif",
  "geo-arrow-down",
  "geo-arrow-left",
  "geo-arrow-right",
  "geo-arrow-up",
  "geo-check-box",
  "geo-cloud",
  "geo-diamond",
  "geo-ellipse",
  "geo-heart",
  "geo-hexagon",
  "geo-octagon",
  "geo-oval",
  "geo-pentagon",
  "geo-rectangle",
  "geo-rhombus-2",
  "geo-rhombus",
  "geo-star",
  "geo-trapezoid",
  "geo-triangle",
  "geo-x-box",
  "github",
  "group",
  "horizontal-align-end",
  "horizontal-align-middle",
  "horizontal-align-start",
  "info-circle",
  "leading",
  "link",
  "lock",
  "menu",
  "minus",
  "mixed",
  "pack",
  "plus",
  "question-mark-circle",
  "question-mark",
  "redo",
  "reset-zoom",
  "rotate-ccw",
  "rotate-cw",
  "send-backward",
  "send-to-back",
  "share-1",
  "size-extra-large",
  "size-large",
  "size-medium",
  "size-small",
  "spline-cubic",
  "spline-line",
  "stack-horizontal",
  "stack-vertical",
  "status-offline",
  "stretch-horizontal",
  "stretch-vertical",
  "text-align-center",
  "text-align-left",
  "text-align-right",
  "toggle-off",
  "toggle-on",
  "tool-arrow",
  "tool-eraser",
  "tool-frame",
  "tool-hand",
  "tool-highlight",
  "tool-laser",
  "tool-line",
  "tool-media",
  "tool-note",
  "tool-pencil",
  "tool-pointer",
  "tool-screenshot",
  "tool-text",
  "trash",
  "twitter",
  "undo",
  "ungroup",
  "unlock",
  "vertical-align-end",
  "vertical-align-middle",
  "vertical-align-start",
  "warning-triangle",
  "zoom-in",
  "zoom-out"
];
let ul = {
  ...YI,
  icons: Object.fromEntries(
    eoe.map((t) => [t, `${Hs()}/icons/icon/0_merged.svg#${t}`])
  ),
  translations: Object.fromEntries(
    Jl.map((t) => [
      t.locale,
      `${Hs()}/translations/${t.locale}.json`
    ])
  ),
  embedIcons: Object.fromEntries(
    LS.map((t) => [
      t.type,
      `${Hs()}/embed-icons/${t.type}.png`
    ])
  )
};
function toe(t) {
  return t ? {
    fonts: Object.assign({ ...ul.fonts }, { ...t == null ? void 0 : t.fonts }),
    icons: Object.assign({ ...ul.icons }, { ...t == null ? void 0 : t.icons }),
    embedIcons: Object.assign({ ...ul.embedIcons }, { ...t == null ? void 0 : t.embedIcons }),
    translations: Object.assign(
      { ...ul.translations },
      { ...t == null ? void 0 : t.translations }
    )
  } : ul;
}
function noe() {
  const { addToast: t, removeToast: e, clearToasts: n } = Vr(), { addDialog: i, clearDialogs: r, removeDialog: s } = po(), a = Un() < Qt.TABLET_SM, c = ke();
  return yt(
    () => ({
      addToast: t,
      removeToast: e,
      clearToasts: n,
      addDialog: i,
      removeDialog: s,
      clearDialogs: r,
      msg: c,
      isMobile: a
    }),
    [i, t, r, n, c, s, e, a]
  );
}
function ioe(t, e) {
  const n = {};
  for (const i of t)
    if (i.translations)
      for (const [r, s] of Mi(i.translations)) {
        let o = n[r];
        o || (o = n[r] = {}), Object.assign(o, s);
      }
  return {
    actions: (i, r) => {
      for (const s of t)
        s.actions && (r = s.actions(i, r, e));
      return r;
    },
    tools: (i, r, s) => {
      for (const o of t)
        o.tools && (r = o.tools(i, r, { ...e, ...s }));
      return r;
    },
    translations: n
  };
}
function HO(t) {
  return yt(() => t, t);
}
function roe(t) {
  const e = HO(
    t == null ? [] : Array.isArray(t) ? t : [t]
  );
  return yt(() => {
    const n = {};
    for (const i of e)
      if (i.translations)
        for (const [r, s] of Mi(i.translations)) {
          let o = n[r];
          o || (o = n[r] = {}), Object.assign(o, s);
        }
    return n;
  }, [e]);
}
function soe(t) {
  const e = noe(), n = HO(
    t == null ? [] : Array.isArray(t) ? t : [t]
  );
  return yt(
    () => ioe(n, e),
    [n, e]
  );
}
var Dj = "Popover", [VO, fye] = bc(Dj, [
  Cc
]), Gd = Cc(), [ooe, yo] = VO(Dj), KO = (t) => {
  const {
    __scopePopover: e,
    children: n,
    open: i,
    defaultOpen: r,
    onOpenChange: s,
    modal: o = !1
  } = t, a = Gd(e), c = N.useRef(null), [d, u] = N.useState(!1), [h = !1, g] = go({
    prop: i,
    defaultProp: r,
    onChange: s
  });
  return /* @__PURE__ */ l.jsx(Od, { ...a, children: /* @__PURE__ */ l.jsx(
    ooe,
    {
      scope: e,
      contentId: dr(),
      triggerRef: c,
      open: h,
      onOpenChange: g,
      onOpenToggle: N.useCallback(() => g((p) => !p), [g]),
      hasCustomAnchor: d,
      onCustomAnchorAdd: N.useCallback(() => u(!0), []),
      onCustomAnchorRemove: N.useCallback(() => u(!1), []),
      modal: o,
      children: n
    }
  ) });
};
KO.displayName = Dj;
var XO = "PopoverAnchor", aoe = N.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...i } = t, r = yo(XO, n), s = Gd(n), { onCustomAnchorAdd: o, onCustomAnchorRemove: a } = r;
    return N.useEffect(() => (o(), () => a()), [o, a]), /* @__PURE__ */ l.jsx(tf, { ...s, ...i, ref: e });
  }
);
aoe.displayName = XO;
var JO = "PopoverTrigger", qO = N.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...i } = t, r = yo(JO, n), s = Gd(n), o = it(e, r.triggerRef), a = /* @__PURE__ */ l.jsx(
      Fe.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": nP(r.open),
        ...i,
        ref: o,
        onClick: se(t.onClick, r.onOpenToggle)
      }
    );
    return r.hasCustomAnchor ? a : /* @__PURE__ */ l.jsx(tf, { asChild: !0, ...s, children: a });
  }
);
qO.displayName = JO;
var wj = "PopoverPortal", [coe, loe] = VO(wj, {
  forceMount: void 0
}), _O = (t) => {
  const { __scopePopover: e, forceMount: n, children: i, container: r } = t, s = yo(wj, e);
  return /* @__PURE__ */ l.jsx(coe, { scope: e, forceMount: n, children: /* @__PURE__ */ l.jsx(jr, { present: n || s.open, children: /* @__PURE__ */ l.jsx(Td, { asChild: !0, container: r, children: i }) }) });
};
_O.displayName = wj;
var ic = "PopoverContent", $O = N.forwardRef(
  (t, e) => {
    const n = loe(ic, t.__scopePopover), { forceMount: i = n.forceMount, ...r } = t, s = yo(ic, t.__scopePopover);
    return /* @__PURE__ */ l.jsx(jr, { present: i || s.open, children: s.modal ? /* @__PURE__ */ l.jsx(doe, { ...r, ref: e }) : /* @__PURE__ */ l.jsx(uoe, { ...r, ref: e }) });
  }
);
$O.displayName = ic;
var doe = N.forwardRef(
  (t, e) => {
    const n = yo(ic, t.__scopePopover), i = N.useRef(null), r = it(e, i), s = N.useRef(!1);
    return N.useEffect(() => {
      const o = i.current;
      if (o) return Wp(o);
    }, []), /* @__PURE__ */ l.jsx(Gp, { as: eo, allowPinchZoom: !0, children: /* @__PURE__ */ l.jsx(
      eP,
      {
        ...t,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: se(t.onCloseAutoFocus, (o) => {
          var a;
          o.preventDefault(), s.current || (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: se(
          t.onPointerDownOutside,
          (o) => {
            const a = o.detail.originalEvent, c = a.button === 0 && a.ctrlKey === !0, d = a.button === 2 || c;
            s.current = d;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: se(
          t.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), uoe = N.forwardRef(
  (t, e) => {
    const n = yo(ic, t.__scopePopover), i = N.useRef(!1), r = N.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      eP,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var o, a;
          (o = t.onCloseAutoFocus) == null || o.call(t, s), s.defaultPrevented || (i.current || (a = n.triggerRef.current) == null || a.focus(), s.preventDefault()), i.current = !1, r.current = !1;
        },
        onInteractOutside: (s) => {
          var c, d;
          (c = t.onInteractOutside) == null || c.call(t, s), s.defaultPrevented || (i.current = !0, s.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const o = s.target;
          ((d = n.triggerRef.current) == null ? void 0 : d.contains(o)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && r.current && s.preventDefault();
        }
      }
    );
  }
), eP = N.forwardRef(
  (t, e) => {
    const {
      __scopePopover: n,
      trapFocus: i,
      onOpenAutoFocus: r,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: o,
      onEscapeKeyDown: a,
      onPointerDownOutside: c,
      onFocusOutside: d,
      onInteractOutside: u,
      ...h
    } = t, g = yo(ic, n), p = Gd(n);
    return jS(), /* @__PURE__ */ l.jsx(
      Ad,
      {
        asChild: !0,
        loop: !0,
        trapped: i,
        onMountAutoFocus: r,
        onUnmountAutoFocus: s,
        children: /* @__PURE__ */ l.jsx(
          Nd,
          {
            asChild: !0,
            disableOutsidePointerEvents: o,
            onInteractOutside: u,
            onEscapeKeyDown: a,
            onPointerDownOutside: c,
            onFocusOutside: d,
            onDismiss: () => g.onOpenChange(!1),
            children: /* @__PURE__ */ l.jsx(
              WS,
              {
                "data-state": nP(g.open),
                role: "dialog",
                id: g.contentId,
                ...p,
                ...h,
                ref: e,
                style: {
                  ...h.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), tP = "PopoverClose", hoe = N.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...i } = t, r = yo(tP, n);
    return /* @__PURE__ */ l.jsx(
      Fe.button,
      {
        type: "button",
        ...i,
        ref: e,
        onClick: se(t.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
hoe.displayName = tP;
var goe = "PopoverArrow", poe = N.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...i } = t, r = Gd(n);
    return /* @__PURE__ */ l.jsx(HS, { ...r, ...i, ref: e });
  }
);
poe.displayName = goe;
function nP(t) {
  return t ? "open" : "closed";
}
var Nj = KO, Aj = qO, Tj = _O, bj = $O;
function Gn({ id: t, children: e, onOpenChange: n, open: i }) {
  const [r, s] = Nr(t, n);
  return /* @__PURE__ */ l.jsx(
    Nj,
    {
      onOpenChange: s,
      open: i || r,
      children: /* @__PURE__ */ l.jsx("div", { className: "tlui-popover", children: e })
    }
  );
}
function Wn({ children: t }) {
  return /* @__PURE__ */ l.jsx(Aj, { asChild: !0, dir: "ltr", children: t });
}
function Hn({
  side: t,
  children: e,
  align: n = "center",
  sideOffset: i = 8,
  alignOffset: r = 0,
  disableEscapeKeyDown: s = !1
}) {
  const o = qt();
  return /* @__PURE__ */ l.jsx(Tj, { container: o, children: /* @__PURE__ */ l.jsx(
    bj,
    {
      className: "tlui-popover__content",
      side: t,
      sideOffset: i,
      align: n,
      alignOffset: r,
      dir: "ltr",
      onEscapeKeyDown: (a) => s && a.preventDefault(),
      children: e
    }
  ) });
}
function foe(t) {
  return t.getSelectedShapeIds().map((i) => t.getShape(i)).filter((i) => {
    if (!i) return !1;
    if (t.isShapeOfType(i, "arrow")) {
      const r = li(t, i);
      if (r.start || r.end) return !1;
    }
    return !0;
  });
}
const iP = () => {
  const t = Q();
  return G("threeStackableItems", () => foe(t).length > 2, [t]);
}, Di = () => {
  const t = Q();
  return G("isInSelectState", () => t.isIn("select"), [t]);
}, vj = () => {
  const t = Q();
  return G(
    "allow group",
    () => {
      const e = t.getSelectedShapes();
      if (e.length < 2) return !1;
      for (const n of e)
        if (t.isShapeOfType(n, "arrow")) {
          const i = li(t, n);
          if (i.start && !e.some((r) => r.id === i.start.toId) || i.end && !e.some((r) => r.id === i.end.toId))
            return !1;
        }
      return !0;
    },
    [t]
  );
}, Ej = () => {
  const t = Q();
  return G(
    "allowUngroup",
    () => t.getSelectedShapeIds().some((e) => {
      var n;
      return ((n = t.getShape(e)) == null ? void 0 : n.type) === "group";
    }),
    [t]
  );
}, Moe = typeof window < "u" && "navigator" in window && !!navigator.clipboard && !!navigator.clipboard.read;
function rP(t, e) {
  const n = Q();
  return G(
    "selectedShapes",
    () => n.getSelectedShapes().length >= t,
    [n, t, e]
  );
}
function $t(t, e) {
  const n = Q();
  return G(
    "selectedShapes",
    () => {
      const i = n.getSelectedShapes().filter((r) => !n.isShapeOrAncestorLocked(r)).length;
      return t === void 0 ? i : i >= t;
    },
    [n]
  );
}
function moe() {
  const t = Q();
  return G(
    "showAutoSizeToggle",
    () => {
      const e = t.getSelectedShapes();
      return e.length === 1 && t.isShapeOfType(e[0], "text") && e[0].props.autoSize === !1;
    },
    [t]
  );
}
function sP() {
  const t = Q();
  return G(
    "hasLinkShapeSelected",
    () => {
      const e = t.getOnlySelectedShape();
      return !!(e && e.type !== "embed" && "url" in e.props && !e.isLocked);
    },
    [t]
  );
}
function yoe() {
  const t = Q();
  return G(
    "onlyFlippableShape",
    () => {
      const e = t.getOnlySelectedShape();
      return e && (t.isShapeOfType(e, "group") || t.isShapeOfType(e, "image") || t.isShapeOfType(e, "arrow") || t.isShapeOfType(e, "line") || t.isShapeOfType(e, "draw"));
    },
    [t]
  );
}
function jf() {
  const t = Q();
  return G("useCanRedo", () => t.getCanRedo(), [t]);
}
function Df() {
  const t = Q();
  return G("useCanUndo", () => t.getCanUndo(), [t]);
}
function Ioe() {
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(Cj, {}),
    /* @__PURE__ */ l.jsx(xoe, {}),
    /* @__PURE__ */ l.jsx(Soe, {}),
    /* @__PURE__ */ l.jsx(joe, {}),
    /* @__PURE__ */ l.jsx(Doe, {}),
    /* @__PURE__ */ l.jsx(Aoe, {}),
    /* @__PURE__ */ l.jsx(Toe, {}),
    /* @__PURE__ */ l.jsx(boe, {})
  ] });
}
function Cj() {
  const t = $t(2), e = Di(), n = t && e;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(V, { actionId: "align-left", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "align-center-horizontal", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "align-right", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "stretch-horizontal", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "align-top", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "align-center-vertical", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "align-bottom", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "stretch-vertical", disabled: !n })
  ] });
}
function xoe() {
  const t = $t(3), e = Di(), n = t && e;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(V, { actionId: "distribute-horizontal", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "distribute-vertical", disabled: !n })
  ] });
}
function Soe() {
  const t = iP(), e = Di(), n = t && e;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(V, { actionId: "stack-horizontal", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "stack-vertical", disabled: !n })
  ] });
}
function joe() {
  const t = $t(1), e = Di(), n = t && e;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(V, { actionId: "send-to-back", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "send-backward", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "bring-forward", disabled: !n }),
    /* @__PURE__ */ l.jsx(V, { actionId: "bring-to-front", disabled: !n })
  ] });
}
function Doe() {
  return Un() < Qt.TABLET_SM ? /* @__PURE__ */ l.jsx(woe, {}) : /* @__PURE__ */ l.jsx(Noe, {});
}
function woe() {
  const t = Q(), e = G("zoom is 1", () => t.getZoomLevel() === 1, [t]);
  return /* @__PURE__ */ l.jsx(V, { actionId: "zoom-to-100", disabled: e });
}
function Noe() {
  const t = $t(1), e = Di(), n = t && e;
  return /* @__PURE__ */ l.jsx(V, { actionId: "rotate-ccw", disabled: !n });
}
function Aoe() {
  const t = $t(1), e = Di(), n = t && e;
  return /* @__PURE__ */ l.jsx(V, { actionId: "rotate-cw", disabled: !n });
}
function Toe() {
  const t = sP(), e = Di(), n = t && e;
  return /* @__PURE__ */ l.jsx(V, { actionId: "edit-link", disabled: !n });
}
function boe() {
  const t = vj(), e = Ej();
  return t ? /* @__PURE__ */ l.jsx(BN, {}) : e ? /* @__PURE__ */ l.jsx(voe, {}) : /* @__PURE__ */ l.jsx(BN, {});
}
function BN() {
  const t = $t(2), e = Di(), n = t && e;
  return /* @__PURE__ */ l.jsx(V, { actionId: "group", disabled: !n });
}
function voe() {
  return /* @__PURE__ */ l.jsx(V, { actionId: "ungroup" });
}
const Eoe = _e(function({
  children: e
}) {
  const n = ke(), i = Un(), r = ji(), s = le(null);
  uo(s);
  const o = Q(), a = G(
    "should display quick actions when in readonly",
    () => o.isInAny("hand", "zoom"),
    [o]
  ), c = e ?? /* @__PURE__ */ l.jsx(Ioe, {});
  if (!(r && !a))
    return /* @__PURE__ */ l.jsxs(Gn, { id: "actions-menu", children: [
      /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
        q,
        {
          type: "icon",
          "data-testid": "actions-menu.button",
          title: n("actions-menu.title"),
          children: /* @__PURE__ */ l.jsx(Te, { icon: "dots-vertical", small: !0 })
        }
      ) }),
      /* @__PURE__ */ l.jsx(
        Hn,
        {
          side: i >= Qt.TABLET ? "bottom" : "top",
          sideOffset: 6,
          children: /* @__PURE__ */ l.jsx(
            "div",
            {
              ref: s,
              className: "tlui-actions-menu tlui-buttons__grid",
              "data-testid": "actions-menu.content",
              children: /* @__PURE__ */ l.jsx(yn, { type: "icons", sourceId: "actions-menu", children: c })
            }
          )
        }
      )
    ] });
});
function Ce({ id: t, label: e, children: n }) {
  const { type: i, sourceId: r } = uf(), s = ke(), o = _l(e, i), a = o ? s(o) : void 0;
  switch (i) {
    case "panel":
      return /* @__PURE__ */ l.jsx("div", { className: "tlui-menu__group", "data-testid": `${r}-group.${t}`, children: n });
    case "menu":
      return /* @__PURE__ */ l.jsx(Bne, { "data-testid": `${r}-group.${t}`, children: n });
    case "context-menu":
      return /* @__PURE__ */ l.jsx(
        NL,
        {
          dir: "ltr",
          className: "tlui-menu__group",
          "data-testid": `${r}-group.${t}`,
          children: n
        }
      );
    case "keyboard-shortcuts":
      return /* @__PURE__ */ l.jsxs("div", { className: "tlui-shortcuts-dialog__group", "data-testid": `${r}-group.${t}`, children: [
        /* @__PURE__ */ l.jsx("h2", { className: "tlui-shortcuts-dialog__group__title", children: a }),
        /* @__PURE__ */ l.jsx("div", { className: "tlui-shortcuts-dialog__group__content", children: n })
      ] });
    default:
      return n;
  }
}
function Rn({
  id: t,
  disabled: e = !1,
  label: n,
  size: i = "small",
  children: r
}) {
  const { type: s, sourceId: o } = uf(), a = qt(), c = ke(), d = n ? typeof n == "string" ? n : n[s] ?? n.default : void 0, u = d ? c(d) : void 0;
  switch (s) {
    case "menu":
      return /* @__PURE__ */ l.jsxs(Qne, { id: `${o}-sub.${t}`, children: [
        /* @__PURE__ */ l.jsx(
          Zne,
          {
            id: `${o}-sub.${u ? u.toLowerCase() + "-button" : ""}`,
            disabled: e,
            label: u,
            title: u
          }
        ),
        /* @__PURE__ */ l.jsx(
          Fne,
          {
            id: `${o}-sub.${u ? u.toLowerCase() + "-content" : ""}`,
            size: i,
            children: r
          }
        )
      ] });
    case "context-menu":
      return e ? null : /* @__PURE__ */ l.jsxs(Coe, { id: `${o}-sub.${t}`, children: [
        /* @__PURE__ */ l.jsx(vL, { dir: "ltr", disabled: e, asChild: !0, children: /* @__PURE__ */ l.jsxs(
          q,
          {
            "data-testid": `${o}-sub-trigger.${t}`,
            type: "menu",
            className: "tlui-menu__submenu__trigger",
            children: [
              /* @__PURE__ */ l.jsx(St, { children: u }),
              /* @__PURE__ */ l.jsx(Te, { icon: "chevron-right", small: !0 })
            ]
          }
        ) }),
        /* @__PURE__ */ l.jsx(nj, { container: a, children: /* @__PURE__ */ l.jsx(
          EL,
          {
            "data-testid": `${o}-sub-content.${t}`,
            className: "tlui-menu tlui-menu__submenu__content",
            alignOffset: -1,
            sideOffset: -4,
            collisionPadding: 4,
            "data-size": i,
            children: r
          }
        ) })
      ] });
    default:
      return r;
  }
}
function Coe({ id: t, children: e }) {
  const [n, i] = Nr(t);
  return /* @__PURE__ */ l.jsx(bL, { open: n, onOpenChange: i, children: e });
}
function oP() {
  return moe() ? /* @__PURE__ */ l.jsx(V, { actionId: "toggle-auto-size" }) : null;
}
function aP() {
  return sP() ? /* @__PURE__ */ l.jsx(V, { actionId: "edit-link" }) : null;
}
function zoe() {
  return $t(1) ? /* @__PURE__ */ l.jsx(V, { actionId: "duplicate" }) : null;
}
function cP() {
  const t = Q();
  return G(
    "should display flatten option",
    () => {
      if (t.getSelectedShapeIds().length === 0) return !1;
      const i = t.getOnlySelectedShape();
      return !(i && t.isShapeOfType(i, "image"));
    },
    [t]
  ) ? /* @__PURE__ */ l.jsx(V, { actionId: "flatten-to-image" }) : null;
}
function lP() {
  return vj() ? /* @__PURE__ */ l.jsx(V, { actionId: "group" }) : null;
}
function wf() {
  return Ej() ? /* @__PURE__ */ l.jsx(V, { actionId: "ungroup" }) : null;
}
function dP() {
  const t = Q();
  return G(
    "allow unframe",
    () => {
      const n = t.getSelectedShapes();
      return n.length === 0 ? !1 : n.every((i) => t.isShapeOfType(i, "frame"));
    },
    [t]
  ) ? /* @__PURE__ */ l.jsx(V, { actionId: "remove-frame" }) : null;
}
function uP() {
  const t = Q();
  return G(
    "allow fit frame to content",
    () => {
      const n = t.getOnlySelectedShape();
      return n ? t.isShapeOfType(n, "frame") && t.getSortedChildIdsForParent(n).length > 0 : !1;
    },
    [t]
  ) ? /* @__PURE__ */ l.jsx(V, { actionId: "fit-frame-to-content" }) : null;
}
function hP() {
  const t = Q();
  return G("selected shapes", () => t.getSelectedShapes().length > 0, [
    t
  ]) ? /* @__PURE__ */ l.jsx(V, { actionId: "toggle-lock" }) : null;
}
function zj() {
  const t = Q(), e = G(
    "isTransparentBg",
    () => !t.getInstanceState().exportBackground,
    [t]
  );
  return /* @__PURE__ */ l.jsx(
    wr,
    {
      actionId: "toggle-transparent",
      checked: e,
      toggle: !0
    }
  );
}
function Loe() {
  const t = Q(), e = G("any shapes", () => t.getCurrentPageShapeIds().size > 0, [
    t
  ]);
  return /* @__PURE__ */ l.jsx(V, { actionId: "unlock-all", disabled: !e });
}
function gP() {
  const t = Q(), e = G("zoomed to 100", () => t.getZoomLevel() === 1, [t]);
  return /* @__PURE__ */ l.jsx(V, { actionId: "zoom-to-100", noClose: !0, disabled: e });
}
function pP() {
  const t = Q(), e = G("has shapes", () => t.getCurrentPageShapeIds().size > 0, [t]);
  return /* @__PURE__ */ l.jsx(
    V,
    {
      actionId: "zoom-to-fit",
      disabled: !e,
      "data-testid": "minimap.zoom-menu.zoom-to-fit",
      noClose: !0
    }
  );
}
function fP() {
  const t = Q(), e = G("has shapes", () => t.getSelectedShapeIds().length > 0, [
    t
  ]);
  return /* @__PURE__ */ l.jsx(
    V,
    {
      actionId: "zoom-to-selection",
      disabled: !e,
      "data-testid": "minimap.zoom-menu.zoom-to-selection",
      noClose: !0
    }
  );
}
function Lj() {
  return /* @__PURE__ */ l.jsxs(Ce, { id: "clipboard", children: [
    /* @__PURE__ */ l.jsx(Ooe, {}),
    /* @__PURE__ */ l.jsx(Poe, {}),
    /* @__PURE__ */ l.jsx(Uoe, {}),
    /* @__PURE__ */ l.jsx(zoe, {}),
    /* @__PURE__ */ l.jsx(Roe, {})
  ] });
}
function koe() {
  var n;
  const t = Q(), e = G(
    "atLeastOneShapeOnPage",
    () => t.getCurrentPageShapeIds().size > 0,
    [t]
  );
  return /* @__PURE__ */ l.jsxs(
    Rn,
    {
      id: "copy-as",
      label: "context-menu.copy-as",
      size: "small",
      disabled: !e,
      children: [
        /* @__PURE__ */ l.jsxs(Ce, { id: "copy-as-group", children: [
          /* @__PURE__ */ l.jsx(V, { actionId: "copy-as-svg" }),
          !!((n = window.navigator.clipboard) != null && n.write) && /* @__PURE__ */ l.jsx(V, { actionId: "copy-as-png" }),
          /* @__PURE__ */ l.jsx(V, { actionId: "copy-as-json" })
        ] }),
        /* @__PURE__ */ l.jsx(Ce, { id: "copy-as-bg", children: /* @__PURE__ */ l.jsx(zj, {}) })
      ]
    }
  );
}
function Ooe() {
  const t = $t(1);
  return /* @__PURE__ */ l.jsx(V, { actionId: "cut", disabled: !t });
}
function Poe() {
  const t = rP(1);
  return /* @__PURE__ */ l.jsx(V, { actionId: "copy", disabled: !t });
}
function Uoe() {
  const t = Moe;
  return /* @__PURE__ */ l.jsx(V, { actionId: "paste", disabled: !t });
}
function MP() {
  const t = Q();
  return G(
    "atLeastOneShapeOnPage",
    () => t.getCurrentPageShapeIds().size > 0,
    [t]
  ) ? /* @__PURE__ */ l.jsxs(Ce, { id: "conversions", children: [
    /* @__PURE__ */ l.jsx(koe, {}),
    /* @__PURE__ */ l.jsxs(Rn, { id: "export-as", label: "context-menu.export-as", size: "small", children: [
      /* @__PURE__ */ l.jsxs(Ce, { id: "export-as-group", children: [
        /* @__PURE__ */ l.jsx(V, { actionId: "export-as-svg" }),
        /* @__PURE__ */ l.jsx(V, { actionId: "export-as-png" }),
        /* @__PURE__ */ l.jsx(V, { actionId: "export-as-json" })
      ] }),
      /* @__PURE__ */ l.jsx(Ce, { id: "export-as-bg", children: /* @__PURE__ */ l.jsx(zj, {}) })
    ] })
  ] }) : null;
}
function mP() {
  const t = Q(), e = G(
    "atLeastOneShapeOnPage",
    () => t.getCurrentPageShapeIds().size > 0,
    [t]
  );
  return /* @__PURE__ */ l.jsx(V, { actionId: "select-all", disabled: !e });
}
function Roe() {
  const t = $t(1);
  return /* @__PURE__ */ l.jsx(V, { actionId: "delete", disabled: !t });
}
function Yoe() {
  const t = ji();
  return !rP(1) || t ? null : /* @__PURE__ */ l.jsxs(Rn, { id: "edit", label: "context-menu.edit", size: "small", children: [
    /* @__PURE__ */ l.jsx(lP, {}),
    /* @__PURE__ */ l.jsx(wf, {}),
    /* @__PURE__ */ l.jsx(cP, {}),
    /* @__PURE__ */ l.jsx(aP, {}),
    /* @__PURE__ */ l.jsx(uP, {}),
    /* @__PURE__ */ l.jsx(dP, {}),
    /* @__PURE__ */ l.jsx(IP, {}),
    /* @__PURE__ */ l.jsx(yP, {}),
    /* @__PURE__ */ l.jsx(oP, {}),
    /* @__PURE__ */ l.jsx(hP, {})
  ] });
}
function Qoe() {
  const t = $t(2), e = yoe();
  return ji() || !(t || e) ? null : /* @__PURE__ */ l.jsxs(Rn, { id: "arrange", label: "context-menu.arrange", size: "small", children: [
    t && /* @__PURE__ */ l.jsxs(Ce, { id: "align", children: [
      /* @__PURE__ */ l.jsx(V, { actionId: "align-left" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "align-center-horizontal" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "align-right" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "align-top" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "align-center-vertical" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "align-bottom" })
    ] }),
    /* @__PURE__ */ l.jsx(Zoe, {}),
    t && /* @__PURE__ */ l.jsxs(Ce, { id: "stretch", children: [
      /* @__PURE__ */ l.jsx(V, { actionId: "stretch-horizontal" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "stretch-vertical" })
    ] }),
    (t || e) && /* @__PURE__ */ l.jsxs(Ce, { id: "flip", children: [
      /* @__PURE__ */ l.jsx(V, { actionId: "flip-horizontal" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "flip-vertical" })
    ] }),
    /* @__PURE__ */ l.jsx(Foe, {})
  ] });
}
function Zoe() {
  return $t(3) ? /* @__PURE__ */ l.jsxs(Ce, { id: "distribute", children: [
    /* @__PURE__ */ l.jsx(V, { actionId: "distribute-horizontal" }),
    /* @__PURE__ */ l.jsx(V, { actionId: "distribute-vertical" })
  ] }) : null;
}
function Foe() {
  const t = $t(2), e = iP();
  return t ? /* @__PURE__ */ l.jsxs(Ce, { id: "order", children: [
    /* @__PURE__ */ l.jsx(V, { actionId: "pack" }),
    e && /* @__PURE__ */ l.jsx(V, { actionId: "stack-horizontal" }),
    e && /* @__PURE__ */ l.jsx(V, { actionId: "stack-vertical" })
  ] }) : null;
}
function Boe() {
  const t = ji(), e = $t(1);
  return t || !e ? null : /* @__PURE__ */ l.jsx(Rn, { id: "reorder", label: "context-menu.reorder", size: "small", children: /* @__PURE__ */ l.jsxs(Ce, { id: "reorder", children: [
    /* @__PURE__ */ l.jsx(V, { actionId: "bring-to-front" }),
    /* @__PURE__ */ l.jsx(V, { actionId: "bring-forward" }),
    /* @__PURE__ */ l.jsx(V, { actionId: "send-backward" }),
    /* @__PURE__ */ l.jsx(V, { actionId: "send-to-back" })
  ] }) });
}
function Goe() {
  const t = Q(), e = G("pages", () => t.getPages(), [t]), n = G("current page id", () => t.getCurrentPageId(), [t]), { addToast: i } = Vr(), r = Zt(), s = ji();
  return !$t(1) || s ? null : /* @__PURE__ */ l.jsxs(Rn, { id: "move-to-page", label: "context-menu.move-to-page", size: "small", children: [
    /* @__PURE__ */ l.jsx(Ce, { id: "pages", children: e.map((a) => /* @__PURE__ */ l.jsx(
      Qe,
      {
        id: a.id,
        disabled: n === a.id,
        label: a.name.length > 30 ? `${a.name.slice(0, 30)}…` : a.name,
        onSelect: () => {
          t.markHistoryStoppingPoint("move_shapes_to_page"), t.moveShapesToPage(t.getSelectedShapeIds(), a.id);
          const c = t.getPage(a.id);
          c && i({
            title: "Changed Page",
            description: `Moved to ${c.name}.`,
            actions: [
              {
                label: "Go Back",
                type: "primary",
                onClick: () => {
                  t.markHistoryStoppingPoint("change-page"), t.setCurrentPage(n);
                }
              }
            ]
          }), r("move-to-page", { source: "context-menu" });
        }
      },
      a.id
    )) }),
    /* @__PURE__ */ l.jsx(Ce, { id: "new-page", children: /* @__PURE__ */ l.jsx(V, { actionId: "move-to-new-page" }) })
  ] });
}
function yP() {
  const t = Q();
  return G(
    "oneEmbedSelected",
    () => {
      const n = t.getOnlySelectedShape();
      return n ? !!(t.isShapeOfType(n, "embed") && n.props.url && !t.isShapeOrAncestorLocked(n)) : !1;
    },
    [t]
  ) ? /* @__PURE__ */ l.jsx(V, { actionId: "convert-to-bookmark" }) : null;
}
function IP() {
  const t = Q(), e = kS();
  return G(
    "oneEmbeddableBookmarkSelected",
    () => {
      const i = t.getOnlySelectedShape();
      return i ? !!(t.isShapeOfType(i, "bookmark") && i.props.url && e(i.props.url) && !t.isShapeOrAncestorLocked(i)) : !1;
    },
    [t]
  ) ? /* @__PURE__ */ l.jsx(V, { actionId: "convert-to-embed" }) : null;
}
function Woe() {
  const t = Q(), e = G("isSnapMode", () => t.user.getIsSnapMode(), [t]);
  return /* @__PURE__ */ l.jsx(wr, { actionId: "toggle-snap-mode", checked: e });
}
function Hoe() {
  const t = Q(), e = G("isToolLock", () => t.getInstanceState().isToolLocked, [t]);
  return /* @__PURE__ */ l.jsx(wr, { actionId: "toggle-tool-lock", checked: e });
}
function Voe() {
  const t = Q(), e = G("isGridMode", () => t.getInstanceState().isGridMode, [t]);
  return /* @__PURE__ */ l.jsx(wr, { actionId: "toggle-grid", checked: e });
}
function Koe() {
  const t = Q(), e = G("isWrapMode", () => t.user.getIsWrapMode(), [t]);
  return /* @__PURE__ */ l.jsx(wr, { actionId: "toggle-wrap-mode", checked: e });
}
function Xoe() {
  const t = Q(), e = G("isFocusMode", () => t.getInstanceState().isFocusMode, [t]);
  return /* @__PURE__ */ l.jsx(wr, { actionId: "toggle-focus-mode", checked: e });
}
function Joe() {
  const t = Q(), e = G("edgeScrollSpeed", () => t.user.getEdgeScrollSpeed(), [
    t
  ]);
  return /* @__PURE__ */ l.jsx(
    wr,
    {
      actionId: "toggle-edge-scrolling",
      checked: e === 1
    }
  );
}
function qoe() {
  const t = Q(), e = G("animationSpeed", () => t.user.getAnimationSpeed(), [t]);
  return /* @__PURE__ */ l.jsx(
    wr,
    {
      actionId: "toggle-reduce-motion",
      checked: e === 0
    }
  );
}
function _oe() {
  const t = Q(), e = G("isDebugMode", () => t.getInstanceState().isDebugMode, [t]);
  return /* @__PURE__ */ l.jsx(wr, { actionId: "toggle-debug-mode", checked: e });
}
function $oe() {
  const t = Q(), e = G(
    "dynamic resize",
    () => t.user.getIsDynamicResizeMode(),
    [t]
  );
  return /* @__PURE__ */ l.jsx(
    wr,
    {
      actionId: "toggle-dynamic-size-mode",
      checked: e
    }
  );
}
function eae() {
  const t = Q(), e = G("paste at cursor", () => t.user.getIsPasteAtCursorMode(), [
    t
  ]);
  return /* @__PURE__ */ l.jsx(wr, { actionId: "toggle-paste-at-cursor", checked: e });
}
function tae() {
  const t = Q();
  return G(
    "show cursor chat",
    () => t.getCurrentToolId() === "select" && !t.getInstanceState().isCoarsePointer,
    [t]
  ) ? /* @__PURE__ */ l.jsx(V, { actionId: "open-cursor-chat" }) : null;
}
function nae() {
  const t = Q(), e = qp(), n = G(
    "isSelectToolActive",
    () => t.getCurrentToolId() === "select",
    [t]
  ), i = G("isSinglePageMode", () => t.options.maxPages <= 1, [
    t
  ]);
  return n ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    e && /* @__PURE__ */ l.jsx(tae, {}),
    /* @__PURE__ */ l.jsxs(Ce, { id: "modify", children: [
      /* @__PURE__ */ l.jsx(Yoe, {}),
      /* @__PURE__ */ l.jsx(Qoe, {}),
      /* @__PURE__ */ l.jsx(Boe, {}),
      !i && /* @__PURE__ */ l.jsx(Goe, {})
    ] }),
    /* @__PURE__ */ l.jsx(Lj, {}),
    /* @__PURE__ */ l.jsx(MP, {}),
    /* @__PURE__ */ l.jsx(Ce, { id: "select-all", children: /* @__PURE__ */ l.jsx(mP, {}) })
  ] }) : null;
}
const iae = _e(function({
  children: e,
  disabled: n = !1
}) {
  const i = Q(), { Canvas: r } = At(), s = re(
    (u) => {
      if (u) {
        if (i.getInstanceState().isCoarsePointer) {
          const h = i.getSelectedShapes(), {
            inputs: { currentPagePoint: g }
          } = i, p = i.getShapesAtPoint(g);
          if (
            // if there are no selected shapes
            !i.getSelectedShapes().length || // OR if none of the shapes at the point include the selected shape
            !p.some((f) => h.includes(f))
          ) {
            const f = p.filter((M) => i.isShapeOrAncestorLocked(M));
            f.length && i.select(...f.map((M) => M.id));
          }
        }
      } else {
        const h = i.getOnlySelectedShape();
        h && i.isShapeOrAncestorLocked(h) && i.setSelectedShapes([]);
      }
    },
    [i]
  ), o = qt(), [a, c] = Nr("context menu", s), d = e ?? /* @__PURE__ */ l.jsx(nae, {});
  return /* @__PURE__ */ l.jsxs(Hee, { dir: "ltr", onOpenChange: c, modal: !1, children: [
    /* @__PURE__ */ l.jsx(Vee, { onContextMenu: void 0, dir: "ltr", disabled: n, children: r ? /* @__PURE__ */ l.jsx(r, {}) : null }),
    a && /* @__PURE__ */ l.jsx(Kee, { container: o, children: /* @__PURE__ */ l.jsx(
      Xee,
      {
        className: "tlui-menu scrollable",
        "data-testid": "context-menu",
        alignOffset: -4,
        collisionPadding: 4,
        onContextMenu: Ke,
        children: /* @__PURE__ */ l.jsx(yn, { type: "context-menu", sourceId: "context-menu", children: d })
      }
    ) })
  ] });
}), rae = 2e3, sae = 5e3, oae = Vt(function() {
  const e = Q(), { isChatting: n, chatMessage: i } = e.getInstanceState(), r = le(-1), [s, o] = pe("");
  return ze(() => {
    if (!n && i || n) {
      const c = n ? sae : rae;
      r.current = e.timers.setTimeout(() => {
        e.updateInstanceState({ chatMessage: "", isChatting: !1 }), o(""), e.focus();
      }, c);
    }
    return () => {
      clearTimeout(r.current);
    };
  }, [e, i, n]), n ? /* @__PURE__ */ l.jsx(cae, { value: s, setValue: o, chatMessage: i }) : i.trim() ? /* @__PURE__ */ l.jsx(aae, { chatMessage: i }) : null;
});
function xP(t) {
  const e = Q();
  at(() => {
    var o;
    if (!t.current) return;
    const { x: i, y: r } = e.inputs.currentScreenPoint;
    (o = t.current) == null || o.style.setProperty("transform", `translate(${i}px, ${r}px)`);
    function s(a) {
      var u;
      const { minX: c, minY: d } = e.getViewportScreenBounds();
      (u = t.current) == null || u.style.setProperty(
        "transform",
        `translate(${a.clientX - c}px, ${a.clientY - d}px)`
      );
    }
    return window.addEventListener("pointermove", s), () => {
      window.removeEventListener("pointermove", s);
    };
  }, [t, e]);
}
const aae = ({ chatMessage: t }) => {
  const e = Q(), n = le(null);
  return xP(n), /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: n,
      className: "tl-cursor-chat tl-cursor-chat__bubble",
      style: { backgroundColor: e.user.getColor() },
      children: t
    }
  );
}, cae = Vt(function({
  chatMessage: e,
  value: n,
  setValue: i
}) {
  const r = Q(), s = ke(), o = le(null), a = e || s("cursor-chat.type-to-chat");
  xP(o), at(() => {
    const g = o.current;
    if (!g) return;
    const p = r.textMeasure.measureText(n || a, {
      fontFamily: "var(--font-body)",
      fontSize: 12,
      fontWeight: "500",
      fontStyle: "normal",
      maxWidth: null,
      lineHeight: 1,
      padding: "6px"
    });
    g.style.setProperty("width", p.w + "px");
  }, [r, n, a]), at(() => {
    const g = r.timers.requestAnimationFrame(() => {
      var p;
      (p = o.current) == null || p.focus();
    });
    return () => {
      cancelAnimationFrame(g);
    };
  }, [r]);
  const c = re(() => {
    r.updateInstanceState({ isChatting: !1 }), r.focus();
  }, [r]), d = re(
    (g) => {
      const { value: p } = g.target;
      i(p.slice(0, 64)), r.updateInstanceState({ chatMessage: p });
    },
    [r, i]
  ), u = re(
    (g) => {
      const p = o.current;
      if (!p) return;
      const { value: f } = p;
      switch (g.key) {
        case "Enter": {
          if (Ke(g), g.stopPropagation(), !f) {
            c();
            return;
          }
          i("");
          break;
        }
        case "Escape": {
          Ke(g), g.stopPropagation(), c();
          break;
        }
      }
    },
    [c, i]
  ), h = re((g) => {
    g.stopPropagation();
  }, []);
  return /* @__PURE__ */ l.jsx(
    "input",
    {
      ref: o,
      className: "tl-cursor-chat",
      style: { backgroundColor: r.user.getColor() },
      onBlur: c,
      onChange: d,
      onKeyDown: u,
      onPaste: h,
      value: n,
      placeholder: a,
      spellCheck: !1
    }
  );
});
function sd({ checked: t }) {
  return /* @__PURE__ */ l.jsx(Ui, { icon: t ? "check" : "none", className: "tlui-button__icon", small: !0 });
}
function lae() {
  const t = Q(), { addToast: e } = Vr(), { addDialog: n } = po(), [i, r] = Ye.useState(!1);
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(Ce, { id: "items", children: [
      /* @__PURE__ */ l.jsx(
        Qe,
        {
          id: "add-toast",
          onSelect: () => {
            e({
              id: ht(),
              title: "Something good happened",
              description: "Hey, attend to this thing over here. It might be important!",
              keepOpen: !0,
              severity: "success"
              // icon?: string
              // title?: string
              // description?: string
              // actions?: TLUiToastAction[]
            }), e({
              id: ht(),
              title: "Something happened",
              description: "Hey, attend to this thing over here. It might be important!",
              keepOpen: !0,
              severity: "info",
              actions: [
                {
                  label: "Primary",
                  type: "primary",
                  onClick: () => {
                  }
                },
                {
                  label: "Normal",
                  type: "normal",
                  onClick: () => {
                  }
                },
                {
                  label: "Danger",
                  type: "danger",
                  onClick: () => {
                  }
                }
              ]
              // icon?: string
              // title?: string
              // description?: string
              // actions?: TLUiToastAction[]
            }), e({
              id: ht(),
              title: "Something maybe bad happened",
              description: "Hey, attend to this thing over here. It might be important!",
              keepOpen: !0,
              severity: "warning",
              actions: [
                {
                  label: "Primary",
                  type: "primary",
                  onClick: () => {
                  }
                },
                {
                  label: "Normal",
                  type: "normal",
                  onClick: () => {
                  }
                },
                {
                  label: "Danger",
                  type: "danger",
                  onClick: () => {
                  }
                }
              ]
            }), e({
              id: ht(),
              title: "Something bad happened",
              severity: "error",
              keepOpen: !0
            });
          },
          label: "Show toast"
        }
      ),
      /* @__PURE__ */ l.jsx(
        Qe,
        {
          id: "show-dialog",
          label: "Show dialog",
          onSelect: () => {
            n({
              component: ({ onClose: s }) => /* @__PURE__ */ l.jsx(
                hae,
                {
                  displayDontShowAgain: !0,
                  onCancel: () => s(),
                  onContinue: () => s()
                }
              ),
              onClose: () => {
              }
            });
          }
        }
      ),
      /* @__PURE__ */ l.jsx(
        Qe,
        {
          id: "create-shapes",
          label: "Create 100 shapes",
          onSelect: () => gae(t, 100)
        }
      ),
      /* @__PURE__ */ l.jsx(
        Qe,
        {
          id: "count-nodes",
          label: "Count shapes / nodes",
          onSelect: () => {
            var a;
            const s = t.getSelectedShapes(), o = s.length === 0 ? t.getRenderingShapes() : s;
            window.alert(
              `Shapes ${o.length}, DOM nodes:${(a = document.querySelector(".tl-shapes").querySelectorAll("*")) == null ? void 0 : a.length}`
            );
          }
        }
      ),
      (() => {
        if (i) throw Error("oh no!");
        return null;
      })(),
      /* @__PURE__ */ l.jsx(Qe, { id: "throw-error", onSelect: () => r(!0), label: "Throw error" }),
      /* @__PURE__ */ l.jsx(Qe, { id: "hard-reset", onSelect: Zv, label: "Hard reset" })
    ] }),
    /* @__PURE__ */ l.jsxs(Ce, { id: "flags", children: [
      /* @__PURE__ */ l.jsx(dae, {}),
      /* @__PURE__ */ l.jsx(uae, {})
    ] })
  ] });
}
function dae() {
  const t = Object.values(Wt);
  return t.length ? /* @__PURE__ */ l.jsx(Rn, { id: "debug flags", label: "Debug Flags", children: /* @__PURE__ */ l.jsx(Ce, { id: "debug flags", children: t.map((e) => /* @__PURE__ */ l.jsx(SP, { flag: e }, e.name)) }) }) : null;
}
function uae() {
  const t = Object.values(VW);
  return t.length ? /* @__PURE__ */ l.jsx(Rn, { id: "feature flags", label: "Feature Flags", children: /* @__PURE__ */ l.jsx(Ce, { id: "feature flags", children: t.map((e) => /* @__PURE__ */ l.jsx(SP, { flag: e }, e.name)) }) }) : null;
}
function hae({
  title: t = "title",
  body: e = "hello hello hello",
  cancel: n = "Cancel",
  confirm: i = "Continue",
  displayDontShowAgain: r = !1,
  onCancel: s,
  onContinue: o
}) {
  const [a, c] = Ye.useState(!1);
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(Ed, { children: [
      /* @__PURE__ */ l.jsx(Cd, { children: t }),
      /* @__PURE__ */ l.jsx(zd, {})
    ] }),
    /* @__PURE__ */ l.jsx(Ja, { style: { maxWidth: 350 }, children: e }),
    /* @__PURE__ */ l.jsxs(Xp, { className: "tlui-dialog__footer__actions", children: [
      r && /* @__PURE__ */ l.jsxs(
        q,
        {
          type: "normal",
          onClick: () => c(!a),
          style: { marginRight: "auto" },
          children: [
            /* @__PURE__ */ l.jsx(sd, { checked: a }),
            /* @__PURE__ */ l.jsx(St, { children: "Don’t show again" })
          ]
        }
      ),
      /* @__PURE__ */ l.jsx(q, { type: "normal", onClick: s, children: /* @__PURE__ */ l.jsx(St, { children: n }) }),
      /* @__PURE__ */ l.jsx(q, { type: "primary", onClick: async () => o(), children: /* @__PURE__ */ l.jsx(St, { children: i }) })
    ] })
  ] });
}
const SP = Vt(function({
  flag: e,
  onChange: n
}) {
  const i = e.get();
  return /* @__PURE__ */ l.jsx(
    hf,
    {
      id: e.name,
      title: e.name,
      label: e.name.replace(/([a-z0-9])([A-Z])/g, (r) => `${r[0]} ${r[1].toLowerCase()}`).replace(/^[a-z]/, (r) => r.toUpperCase()),
      checked: i,
      onSelect: () => {
        e.set(!i), n == null || n(!i);
      }
    }
  );
});
let GN = 0;
function gae(t, e) {
  const n = Array(e), i = Math.floor(Math.sqrt(e));
  for (let r = 0; r < e; r++)
    GN++, n[r] = {
      id: Ee("box" + GN),
      type: "geo",
      x: r % i * 132,
      y: Math.floor(r / i) * 132
    };
  t.run(() => {
    t.createShapes(n).setSelectedShapes(n.map((r) => r.id));
  });
}
function pae({ children: t }) {
  const e = t ?? /* @__PURE__ */ l.jsx(lae, {});
  return /* @__PURE__ */ l.jsxs(mr, { id: "debug", children: [
    /* @__PURE__ */ l.jsx(yr, { children: /* @__PURE__ */ l.jsx(q, { type: "icon", title: "Debug menu", children: /* @__PURE__ */ l.jsx(Te, { icon: "dots-horizontal" }) }) }),
    /* @__PURE__ */ l.jsx(Ir, { side: "top", align: "end", alignOffset: 0, children: /* @__PURE__ */ l.jsx(yn, { type: "menu", sourceId: "debug-panel", children: e }) })
  ] });
}
const fae = _e(function() {
  const { DebugMenu: e } = Io(), n = le(null);
  return uo(n), /* @__PURE__ */ l.jsxs("div", { ref: n, className: "tlui-debug-panel", children: [
    /* @__PURE__ */ l.jsx(mae, {}),
    /* @__PURE__ */ l.jsx(yae, {}),
    e && /* @__PURE__ */ l.jsx(e, {})
  ] });
});
function Mae(t = !0) {
  const [e, n] = pe(0), i = Q();
  ze(() => {
    if (!t) return;
    const r = () => n((s) => s + 1);
    return i.on("tick", r), () => {
      i.off("tick", r);
    };
  }, [i, t]);
}
const mae = Vt(function() {
  Mae();
  const e = Q(), n = e.getPath(), i = e.getHoveredShape(), r = e.getOnlySelectedShape(), s = n === "select.idle" || !n.includes("select.") ? i : r, o = s && n.includes("select.") ? ` / ${s.type || ""}${"geo" in s.props ? " / " + s.props.geo : ""} / [${x.ToInt(e.getPointInShapeSpace(s, e.inputs.currentPagePoint))}]` : "", a = n.startsWith("select.") && !n.includes(".idle") ? ` / [${x.ToInt(e.inputs.originPagePoint)}] → [${x.ToInt(
    e.inputs.currentPagePoint
  )}] = ${x.Dist(e.inputs.originPagePoint, e.inputs.currentPagePoint).toFixed(0)}` : "";
  return /* @__PURE__ */ l.jsx("div", { className: "tlui-debug-panel__current-state", children: `${n}${o}${a}` });
});
function yae() {
  const t = Q(), e = G("show_fps", () => Wt.showFps.get(), [Wt]), n = le(null);
  return ze(() => {
    if (!e) return;
    const i = 250;
    let r = 0, s = -1, o = performance.now(), a = 0, c = 0, d = !1;
    function u() {
      if (c++, a = performance.now() - o, a > i) {
        const h = Math.round(
          c * (i / a) * (1e3 / i)
        );
        h > r && (r = h);
        const g = r * 0.75;
        (h < g && !d || h >= g && d) && (d = !d), n.current.innerHTML = `FPS ${h.toString()}`, n.current.className = "tlui-debug-panel__fps" + (d ? " tlui-debug-panel__fps__slow" : ""), a -= i, c = 0, o = performance.now();
      }
      s = t.timers.requestAnimationFrame(u);
    }
    return u(), () => {
      cancelAnimationFrame(s);
    };
  }, [e, t]), e ? /* @__PURE__ */ l.jsx("div", { ref: n }) : null;
}
const Iae = _e(function() {
  const e = Un(), n = le(null);
  uo(n);
  const { MainMenu: i, QuickActions: r, ActionsMenu: s, PageMenu: o } = Io(), a = Q(), c = G("isSinglePageMode", () => a.options.maxPages <= 1, [
    a
  ]), d = a.options.actionShortcutsLocation === "menu" ? !0 : a.options.actionShortcutsLocation === "toolbar" ? !1 : e >= Qt.TABLET;
  return !i && !o && !d ? null : /* @__PURE__ */ l.jsx("div", { ref: n, className: "tlui-menu-zone", children: /* @__PURE__ */ l.jsxs("div", { className: "tlui-buttons__horizontal", children: [
    i && /* @__PURE__ */ l.jsx(i, {}),
    o && !c && /* @__PURE__ */ l.jsx(o, {}),
    d ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      r && /* @__PURE__ */ l.jsx(r, {}),
      s && /* @__PURE__ */ l.jsx(s, {})
    ] }) : null
  ] }) });
});
function xae() {
  const t = Q(), e = _t(), [n, i] = pe(!1), r = le(!1);
  return Vs(
    "toggle showback to content",
    () => {
      const s = r.current, o = t.getCurrentPageShapeIds();
      let a = !1;
      o.size && (a = o.size === t.getCulledShapes().size), s !== a && (i(a), r.current = a);
    },
    [t]
  ), n ? /* @__PURE__ */ l.jsx(
    V,
    {
      actionId: "back-to-content",
      onSelect: () => {
        e["back-to-content"].onSelect("helper-buttons"), i(!1);
      }
    }
  ) : null;
}
function Sae() {
  const t = Q();
  return G("is pen mode", () => t.getInstanceState().isPenMode, [t]) ? /* @__PURE__ */ l.jsx(V, { actionId: "exit-pen-mode" }) : null;
}
function jae() {
  const t = Q(), e = _t();
  return G(
    "is following user",
    () => !!t.getInstanceState().followingUserId,
    [t]
  ) ? /* @__PURE__ */ l.jsx(Qe, { ...e["stop-following"] }) : null;
}
function Dae() {
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(Sae, {}),
    /* @__PURE__ */ l.jsx(xae, {}),
    /* @__PURE__ */ l.jsx(jae, {})
  ] });
}
function wae({ children: t }) {
  const e = t ?? /* @__PURE__ */ l.jsx(Dae, {});
  return /* @__PURE__ */ l.jsx("div", { className: "tlui-helper-buttons", children: /* @__PURE__ */ l.jsx(yn, { type: "helper-buttons", sourceId: "helper-buttons", children: e }) });
}
function Nae() {
  const t = qp();
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(Ce, { label: "shortcuts-dialog.tools", id: "tools", children: [
      /* @__PURE__ */ l.jsx(V, { actionId: "toggle-tool-lock" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "insert-media" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "select" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "draw" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "eraser" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "hand" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "rectangle" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "ellipse" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "arrow" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "line" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "text" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "frame" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "note" }),
      /* @__PURE__ */ l.jsx(ii, { toolId: "laser" }),
      /* @__PURE__ */ l.jsx(
        Qe,
        {
          id: "pointer-down",
          label: "tool.pointer-down",
          kbd: ",",
          onSelect: () => {
          }
        }
      )
    ] }),
    /* @__PURE__ */ l.jsxs(Ce, { label: "shortcuts-dialog.preferences", id: "preferences", children: [
      /* @__PURE__ */ l.jsx(V, { actionId: "toggle-dark-mode" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "toggle-focus-mode" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "toggle-grid" })
    ] }),
    /* @__PURE__ */ l.jsxs(Ce, { label: "shortcuts-dialog.edit", id: "edit", children: [
      /* @__PURE__ */ l.jsx(V, { actionId: "undo" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "redo" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "cut" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "copy" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "paste" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "select-all" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "delete" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "duplicate" })
    ] }),
    /* @__PURE__ */ l.jsxs(Ce, { label: "shortcuts-dialog.view", id: "view", children: [
      /* @__PURE__ */ l.jsx(V, { actionId: "zoom-in" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "zoom-out" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "zoom-to-100" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "zoom-to-fit" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "zoom-to-selection" })
    ] }),
    /* @__PURE__ */ l.jsxs(Ce, { label: "shortcuts-dialog.transform", id: "transform", children: [
      /* @__PURE__ */ l.jsx(V, { actionId: "bring-to-front" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "bring-forward" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "send-backward" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "send-to-back" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "group" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "ungroup" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "flip-horizontal" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "flip-vertical" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "align-top" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "align-center-vertical" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "align-bottom" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "align-left" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "align-center-horizontal" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "align-right" })
    ] }),
    t && /* @__PURE__ */ l.jsx(Ce, { label: "shortcuts-dialog.collaboration", id: "collaboration", children: /* @__PURE__ */ l.jsx(V, { actionId: "open-cursor-chat" }) })
  ] });
}
const Aae = _e(function({
  children: e
}) {
  const n = ke(), i = Un(), r = e ?? /* @__PURE__ */ l.jsx(Nae, {});
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(Ed, { className: "tlui-shortcuts-dialog__header", children: [
      /* @__PURE__ */ l.jsx(Cd, { children: n("shortcuts-dialog.title") }),
      /* @__PURE__ */ l.jsx(zd, {})
    ] }),
    /* @__PURE__ */ l.jsx(
      Ja,
      {
        className: ce("tlui-shortcuts-dialog__body", {
          "tlui-shortcuts-dialog__body__mobile": i <= Qt.MOBILE_XS,
          "tlui-shortcuts-dialog__body__tablet": i <= Qt.TABLET
        }),
        children: /* @__PURE__ */ l.jsx(yn, { type: "keyboard-shortcuts", sourceId: "kbd", children: r })
      }
    ),
    /* @__PURE__ */ l.jsx("div", { className: "tlui-dialog__scrim" })
  ] });
}), Tae = [
  { colorScheme: "light", label: "theme.light" },
  { colorScheme: "dark", label: "theme.dark" },
  { colorScheme: "system", label: "theme.system" }
];
function bae() {
  const t = Q(), e = Zt(), n = G(
    "colorScheme",
    () => t.user.getUserPreferences().colorScheme ?? (t.user.getIsDarkMode() ? "dark" : "light"),
    [t]
  );
  return /* @__PURE__ */ l.jsx(Rn, { id: "help menu color-scheme", label: "menu.theme", children: /* @__PURE__ */ l.jsx(Ce, { id: "theme", children: Tae.map(({ colorScheme: i, label: r }) => /* @__PURE__ */ l.jsx(
    hf,
    {
      id: `color-scheme-${i}`,
      label: r,
      checked: i === n,
      readonlyOk: !0,
      onSelect: () => {
        t.user.updateUserPreferences({ colorScheme: i }), e("color-scheme", { source: "menu", value: i });
      }
    },
    i
  )) }) });
}
function jP() {
  const t = Q(), e = Zt(), n = G("locale", () => t.user.getLocale(), [t]);
  return /* @__PURE__ */ l.jsx(Rn, { id: "help menu language", label: "menu.language", children: /* @__PURE__ */ l.jsx(Ce, { id: "languages", children: Jl.map(({ locale: i, label: r }) => /* @__PURE__ */ l.jsx(
    hf,
    {
      id: `language-${i}`,
      title: i,
      label: r,
      checked: i === n,
      readonlyOk: !0,
      onSelect: () => {
        t.user.updateUserPreferences({ locale: i }), e("change-language", { source: "menu", locale: i });
      }
    },
    i
  )) }) });
}
function vae() {
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(jP, {}),
    /* @__PURE__ */ l.jsx(DP, {})
  ] });
}
function DP() {
  const { KeyboardShortcutsDialog: t } = Io(), { addDialog: e } = po(), n = re(() => {
    t && e({ component: t });
  }, [e, t]);
  return t ? /* @__PURE__ */ l.jsx(
    Qe,
    {
      id: "keyboard-shortcuts-button",
      label: "help-menu.keyboard-shortcuts",
      readonlyOk: !0,
      onSelect: n
    }
  ) : null;
}
function wP() {
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(Cae, {}),
    /* @__PURE__ */ l.jsx(NP, {}),
    /* @__PURE__ */ l.jsx(Eae, {}),
    /* @__PURE__ */ l.jsx(Oae, {}),
    /* @__PURE__ */ l.jsx(Pae, {})
  ] });
}
function Eae() {
  return /* @__PURE__ */ l.jsxs(Rn, { id: "export-all-as", label: "context-menu.export-all-as", size: "small", children: [
    /* @__PURE__ */ l.jsxs(Ce, { id: "export-all-as-group", children: [
      /* @__PURE__ */ l.jsx(V, { actionId: "export-all-as-svg" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "export-all-as-png" }),
      /* @__PURE__ */ l.jsx(V, { actionId: "export-all-as-json" })
    ] }),
    /* @__PURE__ */ l.jsx(Ce, { id: "export-all-as-bg", children: /* @__PURE__ */ l.jsx(zj, {}) })
  ] });
}
function Cae() {
  const t = Q(), e = G(
    "isSelectToolActive",
    () => t.getCurrentToolId() === "select",
    [t]
  );
  return /* @__PURE__ */ l.jsxs(Rn, { id: "edit", label: "menu.edit", disabled: !e, children: [
    /* @__PURE__ */ l.jsx(kae, {}),
    /* @__PURE__ */ l.jsx(Lj, {}),
    /* @__PURE__ */ l.jsx(MP, {}),
    /* @__PURE__ */ l.jsx(zae, {}),
    /* @__PURE__ */ l.jsx(Lae, {}),
    /* @__PURE__ */ l.jsx(Ce, { id: "select-all", children: /* @__PURE__ */ l.jsx(mP, {}) })
  ] });
}
function zae() {
  return /* @__PURE__ */ l.jsxs(Ce, { id: "misc", children: [
    /* @__PURE__ */ l.jsx(lP, {}),
    /* @__PURE__ */ l.jsx(wf, {}),
    /* @__PURE__ */ l.jsx(aP, {}),
    /* @__PURE__ */ l.jsx(oP, {}),
    /* @__PURE__ */ l.jsx(dP, {}),
    /* @__PURE__ */ l.jsx(uP, {}),
    /* @__PURE__ */ l.jsx(IP, {}),
    /* @__PURE__ */ l.jsx(yP, {}),
    /* @__PURE__ */ l.jsx(cP, {})
  ] });
}
function Lae() {
  return /* @__PURE__ */ l.jsxs(Ce, { id: "lock", children: [
    /* @__PURE__ */ l.jsx(hP, {}),
    /* @__PURE__ */ l.jsx(Loe, {})
  ] });
}
function kae() {
  const t = Df(), e = jf();
  return /* @__PURE__ */ l.jsxs(Ce, { id: "undo-redo", children: [
    /* @__PURE__ */ l.jsx(V, { actionId: "undo", disabled: !t }),
    /* @__PURE__ */ l.jsx(V, { actionId: "redo", disabled: !e })
  ] });
}
function NP() {
  return /* @__PURE__ */ l.jsx(Rn, { id: "view", label: "menu.view", children: /* @__PURE__ */ l.jsxs(Ce, { id: "view-actions", children: [
    /* @__PURE__ */ l.jsx(V, { actionId: "zoom-in" }),
    /* @__PURE__ */ l.jsx(V, { actionId: "zoom-out" }),
    /* @__PURE__ */ l.jsx(gP, {}),
    /* @__PURE__ */ l.jsx(pP, {}),
    /* @__PURE__ */ l.jsx(fP, {})
  ] }) });
}
function Oae() {
  return /* @__PURE__ */ l.jsxs(Ce, { id: "extras", children: [
    /* @__PURE__ */ l.jsx(V, { actionId: "insert-embed" }),
    /* @__PURE__ */ l.jsx(V, { actionId: "insert-media" })
  ] });
}
function Pae() {
  return /* @__PURE__ */ l.jsxs(Ce, { id: "preferences", children: [
    /* @__PURE__ */ l.jsxs(Rn, { id: "preferences", label: "menu.preferences", children: [
      /* @__PURE__ */ l.jsxs(Ce, { id: "preferences-actions", children: [
        /* @__PURE__ */ l.jsx(Woe, {}),
        /* @__PURE__ */ l.jsx(Hoe, {}),
        /* @__PURE__ */ l.jsx(Voe, {}),
        /* @__PURE__ */ l.jsx(Koe, {}),
        /* @__PURE__ */ l.jsx(Xoe, {}),
        /* @__PURE__ */ l.jsx(Joe, {}),
        /* @__PURE__ */ l.jsx(qoe, {}),
        /* @__PURE__ */ l.jsx($oe, {}),
        /* @__PURE__ */ l.jsx(eae, {}),
        /* @__PURE__ */ l.jsx(_oe, {})
      ] }),
      /* @__PURE__ */ l.jsx(Ce, { id: "color-scheme", children: /* @__PURE__ */ l.jsx(bae, {}) })
    ] }),
    /* @__PURE__ */ l.jsx(jP, {}),
    /* @__PURE__ */ l.jsx(DP, {})
  ] });
}
const Uae = _e(function({ children: e }) {
  const n = qt(), [i, r] = Nr("main menu"), s = ke(), o = e ?? /* @__PURE__ */ l.jsx(wP, {});
  return /* @__PURE__ */ l.jsxs(cf, { dir: "ltr", open: i, onOpenChange: r, modal: !1, children: [
    /* @__PURE__ */ l.jsx(lf, { asChild: !0, dir: "ltr", children: /* @__PURE__ */ l.jsx(q, { type: "icon", "data-testid": "main-menu.button", title: s("menu.title"), children: /* @__PURE__ */ l.jsx(Te, { icon: "menu", small: !0 }) }) }),
    /* @__PURE__ */ l.jsx(Bd, { container: n, children: /* @__PURE__ */ l.jsx(
      df,
      {
        className: "tlui-menu",
        side: "bottom",
        align: "start",
        collisionPadding: 4,
        alignOffset: 0,
        sideOffset: 6,
        children: /* @__PURE__ */ l.jsx(yn, { type: "menu", sourceId: "main-menu", children: o })
      }
    ) })
  ] });
}), um = {};
function hl(t) {
  if (um[t])
    return um[t];
  const n = document.createElement("canvas").getContext("2d");
  n.fillStyle = t, n.fillRect(0, 0, 1, 1);
  const [i, r, s, o] = n.getImageData(0, 0, 1, 1).data, a = new Float32Array([i / 255, r / 255, s / 255, o / 255]);
  return um[t] = a, a;
}
const Kh = 10, AP = (
  // num triangles in corners
  // num triangles in outer rects
  4 * 6 * Kh + // num triangles in center rect
  12 + 4 * 12
);
function xa(t, {
  center: e,
  radius: n,
  numArcSegments: i = 20,
  startAngle: r = 0,
  endAngle: s = gt,
  offset: o = 0
}) {
  const a = (s - r) / i;
  let c = o;
  for (let d = r; d < s; d += a)
    t[c++] = e.x, t[c++] = e.y, t[c++] = e.x + Math.cos(d) * n, t[c++] = e.y + Math.sin(d) * n, t[c++] = e.x + Math.cos(d + a) * n, t[c++] = e.y + Math.sin(d + a) * n;
  return t;
}
function Sa(t, e, n, i, r, s) {
  t[e++] = n, t[e++] = i, t[e++] = n, t[e++] = i + s, t[e++] = n + r, t[e++] = i, t[e++] = n + r, t[e++] = i, t[e++] = n, t[e++] = i + s, t[e++] = n + r, t[e++] = i + s;
}
function Rae(t, e, n) {
  const i = Kh;
  n = Math.min(n, Math.min(e.w, e.h) / 2);
  const r = ae.ExpandBy(e, -n);
  if (r.w <= 0 || r.h <= 0)
    return xa(t, { center: e.center, radius: n, numArcSegments: Kh * 4 }), Kh * 4 * 6;
  let s = 0;
  return Sa(t, s, r.minX, r.minY, r.w, r.h), s += 12, Sa(t, s, r.minX, e.minY, r.w, n), s += 12, Sa(t, s, r.maxX, r.minY, n, r.h), s += 12, Sa(t, s, r.minX, r.maxY, r.w, n), s += 12, Sa(t, s, e.minX, r.minY, n, r.h), s += 12, xa(t, {
    numArcSegments: i,
    offset: s,
    center: r.point,
    radius: n,
    startAngle: st,
    endAngle: st * 1.5
  }), s += i * 6, xa(t, {
    numArcSegments: i,
    offset: s,
    center: x.Add(r.point, new x(r.w, 0)),
    radius: n,
    startAngle: st * 1.5,
    endAngle: gt
  }), s += i * 6, xa(t, {
    numArcSegments: i,
    offset: s,
    center: x.Add(r.point, r.size),
    radius: n,
    startAngle: 0,
    endAngle: Nt
  }), s += i * 6, xa(t, {
    numArcSegments: i,
    offset: s,
    center: x.Add(r.point, new x(0, r.h)),
    radius: n,
    startAngle: Nt,
    endAngle: st
  }), AP;
}
function Yae(t) {
  if (!t) throw new Error("Canvas element not found");
  const e = t.getContext("webgl2", {
    premultipliedAlpha: !1
  });
  if (!e) throw new Error("Failed to get webgl2 context");
  const n = `#version 300 es
  precision mediump float;
  
  in vec2 shapeVertexPosition;

	uniform vec4 canvasPageBounds;

	// taken (with thanks) from
	// https://webglfundamentals.org/webgl/lessons/webgl-2d-matrices.html
  void main() {
		// convert the position from pixels to 0.0 to 1.0
		vec2 zeroToOne = (shapeVertexPosition - canvasPageBounds.xy) / canvasPageBounds.zw;
	
		// convert from 0->1 to 0->2
		vec2 zeroToTwo = zeroToOne * 2.0;
	
		// convert from 0->2 to -1->+1 (clipspace)
		vec2 clipSpace = zeroToTwo - 1.0;
	
		gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);
  }`, i = e.createShader(e.VERTEX_SHADER);
  if (!i)
    throw new Error("Failed to create vertex shader");
  if (e.shaderSource(i, n), e.compileShader(i), !e.getShaderParameter(i, e.COMPILE_STATUS))
    throw new Error("Failed to compile vertex shader");
  const r = `#version 300 es
  precision mediump float;
  
	uniform vec4 fillColor;
  out vec4 outputColor;

  void main() {
	outputColor = fillColor;
  }`, s = e.createShader(e.FRAGMENT_SHADER);
  if (!s)
    throw new Error("Failed to create fragment shader");
  if (e.shaderSource(s, r), e.compileShader(s), !e.getShaderParameter(s, e.COMPILE_STATUS))
    throw new Error("Failed to compile fragment shader");
  const o = e.createProgram();
  if (!o)
    throw new Error("Failed to create program");
  if (e.attachShader(o, i), e.attachShader(o, s), e.linkProgram(o), !e.getProgramParameter(o, e.LINK_STATUS))
    throw new Error("Failed to link program");
  e.useProgram(o);
  const a = e.getAttribLocation(
    o,
    "shapeVertexPosition"
  );
  if (a < 0)
    throw new Error("Failed to get shapeVertexPosition attribute location");
  e.enableVertexAttribArray(a);
  const c = e.getUniformLocation(o, "canvasPageBounds"), d = e.getUniformLocation(o, "fillColor");
  if (!e.createBuffer()) throw new Error("Failed to create buffer");
  if (!e.createBuffer()) throw new Error("Failed to create buffer");
  return {
    context: e,
    selectedShapes: eh(e, 1024),
    unselectedShapes: eh(e, 4096),
    viewport: eh(e, AP),
    collaborators: eh(e, 1024),
    prepareTriangles(g, p) {
      e.bindBuffer(e.ARRAY_BUFFER, g.buffer), e.bufferData(e.ARRAY_BUFFER, g.vertices, e.STATIC_DRAW, 0, p), e.enableVertexAttribArray(a), e.vertexAttribPointer(
        a,
        2,
        e.FLOAT,
        !1,
        0,
        0
      );
    },
    drawTrianglesTransparently(g) {
      e.enable(e.BLEND), e.blendFunc(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA), e.drawArrays(e.TRIANGLES, 0, g / 2), e.disable(e.BLEND);
    },
    drawTriangles(g) {
      e.drawArrays(e.TRIANGLES, 0, g / 2);
    },
    setFillColor(g) {
      e.uniform4fv(d, g);
    },
    setCanvasPageBounds(g) {
      e.uniform4fv(c, g);
    }
  };
}
function eh(t, e) {
  const n = t.createBuffer();
  if (!n) throw new Error("Failed to create buffer");
  return { buffer: n, vertices: new Float32Array(e) };
}
function WN(t, e, n) {
  let i = t.vertices.length;
  for (; i < e + n.length; )
    i *= 2;
  if (i != t.vertices.length) {
    const r = new Float32Array(i);
    r.set(t.vertices), t.vertices = r;
  }
  t.vertices.set(n, e);
}
var Qae = Object.create, TP = Object.defineProperty, Zae = Object.getOwnPropertyDescriptor, Fae = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), bP = (t) => {
  throw TypeError(t);
}, vP = (t, e, n) => e in t ? TP(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Bae = (t) => [, , , Qae(null)], EP = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], CP = (t) => t !== void 0 && typeof t != "function" ? bP("Function expected") : t, Gae = (t, e, n, i, r) => ({ kind: EP[t], name: e, metadata: i, addInitializer: (s) => n._ ? bP("Already initialized") : r.push(CP(s || null)) }), Wae = (t, e) => vP(e, Fae("metadata"), t[3]), Hae = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], o = s && s.length; r < o; r++) s[r].call(n);
  return i;
}, Kr = (t, e, n, i, r, s) => {
  for (var o, a, c, d, u = e & 7, h = !!(e & 8), g = !!(e & 16), p = 2, f = EP[u + 5], M = t[p] || (t[p] = []), m = (r = r.prototype, Zae(r, n)), y = i.length - 1; y >= 0; y--)
    c = Gae(u, n, a = {}, t[3], M), c.static = h, c.private = g, d = c.access = { has: (I) => n in I }, d.get = (I) => I[n], o = (0, i[y])(m[f], c), a._ = 1, CP(o) && (m[f] = o);
  return m && TP(r, n, m), r;
}, ns = (t, e, n) => vP(t, typeof e != "symbol" ? e + "" : e, n), zP, LP, kP, OP, PP, UP, RP, YP, QP, ZP, Yi;
ZP = [di], QP = [K], YP = [K], RP = [K], UP = [K], PP = [K], OP = [K], kP = [K], LP = [K], zP = [di];
class _i {
  constructor(e, n, i) {
    this.editor = e, this.elem = n, this.container = i, Hae(Yi, 5, this), ns(this, "disposables", []), ns(this, "gl"), ns(this, "shapeGeometryCache"), ns(this, "colors"), ns(this, "id", ht()), ns(this, "canvasBoundingClientRect", xt("canvasBoundingClientRect", new ae())), ns(this, "originPagePoint", new x()), ns(this, "originPageCenter", new x()), ns(this, "isInViewport", !1), this.gl = Yae(n), this.shapeGeometryCache = e.store.createComputedCache("webgl-geometry", (r) => {
      const s = e.getShapeMaskedPageBounds(r.id);
      if (!s) return null;
      const o = new Float32Array(12);
      return Sa(o, 0, s.x, s.y, s.w, s.h), o;
    }), this.colors = this._getColors(), this.disposables.push(this._listenForCanvasResize(), Yr("minimap render", this.render));
  }
  close() {
    return this.disposables.forEach((e) => e());
  }
  _getColors() {
    const e = getComputedStyle(this.editor.getContainer());
    return {
      shapeFill: hl(e.getPropertyValue("--color-text-3").trim()),
      selectFill: hl(e.getPropertyValue("--color-selected").trim()),
      viewportFill: hl(e.getPropertyValue("--color-muted-1").trim()),
      background: hl(e.getPropertyValue("--color-low").trim())
    };
  }
  // this should be called after dark/light mode changes have propagated to the dom
  updateColors() {
    this.colors = this._getColors();
  }
  getDpr() {
    return this.editor.getInstanceState().devicePixelRatio;
  }
  getContentPageBounds() {
    const e = this.editor.getViewportPageBounds(), n = this.editor.getCurrentPageBounds();
    return n ? ae.Expand(n, e) : e;
  }
  getContentScreenBounds() {
    const e = this.getContentPageBounds(), n = this.editor.pageToScreen(e.point), i = this.editor.pageToScreen(
      new x(e.maxX, e.maxY)
    );
    return new ae(n.x, n.y, i.x - n.x, i.y - n.y);
  }
  _getCanvasBoundingRect() {
    const { x: e, y: n, width: i, height: r } = this.elem.getBoundingClientRect();
    return new ae(e, n, i, r);
  }
  getCanvasScreenBounds() {
    return this.canvasBoundingClientRect.get();
  }
  _listenForCanvasResize() {
    const e = new ResizeObserver(() => {
      const n = this._getCanvasBoundingRect();
      this.canvasBoundingClientRect.set(n);
    });
    return e.observe(this.elem), e.observe(this.container), () => e.disconnect();
  }
  getCanvasSize() {
    const e = this.canvasBoundingClientRect.get(), n = this.getDpr();
    return new x(e.width * n, e.height * n);
  }
  getCanvasClientPosition() {
    return this.canvasBoundingClientRect.get().point;
  }
  getCanvasPageBounds() {
    const e = this.getCanvasScreenBounds(), n = this.getContentPageBounds(), i = e.width / e.height;
    let r = n.width, s = r / i;
    s < n.height && (s = n.height, r = s * i);
    const o = new ae(0, 0, r, s);
    return o.center = n.center, o;
  }
  getZoom() {
    return this.getCanvasPageBounds().width / this.getCanvasScreenBounds().width;
  }
  getCanvasPageBoundsArray() {
    const { x: e, y: n, w: i, h: r } = this.getCanvasPageBounds();
    return new Float32Array([e, n, i, r]);
  }
  getMinimapPagePoint(e, n) {
    const i = this.getCanvasPageBounds(), r = this.getCanvasScreenBounds();
    let s = e - r.x, o = n - r.y;
    return s *= i.width / r.width, o *= i.height / r.height, s += i.minX, o += i.minY, new x(s, o, 1);
  }
  minimapScreenPointToPagePoint(e, n, i = !1, r = !1) {
    const { editor: s } = this, o = s.getViewportPageBounds();
    let { x: a, y: c } = this.getMinimapPagePoint(e, n);
    if (r) {
      const d = this.editor.getCurrentPageBounds() ?? new ae(), u = d.minX - o.width / 2, h = d.maxX + o.width / 2, g = d.minY - o.height / 2, p = d.maxY + o.height / 2, f = Math.max(0, u + o.width - a), M = Math.max(0, -(h - o.width - a)), m = Math.max(0, g + o.height - c), y = Math.max(0, -(p - o.height - c));
      a += (f - M) / 2, c += (m - y) / 2, a = hn(a, u, h), c = hn(c, g, p);
    }
    if (i) {
      const { originPagePoint: d } = this, u = Math.abs(a - d.x), h = Math.abs(c - d.y);
      u > h ? c = d.y : a = d.x;
    }
    return new x(a, c);
  }
  render() {
    const e = this.gl.context, n = this.getCanvasSize();
    this.gl.setCanvasPageBounds(this.getCanvasPageBoundsArray()), this.elem.width = n.x, this.elem.height = n.y, e.viewport(0, 0, n.x, n.y), e.clearColor(
      this.colors.background[0],
      this.colors.background[1],
      this.colors.background[2],
      1
    ), e.clear(e.COLOR_BUFFER_BIT);
    const i = new Set(this.editor.getSelectedShapeIds()), r = this.colors;
    let s = 0, o = 0;
    const a = this.editor.getCurrentPageShapeIdsSorted();
    for (let c = 0, d = a.length; c < d; c++) {
      const u = a[c], h = this.shapeGeometryCache.get(u);
      if (!h) continue;
      const g = h.length;
      i.has(u) ? (WN(this.gl.selectedShapes, s, h), s += g) : (WN(this.gl.unselectedShapes, o, h), o += g);
    }
    this.drawShapes(this.gl.unselectedShapes, o, r.shapeFill), this.drawShapes(this.gl.selectedShapes, s, r.selectFill), this.drawViewport(), this.drawCollaborators();
  }
  drawShapes(e, n, i) {
    this.gl.prepareTriangles(e, n), this.gl.setFillColor(i), this.gl.drawTriangles(n);
  }
  drawViewport() {
    const e = this.editor.getViewportPageBounds(), n = Rae(this.gl.viewport.vertices, e, 4 * this.getZoom());
    this.gl.prepareTriangles(this.gl.viewport, n), this.gl.setFillColor(this.colors.viewportFill), this.gl.drawTrianglesTransparently(n), mt.isSafari && (this.gl.drawTrianglesTransparently(n), this.gl.drawTrianglesTransparently(n), this.gl.drawTrianglesTransparently(n));
  }
  drawCollaborators() {
    const e = this.editor.getCollaboratorsOnCurrentPage();
    if (!e.length) return;
    const n = 20, i = n * 6, r = i * e.length;
    this.gl.collaborators.vertices.length < r && (this.gl.collaborators.vertices = new Float32Array(r));
    const s = this.gl.collaborators.vertices;
    let o = 0;
    const a = this.getZoom();
    for (const { cursor: c } of e)
      xa(s, {
        center: x.From(c),
        radius: 3 * a,
        offset: o,
        numArcSegments: n
      }), o += i;
    this.gl.prepareTriangles(this.gl.collaborators, r), o = 0;
    for (const { color: c } of e)
      this.gl.setFillColor(hl(c)), this.gl.context.drawArrays(this.gl.context.TRIANGLES, o / 2, i / 2), o += i;
  }
}
Yi = Bae();
Kr(Yi, 1, "close", ZP, _i);
Kr(Yi, 1, "getDpr", QP, _i);
Kr(Yi, 1, "getContentPageBounds", YP, _i);
Kr(Yi, 1, "getContentScreenBounds", RP, _i);
Kr(Yi, 1, "getCanvasSize", UP, _i);
Kr(Yi, 1, "getCanvasClientPosition", PP, _i);
Kr(Yi, 1, "getCanvasPageBounds", OP, _i);
Kr(Yi, 1, "getZoom", kP, _i);
Kr(Yi, 1, "getCanvasPageBoundsArray", LP, _i);
Kr(Yi, 1, "render", zP, _i);
Wae(Yi, _i);
function Vae() {
  const t = Q(), e = qt(), n = N.useRef(null), i = N.useRef(!1), r = N.useRef();
  N.useEffect(() => {
    try {
      const u = new _i(t, n.current, e);
      return r.current = u, r.current.close;
    } catch (u) {
      t.annotateError(u, {
        origin: "minimap",
        willCrashApp: !1
      }), t.timers.setTimeout(() => {
        throw u;
      });
    }
  }, [t, e]);
  const s = N.useCallback(
    (u) => {
      if (!t.getCurrentPageShapeIds().size || !r.current) return;
      const h = r.current.minimapScreenPointToPagePoint(
        u.clientX,
        u.clientY,
        !1,
        !1
      ), g = r.current.minimapScreenPointToPagePoint(
        u.clientX,
        u.clientY,
        !1,
        !0
      );
      r.current.originPagePoint.setTo(g), r.current.originPageCenter.setTo(t.getViewportPageBounds().center), t.centerOnPoint(h, { animation: { duration: t.options.animationMediumMs } });
    },
    [t]
  ), o = N.useCallback(
    (u) => {
      if (!r.current) return;
      const h = u.currentTarget;
      if (jc(h, u), !t.getCurrentPageShapeIds().size) return;
      i.current = !0, r.current.isInViewport = !1;
      const g = r.current.minimapScreenPointToPagePoint(
        u.clientX,
        u.clientY,
        !1,
        !1
      ), p = t.getViewportPageBounds(), f = r.current.getContentPageBounds();
      if (new ae(
        f.x - p.width / 2,
        f.y - p.height / 2,
        f.width + p.width,
        f.height + p.height
      ).containsPoint(g) && !p.containsPoint(g)) {
        r.current.isInViewport = p.containsPoint(g);
        const y = x.Sub(p.center, p.point), I = x.Add(g, y);
        r.current.originPagePoint.setTo(I), r.current.originPageCenter.setTo(g), t.centerOnPoint(g, { animation: { duration: t.options.animationMediumMs } });
      } else {
        const y = r.current.minimapScreenPointToPagePoint(
          u.clientX,
          u.clientY,
          !1,
          !0
        );
        r.current.isInViewport = p.containsPoint(y), r.current.originPagePoint.setTo(y), r.current.originPageCenter.setTo(p.center);
      }
      function m(y) {
        h && Dc(h, y), i.current = !1, document.body.removeEventListener("pointerup", m);
      }
      document.body.addEventListener("pointerup", m);
    },
    [t]
  ), a = N.useCallback(
    (u) => {
      if (!r.current) return;
      const h = r.current.minimapScreenPointToPagePoint(
        u.clientX,
        u.clientY,
        u.shiftKey,
        !0
      );
      if (i.current) {
        if (r.current.isInViewport) {
          const M = r.current.originPagePoint.clone().sub(r.current.originPageCenter);
          t.centerOnPoint(x.Sub(h, M));
          return;
        }
        t.centerOnPoint(h);
      }
      const g = r.current.getMinimapPagePoint(u.clientX, u.clientY), p = t.pageToScreen(g), f = {
        type: "pointer",
        target: "canvas",
        name: "pointer_move",
        ...gi(u),
        point: p,
        isPen: t.getInstanceState().isPenMode
      };
      t.dispatch(f);
    },
    [t]
  ), c = N.useCallback(
    (u) => {
      const h = Ev(u);
      t.dispatch({
        type: "wheel",
        name: "wheel",
        delta: h,
        point: new x(u.clientX, u.clientY),
        shiftKey: u.shiftKey,
        altKey: u.altKey,
        ctrlKey: u.metaKey || u.ctrlKey,
        metaKey: u.metaKey,
        accelKey: bn(u)
      });
    },
    [t]
  ), d = Tc();
  return N.useEffect(() => {
    t.timers.setTimeout(() => {
      var u, h;
      (u = r.current) == null || u.updateColors(), (h = r.current) == null || h.render();
    });
  }, [d, t]), /* @__PURE__ */ l.jsx("div", { className: "tlui-minimap", children: /* @__PURE__ */ l.jsx(
    "canvas",
    {
      role: "img",
      "aria-label": "minimap",
      ref: n,
      className: "tlui-minimap__canvas",
      onDoubleClick: s,
      onPointerMove: a,
      onPointerDown: o,
      onWheelCapture: c
    }
  ) });
}
function Kae(t, e) {
  const [n, i] = Ye.useState(e);
  Ye.useLayoutEffect(() => {
    const s = gx(t);
    if (s)
      try {
        i(JSON.parse(s));
      } catch {
        console.error(`Could not restore value ${t} from local storage.`);
      }
  }, [t]);
  const r = Ye.useCallback(
    (s) => {
      i((o) => {
        const a = typeof s == "function" ? s(o) : s;
        return px(t, JSON.stringify(a)), a;
      });
    },
    [t]
  );
  return [n, r];
}
const Xae = _e(function() {
  const e = _t(), n = ke(), i = Un(), r = le(null);
  uo(r);
  const [s, o] = Kae("minimap", !0), a = re(() => {
    o((u) => !u);
  }, [o]), { ZoomMenu: c, Minimap: d } = Io();
  return i < Qt.MOBILE ? null : /* @__PURE__ */ l.jsxs("div", { ref: r, className: "tlui-navigation-panel", children: [
    /* @__PURE__ */ l.jsx("div", { className: "tlui-buttons__horizontal", children: c && i < Qt.TABLET ? /* @__PURE__ */ l.jsx(c, {}) : s ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      c && /* @__PURE__ */ l.jsx(c, {}),
      d && /* @__PURE__ */ l.jsx(
        q,
        {
          type: "icon",
          "data-testid": "minimap.toggle-button",
          title: n("navigation-zone.toggle-minimap"),
          className: "tlui-navigation-panel__toggle",
          onClick: a,
          children: /* @__PURE__ */ l.jsx(Te, { icon: s ? "chevrons-ne" : "chevrons-sw" })
        }
      )
    ] }) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        q,
        {
          type: "icon",
          "data-testid": "minimap.zoom-out",
          title: `${n(_l(e["zoom-out"].label))} ${jI(e["zoom-out"].kbd)}`,
          onClick: () => e["zoom-out"].onSelect("navigation-zone"),
          children: /* @__PURE__ */ l.jsx(Te, { icon: "minus" })
        }
      ),
      c && /* @__PURE__ */ l.jsx(c, {}),
      /* @__PURE__ */ l.jsx(
        q,
        {
          type: "icon",
          "data-testid": "minimap.zoom-in",
          title: `${n(_l(e["zoom-in"].label))} ${jI(e["zoom-in"].kbd)}`,
          onClick: () => e["zoom-in"].onSelect("navigation-zone"),
          children: /* @__PURE__ */ l.jsx(Te, { icon: "plus" })
        }
      ),
      d && /* @__PURE__ */ l.jsx(
        q,
        {
          type: "icon",
          "data-testid": "minimap.toggle-button",
          title: n("navigation-zone.toggle-minimap"),
          className: "tlui-navigation-panel__toggle",
          onClick: a,
          children: /* @__PURE__ */ l.jsx(Te, { icon: s ? "chevrons-ne" : "chevrons-sw" })
        }
      )
    ] }) }),
    d && i >= Qt.TABLET && !s && /* @__PURE__ */ l.jsx(d, {})
  ] });
}), Jae = function({
  name: e,
  id: n,
  isCurrentPage: i,
  onCancel: r
}) {
  const s = Q(), o = Zt(), a = le(null), c = le(null), d = re(() => {
    c.current = s.markHistoryStoppingPoint("rename page");
  }, [s]), u = re(
    (g) => {
      s.renamePage(n, g || "New Page"), o("rename-page", { source: "page-menu" });
    },
    [s, n, o]
  ), h = re(() => {
    c.current && s.bailToMark(c.current), r();
  }, [s, r]);
  return /* @__PURE__ */ l.jsx(
    Ld,
    {
      className: "tlui-page-menu__item__input",
      ref: (g) => a.current = g,
      defaultValue: e,
      onValueChange: u,
      onCancel: h,
      onFocus: d,
      shouldManuallyMaintainScrollPositionWhenFocused: !0,
      autoFocus: i,
      autoSelect: !0
    }
  );
}, QI = (t, e, n, i, r) => {
  let s;
  const o = t.getPages(), a = n > i ? o[i - 1] : o[i], c = n > i ? o[i] : o[i + 1];
  a && !c ? s = hi(a.index) : !a && c ? s = uT(o[0].index) : s = ko(a.index, c.index), s !== o[n].index && (t.markHistoryStoppingPoint("moving page"), t.updatePage({
    id: e,
    index: s
  }), r("move-page", { source: "page-menu" }));
}, HN = Vt(function({
  index: e,
  listSize: n,
  item: i,
  onRename: r
}) {
  const s = Q(), o = ke(), a = s.getPages(), c = Zt(), d = re(() => {
    s.markHistoryStoppingPoint("creating page");
    const p = kn.createId();
    s.duplicatePage(i.id, p), c("duplicate-page", { source: "page-menu" });
  }, [s, i, c]), u = re(() => {
    QI(s, i.id, e, e - 1, c);
  }, [s, i, e, c]), h = re(() => {
    QI(s, i.id, e, e + 1, c);
  }, [s, i, e, c]), g = re(() => {
    s.markHistoryStoppingPoint("deleting page"), s.deletePage(i.id), c("delete-page", { source: "page-menu" });
  }, [s, i, c]);
  return /* @__PURE__ */ l.jsxs(mr, { id: `page item submenu ${e}`, children: [
    /* @__PURE__ */ l.jsx(yr, { children: /* @__PURE__ */ l.jsx(q, { type: "icon", title: o("page-menu.submenu.title"), children: /* @__PURE__ */ l.jsx(Te, { icon: "dots-vertical" }) }) }),
    /* @__PURE__ */ l.jsx(Ir, { alignOffset: 0, side: "right", sideOffset: -4, children: /* @__PURE__ */ l.jsxs(yn, { type: "menu", sourceId: "page-menu", children: [
      /* @__PURE__ */ l.jsxs(Ce, { id: "modify", children: [
        r && /* @__PURE__ */ l.jsx(Qe, { id: "rename", label: "page-menu.submenu.rename", onSelect: r }),
        /* @__PURE__ */ l.jsx(
          Qe,
          {
            id: "duplicate",
            label: "page-menu.submenu.duplicate-page",
            onSelect: d,
            disabled: a.length >= s.options.maxPages
          }
        ),
        e > 0 && /* @__PURE__ */ l.jsx(
          Qe,
          {
            id: "move-up",
            onSelect: u,
            label: "page-menu.submenu.move-up"
          }
        ),
        e < n - 1 && /* @__PURE__ */ l.jsx(
          Qe,
          {
            id: "move-down",
            label: "page-menu.submenu.move-down",
            onSelect: h
          }
        )
      ] }),
      n > 1 && /* @__PURE__ */ l.jsx(Ce, { id: "delete", children: /* @__PURE__ */ l.jsx(Qe, { id: "delete", onSelect: g, label: "page-menu.submenu.delete" }) })
    ] }) })
  ] });
}), qae = _e(function() {
  const e = Q(), n = Zt(), i = ke(), r = Un(), s = re(() => y(!1), []), [o, a] = Nr("page-menu", s), c = 36, d = le(null), u = G("pages", () => e.getPages(), [e]), h = G("currentPage", () => e.getCurrentPage(), [e]), g = G("currentPageId", () => e.getCurrentPageId(), [e]), p = ji(), f = G(
    "maxPageCountReached",
    () => e.getPages().length >= e.options.maxPages,
    [e]
  ), M = G(
    "isCoarsePointer",
    () => e.getInstanceState().isCoarsePointer,
    [e]
  ), [m, y] = pe(!1), I = re(() => {
    p || y((z) => !z);
  }, [p]), D = le({
    isPointing: !1,
    status: "idle",
    pointing: null,
    startY: 0,
    startIndex: 0,
    dragIndex: 0
  }), [j, w] = pe(
    Object.fromEntries(
      u.map((z, O) => [z.id, { y: O * c, offsetY: 0, isSelected: !1 }])
    )
  );
  at(() => {
    w(
      Object.fromEntries(
        u.map((z, O) => [z.id, { y: O * c, offsetY: 0, isSelected: !1 }])
      )
    );
  }, [c, u]), ze(() => {
    o && e.timers.requestAnimationFrame(() => {
      const z = document.querySelector(
        `[data-testid="page-menu-item-${g}"]`
      );
      if (z) {
        const O = d.current;
        if (!O) return;
        const R = z.offsetTop, U = O.scrollTop;
        R < U && O.scrollTo({ top: R });
        const F = R + c, H = O.scrollTop + O.offsetHeight;
        F > H && O.scrollTo({ top: F - O.offsetHeight });
      }
    });
  }, [c, g, o, e]);
  const A = re(
    (z) => {
      const { clientY: O, currentTarget: R } = z, {
        dataset: { id: U, index: F }
      } = R;
      if (!U || !F) return;
      const H = D.current;
      jc(z.currentTarget, z), H.status = "pointing", H.pointing = { id: U, index: +F };
      const te = j[U].y;
      H.startY = O, H.startIndex = Math.max(0, Math.min(Math.round(te / c), u.length - 1));
    },
    [c, u.length, j]
  ), b = re(
    (z) => {
      const O = D.current;
      if (O.status === "pointing") {
        const { clientY: R } = z, U = R - O.startY;
        Math.abs(U) > 5 && (O.status = "dragging");
      }
      if (O.status === "dragging") {
        const { clientY: R } = z, U = R - O.startY, F = j[O.pointing.id], { startIndex: H, pointing: Z } = O, te = F.y + U, oe = Math.max(0, Math.min(Math.round(te / c), u.length - 1)), me = { ...j };
        if (me[Z.id] = {
          y: F.y,
          offsetY: U,
          isSelected: !0
        }, oe !== O.dragIndex) {
          O.dragIndex = oe;
          for (let he = 0; he < u.length; he++) {
            const ve = u[he];
            if (ve.id === O.pointing.id)
              continue;
            let { y: ie } = me[ve.id];
            oe === H ? ie = he * c : oe < H ? oe <= he && he < H ? ie = (he + 1) * c : ie = he * c : oe > H && (oe >= he && he > H ? ie = (he - 1) * c : ie = he * c), ie !== me[ve.id].y && (me[ve.id] = { y: ie, offsetY: 0, isSelected: !0 });
          }
        }
        w(me);
      }
    },
    [c, u, j]
  ), T = re(
    (z) => {
      const O = D.current;
      if (O.status === "dragging") {
        const { id: R, index: U } = O.pointing;
        QI(e, R, U, O.dragIndex, n);
      }
      Dc(z.currentTarget, z), O.status = "idle";
    },
    [e, n]
  ), E = re(
    (z) => {
      const O = D.current;
      z.key === "Escape" && (O.status === "dragging" && w(
        Object.fromEntries(
          u.map((R, U) => [
            R.id,
            { y: U * c, offsetY: 0, isSelected: !1 }
          ])
        )
      ), O.status = "idle");
    },
    [c, u]
  ), v = re(() => {
    p || (e.run(() => {
      e.markHistoryStoppingPoint("creating page");
      const z = kn.createId();
      e.createPage({ name: i("page-menu.new-page-initial-name"), id: z }), e.setCurrentPage(z), y(!0);
    }), n("new-page", { source: "page-menu" }));
  }, [e, i, p, n]), P = re(
    (z) => {
      e.setCurrentPage(z), n("change-page", { source: "page-menu" });
    },
    [e, n]
  ), C = re(
    (z, O) => {
      e.renamePage(z, O), n("rename-page", { source: "page-menu" });
    },
    [e, n]
  );
  return /* @__PURE__ */ l.jsxs(Gn, { id: "pages", onOpenChange: a, open: o, children: [
    /* @__PURE__ */ l.jsx(Wn, { "data-testid": "main.page-menu", children: /* @__PURE__ */ l.jsxs(
      q,
      {
        type: "menu",
        title: h.name,
        "data-testid": "page-menu.button",
        className: "tlui-page-menu__trigger",
        children: [
          /* @__PURE__ */ l.jsx("div", { className: "tlui-page-menu__name", children: h.name }),
          /* @__PURE__ */ l.jsx(Te, { icon: "chevron-down", small: !0 })
        ]
      }
    ) }),
    /* @__PURE__ */ l.jsx(
      Hn,
      {
        side: "bottom",
        align: "start",
        sideOffset: 6,
        disableEscapeKeyDown: m,
        children: /* @__PURE__ */ l.jsxs("div", { className: "tlui-page-menu__wrapper", children: [
          /* @__PURE__ */ l.jsxs("div", { className: "tlui-page-menu__header", children: [
            /* @__PURE__ */ l.jsx("div", { className: "tlui-page-menu__header__title", children: i("page-menu.title") }),
            !p && /* @__PURE__ */ l.jsxs("div", { className: "tlui-buttons__horizontal", children: [
              /* @__PURE__ */ l.jsx(
                q,
                {
                  type: "icon",
                  "data-testid": "page-menu.edit",
                  title: i(m ? "page-menu.edit-done" : "page-menu.edit-start"),
                  onClick: I,
                  children: /* @__PURE__ */ l.jsx(Te, { icon: m ? "check" : "edit" })
                }
              ),
              /* @__PURE__ */ l.jsx(
                q,
                {
                  type: "icon",
                  "data-testid": "page-menu.create",
                  title: i(
                    f ? "page-menu.max-page-count-reached" : "page-menu.create-new-page"
                  ),
                  disabled: f,
                  onClick: v,
                  children: /* @__PURE__ */ l.jsx(Te, { icon: "plus" })
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ l.jsx(
            "div",
            {
              "data-testid": "page-menu.list",
              className: "tlui-page-menu__list tlui-menu__group",
              style: { height: c * u.length + 4 },
              ref: d,
              children: u.map((z, O) => {
                const R = j[z.id] ?? {
                  offsetY: 0
                };
                return m ? /* @__PURE__ */ l.jsxs(
                  "div",
                  {
                    "data-testid": "page-menu.item",
                    className: "tlui-page_menu__item__sortable",
                    style: {
                      zIndex: z.id === h.id ? 888 : O,
                      transform: `translate(0px, ${R.y + R.offsetY}px)`
                    },
                    children: [
                      /* @__PURE__ */ l.jsx(
                        q,
                        {
                          type: "icon",
                          tabIndex: -1,
                          className: "tlui-page_menu__item__sortable__handle",
                          onPointerDown: A,
                          onPointerUp: T,
                          onPointerMove: b,
                          onKeyDown: E,
                          "data-id": z.id,
                          "data-index": O,
                          children: /* @__PURE__ */ l.jsx(Te, { icon: "drag-handle-dots" })
                        }
                      ),
                      r < Qt.TABLET_SM && M ? (
                        // sigh, this is a workaround for iOS Safari
                        // because the device and the radix popover seem
                        // to be fighting over scroll position. Nothing
                        // else seems to work!
                        /* @__PURE__ */ l.jsxs(q, {
                          type: "normal",
                          className: "tlui-page-menu__item__button",
                          onClick: () => {
                            const U = window.prompt("Rename page", z.name);
                            U && U !== z.name && C(z.id, U);
                          },
                          onDoubleClick: I,
                          children: [
                            /* @__PURE__ */ l.jsx(sd, { checked: z.id === h.id }),
                            /* @__PURE__ */ l.jsx(St, { children: z.name })
                          ]
                        })
                      ) : /* @__PURE__ */ l.jsx(
                        "div",
                        {
                          className: "tlui-page_menu__item__sortable__title",
                          style: { height: c },
                          children: /* @__PURE__ */ l.jsx(
                            Jae,
                            {
                              id: z.id,
                              name: z.name,
                              isCurrentPage: z.id === h.id,
                              onCancel: () => {
                                y(!1), e.menus.clearOpenMenus();
                              }
                            }
                          )
                        }
                      ),
                      !p && /* @__PURE__ */ l.jsx("div", { className: "tlui-page_menu__item__submenu", "data-isediting": m, children: /* @__PURE__ */ l.jsx(HN, { index: O, item: z, listSize: u.length }) })
                    ]
                  },
                  z.id + "_editing"
                ) : /* @__PURE__ */ l.jsxs("div", { "data-testid": "page-menu.item", className: "tlui-page-menu__item", children: [
                  /* @__PURE__ */ l.jsxs(
                    q,
                    {
                      type: "normal",
                      className: "tlui-page-menu__item__button",
                      onClick: () => P(z.id),
                      onDoubleClick: I,
                      title: i("page-menu.go-to-page"),
                      children: [
                        /* @__PURE__ */ l.jsx(sd, { checked: z.id === h.id }),
                        /* @__PURE__ */ l.jsx(St, { children: z.name })
                      ]
                    }
                  ),
                  !p && /* @__PURE__ */ l.jsx("div", { className: "tlui-page_menu__item__submenu", children: /* @__PURE__ */ l.jsx(
                    HN,
                    {
                      index: O,
                      item: z,
                      listSize: u.length,
                      onRename: () => {
                        if (mt.isIos) {
                          const U = window.prompt("Rename page", z.name);
                          U && U !== z.name && C(z.id, U);
                        } else
                          y(!0), g !== z.id && P(z.id);
                      }
                    }
                  ) })
                ] }, z.id);
              })
            }
          )
        ] })
      }
    )
  ] });
});
function _ae() {
  const t = Q(), e = Df(), n = jf(), i = $t(1), r = ji(), s = G(
    "should display quick actions",
    () => t.isInAny("select", "hand", "zoom"),
    [t]
  ), o = Di(), a = i && o;
  if (!(r && !s))
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(V, { actionId: "undo", disabled: !e }),
      /* @__PURE__ */ l.jsx(V, { actionId: "redo", disabled: !n }),
      /* @__PURE__ */ l.jsx(V, { actionId: "delete", disabled: !a }),
      /* @__PURE__ */ l.jsx(V, { actionId: "duplicate", disabled: !a })
    ] });
}
const $ae = _e(function({
  children: e
}) {
  const n = e ?? /* @__PURE__ */ l.jsx(_ae, {});
  return /* @__PURE__ */ l.jsx(yn, { type: "small-icons", sourceId: "quick-actions", children: n });
});
function ece({ userId: t }) {
  const e = Tp(t);
  return e ? /* @__PURE__ */ l.jsx(
    "div",
    {
      className: "tlui-people-menu__avatar",
      style: {
        backgroundColor: e.color
      },
      children: e.userName === "New User" ? "" : e.userName[0] ?? ""
    },
    t
  ) : null;
}
const tce = Vt(function({ userId: e }) {
  const n = Q(), i = ke(), r = Zt(), s = Tp(e), o = re(() => {
    n.getInstanceState().followingUserId === e ? (n.stopFollowingUser(), r("stop-following", { source: "people-menu" })) : (n.startFollowingUser(e), r("start-following", { source: "people-menu" }));
  }, [n, e, r]), a = (s == null ? void 0 : s.followingUserId) === n.user.getId(), c = n.getInstanceState().followingUserId === e;
  return s ? /* @__PURE__ */ l.jsxs("div", { className: "tlui-people-menu__item tlui-buttons__horizontal", children: [
    /* @__PURE__ */ l.jsxs(
      q,
      {
        type: "menu",
        className: "tlui-people-menu__item__button",
        onClick: () => n.zoomToUser(e),
        onDoubleClick: o,
        children: [
          /* @__PURE__ */ l.jsx(Ui, { icon: "color", color: s.color }),
          /* @__PURE__ */ l.jsx("div", { className: "tlui-people-menu__name", children: s.userName ?? "New User" })
        ]
      }
    ),
    /* @__PURE__ */ l.jsx(
      q,
      {
        type: "icon",
        className: "tlui-people-menu__item__follow",
        title: i(a ? "people-menu.leading" : c ? "people-menu.following" : "people-menu.follow"),
        onClick: o,
        disabled: a,
        "data-active": c || a,
        children: /* @__PURE__ */ l.jsx(
          Te,
          {
            icon: a ? "leading" : c ? "following" : "follow"
          }
        )
      }
    )
  ] }) : null;
});
function nce({ count: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: "tlui-people-menu__more", children: "+" + Math.abs(t) });
}
const ice = Vt(function() {
  const e = Q(), n = qt(), i = ke(), r = Zt(), s = le(!1), [o, a] = pe(!1), c = re((M) => {
    a(M);
  }, []), d = e.user.getColor(), u = re(
    (M) => {
      e.user.updateUserPreferences({ color: M }), r("set-color", { source: "people-menu" });
    },
    [e, r]
  ), {
    handleButtonClick: h,
    handleButtonPointerDown: g,
    handleButtonPointerEnter: p,
    handleButtonPointerUp: f
  } = Ye.useMemo(() => {
    const M = () => {
      s.current = !1, window.removeEventListener("pointerup", M);
    };
    return {
      handleButtonClick: (j) => {
        const { id: w } = j.currentTarget.dataset;
        w && d !== w && u(w);
      },
      handleButtonPointerDown: (j) => {
        const { id: w } = j.currentTarget.dataset;
        w && (u(w), s.current = !0, window.addEventListener("pointerup", M));
      },
      handleButtonPointerEnter: (j) => {
        if (!s.current) return;
        const { id: w } = j.currentTarget.dataset;
        w && u(w);
      },
      handleButtonPointerUp: (j) => {
        const { id: w } = j.currentTarget.dataset;
        w && u(w);
      }
    };
  }, [d, u]);
  return /* @__PURE__ */ l.jsxs(Nj, { onOpenChange: c, open: o, children: [
    /* @__PURE__ */ l.jsx(Aj, { dir: "ltr", asChild: !0, children: /* @__PURE__ */ l.jsx(
      q,
      {
        type: "icon",
        className: "tlui-people-menu__user__color",
        style: { color: e.user.getColor() },
        title: i("people-menu.change-color"),
        children: /* @__PURE__ */ l.jsx(Te, { icon: "color" })
      }
    ) }),
    /* @__PURE__ */ l.jsx(Tj, { container: n, children: /* @__PURE__ */ l.jsx(
      bj,
      {
        dir: "ltr",
        className: "tlui-menu tlui-people-menu__user__color-picker",
        align: "start",
        side: "left",
        sideOffset: 8,
        children: /* @__PURE__ */ l.jsx("div", { className: "tlui-buttons__grid", children: Wy.map((M) => /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            "data-id": M,
            "data-testid": M,
            "aria-label": M,
            "data-state": d === M ? "hinted" : void 0,
            title: M,
            className: "tlui-button-grid__button",
            style: { color: M },
            onPointerEnter: p,
            onPointerDown: g,
            onPointerUp: f,
            onClick: h,
            children: /* @__PURE__ */ l.jsx(Te, { icon: "color" })
          },
          M
        )) })
      }
    ) })
  ] });
});
function rce() {
  const t = Q(), e = Zt(), n = G("userName", () => t.user.getName(), []), i = ke(), r = le(n), s = le(n), [o, a] = pe(!1), c = re(() => {
    a((g) => !g);
  }, []), d = re(
    (g) => {
      s.current = g, t.user.updateUserPreferences({ name: g });
    },
    [t]
  ), u = re(() => {
    r.current !== s.current && (e("change-user-name", { source: "people-menu" }), r.current = s.current);
  }, [e]), h = re(() => {
    a(!1), t.user.updateUserPreferences({ name: r.current }), t.menus.clearOpenMenus();
  }, [t]);
  return /* @__PURE__ */ l.jsxs("div", { className: "tlui-people-menu__user", children: [
    /* @__PURE__ */ l.jsx(ice, {}),
    o ? /* @__PURE__ */ l.jsx(
      Ld,
      {
        className: "tlui-people-menu__user__input",
        defaultValue: n,
        onValueChange: d,
        onComplete: c,
        onCancel: h,
        onBlur: u,
        shouldManuallyMaintainScrollPositionWhenFocused: !0,
        autoFocus: !0,
        autoSelect: !0
      }
    ) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "div",
        {
          className: "tlui-people-menu__user__name",
          onDoubleClick: () => {
            o || a(!0);
          },
          children: n
        }
      ),
      n === "New User" ? /* @__PURE__ */ l.jsx("div", { className: "tlui-people-menu__user__label", children: i("people-menu.user") }) : null
    ] }),
    /* @__PURE__ */ l.jsx(
      q,
      {
        type: "icon",
        className: "tlui-people-menu__user__edit",
        "data-testid": "people-menu.change-name",
        title: i("people-menu.change-name"),
        onClick: c,
        children: /* @__PURE__ */ l.jsx(Te, { icon: o ? "check" : "edit" })
      }
    )
  ] });
}
const sce = Vt(function({ children: e }) {
  const n = ke(), i = qt(), r = Q(), s = Lv(), o = G("user", () => r.user.getColor(), [r]), a = G("user", () => r.user.getName(), [r]), [c, d] = Nr("people menu");
  return /* @__PURE__ */ l.jsxs(Nj, { onOpenChange: d, open: c, children: [
    /* @__PURE__ */ l.jsx(Aj, { dir: "ltr", asChild: !0, children: /* @__PURE__ */ l.jsxs("button", { className: "tlui-people-menu__avatars-button", title: n("people-menu.title"), children: [
      s.length > 5 && /* @__PURE__ */ l.jsx(nce, { count: s.length - 5 }),
      /* @__PURE__ */ l.jsxs("div", { className: "tlui-people-menu__avatars", children: [
        s.slice(-5).map((u) => /* @__PURE__ */ l.jsx(ece, { userId: u }, u)),
        /* @__PURE__ */ l.jsx(
          "div",
          {
            className: "tlui-people-menu__avatar",
            style: {
              backgroundColor: o
            },
            children: a === "New User" ? "" : a[0] ?? ""
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ l.jsx(Tj, { container: i, children: /* @__PURE__ */ l.jsx(
      bj,
      {
        dir: "ltr",
        className: "tlui-menu",
        align: "end",
        side: "bottom",
        sideOffset: 2,
        alignOffset: -5,
        onEscapeKeyDown: Ke,
        children: /* @__PURE__ */ l.jsxs("div", { className: "tlui-people-menu__wrapper", children: [
          /* @__PURE__ */ l.jsx("div", { className: "tlui-people-menu__section", children: /* @__PURE__ */ l.jsx(rce, {}) }),
          s.length > 0 && /* @__PURE__ */ l.jsx("div", { className: "tlui-people-menu__section", children: s.map((u) => /* @__PURE__ */ l.jsx(tce, { userId: u }, u + "_presence")) }),
          e
        ] })
      }
    ) })
  ] });
});
function oce() {
  return /* @__PURE__ */ l.jsx("div", { className: "tlui-share-zone", draggable: !1, children: /* @__PURE__ */ l.jsx(sce, {}) });
}
const ace = Object.freeze([
  Ln,
  Ms,
  ms,
  Oi
]);
function Nf(t = ace) {
  const e = Q();
  return G(
    "getRelevantStyles",
    () => {
      var s;
      const n = new qy(e.getSharedStyles()), i = !!((s = e.root.getCurrent()) != null && s.shapeType), r = e.isIn("select") && e.getSelectedShapeIds().length > 0;
      if (n.size === 0 && e.isIn("select") && e.getSelectedShapeIds().length === 0)
        for (const o of t)
          n.applyValue(o, e.getStyleForNextShape(o));
      return i || r || n.size > 0 ? n : null;
    },
    [e]
  );
}
const ut = {
  color: [
    { value: "black", icon: "color" },
    { value: "grey", icon: "color" },
    { value: "light-violet", icon: "color" },
    { value: "violet", icon: "color" },
    { value: "blue", icon: "color" },
    { value: "light-blue", icon: "color" },
    { value: "yellow", icon: "color" },
    { value: "orange", icon: "color" },
    { value: "green", icon: "color" },
    { value: "light-green", icon: "color" },
    { value: "light-red", icon: "color" },
    { value: "red", icon: "color" }
  ],
  fill: [
    { value: "none", icon: "fill-none" },
    { value: "semi", icon: "fill-semi" },
    { value: "solid", icon: "fill-solid" },
    { value: "pattern", icon: "fill-pattern" }
    // { value: 'fill', icon: 'fill-fill' },
  ],
  dash: [
    { value: "draw", icon: "dash-draw" },
    { value: "dashed", icon: "dash-dashed" },
    { value: "dotted", icon: "dash-dotted" },
    { value: "solid", icon: "dash-solid" }
  ],
  size: [
    { value: "s", icon: "size-small" },
    { value: "m", icon: "size-medium" },
    { value: "l", icon: "size-large" },
    { value: "xl", icon: "size-extra-large" }
  ],
  font: [
    { value: "draw", icon: "font-draw" },
    { value: "sans", icon: "font-sans" },
    { value: "serif", icon: "font-serif" },
    { value: "mono", icon: "font-mono" }
  ],
  textAlign: [
    { value: "start", icon: "text-align-left" },
    { value: "middle", icon: "text-align-center" },
    { value: "end", icon: "text-align-right" }
  ],
  horizontalAlign: [
    { value: "start", icon: "horizontal-align-start" },
    { value: "middle", icon: "horizontal-align-middle" },
    { value: "end", icon: "horizontal-align-end" }
  ],
  verticalAlign: [
    { value: "start", icon: "vertical-align-start" },
    { value: "middle", icon: "vertical-align-middle" },
    { value: "end", icon: "vertical-align-end" }
  ],
  geo: [
    { value: "rectangle", icon: "geo-rectangle" },
    { value: "ellipse", icon: "geo-ellipse" },
    { value: "triangle", icon: "geo-triangle" },
    { value: "diamond", icon: "geo-diamond" },
    { value: "star", icon: "geo-star" },
    { value: "pentagon", icon: "geo-pentagon" },
    { value: "hexagon", icon: "geo-hexagon" },
    { value: "octagon", icon: "geo-octagon" },
    { value: "rhombus", icon: "geo-rhombus" },
    { value: "rhombus-2", icon: "geo-rhombus-2" },
    { value: "oval", icon: "geo-oval" },
    { value: "trapezoid", icon: "geo-trapezoid" },
    { value: "arrow-left", icon: "geo-arrow-left" },
    { value: "arrow-up", icon: "geo-arrow-up" },
    { value: "arrow-down", icon: "geo-arrow-down" },
    { value: "arrow-right", icon: "geo-arrow-right" },
    { value: "cloud", icon: "geo-cloud" },
    { value: "x-box", icon: "geo-x-box" },
    { value: "check-box", icon: "geo-check-box" },
    { value: "heart", icon: "geo-heart" }
  ],
  arrowheadStart: [
    { value: "none", icon: "arrowhead-none" },
    { value: "arrow", icon: "arrowhead-arrow" },
    { value: "triangle", icon: "arrowhead-triangle" },
    { value: "square", icon: "arrowhead-square" },
    { value: "dot", icon: "arrowhead-dot" },
    { value: "diamond", icon: "arrowhead-diamond" },
    { value: "inverted", icon: "arrowhead-triangle-inverted" },
    { value: "bar", icon: "arrowhead-bar" }
  ],
  arrowheadEnd: [
    { value: "none", icon: "arrowhead-none" },
    { value: "arrow", icon: "arrowhead-arrow" },
    { value: "triangle", icon: "arrowhead-triangle" },
    { value: "square", icon: "arrowhead-square" },
    { value: "dot", icon: "arrowhead-dot" },
    { value: "diamond", icon: "arrowhead-diamond" },
    { value: "inverted", icon: "arrowhead-triangle-inverted" },
    { value: "bar", icon: "arrowhead-bar" }
  ],
  spline: [
    { value: "line", icon: "spline-line" },
    { value: "cubic", icon: "spline-cubic" }
  ]
}, Bn = _e(function(e) {
  const {
    uiType: n,
    items: i,
    title: r,
    style: s,
    value: o,
    // columns = clamp(items.length, 2, 4),
    onValueChange: a,
    onHistoryMark: c,
    theme: d
  } = e, u = ke(), h = le(!1), g = le(null), {
    handleButtonClick: p,
    handleButtonPointerDown: f,
    handleButtonPointerEnter: M,
    handleButtonPointerUp: m
  } = yt(() => {
    const y = () => {
      h.current = !1, window.removeEventListener("pointerup", y);
      const A = g.current;
      A && ["TEXTAREA", "INPUT"].includes(A.nodeName) && A.focus(), g.current = null;
    };
    return {
      handleButtonClick: (A) => {
        const { id: b } = A.currentTarget.dataset;
        o.type === "shared" && o.value === b || (c == null || c("point picker item"), a(s, b));
      },
      handleButtonPointerDown: (A) => {
        const { id: b } = A.currentTarget.dataset;
        c == null || c("point picker item"), a(s, b), h.current = !0, g.current = document.activeElement, window.addEventListener("pointerup", y);
      },
      handleButtonPointerEnter: (A) => {
        if (!h.current) return;
        const { id: b } = A.currentTarget.dataset;
        a(s, b);
      },
      handleButtonPointerUp: (A) => {
        const { id: b } = A.currentTarget.dataset;
        o.type === "shared" && o.value === b || a(s, b);
      }
    };
  }, [o, c, a, s]);
  return /* @__PURE__ */ l.jsx("div", { "data-testid": `style.${n}`, className: ce("tlui-buttons__grid"), children: i.map((y) => /* @__PURE__ */ l.jsx(
    q,
    {
      type: "icon",
      "data-id": y.value,
      "data-testid": `style.${n}.${y.value}`,
      "aria-label": y.value,
      "data-state": o.type === "shared" && o.value === y.value ? "hinted" : void 0,
      title: r + " — " + u(`${n}-style.${y.value}`),
      className: ce("tlui-button-grid__button"),
      style: s === Ln ? { color: d[y.value].solid } : void 0,
      onPointerEnter: M,
      onPointerDown: f,
      onPointerUp: m,
      onClick: p,
      children: /* @__PURE__ */ l.jsx(Te, { icon: y.icon })
    },
    y.value
  )) });
});
function FP(t, [e, n]) {
  return Math.min(n, Math.max(e, t));
}
function cce(t) {
  const e = N.useRef({ value: t, previous: t });
  return N.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
var BP = ["PageUp", "PageDown"], GP = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], WP = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, zc = "Slider", [ZI, lce, dce] = vd(zc), [HP, Mye] = bc(zc, [
  dce
]), [uce, Af] = HP(zc), VP = N.forwardRef(
  (t, e) => {
    const {
      name: n,
      min: i = 0,
      max: r = 100,
      step: s = 1,
      orientation: o = "horizontal",
      disabled: a = !1,
      minStepsBetweenThumbs: c = 0,
      defaultValue: d = [i],
      value: u,
      onValueChange: h = () => {
      },
      onValueCommit: g = () => {
      },
      inverted: p = !1,
      form: f,
      ...M
    } = t, m = N.useRef(/* @__PURE__ */ new Set()), y = N.useRef(0), D = o === "horizontal" ? hce : gce, [j = [], w] = go({
      prop: u,
      defaultProp: d,
      onChange: (P) => {
        var z;
        (z = [...m.current][y.current]) == null || z.focus(), h(P);
      }
    }), A = N.useRef(j);
    function b(P) {
      const C = yce(j, P);
      v(P, C);
    }
    function T(P) {
      v(P, y.current);
    }
    function E() {
      const P = A.current[y.current];
      j[y.current] !== P && g(j);
    }
    function v(P, C, { commit: z } = { commit: !1 }) {
      const O = jce(s), R = Dce(Math.round((P - i) / s) * s + i, O), U = FP(R, [i, r]);
      w((F = []) => {
        const H = Mce(F, U, C);
        if (Sce(H, c * s)) {
          y.current = H.indexOf(U);
          const Z = String(H) !== String(F);
          return Z && z && g(H), Z ? H : F;
        } else
          return F;
      });
    }
    return /* @__PURE__ */ l.jsx(
      uce,
      {
        scope: t.__scopeSlider,
        name: n,
        disabled: a,
        min: i,
        max: r,
        valueIndexToChangeRef: y,
        thumbs: m.current,
        values: j,
        orientation: o,
        form: f,
        children: /* @__PURE__ */ l.jsx(ZI.Provider, { scope: t.__scopeSlider, children: /* @__PURE__ */ l.jsx(ZI.Slot, { scope: t.__scopeSlider, children: /* @__PURE__ */ l.jsx(
          D,
          {
            "aria-disabled": a,
            "data-disabled": a ? "" : void 0,
            ...M,
            ref: e,
            onPointerDown: se(M.onPointerDown, () => {
              a || (A.current = j);
            }),
            min: i,
            max: r,
            inverted: p,
            onSlideStart: a ? void 0 : b,
            onSlideMove: a ? void 0 : T,
            onSlideEnd: a ? void 0 : E,
            onHomeKeyDown: () => !a && v(i, 0, { commit: !0 }),
            onEndKeyDown: () => !a && v(r, j.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: P, direction: C }) => {
              if (!a) {
                const R = BP.includes(P.key) || P.shiftKey && GP.includes(P.key) ? 10 : 1, U = y.current, F = j[U], H = s * R * C;
                v(F + H, U, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
VP.displayName = zc;
var [KP, XP] = HP(zc, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), hce = N.forwardRef(
  (t, e) => {
    const {
      min: n,
      max: i,
      dir: r,
      inverted: s,
      onSlideStart: o,
      onSlideMove: a,
      onSlideEnd: c,
      onStepKeyDown: d,
      ...u
    } = t, [h, g] = N.useState(null), p = it(e, (D) => g(D)), f = N.useRef(), M = _p(r), m = M === "ltr", y = m && !s || !m && s;
    function I(D) {
      const j = f.current || h.getBoundingClientRect(), w = [0, j.width], b = kj(w, y ? [n, i] : [i, n]);
      return f.current = j, b(D - j.left);
    }
    return /* @__PURE__ */ l.jsx(
      KP,
      {
        scope: t.__scopeSlider,
        startEdge: y ? "left" : "right",
        endEdge: y ? "right" : "left",
        direction: y ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ l.jsx(
          JP,
          {
            dir: M,
            "data-orientation": "horizontal",
            ...u,
            ref: p,
            style: {
              ...u.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (D) => {
              const j = I(D.clientX);
              o == null || o(j);
            },
            onSlideMove: (D) => {
              const j = I(D.clientX);
              a == null || a(j);
            },
            onSlideEnd: () => {
              f.current = void 0, c == null || c();
            },
            onStepKeyDown: (D) => {
              const w = WP[y ? "from-left" : "from-right"].includes(D.key);
              d == null || d({ event: D, direction: w ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), gce = N.forwardRef(
  (t, e) => {
    const {
      min: n,
      max: i,
      inverted: r,
      onSlideStart: s,
      onSlideMove: o,
      onSlideEnd: a,
      onStepKeyDown: c,
      ...d
    } = t, u = N.useRef(null), h = it(e, u), g = N.useRef(), p = !r;
    function f(M) {
      const m = g.current || u.current.getBoundingClientRect(), y = [0, m.height], D = kj(y, p ? [i, n] : [n, i]);
      return g.current = m, D(M - m.top);
    }
    return /* @__PURE__ */ l.jsx(
      KP,
      {
        scope: t.__scopeSlider,
        startEdge: p ? "bottom" : "top",
        endEdge: p ? "top" : "bottom",
        size: "height",
        direction: p ? 1 : -1,
        children: /* @__PURE__ */ l.jsx(
          JP,
          {
            "data-orientation": "vertical",
            ...d,
            ref: h,
            style: {
              ...d.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (M) => {
              const m = f(M.clientY);
              s == null || s(m);
            },
            onSlideMove: (M) => {
              const m = f(M.clientY);
              o == null || o(m);
            },
            onSlideEnd: () => {
              g.current = void 0, a == null || a();
            },
            onStepKeyDown: (M) => {
              const y = WP[p ? "from-bottom" : "from-top"].includes(M.key);
              c == null || c({ event: M, direction: y ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), JP = N.forwardRef(
  (t, e) => {
    const {
      __scopeSlider: n,
      onSlideStart: i,
      onSlideMove: r,
      onSlideEnd: s,
      onHomeKeyDown: o,
      onEndKeyDown: a,
      onStepKeyDown: c,
      ...d
    } = t, u = Af(zc, n);
    return /* @__PURE__ */ l.jsx(
      Fe.span,
      {
        ...d,
        ref: e,
        onKeyDown: se(t.onKeyDown, (h) => {
          h.key === "Home" ? (o(h), h.preventDefault()) : h.key === "End" ? (a(h), h.preventDefault()) : BP.concat(GP).includes(h.key) && (c(h), h.preventDefault());
        }),
        onPointerDown: se(t.onPointerDown, (h) => {
          const g = h.target;
          g.setPointerCapture(h.pointerId), h.preventDefault(), u.thumbs.has(g) ? g.focus() : i(h);
        }),
        onPointerMove: se(t.onPointerMove, (h) => {
          h.target.hasPointerCapture(h.pointerId) && r(h);
        }),
        onPointerUp: se(t.onPointerUp, (h) => {
          const g = h.target;
          g.hasPointerCapture(h.pointerId) && (g.releasePointerCapture(h.pointerId), s(h));
        })
      }
    );
  }
), qP = "SliderTrack", _P = N.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, ...i } = t, r = Af(qP, n);
    return /* @__PURE__ */ l.jsx(
      Fe.span,
      {
        "data-disabled": r.disabled ? "" : void 0,
        "data-orientation": r.orientation,
        ...i,
        ref: e
      }
    );
  }
);
_P.displayName = qP;
var FI = "SliderRange", $P = N.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, ...i } = t, r = Af(FI, n), s = XP(FI, n), o = N.useRef(null), a = it(e, o), c = r.values.length, d = r.values.map(
      (g) => t2(g, r.min, r.max)
    ), u = c > 1 ? Math.min(...d) : 0, h = 100 - Math.max(...d);
    return /* @__PURE__ */ l.jsx(
      Fe.span,
      {
        "data-orientation": r.orientation,
        "data-disabled": r.disabled ? "" : void 0,
        ...i,
        ref: a,
        style: {
          ...t.style,
          [s.startEdge]: u + "%",
          [s.endEdge]: h + "%"
        }
      }
    );
  }
);
$P.displayName = FI;
var BI = "SliderThumb", e2 = N.forwardRef(
  (t, e) => {
    const n = lce(t.__scopeSlider), [i, r] = N.useState(null), s = it(e, (a) => r(a)), o = N.useMemo(
      () => i ? n().findIndex((a) => a.ref.current === i) : -1,
      [n, i]
    );
    return /* @__PURE__ */ l.jsx(pce, { ...t, ref: s, index: o });
  }
), pce = N.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, index: i, name: r, ...s } = t, o = Af(BI, n), a = XP(BI, n), [c, d] = N.useState(null), u = it(e, (I) => d(I)), h = c ? o.form || !!c.closest("form") : !0, g = Cz(c), p = o.values[i], f = p === void 0 ? 0 : t2(p, o.min, o.max), M = mce(i, o.values.length), m = g == null ? void 0 : g[a.size], y = m ? Ice(m, f, a.direction) : 0;
    return N.useEffect(() => {
      if (c)
        return o.thumbs.add(c), () => {
          o.thumbs.delete(c);
        };
    }, [c, o.thumbs]), /* @__PURE__ */ l.jsxs(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [a.startEdge]: `calc(${f}% + ${y}px)`
        },
        children: [
          /* @__PURE__ */ l.jsx(ZI.ItemSlot, { scope: t.__scopeSlider, children: /* @__PURE__ */ l.jsx(
            Fe.span,
            {
              role: "slider",
              "aria-label": t["aria-label"] || M,
              "aria-valuemin": o.min,
              "aria-valuenow": p,
              "aria-valuemax": o.max,
              "aria-orientation": o.orientation,
              "data-orientation": o.orientation,
              "data-disabled": o.disabled ? "" : void 0,
              tabIndex: o.disabled ? void 0 : 0,
              ...s,
              ref: u,
              style: p === void 0 ? { display: "none" } : t.style,
              onFocus: se(t.onFocus, () => {
                o.valueIndexToChangeRef.current = i;
              })
            }
          ) }),
          h && /* @__PURE__ */ l.jsx(
            fce,
            {
              name: r ?? (o.name ? o.name + (o.values.length > 1 ? "[]" : "") : void 0),
              form: o.form,
              value: p
            },
            i
          )
        ]
      }
    );
  }
);
e2.displayName = BI;
var fce = (t) => {
  const { value: e, ...n } = t, i = N.useRef(null), r = cce(e);
  return N.useEffect(() => {
    const s = i.current, o = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(o, "value").set;
    if (r !== e && c) {
      const d = new Event("input", { bubbles: !0 });
      c.call(s, e), s.dispatchEvent(d);
    }
  }, [r, e]), /* @__PURE__ */ l.jsx("input", { style: { display: "none" }, ...n, ref: i, defaultValue: e });
};
function Mce(t = [], e, n) {
  const i = [...t];
  return i[n] = e, i.sort((r, s) => r - s);
}
function t2(t, e, n) {
  const s = 100 / (n - e) * (t - e);
  return FP(s, [0, 100]);
}
function mce(t, e) {
  return e > 2 ? `Value ${t + 1} of ${e}` : e === 2 ? ["Minimum", "Maximum"][t] : void 0;
}
function yce(t, e) {
  if (t.length === 1) return 0;
  const n = t.map((r) => Math.abs(r - e)), i = Math.min(...n);
  return n.indexOf(i);
}
function Ice(t, e, n) {
  const i = t / 2, s = kj([0, 50], [0, i]);
  return (i - s(e) * n) * n;
}
function xce(t) {
  return t.slice(0, -1).map((e, n) => t[n + 1] - e);
}
function Sce(t, e) {
  if (e > 0) {
    const n = xce(t);
    return Math.min(...n) >= e;
  }
  return !0;
}
function kj(t, e) {
  return (n) => {
    if (t[0] === t[1] || e[0] === e[1]) return e[0];
    const i = (e[1] - e[0]) / (t[1] - t[0]);
    return e[0] + i * (n - t[0]);
  };
}
function jce(t) {
  return (String(t).split(".")[1] || "").length;
}
function Dce(t, e) {
  const n = Math.pow(10, e);
  return Math.round(t * n) / n;
}
var wce = VP, Nce = _P, Ace = $P, Tce = e2;
const n2 = _e(function({
  onHistoryMark: e,
  title: n,
  steps: i,
  value: r,
  label: s,
  onValueChange: o,
  ["data-testid"]: a
}) {
  const c = ke(), d = re(
    (g) => {
      o(g[0]);
    },
    [o]
  ), u = re(() => {
    e("click slider");
  }, [e]), h = re(() => {
    r && o(r);
  }, [r, o]);
  return /* @__PURE__ */ l.jsx("div", { className: "tlui-slider__container", children: /* @__PURE__ */ l.jsxs(
    wce,
    {
      "data-testid": a,
      className: "tlui-slider",
      "area-label": "Opacity",
      dir: "ltr",
      min: 0,
      max: i,
      step: 1,
      value: r ? [r] : void 0,
      onPointerDown: u,
      onValueChange: d,
      onPointerUp: h,
      title: n + " — " + c(s),
      children: [
        /* @__PURE__ */ l.jsx(Nce, { className: "tlui-slider__track", dir: "ltr", children: r !== null && /* @__PURE__ */ l.jsx(Ace, { className: "tlui-slider__range", dir: "ltr" }) }),
        r !== null && /* @__PURE__ */ l.jsx(Tce, { className: "tlui-slider__thumb", dir: "ltr" })
      ]
    }
  ) });
});
function bce({
  label: t,
  uiTypeA: e,
  uiTypeB: n,
  labelA: i,
  labelB: r,
  itemsA: s,
  itemsB: o,
  styleA: a,
  styleB: c,
  valueA: d,
  valueB: u,
  onValueChange: h
}) {
  const g = ke(), p = N.useMemo(
    () => {
      var M;
      return ((M = s.find((m) => d.type === "shared" && d.value === m.value)) == null ? void 0 : M.icon) ?? "mixed";
    },
    [s, d]
  ), f = N.useMemo(
    () => {
      var M;
      return ((M = o.find((m) => u.type === "shared" && u.value === m.value)) == null ? void 0 : M.icon) ?? "mixed";
    },
    [o, u]
  );
  return d === void 0 && u === void 0 ? null : /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__double-select-picker", children: [
    /* @__PURE__ */ l.jsx("div", { title: g(t), className: "tlui-style-panel__double-select-picker-label", children: g(t) }),
    /* @__PURE__ */ l.jsxs("div", { className: "tlui-buttons__horizontal", children: [
      /* @__PURE__ */ l.jsxs(mr, { id: `style panel ${e} A`, children: [
        /* @__PURE__ */ l.jsx(yr, { children: /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            "data-testid": `style.${e}`,
            title: g(i) + " — " + (d === null || d.type === "mixed" ? g("style-panel.mixed") : g(`${e}-style.${d.value}`)),
            children: /* @__PURE__ */ l.jsx(Te, { icon: p, small: !0, invertIcon: !0 })
          }
        ) }),
        /* @__PURE__ */ l.jsx(Ir, { side: "left", align: "center", sideOffset: 80, alignOffset: 0, children: /* @__PURE__ */ l.jsx("div", { className: "tlui-buttons__grid", children: s.map((M, m) => /* @__PURE__ */ l.jsx(ro, { "data-testid": `style.${e}.${M.value}`, children: /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            onClick: () => h(a, M.value),
            title: `${g(i)} — ${g(`${e}-style.${M.value}`)}`,
            children: /* @__PURE__ */ l.jsx(Te, { icon: M.icon, invertIcon: !0 })
          },
          M.value
        ) }, m)) }) })
      ] }),
      /* @__PURE__ */ l.jsxs(mr, { id: `style panel ${n}`, children: [
        /* @__PURE__ */ l.jsx(yr, { children: /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            "data-testid": `style.${n}`,
            title: g(r) + " — " + (u === null || u.type === "mixed" ? g("style-panel.mixed") : g(`${n}-style.${u.value}`)),
            children: /* @__PURE__ */ l.jsx(Te, { icon: f, small: !0 })
          }
        ) }),
        /* @__PURE__ */ l.jsx(Ir, { side: "left", align: "center", sideOffset: 116, alignOffset: 0, children: /* @__PURE__ */ l.jsx("div", { className: "tlui-buttons__grid", children: o.map((M) => /* @__PURE__ */ l.jsx(ro, { children: /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            title: `${g(r)} — ${g(`${n}-style.${M.value}`)}`,
            "data-testid": `style.${n}.${M.value}`,
            onClick: () => h(c, M.value),
            children: /* @__PURE__ */ l.jsx(Te, { icon: M.icon })
          }
        ) }, M.value)) }) })
      ] })
    ] })
  ] });
}
const vce = N.memo(
  bce
);
function Ece({
  id: t,
  label: e,
  uiType: n,
  stylePanelType: i,
  style: r,
  items: s,
  type: o,
  value: a,
  onValueChange: c
}) {
  const d = ke(), u = Q(), h = N.useMemo(
    () => {
      var M;
      return (M = s.find((m) => a.type === "shared" && m.value === a.value)) == null ? void 0 : M.icon;
    },
    [s, a]
  ), g = d(`style-panel.${i}`), p = a.type === "mixed" ? d("style-panel.mixed") : g + " — " + d(`${n}-style.${a.value}`), f = e ? d(e) : "";
  return /* @__PURE__ */ l.jsxs(mr, { id: `style panel ${t}`, children: [
    /* @__PURE__ */ l.jsx(yr, { children: /* @__PURE__ */ l.jsxs(q, { type: o, "data-testid": `style.${n}`, title: p, children: [
      f && /* @__PURE__ */ l.jsx(St, { children: f }),
      /* @__PURE__ */ l.jsx(Te, { icon: h ?? "mixed" })
    ] }) }),
    /* @__PURE__ */ l.jsx(Ir, { side: "left", align: "center", alignOffset: 0, children: /* @__PURE__ */ l.jsx("div", { className: "tlui-buttons__grid", children: s.map((M) => /* @__PURE__ */ l.jsx(ro, { children: /* @__PURE__ */ l.jsx(
      q,
      {
        type: "icon",
        "data-testid": `style.${n}.${M.value}`,
        title: g + " — " + d(`${n}-style.${M.value}`),
        onClick: () => {
          u.markHistoryStoppingPoint("select style dropdown item"), c(r, M.value);
        },
        children: /* @__PURE__ */ l.jsx(Te, { icon: M.icon })
      }
    ) }, M.value)) }) })
  ] });
}
const Oj = N.memo(Ece);
function Cce({ styles: t }) {
  const e = Tc();
  if (!t) return null;
  const n = t.get(Fn), i = t.get($s), r = t.get(Uo), s = t.get(Ro), o = t.get(ki), a = n === void 0, c = i === void 0 && r === void 0, d = s === void 0, u = o === void 0, h = Hr({ isDarkMode: e });
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(zce, { theme: h, styles: t }),
    !u && /* @__PURE__ */ l.jsx(Lce, { theme: h, styles: t }),
    !(a && c && d) && /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__section", "aria-label": "style panel styles", children: [
      /* @__PURE__ */ l.jsx(kce, { styles: t }),
      /* @__PURE__ */ l.jsx(Pce, { styles: t }),
      /* @__PURE__ */ l.jsx(Oce, { styles: t })
    ] })
  ] });
}
function Wd() {
  const t = Q(), e = Zt();
  return Ye.useMemo(
    () => function(i, r) {
      t.run(() => {
        t.isIn("select") && t.setStyleForSelectedShapes(i, r), t.setStyleForNextShapes(i, r), t.updateInstanceState({ isChangingStyle: !0 });
      }), e("set-style", { source: "style-panel", id: i.id, value: r });
    },
    [t, e]
  );
}
function zce({ styles: t, theme: e }) {
  const n = ke(), i = Q(), r = re((h) => i.markHistoryStoppingPoint(h), [i]), s = Wd(), o = t.get(Ln), a = t.get(ms), c = t.get(Ms), d = t.get(Oi), u = a !== void 0 || c !== void 0 || d !== void 0;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(
      "div",
      {
        tabIndex: -1,
        className: "tlui-style-panel__section__common",
        "aria-label": "style panel styles",
        "data-testid": "style.panel",
        children: [
          o === void 0 ? null : /* @__PURE__ */ l.jsx(
            Bn,
            {
              title: n("style-panel.color"),
              uiType: "color",
              style: Ln,
              items: ut.color,
              value: o,
              onValueChange: s,
              theme: e,
              onHistoryMark: r
            }
          ),
          /* @__PURE__ */ l.jsx(Uce, {})
        ]
      }
    ),
    u && /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__section", "aria-label": "style panel styles", children: [
      a === void 0 ? null : /* @__PURE__ */ l.jsx(
        Bn,
        {
          title: n("style-panel.fill"),
          uiType: "fill",
          style: ms,
          items: ut.fill,
          value: a,
          onValueChange: s,
          theme: e,
          onHistoryMark: r
        }
      ),
      c === void 0 ? null : /* @__PURE__ */ l.jsx(
        Bn,
        {
          title: n("style-panel.dash"),
          uiType: "dash",
          style: Ms,
          items: ut.dash,
          value: c,
          onValueChange: s,
          theme: e,
          onHistoryMark: r
        }
      ),
      d === void 0 ? null : /* @__PURE__ */ l.jsx(
        Bn,
        {
          title: n("style-panel.size"),
          uiType: "size",
          style: Oi,
          items: ut.size,
          value: d,
          onValueChange: (h, g) => {
            s(h, g);
            const p = i.getSelectedShapeIds();
            p.length > 0 && It(i, p);
          },
          theme: e,
          onHistoryMark: r
        }
      )
    ] })
  ] });
}
function Lce({ theme: t, styles: e }) {
  const n = ke(), i = Wd(), r = Q(), s = re((u) => r.markHistoryStoppingPoint(u), [r]), o = e.get(ki), a = e.get(Xl), c = e.get(Ka), d = e.get(Xa);
  return o === void 0 && c === void 0 ? null : /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__section", "aria-label": "style panel text", children: [
    o === void 0 ? null : /* @__PURE__ */ l.jsx(
      Bn,
      {
        title: n("style-panel.font"),
        uiType: "font",
        style: ki,
        items: ut.font,
        value: o,
        onValueChange: i,
        theme: t,
        onHistoryMark: s
      }
    ),
    a === void 0 ? null : /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__row", children: [
      /* @__PURE__ */ l.jsx(
        Bn,
        {
          title: n("style-panel.align"),
          uiType: "align",
          style: Xl,
          items: ut.textAlign,
          value: a,
          onValueChange: i,
          theme: t,
          onHistoryMark: s
        }
      ),
      /* @__PURE__ */ l.jsx("div", { className: "tlui-style-panel__row__extra-button", children: /* @__PURE__ */ l.jsx(
        q,
        {
          type: "icon",
          title: n("style-panel.vertical-align"),
          "data-testid": "vertical-align",
          disabled: !0,
          children: /* @__PURE__ */ l.jsx(Te, { icon: "vertical-align-middle" })
        }
      ) })
    ] }),
    c === void 0 ? null : /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__row", children: [
      /* @__PURE__ */ l.jsx(
        Bn,
        {
          title: n("style-panel.label-align"),
          uiType: "align",
          style: Ka,
          items: ut.horizontalAlign,
          value: c,
          onValueChange: i,
          theme: t,
          onHistoryMark: s
        }
      ),
      /* @__PURE__ */ l.jsx("div", { className: "tlui-style-panel__row__extra-button", children: d === void 0 ? /* @__PURE__ */ l.jsx(
        q,
        {
          type: "icon",
          title: n("style-panel.vertical-align"),
          "data-testid": "vertical-align",
          disabled: !0,
          children: /* @__PURE__ */ l.jsx(Te, { icon: "vertical-align-middle" })
        }
      ) : /* @__PURE__ */ l.jsx(
        Oj,
        {
          type: "icon",
          id: "geo-vertical-alignment",
          uiType: "verticalAlign",
          stylePanelType: "vertical-align",
          style: Xa,
          items: ut.verticalAlign,
          value: d,
          onValueChange: i
        }
      ) })
    ] })
  ] });
}
function kce({ styles: t }) {
  const e = Wd(), n = t.get(Fn);
  return n === void 0 ? null : /* @__PURE__ */ l.jsx(
    Oj,
    {
      id: "geo",
      type: "menu",
      label: "style-panel.geo",
      uiType: "geo",
      stylePanelType: "geo",
      style: Fn,
      items: ut.geo,
      value: n,
      onValueChange: e
    }
  );
}
function Oce({ styles: t }) {
  const e = Wd(), n = t.get(Ro);
  return n === void 0 ? null : /* @__PURE__ */ l.jsx(
    Oj,
    {
      id: "spline",
      type: "menu",
      label: "style-panel.spline",
      uiType: "spline",
      stylePanelType: "spline",
      style: Ro,
      items: ut.spline,
      value: n,
      onValueChange: e
    }
  );
}
function Pce({ styles: t }) {
  const e = Wd(), n = t.get($s), i = t.get(Uo);
  return !n || !i ? null : /* @__PURE__ */ l.jsx(
    vce,
    {
      label: "style-panel.arrowheads",
      uiTypeA: "arrowheadStart",
      styleA: Uo,
      itemsA: ut.arrowheadStart,
      valueA: i,
      uiTypeB: "arrowheadEnd",
      styleB: $s,
      itemsB: ut.arrowheadEnd,
      valueB: n,
      onValueChange: e,
      labelA: "style-panel.arrowhead-start",
      labelB: "style-panel.arrowhead-end"
    }
  );
}
const gl = [0.1, 0.25, 0.5, 0.75, 1];
function Uce() {
  const t = Q(), e = re((a) => t.markHistoryStoppingPoint(a), [t]), n = G("opacity", () => t.getSharedOpacity(), [t]), i = Zt(), r = ke(), s = Ye.useCallback(
    (a) => {
      const c = gl[a];
      t.run(() => {
        t.isIn("select") && t.setOpacityForSelectedShapes(c), t.setOpacityForNextShapes(c), t.updateInstanceState({ isChangingStyle: !0 });
      }), i("set-style", { source: "style-panel", id: "opacity", value: a });
    },
    [t, i]
  );
  if (n === void 0) return null;
  const o = n.type === "mixed" ? -1 : gl.indexOf(
    IU(
      gl,
      (a) => Math.abs(a - n.value)
    )
  );
  return /* @__PURE__ */ l.jsx(
    n2,
    {
      "data-testid": "style.opacity",
      value: o >= 0 ? o : gl.length - 1,
      label: n.type === "mixed" ? "style-panel.mixed" : `opacity-style.${n.value}`,
      onValueChange: s,
      steps: gl.length - 1,
      title: r("style-panel.opacity"),
      onHistoryMark: e
    }
  );
}
const Rce = _e(function({
  isMobile: e,
  children: n
}) {
  const i = Q(), r = le(null);
  uo(r);
  const s = Nf(), o = re(() => {
    e || i.updateInstanceState({ isChangingStyle: !1 });
  }, [i, e]), a = n ?? /* @__PURE__ */ l.jsx(Cce, { styles: s });
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: r,
      className: ce("tlui-style-panel", { "tlui-style-panel__wrapper": !e }),
      "data-ismobile": e,
      onPointerLeave: o,
      children: a
    }
  );
});
function Yce() {
  const t = Q(), e = ke(), n = Nf(), i = n == null ? void 0 : n.get(Ln), r = Hr({ isDarkMode: t.user.getIsDarkMode() }), s = ((i == null ? void 0 : i.type) === "shared" ? r[i.value] : r.black).solid, o = G(
    "disable style panel",
    () => t.isInAny("hand", "zoom", "eraser", "laser"),
    [t]
  ), a = re(
    (d) => {
      d || t.updateInstanceState({ isChangingStyle: !1 });
    },
    [t]
  ), { StylePanel: c } = Io();
  return c ? /* @__PURE__ */ l.jsxs(Gn, { id: "mobile style menu", onOpenChange: a, children: [
    /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
      q,
      {
        type: "tool",
        "data-testid": "mobile-styles.button",
        style: {
          color: o ? "var(--color-muted-1)" : s
        },
        title: e("style-panel.title"),
        disabled: o,
        children: /* @__PURE__ */ l.jsx(
          Te,
          {
            icon: o ? "blob" : (i == null ? void 0 : i.type) === "mixed" ? "mixed" : "blob"
          }
        )
      }
    ) }),
    /* @__PURE__ */ l.jsx(Hn, { side: "top", align: "end", children: c && /* @__PURE__ */ l.jsx(c, { isMobile: !0 }) })
  ] }) : null;
}
function Qce() {
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(Zce, {}),
    /* @__PURE__ */ l.jsx(Fce, {}),
    /* @__PURE__ */ l.jsx(Bce, {}),
    /* @__PURE__ */ l.jsx(Gce, {}),
    /* @__PURE__ */ l.jsx(Wce, {}),
    /* @__PURE__ */ l.jsx(Hce, {}),
    /* @__PURE__ */ l.jsx(Vce, {}),
    /* @__PURE__ */ l.jsx(i2, {}),
    /* @__PURE__ */ l.jsx(Kce, {}),
    /* @__PURE__ */ l.jsx(Xce, {}),
    /* @__PURE__ */ l.jsx(qce, {}),
    /* @__PURE__ */ l.jsx(Jce, {}),
    /* @__PURE__ */ l.jsx(ele, {}),
    /* @__PURE__ */ l.jsx(ile, {}),
    /* @__PURE__ */ l.jsx(_ce, {}),
    /* @__PURE__ */ l.jsx(nle, {}),
    /* @__PURE__ */ l.jsx(tle, {}),
    /* @__PURE__ */ l.jsx($ce, {}),
    /* @__PURE__ */ l.jsx(rle, {}),
    /* @__PURE__ */ l.jsx(sle, {}),
    /* @__PURE__ */ l.jsx(ole, {}),
    /* @__PURE__ */ l.jsx(ale, {}),
    /* @__PURE__ */ l.jsx(cle, {}),
    /* @__PURE__ */ l.jsx(lle, {}),
    /* @__PURE__ */ l.jsx(dle, {}),
    /* @__PURE__ */ l.jsx(ule, {}),
    /* @__PURE__ */ l.jsx(gle, {}),
    /* @__PURE__ */ l.jsx(hle, {})
  ] });
}
function Tf(t) {
  var i;
  const e = Q(), n = (i = t.meta) == null ? void 0 : i.geo;
  return G(
    "is tool selected",
    () => {
      const r = e.getCurrentToolId(), s = e.getSharedStyles().getAsKnownValue(Fn);
      return n ? r === "geo" && s === n : r === t.id;
    },
    [e, t.id, n]
  );
}
function jt({ tool: t }) {
  const e = mo(), n = Tf(e[t]);
  return /* @__PURE__ */ l.jsx(ii, { toolId: t, isSelected: n });
}
function Zce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "select" });
}
function Fce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "hand" });
}
function Bce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "draw" });
}
function Gce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "eraser" });
}
function Wce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "arrow" });
}
function Hce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "text" });
}
function Vce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "note" });
}
function i2() {
  return /* @__PURE__ */ l.jsx(ii, { toolId: "asset" });
}
function Kce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "rectangle" });
}
function Xce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "ellipse" });
}
function Jce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "diamond" });
}
function qce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "triangle" });
}
function _ce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "rhombus" });
}
function $ce() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "heart" });
}
function ele() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "hexagon" });
}
function tle() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "cloud" });
}
function nle() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "star" });
}
function ile() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "oval" });
}
function rle() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "x-box" });
}
function sle() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "check-box" });
}
function ole() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "arrow-left" });
}
function ale() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "arrow-up" });
}
function cle() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "arrow-down" });
}
function lle() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "arrow-right" });
}
function dle() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "line" });
}
function ule() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "highlight" });
}
function hle() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "frame" });
}
function gle() {
  return /* @__PURE__ */ l.jsx(jt, { tool: "laser" });
}
const hm = typeof navigator < "u" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1;
function gm(t, e, n, i) {
  t.addEventListener ? t.addEventListener(e, n, i) : t.attachEvent && t.attachEvent("on".concat(e), n);
}
function pl(t, e, n, i) {
  t.removeEventListener ? t.removeEventListener(e, n, i) : t.detachEvent && t.detachEvent("on".concat(e), n);
}
function r2(t, e) {
  const n = e.slice(0, e.length - 1);
  for (let i = 0; i < n.length; i++) n[i] = t[n[i].toLowerCase()];
  return n;
}
function s2(t) {
  typeof t != "string" && (t = ""), t = t.replace(/\s/g, "");
  const e = t.split(",");
  let n = e.lastIndexOf("");
  for (; n >= 0; )
    e[n - 1] += ",", e.splice(n, 1), n = e.lastIndexOf("");
  return e;
}
function ple(t, e) {
  const n = t.length >= e.length ? t : e, i = t.length >= e.length ? e : t;
  let r = !0;
  for (let s = 0; s < n.length; s++)
    i.indexOf(n[s]) === -1 && (r = !1);
  return r;
}
const od = {
  backspace: 8,
  "⌫": 8,
  tab: 9,
  clear: 12,
  enter: 13,
  "↩": 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": hm ? 173 : 189,
  "=": hm ? 61 : 187,
  ";": hm ? 59 : 186,
  "'": 222,
  "[": 219,
  "]": 221,
  "\\": 220
}, Br = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  command: 91
}, GI = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, gn = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, Rt = {};
for (let t = 1; t < 20; t++)
  od["f".concat(t)] = 111 + t;
let wt = [], Ql = null, o2 = "all";
const os = /* @__PURE__ */ new Map(), Hd = (t) => od[t.toLowerCase()] || Br[t.toLowerCase()] || t.toUpperCase().charCodeAt(0), fle = (t) => Object.keys(od).find((e) => od[e] === t), Mle = (t) => Object.keys(Br).find((e) => Br[e] === t);
function a2(t) {
  o2 = t || "all";
}
function ad() {
  return o2 || "all";
}
function mle() {
  return wt.slice(0);
}
function yle() {
  return wt.map((t) => fle(t) || Mle(t) || String.fromCharCode(t));
}
function Ile() {
  const t = [];
  return Object.keys(Rt).forEach((e) => {
    Rt[e].forEach((n) => {
      let {
        key: i,
        scope: r,
        mods: s,
        shortcut: o
      } = n;
      t.push({
        scope: r,
        shortcut: o,
        mods: s,
        keys: i.split("+").map((a) => Hd(a))
      });
    });
  }), t;
}
function xle(t) {
  const e = t.target || t.srcElement, {
    tagName: n
  } = e;
  let i = !0;
  const r = n === "INPUT" && !["checkbox", "radio", "range", "button", "file", "reset", "submit", "color"].includes(e.type);
  return (e.isContentEditable || (r || n === "TEXTAREA" || n === "SELECT") && !e.readOnly) && (i = !1), i;
}
function Sle(t) {
  return typeof t == "string" && (t = Hd(t)), wt.indexOf(t) !== -1;
}
function jle(t, e) {
  let n, i;
  t || (t = ad());
  for (const r in Rt)
    if (Object.prototype.hasOwnProperty.call(Rt, r))
      for (n = Rt[r], i = 0; i < n.length; )
        n[i].scope === t ? n.splice(i, 1).forEach((o) => {
          let {
            element: a
          } = o;
          return Pj(a);
        }) : i++;
  ad() === t && a2(e || "all");
}
function Dle(t) {
  let e = t.keyCode || t.which || t.charCode;
  const n = wt.indexOf(e);
  if (n >= 0 && wt.splice(n, 1), t.key && t.key.toLowerCase() === "meta" && wt.splice(0, wt.length), (e === 93 || e === 224) && (e = 91), e in gn) {
    gn[e] = !1;
    for (const i in Br) Br[i] === e && (pi[i] = !1);
  }
}
function c2(t) {
  if (typeof t > "u")
    Object.keys(Rt).forEach((r) => {
      Array.isArray(Rt[r]) && Rt[r].forEach((s) => th(s)), delete Rt[r];
    }), Pj(null);
  else if (Array.isArray(t))
    t.forEach((r) => {
      r.key && th(r);
    });
  else if (typeof t == "object")
    t.key && th(t);
  else if (typeof t == "string") {
    for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++)
      n[i - 1] = arguments[i];
    let [r, s] = n;
    typeof r == "function" && (s = r, r = ""), th({
      key: t,
      scope: r,
      method: s,
      splitKey: "+"
    });
  }
}
const th = (t) => {
  let {
    key: e,
    scope: n,
    method: i,
    splitKey: r = "+"
  } = t;
  s2(e).forEach((o) => {
    const a = o.split(r), c = a.length, d = a[c - 1], u = d === "*" ? "*" : Hd(d);
    if (!Rt[u]) return;
    n || (n = ad());
    const h = c > 1 ? r2(Br, a) : [], g = [];
    Rt[u] = Rt[u].filter((p) => {
      const M = (i ? p.method === i : !0) && p.scope === n && ple(p.mods, h);
      return M && g.push(p.element), !M;
    }), g.forEach((p) => Pj(p));
  });
};
function VN(t, e, n, i) {
  if (e.element !== i)
    return;
  let r;
  if (e.scope === n || e.scope === "all") {
    r = e.mods.length > 0;
    for (const s in gn)
      Object.prototype.hasOwnProperty.call(gn, s) && (!gn[s] && e.mods.indexOf(+s) > -1 || gn[s] && e.mods.indexOf(+s) === -1) && (r = !1);
    (e.mods.length === 0 && !gn[16] && !gn[18] && !gn[17] && !gn[91] || r || e.shortcut === "*") && (e.keys = [], e.keys = e.keys.concat(wt), e.method(t, e) === !1 && (t.preventDefault ? t.preventDefault() : t.returnValue = !1, t.stopPropagation && t.stopPropagation(), t.cancelBubble && (t.cancelBubble = !0)));
  }
}
function KN(t, e) {
  const n = Rt["*"];
  let i = t.keyCode || t.which || t.charCode;
  if (!pi.filter.call(this, t)) return;
  if ((i === 93 || i === 224) && (i = 91), wt.indexOf(i) === -1 && i !== 229 && wt.push(i), ["ctrlKey", "altKey", "shiftKey", "metaKey"].forEach((a) => {
    const c = GI[a];
    t[a] && wt.indexOf(c) === -1 ? wt.push(c) : !t[a] && wt.indexOf(c) > -1 ? wt.splice(wt.indexOf(c), 1) : a === "metaKey" && t[a] && wt.length === 3 && (t.ctrlKey || t.shiftKey || t.altKey || (wt = wt.slice(wt.indexOf(c))));
  }), i in gn) {
    gn[i] = !0;
    for (const a in Br)
      Br[a] === i && (pi[a] = !0);
    if (!n) return;
  }
  for (const a in gn)
    Object.prototype.hasOwnProperty.call(gn, a) && (gn[a] = t[GI[a]]);
  t.getModifierState && !(t.altKey && !t.ctrlKey) && t.getModifierState("AltGraph") && (wt.indexOf(17) === -1 && wt.push(17), wt.indexOf(18) === -1 && wt.push(18), gn[17] = !0, gn[18] = !0);
  const r = ad();
  if (n)
    for (let a = 0; a < n.length; a++)
      n[a].scope === r && (t.type === "keydown" && n[a].keydown || t.type === "keyup" && n[a].keyup) && VN(t, n[a], r, e);
  if (!(i in Rt)) return;
  const s = Rt[i], o = s.length;
  for (let a = 0; a < o; a++)
    if ((t.type === "keydown" && s[a].keydown || t.type === "keyup" && s[a].keyup) && s[a].key) {
      const c = s[a], {
        splitKey: d
      } = c, u = c.key.split(d), h = [];
      for (let g = 0; g < u.length; g++)
        h.push(Hd(u[g]));
      h.sort().join("") === wt.sort().join("") && VN(t, c, r, e);
    }
}
function pi(t, e, n) {
  wt = [];
  const i = s2(t);
  let r = [], s = "all", o = document, a = 0, c = !1, d = !0, u = "+", h = !1, g = !1;
  for (n === void 0 && typeof e == "function" && (n = e), Object.prototype.toString.call(e) === "[object Object]" && (e.scope && (s = e.scope), e.element && (o = e.element), e.keyup && (c = e.keyup), e.keydown !== void 0 && (d = e.keydown), e.capture !== void 0 && (h = e.capture), typeof e.splitKey == "string" && (u = e.splitKey), e.single === !0 && (g = !0)), typeof e == "string" && (s = e), g && c2(t, s); a < i.length; a++)
    t = i[a].split(u), r = [], t.length > 1 && (r = r2(Br, t)), t = t[t.length - 1], t = t === "*" ? "*" : Hd(t), t in Rt || (Rt[t] = []), Rt[t].push({
      keyup: c,
      keydown: d,
      scope: s,
      mods: r,
      shortcut: i[a],
      method: n,
      key: i[a],
      splitKey: u,
      element: o
    });
  if (typeof o < "u" && window) {
    if (!os.has(o)) {
      const p = function() {
        let M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        return KN(M, o);
      }, f = function() {
        let M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        KN(M, o), Dle(M);
      };
      os.set(o, {
        keydownListener: p,
        keyupListenr: f,
        capture: h
      }), gm(o, "keydown", p, h), gm(o, "keyup", f, h);
    }
    if (!Ql) {
      const p = () => {
        wt = [];
      };
      Ql = {
        listener: p,
        capture: h
      }, gm(window, "focus", p, h);
    }
  }
}
function wle(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
  Object.keys(Rt).forEach((n) => {
    Rt[n].filter((r) => r.scope === e && r.shortcut === t).forEach((r) => {
      r && r.method && r.method();
    });
  });
}
function Pj(t) {
  const e = Object.values(Rt).flat();
  if (e.findIndex((i) => {
    let {
      element: r
    } = i;
    return r === t;
  }) < 0) {
    const {
      keydownListener: i,
      keyupListenr: r,
      capture: s
    } = os.get(t) || {};
    i && r && (pl(t, "keyup", r, s), pl(t, "keydown", i, s), os.delete(t));
  }
  if ((e.length <= 0 || os.size <= 0) && (Object.keys(os).forEach((r) => {
    const {
      keydownListener: s,
      keyupListenr: o,
      capture: a
    } = os.get(r) || {};
    s && o && (pl(r, "keyup", o, a), pl(r, "keydown", s, a), os.delete(r));
  }), os.clear(), Object.keys(Rt).forEach((r) => delete Rt[r]), Ql)) {
    const {
      listener: r,
      capture: s
    } = Ql;
    pl(window, "focus", r, s), Ql = null;
  }
}
const pm = {
  getPressedKeyString: yle,
  setScope: a2,
  getScope: ad,
  deleteScope: jle,
  getPressedKeyCodes: mle,
  getAllKeyCodes: Ile,
  isPressed: Sle,
  filter: xle,
  trigger: wle,
  unbind: c2,
  keyMap: od,
  modifier: Br,
  modifierMap: GI
};
for (const t in pm)
  Object.prototype.hasOwnProperty.call(pm, t) && (pi[t] = pm[t]);
if (typeof window < "u") {
  const t = window.hotkeys;
  pi.noConflict = (e) => (e && window.hotkeys === pi && (window.hotkeys = t), pi), window.hotkeys = pi;
}
const XN = [
  // we set these in useNativeClipboardEvents instead
  "copy",
  "cut",
  "paste",
  // There's also an upload asset action, so we don't want to set the kbd twice
  "asset"
];
function Nle() {
  const t = Q(), e = ji(), n = _t(), i = mo(), r = G("is focused", () => t.getInstanceState().isFocused, [t]);
  ze(() => {
    if (!r) return;
    const s = new Array(), o = (c, d) => {
      pi(c, { element: document.body }, d), s.push(() => {
        pi.unbind(c, d);
      });
    }, a = (c, d) => {
      pi(c, { element: document.body, keyup: !0, keydown: !1 }, d), s.push(() => {
        pi.unbind(c, d);
      });
    };
    for (const c of Object.values(n))
      c.kbd && (e && !c.readonlyOk || XN.includes(c.id) || o(JN(c.kbd), (d) => {
        vl(t) || (Ke(d), c.onSelect("kbd"));
      }));
    for (const c of Object.values(i))
      !c.kbd || !c.readonlyOk && t.getIsReadonly() || XN.includes(c.id) || o(JN(c.kbd), (d) => {
        vl(t) || (Ke(d), c.onSelect("kbd"));
      });
    return o(",", (c) => {
      if (vl(t) || t.inputs.keys.has("Comma")) return;
      Ke(c), t.focus(), t.inputs.keys.add("Comma");
      const { x: d, y: u, z: h } = t.inputs.currentPagePoint, g = t.pageToScreen({ x: d, y: u }), p = {
        type: "pointer",
        name: "pointer_down",
        point: { x: g.x, y: g.y, z: h },
        shiftKey: c.shiftKey,
        altKey: c.altKey,
        ctrlKey: c.metaKey || c.ctrlKey,
        metaKey: c.metaKey,
        accelKey: bn(c),
        pointerId: 0,
        button: 0,
        isPen: t.getInstanceState().isPenMode,
        target: "canvas"
      };
      t.dispatch(p);
    }), a(",", (c) => {
      if (vl(t) || !t.inputs.keys.has("Comma")) return;
      t.inputs.keys.delete("Comma");
      const { x: d, y: u, z: h } = t.inputs.currentScreenPoint, g = {
        type: "pointer",
        name: "pointer_up",
        point: { x: d, y: u, z: h },
        shiftKey: c.shiftKey,
        altKey: c.altKey,
        ctrlKey: c.metaKey || c.ctrlKey,
        metaKey: c.metaKey,
        accelKey: bn(c),
        pointerId: 0,
        button: 0,
        isPen: t.getInstanceState().isPenMode,
        target: "canvas"
      };
      t.dispatch(g);
    }), () => {
      s.forEach((c) => c());
    };
  }, [n, i, e, t, r]);
}
function JN(t) {
  return Ale(t).map((e) => {
    let n = "";
    const i = e.split("");
    return i.length === 1 ? n = i[0] : i[0] === "!" ? n = `shift+${i[1]}` : i[0] === "?" ? i.length === 3 && i[1] === "!" ? n = `alt+shift+${i[2]}` : n = `alt+${i[1]}` : i[0] === "$" ? i[1] === "!" ? n = `cmd+shift+${i[2]},ctrl+shift+${i[2]}` : i[1] === "?" ? n = `cmd+⌥+${i[2]},ctrl+alt+${i[2]}` : n = `cmd+${i[1]},ctrl+${i[1]}` : n = e, n;
  }).join(",");
}
function Ale(t) {
  typeof t != "string" && (t = ""), t = t.replace(/\s/g, "");
  const e = t.split(",");
  let n = e.lastIndexOf("");
  for (; n >= 0; )
    e[n - 1] += ",", e.splice(n, 1), n = e.lastIndexOf("");
  return e;
}
function vl(t) {
  return t.menus.hasAnyOpenMenus() || t.getEditingShapeId() !== null || t.getCrashingError();
}
const Tle = Ii(!1);
function ble({ children: t }) {
  const e = Q(), n = Sc(), i = Un(), r = ke(), s = Math.min(8, 5 + i), [o, a] = pe(0), c = le(null), [d, u] = pe(null), h = yt(() => {
    const p = d ? `:not([data-value="${d}"])` : "";
    return `
			#${n}_main > *:nth-child(n + ${s + (d ? 1 : 2)})${p} {
				display: none;
			}
			#${n}_more > *:nth-child(-n + ${s}) {
				display: none;
			}
        `;
  }, [d, n, s]), g = kp(() => {
    if (!c.current) return;
    const p = Array.from(c.current.children);
    a(p.length), p.findIndex(
      (m) => m.getAttribute("data-value") === d
    ) <= s && u(null);
    const M = Array.from(c.current.children).findIndex(
      (m) => m.getAttribute("aria-checked") === "true"
    );
    M !== -1 && M >= s && u(p[M].getAttribute("data-value"));
  });
  return at(() => {
    g();
  }), at(() => {
    if (!c.current) return;
    const p = new MutationObserver(g);
    return p.observe(c.current, {
      childList: !0,
      subtree: !0,
      attributeFilter: ["data-value", "aria-checked"]
    }), () => {
      p.disconnect();
    };
  }, [g]), ze(() => {
    const p = [
      ["1", 0],
      ["2", 1],
      ["3", 2],
      ["4", 3],
      ["5", 4],
      ["6", 5],
      ["7", 6],
      ["8", 7],
      ["9", 8],
      ["0", 9]
    ];
    for (const [f, M] of p)
      pi(f, (m) => {
        var D;
        if (vl(e)) return;
        Ke(m);
        const I = Array.from(((D = c.current) == null ? void 0 : D.children) ?? []).filter(
          (j) => !(j instanceof HTMLElement) || j.tagName.toLowerCase() !== "button" ? !1 : !!(j.offsetWidth || j.offsetHeight)
        )[M];
        I && I.click();
      });
    return () => {
      pi.unbind("1,2,3,4,5,6,7,8,9,0");
    };
  }, [e]), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx("style", { children: h }),
    /* @__PURE__ */ l.jsxs(
      "div",
      {
        className: ce("tlui-toolbar__tools", {
          "tlui-toolbar__tools__mobile": i < Qt.TABLET_SM
        }),
        role: "radiogroup",
        children: [
          /* @__PURE__ */ l.jsx("div", { id: `${n}_main`, ref: c, className: "tlui-toolbar__tools__list", children: /* @__PURE__ */ l.jsx(yn, { type: "toolbar", sourceId: "toolbar", children: t }) }),
          o > s + 1 && /* @__PURE__ */ l.jsx(Tle.Provider, { value: !0, children: /* @__PURE__ */ l.jsxs(mr, { id: "toolbar overflow", modal: !1, children: [
            /* @__PURE__ */ l.jsx(yr, { children: /* @__PURE__ */ l.jsx(
              q,
              {
                title: r("tool-panel.more"),
                type: "tool",
                className: "tlui-toolbar__overflow",
                "data-testid": "tools.more-button",
                children: /* @__PURE__ */ l.jsx(Te, { icon: "chevron-up" })
              }
            ) }),
            /* @__PURE__ */ l.jsx(Ir, { side: "top", align: "center", children: /* @__PURE__ */ l.jsx(
              "div",
              {
                className: "tlui-buttons__grid",
                "data-testid": "tools.more-content",
                id: `${n}_more`,
                children: /* @__PURE__ */ l.jsx(yn, { type: "toolbar-overflow", sourceId: "toolbar", children: t })
              }
            ) })
          ] }) })
        ]
      }
    )
  ] });
}
function vle({ activeToolId: t }) {
  const e = Q(), n = Un(), i = ke(), r = G("is tool locked", () => e.getInstanceState().isToolLocked, [
    e
  ]), s = G("current tool", () => e.getCurrentTool(), [e]);
  return !t || !s.isLockable ? null : /* @__PURE__ */ l.jsx(
    q,
    {
      type: "normal",
      title: i("action.toggle-tool-lock"),
      "data-testid": "tool-lock",
      className: ce("tlui-toolbar__lock-button", {
        "tlui-toolbar__lock-button__mobile": n < Qt.TABLET_SM
      }),
      onClick: () => e.updateInstanceState({ isToolLocked: !r }),
      children: /* @__PURE__ */ l.jsx(Te, { icon: r ? "lock" : "unlock", small: !0 })
    }
  );
}
const Ele = _e(function({ children: e }) {
  const n = Q(), i = Un(), r = ji(), s = G("current tool id", () => n.getCurrentToolId(), [n]), o = le(null);
  uo(o);
  const { ActionsMenu: a, QuickActions: c } = Io(), d = n.options.actionShortcutsLocation === "menu" ? !1 : n.options.actionShortcutsLocation === "toolbar" ? !0 : i < Qt.TABLET;
  return /* @__PURE__ */ l.jsx("div", { ref: o, className: "tlui-toolbar", children: /* @__PURE__ */ l.jsxs("div", { className: "tlui-toolbar__inner", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "tlui-toolbar__left", children: [
      !r && /* @__PURE__ */ l.jsxs("div", { className: "tlui-toolbar__extras", children: [
        d && /* @__PURE__ */ l.jsxs("div", { className: "tlui-toolbar__extras__controls tlui-buttons__horizontal", children: [
          c && /* @__PURE__ */ l.jsx(c, {}),
          a && /* @__PURE__ */ l.jsx(a, {})
        ] }),
        /* @__PURE__ */ l.jsx(vle, { activeToolId: s })
      ] }),
      /* @__PURE__ */ l.jsx(ble, { children: e ?? /* @__PURE__ */ l.jsx(Qce, {}) })
    ] }),
    i < Qt.TABLET_SM && !r && /* @__PURE__ */ l.jsx("div", { className: "tlui-toolbar__tools", children: /* @__PURE__ */ l.jsx(Yce, {}) })
  ] }) });
});
function Cle() {
  const t = ke();
  return /* @__PURE__ */ l.jsxs("div", { className: ce("tlui-offline-indicator"), children: [
    t("status.offline"),
    /* @__PURE__ */ l.jsx(Ui, { "aria-label": "offline", icon: "status-offline", small: !0 })
  ] });
}
function zle({
  maxWidth: t = 420,
  ignoreRightWidth: e = 0,
  stylePanelWidth: n = 148,
  marginBetweenZones: i = 12,
  squeezeAmount: r = 52,
  children: s
}) {
  const o = le(null), a = Un(), c = re(() => {
    const d = o.current;
    if (!d) return;
    const u = d.parentElement.parentElement, h = u.querySelector(".tlui-layout__top__left"), g = u.querySelector(".tlui-layout__top__right"), p = u.offsetWidth, f = h.offsetWidth, M = g.offsetWidth, m = d.offsetWidth - e;
    let y = (p - m) / 2;
    p % 2 !== 0 && (y -= 0.5);
    const I = f + i, D = d.offsetLeft, j = Math.min(
      p - M - f - 2 * i,
      t
    ), w = Math.max(y, I) - D;
    g.offsetWidth > n && a <= 6 ? d.style.setProperty("max-width", j - r + "px") : d.style.setProperty("max-width", j + "px"), d.style.setProperty("transform", `translate(${w}px, 0px)`);
  }, [a, e, i, t, r, n]);
  return at(() => {
    const d = o.current;
    if (!d) return;
    const u = d.parentElement.parentElement, h = u.querySelector(".tlui-layout__top__left"), g = u.querySelector(".tlui-layout__top__right"), p = new ResizeObserver(c);
    return p.observe(h), p.observe(g), p.observe(u), p.observe(d), c(), () => {
      p.disconnect();
    };
  }, [c]), at(() => {
    c();
  }), /* @__PURE__ */ l.jsx("div", { ref: o, className: "tlui-top-panel__container", children: s });
}
function Lle() {
  const t = m_() === "offline";
  return /* @__PURE__ */ l.jsx(zle, { children: t && /* @__PURE__ */ l.jsx(Cle, {}) });
}
function kle() {
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(V, { actionId: "zoom-in", noClose: !0 }),
    /* @__PURE__ */ l.jsx(V, { actionId: "zoom-out", noClose: !0 }),
    /* @__PURE__ */ l.jsx(gP, {}),
    /* @__PURE__ */ l.jsx(pP, {}),
    /* @__PURE__ */ l.jsx(fP, {})
  ] });
}
const Ole = _e(function({ children: e }) {
  const n = qt(), [i, r] = Nr("zoom menu"), s = e ?? /* @__PURE__ */ l.jsx(kle, {});
  return /* @__PURE__ */ l.jsxs(cf, { dir: "ltr", open: i, onOpenChange: r, modal: !1, children: [
    /* @__PURE__ */ l.jsx(lf, { asChild: !0, dir: "ltr", children: /* @__PURE__ */ l.jsx(Ple, {}) }),
    /* @__PURE__ */ l.jsx(Bd, { container: n, children: /* @__PURE__ */ l.jsx(
      df,
      {
        className: "tlui-menu",
        side: "top",
        align: "start",
        alignOffset: 0,
        sideOffset: 8,
        collisionPadding: 4,
        children: /* @__PURE__ */ l.jsx(yn, { type: "menu", sourceId: "zoom-menu", children: s })
      }
    ) })
  ] });
}), Ple = dc(
  function(e, n) {
    const i = Q(), r = Un(), s = G("zoom", () => i.getZoomLevel(), [i]), o = ke(), a = re(() => {
      i.resetZoom(i.getViewportScreenCenter(), {
        animation: { duration: i.options.animationMediumMs }
      });
    }, [i]);
    return /* @__PURE__ */ l.jsx(
      q,
      {
        ref: n,
        ...e,
        type: "icon",
        title: `${o("navigation-zone.zoom")}`,
        "data-testid": "minimap.zoom-menu-button",
        className: r < Qt.TABLET_SM ? "tlui-zoom-menu__button" : "tlui-zoom-menu__button__pct",
        onDoubleClick: a,
        children: r < Qt.MOBILE ? null : /* @__PURE__ */ l.jsxs("span", { style: { flexGrow: 0, textAlign: "center" }, children: [
          Math.floor(s * 100),
          "%"
        ] })
      }
    );
  }
), l2 = Ii(null);
function Ule({
  overrides: t = {},
  children: e
}) {
  const n = wc(t), i = qp();
  return /* @__PURE__ */ l.jsx(
    l2.Provider,
    {
      value: yt(
        () => ({
          ContextMenu: iae,
          ActionsMenu: Eoe,
          HelpMenu: null,
          ZoomMenu: Ole,
          MainMenu: Uae,
          Minimap: Vae,
          StylePanel: Rce,
          PageMenu: qae,
          NavigationPanel: Xae,
          Toolbar: Ele,
          KeyboardShortcutsDialog: Aae,
          QuickActions: $ae,
          HelperButtons: wae,
          DebugPanel: fae,
          DebugMenu: pae,
          MenuPanel: Iae,
          SharePanel: i ? oce : null,
          CursorChatBubble: i ? oae : null,
          TopPanel: i ? Lle : null,
          ...n
        }),
        [n, i]
      ),
      children: e
    }
  );
}
function Io() {
  const t = Vn(l2);
  if (!t)
    throw new Error("useTldrawUiComponents must be used within a TldrawUiComponentsProvider");
  return t;
}
const Rle = Vt(function({
  overrides: e,
  components: n,
  assetUrls: i,
  onUiEvent: r,
  forceMobile: s,
  mediaMimeTypes: o,
  children: a
}) {
  const c = Q();
  return /* @__PURE__ */ l.jsx(yz.Provider, { value: o, children: /* @__PURE__ */ l.jsx(iq, { assetUrls: toe(i), children: /* @__PURE__ */ l.jsx(
    oq,
    {
      overrides: roe(e),
      locale: c.user.getLocale(),
      children: /* @__PURE__ */ l.jsx(vJ, { onEvent: r, children: /* @__PURE__ */ l.jsx(nq, { children: /* @__PURE__ */ l.jsx(EJ, { context: c.contextId, children: /* @__PURE__ */ l.jsx(Une, { forceMobile: s, children: /* @__PURE__ */ l.jsx(Ule, { overrides: n, children: /* @__PURE__ */ l.jsx(Yle, { overrides: e, children: a }) }) }) }) }) })
    }
  ) }) });
});
function Yle({
  overrides: t,
  children: e
}) {
  const n = soe(t);
  return /* @__PURE__ */ l.jsx(x_, { overrides: n.actions, children: /* @__PURE__ */ l.jsx(Gne, { overrides: n.tools, children: e }) });
}
function Qle() {
  const t = Q(), { addToast: e } = Vr();
  ze(() => {
    function n({ name: i, count: r }) {
      e({
        title: "Maximum Shapes Reached",
        description: `You've reached the maximum number of shapes allowed on ${i} (${r}). Please delete some shapes or move to a different page to continue.`,
        severity: "warning"
      });
    }
    return t.addListener("max-shapes", n), () => {
      t.removeListener("max-shapes", n);
    };
  }, [t, e]);
}
const Zle = Ye.memo(function({
  renderDebugMenuItems: e,
  children: n,
  hideUi: i,
  components: r,
  ...s
}) {
  return /* @__PURE__ */ l.jsx(Rle, { ...s, components: r, children: /* @__PURE__ */ l.jsx(Fle, { hideUi: i, renderDebugMenuItems: e, children: n }) });
}), Fle = Ye.memo(function({
  children: e,
  hideUi: n,
  ...i
}) {
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    e,
    n ? null : /* @__PURE__ */ l.jsx(Ble, { ...i })
  ] });
}), Ble = Ye.memo(function() {
  const e = Q(), n = ke(), i = Un(), r = ji(), s = G("focus", () => e.getInstanceState().isFocusMode, [e]), o = G("debug", () => e.getInstanceState().isDebugMode, [e]), {
    SharePanel: a,
    TopPanel: c,
    MenuPanel: d,
    StylePanel: u,
    Toolbar: h,
    HelpMenu: g,
    NavigationPanel: p,
    HelperButtons: f,
    DebugPanel: M,
    CursorChatBubble: m
  } = Io();
  Nle(), Wq(), Qle();
  const { "toggle-focus-mode": y } = _t();
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: ce("tlui-layout", {
        "tlui-layout__mobile": i < Qt.TABLET_SM
      }),
      "data-breakpoint": i,
      children: [
        s ? /* @__PURE__ */ l.jsx("div", { className: "tlui-layout__top", children: /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            className: "tlui-focus-button",
            title: n("focus-mode.toggle-focus-mode"),
            onClick: () => y.onSelect("menu"),
            children: /* @__PURE__ */ l.jsx(Te, { icon: "dot" })
          }
        ) }) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsxs("div", { className: "tlui-layout__top", children: [
            /* @__PURE__ */ l.jsxs("div", { className: "tlui-layout__top__left", children: [
              d && /* @__PURE__ */ l.jsx(d, {}),
              f && /* @__PURE__ */ l.jsx(f, {})
            ] }),
            /* @__PURE__ */ l.jsx("div", { className: "tlui-layout__top__center", children: c && /* @__PURE__ */ l.jsx(c, {}) }),
            /* @__PURE__ */ l.jsxs("div", { className: "tlui-layout__top__right", children: [
              a && /* @__PURE__ */ l.jsx(a, {}),
              u && i >= Qt.TABLET_SM && !r && /* @__PURE__ */ l.jsx(u, {})
            ] })
          ] }),
          /* @__PURE__ */ l.jsxs("div", { className: "tlui-layout__bottom", children: [
            /* @__PURE__ */ l.jsxs("div", { className: "tlui-layout__bottom__main", children: [
              p && /* @__PURE__ */ l.jsx(p, {}),
              h && /* @__PURE__ */ l.jsx(h, {}),
              g && /* @__PURE__ */ l.jsx(g, {})
            ] }),
            o && M && /* @__PURE__ */ l.jsx(M, {})
          ] })
        ] }),
        /* @__PURE__ */ l.jsx(dq, {}),
        /* @__PURE__ */ l.jsx(zJ, {}),
        /* @__PURE__ */ l.jsx(_se, {}),
        m && /* @__PURE__ */ l.jsx(m, {})
      ]
    }
  );
});
async function Gle(t, e) {
  const {
    url: n,
    style: i = "normal",
    weight: r = "500",
    display: s,
    featureSettings: o,
    stretch: a,
    unicodeRange: c,
    variant: d,
    format: u
  } = e, h = {
    style: i,
    weight: r,
    display: s,
    featureSettings: o,
    stretch: a,
    unicodeRange: c,
    // @ts-expect-error why is this here
    variant: d
  }, g = new FontFace(t, `url(${n})`, h);
  return await g.load(), document.fonts.add(g), g.$$_url = n, g.$$_fontface = `
@font-face {
	font-family: ${g.family};
	font-stretch: ${g.stretch};
	font-weight: ${g.weight};
	font-style: ${g.style};
	src: url("${n}") format("${u}")
}`, g;
}
const nh = (t, e) => {
  const [n, i] = pe(
    2
    /* WAITING */
  );
  return ze(() => {
    let r = !1;
    return i(
      2
      /* WAITING */
    ), Gle(t, e).then(() => {
      r || i(
        0
        /* SUCCESS */
      );
    }).catch((s) => {
      r || (console.error(s), i(
        1
        /* FAILED */
      ));
    }), () => {
      r = !0;
    };
  }, [t, e]), n;
};
function Wle(t) {
  return {
    draw: {
      url: t.fonts.draw,
      format: t.fonts.draw.split(".").pop()
    },
    serif: {
      url: t.fonts.serif,
      format: t.fonts.serif.split(".").pop()
    },
    sansSerif: {
      url: t.fonts.sansSerif,
      format: t.fonts.sansSerif.split(".").pop()
    },
    monospace: {
      url: t.fonts.monospace,
      format: t.fonts.monospace.split(".").pop()
    }
  };
}
function d2(t) {
  const e = yt(() => Wle(t), [t]), n = [
    nh("tldraw_draw", e.draw),
    nh("tldraw_serif", e.serif),
    nh("tldraw_sans", e.sansSerif),
    nh("tldraw_mono", e.monospace)
  ];
  return {
    // If any of the results have errored, then preloading has failed
    error: n.some(
      (i) => i === 1
      /* FAILED */
    ),
    // If any of the results are waiting, then we're not done yet
    done: !n.some(
      (i) => i === 2
      /* WAITING */
    )
  };
}
function Hle(t) {
  const {
    children: e,
    maxImageDimension: n,
    maxAssetSize: i,
    acceptedImageMimeTypes: r,
    acceptedVideoMimeTypes: s,
    onMount: o,
    components: a = {},
    shapeUtils: c = [],
    bindingUtils: d = [],
    tools: u = [],
    embeds: h,
    ...g
  } = t, p = wc(a), f = yt(
    () => ({
      Scribble: cN,
      ShapeIndicators: tie,
      CollaboratorScribble: cN,
      SelectionForeground: _ne,
      SelectionBackground: Jne,
      Handles: Wne,
      ...p
    }),
    [p]
  ), M = Bs(c), m = yt(
    () => [...lO, ...M],
    [M]
  ), y = Bs(d), I = yt(
    () => [...vk, ...y],
    [y]
  ), D = Bs(u), j = yt(
    () => [...qse, ...Uie, ...D],
    [D]
  ), w = Bs(
    r ?? dp
  ), A = Bs(
    s ?? dx
  ), b = yt(
    () => [...w, ...A],
    [w, A]
  ), T = WO(g.assetUrls), { done: E, error: v } = d2(T);
  return v ? /* @__PURE__ */ l.jsx(u4, { children: "Could not load assets. Please refresh the page." }) : E ? /* @__PURE__ */ l.jsx(
    WK,
    {
      initialState: "select",
      ...g,
      components: f,
      shapeUtils: m,
      bindingUtils: I,
      tools: j,
      children: /* @__PURE__ */ l.jsxs(Zle, { ...g, components: f, mediaMimeTypes: b, children: [
        /* @__PURE__ */ l.jsx(
          Vle,
          {
            maxImageDimension: n,
            maxAssetSize: i,
            acceptedImageMimeTypes: w,
            acceptedVideoMimeTypes: A,
            onMount: o,
            embeds: h
          }
        ),
        e
      ] })
    }
  ) : /* @__PURE__ */ l.jsx(IS, { children: /* @__PURE__ */ l.jsx(iS, {}) });
}
function Vle({
  maxImageDimension: t = 5e3,
  maxAssetSize: e = 10 * 1024 * 1024,
  // 10mb
  acceptedImageMimeTypes: n = dp,
  acceptedVideoMimeTypes: i = dx,
  onMount: r,
  embeds: s
}) {
  const o = Q(), a = Vr(), c = ke();
  h4(() => {
    const h = o.getShapeUtil("embed");
    h && s && h.setEmbedDefinitions(s);
    const g = [];
    return g.push(yse(o)), yie(
      o,
      {
        maxImageDimension: t,
        maxAssetSize: e,
        acceptedImageMimeTypes: n,
        acceptedVideoMimeTypes: i
      },
      {
        toasts: a,
        msg: c
      }
    ), g.push(o.store.props.onMount(o)), g.push(r == null ? void 0 : r(o)), () => {
      g.forEach((p) => p == null ? void 0 : p());
    };
  });
  const { Canvas: d } = At(), { ContextMenu: u } = Io();
  return u ? /* @__PURE__ */ l.jsx(u, {}) : d ? /* @__PURE__ */ l.jsx(d, {}) : null;
}
_e(function(e) {
  const [n, i] = pe(null), [r, s] = pe(null), o = Bs(e.shapeUtils ?? []), a = yt(() => [...lO, ...o], [o]), c = Bs(e.bindingUtils ?? []), d = yt(
    () => [...vk, ...c],
    [c]
  ), u = _K({ snapshot: e.snapshot, shapeUtils: a }), h = WO(e.assetUrls), { done: g, error: p } = d2(h), {
    pageId: f,
    bounds: M,
    scale: m,
    background: y,
    padding: I,
    darkMode: D,
    preserveAspectRatio: j,
    format: w = "svg",
    licenseKey: A
  } = e;
  return at(() => {
    if (!r || !u || !g) return;
    let b = !1;
    const T = document.createElement("div");
    r.appendChild(T), r.classList.add("tl-container", "tl-theme__light");
    const E = new de({
      store: u,
      shapeUtils: a,
      bindingUtils: d,
      tools: [],
      getContainer: () => T,
      licenseKey: A
    });
    f && E.setCurrentPage(f);
    const v = E.getCurrentPageShapeIds();
    async function P() {
      const C = await E.getSvgString([...v], {
        bounds: M,
        scale: m,
        background: y,
        padding: I,
        darkMode: D,
        preserveAspectRatio: j
      });
      if (C && !b) {
        if (w === "svg") {
          if (!b) {
            const z = new Blob([C.svg], { type: "image/svg+xml" }), O = URL.createObjectURL(z);
            i(O);
          }
        } else if (w === "png") {
          const z = await PS(E, C.svg, {
            type: w,
            quality: 1,
            scale: 2,
            width: C.width,
            height: C.height
          });
          if (z && !b) {
            const O = URL.createObjectURL(z);
            i(O);
          }
        }
      }
      E.dispose();
    }
    return P(), () => {
      b = !0;
    };
  }, [
    w,
    r,
    u,
    a,
    d,
    f,
    M,
    m,
    y,
    I,
    D,
    j,
    g,
    p,
    A
  ]), p ? /* @__PURE__ */ l.jsx(u4, { children: "Could not load assets." }) : g ? /* @__PURE__ */ l.jsx("div", { ref: s, style: { position: "relative", width: "100%", height: "100%" }, children: n && /* @__PURE__ */ l.jsx(
    "img",
    {
      src: n,
      referrerPolicy: "strict-origin-when-cross-origin",
      style: { width: "100%", height: "100%" }
    }
  ) }) : /* @__PURE__ */ l.jsx(IS, { children: /* @__PURE__ */ l.jsx(iS, {}) });
});
_e(function({ children: e }) {
  const n = ke(), i = Un(), r = le(null);
  uo(r);
  const s = e ?? /* @__PURE__ */ l.jsx(vae, {});
  return i < Qt.MOBILE ? null : /* @__PURE__ */ l.jsx("div", { ref: r, className: "tlui-help-menu", children: /* @__PURE__ */ l.jsxs(mr, { id: "help menu", children: [
    /* @__PURE__ */ l.jsx(yr, { children: /* @__PURE__ */ l.jsx(q, { type: "help", title: n("help-menu.title"), "data-testid": "help-menu.button", children: /* @__PURE__ */ l.jsx(Te, { icon: "question-mark", small: !0 }) }) }),
    /* @__PURE__ */ l.jsx(Ir, { side: "top", align: "end", alignOffset: 0, sideOffset: 8, children: /* @__PURE__ */ l.jsx(yn, { type: "menu", sourceId: "help-menu", children: s }) })
  ] }) });
});
const Kle = Xe({
  schemaVersion: zn(1),
  storeVersion: xh,
  recordVersions: Ha(
    Ne,
    Xe({
      version: xh,
      subTypeVersions: Ha(Ne, xh).optional(),
      subTypeKey: Ne.optional()
    })
  )
}), Xle = Xe({
  schemaVersion: zn(2),
  sequences: Ha(Ne, xh)
});
Xe({
  tldrawFileFormatVersion: bG,
  schema: vG("schemaVersion", {
    1: Kle,
    2: Xle
  }),
  records: sn(
    Xe({
      id: Ne,
      typeName: Ne
    }).allowUnknownProperties()
  )
});
so(
  "tldraw",
  "3.4.1",
  "esm"
);
const u2 = Ii({
  navigatorRef: null,
  menubarRef: null,
  stylePanelRef: null,
  iconbarRef: null,
  contextMenuRef: null,
  legendIconRef: null,
  legendIconMenuRef: null,
  topToolbarRef: null
}), bf = () => Vn(u2), Jle = u2.Provider, Lr = xt(
  "context menu atom",
  {
    canvasX: 0,
    canvasY: 0,
    isOpen: !1
  }
);
function qle() {
  var o;
  const t = Q(), e = t.isInAny("select"), n = G("is open", () => Lr.get().isOpen, [Lr]), i = G("context menu atom", () => Lr.get(), [Lr]);
  if (!n) return null;
  let r = t.getSelectionRotatedPageBounds(), s = { x: 0, y: 0 };
  if (e) {
    if (!r || (s = t.pageToViewport(r.point), t.getSelectedShapes().filter((c) => {
      var u, h;
      return ((h = (u = t == null ? void 0 : t.getShapeUtil(c.type)) == null ? void 0 : u.hasContextMenu) == null ? void 0 : h.call(u, c)) ?? !1;
    }).length == 0)) return null;
  } else
    r = {
      width: 50
    }, s = {
      y: i.canvasY < 100 ? i.canvasY + 100 : i.canvasY - 30,
      x: i.canvasX,
      //@ts-ignore
      width: 50
    };
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(
    "div",
    {
      style: {
        position: "absolute",
        top: Math.max(16, s.y - 48),
        left: Math.max(16, s.x),
        pointerEvents: "all",
        // [3]
        width: r.width
      },
      onPointerDown: (a) => a.stopPropagation(),
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          children: /* @__PURE__ */ l.jsx(
            "div",
            {
              style: {
                borderRadius: 8,
                display: "flex",
                boxShadow: "0 0 0 1px rgba(0,0,0,0.1), 0 4px 8px rgba(0,0,0,0.1)",
                background: "var(--color-panel)",
                width: "fit-content",
                alignItems: "center"
              },
              children: (o = i.menuItems) == null ? void 0 : o.map((a, c) => /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx("button", { onClick: a.onClick, children: a.label }) }, c))
            }
          )
        }
      )
    }
  ) });
}
function _le() {
  return /* @__PURE__ */ l.jsx(l.Fragment, {});
}
function $le() {
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(qle, {}),
    /* @__PURE__ */ l.jsx(_le, {})
  ] });
}
const h2 = ({ label: t = "", isExpanded: e = !0, onClickSearch: n = () => {
}, children: i }) => {
  const [r, s] = pe(e);
  return /* @__PURE__ */ l.jsxs("div", { children: [
    /* @__PURE__ */ l.jsx("div", { style: { padding: "8px" }, children: /* @__PURE__ */ l.jsxs(
      "div",
      {
        className: "button-collapsible",
        children: [
          /* @__PURE__ */ l.jsx("label", { style: { flexGrow: 1 }, children: t }),
          /* @__PURE__ */ l.jsxs("div", { style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "8px"
          }, children: [
            /* @__PURE__ */ l.jsx(q, { type: "icon", className: "small-button", onClick: n, children: /* @__PURE__ */ l.jsx(Te, { icon: "search" }) }),
            /* @__PURE__ */ l.jsx(q, { type: "icon", className: "small-button", onClick: () => s(!r), children: /* @__PURE__ */ l.jsx(Te, { icon: r ? "chevron-up" : "chevron-down" }) })
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ l.jsx("div", { style: {
      visibility: r ? "visible" : "hidden",
      height: r ? "auto" : "0",
      paddingBottom: r ? "20px" : "0px"
    }, children: i })
  ] });
}, Zn = xt(
  "legend atom",
  {
    page: {},
    version: 2
  }
);
function ede({
  items: t,
  label: e,
  value: n,
  direction: i = "horizontal",
  onValueChange: r
}) {
  return /* @__PURE__ */ l.jsxs("div", { draggable: !1, className: `${i == "horizontal" ? "tlui-input__wrapper" : ""}`, children: [
    e && /* @__PURE__ */ l.jsx("label", { children: e }),
    /* @__PURE__ */ l.jsx("div", { className: `tlui-buttons__flex ${i == "vertical" ? "tlui-buttons__flex_vertical" : ""}`, children: t.map((s) => /* @__PURE__ */ l.jsx(
      q,
      {
        type: s.value == n ? "primary" : "normal",
        title: s.title ?? s.label,
        onClick: () => {
          r(s.value);
        },
        children: /* @__PURE__ */ l.jsx(St, { children: s.label })
      },
      s.value
    )) })
  ] });
}
const g2 = N.memo(ede);
let fm = {};
const Mm = {}, p2 = Ii({
  selectedIcon: null,
  updateIcon: (t) => {
  }
}), La = {
  pest: {
    title: "Pest Control",
    icon: "pest-icon"
  },
  general: {
    title: "General",
    icon: "icon-library"
  }
}, tde = _e(function({
  inSearch: t,
  iconPack: e = "pest"
}) {
  const { selectedIcon: n, updateIcon: i } = Vn(p2), r = Q(), s = mo(), o = Tf(s["legend-tool"]), a = G("legend-tool", () => Zn.get().page[r.getCurrentPageId()] ?? { icons: {} }, [Zn, r]), [c, d] = pe(""), [u, h] = pe({}), [g, p] = pe(0), f = le(null), M = (y) => {
    i(y);
  };
  console.log("selectedIcon in content", n), at(
    () => {
      if (fm[e]) {
        h(fm[e]);
        return;
      }
      let y = null;
      switch (e) {
        case "general":
          y = import("./General-KMvoaw-Y.js");
          break;
        case "pest":
        default:
          y = import("./Pest-DJRhWONA.js");
          break;
      }
      y.then(
        (I) => {
          I.fetchIcons().then(
            (D) => {
              h(D), fm[e] = D;
            }
          );
        }
      );
    },
    [u, e]
  ), at(
    () => {
      f.current && (f.current.scrollTop = g);
    },
    [n, g]
  );
  const m = (y) => {
    var D;
    if (n == y) {
      M(null);
      return;
    }
    M(y), p(((D = f.current) == null ? void 0 : D.scrollTop) || 0);
    const I = y;
    if (!Mm[u[I]]) {
      const j = ci.createId(`icon-${I}`);
      r.createAssets([
        {
          id: j,
          type: "image",
          typeName: "asset",
          props: {
            name: I,
            src: `data:image/svg+xml;base64,${u[I]}`,
            // You could also use a base64 encoded string here
            w: 32,
            h: 32,
            fileSize: 1,
            mimeType: "image/png",
            isAnimated: !1
          },
          meta: {
            iconIndex: I,
            iconFile: I
          }
        }
      ]), Mm[u[I]] = j;
    }
    r.setCurrentTool("select"), r.setCurrentTool(
      "legend-tool",
      {
        assetId: Mm[u[I]],
        iconId: I
      }
    );
  };
  return /* @__PURE__ */ l.jsxs("div", { children: [
    t && /* @__PURE__ */ l.jsx(
      "input",
      {
        type: "text",
        className: "search-input",
        value: c,
        onChange: (y) => {
          d(y.target.value);
        },
        placeholder: "Search"
      }
    ),
    /* @__PURE__ */ l.jsx("div", { className: "icon-grid-container", ref: f, children: /* @__PURE__ */ l.jsx("div", { className: "icon-grid", children: Object.keys(u).filter(
      (y) => (n == null || n == y) && (t && (c == "" || y.toLowerCase().includes(c.toLowerCase())) || t == !1)
    ).map(
      (y, I) => /* @__PURE__ */ l.jsxs("div", { style: { position: "relative" }, onClick: () => m(y), className: `${o && n == y ? "icon-selected" : ""}`, children: [
        /* @__PURE__ */ l.jsx(
          "div",
          {
            title: y,
            className: "tlui-icon tlui-button__icon icon-item",
            style: {
              background: `url("data:image/svg+xml;base64,${u[y]}") center 100% / 100% no-repeat`
            }
          }
        ),
        /* @__PURE__ */ l.jsx(
          "div",
          {
            className: "tlui-icon__backdrop"
          }
        ),
        a.icons[y] != null && a.icons[y].count > 0 && /* @__PURE__ */ l.jsx("div", { style: {
          position: "absolute",
          top: 0,
          right: 0
        }, children: a.icons[y].count })
      ] }, `icon_${y}`)
    ) }) }),
    /* @__PURE__ */ l.jsx("div", { style: {
      padding: "10px 20px 0px 20px"
    }, children: n && n.replace(".svg", "") })
  ] });
}), nde = ({
  iconPack: t = "pest",
  onClickBackPressed: e = () => {
  }
}) => {
  const [n, i] = pe(!1);
  return t == "" ? null : /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(
    h2,
    {
      onClickSearch: () => {
        i(!n);
      },
      label: /* @__PURE__ */ l.jsxs("div", { className: "icon-container", children: [
        /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            className: "small-button",
            onClick: e,
            children: /* @__PURE__ */ l.jsx(
              Te,
              {
                icon: "back-arrow"
              }
            )
          }
        ),
        /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            className: "small-button",
            children: /* @__PURE__ */ l.jsx(
              Te,
              {
                icon: La[t].icon
              }
            )
          }
        ),
        /* @__PURE__ */ l.jsx("label", { className: "icon-label", children: La[t].title })
      ] }),
      children: /* @__PURE__ */ l.jsx(
        tde,
        {
          inSearch: n,
          iconPack: t
        }
      )
    }
  ) });
}, ide = ({
  iconPack: t,
  setIconPack: e
}) => {
  const [n, i] = pe($g.selectedIcon), r = (s) => {
    $g.selectedIcon = s, i(() => s);
  };
  return /* @__PURE__ */ l.jsx(p2.Provider, { value: { selectedIcon: n, updateIcon: r }, children: /* @__PURE__ */ l.jsx(
    nde,
    {
      iconPack: t,
      onClickBackPressed: () => {
        n != null ? i(null) : e("");
      }
    }
  ) });
};
let $g = {
  iconPack: "",
  selectedIcon: null
};
const rde = ({}) => {
  const [t, e] = pe($g.iconPack), n = Q(), [i, r] = pe(!1);
  return ze(() => {
    n.getAsset(
      ci.createId("asset-blank")
    ) || n.createAssets([
      {
        id: ci.createId("asset-blank"),
        type: "image",
        typeName: "asset",
        props: {
          name: "blank",
          src: "data:image/svg+xml;base64,",
          // You could also use a base64 encoded string here
          w: 1,
          h: 1,
          fileSize: 1,
          mimeType: "image/png",
          isAnimated: !1
        },
        meta: {}
      }
    ]), r(!0);
  }, []), /* @__PURE__ */ l.jsx(l.Fragment, { children: i && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(ide, { iconPack: t, setIconPack: e }),
    t == "" && /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
      g2,
      {
        value: t,
        direction: "vertical",
        items: Object.keys(La).map(
          (s) => ({
            label: /* @__PURE__ */ l.jsxs("div", { className: "iconbar-icon-label", children: [
              /* @__PURE__ */ l.jsx(Ui, { icon: La[s].icon }),
              " ",
              /* @__PURE__ */ l.jsx("label", { children: La[s].title })
            ] }),
            title: La[s].title,
            value: s
          })
        ),
        onValueChange: (s) => {
          $g.iconPack = s, e(s);
        }
      }
    ) })
  ] }) });
};
let qN = !1, _N = [];
const sde = function({
  inSearch: t
}) {
  mo();
  const e = Q(), [n, i] = pe(""), [r, s] = pe([]), o = Ye.useRef(null), [a, c] = pe(0), [d, u] = pe(null);
  ze(
    () => {
      if (qN) {
        s(_N);
        return;
      }
      import("./index-CJ-lF7D_.js").then(
        (g) => {
          qN = !0, _N = g.default, s(g.default);
        }
      );
    },
    [r]
  ), at(
    () => {
      o.current && (o.current.scrollTop = a);
    },
    [d, a]
  );
  const h = (g) => {
    var j;
    if (d != null && d.id === g.id) {
      u(null);
      return;
    }
    u({
      id: g.id,
      name: g.name
    }), c(((j = o.current) == null ? void 0 : j.scrollTop) || 0);
    const p = ci.createId(`icon-${g.id}`), f = atob(g.resource), y = new DOMParser().parseFromString(f, "image/svg+xml").querySelector("svg"), I = +y.getAttribute("width"), D = +y.getAttribute("height");
    e.getAsset(p) === void 0 && e.createAssets([
      {
        id: p,
        type: "image",
        typeName: "asset",
        props: {
          name: g.name,
          src: `data:image/svg+xml;base64,${g.resource}`,
          // You could also use a base64 encoded string here
          w: I,
          h: D,
          fileSize: 1,
          mimeType: "image/png",
          isAnimated: !1
        },
        meta: {}
      }
    ]), e.setCurrentTool("select"), e.setCurrentTool(
      "image-gallery-tool",
      {
        assetId: p,
        imageId: g.id,
        categoryId: "test"
      }
    );
  };
  return /* @__PURE__ */ l.jsxs("div", { children: [
    t && /* @__PURE__ */ l.jsx(
      "input",
      {
        type: "text",
        className: "search-input",
        value: n,
        onChange: (g) => {
          i(g.target.value);
        },
        placeholder: "Search"
      }
    ),
    /* @__PURE__ */ l.jsx("div", { className: "gallery-grid-container", ref: o, children: /* @__PURE__ */ l.jsx("div", { children: r.map(
      (g, p) => {
        const f = g.images.filter(
          (M) => (d == null || M.id == d.id) && M.name.toLowerCase().indexOf(n.toLowerCase()) > -1 || M.tags.includes(n.toLowerCase())
        );
        return f.length > 0 ? /* @__PURE__ */ l.jsxs("div", { children: [
          /* @__PURE__ */ l.jsx("div", { children: g.name }),
          /* @__PURE__ */ l.jsx("div", { className: "icon-grid-lg image-gallery-grid", children: f.map(
            (M) => {
              const m = [];
              return d && d.id !== M.id && M.row && M.row > 1 && m.push(`tlui-icon-row-span-${M.row}`), d && d.id !== M.id && M.col && M.col > 1 && m.push(`tlui-icon-col-span-${M.col}`), d && d.id == M.id && m.push("icon-selected"), /* @__PURE__ */ l.jsxs("div", { onClick: () => h(M), className: m.join(" "), children: [
                /* @__PURE__ */ l.jsx(
                  "div",
                  {
                    className: "tlui-icon tlui-button__icon icon-item",
                    style: {
                      background: `url("data:image/svg+xml;base64,${M.resource}")`,
                      backgroundSize: "contain",
                      backgroundPositionX: "center",
                      backgroundPositionY: "100%",
                      backgroundRepeat: "no-repeat",
                      ...M != null && M.width ? { width: M.width } : {},
                      ...M != null && M.height ? { height: M.height } : {}
                    }
                  }
                ),
                /* @__PURE__ */ l.jsx("div", { className: "tlui-icon__backdrop" })
              ] }, `icon_${M.id}`);
            }
          ) })
        ] }, `icon-category-${p}`) : null;
      }
    ) }) }),
    /* @__PURE__ */ l.jsx("div", { style: {
      padding: "10px 20px 0px 20px"
    }, children: d && d.name })
  ] });
}, ode = () => {
  Q();
  const [t, e] = pe(!1);
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(
    h2,
    {
      onClickSearch: () => {
        e(!t);
      },
      label: /* @__PURE__ */ l.jsx("div", { className: "icon-container", children: /* @__PURE__ */ l.jsx("label", { className: "icon-label", children: "Images" }) }),
      children: /* @__PURE__ */ l.jsx(
        sde,
        {
          inSearch: t
        }
      )
    }
  ) });
};
function an({ icon: t, small: e, invertIcon: n }) {
  return /* @__PURE__ */ l.jsx(ade, { className: "tlui-button__icon", icon: t, small: e, invertIcon: n });
}
const ade = _e(function({
  small: e,
  invertIcon: n,
  icon: i,
  color: r,
  className: s,
  ...o
}) {
  const a = Kp(), c = a.icons[i] ?? a.icons["question-mark-circle"], d = le(null);
  return at(() => {
    c || console.error(`Icon not found: ${i}. Add it to the assetUrls.icons object.`), d != null && d.current && (d.current.style.webkitMask = `url(${c}) center 100% / 100% no-repeat`);
  }, [d, c, i]), i === "none" ? /* @__PURE__ */ l.jsx(
    "div",
    {
      className: ce(
        "tlui-icon tlui-icon__placeholder",
        { "tlui-icon__small": e },
        s
      )
    }
  ) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      "div",
      {
        ...o,
        ref: d,
        className: ce("tlui-icon", { "tlui-icon__small": e }, s),
        style: {
          color: r,
          mask: `url(${c}) center 100% / 100% no-repeat`,
          transform: n ? "scale(-1, 1)" : void 0
        }
      }
    ),
    /* @__PURE__ */ l.jsx(
      "div",
      {
        className: "tlui-icon__backdrop"
      }
    )
  ] });
});
function cde(t, e) {
  return t ? typeof t == "string" ? t : t[e] ?? t.default : void 0;
}
const Uj = function({
  id: t,
  label: e = "",
  onSelect: n,
  disabled: i,
  isSelected: r,
  icon: s
}) {
  const o = cde(e, "default"), a = ke(), d = o ? a(o) : void 0;
  return /* @__PURE__ */ l.jsx(
    q,
    {
      type: "tool",
      "data-testid": `tools.${t}`,
      "aria-label": o,
      "data-value": t,
      onClick: () => n("toolbar"),
      title: d,
      disabled: i,
      onTouchStart: (u) => {
        u.preventDefault(), u.stopPropagation(), n("toolbar");
      },
      role: "radio",
      "aria-checked": r ? "true" : "false",
      children: /* @__PURE__ */ l.jsx(an, { icon: s })
    }
  );
}, Ar = dc(function(t, e) {
  const { tool: n } = t, i = mo(), r = Tf(i[n]);
  return /* @__PURE__ */ l.jsx("div", { ref: e, children: /* @__PURE__ */ l.jsx(Uj, { ...i[n], isSelected: r }) });
}), f2 = function({
  id: t,
  side: e,
  children: n,
  tool: i,
  ...r
}) {
  const s = mo(), o = Tf(s[i]);
  return /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsxs(
    Gn,
    {
      id: t,
      open: o,
      children: [
        /* @__PURE__ */ l.jsx(
          Hn,
          {
            side: e,
            children: n
          }
        ),
        /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(Uj, { ...s[i], isSelected: o }) }) })
      ]
    }
  ) });
}, lde = function({}) {
  return /* @__PURE__ */ l.jsx(
    f2,
    {
      id: "toolbar-legend-popover",
      side: "top",
      tool: "legend-tool",
      children: /* @__PURE__ */ l.jsx(rde, {})
    }
  );
}, dde = function({}) {
  return /* @__PURE__ */ l.jsx(
    f2,
    {
      id: "toolbar-image-gallery-popover",
      side: "top",
      tool: "image-gallery-tool",
      children: /* @__PURE__ */ l.jsx(ode, {})
    }
  );
};
function M2() {
  return /* @__PURE__ */ l.jsx(Ar, { tool: "select" });
}
function m2() {
  return /* @__PURE__ */ l.jsx(Ar, { tool: "hand" });
}
function ude() {
  return /* @__PURE__ */ l.jsx(Ar, { tool: "draw" });
}
function y2() {
  return /* @__PURE__ */ l.jsx(Ar, { tool: "eraser-tool" });
}
function hde() {
  return /* @__PURE__ */ l.jsx(
    Ar,
    {
      tool: "back"
    }
  );
}
function Vd({
  tool: t
}) {
  const e = mo(), n = Q(), i = G(
    "subtoolbar-item",
    () => n.isIn(t),
    [n.isIn(t)]
  );
  return /* @__PURE__ */ l.jsx(Uj, { ...e[t], isSelected: i });
}
function gde() {
  return /* @__PURE__ */ l.jsx(
    Vd,
    {
      tool: "floor-planner.wall-tool"
    }
  );
}
function pde({
  tool: t = "floor-planner.door-tool"
}) {
  return /* @__PURE__ */ l.jsx(Vd, { tool: t });
}
function fde() {
  return /* @__PURE__ */ l.jsx(
    Vd,
    {
      tool: "floor-planner.eraser-tool"
    }
  );
}
function Mde() {
  return /* @__PURE__ */ l.jsx(
    Vd,
    {
      tool: "floor-planner.intersect-tool"
    }
  );
}
function mde({
  tool: t = "floor-planner.window-tool"
}) {
  return /* @__PURE__ */ l.jsx(Vd, { tool: t });
}
function yde() {
  return /* @__PURE__ */ l.jsx(Ar, { tool: "note" });
}
function Ide() {
  return /* @__PURE__ */ l.jsx(Ar, { tool: "line" });
}
function xde() {
  return /* @__PURE__ */ l.jsx(Ar, { tool: "arrow" });
}
var fi = function() {
  return fi = Object.assign || function(e) {
    for (var n, i = 1, r = arguments.length; i < r; i++) {
      n = arguments[i];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, fi.apply(this, arguments);
};
function rc(t, e, n) {
  if (n || arguments.length === 2) for (var i = 0, r = e.length, s; i < r; i++)
    (s || !(i in e)) && (s || (s = Array.prototype.slice.call(e, 0, i)), s[i] = e[i]);
  return t.concat(s || Array.prototype.slice.call(e));
}
function Sde(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var jde = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Dde = /* @__PURE__ */ Sde(
  function(t) {
    return jde.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), vt = "-ms-", Zl = "-moz-", dt = "-webkit-", I2 = "comm", vf = "rule", Rj = "decl", wde = "@import", x2 = "@keyframes", Nde = "@layer", S2 = Math.abs, Yj = String.fromCharCode, WI = Object.assign;
function Ade(t, e) {
  return nn(t, 0) ^ 45 ? (((e << 2 ^ nn(t, 0)) << 2 ^ nn(t, 1)) << 2 ^ nn(t, 2)) << 2 ^ nn(t, 3) : 0;
}
function j2(t) {
  return t.trim();
}
function as(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function Ve(t, e, n) {
  return t.replace(e, n);
}
function Xh(t, e, n) {
  return t.indexOf(e, n);
}
function nn(t, e) {
  return t.charCodeAt(e) | 0;
}
function sc(t, e, n) {
  return t.slice(e, n);
}
function Cr(t) {
  return t.length;
}
function D2(t) {
  return t.length;
}
function El(t, e) {
  return e.push(t), t;
}
function Tde(t, e) {
  return t.map(e).join("");
}
function $N(t, e) {
  return t.filter(function(n) {
    return !as(n, e);
  });
}
var Ef = 1, oc = 1, w2 = 0, Ji = 0, Xt = 0, Lc = "";
function Cf(t, e, n, i, r, s, o, a) {
  return { value: t, root: e, parent: n, type: i, props: r, children: s, line: Ef, column: oc, length: o, return: "", siblings: a };
}
function Qs(t, e) {
  return WI(Cf("", null, null, "", null, null, 0, t.siblings), t, { length: -t.length }, e);
}
function ya(t) {
  for (; t.root; )
    t = Qs(t.root, { children: [t] });
  El(t, t.siblings);
}
function bde() {
  return Xt;
}
function vde() {
  return Xt = Ji > 0 ? nn(Lc, --Ji) : 0, oc--, Xt === 10 && (oc = 1, Ef--), Xt;
}
function ur() {
  return Xt = Ji < w2 ? nn(Lc, Ji++) : 0, oc++, Xt === 10 && (oc = 1, Ef++), Xt;
}
function Eo() {
  return nn(Lc, Ji);
}
function Jh() {
  return Ji;
}
function zf(t, e) {
  return sc(Lc, t, e);
}
function HI(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Ede(t) {
  return Ef = oc = 1, w2 = Cr(Lc = t), Ji = 0, [];
}
function Cde(t) {
  return Lc = "", t;
}
function mm(t) {
  return j2(zf(Ji - 1, VI(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function zde(t) {
  for (; (Xt = Eo()) && Xt < 33; )
    ur();
  return HI(t) > 2 || HI(Xt) > 3 ? "" : " ";
}
function Lde(t, e) {
  for (; --e && ur() && !(Xt < 48 || Xt > 102 || Xt > 57 && Xt < 65 || Xt > 70 && Xt < 97); )
    ;
  return zf(t, Jh() + (e < 6 && Eo() == 32 && ur() == 32));
}
function VI(t) {
  for (; ur(); )
    switch (Xt) {
      case t:
        return Ji;
      case 34:
      case 39:
        t !== 34 && t !== 39 && VI(Xt);
        break;
      case 40:
        t === 41 && VI(t);
        break;
      case 92:
        ur();
        break;
    }
  return Ji;
}
function kde(t, e) {
  for (; ur() && t + Xt !== 57; )
    if (t + Xt === 84 && Eo() === 47)
      break;
  return "/*" + zf(e, Ji - 1) + "*" + Yj(t === 47 ? t : ur());
}
function Ode(t) {
  for (; !HI(Eo()); )
    ur();
  return zf(t, Ji);
}
function Pde(t) {
  return Cde(qh("", null, null, null, [""], t = Ede(t), 0, [0], t));
}
function qh(t, e, n, i, r, s, o, a, c) {
  for (var d = 0, u = 0, h = o, g = 0, p = 0, f = 0, M = 1, m = 1, y = 1, I = 0, D = "", j = r, w = s, A = i, b = D; m; )
    switch (f = I, I = ur()) {
      case 40:
        if (f != 108 && nn(b, h - 1) == 58) {
          Xh(b += Ve(mm(I), "&", "&\f"), "&\f", S2(d ? a[d - 1] : 0)) != -1 && (y = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        b += mm(I);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        b += zde(f);
        break;
      case 92:
        b += Lde(Jh() - 1, 7);
        continue;
      case 47:
        switch (Eo()) {
          case 42:
          case 47:
            El(Ude(kde(ur(), Jh()), e, n, c), c);
            break;
          default:
            b += "/";
        }
        break;
      case 123 * M:
        a[d++] = Cr(b) * y;
      case 125 * M:
      case 59:
      case 0:
        switch (I) {
          case 0:
          case 125:
            m = 0;
          case 59 + u:
            y == -1 && (b = Ve(b, /\f/g, "")), p > 0 && Cr(b) - h && El(p > 32 ? tA(b + ";", i, n, h - 1, c) : tA(Ve(b, " ", "") + ";", i, n, h - 2, c), c);
            break;
          case 59:
            b += ";";
          default:
            if (El(A = eA(b, e, n, d, u, r, a, D, j = [], w = [], h, s), s), I === 123)
              if (u === 0)
                qh(b, e, A, A, j, s, h, a, w);
              else
                switch (g === 99 && nn(b, 3) === 110 ? 100 : g) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    qh(t, A, A, i && El(eA(t, A, A, 0, 0, r, a, D, r, j = [], h, w), w), r, w, h, a, i ? j : w);
                    break;
                  default:
                    qh(b, A, A, A, [""], w, 0, a, w);
                }
        }
        d = u = p = 0, M = y = 1, D = b = "", h = o;
        break;
      case 58:
        h = 1 + Cr(b), p = f;
      default:
        if (M < 1) {
          if (I == 123)
            --M;
          else if (I == 125 && M++ == 0 && vde() == 125)
            continue;
        }
        switch (b += Yj(I), I * M) {
          case 38:
            y = u > 0 ? 1 : (b += "\f", -1);
            break;
          case 44:
            a[d++] = (Cr(b) - 1) * y, y = 1;
            break;
          case 64:
            Eo() === 45 && (b += mm(ur())), g = Eo(), u = h = Cr(D = b += Ode(Jh())), I++;
            break;
          case 45:
            f === 45 && Cr(b) == 2 && (M = 0);
        }
    }
  return s;
}
function eA(t, e, n, i, r, s, o, a, c, d, u, h) {
  for (var g = r - 1, p = r === 0 ? s : [""], f = D2(p), M = 0, m = 0, y = 0; M < i; ++M)
    for (var I = 0, D = sc(t, g + 1, g = S2(m = o[M])), j = t; I < f; ++I)
      (j = j2(m > 0 ? p[I] + " " + D : Ve(D, /&\f/g, p[I]))) && (c[y++] = j);
  return Cf(t, e, n, r === 0 ? vf : a, c, d, u, h);
}
function Ude(t, e, n, i) {
  return Cf(t, e, n, I2, Yj(bde()), sc(t, 2, -2), 0, i);
}
function tA(t, e, n, i, r) {
  return Cf(t, e, n, Rj, sc(t, 0, i), sc(t, i + 1, -1), i, r);
}
function N2(t, e, n) {
  switch (Ade(t, e)) {
    case 5103:
      return dt + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return dt + t + t;
    case 4789:
      return Zl + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return dt + t + Zl + t + vt + t + t;
    case 5936:
      switch (nn(t, e + 11)) {
        case 114:
          return dt + t + vt + Ve(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return dt + t + vt + Ve(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return dt + t + vt + Ve(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
    case 6828:
    case 4268:
    case 2903:
      return dt + t + vt + t + t;
    case 6165:
      return dt + t + vt + "flex-" + t + t;
    case 5187:
      return dt + t + Ve(t, /(\w+).+(:[^]+)/, dt + "box-$1$2" + vt + "flex-$1$2") + t;
    case 5443:
      return dt + t + vt + "flex-item-" + Ve(t, /flex-|-self/g, "") + (as(t, /flex-|baseline/) ? "" : vt + "grid-row-" + Ve(t, /flex-|-self/g, "")) + t;
    case 4675:
      return dt + t + vt + "flex-line-pack" + Ve(t, /align-content|flex-|-self/g, "") + t;
    case 5548:
      return dt + t + vt + Ve(t, "shrink", "negative") + t;
    case 5292:
      return dt + t + vt + Ve(t, "basis", "preferred-size") + t;
    case 6060:
      return dt + "box-" + Ve(t, "-grow", "") + dt + t + vt + Ve(t, "grow", "positive") + t;
    case 4554:
      return dt + Ve(t, /([^-])(transform)/g, "$1" + dt + "$2") + t;
    case 6187:
      return Ve(Ve(Ve(t, /(zoom-|grab)/, dt + "$1"), /(image-set)/, dt + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return Ve(t, /(image-set\([^]*)/, dt + "$1$`$1");
    case 4968:
      return Ve(Ve(t, /(.+:)(flex-)?(.*)/, dt + "box-pack:$3" + vt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + dt + t + t;
    case 4200:
      if (!as(t, /flex-|baseline/)) return vt + "grid-column-align" + sc(t, e) + t;
      break;
    case 2592:
    case 3360:
      return vt + Ve(t, "template-", "") + t;
    case 4384:
    case 3616:
      return n && n.some(function(i, r) {
        return e = r, as(i.props, /grid-\w+-end/);
      }) ? ~Xh(t + (n = n[e].value), "span", 0) ? t : vt + Ve(t, "-start", "") + t + vt + "grid-row-span:" + (~Xh(n, "span", 0) ? as(n, /\d+/) : +as(n, /\d+/) - +as(t, /\d+/)) + ";" : vt + Ve(t, "-start", "") + t;
    case 4896:
    case 4128:
      return n && n.some(function(i) {
        return as(i.props, /grid-\w+-start/);
      }) ? t : vt + Ve(Ve(t, "-end", "-span"), "span ", "") + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ve(t, /(.+)-inline(.+)/, dt + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Cr(t) - 1 - e > 6)
        switch (nn(t, e + 1)) {
          case 109:
            if (nn(t, e + 4) !== 45)
              break;
          case 102:
            return Ve(t, /(.+:)(.+)-([^]+)/, "$1" + dt + "$2-$3$1" + Zl + (nn(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~Xh(t, "stretch", 0) ? N2(Ve(t, "stretch", "fill-available"), e, n) + t : t;
        }
      break;
    case 5152:
    case 5920:
      return Ve(t, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(i, r, s, o, a, c, d) {
        return vt + r + ":" + s + d + (o ? vt + r + "-span:" + (a ? c : +c - +s) + d : "") + t;
      });
    case 4949:
      if (nn(t, e + 6) === 121)
        return Ve(t, ":", ":" + dt) + t;
      break;
    case 6444:
      switch (nn(t, nn(t, 14) === 45 ? 18 : 11)) {
        case 120:
          return Ve(t, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + dt + (nn(t, 14) === 45 ? "inline-" : "") + "box$3$1" + dt + "$2$3$1" + vt + "$2box$3") + t;
        case 100:
          return Ve(t, ":", ":" + vt) + t;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return Ve(t, "scroll-", "scroll-snap-") + t;
  }
  return t;
}
function ep(t, e) {
  for (var n = "", i = 0; i < t.length; i++)
    n += e(t[i], i, t, e) || "";
  return n;
}
function Rde(t, e, n, i) {
  switch (t.type) {
    case Nde:
      if (t.children.length) break;
    case wde:
    case Rj:
      return t.return = t.return || t.value;
    case I2:
      return "";
    case x2:
      return t.return = t.value + "{" + ep(t.children, i) + "}";
    case vf:
      if (!Cr(t.value = t.props.join(","))) return "";
  }
  return Cr(n = ep(t.children, i)) ? t.return = t.value + "{" + n + "}" : "";
}
function Yde(t) {
  var e = D2(t);
  return function(n, i, r, s) {
    for (var o = "", a = 0; a < e; a++)
      o += t[a](n, i, r, s) || "";
    return o;
  };
}
function Qde(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
function Zde(t, e, n, i) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case Rj:
        t.return = N2(t.value, t.length, n);
        return;
      case x2:
        return ep([Qs(t, { value: Ve(t.value, "@", "@" + dt) })], i);
      case vf:
        if (t.length)
          return Tde(n = t.props, function(r) {
            switch (as(r, i = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                ya(Qs(t, { props: [Ve(r, /:(read-\w+)/, ":" + Zl + "$1")] })), ya(Qs(t, { props: [r] })), WI(t, { props: $N(n, i) });
                break;
              case "::placeholder":
                ya(Qs(t, { props: [Ve(r, /:(plac\w+)/, ":" + dt + "input-$1")] })), ya(Qs(t, { props: [Ve(r, /:(plac\w+)/, ":" + Zl + "$1")] })), ya(Qs(t, { props: [Ve(r, /:(plac\w+)/, vt + "input-$1")] })), ya(Qs(t, { props: [r] })), WI(t, { props: $N(n, i) });
                break;
            }
            return "";
          });
    }
}
var Fde = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Bo = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", A2 = "active", T2 = "data-styled-version", Lf = "6.1.13", Qj = `/*!sc*/
`, tp = typeof window < "u" && "HTMLElement" in window, Bde = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), nA = /invalid hook call/i, ih = /* @__PURE__ */ new Set(), Gde = function(t, e) {
  if (process.env.NODE_ENV !== "production") {
    var n = e ? ' with the id of "'.concat(e, '"') : "", i = "The component ".concat(t).concat(n, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, r = console.error;
    try {
      var s = !0;
      console.error = function(o) {
        for (var a = [], c = 1; c < arguments.length; c++) a[c - 1] = arguments[c];
        nA.test(o) ? (s = !1, ih.delete(i)) : r.apply(void 0, rc([o], a, !1));
      }, le(), s && !ih.has(i) && (console.warn(i), ih.add(i));
    } catch (o) {
      nA.test(o.message) && ih.delete(i);
    } finally {
      console.error = r;
    }
  }
}, kf = Object.freeze([]), ac = Object.freeze({});
function Wde(t, e, n) {
  return n === void 0 && (n = ac), t.theme !== n.theme && t.theme || e || n.theme;
}
var KI = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), Hde = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, Vde = /(^-|-$)/g;
function iA(t) {
  return t.replace(Hde, "-").replace(Vde, "");
}
var Kde = /(a)(d)/gi, rh = 52, rA = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function XI(t) {
  var e, n = "";
  for (e = Math.abs(t); e > rh; e = e / rh | 0) n = rA(e % rh) + n;
  return (rA(e % rh) + n).replace(Kde, "$1-$2");
}
var ym, b2 = 5381, Ao = function(t, e) {
  for (var n = e.length; n; ) t = 33 * t ^ e.charCodeAt(--n);
  return t;
}, v2 = function(t) {
  return Ao(b2, t);
};
function Xde(t) {
  return XI(v2(t) >>> 0);
}
function E2(t) {
  return process.env.NODE_ENV !== "production" && typeof t == "string" && t || t.displayName || t.name || "Component";
}
function Im(t) {
  return typeof t == "string" && (process.env.NODE_ENV === "production" || t.charAt(0) === t.charAt(0).toLowerCase());
}
var C2 = typeof Symbol == "function" && Symbol.for, z2 = C2 ? Symbol.for("react.memo") : 60115, Jde = C2 ? Symbol.for("react.forward_ref") : 60112, qde = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, _de = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, L2 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, $de = ((ym = {})[Jde] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, ym[z2] = L2, ym);
function sA(t) {
  return ("type" in (e = t) && e.type.$$typeof) === z2 ? L2 : "$$typeof" in t ? $de[t.$$typeof] : qde;
  var e;
}
var eue = Object.defineProperty, tue = Object.getOwnPropertyNames, oA = Object.getOwnPropertySymbols, nue = Object.getOwnPropertyDescriptor, iue = Object.getPrototypeOf, aA = Object.prototype;
function k2(t, e, n) {
  if (typeof e != "string") {
    if (aA) {
      var i = iue(e);
      i && i !== aA && k2(t, i, n);
    }
    var r = tue(e);
    oA && (r = r.concat(oA(e)));
    for (var s = sA(t), o = sA(e), a = 0; a < r.length; ++a) {
      var c = r[a];
      if (!(c in _de || n && n[c] || o && c in o || s && c in s)) {
        var d = nue(e, c);
        try {
          eue(t, c, d);
        } catch {
        }
      }
    }
  }
  return t;
}
function cc(t) {
  return typeof t == "function";
}
function Zj(t) {
  return typeof t == "object" && "styledComponentId" in t;
}
function To(t, e) {
  return t && e ? "".concat(t, " ").concat(e) : t || e || "";
}
function cA(t, e) {
  if (t.length === 0) return "";
  for (var n = t[0], i = 1; i < t.length; i++) n += t[i];
  return n;
}
function lc(t) {
  return t !== null && typeof t == "object" && t.constructor.name === Object.name && !("props" in t && t.$$typeof);
}
function JI(t, e, n) {
  if (n === void 0 && (n = !1), !n && !lc(t) && !Array.isArray(t)) return e;
  if (Array.isArray(e)) for (var i = 0; i < e.length; i++) t[i] = JI(t[i], e[i]);
  else if (lc(e)) for (var i in e) t[i] = JI(t[i], e[i]);
  return t;
}
function Fj(t, e) {
  Object.defineProperty(t, "toString", { value: e });
}
var rue = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function sue() {
  for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
  for (var n = t[0], i = [], r = 1, s = t.length; r < s; r += 1) i.push(t[r]);
  return i.forEach(function(o) {
    n = n.replace(/%[a-z]/, o);
  }), n;
}
function kc(t) {
  for (var e = [], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(e.length > 0 ? " Args: ".concat(e.join(", ")) : "")) : new Error(sue.apply(void 0, rc([rue[t]], e, !1)).trim());
}
var oue = function() {
  function t(e) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
  }
  return t.prototype.indexOfGroup = function(e) {
    for (var n = 0, i = 0; i < e; i++) n += this.groupSizes[i];
    return n;
  }, t.prototype.insertRules = function(e, n) {
    if (e >= this.groupSizes.length) {
      for (var i = this.groupSizes, r = i.length, s = r; e >= s; ) if ((s <<= 1) < 0) throw kc(16, "".concat(e));
      this.groupSizes = new Uint32Array(s), this.groupSizes.set(i), this.length = s;
      for (var o = r; o < s; o++) this.groupSizes[o] = 0;
    }
    for (var a = this.indexOfGroup(e + 1), c = (o = 0, n.length); o < c; o++) this.tag.insertRule(a, n[o]) && (this.groupSizes[e]++, a++);
  }, t.prototype.clearGroup = function(e) {
    if (e < this.length) {
      var n = this.groupSizes[e], i = this.indexOfGroup(e), r = i + n;
      this.groupSizes[e] = 0;
      for (var s = i; s < r; s++) this.tag.deleteRule(i);
    }
  }, t.prototype.getGroup = function(e) {
    var n = "";
    if (e >= this.length || this.groupSizes[e] === 0) return n;
    for (var i = this.groupSizes[e], r = this.indexOfGroup(e), s = r + i, o = r; o < s; o++) n += "".concat(this.tag.getRule(o)).concat(Qj);
    return n;
  }, t;
}(), aue = 1 << 30, _h = /* @__PURE__ */ new Map(), np = /* @__PURE__ */ new Map(), $h = 1, sh = function(t) {
  if (_h.has(t)) return _h.get(t);
  for (; np.has($h); ) $h++;
  var e = $h++;
  if (process.env.NODE_ENV !== "production" && ((0 | e) < 0 || e > aue)) throw kc(16, "".concat(e));
  return _h.set(t, e), np.set(e, t), e;
}, cue = function(t, e) {
  $h = e + 1, _h.set(t, e), np.set(e, t);
}, lue = "style[".concat(Bo, "][").concat(T2, '="').concat(Lf, '"]'), due = new RegExp("^".concat(Bo, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), uue = function(t, e, n) {
  for (var i, r = n.split(","), s = 0, o = r.length; s < o; s++) (i = r[s]) && t.registerName(e, i);
}, hue = function(t, e) {
  for (var n, i = ((n = e.textContent) !== null && n !== void 0 ? n : "").split(Qj), r = [], s = 0, o = i.length; s < o; s++) {
    var a = i[s].trim();
    if (a) {
      var c = a.match(due);
      if (c) {
        var d = 0 | parseInt(c[1], 10), u = c[2];
        d !== 0 && (cue(u, d), uue(t, u, c[3]), t.getTag().insertRules(d, r)), r.length = 0;
      } else r.push(a);
    }
  }
}, lA = function(t) {
  for (var e = document.querySelectorAll(lue), n = 0, i = e.length; n < i; n++) {
    var r = e[n];
    r && r.getAttribute(Bo) !== A2 && (hue(t, r), r.parentNode && r.parentNode.removeChild(r));
  }
};
function gue() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var O2 = function(t) {
  var e = document.head, n = t || e, i = document.createElement("style"), r = function(a) {
    var c = Array.from(a.querySelectorAll("style[".concat(Bo, "]")));
    return c[c.length - 1];
  }(n), s = r !== void 0 ? r.nextSibling : null;
  i.setAttribute(Bo, A2), i.setAttribute(T2, Lf);
  var o = gue();
  return o && i.setAttribute("nonce", o), n.insertBefore(i, s), i;
}, pue = function() {
  function t(e) {
    this.element = O2(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(n) {
      if (n.sheet) return n.sheet;
      for (var i = document.styleSheets, r = 0, s = i.length; r < s; r++) {
        var o = i[r];
        if (o.ownerNode === n) return o;
      }
      throw kc(17);
    }(this.element), this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    try {
      return this.sheet.insertRule(n, e), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.prototype.deleteRule = function(e) {
    this.sheet.deleteRule(e), this.length--;
  }, t.prototype.getRule = function(e) {
    var n = this.sheet.cssRules[e];
    return n && n.cssText ? n.cssText : "";
  }, t;
}(), fue = function() {
  function t(e) {
    this.element = O2(e), this.nodes = this.element.childNodes, this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    if (e <= this.length && e >= 0) {
      var i = document.createTextNode(n);
      return this.element.insertBefore(i, this.nodes[e] || null), this.length++, !0;
    }
    return !1;
  }, t.prototype.deleteRule = function(e) {
    this.element.removeChild(this.nodes[e]), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.nodes[e].textContent : "";
  }, t;
}(), Mue = function() {
  function t(e) {
    this.rules = [], this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    return e <= this.length && (this.rules.splice(e, 0, n), this.length++, !0);
  }, t.prototype.deleteRule = function(e) {
    this.rules.splice(e, 1), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.rules[e] : "";
  }, t;
}(), dA = tp, mue = { isServer: !tp, useCSSOMInjection: !Bde }, P2 = function() {
  function t(e, n, i) {
    e === void 0 && (e = ac), n === void 0 && (n = {});
    var r = this;
    this.options = fi(fi({}, mue), e), this.gs = n, this.names = new Map(i), this.server = !!e.isServer, !this.server && tp && dA && (dA = !1, lA(this)), Fj(this, function() {
      return function(s) {
        for (var o = s.getTag(), a = o.length, c = "", d = function(h) {
          var g = function(y) {
            return np.get(y);
          }(h);
          if (g === void 0) return "continue";
          var p = s.names.get(g), f = o.getGroup(h);
          if (p === void 0 || !p.size || f.length === 0) return "continue";
          var M = "".concat(Bo, ".g").concat(h, '[id="').concat(g, '"]'), m = "";
          p !== void 0 && p.forEach(function(y) {
            y.length > 0 && (m += "".concat(y, ","));
          }), c += "".concat(f).concat(M, '{content:"').concat(m, '"}').concat(Qj);
        }, u = 0; u < a; u++) d(u);
        return c;
      }(r);
    });
  }
  return t.registerId = function(e) {
    return sh(e);
  }, t.prototype.rehydrate = function() {
    !this.server && tp && lA(this);
  }, t.prototype.reconstructWithOptions = function(e, n) {
    return n === void 0 && (n = !0), new t(fi(fi({}, this.options), e), this.gs, n && this.names || void 0);
  }, t.prototype.allocateGSInstance = function(e) {
    return this.gs[e] = (this.gs[e] || 0) + 1;
  }, t.prototype.getTag = function() {
    return this.tag || (this.tag = (e = function(n) {
      var i = n.useCSSOMInjection, r = n.target;
      return n.isServer ? new Mue(r) : i ? new pue(r) : new fue(r);
    }(this.options), new oue(e)));
    var e;
  }, t.prototype.hasNameForId = function(e, n) {
    return this.names.has(e) && this.names.get(e).has(n);
  }, t.prototype.registerName = function(e, n) {
    if (sh(e), this.names.has(e)) this.names.get(e).add(n);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(n), this.names.set(e, i);
    }
  }, t.prototype.insertRules = function(e, n, i) {
    this.registerName(e, n), this.getTag().insertRules(sh(e), i);
  }, t.prototype.clearNames = function(e) {
    this.names.has(e) && this.names.get(e).clear();
  }, t.prototype.clearRules = function(e) {
    this.getTag().clearGroup(sh(e)), this.clearNames(e);
  }, t.prototype.clearTag = function() {
    this.tag = void 0;
  }, t;
}(), yue = /&/g, Iue = /^\s*\/\/.*$/gm;
function U2(t, e) {
  return t.map(function(n) {
    return n.type === "rule" && (n.value = "".concat(e, " ").concat(n.value), n.value = n.value.replaceAll(",", ",".concat(e, " ")), n.props = n.props.map(function(i) {
      return "".concat(e, " ").concat(i);
    })), Array.isArray(n.children) && n.type !== "@keyframes" && (n.children = U2(n.children, e)), n;
  });
}
function xue(t) {
  var e, n, i, r = ac, s = r.options, o = s === void 0 ? ac : s, a = r.plugins, c = a === void 0 ? kf : a, d = function(g, p, f) {
    return f.startsWith(n) && f.endsWith(n) && f.replaceAll(n, "").length > 0 ? ".".concat(e) : g;
  }, u = c.slice();
  u.push(function(g) {
    g.type === vf && g.value.includes("&") && (g.props[0] = g.props[0].replace(yue, n).replace(i, d));
  }), o.prefix && u.push(Zde), u.push(Rde);
  var h = function(g, p, f, M) {
    p === void 0 && (p = ""), f === void 0 && (f = ""), M === void 0 && (M = "&"), e = M, n = p, i = new RegExp("\\".concat(n, "\\b"), "g");
    var m = g.replace(Iue, ""), y = Pde(f || p ? "".concat(f, " ").concat(p, " { ").concat(m, " }") : m);
    o.namespace && (y = U2(y, o.namespace));
    var I = [];
    return ep(y, Yde(u.concat(Qde(function(D) {
      return I.push(D);
    })))), I;
  };
  return h.hash = c.length ? c.reduce(function(g, p) {
    return p.name || kc(15), Ao(g, p.name);
  }, b2).toString() : "", h;
}
var Sue = new P2(), qI = xue(), R2 = Ye.createContext({ shouldForwardProp: void 0, styleSheet: Sue, stylis: qI });
R2.Consumer;
Ye.createContext(void 0);
function uA() {
  return Vn(R2);
}
var hA = function() {
  function t(e, n) {
    var i = this;
    this.inject = function(r, s) {
      s === void 0 && (s = qI);
      var o = i.name + s.hash;
      r.hasNameForId(i.id, o) || r.insertRules(i.id, o, s(i.rules, o, "@keyframes"));
    }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = n, Fj(this, function() {
      throw kc(12, String(i.name));
    });
  }
  return t.prototype.getName = function(e) {
    return e === void 0 && (e = qI), this.name + e.hash;
  }, t;
}(), jue = function(t) {
  return t >= "A" && t <= "Z";
};
function gA(t) {
  for (var e = "", n = 0; n < t.length; n++) {
    var i = t[n];
    if (n === 1 && i === "-" && t[0] === "-") return t;
    jue(i) ? e += "-" + i.toLowerCase() : e += i;
  }
  return e.startsWith("ms-") ? "-" + e : e;
}
var Y2 = function(t) {
  return t == null || t === !1 || t === "";
}, Q2 = function(t) {
  var e, n, i = [];
  for (var r in t) {
    var s = t[r];
    t.hasOwnProperty(r) && !Y2(s) && (Array.isArray(s) && s.isCss || cc(s) ? i.push("".concat(gA(r), ":"), s, ";") : lc(s) ? i.push.apply(i, rc(rc(["".concat(r, " {")], Q2(s), !1), ["}"], !1)) : i.push("".concat(gA(r), ": ").concat((e = r, (n = s) == null || typeof n == "boolean" || n === "" ? "" : typeof n != "number" || n === 0 || e in Fde || e.startsWith("--") ? String(n).trim() : "".concat(n, "px")), ";")));
  }
  return i;
};
function Co(t, e, n, i) {
  if (Y2(t)) return [];
  if (Zj(t)) return [".".concat(t.styledComponentId)];
  if (cc(t)) {
    if (!cc(s = t) || s.prototype && s.prototype.isReactComponent || !e) return [t];
    var r = t(e);
    return process.env.NODE_ENV === "production" || typeof r != "object" || Array.isArray(r) || r instanceof hA || lc(r) || r === null || console.error("".concat(E2(t), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), Co(r, e, n, i);
  }
  var s;
  return t instanceof hA ? n ? (t.inject(n, i), [t.getName(i)]) : [t] : lc(t) ? Q2(t) : Array.isArray(t) ? Array.prototype.concat.apply(kf, t.map(function(o) {
    return Co(o, e, n, i);
  })) : [t.toString()];
}
function Due(t) {
  for (var e = 0; e < t.length; e += 1) {
    var n = t[e];
    if (cc(n) && !Zj(n)) return !1;
  }
  return !0;
}
var wue = v2(Lf), Nue = function() {
  function t(e, n, i) {
    this.rules = e, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (i === void 0 || i.isStatic) && Due(e), this.componentId = n, this.baseHash = Ao(wue, n), this.baseStyle = i, P2.registerId(n);
  }
  return t.prototype.generateAndInjectStyles = function(e, n, i) {
    var r = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, n, i) : "";
    if (this.isStatic && !i.hash) if (this.staticRulesId && n.hasNameForId(this.componentId, this.staticRulesId)) r = To(r, this.staticRulesId);
    else {
      var s = cA(Co(this.rules, e, n, i)), o = XI(Ao(this.baseHash, s) >>> 0);
      if (!n.hasNameForId(this.componentId, o)) {
        var a = i(s, ".".concat(o), void 0, this.componentId);
        n.insertRules(this.componentId, o, a);
      }
      r = To(r, o), this.staticRulesId = o;
    }
    else {
      for (var c = Ao(this.baseHash, i.hash), d = "", u = 0; u < this.rules.length; u++) {
        var h = this.rules[u];
        if (typeof h == "string") d += h, process.env.NODE_ENV !== "production" && (c = Ao(c, h));
        else if (h) {
          var g = cA(Co(h, e, n, i));
          c = Ao(c, g + u), d += g;
        }
      }
      if (d) {
        var p = XI(c >>> 0);
        n.hasNameForId(this.componentId, p) || n.insertRules(this.componentId, p, i(d, ".".concat(p), void 0, this.componentId)), r = To(r, p);
      }
    }
    return r;
  }, t;
}(), Z2 = Ye.createContext(void 0);
Z2.Consumer;
var xm = {}, pA = /* @__PURE__ */ new Set();
function Aue(t, e, n) {
  var i = Zj(t), r = t, s = !Im(t), o = e.attrs, a = o === void 0 ? kf : o, c = e.componentId, d = c === void 0 ? function(j, w) {
    var A = typeof j != "string" ? "sc" : iA(j);
    xm[A] = (xm[A] || 0) + 1;
    var b = "".concat(A, "-").concat(Xde(Lf + A + xm[A]));
    return w ? "".concat(w, "-").concat(b) : b;
  }(e.displayName, e.parentComponentId) : c, u = e.displayName, h = u === void 0 ? function(j) {
    return Im(j) ? "styled.".concat(j) : "Styled(".concat(E2(j), ")");
  }(t) : u, g = e.displayName && e.componentId ? "".concat(iA(e.displayName), "-").concat(e.componentId) : e.componentId || d, p = i && r.attrs ? r.attrs.concat(a).filter(Boolean) : a, f = e.shouldForwardProp;
  if (i && r.shouldForwardProp) {
    var M = r.shouldForwardProp;
    if (e.shouldForwardProp) {
      var m = e.shouldForwardProp;
      f = function(j, w) {
        return M(j, w) && m(j, w);
      };
    } else f = M;
  }
  var y = new Nue(n, g, i ? r.componentStyle : void 0);
  function I(j, w) {
    return function(A, b, T) {
      var E = A.attrs, v = A.componentStyle, P = A.defaultProps, C = A.foldedComponentIds, z = A.styledComponentId, O = A.target, R = Ye.useContext(Z2), U = uA(), F = A.shouldForwardProp || U.shouldForwardProp;
      process.env.NODE_ENV !== "production" && dy(z);
      var H = Wde(b, R, P) || ac, Z = function(ie, Ue, ge) {
        for (var Re, ye = fi(fi({}, Ue), { className: void 0, theme: ge }), Be = 0; Be < ie.length; Be += 1) {
          var We = cc(Re = ie[Be]) ? Re(ye) : Re;
          for (var lt in We) ye[lt] = lt === "className" ? To(ye[lt], We[lt]) : lt === "style" ? fi(fi({}, ye[lt]), We[lt]) : We[lt];
        }
        return Ue.className && (ye.className = To(ye.className, Ue.className)), ye;
      }(E, b, H), te = Z.as || O, oe = {};
      for (var me in Z) Z[me] === void 0 || me[0] === "$" || me === "as" || me === "theme" && Z.theme === H || (me === "forwardedAs" ? oe.as = Z.forwardedAs : F && !F(me, te) || (oe[me] = Z[me], F || process.env.NODE_ENV !== "development" || Dde(me) || pA.has(me) || !KI.has(te) || (pA.add(me), console.warn('styled-components: it looks like an unknown prop "'.concat(me, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var he = function(ie, Ue) {
        var ge = uA(), Re = ie.generateAndInjectStyles(Ue, ge.styleSheet, ge.stylis);
        return process.env.NODE_ENV !== "production" && dy(Re), Re;
      }(v, Z);
      process.env.NODE_ENV !== "production" && A.warnTooManyClasses && A.warnTooManyClasses(he);
      var ve = To(C, z);
      return he && (ve += " " + he), Z.className && (ve += " " + Z.className), oe[Im(te) && !KI.has(te) ? "class" : "className"] = ve, oe.ref = T, J3(te, oe);
    }(D, j, w);
  }
  I.displayName = h;
  var D = Ye.forwardRef(I);
  return D.attrs = p, D.componentStyle = y, D.displayName = h, D.shouldForwardProp = f, D.foldedComponentIds = i ? To(r.foldedComponentIds, r.styledComponentId) : "", D.styledComponentId = g, D.target = i ? r.target : t, Object.defineProperty(D, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(j) {
    this._foldedDefaultProps = i ? function(w) {
      for (var A = [], b = 1; b < arguments.length; b++) A[b - 1] = arguments[b];
      for (var T = 0, E = A; T < E.length; T++) JI(w, E[T], !0);
      return w;
    }({}, r.defaultProps, j) : j;
  } }), process.env.NODE_ENV !== "production" && (Gde(h, g), D.warnTooManyClasses = /* @__PURE__ */ function(j, w) {
    var A = {}, b = !1;
    return function(T) {
      if (!b && (A[T] = !0, Object.keys(A).length >= 200)) {
        var E = w ? ' with the id of "'.concat(w, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(j).concat(E, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), b = !0, A = {};
      }
    };
  }(h, g)), Fj(D, function() {
    return ".".concat(D.styledComponentId);
  }), s && k2(D, t, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), D;
}
function fA(t, e) {
  for (var n = [t[0]], i = 0, r = e.length; i < r; i += 1) n.push(e[i], t[i + 1]);
  return n;
}
var MA = function(t) {
  return Object.assign(t, { isCss: !0 });
};
function Tue(t) {
  for (var e = [], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
  if (cc(t) || lc(t)) return MA(Co(fA(kf, rc([t], e, !0))));
  var i = t;
  return e.length === 0 && i.length === 1 && typeof i[0] == "string" ? Co(i) : MA(Co(fA(i, e)));
}
function _I(t, e, n) {
  if (n === void 0 && (n = ac), !e) throw kc(1, e);
  var i = function(r) {
    for (var s = [], o = 1; o < arguments.length; o++) s[o - 1] = arguments[o];
    return t(e, n, Tue.apply(void 0, rc([r], s, !1)));
  };
  return i.attrs = function(r) {
    return _I(t, e, fi(fi({}, n), { attrs: Array.prototype.concat(n.attrs, r).filter(Boolean) }));
  }, i.withConfig = function(r) {
    return _I(t, e, fi(fi({}, n), r));
  }, i;
}
var F2 = function(t) {
  return _I(Aue, t);
}, Kd = F2;
KI.forEach(function(t) {
  Kd[t] = F2(t);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var oh = "__sc-".concat(Bo, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[oh] || (window[oh] = 0), window[oh] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[oh] += 1);
const bue = Kd.div`
    height: 100%;
    &::after {
        content: "";
        display: block;
        height: 100%;
        border: 1px solid rgba(58, 53, 65, 0.12);
    }
`, tr = () => /* @__PURE__ */ l.jsx(bue, {}), mA = {
  default: {
    font: "'Outfit', sans-serif",
    color: "#000"
  },
  header: {
    padding: "5px",
    color: "rgba(58, 53, 65, 1);"
  },
  subheader: {
    padding: "0px 6px 0px 20px",
    color: "rgba(58, 53, 65, 1);"
  }
}, vue = (t) => ({
  ...mA.default,
  ...mA[t] ?? {}
}), Eue = Kd.label`
    ${(t) => vue(t.variant ?? "default")}
`, ja = ({ children: t, ...e }) => /* @__PURE__ */ l.jsx(Eue, { ...e, children: t }), yA = {
  showRuler: !0,
  rulerMeasurement: "m",
  rulerPixelUnits: 64,
  canExport: !0,
  canSave: !1,
  canExit: !1,
  width: 1024,
  defaultGridSize: 16,
  height: 1024,
  isMobile: !1
}, Go = xt(
  "settings atom",
  {
    ...yA,
    initialSettings: {
      ...yA
    }
  }
), Zs = (t, e) => {
  var n = 1;
  switch (e) {
    case "cm":
      n = 1;
      break;
    case "mm":
      n = 1;
      break;
    case "in":
      n = 1;
      break;
    case "ft":
      n = 3.280839895;
      break;
  }
  return parseFloat(t) * n;
}, Cue = () => {
  const { rulerPixelUnits: t, rulerMeasurement: e } = Go.get();
  return Zs(t ?? 64, e);
}, Fl = (t) => {
  Go.update((e) => ({
    ...e,
    ...t
  }));
}, _o = () => Go.get(), zue = () => G(
  "settings atom",
  () => Go.get().showRuler,
  [Go]
), B2 = () => G(
  "settings atom",
  () => Go.get(),
  [Go]
);
function Fa(t) {
  const e = _o(), n = (e.isMobile ? window.innerHeight : window.innerWidth) / 12, i = Array.from(t.getCurrentPageShapes().filter(
    (s) => s.type === "grid"
  ));
  let r = {
    x: 0,
    y: 0,
    w: e.width,
    h: e.height
  };
  if (i.length > 0) {
    const s = i[0];
    r = {
      x: s.x,
      y: s.y,
      w: s.props.w,
      h: s.props.h
    };
  }
  t.setCameraOptions({
    isLocked: !1,
    wheelBehavior: "pan",
    panSpeed: 1,
    zoomSpeed: 1,
    zoomSteps: [0.2, 0.5, 1, 2, 4, 8],
    constraints: {
      initialZoom: "fit-y",
      baseZoom: "fit-y",
      bounds: {
        x: 0,
        y: 0,
        w: Math.ceil(r.w / e.defaultGridSize) * e.defaultGridSize,
        h: Math.ceil(r.h / e.defaultGridSize) * e.defaultGridSize
      },
      behavior: { x: "contain", y: "contain" },
      padding: { x: n, y: n },
      origin: { x: 0.5, y: 0.5 }
    }
  }), t.setCamera({
    x: n / 2,
    y: n / 2,
    z: Math.min(window.innerWidth / (r.w + n), window.innerHeight / (r.h + n), 0.8)
  });
}
const ah = N.forwardRef(
  function({
    className: e,
    label: n,
    icon: i,
    iconLeft: r,
    onComplete: s,
    onValueChange: o,
    onCancel: a,
    onFocus: c,
    onBlur: d,
    children: u,
    items: h
  }, g) {
    const p = Q(), f = ke(), [M, m] = N.useState(!1);
    N.useCallback(
      (D, j) => {
        m(!0), D.currentTarget, c == null || c(j);
      },
      [c, p.timers]
    );
    const y = N.useCallback(
      (D, j) => {
        const w = D.currentTarget.value;
        o == null || o(w, j);
      },
      [o]
    ), I = N.useCallback(
      (D, j) => {
        switch (D.key) {
          case "Enter": {
            D.currentTarget.blur(), Yt(D), s == null || s(D.currentTarget.value, j);
            break;
          }
          case "Escape": {
            D.currentTarget.blur(), Yt(D), a == null || a(D.currentTarget.value, j);
            break;
          }
        }
      },
      [s, a]
    );
    return N.useCallback(
      (D, j) => {
        m(!1);
        const w = D.currentTarget.value;
        d == null || d(w, j);
      },
      [d]
    ), /* @__PURE__ */ l.jsxs("div", { draggable: !1, className: "tlui-input__wrapper", children: [
      u,
      n && /* @__PURE__ */ l.jsx("label", { children: f(n) }),
      r && /* @__PURE__ */ l.jsx(Ui, { icon: r, className: "tlui-icon-left", small: !0 }),
      /* @__PURE__ */ l.jsx("div", { className: "tlui-input__multitext", children: h.map((D) => /* @__PURE__ */ l.jsxs("div", { className: ce("tlui-input__multitext_wrapper", D.label && ["start", "", void 0].includes(D.labelPosition) ? "multitext_label_start" : "multitext_label_end"), children: [
        D.label && ["start", "", void 0].includes(D.labelPosition) && /* @__PURE__ */ l.jsx("label", { children: f(D.label) }),
        /* @__PURE__ */ l.jsx(
          "input",
          {
            className: ce("tlui-input", e),
            type: "text",
            onKeyUp: (j) => I(j, D.id),
            onChange: (j) => {
              var w;
              (w = D.onChange) == null || w.call(D, j.target.value), y(j, D.id);
            },
            placeholder: D.placeholder,
            value: D.value
          }
        ),
        D.label && D.labelPosition == "end" && /* @__PURE__ */ l.jsx("label", { children: f(D.label) })
      ] }, D.id)) }),
      i && /* @__PURE__ */ l.jsx(Ui, { icon: i, small: !!n })
    ] });
  }
), Lue = Vt(function({ onClose: t }) {
  const e = Q(), n = Array.from(e.getCurrentPageShapes().filter(
    (p) => p.type === "grid"
  )), {
    width: i,
    height: r,
    rulerPixelUnits: s,
    defaultGridSize: o,
    rulerMeasurement: a,
    initialSettings: c,
    showRuler: d
  } = B2();
  let u = {
    x: 0,
    y: 0,
    w: i,
    h: r,
    gridSize: o,
    pixelToUnit: s,
    rulerMeasurement: a,
    showRuler: d
  };
  if (n.length > 0) {
    const p = n[0];
    u = {
      x: p.x,
      y: p.y,
      w: p.props.w,
      h: p.props.h,
      gridSize: p.props.gridSize ?? o,
      pixelToUnit: p.props.pixelToUnit ?? s,
      rulerMeasurement: p.props.rulerUnit ?? "m",
      showRuler: p.props.showRuler ?? d
    };
  }
  const [
    h,
    g
  ] = pe({
    width: u.w,
    height: u.h,
    rulerMeasurement: u.rulerMeasurement,
    rulerPixelUnits: u.pixelToUnit,
    defaultGridSize: u.gridSize,
    showRuler: u.showRuler
  });
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(Ed, { children: [
      /* @__PURE__ */ l.jsx(Cd, { children: "Settings" }),
      /* @__PURE__ */ l.jsx(zd, {})
    ] }),
    /* @__PURE__ */ l.jsxs(Ja, { className: "tlui-embed-dialog__enter grid-settings-display", children: [
      /* @__PURE__ */ l.jsx(
        ah,
        {
          className: "tlui-embed-dialog__input",
          label: "Width",
          items: [
            {
              label: h.rulerMeasurement,
              labelPosition: "end",
              id: "unit-width",
              value: (h.width / Zs(h.rulerPixelUnits, h.rulerMeasurement)).toString()
            },
            {
              label: "px",
              labelPosition: "end",
              id: "width",
              value: h.width.toString()
            }
          ],
          onValueChange: (p, f) => {
            switch (isNaN(parseFloat(p)) && (p = "1"), f) {
              case "unit-width":
                g(
                  {
                    ...h,
                    width: parseFloat(p) * Zs(h.rulerPixelUnits, h.rulerMeasurement)
                  }
                );
                break;
              case "width": {
                g(
                  {
                    ...h,
                    width: parseFloat(p)
                  }
                );
                break;
              }
            }
          }
        }
      ),
      /* @__PURE__ */ l.jsx(
        ah,
        {
          className: "tlui-embed-dialog__input",
          label: "Height",
          items: [
            {
              label: h.rulerMeasurement,
              labelPosition: "end",
              id: "unit-height",
              value: (h.height / Zs(h.rulerPixelUnits, h.rulerMeasurement)).toString()
            },
            {
              label: "px",
              labelPosition: "end",
              id: "height",
              value: h.height.toString()
            }
          ],
          onValueChange: (p, f) => {
            switch (isNaN(parseFloat(p)) && (p = "1"), f) {
              case "unit-height":
                g(
                  {
                    ...h,
                    height: parseFloat(p) * Zs(h.rulerPixelUnits, h.rulerMeasurement)
                  }
                );
                break;
              case "height": {
                g(
                  {
                    ...h,
                    height: parseFloat(p)
                  }
                );
                break;
              }
            }
          }
        }
      ),
      /* @__PURE__ */ l.jsx(
        ah,
        {
          className: "tlui-embed-dialog__input",
          label: "Grid Size",
          items: [
            {
              label: " ",
              labelPosition: "end",
              id: "grid-size",
              value: h.defaultGridSize.toString()
            }
          ],
          onValueChange: (p, f) => {
            isNaN(parseFloat(p)) && (p = "1"), g(
              {
                ...h,
                defaultGridSize: parseInt(p)
              }
            );
          }
        }
      ),
      /* @__PURE__ */ l.jsx(
        ah,
        {
          className: "tlui-embed-dialog__input",
          label: "Pixel to Unit",
          items: [
            {
              label: " ",
              labelPosition: "end",
              id: "pixe-to-unit",
              value: h.rulerPixelUnits.toString()
            }
          ],
          onValueChange: (p, f) => {
            isNaN(parseFloat(p)) && (p = "1"), g(
              {
                ...h,
                rulerPixelUnits: parseFloat(p)
              }
            );
          }
        }
      ),
      /* @__PURE__ */ l.jsx(
        g2,
        {
          label: "Unit Type",
          value: h.rulerMeasurement.toString(),
          items: [
            { label: "Meters", value: "m" },
            { label: "Feet", value: "ft" },
            { label: "Inches", value: "in" },
            { label: "Centimeters", value: "cm" },
            { label: "Millimeters", value: "mm" }
          ],
          onValueChange: (p) => {
            const f = Zs(1, h.rulerMeasurement == "ft" ? "m" : h.rulerMeasurement), M = Zs(1, p == "ft" ? "m" : p);
            g(
              {
                ...h,
                rulerPixelUnits: h.rulerPixelUnits * (f / M),
                rulerMeasurement: p
              }
            );
          }
        }
      ),
      /* @__PURE__ */ l.jsxs("div", { draggable: !1, className: "tlui-input__wrapper", children: [
        /* @__PURE__ */ l.jsx("label", { children: "Show Ruler" }),
        /* @__PURE__ */ l.jsx("div", { className: "", children: /* @__PURE__ */ l.jsx(
          q,
          {
            type: "normal",
            onClick: () => {
              g({
                ...h,
                showRuler: !h.showRuler
              });
            },
            children: /* @__PURE__ */ l.jsx("div", { style: {
              border: "1px solid rgba(58, 53, 65, 0.12)"
            }, children: /* @__PURE__ */ l.jsx(
              sd,
              {
                checked: h.showRuler
              }
            ) })
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ l.jsxs(Xp, { className: "tlui-dialog__footer__actions", children: [
      /* @__PURE__ */ l.jsx(q, { type: "normal", onClick: () => {
        g({
          width: c.width,
          height: c.height,
          rulerPixelUnits: c.rulerPixelUnits,
          rulerMeasurement: c.rulerMeasurement,
          defaultGridSize: c.defaultGridSize,
          showRuler: c.showRuler
        });
      }, children: /* @__PURE__ */ l.jsx(St, { children: "Defaults" }) }),
      /* @__PURE__ */ l.jsx("div", { className: "tlui-embed__spacer" }),
      /* @__PURE__ */ l.jsx(q, { type: "normal", onClick: t, children: /* @__PURE__ */ l.jsx(St, { children: "Cancel" }) }),
      /* @__PURE__ */ l.jsx(
        q,
        {
          type: "normal",
          onClick: () => {
            Fl(h);
            const p = Array.from(e.getCurrentPageShapes().filter(
              (M) => M.type === "grid"
            )), f = p.length > 0 ? p[0] : void 0;
            f && (e.updateShape({
              ...f,
              props: {
                ...f.props,
                gridSize: h.defaultGridSize,
                h: h.height,
                w: h.width,
                rulerUnit: h.rulerMeasurement,
                pixelToUnit: h.rulerPixelUnits,
                showRuler: h.showRuler
              }
            }), Fa(e)), t();
          },
          children: /* @__PURE__ */ l.jsx(St, { children: "Save" })
        }
      )
    ] })
  ] });
});
function G2() {
  const { addDialog: t, clearDialogs: e } = po(), n = Q(), [i, r] = pe(!1), { gridType: s, grid: o } = G(
    "grid type",
    () => {
      if (n == null) return;
      const d = n.getCurrentPageShapes().find((u) => u.type === "grid");
      return { gridType: (d == null ? void 0 : d.props.renderType) ?? "grid", grid: d };
    },
    [n]
  ), a = (c) => () => {
    o && n.updateShape({
      ...o,
      props: {
        ...o.props,
        renderType: c
      }
    });
  };
  return at(() => {
    const c = window.matchMedia("(max-width: 660px)");
    r(c.matches);
    const d = (u) => {
      r(u.matches);
    };
    return c.addEventListener("change", d), () => c.removeEventListener("change", d);
  }, []), n.getViewportScreenCenter(), /* @__PURE__ */ l.jsx(l.Fragment, { children: o && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(
      Gn,
      {
        id: "grid-selection",
        children: [
          /* @__PURE__ */ l.jsx(
            Hn,
            {
              side: "bottom",
              children: /* @__PURE__ */ l.jsx("div", { className: ce("tlui-toolbar", i ? "tlui-layout__mobile" : ""), children: /* @__PURE__ */ l.jsxs(
                "div",
                {
                  "aria-label": "style panel styles",
                  "data-testid": "style.panel",
                  className: "tlui-toolbar__tools tlui-toolbar__col",
                  children: [
                    /* @__PURE__ */ l.jsx(
                      q,
                      {
                        type: "tool",
                        "aria-checked": s === "grid",
                        onClick: a("grid"),
                        children: /* @__PURE__ */ l.jsx(an, { icon: "grid" })
                      }
                    ),
                    /* @__PURE__ */ l.jsx(
                      q,
                      {
                        type: "tool",
                        "aria-checked": s === "none",
                        onClick: a("none"),
                        children: /* @__PURE__ */ l.jsx(an, { icon: "grid-empty" })
                      }
                    )
                  ]
                }
              ) })
            }
          ),
          /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
            q,
            {
              type: "tool",
              children: /* @__PURE__ */ l.jsx(an, { icon: s === "none" ? "grid-empty" : "grid" })
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ l.jsx(
      q,
      {
        type: "tool",
        onClick: (c) => {
          c.preventDefault(), c.stopPropagation(), e(), t({ component: Lue });
        },
        onPointerDown: (c) => {
          c.preventDefault(), c.stopPropagation();
        },
        children: /* @__PURE__ */ l.jsx(an, { icon: "settings" })
      }
    )
  ] }) });
}
function kue() {
  return /* @__PURE__ */ l.jsx(
    Ar,
    {
      tool: "floor-planner"
    }
  );
}
function Oue() {
  const t = Nf(), e = t == null ? { value: "rectangle" } : t.get(Fn);
  return /* @__PURE__ */ l.jsx(
    Ar,
    {
      tool: t == null || !e || !e.value ? "rectangle" : e.value
    }
  );
}
const Pue = [
  /* @__PURE__ */ l.jsx(hde, {}),
  {
    label: "",
    items: [
      /* @__PURE__ */ l.jsx(gde, {}),
      /* @__PURE__ */ l.jsx(fde, {}),
      /* @__PURE__ */ l.jsx(Mde, {}),
      /* @__PURE__ */ l.jsx("div", { className: "tlui-button__tool_divider", children: /* @__PURE__ */ l.jsx(tr, {}) })
    ]
  },
  /* @__PURE__ */ l.jsx(pde, {}),
  /* @__PURE__ */ l.jsx(mde, {})
], Uue = () => {
  const t = _t();
  return t["form-sketch-save"].canSave ? /* @__PURE__ */ l.jsx(Qe, { ...t["form-sketch-save"] }) : null;
}, Rue = () => {
  const t = _t(), e = Df();
  return /* @__PURE__ */ l.jsx(Qe, { ...t.undo, disabled: !e });
}, Yue = () => {
  const t = _t(), e = jf();
  return /* @__PURE__ */ l.jsx(Qe, { ...t.redo, disabled: !e });
};
function W2() {
  const t = _t(), e = $t(1), n = Di(), i = e && n;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(Qe, { ...t["bring-to-front"], disabled: !i }),
    /* @__PURE__ */ l.jsx(Qe, { ...t["bring-forward"], disabled: !i }),
    /* @__PURE__ */ l.jsx(Qe, { ...t["send-backward"], disabled: !i }),
    /* @__PURE__ */ l.jsx(Qe, { ...t["send-to-back"], disabled: !i })
  ] });
}
function H2() {
  const t = $t(2), e = Di(), n = t && e;
  return /* @__PURE__ */ l.jsxs(Gn, { id: "wall-color-popover", children: [
    /* @__PURE__ */ l.jsx(Hn, { side: "bottom", children: /* @__PURE__ */ l.jsx("div", { style: { display: "flex" }, children: /* @__PURE__ */ l.jsx(Cj, {}) }) }),
    /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
      q,
      {
        type: "tool",
        "data-testid": "mobile-styles.button",
        title: "Align Content",
        disabled: !n,
        children: /* @__PURE__ */ l.jsx(
          Te,
          {
            icon: "align-left"
          }
        )
      }
    ) })
  ] });
}
function V2() {
  const t = _t(), e = vj(), n = Ej();
  return !e && !e && n ? null : /* @__PURE__ */ l.jsx(Qe, { disabled: !e, ...t.group });
}
function Que({
  showGridOptions: t = !0
}) {
  const e = _t(), [n, i] = pe(0), r = Q(), s = $t(1), o = G(
    "should display quick actions",
    () => r.isInAny("select", "hand", "zoom"),
    [r]
  ), a = Di(), c = s && a;
  return at(() => {
    const d = window.matchMedia("(min-width: 1251px) and (max-width: 1640px)"), u = window.matchMedia("(max-width: 1250px)"), h = {
      "false-false": 0,
      "true-false": 1,
      "false-true": 2
    }, g = () => (d.matches ? "true" : "false") + "-" + (u.matches ? "true" : "false");
    i(h[g()]);
    const p = (M) => {
      i(h[g()]);
    }, f = (M) => {
      i(h[g()]);
    };
    return d.addEventListener("change", p), u.addEventListener("change", f), () => {
      d.removeEventListener("change", p), u.removeEventListener("change", f);
    };
  }, []), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(tr, {}),
    /* @__PURE__ */ l.jsx(M2, {}),
    /* @__PURE__ */ l.jsx(m2, {}),
    /* @__PURE__ */ l.jsx(tr, {}),
    /* @__PURE__ */ l.jsx(Qe, { ...e.duplicate, disabled: !c && o }),
    /* @__PURE__ */ l.jsx(y2, {}),
    /* @__PURE__ */ l.jsx(tr, {}),
    !n && /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(ja, { variant: "subheader", children: "Align" }) }),
    n == 2 && /* @__PURE__ */ l.jsx(H2, {}),
    n != 2 && /* @__PURE__ */ l.jsx(Cj, {}),
    /* @__PURE__ */ l.jsx(tr, {}),
    !n && /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(ja, { variant: "subheader", children: "Arrange" }) }),
    n != 2 ? /* @__PURE__ */ l.jsx(W2, {}) : /* @__PURE__ */ l.jsx(K2, {}),
    /* @__PURE__ */ l.jsx(tr, {}),
    !n && /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(ja, { variant: "subheader", children: "Reflect" }) }),
    /* @__PURE__ */ l.jsxs(Ce, { id: "flip", children: [
      /* @__PURE__ */ l.jsx(Qe, { icon: "flip-horizontal", ...e["flip-horizontal"], disabled: !s }),
      /* @__PURE__ */ l.jsx(Qe, { icon: "flip-vertical", ...e["flip-vertical"], disabled: !s })
    ] }),
    /* @__PURE__ */ l.jsx(tr, {}),
    !n && /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(ja, { variant: "subheader", children: "Group" }) }),
    /* @__PURE__ */ l.jsx(V2, {}),
    /* @__PURE__ */ l.jsx(wf, {}),
    /* @__PURE__ */ l.jsx(tr, {}),
    t && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      !n && /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(ja, { variant: "subheader", children: "Grid" }) }),
      /* @__PURE__ */ l.jsx(G2, {}),
      /* @__PURE__ */ l.jsx(tr, {})
    ] })
  ] });
}
function K2() {
  const t = $t(1), e = Di(), n = t && e;
  return /* @__PURE__ */ l.jsxs(Gn, { id: "arrange-popover", children: [
    /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
      q,
      {
        type: "tool",
        "data-testid": "mobile-styles.button",
        title: "Arrange",
        disabled: !n,
        children: /* @__PURE__ */ l.jsx(
          Te,
          {
            icon: "bring-to-front"
          }
        )
      }
    ) }),
    /* @__PURE__ */ l.jsx(Hn, { side: "bottom", children: /* @__PURE__ */ l.jsx("div", { style: { display: "flex" }, children: /* @__PURE__ */ l.jsx(W2, {}) }) })
  ] });
}
function Zue({
  showGridOptions: t = !0
}) {
  const e = _t(), n = Q(), i = $t(1), r = G(
    "should display quick actions",
    () => n.isInAny("select", "hand", "zoom"),
    [n]
  ), s = Di(), o = i && s;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(M2, {}),
    /* @__PURE__ */ l.jsx(m2, {}),
    /* @__PURE__ */ l.jsx(Qe, { ...e.duplicate, disabled: !o && r }),
    /* @__PURE__ */ l.jsx(y2, {}),
    /* @__PURE__ */ l.jsx(H2, {}),
    /* @__PURE__ */ l.jsx(K2, {}),
    /* @__PURE__ */ l.jsxs(Ce, { id: "flip", children: [
      /* @__PURE__ */ l.jsx(Qe, { icon: "flip-horizontal", ...e["flip-horizontal"], disabled: !i }),
      /* @__PURE__ */ l.jsx(Qe, { icon: "flip-vertical", ...e["flip-vertical"], disabled: !i })
    ] }),
    /* @__PURE__ */ l.jsx(V2, {}),
    /* @__PURE__ */ l.jsx(wf, {}),
    t && /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(G2, {}) })
  ] });
}
function IA({
  isMobile: t = !1,
  showGridOptions: e = !0
}) {
  return t ? /* @__PURE__ */ l.jsx(Zue, { showGridOptions: e }) : /* @__PURE__ */ l.jsx(Que, { showGridOptions: e });
}
function Fue({}) {
  const t = Q(), {
    legendIconRef: e
  } = bf(), n = G(
    "isInFloorPlanner",
    () => t.isInAny("floor-planner"),
    [t.isInAny("floor-planner"), t.isIn("floor-planner")]
  );
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    n && Pue.map(
      (i, r) => /* @__PURE__ */ l.jsx("div", { children: typeof i == "object" && i.items ? /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsxs("div", { className: "toolbar-item-description", children: [
        (i == null ? void 0 : i.label) && /* @__PURE__ */ l.jsx("label", { children: i.label }),
        /* @__PURE__ */ l.jsx("div", { className: "toolbar-item-grouped", children: i.items.map((s, o) => /* @__PURE__ */ l.jsx("div", { children: s }, `floor-planner-${r}-${o}`)) })
      ] }) }) : i }, `floor-planner-${r}`)
    ),
    !n && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(ude, {}),
      /* @__PURE__ */ l.jsx(Ide, {}),
      /* @__PURE__ */ l.jsx(Oue, {}),
      /* @__PURE__ */ l.jsx(xde, {}),
      /* @__PURE__ */ l.jsx(yde, {}),
      /* @__PURE__ */ l.jsx(
        Ar,
        {
          tool: "text"
        }
      ),
      /* @__PURE__ */ l.jsx(dde, {}),
      /* @__PURE__ */ l.jsx(lde, {}),
      /* @__PURE__ */ l.jsx(kue, {}),
      /* @__PURE__ */ l.jsx(i2, {})
    ] })
  ] });
}
function Bue({
  label: t,
  uiTypeA: e,
  uiTypeB: n,
  labelA: i,
  labelB: r,
  itemsA: s,
  itemsB: o,
  styleA: a,
  styleB: c,
  valueA: d,
  valueB: u,
  onValueChange: h,
  side: g = "top"
}) {
  const p = ke(), f = N.useMemo(
    () => {
      var m;
      return ((m = s.find((y) => d.type === "shared" && d.value === y.value)) == null ? void 0 : m.icon) ?? "mixed";
    },
    [s, d]
  ), M = N.useMemo(
    () => {
      var m;
      return ((m = o.find((y) => u.type === "shared" && u.value === y.value)) == null ? void 0 : m.icon) ?? "mixed";
    },
    [o, u]
  );
  return d === void 0 && u === void 0 ? null : /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__double-select-picker", children: [
    /* @__PURE__ */ l.jsx("div", { title: p(t), className: "tlui-style-panel__double-select-picker-label", children: p(t) }),
    /* @__PURE__ */ l.jsxs("div", { className: "tlui-buttons__horizontal", children: [
      /* @__PURE__ */ l.jsxs(mr, { id: `style panel ${e} A`, children: [
        /* @__PURE__ */ l.jsx(yr, { children: /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            "data-testid": `style.${e}`,
            title: p(i) + " — " + (d === null || d.type === "mixed" ? p("style-panel.mixed") : p(`${e}-style.${d.value}`)),
            children: /* @__PURE__ */ l.jsx(Te, { icon: f, small: !0, invertIcon: !0 })
          }
        ) }),
        /* @__PURE__ */ l.jsx(Ir, { side: g, align: "center", alignOffset: 0, children: /* @__PURE__ */ l.jsx("div", { className: "tlui-buttons__grid tlui-popover__content", children: s.map((m, y) => /* @__PURE__ */ l.jsx(ro, { "data-testid": `style.${e}.${m.value}`, children: /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            onClick: () => h(a, m.value),
            title: `${p(i)} — ${p(`${e}-style.${m.value}`)}`,
            children: /* @__PURE__ */ l.jsx(Te, { icon: m.icon, invertIcon: !0 })
          },
          m.value
        ) }, y)) }) })
      ] }),
      /* @__PURE__ */ l.jsxs(mr, { id: `style panel ${n}`, children: [
        /* @__PURE__ */ l.jsx(yr, { children: /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            "data-testid": `style.${n}`,
            title: p(r) + " — " + (u === null || u.type === "mixed" ? p("style-panel.mixed") : p(`${n}-style.${u.value}`)),
            children: /* @__PURE__ */ l.jsx(Te, { icon: M, small: !0 })
          }
        ) }),
        /* @__PURE__ */ l.jsx(Ir, { side: g, align: "center", alignOffset: 0, children: /* @__PURE__ */ l.jsx("div", { className: "tlui-buttons__grid tlui-popover__content", children: o.map((m) => /* @__PURE__ */ l.jsx(ro, { children: /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            title: `${p(r)} — ${p(`${n}-style.${m.value}`)}`,
            "data-testid": `style.${n}.${m.value}`,
            onClick: () => h(c, m.value),
            children: /* @__PURE__ */ l.jsx(Te, { icon: m.icon })
          }
        ) }, m.value)) }) })
      ] })
    ] })
  ] });
}
const Gue = N.memo(
  Bue
);
function Wue({
  id: t,
  label: e,
  uiType: n,
  style: i,
  items: r,
  type: s,
  value: o,
  onValueChange: a,
  side: c = "top"
}) {
  const d = ke(), u = Q(), h = N.useMemo(
    () => {
      var f;
      return (f = r.find((M) => o.type === "shared" && M.value === o.value)) == null ? void 0 : f.icon;
    },
    [r, o]
  ), g = o.type === "mixed" ? d("style-panel.mixed") : d(`${n}-style.${o.value}`), p = e ? d(e) : "";
  return /* @__PURE__ */ l.jsxs(mr, { id: `style panel ${t}`, children: [
    /* @__PURE__ */ l.jsx(yr, { children: /* @__PURE__ */ l.jsxs(q, { type: s, "data-testid": `style.${n}`, title: g, children: [
      p && /* @__PURE__ */ l.jsx(St, { children: p }),
      /* @__PURE__ */ l.jsx(Te, { icon: h ?? "mixed" })
    ] }) }),
    /* @__PURE__ */ l.jsx(Ir, { side: c, align: "center", alignOffset: 0, children: /* @__PURE__ */ l.jsx("div", { className: "tlui-buttons__grid tlui-popover__content", children: r.map((f) => /* @__PURE__ */ l.jsx(ro, { children: /* @__PURE__ */ l.jsx(
      q,
      {
        type: "icon",
        "data-testid": `style.${n}.${f.value}`,
        title: d(`${n}-style.${f.value}`),
        onClick: () => {
          u == null || u.markHistory("select style dropdown item"), a(i, f.value);
        },
        children: /* @__PURE__ */ l.jsx(Te, { icon: f.icon })
      }
    ) }, f.value)) }) })
  ] });
}
const Bj = N.memo(Wue);
function X2() {
  const t = Q();
  return G("selected tool", () => {
    var e;
    return {
      toolId: t.getCurrentToolId(),
      stateId: (e = t.getCurrentTool().getCurrent()) == null ? void 0 : e.id
    };
  }, [t]);
}
const rr = xt(
  "active handle",
  {
    shapeId: null,
    handleId: null
  }
), J2 = xt(
  "editor atom",
  null
), Wo = xt(
  "floor planner - wall properties",
  {
    thickness: "external",
    color: "black"
  }
), Gj = () => Wo.get(), Hue = () => G("door-thickness", () => Wo.get(), [Wo]), Wj = (t) => {
  Wo.set({
    ...Wo.get(),
    color: t
  });
}, ch = () => {
  const t = J2.get();
  if (t) {
    const e = Gj(), n = rr.get();
    if (!n || !n.handleId || !n.shapeId) return;
    const i = t.getShape(n.shapeId);
    if (!i) return;
    t.updateShape({
      ...i,
      props: {
        ...i.props,
        points: {
          ...i.props.points,
          [n.handleId]: {
            ...i.props.points[n.handleId],
            ...e
          }
        }
      }
    });
  }
}, Bl = (t) => {
  Wo.set({
    ...Wo.get(),
    thickness: t
  });
};
function Vue({
  theme: t
}) {
  Q();
  const e = B2(), n = () => {
    Fl({
      showRuler: !e.showRuler
    });
  };
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      q,
      {
        type: "tool",
        "data-testid": "mobile-styles.button",
        title: "Wall Tool - Show Ruler",
        "aria-checked": e.showRuler,
        onClick: () => {
          n();
        },
        children: /* @__PURE__ */ l.jsx(
          an,
          {
            icon: "ruler"
          }
        )
      }
    ),
    /* @__PURE__ */ l.jsxs(
      q,
      {
        type: "tool",
        "data-testid": "mobile-styles.button",
        title: "Wall Tool - Meters",
        "aria-checked": e.rulerMeasurement === "m",
        onClick: () => {
          Fl({
            rulerMeasurement: "m"
          });
        },
        children: [
          "m",
          /* @__PURE__ */ l.jsx(
            "div",
            {
              className: "tlui-icon__backdrop"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ l.jsxs(
      q,
      {
        type: "tool",
        "data-testid": "mobile-styles.button",
        title: "Wall Tool - Feet",
        "aria-checked": e.rulerMeasurement == "ft",
        onClick: () => {
          Fl({
            rulerMeasurement: "ft"
          });
        },
        children: [
          "ft",
          /* @__PURE__ */ l.jsx(
            "div",
            {
              className: "tlui-icon__backdrop"
            }
          )
        ]
      }
    )
  ] });
}
function Kue({
  theme: t
}) {
  const e = Hue();
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      q,
      {
        type: "tool",
        "data-testid": "mobile-styles.button",
        title: "Wall Tool - Wall Thickness",
        "aria-checked": e.thickness === "external",
        onClick: () => {
          Bl("external"), ch();
        },
        children: /* @__PURE__ */ l.jsx(
          an,
          {
            icon: "wall-external"
          }
        )
      }
    ),
    /* @__PURE__ */ l.jsx(
      q,
      {
        type: "tool",
        "data-testid": "mobile-styles.button",
        title: "Wall Tool - Wall Thickness",
        "aria-checked": e.thickness === "internal",
        onClick: () => {
          Bl("internal"), ch();
        },
        children: /* @__PURE__ */ l.jsx(
          an,
          {
            icon: "wall-internal"
          }
        )
      }
    ),
    /* @__PURE__ */ l.jsx(
      q,
      {
        type: "tool",
        "data-testid": "mobile-styles.button",
        title: "Wall Tool - Wall Thickness",
        "aria-checked": e.thickness === "partition",
        onClick: () => {
          Bl("partition"), ch();
        },
        children: /* @__PURE__ */ l.jsx(
          an,
          {
            icon: "wall-partition"
          }
        )
      }
    ),
    /* @__PURE__ */ l.jsx("div", { className: "tlui-button__tool_divider", children: /* @__PURE__ */ l.jsx(tr, {}) }),
    /* @__PURE__ */ l.jsxs(
      Gn,
      {
        id: "wall-color-popover",
        children: [
          /* @__PURE__ */ l.jsx(
            Hn,
            {
              side: "top",
              children: /* @__PURE__ */ l.jsx(
                Bn,
                {
                  title: "Color",
                  uiType: "color",
                  style: Ln,
                  items: ut.color,
                  value: { type: "shared", value: e.color },
                  onValueChange: (n, i) => {
                    Wj(i), ch();
                  },
                  theme: t
                }
              )
            }
          ),
          /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
            q,
            {
              type: "tool",
              style: { color: "black" },
              "data-testid": "mobile-styles.button",
              title: "Wall Tool - Colour Picker",
              children: /* @__PURE__ */ l.jsx(
                an,
                {
                  icon: "colour-palette"
                }
              )
            }
          ) })
        ]
      }
    )
  ] });
}
function Xue({
  theme: t
}) {
  const e = X2();
  return e.toolId !== "floor-planner" ? null : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    e.stateId == "wall-tool" && /* @__PURE__ */ l.jsx(Kue, { theme: t }),
    e.stateId == "ruler-tool" && /* @__PURE__ */ l.jsx(Vue, { theme: t })
  ] });
}
function Jue({ styles: t }) {
  const e = Tc(), n = ke(), i = Hr({ isDarkMode: e }), r = Oc(), s = X2(), [o, a] = Ye.useState(!1);
  if (!(t || s.toolId == "floor-planner")) return null;
  const c = t ? t.get(Ln) : void 0, d = t ? t.get(Fn) : void 0, u = t ? t.get($s) : void 0, h = t ? t.get(Uo) : void 0, g = t ? t.get(Ro) : void 0, p = t ? t.get(ki) : void 0, f = d === void 0, M = u === void 0 && h === void 0, m = g === void 0, y = p === void 0;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    t && /* @__PURE__ */ l.jsx(que, { theme: i, styles: t }),
    !y && /* @__PURE__ */ l.jsx(_ue, { theme: i, styles: t }),
    !(f && M && m) && /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__section", "aria-label": "style panel styles", children: [
      /* @__PURE__ */ l.jsx($ue, { styles: t }),
      /* @__PURE__ */ l.jsx(the, { styles: t }),
      /* @__PURE__ */ l.jsx(ehe, { styles: t })
    ] }),
    /* @__PURE__ */ l.jsx(Xue, { theme: i }),
    /* @__PURE__ */ l.jsx(
      "div",
      {
        tabIndex: -1,
        className: "",
        "aria-label": "style panel styles",
        "data-testid": "style.panel",
        children: c === void 0 && c === void 0 && !o ? null : /* @__PURE__ */ l.jsxs(
          Gn,
          {
            id: "color-popover",
            children: [
              /* @__PURE__ */ l.jsxs(
                Hn,
                {
                  side: "top",
                  children: [
                    /* @__PURE__ */ l.jsx(
                      Bn,
                      {
                        title: n("style-panel.color"),
                        uiType: "color",
                        style: Ln,
                        items: ut.color,
                        value: c ?? { type: "shared", value: "black" },
                        onValueChange: r,
                        theme: i
                      }
                    ),
                    /* @__PURE__ */ l.jsxs(
                      "div",
                      {
                        style: { minWidth: "150px" },
                        className: "",
                        "aria-label": "style panel styles",
                        "data-testid": "style.panel",
                        children: [
                          /* @__PURE__ */ l.jsx(ja, { variant: "header", children: "Opacity" }),
                          /* @__PURE__ */ l.jsx(nhe, {})
                        ]
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
                q,
                {
                  type: "tool",
                  style: { color: (c == null ? void 0 : c.value) ?? "black" },
                  "data-testid": "mobile-styles.button",
                  title: "Color",
                  children: /* @__PURE__ */ l.jsx(
                    an,
                    {
                      icon: "colour-palette"
                    }
                  )
                }
              ) })
            ]
          }
        )
      }
    )
  ] });
}
function Oc() {
  const t = Q(), e = Zt();
  return Ye.useMemo(
    () => function(i, r) {
      t.batch(() => {
        t.isIn("select") && t.setStyleForSelectedShapes(i, r), t.setStyleForNextShapes(i, r), t.updateInstanceState({ isChangingStyle: !0 });
      }), e("set-style", { source: "style-panel", id: i.id, value: r });
    },
    [t, e]
  );
}
function que({ styles: t, theme: e }) {
  var d, u, h;
  const n = ke(), i = Q(), r = Oc(), s = t.get(ms), o = t.get(Ms), a = t.get(Oi), c = s !== void 0 || o !== void 0 || a !== void 0;
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: c && /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__section", "aria-label": "style panel styles", children: [
    s === void 0 ? null : /* @__PURE__ */ l.jsxs(
      Gn,
      {
        id: "fill-popover",
        children: [
          /* @__PURE__ */ l.jsx(
            Hn,
            {
              side: "top",
              children: /* @__PURE__ */ l.jsx(
                Bn,
                {
                  title: n("style-panel.fill"),
                  uiType: "fill",
                  style: ms,
                  items: ut.fill,
                  value: s,
                  onValueChange: r,
                  theme: e
                }
              )
            }
          ),
          /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
            q,
            {
              type: "tool",
              "data-testid": "mobile-styles.button",
              title: "Fill Style",
              children: /* @__PURE__ */ l.jsx(
                an,
                {
                  icon: (d = ut.fill.find((g) => g.value == (s == null ? void 0 : s.value))) == null ? void 0 : d.icon
                }
              )
            }
          ) })
        ]
      }
    ),
    o === void 0 ? null : /* @__PURE__ */ l.jsxs(
      Gn,
      {
        id: "dash-popover",
        children: [
          /* @__PURE__ */ l.jsx(
            Hn,
            {
              side: "top",
              children: /* @__PURE__ */ l.jsx(
                Bn,
                {
                  title: n("style-panel.dash"),
                  uiType: "dash",
                  style: Ms,
                  items: ut.dash,
                  value: o,
                  onValueChange: r,
                  theme: e
                }
              )
            }
          ),
          /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
            q,
            {
              type: "tool",
              "data-testid": "mobile-styles.button",
              title: "Line Style",
              children: /* @__PURE__ */ l.jsx(
                an,
                {
                  icon: (u = ut.dash.find((g) => g.value == o.value)) == null ? void 0 : u.icon
                }
              )
            }
          ) })
        ]
      }
    ),
    a === void 0 ? null : /* @__PURE__ */ l.jsxs(
      Gn,
      {
        id: "size-popover",
        children: [
          /* @__PURE__ */ l.jsx(
            Hn,
            {
              side: "top",
              children: /* @__PURE__ */ l.jsx(
                Bn,
                {
                  title: n("style-panel.size"),
                  uiType: "size",
                  style: Oi,
                  items: ut.size,
                  value: a,
                  onValueChange: (g, p) => {
                    r(g, p);
                    const f = i.getSelectedShapeIds();
                    f.length > 0 && It(i, f);
                  },
                  theme: e
                }
              )
            }
          ),
          /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
            q,
            {
              type: "tool",
              "data-testid": "mobile-styles.button",
              title: n("style-panel.size"),
              children: /* @__PURE__ */ l.jsx(
                an,
                {
                  icon: (h = ut.size.find((g) => g.value == (a == null ? void 0 : a.value))) == null ? void 0 : h.icon
                }
              )
            }
          ) })
        ]
      }
    )
  ] }) });
}
function _ue({ theme: t, styles: e }) {
  var c, d;
  const n = ke(), i = Oc(), r = e.get(ki), s = e.get(Xl), o = e.get(Ka), a = e.get(Xa);
  return r === void 0 && o === void 0 ? null : /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__section", "aria-label": "style panel text", children: [
    r === void 0 ? null : /* @__PURE__ */ l.jsxs(
      Gn,
      {
        id: "font-popover",
        children: [
          /* @__PURE__ */ l.jsx(
            Hn,
            {
              side: "top",
              children: /* @__PURE__ */ l.jsx(
                Bn,
                {
                  title: n("style-panel.font"),
                  uiType: "font",
                  style: ki,
                  items: ut.font,
                  value: r,
                  onValueChange: i,
                  theme: t
                }
              )
            }
          ),
          /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
            q,
            {
              type: "tool",
              "data-testid": "mobile-styles.button",
              title: n("style-panel.title"),
              children: /* @__PURE__ */ l.jsx(
                an,
                {
                  icon: (c = ut.font.find((u) => u.value == (r == null ? void 0 : r.value))) == null ? void 0 : c.icon
                }
              )
            }
          ) })
        ]
      }
    ),
    s === void 0 ? null : /* @__PURE__ */ l.jsxs(
      Gn,
      {
        id: "text-align-popover",
        children: [
          /* @__PURE__ */ l.jsx(
            Hn,
            {
              side: "top",
              children: /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__row", children: [
                /* @__PURE__ */ l.jsx(
                  Bn,
                  {
                    title: n("style-panel.align"),
                    uiType: "align",
                    style: Xl,
                    items: ut.textAlign,
                    value: s,
                    onValueChange: i,
                    theme: t
                  }
                ),
                /* @__PURE__ */ l.jsx("div", { className: "tlui-style-panel__row__extra-button", children: /* @__PURE__ */ l.jsx(
                  q,
                  {
                    type: "icon",
                    title: n("style-panel.vertical-align"),
                    "data-testid": "vertical-align",
                    disabled: !0,
                    children: /* @__PURE__ */ l.jsx(an, { icon: "vertical-align-middle" })
                  }
                ) })
              ] })
            }
          ),
          /* @__PURE__ */ l.jsx(Wn, { children: /* @__PURE__ */ l.jsx(
            q,
            {
              type: "tool",
              "data-testid": "mobile-styles.button",
              title: n("style-panel.title"),
              children: /* @__PURE__ */ l.jsx(
                an,
                {
                  icon: (d = ut.textAlign.find((u) => u.value == (s == null ? void 0 : s.value))) == null ? void 0 : d.icon
                }
              )
            }
          ) })
        ]
      }
    ),
    o === void 0 ? null : /* @__PURE__ */ l.jsxs("div", { className: "tlui-style-panel__row", children: [
      /* @__PURE__ */ l.jsx(
        Bn,
        {
          title: n("style-panel.align"),
          uiType: "align",
          style: Ka,
          items: ut.horizontalAlign,
          value: o,
          onValueChange: i,
          theme: t
        }
      ),
      /* @__PURE__ */ l.jsx("div", { className: "tlui-style-panel__row__extra-button", children: a === void 0 ? /* @__PURE__ */ l.jsx(
        q,
        {
          type: "icon",
          title: n("style-panel.vertical-align"),
          "data-testid": "vertical-align",
          disabled: !0,
          children: /* @__PURE__ */ l.jsx(an, { icon: "vertical-align-middle" })
        }
      ) : /* @__PURE__ */ l.jsx(
        Bj,
        {
          type: "icon",
          id: "geo-vertical-alignment",
          uiType: "verticalAlign",
          style: Xa,
          items: ut.verticalAlign,
          value: a,
          onValueChange: i
        }
      ) })
    ] })
  ] });
}
function $ue({ styles: t }) {
  const e = Oc(), n = t.get(Fn);
  return n === void 0 ? null : /* @__PURE__ */ l.jsx(
    Bj,
    {
      id: "geo",
      type: "menu",
      label: "style-panel.geo",
      uiType: "geo",
      style: Fn,
      items: ut.geo,
      value: n,
      onValueChange: e
    }
  );
}
function ehe({ styles: t }) {
  const e = Oc(), n = t.get(Ro);
  return n === void 0 ? null : /* @__PURE__ */ l.jsx(
    Bj,
    {
      id: "spline",
      type: "menu",
      label: "style-panel.spline",
      uiType: "spline",
      style: Ro,
      items: ut.spline,
      value: n,
      onValueChange: e
    }
  );
}
function the({ styles: t }) {
  const e = Oc(), n = t.get($s), i = t.get(Uo);
  return !n || !i ? null : /* @__PURE__ */ l.jsx(
    Gue,
    {
      label: "style-panel.arrowheads",
      uiTypeA: "arrowheadStart",
      styleA: Uo,
      itemsA: ut.arrowheadStart,
      valueA: i,
      uiTypeB: "arrowheadEnd",
      styleB: $s,
      itemsB: ut.arrowheadEnd,
      valueB: n,
      onValueChange: e,
      labelA: "style-panel.arrowhead-start",
      labelB: "style-panel.arrowhead-end"
    }
  );
}
const fl = [0.1, 0.25, 0.5, 0.75, 1];
function nhe() {
  const t = Q(), e = G("opacity", () => t.getSharedOpacity(), [t]), n = Zt();
  ke();
  const i = re((o) => t.markHistoryStoppingPoint(o), [t]), r = Ye.useCallback(
    (o) => {
      const a = fl[o];
      t.batch(() => {
        t.isIn("select") && t.setOpacityForSelectedShapes(a), t.setOpacityForNextShapes(a), t.updateInstanceState({ isChangingStyle: !0 });
      }), n("set-style", { source: "style-panel", id: "opacity", value: o });
    },
    [t, n]
  );
  if (e === void 0) return null;
  const s = e.type === "mixed" ? -1 : fl.indexOf(
    ihe(
      fl,
      (o) => Math.abs(o - e.value)
    )
  );
  return /* @__PURE__ */ l.jsx(
    n2,
    {
      onHistoryMark: i,
      "data-testid": "style.opacity",
      value: s >= 0 ? s : fl.length - 1,
      label: e.type === "mixed" ? "style-panel.mixed" : `opacity-style.${e.value}`,
      onValueChange: r,
      steps: fl.length - 1,
      title: "style-panel.opacity"
    }
  );
}
function ihe(t, e) {
  let n, i = 1 / 0;
  for (const r of t) {
    const s = e(r);
    s < i && (n = r, i = s);
  }
  return n;
}
const rhe = () => {
  const { stylePanelRef: t } = bf(), e = Nf();
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsxs("div", { className: "tlui-toolbar", children: [
    /* @__PURE__ */ l.jsx("div", { className: "tlui-toolbar__extras" }),
    /* @__PURE__ */ l.jsx("div", { className: "tlui-toolbar__tools", role: "radiogroup", children: /* @__PURE__ */ l.jsx("div", { id: "_ra__main", className: "tlui-toolbar__tools__list", children: /* @__PURE__ */ l.jsx(Jue, { styles: e }) }) })
  ] }) });
}, she = function({
  name: e,
  id: n,
  isCurrentPage: i
}) {
  const r = Q(), s = Zt(), o = le(null), a = re(() => {
    r.markHistory("rename page");
  }, [r]), c = re(
    (d) => {
      r.renamePage(n, d || "New Page"), s("rename-page", { source: "page-menu" });
    },
    [r, n, s]
  );
  return /* @__PURE__ */ l.jsx(
    Ld,
    {
      className: "tlui-page-menu__item__input",
      ref: (d) => o.current = d,
      defaultValue: e,
      onValueChange: c,
      onFocus: a,
      shouldManuallyMaintainScrollPositionWhenFocused: !0
    }
  );
}, ohe = Vt(function({
  index: e,
  listSize: n,
  item: i,
  onRename: r,
  canDuplicate: s = !0
}) {
  const o = Q(), a = ke(), c = o.getPages(), d = Zt(), u = re(() => {
    o.markHistoryStoppingPoint("creating page");
    const f = kn.createId();
    o.duplicatePage(i.id, f), d("duplicate-page", { source: "page-menu" });
  }, [o, i, d]), h = re(() => {
    xA(o, i.id, e, e - 1, d);
  }, [o, i, e, d]), g = re(() => {
    xA(o, i.id, e, e + 1, d);
  }, [o, i, e, d]), p = re(() => {
    o.markHistoryStoppingPoint("deleting page"), o.deletePage(i.id), d("delete-page", { source: "page-menu" });
  }, [o, i, d]);
  return /* @__PURE__ */ l.jsxs(mr, { id: `page item submenu ${e}`, children: [
    /* @__PURE__ */ l.jsx(yr, { children: /* @__PURE__ */ l.jsx(q, { type: "icon", title: a("page-menu.submenu.title"), children: /* @__PURE__ */ l.jsx(Te, { icon: "dots-vertical" }) }) }),
    /* @__PURE__ */ l.jsx(Ir, { alignOffset: 0, side: "right", sideOffset: -4, children: /* @__PURE__ */ l.jsxs(yn, { type: "menu", sourceId: "page-menu", children: [
      /* @__PURE__ */ l.jsxs(Ce, { id: "modify", children: [
        r && /* @__PURE__ */ l.jsx(Qe, { id: "rename", label: "page-menu.submenu.rename", onSelect: r }),
        s && /* @__PURE__ */ l.jsx(
          Qe,
          {
            id: "duplicate",
            label: "page-menu.submenu.duplicate-page",
            onSelect: u,
            disabled: c.length >= o.options.maxPages
          }
        ),
        e > 0 && /* @__PURE__ */ l.jsx(
          Qe,
          {
            id: "move-up",
            onSelect: h,
            label: "page-menu.submenu.move-up"
          }
        ),
        e < n - 1 && /* @__PURE__ */ l.jsx(
          Qe,
          {
            id: "move-down",
            label: "page-menu.submenu.move-down",
            onSelect: g
          }
        )
      ] }),
      n > 1 && /* @__PURE__ */ l.jsx(Ce, { id: "delete", children: /* @__PURE__ */ l.jsx(Qe, { id: "delete", onSelect: p, label: "page-menu.submenu.delete" }) })
    ] }) })
  ] });
}), xA = (t, e, n, i, r) => {
  let s;
  const o = t.getPages(), a = n > i ? o[i - 1] : o[i], c = n > i ? o[i] : o[i + 1];
  a && !c ? s = hi(a.index) : !a && c ? s = uT(o[0].index) : s = ko(a.index, c.index), s !== o[n].index && (t.markHistoryStoppingPoint("moving page"), t.updatePage({
    id: e,
    index: s
  }), r("move-page", { source: "page-menu" }));
}, ahe = _e(function({
  canDuplicate: e = !0,
  canCreatePage: n = !0
}) {
  const i = Q(), r = Zt(), s = ke(), o = le(null), a = Un(), [c, d] = pe("260px"), u = re(() => b(!1), []), [h, g] = Nr("page-menu", u), p = re((R) => {
    if (!o.current) return !1;
    d(`${o.current.clientWidth}px`), g(R);
  }, [o.current, g]), f = 36, M = le(null), m = G("pages", () => i.getPages(), [i]), y = G("currentPage", () => i.getCurrentPage(), [i]), I = G("currentPageId", () => i.getCurrentPageId(), [i]), D = !1, j = G(
    "maxPageCountReached",
    () => i.getPages().length >= i.options.maxPages,
    [i]
  ), w = G(
    "isCoarsePointer",
    () => i.getInstanceState().isCoarsePointer,
    [i]
  ), [A, b] = pe(!0), T = re(() => {
    b((R) => !R);
  }, [D]), E = le({
    isPointing: !1,
    status: "idle",
    pointing: null,
    startY: 0,
    startIndex: 0,
    dragIndex: 0
  }), [v, P] = pe(
    Object.fromEntries(
      m.map((R, U) => [R.id, { y: U * f, offsetY: 0, isSelected: !1 }])
    )
  );
  at(() => {
    P(
      Object.fromEntries(
        m.map((R, U) => [R.id, { y: U * f, offsetY: 0, isSelected: !1 }])
      )
    );
  }, [f, m]), ze(() => {
    h && i.timers.requestAnimationFrame(() => {
      const R = document.querySelector(
        `[data-testid="page-menu-item-${I}"]`
      );
      if (R) {
        const U = M.current;
        if (!U) return;
        const F = R.offsetTop, H = U.scrollTop;
        F < H && U.scrollTo({ top: F });
        const Z = F + f, te = U.scrollTop + U.offsetHeight;
        Z > te && U.scrollTo({ top: Z - U.offsetHeight });
      }
    });
  }, [f, I, h, i]), re(
    (R) => {
      const { clientY: U, currentTarget: F } = R, {
        dataset: { id: H, index: Z }
      } = F;
      if (!H || !Z) return;
      const te = E.current;
      jc(R.currentTarget, R), te.status = "pointing", te.pointing = { id: H, index: +Z };
      const me = v[H].y;
      te.startY = U, te.startIndex = Math.max(0, Math.min(Math.round(me / f), m.length - 1));
    },
    [f, m.length, v]
  ), re(
    (R) => {
      const U = E.current;
      if (U.status === "pointing") {
        const { clientY: F } = R, H = F - U.startY;
        Math.abs(H) > 5 && (U.status = "dragging");
      }
      if (U.status === "dragging") {
        const { clientY: F } = R, H = F - U.startY, Z = v[U.pointing.id], { startIndex: te, pointing: oe } = U, me = Z.y + H, he = Math.max(0, Math.min(Math.round(me / f), m.length - 1)), ve = { ...v };
        if (ve[oe.id] = {
          y: Z.y,
          offsetY: H,
          isSelected: !0
        }, he !== U.dragIndex) {
          U.dragIndex = he;
          for (let ie = 0; ie < m.length; ie++) {
            const Ue = m[ie];
            if (Ue.id === U.pointing.id)
              continue;
            let { y: ge } = ve[Ue.id];
            he === te ? ge = ie * f : he < te ? he <= ie && ie < te ? ge = (ie + 1) * f : ge = ie * f : he > te && (he >= ie && ie > te ? ge = (ie - 1) * f : ge = ie * f), ge !== ve[Ue.id].y && (ve[Ue.id] = { y: ge, offsetY: 0, isSelected: !0 });
          }
        }
        P(ve);
      }
    },
    [f, m, v]
  ), re(
    (R) => {
      const U = E.current;
      if (U.status === "dragging") {
        const { id: F, index: H } = U.pointing;
        onMovePage(i, F, H, U.dragIndex, r);
      }
      Dc(R.currentTarget, R), U.status = "idle";
    },
    [i, r]
  ), re(
    (R) => {
      const U = E.current;
      R.key === "Escape" && (U.status === "dragging" && P(
        Object.fromEntries(
          m.map((F, H) => [
            F.id,
            { y: H * f, offsetY: 0, isSelected: !1 }
          ])
        )
      ), U.status = "idle");
    },
    [f, m]
  );
  const C = re(() => {
    i.run(() => {
      i.markHistory("creating page");
      const R = kn.createId();
      i.createPage({ name: s("page-menu.new-page-initial-name"), id: R }), i.setCurrentPage(R), b(!0), Fa(i);
    }), r("new-page", { source: "page-menu" });
  }, [i, s, D, r]), z = re(
    (R) => {
      i.setCurrentPage(R), Fa(i), r("change-page", { source: "page-menu" });
    },
    [i, r]
  ), O = re(
    (R, U) => {
      i.renamePage(R, U), r("rename-page", { source: "page-menu" });
    },
    [i, r]
  );
  return /* @__PURE__ */ l.jsxs(Gn, { id: "pages", onOpenChange: p, open: h, children: [
    /* @__PURE__ */ l.jsx(Wn, { "data-testid": "main.page-menu", children: /* @__PURE__ */ l.jsxs(
      q,
      {
        type: "menu",
        title: y.name,
        "data-testid": "page-menu.button",
        ref: o,
        className: "tlui-page-menu__trigger",
        children: [
          /* @__PURE__ */ l.jsx("div", { className: "tlui-page-menu__name", children: y.name }),
          /* @__PURE__ */ l.jsx(Te, { icon: "chevron-down", small: !0 })
        ]
      }
    ) }),
    /* @__PURE__ */ l.jsx(Hn, { side: "bottom", align: "start", sideOffset: 6, children: /* @__PURE__ */ l.jsxs("div", { className: "tlui-page-menu__wrapper", style: { minWidth: c }, children: [
      /* @__PURE__ */ l.jsxs("div", { className: "tlui-page-menu__header", children: [
        /* @__PURE__ */ l.jsx("div", { className: "tlui-page-menu__header__title", children: s("page-menu.title") }),
        n && /* @__PURE__ */ l.jsx("div", { className: "tlui-buttons__horizontal", children: /* @__PURE__ */ l.jsx(
          q,
          {
            type: "icon",
            "data-testid": "page-menu.create",
            title: s(
              j ? "page-menu.max-page-count-reached" : "page-menu.create-new-page"
            ),
            disabled: j,
            onClick: C,
            children: /* @__PURE__ */ l.jsx(Te, { icon: "plus" })
          }
        ) })
      ] }),
      /* @__PURE__ */ l.jsx(
        "div",
        {
          "data-testid": "page-menu.list",
          className: "tlui-page-menu__list tlui-menu__group",
          style: { height: f * m.length + 4 },
          ref: M,
          children: m.map((R, U) => {
            const F = v[R.id] ?? {
              offsetY: 0
            };
            return /* @__PURE__ */ l.jsxs(
              "div",
              {
                "data-testid": "page-menu.item",
                className: "tlui-page_menu__item__sortable",
                style: {
                  zIndex: R.id === y.id ? 888 : U,
                  //@ts-ignore
                  transform: `translate(0px, ${F.y + F.offsetY}px)`
                },
                children: [
                  /* @__PURE__ */ l.jsx(
                    q,
                    {
                      type: "icon",
                      tabIndex: -1,
                      onClick: () => z(R.id),
                      "data-id": R.id,
                      "data-index": U,
                      children: /* @__PURE__ */ l.jsx("div", { style: {
                        border: "1px solid rgba(58, 53, 65, 0.12)"
                      }, children: /* @__PURE__ */ l.jsx(sd, { checked: R.id === y.id }) })
                    }
                  ),
                  a < Qt.TABLET_SM && w ? (
                    // sigh, this is a workaround for iOS Safari
                    // because the device and the radix popover seem
                    // to be fighting over scroll position. Nothing
                    // else seems to work!
                    /* @__PURE__ */ l.jsx(
                      q,
                      {
                        type: "normal",
                        className: "tlui-page-menu__item__button",
                        onClick: () => {
                          const H = window.prompt("Rename page", R.name);
                          H && H !== R.name && O(R.id, H);
                        },
                        onDoubleClick: T,
                        children: /* @__PURE__ */ l.jsx(St, { children: R.name })
                      }
                    )
                  ) : /* @__PURE__ */ l.jsx(
                    "div",
                    {
                      className: "tlui-page_menu__item__sortable__title",
                      style: { height: f },
                      children: /* @__PURE__ */ l.jsx(
                        she,
                        {
                          id: R.id,
                          name: R.name,
                          isCurrentPage: R.id === y.id
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ l.jsx("div", { className: "", "data-isediting": A, children: /* @__PURE__ */ l.jsx(
                    ohe,
                    {
                      canDuplicate: e,
                      index: U,
                      item: R,
                      listSize: m.length
                    }
                  ) })
                ]
              },
              R.id + "_editing"
            );
          })
        }
      )
    ] }) })
  ] });
}), che = ({
  canDuplicate: t = !0,
  showGridOptions: e = !0,
  canCreatePage: n = !0
}) => {
  const i = "my-custom-toolbar", [r, s] = pe(null), { menubarRef: o, topToolbarRef: a } = bf(), [c, d] = pe(!1);
  return at(() => {
    const u = window.matchMedia("(max-width: 780px)");
    d(u.matches);
    const h = (g) => {
      d(g.matches);
    };
    return u.addEventListener("change", h), () => u.removeEventListener("change", h);
  }, []), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    c && a.current && hy(
      /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(yn, { type: "icons", sourceId: "toolbar", children: /* @__PURE__ */ l.jsx("div", { className: "tl-theme__light", children: /* @__PURE__ */ l.jsx("div", { className: "tlui-toolbar__tools tlui-buttons__grid", role: "radiogroup", children: /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx("div", { id: `${i}_main`, role: "radiogroup", className: "tlui-toolbar__tools__list", children: /* @__PURE__ */ l.jsx(IA, { isMobile: !0, showGridOptions: e }) }) }) }) }) }) }),
      a.current
    ),
    hy(
      /* @__PURE__ */ l.jsx("div", { style: { flexGrow: 1 }, children: /* @__PURE__ */ l.jsx(yn, { type: "icons", sourceId: "toolbar", children: /* @__PURE__ */ l.jsx("div", { className: "tl-theme__light", children: /* @__PURE__ */ l.jsxs("div", { className: `tlui-buttons__grid top-drawing-tool${c ? "" : "-desktop"}`, role: "radiogroup", children: [
        /* @__PURE__ */ l.jsx("div", { className: "top-menu-page-selection", children: /* @__PURE__ */ l.jsx(
          ahe,
          {
            canDuplicate: t,
            canCreatePage: n
          }
        ) }),
        !c && /* @__PURE__ */ l.jsx("div", { className: "top-drawing-tool-desktop-icons", children: /* @__PURE__ */ l.jsx(IA, { isMobile: !1, showGridOptions: e }) }),
        /* @__PURE__ */ l.jsx("div", { className: "top-menubar-history", children: /* @__PURE__ */ l.jsxs("div", { id: `${i}_main`, role: "radiogroup", className: "tlui-toolbar__tools__list", children: [
          /* @__PURE__ */ l.jsx(Uue, {}),
          /* @__PURE__ */ l.jsx(Rue, {}),
          /* @__PURE__ */ l.jsx(Yue, {})
        ] }) })
      ] }) }) }) }),
      o.current
    ),
    /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsxs("div", { children: [
      /* @__PURE__ */ l.jsx(rhe, {}),
      /* @__PURE__ */ l.jsx("div", { className: "tlui-toolbar", "data-testid": "ui.toolbar-bottom", children: /* @__PURE__ */ l.jsx("div", { className: "tlui-toolbar__tools", role: "radiogroup", children: /* @__PURE__ */ l.jsx("div", { id: `${i}_main`, className: "tlui-toolbar__tools__list toolbar_bottom", children: /* @__PURE__ */ l.jsx(yn, { type: "toolbar", sourceId: "toolbar", children: /* @__PURE__ */ l.jsx(Fue, {}) }) }) }) })
    ] }) })
  ] });
};
let $I = {};
function Sm(t = {}) {
  $I = {
    animate: !0,
    allowClose: !0,
    overlayOpacity: 0.7,
    smoothScroll: !1,
    disableActiveInteraction: !1,
    showProgress: !1,
    stagePadding: 10,
    stageRadius: 5,
    popoverOffset: 10,
    showButtons: ["next", "previous", "close"],
    disableButtons: [],
    overlayColor: "#000",
    ...t
  };
}
function Se(t) {
  return t ? $I[t] : $I;
}
function lh(t, e, n, i) {
  return (t /= i / 2) < 1 ? n / 2 * t * t + e : -n / 2 * (--t * (t - 2) - 1) + e;
}
function q2(t) {
  const e = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])';
  return t.flatMap((n) => {
    const i = n.matches(e), r = Array.from(n.querySelectorAll(e));
    return [...i ? [n] : [], ...r];
  }).filter((n) => getComputedStyle(n).pointerEvents !== "none" && uhe(n));
}
function _2(t) {
  if (!t || dhe(t))
    return;
  const e = Se("smoothScroll");
  t.scrollIntoView({
    // Removing the smooth scrolling for elements which exist inside the scrollable parent
    // This was causing the highlight to not properly render
    behavior: !e || lhe(t) ? "auto" : "smooth",
    inline: "center",
    block: "center"
  });
}
function lhe(t) {
  if (!t || !t.parentElement)
    return;
  const e = t.parentElement;
  return e.scrollHeight > e.clientHeight;
}
function dhe(t) {
  const e = t.getBoundingClientRect();
  return e.top >= 0 && e.left >= 0 && e.bottom <= (window.innerHeight || document.documentElement.clientHeight) && e.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function uhe(t) {
  return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
}
let ip = {};
function tn(t, e) {
  ip[t] = e;
}
function De(t) {
  return t ? ip[t] : ip;
}
function SA() {
  ip = {};
}
let rp = {};
function dh(t, e) {
  rp[t] = e;
}
function zo(t) {
  var e;
  (e = rp[t]) == null || e.call(rp);
}
function hhe() {
  rp = {};
}
function ghe(t, e, n, i) {
  let r = De("__activeStagePosition");
  const s = r || n.getBoundingClientRect(), o = i.getBoundingClientRect(), a = lh(t, s.x, o.x - s.x, e), c = lh(t, s.y, o.y - s.y, e), d = lh(t, s.width, o.width - s.width, e), u = lh(t, s.height, o.height - s.height, e);
  r = {
    x: a,
    y: c,
    width: d,
    height: u
  }, e3(r), tn("__activeStagePosition", r);
}
function $2(t) {
  if (!t)
    return;
  const e = t.getBoundingClientRect(), n = {
    x: e.x,
    y: e.y,
    width: e.width,
    height: e.height
  };
  tn("__activeStagePosition", n), e3(n);
}
function phe() {
  const t = De("__activeStagePosition"), e = De("__overlaySvg");
  if (!t)
    return;
  if (!e) {
    console.warn("No stage svg found.");
    return;
  }
  const n = window.innerWidth, i = window.innerHeight;
  e.setAttribute("viewBox", `0 0 ${n} ${i}`);
}
function fhe(t) {
  const e = Mhe(t);
  document.body.appendChild(e), i3(e, (n) => {
    n.target.tagName === "path" && zo("overlayClick");
  }), tn("__overlaySvg", e);
}
function e3(t) {
  const e = De("__overlaySvg");
  if (!e) {
    fhe(t);
    return;
  }
  const n = e.firstElementChild;
  if ((n == null ? void 0 : n.tagName) !== "path")
    throw new Error("no path element found in stage svg");
  n.setAttribute("d", t3(t));
}
function Mhe(t) {
  const e = window.innerWidth, n = window.innerHeight, i = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  i.classList.add("driver-overlay", "driver-overlay-animated"), i.setAttribute("viewBox", `0 0 ${e} ${n}`), i.setAttribute("xmlSpace", "preserve"), i.setAttribute("xmlnsXlink", "http://www.w3.org/1999/xlink"), i.setAttribute("version", "1.1"), i.setAttribute("preserveAspectRatio", "xMinYMin slice"), i.style.fillRule = "evenodd", i.style.clipRule = "evenodd", i.style.strokeLinejoin = "round", i.style.strokeMiterlimit = "2", i.style.zIndex = "10000", i.style.position = "fixed", i.style.top = "0", i.style.left = "0", i.style.width = "100%", i.style.height = "100%";
  const r = document.createElementNS("http://www.w3.org/2000/svg", "path");
  return r.setAttribute("d", t3(t)), r.style.fill = Se("overlayColor") || "rgb(0,0,0)", r.style.opacity = `${Se("overlayOpacity")}`, r.style.pointerEvents = "auto", r.style.cursor = "auto", i.appendChild(r), i;
}
function t3(t) {
  const e = window.innerWidth, n = window.innerHeight, i = Se("stagePadding") || 0, r = Se("stageRadius") || 0, s = t.width + i * 2, o = t.height + i * 2, a = Math.min(r, s / 2, o / 2), c = Math.floor(Math.max(a, 0)), d = t.x - i + c, u = t.y - i, h = s - c * 2, g = o - c * 2;
  return `M${e},0L0,0L0,${n}L${e},${n}L${e},0Z
    M${d},${u} h${h} a${c},${c} 0 0 1 ${c},${c} v${g} a${c},${c} 0 0 1 -${c},${c} h-${h} a${c},${c} 0 0 1 -${c},-${c} v-${g} a${c},${c} 0 0 1 ${c},-${c} z`;
}
function mhe() {
  const t = De("__overlaySvg");
  t && t.remove();
}
function yhe() {
  const t = document.getElementById("driver-dummy-element");
  if (t)
    return t;
  let e = document.createElement("div");
  return e.id = "driver-dummy-element", e.style.width = "0", e.style.height = "0", e.style.pointerEvents = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.top = "50%", e.style.left = "50%", document.body.appendChild(e), e;
}
function jA(t) {
  const { element: e } = t;
  let n = typeof e == "string" ? document.querySelector(e) : e;
  n || (n = yhe()), xhe(n, t);
}
function Ihe() {
  const t = De("__activeElement"), e = De("__activeStep");
  t && ($2(t), phe(), s3(t, e));
}
function xhe(t, e) {
  const n = Date.now(), i = De("__activeStep"), r = De("__activeElement") || t, s = !r || r === t, o = t.id === "driver-dummy-element", a = r.id === "driver-dummy-element", c = Se("animate"), d = e.onHighlightStarted || Se("onHighlightStarted"), u = (e == null ? void 0 : e.onHighlighted) || Se("onHighlighted"), h = (i == null ? void 0 : i.onDeselected) || Se("onDeselected"), g = Se(), p = De();
  !s && h && h(a ? void 0 : r, i, {
    config: g,
    state: p
  }), d && d(o ? void 0 : t, e, {
    config: g,
    state: p
  });
  const f = !s && c;
  let M = !1;
  Nhe(), tn("previousStep", i), tn("previousElement", r), tn("activeStep", e), tn("activeElement", t);
  const m = () => {
    if (De("__transitionCallback") !== m)
      return;
    const y = Date.now() - n, I = 400 - y <= 400 / 2;
    e.popover && I && !M && f && (DA(t, e), M = !0), Se("animate") && y < 400 ? ghe(y, 400, r, t) : ($2(t), u && u(o ? void 0 : t, e, {
      config: Se(),
      state: De()
    }), tn("__transitionCallback", void 0), tn("__previousStep", i), tn("__previousElement", r), tn("__activeStep", e), tn("__activeElement", t)), window.requestAnimationFrame(m);
  };
  tn("__transitionCallback", m), window.requestAnimationFrame(m), _2(t), !f && e.popover && DA(t, e), r.classList.remove("driver-active-element", "driver-no-interaction"), r.removeAttribute("aria-haspopup"), r.removeAttribute("aria-expanded"), r.removeAttribute("aria-controls"), Se("disableActiveInteraction") && t.classList.add("driver-no-interaction"), t.classList.add("driver-active-element"), t.setAttribute("aria-haspopup", "dialog"), t.setAttribute("aria-expanded", "true"), t.setAttribute("aria-controls", "driver-popover-content");
}
function She() {
  var t;
  (t = document.getElementById("driver-dummy-element")) == null || t.remove(), document.querySelectorAll(".driver-active-element").forEach((e) => {
    e.classList.remove("driver-active-element", "driver-no-interaction"), e.removeAttribute("aria-haspopup"), e.removeAttribute("aria-expanded"), e.removeAttribute("aria-controls");
  });
}
function cd() {
  const t = De("__resizeTimeout");
  t && window.cancelAnimationFrame(t), tn("__resizeTimeout", window.requestAnimationFrame(Ihe));
}
function jhe(t) {
  var e;
  if (!De("isInitialized") || !(t.key === "Tab" || t.keyCode === 9))
    return;
  const n = De("__activeElement"), i = (e = De("popover")) == null ? void 0 : e.wrapper, r = q2([
    ...i ? [i] : [],
    ...n ? [n] : []
  ]), s = r[0], o = r[r.length - 1];
  if (t.preventDefault(), t.shiftKey) {
    const a = r[r.indexOf(document.activeElement) - 1] || o;
    a == null || a.focus();
  } else {
    const a = r[r.indexOf(document.activeElement) + 1] || s;
    a == null || a.focus();
  }
}
function n3(t) {
  var e;
  ((e = Se("allowKeyboardControl")) == null || e) && (t.key === "Escape" ? zo("escapePress") : t.key === "ArrowRight" ? zo("arrowRightPress") : t.key === "ArrowLeft" && zo("arrowLeftPress"));
}
function i3(t, e, n) {
  const i = (r, s) => {
    const o = r.target;
    t.contains(o) && ((!n || n(o)) && (r.preventDefault(), r.stopPropagation(), r.stopImmediatePropagation()), s == null || s(r));
  };
  document.addEventListener("pointerdown", i, !0), document.addEventListener("mousedown", i, !0), document.addEventListener("pointerup", i, !0), document.addEventListener("mouseup", i, !0), document.addEventListener(
    "click",
    (r) => {
      i(r, e);
    },
    !0
  );
}
function Dhe() {
  window.addEventListener("keyup", n3, !1), window.addEventListener("keydown", jhe, !1), window.addEventListener("resize", cd), window.addEventListener("scroll", cd);
}
function whe() {
  window.removeEventListener("keyup", n3), window.removeEventListener("resize", cd), window.removeEventListener("scroll", cd);
}
function Nhe() {
  const t = De("popover");
  t && (t.wrapper.style.display = "none");
}
function DA(t, e) {
  var n, i;
  let r = De("popover");
  r && document.body.removeChild(r.wrapper), r = The(), document.body.appendChild(r.wrapper);
  const {
    title: s,
    description: o,
    showButtons: a,
    disableButtons: c,
    showProgress: d,
    nextBtnText: u = Se("nextBtnText") || "Next &rarr;",
    prevBtnText: h = Se("prevBtnText") || "&larr; Previous",
    progressText: g = Se("progressText") || "{current} of {total}"
  } = e.popover || {};
  r.nextButton.innerHTML = u, r.previousButton.innerHTML = h, r.progress.innerHTML = g, s ? (r.title.innerHTML = s, r.title.style.display = "block") : r.title.style.display = "none", o ? (r.description.innerHTML = o, r.description.style.display = "block") : r.description.style.display = "none";
  const p = a || Se("showButtons"), f = d || Se("showProgress") || !1, M = (p == null ? void 0 : p.includes("next")) || (p == null ? void 0 : p.includes("previous")) || f;
  r.closeButton.style.display = p.includes("close") ? "block" : "none", M ? (r.footer.style.display = "flex", r.progress.style.display = f ? "block" : "none", r.nextButton.style.display = p.includes("next") ? "block" : "none", r.previousButton.style.display = p.includes("previous") ? "block" : "none") : r.footer.style.display = "none";
  const m = c || Se("disableButtons") || [];
  m != null && m.includes("next") && (r.nextButton.disabled = !0, r.nextButton.classList.add("driver-popover-btn-disabled")), m != null && m.includes("previous") && (r.previousButton.disabled = !0, r.previousButton.classList.add("driver-popover-btn-disabled")), m != null && m.includes("close") && (r.closeButton.disabled = !0, r.closeButton.classList.add("driver-popover-btn-disabled"));
  const y = r.wrapper;
  y.style.display = "block", y.style.left = "", y.style.top = "", y.style.bottom = "", y.style.right = "", y.id = "driver-popover-content", y.setAttribute("role", "dialog"), y.setAttribute("aria-labelledby", "driver-popover-title"), y.setAttribute("aria-describedby", "driver-popover-description");
  const I = r.arrow;
  I.className = "driver-popover-arrow";
  const D = ((n = e.popover) == null ? void 0 : n.popoverClass) || Se("popoverClass") || "";
  y.className = `driver-popover ${D}`.trim(), i3(
    r.wrapper,
    (b) => {
      var T, E, v;
      const P = b.target, C = ((T = e.popover) == null ? void 0 : T.onNextClick) || Se("onNextClick"), z = ((E = e.popover) == null ? void 0 : E.onPrevClick) || Se("onPrevClick"), O = ((v = e.popover) == null ? void 0 : v.onCloseClick) || Se("onCloseClick");
      if (P.classList.contains("driver-popover-next-btn"))
        return C ? C(t, e, {
          config: Se(),
          state: De()
        }) : zo("nextClick");
      if (P.classList.contains("driver-popover-prev-btn"))
        return z ? z(t, e, {
          config: Se(),
          state: De()
        }) : zo("prevClick");
      if (P.classList.contains("driver-popover-close-btn"))
        return O ? O(t, e, {
          config: Se(),
          state: De()
        }) : zo("closeClick");
    },
    (b) => !(r != null && r.description.contains(b)) && !(r != null && r.title.contains(b)) && typeof b.className == "string" && b.className.includes("driver-popover")
  ), tn("popover", r);
  const j = ((i = e.popover) == null ? void 0 : i.onPopoverRender) || Se("onPopoverRender");
  j && j(r, {
    config: Se(),
    state: De()
  }), s3(t, e), _2(y);
  const w = t.classList.contains("driver-dummy-element"), A = q2([y, ...w ? [] : [t]]);
  A.length > 0 && A[0].focus();
}
function r3() {
  const t = De("popover");
  if (!(t != null && t.wrapper))
    return;
  const e = t.wrapper.getBoundingClientRect(), n = Se("stagePadding") || 0, i = Se("popoverOffset") || 0;
  return {
    width: e.width + n + i,
    height: e.height + n + i,
    realWidth: e.width,
    realHeight: e.height
  };
}
function wA(t, e) {
  const { elementDimensions: n, popoverDimensions: i, popoverPadding: r, popoverArrowDimensions: s } = e;
  return t === "start" ? Math.max(
    Math.min(
      n.top - r,
      window.innerHeight - i.realHeight - s.width
    ),
    s.width
  ) : t === "end" ? Math.max(
    Math.min(
      n.top - (i == null ? void 0 : i.realHeight) + n.height + r,
      window.innerHeight - (i == null ? void 0 : i.realHeight) - s.width
    ),
    s.width
  ) : t === "center" ? Math.max(
    Math.min(
      n.top + n.height / 2 - (i == null ? void 0 : i.realHeight) / 2,
      window.innerHeight - (i == null ? void 0 : i.realHeight) - s.width
    ),
    s.width
  ) : 0;
}
function NA(t, e) {
  const { elementDimensions: n, popoverDimensions: i, popoverPadding: r, popoverArrowDimensions: s } = e;
  return t === "start" ? Math.max(
    Math.min(
      n.left - r,
      window.innerWidth - i.realWidth - s.width
    ),
    s.width
  ) : t === "end" ? Math.max(
    Math.min(
      n.left - (i == null ? void 0 : i.realWidth) + n.width + r,
      window.innerWidth - (i == null ? void 0 : i.realWidth) - s.width
    ),
    s.width
  ) : t === "center" ? Math.max(
    Math.min(
      n.left + n.width / 2 - (i == null ? void 0 : i.realWidth) / 2,
      window.innerWidth - (i == null ? void 0 : i.realWidth) - s.width
    ),
    s.width
  ) : 0;
}
function s3(t, e) {
  const n = De("popover");
  if (!n)
    return;
  const { align: i = "start", side: r = "left" } = (e == null ? void 0 : e.popover) || {}, s = i, o = t.id === "driver-dummy-element" ? "over" : r, a = Se("stagePadding") || 0, c = r3(), d = n.arrow.getBoundingClientRect(), u = t.getBoundingClientRect(), h = u.top - c.height;
  let g = h >= 0;
  const p = window.innerHeight - (u.bottom + c.height);
  let f = p >= 0;
  const M = u.left - c.width;
  let m = M >= 0;
  const y = window.innerWidth - (u.right + c.width);
  let I = y >= 0;
  const D = !g && !f && !m && !I;
  let j = o;
  if (o === "top" && g ? I = m = f = !1 : o === "bottom" && f ? I = m = g = !1 : o === "left" && m ? I = g = f = !1 : o === "right" && I && (m = g = f = !1), o === "over") {
    const w = window.innerWidth / 2 - c.realWidth / 2, A = window.innerHeight / 2 - c.realHeight / 2;
    n.wrapper.style.left = `${w}px`, n.wrapper.style.right = "auto", n.wrapper.style.top = `${A}px`, n.wrapper.style.bottom = "auto";
  } else if (D) {
    const w = window.innerWidth / 2 - (c == null ? void 0 : c.realWidth) / 2, A = 10;
    n.wrapper.style.left = `${w}px`, n.wrapper.style.right = "auto", n.wrapper.style.bottom = `${A}px`, n.wrapper.style.top = "auto";
  } else if (m) {
    const w = Math.min(
      M,
      window.innerWidth - (c == null ? void 0 : c.realWidth) - d.width
    ), A = wA(s, {
      elementDimensions: u,
      popoverDimensions: c,
      popoverPadding: a,
      popoverArrowDimensions: d
    });
    n.wrapper.style.left = `${w}px`, n.wrapper.style.top = `${A}px`, n.wrapper.style.bottom = "auto", n.wrapper.style.right = "auto", j = "left";
  } else if (I) {
    const w = Math.min(
      y,
      window.innerWidth - (c == null ? void 0 : c.realWidth) - d.width
    ), A = wA(s, {
      elementDimensions: u,
      popoverDimensions: c,
      popoverPadding: a,
      popoverArrowDimensions: d
    });
    n.wrapper.style.right = `${w}px`, n.wrapper.style.top = `${A}px`, n.wrapper.style.bottom = "auto", n.wrapper.style.left = "auto", j = "right";
  } else if (g) {
    const w = Math.min(
      h,
      window.innerHeight - c.realHeight - d.width
    );
    let A = NA(s, {
      elementDimensions: u,
      popoverDimensions: c,
      popoverPadding: a,
      popoverArrowDimensions: d
    });
    n.wrapper.style.top = `${w}px`, n.wrapper.style.left = `${A}px`, n.wrapper.style.bottom = "auto", n.wrapper.style.right = "auto", j = "top";
  } else if (f) {
    const w = Math.min(
      p,
      window.innerHeight - (c == null ? void 0 : c.realHeight) - d.width
    );
    let A = NA(s, {
      elementDimensions: u,
      popoverDimensions: c,
      popoverPadding: a,
      popoverArrowDimensions: d
    });
    n.wrapper.style.left = `${A}px`, n.wrapper.style.bottom = `${w}px`, n.wrapper.style.top = "auto", n.wrapper.style.right = "auto", j = "bottom";
  }
  D ? n.arrow.classList.add("driver-popover-arrow-none") : Ahe(s, j, t);
}
function Ahe(t, e, n) {
  const i = De("popover");
  if (!i)
    return;
  const r = n.getBoundingClientRect(), s = r3(), o = i.arrow, a = s.width, c = window.innerWidth, d = r.width, u = r.left, h = s.height, g = window.innerHeight, p = r.top, f = r.height;
  o.className = "driver-popover-arrow";
  let M = e, m = t;
  e === "top" ? (u + d <= 0 ? (M = "right", m = "end") : u + d - a <= 0 && (M = "top", m = "start"), u >= c ? (M = "left", m = "end") : u + a >= c && (M = "top", m = "end")) : e === "bottom" ? (u + d <= 0 ? (M = "right", m = "start") : u + d - a <= 0 && (M = "bottom", m = "start"), u >= c ? (M = "left", m = "start") : u + a >= c && (M = "bottom", m = "end")) : e === "left" ? (p + f <= 0 ? (M = "bottom", m = "end") : p + f - h <= 0 && (M = "left", m = "start"), p >= g ? (M = "top", m = "end") : p + h >= g && (M = "left", m = "end")) : e === "right" && (p + f <= 0 ? (M = "bottom", m = "start") : p + f - h <= 0 && (M = "right", m = "start"), p >= g ? (M = "top", m = "start") : p + h >= g && (M = "right", m = "end")), M ? (o.classList.add(`driver-popover-arrow-side-${M}`), o.classList.add(`driver-popover-arrow-align-${m}`)) : o.classList.add("driver-popover-arrow-none");
}
function The() {
  const t = document.createElement("div");
  t.classList.add("driver-popover");
  const e = document.createElement("div");
  e.classList.add("driver-popover-arrow");
  const n = document.createElement("header");
  n.id = "driver-popover-title", n.classList.add("driver-popover-title"), n.style.display = "none", n.innerText = "Popover Title";
  const i = document.createElement("div");
  i.id = "driver-popover-description", i.classList.add("driver-popover-description"), i.style.display = "none", i.innerText = "Popover description is here";
  const r = document.createElement("button");
  r.type = "button", r.classList.add("driver-popover-close-btn"), r.setAttribute("aria-label", "Close"), r.innerHTML = "&times;";
  const s = document.createElement("footer");
  s.classList.add("driver-popover-footer");
  const o = document.createElement("span");
  o.classList.add("driver-popover-progress-text"), o.innerText = "";
  const a = document.createElement("span");
  a.classList.add("driver-popover-navigation-btns");
  const c = document.createElement("button");
  c.type = "button", c.classList.add("driver-popover-prev-btn"), c.innerHTML = "&larr; Previous";
  const d = document.createElement("button");
  return d.type = "button", d.classList.add("driver-popover-next-btn"), d.innerHTML = "Next &rarr;", a.appendChild(c), a.appendChild(d), s.appendChild(o), s.appendChild(a), t.appendChild(r), t.appendChild(e), t.appendChild(n), t.appendChild(i), t.appendChild(s), {
    wrapper: t,
    arrow: e,
    title: n,
    description: i,
    footer: s,
    previousButton: c,
    nextButton: d,
    closeButton: r,
    footerButtons: a,
    progress: o
  };
}
function bhe() {
  var t;
  const e = De("popover");
  e && ((t = e.wrapper.parentElement) == null || t.removeChild(e.wrapper));
}
function vhe(t = {}) {
  Sm(t);
  function e() {
    Se("allowClose") && d();
  }
  function n() {
    const u = De("activeIndex"), h = Se("steps") || [];
    if (typeof u > "u")
      return;
    const g = u + 1;
    h[g] ? c(g) : d();
  }
  function i() {
    const u = De("activeIndex"), h = Se("steps") || [];
    if (typeof u > "u")
      return;
    const g = u - 1;
    h[g] ? c(g) : d();
  }
  function r(u) {
    (Se("steps") || [])[u] ? c(u) : d();
  }
  function s() {
    var u;
    if (De("__transitionCallback"))
      return;
    const h = De("activeIndex"), g = De("__activeStep"), p = De("__activeElement");
    if (typeof h > "u" || typeof g > "u" || typeof De("activeIndex") > "u")
      return;
    const f = ((u = g.popover) == null ? void 0 : u.onPrevClick) || Se("onPrevClick");
    if (f)
      return f(p, g, {
        config: Se(),
        state: De()
      });
    i();
  }
  function o() {
    var u;
    if (De("__transitionCallback"))
      return;
    const h = De("activeIndex"), g = De("__activeStep"), p = De("__activeElement");
    if (typeof h > "u" || typeof g > "u")
      return;
    const f = ((u = g.popover) == null ? void 0 : u.onNextClick) || Se("onNextClick");
    if (f)
      return f(p, g, {
        config: Se(),
        state: De()
      });
    n();
  }
  function a() {
    De("isInitialized") || (tn("isInitialized", !0), document.body.classList.add("driver-active", Se("animate") ? "driver-fade" : "driver-simple"), Dhe(), dh("overlayClick", e), dh("escapePress", e), dh("arrowLeftPress", s), dh("arrowRightPress", o));
  }
  function c(u = 0) {
    var h, g, p, f, M, m, y, I;
    const D = Se("steps");
    if (!D) {
      console.error("No steps to drive through"), d();
      return;
    }
    if (!D[u]) {
      d();
      return;
    }
    tn("__activeOnDestroyed", document.activeElement), tn("activeIndex", u);
    const j = D[u], w = D[u + 1], A = D[u - 1], b = ((h = j.popover) == null ? void 0 : h.doneBtnText) || Se("doneBtnText") || "Done", T = Se("allowClose"), E = typeof ((g = j.popover) == null ? void 0 : g.showProgress) < "u" ? (p = j.popover) == null ? void 0 : p.showProgress : Se("showProgress"), v = (((f = j.popover) == null ? void 0 : f.progressText) || Se("progressText") || "{{current}} of {{total}}").replace("{{current}}", `${u + 1}`).replace("{{total}}", `${D.length}`), P = ((M = j.popover) == null ? void 0 : M.showButtons) || Se("showButtons"), C = [
      "next",
      "previous",
      ...T ? ["close"] : []
    ].filter((U) => !(P != null && P.length) || P.includes(U)), z = ((m = j.popover) == null ? void 0 : m.onNextClick) || Se("onNextClick"), O = ((y = j.popover) == null ? void 0 : y.onPrevClick) || Se("onPrevClick"), R = ((I = j.popover) == null ? void 0 : I.onCloseClick) || Se("onCloseClick");
    jA({
      ...j,
      popover: {
        showButtons: C,
        nextBtnText: w ? void 0 : b,
        disableButtons: [...A ? [] : ["previous"]],
        showProgress: E,
        progressText: v,
        onNextClick: z || (() => {
          w ? c(u + 1) : d();
        }),
        onPrevClick: O || (() => {
          c(u - 1);
        }),
        onCloseClick: R || (() => {
          d();
        }),
        ...(j == null ? void 0 : j.popover) || {}
      }
    });
  }
  function d(u = !0) {
    const h = De("__activeElement"), g = De("__activeStep"), p = De("__activeOnDestroyed"), f = Se("onDestroyStarted");
    if (u && f) {
      const y = !h || (h == null ? void 0 : h.id) === "driver-dummy-element";
      f(y ? void 0 : h, g, {
        config: Se(),
        state: De()
      });
      return;
    }
    const M = (g == null ? void 0 : g.onDeselected) || Se("onDeselected"), m = Se("onDestroyed");
    if (document.body.classList.remove("driver-active", "driver-fade", "driver-simple"), whe(), bhe(), She(), mhe(), hhe(), SA(), h && g) {
      const y = h.id === "driver-dummy-element";
      M && M(y ? void 0 : h, g, {
        config: Se(),
        state: De()
      }), m && m(y ? void 0 : h, g, {
        config: Se(),
        state: De()
      });
    }
    p && p.focus();
  }
  return {
    isActive: () => De("isInitialized") || !1,
    refresh: cd,
    drive: (u = 0) => {
      a(), c(u);
    },
    setConfig: Sm,
    setSteps: (u) => {
      SA(), Sm({
        ...Se(),
        steps: u
      });
    },
    getConfig: Se,
    getState: De,
    getActiveIndex: () => De("activeIndex"),
    isFirstStep: () => De("activeIndex") === 0,
    isLastStep: () => {
      const u = Se("steps") || [], h = De("activeIndex");
      return h !== void 0 && h === u.length - 1;
    },
    getActiveStep: () => De("activeStep"),
    getActiveElement: () => De("activeElement"),
    getPreviousElement: () => De("previousElement"),
    getPreviousStep: () => De("previousStep"),
    moveNext: n,
    movePrevious: i,
    moveTo: r,
    hasNextStep: () => {
      const u = Se("steps") || [], h = De("activeIndex");
      return h !== void 0 && u[h + 1];
    },
    hasPreviousStep: () => {
      const u = Se("steps") || [], h = De("activeIndex");
      return h !== void 0 && u[h - 1];
    },
    highlight: (u) => {
      a(), jA({
        ...u,
        popover: u.popover ? {
          showButtons: [],
          showProgress: !1,
          progressText: "",
          ...u.popover
        } : void 0
      });
    },
    destroy: () => {
      d(!1);
    }
  };
}
const AA = vhe({
  showProgress: !0,
  disableActiveInteraction: !0,
  allowClose: !1,
  steps: [
    {
      element: "[data-testid='ui.toolbar-bottom']",
      popover: {
        title: "This is the tool bar.",
        description: "Select tools here.",
        side: "top"
      }
    },
    {
      element: "[data-testid='tools.floor-planner']",
      popover: {
        title: "Floor Planner",
        description: "This is the floor planner tool",
        side: "top",
        onNextClick: () => {
          var t;
          (t = document.querySelector("[data-testid='tools.floor-planner']")) == null || t.click(), setTimeout(() => {
            AA.moveNext();
          }, 150);
        }
      }
    },
    {
      element: "[data-testid='tools.floor-planner.wall-tool']",
      popover: {
        onPrevClick: () => {
          var t;
          (t = document.querySelector("[data-testid='tools.back']")) == null || t.click(), setTimeout(() => {
            AA.movePrevious();
          }, 150);
        },
        title: "Floor Planner - Draw Wall",
        description: "This allows you to draw walls",
        side: "top"
      }
    }
  ]
});
function Ehe() {
  const t = Q(), { canExport: e } = _o(), n = G(
    "isSelectToolActive",
    () => t.getCurrentToolId() === "select",
    [t]
  );
  return /* @__PURE__ */ l.jsxs(Rn, { id: "edit", label: "menu.edit", disabled: !n, children: [
    /* @__PURE__ */ l.jsx(Che, {}),
    /* @__PURE__ */ l.jsx(Lj, {}),
    e && /* @__PURE__ */ l.jsx(o3, {}),
    /* @__PURE__ */ l.jsx(Ce, { id: "select-all", children: /* @__PURE__ */ l.jsx(zhe, {}) })
  ] });
}
function Che() {
  const t = _t(), e = Df(), n = jf();
  return /* @__PURE__ */ l.jsxs(Ce, { id: "undo-redo", children: [
    /* @__PURE__ */ l.jsx(Qe, { ...t.undo, disabled: !e }),
    /* @__PURE__ */ l.jsx(Qe, { ...t.redo, disabled: !n })
  ] });
}
function zhe() {
  const t = _t(), e = Q(), n = G(
    "atLeastOneShapeOnPage",
    () => e.getCurrentPageShapeIds().size > 0,
    [e]
  );
  return /* @__PURE__ */ l.jsx(Qe, { ...t["select-all"], disabled: !n });
}
function o3({
  baseId: t = "conversions",
  menuId: e = "export-as",
  groupId: n = "export-as-group"
}) {
  const i = Q(), r = _t();
  return G(
    "atLeastOneShapeOnPage",
    () => i.getCurrentPageShapeIds().size > 0,
    [i]
  ) ? /* @__PURE__ */ l.jsx(Ce, { id: t, children: /* @__PURE__ */ l.jsx(Rn, { id: e, label: "context-menu.export-all-as", size: "small", children: /* @__PURE__ */ l.jsxs(Ce, { id: n, children: [
    /* @__PURE__ */ l.jsx(Qe, { ...r["export-as-svg"] }),
    /* @__PURE__ */ l.jsx(Qe, { ...r["export-as-png"] }),
    /* @__PURE__ */ l.jsx(Qe, { ...r["export-as-json"] })
  ] }) }) }) : null;
}
function Lhe() {
  const t = _t();
  return /* @__PURE__ */ l.jsx(Ce, { id: "extras", children: /* @__PURE__ */ l.jsx(Qe, { ...t["insert-media"] }) });
}
function khe() {
  const t = _t(), { canSave: e } = _o();
  return e ? /* @__PURE__ */ l.jsx(
    Qe,
    {
      ...t["form-sketch-save"]
    }
  ) : null;
}
function Ohe() {
  const t = _t(), { canExit: e } = _o();
  return e ? /* @__PURE__ */ l.jsx(
    Qe,
    {
      ...t["form-sketch-exit"]
    }
  ) : null;
}
function Phe() {
  const { canExport: t } = _o();
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(khe, {}),
    /* @__PURE__ */ l.jsx(Ehe, {}),
    /* @__PURE__ */ l.jsx(NP, {}),
    t && /* @__PURE__ */ l.jsx(
      o3,
      {
        baseId: "base-conversions",
        menuId: "base-export-as-menu",
        groupId: "base-export-as-group"
      }
    ),
    /* @__PURE__ */ l.jsx(Lhe, {}),
    /* @__PURE__ */ l.jsx(Ohe, {})
  ] });
}
const Uhe = _e(function({ children: e }) {
  const n = qt(), [i, r] = Nr("main menu"), s = ke(), o = e ?? /* @__PURE__ */ l.jsx(wP, {});
  return /* @__PURE__ */ l.jsxs(cf, { dir: "ltr", open: i, onOpenChange: r, modal: !1, children: [
    /* @__PURE__ */ l.jsx(lf, { asChild: !0, dir: "ltr", children: /* @__PURE__ */ l.jsx(q, { type: "icon", "data-testid": "main-menu.button", title: s("menu.title"), children: /* @__PURE__ */ l.jsx(Te, { icon: "menu", small: !0 }) }) }),
    /* @__PURE__ */ l.jsx(Bd, { container: n, children: /* @__PURE__ */ l.jsx(
      df,
      {
        className: "tlui-menu",
        side: "bottom",
        align: "start",
        collisionPadding: 4,
        alignOffset: 0,
        sideOffset: 6,
        children: /* @__PURE__ */ l.jsx(yn, { type: "menu", sourceId: "main-menu", children: o })
      }
    ) })
  ] });
}), Rhe = ({
  children: t
}) => {
  const { navigatorRef: e } = bf();
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: hy(
    /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(Uhe, { children: /* @__PURE__ */ l.jsx(Phe, {}) }) }),
    e.current
  ) });
};
var Xm;
let Yhe = (Xm = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "assetId", "");
    S(this, "iconId", "");
    S(this, "onEnter", (n) => {
      this.assetId = n.assetId, this.iconId = n.iconId, this.editor.setCursor({ type: "cross", rotation: 0 });
    });
    S(this, "onPointerDown", (n) => {
      this.assetId && this.parent.transition("drawing", {
        assetId: this.assetId,
        iconId: this.iconId,
        ...n
      });
    });
    S(this, "onCancel", () => {
    });
  }
}, S(Xm, "id", "idle"), Xm);
var Jm;
let Qhe = (Jm = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
    S(this, "markId");
    S(this, "shape", {});
    S(this, "initialPoint", {});
    S(this, "startPoint", {});
    S(this, "assetId", "");
    S(this, "iconId", "");
    S(this, "pointCounter", 0);
    S(this, "onEnter", (n) => {
      const { inputs: i } = this.editor, { currentPagePoint: r } = i;
      if (this.assetId = n.assetId, this.iconId = n.iconId, this.pointCounter = 0, this.markId = void 0, !(n.shapeId && this.editor.getShape(n.shapeId))) {
        const o = Ee();
        this.markId = `creating:${o}`, this.editor.mark(this.markId), this.editor.createShape({
          id: o,
          type: "image",
          x: r.x,
          y: r.y,
          props: {
            assetId: n.assetId,
            w: 64,
            h: 64
          },
          meta: {
            iconId: n.iconId,
            assetId: n.assetId
          }
        }), this.editor.select(o), this.shape = this.editor.getShape(o);
      }
    });
    S(this, "onPointerMove", (n) => {
      const { inputs: i } = this.editor, { currentPagePoint: r } = i;
      i.isDragging && this.editor.updateShape({
        ...this.shape,
        x: r.x,
        y: r.y
      });
    });
    S(this, "onPointerUp", (n) => {
      this.shape && this.complete();
    });
    S(this, "onCancel", () => {
      this.parent.transition("idle");
    });
    S(this, "onComplete", () => {
      this.complete();
    });
    S(this, "onDoubleClick", () => {
      this.complete();
    });
  }
  complete() {
    this.parent.transition("idle", {
      assetId: this.assetId,
      iconId: this.iconId
    });
  }
}, S(Jm, "id", "drawing"), Jm);
class eg extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "image");
  }
}
S(eg, "id", "legend-tool"), S(eg, "initial", "idle"), S(eg, "children", () => [Yhe, Qhe]);
var qm;
let Zhe = (qm = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "imageId", "");
    S(this, "assetId", "");
    S(this, "categoryId", "");
    S(this, "onEnter", (n) => {
      this.imageId = n.imageId, this.assetId = n.assetId, this.categoryId = n.categoryId, this.editor.setCursor({ type: "cross", rotation: 0 });
    });
    S(this, "onPointerDown", (n) => {
      this.imageId && this.parent.transition("drawing", {
        imageId: this.imageId,
        assetId: this.assetId,
        categoryId: this.categoryId,
        ...n
      });
    });
    S(this, "onCancel", () => {
    });
  }
}, S(qm, "id", "idle"), qm);
var _m;
let Fhe = (_m = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
    S(this, "markId");
    S(this, "shape", {});
    S(this, "initialPoint", {});
    S(this, "startPoint", {});
    S(this, "imageId", "");
    S(this, "categoryId", "");
    S(this, "assetId", "");
    S(this, "pointCounter", 0);
    S(this, "onEnter", (n) => {
      var a, c;
      const { inputs: i } = this.editor, { currentPagePoint: r } = i;
      this.imageId = n.imageId, this.categoryId = n.categoryId, this.assetId = n.assetId, this.pointCounter = 0, this.markId = void 0;
      const s = Ee();
      this.markId = `creating:${s}`, this.editor.mark(this.markId);
      const o = this.editor.getAsset(this.assetId);
      o !== void 0 && (this.editor.createShape({
        id: s,
        type: "image",
        x: Math.round(r.x / Os) * Os,
        y: Math.round(r.y / Os) * Os,
        props: {
          assetId: n.assetId,
          //@ts-ignore
          w: ((a = o.props) == null ? void 0 : a.w) ?? 64,
          //@ts-ignore
          h: ((c = o.props) == null ? void 0 : c.h) ?? 64
        },
        meta: {
          imageId: n.imageId,
          categoryId: n.categoryId
        }
      }), this.editor.select(s), this.shape = this.editor.getShape(s));
    });
    S(this, "onPointerMove", (n) => {
      const { inputs: i } = this.editor, { currentPagePoint: r } = i;
      i.isDragging && this.editor.updateShape({
        ...this.shape,
        x: Math.round(r.x / Os) * Os,
        y: Math.round(r.y / Os) * Os
      });
    });
    S(this, "onPointerUp", (n) => {
      this.shape && this.complete();
    });
    S(this, "onCancel", () => {
      this.parent.transition("idle");
    });
    S(this, "onComplete", () => {
      this.complete();
    });
    S(this, "onDoubleClick", () => {
      this.complete();
    });
  }
  complete() {
    this.parent.transition("idle", {
      assetId: this.assetId,
      categoryId: this.categoryId,
      imageId: this.imageId
    });
  }
}, S(_m, "id", "drawing"), _m);
const Os = 8;
class tg extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "image");
  }
}
S(tg, "id", "image-gallery-tool"), S(tg, "initial", "idle"), S(tg, "children", () => [Zhe, Fhe]);
var $m;
let Bhe = ($m = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeId", "");
    S(this, "onEnter", (n) => {
      if (this.shapeId = n.shapeId, this.editor.setCursor({ type: "cross", rotation: 0 }), n.shapeId) {
        const i = this.editor.getShape(n.shapeId);
        i && (this.shapeId = i.id, this.editor.setHoveredShape(i), this.editor.setHintingShapes([]), this.parent.transition("drawing", {
          shapeId: this.shapeId,
          ...n
        }));
      }
    });
    S(this, "onPointerDown", (n) => {
      try {
        const i = this.editor.getShapeAtPoint(this.editor.inputs.currentPagePoint, {
          filter: (r) => r.type === "wall",
          hitInside: !0,
          margin: this.editor.options.hitTestMargin / this.editor.getZoomLevel()
        });
        i && (i == null ? void 0 : i.type) == "wall" && (this.shapeId = i.id, this.editor.setHoveredShape(i), this.editor.setHintingShapes([]), this.parent.transition("drawing", {
          shapeId: this.shapeId,
          ...n
        }));
      } catch {
      }
    });
    S(this, "onDoubleClick", (n) => {
    });
    S(this, "onPointerMove", (n) => {
      try {
        const i = this.editor.getShapeAtPoint(this.editor.inputs.currentPagePoint, {
          filter: (r) => r.type === "wall",
          hitInside: !0,
          margin: this.editor.options.hitTestMargin / this.editor.getZoomLevel()
        });
        i && (i == null ? void 0 : i.type) == "wall" ? this.editor.setHintingShapes([i]) : this.editor.setHintingShapes([]);
      } catch {
      }
    });
    S(this, "onCancel", () => {
    });
  }
}, S($m, "id", "idle"), $m);
var un = [];
for (var jm = 0; jm < 256; ++jm)
  un.push((jm + 256).toString(16).slice(1));
function Ghe(t, e = 0) {
  return (un[t[e + 0]] + un[t[e + 1]] + un[t[e + 2]] + un[t[e + 3]] + "-" + un[t[e + 4]] + un[t[e + 5]] + "-" + un[t[e + 6]] + un[t[e + 7]] + "-" + un[t[e + 8]] + un[t[e + 9]] + "-" + un[t[e + 10]] + un[t[e + 11]] + un[t[e + 12]] + un[t[e + 13]] + un[t[e + 14]] + un[t[e + 15]]).toLowerCase();
}
var uh, Whe = new Uint8Array(16);
function Hhe() {
  if (!uh && (uh = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !uh))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return uh(Whe);
}
var Vhe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const TA = {
  randomUUID: Vhe
};
function Hj(t, e, n) {
  if (TA.randomUUID && !e && !t)
    return TA.randomUUID();
  t = t || {};
  var i = t.random || (t.rng || Hhe)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, Ghe(i);
}
function Xd(t, e, n, i = 0) {
  const r = { x: e.x - t.x, y: e.y - t.y }, s = { x: n.x - t.x, y: n.y - t.y }, o = r.x * r.x + r.y * r.y;
  let c = (s.x * r.x + s.y * r.y) / o;
  c = Math.max(0, Math.min(1, c));
  const d = {
    x: t.x + c * r.x,
    y: t.y + c * r.y
  }, u = r.x * s.y - r.y * s.x;
  let h = 0, g = 0;
  u > 0 ? g = i : u < 0 && (g = -i);
  const p = {
    x: d.x + h,
    y: d.y + g
  }, M = Math.atan2(r.y, r.x) * (180 / Math.PI);
  return { ...p, rotation: M };
}
function Pc(t, e, n) {
  let i = 1 / 0, r = { pointA: null, pointB: null };
  const s = (o, a = null) => {
    if (a == null) {
      Array.isArray(e[o].next) && e[o].next.forEach((u) => s(o, u));
      return;
    }
    const c = a3(e[o], e[a], n), d = Khe(n, c);
    d < i && (i = d, r = { pointA: e[o], pointB: e[a] }), Array.isArray(e[a].next) && e[a].next.forEach((u) => s(a, u));
  };
  return t.forEach((o) => s(o)), r;
}
function a3(t, e, n) {
  try {
    const i = { x: e.x - t.x, y: e.y - t.y }, r = { x: n.x - t.x, y: n.y - t.y }, s = i.x * i.x + i.y * i.y;
    let a = (r.x * i.x + r.y * i.y) / s;
    return a = Math.max(0, Math.min(1, a)), {
      x: t.x + a * i.x,
      y: t.y + a * i.y
    };
  } catch {
    debugger;
  }
}
function Khe(t, e) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function Jd(t, e, n = 8) {
  const i = t.props.points, r = e.x, s = e.y;
  let o = null;
  const a = (c, d = null) => {
    if (d == null) {
      Array.isArray(i[c].next) && i[c].next.forEach((I) => a(c, I));
      return;
    }
    const u = i[c], h = i[d], g = t.x + u.x, p = t.y + u.y, f = t.x + h.x, M = t.y + h.y, m = a3(
      { x: g, y: p },
      { x: f, y: M },
      { x: r, y: s }
    ), y = Math.sqrt(Math.pow(r - m.x, 2) + Math.pow(s - m.y, 2));
    y < n && (n = y, o = { x: m.x - t.x, y: m.y - t.y, indexBefore: c, indexAfter: d }), Array.isArray(i[d].next) && i[d].next.forEach((I) => a(d, I));
  };
  return t.props.startPoints.forEach((c) => a(c)), o;
}
function Of(t, e) {
  const n = e.x - t.x, i = e.y - t.y;
  return Math.abs(n) > Math.abs(i) ? n > 0 ? "right" : "left" : i > 0 ? "down" : "up";
}
const Xhe = (t, e, n = 64, i = {}) => {
  const { inputs: r } = t, s = t.getShape(e), o = Jhe(s), a = qhe(r.currentPagePoint, n), { pointA: c, pointB: d } = Pc(s.props.startPoints, o, a), u = Xd(c, d, a, 1);
  if (!u) return;
  const h = Jd(s, u);
  if (!h) return;
  const g = _he(o, s, h, n), p = c3(o, h, g, s, n), f = `${h.indexBefore}-${h.indexAfter}`;
  s.props.decorations[f];
  const M = Hj();
  t.mark("place door");
  const m = $he(t, s, h, g, p, f, M, n, i);
  return l3(t, r, e, f, M), {
    shapeMetaId: m
  };
}, Jhe = (t) => {
  const e = structuredClone(t.props.points);
  for (const n in e)
    e[n].x += t.x, e[n].y += t.y;
  return e;
}, qhe = (t, e = 64) => ({
  x: Math.round(t.x / 16) * 16,
  // - (size / 2),
  y: Math.round(t.y / 16) * 16
  // - (size / 2)
}), _he = (t, e, n, i = 64) => {
  const r = new x(n.x, n.y, 0), s = e.props.points[n.indexAfter], a = new x(s.x, s.y, 0).sub(r).norm(), c = Of(t[n.indexBefore], t[n.indexAfter]), d = ["up", "left"].includes(c) ? "sub" : "add";
  return r[d](a.mul(i / 2));
}, c3 = (t, e, n, i, r = 64) => {
  const s = x.From(t[e.indexBefore]).dist(x.From(t[e.indexAfter]));
  return x.From(t[e.indexBefore]).dist(new x(n.x + i.x - r / 2, n.y + i.y - r / 2, 0)) / s;
}, $he = (t, e, n, i, r, s, o, a, c = {}) => {
  const d = Ee();
  t.updateShape({
    ...e,
    props: {
      ...e.props,
      decorations: {
        ...e.props.decorations,
        [s]: {
          ...e.props.decorations[s],
          [o]: {
            lerp: r,
            x: i.x,
            y: i.y,
            metaShapeId: d,
            type: "door",
            size: a,
            flipH: c.flipH ?? !1,
            flipV: c.flipV ?? !1
          }
        }
      }
    }
  });
  const u = e.props.points[n.indexBefore], h = e.props.points[n.indexAfter], g = {
    x: u.x + (h.x - u.x) * r,
    y: u.y + (h.y - u.y) * r
  }, p = Math.hypot(u.x - h.x, u.y - h.y), f = {
    x: (u.x - u.x) / p,
    y: (h.y - h.y) / p
  }, M = {
    x: g.x + f.x * a,
    y: g.y + f.y * a
  };
  return Math.atan2(h.y - u.y, h.x - u.x) * 180 / Math.PI, t.createShape({
    id: d,
    type: "floor-planner-meta",
    x: M.x,
    y: M.y,
    parentId: e.id,
    props: {
      targetShapeId: e.id,
      targetIndex: s,
      targetDecorationIndex: o
    }
  }), d;
}, l3 = (t, e, n, i, r) => {
  Lr.set({
    canvasX: e.currentScreenPoint.x,
    canvasY: e.currentScreenPoint.y,
    isOpen: !0,
    menuItems: [
      {
        label: "Flip H",
        onClick: () => bA(t, n, i, r, "flipH")
      },
      {
        label: "Flip V",
        onClick: () => bA(t, n, i, r, "flipV")
      }
    ]
  });
}, bA = (t, e, n, i, r) => {
  const s = t.getShape(e);
  t.updateShape({
    ...s,
    props: {
      ...s.props,
      decorations: {
        ...s.props.decorations,
        [n]: {
          ...s.props.decorations[n],
          [i]: {
            ...s.props.decorations[n][i],
            [r]: !s.props.decorations[n][i][r]
          }
        }
      }
    }
  });
};
var ey;
let ege = (ey = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "initialPagePoint", {});
    S(this, "initialPageTransform");
    S(this, "initialPageRotation");
    S(this, "info", {});
    S(this, "markId");
    S(this, "shapeId");
    S(this, "originalWallShape");
    S(this, "initialPoint", {});
    S(this, "callBack", null);
    S(this, "size", 64);
    S(this, "flipV", !1);
    S(this, "flipH", !1);
    S(this, "shapeHelperId", "");
    S(this, "onEnter", (n) => {
      this.shapeId = n.shapeId, this.callBack = n.callBack ?? null, this.originalWallShape = structuredClone(this.editor.getShape(this.shapeId)), this.shapeHelperId = Ee("drawing-door-helper");
      const { inputs: i } = this.editor, { currentPagePoint: r } = i;
      this.size = (n == null ? void 0 : n.size) ?? 64, this.flipV = (n == null ? void 0 : n.flipV) ?? !1, this.flipH = (n == null ? void 0 : n.flipH) ?? !1, this.editor.createShapes([
        {
          id: this.shapeHelperId,
          type: "geo",
          x: r.x,
          y: r.y,
          props: {
            w: this.size,
            h: this.size
          }
        }
      ]), n.shapeId && this.editor.updateShape({
        id: this.shapeHelperId,
        type: "box",
        opacity: 0
      });
    });
    S(this, "onExit", () => {
      this.editor.deleteShape(this.shapeHelperId);
    });
    S(this, "onPointerDown", (n) => {
      this.moveShape(n);
    });
    S(this, "moveShape", (n) => {
      const { inputs: i } = this.editor, r = this.editor.getShape(this.shapeId), s = structuredClone(r.props.points);
      for (const h in s)
        s[h].x += r.x, s[h].y += r.y;
      const o = {
        x: Math.round(i.currentPagePoint.x / 16) * 16,
        y: Math.round(i.currentPagePoint.y / 16) * 16
      }, { pointA: a, pointB: c } = Pc(r.props.startPoints, s, o), d = Xd(a, c, o, 1);
      if (!d) return;
      const u = Jd(r, d);
      u && this.editor.updateShape({
        id: this.shapeHelperId,
        type: "box",
        opacity: 1,
        //rotation: -(clampedMouse.rotation / (Math.PI * 180)),
        x: r.x + u.x - this.size / 2,
        y: r.y + u.y - this.size / 2
      });
    });
    S(this, "onPointerMove", (n) => {
      const { inputs: i } = this.editor;
      i.isDragging && this.moveShape(n);
    });
    S(this, "onPointerUp", (n) => {
      this.editor.updateShape({
        opacity: 0,
        id: this.shapeHelperId,
        type: "geo"
      });
      const i = Xhe(this.editor, this.shapeId, this.size, {
        flipH: this.flipH,
        flipV: this.flipV
      });
      this.callBack && i && this.callBack(n, this.shapeId, i.shapeMetaId);
    });
    S(this, "onCancel", () => {
    });
    S(this, "onComplete", () => {
    });
    S(this, "onDoubleClick", () => {
      this.complete();
    });
  }
  complete() {
    this.parent.transition("idle");
  }
}, S(ey, "id", "drawing"), ey);
class ng extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "wall");
    S(this, "onExit", () => {
      this.editor.setHintingShapes([]);
    });
    S(this, "onEnter", () => {
    });
  }
}
S(ng, "id", "door-tool"), S(ng, "initial", "idle"), S(ng, "children", () => [Bhe, ege]);
var ty;
let tge = (ty = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeId", "");
    S(this, "onEnter", (n) => {
      this.shapeId = n.shapeId, this.editor.setCursor({ type: "cross", rotation: 0 });
    });
    S(this, "onPointerDown", (n) => {
      try {
        const i = this.editor.getShapeAtPoint(this.editor.inputs.currentPagePoint, {
          filter: (r) => r.type === "wall",
          hitInside: !0,
          margin: this.editor.options.hitTestMargin / this.editor.getZoomLevel()
        });
        i && (i == null ? void 0 : i.type) == "wall" && (this.shapeId = i.id, this.editor.setHoveredShape(i), this.editor.setHintingShapes([]), this.parent.transition("drawing", {
          shapeId: this.shapeId,
          ...n
        }));
      } catch {
      }
    });
    S(this, "onDoubleClick", (n) => {
    });
    S(this, "onPointerMove", (n) => {
      try {
        const i = this.editor.getShapeAtPoint(this.editor.inputs.currentPagePoint, {
          filter: (r) => r.type === "wall",
          hitInside: !0,
          margin: this.editor.options.hitTestMargin / this.editor.getZoomLevel()
        });
        i && (i == null ? void 0 : i.type) == "wall" ? this.editor.setHintingShapes([i]) : this.editor.setHintingShapes([]);
      } catch {
      }
    });
    S(this, "onCancel", () => {
    });
  }
}, S(ty, "id", "idle"), ty);
const nge = (t, e, n = 64) => {
  const { inputs: i } = t, r = t.getShape(e), s = ige(r), o = rge(i.currentPagePoint), { pointA: a, pointB: c } = Pc(r.props.startPoints, s, o), d = Xd(a, c, o, 1);
  if (!d) return;
  const u = Jd(r, d);
  if (!u) return;
  const h = sge(s, r, u), g = oge(s, u, h, r), p = `${u.indexBefore}-${u.indexAfter}`;
  r.props.decorations[p];
  const f = Hj();
  return t.mark("place window"), {
    shapeMetaId: age(t, r, u, h, g, p, f, n)
  };
}, ige = (t) => {
  const e = structuredClone(t.props.points);
  for (const n in e)
    e[n].x += t.x, e[n].y += t.y;
  return e;
}, rge = (t) => ({
  x: Math.round(t.x / 16) * 16 - 32,
  y: Math.round(t.y / 16) * 16 - 32
}), sge = (t, e, n) => {
  const i = new x(n.x, n.y, 0), r = e.props.points[n.indexAfter], o = new x(r.x, r.y, 0).sub(i).norm(), a = Of(t[n.indexBefore], t[n.indexAfter]), c = ["up", "left"].includes(a) ? "sub" : "add";
  return i[c](o.mul(32));
}, oge = (t, e, n, i) => {
  const r = x.From(t[e.indexBefore]).dist(x.From(t[e.indexAfter]));
  return x.From(t[e.indexBefore]).dist(new x(n.x + i.x, n.y + i.y, 0)) / r;
}, age = (t, e, n, i, r, s, o, a = 64) => {
  const c = Ee();
  t.updateShape({
    ...e,
    props: {
      ...e.props,
      decorations: {
        ...e.props.decorations,
        [s]: {
          ...e.props.decorations[s],
          [o]: {
            lerp: r,
            metaShapeId: c,
            type: "window",
            size: a,
            flipH: !1,
            flipV: !1
          }
        }
      }
    }
  });
  const d = e.props.points[n.indexBefore], u = e.props.points[n.indexAfter], h = {
    x: d.x + (u.x - d.x) * r,
    y: d.y + (u.y - d.y) * r
  }, g = Math.hypot(d.x - u.x, d.y - u.y), p = {
    x: (d.x - d.x) / g,
    y: (u.y - u.y) / g
  }, f = {
    x: h.x - p.x * a,
    y: h.y - p.y * a
  };
  return t.createShape({
    id: c,
    type: "floor-planner-meta",
    x: f.x,
    y: f.y,
    parentId: e.id,
    props: {
      targetShapeId: e.id,
      targetIndex: s,
      targetDecorationIndex: o
    }
  }), c;
};
var ny;
let cge = (ny = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "initialPagePoint", {});
    S(this, "initialPageTransform");
    S(this, "initialPageRotation");
    S(this, "info", {});
    S(this, "markId");
    S(this, "shapeId");
    S(this, "originalWallShape");
    S(this, "initialPoint", {});
    S(this, "callBack", null);
    S(this, "size", 64);
    S(this, "shapeHelperId", "");
    S(this, "onEnter", (n) => {
      this.shapeId = n.shapeId, this.originalWallShape = structuredClone(this.editor.getShape(this.shapeId)), this.shapeHelperId = Ee("drawing-door-helper");
      const { inputs: i } = this.editor, { currentPagePoint: r } = i;
      this.size = (n == null ? void 0 : n.size) ?? 64, this.callBack = n.callBack ?? null, this.editor.createShapes([
        {
          id: this.shapeHelperId,
          type: "geo",
          x: r.x,
          y: r.y,
          props: {
            w: this.size,
            h: this.size / 2
          }
        }
      ]);
    });
    S(this, "onExit", () => {
      this.editor.deleteShape(this.shapeHelperId);
    });
    S(this, "onPointerDown", (n) => {
      this.moveShape(n);
    });
    S(this, "moveShape", (n) => {
      const { inputs: i } = this.editor, r = this.editor.getShape(this.shapeId), s = structuredClone(r.props.points);
      for (const h in s)
        s[h].x += r.x, s[h].y += r.y;
      const o = {
        x: Math.round(i.currentPagePoint.x / 16) * 16,
        y: Math.round(i.currentPagePoint.y / 16) * 16
      }, { pointA: a, pointB: c } = Pc(r.props.startPoints, s, o), u = Xd(a, c, o, 1);
      this.editor.updateShape({
        id: this.shapeHelperId,
        type: "box",
        opacity: 1,
        //rotation: -(clampedMouse.rotation / (Math.PI * 180)),
        x: u.x - this.size / 2,
        y: u.y - this.size / 4
      });
    });
    S(this, "onPointerMove", (n) => {
      const { inputs: i } = this.editor;
      i.isDragging && this.moveShape(n);
    });
    S(this, "onPointerUp", (n) => {
      this.editor.updateShape({
        opacity: 0,
        id: this.shapeHelperId,
        type: "geo"
      });
      const i = nge(this.editor, this.shapeId, this.size);
      this.callBack && i && this.callBack(n, this.shapeId, i.shapeMetaId);
    });
    S(this, "onCancel", () => {
    });
    S(this, "onComplete", () => {
    });
    S(this, "onDoubleClick", () => {
      this.complete();
    });
  }
  complete() {
    this.parent.transition("idle");
  }
}, S(ny, "id", "drawing"), ny);
class ig extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "wall");
    S(this, "onExit", () => {
      this.editor.setHintingShapes([]);
    });
  }
}
S(ig, "id", "window-tool"), S(ig, "initial", "idle"), S(ig, "children", () => [tge, cge]);
function lge(t) {
  try {
    const e = t.getShapeAtPoint(t.inputs.currentPagePoint, {
      hitInside: !1,
      hitLabels: !1,
      margin: t.options.hitTestMargin / t.getZoomLevel(),
      renderingOnly: !0
    });
    if (!e) return t.setHoveredShape(null);
    let n;
    const i = t.getOutermostSelectableShape(e);
    return i === e || i.id === t.getFocusedGroupId() || t.getSelectedShapeIds().includes(i.id) ? n = e : n = i, t.setHoveredShape(n.id);
  } catch {
    return null;
  }
}
const vA = nx(
  lge,
  32
);
var iy;
let dge = (iy = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeId", "");
    S(this, "activeHandleId", "");
    S(this, "onEnter", (n) => {
      var i;
      if (n.callBack) {
        this.editor.setHoveredShape(null), this.editor.setHintingShapes([]);
        return;
      }
      if (this.shapeId = n.shapeId ?? this.parent.shapeId, this.editor.setCursor({ type: "cross", rotation: 0 }), this.activeHandleId = (n == null ? void 0 : n.activeHandleId) ?? null, n.shapeId) {
        const r = this.editor.getShape(n.shapeId);
        r && (r == null ? void 0 : r.type) == "wall" ? (this.shapeId = r.id, this.editor.setHoveredShape(r), this.editor.setHintingShapes([])) : (this.editor.setHoveredShape(null), this.editor.setHintingShapes([])), this.parent.transition("drawing", {
          shapeId: this.shapeId,
          ...n
        });
      } else {
        const r = this.editor.getSelectedShapes();
        if (r.length !== 0 && ((i = r[0]) == null ? void 0 : i.type) == "wall")
          this.editor.setHintingShapes([]), this.shapeId = r[0].id, this.parent.transition("drawing", {
            shapeId: this.shapeId,
            ...n
          });
        else {
          const s = this.editor.getCurrentPageShapes().filter((o) => o.type == "wall");
          if (s.length > 0) {
            const o = s[0];
            o && (o == null ? void 0 : o.type) == "wall" && (this.shapeId = o.id, this.editor.setHoveredShape(o), this.editor.setHintingShapes([]), this.parent.transition("drawing", {
              shapeId: this.shapeId,
              ...n
            }));
          }
        }
      }
    });
    S(this, "onPointerDown", (n) => {
      vA(this.editor);
      const i = this.editor.getHoveredShape();
      i && (i == null ? void 0 : i.type) == "wall" ? (this.shapeId = i.id, this.editor.setHoveredShape(i), this.editor.setHintingShapes([])) : (this.editor.setHoveredShape(null), this.editor.setHintingShapes([])), this.parent.transition("drawing", {
        shapeId: this.shapeId,
        ...n
      });
    });
    S(this, "onDoubleClick", (n) => {
    });
    S(this, "onPointerMove", (n) => {
      vA(this.editor);
      const i = this.editor.getHoveredShape();
      i && (i == null ? void 0 : i.type) == "wall" ? this.editor.setHintingShapes([i]) : this.editor.setHintingShapes([]);
    });
    S(this, "onCancel", () => {
    });
  }
}, S(iy, "id", "idle"), iy);
var ry;
let uge = (ry = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "initialPagePoint", {});
    S(this, "initialPageTransform");
    S(this, "initialPageRotation");
    S(this, "info", {});
    S(this, "markId");
    S(this, "shape", {});
    S(this, "previousHandleId", "");
    S(this, "shapeId", "");
    S(this, "initialPoint", {});
    S(this, "activeHandleId", "");
    S(this, "activeHandleBeforeLongPress", "");
    S(this, "callBack", null);
    S(this, "shapeBeforeLongPress", {});
    S(this, "measurementArrowId", null);
    S(this, "onEnter", (n) => {
      const { inputs: i } = this.editor, { currentPagePoint: r } = i;
      if (this.measurementArrowId) {
        const o = this.editor.getShape(this.measurementArrowId);
        o && this.editor.deleteShape(o.id);
      }
      this.initialPoint = n.point, this.callBack = n.callBack ?? null, this.markId = void 0;
      const s = n.shapeId && this.editor.getShape(n.shapeId);
      if (this.initialPageTransform = this.editor.getShapePageTransform(this.shape), this.initialPageRotation = this.initialPageTransform.rotation(), this.initialPagePoint = this.editor.inputs.originPagePoint.clone(), this.initialPagePoint.x = Math.round(this.initialPagePoint.x / jn) * jn, this.initialPagePoint.y = Math.round(this.initialPagePoint.y / jn) * jn, s)
        s.props.points, this.shape = s, this.editor.select(s.id), this.activeHandleId = (n == null ? void 0 : n.activeHandleId) ?? null, rr.set({
          shapeId: s.id,
          handleId: this.activeHandleId
        });
      else {
        const o = Ee();
        this.markId = `creating:${o}`, this.editor.mark(this.markId), this.editor.createShapes([{
          id: o,
          type: "wall",
          x: this.initialPagePoint.x,
          y: this.initialPagePoint.y,
          props: {
            //scale: this.editor.user.getIsDynamicResizeMode() ? 1 / this.editor.getZoomLevel(): 1
            points: {
              a1: {
                id: "a1",
                index: "a1",
                x: 0,
                y: 0,
                wallType: "wall",
                before: null,
                next: []
              }
            }
          }
        }]), this.editor.select(o), this.shape = this.editor.getShape(o), this.activeHandleId = "a1", rr.set({
          shapeId: o,
          handleId: "a1"
        });
      }
      this.editor.setHoveredShape(this.shape), this.shapeId = this.shape.id;
    });
    S(this, "onLongPress", (n) => {
      switch (n.target) {
        case "handle":
          return;
      }
      if (this.activeHandleId !== null) return;
      const { editor: i } = this, { initialPageRotation: r } = this, {
        inputs: { currentPagePoint: s }
      } = i, o = structuredClone(i.getShape(this.shapeId));
      if (this.activeHandleBeforeLongPress = this.activeHandleId, this.shapeBeforeLongPress = structuredClone(o), !o) return;
      s.clone().sub(x.From(o)).rot(-r), this.editor.mark(this.markId), this.shape = o;
      const a = o.props.points[this.activeHandleId].before, c = o.props.points[a];
      let d = c.next.filter((u) => u != this.activeHandleId);
      c.next = d, o.props.startPoints.push(this.activeHandleId), o.props.points[this.activeHandleId].before = null, this.editor.updateShape(o), this.shape = o;
    });
    S(this, "onLongPressOld", (n) => {
    });
    S(this, "onPointerUp", (n) => {
      if (this.measurementArrowId) {
        const i = this.editor.getShape(this.measurementArrowId);
        i && this.editor.deleteShape(i.id), this.measurementArrowId = null;
      }
    });
    S(this, "onPointerDown", (n) => {
      switch (n.target) {
        case "handle":
          const i = rr.get();
          if (i.handleId == n.handle.index && i.shapeId == this.shapeId) {
            this.previousHandleId = this.activeHandleId, this.activeHandleId = null, rr.set({
              shapeId: this.shape.id,
              handleId: null
            });
            return;
          }
          const r = this.editor.getShape(this.shapeId);
          try {
            Bl(r.props.points[n.handle.index].thickness ?? "external"), Wj(r.props.points[n.handle.index].color ?? "black");
          } catch {
          }
          this.activeHandleId = n.handle.index, rr.set({
            shapeId: this.shape.id,
            handleId: n.handle.index
          });
          return;
        default:
          this.addWall(this.activeHandleId);
          break;
      }
    });
    S(this, "getMeasurementShape", () => {
      this.measurementArrowId || (this.measurementArrowId = Ee(), this.editor.createShape({
        id: this.measurementArrowId,
        type: "arrow",
        props: {
          arrowheadStart: "arrow",
          arrowheadEnd: "arrow",
          text: "0 meters",
          start: { x: 0, y: 0 },
          end: { x: 1, y: 0 }
        },
        opacity: 0
      }));
      const n = this.editor.getShape(this.measurementArrowId);
      return n || this.editor.createShape({
        id: this.measurementArrowId,
        type: "arrow",
        props: {
          arrowheadStart: "arrow",
          arrowheadEnd: "arrow",
          text: "0 meters",
          start: { x: 0, y: 0 },
          end: { x: 1, y: 0 }
        },
        opacity: 0
      }), n;
    });
    S(this, "updateMeasurement", () => {
      const { showRuler: n, rulerMeasurement: i } = _o();
      if (!n) return;
      const r = this.getMeasurementShape();
      if (this.activeHandleId == null) {
        this.editor.updateShape({
          ...r,
          opacity: 0
        });
        return;
      }
      let s = this.editor.getShape(this.shapeId);
      const o = s.props.points[this.activeHandleId];
      if (!o || !o.before) return;
      const a = s.props.points[o.before];
      if (!a) return;
      const c = Math.sqrt(Math.pow(o.x - a.x, 2) + Math.pow(o.y - a.y, 2)), d = x.From(a).sub(x.From(o)).norm();
      let u = d.y * -40, h = d.x * 40;
      this.editor.updateShape({
        ...r,
        opacity: 1,
        props: {
          ...r == null ? void 0 : r.props,
          text: `${(c / Cue()).toFixed(2)}  ${i}`,
          start: { x: a.x + s.x + u, y: a.y + s.y + h },
          end: { x: o.x + s.x + u, y: o.y + s.y + h }
        }
      });
    });
    S(this, "onPointerMove", (n) => {
      const { inputs: i } = this.editor;
      let r = this.activeHandleId;
      if (i.isDragging && this.activeHandleId == null && (r = this.previousHandleId, this.activeHandleId = r, rr.set({
        shapeId: this.shape.id,
        handleId: r
      })), r == null || !i.isDragging || i.isPanning || i.isPinching) return;
      const { currentPagePoint: s } = i, { editor: o, initialPagePoint: a } = this, { initialPageRotation: c } = this;
      let d = o.getShape(this.shapeId);
      if (!d) return;
      this.updateMeasurement();
      let u = s.clone().sub(x.From(d)).rot(-c);
      d = {
        ...d,
        props: {
          ...this.shape.props,
          points: {
            ...this.shape.props.points,
            [r]: {
              ...this.shape.props.points[r],
              x: Math.round(u.x / jn) * jn,
              y: Math.round(u.y / jn) * jn
            }
          }
        }
      }, this.editor.updateShape(d), this.shape = d;
    });
    S(this, "onCancel", () => {
    });
    S(this, "onComplete", () => {
    });
    S(this, "onDoubleClick", () => {
      this.complete();
    });
  }
  calculateIndex(n) {
    return hi(n);
  }
  addWall(n = null) {
    var g;
    const i = Gj(), { editor: r, initialPagePoint: s } = this, { initialPageRotation: o } = this, {
      inputs: { currentPagePoint: a }
    } = r;
    this.info.shape;
    const c = r.getShape(this.shapeId);
    if (this.activeHandleBeforeLongPress = this.activeHandleId, this.shapeBeforeLongPress = structuredClone(c), !c) return;
    r.getShapeUtil(c);
    let d = a.clone().sub(x.From(c)).rot(-o);
    this.editor.mark(this.markId), this.shape = this.editor.getShape(this.shape.id);
    const u = Object.keys(this.shape.props.points).filter(Boolean).sort(Jt), h = this.calculateIndex(u[u.length - 1]);
    n = n ?? null, this.activeHandleId = h, rr.set({
      shapeId: this.shape.id,
      handleId: h
    }), !n || !this.shape.props.points[n] ? this.editor.updateShape({
      ...this.shape,
      props: {
        ...this.shape.props,
        startPoints: [
          ...this.shape.props.startPoints,
          h
        ],
        points: {
          ...this.shape.props.points,
          [h]: {
            id: h,
            index: h,
            before: n,
            color: i.color,
            thickness: i.thickness,
            next: [],
            x: Math.round(d.x / jn) * jn,
            y: Math.round(d.y / jn) * jn
          }
        }
      }
    }) : this.editor.updateShape({
      ...this.shape,
      props: {
        ...this.shape.props,
        points: {
          ...this.shape.props.points,
          [n]: {
            ...this.shape.props.points[n],
            next: [
              ...((g = this.shape.props.points[n]) == null ? void 0 : g.next) ?? [],
              h
            ]
          },
          [h]: {
            id: h,
            index: h,
            before: n,
            next: [],
            color: i.color,
            thickness: i.thickness,
            x: Math.round(d.x / jn) * jn,
            y: Math.round(d.y / jn) * jn
          }
        }
      }
    }), this.shape = this.editor.getShape(this.shape.id);
  }
  complete() {
    this.parent.transition("idle");
  }
}, S(ry, "id", "drawing"), ry);
class d3 extends ee {
  constructor() {
    super(...arguments);
    S(this, "initialPagePoint", {});
    S(this, "initialPageTransform");
    S(this, "initialPageRotation");
    S(this, "info", {});
    S(this, "shape");
    S(this, "initialHandle");
    S(this, "shapeId");
    S(this, "onEnter", (n) => {
      const { handle: i } = n;
      switch (this.initialHandle = structuredClone(n.handle), this.shape = n.shape, this.shapeId = this.shape.id, this.initialPageTransform = this.editor.getShapePageTransform(this.shape), this.initialPageRotation = this.initialPageTransform.rotation(), this.initialPagePoint = this.editor.inputs.originPagePoint.clone(), this.initialHandle.type) {
        case "create":
          this.editor.updateShape({
            ...this.shape,
            props: {
              points: {
                ...this.shape.props.points,
                [i.index]: { id: i.index, index: i.index, x: i.x, y: i.y }
              }
            }
          });
          const s = this.editor.getShapeHandles(this.shape).find((o) => o.index === i.index);
          this.initialHandle = structuredClone(s);
          break;
        case "vertex":
          break;
        default:
          alert(this.initialHandle.type);
      }
    });
    S(this, "onPointerDown", (n) => {
    });
    S(this, "onPointerMove", (n) => {
      const { isDragging: i } = this.editor.inputs;
      if (!i) return;
      const { editor: r, shapeId: s, initialPagePoint: o } = this, { initialHandle: a, initialPageRotation: c } = this, {
        inputs: { currentPagePoint: d }
      } = r;
      this.info.shape;
      const u = r.getShape(this.shapeId);
      if (!u) return;
      r.getShapeUtil(u);
      let h = d.clone().sub(o).rot(-c).add(a);
      this.editor.updateShape({
        ...u,
        type: "wall",
        props: {
          ...u.props,
          points: {
            ...u.props.points,
            [this.initialHandle.id]: {
              ...u.props.points[this.initialHandle.id],
              x: Math.floor(h.x / hh) * hh,
              y: Math.floor(h.y / hh) * hh
            }
          }
        }
      });
    });
    S(this, "onPointerUp", (n) => {
      this.complete();
    });
    S(this, "onCancel", () => {
      this.complete();
    });
    S(this, "onComplete", () => {
      this.complete();
    });
    S(this, "onDoubleClick", () => {
      this.complete();
    });
  }
  complete() {
    this.parent.transition("drawing", {
      ...this.info,
      shapeId: this.shapeId
    });
  }
}
S(d3, "id", "drag-handle");
const hh = 8;
class rg extends ee {
  constructor() {
    super(...arguments);
    S(this, "activeHandleId", "");
    S(this, "shapeId", "");
    S(this, "shapeType", "wall");
    S(this, "onExit", () => {
      this.editor.setHintingShapes([]);
    });
  }
}
S(rg, "id", "wall-tool"), S(rg, "initial", "idle"), S(rg, "children", () => [dge, uge, d3]);
var sy;
let u3 = (sy = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "onPointerDown", (n) => {
      this.parent.transition("erasing", n);
    });
  }
}, S(sy, "id", "idle"), sy);
const sp = xt(
  "floor planner atom",
  {}
);
function ex(t) {
  return sp.get();
}
function gh(t, e) {
  const n = ex(), i = Object.keys(e), r = Object.keys(n);
  t.run(
    () => {
      if (i.length === r.length) {
        for (let s = 0; s < i.length; s++)
          if (!n[i[s]] || e[i[s]] !== n[i[s]]) {
            sp.set(e);
            break;
          }
      } else
        sp.set(e);
    },
    { history: "ignore" }
  );
}
class Vj extends ee {
  constructor() {
    super(...arguments);
    S(this, "scribbleId", "");
    S(this, "followShapeId", "");
    S(this, "onEnter", (n) => {
      gh(this.editor, {});
      const i = this.editor.scribbles.addScribble({
        color: "muted-1",
        opacity: 0.7,
        size: 4,
        delay: 500,
        shrink: 0.05,
        taper: !0
      });
      this.scribbleId = i.id, this.followShapeId = null;
    });
    S(this, "onPointerMove", (n) => {
      try {
        this.update();
      } catch {
      }
    });
    S(this, "onPointerUp", (n) => {
      this.complete();
    });
    S(this, "onCancel", () => {
      this.cancel();
    });
    S(this, "onComplete", () => {
      this.complete();
    });
  }
  updateFollowShape() {
    if (this.followShapeId || (this.followShapeId = Ee(), this.editor.createShape({
      id: this.followShapeId,
      type: "geo",
      x: this.editor.inputs.currentPagePoint.x - 16,
      y: this.editor.inputs.currentPagePoint.y - 16,
      props: {
        geo: "rectangle",
        w: 32,
        h: 32
      }
    })), this.followShapeId) {
      const n = this.editor.getShape(this.followShapeId);
      this.editor.updateShape({
        ...n,
        id: this.followShapeId,
        type: "geo",
        x: this.editor.inputs.currentPagePoint.x - 16,
        y: this.editor.inputs.currentPagePoint.y - 16
      });
    }
  }
  pushPointToScribble() {
    const { x: n, y: i } = this.editor.inputs.currentPagePoint;
    this.editor.scribbles.addPoint(this.scribbleId, n, i);
  }
  update() {
    this.pushPointToScribble();
    const { inputs: n } = this.editor, i = this.editor.getShapeAtPoint(n.currentPagePoint, {
      //filter: (shape) => shape.type === 'wall',
      hitInside: !0,
      margin: this.editor.options.hitTestMargin / this.editor.getZoomLevel()
    });
    if (i)
      if (i.type === "wall") {
        const r = {
          x: Math.round(n.currentPagePoint.x / 16) * 16,
          y: Math.round(n.currentPagePoint.y / 16) * 16
        }, s = structuredClone(i.props.points);
        for (const p in s)
          s[p].x += i.x, s[p].y += i.y;
        const { pointA: o, pointB: a } = Pc(i.props.startPoints, s, r), c = Jd(i, r, 8);
        if (!c) return;
        const u = ex(this.editor), h = `${i.id}-${c.indexBefore}-${c.indexAfter}`;
        let g = !1;
        u[h] || (g = !0), u[h] = {
          beforeIndex: c.indexBefore,
          afterIndex: c.indexAfter,
          shapeId: i.id
        }, gh(this.editor, u), g && this.editor.updateShape({
          ...i,
          props: {
            ...i.props,
            forceRerender: Math.random() + Math.random()
          }
        });
      } else {
        const { editor: r } = this, s = r.getErasingShapeIds(), o = r.getZoomLevel(), a = r.getCurrentPageShapes(), {
          inputs: { currentPagePoint: c, previousPagePoint: d }
        } = r;
        this.pushPointToScribble();
        const u = new Set(s), h = 4 / o;
        for (const g of a) {
          if (["group", "wall", "grid", "legend"].includes(g.type)) continue;
          const p = r.getShapeMask(g.id);
          if (p && !yi(c, p))
            continue;
          const f = r.getShapeGeometry(g), M = r.getShapePageTransform(g);
          if (!f || !M) continue;
          const m = M.clone().invert(), y = m.applyToPoint(d), I = m.applyToPoint(c), { bounds: D } = f;
          D.minX - h > Math.max(y.x, I.x) || D.minY - h > Math.max(y.y, I.y) || D.maxX + h < Math.min(y.x, I.x) || D.maxY + h < Math.min(y.y, I.y) || f.hitTestLineSegment(y, I, h) && u.add(r.getOutermostSelectableShape(g).id);
        }
        this.editor.setErasingShapes([...u]);
      }
  }
  complete() {
    const { editor: n } = this;
    n.run(
      () => {
        n.deleteShapes(n.getCurrentPageState().erasingShapeIds), n.setErasingShapes([]);
        const i = ex(), r = {};
        Object.keys(i).forEach((o) => {
          const a = i[o];
          r[a.shapeId] || (r[a.shapeId] = []), r[a.shapeId].push(a);
        }), this.editor.mark("erasing shape");
        for (const o in r) {
          const a = structuredClone(n.getShape(o));
          if (n.getShapeAndDescendantIds([a.id]), a) {
            const c = a.props.points;
            r[o].forEach((d) => {
              const { beforeIndex: u, afterIndex: h } = d;
              c[u];
              const g = a.props.decorations[`${u}-${h}`];
              if (g)
                for (const p in g)
                  n.deleteShape(g[p].metaShapeId);
              delete a.props.decorations[`${u}-${h}`], a.props.points[u].next = a.props.points[u].next.filter((p) => p !== h), a.props.points[h].before = null, a.props.points[u].before == null && a.props.points[u].next.length == 0 && (delete a.props.points[u], a.props.startPoints = a.props.startPoints.filter((p) => p !== u)), a.props.points[h].before == null && a.props.points[h].next.length == 0 ? (delete a.props.points[h], a.props.startPoints = a.props.startPoints.filter((p) => p !== h)) : a.props.startPoints.push(h);
            }), n.updateShape(a);
          }
        }
        n.scribbles.stop(this.scribbleId), gh(n, {});
        const s = n.getSelectedShapes();
        for (const o of s)
          o.type == "wall" && Object.values(o.props.points).length == 0 && (n.setSelectedShapes([]), n.deleteShape(o.id), s.splice(s.indexOf(o), 1), n.deleteShape(o.id));
        n.setSelectedShapes(s);
      }
    ), this.parent.transition("idle");
  }
  cancel() {
    const { editor: n } = this;
    n.scribbles.stop(this.scribbleId), gh(n, []), this.parent.transition("idle");
  }
}
S(Vj, "id", "erasing");
var ml;
let hge = (ml = class extends ee {
}, S(ml, "id", "eraser-tool"), S(ml, "initial", "idle"), S(ml, "children", () => [u3, Vj]), ml);
var oy;
let gge = (oy = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "onPointerDown", (n) => {
      this.parent.transition("drawing", n);
    });
  }
}, S(oy, "id", "idle"), oy);
var ay;
let pge = (ay = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "scribbleId", "");
    S(this, "intersectPoints", []);
    S(this, "intersectHashes", {});
    S(this, "hasStoppedScribble", !1);
    S(this, "onEnter", (n) => {
      this.intersectHashes = {}, this.intersectPoints = [];
      const i = this.editor.scribbles.addScribble({
        color: "laser",
        opacity: 0.7,
        size: 4,
        delay: 1e3,
        shrink: 0.05,
        taper: !0
      });
      this.scribbleId = i.id;
    });
    S(this, "onPointerMove", (n) => {
      try {
        const { inputs: i } = this.editor;
        this.pushPointToScribble();
        const r = {
          x: Math.round(i.currentPagePoint.x / 16) * 16,
          y: Math.round(i.currentPagePoint.y / 16) * 16
        }, s = this.editor.getShapeAtPoint(this.editor.inputs.currentPagePoint, {
          filter: (g) => g.type === "wall",
          hitInside: !0,
          margin: this.editor.options.hitTestMargin / this.editor.getZoomLevel()
        });
        if (!s) return;
        this.hasStoppedScribble || this.clearScribbles();
        const o = structuredClone(s.props.points);
        for (const g in o)
          o[g].x += s.x, o[g].y += s.y;
        const { pointA: a, pointB: c } = Pc(s.props.startPoints, o, r), u = Xd(a, c, r, 1), h = Jd(s, u);
        if (!h) return;
        if (rr.set({
          shapeId: s.id,
          handleId: h.indexBefore
        }), this.intersectPoints.length > 0) {
          const g = this.editor.getShape(this.intersectPoints[this.intersectPoints.length - 1].metaShapeId);
          if (!g) return;
          this.editor.updateShape({
            ...g,
            id: g.id,
            type: "geo",
            x: s.x + h.x - 16 / 2,
            y: s.y + h.y - 16 / 2
          }), this.intersectPoints[this.intersectPoints.length - 1].x = h.x, this.intersectPoints[this.intersectPoints.length - 1].y = h.y, this.intersectPoints[this.intersectPoints.length - 1].pointA = h.indexBefore, this.intersectPoints[this.intersectPoints.length - 1].pointB = h.indexAfter;
        } else {
          const g = Ee();
          this.editor.createShape({
            id: g,
            type: "geo",
            x: s.x + h.x - 16 / 2,
            y: s.y + h.y - 16 / 2,
            props: {
              geo: "ellipse",
              w: 16,
              h: 16,
              size: "s",
              fill: "solid"
            }
          }), this.intersectPoints.push({
            metaShapeId: g,
            wallShapeId: s.id,
            pointA: h.indexBefore,
            pointB: h.indexAfter,
            x: h.x,
            y: h.y
          });
        }
      } catch {
      }
    });
    S(this, "onExit", () => {
      this.hasStoppedScribble || this.clearScribbles();
    });
    S(this, "onPointerUp", (n) => {
      const i = {};
      this.intersectPoints.forEach((r) => {
        i[r.wallShapeId] || (i[r.wallShapeId] = []), i[r.wallShapeId].push(r);
      });
      for (const r in i)
        this.editor.deleteShape(i[r][0].metaShapeId);
      this.editor.mark("intersection.");
      for (const r in i) {
        const s = structuredClone(this.editor.getShape(r)), a = i[r][0], c = Object.keys(s.props.points).sort(Jt), d = hi(c[c.length - 1]);
        s.props.points[a.pointA] = {
          ...s.props.points[a.pointA],
          next: [...s.props.points[a.pointA].next, d].filter((u) => u !== a.pointB)
        };
        try {
          Bl(s.props.points[a.pointA].thickness ?? "external"), Wj(s.props.points[a.pointA].color ?? "black");
        } catch {
        }
        s.props.points[d] = {
          id: d,
          index: d,
          x: this.intersectPoints[0].x,
          y: this.intersectPoints[0].y,
          thickness: s.props.points[a.pointA].thickness ?? "external",
          color: s.props.points[a.pointA].color ?? "black",
          next: [
            a.pointB
          ]
        }, this.recalculateDecorations(s, a.pointA, a.pointB, d), this.editor.updateShape({
          ...s
        }), this.editor.setCurrentTool("floor-planner.wall-tool.drawing", {
          shapeId: r,
          activeHandleId: d
        });
      }
    });
  }
  pushPointToScribble() {
    if (this.intersectPoints.length !== 0) return;
    const { x: n, y: i } = this.editor.inputs.currentPagePoint;
    this.editor.scribbles.addPoint(this.scribbleId, n, i);
  }
  clearScribbles() {
    this.editor.scribbles.stop(this.scribbleId), this.editor.scribbles.reset(), this.hasStoppedScribble = !0;
  }
  buildIntersectionHash(n, i) {
    return n = Math.floor(n / 64) * 64, i = Math.floor(i / 64) * 64, `${n}-${i}`;
  }
  recalculateDecorations(n, i, r, s) {
    const o = n.props.decorations, a = `${i}-${r}`, c = `${i}-${s}`, d = `${s}-${r}`;
    if (o[a]) {
      const u = x.From(n.props.points[i]), h = x.From(n.props.points[r]), g = x.From(n.props.points[s]), p = o[a], f = {}, M = {};
      for (const m in p) {
        const y = p[m], { lerp: I } = y, D = u.x + (h.x - u.x) * I, j = u.y + (h.y - u.y) * I, w = new x(D, j, 0), A = g.dist(u), b = h.dist(g);
        if (h.dist(u), g.dist(w) <= A) {
          const T = u.dist(w) / A;
          f[m] = {
            ...y,
            lerp: T
          };
        } else {
          const T = g.dist(w) / b;
          M[m] = {
            ...y,
            lerp: T
          };
        }
      }
      n.props.decorations[c] = f, n.props.decorations[d] = M, delete n.props.decorations[a];
    }
  }
}, S(ay, "id", "drawing"), ay);
class sg extends ee {
}
S(sg, "id", "intersect-tool"), S(sg, "initial", "idle"), S(sg, "children", () => [gge, pge]);
var cy;
let fge = (cy = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeId", "");
    S(this, "onEnter", (n) => {
      this.shapeId = n.shapeId, this.editor.setCursor({ type: "cross", rotation: 0 });
    });
    S(this, "onPointerDown", (n) => {
      this.parent.transition("drawing", {
        shapeId: this.shapeId,
        ...n
      });
    });
    S(this, "onCancel", () => {
    });
  }
}, S(cy, "id", "idle"), cy);
var ly;
let Mge = (ly = class extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
    S(this, "markId");
    S(this, "shape", {});
    S(this, "initialPoint", {});
    S(this, "startPoint", {});
    S(this, "pointCounter", 2);
    S(this, "onEnter", (n) => {
    });
  }
}, S(ly, "id", "drawing"), ly);
class og extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "line");
  }
}
S(og, "id", "ruler-tool"), S(og, "initial", "idle"), S(og, "children", () => [fge, Mge]);
const jn = 16;
class ag extends ee {
  constructor() {
    super(...arguments);
    S(this, "activeHandleId", "");
    S(this, "onExit", () => {
      this.editor.setHintingShapes([]);
    });
  }
}
S(ag, "id", "floor-planner"), S(ag, "initial", "wall-tool"), S(ag, "children", () => [rg, hge, ng, ig, sg, og]);
class h3 extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeId", "");
    S(this, "onEnter", (n) => {
      this.shapeId = n.shapeId, this.editor.setCursor({ type: "cross", rotation: 0 });
    });
    S(this, "onPointerDown", (n) => {
      this.parent.transition("drawing", {
        shapeId: this.shapeId,
        ...n
      });
    });
    S(this, "onCancel", () => {
    });
  }
}
S(h3, "id", "idle");
class g3 extends ee {
  constructor() {
    super(...arguments);
    S(this, "info", {});
    S(this, "markId");
    S(this, "shape", {});
    S(this, "initialPoint", {});
    S(this, "startPoint", {});
    S(this, "pointCounter", 0);
    S(this, "onEnter", (n) => {
      const { inputs: i } = this.editor, { currentPagePoint: r } = i;
      if (this.pointCounter = 0, this.markId = void 0, n.shapeId && this.editor.getShape(n.shapeId))
        alert("A");
      else {
        const o = ci.createId("compass");
        this.editor.createAssets([
          {
            id: o,
            type: "image",
            typeName: "asset",
            props: {
              name: "compass",
              src: "/resources/compass.svg",
              // You could also use a base64 encoded string here
              w: 100,
              h: 100,
              fileSize: 1,
              mimeType: "image/png",
              isAnimated: !1
            },
            meta: {}
          }
        ]);
        const a = Ee();
        this.markId = `creating:${a}`, this.editor.mark(this.markId), this.editor.createShape({
          id: a,
          type: "image",
          x: r.x,
          y: r.y,
          props: {
            assetId: o,
            w: 100,
            h: 100
          }
        }), this.editor.select(a), this.shape = this.editor.getShape(a);
      }
    });
    S(this, "onPointerMove", (n) => {
      const { inputs: i } = this.editor, { currentPagePoint: r } = i;
      i.isDragging && this.editor.updateShape({
        ...this.shape,
        x: r.x,
        y: r.y
      });
    });
    S(this, "onPointerUp", (n) => {
      this.shape && this.complete();
    });
    S(this, "onCancel", () => {
      this.parent.transition("idle");
    });
    S(this, "onComplete", () => {
      this.complete();
    });
    S(this, "onDoubleClick", () => {
      this.complete();
    });
  }
  complete() {
    this.editor.setCurrentTool("select.idle", {
      target: "shape",
      shape: this.shape
    });
  }
}
S(g3, "id", "drawing");
class cg extends ee {
  constructor() {
    super(...arguments);
    S(this, "shapeType", "image");
  }
}
S(cg, "id", "compass-tool"), S(cg, "initial", "idle"), S(cg, "children", () => [h3, g3]);
class lg extends ee {
}
S(lg, "id", "eraser-tool"), S(lg, "initial", "idle"), S(lg, "children", () => [u3, Vj]);
function mge({ handle: t, isCoarse: e, className: n, zoom: i, shapeId: r }) {
  const s = Q(), o = G("active handle", () => rr.get(), [r, s, rr.get()]), a = (e ? s.options.coarseHandleRadius : s.options.handleRadius) / i;
  if (t.type === "clone") {
    const u = 3 / i, h = `M0,${-u} A${u},${u} 0 0,1 0,${u}`, g = xv.indexOf(t.id);
    return /* @__PURE__ */ l.jsxs("g", { className: `tl-handle tl-handle__${t.type} ${n ?? ""}`, children: [
      /* @__PURE__ */ l.jsx("circle", { className: "tl-handle__bg", r: a }),
      /* @__PURE__ */ l.jsx("path", { className: "tl-handle__fg", d: h, transform: `rotate(${-90 + 90 * g})` })
    ] });
  }
  const c = (t.type === "create" && e ? 3 : 4) / Math.max(i, 0.25), d = r == o.shapeId && o.handleId == t.id;
  return /* @__PURE__ */ l.jsxs("g", { className: `tl-handle tl-handle__${t.type} ${n ?? ""}`, children: [
    /* @__PURE__ */ l.jsx("circle", { className: `tl-handle__bg${d ? "-active" : ""}`, r: a }),
    /* @__PURE__ */ l.jsx("circle", { className: `tl-handle__fg${d ? "-active" : ""}`, r: c })
  ] });
}
function yge({ children: t }) {
  const e = Q();
  return G(
    "shouldDisplayHandles",
    () => {
      if (e.isInAny(
        "select.idle",
        "select.pointing_handle",
        "select.pointing_shape",
        "wall.drawing",
        "floor-planner.drawing",
        "floor-planner.wall-tool.idle",
        "floor-planner.wall-tool.drawing",
        "floor-planner.intersect-tool.drawing"
      ))
        return !0;
      if (e.isInAny(
        "select.editing_shape",
        "wall.drawing",
        "floor-planner.drawing",
        "floor-planner.wall-tool.idle",
        "floor-planner.wall-tool.drawing",
        "floor-planner.intersect-tool.drawing"
      )) {
        const i = e.getOnlySelectedShape();
        return i && e.isShapeOfType(i, "note");
      }
      return !1;
    },
    [e]
  ) ? /* @__PURE__ */ l.jsx("svg", { className: "tl-user-handles tl-overlays__item", children: t }) : null;
}
const Ps = 30, Ige = 30, Dn = {
  x: 10,
  y: 10
}, is = 0.6;
class p3 extends ho {
  getDefaultProps() {
    return {
      w: 300,
      h: 50,
      legendWidth: 16,
      legendHeight: 16,
      legendCount: !0
    };
  }
  getGeometry(e) {
    return new Pi({
      width: e.props.w,
      height: e.props.h,
      isFilled: !0
    });
  }
  toSvg(e) {
    const n = Zn.get(), i = this.editor.getCurrentPageId(), r = n.page[i] && n.page[i].icons && Object.keys(n.page[i].icons).length > 0;
    return /* @__PURE__ */ l.jsx(l.Fragment, { children: r && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx("filter", { id: "dropshadow", height: "130%", children: /* @__PURE__ */ l.jsx("feDropShadow", { dx: "3", dy: "3", stdDeviation: "0.5", floodColor: "#000", floodOpacity: "0.33" }) }),
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          r: 16,
          width: e.props.w,
          height: e.props.h,
          fillOpacity: 1,
          fill: "white",
          color: "white",
          style: { filter: "url(#dropshadow)" },
          strokeWidth: 3,
          rx: 16,
          ry: 16
        }
      )
    ] }) });
  }
  component(e) {
    const n = G("legend-tool", () => Zn.get().page[this.editor.getCurrentPageId()] ?? { icons: {} }, [Zn, this.editor]);
    this.editor.getCurrentPageId();
    const i = n.icons && Object.keys(n.icons).length > 0;
    return ze(
      () => {
        const r = e.id, s = this.editor.getShapeAndDescendantIds([r]);
        s.delete(r);
        let o = Dn.y, a;
        if (Object.keys(n.icons).forEach((c) => {
          const d = Ee(`${r}-${c}`), u = Ee(`${r}-${c}-count`), h = Ee(`${r}-${c}-count-container`), g = this.editor.getShape(d), p = Ee(`${r}-${c}-image`);
          if (g ? this.editor.updateShapes(
            [
              {
                id: d,
                parentId: r,
                type: "text",
                y: o,
                x: Ps + Dn.x * 2,
                props: {
                  text: `${n.icons[c].label}`
                }
              },
              {
                id: h,
                parentId: r,
                type: "geo",
                y: o,
                x: Ps + Dn.x * 2 + is * ((e.props.w - (Ps + Dn.x)) * (1 + (1 - is)) - Dn.x),
                props: {
                  scale: is,
                  geo: "ellipse",
                  w: 24,
                  h: 24
                }
              },
              {
                id: u,
                parentId: h,
                type: "text",
                y: 4,
                x: 0,
                props: {
                  textAlign: "middle",
                  text: `${n.icons[c].count}`
                }
              },
              {
                id: p,
                parentId: r,
                type: "image",
                y: o,
                x: Dn.x
              }
            ]
          ) : (this.editor.createShape({
            id: p,
            type: "image",
            y: o,
            x: Dn.x,
            parentId: r,
            props: {
              assetId: n.icons[c].assetId,
              w: Ps,
              h: Ige
            }
          }), this.editor.createShape({
            id: d,
            type: "text",
            parentId: r,
            y: o,
            x: Ps + Dn.x * 2,
            props: {
              color: "black",
              autoSize: !1,
              w: (e.props.w - (Ps + Dn.x)) * (1 + (1 - is)) - Dn.x - 40,
              size: "s",
              scale: is,
              font: "sans",
              text: `${n.icons[c].label}`
            }
          }), this.editor.createShape({
            id: h,
            type: "geo",
            parentId: r,
            y: o,
            x: Ps + Dn.x * 2 + is * ((e.props.w - (Ps + Dn.x)) * (1 + (1 - is)) - Dn.x),
            props: {
              size: "m",
              color: "black",
              scale: is,
              geo: "ellipse",
              w: 24,
              h: 24
            }
          }), this.editor.createShape({
            id: u,
            type: "text",
            parentId: h,
            y: 4,
            x: 0,
            props: {
              color: "black",
              autoSize: !1,
              w: 40,
              size: "s",
              textAlign: "middle",
              scale: is,
              font: "sans",
              text: `${n.icons[c].count}`
            }
          })), s.delete(u), s.delete(h), s.delete(d), s.delete(p), a = this.editor.getShape(d), a) {
            const f = this.editor.getShapeGeometry(a);
            if (f) {
              const M = this.editor.getShape(p);
              if (M) {
                const m = this.editor.getShapeGeometry(
                  M
                ), {
                  y,
                  h: I
                } = m.bounds, {
                  y: D,
                  h: j
                } = f.bounds;
                j < I ? (this.editor.updateShape({
                  id: d,
                  y: o + y + (I - j) / 2,
                  type: "text"
                }), o += I + Dn.y) : (this.editor.updateShape({
                  id: p,
                  y: o + D + (j - I) / 2,
                  type: "image"
                }), o += f.bounds.h + Dn.y);
              } else
                o += f.bounds.h + Dn.y;
            }
          }
        }), o > e.props.h || e.props.h > this.getDefaultProps().h && o < e.props.h) {
          const c = this.editor.getShape(r), d = this.editor.getCurrentPageShapes().filter((p) => p.type == "grid"), u = d.length != 0 ? d[0] : null;
          let h = c.x, g = c.y;
          if (c && u) {
            const p = this.editor.getShapeGeometry(u), f = this.editor.getShapeGeometry(c);
            g = p.bounds.h - Math.max(this.getDefaultProps().h, o) - 10, h = p.bounds.w - f.bounds.w - 10;
          }
          this.editor.updateShape(
            {
              id: r,
              type: "legend",
              x: h,
              y: g,
              props: {
                ...e.props,
                h: Math.max(this.getDefaultProps().h, o)
              }
            }
          );
        }
        this.editor.deleteShapes(Array.from(s.values()));
      },
      [
        n,
        e
      ]
    ), /* @__PURE__ */ l.jsx(l.Fragment, { children: i && /* @__PURE__ */ l.jsx(Xi, { children: this.toSvg(e) }) });
  }
  indicator(e) {
    return /* @__PURE__ */ l.jsx("rect", { width: e.props.w, height: e.props.h });
  }
}
S(p3, "type", "legend");
const f3 = [
  { min: 0.15, mid: 1, step: 4 },
  { min: 0.7, mid: 2.5, step: 1 }
];
function xge(t, e, n, i = !1) {
  const [r, s] = e, [o, a] = n, c = o + (t - r) / (s - r) * (a - o);
  return i ? o < a ? Math.max(Math.min(c, a), o) : Math.max(Math.min(c, o), a) : c;
}
function Sge(t, e) {
  return f3.map(({ min: n, mid: i, step: r }, s) => {
    const o = r * t * e, a = 0.5 + 0 * e, c = 0.5 + 0 * e, d = a % o, u = c % o, h = e < i ? xge(e, [n, i], [0, 1]) : 1;
    return /* @__PURE__ */ l.jsxs(
      "pattern",
      {
        id: `grid-${r}`,
        width: o,
        height: o,
        patternUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ l.jsx(
            "line",
            {
              className: "tl-grid-line",
              x1: 0,
              y1: u,
              x2: o,
              y2: u,
              stroke: "black",
              strokeWidth: 0.5,
              opacity: h
            }
          ),
          /* @__PURE__ */ l.jsx(
            "line",
            {
              className: "tl-grid-line",
              x1: d,
              y1: 0,
              x2: d,
              y2: o,
              stroke: "black",
              strokeWidth: 0.5,
              opacity: h
            }
          )
        ]
      },
      `grid-pattern-${s}`
    );
  });
}
class M3 extends ho {
  constructor() {
    super(...arguments);
    S(this, "canEdit", () => !1);
    S(this, "canResize", () => !1);
    S(this, "canBeLaidOut", () => !1);
    S(this, "canBind", () => !1);
    S(this, "hideRotateHandle", () => !0);
    S(this, "hideResizeHandles", () => !0);
    S(this, "canReceiveNewChildrenOfType", (n, i) => !n.isLocked);
    S(this, "canDropShapes", (n, i) => !0);
    S(this, "onDragShapesOver", (n, i) => {
      this.editor.reparentShapes(i, n.id);
    });
    S(this, "onDragShapesOut", (n, i) => {
      const r = this.editor.getShape(n.parentId);
      r && this.editor.isShapeOfType(r, "group") ? this.editor.reparentShapes(i, r.id) : this.editor.reparentShapes(i, this.editor.getCurrentPageId());
    });
  }
  getDefaultProps() {
    return {
      w: 300,
      h: 200,
      gridSize: 16,
      rulerUnit: "m",
      pixelToUnit: 64,
      renderType: "grid",
      showRuler: !0
    };
  }
  onRotate(n, i) {
    return n;
  }
  onRotateEnd(n, i) {
    return n;
  }
  onTranslate(n, i) {
    return n;
  }
  getGeometry(n) {
    return new Pi({
      width: n.props.w,
      height: n.props.h,
      isFilled: !1,
      ignore: !0
    });
  }
  toSvg(n) {
    const i = n.props.gridSize, r = 1, s = n.props.renderType ?? "grid";
    return /* @__PURE__ */ l.jsx(l.Fragment, { children: s === "grid" && /* @__PURE__ */ l.jsxs(Xi, { id: n.id, children: [
      /* @__PURE__ */ l.jsx("defs", { children: Sge(i, r) }),
      f3.map(({ step: o }, a) => /* @__PURE__ */ l.jsx("rect", { width: "100%", height: "100%", fill: `url(#grid-${o})` }, `grid-rect-${a}`))
    ] }) });
  }
  component(n) {
    return /* @__PURE__ */ l.jsx(l.Fragment, { children: this.toSvg(n) });
  }
  providesBackgroundForChildren() {
    return !0;
  }
  indicator(n) {
    return /* @__PURE__ */ l.jsx(l.Fragment, {});
  }
}
S(M3, "type", "grid");
const jge = Xe({
  id: Ne,
  type: Ne,
  index: Va,
  next: Uy,
  thickness: Ne,
  wallType: Ne,
  color: Ne,
  before: Va,
  x: we,
  y: we
}), Dge = Xe({
  id: Ne,
  metaShapeId: Ne,
  type: Ne,
  size: we,
  lerp: we,
  index: Va,
  x: we,
  y: we
});
Ha(Ne, jge), Ha(Ne, Dge), sn(Ne);
const Dm = {
  external: 16,
  internal: 8,
  partition: 2
}, wge = new hr();
class m3 extends Ci {
  constructor(n) {
    super(n);
    S(this, "hideResizeHandles", () => !0);
    S(this, "hideRotateHandle", () => !0);
    S(this, "hideSelectionBoundsFg", () => !0);
    S(this, "hideSelectionBoundsBg", () => !0);
    S(this, "onDuplicateComplete", (n, i) => {
      const r = this.editor.getCurrentPageShapes().filter((u) => u.type == "wall" && u.id !== n.id);
      if (r.length == 0) return;
      let s = structuredClone(n), o = structuredClone(r[0]), a = Object.keys(o.props.points).sort(Jt).slice(-1)[0], c = /* @__PURE__ */ new Map();
      Object.keys(s.props.points).forEach((u) => {
        a = hi(a), c.set(u, a);
      }), s.props.startPoints = s.props.startPoints.map((u) => c.get(u));
      for (const u in s.props.points)
        s.props.points[u].x += n.x - o.x, s.props.points[u].y += n.y - o.y, s.props.points[u].before = s.props.points[u].before == null ? null : c.get(s.props.points[u].before), s.props.points[u].next = s.props.points[u].next.map((h) => c.get(h)), s.props.points[c.get(u)] = s.props.points[u], delete s.props.points[u];
      for (const u in s.props.decorations) {
        let h = u.split("-");
        h[0] = c.get(h[0]), h[1] = c.get(h[1]), s.props.decorations[h.join("-")] = s.props.decorations[u], delete s.props.decorations[u];
      }
      let d = {
        ...o,
        props: {
          ...o.props,
          points: {
            ...o.props.points,
            ...s.props.points
          },
          decorations: {
            ...o.props.decorations,
            ...s.props.decorations
          },
          startPoints: [
            ...o.props.startPoints,
            ...s.props.startPoints
          ]
        }
      };
      this.editor.updateShape(d), this.editor.getShapeAndDescendantIds([n.id]).forEach((u) => {
        if (u === d.id || u === n.id) return;
        const h = structuredClone(this.editor.getShape(u));
        if (!h) return;
        h.parentId = d.id, h.props.targetShapeId = d.id;
        let g = h.props.targetIndex.split("-");
        g[0] = c.get(g[0]), g[1] = c.get(g[1]), h.x += n.x - o.x, h.y += n.y - o.y, h.props.targetIndex = g.join("-"), this.editor.updateShape(h);
      }), this.editor.deleteShape(n.id), this.editor.setSelectedShapes([d.id]);
    });
    S(this, "onDuplicate", (n, i) => {
      let r = structuredClone(n);
      for (const s in r.props.decorations)
        for (const o in r.props.decorations[s])
          r.props.decorations[s][o].metaShapeId = i.get(r.props.decorations[s][o].metaShapeId);
      return r;
    });
    S(this, "onHandleDrag", (n, { handle: i }) => {
      if (i.type === "vertex")
        return {
          ...n,
          props: {
            ...n.props,
            points: {
              ...n.props.points,
              [i.id]: { ...n.props.points[i.id], x: i.x, y: i.y }
            }
          }
        };
    });
  }
  getDefaultProps() {
    const [n] = Wa(1), i = Gj();
    return {
      startPoints: [n],
      decorations: {},
      points: {
        [n]: { id: n, index: n, x: 0, y: 0, next: [], thickness: i.thickness, color: i.color }
        //[end]: { id: end, index: end, x: 0.1, y: 0.1, next: [] },
      }
    };
  }
  toSvg(n) {
    const i = n.props.points, r = [], s = n.props.decorations, o = sp.get(), a = this.editor.getCurrentPageState().erasingShapeIds;
    let c = (d, u) => {
      const h = i[d];
      if (u == null || u == null) {
        Array.isArray(i[d].next) && i[d].next.forEach((g) => c(d, g));
        return;
      }
      h.next.forEach((g) => {
        let p = 1, f = 1, M = `${n.id}-${d}-${g}`;
        o[M] && (f = p = 1 * 0.45);
        let m = i[g];
        switch (m.wallType) {
          case "wall":
          case void 0:
          default:
            const y = `${d}-${g}`;
            if (s[y] && Object.keys(s[y]).length != 0) {
              let I = Object.values(s[y]);
              I.sort((j, w) => j.lerp - w.lerp);
              let D = h;
              I.forEach((j) => {
                f = p, j.metaShapeId && a.includes(j.metaShapeId) && (f = 1 * 0.45);
                const w = {
                  //@ts-ignore
                  x: h.x + (m.x - h.x) * j.lerp,
                  //@ts-ignore
                  y: h.y + (m.y - h.y) * j.lerp
                }, A = Math.hypot(w.x - D.x, w.y - D.y), b = {
                  x: (w.x - D.x) / A,
                  y: (w.y - D.y) / A
                }, T = j.size ?? 64, E = {
                  x: w.x - b.x * T / 2,
                  y: w.y - b.y * T / 2
                };
                r.push({
                  type: "wall",
                  opacity: p,
                  color: h.color,
                  wallThickness: h.thickness,
                  points: [D, E]
                }), r.push({
                  //@ts-ignore
                  type: j.type,
                  opacity: f,
                  size: T,
                  color: h.color,
                  wallThickness: h.thickness,
                  //@ts-ignore
                  points: [D, m, { ...j, x: w.x, y: w.y }]
                }), D = {
                  x: w.x + b.x * T / 2,
                  y: w.y + b.y * T / 2
                };
              }), r.push({
                type: "wall",
                opacity: p,
                color: h.color,
                wallThickness: h.thickness,
                points: [D, m]
              });
            } else
              r.push({
                type: "wall",
                color: h.color,
                opacity: p,
                wallThickness: h.thickness,
                points: [h, m]
              });
        }
        Array.isArray(m.next) && m.next.forEach((y) => c(g, y));
      });
    };
    return n.props.startPoints.forEach((d) => c(d, null)), /* @__PURE__ */ l.jsx(l.Fragment, { children: r.map(
      (d, u) => {
        switch (d.type) {
          case "window":
            return /* @__PURE__ */ l.jsx(Tge, { color: d.color, wallThickness: d.wallThickness, opacity: d.opacity, shouldScale: !0, size: d.size, shape: n, points: d.points }, `${n.id}-${u}`);
          case "door":
            return /* @__PURE__ */ l.jsx(bge, { color: d.color, wallThickness: d.wallThickness, opacity: d.opacity, shouldScale: !0, shape: n, size: d.size, points: d.points }, `${n.id}-${u}`);
          default:
          case "wall":
            return /* @__PURE__ */ l.jsx(Nge, { color: d.color, wallThickness: d.wallThickness, opacity: d.opacity, shouldScale: !0, shape: n, points: d.points }, `${n.id}-${u}`);
        }
      }
    ) });
  }
  getHandles(n) {
    return wge.get(n.props, () => (wm(n), EA(n).map((s) => ({
      ...s,
      id: s.index,
      type: "vertex",
      canSnap: !0
    }))));
  }
  getHandleSnapGeometry(n) {
    const i = EA(n);
    return {
      //@ts-ignore
      points: i,
      getSelfSnapPoints: (r) => {
        const s = this.getHandles(n).filter((o) => o.type === "vertex").findIndex((o) => o.id === r.id);
        return i.filter((o, a) => Math.abs(a - s) > 1).map(x.From);
      },
      getSelfSnapOutline: (r) => {
        const s = this.getHandles(n).filter((a) => a.type === "vertex").findIndex((a) => a.id === r.id), o = wm(n).segments.filter(
          (a, c) => c !== s - 1 && c !== s
        );
        return o.length ? new Ki({ children: o }) : null;
      }
    };
  }
  getGeometry(n) {
    return wm(n);
  }
  component(n) {
    return /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(Xi, { id: n.id, children: this.toSvg(n) }) });
  }
  indicator(n) {
    const { size: i, scale: r } = { scale: 1, size: "s" };
    mn[i] * r;
    const s = Age(n);
    return /* @__PURE__ */ l.jsx(l.Fragment, { children: s.map((o, a) => {
      let c;
      {
        const d = o.points;
        c = "M" + d[0] + "L" + d.slice(1);
      }
      return /* @__PURE__ */ l.jsx("path", { d: c }, a);
    }) });
  }
}
S(m3, "type", "wall");
function Nge({
  shape: t,
  shouldScale: e = !1,
  points: n = [],
  wallThickness: i = "external",
  color: r = "black",
  opacity: s = 1
}) {
  const o = $n(), c = 1 / 1, d = e ? c : 1, u = ({
    start: f,
    end: M,
    DISTANCE: m = 8,
    strokeWidth: y = Dm.external
  }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(
    g,
    {
      start: f,
      end: M,
      strokeWidth: y
    }
  ) }), h = ({
    start: f,
    end: M
  }) => /* @__PURE__ */ l.jsx(u, { start: f, end: M, DISTANCE: 4, strokeWidth: Dm.internal }), g = ({
    start: f,
    end: M,
    strokeWidth: m = Dm.partition
  }) => {
    const I = new Ds({ points: [f, M] }).points, D = "M" + I[0] + "L" + I.slice(1);
    return /* @__PURE__ */ l.jsx(
      "path",
      {
        d: D,
        strokeLinecap: "butt",
        stroke: o[r].solid,
        strokeWidth: m,
        opacity: s,
        fill: "none",
        transform: `scale(${d})`
      }
    );
  };
  let p = g;
  switch (i) {
    case "external":
      p = u;
      break;
    case "internal":
      p = h;
      break;
    case "partition":
      p = g;
      break;
    default:
      p = g;
      break;
  }
  return /* @__PURE__ */ l.jsx(p, { start: x.From(n[0]), end: x.From(n[1]) });
}
function EA(t) {
  return Object.values(t.props.points).sort(Jt);
}
function Age(t) {
  const e = t.props.points, n = (i, r, s = null) => {
    if (s == null || s == null)
      return i.push(x.From(e[r])), Array.isArray(e[r].next) && e[r].next.forEach((c) => n(i, c, r)), i;
    const o = e[r], a = e[s];
    return i.push(x.From(o)), Array.isArray(o.next) && o.next.length != 0 && o.next.forEach((c) => n(i, c, r)), i.push(x.From(a)), i;
  };
  return t.props.startPoints.map((i) => new Ds({ points: n([], i) }));
}
function wm(t) {
  const e = t.props.points, n = [], i = (r, s = null) => {
    if (s == null || s == null) {
      n.push(x.From(e[r])), Array.isArray(e[r].next) && e[r].next.forEach((c) => i(c, r));
      return;
    }
    const o = e[r], a = e[s];
    n.push(x.From(o)), Array.isArray(o.next) && o.next.length != 0 && o.next.forEach((c) => i(c, r)), n.push(x.From(a));
  };
  return t.props.startPoints.forEach((r) => i(r)), new Ds({ points: n });
}
function Tge({
  shape: t,
  wallThickness: e = "external",
  color: n = "black",
  size: i = 32,
  points: r = [],
  opacity: s = 1,
  shouldScale: o = !1
}) {
  const a = $n(), c = r[0], d = r[1], u = r[2], h = Math.atan2(d.y - c.y, d.x - c.x) * 180 / Math.PI, g = Math.hypot(d.x - c.x, d.y - c.y), p = {
    x: (d.x - c.x) / g,
    y: (d.y - c.y) / g
  }, f = {
    x: u.x - p.x * i / 2,
    y: u.y - p.y * i / 2
  }, M = {
    up: { x: -2, y: 0 },
    down: { x: 2, y: 0 },
    left: { x: 0, y: 2 },
    right: { x: 0, y: -2 }
  }, m = vge(c, d);
  return /* @__PURE__ */ l.jsxs("g", { opacity: s, transform: `
            translate(${f.x + M[m].x} ${f.y + M[m].y})
            rotate(${h})
        `, children: [
    /* @__PURE__ */ l.jsx("rect", { x: "0", y: "0", width: i, height: "4", fill: a[n].solid }),
    /* @__PURE__ */ l.jsx("circle", { cx: 0, cy: "2", r: "4", fill: a[n].solid }),
    /* @__PURE__ */ l.jsx("circle", { cx: i, cy: "2", r: "4", fill: a[n].solid })
  ] });
}
function bge({
  shape: t,
  color: e = "black",
  points: n = [],
  wallThickness: i = "external",
  size: r = 64,
  opacity: s = 1,
  shouldScale: o = !1
}) {
  const a = $n(), c = n[0], d = n[1], u = n[2];
  let h = Math.atan2(d.y - c.y, d.x - c.x) * 180 / Math.PI;
  const g = Math.hypot(d.x - c.x, d.y - c.y), p = {
    x: (d.x - c.x) / g,
    y: (d.y - c.y) / g
  }, f = {
    x: u.x - p.x * r / 2,
    y: u.y - p.y * r / 2
  };
  let M = !1, m = !1;
  u.flipV && (m = !0), u.flipH && (M = !0);
  const y = 4, I = r;
  return /* @__PURE__ */ l.jsx("g", { opacity: s, transform: `
            translate(${f.x} ${f.y})
            rotate(${h})
        `, children: /* @__PURE__ */ l.jsxs("g", { transform: `
                rotate(${m ? 180 : 0} ${r / 2} 0)
            `, children: [
    /* @__PURE__ */ l.jsx("rect", { x: M ? r : 0, y: "0", width: y, height: r, fill: a[e].solid }),
    M && /* @__PURE__ */ l.jsx("path", { d: `M${r} ${r} A${I} ${I} 0 0 1 0 ${y / 2}`, stroke: a[e].solid, strokeWidth: "2", fill: "none", strokeDasharray: "5,5" }),
    !M && /* @__PURE__ */ l.jsx("path", { d: `M${r + y} ${y / 2} A${I} ${I} 0 0 1 0 ${r - y / 2}`, stroke: a[e].solid, strokeWidth: "2", fill: "none", strokeDasharray: "5,5" })
  ] }) });
}
function vge(t, e) {
  const n = e.x - t.x, i = e.y - t.y;
  return Math.abs(n) > Math.abs(i) ? n > 0 ? "right" : "left" : i > 0 ? "down" : "up";
}
class Ege {
  calculateOffset(e, n, i, r) {
    const { size: s, size: o, flipH: a = !1, flipV: c = !1 } = e, d = Of(n, i), { xOffset: u, yOffset: h } = zge(d, r, s, o, c), g = Lge(d, s, o, c);
    return {
      xOffset: u + g.xOffset,
      yOffset: h + g.yOffset
    };
  }
}
class Cge {
  getBaseOffset(e, n, i, r) {
    const s = {
      up: -1,
      down: -1,
      left: 1,
      right: -1
    };
    let o = 0, a = 0;
    switch (e) {
      case "down":
      case "up":
        o = -1 * (i / 2), a = (e === "down" ? -1 : 1) * n.y * (r / 2);
        break;
      case "right":
      case "left":
        o = s[e] * n.x * (i / 2), a = -1 * (r / 2);
        break;
    }
    return { xOffset: o, yOffset: a };
  }
  calculateOffset(e, n, i, r) {
    const { size: s, size: o } = e, a = Of(n, i), { xOffset: c, yOffset: d } = this.getBaseOffset(a, r, s, o);
    return {
      xOffset: c,
      // + adjustment.xOffset,
      yOffset: d
      // + adjustment.yOffset,
    };
  }
}
function zge(t, e, n, i, r) {
  const s = {
    up: -1,
    down: -1,
    left: 1,
    right: -1
  };
  let o = 0, a = 0;
  switch (t) {
    case "down":
    case "up":
      o = s[t] * e.x * (n / 2), a = (t === "down" ? -1 : 1) * e.y * (i / 2);
      break;
    case "right":
    case "left":
      o = s[t] * e.x * (n / 2), a = (r ? 1 : -1) * e.y * (i / 2);
      break;
  }
  return { xOffset: o, yOffset: a };
}
function Lge(t, e, n, i) {
  let r = 0, s = 0;
  switch (t) {
    case "down":
      r += (i ? 0 : -1) * e;
      break;
    case "up":
      r += (i ? -1 : 0) * e;
      break;
    case "right":
      s -= (i ? 1 : 0) * n;
      break;
    case "left":
      s -= (i ? 0 : 1) * n;
      break;
  }
  return { xOffset: r, yOffset: s };
}
class y3 {
  static getCalculator(e) {
    return this.calculators[e];
  }
}
S(y3, "calculators", {
  door: new Ege(),
  window: new Cge()
  // Add other calculators as needed
});
class I3 extends Ci {
  constructor(n) {
    super(n);
    S(this, "hasContextMenu", (n) => {
      const i = this.getTargetShape(n), r = this.getTargetDecoration(n);
      if (!i || !r)
        return !1;
      switch (r.type) {
        case "door":
          return !0;
        default:
          return !1;
      }
    });
    S(this, "isAspectRatioLocked", () => !0);
    S(this, "hideRotateHandle", () => !0);
    S(this, "resizeInitialShape", null);
    S(this, "beforeTranslateContextMenu", null);
    S(this, "onTranslateStart", (n) => {
      const i = Lr.get();
      return this.beforeTranslateContextMenu = i, Lr.set({
        isOpen: !1
      }), !1;
    });
    S(this, "onTranslateEnd", (n, i) => {
      Lr.set({
        isOpen: this.beforeTranslateContextMenu.isOpen
      });
    });
    S(this, "onBeforeUpdate", (n, i) => i);
    S(this, "onDuplicateComplete", (n, i) => {
      let r = structuredClone(n);
      const s = structuredClone(this.getTargetShape(r)), o = Hj();
      s.props.decorations[r.props.targetIndex][o] = structuredClone(s.props.decorations[r.props.targetIndex][r.props.targetDecorationIndex]), r.props.targetDecorationIndex = o, s.props.decorations[r.props.targetIndex][o].metaShapeId = r.id;
      const [a, c] = r.props.targetIndex.split("-"), d = c3(
        s.props.points,
        {
          indexBefore: a,
          indexAfter: c
        },
        {
          x: r.x - s.x,
          y: r.y - s.y
        },
        s,
        0
      );
      return r.x = s.props.points[a].x + (s.props.points[c].x - s.props.points[a].x) * d, r.y = s.props.points[a].y + (s.props.points[c].y - s.props.points[a].y) * d, s.props.decorations[r.props.targetIndex][o].lerp = d, r.props.targetDecorationIndex = o, this.editor.updateShapes([
        s,
        r
      ]), r;
    });
    S(this, "onDelete", (n) => {
      const i = this.editor.getShape(n.parentId);
      if (!i) return {};
      const r = i.props.decorations[n.props.targetIndex];
      if (!r) return {};
      const {
        //@ts-ignore
        [n.props.targetDecorationIndex]: s,
        ...o
      } = r;
      this.editor.updateShape({
        ...i,
        props: {
          ...i == null ? void 0 : i.props,
          decorations: {
            ...i == null ? void 0 : i.props.decorations,
            [n.props.targetIndex]: {
              ...o
            }
          }
        }
      }), this.editor.deleteShape(n.id);
    });
    S(this, "onClick", (n) => {
      const i = this.getTargetShape(n), r = this.getTargetDecoration(n);
      if (!i || !r) {
        Lr.set({
          isOpen: !1
        });
        return;
      }
      switch (r.type) {
        case "door":
          l3(
            this.editor,
            this.editor.inputs,
            n.parentId,
            n.props.targetIndex,
            n.props.targetDecorationIndex
          );
          break;
        default:
          Lr.set({
            isOpen: !1
          });
      }
    });
    S(this, "onResizeStart", (n) => {
      const i = this.getTargetShape(n);
      i && (this.resizeInitialShape = structuredClone(i));
    });
    S(this, "onResize", (n, i) => {
      const { scaleX: r, scaleY: s } = i;
      if (!this.getTargetDecoration(n)) return;
      const a = this.getTargetShape(n);
      if (!a) return;
      const c = structuredClone(a);
      return c.props.decorations[n.props.targetIndex][n.props.targetDecorationIndex].size = this.resizeInitialShape.props.decorations[n.props.targetIndex][n.props.targetDecorationIndex].size * r, this.editor.updateShape(c), n;
    });
    S(this, "onTranslate", (n, i) => {
      const r = this.editor.getShape(i.parentId);
      if (!r) return;
      const {
        //@ts-ignore
        [i.props.targetDecorationIndex]: s,
        ...o
      } = r.props.decorations[i.props.targetIndex];
      this.editor.updateShape({
        ...r,
        props: {
          ...r == null ? void 0 : r.props,
          decorations: {
            ...r == null ? void 0 : r.props.decorations,
            [i.props.targetIndex]: {
              ...o
            }
          }
        }
      }), this.editor.deleteShape(i.id);
      const d = `floor-planner.${{
        window: "window-tool",
        door: "door-tool"
      }[s.type] ?? ""}.drawing`;
      this.editor.setCurrentTool(
        d,
        {
          shapeId: r.id,
          size: s.size,
          callBack: (u, h, g) => {
            this.editor.setSelectedShapes([g]), this.editor.setHoveredShape(g), this.editor.setHintingShapes([]), this.editor.setCurrentTool("select.idle", {
              target: "shape",
              shape: this.editor.getShape(g)
            });
          }
        }
      );
    });
    S(this, "onHandleDrag", (n, { handle: i }) => {
      if (i.type === "vertex")
        return {
          ...n
        };
    });
  }
  getDefaultProps() {
    return {
      targetShapeId: "",
      targetIndex: "",
      targetDecorationIndex: ""
    };
  }
  getTargetShape(n) {
    return this.editor.getShape(n.parentId);
  }
  getTargetDecoration(n) {
    var r, s;
    const i = this.getTargetShape(n);
    return (s = (r = i == null ? void 0 : i.props.decorations) == null ? void 0 : r[n.props.targetIndex]) == null ? void 0 : s[n.props.targetDecorationIndex];
  }
  //
  toSvg(n) {
    return /* @__PURE__ */ l.jsx(l.Fragment, {});
  }
  getHandles(n) {
    return [];
  }
  getOffset(n) {
    const i = this.getTargetDecoration(n);
    if (!i) return {
      xOffset: 0,
      yOffset: 0
    };
    const r = this.getTargetShape(n), [s, o] = n.props.targetIndex.split("-"), a = r.props.points[s], c = r.props.points[o], d = Math.hypot(c.x - a.x, c.y - a.y), u = {
      x: (c.x - a.x) / d,
      y: (c.y - a.y) / d
    }, h = y3.getCalculator(i.type);
    if (!h)
      throw new Error(`Unsupported decoration type: ${i.type}`);
    return h.calculateOffset(i, a, c, u);
  }
  getGeometry(n) {
    const i = this.getTargetDecoration(n);
    if (!i) return new Pi({
      width: 0,
      x: 0,
      y: 0,
      height: 0,
      isFilled: !0
    });
    const {
      size: r,
      size: s
    } = i, { xOffset: o, yOffset: a } = this.getOffset(n);
    return new Pi({
      width: r,
      x: o,
      y: a,
      height: s,
      isFilled: !0
    });
  }
  component(n) {
    return /* @__PURE__ */ l.jsx(l.Fragment, {});
  }
  indicator(n) {
    const i = this.getTargetDecoration(n);
    if (!i) return /* @__PURE__ */ l.jsx(l.Fragment, {});
    const {
      size: r,
      size: s
    } = i, { xOffset: o, yOffset: a } = this.getOffset(n);
    return /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx("rect", { width: r, height: s, x: o, y: a }) });
  }
}
S(I3, "type", "floor-planner-meta");
function kge(t) {
  const e = (...n) => {
    try {
      return t(...n);
    } catch (i) {
      throw i instanceof Error && Error.captureStackTrace && Error.captureStackTrace(i, e), i;
    }
  };
  return e;
}
function Oge(t) {
  return t.filter((e) => e != null);
}
const Nm = kge((t, e) => {
  if (t == null)
    throw new Error(e ?? "value must be defined");
  return t;
});
function Pge(t, e, n) {
  let i;
  if (t.run(
    () => {
      const r = t.store.extractingChanges(() => {
        const s = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set();
        for (const a of e)
          if (t.getShape(a))
            for (const d of t.getBindingsInvolvingShape(a)) {
              const u = e.has(d.fromId), h = e.has(d.toId);
              if (u && h) {
                s.add(d.id);
                continue;
              }
              (!u || !h) && o.add(d.id);
            }
        t.deleteBindings([...o], { isolateShapes: !0 });
        try {
          i = Rr.ok(n(s));
        } catch (a) {
          i = Rr.err(a);
        }
      });
      t.store.applyDiff(Sg(r));
    },
    { history: "ignore" }
  ), i.ok)
    return i.value;
  throw i.error;
}
function Uge(t, e) {
  return this.run(() => {
    const n = typeof t[0] == "string" ? t : t.map((h) => h.id);
    if (n.length <= 0) return this;
    const i = new Set(n), r = this.getShapeAndDescendantIds(n), s = [...r].reverse(), o = /* @__PURE__ */ new Map();
    for (const h of r)
      o.set(h, Ee());
    const { shapesToCreateWithOriginals: a, bindingsToCreate: c } = Pge(
      this,
      r,
      (h) => {
        var f;
        const g = [];
        for (const M of h) {
          const m = this.getBinding(M);
          if (!m) continue;
          const y = Ks();
          g.push({
            ...m,
            id: y,
            fromId: Nm(o.get(m.fromId)),
            toId: Nm(o.get(m.toId))
          });
        }
        const p = [];
        for (const M of s) {
          const m = Nm(o.get(M));
          let y = this.getShape(M);
          if (!y) continue;
          let I = 0, D = 0;
          if (e && i.has(M)) {
            const w = this.getShapeParentTransform(y), A = new x(e.x, e.y).rot(-w.rotation());
            I = A.x, D = A.y;
          }
          const j = this.getShapeUtil(y);
          j && (j != null && j.onDuplicate) && (y = ((f = j == null ? void 0 : j.onDuplicate) == null ? void 0 : f.call(j, y, o)) ?? y), p.push({
            shape: {
              ...y,
              id: m,
              x: y.x + I,
              y: y.y + D,
              // Use a dummy index for now, it will get updated outside of the `withIsolatedShapes`
              index: "a1",
              parentId: o.get(y.parentId) ?? y.parentId
            },
            originalShape: y
          });
        }
        return { shapesToCreateWithOriginals: p, bindingsToCreate: g };
      }
    );
    a.forEach(({ shape: h, originalShape: g }) => {
      const p = g.parentId, f = this.getSortedChildIdsForParent(p), M = f.indexOf(g.id), m = f[M + 1], y = m ? this.getShape(m) : void 0, I = ko(g.index, y == null ? void 0 : y.index);
      h.index = I;
    });
    const d = a.map(({ shape: h }) => h);
    if (d.length + this.getCurrentPageShapeIds().size > this.options.maxShapesPerPage) {
      Qge(this);
      return;
    }
    if (this.createShapes(d), this.createBindings(c), this.setSelectedShapes(Oge(n.map((h) => o.get(h)))), e !== void 0) {
      const h = this.getSelectionPageBounds(), g = this.getViewportPageBounds();
      h && !g.contains(h) && this.centerOnPoint(h.center, {
        animation: { duration: this.options.animationMediumMs }
      });
    }
    d.forEach((h) => {
      var p;
      const g = this.getShapeUtil(h);
      g && (g != null && g.onDuplicateComplete) && ((p = g == null ? void 0 : g.onDuplicateComplete) == null || p.call(g, h, o));
    });
  }), this;
}
function Rge(t) {
  return t.duplicateShapes = Uge, t.markHistory = function(e) {
    const n = `[${e ?? "stop"}]_${ht()}`;
    return this.mark(n), n;
  }, Yge(t), t;
}
let CA = !1;
const Yge = (t) => {
  if (CA) return !1;
  CA = !0, t.sideEffects.registerAfterDeleteHandler(
    "shape",
    (e) => {
      let n = Zn.get();
      const i = t.getCurrentPageId();
      e.type == "image" && e.meta && e.meta.iconId && n.page[i].icons[e.meta.iconId] != null && (n.page[i].icons[e.meta.iconId].count == 1 ? delete n.page[i].icons[e.meta.iconId] : n.page[i].icons[e.meta.iconId].count -= 1, Zn.set({
        ...n,
        page: {
          ...n.page,
          [i]: {
            icons: {
              ...n.page[i].icons
            }
          }
        }
      }));
    }
  ), t.sideEffects.registerAfterCreateHandler(
    "shape",
    (e) => {
      let n = Zn.get();
      const i = t.getCurrentPageId();
      e.type == "image" && e.meta && e.meta.iconId && (n.page[i] === void 0 && (n.page[i] = { icons: {} }), n.page[i].icons[e.meta.iconId] == null ? (n.page[i].icons[e.meta.iconId] = {
        count: 1,
        assetId: e.meta.assetId,
        label: (e.meta.iconId + "").replace(".svg", "")
      }, Zn.set({
        ...n,
        page: {
          ...n.page,
          [i]: {
            icons: {
              ...n.page[i].icons
            }
          }
        }
      })) : Zn.set(
        {
          ...n,
          page: {
            ...n.page,
            [i]: {
              icons: {
                ...n.page[i].icons,
                [e.meta.iconId]: {
                  ...n.page[i].icons[e.meta.iconId],
                  count: n.page[i].icons[e.meta.iconId].count + 1
                }
              }
            }
          }
        }
      ));
    }
  );
};
function Qge(t, e = t.getCurrentPageId()) {
  const n = t.getPage(e).name;
  t.emit("max-shapes", { name: n, pageId: e, count: t.options.maxShapesPerPage });
}
const zA = [
  { min: 1.5, mid: 4, step: 1 },
  { min: 1.5, mid: 4, step: 3 },
  { min: 0.7, mid: 4, step: 2 },
  { min: 0, mid: 1, step: 0 }
], LA = [
  { min: 1.5, max: 20, mid: 4, step: 2, value: 0.5, mod: 1 },
  { min: 0.5, max: 20, mid: 1, step: 0, value: 0, mod: 1 },
  { min: 0.5, max: 0.8, mid: 1, step: 0, value: 0, mod: 2 },
  { min: 0, max: 0.85, mid: 1, step: 0, value: 0, mod: 4 }
];
function Zge() {
  var D;
  const t = Q();
  let e = 0, n = 0, i = 0, r = 0;
  const s = G(
    "grid",
    () => {
      const j = t.getCurrentPageShapes().filter((w) => w.type === "grid");
      return j.length === 0 ? null : j[0];
    },
    [t]
  ), [o, a] = pe({ width: window.innerWidth, height: window.innerHeight });
  at(() => {
    const j = () => {
      a({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    return window.addEventListener("resize", j), j(), () => window.removeEventListener("resize", j);
  }, []);
  const c = G(
    "zoom level",
    () => t.getZoomLevel(),
    [t]
  ), d = G(
    "page bounds",
    () => t.getViewportPageBounds(),
    [t]
  );
  if (!s) return null;
  const u = s.props.rulerUnit, h = Zs(
    s.props.pixelToUnit,
    s.props.rulerUnit
  );
  if (!(s.props.showRuler === void 0 ? !0 : s.props.showRuler)) return null;
  const p = ((D = t.getCameraOptions().constraints) == null ? void 0 : D.padding) ?? { x: 0, y: 0 }, f = t.getShapePageBounds(s);
  let M = -d.x / (1 / c), m = -d.y / (1 / c);
  i = d.x < f.x ? 0 : M % (h * c), r = d.y < f.y ? 0 : m % (h * c), e = Math.floor(d.x / h), e < 0 && (e = 0), n = Math.floor(d.y / h), n < 0 && (n = 0), M = Math.max(M, f.x) + i, m = Math.max(m, f.y) + r;
  const y = h * c, I = (j, w, A) => {
    const b = [];
    let T = Math.ceil(w / y);
    y / h < T && (T = Math.ceil(w / h));
    for (let E = 0; E <= T; E++) {
      const v = E * y, P = j + E;
      A === "horizontal" ? (zA.forEach(({ min: C, mid: z, step: O }) => {
        if (c >= C) {
          const R = c >= z ? 10 : 8, U = c >= C * z ? 1 * c : 1, F = v + M + y / z * O + U / 2;
          b.push(
            /* @__PURE__ */ l.jsx(
              "line",
              {
                x1: F,
                y1: 0,
                x2: F,
                y2: R,
                stroke: "black",
                strokeWidth: U,
                opacity: 1
              },
              `h-tick-${E}-${z}-${C}-${O}`
            )
          );
        }
      }), LA.forEach(({ min: C, max: z, mid: O, step: R, value: U, mod: F }) => {
        if (c <= C || c >= z || E % F !== 0) return;
        const H = v + M + y / O * R;
        b.push(
          /* @__PURE__ */ l.jsxs(
            "text",
            {
              x: H,
              y: 24,
              fill: "black",
              children: [
                P + U,
                u
              ]
            },
            `h-text-${E}-${z}-${O}-${C}-${R}`
          )
        );
      })) : (zA.forEach(({ min: C, mid: z, step: O }) => {
        if (c >= C) {
          const R = c >= z ? 16 : 8, U = c >= z ? 1 * c : 1, F = v + m + y / z * O + U / 2;
          b.push(
            /* @__PURE__ */ l.jsx(
              "line",
              {
                x1: 0,
                y1: F,
                x2: R,
                y2: F,
                stroke: "black",
                strokeWidth: U,
                opacity: 1
              },
              `v-tick-${E}-${z}-${C}-${O}`
            )
          );
        }
      }), LA.forEach(({ min: C, mid: z, max: O, step: R, value: U, mod: F }) => {
        if (c <= C || c >= O || E % F !== 0) return;
        const H = P + U, Z = v + m + y / z * R;
        b.push(
          /* @__PURE__ */ l.jsxs(
            "text",
            {
              x: 5,
              y: Z,
              fill: "black",
              children: [
                H,
                u
              ]
            },
            `v-text-${E}-${O}-${z}-${C}-${R}`
          )
        );
      }));
    }
    return b;
  };
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(Xi, { children: /* @__PURE__ */ l.jsxs("svg", { id: "ruler-screen", width: o.width, height: o.height, children: [
    /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("mask", { id: "ruler-mask", children: /* @__PURE__ */ l.jsx("rect", { x: 0, y: 0, width: 32, height: 32, fill: "white" }) }) }),
    /* @__PURE__ */ l.jsx("rect", { x: 0, y: 0, width: 32, height: o.height, fill: "white", opacity: 1 }),
    I(n, o.height < s.props.h ? Math.max(s.props.h, o.height - p.y / 2) : Math.min(s.props.h, o.height), "vertical"),
    /* @__PURE__ */ l.jsx("rect", { x: 0, y: 0, width: 32, height: 32, fill: "white", opacity: 1, mask: "url(#ruler-mask)" }),
    /* @__PURE__ */ l.jsx("rect", { x: 0, y: 0, width: o.width, height: 32, fill: "white", opacity: 1 }),
    I(e, o.width < s.props.w ? Math.max(s.props.w, o.width - p.x / 2) : Math.min(s.props.w, o.width - p.x / 2), "horizontal")
  ] }) }) });
}
const Fge = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkwNDNfNzkxKSI+CjxwYXRoIGQ9Ik02LjAzIDMuOTkwMDNMMTcuNTMgMTIuNjI4NEwxMS4zOCAxMi45MTc3TDEwLjUgMTIuOTU3Nkw5Ljk0IDEzLjYzNTlMNiAxOC4zNTQxTDYuMDMgMy45OTAwM1pNNC4wNCAwTDQgMjMuODgwM0wxMS40OSAxNC45MTI3TDIzLjE3IDE0LjM2NDFMNC4wNCAwWiIgZmlsbD0iIzA2MUMzMSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzkwNDNfNzkxIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", Bge = "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", Gge = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkxOTlfMTEpIj4KPHBhdGggZD0iTTIyLjMwOTkgOC4yNTk5OUwxMy43NTk5IDE2LjcxQzEyLjYwOTkgMTUuMDYgMTAuOTc5OSAxNC40NSA5Ljk2OTg5IDE0LjIzQzkuNjY5ODkgMTIuMyA4LjQ5OTg5IDExLjE0IDcuMzM5ODkgMTAuNUwxNS45Mzk5IDEuODk5OTlMMTQuNTI5OSAwLjQ4OTk5TDQuMTc5ODkgMTAuODNMMC4zODk4OTMgMjMuMzdMMTMuNDg5OSAxOS43OUwyMy43MTk5IDkuNjg5OTlMMjIuMzA5OSA4LjI2OTk5VjguMjU5OTlaTTUuOTA5ODkgMTIuMDNDNi43MTk4OSAxMi4zMyA4LjAwOTg5IDEzLjEyIDguMDQ5ODkgMTUuMTRMOC4wNjk4OSAxNi4xTDkuMDI5ODkgMTYuMTJDOS4wMjk4OSAxNi4xMiAxMS4xMTk5IDE2LjIgMTIuMjY5OSAxOC4wNkw1LjQyOTg5IDE5LjkzTDMuOTc5ODkgMTguNDhMNS45Mjk4OSAxMi4wNEw1LjkwOTg5IDEyLjAzWiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85MTk5XzExIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", Wge = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImFycm93X2ZvcndhcmRfMjRweCI+CjxwYXRoIGlkPSJpY29uL25hdmlnYXRpb24vYXJyb3dfZm9yd2FyZF8yNHB4IiBkPSJNMTIgNEwxMC41OSA1LjQxTDE2LjE3IDExSDRWMTNIMTYuMTdMMTAuNTkgMTguNTlMMTIgMjBMMjAgMTJMMTIgNFoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjEiLz4KPC9nPgo8L3N2Zz4K", Hge = "PHN2ZwoJeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBkaXJlY3Rpb249Imx0ciIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiB2aWV3Qm94PSIwIDAgNjggNjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZGF0YS1jb2xvci1tb2RlPSJsaWdodCI+Cgk8ZGVmcy8+Cgk8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLCAwLCAwLCAxLCAwLCAwKSIgb3BhY2l0eT0iMSI+CgkJPHN2Zz4KCQkJPGRlZnM+CgkJCQk8cGF0dGVybiBpZD0iZ3JpZC00IiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiPgoJCQkJCTxsaW5lIHgxPSIwIiB5MT0iMC41IiB4Mj0iNjQiIHkyPSIwLjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iNCIgb3BhY2l0eT0iMSIvPgoJCQkJCTxsaW5lICB4MT0iMC41IiB5MT0iMCIgeDI9IjAuNSIgeTI9IjY0IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjQiIG9wYWNpdHk9IjEiLz4KCQkJCTwvcGF0dGVybj4KCQkJCTxwYXR0ZXJuIGlkPSJncmlkLTEiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CgkJCQkJPGxpbmUgeDE9IjAiIHkxPSIwLjUiIHgyPSIxNiIgeTI9IjAuNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSI0IiBvcGFjaXR5PSIwLjE2NjY2NjY2NjY2NjY2NjY5Ii8+CgkJCQkJPGxpbmUgeDE9IjAuNSIgeTE9IjAiIHgyPSIwLjUiIHkyPSIxNiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSI0IiBvcGFjaXR5PSIwLjE2NjY2NjY2NjY2NjY2NjY5Ii8+CgkJCQk8L3BhdHRlcm4+CgkJCTwvZGVmcz4KCQkJPHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkLTQpIi8+CgkJCTxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZC0xKSIvPgoJCTwvc3ZnPgoJPC9nPgo8L3N2Zz4=", Vge = "PHN2ZwoJeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBkaXJlY3Rpb249Imx0ciIgd2lkdGg9IjY1IiBoZWlnaHQ9IjY1IiB2aWV3Qm94PSIwIDAgNjUgNjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZGF0YS1jb2xvci1tb2RlPSJsaWdodCI+Cgk8ZGVmcy8+Cgk8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLCAwLCAwLCAxLCAwLCAwKSIgb3BhY2l0eT0iMSI+CgkJPHN2Zz4KCQkJPGRlZnM+CgkJCQk8cGF0dGVybiBpZD0iZ3JpZC00IiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiPgoJCQkJCTxsaW5lIHgxPSIwIiB5MT0iMC41IiB4Mj0iNjQiIHkyPSIwLjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgb3BhY2l0eT0iMSIvPgoJCQkJCTxsaW5lICB4MT0iMC41IiB5MT0iMCIgeDI9IjAuNSIgeTI9IjY0IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIG9wYWNpdHk9IjEiLz4KCQkJCTwvcGF0dGVybj4KCQkJPC9kZWZzPgoJCQk8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQtNCkiLz4KCQk8L3N2Zz4KCTwvZz4KPC9zdmc+", Kge = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InRleHRfZmllbGRzXzI0cHgiPgo8cGF0aCBpZD0iaWNvbi9lZGl0b3IvdGV4dF9maWVsZHNfMjRweCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjUgNy41VjQuNUgxNS41VjcuNUgxMC41VjE5LjVINy41VjcuNUgyLjVaTTEyLjUgOS41SDIxLjVWMTIuNUgxOC41VjE5LjVIMTUuNVYxMi41SDEyLjVWOS41WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMSIvPgo8L2c+Cjwvc3ZnPgo=", Xge = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkzMzFfNTI1KSI+CjxwYXRoIGQ9Ik0xNC40MSAxLjQxOTkySDFWMjMuNDE5OUgyM1YxMC4wMDk5TDE0LjQxIDEuNDE5OTJaTTE0LjUgNC4zMjk5MkwyMC4wOSA5LjkxOTkySDE0LjVWNC4zMjk5MlpNMyAyMS40MTk5VjMuNDE5OTJIMTMuNVYxMC45MTk5SDIxVjIxLjQxOTlIM1oiIGZpbGw9IiMzQTM1NDEiIGZpbGwtb3BhY2l0eT0iMSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzkzMzFfNTI1Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjQxOTkyMikiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", Jge = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjU5NzggMEgxNi4xNjNWMi4xODE4MkgyMS41OTc4QzIxLjcyODMgMi4xODE4MiAyMS44MjYxIDIuMjggMjEuODI2MSAyLjQxMDkxVjExLjAwNzNIMTguOTAyMlYxMy4xODkxSDIxLjgyNjFWMjEuNkMyMS44MjYxIDIxLjczMDkgMjEuNzI4MyAyMS44MjkxIDIxLjU5NzggMjEuODI5MUgxMS43ODI2VjEzLjE4OTFIMTQuODA0M1YxMS4wMDczSDYuNTk3ODNWMTMuMTg5MUg5LjYxOTU3VjIxLjgyOTFIMi40MDIxN0MyLjI3MTc0IDIxLjgyOTEgMi4xNzM5MSAyMS43MzA5IDIuMTczOTEgMjEuNlYyLjQxMDkxQzIuMTczOTEgMi4yOTA5MSAyLjI3MTc0IDIuMTgxODIgMi40MDIxNyAyLjE4MTgySDguODE1MjJMMTMuMDQzNSA2LjM5MjczTDE0LjU3NjEgNC44NDM2NEw5LjcxNzM5IDBIMi40MDIxN0MxLjA3NjA5IDAgMCAxLjA4IDAgMi40MTA5MVYyMS41ODkxQzAgMjIuOTIgMS4wNzYwOSAyNCAyLjQwMjE3IDI0SDIxLjU5NzhDMjIuOTIzOSAyNCAyNCAyMi45MiAyNCAyMS41ODkxVjIuNDEwOTFDMjQgMS4wOCAyMi45MjM5IDAgMjEuNTk3OCAwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", qge = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkyMjFfMTEwKSI+CjxwYXRoIGQ9Ik0xLjAwMDA2IDI0LjQxQzAuNzQwMDU5IDI0LjQxIDAuNDkwMDU5IDI0LjMxIDAuMjkwMDU5IDI0LjEyQy0wLjA5OTk0MTQgMjMuNzMgLTAuMDk5OTQxNCAyMy4xIDAuMjkwMDU5IDIyLjcxTDIyLjI5MDEgMC43MDk5OEMyMi42ODAxIDAuMzE5OTggMjMuMzEwMSAwLjMxOTk4IDIzLjcwMDEgMC43MDk5OEMyNC4wOTAxIDEuMDk5OTggMjQuMDkwMSAxLjcyOTk4IDIzLjcwMDEgMi4xMTk5OEwxLjcxMDA2IDI0LjEyQzEuNTEwMDYgMjQuMzIgMS4yNjAwNiAyNC40MSAxLjAwMDA2IDI0LjQxWiIgZmlsbD0iIzNBMzU0MSIgZmlsbC1vcGFjaXR5PSIxIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfOTIyMV8xMTAiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQuNCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC4wMTAwMDk4KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", _ge = "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", $ge = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImZpbHRlcl8yNHB4Ij4KPHBhdGggaWQ9Imljb24vaW1hZ2UvZmlsdGVyXzI0cHgiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjEgMUg3QzUuOSAxIDUgMS45IDUgM1YxN0M1IDE4LjEgNS45IDE5IDcgMTlIMjFDMjIuMSAxOSAyMyAxOC4xIDIzIDE3VjNDMjMgMS45IDIyLjEgMSAyMSAxWk0xIDVIM1YyMUgxOVYyM0gzQzEuOSAyMyAxIDIyLjEgMSAyMVY1Wk0xMy4yMSAxMy44M0wxNS45NiAxMC4yOUwxOS41IDE1SDguNUwxMS4yNSAxMS40N0wxMy4yMSAxMy44M1pNNyAxN0gyMVYzSDdWMTdaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIxIi8+CjwvZz4KPC9zdmc+Cg==", epe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzk3NDhfNDc4NDApIj4KPHBhdGggZD0iTTkuMTEwMDMgMTQuMjE5OUw5LjgxMDAzIDE0LjkyOTlMMTEuOTYgMTIuNzc5OUw5LjgwMDAzIDEwLjYxOTlMOS4wOTAwMyAxMS4zMjk5TDEwLjA1IDEyLjI3OTlINy4wMzAwM1YxMy4yNzk5SDEwLjA1TDkuMTEwMDMgMTQuMjE5OVoiIGZpbGw9IiMzQTM1NDEiIGZpbGwtb3BhY2l0eT0iMC42Ii8+CjxwYXRoIGQ9Ik0yMi45OSA1LjU4OTg1SDExLjQyVjEuNDI5ODVDMTEuNDIgMS4wMTk4NSAxMS4xNyAwLjY1OTg1MiAxMC44IDAuNDk5ODUyQzEwLjQzIDAuMzM5ODUyIDkuOTkwMDEgMC40Mzk4NTIgOS43MTAwMSAwLjcyOTg1MkwwLjMwMDAxIDEwLjMyOTlDMC4xMjAwMSAxMC41MTk5IDAuMDEwMDA5OCAxMC43Njk5IDAuMDEwMDA5OCAxMS4wMjk5VjIzLjQwOTlDMC4wMTAwMDk4IDIzLjgxOTkgMC4yNjAwMSAyNC4xNzk5IDAuNjMwMDEgMjQuMzM5OUMwLjc1MDAxIDI0LjM4OTkgMC44ODAwMSAyNC40MDk5IDEuMDEwMDEgMjQuNDA5OUMxLjI3MDAxIDI0LjQwOTkgMS41MzAwMSAyNC4zMDk5IDEuNzIwMDEgMjQuMTA5OUw1Ljc4MDAxIDE5Ljk1OTlIMjIuOThDMjMuNTMgMTkuOTU5OSAyMy45OCAxOS41MDk5IDIzLjk4IDE4Ljk1OTlWNi41ODk4NUMyMy45OCA2LjAzOTg1IDIzLjUzIDUuNTg5ODUgMjIuOTggNS41ODk4NUgyMi45OVpNNC44NzAwMSAxOC4wMzk5TDIuMDEwMDEgMjAuOTU5OVYxMS40Mzk5TDQuODcwMDEgOC41MTk4NVYxOC4wMzk5Wk05LjQyMDAxIDMuODc5ODVWNS41ODk4NUg3Ljc0MDAxTDkuNDIwMDEgMy44Nzk4NVpNMjEuOTkgMTcuOTU5OUg1Ljg3MDAxVjcuNTg5ODVIMjEuOTlWMTcuOTU5OVoiIGZpbGw9IiMzQTM1NDEiIGZpbGwtb3BhY2l0eT0iMSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzk3NDhfNDc4NDAiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuNDE5OTIyKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", tpe = "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", npe = "PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjIyMjY2IDEyQzIuMjIyNjYgMTcuNTEgNi43MTI2NiAyMiAxMi4yMjI3IDIyQzEzLjYwMjcgMjIgMTQuNzIyNyAyMC44OCAxNC43MjI3IDE5LjVDMTQuNzIyNyAxOC44OSAxNC40OTI3IDE4LjMgMTQuMDgyNyAxNy44M0MxNC4wMDI3IDE3LjczIDEzLjk1MjcgMTcuNjIgMTMuOTUyNyAxNy41QzEzLjk1MjcgMTcuMjIgMTQuMTcyNyAxNyAxNC40NTI3IDE3SDE2LjIyMjdDMTkuNTMyNyAxNyAyMi4yMjI3IDE0LjMxIDIyLjIyMjcgMTFDMjIuMjIyNyA2LjA0IDE3LjczMjcgMiAxMi4yMjI3IDJDNi43MTI2NiAyIDIuMjIyNjYgNi40OSAyLjIyMjY2IDEyWk00LjIyMjY2IDEyQzQuMjIyNjYgNy41OSA3LjgxMjY2IDQgMTIuMjIyNyA0QzE2LjYzMjcgNCAyMC4yMjI3IDcuMTQgMjAuMjIyNyAxMUMyMC4yMjI3IDEzLjIxIDE4LjQzMjcgMTUgMTYuMjIyNyAxNUgxNC40NTI3QzEzLjA3MjcgMTUgMTEuOTUyNyAxNi4xMiAxMS45NTI3IDE3LjVDMTEuOTUyNyAxOC4xIDEyLjE3MjcgMTguNjkgMTIuNTgyNyAxOS4xNUMxMi42NDI3IDE5LjIyIDEyLjcyMjcgMTkuMzQgMTIuNzIyNyAxOS41QzEyLjcyMjcgMTkuNzggMTIuNTAyNyAyMCAxMi4yMjI3IDIwQzcuODEyNjYgMjAgNC4yMjI2NiAxNi40MSA0LjIyMjY2IDEyWk02LjcyMjY2IDEwQzUuODk0MjMgMTAgNS4yMjI2NiAxMC42NzE2IDUuMjIyNjYgMTEuNUM1LjIyMjY2IDEyLjMyODQgNS44OTQyMyAxMyA2LjcyMjY2IDEzQzcuNTUxMDggMTMgOC4yMjI2NiAxMi4zMjg0IDguMjIyNjYgMTEuNUM4LjIyMjY2IDEwLjY3MTYgNy41NTEwOCAxMCA2LjcyMjY2IDEwWk04LjIyMjY2IDcuNUM4LjIyMjY2IDYuNjcxNTcgOC44OTQyMyA2IDkuNzIyNjYgNkMxMC41NTExIDYgMTEuMjIyNyA2LjY3MTU3IDExLjIyMjcgNy41QzExLjIyMjcgOC4zMjg0MyAxMC41NTExIDkgOS43MjI2NiA5QzguODk0MjMgOSA4LjIyMjY2IDguMzI4NDMgOC4yMjI2NiA3LjVaTTE0LjcyMjcgNkMxMy44OTQyIDYgMTMuMjIyNyA2LjY3MTU3IDEzLjIyMjcgNy41QzEzLjIyMjcgOC4zMjg0MyAxMy44OTQyIDkgMTQuNzIyNyA5QzE1LjU1MTEgOSAxNi4yMjI3IDguMzI4NDMgMTYuMjIyNyA3LjVDMTYuMjIyNyA2LjY3MTU3IDE1LjU1MTEgNiAxNC43MjI3IDZaTTE2LjIyMjcgMTEuNUMxNi4yMjI3IDEwLjY3MTYgMTYuODk0MiAxMCAxNy43MjI3IDEwQzE4LjU1MTEgMTAgMTkuMjIyNyAxMC42NzE2IDE5LjIyMjcgMTEuNUMxOS4yMjI3IDEyLjMyODQgMTguNTUxMSAxMyAxNy43MjI3IDEzQzE2Ljg5NDIgMTMgMTYuMjIyNyAxMi4zMjg0IDE2LjIyMjcgMTEuNVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjEiLz4KPC9zdmc+Cg==", ipe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuOTIzMDggNkMzLjQxMzI4IDYgMyA2LjQ0NzcyIDMgN0MzIDcuNTUyMjggMy40MTMyOCA4IDMuOTIzMDggOEgyNi4wNzY5QzI2LjU4NjcgOCAyNyA3LjU1MjI4IDI3IDdDMjcgNi40NDc3MiAyNi41ODY3IDYgMjYuMDc2OSA2SDMuOTIzMDhaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMyAxNUMzIDE0LjQ0NzcgMy40MTMyOCAxNCAzLjkyMzA4IDE0SDI2LjA3NjlDMjYuNTg2NyAxNCAyNyAxNC40NDc3IDI3IDE1QzI3IDE1LjU1MjMgMjYuNTg2NyAxNiAyNi4wNzY5IDE2SDMuOTIzMDhDMy40MTMyOCAxNiAzIDE1LjU1MjMgMyAxNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0zIDIzQzMgMjIuNDQ3NyAzLjQxMzI4IDIyIDMuOTIzMDggMjJIMjYuMDc2OUMyNi41ODY3IDIyIDI3IDIyLjQ0NzcgMjcgMjNDMjcgMjMuNTUyMyAyNi41ODY3IDI0IDI2LjA3NjkgMjRIMy45MjMwOEMzLjQxMzI4IDI0IDMgMjMuNTUyMyAzIDIzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", rpe = "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", spe = "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", ope = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjQxIDcuNDFMMTQgNkw4IDEyTDE0IDE4TDE1LjQxIDE2LjU5TDEwLjgzIDEyTDE1LjQxIDcuNDFaIiBmaWxsPSIjMDAxNjIzIiBmaWxsLW9wYWNpdHk9IjAuOCIvPgo8cGF0aCBkPSJNMTUuNDEgNy40MUwxNCA2TDggMTJMMTQgMThMMTUuNDEgMTYuNTlMMTAuODMgMTJMMTUuNDEgNy40MVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNMTUuNDEgNy40MUwxNCA2TDggMTJMMTQgMThMMTUuNDEgMTYuNTlMMTAuODMgMTJMMTUuNDEgNy40MVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNMTUuNDEgNy40MUwxNCA2TDggMTJMMTQgMThMMTUuNDEgMTYuNTlMMTAuODMgMTJMMTUuNDEgNy40MVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8L3N2Zz4K", ape = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkyMjdfNTEpIj4KPHBhdGggZD0iTTIwLjY0IDIyLjQyOTlWMC40Mjk5MzJIMy4zNlYyMi40Mjk5SDBWMjQuNDI5OUg1LjM2VjIuNDI5OTNIMTguNjRWMjQuNDI5OUgyNFYyMi40Mjk5SDIwLjY0WiIgZmlsbD0iIzNBMzU0MSIgZmlsbC1vcGFjaXR5PSIxIi8+CjxwYXRoIGQ9Ik0xNS42Nzk5IDE1LjI2QzE2LjUwODQgMTUuMjYgMTcuMTc5OSAxNC41ODg0IDE3LjE3OTkgMTMuNzZDMTcuMTc5OSAxMi45MzE2IDE2LjUwODQgMTIuMjYgMTUuNjc5OSAxMi4yNkMxNC44NTE1IDEyLjI2IDE0LjE3OTkgMTIuOTMxNiAxNC4xNzk5IDEzLjc2QzE0LjE3OTkgMTQuNTg4NCAxNC44NTE1IDE1LjI2IDE1LjY3OTkgMTUuMjZaIiBmaWxsPSIjM0EzNTQxIiBmaWxsLW9wYWNpdHk9IjEiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85MjI3XzUxIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0LjAxIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjQxOTkyMikiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", cpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkyMjdfNTIpIj4KPHBhdGggZD0iTTMuNDI5OTMgMC40MTk5MjJWMjQuNDE5OUgyMC43MDk5VjAuNDE5OTIySDMuNDI5OTNaTTE4LjY5OTkgMTEuNDY5OUgxMy4wNTk5VjIuNDE5OTJIMTguNjk5OVYxMS40Njk5Wk0xMS4wNTk5IDIuNDE5OTJWMTEuNDY5OUg1LjQxOTkzVjIuNDE5OTJIMTEuMDU5OVpNNS40Mjk5MyAxMy40Njk5SDExLjA2OTlWMjIuNDE5OUg1LjQyOTkzVjEzLjQ2OTlaTTEzLjA1OTkgMjIuNDE5OVYxMy40Njk5SDE4LjY5OTlWMjIuNDE5OUgxMy4wNTk5WiIgZmlsbD0iIzNBMzU0MSIgZmlsbC1vcGFjaXR5PSIxIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfOTIyN181MiI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC40MTk5MjIpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==", lpe = "Cjxzdmcgd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IiB2aWV3Qm94PSIwIDAgMjUgMjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF85MzE2XzI0KSI+CjxwYXRoIGQ9Ik0yMy4wNjAxIDQuNjQ5ODVINy4xNTAwNkwxLjY1MDA2IDAuNjQ5ODQ5QzEuMzQwMDYgMC40Mjk4NDkgMC45NDAwNTkgMC4zOTk4NDkgMC42MTAwNTkgMC41Njk4NDlDMC4yODAwNTkgMC43Mzk4NDkgMC4wNjAwNTg2IDEuMDc5ODUgMC4wNjAwNTg2IDEuNDU5ODVWMTkuMjI5OEMwLjA2MDA1ODYgMTkuNTQ5OCAwLjIxMDA1OSAxOS44NDk4IDAuNDcwMDU5IDIwLjAzOTlMNi4yNDAwNiAyNC4yMjk4QzYuNDEwMDYgMjQuMzQ5OCA2LjYyMDA2IDI0LjQxOTggNi44MzAwNiAyNC40MTk4SDIzLjA2MDFDMjMuNjEwMSAyNC40MTk4IDI0LjA2MDEgMjMuOTY5OCAyNC4wNjAxIDIzLjQxOThWNS42NDk4NUMyNC4wNjAxIDUuMDk5ODUgMjMuNjEwMSA0LjY0OTg1IDIzLjA2MDEgNC42NDk4NVpNMi4wNjAwNiAxOC43MTk4VjMuNDE5ODVMNi4yNDAwNiA2LjQ1OTg1QzYuMjQwMDYgNi40NTk4NSA2LjMwMDA2IDYuNDg5ODUgNi4zMzAwNiA2LjQ5OTg1VjIxLjgxOThMMi4wNjAwNiAxOC43MTk4Wk0yMi4wNjAxIDIyLjQxOThINy4zMzAwNlY2LjY0OTg1SDIyLjA2MDFWMjIuNDE5OFoiIGZpbGw9IiMzQTM1NDEiIGZpbGwtb3BhY2l0eT0iMSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzkzMTZfMjQiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjA2MDA1ODYgMC40MTk5MjIpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==", dpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImRlbGV0ZV8yNHB4Ij4KPHBhdGggaWQ9Imljb24vYWN0aW9uL2RlbGV0ZV8yNHB4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjUgM0g5LjVMOC41IDRINVY2SDE5VjRIMTUuNUwxNC41IDNaTTE2IDlWMTlIOFY5SDE2Wk02IDdIMThWMTlDMTggMjAuMSAxNy4xIDIxIDE2IDIxSDhDNi45IDIxIDYgMjAuMSA2IDE5VjdaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIxIi8+CjwvZz4KPC9zdmc+Cg==", upe = "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDBWMHoiIGZpbGw9Im5vbmUiLz48cGF0aCBkPSJNMjEgNkgzYy0xLjEgMC0yIC45LTIgMnY4YzAgMS4xLjkgMiAyIDJoMThjMS4xIDAgMi0uOSAyLTJWOGMwLTEuMS0uOS0yLTItMnptMCAxMEgzVjhoMnY0aDJWOGgydjRoMlY4aDJ2NGgyVjhoMnY0aDJWOGgydjh6Ii8+PC9zdmc+", hpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InNhdmVfMjRweCI+CjxwYXRoIGlkPSJpY29uL2NvbnRlbnQvc2F2ZV8yNHB4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUgM0gxN0wyMSA3VjE5QzIxIDIwLjEgMjAuMSAyMSAxOSAyMUg1QzMuODkgMjEgMyAyMC4xIDMgMTlWNUMzIDMuOSAzLjg5IDMgNSAzWk0xOSAxOVY3LjgzTDE2LjE3IDVINVYxOUgxOVpNMTIgMTJDMTAuMzQgMTIgOSAxMy4zNCA5IDE1QzkgMTYuNjYgMTAuMzQgMTggMTIgMThDMTMuNjYgMTggMTUgMTYuNjYgMTUgMTVDMTUgMTMuMzQgMTMuNjYgMTIgMTIgMTJaTTE1IDZINlYxMEgxNVY2WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMSIvPgo8L2c+Cjwvc3ZnPgo=", gpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImN1dF8yNHB4Ij4KPHBhdGggaWQ9Imljb24vY29udGVudC9jdXRfMjRweCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjY0IDcuNjRDOS44NyA3LjE0IDEwIDYuNTkgMTAgNkMxMCAzLjc5IDguMjEgMiA2IDJDMy43OSAyIDIgMy43OSAyIDZDMiA4LjIxIDMuNzkgMTAgNiAxMEM2LjU5IDEwIDcuMTQgOS44NyA3LjY0IDkuNjRMMTAgMTJMNy42NCAxNC4zNkM3LjE0IDE0LjEzIDYuNTkgMTQgNiAxNEMzLjc5IDE0IDIgMTUuNzkgMiAxOEMyIDIwLjIxIDMuNzkgMjIgNiAyMkM4LjIxIDIyIDEwIDIwLjIxIDEwIDE4QzEwIDE3LjQxIDkuODcgMTYuODYgOS42NCAxNi4zNkwxMiAxNEwxOSAyMUgyMlYyMEw5LjY0IDcuNjRaTTYgOEM0LjkgOCA0IDcuMTEgNCA2QzQgNC44OSA0LjkgNCA2IDRDNy4xIDQgOCA0Ljg5IDggNkM4IDcuMTEgNy4xIDggNiA4Wk00IDE4QzQgMTkuMTEgNC45IDIwIDYgMjBDNy4xIDIwIDggMTkuMTEgOCAxOEM4IDE2Ljg5IDcuMSAxNiA2IDE2QzQuOSAxNiA0IDE2Ljg5IDQgMThaTTEyIDEyLjVDMTEuNzIgMTIuNSAxMS41IDEyLjI4IDExLjUgMTJDMTEuNSAxMS43MiAxMS43MiAxMS41IDEyIDExLjVDMTIuMjggMTEuNSAxMi41IDExLjcyIDEyLjUgMTJDMTIuNSAxMi4yOCAxMi4yOCAxMi41IDEyIDEyLjVaTTEzIDlMMTkgM0gyMlY0TDE1IDExTDEzIDlaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIxIi8+CjwvZz4KPC9zdmc+Cg==", ppe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InNlYXJjaF8yNHB4Ij4KPHBhdGggaWQ9Imljb24vYWN0aW9uL3NlYXJjaF8yNHB4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0Ljk2NDkgMTQuMjU1SDE1Ljc1NDlMMjAuNzQ0OSAxOS4yNTVMMTkuMjU0OSAyMC43NDVMMTQuMjU0OSAxNS43NTVWMTQuOTY1TDEzLjk4NDkgMTQuNjg1QzEyLjg0NDkgMTUuNjY1IDExLjM2NDkgMTYuMjU1IDkuNzU0ODggMTYuMjU1QzYuMTY0ODggMTYuMjU1IDMuMjU0ODggMTMuMzQ1IDMuMjU0ODggOS43NTVDMy4yNTQ4OCA2LjE2NSA2LjE2NDg4IDMuMjU1IDkuNzU0ODggMy4yNTVDMTMuMzQ0OSAzLjI1NSAxNi4yNTQ5IDYuMTY1IDE2LjI1NDkgOS43NTVDMTYuMjU0OSAxMS4zNjUgMTUuNjY0OSAxMi44NDUgMTQuNjg0OSAxMy45ODVMMTQuOTY0OSAxNC4yNTVaTTUuMjU0ODggOS43NTVDNS4yNTQ4OCAxMi4yNDUgNy4yNjQ4OCAxNC4yNTUgOS43NTQ4OCAxNC4yNTVDMTIuMjQ0OSAxNC4yNTUgMTQuMjU0OSAxMi4yNDUgMTQuMjU0OSA5Ljc1NUMxNC4yNTQ5IDcuMjY1MDEgMTIuMjQ0OSA1LjI1NSA5Ljc1NDg4IDUuMjU1QzcuMjY0ODggNS4yNTUgNS4yNTQ4OCA3LjI2NTAxIDUuMjU0ODggOS43NTVaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIxIi8+CjwvZz4KPC9zdmc+Cg==", fpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkyNTdfMjE3KSI+CjxwYXRoIGQ9Ik0yMy45OSAxMi4yNTAxQzIzLjk5IDkuOTkwMDYgMjEuMjUgOC4yMTAwNiAxNy43NSA4LjIxMDA2QzE3LjQgOC4yMTAwNiAxNy4wNiA4LjIzMDA2IDE2LjcyIDguMjcwMDZDMTcuNzEgNy40MzAwNiAxOC40MSA3LjA2MDA2IDE4LjgxIDcuMDIwMDZDMTkuNjUgNi45MzAwNiAyMC44IDYuNjkwMDYgMjEuMTggNS43NzAwNkMyMS40MiA1LjE5MDA2IDIxLjIyIDQuNjMwMDYgMjAuOTcgNC4zMzAwNkMyMC42MyAzLjkxMDA2IDIwLjAxIDMuODMwMDYgMTkuNTggNC4xNjAwNkMxOS4zMyA0LjM1MDA2IDE5LjIgNC42MzAwNiAxOS4xOSA0LjkyMDA2QzE5LjA1IDQuOTYwMDYgMTguODYgNS4wMDAwNiAxOC41OCA1LjAzMDA2QzE3LjU0IDUuMTUwMDYgMTYuMjMgNS45NTAwNiAxNC42OSA3LjQxMDA2QzE1LjE4IDUuODAwMDYgMTUuNzEgNS4zNDAwNiAxNS45IDUuMjMwMDZDMTguMzQgMy43MjAwNiAxOC4xNyAxLjg1MDA2IDE3Ljc0IDEuMDcwMDZDMTcuNDcgMC41OTAwNiAxNi44NiAwLjM5MDA2IDE2LjM3IDAuNjUwMDZDMTUuODkgMC45MjAwNiAxNS43IDEuNTAwMDYgMTUuOTYgMS45OTAwNkMxNi4wNiAyLjI0MDA2IDE1Ljk0IDIuODQwMDYgMTQuODQgMy41MjAwNkMxMy43MyA0LjIxMDA2IDEyLjkzIDUuNzcwMDYgMTIuNCA4LjI4MDA2QzEyLjEgOC4yNDAwNiAxMS44IDguMjMwMDYgMTEuNSA4LjI0MDA2QzEwLjkgNy41MDAwNiAxMC4zMyA3LjA2MDA2IDkuNzcwMDIgNi45MDAwNkM5LjQyMDAyIDYuNjIwMDYgOC42OTAwMiA1LjIzMDA2IDguMjEwMDIgMy45MjAwNkM4LjAyMDAyIDMuNDAwMDYgNy40NDAwMiAzLjE0MDA2IDYuOTMwMDIgMy4zMzAwNkM2LjQyMDAyIDMuNTIwMDYgNi4xNTAwMiA0LjEwMDA2IDYuMzQwMDIgNC42MTAwNkM2LjczMDAyIDUuNjcwMDYgNy4yNjAwMiA2Ljg2MDA2IDcuODcwMDIgNy43MTAwNkM3LjUxMDAyIDcuNjIwMDYgNy4xNDAwMiA3LjU3MDA2IDYuNzYwMDIgNy41NzAwNkM1LjI4MDAyIDcuNTcwMDYgMy45ODAwMiA4LjI3MDA2IDMuMTIwMDIgOS4zNDAwNkMzLjA0MDAyIDkuMzQwMDYgMi45NjAwMiA5LjMyMDA2IDIuODgwMDIgOS4zMjAwNkMxLjYyMDAyIDkuMzIwMDYgMC40NzAwMiAxMC4xMTAxIDAuMDIwMDE5NSAxMS4yOTAxTDEuODkwMDIgMTIuMDAwMUMxLjk0MDAyIDExLjg2MDEgMi4wMzAwMiAxMS43NTAxIDIuMTMwMDIgMTEuNjQwMUMyLjEwMDAyIDExLjg0MDEgMi4wNzAwMiAxMi4wNDAxIDIuMDcwMDIgMTIuMjQwMUMyLjA3MDAyIDEyLjU0MDEgMi4xMDAwMiAxMi44NDAxIDIuMTYwMDIgMTMuMTIwMUMyLjA0MDAyIDEzLjAxMDEgMS45NDAwMiAxMi44OTAxIDEuODkwMDIgMTIuNzQwMUwwLjA0MDAxOTUgMTMuNDYwMUMwLjQ5MDAyIDE0LjY0MDEgMS42NDAwMiAxNS40MzAxIDIuOTAwMDIgMTUuNDMwMUMzLjA0MDAyIDE1LjQzMDEgMy4xODAwMiAxNS40MDAxIDMuMzMwMDIgMTUuMzgwMUM0LjE5MDAyIDE2LjMyMDEgNS40MTAwMiAxNi45MjAxIDYuNzgwMDIgMTYuOTIwMUM3LjE2MDAyIDE2LjkyMDEgNy41MzAwMiAxNi44NzAxIDcuODkwMDIgMTYuNzgwMUM3LjI3MDAyIDE3LjYzMDEgNi43NDAwMiAxOC44MzAxIDYuMzUwMDIgMTkuODgwMUM2LjE2MDAyIDIwLjQwMDEgNi40MzAwMiAyMC45NzAxIDYuOTQwMDIgMjEuMTYwMUM3LjA1MDAyIDIxLjIwMDEgNy4xNzAwMiAyMS4yMjAxIDcuMjkwMDIgMjEuMjIwMUM3LjcwMDAyIDIxLjIyMDEgOC4wODAwMiAyMC45NzAxIDguMjMwMDIgMjAuNTYwMUM4LjcxMDAyIDE5LjI1MDEgOS40NDAwMiAxNy44NjAxIDkuNzkwMDIgMTcuNTgwMUMxMC4zNSAxNy40MjAxIDEwLjkxIDE2Ljk5MDEgMTEuNTEgMTYuMjYwMUMxMS41OCAxNi4yNjAxIDExLjY1IDE2LjI4MDEgMTEuNzMgMTYuMjgwMUMxMS45NCAxNi4yODAxIDEyLjE0IDE2LjI0MDEgMTIuMzQgMTYuMjEwMUMxMi44MiAxOC43OTAxIDEzLjcgMjAuNDEwMSAxNC45NiAyMS4wMTAxQzE2LjIzIDIxLjYyMDEgMTYuMTEgMjIuMjQwMSAxNi4wMSAyMi40NTAxQzE1Ljc0IDIyLjkzMDEgMTUuOTIgMjMuNTQwMSAxNi40IDIzLjgxMDFDMTYuNTUgMjMuODkwMSAxNi43MiAyMy45MzAxIDE2Ljg4IDIzLjkzMDFDMTcuMjMgMjMuOTMwMSAxNy41OCAyMy43NDAxIDE3Ljc2IDIzLjQxMDFDMTcuODEgMjMuMzEwMSAxOC4yNyAyMi40MzAxIDE3LjkzIDIxLjM1MDFDMTcuNjUgMjAuNDcwMSAxNi45NCAxOS43NTAxIDE1LjgzIDE5LjIxMDFDMTUuNjMgMTkuMTEwMSAxNS4wNSAxOC42OTAxIDE0LjU3IDE3LjAwMDFDMTYuMTkgMTguNTAwMSAxNy41NCAxOS4zMzAxIDE4LjYgMTkuNDUwMUMxOC44OCAxOS40ODAxIDE5LjA3IDE5LjUyMDEgMTkuMjEgMTkuNTYwMUMxOS4yMSAxOS44NDAxIDE5LjM1IDIwLjEyMDEgMTkuNTkgMjAuMzEwMUMxOS43NyAyMC40NjAxIDIwIDIwLjUzMDEgMjAuMjEgMjAuNTMwMUMyMC41IDIwLjUzMDEgMjAuNzkgMjAuNDAwMSAyMC45OSAyMC4xNTAxQzIxLjI0IDE5Ljg0MDEgMjEuNDQgMTkuMjgwMSAyMS4yIDE4LjcxMDFDMjAuODIgMTcuNzkwMSAxOS42NiAxNy41NjAxIDE4LjgzIDE3LjQ2MDFDMTguNDMgMTcuNDIwMSAxNy43MSAxNy4wNDAxIDE2LjcgMTYuMjEwMUMxNy4wNSAxNi4yNTAxIDE3LjQgMTYuMjcwMSAxNy43NyAxNi4yNzAxQzIxLjI3IDE2LjI3MDEgMjQuMDEgMTQuNDkwMSAyNC4wMSAxMi4yMzAxTDIzLjk5IDEyLjI1MDFaTTkuNDAwMDIgMTIuNzUwMUM5LjMyMDAyIDEzLjE5MDEgOS4xNDAwMiAxMy41OTAxIDguODUwMDIgMTMuOTQwMUM4LjM0MDAyIDE0LjU2MDEgNy41ODAwMiAxNC45MjAxIDYuNzcwMDIgMTQuOTIwMUM1LjI5MDAyIDE0LjkyMDEgNC4wOTAwMiAxMy43MjAxIDQuMDkwMDIgMTIuMjUwMUM0LjA5MDAyIDEwLjc4MDEgNS4yOTAwMiA5LjU4MDA2IDYuNzcwMDIgOS41ODAwNkM3LjU4MDAyIDkuNTgwMDYgOC4zMzAwMiA5Ljk0MDA2IDguODQwMDIgMTAuNTcwMUM5LjIzMDAyIDExLjA1MDEgOS40NDAwMiAxMS42MzAxIDkuNDQwMDIgMTIuMjYwMUM5LjQ0MDAyIDEyLjQzMDEgOS40MjAwMiAxMi42MDAxIDkuMzkwMDIgMTIuNzYwMUw5LjQwMDAyIDEyLjc1MDFaTTEzLjkxIDEyLjcwMDFDMTMuODIgMTMuMDYwMSAxMy42MyAxMy4zOTAxIDEzLjM0IDEzLjY3MDFDMTMuMTYgMTMuODQwMSAxMi45NiAxMy45NzAxIDEyLjcyIDE0LjA4MDFDMTIuMTkgMTQuMzIwMSAxMS41OCAxNC4zNjAxIDExLjAzIDE0LjIwMDFDMTEuMDUgMTQuMTUwMSAxMS4wNiAxNC4xMDAxIDExLjA4IDE0LjA1MDFDMTEuMTYgMTMuODUwMSAxMS4yMyAxMy42NTAxIDExLjI4IDEzLjQ0MDFDMTEuMyAxMy4zNTAxIDExLjMzIDEzLjI2MDEgMTEuMzUgMTMuMTcwMUMxMS40MSAxMi44NzAxIDExLjQ1IDEyLjU3MDEgMTEuNDUgMTIuMjUwMUMxMS40NSAxMS45MzAxIDExLjQxIDExLjYzMDEgMTEuMzUgMTEuMzQwMUMxMS4zMyAxMS4yNTAxIDExLjMgMTEuMTYwMSAxMS4yOCAxMS4wNzAxQzExLjIzIDEwLjg2MDEgMTEuMTYgMTAuNjYwMSAxMS4wOCAxMC40NjAxQzExLjA2IDEwLjQxMDEgMTEuMDUgMTAuMzYwMSAxMS4wMyAxMC4zMTAxQzExLjYgMTAuMTQwMSAxMi4yMyAxMC4xOTAxIDEyLjc3IDEwLjQ1MDFDMTIuOTggMTAuNTQwMSAxMy4xNiAxMC42NzAxIDEzLjM0IDEwLjg0MDFDMTMuNzQgMTEuMjIwMSAxMy45NiAxMS43MjAxIDEzLjk2IDEyLjI1MDFDMTMuOTYgMTIuNDAwMSAxMy45NCAxMi41NTAxIDEzLjkgMTIuNzAwMUgxMy45MVpNMTUuNTYgMTMuOTcwMUMxNS41NiAxMy45NzAxIDE1LjU4IDEzLjkxMDEgMTUuNTkgMTMuODkwMUMxNS42NyAxMy43MjAxIDE1LjczIDEzLjU0MDEgMTUuNzggMTMuMzYwMUMxNS44MSAxMy4yNzAxIDE1Ljg0IDEzLjE5MDEgMTUuODYgMTMuMTAwMUMxNS45MiAxMi44MjAxIDE1Ljk2IDEyLjU0MDEgMTUuOTYgMTIuMjUwMUMxNS45NiAxMS45NjAxIDE1LjkyIDExLjY4MDEgMTUuODYgMTEuNDAwMUMxNS44NCAxMS4zMTAxIDE1LjgxIDExLjIzMDEgMTUuNzggMTEuMTUwMUMxNS43MiAxMC45NjAxIDE1LjY3IDEwLjc4MDEgMTUuNTggMTAuNjAwMUMxNS41NyAxMC41ODAxIDE1LjU2IDEwLjU1MDEgMTUuNTUgMTAuNTIwMUMxNi4yMSAxMC4zMTAxIDE2Ljk2IDEwLjIwMDEgMTcuNzMgMTAuMjAwMUMyMC4xNiAxMC4yMDAxIDIxLjk3IDExLjI4MDEgMjEuOTcgMTIuMjQwMUMyMS45NyAxMy4yMDAxIDIwLjE2IDE0LjI4MDEgMTcuNzMgMTQuMjgwMUMxNi45NiAxNC4yODAxIDE2LjIgMTQuMTcwMSAxNS41NCAxMy45NjAxTDE1LjU2IDEzLjk3MDFaIiBmaWxsPSJibGFjayIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzkyNTdfMjE3Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjI1KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", Mpe = "PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkyMzBfNzYpIj4KPHBhdGggZD0iTTI0LjA2MDEgNy40MTk5MkgwLjA2MDA1ODZWOS40MTk5MkgyNC4wNjAxVjcuNDE5OTJaIiBmaWxsPSIjM0EzNTQxIiBmaWxsLW9wYWNpdHk9IjEiLz4KPHBhdGggZD0iTTI0LjA2MDEgMTUuNDA5OUgwLjA2MDA1ODZWMTcuNDA5OUgyNC4wNjAxVjE1LjQwOTlaIiBmaWxsPSIjM0EzNTQxIiBmaWxsLW9wYWNpdHk9IjEiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85MjMwXzc2Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wNjAwNTg2IDAuNDE5OTIyKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", mpe = "PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkyMzBfODkpIj4KPHBhdGggZD0iTTI0LjA2MDEgOS40MTk5MkgwLjA2MDA1ODZWMTEuNDE5OUgyNC4wNjAxVjkuNDE5OTJaIiBmaWxsPSIjM0EzNTQxIiBmaWxsLW9wYWNpdHk9IjEiLz4KPHBhdGggZD0iTTI0LjA2MDEgMTMuNDdIMC4wNjAwNTg2VjE1LjQ3SDI0LjA2MDFWMTMuNDdaIiBmaWxsPSIjM0EzNTQxIiBmaWxsLW9wYWNpdHk9IjEiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85MjMwXzg5Ij4KPHJlY3Qgd2lkdGg9IjI0LjA0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wNjAwNTg2IDAuNDE5OTIyKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", ype = "PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkyMzBfOTApIj4KPHBhdGggZD0iTTI0LjEwMDEgMTEuNDE5OUgwLjEwMDA5OFYxMy40MTk5SDI0LjEwMDFWMTEuNDE5OVoiIGZpbGw9IiMzQTM1NDEiIGZpbGwtb3BhY2l0eT0iMSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzkyMzBfOTAiPgo8cmVjdCB3aWR0aD0iMjQuMDMiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjEwMDA5OCAwLjQxOTkyMikiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", Ipe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQgMjJIMlYySDRWMjJaTTIyIDdINlYxMEgyMlY3Wk0xNiAxNEg2VjE3SDE2VjE0WiIgZmlsbD0iIzAwMTYyMyIgZmlsbC1vcGFjaXR5PSIwLjgiLz4KPHBhdGggZD0iTTQgMjJIMlYySDRWMjJaTTIyIDdINlYxMEgyMlY3Wk0xNiAxNEg2VjE3SDE2VjE0WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxwYXRoIGQ9Ik00IDIySDJWMkg0VjIyWk0yMiA3SDZWMTBIMjJWN1pNMTYgMTRINlYxN0gxNlYxNFoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNNCAyMkgyVjJINFYyMlpNMjIgN0g2VjEwSDIyVjdaTTE2IDE0SDZWMTdIMTZWMTRaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPC9zdmc+Cg==", xpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDJIMTNWN0gyMVYxMEgxM1YxNEgxOFYxN0gxM1YyMkgxMVYxN0g2VjE0SDExVjEwSDNWN0gxMVYyWiIgZmlsbD0iIzAwMTYyMyIgZmlsbC1vcGFjaXR5PSIwLjgiLz4KPHBhdGggZD0iTTExIDJIMTNWN0gyMVYxMEgxM1YxNEgxOFYxN0gxM1YyMkgxMVYxN0g2VjE0SDExVjEwSDNWN0gxMVYyWiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxwYXRoIGQ9Ik0xMSAySDEzVjdIMjFWMTBIMTNWMTRIMThWMTdIMTNWMjJIMTFWMTdINlYxNEgxMVYxMEgzVjdIMTFWMloiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNMTEgMkgxM1Y3SDIxVjEwSDEzVjE0SDE4VjE3SDEzVjIySDExVjE3SDZWMTRIMTFWMTBIM1Y3SDExVjJaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPC9zdmc+Cg==", Spe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDJIMjJWMjJIMjBWMlpNMiAxMEgxOFY3SDJWMTBaTTggMTdIMThWMTRIOFYxN1oiIGZpbGw9IiMwMDE2MjMiIGZpbGwtb3BhY2l0eT0iMC44Ii8+CjxwYXRoIGQ9Ik0yMCAySDIyVjIySDIwVjJaTTIgMTBIMThWN0gyVjEwWk04IDE3SDE4VjE0SDhWMTdaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPHBhdGggZD0iTTIwIDJIMjJWMjJIMjBWMlpNMiAxMEgxOFY3SDJWMTBaTTggMTdIMThWMTRIOFYxN1oiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNMjAgMkgyMlYyMkgyMFYyWk0yIDEwSDE4VjdIMlYxMFpNOCAxN0gxOFYxNEg4VjE3WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4yIi8+Cjwvc3ZnPgo=", jpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyIDJWNEgyVjJIMjJaTTcgMjJIMTBWNkg3VjIyWk0xNCAxNkgxN1Y2SDE0VjE2WiIgZmlsbD0iIzAwMTYyMyIgZmlsbC1vcGFjaXR5PSIwLjgiLz4KPHBhdGggZD0iTTIyIDJWNEgyVjJIMjJaTTcgMjJIMTBWNkg3VjIyWk0xNCAxNkgxN1Y2SDE0VjE2WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxwYXRoIGQ9Ik0yMiAyVjRIMlYySDIyWk03IDIySDEwVjZIN1YyMlpNMTQgMTZIMTdWNkgxNFYxNloiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNMjIgMlY0SDJWMkgyMlpNNyAyMkgxMFY2SDdWMjJaTTE0IDE2SDE3VjZIMTRWMTZaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPC9zdmc+Cg==", Dpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyIDExSDE3VjZIMTRWMTFIMTBWM0g3LjAwMDAzVjExSDEuODQwMDNWMTNINy4wMDAwM1YyMUgxMFYxM0gxNFYxOEgxN1YxM0gyMlYxMVoiIGZpbGw9IiMwMDE2MjMiIGZpbGwtb3BhY2l0eT0iMC44Ii8+CjxwYXRoIGQ9Ik0yMiAxMUgxN1Y2SDE0VjExSDEwVjNINy4wMDAwM1YxMUgxLjg0MDAzVjEzSDcuMDAwMDNWMjFIMTBWMTNIMTRWMThIMTdWMTNIMjJWMTFaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPHBhdGggZD0iTTIyIDExSDE3VjZIMTRWMTFIMTBWM0g3LjAwMDAzVjExSDEuODQwMDNWMTNINy4wMDAwM1YyMUgxMFYxM0gxNFYxOEgxN1YxM0gyMlYxMVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNMjIgMTFIMTdWNkgxNFYxMUgxMFYzSDcuMDAwMDNWMTFIMS44NDAwM1YxM0g3LjAwMDAzVjIxSDEwVjEzSDE0VjE4SDE3VjEzSDIyVjExWiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4yIi8+Cjwvc3ZnPgo=", wpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyIDIySDJWMjBIMjJWMjJaTTEwIDJIN1YxOEgxMFYyWk0xNyA4SDE0VjE4SDE3VjhaIiBmaWxsPSIjMDAxNjIzIiBmaWxsLW9wYWNpdHk9IjAuOCIvPgo8cGF0aCBkPSJNMjIgMjJIMlYyMEgyMlYyMlpNMTAgMkg3VjE4SDEwVjJaTTE3IDhIMTRWMThIMTdWOFoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNMjIgMjJIMlYyMEgyMlYyMlpNMTAgMkg3VjE4SDEwVjJaTTE3IDhIMTRWMThIMTdWOFoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNMjIgMjJIMlYyMEgyMlYyMlpNMTAgMkg3VjE4SDEwVjJaTTE3IDhIMTRWMThIMTdWOFoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8L3N2Zz4K", Npe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkwNzZfMTYpIj4KPHBhdGggZD0iTTIzLjk4IDEwLjk3MDlWNS45NzUwMkgxOC45OFY3LjUwMzc1SDE2LjVWNC45ODU4NEgxOFYwSDEzVjEuNTI4NzNINVYwSDBWNC45OTU4NEgxLjVWMTMuMDE5MUgwVjE4LjAxNUg1VjE2LjUxNjJINy40OFYxOC45OTQySDUuOThWMjMuOTlIMTAuOThWMjIuNDkxM0gxOC45OFYyMy45OUgyMy45OFYxOC45OTQySDIyLjQ4VjEwLjk3MDlIMjMuOThaTTMuNSAxMy4wMTkxVjQuOTk1ODRINVYzLjUyNzA2SDEzVjQuOTk1ODRIMTQuNVYxMy4wMTkxSDEzVjE0LjUxNzlINVYxMy4wMTkxSDMuNVpNMjAuNDggMTkuMDA0MkgxOC45OFYyMC41MDI5SDEwLjk4VjE5LjAwNDJIOS40OFYxNi41MjYySDEzVjE4LjAyNUgxOFYxMy4wMjkxSDE2LjVWOS41MTIwN0gxOC45OFYxMC45ODA4SDIwLjQ4VjE5LjAwNDJaIiBmaWxsPSIjM0EzNTQxIiBmaWxsLW9wYWNpdHk9IjEiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85MDc2XzE2Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", Ape = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkwNzBfMzgpIj4KPHBhdGggZD0iTTI0IDUuOTYyNjFWMEgxOFYxLjk4NDIxSDZWMEgwVjUuOTYyNjFIMlYxNy44OTc4SDBWMjMuODYwNEg2VjIxLjg3NjJIMThWMjMuODYwNEgyNFYxNy44OTc4SDIyVjUuOTYyNjFIMjRaTTIwIDE3Ljg5NzhIMThWMTkuODgySDZWMTcuODk3OEg0VjUuOTYyNjFINlYzLjk3ODRIMThWNS45NjI2MUgyMFYxNy44OTc4WiIgZmlsbD0iIzNBMzU0MSIgZmlsbC1vcGFjaXR5PSIxIi8+CjxwYXRoIGQ9Ik0xMi44NiA3LjU2Nzg3SDcuNDU5OTZWMTIuOTMyMkgxMi44NlY3LjU2Nzg3WiIgZmlsbD0iIzNBMzU0MSIgZmlsbC1vcGFjaXR5PSIxIi8+CjxwYXRoIGQ9Ik0xNC42NjAxIDE0LjcyN0gxMS4wNjAxVjE2LjUxMThIMTYuNDYwMVYxMS4xNDc1SDE0LjY2MDFWMTQuNzI3WiIgZmlsbD0iIzNBMzU0MSIgZmlsbC1vcGFjaXR5PSIxIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfOTA3MF8zOCI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", Tpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImFkZF90b19waG90b3NfMjRweCI+CjxwYXRoIGlkPSJpY29uL2ltYWdlL2FkZF90b19waG90b3NfMjRweCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDJIMjBDMjEuMSAyIDIyIDIuOSAyMiA0VjE2QzIyIDE3LjEgMjEuMSAxOCAyMCAxOEg4QzYuOSAxOCA2IDE3LjEgNiAxNlY0QzYgMi45IDYuOSAyIDggMlpNMiA2SDRWMjBIMThWMjJINEMyLjkgMjIgMiAyMS4xIDIgMjBWNlpNMjAgMTZIOFY0SDIwVjE2Wk0xNSAxNUgxM1YxMUg5VjlIMTNWNUgxNVY5SDE5VjExSDE1VjE1WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMSIvPgo8L2c+Cjwvc3ZnPgo=", bpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkwNzBfMTEpIj4KPHBhdGggZD0iTTEyLjk0MDYgMEgxMC45NDk3VjIuNUgxMi45NDA2VjBaIiBmaWxsPSIjM0EzNTQxIiBmaWxsLW9wYWNpdHk9IjEiLz4KPHBhdGggZD0iTTEyLjk0MDYgMTkuMDhIMTAuOTQ5N1YxNS45N0gxMi45NDA2VjE5LjA4Wk0xMi45NDA2IDEzLjU1SDEwLjk0OTdWMTAuNDRIMTIuOTQwNlYxMy41NVpNMTIuOTQwNiA4LjAzMDA0SDEwLjk0OTdWNC45MjAwNEgxMi45NDA2VjguMDMwMDRaIiBmaWxsPSIjM0EzNTQxIiBmaWxsLW9wYWNpdHk9IjEiLz4KPHBhdGggZD0iTTEyLjk0MDYgMjEuNUgxMC45NDk3VjI0SDEyLjk0MDZWMjEuNVoiIGZpbGw9IiMzQTM1NDEiIGZpbGwtb3BhY2l0eT0iMSIvPgo8cGF0aCBkPSJNMjQuMDAwMSAyMC4wNjk5TDEzLjgzNjcgMTEuOTk5OUwyNC4wMDAxIDMuOTM5OTRWMjAuMDY5OVpNMTcuMDQyIDExLjk5OTlMMjEuOTk5MyAxNS45Mzk5VjguMDY5OTRMMTcuMDQyIDEyLjAwOTlWMTEuOTk5OVoiIGZpbGw9IiMzQTM1NDEiIGZpbGwtb3BhY2l0eT0iMSIvPgo8cGF0aCBkPSJNMC4zODgxODQgMTkuMDNWNC45Njk5N0w5LjI0NzU4IDEyTDAuMzg4MTg0IDE5LjAzWk0xLjM4MzYyIDcuMDI5OTdWMTYuOTdMNy42NDQ5MiAxMkwxLjM4MzYyIDcuMDI5OTdaIiBmaWxsPSIjM0EzNTQxIiBmaWxsLW9wYWNpdHk9IjEiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85MDcwXzExIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", vpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkwNzBfMTEpIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAxMiAxMikiPgo8cGF0aCBkPSJNMTIuOTQwNiAwSDEwLjk0OTdWMi41SDEyLjk0MDZWMFoiIGZpbGw9IiMzQTM1NDEiIGZpbGwtb3BhY2l0eT0iMSIvPgo8cGF0aCBkPSJNMTIuOTQwNiAxOS4wOEgxMC45NDk3VjE1Ljk3SDEyLjk0MDZWMTkuMDhaTTEyLjk0MDYgMTMuNTVIMTAuOTQ5N1YxMC40NEgxMi45NDA2VjEzLjU1Wk0xMi45NDA2IDguMDMwMDRIMTAuOTQ5N1Y0LjkyMDA0SDEyLjk0MDZWOC4wMzAwNFoiIGZpbGw9IiMzQTM1NDEiIGZpbGwtb3BhY2l0eT0iMSIvPgo8cGF0aCBkPSJNMTIuOTQwNiAyMS41SDEwLjk0OTdWMjRIMTIuOTQwNlYyMS41WiIgZmlsbD0iIzNBMzU0MSIgZmlsbC1vcGFjaXR5PSIxIi8+CjxwYXRoIGQ9Ik0yNC4wMDAxIDIwLjA2OTlMMTMuODM2NyAxMS45OTk5TDI0LjAwMDEgMy45Mzk5NFYyMC4wNjk5Wk0xNy4wNDIgMTEuOTk5OUwyMS45OTkzIDE1LjkzOTlWOC4wNjk5NEwxNy4wNDIgMTIuMDA5OVYxMS45OTk5WiIgZmlsbD0iIzNBMzU0MSIgZmlsbC1vcGFjaXR5PSIxIi8+CjxwYXRoIGQ9Ik0wLjM4ODE4NCAxOS4wM1Y0Ljk2OTk3TDkuMjQ3NTggMTJMMC4zODgxODQgMTkuMDNaTTEuMzgzNjIgNy4wMjk5N1YxNi45N0w3LjY0NDkyIDEyTDEuMzgzNjIgNy4wMjk5N1oiIGZpbGw9IiMzQTM1NDEiIGZpbGwtb3BhY2l0eT0iMSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzkwNzBfMTEiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==", Epe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgMTNINVYxMUgzVjEzWk0zIDE3SDVWMTVIM1YxN1pNNSAyMVYxOUgzQzMgMjAuMSAzLjg5IDIxIDUgMjFaTTMgOUg1VjdIM1Y5Wk0xNSAyMUgxN1YxOUgxNVYyMVpNMTkgM0g5QzcuODkgMyA3IDMuOSA3IDVWMTVDNyAxNi4xIDcuODkgMTcgOSAxN0gxOUMyMC4xIDE3IDIxIDE2LjEgMjEgMTVWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTE5IDE1SDlWNUgxOVYxNVpNMTEgMjFIMTNWMTlIMTFWMjFaTTcgMjFIOVYxOUg3VjIxWiIgZmlsbD0iIzAwMTYyMyIgZmlsbC1vcGFjaXR5PSIxIi8+CjxwYXRoIGQ9Ik0zIDEzSDVWMTFIM1YxM1pNMyAxN0g1VjE1SDNWMTdaTTUgMjFWMTlIM0MzIDIwLjEgMy44OSAyMSA1IDIxWk0zIDlINVY3SDNWOVpNMTUgMjFIMTdWMTlIMTVWMjFaTTE5IDNIOUM3Ljg5IDMgNyAzLjkgNyA1VjE1QzcgMTYuMSA3Ljg5IDE3IDkgMTdIMTlDMjAuMSAxNyAyMSAxNi4xIDIxIDE1VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xOSAxNUg5VjVIMTlWMTVaTTExIDIxSDEzVjE5SDExVjIxWk03IDIxSDlWMTlIN1YyMVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNMyAxM0g1VjExSDNWMTNaTTMgMTdINVYxNUgzVjE3Wk01IDIxVjE5SDNDMyAyMC4xIDMuODkgMjEgNSAyMVpNMyA5SDVWN0gzVjlaTTE1IDIxSDE3VjE5SDE1VjIxWk0xOSAzSDlDNy44OSAzIDcgMy45IDcgNVYxNUM3IDE2LjEgNy44OSAxNyA5IDE3SDE5QzIwLjEgMTcgMjEgMTYuMSAyMSAxNVY1QzIxIDMuOSAyMC4xIDMgMTkgM1pNMTkgMTVIOVY1SDE5VjE1Wk0xMSAyMUgxM1YxOUgxMVYyMVpNNyAyMUg5VjE5SDdWMjFaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPHBhdGggZD0iTTMgMTNINVYxMUgzVjEzWk0zIDE3SDVWMTVIM1YxN1pNNSAyMVYxOUgzQzMgMjAuMSAzLjg5IDIxIDUgMjFaTTMgOUg1VjdIM1Y5Wk0xNSAyMUgxN1YxOUgxNVYyMVpNMTkgM0g5QzcuODkgMyA3IDMuOSA3IDVWMTVDNyAxNi4xIDcuODkgMTcgOSAxN0gxOUMyMC4xIDE3IDIxIDE2LjEgMjEgMTVWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTE5IDE1SDlWNUgxOVYxNVpNMTEgMjFIMTNWMTlIMTFWMjFaTTcgMjFIOVYxOUg3VjIxWiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4yIi8+Cjwvc3ZnPgo=", Cpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImFycm93X3Vwd2FyZF8yNHB4Ij4KPHBhdGggaWQ9Imljb24vbmF2aWdhdGlvbi9hcnJvd191cHdhcmRfMjRweCIgZD0iTTQgMTJMNS40MSAxMy40MUwxMSA3LjgzVjIwSDEzVjcuODNMMTguNTggMTMuNDJMMjAgMTJMMTIgNEw0IDEyWiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMSIvPgo8L2c+Cjwvc3ZnPgo=", zpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImFycm93X2Rvd253YXJkXzI0cHgiPgo8cGF0aCBpZD0iaWNvbi9uYXZpZ2F0aW9uL2Fycm93X2Rvd253YXJkXzI0cHgiIGQ9Ik0yMCAxMkwxOC41OSAxMC41OUwxMyAxNi4xN1Y0SDExVjE2LjE3TDUuNDIgMTAuNThMNCAxMkwxMiAyMEwyMCAxMloiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjEiLz4KPC9nPgo8L3N2Zz4K", Lpe = "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgN0g3VjlIOVY3Wk05IDExSDdWMTNIOVYxMVpNOSAzQzcuODkgMyA3IDMuOSA3IDVIOVYzWk0xMyAxNUgxMVYxN0gxM1YxNVpNMTkgM1Y1SDIxQzIxIDMuOSAyMC4xIDMgMTkgM1pNMTMgM0gxMVY1SDEzVjNaTTkgMTdWMTVIN0M3IDE2LjEgNy44OSAxNyA5IDE3Wk0xOSAxM0gyMVYxMUgxOVYxM1pNMTkgOUgyMVY3SDE5VjlaTTE5IDE3QzIwLjEgMTcgMjEgMTYuMSAyMSAxNUgxOVYxN1pNNSA3SDNWMTlDMyAyMC4xIDMuODkgMjEgNSAyMUgxN1YxOUg1VjdaTTE1IDVIMTdWM0gxNVY1Wk0xNSAxN0gxN1YxNUgxNVYxN1oiIGZpbGw9IiMwMDE2MjMiIGZpbGwtb3BhY2l0eT0iMSIvPgo8cGF0aCBkPSJNOSA3SDdWOUg5VjdaTTkgMTFIN1YxM0g5VjExWk05IDNDNy44OSAzIDcgMy45IDcgNUg5VjNaTTEzIDE1SDExVjE3SDEzVjE1Wk0xOSAzVjVIMjFDMjEgMy45IDIwLjEgMyAxOSAzWk0xMyAzSDExVjVIMTNWM1pNOSAxN1YxNUg3QzcgMTYuMSA3Ljg5IDE3IDkgMTdaTTE5IDEzSDIxVjExSDE5VjEzWk0xOSA5SDIxVjdIMTlWOVpNMTkgMTdDMjAuMSAxNyAyMSAxNi4xIDIxIDE1SDE5VjE3Wk01IDdIM1YxOUMzIDIwLjEgMy44OSAyMSA1IDIxSDE3VjE5SDVWN1pNMTUgNUgxN1YzSDE1VjVaTTE1IDE3SDE3VjE1SDE1VjE3WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxwYXRoIGQ9Ik05IDdIN1Y5SDlWN1pNOSAxMUg3VjEzSDlWMTFaTTkgM0M3Ljg5IDMgNyAzLjkgNyA1SDlWM1pNMTMgMTVIMTFWMTdIMTNWMTVaTTE5IDNWNUgyMUMyMSAzLjkgMjAuMSAzIDE5IDNaTTEzIDNIMTFWNUgxM1YzWk05IDE3VjE1SDdDNyAxNi4xIDcuODkgMTcgOSAxN1pNMTkgMTNIMjFWMTFIMTlWMTNaTTE5IDlIMjFWN0gxOVY5Wk0xOSAxN0MyMC4xIDE3IDIxIDE2LjEgMjEgMTVIMTlWMTdaTTUgN0gzVjE5QzMgMjAuMSAzLjg5IDIxIDUgMjFIMTdWMTlINVY3Wk0xNSA1SDE3VjNIMTVWNVpNMTUgMTdIMTdWMTVIMTVWMTdaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPHBhdGggZD0iTTkgN0g3VjlIOVY3Wk05IDExSDdWMTNIOVYxMVpNOSAzQzcuODkgMyA3IDMuOSA3IDVIOVYzWk0xMyAxNUgxMVYxN0gxM1YxNVpNMTkgM1Y1SDIxQzIxIDMuOSAyMC4xIDMgMTkgM1pNMTMgM0gxMVY1SDEzVjNaTTkgMTdWMTVIN0M3IDE2LjEgNy44OSAxNyA5IDE3Wk0xOSAxM0gyMVYxMUgxOVYxM1pNMTkgOUgyMVY3SDE5VjlaTTE5IDE3QzIwLjEgMTcgMjEgMTYuMSAyMSAxNUgxOVYxN1pNNSA3SDNWMTlDMyAyMC4xIDMuODkgMjEgNSAyMUgxN1YxOUg1VjdaTTE1IDVIMTdWM0gxNVY1Wk0xNSAxN0gxN1YxNUgxNVYxN1oiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8L3N2Zz4K", kpe = "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", Ope = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjI3MDQ3IDEyLjMxNjFDNi42NDgyIDExLjkxMzEgNy4yODEwMyAxMS44OTI3IDcuNjgzOTQgMTIuMjcwNUwxNSAxOS4xMjkzTDIyLjMxNjEgMTIuMjcwNUMyMi43MTkgMTEuODkyNyAyMy4zNTE4IDExLjkxMzEgMjMuNzI5NSAxMi4zMTYxQzI0LjEwNzMgMTIuNzE5IDI0LjA4NjkgMTMuMzUxOCAyMy42ODM5IDEzLjcyOTVMMTUuNjgzOSAyMS4yMjk1QzE1LjI5OTMgMjEuNTkwMiAxNC43MDA3IDIxLjU5MDIgMTQuMzE2MSAyMS4yMjk1TDYuMzE2MDYgMTMuNzI5NUM1LjkxMzE1IDEzLjM1MTggNS44OTI3NCAxMi43MTkgNi4yNzA0NyAxMi4zMTYxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", Ppe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuOTk5NzYgMTJIMjcuOTk5OFYxOEgxLjk5OTc2VjEyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTAgM0MwIDIuNDQ3NzIgMC40NDc3MTUgMiAxIDJDMS41NTIyOCAyIDIgMi40NDc3MiAyIDNWMjdDMiAyNy41NTIzIDEuNTUyMjggMjggMSAyOEMwLjQ0NzcxNSAyOCAwIDI3LjU1MjMgMCAyN1YzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTI3Ljk5OTggM0MyNy45OTk4IDIuNDQ3NzIgMjguNDQ3NSAyIDI4Ljk5OTggMkMyOS41NTIgMiAyOS45OTk4IDIuNDQ3NzIgMjkuOTk5OCAzVjI3QzI5Ljk5OTggMjcuNTUyMyAyOS41NTIgMjggMjguOTk5OCAyOEMyOC40NDc1IDI4IDI3Ljk5OTggMjcuNTUyMyAyNy45OTk4IDI3VjNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", Upe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuOTk5ODggMUMxLjk5OTg4IDAuNDQ3NzE1IDIuNDQ3NTkgMCAyLjk5OTg4IDBIMjYuOTk5OUMyNy41NTIyIDAgMjcuOTk5OSAwLjQ0NzcxNSAyNy45OTk5IDFDMjcuOTk5OSAxLjU1MjI4IDI3LjU1MjIgMiAyNi45OTk5IDJIMi45OTk4OEMyLjQ0NzU5IDIgMS45OTk4OCAxLjU1MjI4IDEuOTk5ODggMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMi4wMDAxIDIuMDAwMDFMMTguMDAwMSAyLjAwMDAxVjI4TDI2Ljk5OTkgMjhDMjcuNTUyMiAyOCAyNy45OTk5IDI4LjQ0NzcgMjcuOTk5OSAyOUMyNy45OTk5IDI5LjU1MjMgMjcuNTUyMiAzMCAyNi45OTk5IDMwSDIuOTk5ODhDMi40NDc1OSAzMCAxLjk5OTg4IDI5LjU1MjMgMS45OTk4OCAyOUMxLjk5OTg4IDI4LjQ0NzcgMi40NDc1OSAyOCAyLjk5OTg4IDI4TDEyLjAwMDEgMjhWMi4wMDAwMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", Rpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjcwNzExIDQuMjkyODlDMTAuMDk3NiA0LjY4MzQyIDEwLjA5NzYgNS4zMTY1OCA5LjcwNzExIDUuNzA3MTFMNy40MTQyMSA4SDE4QzIyLjk3MDYgOCAyNyAxMi4wMjk0IDI3IDE3QzI3IDIxLjk3MDYgMjIuOTcwNiAyNiAxOCAyNkgxMEM5LjQ0NzcyIDI2IDkgMjUuNTUyMyA5IDI1QzkgMjQuNDQ3NyA5LjQ0NzcyIDI0IDEwIDI0SDE4QzIxLjg2NiAyNCAyNSAyMC44NjYgMjUgMTdDMjUgMTMuMTM0IDIxLjg2NiAxMCAxOCAxMEg3LjQxNDIxTDkuNzA3MTEgMTIuMjkyOUMxMC4wOTc2IDEyLjY4MzQgMTAuMDk3NiAxMy4zMTY2IDkuNzA3MTEgMTMuNzA3MUM5LjMxNjU4IDE0LjA5NzYgOC42ODM0MiAxNC4wOTc2IDguMjkyODkgMTMuNzA3MUw0LjI5Mjg5IDkuNzA3MTFDMy45MDIzNyA5LjMxNjU4IDMuOTAyMzcgOC42ODM0MiA0LjI5Mjg5IDguMjkyODlMOC4yOTI4OSA0LjI5Mjg5QzguNjgzNDIgMy45MDIzNyA5LjMxNjU4IDMuOTAyMzcgOS43MDcxMSA0LjI5Mjg5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", Ype = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC4yOTI5IDQuMjkyODlDMjAuNjgzNCAzLjkwMjM3IDIxLjMxNjYgMy45MDIzNyAyMS43MDcxIDQuMjkyODlMMjUuNzA3MSA4LjI5Mjg5QzI2LjA5NzYgOC42ODM0MiAyNi4wOTc2IDkuMzE2NTggMjUuNzA3MSA5LjcwNzExTDIxLjcwNzEgMTMuNzA3MUMyMS4zMTY2IDE0LjA5NzYgMjAuNjgzNCAxNC4wOTc2IDIwLjI5MjkgMTMuNzA3MUMxOS45MDI0IDEzLjMxNjYgMTkuOTAyNCAxMi42ODM0IDIwLjI5MjkgMTIuMjkyOUwyMi41ODU4IDEwSDEyQzguMTM0MDEgMTAgNSAxMy4xMzQgNSAxN0M1IDIwLjg2NiA4LjEzNDAxIDI0IDEyIDI0SDIwQzIwLjU1MjMgMjQgMjEgMjQuNDQ3NyAyMSAyNUMyMSAyNS41NTIzIDIwLjU1MjMgMjYgMjAgMjZIMTJDNy4wMjk0NCAyNiAzIDIxLjk3MDYgMyAxN0MzIDEyLjAyOTQgNy4wMjk0NCA4IDEyIDhIMjIuNTg1OEwyMC4yOTI5IDUuNzA3MTFDMTkuOTAyNCA1LjMxNjU4IDE5LjkwMjQgNC42ODM0MiAyMC4yOTI5IDQuMjkyODlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", Qpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNTI3MSA4LjczMjU1TDEzLjc5NDcgMTUuMDAwMkw3LjUyNzIyIDIxLjI2NzdNMTYuMjA1MiA4LjczMjQyTDIyLjQ3MjggMTVMMTYuMjA1MyAyMS4yNjc1IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", Zpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDRIMjZWMjJIMjRWNy45OTk1MUMyNCA2Ljg5NDk0IDIzLjEwNDYgNS45OTk1MSAyMiA1Ljk5OTUxSDhWNFpNNiA1Ljk5OTUxVjRDNiAyLjg5NTQzIDYuODk1NDMgMiA4IDJIMjZDMjcuMTA0NiAyIDI4IDIuODk1NDMgMjggNFYyMkMyOCAyMy4xMDQ2IDI3LjEwNDYgMjQgMjYgMjRIMjRWMjUuOTk5NUMyNCAyNy4xMDQxIDIzLjEwNDYgMjcuOTk5NSAyMiAyNy45OTk1SDRDMi44OTU0MyAyNy45OTk1IDIgMjcuMTA0MSAyIDI1Ljk5OTVWNy45OTk1MUMyIDYuODk0OTQgMi44OTU0MyA1Ljk5OTUxIDQgNS45OTk1MUg2Wk0yMiAyNFYyNS45OTk1SDRMNCA3Ljk5OTUxSDZWMjJDNiAyMy4xMDQ2IDYuODk1NDMgMjQgOCAyNEgyMlpNMjIgMjJIOEw4IDcuOTk5NTFIMjJWMjJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", Fpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMS44ODggMTUuNzMzMUMyMS44ODggMTEuNTczOCAxNy44NjU4IDguOTIyNzcgMTMuMTEyMyA4LjkyMjc3QzkuNDgxMjEgOC45MjI3NyA2Ljk4MTg5IDExLjU2NDIgNi4yNzE0NSAxNC4xNjkyQzQuOTYwNzkgMTguOTc0OSA3Ljg5NDUgMjMuMDI3NyAxMS42NzQ2IDI0LjA5MDhDMTcuNzEyNiAyNS4yODE0IDIxLjg4OCAyMS40OTIxIDIxLjg4OCAxNS43MzMxWk0xNy4xNDMxIDIuMTg0NEMyMi4wNTYzIDIuOTAzNyAyNi4wOTUxIDYuNjAxMSAyNy40MjQxIDExLjM1MzFDMzEuMjgxNCAyNC40NTk4IDE0LjgxMzUgMzMuMTMyMiA2LjI3MTQ1IDI0LjU5MDJDLTMuNDU4NDkgMTQuODYxMSA0LjgzMDYzIDAuMTg3MTQxIDE3LjE0MzEgMi4xODQ0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", Bpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgNS43OTE1SDkuNjkzMzZMMTQuNjUwNCAxNy44ODUzSDE0Ljg2MTNMMTkuODE4NCA1Ljc5MTVIMjQuNTExN1YyMy43OTE1SDIwLjgyMDNWMTIuMDc1N0gyMC42NzA5TDE2LjAxMjcgMjMuNzAzNkgxMy40OTlMOC44NDA4MiAxMi4wMzE3SDguNjkxNDFWMjMuNzkxNUg1VjUuNzkxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", Gpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1IDNDMjYuMTA0NiAzIDI3IDMuODk1NDMgMjcgNVYyNUMyNyAyNi4xMDQ2IDI2LjEwNDYgMjcgMjUgMjdINUMzLjg5NTQzIDI3IDMgMjYuMTA0NiAzIDI1VjVDMyAzLjg5NTQzIDMuODk1NDMgMyA1IDNIMjVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==", Wpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSA3LjM5ODQ0QzEzLjAxMDkgNy4zOTg0NCAxMS4zOTg0IDkuMDEwOTEgMTEuMzk4NCAxMUMxMS4zOTg0IDEyLjk4OTEgMTMuMDEwOSAxNC42MDE2IDE1IDE0LjYwMTZDMTYuOTg5MSAxNC42MDE2IDE4LjYwMTYgMTIuOTg5MSAxOC42MDE2IDExQzE4LjYwMTYgOS4wMTA5MSAxNi45ODkxIDcuMzk4NDQgMTUgNy4zOTg0NFpNMTMuMzk4NCAxMUMxMy4zOTg0IDEwLjExNTUgMTQuMTE1NSA5LjM5ODQ0IDE1IDkuMzk4NDRDMTUuODg0NSA5LjM5ODQ0IDE2LjYwMTYgMTAuMTE1NSAxNi42MDE2IDExQzE2LjYwMTYgMTEuODg0NSAxNS44ODQ1IDEyLjYwMTYgMTUgMTIuNjAxNkMxNC4xMTU1IDEyLjYwMTYgMTMuMzk4NCAxMS44ODQ1IDEzLjM5ODQgMTFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQuNSAySDI1LjVDMjYuODgwNyAyIDI4IDMuMTE5MjkgMjggNC41VjI1LjVDMjggMjYuODgwNyAyNi44ODA3IDI4IDI1LjUgMjhINC41QzMuMTE5MjkgMjggMiAyNi44ODA3IDIgMjUuNVY0LjVDMiAzLjExOTI5IDMuMTE5MjkgMiA0LjUgMlpNMjYgNC41VjE4LjU4NThMMjIuNzA3MSAxNS4yOTI5QzIyLjMxNjYgMTQuOTAyNCAyMS42ODM0IDE0LjkwMjQgMjEuMjkyOSAxNS4yOTI5TDE1Ljc0OTYgMjAuODM2Mkw4LjczMSAxMy4zMTc2QzguNTQ1OTUgMTMuMTE5NCA4LjI4ODMzIDEzLjAwNDggOC4wMTcxOSAxMy4wMDAxQzcuNzQ2MDUgMTIuOTk1NSA3LjQ4NDY1IDEzLjEwMTEgNy4yOTI4OSAxMy4yOTI5TDQgMTYuNTg1OFY0LjVDNCA0LjIyMzg2IDQuMjIzODYgNCA0LjUgNEgyNS41QzI1Ljc3NjEgNCAyNiA0LjIyMzg2IDI2IDQuNVpNNCAyNS41VjE5LjQxNDJMNy45NzUyNiAxNS40MzlMMTQuOTg4NiAyMi45NTE5TDE3Ljc0NzQgMjZINC41QzQuMjIzODYgMjYgNCAyNS43NzYxIDQgMjUuNVpNMjUuNSAyNkgyMC40NDQ5TDE3LjEwNDcgMjIuMzA5NUwyMiAxNy40MTQyTDI2IDIxLjQxNDJWMjUuNUMyNiAyNS43NzYxIDI1Ljc3NjEgMjYgMjUuNSAyNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", Hpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjQ5OTYgMjEuNTAwMUw1Ljk5OTYzIDE1LjAwMDFNNS45OTk2MyAxNS4wMDAxTDEyLjQ5OTYgOC41MDAxMk01Ljk5OTYzIDE1LjAwMDFMMjMuOTk5OSAxNS4wMDAxIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", Vpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMTVMMjcgMTVNMTMgMjZMMjkgMTVMMTMgNCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", Kpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMTVMMjkgMTVNMjkgMTVWMk0yOSAxNVYyOCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==", Xpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjQxNDIgMy44MjgyMkwyOC4zMTM3IDEzLjcyNzdDMjkuMDk0OCAxNC41MDg4IDI5LjA5NDggMTUuNzc1MSAyOC4zMTM3IDE2LjU1NjFMMTguNDE0MiAyNi40NTU2QzE3LjYzMzIgMjcuMjM2NyAxNi4zNjY5IDI3LjIzNjcgMTUuNTg1OCAyNi40NTU2TDUuNjg2MzEgMTYuNTU2MUM0LjkwNTI2IDE1Ljc3NTEgNC45MDUyNiAxNC41MDg4IDUuNjg2MzEgMTMuNzI3N0wxNS41ODU4IDMuODI4MjJDMTYuMzY2OSAzLjA0NzE3IDE3LjYzMzIgMy4wNDcxNyAxOC40MTQyIDMuODI4MjJaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTEgMTVINSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==", Jpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5IDE1QzI5IDIxLjA3NTEgMjQuMDc1MSAyNiAxOCAyNkMxMS45MjQ5IDI2IDcgMjEuMDc1MSA3IDE1QzcgOC45MjQ4NyAxMS45MjQ5IDQgMTggNEMyNC4wNzUxIDQgMjkgOC45MjQ4NyAyOSAxNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMSAxNUg2IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K", qpe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMTVMMjkgMTUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=", _pe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMTVMNSAxNU04IDI3SDI2QzI3LjY1NjkgMjcgMjkgMjUuNjU2OSAyOSAyNFY2QzI5IDQuMzQzMTUgMjcuNjU2OSAzIDI2IDNIOEM2LjM0MzE1IDMgNSA0LjM0MzE1IDUgNlYyNEM1IDI1LjY1NjkgNi4zNDMxNSAyNyA4IDI3WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==", $pe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMTRDMC40NDc3MTUgMTQgMCAxNC40NDc3IDAgMTVDNS45NjA0NmUtMDggMTUuNTUyMyAwLjQ0NzcxNSAxNiAxIDE2TDEgMTRaTTI5IDJIMzBDMzAgMS42MjQ0NyAyOS43ODk2IDEuMjgwNiAyOS40NTUzIDEuMTA5NjRDMjkuMTIwOSAwLjkzODY3NyAyOC43MTg5IDAuOTY5NDUyIDI4LjQxNDUgMS4xODkzMkwyOSAyWk0yOSAyOEwyOC40MTQ1IDI4LjgxMDdDMjguNzE4OSAyOS4wMzA1IDI5LjEyMDkgMjkuMDYxMyAyOS40NTUzIDI4Ljg5MDRDMjkuNzg5NiAyOC43MTk0IDMwIDI4LjM3NTUgMzAgMjhIMjlaTTEgMTZMMTEgMTZWMTRMMSAxNEwxIDE2Wk0yOCAyVjI4SDMwVjJIMjhaTTI5LjU4NTUgMjcuMTg5M0wxMS41ODU1IDE0LjE4OTNMMTAuNDE0NSAxNS44MTA3TDI4LjQxNDUgMjguODEwN0wyOS41ODU1IDI3LjE4OTNaTTExLjU4NTUgMTUuODEwN0wyOS41ODU1IDIuODEwNjhMMjguNDE0NSAxLjE4OTMyTDEwLjQxNDUgMTQuMTg5M0wxMS41ODU1IDE1LjgxMDdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", efe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMTUuMTUzOUwxMS42OTIzIDE1LjE1MzlNMTIuNjkyMyAzLjQ2MTU1VjI2LjUzODVMMjguODQ2MiAxNUwxMi42OTIzIDMuNDYxNTVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", tfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuOTgxMjUgMTIuNDcyM0MxLjgzODM2IDEyLjY5MzggMi4wOTU1MSAxMy4wMDA4IDIuMzMyMTMgMTIuODg0NkMzLjE0Njg1IDEyLjQ4NDIgMy45MzU2OCAxMi4wNjE5IDQuNzA3MzMgMTEuNTk2N0M0LjkzNDQ4IDExLjQ1OTggNS4xODMwMyAxMS43MDQ2IDUuMDM1OSAxMS45MjUzQzMuMTMxNTEgMTQuNzgxOCAtMS41OTYzNCAyMS43OTgxIDMuNjA5MTggMjIuMjU3OEM2Ljc2ODk5IDIyLjUzNjggOS45Mzg5NCAxOS45NjE2IDEyLjkxMzMgMTcuMjczNUMxMy4xMzE4IDE3LjA3NTkgMTMuNDM3NiAxNy4zMzUgMTMuMjc0MyAxNy41ODAyQzEwLjg1MzcgMjEuMjE0MyA2LjQxNTE1IDI4LjYzNiAxMi4yNDkzIDI4Ljk5QzE3LjMyMzQgMjkuMjk4IDE2LjE1MzMgMjQuNTk3NyAyNy42NzkgMTguMjUyNEMyOC41MTY5IDE3Ljc5MTEgMjguNzgwNSAxNi44Mzk2IDI4LjU3MDcgMTUuOTEyNUMyOC4xOTg4IDEzLjkxODQgMjQuNDM2NCAxMy45NDk2IDIyLjM0NjYgMTQuNDk4NEMyMi4wOTI1IDE0LjU2NTEgMjEuODQ3NyAxNC4yNDUgMjIuMDE4MiAxNC4wNDVDMjQuNTY0MyAxMS4wNTkyIDMxLjg3MTEgMy42MDQxNCAyNy4yNjk3IDEuMjc3NDFDMjMuMjE5IC0wLjc3MDgzNiAxMy45MTggOC44OTgxOSA5Ljk2NTM1IDEyLjU0MDZDOS43NTcwNiAxMi43MzI1IDkuNTI5ODkgMTIuNTE5MiA5LjY5NzkzIDEyLjI5MTJDMTEuNjQyMyA5LjY1MzA4IDE0LjE4NjQgNi43MzE5MiAxNC42NDI5IDMuNjkzNjRDMTQuNzA3MyAzLjI2NTU1IDE0LjYyOCAyLjg2MTAzIDE0LjQwNTMgMi40ODAwOEMxNC4xODI1IDIuMDk5MTMgMTMuODU4NyAxLjgxNDUgMTMuNDMzOSAxLjYyNjJDOS4xMjQ3IC0wLjI4NDAwNyA0LjIwMjY4IDkuMDI3NjEgMS45ODEyNSAxMi40NzIzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", nfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI4LjAwMDEgMTJDMjguMDAwMSAxMS40NDc3IDI3LjU1MjQgMTEgMjcuMDAwMSAxMUMyNi40NDc4IDExIDI2LjAwMDEgMTEuNDQ3NyAyNi4wMDAxIDEyVjI2SDEyQzExLjQ0NzcgMjYgMTEgMjYuNDQ3NyAxMSAyN0MxMSAyNy41NTIzIDExLjQ0NzcgMjggMTIgMjhIMjYuOUMyNy40NTIzIDI4IDI4LjAwMDEgMjcuNDUyMiAyOC4wMDAxIDI2Ljg5OTlWMTJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMiAxOEMyIDE4LjU1MjMgMi40NDc2OSAxOSAyLjk5OTk3IDE5QzMuNTUyMjUgMTkgNCAxOC41NTIzIDQgMThMNCA0TDE4IDRDMTguNTUyMyA0IDE5IDMuNTUyMjggMTkgM0MxOSAyLjQ0NzcyIDE4LjU1MjMgMiAxOCAyTDMuMTAwMDcgMkMyLjU0Nzc5IDIgMiAyLjU0NzgxIDIgMy4xMDAwOUwyIDE4WiIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMS41ODQxMSIgeT0iMjcuMDAxOCIgd2lkdGg9IjM1Ljk0NjEiIGhlaWdodD0iMiIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKC00NSAxLjU4NDExIDI3LjAwMTgpIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", ife = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0Ljk5OTggMjcuMjk0OUMyMS43OTA0IDI3LjI5NDkgMjcuMjk1NCAyMS43ODk5IDI3LjI5NTQgMTQuOTk5M0MyNy4yOTU0IDguMjA4NTggMjEuNzkwNCAyLjcwMzYxIDE0Ljk5OTggMi43MDM2MUM4LjIwOTA3IDIuNzAzNjEgMi43MDQxIDguMjA4NTggMi43MDQxIDE0Ljk5OTNDMi43MDQxIDIxLjc4OTkgOC4yMDkwNyAyNy4yOTQ5IDE0Ljk5OTggMjcuMjk0OVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMjAuNzA3NSA5LjM5NDg5QzIxLjEzNjcgOS42NzU1MSAyMS4yNTcyIDEwLjI1MDkgMjAuOTc2NSAxMC42ODAxTDE0LjY2MjkgMjAuMzM2M0MxNC41MTQxIDIwLjU2MzkgMTQuMjczIDIwLjcxNDggMTQuMDAzMyAyMC43NDkyQzEzLjczMzYgMjAuNzgzNiAxMy40NjI0IDIwLjY5ODEgMTMuMjYxMiAyMC41MTUyTDkuMTc1ODcgMTYuODAxM0M4Ljc5NjQ0IDE2LjQ1NjQgOC43Njg0OCAxNS44NjkxIDkuMTEzNDIgMTUuNDg5N0M5LjQ1ODM1IDE1LjExMDMgMTAuMDQ1NiAxNS4wODIzIDEwLjQyNSAxNS40MjczTDEzLjcwNDYgMTguNDA4N0wxOS40MjIzIDkuNjYzODlDMTkuNzAyOSA5LjIzNDcgMjAuMjc4NCA5LjExNDI2IDIwLjcwNzUgOS4zOTQ4OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", rfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjkzMzkgNy40NTM2OUMyMy41MTE4IDcuODMxNDggMjMuNjczOSA4LjYwNjE1IDIzLjI5NjEgOS4xODM5NkwxNC43OTYxIDIyLjE4NEMxNC41OTU4IDIyLjQ5MDMgMTQuMjcxMiAyMi42OTM1IDEzLjkwODIgMjIuNzM5OEMxMy41NDUxIDIyLjc4NjIgMTMuMTc5OSAyMi42NzExIDEyLjkwOSAyMi40MjQ4TDcuNDA5MDUgMTcuNDI0OEM2Ljg5ODIyIDE2Ljk2MDQgNi44NjA1OCAxNi4xNjk5IDcuMzI0OTYgMTUuNjU5MUM3Ljc4OTM1IDE1LjE0ODIgOC41Nzk5MSAxNS4xMTA2IDkuMDkwNzMgMTUuNTc1TDEzLjUwNiAxOS41ODg4TDIxLjIwMzcgNy44MTU4NEMyMS41ODE1IDcuMjM4MDMgMjIuMzU2MSA3LjA3NTg5IDIyLjkzMzkgNy40NTM2OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", sfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy42ODM2IDYuMjcwMjhDMTguMDg2NSA2LjY0ODAxIDE4LjEwNjkgNy4yODA4NSAxNy43MjkyIDcuNjgzNzZMMTAuODcwNCAxNC45OTk4TDE3LjcyOTIgMjIuMzE1OUMxOC4xMDY5IDIyLjcxODggMTguMDg2NSAyMy4zNTE2IDE3LjY4MzYgMjMuNzI5NEMxNy4yODA3IDI0LjEwNzEgMTYuNjQ3OCAyNC4wODY3IDE2LjI3MDEgMjMuNjgzOEw4Ljc3MDEgMTUuNjgzOEM4LjQwOTQ4IDE1LjI5OTEgOC40MDk0OCAxNC43MDA1IDguNzcwMSAxNC4zMTU5TDE2LjI3MDEgNi4zMTU4OEMxNi42NDc4IDUuOTEyOTcgMTcuMjgwNyA1Ljg5MjU1IDE3LjY4MzYgNi4yNzAyOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", ofe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4zMTY4IDYuMjcwMTNDMTIuNzE5NyA1Ljg5MjQgMTMuMzUyNSA1LjkxMjgxIDEzLjczMDMgNi4zMTU3M0wyMS4yMzAzIDE0LjMxNTdDMjEuNTkwOSAxNC43MDA0IDIxLjU5MDkgMTUuMjk5IDIxLjIzMDMgMTUuNjgzNkwxMy43MzAzIDIzLjY4MzZDMTMuMzUyNSAyNC4wODY1IDEyLjcxOTcgMjQuMTA2OSAxMi4zMTY4IDIzLjcyOTJDMTEuOTEzOSAyMy4zNTE1IDExLjg5MzUgMjIuNzE4NiAxMi4yNzEyIDIyLjMxNTdMMTkuMTMgMTQuOTk5N0wxMi4yNzEyIDcuNjgzNjFDMTEuODkzNSA3LjI4MDcgMTEuOTEzOSA2LjY0Nzg2IDEyLjMxNjggNi4yNzAxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", afe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjI3MDQ3IDE3LjY4MzlDNi42NDgyIDE4LjA4NjkgNy4yODEwMyAxOC4xMDczIDcuNjgzOTQgMTcuNzI5NUwxNSAxMC44NzA3TDIyLjMxNjEgMTcuNzI5NUMyMi43MTkgMTguMTA3MyAyMy4zNTE4IDE4LjA4NjkgMjMuNzI5NSAxNy42ODM5QzI0LjEwNzMgMTcuMjgxIDI0LjA4NjkgMTYuNjQ4MiAyMy42ODM5IDE2LjI3MDVMMTUuNjgzOSA4Ljc3MDQ2QzE1LjI5OTMgOC40MDk4NCAxNC43MDA3IDguNDA5ODQgMTQuMzE2MSA4Ljc3MDQ2TDYuMzE2MDYgMTYuMjcwNUM1LjkxMzE1IDE2LjY0ODIgNS44OTI3NCAxNy4yODEgNi4yNzA0NyAxNy42ODM5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", cfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjQ3MjggMjEuMjY3NUwxNi4yMDUyIDE0Ljk5OTlMMjIuNDcyNyA4LjczMjQyTTEzLjc5NDcgMjEuMjY3Nkw3LjUyNzEgMTVMMTMuNzk0NiA4LjczMjU0IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", lfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDJWNEgxOFYySDhaTTYgMS41QzYgMC42NzE1NzMgNi42NzE1NyAwIDcuNSAwSDE4LjVDMTkuMzI4NCAwIDIwIDAuNjcxNTcyIDIwIDEuNVYySDIxQzIyLjY1NjkgMiAyNCAzLjM0MzE1IDI0IDVWMTRIMjJWNUMyMiA0LjQ0NzcyIDIxLjU1MjMgNCAyMSA0SDIwVjQuNUMyMCA1LjMyODQzIDE5LjMyODQgNiAxOC41IDZINy41QzYuNjcxNTcgNiA2IDUuMzI4NDMgNiA0LjVWNEg1QzQuNDQ3NzEgNCA0IDQuNDQ3NzIgNCA1VjI1QzQgMjUuNTUyMyA0LjQ0NzcyIDI2IDUgMjZIMTJWMjhINUMzLjM0MzE1IDI4IDIgMjYuNjU2OSAyIDI1VjVDMiAzLjM0MzE0IDMuMzQzMTUgMiA1IDJINlYxLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjcuNTE5NyAxNy4xNzNDMjguMDA5OSAxNy40OTM2IDI4LjE0NzUgMTguMTUwOSAyNy44MjcgMTguNjQxMUwyMC42MTQ5IDI5LjY3MTNDMjAuNDQ1IDI5LjkzMTMgMjAuMTY5NiAzMC4xMDM3IDE5Ljg2MTUgMzAuMTQzQzE5LjU1MzQgMzAuMTgyMyAxOS4yNDM2IDMwLjA4NDYgMTkuMDEzOCAyOS44NzU3TDE0LjM0NzIgMjUuNjMzM0MxMy45MTM3IDI1LjIzOTMgMTMuODgxOCAyNC41Njg1IDE0LjI3NTggMjQuMTM1MUMxNC42Njk4IDIzLjcwMTcgMTUuMzQwNiAyMy42Njk3IDE1Ljc3NCAyNC4wNjM4TDE5LjUyMDMgMjcuNDY5NEwyNi4wNTE2IDE3LjQ4MDNDMjYuMzcyMSAxNi45OTAxIDI3LjAyOTQgMTYuODUyNSAyNy41MTk3IDE3LjE3M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", dfe = "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", ufe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTMiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", hfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjU2MzEgOC4wNjMxNUMyNC4wMTIzIDcuNjE0MDUgMjQuMDEyMyA2Ljg4NTkxIDIzLjU2MzEgNi40MzY4QzIzLjExNCA1Ljk4NzcgMjIuMzg1OSA1Ljk4NzcgMjEuOTM2OCA2LjQzNjhMMTUgMTMuMzczNkw4LjA2MzE1IDYuNDM2OEM3LjYxNDA1IDUuOTg3NyA2Ljg4NTkxIDUuOTg3NyA2LjQzNjggNi40MzY4QzUuOTg3NyA2Ljg4NTkxIDUuOTg3NyA3LjYxNDA1IDYuNDM2OCA4LjA2MzE1TDEzLjM3MzYgMTVMNi40MzY4IDIxLjkzNjhDNS45ODc3IDIyLjM4NTkgNS45ODc3IDIzLjExNCA2LjQzNjggMjMuNTYzMUM2Ljg4NTkxIDI0LjAxMjMgNy42MTQwNSAyNC4wMTIzIDguMDYzMTUgMjMuNTYzMUwxNSAxNi42MjYzTDIxLjkzNjggMjMuNTYzMUMyMi4zODU5IDI0LjAxMjMgMjMuMTE0IDI0LjAxMjMgMjMuNTYzMSAyMy41NjMxQzI0LjAxMjMgMjMuMTE0IDI0LjAxMjMgMjIuMzg1OSAyMy41NjMxIDIxLjkzNjhMMTYuNjI2MyAxNUwyMy41NjMxIDguMDYzMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", gfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjQ0MjIgMTEuODkyNUMxOS44MTA2IDExLjUyNCAxOS44MTA2IDEwLjkyNjQgMTkuNDQyMiAxMC41NTc5QzE5LjA3MzYgMTAuMTg5NCAxOC40NzYxIDEwLjE4OTQgMTguMTA3NiAxMC41NTc5TDE1IDEzLjY2NTRMMTEuODkyNSAxMC41NTc5QzExLjUyNCAxMC4xODk0IDEwLjkyNjQgMTAuMTg5NCAxMC41NTc5IDEwLjU1NzlDMTAuMTg5NCAxMC45MjY0IDEwLjE4OTQgMTEuNTI0IDEwLjU1NzkgMTEuODkyNUwxMy42NjU0IDE1TDEwLjU1NzkgMTguMTA3NUMxMC4xODk0IDE4LjQ3NjEgMTAuMTg5NCAxOS4wNzM2IDEwLjU1NzkgMTkuNDQyMUMxMC45MjY0IDE5LjgxMDcgMTEuNTI0IDE5LjgxMDcgMTEuODkyNSAxOS40NDIxTDE1IDE2LjMzNDZMMTguMTA3NiAxOS40NDIxQzE4LjQ3NjEgMTkuODEwNyAxOS4wNzM2IDE5LjgxMDcgMTkuNDQyMiAxOS40NDIxQzE5LjgxMDYgMTkuMDczNiAxOS44MTA2IDE4LjQ3NjEgMTkuNDQyMiAxOC4xMDc1TDE2LjMzNDYgMTVMMTkuNDQyMiAxMS44OTI1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0Ljk5OTggMjcuMjk0OUMyMS43OTA0IDI3LjI5NDkgMjcuMjk1NCAyMS43ODk5IDI3LjI5NTQgMTQuOTk5M0MyNy4yOTU0IDguMjA4NTggMjEuNzkwNCAyLjcwMzYxIDE0Ljk5OTggMi43MDM2MUM4LjIwOTA3IDIuNzAzNjEgMi43MDQxIDguMjA4NTggMi43MDQxIDE0Ljk5OTNDMi43MDQxIDIxLjc4OTkgOC4yMDkwNyAyNy4yOTQ5IDE0Ljk5OTggMjcuMjk0OVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K", pfe = "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", ffe = "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", Mfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTEuNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIzIi8+Cjwvc3ZnPgo=", mfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC42MjQ2IDguMDg5NjZDOC45NDI4NSA4LjE5ODUgMy45MDk3NCAxMC43NzE3IDAuNzAyNDA3IDE0LjcxMDdDMC4yOTQzODcgMTUuMjExOCAwLjQxNDkxNCAxNS45NDM2IDAuOTM0Mjk4IDE2LjMyODFDMS40NzYxNSAxNi43MjkyIDIuMjM5NDEgMTYuNTk2NyAyLjY2NTg2IDE2LjA3NDZDNS4xNDY4NiAxMy4wMzY5IDguODg2NzUgMTAuOTQzMSAxMy4xNTkxIDEwLjQ3MTJMMTQuNjI0NiA4LjA4OTY2Wk0xMC43OTY3IDE0LjMxMDRDOC41NjI5NSAxNS4wODc4IDYuNjQzMjggMTYuNDY2OCA1LjI2Mzg3IDE4LjIzNjNDNC45MDI5MyAxOC42OTkzIDUuMDI4MDMgMTkuMzU4NCA1LjQ5OTkgMTkuNzA3N0M2LjAzMTI1IDIwLjEwMSA2Ljc4MjcyIDE5Ljk0NDIgNy4xOTQ3MSAxOS40MjcyQzcuNTY1MjEgMTguOTYyMyA3Ljk4MjI3IDE4LjUzMTYgOC40Mzk0NSAxOC4xNDExTDEwLjc5NjcgMTQuMzEwNFpNMjAuMzY4NyAxNy4yNzEzTDIxLjUyMTkgMTUuMzk3MkMyMi43NzE4IDE2LjE1MTEgMjMuODYyNCAxNy4xMTUzIDI0LjczNjIgMTguMjM2MkMyNS4wOTcyIDE4LjY5OTIgMjQuOTcyMSAxOS4zNTgzIDI0LjUwMDIgMTkuNzA3NkMyMy45Njg5IDIwLjEwMDkgMjMuMjE3NCAxOS45NDQyIDIyLjgwNTQgMTkuNDI3MkMyMi4xMzM1IDE4LjU4NCAyMS4zMDg1IDE3Ljg1MzQgMjAuMzY4NyAxNy4yNzEzWk0xNy40NzU5IDIxLjk3MjNMMTguNTY4MiAyMC4xOTcyQzE5LjIzNjUgMjAuNjQ1NyAxOS44MDM5IDIxLjIxNjkgMjAuMjMyNiAyMS44NzU0QzIwLjQ4ODIgMjIuMjY4IDIwLjM1MTYgMjIuNzc4NiAxOS45NzUgMjMuMDU3M0MxOS40MTc0IDIzLjQ3MDEgMTguNTk3OCAyMy4xODQxIDE4LjE2NTIgMjIuNjQxNkMxNy45NjY1IDIyLjM5MjQgMTcuNzM0NyAyMi4xNjc0IDE3LjQ3NTkgMjEuOTcyM1pNMjMuMjUwNiAxMi41ODc5TDI0LjQ3MDUgMTAuNjA1NEMyNi4zMzU5IDExLjY4OTEgMjcuOTcyNiAxMy4wODMzIDI5LjI5NzcgMTQuNzEwNkMyOS43MDU3IDE1LjIxMTcgMjkuNTg1MiAxNS45NDM2IDI5LjA2NTggMTYuMzI4MUMyOC41MjM5IDE2LjcyOTEgMjcuNzYwNyAxNi41OTY3IDI3LjMzNDIgMTYuMDc0NkMyNi4yMDkzIDE0LjY5NzIgMjQuODI1NSAxMy41MTM5IDIzLjI1MDYgMTIuNTg3OVoiIGZpbGw9ImJsYWNrIi8+CjxyZWN0IHg9IjIzLjM3NiIgeT0iMC4xNjkwNjciIHdpZHRoPSIzIiBoZWlnaHQ9IjMzLjM3MiIgcng9IjEuNSIgdHJhbnNmb3JtPSJyb3RhdGUoMzEuNjA1OSAyMy4zNzYgMC4xNjkwNjcpIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", yfe = "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", Ife = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuOTk5NzYgMTJIMTAuOTk5OEMxMS41NTIgMTIgMTEuOTk5OCAxMi40NDc3IDExLjk5OTggMTNWMTdDMTEuOTk5OCAxNy41NTIzIDExLjU1MiAxOCAxMC45OTk4IDE4SDEuOTk5NzZWMTJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcuOTk5OCAxM0MxNy45OTk4IDEyLjQ0NzcgMTguNDQ3NSAxMiAxOC45OTk4IDEySDI3Ljk5OThWMThIMTguOTk5OEMxOC40NDc1IDE4IDE3Ljk5OTggMTcuNTUyMyAxNy45OTk4IDE3VjEzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTAgM0MwIDIuNDQ3NzIgMC40NDc3MTUgMiAxIDJDMS41NTIyOCAyIDIgMi40NDc3MiAyIDNWMjdDMiAyNy41NTIzIDEuNTUyMjggMjggMSAyOEMwLjQ0NzcxNSAyOCAwIDI3LjU1MjMgMCAyN1YzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTI3Ljk5OTggM0MyNy45OTk4IDIuNDQ3NzIgMjguNDQ3NSAyIDI4Ljk5OTggMkMyOS41NTIgMiAyOS45OTk4IDIuNDQ3NzIgMjkuOTk5OCAzVjI3QzI5Ljk5OTggMjcuNTUyMyAyOS41NTIgMjggMjguOTk5OCAyOEMyOC40NDc1IDI4IDI3Ljk5OTggMjcuNTUyMyAyNy45OTk4IDI3VjNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", xfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjAwMDIgMkwxOC4wMDAyIDJWMTFDMTguMDAwMiAxMS41NTIzIDE3LjU1MjUgMTIgMTcuMDAwMiAxMkgxMy4wMDAyQzEyLjQ0OCAxMiAxMi4wMDAyIDExLjU1MjMgMTIuMDAwMiAxMVYyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyLjAwMDIgMTlDMTIuMDAwMiAxOC40NDc3IDEyLjQ0OCAxOCAxMy4wMDAyIDE4SDE3LjAwMDJDMTcuNTUyNSAxOCAxOC4wMDAyIDE4LjQ0NzcgMTguMDAwMiAxOVYyOEgxMi4wMDAyVjE5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIgMUMyIDAuNDQ3NzE1IDIuNDQ3NzIgMCAzIDBIMjdDMjcuNTUyMyAwIDI4IDAuNDQ3NzE1IDI4IDFDMjggMS41NTIyOCAyNy41NTIzIDIgMjcgMkgzQzIuNDQ3NzIgMiAyIDEuNTUyMjggMiAxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIgMjlDMiAyOC40NDc3IDIuNDQ3NzIgMjggMyAyOEgyN0MyNy41NTIzIDI4IDI4IDI4LjQ0NzcgMjggMjlDMjggMjkuNTUyMyAyNy41NTIzIDMwIDI3IDMwSDNDMi40NDc3MiAzMCAyIDI5LjU1MjMgMiAyOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", Sfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTQuNSIgY3k9IjE1LjUiIHI9IjQuNSIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", jfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMjUgMTVDNy4yNSAxNi4yNDI2IDYuMjQyNjQgMTcuMjUgNSAxNy4yNUMzLjc1NzM2IDE3LjI1IDIuNzUgMTYuMjQyNiAyLjc1IDE1QzIuNzUgMTMuNzU3NCAzLjc1NzM2IDEyLjc1IDUgMTIuNzVDNi4yNDI2NCAxMi43NSA3LjI1IDEzLjc1NzQgNy4yNSAxNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNy4yNSAxNUMxNy4yNSAxNi4yNDI2IDE2LjI0MjYgMTcuMjUgMTUgMTcuMjVDMTMuNzU3NCAxNy4yNSAxMi43NSAxNi4yNDI2IDEyLjc1IDE1QzEyLjc1IDEzLjc1NzQgMTMuNzU3NCAxMi43NSAxNSAxMi43NUMxNi4yNDI2IDEyLjc1IDE3LjI1IDEzLjc1NzQgMTcuMjUgMTVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjcuMjUgMTVDMjcuMjUgMTYuMjQyNiAyNi4yNDI2IDE3LjI1IDI1IDE3LjI1QzIzLjc1NzQgMTcuMjUgMjIuNzUgMTYuMjQyNiAyMi43NSAxNUMyMi43NSAxMy43NTc0IDIzLjc1NzQgMTIuNzUgMjUgMTIuNzVDMjYuMjQyNiAxMi43NSAyNy4yNSAxMy43NTc0IDI3LjI1IDE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", Dfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjI1IDVDMTcuMjUgNi4yNDI2NCAxNi4yNDI2IDcuMjUgMTUgNy4yNUMxMy43NTc0IDcuMjUgMTIuNzUgNi4yNDI2NCAxMi43NSA1QzEyLjc1IDMuNzU3MzYgMTMuNzU3NCAyLjc1IDE1IDIuNzVDMTYuMjQyNiAyLjc1IDE3LjI1IDMuNzU3MzYgMTcuMjUgNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNy4yNSAxNUMxNy4yNSAxNi4yNDI2IDE2LjI0MjYgMTcuMjUgMTUgMTcuMjVDMTMuNzU3NCAxNy4yNSAxMi43NSAxNi4yNDI2IDEyLjc1IDE1QzEyLjc1IDEzLjc1NzQgMTMuNzU3NCAxMi43NSAxNSAxMi43NUMxNi4yNDI2IDEyLjc1IDE3LjI1IDEzLjc1NzQgMTcuMjUgMTVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcuMjUgMjVDMTcuMjUgMjYuMjQyNiAxNi4yNDI2IDI3LjI1IDE1IDI3LjI1QzEzLjc1NzQgMjcuMjUgMTIuNzUgMjYuMjQyNiAxMi43NSAyNUMxMi43NSAyMy43NTc0IDEzLjc1NzQgMjIuNzUgMTUgMjIuNzVDMTYuMjQyNiAyMi43NSAxNy4yNSAyMy43NTc0IDE3LjI1IDI1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", wfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDkuMjVDMTIuMjQyNiA5LjI1IDEzLjI1IDguMjQyNjQgMTMuMjUgN0MxMy4yNSA1Ljc1NzM2IDEyLjI0MjYgNC43NSAxMSA0Ljc1QzkuNzU3MzYgNC43NSA4Ljc1IDUuNzU3MzYgOC43NSA3QzguNzUgOC4yNDI2NCA5Ljc1NzM2IDkuMjUgMTEgOS4yNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOSA5LjI1QzIwLjI0MjYgOS4yNSAyMS4yNSA4LjI0MjY0IDIxLjI1IDdDMjEuMjUgNS43NTczNiAyMC4yNDI2IDQuNzUgMTkgNC43NUMxNy43NTc0IDQuNzUgMTYuNzUgNS43NTczNiAxNi43NSA3QzE2Ljc1IDguMjQyNjQgMTcuNzU3NCA5LjI1IDE5IDkuMjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjEuMjUgMTVDMjEuMjUgMTYuMjQyNiAyMC4yNDI2IDE3LjI1IDE5IDE3LjI1QzE3Ljc1NzQgMTcuMjUgMTYuNzUgMTYuMjQyNiAxNi43NSAxNUMxNi43NSAxMy43NTc0IDE3Ljc1NzQgMTIuNzUgMTkgMTIuNzVDMjAuMjQyNiAxMi43NSAyMS4yNSAxMy43NTc0IDIxLjI1IDE1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExIDE3LjI1QzEyLjI0MjYgMTcuMjUgMTMuMjUgMTYuMjQyNiAxMy4yNSAxNUMxMy4yNSAxMy43NTc0IDEyLjI0MjYgMTIuNzUgMTEgMTIuNzVDOS43NTczNiAxMi43NSA4Ljc1IDEzLjc1NzQgOC43NSAxNUM4Ljc1IDE2LjI0MjYgOS43NTczNiAxNy4yNSAxMSAxNy4yNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMS4yNSAyM0MyMS4yNSAyNC4yNDI2IDIwLjI0MjYgMjUuMjUgMTkgMjUuMjVDMTcuNzU3NCAyNS4yNSAxNi43NSAyNC4yNDI2IDE2Ljc1IDIzQzE2Ljc1IDIxLjc1NzQgMTcuNzU3NCAyMC43NSAxOSAyMC43NUMyMC4yNDI2IDIwLjc1IDIxLjI1IDIxLjc1NzQgMjEuMjUgMjNaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTEgMjUuMjVDMTIuMjQyNiAyNS4yNSAxMy4yNSAyNC4yNDI2IDEzLjI1IDIzQzEzLjI1IDIxLjc1NzQgMTIuMjQyNiAyMC43NSAxMSAyMC43NUM5Ljc1NzM2IDIwLjc1IDguNzUgMjEuNzU3NCA4Ljc1IDIzQzguNzUgMjQuMjQyNiA5Ljc1NzM2IDI1LjI1IDExIDI1LjI1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", Nfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDkuMjcyNzNMMTEuNzk1NCAyMS40Nzc0QzExLjc1MDQgMjEuNTIyMyAxMS42OTcyIDIxLjU1ODMgMTEuNjM4OCAyMS41ODM0TDYgMjRMOC40MTY2MSAxOC4zNjEyQzguNDQxNjcgMTguMzAyOCA4LjQ3NzY1IDE4LjI0OTYgOC41MjI2MyAxOC4yMDQ2TDIwLjcyNzMgNkwyNCA5LjI3MjczWiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", Afe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzIDVIN0M1Ljg5NTQzIDUgNSA1Ljg5NTQzIDUgN1YyM0M1IDI0LjEwNDYgNS44OTU0MyAyNSA3IDI1SDIzQzI0LjEwNDYgMjUgMjUgMjQuMTA0NiAyNSAyM1YxN00xOSA1SDI1TTI1IDVWMTFNMjUgNUwxMyAxNyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", Tfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNiA0SDhWNS45OTk1MUgyMkMyMy4xMDQ2IDUuOTk5NTEgMjQgNi44OTQ5NCAyNCA3Ljk5OTUxVjIySDI2VjRaTTYgNFY1Ljk5OTUxSDRDMi44OTU0MyA1Ljk5OTUxIDIgNi44OTQ5NCAyIDcuOTk5NTFWMjUuOTk5NUMyIDI3LjEwNDEgMi44OTU0MyAyNy45OTk1IDQgMjcuOTk5NUgyMkMyMy4xMDQ2IDI3Ljk5OTUgMjQgMjcuMTA0MSAyNCAyNS45OTk1VjI0SDI2QzI3LjEwNDYgMjQgMjggMjMuMTA0NiAyOCAyMlY0QzI4IDIuODk1NDMgMjcuMTA0NiAyIDI2IDJIOEM2Ljg5NTQzIDIgNiAyLjg5NTQzIDYgNFpNMjIgMjUuOTk5NUw0IDI2VjhMMjIgNy45OTk1MVYyNS45OTk1WiIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMyIgeT0iNyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", bfe = "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", vfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNiA0SDhWNS45OTk1MUgyMkMyMy4xMDQ2IDUuOTk5NTEgMjQgNi44OTQ5NCAyNCA3Ljk5OTUxVjIySDI2VjRaTTYgNFY1Ljk5OTUxSDRDMi44OTU0MyA1Ljk5OTUxIDIgNi44OTQ5NCAyIDcuOTk5NTFWMjUuOTk5NUMyIDI3LjEwNDEgMi44OTU0MyAyNy45OTk1IDQgMjcuOTk5NUgyMkMyMy4xMDQ2IDI3Ljk5OTUgMjQgMjcuMTA0MSAyNCAyNS45OTk1VjI0SDI2QzI3LjEwNDYgMjQgMjggMjMuMTA0NiAyOCAyMlY0QzI4IDIuODk1NDMgMjcuMTA0NiAyIDI2IDJIOEM2Ljg5NTQzIDIgNiAyLjg5NTQzIDYgNFpNMjIgMjUuOTk5NVYyNkg0TDQgMjUuOTk5NUw0IDhWNy45OTk1MUg2VjhIOFY3Ljk5OTUxSDIyVjhWMjJWMjRWMjUuOTk5NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", Efe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNiA0SDhWNS45OTk1MUgyMkMyMy4xMDQ2IDUuOTk5NTEgMjQgNi44OTQ5NCAyNCA3Ljk5OTUxVjIySDI2VjRaTTYgNFY1Ljk5OTUxSDRDMi44OTU0MyA1Ljk5OTUxIDIgNi44OTQ5NCAyIDcuOTk5NTFWMjUuOTk5NUMyIDI3LjEwNDEgMi44OTU0MyAyNy45OTk1IDQgMjcuOTk5NUgyMkMyMy4xMDQ2IDI3Ljk5OTUgMjQgMjcuMTA0MSAyNCAyNS45OTk1VjI0SDI2QzI3LjEwNDYgMjQgMjggMjMuMTA0NiAyOCAyMlY0QzI4IDIuODk1NDMgMjcuMTA0NiAyIDI2IDJIOEM2Ljg5NTQzIDIgNiAyLjg5NTQzIDYgNFpNMjIgMjUuOTk5NUw0IDI2VjhMMjIgNy45OTk1MVYyNS45OTk1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQgOEwyMiA3Ljk5OTUxVjI1Ljk5OTVMNCAyNlY4WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4zMiIvPgo8L3N2Zz4K", Cfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDE1QzE5IDE3LjIwOTEgMTcuMjA5MSAxOSAxNSAxOUMxMi43OTA5IDE5IDExIDE3LjIwOTEgMTEgMTVDMTEgMTIuNzkwOSAxMi43OTA5IDExIDE1IDExQzE3LjIwOTEgMTEgMTkgMTIuNzkwOSAxOSAxNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yNiAxNUMyNiAxNi43NzA4IDI0LjkyMzQgMTguNDk2MyAyMi45MzA2IDE5LjgyNDhDMjAuOTQ0OCAyMS4xNDg3IDE4LjE0MzggMjIgMTUgMjJDMTEuODU2MiAyMiA5LjA1NTIyIDIxLjE0ODcgNy4wNjk0MiAxOS44MjQ4QzUuMDc2NjMgMTguNDk2MyA0IDE2Ljc3MDggNCAxNUM0IDEzLjIyOTIgNS4wNzY2MyAxMS41MDM3IDcuMDY5NDIgMTAuMTc1MkM5LjA1NTIyIDguODUxMzMgMTEuODU2MiA4IDE1IDhDMTguMTQzOCA4IDIwLjk0NDggOC44NTEzMyAyMi45MzA2IDEwLjE3NTJDMjQuOTIzNCAxMS41MDM3IDI2IDEzLjIyOTIgMjYgMTVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==", zfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2IDE1QzI2IDE2Ljc3MDggMjQuOTIzNCAxOC40OTYzIDIyLjkzMDYgMTkuODI0OEMyMC45NDQ4IDIxLjE0ODcgMTguMTQzOCAyMiAxNSAyMkMxMS44NTYyIDIyIDkuMDU1MjIgMjEuMTQ4NyA3LjA2OTQyIDE5LjgyNDhDNS4wNzY2MyAxOC40OTYzIDQgMTYuNzcwOCA0IDE1QzQgMTMuMjI5MiA1LjA3NjYzIDExLjUwMzcgNy4wNjk0MiAxMC4xNzUyQzkuMDU1MjIgOC44NTEzMyAxMS44NTYyIDggMTUgOEMxOC4xNDM4IDggMjAuOTQ0OCA4Ljg1MTMzIDIyLjkzMDYgMTAuMTc1MkMyNC45MjM0IDExLjUwMzcgMjYgMTMuMjI5MiAyNiAxNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMTIgMTVDMTIgMTcuMjA5MSAxMC40MzMgMTkgOC41IDE5QzYuNTY3IDE5IDUgMTcuMjA5MSA1IDE1QzUgMTIuNzkwOSA2LjU2NyAxMSA4LjUgMTFDMTAuNDMzIDExIDEyIDEyLjc5MDkgMTIgMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", Lfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjk2NTMgMTEuOTYzQzE5LjAyOTUgMTEuOTYzIDE1LjY2IDE4LjMzMTkgMTkuMDU2OCAyMS42MjZDMjIuNDUzNiAyNC45MiAyNC44NDQgMTcuNDUzIDI0LjkxMDEgMTQuNTk4MkMyNC45NzYyIDExLjc0MzMgMjYuMzE2MSAxOS43MjYxIDI4LjIwMjcgMjIuMDY4NU0xLjgwMDY2IDE4LjU3OTFDMS44MDA2NiAxOC41NzkxIDYuMTM2NTcgMTcuMjY3NyAxMy4wOTEzIDE3LjE4MDFNMy43MjM2OSAxMC44MDczQzMuNjM3NTEgMTMuMzgyIDMuNjMyMTQgMTUuNDIxOSAzLjYzOTA4IDE3LjAyMzhNMy42MzkwOCAxNy4wMjM4QzMuNjUzMzMgMjAuMzE0NiAzLjcxOTUyIDIxLjc1NjkgMy4yNDM3NSAyMi4xODk0QzIuOTQ5NTggMjIuNDU2OSAzLjA4NDc2IDE5Ljk5OTcgMy42MzkwOCAxNy4wMjM4Wk0zLjYzOTA4IDE3LjAyMzhDNC40MTc2NSAxMi44NDM5IDYuMDIzMDkgNy42NDA0NSA4LjQyNzA4IDcuNTI1NDFDMTIuNTQyNiA3LjMyODQ2IDkuODEyOTEgMTUuNjM0NSAxNC4yNSAyMi41Nzk4IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjMuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=", kfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjM1OCAyMy45MzUzTDEwLjA4MTUgMTkuMzI0NEg0LjY4OTA5TDMuNDM4NjcgMjMuOTM1M0gwTDUuMTA1OSA1Ljc1MjA4SDkuODQ3MDlMMTQuOTc5IDIzLjkzNTNIMTEuMzU4Wk03LjUwMjU0IDkuMTEyNTlINy4yOTQxNEw1LjI4ODI1IDE2LjUzN0g5LjUwODQzTDcuNTAyNTQgOS4xMTI1OVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yOC4wNDYyIDIzLjkzNTNDMjcuMjMgMjMuOTM1MyAyNi41OTYxIDIzLjczNTYgMjYuMTQ0NSAyMy4zMzYyQzI1LjcxMDQgMjIuOTE5NCAyNS40NDk4IDIyLjM0NjIgMjUuMzYzIDIxLjYxNjhIMjUuMjMyOEMyNC45ODk2IDIyLjQ1MDQgMjQuNTEyIDIzLjEwMTcgMjMuOCAyMy41NzA2QzIzLjA4NzkgMjQuMDIyMiAyMi4yMTA5IDI0LjI0NzkgMjEuMTY4OSAyNC4yNDc5QzE5LjgxNDMgMjQuMjQ3OSAxOC43Mzc1IDIzLjg5MTkgMTcuOTM4NiAyMy4xNzk5QzE3LjEzOTcgMjIuNDY3OCAxNi43NDAzIDIxLjQ3NzkgMTYuNzQwMyAyMC4yMTAxQzE2Ljc0MDMgMTcuNTAwOCAxOC43Mjg4IDE2LjE0NjIgMjIuNzA1OSAxNi4xNDYySDI1LjA3NjVWMTUuMjYwNUMyNS4wNzY1IDE0LjQwOTUgMjQuODY4IDEzLjc2NjkgMjQuNDUxMiAxMy4zMzI4QzI0LjAzNDQgMTIuODk4NiAyMy4zNTcxIDEyLjY4MTUgMjIuNDE5MyAxMi42ODE1QzIxLjU2ODMgMTIuNjgxNSAyMC44ODIzIDEyLjg0NjUgMjAuMzYxMyAxMy4xNzY1QzE5Ljg0MDMgMTMuNTA2NCAxOS4zOTc0IDEzLjkzMTkgMTkuMDMyNyAxNC40NTI5TDE3LjEzMTEgMTIuODM3OEMxNy41NDc5IDEyLjA5MSAxOC4yMTY1IDExLjQ2NTggMTkuMTM2OSAxMC45NjIyQzIwLjA3NDggMTAuNDQxMiAyMS4yODE4IDEwLjE4MDcgMjIuNzU4IDEwLjE4MDdDMjQuNTI5NCAxMC4xODA3IDI1LjkxMDEgMTAuNTk3NSAyNi45IDExLjQzMTFDMjcuOTA3MyAxMi4yNDczIDI4LjQxMDkgMTMuNDcxNyAyOC40MTA5IDE1LjEwNDJWMjEuNDM0NUgzMFYyMy45MzUzSDI4LjA0NjJaTTIyLjI4OTEgMjEuOTU1NUMyMy4wODc5IDIxLjk1NTUgMjMuNzQ3OSAyMS43NzMxIDI0LjI2ODkgMjEuNDA4NEMyNC44MDczIDIxLjAyNjQgMjUuMDc2NSAyMC41MTQgMjUuMDc2NSAxOS44NzE0VjE4LjA3NEgyMi43ODRDMjAuOTYwNSAxOC4wNzQgMjAuMDQ4NyAxOC42NDcxIDIwLjA0ODcgMTkuNzkzM1YyMC4zMTQzQzIwLjA0ODcgMjAuODUyNyAyMC4yNDg0IDIxLjI2MDggMjAuNjQ3OSAyMS41Mzg3QzIxLjA0NzMgMjEuODE2NSAyMS41OTQ0IDIxLjk1NTUgMjIuMjg5MSAyMS45NTU1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", Ofe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjUwNDIgMjMuOTk5OEwxMS4wODM4IDE5LjQ4NTFINC43OTM2OUwzLjM5ODcgMjMuOTk5OEgwTDUuOTM1MDUgNi4yOTYxNEgxMC4wOTQ3TDE1Ljk3OSAyMy45OTk4SDEyLjUwNDJaTTcuOTg5NDggOS4zMzk3Nkg3Ljg2MjY3TDUuNjA1MzIgMTYuNjE5MUgxMC4yNzIyTDcuOTg5NDggOS4zMzk3NloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yOC4xOTkyIDIzLjk5OThDMjcuNDg5IDIzLjk5OTggMjYuOTIyNiAyMy43OTY5IDI2LjQ5OTggMjMuMzkxMUMyNi4wOTQgMjIuOTY4NCAyNS44NDA0IDIyLjQxMDQgMjUuNzM4OSAyMS43MTcxSDI1LjU4NjhDMjUuMzY2OSAyMi41Nzk1IDI0LjkxODkgMjMuMjMwNSAyNC4yNDI1IDIzLjY3MDFDMjMuNTY2MSAyNC4wOTI4IDIyLjcyOTEgMjQuMzA0MiAyMS43MzE1IDI0LjMwNDJDMjAuMzc4OCAyNC4zMDQyIDE5LjMzODkgMjMuOTQ5MSAxOC42MTE4IDIzLjIzODlDMTcuODg0NyAyMi41Mjg3IDE3LjUyMTIgMjEuNTgxOCAxNy41MjEyIDIwLjM5ODJDMTcuNTIxMiAxOS4wMjg2IDE4LjAxMTUgMTguMDE0MSAxOC45OTIzIDE3LjM1NDZDMTkuOTczIDE2LjY3ODIgMjEuMzY4IDE2LjM0MDEgMjMuMTc3MiAxNi4zNDAxSDI1LjQzNDZWMTUuMzc2M0MyNS40MzQ2IDE0LjYzMjMgMjUuMjQwMSAxNC4wNTc0IDI0Ljg1MTIgMTMuNjUxNUMyNC40NjIzIDEzLjI0NTcgMjMuODM2NyAxMy4wNDI4IDIyLjk3NDMgMTMuMDQyOEMyMi4yMTM0IDEzLjA0MjggMjEuNTk2MiAxMy4yMTE5IDIxLjEyMjggMTMuNTUwMUMyMC42NjYzIDEzLjg3MTQgMjAuMjc3MyAxNC4yNjAzIDE5Ljk1NjEgMTQuNzE2OEwxOC4wMjg1IDEyLjk5MjFDMTguNTE4OCAxMi4yMzEyIDE5LjE2OTggMTEuNjIyNSAxOS45ODE0IDExLjE2NTlDMjAuNzkzMSAxMC42OTI1IDIxLjg2NjggMTAuNDU1NyAyMy4yMDI2IDEwLjQ1NTdDMjQuOTk0OSAxMC40NTU3IDI2LjM1NjEgMTAuODYxNiAyNy4yODYxIDExLjY3MzJDMjguMjE2MSAxMi40ODQ4IDI4LjY4MTEgMTMuNjUxNSAyOC42ODExIDE1LjE3MzNWMjEuNDEyOEgzMFYyMy45OTk4SDI4LjE5OTJaTTIyLjgyMjEgMjEuOTQ1NEMyMy41NDkyIDIxLjk0NTQgMjQuMTY2NCAyMS43ODQ4IDI0LjY3MzcgMjEuNDYzNUMyNS4xODA5IDIxLjE0MjIgMjUuNDM0NiAyMC42Njg4IDI1LjQzNDYgMjAuMDQzMVYxOC4yOTNIMjMuMzU0OEMyMS42NjM5IDE4LjI5MyAyMC44MTg0IDE4LjgzNDEgMjAuODE4NCAxOS45MTYzVjIwLjM0NzVDMjAuODE4NCAyMC44ODg2IDIwLjk4NzUgMjEuMjk0NCAyMS4zMjU3IDIxLjU2NDlDMjEuNjgwOCAyMS44MTg2IDIyLjE3OTYgMjEuOTQ1NCAyMi44MjIxIDIxLjk0NTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", Pfe = "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", Ufe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDI2LjgyMjVMMjYuNjU0NCAxMi42NTc5QzI3LjE5MTMgMTIuMDA1NCAyNi43MjcxIDExLjAyMjUgMjUuODgyMiAxMS4wMjI1SDIxLjhWMi44MjI1MUg4LjJMOC4yIDExLjAyMjVINC4xMTc3N0MzLjI3Mjg1IDExLjAyMjUgMi44MDg3MyAxMi4wMDU0IDMuMzQ1NTUgMTIuNjU3OUwxNSAyNi44MjI1WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", Rfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgMTQuODIyNUwxNy4xNjQ2IDI2LjQ3N0MxNy44MTcxIDI3LjAxMzggMTguOCAyNi41NDk3IDE4LjggMjUuNzA0N0wxOC44IDIxLjYyMjVMMjcgMjEuNjIyNUwyNyA4LjAyMjUxTDE4LjggOC4wMjI1MUwxOC44IDMuOTQwMjhDMTguOCAzLjA5NTM3IDE3LjgxNzEgMi42MzEyNCAxNy4xNjQ2IDMuMTY4MDZMMyAxNC44MjI1WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", Yfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3IDE0LjgyMjVMMTIuODM1NCAzLjE2ODA2QzEyLjE4MjkgMi42MzEyMyAxMS4yIDMuMDk1MzYgMTEuMiAzLjk0MDI4TDExLjIgOC4wMjI1MUwzIDguMDIyNTFMMyAyMS42MjI1TDExLjIgMjEuNjIyNUwxMS4yIDI1LjcwNDdDMTEuMiAyNi41NDk3IDEyLjE4MjkgMjcuMDEzOCAxMi44MzU0IDI2LjQ3N0wyNyAxNC44MjI1WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", Qfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDIuODIyNTFMMy4zNDU1NSAxNi45ODcxQzIuODA4NzIgMTcuNjM5NiAzLjI3Mjg1IDE4LjYyMjUgNC4xMTc3NiAxOC42MjI1TDguMiAxOC42MjI1TDguMTk5OTkgMjYuODIyNUwyMS44IDI2LjgyMjVMMjEuOCAxOC42MjI1TDI1Ljg4MjIgMTguNjIyNUMyNi43MjcxIDE4LjYyMjUgMjcuMTkxMyAxNy42Mzk2IDI2LjY1NDQgMTYuOTg3MUwxNSAyLjgyMjUxWiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", Zfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1IDNDMjYuMTA0NiAzIDI3IDMuODk1NDMgMjcgNVYyNUMyNyAyNi4xMDQ2IDI2LjEwNDYgMjcgMjUgMjdINUMzLjg5NTQzIDI3IDMgMjYuMTA0NiAzIDI1VjVDMyAzLjg5NTQzIDMuODk1NDMgMyA1IDNIMjVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTggMTVMMTMgMjIiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMiA4TDEzIDIyIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K", Ffe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjMyMzUgMTIuMzk1TDIyLjM0NDMgMTMuMjU4TDIzLjIwMSAxMy4zNjM0QzI2LjA5NTIgMTMuNzE5NiAyOC4zMzY3IDE2LjE4ODQgMjguMzM2NyAxOS4xNzkyQzI4LjMzNjcgMjIuNDE1NiAyNS43MTMgMjUuMDM5MyAyMi40NzY2IDI1LjAzOTNINy41MjM1MUM0LjI4NzA5IDI1LjAzOTMgMS42NjM0NSAyMi40MTU2IDEuNjYzNDUgMTkuMTc5MkMxLjY2MzQ1IDE2LjE4ODUgMy45MDQ4IDEzLjcxOTcgNi43OTg5MSAxMy4zNjM0TDcuNjU1NTggMTMuMjU4TDcuNjc2NDQgMTIuMzk1MUM3Ljc3MjIgOC40MzMwNCAxMS4wMTQ1IDUuMjUwMjQgMTUgNS4yNTAyNEMxOC45ODU0IDUuMjUwMjQgMjIuMjI3NyA4LjQzMzAyIDIyLjMyMzUgMTIuMzk1WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", Bfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQxNDIgMS45NzA2NEwyOC4wMjk0IDEzLjU4NTlDMjguODEwNSAxNC4zNjY5IDI4LjgxMDUgMTUuNjMzMiAyOC4wMjk0IDE2LjQxNDNMMTYuNDE0MiAyOC4wMjk1QzE1LjYzMzIgMjguODEwNiAxNC4zNjY4IDI4LjgxMDYgMTMuNTg1OCAyOC4wMjk1TDEuOTcwNTYgMTYuNDE0M0MxLjE4OTUxIDE1LjYzMzIgMS4xODk1MSAxNC4zNjY5IDEuOTcwNTYgMTMuNTg1OUwxMy41ODU4IDEuOTcwNjRDMTQuMzY2OCAxLjE4OTU5IDE1LjYzMzIgMS4xODk1OSAxNi40MTQyIDEuOTcwNjRaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==", Gfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3IDE1QzI3IDIxLjYyNzQgMjEuNjI3NCAyNyAxNSAyN0M4LjM3MjYgMjcgMyAyMS42Mjc0IDMgMTVDMyA4LjM3MjU5IDguMzcyNTkgMyAxNSAzQzIxLjYyNzQgMyAyNyA4LjM3MjYgMjcgMTVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==", Wfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMTAuMTE4MUMyIDAuOTUzNTgxIDE0LjAyNSAwLjk1MzU4MSAxNSA4LjMwOTI4QzE1Ljk3NSAwLjk1MzU4MSAyOCAwLjk1MzU4MSAyOCAxMC4xMTgxQzI4IDE3Ljk1NjEgMTguMjUgMjAuOTcwNyAxNSAyN0MxMS43NSAyMC45NzA3IDIgMTcuOTU2MSAyIDEwLjExODFaIiBzdHJva2U9IiMxRDFEMUQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", Hfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjAwODYgMy4yMTczNUMxNC42MjMgMi44NjY2MyAxNS4zNzcgMi44NjY2MyAxNS45OTE1IDMuMjE3MzVMMjQuODE3MSA4LjI1NDk3QzI1LjQ0MDcgOC42MTA5MiAyNS44MjU2IDkuMjczODcgMjUuODI1NiA5Ljk5MTkzVjIwLjAwODFDMjUuODI1NiAyMC43MjYxIDI1LjQ0MDcgMjEuMzg5MSAyNC44MTcxIDIxLjc0NUwxNS45OTE1IDI2Ljc4MjZDMTUuMzc3IDI3LjEzMzQgMTQuNjIzIDI3LjEzMzQgMTQuMDA4NiAyNi43ODI2TDUuMTgyOTUgMjEuNzQ1QzQuNTU5MzQgMjEuMzg5MSA0LjE3NDQgMjAuNzI2MSA0LjE3NDQgMjAuMDA4MVY5Ljk5MTkzQzQuMTc0NCA5LjI3Mzg3IDQuNTU5MzQgOC42MTA5MiA1LjE4Mjk1IDguMjU0OTdMMTQuMDA4NiAzLjIxNzM1WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", Vfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjI0MjEgMy4yMjQ0OEMxNC43Mjc4IDMuMDI1NTcgMTUuMjcyMiAzLjAyNTU3IDE1Ljc1NzkgMy4yMjQ0OEwyMi44NDAzIDYuMTI0NzhDMjMuMzMxMSA2LjMyNTc5IDIzLjcyMiA2LjcxMzU0IDIzLjkyNyA3LjIwMjc1TDI2Ljg0MiAxNC4xNjAyQzI3LjA0OTEgMTQuNjU0NiAyNy4wNDkxIDE1LjIxMTUgMjYuODQyIDE1LjcwNTlMMjMuOTI3IDIyLjY2MzNDMjMuNzIyIDIzLjE1MjUgMjMuMzMxMSAyMy41NDAzIDIyLjg0MDMgMjMuNzQxM0wxNS43NTc5IDI2LjY0MTZDMTUuMjcyMiAyNi44NDA1IDE0LjcyNzggMjYuODQwNSAxNC4yNDIxIDI2LjY0MTZMNy4xNTk3IDIzLjc0MTNDNi42Njg4NSAyMy41NDAzIDYuMjc3OTUgMjMuMTUyNSA2LjA3Mjk5IDIyLjY2MzNMMy4xNTgwMiAxNS43MDU5QzIuOTUwODggMTUuMjExNSAyLjk1MDg4IDE0LjY1NDYgMy4xNTgwMiAxNC4xNjAyTDYuMDcyOTkgNy4yMDI3NUM2LjI3Nzk1IDYuNzEzNTQgNi42Njg4NSA2LjMyNTc5IDcuMTU5NyA2LjEyNDc4TDE0LjI0MjEgMy4yMjQ0OFoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K", Kfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDNDMTkuODUyMiAzIDIzIDYuODIxMTQgMjMgMTEuODE2OEwyMyAxOC4xODMyQzIzIDIzLjE3ODkgMTkuODUyMiAyNyAxNSAyN0MxMC4xNzkyIDI3IDcuMDUxNjkgMjMuMjI4OSA3IDE4LjI3NjdMNyAxMS44MTY4QzcgNi44MjExNCAxMC4xNDc4IDMgMTUgM1oiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K", Xfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjgyNDQgMy44NDAxN0MxNC41MjU0IDMuMzMwODggMTUuNDc0NiAzLjMzMDg4IDE2LjE3NTYgMy44NDAxN0wyNi4yMDE0IDExLjEyNDRDMjYuOTAyNCAxMS42MzM3IDI3LjE5NTcgMTIuNTM2NCAyNi45MjggMTMuMzYwNEwyMy4wOTg0IDI1LjE0NjVDMjIuODMwNyAyNS45NzA2IDIyLjA2MjggMjYuNTI4NSAyMS4xOTYzIDI2LjUyODVIOC44MDM2OUM3LjkzNzIzIDI2LjUyODUgNy4xNjkzMiAyNS45NzA2IDYuOTAxNTggMjUuMTQ2NUwzLjA3MjA0IDEzLjM2MDRDMi44MDQyOSAxMi41MzY0IDMuMDk3NjEgMTEuNjMzNyAzLjc5ODU5IDExLjEyNDRMMTMuODI0NCAzLjg0MDE3WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", Jfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNzcxMTUgM0M0LjQ4NDk4IDMgMy41MzMxNiA0LjE5NjQ4IDMuODIyMzcgNS40NDk3Mkw4LjQzNzc1IDI1LjQ0OTdDOC42NDcxNyAyNi4zNTcyIDkuNDU1MjMgMjcgMTAuMzg2NSAyN0gyNC4yMjg4QzI1LjUxNSAyNyAyNi40NjY4IDI1LjgwMzUgMjYuMTc3NiAyNC41NTAzTDIxLjU2MjIgNC41NTAyOEMyMS4zNTI4IDMuNjQyODIgMjAuNTQ0OCAzIDE5LjYxMzUgM0g1Ljc3MTE1WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", qfe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjIyODggM0MyNS41MTUgMyAyNi40NjY4IDQuMTk2NDggMjYuMTc3NiA1LjQ0OTcyTDIxLjU2MjIgMjUuNDQ5N0MyMS4zNTI4IDI2LjM1NzIgMjAuNTQ0OCAyNyAxOS42MTM1IDI3SDUuNzcxMTVDNC40ODQ5OCAyNyAzLjUzMzE2IDI1LjgwMzUgMy44MjIzNyAyNC41NTAzTDguNDM3NzYgNC41NTAyOEM4LjY0NzE3IDMuNjQyODIgOS40NTUyMyAzIDEwLjM4NjUgM0gyNC4yMjg4WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", _fe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMzQ2NjYgMTcuNzM5MUw2LjUzNzY3IDE4LjMyN0w3LjM0NjY1IDE3LjczOTFMMy4yMzQxNyAxMi4wNzk0TDkuODg3OTQgOS45MTc4M0MxMC4yODk3IDkuNzg3MzIgMTAuNjM5OCA5LjUzMjk0IDEwLjg4ODEgOS4xOTExN0wxNSAzLjUzMTAxTDE5LjExMTkgOS4xOTExN0wxOS45MjA5IDguNjAzNDNMMTkuMTExOSA5LjE5MTE4QzE5LjM2MDIgOS41MzI5NCAxOS43MTAzIDkuNzg3MzIgMjAuMTEyMSA5LjkxNzgzTDI2Ljc2NTggMTIuMDc5NEwyMi42NTMzIDE3LjczOTFDMjIuNDA1IDE4LjA4MDkgMjIuMjcxMyAxOC40OTI0IDIyLjI3MTMgMTguOTE0OUwyMi4yNzE3IDI1LjkxMUwxNS42MTgxIDIzLjc0ODdMMTUuMzA5MSAyNC42OTk3TDE1LjYxODEgMjMuNzQ4N0MxNS4yMTY0IDIzLjYxODEgMTQuNzgzNiAyMy42MTgxIDE0LjM4MTkgMjMuNzQ4N0wxNC42OTA5IDI0LjY5OTdMMTQuMzgxOSAyMy43NDg3TDcuNzI4MzEgMjUuOTExTDcuNzI4NjggMTguOTE0OUM3LjcyODcgMTguNDkyNSA3LjU5NDk3IDE4LjA4MDkgNy4zNDY2NiAxNy43MzkxWiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", $fe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjYxMzUgM0MyMC41NDQ4IDMgMjEuMzUyOCAzLjY0MjgyIDIxLjU2MjIgNC41NTAyOEwyNi4xNzc2IDI0LjU1MDNDMjYuNDY2OCAyNS44MDM1IDI1LjUxNSAyNyAyNC4yMjg4IDI3SDUuNzcxMTVDNC40ODQ5OCAyNyAzLjUzMzE2IDI1LjgwMzUgMy44MjIzNyAyNC41NTAzTDguNDM3NzYgNC41NTAyOEM4LjY0NzE3IDMuNjQyODIgOS40NTUyMyAzIDEwLjM4NjUgM0gxOS42MTM1WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", eMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3LjU1IDI2TDIuNDUwMDcgMjZMMTUgNEwyNy41NSAyNloiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", tMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1IDNDMjYuMTA0NiAzIDI3IDMuODk1NDMgMjcgNVYyNUMyNyAyNi4xMDQ2IDI2LjEwNDYgMjcgMjUgMjdINUMzLjg5NTQzIDI3IDMgMjYuMTA0NiAzIDI1VjVDMyAzLjg5NTQzIDMuODk1NDMgMyA1IDNIMjVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTggOEwyMiAyMiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTIyIDhMOCAyMiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==", nMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC45OTg3IDAuNTAwMDE3QzYuOTkyNzEgMC41MDAwMTcgMC41IDYuOTkxODcgMC41IDE1LjAwMDVDMC41IDIxLjQwNiA0LjY1NDMgMjYuODQxMiAxMC40MTYyIDI4Ljc1OTRDMTEuMTQxNyAyOC44OTIxIDExLjQwNiAyOC40NDQzIDExLjQwNiAyOC4wNTk4QzExLjQwNiAyNy43MTUzIDExLjM5MzYgMjYuODAzOCAxMS4zODY1IDI1LjU5NDFDNy4zNTMyMiAyNi40NyA2LjUwMjI1IDIzLjY1IDYuNTAyMjUgMjMuNjVDNS44NDI2NSAyMS45NzQ4IDQuODkxOTggMjEuNTI4OCA0Ljg5MTk4IDIxLjUyODhDMy41NzU0NSAyMC42Mjk4IDQuOTkxNjcgMjAuNjQ3NiA0Ljk5MTY3IDIwLjY0NzZDNi40NDcwNiAyMC43NDk5IDcuMjEyNTggMjIuMTQyMSA3LjIxMjU4IDIyLjE0MjFDOC41MDU5NiAyNC4zNTc3IDEwLjYwNjcgMjMuNzE3NyAxMS40MzI4IDIzLjM0NjVDMTEuNTY0NSAyMi40MSAxMS45MzkyIDIxLjc3MDkgMTIuMzUzMiAyMS40MDg2QzkuMTMzNTEgMjEuMDQxOSA1Ljc0ODMgMTkuNzk4NCA1Ljc0ODMgMTQuMjQyMUM1Ljc0ODMgMTIuNjU4NSA2LjMxMzU0IDExLjM2NTIgNy4yNDEwNyAxMC4zNTEzQzcuMDkxNTIgOS45ODQ1NCA2LjU5MzkzIDguNTEwNDMgNy4zODM0OSA2LjUxMzgzQzcuMzgzNDkgNi41MTM4MyA4LjYwMDMxIDYuMTIzOTUgMTEuMzcwNCA3Ljk5OTQ4QzEyLjUyNjcgNy42NzgxNCAxMy43Njc2IDcuNTE3OTEgMTUuMDAwNCA3LjUxMTY4QzE2LjIzMjQgNy41MTc5MSAxNy40NzI0IDcuNjc4MTQgMTguNjMwNSA3Ljk5OTQ4QzIxLjM5ODggNi4xMjM5NSAyMi42MTM4IDYuNTEzODMgMjIuNjEzOCA2LjUxMzgzQzIzLjQwNTIgOC41MTA0MyAyMi45MDc2IDkuOTg0NTQgMjIuNzU4OSAxMC4zNTEzQzIzLjY4ODMgMTEuMzY1MiAyNC4yNDkgMTIuNjU4NSAyNC4yNDkgMTQuMjQyMUMyNC4yNDkgMTkuODEyNiAyMC44NTg1IDIxLjAzODMgMTcuNjI5IDIxLjM5NzFDMTguMTQ4OSAyMS44NDQ4IDE4LjYxMjcgMjIuNzI5NiAxOC42MTI3IDI0LjA4MjZDMTguNjEyNyAyNi4wMjA1IDE4LjU5NDggMjcuNTg0NSAxOC41OTQ4IDI4LjA1OThDMTguNTk0OCAyOC40NDc5IDE4Ljg1NjYgMjguODk5MiAxOS41OTE4IDI4Ljc1NzdDMjUuMzQ5MyAyNi44MzU4IDI5LjUgMjEuNDA1MSAyOS41IDE1LjAwMDVDMjkuNSA2Ljk5MTg3IDIzLjAwNzMgMC41MDAwMTcgMTQuOTk4NyAwLjUwMDAxNyIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", iMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTkuNjYxIiB5PSI0LjQxOTQzIiB3aWR0aD0iMiIgaGVpZ2h0PSIyMiIgcng9IjEiIGZpbGw9ImJsYWNrIi8+CjxyZWN0IHg9IjE2LjU3MSIgeT0iMTUuNDE5NCIgd2lkdGg9IjIiIGhlaWdodD0iOCIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKDEzNSAxNi41NzEgMTUuNDE5NCkiIGZpbGw9ImJsYWNrIi8+CjxyZWN0IHg9IjE1LjE1NjkiIHk9IjE0LjAwNTIiIHdpZHRoPSIyIiBoZWlnaHQ9IjgiIHJ4PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxNS4xNTY5IDE0LjAwNTIpIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", rMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTkuMjUiIHk9IjE1IiB3aWR0aD0iMiIgaGVpZ2h0PSI4IiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDE5LjI1IDE1KSIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMjAuNjY0MiIgeT0iMTYuNDE0MiIgd2lkdGg9IjIiIGhlaWdodD0iOCIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKC0xMzUgMjAuNjY0MiAxNi40MTQyKSIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMTEuMDcxIiB5PSIxNSIgd2lkdGg9IjIiIGhlaWdodD0iOCIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKDEzNSAxMS4wNzEgMTUpIiBmaWxsPSJibGFjayIvPgo8cmVjdCB4PSI5LjY1Njg2IiB5PSIxMy41ODU4IiB3aWR0aD0iMiIgaGVpZ2h0PSI4IiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgOS42NTY4NiAxMy41ODU4KSIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMTYuMTYiIHk9IjI2IiB3aWR0aD0iMiIgaGVpZ2h0PSIyMiIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKDE4MCAxNi4xNiAyNikiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", sMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTAuNDk3MiIgeT0iMjYuNTgxNCIgd2lkdGg9IjIiIGhlaWdodD0iMjIiIHJ4PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDEwLjQ5NzIgMjYuNTgxNCkiIGZpbGw9ImJsYWNrIi8+CjxyZWN0IHg9IjEzLjU4ODkiIHk9IjE1LjU4MTQiIHdpZHRoPSIyIiBoZWlnaHQ9IjgiIHJ4PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgMTMuNTg4OSAxNS41ODE0KSIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMTUuMDAzMSIgeT0iMTYuOTk1NiIgd2lkdGg9IjIiIGhlaWdodD0iOCIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKC0xMzUgMTUuMDAzMSAxNi45OTU2KSIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", oMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0Ljk5OTggMjcuMjk0OUMyMS43OTA0IDI3LjI5NDkgMjcuMjk1NCAyMS43ODk5IDI3LjI5NTQgMTQuOTk5M0MyNy4yOTU0IDguMjA4NTggMjEuNzkwNCAyLjcwMzYxIDE0Ljk5OTggMi43MDM2MUM4LjIwOTA3IDIuNzAzNjEgMi43MDQxIDguMjA4NTggMi43MDQxIDE0Ljk5OTNDMi43MDQxIDIxLjc4OTkgOC4yMDkwNyAyNy4yOTQ5IDE0Ljk5OTggMjcuMjk0OVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMTMgMjFIMTVNMTcgMjFIMTVNMTUgMjFWMTNIMTMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSIxNC45OTk4IiBjeT0iOSIgcj0iMS41IiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", aMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2IDE1QzI2IDE2Ljc3MDggMjQuOTIzNCAxOC40OTYzIDIyLjkzMDYgMTkuODI0OEMyMC45NDQ4IDIxLjE0ODcgMTguMTQzOCAyMiAxNSAyMkMxMS44NTYyIDIyIDkuMDU1MjIgMjEuMTQ4NyA3LjA2OTQyIDE5LjgyNDhDNS4wNzY2MyAxOC40OTYzIDQgMTYuNzcwOCA0IDE1QzQgMTMuMjI5MiA1LjA3NjYzIDExLjUwMzcgNy4wNjk0MiAxMC4xNzUyQzkuMDU1MjIgOC44NTEzMyAxMS44NTYyIDggMTUgOEMxOC4xNDM4IDggMjAuOTQ0OCA4Ljg1MTMzIDIyLjkzMDYgMTAuMTc1MkMyNC45MjM0IDExLjUwMzcgMjYgMTMuMjI5MiAyNiAxNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMjUgMTVDMjUgMTcuMjA5MSAyMy40MzMgMTkgMjEuNSAxOUMxOS41NjcgMTkgMTggMTcuMjA5MSAxOCAxNUMxOCAxMi43OTA5IDE5LjU2NyAxMSAyMS41IDExQzIzLjQzMyAxMSAyNSAxMi43OTA5IDI1IDE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", cMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDlIOS4yNUM4LjA4ODM2IDkgNy41MDc1NCA5IDcuMDI0NTUgOS4wOTIyM0M1LjA0MTEgOS40NzA5OCAzLjQ5MDYxIDEwLjk1OTUgMy4wOTYwNyAxMi44NjM2QzMgMTMuMzI3MiAzIDEzLjg4NDggMyAxNUMzIDE2LjExNTIgMyAxNi42NzI4IDMuMDk2MDcgMTcuMTM2NEMzLjQ5MDYxIDE5LjA0MDUgNS4wNDExIDIwLjUyOSA3LjAyNDU1IDIwLjkwNzhDNy41MDc1NCAyMSA4LjA4ODM2IDIxIDkuMjUgMjFIMTFNMTkgOUgyMC43NUMyMS45MTE2IDkgMjIuNDkyNSA5IDIyLjk3NTUgOS4wOTIyM0MyNC45NTg5IDkuNDcwOTggMjYuNTA5NCAxMC45NTk1IDI2LjkwMzkgMTIuODYzNkMyNyAxMy4zMjcyIDI3IDEzLjg4NDggMjcgMTVDMjcgMTYuMTE1MiAyNyAxNi42NzI4IDI2LjkwMzkgMTcuMTM2NEMyNi41MDk0IDE5LjA0MDUgMjQuOTU4OSAyMC41MjkgMjIuOTc1NSAyMC45MDc4QzIyLjQ5MjUgMjEgMjEuOTExNiAyMSAyMC43NSAyMUgxOSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTEwLjAwMTUgMTVIMjAuMDAxNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==", lMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMTQuMDIxNUM1IDEzLjQ2OTIgNS40NDc3MiAxMy4wMjE1IDYgMTMuMDIxNUgyNEMyNC41NTIzIDEzLjAyMTUgMjUgMTMuNDY5MiAyNSAxNC4wMjE1VjI2LjAyMTVDMjUgMjYuNTczOCAyNC41NTIzIDI3LjAyMTUgMjQgMjcuMDIxNUg2QzUuNDQ3NzIgMjcuMDIxNSA1IDI2LjU3MzggNSAyNi4wMjE1VjE0LjAyMTVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIxIDEzLjAyMTlWOS4yODg0MUMyMSA1LjQyNzQ3IDE4Ljg2MzcgMi45Nzg1MSAxNS4wMDI4IDIuOTc4NTFWMi45Nzg1MVYyLjk3ODUxQzExLjE0MjMgMi45Nzg1MSA5IDUuNDMzNDYgOSA5LjI5MzkzVjEzLjAyMTkiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K", dMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNSAxNUM0LjUgMTQuNDQ3NyA0Ljk0NzcyIDE0IDUuNSAxNEgyNC41QzI1LjA1MjMgMTQgMjUuNSAxNC40NDc3IDI1LjUgMTVDMjUuNSAxNS41NTIzIDI1LjA1MjMgMTYgMjQuNSAxNkg1LjVDNC45NDc3MiAxNiA0LjUgMTUuNTUyMyA0LjUgMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", uMe = "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", hMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMkMxIDEuNDQ3NzIgMS40NDc3MiAxIDIgMUgxMkMxMi41NTIzIDEgMTMgMS40NDc3MiAxMyAyVjEyQzEzIDEyLjU1MjMgMTIuNTUyMyAxMyAxMiAxM0gyQzEuNDQ3NzIgMTMgMSAxMi41NTIzIDEgMTJWMlpNMSAxOEMxIDE3LjQ0NzcgMS40NDc3MiAxNyAyIDE3SDEyQzEyLjU1MjMgMTcgMTMgMTcuNDQ3NyAxMyAxOFYyOEMxMyAyOC41NTIzIDEyLjU1MjMgMjkgMTIgMjlIMkMxLjQ0NzcyIDI5IDEgMjguNTUyMyAxIDI4VjE4Wk0xNyAyQzE3IDEuNDQ3NzIgMTcuNDQ3NyAxIDE4IDFIMjhDMjguNTUyMyAxIDI5IDEuNDQ3NzIgMjkgMlYxMkMyOSAxMi41NTIzIDI4LjU1MjMgMTMgMjggMTNIMThDMTcuNDQ3NyAxMyAxNyAxMi41NTIzIDE3IDEyVjJaTTE3IDE4QzE3IDE3LjQ0NzcgMTcuNDQ3NyAxNyAxOCAxN0gyOEMyOC41NTIzIDE3IDI5IDE3LjQ0NzcgMjkgMThWMjhDMjkgMjguNTUyMyAyOC41NTIzIDI5IDI4IDI5SDE4QzE3LjQ0NzcgMjkgMTcgMjguNTUyMyAxNyAyOFYxOFoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K", gMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDUuNUMxNiA0Ljk0NzcyIDE1LjU1MjMgNC41IDE1IDQuNUMxNC40NDc3IDQuNSAxNCA0Ljk0NzcyIDE0IDUuNVYxNEg1LjVDNC45NDc3MiAxNCA0LjUgMTQuNDQ3NyA0LjUgMTVDNC41IDE1LjU1MjMgNC45NDc3MiAxNiA1LjUgMTZIMTRWMjQuNUMxNCAyNS4wNTIzIDE0LjQ0NzcgMjUuNSAxNSAyNS41QzE1LjU1MjMgMjUuNSAxNiAyNS4wNTIzIDE2IDI0LjVWMTZIMjQuNUMyNS4wNTIzIDE2IDI1LjUgMTUuNTUyMyAyNS41IDE1QzI1LjUgMTQuNDQ3NyAyNS4wNTIzIDE0IDI0LjUgMTRIMTZWNS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", pMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0Ljk5OTggMjcuMjk1MUMyMS43OTA0IDI3LjI5NTEgMjcuMjk1NCAyMS43OTAxIDI3LjI5NTQgMTQuOTk5NUMyNy4yOTU0IDguMjA4NzYgMjEuNzkwNCAyLjcwMzggMTQuOTk5OCAyLjcwMzhDOC4yMDkwNyAyLjcwMzggMi43MDQxIDguMjA4NzYgMi43MDQxIDE0Ljk5OTVDMi43MDQxIDIxLjc5MDEgOC4yMDkwNyAyNy4yOTUxIDE0Ljk5OTggMjcuMjk1MVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8Y2lyY2xlIGN4PSIxNC45OTk4IiBjeT0iMjEiIHI9IjEuNSIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExIDEyLjVDMTEgMTAuNSAxMi43IDguNzUgMTUgOC43NUMxNy4zIDguNzUgMTkgMTAuNSAxOSAxMi41QzE5IDE1LjY5IDE1IDE1LjY1IDE1IDE3LjQiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==", fMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgOC4yMDAxN0M5IDUuMDM4NzUgMTIuMDM4NiAyLjcwMDIgMTUgMi43MDAyQzE3Ljk2MTQgMi43MDAyIDIxIDUuMDM4NzUgMjEgOC4yMDAxN0MyMSAxMy43MDMzIDE1IDEzLjU0NTIgMTUgMTkuMDAwMiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTYuNzUgMjQuOTY0OEMxNi43NSAyNS45MzEzIDE1Ljk2NjUgMjYuNzE0OCAxNSAyNi43MTQ4QzE0LjAzMzUgMjYuNzE0OCAxMy4yNSAyNS45MzEzIDEzLjI1IDI0Ljk2NDhDMTMuMjUgMjMuOTk4MyAxNC4wMzM1IDIzLjIxNDggMTUgMjMuMjE0OEMxNS45NjY1IDIzLjIxNDggMTYuNzUgMjMuOTk4MyAxNi43NSAyNC45NjQ4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", MMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIuNDA3NyIgY3k9IjEyLjQwNzciIHI9IjkuNDA3NzMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMjcuMDgwMSAyNS4yNDA0QzI3LjU4ODEgMjUuNzQ4NCAyNy41ODgxIDI2LjU3MjEgMjcuMDgwMSAyNy4wODAyQzI2LjU3MiAyNy41ODgzIDI1Ljc0ODMgMjcuNTg4MyAyNS4yNDAyIDI3LjA4MDJMMTguODg4OCAyMC43Mjg4QzE4LjM4NjEgMjAuMjI2MSAxOC4zOCAxOS40MTMgMTguODc1MiAxOC45MDI4QzE5LjM4MDkgMTguMzgxNyAyMC4yMTUyIDE4LjM3NTUgMjAuNzI4NyAxOC44ODg5TDI3LjA4MDEgMjUuMjQwNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik03LjkwNzcxIDEyLjQwNzdDNy45MDc3MSAxNC44OTMgOS45MjI0MyAxNi45MDc3IDEyLjQwNzcgMTYuOTA3N0MxNC44OTMgMTYuOTA3NyAxNi45MDc3IDE0Ljg5MyAxNi45MDc3IDEyLjQwNzdDMTYuOTA3NyA5LjkyMjQzIDE0Ljg5MyA3LjkwNzcxIDEyLjQwNzcgNy45MDc3MSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGNpcmNsZSBjeD0iOS4yMTYyNSIgY3k9IjkuMTU1MjciIHI9IjEiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", mMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjU5NjggNy4xODY0MkMxNS43NjEgNy4zMTQxNCAxNi4wMDAyIDcuMTk3MTIgMTYuMDAwMiA2Ljk4OTA4VjVDMTkuOTYyOSA1LjAwMDAzIDIyLjM2OTYgNS43Mjc0MyAyMy44MjExIDcuMTc4OTNDMjUuMjcyNiA4LjYzMDQ2IDI2IDExLjAzNzIgMjYgMTVDMjYgMTUuNTUyMyAyNi40NDc3IDE2IDI3IDE2QzI3LjU1MjMgMTYgMjggMTUuNTUyMyAyOCAxNUMyOCAxMC44ODc2IDI3LjI2NSA3Ljc5NDQgMjUuMjM1MyA1Ljc2NDcyQzIzLjIwNTYgMy43MzUwNyAyMC4xMTI1IDMuMDAwMDMgMTYuMDAwMiAzVjEuMDExNEMxNi4wMDAyIDAuODAzMzY3IDE1Ljc2MSAwLjY4NjM0MyAxNS41OTY4IDAuODE0MDY1TDExLjc1NCAzLjgwMjkxQzExLjYyNTMgMy45MDMgMTEuNjI1MyA0LjA5NzQ5IDExLjc1NCA0LjE5NzU4TDE1LjU5NjggNy4xODY0MloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy41IDkuMDAwMDNDMi42NzE1NyA5LjAwMDAzIDIgOS42NzE2IDIgMTAuNVYyNy41QzIgMjguMzI4NSAyLjY3MTU3IDI5IDMuNSAyOUgyMC41QzIxLjMyODQgMjkgMjIgMjguMzI4NSAyMiAyNy41VjEwLjVDMjIgOS42NzE2IDIxLjMyODQgOS4wMDAwMyAyMC41IDkuMDAwMDNIMy41Wk00IDExVjI3SDIwVjExSDRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", yMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjQwMzIgNy4yMTY5OUMxNC4yMzkgNy4zNDQ3MSAxMy45OTk4IDcuMjI3NjggMTMuOTk5OCA3LjAxOTY1VjUuMDMwNTZDMTAuMDM3MSA1LjAzMDU5IDcuNjMwNDMgNS43NTc5OSA2LjE3ODkzIDcuMjA5NUM0LjcyNzQgOC42NjEwMyA0IDExLjA2NzggNCAxNS4wMzA2QzQgMTUuNTgyOCAzLjU1MjI4IDE2LjAzMDYgMyAxNi4wMzA2QzIuNDQ3NzIgMTYuMDMwNiAyIDE1LjU4MjggMiAxNS4wMzA2QzIgMTAuOTE4MiAyLjczNTAzIDcuODI0OTcgNC43NjQ3MiA1Ljc5NTI4QzYuNzk0MzYgMy43NjU2NCA5Ljg4NzUxIDMuMDMwNTkgMTMuOTk5OCAzLjAzMDU2VjEuMDQxOTdDMTMuOTk5OCAwLjgzMzkzIDE0LjIzOSAwLjcxNjkwNiAxNC40MDMyIDAuODQ0NjI5TDE4LjI0NiAzLjgzMzQ3QzE4LjM3NDcgMy45MzM1NiAxOC4zNzQ3IDQuMTI4MDYgMTguMjQ2IDQuMjI4MTVMMTQuNDAzMiA3LjIxNjk5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNi41IDkuMDMwNTlDMjcuMzI4NCA5LjAzMDU5IDI4IDkuNzAyMTcgMjggMTAuNTMwNlYyNy41MzA2QzI4IDI4LjM1OSAyNy4zMjg0IDI5LjAzMDYgMjYuNSAyOS4wMzA2SDkuNUM4LjY3MTU3IDI5LjAzMDYgOCAyOC4zNTkgOCAyNy41MzA2VjEwLjUzMDZDOCA5LjcwMjE3IDguNjcxNTcgOS4wMzA1OSA5LjUgOS4wMzA1OUgyNi41Wk0yNiAxMS4wMzA2VjI3LjAzMDZIMTBWMTEuMDMwNkgyNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", IMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDE1QzExIDE3LjIwOTEgOS4yMDkxNCAxOSA3IDE5QzQuNzkwODYgMTkgMyAxNy4yMDkxIDMgMTVDMyAxMi43OTA5IDQuNzkwODYgMTEgNyAxMUM5LjIwOTE0IDExIDExIDEyLjc5MDkgMTEgMTVaTTI3IDdDMjcgOS4yMDkxNCAyNS4yMDkxIDExIDIzIDExQzIwLjc5MDkgMTEgMTkgOS4yMDkxNCAxOSA3QzE5IDQuNzkwODYgMjAuNzkwOSAzIDIzIDNDMjUuMjA5MSAzIDI3IDQuNzkwODYgMjcgN1pNMjcgMjNDMjcgMjUuMjA5MSAyNS4yMDkxIDI3IDIzIDI3QzIwLjc5MDkgMjcgMTkgMjUuMjA5MSAxOSAyM0MxOSAyMC43OTA5IDIwLjc5MDkgMTkgMjMgMTlDMjUuMjA5MSAxOSAyNyAyMC43OTA5IDI3IDIzWiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0xOSAyMUwxMSAxNk0xOSA5TDExIDE0IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==", xMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNDQ0MzQgNS43OTE1TDguMDc0MjIgMTEuOTI2M0g4LjIxNDg0TDExLjg2MjMgNS43OTE1SDE2LjE2MDJMMTAuNjY3IDE0Ljc5MTVMMTYuMjgzMiAyMy43OTE1SDExLjkwNjNMOC4yMTQ4NCAxNy42NDc5SDguMDc0MjJMNC4zODI4MSAyMy43OTE1SDAuMDIzNDM3NUw1LjY1NzIzIDE0Ljc5MTVMMC4xMjg5MDYgNS43OTE1SDQuNDQ0MzRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTguNDQ2OSAyMy43OTE1VjUuNzkxNUgyMi4yNTI2VjIwLjY1MzhIMjkuOTY5NFYyMy43OTE1SDE4LjQ0NjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", SMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMjMuNzkxNVY1Ljc5MTVIMTIuODA1N1YyMC42NTM4SDIwLjUyMjVWMjMuNzkxNUg5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", jMe = "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", DMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgNlY4QzYgMTMuNjAwNSA2IDE2LjQwMDggNy4wODk5MyAxOC41Mzk5QzguMDQ4NjcgMjAuNDIxNSA5LjU3ODQ3IDIxLjk1MTMgMTEuNDYwMSAyMi45MTAxQzEzLjU5OTIgMjQgMTYuMzk5NSAyNCAyMiAyNEgyNCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==", wMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgNlYyNEgyNCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==", NMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgMjhWMk0xMSAyOFYyTTE5IDI4VjJNMjcgMjhWMiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K", AMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI4IDI3SDJNMjggMTlIMk0yOCAxMUgyTTI4IDNMMiAzIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=", TMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgIGQ9Ik0xNC42MjQ0IDguMDg5NjZDOC45NDI3MyA4LjE5ODUgMy45MDk2MSAxMC43NzE3IDAuNzAyMjg1IDE0LjcxMDdDMC4yOTQyNjUgMTUuMjExOCAwLjQxNDc5MiAxNS45NDM2IDAuOTM0MTc2IDE2LjMyODFDMS40NzYwMiAxNi43MjkyIDIuMjM5MjkgMTYuNTk2NyAyLjY2NTczIDE2LjA3NDZDNS4xNDY3NCAxMy4wMzY5IDguODg2NjIgMTAuOTQzMSAxMy4xNTkgMTAuNDcxMkwxNC42MjQ0IDguMDg5NjZaTTEwLjc5NjUgMTQuMzEwNEM4LjU2MjgzIDE1LjA4NzggNi42NDMxNiAxNi40NjY4IDUuMjYzNzUgMTguMjM2M0M0LjkwMjgxIDE4LjY5OTMgNS4wMjc5MSAxOS4zNTg0IDUuNDk5NzcgMTkuNzA3N0M2LjAzMTEzIDIwLjEwMSA2Ljc4MjU5IDE5Ljk0NDIgNy4xOTQ1OSAxOS40MjcyQzcuNTY1MDggMTguOTYyMyA3Ljk4MjE0IDE4LjUzMTYgOC40MzkzMyAxOC4xNDExTDEwLjc5NjUgMTQuMzEwNFpNMjAuMzY4NiAxNy4yNzEzTDIxLjUyMTggMTUuMzk3MkMyMi43NzE3IDE2LjE1MTEgMjMuODYyMyAxNy4xMTUzIDI0LjczNjEgMTguMjM2MkMyNS4wOTcxIDE4LjY5OTIgMjQuOTcyIDE5LjM1ODMgMjQuNTAwMSAxOS43MDc2QzIzLjk2ODcgMjAuMTAwOSAyMy4yMTczIDE5Ljk0NDIgMjIuODA1MyAxOS40MjcyQzIyLjEzMzQgMTguNTg0IDIxLjMwODMgMTcuODUzNCAyMC4zNjg2IDE3LjI3MTNaTTE3LjQ3NTggMjEuOTcyM0wxOC41NjgxIDIwLjE5NzJDMTkuMjM2MyAyMC42NDU3IDE5LjgwMzcgMjEuMjE2OSAyMC4yMzI1IDIxLjg3NTRDMjAuNDg4MSAyMi4yNjggMjAuMzUxNSAyMi43Nzg2IDE5Ljk3NDkgMjMuMDU3M0MxOS40MTczIDIzLjQ3MDEgMTguNTk3NiAyMy4xODQxIDE4LjE2NTEgMjIuNjQxNkMxNy45NjYzIDIyLjM5MjQgMTcuNzM0NiAyMi4xNjc0IDE3LjQ3NTggMjEuOTcyM1pNMjMuMjUwNSAxMi41ODc5TDI0LjQ3MDQgMTAuNjA1NEMyNi4zMzU3IDExLjY4OTEgMjcuOTcyNSAxMy4wODMzIDI5LjI5NzYgMTQuNzEwNkMyOS43MDU2IDE1LjIxMTcgMjkuNTg1IDE1Ljk0MzYgMjkuMDY1NyAxNi4zMjgxQzI4LjUyMzggMTYuNzI5MiAyNy43NjA1IDE2LjU5NjcgMjcuMzM0MSAxNi4wNzQ2QzI2LjIwOTEgMTQuNjk3MiAyNC44MjU0IDEzLjUxMzkgMjMuMjUwNSAxMi41ODc5WiIKICAgIGZpbGw9ImJsYWNrIiAvPgogIDxyZWN0IHg9IjIzLjM3NiIgeT0iMC4xNjkwNjciIHdpZHRoPSIzIiBoZWlnaHQ9IjMzLjM3MiIgcng9IjEuNSIKICAgIHRyYW5zZm9ybT0icm90YXRlKDMxLjYwNTkgMjMuMzc2IDAuMTY5MDY3KSIgZmlsbD0iYmxhY2siIC8+Cjwvc3ZnPg==", bMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMjFIMjNNOSAxNUgyMU01IDlIMjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=", vMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMjFIMjFNNSAxNUgxNU01IDlIMjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=", EMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMjFIMjVNMTUgMTVIMjVNNSA5SDI1IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K", CMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgb3BhY2l0eT0iMC4zMiIgeD0iMSIgeT0iNyIgd2lkdGg9IjI4IiBoZWlnaHQ9IjE4IiByeD0iOSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxjaXJjbGUgb3BhY2l0eT0iMC4zMiIgY3g9IjEwIiBjeT0iMTYiIHI9IjYiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", zMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMSIgeT0iNyIgd2lkdGg9IjI4IiBoZWlnaHQ9IjE4IiByeD0iOSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", LMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjIgMjdINUMzLjg5NTQzIDI3IDMgMjYuMTA0NiAzIDI1VjE5LjhNMTkuOCAyN0gyNUMyNi4xMDQ2IDI3IDI3IDI2LjEwNDYgMjcgMjVWMTkuOE0zIDEwLjJWNUMzIDMuODk1NDMgMy44OTU0MyAzIDUgM0gxMC4yTTE5LjggM0gyNUMyNi4xMDQ2IDMgMjcgMy44OTU0MyAyNyA1VjEwLjIiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", kMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjEwMjQgMjUuMTIzTDI2LjY5NTMgMTAuNDEyQzI3LjQyNCA5LjYyMzM0IDI3LjM5OTkgOC4zOTk4NyAyNi42NDA1IDcuNjQwNTRMMjMuMzY0OSA0LjM2NDg4QzIyLjYwMzQgMy42MDMzNyAyMS4zNzU2IDMuNTgxNTggMjAuNTg3NSA0LjMxNTU5TDUuOTg0MDEgMTcuOTE3NU0xMy4xMDI0IDI1LjEyM0w1Ljk4NDAxIDE3LjkxNzVNMTMuMTAyNCAyNS4xMjNDMTIuNjAyNCAyNC45NTYzIDExLjMwMjUgMjQuNTM3NCAxMC4xMDI1IDI0LjUzNzRDOC45MDI1NCAyNC41Mzc0IDcuNjAyNTQgMjUuNTM3NCA3LjEwMjU0IDI2LjAzNzRNNS45ODQwMSAxNy45MTc1QzYuMTUwNjggMTguNDE3NSA2LjYwMjU0IDE5LjgzNzQgNi42MDI1NCAyMS4wMzc0QzYuNjAyNTQgMjIuMjM3NCA1LjYwMjU0IDIzLjUzNzQgNS4xMDI1NCAyNC4wMzc0TTcuMTAyNTQgMjYuMDM3NEw2LjEwMjU0IDI1LjAzNzRMNS4xMDI1NCAyNC4wMzc0TTcuMTAyNTQgMjYuMDM3NEw2LjEwMjU0IDI3LjAzNzRMMiAyNy4xMzk5TDUuMTAyNTQgMjQuMDM3NCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIgMjZMNCAyNEw2IDI2TDUgMjdMMiAyNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", OMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNTIxODUgMjYuNDc3Mkw3LjU1NjAyIDIyLjQ0MyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMuNTIxNjYgMjAuNjI2N0w1Ljg4MDEyIDE5Ljc5NzQiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC4yMDE0IDI0LjExODdMOS4zNzIxMyAyNi40NzcyIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjcgNy4zNjM2NEwxMy4xMTEyIDIxLjI1MjRDMTIuOTE2IDIxLjQ0NzcgMTIuNTk5NCAyMS40NDc3IDEyLjQwNDEgMjEuMjUyNEw4Ljc0NzYgMTcuNTk1OUM4LjU1MjMzIDE3LjQwMDYgOC41NTIzMyAxNy4wODQgOC43NDc2IDE2Ljg4ODhMMjIuNjM2NCAzTDI3IDcuMzYzNjRaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", PMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDE1QzIwIDE3Ljc2MTQgMTcuNzYxNCAyMCAxNSAyMEMxMi4yMzg2IDIwIDEwIDE3Ljc2MTQgMTAgMTVDMTAgMTIuMjM4NiAxMi4yMzg2IDEwIDE1IDEwQzE3Ljc2MTQgMTAgMjAgMTIuMjM4NiAyMCAxNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIyMSIgeT0iNSIgd2lkdGg9IjQiIGhlaWdodD0iNCIgcng9IjIiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yNSAzQzI2LjEwNDYgMyAyNyAzLjg5NTQzIDI3IDVWMjVDMjcgMjYuMTA0NiAyNi4xMDQ2IDI3IDI1IDI3SDVDMy44OTU0MyAyNyAzIDI2LjEwNDYgMyAyNVY1QzMgMy44OTU0MyAzLjg5NTQzIDMgNSAzSDI1WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", UMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC41IDMuM1Y1LjFIMTkuNVYzLjNIMTAuNVpNMjEuMyA1LjFWMi44NUMyMS4zIDIuMTA0NDEgMjAuNjk1NiAxLjUgMTkuOTUgMS41SDEwLjA1QzkuMzA0NDQgMS41IDguNzAwMDIgMi4xMDQ0MiA4LjcwMDAyIDIuODVWNS4xSDMuMzAwMDJDMi44MDI5NyA1LjEgMi40MDAwMiA1LjUwMjk0IDIuNDAwMDIgNkMyLjQwMDAyIDYuNDk3MDYgMi44MDI5NyA2LjkgMy4zMDAwMiA2LjlINS4yNjEwM0M1LjI2MTEgNi45NTA5IDUuMjYzMzIgNy4wMDIyNCA1LjI2Nzc1IDcuMDUzOTVMNi45Njc0MiAyNi44NTM5QzcuMDQ3MzQgMjcuNzg1IDcuODI2MzkgMjguNSA4Ljc2MDgyIDI4LjVIMjEuMjM5MkMyMi4xNzM3IDI4LjUgMjIuOTUyNyAyNy43ODUgMjMuMDMyNiAyNi44NTM5TDI0LjczMjMgNy4wNTM5NUMyNC43MzY3IDcuMDAyMjQgMjQuNzM4OSA2Ljk1MDkgMjQuNzM5IDYuOUgyNi43QzI3LjE5NzEgNi45IDI3LjYgNi40OTcwNiAyNy42IDZDMjcuNiA1LjUwMjk0IDI3LjE5NzEgNS4xIDI2LjcgNS4xSDIxLjNaTTIyLjkzODkgNi45SDcuMDYxMTZMOC43NjA4MiAyNi43SDIxLjIzOTJMMjIuOTM4OSA2LjlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjMyNTMgMTEuNDAzMUMxMS44MjA2IDExLjM2MTggMTIuMjU1NiAxMS43Mjk5IDEyLjI5NjkgMTIuMjI1M0wxMy4xOTY5IDIzLjAyNTNDMTMuMjM4MiAyMy41MjA2IDEyLjg3MDEgMjMuOTU1NiAxMi4zNzQ4IDIzLjk5NjlDMTEuODc5NCAyNC4wMzgyIDExLjQ0NDQgMjMuNjcwMSAxMS40MDMxIDIzLjE3NDdMMTAuNTAzMSAxMi4zNzQ3QzEwLjQ2MTkgMTEuODc5NCAxMC44Mjk5IDExLjQ0NDQgMTEuMzI1MyAxMS40MDMxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy42MjUzIDIzLjk5NjlDMTcuMTI5OSAyMy45NTU2IDE2Ljc2MTkgMjMuNTIwNiAxNi44MDMxIDIzLjAyNTNMMTcuNzAzMSAxMi4yMjUzQzE3Ljc0NDQgMTEuNzI5OSAxOC4xNzk0IDExLjM2MTggMTguNjc0OCAxMS40MDMxQzE5LjE3MDEgMTEuNDQ0NCAxOS41MzgyIDExLjg3OTQgMTkuNDk2OSAxMi4zNzQ3TDE4LjU5NjkgMjMuMTc0N0MxOC41NTU2IDIzLjY3MDEgMTguMTIwNiAyNC4wMzgyIDE3LjYyNTMgMjMuOTk2OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", RMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjcyIDQuMTM3MTVDMTcuODE5NCA0LjEzNzE1IDE1LjQ2NjggNi40ODk2OSAxNS40NjY4IDkuMzkyNTlDMTUuNDY2OCA5LjgwMzEgMTUuNTE0MiAxMC4yMDIzIDE1LjYwMjIgMTAuNTg4QzExLjIzNDMgMTAuMzY4MSA3LjM2NDg4IDguMjc2MDkgNC43NzMyNSA1LjA5ODAxQzQuMzIyMTQgNS44NzYxOCA0LjA2Mjc1IDYuNzc4NCA0LjA2Mjc1IDcuNzM5MjdDNC4wNjI3NSA5LjU2MTc2IDQuOTkwOTEgMTEuMTcxMSA2LjM5OTUxIDEyLjExMjhDNS41Mzc4OCAxMi4wODQ2IDQuNzI4MTQgMTEuODQ4OSA0LjAxOTkgMTEuNDU1M1YxMS41MjNDNC4wMTk5IDE0LjA2ODQgNS44Mjk5OCAxNi4xOTIgOC4yMzQ0IDE2LjY3NDdDNy43OTIzMSAxNi43OTQyIDcuMzI4OCAxNi44NTc0IDYuODUwNjIgMTYuODU3NEM2LjUxMjI4IDE2Ljg1NzQgNi4xODE4NSAxNi44MjU4IDUuODYxNTYgMTYuNzY0OUM2LjUzMDMzIDE4Ljg1MTMgOC40NzAxMSAyMC4zNzE1IDEwLjc2OTYgMjAuNDEyMUM4Ljk3MDg0IDIxLjgyMTggNi43MDUxMyAyMi42NjIgNC4yNDQzMiAyMi42NjJDMy44MjAyOCAyMi42NjIgMy40MDE4NyAyMi42MzcyIDIuOTkwMjMgMjIuNTg4N0M1LjMxNTcxIDI0LjA4MDggOC4wNzY1MSAyNC45NDkyIDExLjA0MjYgMjQuOTQ5MkMyMC43MDc2IDI0Ljk0OTIgMjUuOTkxMyAxNi45NDQyIDI1Ljk5MTMgMTAuMDAxNkMyNS45OTEzIDcuMDQyNTQgMjMuODk3NCA0LjEzNzE1IDIwLjcyIDQuMTM3MTVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjYuMzkzIDcuMTM3NThDMjcuNDU2NSA3LjAxMDE0IDI4LjQ2ODEgNi43MjgxOSAyOS40MDk4IDYuMzEwOTFMMjkuNDA3NSA2LjMxNDNDMjguNzA0OSA3LjM2NjUxIDI3LjgxNCA4LjI5MDE2IDI2Ljc4NzcgOS4wMzIyNEwyNS4zNjY3IDUuNTA0NTVDMjYuNTYzMyA1LjI2OTk4IDI3LjY4NzcgNC44MzI0IDI4LjcwMjcgNC4yMzAxNkMyOC4zMTAyIDUuNDU3MTkgMjcuNDc3OSA2LjQ4Nzk4IDI2LjM5MyA3LjEzNzU4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", YMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMTVDNSAxNC40NDc3IDUuNDQ3NzIgMTQgNiAxNEgyNEMyNC41NTIzIDE0IDI1IDE0LjQ0NzcgMjUgMTVWMjdDMjUgMjcuNTUyMyAyNC41NTIzIDI4IDI0IDI4SDZDNS40NDc3MiAyOCA1IDI3LjU1MjMgNSAyN1YxNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjEgMTRWOC4yNzIwM0MyMSA0LjQxMTU1IDE4Ljg1NzcgMiAxNC45OTcyIDJDMTIuODc3MiAyIDExLjI3NzIgMi42OTQ5NSAxMC4yNjUzIDMuOTk5OTdDOS40MzQzNiA1LjA3MTY3IDkgNi41MjU1NCA5IDguMjY2NSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", QMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMjYiIHk9IjE5LjUiIHdpZHRoPSIyIiBoZWlnaHQ9IjIyIiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMjYgMTkuNSkiIGZpbGw9ImJsYWNrIi8+CjxyZWN0IHg9IjE1IiB5PSIxNi40MSIgd2lkdGg9IjIiIGhlaWdodD0iOCIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKC0xMzUgMTUgMTYuNDEpIiBmaWxsPSJibGFjayIvPgo8cmVjdCB4PSIxNi40MTQyIiB5PSIxNC45OTU4IiB3aWR0aD0iMiIgaGVpZ2h0PSI4IiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoMTM1IDE2LjQxNDIgMTQuOTk1OCkiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", ZMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTUiIHk9IjE5LjA5IiB3aWR0aD0iMiIgaGVpZ2h0PSI4IiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTUgMTkuMDkpIiBmaWxsPSJibGFjayIvPgo8cmVjdCB4PSIxMy41ODU4IiB5PSIyMC41MDQyIiB3aWR0aD0iMiIgaGVpZ2h0PSI4IiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDEzLjU4NTggMjAuNTA0MikiIGZpbGw9ImJsYWNrIi8+CjxyZWN0IHg9IjE1IiB5PSIxMC45MTEiIHdpZHRoPSIyIiBoZWlnaHQ9IjgiIHJ4PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTM1IDE1IDEwLjkxMSkiIGZpbGw9ImJsYWNrIi8+CjxyZWN0IHg9IjE2LjQxNDIiIHk9IjkuNDk2ODMiIHdpZHRoPSIyIiBoZWlnaHQ9IjgiIHJ4PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSgxMzUgMTYuNDE0MiA5LjQ5NjgzKSIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iNCIgeT0iMTYiIHdpZHRoPSIyIiBoZWlnaHQ9IjIyIiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDQgMTYpIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", FMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNCIgeT0iMTAuNSIgd2lkdGg9IjIiIGhlaWdodD0iMjIiIHJ4PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSgtOTAgNCAxMC41KSIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMTUiIHk9IjEzLjU5MTciIHdpZHRoPSIyIiBoZWlnaHQ9IjgiIHJ4PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxNSAxMy41OTE3KSIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMTMuNTg1OCIgeT0iMTUuMDA1OSIgd2lkdGg9IjIiIGhlaWdodD0iOCIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKC00NSAxMy41ODU4IDE1LjAwNTkpIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", BMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUuMzk5NyIgY3k9IjE5LjQzOTUiIHI9IjEuNSIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0LjA1MzggMTAuNDU5NUMxNC4wMjQ0IDkuNjk1NzQgMTQuNjM1NiA5LjA2MDU1IDE1LjM5OTkgOS4wNjA1NUMxNi4xNjQzIDkuMDYwNTUgMTYuNzc1NSA5LjY5NTc0IDE2Ljc0NjEgMTAuNDU5NUwxNi40Mzg0IDE1LjQ2MTNDMTYuNDE2OSAxNi4wMTkzIDE1Ljk1ODMgMTYuNDYwNiAxNS4zOTk5IDE2LjQ2MDZDMTQuODQxNSAxNi40NjA2IDE0LjM4MyAxNi4wMTkzIDE0LjM2MTUgMTUuNDYxM0wxNC4wNTM4IDEwLjQ1OTVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjguNDgyNSAyMy44NTc4TDE1LjUyIDEuMzMxOTRDMTUuMjg5MiAwLjkzMDk1IDE0LjcxMDYgMC45MzA5NTEgMTQuNDc5OSAxLjMzMTk0TDEuNTE3NDcgMjMuODU3OEMxLjI4NzMgMjQuMjU3OCAxLjU3NjAyIDI0Ljc1NzEgMi4wMzc1MiAyNC43NTcxSDI3Ljk2MjVDMjguNDI0IDI0Ljc1NzEgMjguNzEyNyAyNC4yNTc4IDI4LjQ4MjUgMjMuODU3OFoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K", GMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIuNDA3NyIgY3k9IjEyLjQwNzciIHI9IjkuNDA3NzMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIxMS4xMDY2IiB5PSI3Ljg1NDMxIiB3aWR0aD0iMi42MDE5MyIgaGVpZ2h0PSI5LjEwNjc3IiByeD0iMS4zMDA5NyIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMTYuOTYwOSIgeT0iMTEuMTA2NyIgd2lkdGg9IjIuNjAxOTMiIGhlaWdodD0iOS4xMDY3NyIgcng9IjEuMzAwOTciIHRyYW5zZm9ybT0icm90YXRlKDkwIDE2Ljk2MDkgMTEuMTA2NykiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yNy4wODAxIDI1LjI0MDRDMjcuNTg4MSAyNS43NDg0IDI3LjU4ODEgMjYuNTcyMSAyNy4wODAxIDI3LjA4MDJDMjYuNTcyIDI3LjU4ODMgMjUuNzQ4MyAyNy41ODgzIDI1LjI0MDIgMjcuMDgwMkwxOC44ODg4IDIwLjcyODhDMTguMzg2MSAyMC4yMjYxIDE4LjM4IDE5LjQxMyAxOC44NzUyIDE4LjkwMjhDMTkuMzgwOSAxOC4zODE3IDIwLjIxNTIgMTguMzc1NSAyMC43Mjg3IDE4Ljg4ODlMMjcuMDgwMSAyNS4yNDA0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", WMe = "PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIuNDA3NyIgY3k9IjEyLjQwNzciIHI9IjkuNDA3NzMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIxNi45NjEiIHk9IjExLjEwNjciIHdpZHRoPSIyLjYwMTkzIiBoZWlnaHQ9IjkuMTA2NzciIHJ4PSIxLjMwMDk3IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAxNi45NjEgMTEuMTA2NykiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yNy4wODAxIDI1LjI0MDRDMjcuNTg4MSAyNS43NDg0IDI3LjU4ODEgMjYuNTcyMSAyNy4wODAxIDI3LjA4MDJDMjYuNTcyIDI3LjU4ODMgMjUuNzQ4MyAyNy41ODgzIDI1LjI0MDIgMjcuMDgwMkwxOC44ODg4IDIwLjcyODhDMTguMzg2MSAyMC4yMjYxIDE4LjM4IDE5LjQxMyAxOC44NzUyIDE4LjkwMjhDMTkuMzgwOSAxOC4zODE3IDIwLjIxNTIgMTguMzc1NSAyMC43Mjg3IDE4Ljg4ODlMMjcuMDgwMSAyNS4yNDA0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", HMe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIGSURBVHgB7ZrvTcMwEMUfTFA2MBMAE5ANKBt0BJgARoAJwgZlg8AE0AnSDcIGxqfkQ2UlDk7u3EvxT3pSpEh5fqn/XNQDMplMJqOXM8Rz7XTnVHTXK6Tlx+m706vTHkIYp62TVaayGxsr9Es2AKxS1d0Y2cJqDeprdmiD9u0tJXCDmdO7BGAXpi0mYgDYhWpwap9jmAcsl/XQjVDgKyyX26EbocKDNgCJouIDbbFAz6apZ8APFScXiIR7XdELLHp8ngW8LCbAPYBNwEuigouG07we8SqY/QYDhzYtTvYj97+RiFSBVzPvs5Eq8NhuXEAB3GuqGvAxkKnXo7EComCbLiTpCXKfnb2ECo9Jb0kRvdlSrWE15MCnTg586qQOTCXkvdOl043TI9pPORVwn4tf6C8hDWTO4mi4B2ACXmsBv2g4zas/+HH/yr1o2rSSfCKmCmyghJSB11AO9yZCa3QT8EuyhkNYIdHx5P8zUAj4RGMF5Z/HpYBHNFJhXzwfI+QTjcQg/GqLrmshr6MHrrznr7oXYIXUS8rCY3dwTZtW3+Z1VCQKevpLpRJ4rq8GE0gxMClVQ6FCU/oTy2WHCSype8eXwUQ0NqKNqcQMDHQ3pPmqwfBl9q8a0w5D1wCsUjUQONON0xsAq0xbREzjKe3DBm0PF7U1HbN9mI7NdyTsHshkMpmMNL8sh8RnoKthkAAAAABJRU5ErkJggg==", VMe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASoSURBVHgB7dpbaBxlFAfw//km2SQbk6oxXtImbdVaaYkxiFJrLLTFgg/2Zq+W+NAKisSmKHjD4KKxagJtFZEkEikxtJpiRbRWSmsritg+WAQVBMU06pqGQnPRTbLZ+Y5nH6pPSbbnm+66sr+XDMs3s3Py3c6ZWSAnJycn57+LEJCRlZVLLJuNRLxKrno1GPmTtTVeAYfn1IHEFJeckAa/yHWOy3E77eo8jQA4Bzy8ZmYZ+V4TwA0M8lI5J8WA/8XwYagdJZWPUSRi4cDAAd85q4it9wkDjakGq0LwwPwohn49wD09Tt/jFPBwudlFjDuQLsRr8fWnjXCgDnhwddVtMh4fQfpF+Mmt86GkDthYbEdmlMhythJKLkO6Dpli6AEoOQTMVcgU5tlQ0gdMpN4eGM7UK7U+YMYAMoZ+gJI6YEkZPkCmEH8EJXXAnKB3ZWjGkH5D8O0+KKkDLj105ivJgDqRdtRGe/b2Qskp00rEQ8/JDRxGuhAdlCLiaThwCrjs8E/DJSjcSEwv4dJKVk4tGPE2wVFg5eHZ1ZU3hNk8zmzvkstWY4p/Jkm1VDx9teTL3X0je+5RePmd1NrxMwKQh4AcKeyrYMIM2a6uANm4YVswRfNotffZ/FuG349f+GDB2t0rRinvITZmETOussYkLKiQDFewb0rR2oEgOPdw9xYuZYsWWbEfTvUcaRstSmDuhgMUv6aLi73r8JZsNZunOkcGw2uXFaDpxzoagQOnHn79Xi6wjKNyeDsUyg/xtTK6P5fDm6Zry8yNI+NUIQebXLI8p0XrysvxpnSXKtikUIjfQArB/oN5/cxjthkO1EO6azMnq6UvoJAc0i/Uo340xMdw8YbzDC3uW0bfQ8GheMA2OPA93gGdUt+3a6CkTy0t7oaSbEbJSbgQSky0AUrqRcsQ5mjLvD8LUc5uO4S6Ftf3cDIxUONkyuHyuFX/aApahH4ohcfoHFs+CyUZGt9BSV8PMz6Gkpzry5Q4ASUm/hBKLkN6v/wZhVJB3LRDZ0DSzvegpA74wf30pWRZb0OpuQunCNyNiyTvrjr6l1IvlJwyrdk3Y4d0tXp4xdg0yA51IuUTiPf9vjz5HkvPKeClEUpMhFEvQb8MhfP30FDcw30yJ9umbsm+pJWvRpd7W+AosHr4nfV8o+/hCeNxbSw0XmMNT1oesuFo+WD4+mS1dOGzWUfG5lmT/5T0eLWUmVVyYwkpE/sN6PiYxZ5zKyiKAAQWcNGp5sUmhG1yk/dLSDOmaR6Nhfy5WBiJI82cHwCUnNxZ5od8GZK8jgN4wn6pOc3himh72Ib8ZD28DlnCKeDz/QNt0qm3IouoAy76tnmR5MP1yDL6HrbcgCzkkksvQRZyqZYqkIVcFq0EtAjjWPC8/nwHDgHTH1CSbOc3l0etLlzKwx6oUSC/qtPQ97AxB6WrxqCQz95uZIg64NGaZ0/Cat4amshg7TO9yBCnTCtWUtoqczHlnx9IJbQ35p/ZiQxyr5YiEVO8il5hMttlYk9WEg7KF7X8VdukqpuDFFh5WHD6xXmGaKthLGNwjSxqE1LL9sFwd55Bz1B1UyDvd3NycnJy/s/+BumrdHhWJ6PmAAAAAElFTkSuQmCC", KMe = "data:image/png;base64,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", XMe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGxSURBVHgB7ZmLjYJAEIbHyxVgCVqBlmAHagd2YKxArUCtQK3AEqQDoALoADrg+MmxAQ488DHiMF+ycR8uye/Oa4VIURRFaS+9G2sRfTal2r6oY6hg6ahg6ahg6ahg6ahg6ahg6XRO8De1hH6/T7vdzoy32y35vk+cRJxtMBhEWSaTyaPPLEV9WDpP+4vneDzmxmEYkuu6dDqdKvfEZkyz2YxGo1Hiw+inWJZlfBjPWq1W1JBew+8385kqqnwRPhsEQVQHz/M+x4djwaXz1+s1OVVunpaWhsOh6UMMzLWK5XKZW4e5Oo6T7EuZz+fJHCd3pwSYYMpms/ljytl127Zlp6X1ep07XZwkJ6yCx+MxLRYLM0YE566mWAVfLhfTh1CUj9ywCS4GqsPhwH66gEUwhMbBy4whdL/f0ztguS0hUGVzbh1Tnk6npo8fiMMa7k4JSDUpxWoqLkEr91VVXsXUVrOV8hKTPp/Ppp892f8CFUcQe9n7YaSfbJDCBQBpCJ+3QClaLEdxkUBrSK/25C8PCW4B+kIcqGDpqGDpqGDpqGDpqGDpqGDpdE6woiiK0mZ+ACADsanhUFUcAAAAAElFTkSuQmCC", JMe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACCSURBVHgB7dmxDYMwFEXRnyiDZJRsmoySUdgEKBGdQTLo+Rzp976Fq1cFAAAc8ah2c91LU8OzBjNc8KvOmdb7V1+f9d7V0by5b/X3272hiT+cTnA6wekEpxOcTnA6wekEpxOcTnA6wekEpxOcbrjgs/vwVNePaU0NBvF0wwUDAADHLBkQDn9Tm0abAAAAAElFTkSuQmCC", qMe = "data:image/png;base64,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", _Me = "data:image/png;base64,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", $Me = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALjSURBVHgB7ZnNS1RRGMafmazMj4rsw0hMEQ0X0SKRIhDcugq0Vi7a2MKVe0Fw5VIQ/AsGaeE2DMGNLQwlQmNC7IMI+0CEUitRy27PmXMHp/SccWbOvc6F9wc/rvoyd3xmzj333PcAgiAIgiAIgiAIwn5iyBEPuMDDJXqVnqeV9Byt8v+u6mW0lB7PUL1X3DeTXd/fGW77btE1uuq74f++QtfpO570M1zDkJW0ny5Sr8h8SR/ScriAJ6qhr4ow6P/OeHq0FRS2nL6NQNi0j1AIPMGDCIVNe8eWKZ4l831Ej7u2YrbANxE9rtmKxtsSh8ZlBDHlB88mPR3Tt7p92L7hOkQTtQaoNhVtgc/AFc3NXIaUIkQumgq2wFVwRW8vsLAAtLYiJGpMhXACK5qagNlZYHwcaGhAwBhHpy1wBYKgqwuYnweGh4Mc5mWmgi1wYcs0GxX8LPv6gKUlPdxjOT/DZKPIAqeprQVGR4G5OaCtDQ45aSrYAoc3rba0ANPTQCIB1NfDASWmQjyfFwVGd7ce5h0dKJB4zgWkFlshk0wCnZ3AxAQK5I+pYPsWtxEWa2xiDA0BIyPscWzBAbumgi3wdwTNBjs2Y2PA4CCbNitwiPFTO7rAU1NsGvXrGdo9m6aCLfAPBMHyMtDTA0xOIkC+mQq2SWsdLlHX5sAA0NgYdFhF7v87p+h7ztou7e2eV10dZpvnlimXrQFwm4cZRJM6BvtwUME2pD8imqgZ+pOpaAv8BZbpvYh5EdO7FwdiDOy/6AmiR9JWzNa1fI7o8dRWtD6Ienq/hqt5XEE0WKQ3GOoX8oWhW+lqiLeUfH1PnTxbqtB19HGRBt2hCc/SuMskp94KT3qWh+vQ3X125VKNPrVHrPpfp6BbK0p1Kaiuwwns7Q8fO8RbqKccNRx3sLc/rH7+Cb03/BV6FaX2iN/QZ/R1TNcOhfNmkglPT5AqdAn+XcOnQhZ03QmCIAiCIAiCEDh/Acf/25ujaxe5AAAAAElFTkSuQmCC", eme = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANXSURBVHgB7ZpNTBNBFIDfdgsUf4qAPwkiJuitIJrggYMJJGKPngC5ESMHj+DRQ8HEeFCBE/4bj0q8aDxIT40aIcFEE+WESCLSoIi0hVqkbNd5E7cpaafd0p12u86XkDTz0+Tb9+bN2wYAgUAgEJgXKd3k6WurraoqeVQVWqHABMOr4F9eyrTMZ5PlvoVR1wfWAqZw+9W14wrAezAJOoUpqiS1Ld5u9KWas7E2xSQYhiJFUlUPa44pbIY0zoFW1oQN/jOEsNURwlZHCFsdOxiA+5gdmg7LwJONpTcQnrure333ndTjhgg31cngbjTkq5io/u+gqM91r+9mjIszbHVE0TKSUCQGLz/9gfkVBVw1JdBQY4faKjnjnuC6ChUOCZzlxseDm/C9179h4Nlq0viFUztg8OzulHvezm5A/+MQfUDD55zQ2VwORsNF+KY3DEPeNfrZSSLlOmiH6YVNCJHI3ScPwlkuwaUzu7bs8ZCHg3O84SI8QSKFuF1lMEIipaXm+UcBGCcpjmK9JNI4Pv9Lgb4nofge3nApWk8vVsLDnj1whaRu4jns+peioYhKo418I+mrybJS3Ui4nWF3Q1nSWHA9Fv+MqY60HCmloi31pTT1PSnOvZHwbY8IWICCJKI0lV+F6ZiWzhpYyPIFd+GO0RUqrdHZ7ICBPKQui7w3HhOzURrtQsFdePLyXli4cQC8/dX0XGO0sVpP+zehEOQtwi7SZY10VdA7GBmbikAh4CKMHdOQN5w0jrLYYiKhhIqdTwwvWpiqHbdW6OfaKtuW9hCbDO3OdToK895iuDCmLkZx2h+FPtIXT3yOkru2hJzdWPxaQnrzeBUlwuVaetBTQaOMBWrsXYT+JYKNRqa3Jl5wET5EZLAqU1lSnPCVD2k5WkpTHLsrFp0nHfHv4AG3xgMLFHZQ2XZRw6SS80T8xGN1xG9aGoHYOOhl8sdOiM6VAU/2fZ2Bho/V+hbblQDAz9RTrD1+5TroZexLJbxY5nuvts+Eod5Xl3EdaVwDqgJtLGFLpbQmu983xfwvHssI65FFLCGsVxYpeuFsZJGiFs5WFila4e3IIkUpvF1ZJJ2wD0xILrJIOuFBMBm5yiJM4cWBSZ8MygkwSaTXZVvOsgKBQCAwO38B4ghF8Qon7ukAAAAASUVORK5CYII=", tme = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUwSURBVHgB7VrNixxFFH9VPbOz6+6G1UWRYCAxEQ/CIijoSYUIHoRFCBsWBPWwFw/e8geIBxcP0YufoOBBT15yyR4kIB49eEviB8oimBjCfsTMZueru36+mo+dnp7+qKruHoLMD4aufvWqun5dr957VT1EU0wxxRRT3L8QZAlwm4Mrp88L0X5bAM8RMNuVDmq7F4y2iLsidC9rTbn07KXZYy+8I568sEMlQpIl7v749BlPtN4TKniREDBZRbl//NJkdXmtIxsfAV9UqURYE674u28C6vHhjDkAMW2F9Lj39fYfu181tjdPArC2PhNUyBrBcR5wqF3UVMO6CeacBCEqgsS6DGiRbnyywZJdKhjWM4wg3CbHLCc/oSoIq+3mwZe4+uFDVDCsCffWnUYZZI8gNenOXPsi/v54mQqEA2ENpNwbmm82eGxYb7fqnwE/OCy9xE7zAjnqkX4PmuXQd66z/dOnRZl3DsKg8QEazCqMhQNIUuqtzlzrIn55P7d5F2PSXe5Irs+AyH5Olft/3a/St9euvTtDOVCASWvArIyobFDjE1STC4pSUOWWrzxRq1zOE6ftCetBDaxZz6rRzCJdBp/UwW98uUdZ4Dj9ktdpbtZ/v+Bk3o7eDwYyE52hDIfb5N/aIninSFTnqeek+/pS5yRaE3zVSY9ak81/m8DahhDfBWSBgty9SZiidBnPMrW2KeCfXxekgrBeaMPRK3pM/GXszOtZvk0WyEnYdBbJODp5M3yzQOTfY9IqRdcx0y7QpKNyRIpI0RnKtOlWaiApQR0mDRXpR0T7sENJJm1bHwGTkjzTvH2i4DDkvMWIihMcCMckHLE6g6JJyIqXVZi0JuY3ovWYtEmnIYmsjc5Q5vVJB63RQxKN7CA2jgIJZ6WZLuuu10ZWe+Wg01/T+g0I0Dxn2mQJB8IqWwWGYcowHe3GXybtsSNDp7emJ7iGKWlUw8LsKVILKzwqL2NiY7y0Lnf2+aTwZ168+yPawuvNrvCF0XuPQzGER8IOx8/Tm4Rjz5MLur2oFsmr55j0/pixCJ2AVdAlvDAnJ2HSSJ81HhFqJygXZI23Cg8Pnzf2CHSldXLomu5X6BcXeyB4VO2Eggm7Z0DxfVmkroYoOLUMIWiQ2LtMdPhrv4lBmNKuePlVgnZ4WbpwI15e4qGY8M4WiTtXzMOUt0Bq/in2RivpfedA+dvD3AkIjESmKCfxOAIs7m02IL3yYmCfaRXvpU3y57H7JOeUxecu2aL4xEPEVqbIhmUgRDIpJDk6qwHsCWuLNrYkc7Jm3eVo20d5Xpq/fmL2JNH8CpnFU86eJB/eVZYy9PKhvO0hDx7HNwiPvhFfHwfBw5l5xKD7iR7xGHppPfjaY5QP+U04ihJy6aJM0H7fbIICCfc9bPfELd+gtLcGbxH7N5Fn5EMJubQiefNzwvIqxb9PZPTMpxvtm70DABRlLUOU4KV5+f7zNYlb31A0KCMcr4fS0bZdK+GvEGO+IjrTboc8jse0BnJ9+DQoGmVfaYeAxZl1edvDTDUXskk65ijFpJE6mHSTJpO2k9wtCUGI37HZ7HYSZKb75v4adjnTsiasEPDHTKE/ZnrmrfKSjRXD36v4ZAnrOCxl7Xu+7KVrIfKLqwuLsmYWIT30i/jzwev71pNs/29aDpP1rcUPPKnOc/kEhM0/82KIIk1n/EXwgJsQ4rpX81YfONu4QZZwCmbYOlM7DG6fpap6hmBi2tn5t4r9+j0uU8Ad1fEuLb3W/KvrT6aYYooppvgf4T/3R4R9AIheOAAAAABJRU5ErkJggg==", nme = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVUSURBVHgB7ZpNUhtXEMe7B1FJ7EXkmHLZqwwVkYg4BdIuS3QCwzIr4ATACcAnCD4B4gTEJ4i8y84jV2zJJaVQdl5QsbKx5Vgzne6RRMmg9zFPIwlX6VdFlcQbzbz/++ju1z0Ac+bMmTPn5oIwQXy/kF28DZsURev8KJ8fViCELBD/9Z7e5s8t/tQGoIDAexa+h0qrFbRhQqQuWERmbsMORPSIv26AGxX08LTxMihDyqQmOBZ6K9rjW+5fzuCYcOdahFRuvnrxGFIiFcErq2t7hHiUltCriHDw8HEaMz6W4Hy+4HeRTsB96SYCEcof3+HBOHvcWfDKw0KB9+kZ8WqGKSKzvUBYqteDFjjggQPf59e2KaLn0xYryDNDpN/jAXcg8Qx/t1rYRKAzmD3tDGEx6UwnEhzvWY+eT8o4JcVleVsvaRErS+mmiBVkebPRTLTarAWHHh2q9iwBbnGgUETCXR73CqQGSgCyy0t3mU20yhcXcg/XfgVLrJY0G4gdNlIniuZ2s1a9M/yPXL6wgeyuRg4Qh5M8MLFbISB/9C2xkiHYHV6qfoEDmw/0FhTIgLOfDsCAneDV9XO1RcZKsxaURrXkfijskwe+50GwEEKl04H2VR/aj7f9KOLrgONugnKzHlSS9wO4H9USGDAKNsyu3OIpC96EKZD7cV0MptodLWCp+efowRpg3sMRHeqaOfp5CzeFUN9XQStYfK4puOB96BQAOOIb2jfEm+gu0ArmAGMbTOiWWIrEQixcYtfjo6kG/ZJGi0OB2l2kilhsdn9PzFfG53AlSqMlrgUk0ND/uNWoVZdhSsSu6T86N8109z3eUZ2o1DPsWcwuTWd2B7QCFhGZZ3nhK3Xf1YKJ1sHAxw78BtOnYrqAPYfSrqgFo8EiIgSTTLapiIMSSf5p4K32rapNKRhNFrEfHs4C7pv22Ryt+ao2pWCT/+Vl04LPEKeMh6AbxVmDykPJGIJ5Xc3sXBwn83XtgC1Vm85o6ffojGZYfPE4SQid0TIZpawpbp0EmY5VKPuvqkFntIyH6S7CVI6Fw6BnEd+juu8awfg3GNHHrROBzBEgG9TkgsEiomE2cj9xzD0lcvm1Q5tc+KKL4PALK8GAIZ1MYy/Hz5D6lQE50OjStkrBcaBuMcuDSsAkRV+miG1AfdbU4IfxKVgwVP7YgZSRyqQk/63LOghP9M0aRp0/EbEc3zRk94DXc9WD0qZkKV0LXr0KR7SduNbM1rn5qlrUX2KAEwFHImzoB5fljX7p5UyT5hHj0cJebVfr5mLjF9JenGVxDCykENCo62vIRsHKLEM/JWquN2HAaVztqGufY4lt9sUYSyuzDCGdSRI9XrahOvPBEZtFHso+m6EiAjywuc7q8MCH7qMR0Us2cwv24/bXwTF39uBa/M3fE2ZFKuCA2JW/aoHVc6xPS5kIt64JItqTWZaPIpqvKfYLa7t8pCl13+FykqxIBpKfsWObEoF1bi1RfXglz2UXvFJ28ei4+fKF1XIy0X9n5Nz6BzwBMshJvMECJOCfizfBN0sP8JN8NeHPd+/d9+/dfVC9uHgzVtpnael+NsLeNrGBQvyl8Tr4AxLg9FLLVVc1BCfY8FmvN9HX8vYdV/S2wJIkM2zjgkaRAQfEiLFoGCGafSht9LsEE0HsCNuTRl1fJVThnOIR0XHVH6aazAtkzzYdxQruOS1GoieJunhTn8Kk4SoHb4+ia7g6YCzBgnSgUQt2sIvFdN/vGCCvP+ByHAukgNMeHkWjEcfKpd77HSDu6xHPSiXJPTpfQnvxg7xQClkiPOWD/PG4Mzpnzpw5cz4n/geYxEgcorbvuAAAAABJRU5ErkJggg==", ime = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGjSURBVHgB7dpPSwJRFAXwczX8h5pto4KgRava9FHCVRGhtGoh1K5N+xZBy0CRkBZFH6bWrUKCoEDUdDSb25N073tvmGEe97eRgXk4ZwYeZy4DCCGEEEIIEQhCQPhkNYfcILXQyYPcmG7fB4iAdWBmUL+avlG/ZXW0WGCQp/74Mb8xqtElfITIOnC/kjn0me9gQN2ro+WGZ7TWVAKWJsy7MMTgHYTMOnDcSGDXSWDXSWDXWQemBL0gRpZgqbjmtbpv6T115/ZVR8xCE9dKJZ3z25QfrV+3hzAU6MtDZ7zgy8NMMjmsqjJ+AS00Avn3hfrPGU3LmqbAApvoVtLn6pKvYMKn42LTa0JTbDctTmILBmSXdp0Edp0Edp0EjgtivMKAdZee05pLz/R6w2k37OisIcJIhX0qNPRb1pR14Plcujf5KqPLWoF9UJ397KbOmo/E0u9247MHQ9aBv6uZA2Y+/T/Sr+YrzY7WE7YV6Vw6CrJLu04Cu04Cu04C67KZSxPRM0IWyVxa9bGx6sQPhbrXQsgimUuXUtF91CKEEEIIIURA/gBq8YENqwvlIAAAAABJRU5ErkJggg==", rme = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANmSURBVHgB7ZhraM5RHMe/7stcZmzkksckFmoNYWQjlmtuiXKbyKWsvJC80oqQVyylpBRvjDe8lZgiUbMXIiH3W8Q2l1yH769z1s6ePec8z//Z/7+9cD71qf9zbv//ec79AB6Px+PxeDwej8fj8XjCZA3CoRNdR9cjBLo64mbTAQjOQDqPltJr9CnSZw7dpb9lA0LAVeGH9DgdYYn/SavoKzqKLqQ94tJMROoVlrzLaS4dC/WnDUkxbyb9ihAop38t7o1LO4heiEuzFcHY4XhfmSPfPoTEUMcHTLbkqTDSVCIY0uPuIliFd9MnCIks2Cscc+TbptPUIDiVSL3Cq+kfBKhwZ0TDMajxL908A8H4mGK6ufQo1CyeMlFVWJDx+4YORviUQc0XWUZYhmEXW8YoKyzdcD7tY4T1pQU0HwFbRiPfe5CepN2N8Bj9ZlhuK8C1LKVDHm2gH/Tvd1DLhYzp7TRbh0tXr6Nn6QH6LIWyR0Kt61PRBsKscA5UN1uE5grH6Dmo9VhavJB+oXdoP7qFLqCL6e0k5U+nPyxx9fS88fs+0iTVWbqI1saF96L3jPS1cR9klvUWzbu6Cthn6RJLXLvM0rJ8XISamK5DjU2TI1BjtYnHxnN8F5bt6GG0A23p0pdpT9oNqnXMssag9d73pfH8OkF5SxB8CQtMW1pYxsx+OhOqdR8ZcZvQehauM57rE5Qn++EiRExYk5ZsByfRq/p3aYI0S+lo/VxgKScbERPmLC2ttpI20vEJ4qUHVOnnKksZN+g4REjY67DMvrbj5Hu0XDo6hCh2WpmW8Ci2mIGJosINlnAZ15noYKKosHTd3wnC5UZjbZK8OYiYKCr8nVZb4uSwHrPE7UHL008kRHVaOmUJHw61dC2DOmjIjUoJPUFnQd2jpUMXhMQw2PfSBUny3nLkFWX5+qWf5daiWOc7ZEm/kU5zlFdsvLvQ9lHJWniKI24G3Mia7NrUy7ublsUKNG9abB8rf/5NqCNnIqrpc/3OXKRBvs5s+0flejYvSRmyJtc4yviMlttQ2aY2WtLKkbM/3QnVIxKleQB1l23FdeuwQr/AxSd6Rn+Ai1VQlZHtZ2+osXpF531hpJOx7Wod2a1dohPoZqjLAKmDHEOr6Wmo87bH4/F4PB6Px+PxeDye/5l/l+v1KYaU8X8AAAAASUVORK5CYII=", sme = "data:image/png;base64,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", ome = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL1SURBVHgB7ZpNiI1RGMf/PgZRYjVDNBdbpcnE7HwksmCnUGKhUZSNMlZcNRspYWZh4SM7mQVjwwIXKVNE+ewqRj4Ss/CtKXQ9z7zvrdvM+3Gec8577nun86tfU7e5z3me9+s857wX8Hg8Ho/H4/FkwwQ0Fs1kW/h3GjlMviMfkl/hkKnkNvI6+YEsk+fJRTCHiztMviQrMf4kT5OtcMA68lVCMl3QYyK5H8GZqyg6SC5ARrSQZxUT2QgZBfIO1Aut9SYyoB3BpauaxD2ow5dwGXrFVl0Fi2wmv2kksVIx/mWYFcueggUmk0cMkjimMMZBg/i1PoMhM8g+wyTKKWMUEEwzNgr+AgPmk48sJPGPnJkwzlELY1T9C01WkG8tJtIRM04TginF1jjDMeOM3JdxdJInEHQ0tlhCDkR8vgHBgeXbZjDMaxm5FcF8LOU9NOjF2CP3grwB/SPfEzNWU8znazTHuQoNOIlrYQDuV7l1rPbeezQTKUHOfY1xdkKTOWQR0Q+b4xqJDEHOFY1xWpEBsxE8/qXJzIWMu8L4l5KC6TwQqnCxJyGnXfC/PCUuh4x+ZAj3vTy/Ss7AAaizVxj7NRxQgiypXsW40yGfm7fAAV2QJfVYMW5RGLcPjuiALDG2OSVmAbJb5XP4HSfw3DwEWcG7UmKeE8bbB8f0QJZg0q5EpzDWE3IKHLMWsiR5NdMSEWch+UMQ5yMcXsq18BP1O2RFd4+KMQ/yp/IO1JF+yJLlrdW28LvcYAwIv6+yg5Ip2yFLmOUl4QXIW9TnqMN9Oxrurf9AXrTUN6jTfRtFCdkW+4lcDANMFg9R3EK28JuIp8gRvAGe1dktIofwSzWdNXKa3cgxZ2C3WJ01t1NWw16xF5G8s5oLeDHxAObF8p7ZJDQI62FW7CE0ILchL/QXuRsNCvfJkgUFv0M2airywCakt5s8jfE2Ue4fTqosRfSyj9eyRXIWHOLqZ0vcwvJ7ogL5G8HPjPg9VQUej8fj8Xg8nnHCf0mlVkcZo3SnAAAAAElFTkSuQmCC", ame = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALjSURBVHgB7ZqBbdswEEU/ig7gbnAbNCNwg2aDcIOmE0SeoO4E9gbtBsoGTieQN4g3aHUQD6RFUlYBs9EpfMCByZkE9HXk8UgbqFQqlUpFuO+t663tbYOV8723P4GxcMIK4Uj+xCDytTfTW4OViqbejhjEHXEpbgcv+g4rgDCIYVG7wB+KO8BH/h6KIXixTeBvna8NfAf4df0AhRDSYoHLpBVGehf4DZRB8NN0jKznFnGykuirnNostst8lkpQBJ/AhA0UZfAOecEp9hgEW/c/ufFHKEH23TkQ4uiOX8DikSREM/qmxP3rDHlzHjEvARHi6FqkM/yiYaH80I9X+uWiO3d2LAaL4aH3E30I+ehOjVskFrGYMauJLsN7qFROqXMvIR/dX1BKi3ypKNFtAl8HpaWl0CA+KDB3iM/CFvlyVA0ijEXsA3tFPrqqBUu1lTNy/WzGrwqL4eFZtAlMXkK47Uh0U8fGm/MR5TGu/QxfeW1d+xVDRE+9vbjPVd5m8kPLWh2bRJfgo2vh628LpRB8TR2uZ/bzC3nC5V4sfS0UY5CObhv4rPNJ/d1AMYR0BpaId4m+exTkA/4fBwzJiZFMvA0+P7v2ExQjxUdu3zWj/lN3YSqQmjk8EIT7rhn15zsstdUWIRZm4UvIlOAD8iesm1ByDT+59tlZ6PuRGSPrWJ1gQlxVWec/wCevMeIvVl6WEmwwROmEOLrbiXEn1xIKUUrwWBz/Txim8mli3ItrCYqwuCwqCP6emZxPykgzGitXQ8WKjxIR/uJaie4D4ujmktLZ9VH1BXlYPBDSxUSD/P3VEQWLjxIRfu7tm/ub1y5Hc5yozhPjf8OfqFQh6zEVLYt8hOXXPgRlGKRvLRl+GamvYXjtyhIgKINFSd3c4voUJazgbprgRXAy2szod+0LuMXDIuWGIzVVCfkfwagm/CEaOR9hpWKFBl60wcrFClJWijV4B/D2w0lMfYKqVCqVyi35CyhFHGoJeaHeAAAAAElFTkSuQmCC", cme = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKWSURBVHgB7ZrxddMwEMY/eAzQEbQB2QCxQTdAG1AmsDcoGzQbkA3sDRImsDdINigWsaEPLOm7WpLdVr/37o8olzt9J1mRLQOFQqFQKGyGd8iLGu0p/WivAj3Y/WDHwc6DPXqsGX01Xhg3g1UIC/RZN5jB/7Nhc3zFMqEu4ZtD4TolHxNZhw2N9hfEHVWX2Ry3WJkK6YX+axVWYg2xk90hM7eQd7IZO6rx9/9Yj20/nhFPIxMK10VEIlSRcfeCuGdkWsgaQadqyKkhK2ZSDNKKnagFeQwS0pGd6LCcJmOuWQz4qmssRwvyGSTgSCZvEA92lGPm/M0O61T7TpBXMwHfg0OypWsRj73AVzNOH8DxifQ7wX8zb28dbfE+jp9/DnYY7OLwv4zxFMKwfaRgp9XBE0Nj/iajg38G7cncZ0RCcv3WjhiK6OzO8dtakF8hAHMN34Cnd7Q3COe4F8acYxdyYAQr8FwcnVAIo0F0OEBwcNhVmmVOsALPnOAeEYkteA7JJXFBYmILVjNtJ/D0M22SggVhBC+tuhXcEn495osTY9H8AyNYMkLK0f4N/sLZ7z4LY7riRIF9KvngiaExf3tp23yrs+TxTxB2a3kCt1f1+bS4jqL12T2J69taWhQ4WkSkBl/lmIuMEuStmYDsKt2CxyAeWuB7QGQacJUObSMldGTOIxJgwE8vjeVoQT6DRLAVjzHKbK4OCTHgq17h+VSCPAaJaZBWtERsjJkUREF2PPoA/qhFUswOmY5aLBp8xyazOybXYZpE6GTZz4olj1BjW42VqPGGxE7YqZXrlQeDjaAgOzOWWoONvsJkEFe4HdXsrzdIUVgu3AqtEfnxTg70YN8R/tuxAo+jr0ZCysulhUKhUCisxy8ilCIokEEQogAAAABJRU5ErkJggg==", lme = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUmSURBVHgB7VZ/UJN1GP+824ChQwVjgfxQMFzCPKGBUQIHpidB/sSkpKzzzjqt0/rDSruKyzzrvLrKjDsvTY1Su1NEUbsDhdLDMUVRRBQBXUvBMWDyc3N732/PppvbZBxSd/2Rz93nDp7v93k+z7Pn8z7vCzyy/8C4gZwmk2nSkasnP1xRuilbYMwPw7RxsmBJ5es/VFxsadh0dEdRRX5+vuB6LvEMUG7OSaw1NO1NjVJFy6WBuNXfgeGa6nEFRvhKM49eq0r5cfSZd8m1jcAc5yLXy+Ffvejfaur+qUJ7NjrQPwAJcgUY1TocCITUiHjc4S3Q/FUn67OaN8k3ZE5x5XMjN1mN08CY4sS1cxCLxEgdH09Z2LDgL/LFtHAlbna1ocGgJR/GMB/ry17JOR5R4Bl39tYVZug1Im1Cgs1LnbCHhiIwAtFB41DWrEGnqcfuEwQW4pXcpgYSGHrNJq7iWjWLDgpD1KhQu+9hMVeRBqnEDwcv/e70MQZ4JecF3j4vWxV7a0s5ESfCnCdT73Uz9HmLOTHmxqahtcsAzY16e767OmDeycW8TYvMjjMUdL3jJnImz8AIsZ/TPxQox05A5OhQHG8+DbPljtMvGqxzEUlURNXZ0NPXg7JGDSaODYcqROH0DwULYjOoWYbfLldCzOD0c4KAQWfuEIxAFw9erICvxAcL4tIh8EMT2kgff8yOSYbO2Aq19oLH+SCdg4fbZY2uDlfbtMimuct8pUMinxmVhImPRWJ39REYem+7nXkq7gFyji44wPNW7Dh9CMEBQVgYm2732QJkpGIx49zu2iCmx/KtlMX2xVJI5A6/lJOQbnzvbh4X81ivttbd133RhWOUMBfz4jLQoNdi3azlUIZMhJZ+1oKTe1F0sRxWgbffTY5QIiFsMvZTTAspfbTfSLz5zCIsScyCzG8E6lubkLJeNXDnG7PfwQRSKaMKHdB3d+CL0m0ov6pB4asbER+mQG1rI8JGyfFtzgf4dPYK+FAaH3q8VqUtgdl6B9vVRRgrDcDmnLV4f9Yyu6+xTYek8UrvnS9/diFmKp7G0l3rqMpmOGTYZzbhywVr0HJbj5d+/gTVuksIHRWMLbnrKCaHliKP41c0yIhJwr7zpWjW67Az7zMkR03FTnUxPjq8Bf0WE2KCI93Ixa7/pOdlx08ZFzN/xqQkXG+/AZPFjGVUUH7WSrT1dqKw6hCeUySj7PIpdNHKrGg4jcTxcZijzECAdCT215ThRGM1Nsxd5SRee+BrWEgDtmG29xhr+it1xQOSH5HWxeu7O+dnKVORl/QC3khZhHTqpqldh7zt7+H52FTkqjIRLAuEuqkGxv4unNVeQnhgCDJjp2N69FNYlDALclkQvv9jD9aXFMBKor2/gLia/lP3yd0FxwvYdaqYEtZhcWImIgJDcV53GYWaEhho9usPFyA8KASvJc+DKjKORKXHVNJAlbYWq3/9HGkxKhqBgAPnjuFYvRour+57xrzP3PYkMAq+8GeDHfa7LuJvNbZjydY1WD3zFeQmZSFsjBw3SAfl9VXYrS7BL5WH7gYM+H0EeB54dE7HHBusWPSZ+rCxZCsKyvfY31rt9Oq1WC0uqdmDDTtTuW8ZN3JmEVqYRMQGq91hnd1deFijLXfLK/kYgVd3CFwTsT+Bf996qK99rg63JdO8tfq2L4eV9PYxeq7OfwL6kjBLGPexYbOm2iu5zfTfqctEjM2mP4spqI/ki2GDwUqoonxL35ZnfmP7IsMj+1/b3/6hsR3WE1YJAAAAAElFTkSuQmCC", dme = "data:font/woff2;base64,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", ume = "data:font/woff2;base64,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", hme = "data:font/woff2;base64,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", gme = "data:font/woff2;base64,d09GMgABAAAAAOhoABEAAAACzAAAAOgCAAICDAAAAAAAAAAAAAAAAAAAAAAAAAAAGoJUG4LuMhyZHgZgAJRGCEoJgnMREAqG8nCGoi4BNgIkA5xQC44qAAQgBZMSB7x/DINGW2WbkgzfO+7e1WrJ1wDD6CkmeTZGgc9z/QOiXrcc0HMTgWpLn8gT6LZ9iFbmtgH8b6tTnEL2/////////7JkEmOa3MMlzwMCgKCCYNVa13XbhMjMIIXisUhlShVrlygUHqI7TRqKuVh9MHGKg7Zz0MtgtSQx8Q4WzM0hjsjsyFIosTZVU5lDEpKQzG4K6FI/6xh+wgw94y7B8QIXokhIIaIQscbzKlU/XKUodK+2/I2V7LeDS/VRobGGA2bwIAy4J/B4yJNqP5scgX3WF+C3c1R1L4ZISB01E0wyyQbu1xZN+JCf4amGl1rSiEpJKAqB6btmBl/qDrbLp7o8YztsYD1lGMMjfp/aq1TyuYCXKuGLkAxn8DAQrCf8xszPXUXKmbH5lYCb/hb339CwRXHgFuJgqUEl53Hct5MqGsj8PGvYTOUdeNEPwJtI9aMbnIgSvEH7I+X+Q3WE02wwEX1cCwecaZqrmBjBw8SqNSzpv2rKcdGiKodUj1IVVdntoyrghfBF+A8zm6h7XQP2w1UP4jDOxY4927+WxZ6Tpb7xP6Hr1lYGFtqoFirPJsqh3/T0fURfkxRgm9+eXRfa7AS+ygUYtvzEsocxxUUa1Qa/ccLMZK7k66hNLChln7J4BF8Jhxx1+MPRySwnLwEFjs2BGpIpjct2JLmS9KbP80v0fH/I/1f3OkmuoOkD5Jk5kvwBZP88r5t/7n0vySMJIYEQsiAbQwiQEAgJayiVNUoZSze4cWyqoCC24sZNFeco4uYj4lg4Nlq0aC117A/bL3X1PasltdyWZNnThvH+r5nFY4gIQ6LwkuSCKAWAKuCBcWUsK22N+SoEPOw2eJ53zlq+73MiUrILsDmSiWfSgzOsdOKIFdXiRSwtltEOyiS314lKJUGzW+B6r5paKuHpv4u3mwB1OIADBRbhSMMC9uwu+0+E6vgTHFTZutyhrIGoWCN7Zh9CwsYRWERPaJE9ChPnYuMs+9T9uV+5y6pT4W5e/W4W1IEqcHJAsjPJD9EHOqmqgBvAGzz8fG36//fcxWL/d7bV3fsm0i+WJ8YVo72/JKXEWpo0UpoUSAgE6SAzwDBKBmhuvWwjHEptwKoYLGB5W7O4RbKxYGMBY8AACUm7X9FXwUTFaHzfeuuNfDNe38h/41+sT1CFLS/KWmA8n06W7P2Fu7YdCDQSr5AolCAEKGLXNmehl1gC9vRO0Hm8UNOkYtQ2n8+5L3FMATFjiiCmAQM4JsiKoID/b8zVXoiv3/L66pr+ivIWdfooYEXRUll1yU4BYESFbff0cFWIfgxSaC9v34ncFBKnCzj0BSl06/85taQZ5s/oEwbkL1aw7GzOOlxfUYIkJ+wsySHpcYHa4FiU1zVXdyqAfwrqtp+HiSSYUYCRBgDFzTd+/6dq1S9UoWBcASBQAAoF42hFkBQpijIttVH3bK9Rn/OKztgOknvT7+7lM0E2fSbfCc+5zPbL1wXZ2Xynn/u91Q188zvSF43YdX5IIh4KS+ErpjPwzRGRAIgAN5ny7wU0hPYWpOJj0y21RLzKEzTl2fchwmk5knxa37p805eW2nECcFBjwSEEzv2/U/sZyU7OmZHixRRT4IQLyHPv2FLIUVv3rR/xkvMr/xYxBaaU1eZwbfuQqJT4JkjJotOT7TFPkcilTkN9GQI0DS+ZR+Gy9tREhpBq6vVozurZ1j5LRk2awNl7e7WHFN4gbQqYhjvJPqCF1xwYvk1ABj78xRZodIKn4ReMvFPfm7Q6VFIVdBriPhe+2DlmEJFxnh7SUzTUpqKwocWg7DzYcsPQpupCCsyfd6fmdgt5KZtic+WnCnRNgwGABgQgEPj3plql/dDsESmJtezhao3Hep3n2ZSSRjqn3TMusz7tfv93f/x+/dEkAUoCWhA0BNdAkFYCIe0Mh2PQDUADgJCGY9ZIWuONSI12V6s5M8ZqjYvOmWydD+98dj4IXcYNL70kvSTxQXTx1WXpxcFWfkF0lR9hcCI3Zw0NeEC0BZ8H/nV92r67ax1L4aly3PmFbVbR2Vy2M/paeKMvA49nJ8Bv4ST/bKaQCScMbSrALpVl/uYfICi69IWToqjj/2dqnyluPRSaI9/CtBhKOC1ng6wH5FDGfa1c+nc3Scjqh65tVD+WNB87azBYyLg5Rtayuhok3MzXcu18jYxxuXOZMoUuSBSEOooT/mylINogFs/TL9/ZvJxQV715CollFcK1X4RC+cy6v5dSisqsyqzQ0IWMshiFkKVbxmMc8Py3rD2yi353Y5WYRIpC46tH4lbiMLJ3uqomvs1Nmmng53A8iwppPg7JF2qN+OHvbZrt7hHKYXRS4fRH1GVS9CnKp9Xa3tVaX2vIWXBydCw4WFkHKxMKD1g+YFpRrGMDB5icC0IFBFVSc1tjlaLtMrFqatFbtfqsjwGGRGhPGRAxfJ6ftX3rjzBEmgC12IipDj2BT4C7tCBMoNUBQdA8gRaFeS4v9NC3Gf+fdZqviRNIM8ggrog0Bo8brt/E/PxvBN89EpoQgllc1Qh30M5OBzGowgjhpld671W/i97/fz1D5v5CtogtrsgdEXlj9GullVbKUkopcz6RW9asJtRZ7QQNijTr3t2v1GHM1ZNnXWtJdeAEBQRliOPG/P+HqTVy0qTTxOO9uk7ejJ3YlqwLJJBAgPjcIt3j2Kv2Lc7rl9v7upTXvM1xk6zSQKIMMCNAxaQ2I0DPHfMs+K+ij891srT0EA1cS4BDwP/GLDOSHYTHH9LsEqwldoAijAyKIioommigaKOFoo8BindioMQlA0p2cqEU5BqUm7kH5UHeQ/mYHih9GYDwDWFNiB47xIAT4k0UEkAZEkoVEk4TEgkMiWYMiWcPSeQMSeENyeALyRQMyRUJGSEaMkpVyDi1IZO0hsw2JqRMWUg1SUiNzpA6aMgu8pD9lCFHYCENboc0eRxy26eQZ/CQv5Ehr1Eh/9GHFHbCJwExSVOAmMkzHwEBBxkbgLnu9fH9hH+f2ZWfKB9a0MSJAQlYgwyw882NQei48M1ugQHEt04gAOpkAWO8WUOgTkSywXzI/ao4Cb6HFmm4xH/6j4JOso1VotT4J3c5EBBukNrhJZf3DQ2bC1eezDCwy/tKxdbSO1Q/oqs0GkggL7s0r37Vj9Wv+TD+hgNOz+i/wvwxrfmQro5vw7iMdk5P47RM6zyc9m34lrpN3ebtuO5YdravNu5ieuzurrVPaz/W+taZDP2e/1723q71T+s9Ga5Iyr64EquiRupH2TuxR/fkntHzelG39UBfHfFjz/DNkfPYfLpWLH1NXNV7zm5uZ9+4Dt2vPMZjDY7hLFpwBS/wB36gjzhTmSvz5Il5cp4rT8/z5gXywhnLdOZzPG/wFh/xN34kwhQRES8j2ciTnOWLAAQkGKGJQBir9mT/LcmuZJlNklSWKirqdaQbfdKzflGAghSjNBWoWJtUpgrF9OlZnugwGY2FjmbH1HhqXB0fim8kZIFeYBbcyJbkatGhIrpILjKK3GJkMb4kay9ni/OLZni7wPiKif7Y/+4298Gq9qFufDyhXU9Mp1etm6dbvnTuR1Svs2rSWV3SDd3TI73QG33Y2cxbH7pnHkKPW+fYiz79PJjz7+Phk+O9/SU3rXqT3P/d9Zn6af7mmEu+D3/gb92fXP/+ZmgFRlxwI8ONgm1UbKNhEx1ujMsLyyE2GziFlD1zuVWHSofKQhWpleGqYLVfGpSRyQSYURZ+ViZanI3JweRkcgWYDnfEM+I95xthD/PjLPBxWe/8WNCSwUBZoDxcgdRIAxn1M7NYUTRk43HwOCluyKODPTAhva2OJMMZ7RrMKxUdgDaCP3d68/ZVpdXrmoAxZIqYFyw9WmM0W7KfsmPFeR53sTAFd8Kjwz4/X2zSq8nWeiVcqNfo/LzT8ryKvtGcrsqsZtXAzcu2QBZaark154+8n/QHk92KkWIiCk4Wkm1O9s75x3U9xtS5azwHvB/xNbCH0+MsxsdltfNje7VZi9fWIm/TC/Y/yL5YAjNrSgfLWjnfWG7szgLeye8wQitw6nU7xQE51111TM0K3Z/o/iNyuqnrNe0Hp2ap5Ys15MFpd8qxHl/3AWQV7rbEGk8faQDLmpRntWI6X+eX9VzjVoo9hiEutUqt6zkaCVDZeOYZQihStG4fl8UpDAbNc+c0Om1My9qC9RYWGM6Hnm7tmW3YAntGLhlzUMmp4TDqMIl5bvG26gWoiscOcgIuNmbb4FPnDb6ZBXAtB5u8lOuJk6ewKqQcU/Il7T92AyiBHFDfO4zj04S5eJIIQhakDFUQ3kD4CQrW3UGsvXoADDgEF/i3hIT4NBRhkJKUhM3/fhUXXkfsI1eoUSH4oBCWTM0gg6ml6ARMwDHQm4IhqGnPy2d/A/KYdAhtU5iK0s1Twbiv5+nutkrvVrs1MefdcuXJV6AwFFXCtGnXofP2Ch+0yfHp/fmkvzUZs2ncTW2e+BYwt5C0tFo+Pfqqr35sfW5juIhEoss8erGINDsP2SRv5rwrzw7D9+GdVGBjybwG06HxNn8JA+pOK/Fe3oBeytVt6AIQNeA/DUnBZnt286gtpAAZ0OP4woSR+BSSklMUigXnR1R24hsbG6fxFbqQQnvcObMn8nn+OihCnFrQlbrPqcf1JvlNePN91qbwnSW7JhTO6uSdZ/mFVf0I0AF+IbgFOgT7lOqpeMwkuoDEpCT0/KNjR3AUAZAxqpMo8avtr4aV3YljfvKnft10d7svRH6ul+hWEVsd1mzZ/WCxevr2Irh99Xx5v2a2PHp2Gh20bGKmZvEYOa3PIyubr1yFSmJVqtWoVadeA4lGTZq1aNWmXYdOCClZ9DTn5QvsGczrgRIglQ5T47gwHcOpaiKVEXJSoVSpQ7Nn0Z5d8BPArHTS/r2E4c8utbS0tLS0utaoTSySza1zIlyR4IL8oS+/LBLNSi1sFj0qQCpt4nErb7FA4YJL9IcjcZqmaYQQQqijpsAwbMX0T7x99FVpVMB9lr+7T2NhUZYXdwFS6TAjteUpdwAA5iSqbdv24hcGabRT22Pf6s24g/vwcIY0Ztzw7q00mqZpmj6jLlEYuUwHK7WiqePX0uYot7f32tBpQjWj4l6Lmfwuqy83DAOZdcxIlqaYerrXdUVml7B5SVW8ulPjp1/H3eyBcczUZb5m6bLO6GjrsycHyTn+c10oBuPm8ABecT4O9gE9XI7/+HGwZ5K1GV6DRaWeySMVApfIPFHJV/ngKqmZd112Axj5mRJWfjSHjZ+94DADLv6VxCXHknNJVnIpCSqIoasCx2GfXDR2GEKxwebIKabhS/ezDL/IlCU7FnExITau93sf+NBHPvaJT33mc1/40le+9o1vfed7P/jRT372i1/95nd/+NNf/vaPf/0X/q8GNAxiOR4LWqITJVlPyYojAScWVgECBQkWIlSYcBEiRRlqmGg/GS5GrDjxEkLiKA90GhwSvMR+b2YKflxZuLCSGkFrZIqjSY3tJmPqziAzeJhFvZybSlrLQtUZIiKJOw+evBgY62noFXKtiJgkSknrzIWMnIKyHTNc9rcW9gdFu0h1D8kRiZyQGOOUEnIzsM3CPqBQG5Qdu9d7s1lVBrrx0CnzmYc1d7ElrTV68G5fm1XStuu+3xuBLqeV65dbjq7XQS+b9LppNRs2T+epzet8gT2DWZdmm2NunLdnvgUWWmRxWHKXBv9X3ntj+zroDJycrimLWfh8Wdncf52quKui+q4m6nrUzYgxsPRFyhFxIB7Qk6V6HWAf4GfBIYP6Yn3Rh2b8jGWDxaXrWaQcGvJs1YyDrDGLETAVzH1uNeXVqBNuRfSGfN+OPeDjtMBU//femZe9ef+3vzcb/sA/3Q9L/b/3xVjPQUGTqqbdLJeQQCnOnfbKN2oaWrqInyLiyNCkqae3LznTmE24avwOltDr4fz9VHh1XhMCCOAMRIBL/CUhLn6ti3QgS9LdUQy2oSLhuwhbUdtBvj1m1UanztxuPucdF8QAbvGsvOl0Ao7Tiod5HJvL2jSMNpKxFavWrNuoFz1uszfbshP3sPaHB+wmvKbdLB3u05HicbRTpb/9+8tU9arpmqw7rHusB4x/6Zw8XSDLpo5gIIz0Y07eTtnJIWb8UAP/TPipiDn/dUjAeNyVYwdOxE6zPF9a3JTUU7LHXJY8+al4N6zuaCO1o0MnhLQuo3Rz9OitD6auNlxbYp+Rn++euof78UHp4fDV0ptD33pWX9FASxfxY0QePjByyqOxMYzXqYbJpamVEWp9R44uW+fwEblWQqEB3xDlZnru9hKZI9wqwqPxAgt5hc6jE8aIUy81Y3D0Bhy8yMGTYPOFY72sgGvNzsY/5QeFYDY+v3if7UDnzB6hBawS+Kc+p0inm/3AXeB2J0HP2+54/2veyOIVDaoqq5c1EQAHduACbY1cVcKnynbcdKQXTrM5ZYln6xytlW2snoC8l/QEfDkJCPzmTsxzfwd96Wh0wQ07+PTFrDfOc+vigqbuMH8BAfgG/zkhJn6ZSjjzhO4fCfsOFYU6Z1Y24cxieVBd692uZW3Lu2uY2QhjK1atWbfRCF7eTGmLvB1up9vNe4x9hgf6JsgUs3R4SkcaHjfvJK9TOWv9bH1EZRaRO9K9hYdfO16L/yVgCTwRuBDUt6kheC4pi6UD688Cv3RoH/+N8NBfdVGR2IhS+CZswkVJjgqLH0toSbSYdCk5pYwkuku5kZRn8mNBX+H3VkyqbsgMMaWO9vTj5PVB0tV918axp+5E7obuJfeHr4S9qfuwSx/xydf0jaxm00BLF3Euoj4ibJQ0ZnxJpixIk0pTivqIoY2qigjx+EvKHlch/U2NFTRqp3n+r+YsRjtBwpVEj1lvZKv/0eRJ72XRcqKiNypDiFriFX7rCEAC3wzkY8Ha+MeEHLG6kjvpS/SBopWK43mnSzXQ14t4CDy7ZOWgSTaCfQaAC4rpye08j+SN+B4esocKBj+yV+HEsi4DihUwEa8iO90hrJe9qod/PR6KH2RcFL7kMv3JWFgeb9hdIze2YtWadRtxQjeLx+FOm6qfrep5V1u8Nf9bRRhLBfQEPjwM2udNA1uVQjxDfQfWBJ9TQjwlWky6lZxSRsq0lCXZcmLuw8M8+bFgqzBXD9SjgSQ104hRluulHOmKIl4iop3g/Ou7LjBvua952rz7fF3sQT/OIj0uuzg/1uq1ia6ZboPHmgQPIqIQUOznaaulEAPV41oSMIkxqZCcUpApK2UjJ+bi8uQ3kJDq19QgEs2UrkR1i4Y26EYbyfCGsUbJ2IpVa9Zt1Atue121Hw+aNTE1O3oS7QyXarBK19WwbtfsdxdN9woPbVzVYNKb0EJvtnx+nk2Qo1yCI3EnhCmfeOr0nMSnVB3Xoi21uw6dS+SWtalrn7p76jG9WeFXr+7yG65vyuoTGtHStbCw6BnZ59GnxmQ8Th6ZqhtbTH1mlrp1iL5ieyz7IccbzjOlJMmdNvaBPC7B71bFstoKH3DJakT9sWtQAibwU91uGtBOHdpELongLloXeMO0Mq7K27fYQ3uchYSETnonC1l9XIFUzAZR9Na0d7KS8lqWx5VAKw/vrkNd2Rqew+VlOa/e9lKTBQJNA4SCPhCs+50WEFpL+MZ2JjLuB8fVfbiwsgtGF5Xup69EoVsKXriXzyMsFL+k70rPVX66WlcTNRvACui5CXgkaAq2FF8SXrWQiGFdG4UNMUH4OcKPUNwAeS1mIZQMD50qBj2XWk4U2IMMecXKFewFLPIbYbk1BW7AGDw3gHgXliUGvil3TwISghOHBaBgXbvk+01MrHI5VVtF9UAU9P8NvHV7U3Ha18Fq8jZdzd7mX+XT37t/d83fne71QAKJJJFCaknnZzLIJIsccskPYBvJqIAxhrGBZDwTWDyqxt6xb+wfxznBn9RzkgZOcZqz5Vw5X5q4SDOXaOEyV7gaK9zkFne5x4PYb4/bk/a0PbtOrrM4j4u4jCs6eM0b3sZjPPGE7iG8uHvcdNyvkGREeteCwERY4E0W4icGb+pzqsfXI0G5EtsMQCYJs3IzsxQcnEMsmumI8H0+oMrBKetoAisLvaObZ+OSKZ7MY92SsZZ2AxNgIX1bjuFKr6xp8a61EpPAf9Y7Xzbsi43c2IpVa9Zt5KK/t2m24nYXfcEm1rOzphTNIrLJRbJfsCD9B148M2oQ6hfKtScS77f5/xzgmXV/7lfbHfwrAb8n8O8F/Yv1a9qAjXnT79rc0xbS1nPaphz8d0LGMPSfhO2AFLf/vR1x56/YlXYT9/yTvfbFA//i4N7hP3Tob/FfCk9FrESdifUs/Nr5eRjfkFCXSD3lt6X+uTTpRDL2lvldWV/Ifibn9+T+vbwkf1jwWOG/KImkUpQpV6FyKP4n1b+rxtSmOur1X2j4PZLUSGoiNZNaYrltR7t06IzIf5Bm2d/rOg27P9bzK3pJfTcZ/UsXe71/SM6lGCp/z9W/dU3j2C+6c+Zu6l5yPz5YeRg/nPnok69D8g61Sz+SgQamH8v68NCmzaENab7pp37kR77jR77mR77Zf4dvTbJmPrnPbrxDoVA8ouh47c35+37UaUSbtuzkvcz2fXiQ3qRx026WD6MdEY9FTltU4jKZO008gj8AAfVNpK2EkHmoHSyT2cg7u/bMjcQ7lCJ2OSoV6ycLzsW9w4DhscyJQ6fX5flEFnICIdEkSZaSRZhMyZItpy6eqybVayBJzdRb5toS7Tp0RuQ9ab1rrrurR29dIU5JuBKvxq7dGkupgDtdRabUX537kProk6/pm2X1Oxpo6cbxM0TLcGbklEcPjWE8Tp6bivqU4aGNp0wB85IltWamCoI52yeHOFuE+3Gx57Ka8sqKplVV1akUypXKhNGop/1KEWxNgVJ0mNuqKrsbI7c+TAbzpwrWWPbyGbcXZTvXc4lMh+3sFgh/hRexxsr6WY+BnYWNF9Pqrb/KGpenOyaPdp7TZWpzKoCu0rdtRKqE4er6T3I3Ol6Y0Y2ZAsHJT8khhSf09AocR+DICepEF+9iUeHEaULsIK+vjGzRKY4odMpK6XMGUb/xaTZFxRf0L3h9wZPi8nKe7+PEmVc0Cs0LphdLtY8oOskDPnjqfcjKeQVAhlVARrdXlj8WFIY7e+FbhC/IB4Wl69Io6u1rFq++Ou1g4DaxA5RIHtwQVAIyeNUiDsG72KYXed1+kjkO+BkeHoITwTk4c3ivL3EFw04gKmx4VGhiCnQ2ryxJvregKIpDObxPrmEf8KKwsbdg6acHNTxAAbwFxeAUv+2rbnkiW8A0tuKaY/rc3hoFvqyIpa+Kmg7INsNtYSfu1W1/eNAHTXratJvlw3BHxGOh01YHmLq6x7r8SX8pBcjWBsa6kKzcblDYCkTa2baHVv5R8pgU97KJVvqdeoru5JJIyU4kU5ZsOXVxqJ7UQKK53hJqW2nXofMuUg+y2Wxd8qIkRaKopyRJTonqlzS0dEv8sVVvZP5uJeljnQEy2WIAEAjYlp09HYyGtN8cg0xgiUrmpfpdmpwfuovkTSC02weCUVAk82F4HWGiSuYMTHKKEZwSlODao5F5bHpbXwIaTLj20QWDvruJeDeAHVOh8HuEt+nCXs2yN+1s4Bx7NbeD1sNCkG5DDPmgriagAZxTNiVZEaa4TNjkFU8sqAQD1k2q3sRNC+8YTgDbaDZrSemm/Dq0UQNy16O5d1vpJraybYNAtBp00vaUYol4Qbx0fBHJEkUIZlSJCegoi6fySGBMY8sho2hMcpYVnVmQouryVtEFfbhkiyQR4bzeT0wze+5DiPuwXRotrkJbgW1q5Mv82mQ3PtpvVulwi2iT8Q9FitXF0aTpZ+1ty5jk6hyQnKBevaXPpHe7IIm6vSCJ845FFrs2LvEEfBHcsl01jm/EnwFOyapYvbfzFW8le2eCNm+VA9eCGojdwX7rI1SYDkfwLmRzEGlZiLu17gQa7YdzOtHWZH7vafN96tBwrCJBu2jvEy3nf3B/lwUawvaccHWwNVzbkE12IicdQDVjpw0QBB6PQHD8tkT3eBAyTMNfRapCx7rhlThzTrZzLe+gyrZPSp5hVobVYEopp+Ytde/oZhPhzPShpzBPwx8h/sdOI7kwPLx8gS2PUx63Or/bL0kWZeDMD7KCm/KgAQGv5NFBW3fB02vrwlr7aBNwJTbejsyV7OM2fCA7lIt2gya26VGtBKLVoJO2xzzWCRMA6gSc3qtxA8HsemIHknqsi8QpXroyYHifZ8UXyKqwVR610umsbKOeThBxtxaaIWxrP/ECBesPbQV6GvHiHZmCU419OI1mEsVJ0zQ1XKfAU9V22pZxTJX30JVbND3Rh8IHQLgnfBBXzsSgD3drHZ4lFutTW4yhDLhSI/o2oaSBjtnHZWF/TulVa2/WSoP0iuq9FrFm4nI7N4I6NAKHCLwCQtxJx2Vx8WAdMdtveP1wG0oO0uHRbQdM3McgdyXn11YiZY3G5Mrbx7WNa6Tu9toJL8L3+AmQ4P7bRmsBwcBpa9/XrsWY7UIFgjZ0Cmh4ELSQxxNO/9OqZtl02JsAnSpygkeyGD/X1YdxNmnsAr6CoPV2KOfhyzR/l2/Rwo0g7gWg0F1BZG3XhnnwvlvOGGLRpUcjZwC/oSoJQzhxl2Ivz1nOyHYcOv0zVjwJsLbJyqUPCXA0SXz98ENQXgNP4vS13U88Wo6q1BLQJuBwtXd0bHyGApQeP0/nhs+cIksavnRC7do8EK8mxDcejCIsKyIAaMXTJZnm75cPsnJl9q252WjWKFCsEPzjepa8HBrfoTL+QyTq2thI26i5xAEElvzwu17dm2GoagbsNc1FNoP5O7iqzKNX3h2CR7xj1IDu3TG4VtLOK2UVkhAsw0jnplBi1fGxAatXhjR0NXIJYCs3g1WaN67HKbXYaCdHlJSicr91jkBZCRq+8bddkOnZNo1qJSu5k+d3kXUOY0jcJc07Vtl2e88C2dLlkO5UMuKv94rZtKXu41QyYwuaKUA2dq8on7/TpYGBoufFDyTq8XAmdD2v8YrTKwjwhhcpM7qkjaqPqPe4EzlAaRoMSG+hpfTy9LspS+SGrSq8BLZt2w+1rfWtnfD+LEW4hfOGfNZaQJDeqFRdNydIBlU+cHxIqI6a0D5lmAyH2WSiXHDB9X6jKdlSteNcq9sdAefRylnsRsoqBSHz/pkY0rpzEgUYT0yJC9Mzha12NZBYPDtybnMZhtw/KcuSGW42lBiA9aBeOs6wQ6BnABoZTZJcD7c6MXrzNG5wme5OFZR2E7C8tgCeJp2T9n2oldoeJ2DVOzqtd+r5KwaNsUzo7jciISZkrrXNueAUMN+y6jcfT9zSc14scoYPNXb77K56igObVn+kqwpynKhMd8k7tO5VgW/hC4krXZT4uIaDGt+7qnQ96uuLjquxpr28unI1MBmAcd/MHSMJmA6EsiNmyp7IlcCOds4/qyEVSPzYqmzN8+/7O0cfRb82D5WYFTD5fVfFVpXP7rRMT5/zms7r9/6sH4i7r16Iq16Plg+evJWtPGKVk4rt/tNMe1MWboeOmx2eHEacXgI83HM9cWfl5kv3pAsX5F/kiZ7rQH/4t1BiQDwP8oprslEfx5Gu0FnVRp0NUwg0DVXB0fBGb4xHOFXLO3kpmaiSEn1CyC1XR7qrsDunBXAre65sv084kPC33qqqAiDqC0AW96JnFG47JF+Iyp6ghM/9jxpSZcj7eMLfMljaWUi2bwjaA8/RgZJWRrrRKh9rz5iWtxOoBGc5kDZdAHVrWjH91ERMC3AKo3mmmsYZOCg2DDC8N4EKs/ESGKShEWt/b3za3zsL2v1ArHKAZw/AmTZ7c5XOxguunHv7X5nCDj2wyafRC1CpsrtFHWrE4pZAOq2pAeMRfQ+H2itWgVoo7szFzDaQ9agwxUUN3znUnAgjVLkohO89ocq31QWOzuaqyMD8kHKKE/ksokV820j8SHsKNL+F6pOJtxSZw5yaMcZmisOAQdZOnKuXd/FqQi2MQK2mAyDU7CoppwE+WU3mFQsgZooArRukm4LDS53LXiYWcCzKVDrZghW4rZn5tKZiYbtlR7TSnDTr+qW918B/oNleY7yW3jT0+WLqY7tma/poXP+iD3ebd4ydYIeMe6+mPzpo9GFpuUC3EKXgGeKHFeJmRwpUKOQFpGILhI3u+e2T2+bHQIwxMeubpNsllWAqydoj+uhpbpJWNw8kLg+cxSlg3YNuVYPQYwXhR9Wua0zo0Gv8P+8t/lm8lbF8ZAUvxF56+hgGD/3rzZ5R76p5GhuvnQgGTOcT7Hdha+YLHEYErI8NL1vN5bbj464uHKFex1QtbxDb58pifrUYg8ogPRN1pWsfp/yxEXhIgMYXXpqi4C/E4Wf2pQfRRgeci92LYAN0uXySd+88Oeq0Gia3sZyrpFqc3IA2yT6cX7pwvpnuqcc/3MnNyAg4AtGxt7yON3nucbhiK+1e3w8yE7pZ2ksIkbGc3XcEKTFUVao+0HuM4GeGNJLaYQ8d1nGblnOTN4fCQrX4oLtJAOmsV68dWXHPeGUcfJ4boG3dzH+GJSJOikjdzFIG+lfm2OUqdNCayIwPzu69V4zqiRfc3vI77mq3XQEJLNOnJRQ37C26Fozi4Wx10GlGYdQZSpTCFPq5hKBixE84unJUnlddUcoGzAGdW/t85/l3Pz6ePG0waVKOhCrbDv+wLNTfIjeieh5PHNw4NUVDxgLVvZvbn7ChlgtfcIgrAG1tVi/7gFirX1uTYfXLdV+ukTbrFusHPzKGE7esa6/P2qBrR+Raz+tUvpo2cD5AeFKUT+ms5Nwat4s6bOSdEwfiPYPMiAb1b8iPd0gGSyWBOBuyoFe308T1uhgz1RpyzVWi+pqtSkkhoGJselwmWTCC7hUbJEVns+GNCRhnLmrO3QhCoIomcNfC8SFEVlBzeRkW5DLJ0rwm5CdWwrL9skXYWrbgxaV7iXrtzCqYOwLZsNbc2IrPGLN1yZXmGxwjDXNiAuAM03dk6JJ71Dh84cLip6ZaeNAn+kUy1lHNJ2yusAIArMCZ1QM9sPBzXoNaLwAv2Qib3hsDBGJUjFzInHKLJ1uT8TlSvGBTRBLCSs5xs7kiBF3tZXBpjEQT1ibgNG1wt7sP5DyzIe342kq2/Aqos4QNL1Mt0vDxgiFKSqZvPkP59HC5JOP4fiQEr8mci+/jt27Qi9P3emI4T73IUF+Z379maGCyhBin0BNBNDk5SJdfSelcAwkcRMsHFzgSyZ4UuBzgJkxSgGuLoABuAFyDCbjDyzd/HXHAdUiBa8xwqH5axMrd/LuJ4UREuxguVBxRJvLnXOreJi0w7NX3wE0Os6J+4J6bry5k9sZ2OhLkgEZDPBDPKL6kxGAPTSgAUMO/I1ZLkGlkC1ekjvfXXDxS4n5PodevuOSh6SWzvMgSYOgRKzS180SRh91f5HVTwpEndIY80qHPM7mlibq6S/d4rmjayRtcDzd6HhDAd9He2Yr5jnndnszeSQLjSSW2WqqBWSK7ILSITNV869DkGsqoWQWSpagmaI3ZTlX5DGFGYgaKuyPdhPMdYX0VL8FoTxnU27v1FJeCDBxUBXkpBWwCNRlF0mtd7RURUMwD8xn/ns5hJrVeg7vYSpyDtGdi31BMyIa5cEpBPUQKtQVLnrWRyZxNugWnsABgMJVyfjzWdYc5vgPd8QITerVB+Pr7lUA2M3efbqMJZ/Zrk2JSq6Y7mj0qB7o8BcOdbro6TVHHcyHg1JHRvkG5PC41AuegQWv80iw33EcwHz/TFjZXpjLDlNQyMJYvLFWOMCwkBGE4/AQtmQWjTFZZMUl96F5D9Ru7GBWjyWaQXaMWy2pu5Mue4GgL19YIy2tS+mbzZfk20oqnDJnxmnsq1YpKjtffTlmLnMoiLly6vYh6uahQvuKtzUYqhRrc6MSFkwLCHw46v6qAa4zF1eanqBVmYqhoAoe4PBf255xzmMv8xyEEqEHsA2qfsa+Kt2KtoMSWxlsNkv7T6fbswqd4WJXjcjdWhLSBE8m/CGPWU1uaw+qCVtANdzd3uEYUwhkJIzvLn2FAJkctT1eCAejma+p29ggoPIpdPa+EcZ5gdoHPOgGhiJcmLqyNZVRWfyaf/AMce4fYk96VR4BPiTu7AVDpyfsrvsAhMh/9CJw3xoYqnbYeai4sE6REeEYRayr8PnJy77U4quOOJTQuAMc7gPQcUcyX8wT5i5hiTy5Pbz7qX3VaoF9RlPOCjV1kvawr9Lp9RX1ceze1wwU+qcncbGvvHXJhZCaowT5oMppyTBwmigxEjuHiZBQ7b6b13CNmRYs2CWs0GhS+sBc7HpMQtNCNn1MHo0CwmiRGAZm50wA42WnZnMCb6hW9EdIgCkUfqRNrVnYdPSqE4ttfmnt9/cH14VEhdNI4zj+XGtejbzUobfxd2uLexvmhczhHKgD2esxWq7Y6XYLEd1ZwXcidn5TILTo5Tv4fAl4wYRVFXmQM891vPmGY8IONTfIArAGjS+XAPutBOOEAIrUZvLPaM4nIepRZpl7TBlFCzvGWd3csJl6Z+ISpXFLvZXHZJPZcAp1re+l7xnI+uwKCeVTdkm5iidSPd9dTcfLPZp0rLmEB9jLY2GZBIThVQs42OuNAOYm+WnQ7iIP7aS3zDmTaJmPYg8OCtGSjoNjpVUh7FVJLfLB5R8XTUPXBfDYYVa/UqHIRbYnUA+9hdA7Sj7EJIT0ZwYOan3WCZKYxUz4+Zv1xHVy5pLMvES/ttDatwBpaZZl7L/2/YCfmjFO9KyEoCItoJ+kEakVPlOAXX+V8pNln68EdcQVYVeE70qQRch6IakQzSv3erXzKStsvwU2PT333+vMvAfx/vcr2CFT/p6j/PzA1+OQVWe+rzd7qlN4wFXmMOoPR4eYqPE8xbRVU6kNkYUC8keB8dBfnmyjodi3eacHbj+Ues0EeXF9XNLh8x0uEicKD5WE0e6drLA4m7qA6HIlKhJbfuViAvm42WhhlPJXoaMXV2jWimu2rwJvdrRKpCQsr6+c7UK2a7gIzgXvmtrfBtKRvXpBkO0t5+zvHqep+1hNJOEUgOTtb7PM79AWaTIcQpGzBl9RWAFeN6UERahQMqjHcQkz5jB9hwMyfOSbjOpNudXiSONeRBRkkN3ysloCa61Stay1eKaS6MYX0JMlAihuLEsZbDKN+a2d+LhmFNKrIadY0e7WRSlNXaX8Drq6ZrbNGOcpW1rRqcjOszmsyJmM7M6dWSN+PQ1FljapLqg4CNHVvi0FB6qXOyHugaX+2ihrLYESxYrZrae4OxWdTZ0UXF7Tkud6iQ7bbgF3yTDKoAjW+cCUWk/IK3k6V7Kro2d5GXRTu0wIADWsytkjLV/qNx0TjCEN5RM2fmh1Mek/zayOQAmGbE0XfjKbZ9Dkqn/ec2m52vNayFB51UbMXAXCy22yFosNSggLZ7vYQUtJrzjXvCu6jxdO0+mjUup8ctgWznAFFEv6KCpsicsiF945CzHVIYYXP/Pzxx60OgMqjSpayMJksiBvDYyDLHuIm+z/tVJvwcAWKY0qMqPkiw+kVsbUzQn4FXnxkS9oHOEwvyVoVInl0BZZ0P9mqG3tcd3/96j6x8OO8AUcvAe/IuRJSDeTTMFKovcQhTDLxJBDGCyuokksfHpf8C7Kmk0VGWFkul2kbJmiftAr9O6DIcN9AvMdXnXt8PJivzKEE29PtqC6XKk9F7WtkpcBU1iq3GXEaQ6YLaZE6PBUkYFEO4Mm8lL3tm0sqFXZi18X1XCN6yKeifMkXTInaLe+Ea5mtCLNpA2J6Hv/Wi/X6/rCJ5JMKIoNDO0WI78DMDl726CxmzVTmGy3ud4hyEqvEu8OjnDwXm9AJwM4MF4rND2Odo1Bu4RmvDPpwyAL2ASGjAxzZRY1st+NaKB+xe6p9flw6MhneOk5zcMbymVUAN5wyexZ+rTOapGvBqqLqHqnXp8JulPBvKMoz+FrodGNvX2aKJhhQzTBcog31I93H6aOv8B9lYHne6AUbbSrZJ7ef3DUK1ghwjMBaD2Rq7BnuqWZpGKD4WpLwX6rf/HQM33T5bgk0oIpiGggq1fNMKhI4DA/6DUFuN6ry599rS9eaAj6SpNe78uAjHn5Ht6V6pZbJX1+zmml5LLyWsEY1n0ccz9Yv30dtcXGaTje3hCURh8qr5DnYYsAGEBjIwiglJ8pr0oGrIG+4rRjmuMGqrXas1tnyUnwx5yqRIZl7sgFreWRwIXIV/6mC92GUD/+E1iBKu2IGd53A8jTOFMAmhlynm6kY1iECk7grXr6z1hY44EpDji5+vdokdmtu3RZfxIbC97ECQfvtOwlAuLFX0wfvnvONNhGrXCtzaldvuRcbFJaHO4RqokELw1gSFEAnSqfuImLkUf2j1ZU3ozuak1FKbrgBROVJvwAE5rrvhhEGhdLelnKJAuHy4+WXXmgcO6xCdsSXof4gJfhESAZQ1rcQcAvirgNU0BESP9XQwE1beTYHiHVqyOw5CTkVpfPC9m726HWm3WUEhFxgol55zcCn0WFoflTmEQMaX2UytXkr1U92GpnGN7x2kiuYeXJ42oXQt6sFzj8ijfRNgbXsa6k0nzbz0N3exxh8OavgtNUeUuguF3zY8CbHWglRjTO4vwFWCA3jsyM0d4PIA6KQAbvih151KqGuRl7zp5XKwJzXJkHOPB+f2KBSjE1l5cMhkuvo/p5hIDuL/ybzmRg6e5XrtugmCANS1Yebv6kwpZu01NQuP8b4lHWVIOOOdEPX+QqaLMzahNYw6SmBezsfegDKqa7iQK1B4hKAg0pwpTVsZTugpJOGqtY4L2QfwrY2YxQu8XEPaQ5qUveSdQqZmaUwhJgR92S19lfMGS8Md5XNCXTb2QyIJk3G7rA4Cb9dsjhxmcsPi4bhqheUI1siYlrjU2OGGy2VL9/f18JH0tVZutYNnekr0C5zjN3oNcdraXjgAb1q9nMgnPqpFV4VpL0U8K45V4OAwJQTyVcdONY1zuyLRNqnCXCGiKEPB/WYwSFMtsojOY8iANuGYPJKSZgIpXsms4NneMaXmVLkSYR+LtMxFbN0Gm6n5DENnx2JpwT8GntoB/PCm/2cLTyJy1gvzARCjIgGIPCzx9RlANcixKEA4Ow9jNDAjztw0UQqs+JPAsmCknInwgxkVkVruO+KZQvgVOPym4F9GbId41SzWarN1fq9R1ZqUOT+66T37dUeWfs77e3vUPvbRZrO915mHU5k+8V/Oam+SJnnTazNDBBpnD2v3IH/4nel82ykFZVV+p3O7Q0nQXtBcCEwekjG2+uC1qf9DFzLIHvxuh/NG6+gWXmn3dh61T9W5saBSWiuarsn363JNWhNtV/mAdX0Su8cU9MUODBA4a9BGgS53ST+HpfdyBQfZnDBcs7QuVwDodqC7fwT3rEYM+KMonAB3Dpbylye0L616a2uLBxPwvWqNr8LdKhfrpYDo4ZjlAfoxLlLlfLNsyulmVE+efa1RmIrjqzkQhl2zP4MwN0emHfvMQagIfPmSaJEM6otiiE62bnTpiap2ECb6ao6uluYej6eHDov5YsqIa5t5DZuAlaT6mfXLlUlAIG04dxczHboKSN9UmHakMgY+meLZQc36XFA92m9pFL1K4STRh4pWzMkdHLYgaCjsDtfvSQVQ4409s6dw+VEzxr+rHijbbvtoDbItxG0+PdBnNN3am17Ov4KtipxcO5oJfNhpeFjAiGvPtlrtHSp8n2nYs5+Agw1DKLBtcY8f5gKD86CqPBTnfiUTQ1X8+TCMPODHowdBSJVOZcyJiC+IBXgFLCDxNrE2RWzDUrBXVJA2888d5jiJIbi+Wvxq+yzxZLMhnb44FnnlfKM7pM763hnjVauN+EQ4smu6gwpHBPX/A7WWLc8aztrIJjgXvjMRzDDeiL2hKB3Ovha2/UReITQlI774XeOxs3wv5/s+dMlUOmTdsIiJ+ox58z6/4vqcwUY9d+jbx8B2NNSVfvLSQqg5fyfKFmEQV2JIWoEUqdx+u8XZ38j9BadXkaJ00g92f09THUckP/a7voPkaX//b4/LL+1Y3RZx5Bx8F8VfTNds1/7B7nJJ9+5/D6oN1DOE7B7ePlvfyP3kS9OOx9Xx/8xA0LqArQAvBiAqFzns/tt8GpPbfAnZCGk4BhxnbA/qHkMTOmjBJ4s3uf3qXtpMcPhuIkBsbIDPPEZk9ULQpPHTwzBI5cbW7cDpODjtfTEu4C9Eh9axlvSCfA/to5pUV+SnqsqDynya1a/iNLN7L80q1nuoIyF+Y7AylKkHeSZ60rsc70gMSxeHq32FAH+CUFll6vvQp6A3JZnx5djQang7hLa9Fx07hIWNQ+8UWMUuQQBgEUR/YnsTwJgpIAjg+40O/WAD6A5B948ZJnRnVgW/yczrIbTykv185/mkFtevyeaUFe1gRtrCvnymBCVeLfnpRsTX0xpeeMntJW4bOWK/6AXcNxZBkkwCX+0cIDQCTwri1RqRCZF3QUpluuhZz3yzN90mzr2uMZiNbMHVtXYYCjZS7jPDSxtqBhbs59v0HjPSpELczez1e1pjO8Ov0t8l43uSujhkYWYcX7iE1xecM2NXplzNx1LKo1GC+mhl9R1ombyWi765k/UoR0AVGc6MLM92jGs+OZx5CVTcYlSIhn7A+zS5CMQ5B8kc2MSdZb5CBzvszKxOUgMKOD0O+xUQ8RQbxYqxpswl5zEgiCy8iHqV6zx5K1fGeiZLPFrXgGZBbwrfySi+bnV3kar/eA4IeHab2K+3HbQP/ard86d9i3npIOqSqSoPavre42J2+HivDKiWvwT7tctSNbae7OlJyOH1Mp0XdmT5o0kw/HU3k+QJm0Nq0P5o+/31qDR/Pan/0FwX0XV/5D3s/n8Z3lahg4zVfA0huLOtnoTtrvCJaP/N2XeFF+zvpeUNaINQY44u7dbieYeA0iCSXAVVLUNTXAEB0PF6t3jyJBrpPEmm2GeRSrUatKhWz8lzE331/JTr318ct8R+0/sCZMMaD0BvH99kJH9JH2Q4P7kFpIg7VV/YoWUDFMf7hIS6ndLdMw7x2CScDIx+3IQYIwfPUOft9GL+rNt0D9DTdm+mTbeNXvtAuWGMLipV+ivN8nHO+eQhzoBHZtiwjCMYlYGWN23SeNRJTaZuEaTG6zS4SllO8nanKYbJEvSK4tsnNjVmLEtmadNGyr45XihMOMho+1UvJm978MQfA8T53v8JFGym2TbzgTVngTWpr2BmLhUf+43vhzUIJUDofzliUzymc9JGJUVH/Xq+KbDZktNUsVgkTSfBYsWpYItaULOXiSszcq9erI+iFgOeC0BYhLxf011cOTBwyFs9hDIY5FE/VI3ehNXtupJ1jbZ0KVeN9XojZm4obKNqd5Uko1p27BsI1DuHQoLL0QhjqKQdVvcXN2tEqAXJdR3kpGTaWcLJbVg4p/SnvcW1s08lPYfwnfb9P9itTs090pXvupuce3r17KRG7+pE69+LUPWO8Uu73r5xb69h3u+t/s8zUb2Y//NtB/r2ycYU5iD+dCIcnYHD4+YEsg8O8fcvIIKVhmhQo1GbVrLfkabuJLrDGVrUa02QQIb7WG/tjEyrGcaamBa6YhddIoHr14XJzbxQGBh2pJFHfLYy4lX4v17wb+3add9pStm3Fh4qZ/+Z9EFo84ixndhzfsED/gMzrY2F9l5FbpmUkpFZix8jn2qCQI95a594s6hsDSBpGQED+eLbOqt3+slby5J4CKNU7jnHfhOD8f4g2Vqzh+yRUqWYFxWnPrAY6Vw2nqTBJosnMbqTLgyYfZGgXUsQ5PA1tjU3u0IEb8taJJzr97H5zqCREhKxuvP1mubuXMIEsQz27IQgIVBtd+UGEubePAkBwgPcOm6izoNiws1HQNK/QavWG3tPyZqDCv13TmIoGZPbwcsClMmON5EpCbmYhKURMrkaFwZSaelw+Bx7Zi8GLH4sOJIkYovJ5kCBSOdjDCeUPGp5SaaRGGKaVSmm4mczanclCmnU6mK3u1kenljGvSaRv1D3pHmmfLeDGk+x80Q5rhFJyCe3ElQjMcRnMzkCElRupOIrDiOyNRll6gcTXcSnYb/V7r9lHNpNDxNuSU+d3JHVp7mjey8z2fj0luliRjIV9A6QQTVCKZog1CFbQTRtMlhzrYI56nWn3xtFyPcDgLR6qRpbw+Rke2VY2z7FSvuAISsg1BoR8hd6qh/3OiEOx52ynOvu+C99zVTG+4SEtkNlMluEuvHwXAbgsyAhJJyoeTKwMwiRaock0wx1TSzzbdAmfJkJiu9kAA+1DSKhFWIGmsKhJQMSuGSO3CEYaSZBBBhQi2bcSGVo43rDdqUqYf4hABbZVLWadvn02m5WFXrsd0e+uNxcbpa/kuvP3b+KghqlFFbtrNprush6RtwDmGNBOoJ54hFHhyXKh4tU3wW9iQcQsmUieShUl0G9cbkZ5xJDZuqpdguneWt1teI9eSN3eJyRX1uN/mQh8097lul1HStMWKiGj/8bItJ+mrDtoQuTTZwdxNRpptOZKaZxOaaR6JSFWcYmqRJASoXiQkcxg4DjyMbQgYc3vwN0eIagxtu8dXqHosHHgv01Euh/vZatH90ivHORwk++78U3SEgMzTEgFGxQUwYG7mykR2ckCycgiqahiamnmcsA0Ncb6Z4vswJLAITBRtaebSY6uMk15QqrY6f/RySLSdpgVF1jTE+tNikFFMsSFlqWepyv3eu2uoG1qrpwka1TWx3oBuHHMlzzPECfzpd6KzmUi2uhJ13LeqiWzFX3Em47l6tmx52uOMxhJ56AaN2bzFQp/e4PvqG8OMLWvdfWH3/4YYwDcnGwEykHhvbIe14c6afLHlAmwQLeyo8vGkIAdOSkU9HSTkDFdWMNDQzsbPPzMExCxfXrEoFZxNWPoeo6FyatM5tlDHzm6psURaQLFaXzgn1QnfSBvKdspVyZ/TBds5+txfvuMdLctmnJbsPX5qnyKV7jprI7/TLsj4ETSpsCBINOJANzI4dgoQESUGBRkODzo0bBl++KC1usdHqNXv/+EprIAzwjQ3iQEjEkYmKIiox0UQjPgUZLyHoxSb0V4mZRS7xe5+otrlP7nakzx9zsm9ecKXvX3OtXyY9XMyEar9gW9homqw242FXKwCv7Q6xt8NvXNVJ0NJOmca0Vz95B1x1rUNuut0Rjz3uuH/97EQ4YsLPHngXyXYm37gKECMfQ6UxWGwOVxBOopgnqchlUVZ103b9MJ3NF8vV2XrcbHfn+8PF8fJ09a+3X735FooBiihkh8S09Dx58WHmJ0i4KMMkSpEuw2hFJppsoSorbPGHnXY56KgGZ5xzyVW33XHXI0/8pcM//vXl09e///0/6aJjFuZgLjwWNg4ePgEhERk5BSUVDZCRnYOTi5uHl0+pgKCwMuUioqrUatVJAjVICfPYR5/gSP+i6O0EgiYBwkKxJ6aPR7xiSG5aczf3YKAwLi4UbXQQLISUVCAXLoK4coUYGBDMzGgsLOhSpGBIlYqSI4erSSZhmWIKsammEplmGoHZZpObbz4nCywgVKaMRLlyqmQmEzdZycJLb3qBB3AQQRR5UlPnRUOTQZGidMLCuatQkV5UNA9jjc3bFMUFWAHJbCVpFqvI8tcLzWQTRT42u5TRQXca4j48X78g8vPAcFZPkWnNcACiIGyPUFWMGxJSj9Lu/JtV7t/t2owVOA/9l8hK2ZtSqeM00LquMbF9N7Ia5qPg80+016mxmpq/CiJSqWKNJtPpYoMhM5k0FovOZosdDp3LdeHxcMYSP7gIJ2kUZZzHSZKmqcgygxAmKS1laasqR127mubUtnk3nKbTfDY/LRae5fo0jvlmc9pu893udH5e7vfscJDHo386BVdX4c9s0K9uWZ62TZehqAWGOSlwU4KwJEkrirKkaSuGteA4M543FwQzUTTX6ZwPBudOd655fFWqgjS7hKHFZY6uauPoua8EvvnO0Q89xHr1ExiIHYjDjQMq/DgRRBQRc8QRE0WSIZyijY4w7nFnjj56onjEyBzv+BLFL35EscRKnIAkEicpKURJTQZJfkkmRrKTxyYFmYmZWZmLlXlZhJ3FKWebJdmKk23ZQZq6nGRNQ86S5lwaWdOUG6y5mVvscjtPWPM0X0jzNd9Z8yM9ZOlNL2v6MgilgMGVirAT5worwau0SvZ0HAUtByys5NjYKRTgZMHDS42Pn5aAoCGERFmIiVORkGYhI0tNTp6FkjK1QoVpqKhypaHJSEubBQhMSUefhYEhDSNTFhaWhrCyZmFnz5ubOwMPT178/OkEBdMrU5ZeufI8RETyFBXNpEpVbmrU5K5efV6aDE+uWUsKrVqTa9ORxUgjsxhlbGrjTEhrosKGmKI4H1NVZjGbOI05qgowV3Uq89RlsYAktUWaslisObUlWtLo0pmrVWQZrdaVRo/elNbpy2K9i1lsIM/PZgMF2GowH9soU9vpSmp9ruXtoDvpHXI/g6Me5uWcV7n72Zt0LvuU3g1f07vpWx5u0+XpgeFMHhrJw6/Gc/PKVB5+p0/vHUP6cE3Krwsqn6IQjUah05kMBsJkUlkslM2mczgol8vi8WgY0/m+IQhM4cQSRbY4RjjXJYkrTT1ZxoTwpQzLclJVUV3Hbcu7Lun7dDrNFguxXOarlVyvi3Est9tyt6vPz5v9vj0cuuNxOJ2mV1czd6RZM4ZLLmF67iueb74j/dAD69WL0K8f20A4QMYO2QE73Dighx8nVIQRYUUcMSqSaDDiGh0q7tGziUc8MOMZT0S84oUZY4yY8Y4fViyJxE5UhrNNTBKwk5hEZJKSgpPUZLBLdvJwk598KAWZgJeJmcY+JZmJl1mZyyHzsgg/i1POMUuymSBbspUo27KDU+qyizC7c5IoDWkgy6mcJc713CLJ7dwmTWvuc86DPOGSp3lDln/yjjzv85ksX/KFKF/znSI/0kOZvgzCeRG2BXU52IGm/DpRV1gJ10qrNKSqamhhq5FIOjQ07ujoHDAw6FEoC+hc1CygVbLR872BR082eEYYjjkaMaiiiUHMpb6qDSjz5kLbjCUhE8gEsoRMIBPISippSArBuuColBn3ZDLFJtsomhcKnt7klO/M0/pOA5Dd0763uvdT1X+u0q9V/K3u/F7X/ry0BrUBznaq1/zQuw96iUYboTFGZy6M8AyCDZ6BZzAwGMYhdUDGnAdF9ENk7TSWNIFMIMgSMoGsIHtIGi6TKTganruieGZBXV7Z4NwkaC5RoxzOrI5t6N3P3yMWRqXQGRgMM24mZoUAxJGoAAAoKwWF83t+yHo51wdQigQWq7YUCiU3M5Qp+J20FQCAYMUSiD0CQPbyogAIolO/hindBDBMEwPQMT6RUcipJFRZRSmJmAKAVwKomdddBMDpXmmbadFNAH8NFw3HuALwlSVrAEJ8oqSQaCKMZEUFv30XgJcA2uUtu5+HALHAVDKKPx9t+IBsCUS4K9xVUgYhg4BLSUtJ5zbUHJccx9nG5l7DH7c8m2Rppjigh6rnd6F8u6Hg3l3XgRsD6MNZWXL5ubi4li0z9MMBCZg4algA5MK4ANdyd0wEaYiBCfqtuz7duq3nL8QGQ4kxbo5vZOPhGDbJN7Ihcc4L+ZKNinjRxMyj/nytEs/Gxr2Q0dQ4XdNFjGMHhNyLmyAwRTEZJ81B87mr12dBJRdnZWnBBZj8XBwXByRgbNGYsIAJwOJa3WiYyY1ne6PDJtMCh/v0oGO0xnYzs/1jdfaflw2heIkxHkbdyEZRkXnYDWY2kM5518yysRQvmpjRRhlljaii85BXvGzrnZPnGtuAR0LXeVSnJBtg8eGl1VSqU4tMFHIhbi3Rqtz7Bsnsp0L+MqOc4BAnPL5vhpVZRFREVBgQABLQ3oRcZCH+guVfdKKoMtRU1ezsVe2jymuu0ER1UPNM1YHmSDdXBzVKc1jS+SqD2omu7aa107x2Yusl7lIYwjdLaqxVjbSuvfgaTYhIqo+pyKMPKj5wuDwuLxUZ9Ek/FpFxgMWOQpF7IOVq9qrUHFDFlepAdXBQU3Og2Xnv6CVdXUNTKx1ISQdM0kaStDCSb2PIEw3CbxHRiBlLR10paTRkhLCVh2AQAvIGISuHkYHgkCwkDxmnYJ74ODJl8IDulLSVBIUMU7yOnzqB6JSdUVLSUhATQtjKk6Fkl2EQAkLIypmYysjCISeInRsyGYFQuDQrHoSVkCn/CgTwppSrJCgkIakoGL9tpFmDBGGVlLzz1GuvPHrwwnN3T7y1siFY4PBS7L8uYXwtfHOikey95SYf+VX2/8ek5ZQ19dCmOLwdie7C8egF9/tgQuJweaSWvpGZBcGezGBxPfHyPe6GfJP92xIyCiraBhhzSxsHihOb56lXfIs5QEQSoaiqrmNoDFpBjlRnV3fPvD5NAVGp4+fnqWnookyw1rZEGtPNg+feePuH+ma27G6drM7+1qJAq2F43HAjTTSzv2BkY1NDXJdVem15s+/TZd/F7XXEaZf6t4prY5G4h575zR+nfq5vbG+I+7eDxEk0tI+ob4rWQ9Ab4n8etEBygIVHfF3ZxA0IZg7efrCppbIRUqFGo7Zx9Pts30Emmm6uhf2uabWN1ZBVem3R1987rZXDhRxy3FmXyo3G8xVGPNXujXflSzMRXdsDHUliFm7zIQWklLTFs/mSPvyFGvp27Ofvrlsky5Br5Nb4rWyyGeZZNFa8L/Td4ndrbFT78XcBBTJdqIDTQYNC+tj3knTwcKTFbWHE4ozF2YuTi/MXY5ZPzU6nDi88Lg8bV6trmp0vZxtPvSP2qSvbm73N1qm2rFQ0B4vMM8PkAouzFrdZkLMvQEJpmT+1gZhZsKHipcs12mSzlKpQrUatPY5o0OiKVo+1e+tTSMR+Ky9mDQL1LhRZL25xn6fa1kzNp+B3r0xCiiehJDOSQvLJZRUbqWFdZw2Sx63X7ESv3Wt2J7b0N2cL9b1SiFLSqeTwRCKTkdz0ZGBa11ztA1ti6XNMb6xncmaZi4BG70lvIHTCCnQr5M8djxIz19oC1fjJnqvUD/zN6/1eTlMZtRb7Nfct9C/lCQhuPQma5174S7uXXvlbh9fe+Mdb/+r0n3fe++CjTz774ms9DnPXDncdGnb4cYwgTlALIcxsOFkBwZ5q+xkoyE/yruBkspR+K6POgFAwOrZmmJ1LMHuohQhsnjKQmLgEpJMPT8T8As+wyYInejLhGY6GzZ6QC/UUwBM+2UHPhZxczOS97XEylMHR0/R0+NmLq29/vgxmIDhxNbpLQpbtT+c7gs51n8KL9isS2t2BJgoMNH5F8Csv7i5yNE9HVsCYuDDY/v0eKAhSiAm3hAPbiKOdhJk88TNlps60KZnpM2NmzqyZPXNm7syb+RAy6clLVwahgZEcYYQAAcDVDYXMNhsTgsyFoX5sF1Co3YMBFOZibA4zzLyxZEAQEOB/y6LyFW3QwxUJHzNuvAhCwwo3vNjHAYKSCbPhDh2MxeS5KBHZRD5kkuT5B5IJ6XJQEDL7poiJmp8mBkI+v8Ge6IDhOOESpsAtohKfniG7NL8D97AHPRfT/LMtVu7pPp4kgxieb2Gm1sRN3PVFMF7jmw56x45n0+JOJH3EAdnwSXJT2fOmqo2kfk5oaU0v9yrXXu8tbk+4ZHg86Czt1Wd9ztD2vmR65iXDdyLLXq2vE3NZF+pS3RlcKhhLANdkYeUPx3XXLkTYTpGyRTTzI+nITsk3tP1f3AzgJvN/auTufGIp4F06QSPpgKcWfsQtJ/KrAAA3OkMAAVj9wx5UT78h5HAGoDcAegA+DZwBAwMMcAoEOODmCAg4BXmAN/AjpehSgUMZWIXKNMYc8ZS30Aqr/OGINpvpAUmcKM4fdwifwQ8IKCQZkg5BQjAQCiQX8hOZAmVBOVArtAwahbZDj5N3ydfkXzDa0EL8NPwq/F/EIUQkEU3EE8nEHGIekUPkE6VEkDicOIo4i7iG2EvcQNxB/J64h/gj8TDxKCmDlEkik3JI+SQnKUzqJm0h7SbtIx0knSSdJseR48kp5HQykowm48lMMkA2ksvJVbTz9Ay6lZn25tH7C+b58bgXDyzst7CAQ8kZ+QuTZay5agv6irU5nJvpqfBrnmlLHw8Qu+B6bSHzk0dknHkuKczUVOdDiBjOZQlKF6s1MMiFcqlcnr6wVu4l95Zb15RY6Y9vjx21E9bw4Sd6ilf7Xj/i9X76BdSpI0eLjJE6Z82jXhQ26/v088JqB2sXwIVrbpevvP93oB4Wm+p31VX58+UF9h+D/RPg///Dy9r/8gr88a7S7y6CkDtMjsrV1+c95jexsN2C2eON2bUfBvC7Te0Htu+177Rvf73WXehGr9lPBPD7j498I2v9tyG/3RvSmIgDv7kPfvPVGdX4ErKM+OketaFnXwc47qNHTwF2vrj9NusggO8B/wD8F8hhiA/od9rau/3UHgD0vwYTTABgDgOYI8BcAuaKSZ30yZ7GuT8fNhKAcoeQ58vIn2xPtxeA6IUF+E6DKf+V7QrzG9r+gf7i1uBMPzkHPwv/to3JRvrdYfOlGGGaElVWKpAm12wB8hXaYJ2Npko13RwzrJAzfkh0DBQbTCwzLTRL9SwwyX6H7HNEqV/Hx2JLTLBdurLxVmF1P/fLmOtqka0T2k+Wmjh0giAYEDW+5ZaotMoy1TUtxP/XHw7ZbZ/9WlzQ5KJdHmv31HNvvOh3HWNghElMw9KBeG8zGnbdqElVAQbfIISRgoQLWX8JBbMIECkwa7gxCow0yjz5Fvg909L6VnRlW9jaqHUxPTV649Yn9GGgPR22IdBRFNoLqHhO4TrLwRn2zhM5R+gajStUGkldpdZM7DpXt+jc5k6vlYe7vNzh6R6D+4we8PaIj4dMzJ7w87cwz1i9EuqLw1en7y7fiv1w6y7R5fV/j8Ey/SF9wdmiCWOi8VIpRoVlo+LaoHFloaKKMrvOmV9ZVVlcTcqrTll+yT+JKgdNTIUr+V+c0xb/EmhE+SmpY6bXKTMryIysdCdbfc/rRKQnGRnITgIELORoZkGnMYgkZzLFhUl14rrxSK/RfCi3r2/v7pdXH2eToxsMFvfO8ukzk5WkcCKxeEKjS8ml7ij6w4Zxz16h1uh1Ro8/EM4VC8ol9aJqRbum37a85Xesu7Zjz4n31Hfmvwhehp7SL9nX3KjLExcJBXyJ3GI/ZzrcvmAomsrGknXDpmnfceA8dJ0HqrSr8JbZ3iSZW2FmVZw5qXI9v7mZGo+z0dNs8iybtWWDJ1ntXtZ6kHUeZr1HWeN+DoZEh0NHx2KDjoeJ/gwb1ccWnQwHnQgLXY4ylyLPXwnKy4TkfWLyMXH5lPh8TkI+JDZvMzSdic5/+SnvMjz/ZljpaHQpNLZ2aFJ5mVL7TK1DppWbyZWntC5ZWEV+rTIn9h9B0p9iWI4XREnWjaBgkOAQUDS0/EPxVNXUNWQ0tQb8iGmzO5wut9fHF4hxqcTMXEaQcoVOqR/zTLzCI9QalV+gerLQ0wUc6P8IwM+4a10EPzvBQoQKEy5CpChDZfGg42azUkocIOvOS393ihdHcDNAKq3s7T7ud71KgxY3XHXNXa26DIQmf2dLorCztGAGJFAWVDuXLFch2SN/tc2iZCo7fvmYx0dNtqTDzrSWTTY7Mndv3aqtuzqjfibg3xJuikm22+Gg9R1igonyZsFhUu+NVJVkymIAcuF0a/2RBZWZ64AixUFV+JutcdbJFqQy+7Ik+3NI7L0WoS+B/E7iL8pA4rGMYbyFRob2kvq3L2ys+Py5i2GSLVixGOlGmMjfOrVqzJKpAjhkWWJnOHomo5cCdk9jtwO777Arxf4YuOQmDWxuecefQb/fbMhg+cdEbj3FBnGPu28boEvOkEeNe/Mj+Zc2wJd8DLroTI8GxCUXelPfR/RqsY/yC3HZGfGNKmfLlxDHRir7yB7a2UVGzf6lQN4nA9Q2580BpCPX9GMeF6jy+6Ue+1k8dNK6aLFJ4vjK+nhbyP4T2wRzZr/AGa4+p6+v9Iw5ck3Qj1GQiLq+xmukNeYUfv+FAJS0qTCuNltdkONAC19xSLkqFSqmraqWYTspir5nqoe24rNz26Pt93/4DQaM+0wDbrVEr+xHH67pqQ/gYQJrtvSYH2N+R4LsBh3m7PLpQIyC5GcLGBAChYmLsQb1gHktYO8C0O+Cq/0Z4KZHAI59NjjsGPDzezAAhWHoCkRAYPyo4/UiYSxrPgQDN+QrggA7es2l8DaJ1gU33Lu5aRDzpTlt3C46DHNFAsnj6SKJkSMsLFiDJQkoA269k1QDgmh3RaR5YZ2ks06i+7p8B5nVOnM1Wq3ZDOaqMZHIbdrk5TSzmMTUpK1mrIwit7a3g3ppMnpslJaHm+s1TeBKNWidG01cWv6t1yxD7yIdAOF2hdVrcM0aFBHvR9GT6EHcdIPsOM97bSDAEZtZZyeWwQNCdKPG54iPsa2A15aVH6xrcLM2kVKGYvto43XLdW0xNM0RmpEaiZwW2i+uGCKuBkY0L99sTmsXIfgBSNxvRGBNpTRk0ZLSDL8438gT533GFnt87rMGaclo5dpFvRxzAXXESQXrbu3JlxwcawXb3MGHoiP10rEjQnRM2eyWwa7pTE9c07FqljFrNrsmbg5emOw4uzFIgF2s1WqScAxCNhhwgnotTfu9VAUTWeAY4cA7az+eOW1pb2lZzIlJFWLApGcJMPGQNgmklNnCKeB6SIG5qQotenkezCBzTODZ8yw9nZ6PSTLoKV9wzNKPEcAVJ0L/cNoCo84gjmGB5m+FBYy3AUeIi/437eSLzE9XJnwwpZlim1teDh7R84LNX/fncrILchgNoQPnKi9LM4CuWzSN8dzl/219WcXTsB+DyoM9sCKyTX7eOtNV8FpMmF3XlxYrhBXE1r7P3thNjc5nmK91XiK6/rxBOF7KTeTCzfd/rzOab+frPZZdLK1VY9Rtl9JyvtPsz+pPO7M3j3wNmO56Qcv9yBzIGqt2388lCM5wVN9Oh/oVeTTvOVM2fs5g5th4Zse4hjQ71CUvRdFuhzCfe2834rkoSaIDViYQCDUybBVGJXndA4Ml0CcATRKgx+iaSSkXiPo6grt1r9+BwFmSx3wU6vLTnokbNGFhd0W5CRscEMDBkOX3Pr4aHIZtRswStIuVb7ScL9w4Adgwd0/6dSHtI5q2hpWXoc+CLduaZNotqWdw4CpeextCQmmL6vDBEjCIoARwjibqJA3FkHl3UTllG6GM1ok7rEU1u6twovjGCjVP7/R6Exl4aFFTBuTdun0ZCef7+AWg2cQEHFgALGSXkK/I3wvH+AZ7BIjqtxKQw+Dl4+b1+RXLnObE6xhyPhVvN2idXjuvPRpNlPsIY0t0n+CUCigvCYXGj7GAi3DkQVAeIroHyqIHsP1sKS0NTtAx8SZjbYSc2B+DUKBM/QNGqUHdSedovu5BM5uW7RXatDPQFJmyL9h2D9kra+ddo4qQ3e6q0XYRlR3ffSb1nBC0QZJd4usIZOIMLSPHAdsobHSRkyFGT54qwc9bzr8qxaqETzKSAzkrQG52CLSQaRqU8IbfenmWJ4pGy/VyT62i7sj12LZe36LDklGiEzqxR979XIDBK3jz/Ow2mTrZYFUnXT93Tqnv9WFbkqMezvLZQFL64VBK+SDzcwlf+/QDDWBkIOylYenHYsWmTIyhDr2nLDDK3dc71nMIrTNWKuvtNichbF3ZheSb0PiW4HBrlvA2TsoASxNZLTpp2GJ9xnLM6aryYhcc+WtowHVm6y5Ff5hbaEneh02KX9wbyR3cxuAxqA45oI2c3kX/tM++1VFAzd9eagFq5fISJ6+txHt0kHNtcGtOPkzGjgMmTh/0PiT8hP2QEbccF1WVAUKCpwgHHL+tKstwuC2aEebMJxANuwg5ZGkXeqizAuT4LqRUO3Ou5wDP5kkcnVFzWqixKUpkh0i8wClVjwwTzYMgsk0jhjZLcz0PT5NkA4AUz6E/THh2m6GfMmJ6wAaM0Bw6gGkgCE2v/ekYTfY5+atdZE65iMDydXl4bxd5MecKrfxzslSRtiy1PO/wXKN2umvJkufNpxq6f9Z6qVSaySIP/JAopwkcFqQc5RoxXz96xYg3nU2l1JH5kJxh9U6fEtTWJVXHVrZjaSKHQbrr95S1gAO2K2OB6C3MLvmiByFt9aVSVF5cMcTY5Thfqs7MLj6Hl+bztTJXxu35P6eD8EhVxs/VeRyyh8vaOY351BPk7ZO0bLQ+UiIrTYpnh+oDNdWJrv1Ouf0ffpgm4CO5Fr47z4eBuUgUvjeun367VPvMz2bkYYEdBgKy7FKLwca3kyTpvyT0wZMfpTR95B6HENYwpjWeXYZnNsHlDWVf2ni27VRU9UUdfhW0J4JC50wr3XVR3Xoeiz3xfY0QrhxJ3BMcKe4sJ8q+tJL6h83BQDs4f6SPaPUuJD+Ay3UcryuXsPsW15L58h+3h6ezyuEqZu5+Dr/x7Km0nZj5nS/YgtV77jzrzjl+b4mekqL7xre+aj2i2CXubWr/a03Y1JWe4WlThpw+p99nVotmFi9qX3onmb1k6OKfcQgaZu/NVdvMuK5ah+CNUlMYaL0UufKi3t6EqQJcaNX4vuKe9/jz/idv/BT+OVT0vg6GkrrW8CpZcBVsOWobCTwVZqDqn9L4TmN0PVvoznIQfTihcqC7qAMZhMJLB55JlpeTp1WPTPS9eHwpj3ndRuaTz1RRG8U0qNpmAxL2+BJEQ84BYSHTTSFLeYLLpYFKdOgjbAJ38Aw0jV6S9joCm6aZW4Oui3rZkrtN4uLMRplsO6c3BO8kDjl3zGhWiF8zrYOBKkAOVJYryMSDE/mMYBWF3UPWHSdCvGwDyhUEsHJX53bLkubEHk8Uza+JPphrVC7UIj1ikf9LHfw/OnIrhcC7c/NJ+xb53b759VDa63T6D738v4V2/2Hxn3grdXAFKTtUiV3zBkgq34Z4ZgXVtq7EOpzUJYHAHtgZhtPLv2WWwao1fiK6UR1YsWMTPxbsPNnC8u0bbXo2C2eBXJZHs8Wq9p1wh+BHUa79sfARa42BkKJlvgCArvmImS6k41J+FisGjdXt7pCR0EELbfO3w41dNL2AYL7OLS8e6NUOzXxyNp9VNR5nx0aG/5GZUna1u7DNQkMlowx3p3A7cig1iJ1Aw0GzCD0SPr4UwriyuTWsXUjvDIe9AmjnCX4qmCr7T+B04Sa4ffZkTYVxfP9k7MFCT8zvPW+7O1vwaCa3AvlwX7UYru8AONhTMpylcK7Wyiy7Qpebwbiwr5+x9Wa2WF1plomisgGh9p+ktybW45jci7old+e1nWeosoKeo+AnwiD2uoplFdAA6VDIasm3nlsWUDaK4xk9McWwNXFob5t+fF7PsJ2Nu7MC/TIMmgNlVuQU5CNXtXONzhYzy0q0nDvjr162mo3gOhgFPjbg/awYQSfkQSPswjx0hqdYx/3owZ/RFq0WGkZ4W+JI8llSI7AmW/DQd5wkZjhmudX14U5v6qbQNrQI7yuVUEITTndcugMC8BIojyeeZAyzauKR99BynGUpgQVlMvHnmk9/OmKGo0PLF22R9+CUebxTp58t7kwFPp5eDN645XZhbHPQph3f6TILPpGID7OIwruz4JWtGE3YBb39zIQ4LVEkxhr7+a2WlWfnBuiybxR/lA36GH43vLcbzfvOfdD18qhVemPW2V77IMi7Ec8yFRm+SBoWEDrN82LZPL2D9IdJ0O64Wrpz8gFhp9hpPegCqsFimv9S81KvYaYP4EMyURBxeKJRM5ca0kjWJqh8qlc610WEh5EkoHcIehcn5APd6Z9Hn0vsOBdKdY1EQZfK/wcHZnV+lX/heLL7PdARCoRDB1wk4NIC1PG0gFK5PPdi6fyQqh38Z5ybYYMOIXiRs+dhd/Fm0IG9CRFI3SuFI/3zXUBS7biPKsvOLh/vYs5BS5NArrxufUEm+s+u3yQhjW8LdexYg3OOtm6n7O0v52KpWr1DRhLyHon+2TSFBg4o2l1s3YUOwcYRMiWLD87BB3g5SRAiyG9mdD23f/3UZDu2oY2aWWZm+jxozzHmiWPTKLSn9eC6VGUfveXuLZ0NtlidKDfI/tNx8wIOc7g7ST1KAPuAAvp7Hf0t6ZDbjWGmKGRn2Ycvp8IVrrjQgEGYqHDjnMUgSNtY+SRStjkOQje/f7a64aJyQpKs+3boers1xupnQ7V4CQX1n8LdLYGCFIyIK1wkiTL8KK+Ql7ABq2/13lBW9qrTIlI0/bEMqbIeDW4g59dwWXz08JmW2yxTJNsp2K9dnjhjpK/moU7iBtoKyl2i3jEOOFJcr7ixt6JnC6g4B8JDeIaLjtbjIZ04NFLTq8AlBBJobnsGqvy4mWDDReWRHvpHNCNqeK1fY6KrRV6Ito205FcFHavL5HPf0OrON2e4QR+JV8elgesbEYuwM2QnldZoXNCjAkkyZ1dG1rPlhqbFkyaBwJZOAaTBTBxkpFppPFpTFyfTPa8E1728X/axliurQ/yHSDGB8/3w585uB+C2z/agtuPE99Gm5jsbrI6vGe//bCUlka7x3AZfwveQM0/2q4xvY5ougsUmHfHq78rHHl4v0VNC9PzzM2Miz1MMXKtMD8PajIy+vHyyb68R3oMRd/h9pLHfcjNH5ujprI6Pu3adLaujS0c0BZuMWzzJuJMBT8kgPVJmqmbh/7XUMKM/JFykE0lVcSKnce8Z/PodCz35fHrTeL7wZDCXnYtmUrNBf6e1xmF+u6wJu1VQEB6NbySKXFcM6u8twWQ9T7G9tTpbzvnpd9dJYU9MYv9qaOVZr2V3z/OFfPU7iRxx5bw3LdHJvFK+EE/CPo7WRGdr9VRgxcN2PZi/UAbvm09WOd5ORjcQhfPWHxjDQiQ0FZmHtE7YhjsQ1lllZ2/LPlo2YaztiMltyZfvU34Hm+eVHLUS6X+F9JAGst5d+hCJAHRgNML5pzx2EEeRBkmLy28bLcV8iCtfD0okxmvxUIGsrE5w9EIRkI6bC6pxksRhjbpoiduqSHsQhopjBOOlL3NAI7mYViggY6zjil2SVC0mM6ATpQrX8z258Q1cMOpPYqx5jVMdUbw5w7vyJGyZsfIQTeJKDzo2ghTlH21odxIce0MfPUMrEamI6YvrXXIvowxgWF2B96c9RkQUnJIu6Ko8ogRG71PMWneslnucMf1Tip9E0X8m+Md+vunjY9/bc2av+JVPr23e1a9n71ifPh2/yA9+AqNj0XKPD8dkbMlfMaHeiWG/l+JzOSkQ9iIlSAQC8cmIS4t0EO90g5FOU0JpAbBJUx9947oqN7N681HTyZXOVdqquUSMu7iYr6apFCVieLp4IBmghR3cBlXqt4fmcDRUwWxmpVdRMiEG/peSl4PsDKEquRK8HRTyp7HYLjwRXV+Z8ODxEptSL+/dkqQoj0KH3PbZH4IZ9n1Sv9M/v59qjt9vKLK7ZR/ddn5yM+k15+o5ehKEryjVhrokWGgolopJMCbsZEeB2yJB33kV14QtjuQncUWPx1UGily6+abnjWTd6zvtHgmnQ8bpk5jKod9pyuvBoZ6nUE6f/zptQ6Qcd6kj141ikmgrGZ+9IUaMUcgJQywbKsBncsZeW6R9muj1anfe03bhsE/faZU0DhbQLe5c94Xz0IgIq1ys/E9+eaf8P27i75Xk4t2ToyZ5rNO9zItOp78oNgE9aZkIfAZtB3pjJH/yYdt6C98y6p2OJ488gIhhd3j53Kb9mb5IAFYKRxsxuKPDLkQMLCucH+sUI69TbAEP7e7O8XmDb/wRvCEGIJZtlLN4k5HP62v1asuIXd172t07aobRRgLMj2zEZg/BUJSBBB29P5mvNOIQYM/+URnZ2FjOT2Td7sJBDfMgBw4bjxXwBATpjgLrwGE4f7Q5Vyi1uFb2/dcyZ6UgPfBH4ML9L9+nXUGhNmZpdjjMrOHxk09Fwp8O1sCQsmQVR2T4fOMomwKadLuQSk3ca0u2ADyZcAE3EhSVNu05Nk9yYfjAfuYLLPJiwRHW/nJ8bnfnHuzUX4LMpgFWaAnNftRdmt/brLAfw0nMoLLPxJb8e7l1X++m8YsurMxGK0ra3TghyFF0MlUgQflHR2DOupnwJ06M9QPq8XpkIwQedXYvP23f+GPQM4qMkW6WTUTR/pdtG710lYnWrntvIDICMvWAPCI/67Rnhrlisy6xhoj/S4Lv3mesRcVm9YWIPQUpHk0XYyy+1p6oKnKkIv5UC/0e/CMAgbR82M69/oqW4C26tzlLE8QrYnJ2zkohI2ioPv53ltyZWasuK1zzpPm6B3+Ve1xAQLLxe0nZx4VhwUQW2wqEeEs6MLpm9cBlEu4hS7CQ4KVFzcrb5Ur6Ul6JBYtHtHHd6hBkVtouuAo3XplFQ+4d8/xlLRLMJrS4u3Wpf5uz03L00NPMu7Ba253+xsex4xSoBxw/Xy4qmI6CIkpLNP4WNRLEc8ef2BwGi4sKq8Yx+2EywadYIwR/iu14MZM1tk32ZPKO1sN4gUcJNsBtvsvaOJsv2nWbbxxksWo+m4YtT07RtrUbcpoW3IgObHLDXY4NhUbgpfXQT+MgliptrXlKuB7f33zCYUTTecBPoDzhfXyOxEvqT/bIZsYx72e+i0FcJO3MaxVDnMZH6ztulG8fOV6zupods++Q+JramLQhWF0j0AR/1tn3wqIT8pZtTtGesrNxeyN9tsN36OPz+noH61q9UTOyzHRsoUea0vktiLksEAhl888V5qUEfq5EQDNCjYHXCfNJ8q7jWUOQQbpVk6hboRyi0DyEihgLrRpb0SCJXbjMAKBFFW/USAv+AjFwx70v8+D20660JVU8uHfUNRJbrhPzV5n6zOyaKV7PSu3b9XCwd+GZh5ZewDvHBQE8eeHsWcF5foXqXFZY2eF88dS6V+059vZOgrafZAHSJtEY7t65C5GtZ5uMyC7wMmq2YfZotBsBdMVDS2B3IRWufPF6MTK82Ooo2ZXHjPk8UzrwNJhQHIbjItMV9j3oFXaP0wKAUFwtlFD/ieqITdqTkEjQo9f1RgWjMesZDkEjOHofnzRIHnV8fkj9rz+yWXFTWhfGo1tyBZzCGo5B3K78RalT5b3aUvrx3pTOhGVfnLWyzKHoRp1pdmXIdsw7h3om0jztvJPKAGJbyBxvZyLUBbrpb0dwwZRjczV3JZPATDvKEvrMeQZSTCvpTmZgiUWXaCQ5uzfqtyA/hJl3Y1Nr1J2G/dj3qcyZBFmTWBjdz0i5TJZKnnePO3diT9Y7jIovn4mUU9qWIjabaWYfGVndcWBTUmzQu4JJWrk5Io5auwn0a8msRzeN2VhzVuJrw2xsZN+EVZPj0FZLllTVblOmHTIiQ2KtVXz3T5eIgbrMtCiUJjUNNgekzSZAhqw2yl+0k5DzdqaRyMoU16+5561rZmqo70yqfQZTjep6ETPYi9TajcboZMf7R5eZZtvNp0iP0pV2mtYOPN9jK3pbWRXmM+B9kwUvPYmF39HtPjO006HIlijNzhnibN3jn+8j1kzT5o2vLVlxThulfdI9p+vLwqpoa2BWpPm03SjYTgI9tb+6StZEbJnH+QBL+2cwElgTvQn6+/9FO+Pm3deoGxUInSbunSLpAqppNQlk42JeIgsl+3MoN8/b3G9/LR3l3b820eqTVst5aUMx9hw9XKpy1UlfMFPYj7sNtTX0JGr54HJLfH1u/owPXjEq2zsTS1BEcPoWISc9MmqEL+giYh3YNC2bcXYtZr3RWqFiHN/X6Jn+rouczzTP/+oOpOGSFRcxGzVemGneRrid7q7/FPlV5Y+9ygrZ0rTKNYSbrZIzfOmhp66XIn6DkHo+qZA45t9giZJBnCEtSMa25h3IA06iqBKd/j9LGrHxroZ0isEObEp2O6Mz9JgZjKP0mGdq1cglLGjtNGvbq7PsPDoK1nO2fbbwcLZvRZanLfuHXmqmtU+yMzqiSLkWVoEYn3XHWJjsZ9lHYeZ5H7whRzFeFXZ3tmniLMvfONvyz23K1mXxn/Gf6/zcHn9uu5/bnM3AlT+heK3tK39vP/8W/P9cQe1Srbaf0R/F/GC34Z7TISTtC4HP1GhWncZveiJCMWvfP3iwOrCxeeFU4wVp7N4TKwFrKPUyF/Wrz8L/AGVPCgO6ASL/lNl/WOgdWD8fuR4Hpe9pc1sKmztP+NZxVno/RJqDOZvPXwiwcNW9ZftdDzF5ATvAz+3NlZ6E2+1WrXWYbbQRVJRJufOgvdpM7CACmozP2sI1Z3DDZSVFYpB9+yAqfwcNBisP5+GTdKxZHL/cMI6ZQb3W8404NqpQh6tUqXCVQp2NylGahf0wkY17/c5V8DOKc4SWBIMZgWxD5ookStaFLErSCoFEa9PV6bS25eXwintthTaZtZushPUbhNLWuhYb9hpJ1tz6XyBzt+HgslK6wkCIylW0Sq0uSBV5yw1iipdIQmCzmumwHywYUkmphVZiMXlVcg0fuXlWWrY224VsQ5meedI3s6mTu0pLFXCYGfwVH8XCpf4chYEYVSjJUaXemyMQusg7CX4Rxke029waqZ4H21xJEumyN+iewY2AXSKWWY0TpoFdoBQszEWph4DZTLmKS8cNQmMeZqV/7oV87+BodtZL67t8QPJk9vVwf2p4LAaReqcZhCYqKMwmP7RfZBXnvh9mycxnX12Q/ZCKSkZnv8PgadC8tB9yc9+PsWblpz19or+PyKLktUdKLBr7VP+k05x+Lonbz4musTId7boEAI0MOjVFtPbrbeq6G5iCO4AhCvCER1npqn4yYZOL3VASUMOeRHOkHBtFCOIihYUINfgId/q4oaFWaNQhIg6jmfo/4WFXFkn+RJ/ZC+wClNw47mKSxD1/eQ1Wu+YKU8MckyQDLmVF5REsCHwGNJlqDICoe0HKFmmAz+s21hAFuHicgBj1XM4DJ5cp5EMQ+NrEvA5Yc1CP0ejtWSn7yiBq+KH6dzZ8viLccKkvjq8oGV5f0b8RJtfoaWrgAWCeMqMvgw+8BsTjLlgdYxXaSWB2HAS+BvbsStZHDsEczZIBmdbKeQJpXhdMJYVsqoo+AiounI8ovZWevY4C+AMd8ePLqrM0yZRCaCEPl18otannqi0qvPF+E/lphTpyZSRGSuftifB5DKRO0OzdjqW9YKUeZQDJdMhg63+wsNP3qErWg33lOMtAAI6B9Bmr+e259iOq1/PR+Q1Mcg6eQESl3eqEEIcnZmgvZWaIfUDyAhD/y1KowLrcms4olNZbZbb0YFG6zQaaIkVO3q4Z0Pz8ZY0rGpYfR1EWZTAdaUVGg7Hau/nnBMmvghZQmkY7MBNfIp0zTjpu8ThWgjm5dgjceExck5EPMDjU+qSJhU6Zr/KAt4BmdCXMeNAA+wDezqsllYUZ/gtAWxqFtXQHgYI5IS2wG+BNuRpunQqDoOEl08SdJxff4gIfAHnVEuiLLwcOA+J5J5bejrF+RWwpDMRQ/F2jrwMRGiEOj32MTjldAlUnJQA5lf+ceyVOpB1TWrs06BXUluPVmT+sRq88E7EuX84hodsV1hVbA88FD6a08FMIABjgFW347/7nBa4cQz4YpoNNpZnsJqA0FguYaCNjqF7Y9zuT3rgFGqor2o5KFkoe8tn8h5KFsklArIBVEAMmTQrD9Y0CWzh3qqOENd0WqMtXqu3MX2CKwI0Al2+Xg2wNfhPSXrAiVt3gB4N636uenR9c+GoRAnx9O8tTkj/J60Xg4IX0/KPSilisoe67OquOVQQIXpLMvkD7P11bDJpzGsOWNNjkrMPExal1GecnIQTgRoXgmgauPcic5i5hT3cGWvJBq5t1UI3LowBwyGyx8pa6ZdWRZrfZa1KHWwAyICUxBRFY5EWKCtHN0CwJMA1SDIIkFpKuSJcdzJFcL7plDdxilOTjxERsOgaB6oUK0MzdsrchAAeYrgYqo07CoothVcP3nrYCTwHd2ZtvR6iBFEC3h+YPnzlAqwnMTc8mBw4PeFDzK/umQ/YvuSCCSpxOkQnjtm+r3FrJwjKjmOsbi/U3HAjYrx3UJlOrOhwwzMqf08T1Rltia2MWeTdCHoW+leMK5k/zeBAIvD09zhg4vY+WV9WUhcINVVXLIWUA4WjrNOEcXgFvjnDaDNguq5p2X+abFRKrS6mjLSwoa/oMa/1h8SyBTtpGRAmfPxXPhLhXMppvRlqxYL6xOKgfMuoO7x0lAbARz2cu3Nf2sDK+sk4SeH85wIErrXm/wGSBiwG2AJRYHQa1iOsecB9so7iwugImQb/WhRHKDfR7MFHgTIDNBwVmnUZewDulS31dnllb4c0n2s76CSsPCEOmFe2Bvqq+QPsKUwjgBqbBzTG8WourtYw0uc/JglRL8auCsLWiZoouC9diRNdJDCFytX6KAIAC3ghH/xZmYPbgBa4AghtTGioNWT4E8IxMhi0Kr2cUzEk96ZzVU1oX0mDs/LQu0Skvoc/xpMBgQD/vF9jiNjVwCVCeTLkaFD968UvY6n+C7dot9D05PkwAJADOJSQYvKecwEVAcLzsnQ+gT/VPAXHtgb4B6RSQPzlwGBlg5ufgz8PdwEIA7j6Pz0E4peMn7e/rQ9l4mJ+BCU8M+n/C3xlbG8UlYid2zKRbks628kxO68dtzxqctR0XjQqbv/mhGVsi3MDabii81RSZ2gMc0nFdt24NHMtlKLlWK8N034LenoDEiUlEIxn9sNiMyG8cXRlgYfTvbmP2dUHVYfmxO344nGdHtF5CkY1EkhiHbLgNJcjMdqWGXGhW20xynUmv4hPFoEiCu32b1WcDdVhrRXKEJch7JBWTvO/1j89h0L/Qb3PDM+tX+3oAM+9S+8lKT+Walvef/ojCJsDhXBvCJeBb7kUXzmozG7N1oAVkfvfqPmrqhEZ72ifOxJ9GFhI5RdglRCfApzlBaTlheAG8Y8J3k6Py5XWNCzSupIelmO82Dx6piqydqyKV17bGBGTvf7+QRpNvnt1HQpD2nb1JftxKa3+2FDXJH9wq+adwmI4J75hSE8q9+Nv+jwnroru7qO6xodrasSE3tWuzcV3Cx7OdF3NDU2raRVqpVY6US61acv+NO3gk/uqNflKAsGjiCnQKauXERYTXUStRKegVk7BxMlkWW5G6o1+arBi/iplfqLOp16gsXehEqjVq3m+iUK7WRItFgEDg7YnwyTEw4YUG6cGkYiarIdZCEuKnzLuznyA5R63Ckis34sZkDs4cg4vGBvuE9RUVLRFumb/LWHi3KfhiLXBIp/D+1LHQaBSmSHUyOebH25DbuUicmNjhimxBsBtG+zy5ycONua2T1VC2R7b3jnPImlcD15HQPgLRiEOETb6cdbaYFRIzCJilBpNGKSCKvsBp796GvEhE4IxE0XaK5d1TN8btJS85u+x5PPRO98/a8ORhowNiI/9669kqd9WSpj///RKDlg1ZY7Qyv14y7C9hL5/gLXaLIVuns2iZG+78kj1hbL0ltZ8z6WhtPpFjx0wnOAEe1amRlOGrWfCO8ZarXSu96NymSaNCx9qqBSTvW8GR5Bf7z5IQpLP7XpDX2vtKuv9FzZk+w3D5/QveD1l1cia8Y1JNKPdwZwtt6Z5J9YwKAuo91JndYhDt/+0wNulQQCuzRYHgLx1Ux117+pEU3Ae9YhI9qSZAyIjprXbWKoJ7ABqOX3R0d239gsLkw8nP958hI8hnJJM8/nXtf15HgbdNrfTR6lYv4Vx6TLcXUM+LTUi2t9qoJpzCfibsuzgQWnINoosiswcfGUEHoHlAkKYfNdIZpnB3sfC5KTmXGIzd9CGkOZzFuV+WXH8/FqdhIqQu3b1TI/3zpNFhwiWhENBd1fitwu/9VlRVKZrnBTKCeaCKzgZ+MsJelRaQf9yLcopFqOK9P5LZY3tgOSBLphcwCwKVTJDZ7HS2so3mNr4jwBxn4lmYox2+1gLDY/KXEYPlX9gPclbkPGCzz3GGc87tlwYyvZlIohOuh2cRnZf1l7NQoYGhy2kGnFKLi8fVUqIAZOqcspT5GB8jJC+NFBR0V7FDm2OdVl1WjT1OI097SCnFD8n+cFSq0hrk+DiC/sk0o3IYDxEZpXClZUVaRt6oLD6O8i9wbO+C4X1jzwVpQDWEUPzhntY5QRpdaDxFlW8WsLsjvxOeSqWn9O7+1ZJBDxe3Rj0FFONTNx5RpV5XFBdUaZEytVyIG3kbMp3j70aOU1SfZHvvaErEZiry4KEjE59WEywTLHsd8JlGsBd6PAgEXvD17XkKD7MKOVxqlVpwsFnevNvIuJZxyhSAacfdvhusAtUO7iLlXx6aOzI7gIc8lAt6nvwQuDWL9yf7d9ZclhzPx+/sP3m1QDQOhXk83TXUNf0xBhUXBWrdWFfy+I7o0GhHphUCuLN+N6ZljDGS6YEWfUDfb/zQHtdQNUAQ0FCjkT9HodwdmXZfZSSCMjsc1VRdbHXUngIfHgC3s7DdvJssvjqLoz3RlnlXg6cXk7/oJ+vJk3/Rxwjw/UQ6eEWSS8ohCHC4uCwk8BLySiVewaReuNBjQziNKpHRUh7vZJfZ6twRmi75Si4wRf1qJzPnd/ZPzc+d9x+xJbgV7gqtEC8h4uLQ2fVCmOQcbshikw+l5tFMPC7Noub6UPx0wFTQ0TTm/1WsEj23pK1zIRvEfcwysThYM0WPYWgMIgbqICprDDIt/hZetDOTd1SoEW3nMT/eJyoW28h5dYrqPLMpt0qmkuVWmU3VeQplVQx6geumMdzSEG+ay4VA4O2Z8HfRrHlrM7ZkIBsIUlzmWIFyfmocMh2xfMHQTEMqsjisIs9YNoqEJo1aNoO84qfnGfFegoXFQspb2eZhhdHdJGNxKTgs+bL1MOEBgVCrnz9GxwiPe8l4Aqm7AFJoWWhayIEQuwmEinf4nDsiNtuZ6GSzRXdyCHOvdRWJKtl8s9DNY+VJ6KQv0IpjQ9M7EIiZCKKJo9FopMC1Avzil2nEtygoZEPzgBxDUDALwjg46svkKyMYbYyKlow4S22lFR4PyGxrAdXrCO3vX8WqnByY8Ne/aS8FWbMjl3/Lzv7tciR7fknIQwfaa20Msm8qrtTUm1uPs5yP4ALF5crOHklYghtO1p3KUL15Hc4q4r6oqeJaINIKUz7Kuos7TjPwwfuVdu26q5ZAAg+uH966Ii7cEtqGjXjhlr2+3YaN0RjWBifqJqKPhDThDQBNZKRErPRcGFv7PeSvWXtypGoybucIa0Y6qSWeXBVmHlc0Qlcr7ur9fM/FqNsctP1HHvRpiVe/oU5OvegiZIfKLkjG5yNJTQlDT0eePmE8cbXsUBffAG/kJcRq9UHjQWB5quY6eN1bOq9nsDNw8ZPG5JMADAwDkBYjE4ejFoOdN8AbKvWric5WQcB9vR3gCuf8dyBCXGU26RGB8f7npnV/OoqPJ0AvB9mvvUEi/oCAJ7auO260r0g0KY3ruL1gr8B/GNDHi1JeYuQNz8dYPvLKRqXeJEoWWaS88ZDM4M2g50ZwDOUha4duEopZYbSHh44Bj8cZMO0nwuCSIgR3d4J605h6Wn/xQF1x03WJg4J+jMo+lEnphqj6EkhDBYttOpcy7U2p7Fw1Q4t5km1ksbKNT7QYhi5gTDfAhpi8BumiFKvZctXQFLVCx877V0gV/lv+DUR5K8GqGrihg+cNc6YWFyMw8N0M+hF4MT98vZBGlgTanRT1b8IJRrYf/Wi570SSkuANeiGChxe5IkWI6e7T24KbFTIAaRnXRtIbS92Ruh3DijkGfAFbrZp+7yfR1w1jRQaJdq6OLMzHE3tUI750t6CsU+kH6OzK5eSZ8zi5EWeCxRtyOpnMsr4GXkuVKuUdIlzspyo0xHK5FBcSaqwUDltLKddkGmKzHFx3r99gjhXMLTWSapU6nw0lUeuNdUYkWQdxFTZbOsrKuyMRutNJn6juftQdlgTPLJWKdJIKiY24/Vc6ATIYdDABPTYslhKCYtCR96lKGrVBPKCAJCAQoBjkBADy2YdaHblBmzXi4t7Z2hrpIP07gVPqU/Ad/y21wLU1fEOYOtXpyZ1uCdRzQL4N4erBUkYRSXlYZBkKmvUFx9bgTmaakh/5PQo/Ev2aGAiFrCT+lJ+2blhAU02xE656O+V/0HESIvpiFmLYc4iamERPSDCgocvGdqduSwrVlPuLTp5++Iea3dn9r26XqHSdwCNItSlCEtO1TCODSTQsdGJ4XHtG9LIa3wq39qANKr2UgzCv2yZZjUbC8fy/vjXCLBH5sTszh0Cj0BqTgOwjkrMxmUXZ0Pga7jd7vKbS66wvDyXYpfYgtNzAB5ce7MzLP/qj2cEKp2dYfUVSkXTQ3fJlTLbnJ2H7xh08Ts3bg7uEvvAG0QbsNmMd5ZM8hqjNV2+izM0E9n8NH0AfIMyIRMBINQKJMWksPRL16smLl5T0Qp/8+eocLRejUhpR+eSYVLRSPo9D48yTC3hZbAo7izeN5BjkEDjeOh49RuxSKZluZEza2b69NjPex4M5JqbFQ1KGwxy8eI8h2agpIBrwxE9oBJcOnY0Zohl6A+/23MQUNaUd5uLBirC3YSW83hsTkyDwyKTc3FsvB2ny4lmV2pUAtmjrdlHpOl5xerWorGTI0mAR+1uqeXeOBLknRHtih8SrRCvzbP0x9IXlQAMzHTCJTI0MyAy40fl+749DJTzF8L5qwfsH8/M3i3p4HxM2dz/sj6UD8ZUslhWuJugkgcPKRBMA/e7rdpoWqPWGVNISl2MTQWPXyJgpJEzw7X8jpaBM6TPa9YaCPMwjdPYlRNqrk3FQTP4MIh7x3/+H9j/4hNFEHf+WFnIZPB6PwS08vvXdbNFYdENE5GLv/+mGwziwRf6+3lBbnGQGuT8TlyiCbhgrmi1911r4fqv6fXPxcJiRsmBH0wIQBnt+CqamdA7keQ8kuo2OsFnNAmbnX7Srdn1VzbuUPxt4q4aHjQ53UvvzEa6qltraqhaXVMU5AutcKe5U1KUVmcSmNWbGCqw5Pjws8wFclyHdMxQxFTF0j38GsFMGyHaunfJA+mDXelOWS+L6/2cpw/+j9v3n+s6wSIf++9nabBwERkbt1QMJgHx3piZLcK6fF/pGDt+CYabSazDwPVf7yQxvt9/NcoCZsCaRqRpvS9gESIprjRlmp8gwGDYExzCK3BmGWnPRqFk/+/2p+VzB7ll249qNZWvYFX8/HXtv4PEwWFVme9/8LWt3LYobXCRJcpYklluFnvA3XPx3duWwpYAEyxTUwiKfB65r4uJVgx2S8ivXNJRNCBv7Wxu/Jsc+VGc3aHwL8b+qvlnYwzk2ZO3bXOyxHrtozBx/gsiW8TZLoFCr0LdvQVFhJC6bTKyhiOpMMaJ/nm78k1SOjX0/xc2YbPc3ssFEeJEk2WUeXKTjkWuIxBwcopgOvTmE5xNR0KDT7Lu9YP73RQQeLKWH7ZC0Xr+qJizNMLNWavKD06ftFYZ+XjQi0OfqC4xY9HMI4C444JK4hg0EWxg/NF/dAJzmj0PwAX76BP5p4H9gHcw8VucEXKMs1gdtF/n/UZIA1RyY6XCQLTd38gdZcvrJlTunLbfIgUqv764PFokPd50E5qjXEbOJRMp6cs5TgSC3zGpsYuq/DhrMVGsSmWrUeyXFBFRUxcLBQENV1Yqam6KbtSEAd7RthmAFh8dZIZjx4++IwyjIFDic0sCLrHHEu90qubLbFinzQC/f0LiVFcB5Hp13HpgpmMivKqAUVPEnDkBTiGeaFZvQ3FzqE+ZjyVjsoyxE/DpyXRTGoPXYCH0L4A8jRTu7rnZpyD9QeglWoLWmKtfCaMxMTp0KAEeLN2BkGoVSXi2t7kqu4eD+K4w9DEo7Kg6Wv4Ma4z0M5KTwp/1ye4qyfjBiBBKN2Lrr5e+Dn7c++7vFkHuEmgDuTR4pjm3lyv5OPuz89TS8aHjptY5h1tFGJUbvWaVBODW+4spMNlbopIjV2FKA6My2291a6S/I7pl/wDSZbErfv5nT4geFxKQodqJMQ932f7885Bp5TpFEajMOIM2VvHvbVy47gsjajRha55qUrBasyhrmoESafx+Z8f7M3YoF5E5tErGHnFUA2VwUdf6E2XhIvMPUhCwrFhenJZ4z19CgBLSG5H2Tr6W18N7zwnS/HOOVzvj1USD3oCKoxDiAITJLfhjdZjSS6iCKG+pUBmON0SLJW/QSz9Ss3hwDHHLzbnJCO9UG3g+3RrvnJx9GuDU4uj2xy3B45RWqIIt02exmpaJXZsh9CUc8B5nF4uKRz/oO8Y4tCd0R9+5J4MYEnqA9z4Eg5Lj5swEn0zH6JMzcYf3SKK4rx6K+aEbbTmOjvBwaiPRgRIZBl2NdXg9sJcUg8HV3W8s2q5F3AMR0+U3hUt+2G2LT8QDJ47Ury9AjTwjBXZ/sgnbjaTxZLbep56J5oyJv7H0s5LvaGZ703QUzYK8vs5F19MyF7EbTi/26ZLGDulqbSl5eUBQ/v6AA2NSwl9nyYMGv8b9mFsxuyprPDqO8Gi8+c1LjgbTGdZepC7kd0NV7ly5lUVwPFB+Q3HIE7nIrGdh+NLovK+PFd7BlHoI6Bq09ZWkYQgEqyNNP7eFSDEq9fEwn6wegsdtPemxUR7PETV6OLWLLGJo31PSRlIGZb1BngHo5dQ7WnL1/5HXKyi0d2bh0NOZRFuJLL+S7HakyFWjNmTdXJez+9OjWDwCYlotGaRpQI8gt9dp/7+RpdkYEG5LzzUgl1sgHKM7TDvTGywniXwW9IkDUFbM2dg0Hhp+JW49q3gvqLXiI7sMkToR72luj03qp038ashPM30iTyxH+6KNDhWpwhqowH9KWxabZT50PSPSlWeALbswG3ER7DbeRImU2opaevEgAanQ77UreNEaORt4NuZLURkCiO0m/U16ShDAg2o3e9GKvu/ZawLNJB7EI8zMOmDa+8GwwA6ffIs83Dn40VnlvER9HivRh2nhbyns5O8cusBKfFJttAcw02CP1DI6Cm8HGS8dPGCKfFuH+bMhbc0y873UyxiCrrp2XYbihqcDqordoqQ9d1XUtldYa07A7nWwVyCvFiy3tfEc4b6rTw5rmDDZztApneWNl+ghzkgDMtNcr9paDlnPKFS/ixHpvKjzJ0UWKWsUA/Ts+y9AoRZCb5uh43+Mklg8J7kqY6b4XJzOUOMuFA5aU+UYZMAPpbuMup+uAXMJh27zsWQyZzMZ/M3hBjWhPawSuAZHu3V4DjEdtBstu/2CJ5wFvVunrSkXNHMDxzcfANRMgLl9lS2ytpmJ95dsK5h2C7JwET4jvgnOwrbGsiKyjF/xrXFZ/YdQ6RSRbX9cGN3Xcw9k4G/yMTfyDbydgO18OsunqDFe8W51O91XvwI76hFBpTbWPLVci3Mtj4yxLXSSnFLt8Tl2FO+yF+SQfngjFIm23oCOo2Uf/IJEYudSyBppSvP4VY8JP9Kxwg2DbH9Dw8MoYQLI/KcnuOSAMpczyn/WN+0B/EywwJQRwp0XQR5x8sDM7TuPpM9Q6qXU7Q1y0J6NAWsco8qdF9NU73LK6aIbzGZAKZCo+TSBvVPqJXLDJOHBhb/o+5bLGMhdZR6eMieJPakt4X4YOaRgIU803obm7ZMMfVf86uRm4KYmIq5c27ibFO6WdpkwX0Au4MoUo01LT6BIfCYx5Xwp9v8z68YisXXPVLX1THGqX3ftYwpsdcA0XrTXweCC2RCKnDDf6mgV2OwKA/4eRS7AlPNDAWysa7grMieusPJXGIrfnZOpOqgh5eSrCyUxdTjuZlbanuzNudleS5IGg44dLwy+VSg1Sf5efdZvZiIUD3hylhdRi1Q+uRzqTve9oDw+0tQk/GLhqHOaHdzMb8ug8HpQ+bJYe7YAZYGN9Sj3PSVxNCMhkxIgC9NLqpGJrYUuh2Cq9Xd6te8AVIJDvcGlkwIa/YEKjUmIIGn0FmRLmWSqKuikvtjv8G7WKjCJPywls/pbSsLHbVrbhfwqvfc85033hjnEcK3AOALuqrgSXdC4Jt1/+bmZ+R8HemU3PeYHVb5ZdY8emakdDOwRYHRE/i5qBSf4TymnS7NAAfwITrOf3I0rGZFBn4Yk6rKADOlo7lR27tuxNYDUPmD/trWY/DTBgt4/5/3yE88wI7spskgBH6EcjFF8gd07lFHbmInKIQlBayGbR0nLeswVHGRjrCmsBFPVI4is1FhbsQEG3fBRQk7qSkcul99QPaLYkTCJfcDGaOvMEs4sA+3xb2WHiNhL0agmD0kUkGrCY/6XQOcbF7NiHA/8FVvCARTPemvZrgM9by+GcdCoBgce8Q6W97IUSEyCId1toQ80JI8ssVuAid+Kzke+uudryxAmprgXfFJu81Z6ZMAhq0OlcThOUZJ2WPMKkgDZpdtCPKqi33d/2IY/EQvbe38tsCZA2JaTrfldlR84VOrpayqzdb7qtZS1dDiC1JLUTPAHDmh0VM2fMQKPDjIHt6fqCaTCMOVdNygdRVVqgKgl8YXPNWNiJSOBr8lfaHcYgxh0ai683zjJapNxFslJ7DlD3AaGmHwFV140uFRG2r2J4vEboOw6dNIwKOG12zzgQ+AAoO4BtfM4+yrfKDUEemWzYlL8Doq7eLhHwEDK/5yycuDz1GbCQMNeG1i8Q8urWlVm76wBw9lh30F1UFHS7OSmS/AuMHMaF/OCN1j0fueivvF6DhvRaaFriil7RHWi7cbDemK4FQ4NpAjdqV71YDd0nBcCuWqd1zp5pOnyKjw/OsTqbDr+DFxgRadu9cs9/nRUbHT4X6pD0UKqr0FMo9MhX9wpf4KJKtIQKhZYW0+hD1OViONdJOkoJ5LXudXEhtrUCVN8hB5EjcNPkOmJlYSECgedKxQKraoHKIvGufDtoPHUTvuE41ABzghJiyQFVFovHYofrbWPvLQoOPZpfMI+GcvmWTszn6/e+QPuV19MbhsXKq5pqavVcKXBIIpAcAlqIR3LxD8Fvm0IAzl9nVzgN0D1BDiAOLnlT7f2Knic9Fafugdtl6wuHytzDTmmmvQNWndCsXF0PRaXhiBISYSWdbzaQPfoNpRCNxbOQ0hW2EAvz6SsJJAkRl4aC1q8+rTixCrhnrgE27zGUptOw6aVrDTb/kwuX+7P2PUJjulXn+s4+kut2G6RksVZZGJNFBFq5gCp8U1hokXBFgWsBOazckaPh2dETsKocconfchMG7WqYTc/PMeuEldglg/EBA0ykpH2k+afsPzP9gHatWGkhZe6dZqPz2yw8hSA7Dm5y9PbvEHz7hzx461FD+flN2jodjp3/4/UMqpmIp2AzGL2w4qTMyrcjUmsTNy1opFNYTp/v7dXjE7c7tBL0Ho96cg/yg5ejZaa1xNczeCEoYxByibi4HMJLGJGauq8tum1L+hMASAHcE14qR0I5I0Mv3cBVALg75Jli3JvZvDxTkWDaohEtLaieJtCSzkp7hhcJGI+UF1h8BqPKaOMs197NCsoHVq2t7D5hPGAw5ZoM9YpjrP2lYvwCYegTLc2YJhwRq25ef8uzfk3+Axgxh6VOLyfqQ6JGDK5zBCmhAGi6ZgKBgSMZql2U5ctn+4FrXFPd/ej674XsfE5qD/StAEzPOmsbYzU1jbFap0wKXJAoJReAsYzxLdOJrN7kCdWFwpxLlFHtwAbGIQcLm/l0jmO0PJcCB8UEyUFgfKJmYUNdmaeisarWARjvTQoHun+RGIFEwCx53R0If7s7Fy4rzTr9J8eVEfWQybMQmNnFfGmiLJEV87f51FYpt736ZXa6ShHLNwfyppd4WdOLA60FcxfBNXVsawlzfFzR6Iy80ULFjYFY2COsrhqmCmzg2IJ50zweBJI2gG2dpznWG7PI+cbdDdM0HhV0qvOoTigttfsbaqtL2xg63v+DbPPe8QYUs0eJGsyLQ5f7NbGVf2WO+q66YY9Eov677YB99yf6nROBibuvVOyo87zQzP5t1di5wFw+Zwk1VARAgPu+j7yHToqiAsVmu6ebg9HcXUd09dDgsiBVpSNXqgrJlUq9h8rn9N2FFlhXWDGM1TyF3utKOeR/CO2wlpoI529DvigQ6H4CTkDK3k4yI5b/6dXgww0wCF7g/ct9V0ID7PvM4vgSA9sEeJrykiITfH7OgffXOUYECUhcDntJaoVZy5anaKXCPTc/1kguTnEdfwptiVUH60a2Nj8HJ64h+ESNBV6q+V0EgMJQ/i7fldAeg4L2IyHXietQzEasUS0qOSTvoOcnJHuMipnj36Ji4hi57fR1fXcYasDIiVTAx117wKd2qd2knV4A6ydKJ34CMRtxpeO4lnwWNqDpmmTKbL0Wtd+xif8jQOkEwAvX35NH9hgNw9uubtsyu769FDZj7r26N63Sukdab9woW7Oi21a2uuuUV9rnBxxbLbebpVYOQqYnmRJe83Dus9vJn94JW5mn8tQVHpVx7l9i8JtbmmD/++/Ckf7cu54eVe449jcVhWJseFuW/Li/VqPC87wzn67wYucCQQ7bnV5uAv4pKwG/RhLGmxQA+8lJEVS+3ShsLyBozbl1BGvXm4RwSnTBMI/wetsPVslg3+ZUGX4S8R/hfPRXD1J7SBk6rZJN2zT9frfeHjlqhLdmSSe4cF0F45jxsFHjvy5guvbqQhD4Or88s2AL0PK7uEAH+wn2vtrzqwhOAL+wULHvrruuhA6MEhZ1hcus3Se7rWXh79IB3eoILzGOQ14DQGOBXdVXgocxuxzJ8W771XVxsFPrxXWC9ThgSTSxQddjR5aJ/8D+YZwSJ4v5fkloesyfmrXvmAypJni4CS71073Ob8nyQZzenjEosgCHS8MggzchBzMR0Aq646wdl//FrSfA7tuLQ/PKUiu/bWjk7Kb/3BaAbQq7XW+cm03mBjN1pXoEHYzS1UZClUJJq1CBPiofOmSib3kiFPOCIaP6LEWllmTntYVF1VvxkUi9j6HBPs02sDy6ZjWxQYugojM/SIi2zkuUYomcl8egj+LO0q01mN8Tvc8zlQEEPyzkgnX3oz1nIlH/VK/EC/vk/HwTrzamhgBcT2VN1Yz+g1WYFexLN4k0xtUFn1ev8Du/JTGwdEsqT+ZEUTMd4vUcrDrpmiLQ0wQ3thUUB1jTvSXM6dZATb5SbqMXweSBawER1yZVewJtMVaiLFFaXTUmynqXtLV8RR6f9mfN7C0FkcMNAKUvtpNf++9HB9goKcOMoq3MMkOfhrO5NpLcVbgpH64MZp0BtldeomZort1tUhDxZeUcglpy5hinWf7LLf/Ny9DWcVUBXk6RXlSOm9IQNDpdBEDq+uf87r8f3ZNloFd9JPRuRTfWvBNtrJj3cJrlm3W918v404faa8heqrgNz3LHEE5yYK3pRkwaU70sAVWLtGVWHVcuGtA2Xw3AeTWAybQOSMdR9fv49dvO+CNtga/ukM5K16OwT2oTMzYIT2oRrU4YlPIXZXEa4dmLvWbyeNaivQbnJnK9lS0x29UkHObt22UXUdlWgiQWbYkqPrCM2LG51xNtie0/EGbE2XXYI+rbwo7gI5u/sqOUtcl0fIqd7WucHPaBuYfaUdlBmwydsSb6jPg0NrD0jj31iEJbIz7ACSRxsNUBiDCyITW/sSw2XPhYx4x2izidJ9WEKGPNnuz1zskc+iG2rGJkcFAiF8BEfHUGAwtQvJNdRdoMTimTFXZ4xX3MstT6mt1CX9882awjFVkzxy6lQJaqanSi4lvZvD4fQF/iPfp1GSeAL9V4umTx3I8eWC8MmWbW/hR9gfaZYNgEAhCXZrX07Bxffx/4nbRNBq40x4+subqu4gLjkvWK9Z+Cbg/RRJJhv+6epzjmIn8wTQAMphyTgYiT/uSeiumDJF+9/bXT0xHHZmBf95j71ovC66dS2lL58mKUIHqJ0b5JupB96Tknh6lKawv9xJ82/1aqvar+Mhy9h43o1NDGfKub3mFkPtT6/+usqSf6EAGNqJH9KzHUGIEA4BCNt6H3KpHxMB2nucgxjKFSOCuGNWIqCdWhphnYBC888/wTTOTTS6NLv1bItGHKaENY7JX8n9B5yvps2WRHBtc9QeAJM6c5S1hTO98dtxCProXSEEiWCr8RaWGviDW0Dkst1wi+Lw1QjKleoZwYlRk8dADw0uQ6QrlMjYtyLGoh/w93JhdfnTO72vTZt94V0AEusZTv1k070Ezdxaxm7qJGHIXdFAkGUWZf3/0NgpaqxCrahzlqmcGXN1RHmd1WvQSHgeMKcEMpLRBUZoYhEzEikwiyRGojj58d3xfDrFLDNum4w7JKlmoV/xEyRyAyDRmZKEi0eIitcAiOm4PPw1DTUHAsCpesiZZ/FxG0bKHWyCqgsKgwTzBH4BSPO7GwT7b+95I3ApnAZJs8ZcpuWGittvAtu1vFZxzVRRpMERCQk8eih1xsBw8njIIuupgjVskl2PoJ5VV7tXqrXScgOX90kJ5dBVONpjHqaSvp/COAxKbXMokbiXBORpWP/VuyXcGdjJDOFtq0e7Q6q5iL+H8JKx36MS+HrecWFgKfnZP3DArOzeWWk4NMYg86Bd1DnJ2RsI0YzB6SHSTm11pSJYiUAidPT75u+UHoZEQP0M1vx/jUzlTtE9YaYzuEtTNYi7r2CWtXmMrdozj3e3Jc+6uh0G0nA7e9tNJbj++YGE2GceO3Lx5h4mg148d9tx0AYMkiKYwzB+/eZTRs8iAeex9bcB4YWZMfITybGtbeHai1BB6ymoLrFzeyx1u3goyV9ARd4bLe9T8ZnJ/cIxAETuYNvFpedTCtc8HEDjwJqEB61J68k08GNGl7Ou/oYLomLTaLFkxYaWOa9mR2KkuJWkmy0r1Ij2L5RcQiO/WUB+nNSt+bR/HPZfssJaNSs4tajPnSKZcuBXb7e5EEM/+OPNnxmCCfWuatriYcR7AkaySFaBTHh4qWn5ImVmEwFnsLOUriGTAmy0hs5l0eJj5DoCxAQeUVw4hpZKl8erWtuJVvsXUInUHGaF0JDxOUGHwMeXTU+KThQ9ZI2HAuFBqIIMNG5TuwCydKyyvRMUY7gx1Cm6WVbyumV/NTZZoYQ/kYM1GNakURmbNekLKzSS9mZXrybZlj8SpmLk7VaMvmRB2lomVEAooT1qgRp8pl4lVjrZkFHnoUtedVnLcTrh/J8Xt57bpwaLGdy9GCLFWLWphTolb5KXyul6iS0dxCepp6ghI84PbCiIvNIjPOxtZwh5e4RuQLt8L1EywQaDVsnK0Y7zQbveEGPKAEJ6Sp6UKaWyXzErl8P0WtyikRqlUtIIujtXNDi8M6XrvfO5IjbCxHRiSS1tRUG23L1AsURJ/4/ckHy/ROHVXl6bxE6YehqVba1smHKAAOsHox26lj6YlcQy6TGcLzsRAsHx/5oZ+N4P5EQVF/4v7Zbl75M273WY8E8qf1zEldC8ogPtORaMGs1fT1Lxn0XA59RvWEHqNRfJlSIdT5M/oh/SUulIhpp8tksdk87T97mczN/2h5s2NvKr+/olmq9B5zFv6bJH+EzqyHQV7Qcbj4FwSsPhP9CIv9xnBzjypdzqxEv8OxcO/QkUA35s9UBQYjT/2gRB9S5f4VqX86mWHMQzwW/xADOBtFJqVAgDLR+v3Jm+Edc2NUuJWpJvSjEnJyHL/wKDdd+D9REPSfYvXvMdPJHDLw6/W8GdH81OK/gaMV73/TLSD39XwXfeoPH+DAH/+lqRlSxBk21T6SlZGdvWHcGkZZQvn/EPlpJe/GpKIh6FRMdC5cFF+jnCDFG9QK0s150Vl88Le9TObe30D+rGie2dht2+9kjFutzmF76Qpax2nPQyjncuun29RIrIPyE5DlEkmzh4i2TjlPICQQt6OrOl7Z3VPpsLrtdmzTr5pr3e9lTlwFUOgorC+TqsdF/zJ/hVG1F05EeZnW/SRgjXf8Kr1RvJwcY5fAm1XWA17WxFXmr0PEdOdMPvh6PYOx/jXIn+mki8/2jJ+sB8XSGVawsVdgZzMVtClJ5tFXuPUTbM2NH0FVU+i8WYmXCdmfq8vlQClwhFMsjqamhIEtU85REF387gVdeqN4OTkiZjWc2R/f92ZVmRmND7srk6YUyRnI00/Eh5OavIgZzkA7+CkR9uKlaiFhT/zg6MJwGnziFE5IiQL5pvWZmZifzrqI+WX2dOkn4CFVfSIZDPMAj8M/wEQ0zQzCIyYM+Txcrirljf9vpv0Nz24eaMWbdOd3uKLy64Mh8rV3MSsBNvD/g+LoUaEKEfA0ORJ2zw57dsghwMbvfkuV35i36a/S4YlrYgw/uh1j/cVKPj9ifHrKY0o/mlPmlbfGa2cOMvD3F8gtW36fGa+Rt5V5R3P0/sVFXPBt9j89mjQqUJlrM+fHCgvzYzZzZS5A1aT1/I16ywUXF/mXMs2EEQQzk0kwjzATmAJv/tk3SRPI6KfphVhsYfpTNHlC0psr3vwTmkfJ5kniSEQ82WIRT45EJonNcJVjWHoG24lTC9nG2Vcbr85mG9VCJ46dkT7MoRpBejxBkA7q6EGBkB4gy5OArrS4/+q/h3fnMfy6rwYjlTLr7As6ff26wzUWXMtQes5ZGpzTo4qb4M7dT9ieNTRrG4FwaH6NDtc5eUyHNPCkZ66dBZwnVzv/asIF9uRWbskTW5hN0QnMLD9UgFVHgJMjXARGtVGeGH1otHFtnGeKLhWlFW+KGWyYm8p1rXRh/3mqbUJ/32MOY3rYaojzh3MdSH93x/xrWNRfrWpZ+fxnb5J9l1S/cVyo4h3QQA3KhkxN2533Q1WnbiI9zvg5wjwjmmfLrLPYXJvHgkbzKf3zov5qVQt9NrgS555Wk2fIUtB7g+NFg2hwQNrT5v+s8wqQkjaJVhmOicw6i821eSxo39A9ujEW+Te1qgWmcwp3QkKDzcL8t1B/tapFfWjyIrJEkH7uPgS9zfE5GxiavTvvz6pc3VzlujOTiAXNtoT0x5NaNBimN+xGC6hFg2E65+CRZSU69iHi80vzygPW31qtpfe5wu7fZHvS8AuM4+yde2NvwIHAQ9xE9D6eHy1+nT/mlWvyitNNi9HK0Fuu4N1JSSDsn5tXoqs/dyfk+0nnDDademzit78V/K/mc2Gh1WVLTIQTwwDnvw8XH4wGHBfmf13UX61qoY83TXEJUj8bV3yDOu+LE657bkgxyqnK16T62bhsVNbs3Xk/PrXpDT6NbB4LmtBG+vOJ1o23V+yBaGH+PNRKi7PRD/HHkJ/Yw5O4D8nCfCDUX61qoY8XWHyD1M/GlafGIkhTHXXxlTReLQ+o8pVYObIAJQllbCOyM7vgHLVx6Yetbc6qNawen7Rm7iXk75KsHJkFxOfN5UH5Y22QofUAPNUrK9G6naIKUhwfUGnRQdrrPstMPe6GH6o6dROnOOMcYX6J5g+ZdXX2Zd/990pW3gEkah3XkmFRVoJBd2DhR9E/u+8lV6hXVlJL46XkYsGMSXug3nh9zNDHbvizqZz7M43sm982KCEFnUje3VMV4/LmqmE34pyiB1ClXllJLY0PzVILypi0h6IDJ5IPWxjWw+tpdGZs0wCo7+mEFtBhVCra3zAlBd2Z3gidQamPyVsfaGPyFYqI7CgzIkBiuoAIUq+sROu1Lk1BGZP2UFyg0xfnme65TPGlL1W+JhXtIStlfeyGH5/a9LacRvbNb4M2kuBE9oA5YBfQA2WSs8HJ3F49cEkUY7GAMUG9shKtF1gmBymOD2hRcUGqte/klQ4lVPlKxIqKrJTxiche7Z03rMYAZ5asJTbearKeSG47GxlqFccHVAUJYQG2pFzMD4J0J6PGcIHwenf2qkQPiJhoSoVakz6Pt4aRzsyMNlr7tRSX4aP/ZKHOPuZaoJsT/68jnENg+NAVf0xT3az81NojF+oaAdRfNUIUzi5WlJLo2vLCg7dr4DDlK+a6KDWVPqgO6hunjyoM6WsR3oOSWYPNRcOFXAzCw8oECHPRT4Oc7w4OQzM+ZlV4a91Nip0q0qHx8HuOH0zMqw1bLUUkTb7roKAbzxrZXoumoi06hDlxUutXqUCptYnktxHnWQpGpllhkdLFihpOhU//c+ebm5XAXnsrS+g+/Vkv2yXkDfvzQ3+RLOxqxGsNVCrJtMsxeziQN/qrnrkLkwzq628yLuy4hV9tAF8Lr4GwGIzrUIckg77oH9p313kMOY6xFPT8EYFVNEcB8HoCI4jSG3s07D8AOBzemPDBFzN+WLDiTyDBhBCah+EOXf5B8/X3dFDkIUuB2V/Yb3G8Xnkr9j9Fn1n4yn3+M94PsvsX9/fBB08ZfPCf/R//R++//qu9W5TH1XblUUO63r1C6R93w5/XYC76fHABnL5MCOAa/xsN3/1VQkdJyQ5nVYSN9Un26fzBi+4XFaJHtJXPa6V6nsbjcjGT+k5Q/sr5xN2B3XWrLAetpjY0T9LJL4V3f/K1Msi9elpIirOqpwWrqDiv5Hjjc+aINkVbo2gXXSYhfKG2uN8RbKVSpi2DHearEMKscTMwcZkOXZ9LP+u1ivLyhWBqOBcJarCnX01rCa9F7Ahh2++GrVTKtGWwK1+FEGbdZmDiMh26Ppd+1msVUd5VUANwkQJOHOF4Syw/0DiNkG5rOoPB7qMyfYnwULsC9DJa3f7BYfdRg22DlwArPgyhwTSaoSNJVz01AA9TQCVq7lOCqHI1s4Rq8Qjbj8Gh+sRo0eb2FO4fJKg+sXV6u5cT9K5zmh7kihFigdyo/eggNx82TAqYp75x2+gXHHW/UoOcEyU9TCYIkldv8/Llbt+OiMnjjrhX8QjXo8Hpjhc9FMj2u3FCu9IXAjlrXuaf3K7UIHKS70DT370PGqHG7t/vzpaPOe3gDuZJe2o3XfsR0ur2Dw5bUQRtGjxYvhKiGzMXmtu1Ma8FSWFZUdoS8LmP6XB8fc2YZoLrAOw5aIln/pdLWp0vD6BLZZ9Fp1F8NtgaZZ+gcbZiObOwAxRzObmrSWx7xgjD6vYPDltRKWjTYKe78lWIVzFzaRZTqx0GtavQKW4JxRR3i9vhJupV68Ot63DAnD1Coe63LfULbenJIZRr26uoLZi/7aAD+bECCfuwL49kzTumCdRxnMNZ2dqK+1BPczlKkTypVybEVGYh6ytutS4QJjw0lMPhfqGnPf9n3jhNTItuNjjO4aaSsQSjGVg2RnOrQNRxnMOUZZVrC35+DkcpyivH95QxDiW2CTOmqael5tzUITu8tt991JY4Ssz+Ifc3udo0Edr1208dh95d5njrMKfZHSzaXNnG3+bK67nydRXITX5ggdyH06JHVdE2P3HWtzRgckfzq/1ufL1Urphf0WcpDCn0/jxN0+Nbu69pWlnK+KDCTB3HOWzKMvhDbeG+6mhsiryvx6UN/Hpt7pDjVkJ3D4cwY5p6Wtb3l8L7zYGxhUY5TYHj2eG1/e5txvKoeZ6Rm3Ljbi4Foo7jHDZlGfx8vOpoTBFP8srpfxjDtqulAI5qZZi9x+22kFuD8cF8e5o4vFuW+sUR9MnIDq8tuO5pvKpsS4+iVclsbhICx2eVRxuL+fLcUe6MpMKjhhwZB/Ip1yYhW9Dp9jISPR49NgV2e1g9boZb8T2TOLhlrhVb4rVd1RZ1D0pn18wpRb4F9wjIj2ABecTiR5w+klvN5IeIHGGMNiJ7krxoZjMvaSz3xUt0w+QISW8Orjsy3d7d1+yS6OH7k+AMeguJ6TkMt406bgmPGO6RA48M472lwgO9K/gstVHodns5J/9gL3U8C87ucW4wyqwI2Mp/nTnRwb2QtvQgUQNVFowmvSj41N40y9jJDTtORpnRRAdrAk+WCvwPSsn5P4dauOcEnB7Ie5hT2/X/ijUjNZg7P1EvZuLn+bA2pnCVzyoBs4MbfRonbSSBrOajA+pggwYCkyuPJRRCUuuj0MAfMtChRv73jVkMw+tNw89/ywcrogUOtmNd6Hxr27weNFdEX664Fvqjbau40Z6NcGkTliIbbp8xugl2DoWUd7AHC+f/wrXtXwoaYNGY1uOGCx0xTodY0HdrYK1rEacVu0YZ6US/hM74eH8kS/jkL+DhOzB+DiD8+gaNwF4EoG/S5sarfO/aDfYJVXmaE+1vh7+jet3/M+xnhJ80uVHqQEud7z7Jgh4fLidzcbagOg2NGpX+b/6lydXCKM86s285R54JUC0vbGxRJKDMoqm8vT1pVdyPYdI8d8xBHaepDz0O+WK5eiE3jYqRUDANyFNLK53GlbBq7lnPFO1TAKU5kfJgphr1kcGk7Q+MQJ/rmRMYloBsI4CVs27GUrAGpnAZIwC1j5lMa4AeM+xGwpn1NytWpqMlVPB1FKj1oAcEqUdd+ILgwI9jEiJ2YcEoEgvf8kAvOm1pAkgFvEwIa+WtqRlaMlc3StJS9LjQijrkvzQHpQI65qhwp6BsLwJBIpHo31rrDdZQpEiUtW4ZTHWq67WsH8ThO6x5RtHOgwxxUc/n/v9QrvYqIDThu9dq7SPRS6/eoZjOYGdTTwtvbaY+Re4gNdHrnTJ4hsVtkvcwFpCO5g1ii1MIe/SMB+aqZ/V/bP6/Z+DHILHHAHe3sKOu0+216TPoB0aAxJJ/fXPZnyh9zcQjcs1gX9MkolYfzYikos1ZL1TdYldRnorZhh6VNYK+zci43BHmBpnOgLpIriuu7qa0qQdMSHlywd0DhBld8EJmDazq+9R1TiYEMvsCBBKIXjjo3MYBcMgZcANOcxnHWQjoUXa5RlvTI6xukRemvFSDQqsTAmUf2oRS11UfVg2aKqbCfni/WbfMjA11rlCV3lCl3Cdhdm+rRFBqELKwO8bkw1eZAyTS573S30UUFW84AnV47x58b0U8K33rmtugadoxZPJAiCEgf+quZ01V4uHcAmHQepcJTRklpzjWo/85+kB9SX2k8PYBUAxVoTYospFzE5TyGDdBTBH4IzE2un2ky8lN1EvniVLiOOLuhekytYSsohqTVls7WdAlnjRKRojJ2gvMlKGMlZHgZom6MyOnvSAR52EVrUdn6mr9qlBLWgaQiXfP6oqp9Xa4tUTkmkPuaeTInaz8MK3LgFYyox6OVjBXHOKNLY4f5q5Gu+mqapUUE+VuuBONZK5BsDDPjDbIIGOjjet2NdkxmbK9Io66EzMgkG6kw84EE5HmBkkeL9JW2JSAYvsyhrNmYduKFSDqKdQBdqzwDFAh9BQV4n9AmsGUQ0KofwnC/z2Ure/xXlP1+cDWmCgISnaRfB5HjbUxrjTbXZHVzWdnIwieNtDI1wCDamrzjYwa+uyHesoOiedTnJ2XGtNZGa3i4v0mPcZx4jkRdXa+TWuOB06hgm2CuwEwj+bh5ZZSpbSipibFiUqQRNGA5shE5ZSGgDJqDlw0YJDab2d+EERQBx4UIUKXgGCoORdJHvEsHsSTjEWDCS+nGF8ppHS34bh4rKwhNqtbLJU4i50zLjiHjV2k57u2r9yiq/TduhEQKr8oBpq70HkwyuuUkyP+aiaTxfU1LpTKKTpKQrYpARWKlMGPUqirOYueI93e08va4rgj4qMFh2wwo01cfILAKVKJxdJlyEpjGW1inV2KcbpgFJtMIsFfMBGDxQ2Y/6afJyHvhcyde+oWAh1LhCGFbJRCVq7M7xNxeQRmiUX6DD4RjRRRQyFKKck11zSZFoEJ8nWQXqeUs3ZKZg0XqQq9pzmhce8/lDRGcWfBUgutoYXtFCFjVzVbOWPOcy0x2qzHrZKH464iSLpE65ocb/JeHckICgc1S8t5girk39k0M/cfRAa+n3SasxilcuSIlbyUXUDm3+IR8o8dh6bYMRgYfC4kQ94HauHyqcWuAIgzKFT75LkfIjXRmT3CJp7T4IILjvu6fuzBxwm0Hd0bhNxk/ehaqOhEIpgUzcygIiYdeOeAoKZTkWDp8qeSz9Rs52xuM4kW5bL2RVpO+xaHWu9ZQ/rMQolTwxoiz07uQprd06rpM0KUgRroPd1MTerRl7GDlbs8W8XwyTX02b+wzUFbWc4qYghxM6T7gAIBC8RnwsyQozI2i3gs3zGp8PKm/okXtjg52U5Sb2qdztoG5p2Jo4p7NdQ6ks056hSUVTY3+DWUCms9bpf2WlyZb8/Ha8BGSuSGMgwExHBvWdqDsRwn46y9OG5KRRX/+DLsLhHiKI6P4qbSBA3tP3XgiB1HJhT0ahU4kxU2saktnJ+9YtuwhwC2AHzebSt7X7pYKMndHJGPEFiFkhjiPkfHlQ3D1UOeWVgi27MenypRRp3NXSU/QVDZiEFDDATEWQHv6GnRStYuhcrx9EGwY5a3YZkjPZq7dNqCiG+V7v8zk7YVqMgO0kJbTKx/R1eqJ42kLZVX5sa6Kbt+uXpkIQS9xOFVRTSiQq0qqGJ4u7VF9gigUm/B6B8nu4xZdE/DpEXLa55LNcnM/JcGQqXsraxdyt/puxbwoQU6qKuDM1aOlR+C8jeKjpHEtcvrv/CGyl0d2bAI8BofcU/bDWw2FGnb2WE5jryTHp/6WI3fGau8mKv4jhg5rGDJMPaA9y6uYCrog4vlQG6jYnHeWVgdu5HnGBC5M935LsVLnTkGXaoFLaJpMVBZYG8apYVhtR908F+k+X3++Rs9zhNT7PesstiTocy+6cFqPFBKwK4z64W25M42GXniBhYdc0aRzXUkvpDp5jxyN2D28r03dLXfZy+vsE8b5D6w9OPjVMNPURu98uOflL1XpiQrH22k7v9yeiXVpWUctaefXZysqSYX9jwL2vVWpyGeIWXocOhhCVZ4Nybg6Y3cgpmNFT09t7Qb4ohzroJYJBbL9QUSXck7l+T5zM55EKDoQhkUWc2iIJ+pBdMZGikzq8LY0H1ADl7/Dze2gEDRdl1FyBCgJ0+1zk5T6pe2fjH8HjUGE8Ta3lToiOKGdYCHEC/i4Vtn3SR75R/tG7CQ+sCwbMkimIMy5DlzPZTyS/fxQslSoEAZzjQjGRn25ob7+N10X7l/tc9wFyHonj56Kj1PF6EoTTDhYPg0K4IJPCIy/qom7rNoEw4ezD/PIxptBvzuVi2mJfQ9E6YynyPl0KhQMk8h6/FPmQLgSa5z5ImrhtcetPaMxf6jB0OC25q8iQ+3q/w7ur0T3RU6qm2ResVsNl+y0ezzg9e0+68BvDo0hwbda1PhG72nUGZobBKhzoTWC2aA7gNvf312SKI+C9JbWTeFdo0XpZa0Cik0CaCHasp5liE8o7DGOue7JlXRL2Q3KFNpUQDZxArJDq8cSpL+EvORb1ehplglaSjlMgIjXh7LLrHl1BHZuTESRRRhpWSc8hQhbCsvdN5SGn7G0M1T75QTL/r0FsrnbgHm6Q5ZGnZq56Vzu72Qsrlmky57rRkybGzmKa/Nc1/CGMqkP2ScndwcMfMDuIi/J/VNZobY7NDjU98PsD3CzPi7ey4e7fjumQp0Gr7CG6aY77x6T1KXVTaFFLrbMFyV5yFFgs6v69f9BVq7pYMH5F5+5FH5Y34LjvLGzg5lhZL+KJL6xQcdvXBz8dXgu/TjM6e86UmkcCgPbww61X29/hE+9BRPvwMbJd6wzIIZfocmfeZNPWmwNjiPMEKd4Ho9nk96P6f6uM9xwBr1sehb2YW3XI9QjSAsU4MSgdGXUppCH4+UTr35coCJSBl94xF872VXeLkpEiuzb0JxZoA6rGRKtF7JCY3+DiXRIQJcoWJzba4PE7FklOAFFRGu5ndmb7eE9w13zmm6ZRQPJaadL6A3t/S5mLtlVtHblqCJWB7unD8/FogRtzS+b5Zji6gBPl1X4RM4v2nnu+uWoI5/8skqLoGN2ObumgJaMPhebcOdE1vTVD4KKaIIV2vxMLF2thtDrmlCdVXfb5aJkum8+3oCIN4j4jKhp3enVYtcnNevivUZaoI8wQASSftg+nDy5jU9SLS2YVr0SnPzbtAWPvZkm7BxE9J7xVhJAJujTvXyPV/U8op7zdRx9zFeYpgvO2oq4xWN094xg2sk8HxmXwVrROYhXzYtxxULUbLK40cPNKuXXkFcWUVLzYozdSve1HJ9eabERhxJTpu5JXQyS5Y5Yi0JmRsQwRCQ9zxrnnzWtiPcE88qanPTZroDK20n5n/BG/o82eWRn/cUEf3M9nEWzVYsKIgJAKlHeUzFPGewR818+HkgQ45rz5NLDW8VenBpazWrmX91cXnn1aZg728dhE/tzjFoc86i7MgxM1AtmRnMDplgIfM8uZmNUrVt+svvee64n8Gno1/wiXpbfKvum3uAmy4oD9+uHRZ2h+jwQ2H8NR2G4kyT21QD+DqjHLV5NI/51rdZ2M6iHrXwr5FR18311NBQb1nz7VousEFvzRsOsXdWlL2VkXAZp5qPCQEhnD8AAA8U15ZeL0BF5upqMxVzmfsWTXNkbQTaNuQhd4zuWD3Zk8YqyTprYxGIEihiNS6KHnDGuxQBb5zN3J7C26ZFnlBIVgXSddNhaqNDa5QHasxdwQmcWX14dAna6t1a1GKBQ8sx12Sg1oJ8wqJNJ2xd9mZHVW5LgIIZMh4bRrbEDjMCEERUuHdobNkm2RBAEdjCYAzJXYDTeYFinhVmpkn2S4iiiGK6xBqNy0K5E5MTxD/q8PmkBHYrHea1cUFbt+YM2taJabS1ZBUV/REOHb5yaeFQ6qPtI4igSbRDJP5Rl1Qxy4Yp9m1l8IW7TENu1XWZUY5I+YYkI6ObuiO4mCGUpTe+8jM7A4lu7im/cJErBP2JkqFso0wnSrsANNh6J2bSorYBFK6oBICCAAgRhPBTpFCQi5q/yl3tMOB5T5r5vI3ovYBcCMYJnuu/jb8GoELk2qA8HUI8oEB2wyg95uQ8joWcVaQXsxNhNx1MlcE+AFAU3nBDccjH5pQ0wVkuvUNK2dgn86/IBEEBBYIBNLXK396w3Jeh2XZXqLzehzkA9AjMqAnzOJ9bYarrraTy+MYMTVLDYBlBRbxII9sodsDX4CQptKvKJscLeZXCFQ2ql34z62TFYERDfB5EnFZvCpT4uP8GdvoBLgzTu24Ys11SgjZKvYEhBYhZUPSMUG3CEYU1NQJqwjb6O8fe2JWwTHi9ku1nbXbCHuSmqCTl3mdW24nkrohORW6xqj5Ad0Gsa2wtlo6feNoyKNTWJdbipURoOebdzVrQpoQZDFPcjrXzdtF2xWNHY+OkoByT4Nfe0nZYxLYRJ3eXs4pcbK++RnlUSurNo3ERsp7HAZCHN26ln5r/4lP56wYGQK4FM5inZ3OHCWDCd6BOnRaTEg1GzOTCUZANpq1jZNyaLRNHW2aaVP49cD4WE+xnFfdwtNm6hL921zdIBZRbfMJb/lZosKAL4daw0JlwGJbcjQ73DlLzfkxBd50TOOIPbh2QNxSR4xYUOih5R/Kkk0BZRvuTbWbnqBfiW/Lyh6huuUrzaImc2wdyO7sxcjkDoLhvYsHmiLg/aPTvbYB24pi7D+zCmc11Ngc/TRIGhtBn5/osIMFvbTHYEsRp0gr6IA7nvGWNIZ6FGqWY+/C8VMzk5ZoH1PPrTiq5PJhk2wvSC8dVewCXHXK+HS0XtbwMm3o0QF294eBD6ez8rP+g9kk9DZT7gy+Cr37G/xT4oYDhE+p8f9Wmt5ui7/fiWUJpNt0A6Yl2uX7+MKW9KVSnWjVLEbI465LJ8occvFcoRPU2uFcgh/5tKcYNK3VVI8aIyO1K2fvzsbp0WXXVv/IHf7n3W2Cuax0avZShV1CcS79R3lul0DGHVq8IB3ecaHLmJRlsdl227SaEr8tQ8izEhA7DFxZcdv6FOJfrID9+ZLxgis0smdeHWaue4ZpDcd2hUy5bngrwu6xxttNOvxc4IzVZn/xHtf2WADZZQ8J6IGlbIH3yrs8FOiXI5CvknTnFNk7o307A2Voy1cRAhS4MnG/CSpx8RZJ6ghCiehOeC5oKt2u5qix3zi/K149u9OLBseBjD1CglJ3WhVzY1cwEUxju7oVw3Mc3G77Trqgtuwh4ml4w3nx08fB0yEMXDoLyC+Rqz7yJUM3ok0McMHcXOeVbudN3WAz5a9+YXPcdf+06imO+1EY2bKJvOf2VLeIS/CUTTBddoq03bXoHu0403251TfT+2VlfZ/vJBF2eAu7cm4yOQveObfNtE6nu1J1Z0tVQRkh9rupd9dS/iXdUj4IUk+VcRYggiGBJP4AKdV5yPlmWVkIfztygVF/gDEo8TngxLFhnBYIzpqpvvWtem0TJU5SAhSVMrKHKtrtijyt3w2P81C4kU+neTcu027BVAYLWGXhxlKnvQXYhYXdBKB7pAZgfIAxFz0wdJORL1Ad1rFOdQQpWpQBoQOqBYGOOEgtocoYWlHdwcZ2k07fD3jJzGMQk7riPOn8NZ/nXRYHVt32dCaUsOnwtDFgICGin46hxBCb5TzPjfc+Obvkq8qhw+bUiiTUY1ljQupvEoGKJWbyoalqcqrbf/o4K09TeYY9BobYqlaDiviKogrO4KTXVKhQUQFIf0GOKGVQsoWAFhhEtNlDdeRPnppyECRY0Xrvy3DmoQzkFJ2UsoU49Z/1j5g7t+/Dgwhmtz9ZH6JEKPTnMi2Rr5HOB7jnDRSA1XdxCocsNCyCOqi62CHUwVlWJQTIuEa62B8FPTzIlqpKJY2x1A7w4t517v5JHyES3I3Q5BYMQAQ7pzZPeu273G7ZCkn2hr894cboouPUApLF9MxjTbWqywsrKHuSClvy4ZFOMcgqAjQfzgQWEbS+qZhy9ks23KVsoMOh7gFdDnkvCBmimIo5M3zbU55STtqA0smpu0EXObQNcy2JpLDL5jpng6mRJLrxIZICrgnLf8wr0aNDL+nX7RuyvLqOFipUJCPXDFN6aY9HqA8twwAp/X5WwEXHXYKmN8CbpClYpa/chCIYRso71ShfZ8LzbvdChM2hVXwEoVoJxQAJgs+CRQuticRRNEi1fuXMvq1EGq/0ucMmWahYfK2WuKoKKJtM5458cVYFxaO6mazzJrNxIQqcBPMpmXu4vKYnXXZ9zT9bykRuVFPPZcnyc7lAEsQmZW+jRiVRQAB+ZlukVlJsiV8pMvzBL+iViiLH4L7s4jOXcH++5hgPgwiXXnJUMDnd7lOLKfOI0g5hqjTZg0CsvnehOdu29mGsVEpkmH5+Z8yp2GBWtsRTp4MzW5MK1JoClnGnv7sgEWWEn1tI2rt89mAQMYW/l/4E7B5V4PFe6i5ymBhouKlSv2CNrIlHJXY7+O3BV3PIRwUYKy+WWuyGlymANYNvzC27t9D+rD8T5CHCz0e+BzSIFdtjmgI0kQa+HtoSCJua+STwuRpxEdxUlAfxKPzxNNFsUnmCkcEIIG2h9O2E1ibdxODXbs+CzKj9GDo3ynvYt5xEbaNC+TUM2NmoDFO1wrrdoIycIok0cBsg8D3LdDjHzrUaLFlO0e2412FOnvsIejINfo/9s1XIHH4/9PvSYkblso/X2NuA7Nu6wUW7tNiJERpeV33jCWcOsjGD0LF/yI18wetkj+IIrZ3HSrMwDEYqYrTWf3y64TmxyPduJ2WlFBnTDSFNE2gG3sJJ/aOpANWYeaNFV8SzZQrSquuNE58RZytd+e6Y5s+BGy9jZ6jY0UFwypS+yTeWjz9iup21+5qtW6x3ryH5jw13RvIT/PH/eBMARwBnAFcA1gVsC9wQeCTwTWM93NocUKULAQjJBrsokqZsrc30b/agMjDFcWcWbyzlQRDhqQb09kj01TzTc5yNIpjw5qNjEYrHFO44dP27UAwPXMIVIliLc9jiv2cIRSVuwBx2th/zoDhg3GYHzpkdP0Jwpfd3TiujJSkfnhDqKL/BeTPB5PNGsUsM4n/Dx8liKgWvypc5nFDajOmo7evyaxR8/ERasUiIhyzEtuWZJZsipdTFOqFYlDZO1EDi7pJWpD4Ax4TlFDfOzC7Y+XIkbL02OXsmOG3c9TPLauT1qDd2STMXdWmFzlE8QTJhvMXmzf6HVyLECZi1cTphpQxY+AtSAIXE5r3KqlSrNpfQE0T2pHhVqZuDvMFJsyo8W2Htbndd4YZgNR4hG89HENTiFJ3LOUzWGDwXfF849AGYGo/zk1rPNExGmPe2RMo8wn100EDHxJwvKvIS5SnZSlu0R+7KVYo+9kd2O2JCGQrkclNG/jFialB2XcKWM7Fc8RuhXoAKT1IIXjUK+mTaI3Gaaz1ppbDSkeTcBE3fhHQs1daugEe2q6arhMOJ/yWy8KbsqAgQI5sPSWakAqoCs66qzD8p0ZCulPOgoq+IAHrv/QhXtEQII7/mQJOpK2xT0dQPmgJo53PtOAMt1wx9y7suHvXmbGGNsEg4qYaSFq4gyGU/G1Jp4cpXDpUWW/D9BfHrhQCiZKV98xrrRJwIwTGTh3IChYJX2QdZ8irYQfQcWy2IppULfpPb3ReYpy5wrOJCyA9rCJgblxdJUZ+tn/1LVPpWU8tZqmZr0ZeDxxZnjozQq1GySYHBtzvPeoEVP3ZMpruIxnodTCXd3gW8dYIDdIvISBtP80jCUmCvZIlMm5MuRXib2KctW38k9tpXP3+Xs5BitIT5V25iHcSY2bszZXQykwju0ECj83JWMOUbM97y6I3e5S4m0DlPOR1icV7I93bk+Ow6nCs7u5OWkNbjCFV1RsiglJzmQNoAwryQDp4FVXTugWhaX6ha3UZJMfQvbXqheciv2/K1zBkO6hUaVrVsWeaiMNMoqgpNDu+3Xlhe27pts64IH/mvXGk7VWS/jfnSpsbcJuOdaaTSwwexXl5lNrxe3IMXnsrtj7T0fOQYpEClGDOT4plL9FF6jxZN7dV5dv3z0QFWXOy5ztLXOc3sWKQpTaIPgUnJ6RporzKMhprlxIfW0XBo2bkBWgKxfJx34AwMolNHtE0NS19kbNKSs8VvUnBjQjaakGvN1kYIZjAzAhSkIbAzX+ODdtmj5ukeEiXk30Q3zynZOmQjTaukEG8vNwq06i6VLtqXSGus2Hptoz3wCvsr0ty4bybrGl1TtrtZYu0nSGDwO0h2ZMnF0OYGgKRDOqmJyZOICm9VpGjQHTZxeGlDzga6bDcE1tBoBzvL6rZ7YNbRG3GzGj3YQjZsIYRCUi5yapAC5EfYKmF+vjQyamgc3vVonFIiFUm6ikn0Kvo/Wjn5po+khK7c4DETQbRyHSUinhGCekU63O/1lxvtSPOGrx5b8+uMM/r4kE+aCKGlkZhZBPVCoqhAw8axhnea92mgq8eG468aCkvUo1kxjprUryE9sQ9HHw1a3Zxj4wSwYh6HzrB1gAmCQwIUpEwcEl7aUD77RROS2TDlwbqTpB0fs94WMrCqBfzEL6OyH4iHoMnogX4EbEHojG34gqSb64wHq6fWnmkMOR0kLNlgMrVAniC4u4Ll9M6+qboC61UkM1vIe1wulPdhaLPHQma4NnMkT74vuXjkiN9SPiF/7Wfi4YzrTG4oE3AulXpIwOV8OHl3R1GGV8vXXgoTxMO3rEEJkSL9NNRA2SUwlj1T2b8U0oPl+gkNTTuaiRVdTOFWFL7KPlnmnIgIz71UkYI+9PiFPJRl3lKuMsqBdd13Qpd34JU9KsEAy/YNbAUoqqinf9x4gHh98HF6HGDni/Vr3dxh5Da1ZQktDa/K6/PhJIhezYSNZt04xeuG00XO29vl5Fuq0LNkRR9p9ysQEHitPTiaUqO+kU3SvQnmnsA3YW2tv7qMGxKGv5PFxNpnxesan+RYZ2rxNzjcHOaoTSNxmX8/kco50lW21Kq7UtrhVb/Z5Y/Tizbhv0Rvj1qZvMDwQXPzVStjXq0UuO0l66c0p6HHuFpFr/pNs2YrwFBHQ3me624iY+Z7n14KkMnFaQpUSEQjKCjgK+ogrxCR30ypv21AqS2XubybldiZ52ciHdYMnVZM9mUIhVDjQ4AlBMWnsIUK/b6f+KHrI1vWlJh09e1LellugzFOFSG61TUsVq5e7Y1UyruyUNAuAVR/N+dCDnZaBEleRXlmR7etHnJKAz2f8XMQXOmdxyio9ZJiKY4P7M/i+eoJ7D/jg8Ik8uXimRFVql9k57DTqioJR9YdPTfppWknK3uwnqBcVRGDPZwTzFrDeyE4e+nDtDVFhhcP2Pnatb9NIAQpvx97lyJo8llnlKNY9eORdAKij8SaQhLl3phosMDAOnAgiBh+4EaW9zryofs6/Th6a8BEieGfx02RhFK/1ZtFdNayEPDUK1mSa1QUCnscBv6Yx8ZFcXQaH1Si3RlRxFe0OI5W34sOJVCrdduYhiN+TmSlMMzA1kCFY3IimtzEy2S3QcV1RseqIYxRQ88flKg7I/OTDBHBABGAP2GKGlDUFgVkzPkHxLbcYrC8cmtjMlAatI4gGKqriCUdgvTQO8luH1B5+vzCf3gcN18WH7EJV0DCjGX0VrTPdsx8vFPYP3VucFuh6NLgGTLc9nJlrdetEzEKE+YjHI0dOYZMvqIeccpmGmqRTOXe3TLIXAztcPR7j/u4FdyjYojWomOrmYUZcT2pD6pBoHTY0UKZ1AZCKxd0XAceTBk2i/MtLK3YMRRJ3J9swhj2FSqSerz//l7ruX/s3OPb8QdXz+w+BNXJV4kECGXhkCtgMXZKQsutLRaJ0Z7i1dOrM8OSwduOvA6CmD1uGeq2fJ3hhhv3y1DN3atx7XFBSgQJen6wPG0lC9sG6LKpsZW7AltGJxA6jV2azyiNmmH3Pltou/nsuVOpOxeKlK4AYSqa7S35p4N/tEpkE8sJCFEYFb0+8DUtnlLsWGlyxH+wpUAiq0U2XzOYdYua79XGdEz/BRChTR2iGNAFobcKzgHggdZhWN3IYyzRdOCQyn9pdhflilimmLEuK+fS1R8YVeifHm+y4ikVsCauVWag8rLisBa+ky/+FPs6Cc5SOrNtSLuNEO/eNZ7JD/YKTaLhABifu9D7UcQ2XwBuxO1AvOmbKshMNE7vrcgd3J/a3Eel+iW3EUhR6/Ht6XmpG3PtiRfjYcnsku8W1yM2p3yidwTk2o3prhfChw1p5jef0FkaIWzYu3cVx3rpQ1QCue/y9nbX54uJQIYVYvgpI0GKQk1OTHXI6prRNvjePOMPVV3bAaCu30HpX/zLHPUHV/GbcO9K7m3eYbU98jvniq0XuGJaXsKTTEG1t/Ugp0TnJZ2v0U+uUWp2xFbVtOHYO+ibgYfkLVygbkTvylddrPFCSAj5DZG1LzqHn5mpZt4xyr+rYmz31WuUmKoDJEgECyacEX1nyXaWv8eueuWLL03tMHYyPGvuyhbM045GD/GDBqaV+QEOVNtkzOZgBo37eW/v42Q1zt2JGlktvorPc0BtgwAz1qW2lNBRvIjMLSVEONJhker1OvPHOFeBKyAu2RJ3ofjNW5AsrGDrB73KpICB9jh1iZPE+SJfWRR5XNjNuPo7fycEpwZwkWtV8VkdDarKeZDpNf1caVZuMVZ1FnDJhRvObUx6zoRM5KCjrmueWGLnleVe6dFRowPYgMbtUyyXk0w6AFF2Ua9jB0VX2MO3cdkW8nAhSBjcZ/UCpuEOiVQ12rrWMbB+Ki53hANhTsnbPcWn9g2ZtD5N1pAZBis93obTaZRIPiL5wj98Ko3GzA7riPURfLXvFtnZ/92Xps8eRRRrVZe90icqdihSJYxkeIp7KPSW6rR26US83Xnaf/DnSrXveMliP/aqx59oIDAiRDiUpDpib/3EBzevnCU6jjcKJoSLsSyrdRz6TKyqDfexAlx0rT0YWqXmsfkpoQi+Yrn8enQjZ57HyC1V+/RPlm+ktrbouo6kWhUWYTnyfxQEDLZIBHqI85YkgaUCX1DSVxgO3iVhrj1/d5QkiyeBzQxd97pKuea5AFxEhfV0NrA8x+elOum1SQyp5JsmKd5KszdJCpyRuHnk9Ng9oZwhEIqsBtQ1jsFHNBFXUOZrNOabgNP+Hqok+pR+h/z6Mq8kPJAYqG/feefLeB1/66Gv/cLcLbLOUnEH2d+W9BU9MhautWzB8tzgA7ajACY6T7twZ0O23XI6cf6VH9Gv+YE7L+y8/3tJK0heQHuv8q3PVj82b8nCrJ2zaBHiGqYHdomScbB6w6RNzvoDwAKxTyQLHqfIY4SrVzHWadtUQx8qTlHdDyd0j2jsF5EqDMzysNYlu9aNElI1dkQYYDGMp2LHLsXKsPEn5hU67N5JlJylPnt61O1Z2dyUL9XA/J1AFjlibNHZppuA4GQt9vxzdS/eTJViIce2uqBeyNnjX9GRkkjZpboopG4WackWFLFwNNa4FFmQKNqGN+NgtKkPwTuolyR0ZBciMEcrtSzrDEDkqXlW2SsHNFr0XPrjAcajlPkt5LUstx6XFFCllWFKJHt2LTJXa39jJOBnPT2gM8iEJEX6BUehOWIp/hOwn7m4KTgzAhBL1nLwLjibK0Wx2u4Sl6dS0tbSFsPOtd3iagHHg4OUUC16trg9KXGzUYSskLbbMfNUOw6XUwLrTdq7VueNFQ+YR26V4Ir1nOSNPHEkvTjY8nuBYRYUI3+3/vePb9D//wuoFsMJ8YAnBFO6ueGBgM5xNGwMM3TnHzqoU1gi344VZPaiLcXuiVeGTSPl3+M4mXh/G/NSEg/QLwZTiY8dfkyo+vRTb2W9Gt/hqHpaYwNAV7IHJmyYnHIKeZ/6zs6m8ukSMM7yjOifgM5AFtVFIqVT3nmaZjH4bCRBTi+JCHbYfgO/OpAOFgCJd3lhuwwVtZgVzEeywgRVKuGwmYOCNkJCF6huy4Xmikski/J/THWHAGgd3TazjtKw/sBcm8MlA/rVHXb7R/oUHrO+DH9zO2Ixz6yxxphNh8t4HJ1goFxK2espZjbB82wzuYgw0LOamMyXzc6lkdIUBvrjcZFo6XOhumiYkaZmSywp4WJFWY8t4JJ1pVFdNKll7NzsnOOl6Q+m1XXdys3pLM+oos2ktXapVfhXcODxeO5H4QqLwww9usU5CUyC9cPOxtKsgZs7SeTag2uy5UYqwoo2s4AMjQRaYrspciO0D33Glc+jjbjUHxgwmtc2qQGCgfGEF3KKNVsk93bQJVnRr7hIgSMg1VvaTYLC2kS+beVyT5l0Dwts3jaTWal1F4cxVhjXUVEE6z/nmwCuYTkFPGZ3swrMZiSchebvOC/3UBmnWNXnXjoBl3aNfByv5WboMzHATJy/YdnSFjBeS1EMQVkqZ2LM53fU7BtzwsLd63aW68iLJH/izKDWRuYxSYoAKNdikw3a6or1TxZbBsMXYE+RTanH6+WzjZ8iwWNl5Gkddq6SfoIoOYOQ7KwJa1K9qNuBltqSaJIAEbFNgbn4OElk0huYrFyPuNLE6VHcTTcuyCEiPSvm98WXLrQPGEhh8/RAnDQMAA5qAN8Y7POeOI5QRuHgBXY6fwm3AOe/rm1VjfbBChgQ3QwCnOy4uYJkvd354Jojk3TCAplby5sbVc17fqSpLiuBIRNL0iBBfla1Hku+2cCxSBYqYfhQ+uSgXExTmBxdSfgzsUzoeXKTwRaCHpEAZ8pGOlzm0xxsBin7UnIgjs7clSY4euxI1naLncteRhbEoq8FsKb/xUcuyoMKJwhZCx9GK+LoGv4t3+W1pzBalaCVA58RnNq0pyJqJjQAU1syfxdXgd93hwlgxVvSiMFsti5hcyWYXxLYtxusujntXgkSY+zBGTBmLESpUqFA5f7uUtMZHq1qFYmHH1iTGcZXFRtyJj0Vx2NGQIfUYbMWGGo5HIZhhjLCUQ3aY2OCCCwCkz8clXdaG3lu0YpXqdBVkmUubFbajMG2VNZsSevJ9zweQBbbDCb2V7StKaKq3zwNVdPITIoMI9IEOnXSKTtNeFPPmhcA3V5WtNN34yvQJa3N17BaHJE1QW4Q/fUPiAARoAwCUDwMAwLVPEZ8wJByYILII/JRpPERxhXF6lnUNDQ+Crc6ByOtRZVWBAmXGygvv3nSkXPvieutYe5HQ+F0xxe5gEcBbWxUeDx7CGj/B/hIW2Kmvni27yTph0yFFSnk5xOq9aU9AqO1qOMYtfyEhku9vrhJ9wOi0Gk3qYqcvohbQytffwFg+AwgIWGXDBU2JwzoI6Eqa4KKHypT3rycG/54sU/Ac8gokTVPin6Jp7WEWM9a6zw5YsEexCZuwGaWXt2h0tMAHE3EXXb7WBYRqr038Q0LjZ5fceOpPU2+e3KitZgNoArQ4UkIuPwxeCqBeCnRlOPYLRyaU3Fd1MgN8a5SOv7R5AxCIW13ZysrPoJ3trdb4vm4dP30ciKc1aNpIbDRE+qJEPPXb7vFtopqEYHvg3XeJ1YaPnLxoXegN2956pVvgirEIvJrQIjWP/NPha5oVieNk58Dk9oNyio5CA3RSM92N6xKOGU2xRIcVsoNj82tbx5c+s0pfCAENH6T+P0g9UBFMy1yKP5cX+oS8yqOHGSSrUU0M0LvdgLYsFQWEDKNQFbTiLF9DVpKMM5UOEn3DZ9axWa43lIFD5jVO3tlnc3S44u479ra4Z9GaBjH7HCcRhWqGwU9EtyuLMK6jOYyZwV3oyi5IXbmhMUnjvMpUTWWO5JZXcQhtYrR1hlB24naea26ns1joedxe996uFoHAwqOY0UrPIlZeE9y9w7QHmju3KVYOlI6rC3YyIfpbVdQOKOXchxraJBDZpJoHOuOvsca6tWUVq2yNTRIvNpVXZGXr5dl83Jffu9tS4tT06OkFElxBhPrFaRk3NG1uEAO4Yb86z5KhGYRfHr/wLQqMjpXPTGqeWcBtghWBBgECClIV7WojjVtGE3rX7lj5hSgTvdEfaqBDh976v2TezGuG5mCBrVR0io21mk4ORHW0SsGucG9tzCCjW5Yb67YnRmmBTflxkAYAqp/pATJjmKELB/JWaYxNDqAZtwMnCUQcCLuvsw49jjyKJujY9CQlUVZjV372EZ9skcfi8y8/YjfOFtCHFeFtoeBlcot1Zi1FRRwSCSoqqHVm77uxuzasVrzg77/wggugHl/GVtqx7NBGyX0zOqloNcHaqW3RA3JoHBicFXe1WI6V42QrqWUfEZdu9URk7RbJo8PYOPy6Zgk9rhsry9UgSlALS1p0XydIktw3w/WGdqH8dJLZCYYeTfMs0ezmkCMk5brKalS6jLlOELaXy+pkzd7uA43czFmCr9UmJ/D8luCAaq0tcGoGIU4z3GWugVVLB5g3rqV+ZgC5v7dafHOp1N1tiOSu1Z6rLZudTHeBEJJN1slUt/iRznJQvQ1Avdvj2BIoA0WGVGQEdFeW4XMdO0Vqt9JacfGFlRNRGfclo2ZlgTSr3tQ7HIDhY6p/7zamXpdht9zGdmyzPHEp5zgdbOp6tkEIdpnpvu2+fuNuyavZQkYdw1T7nd0VuwQUbAcqOzPA8zt0zY1Ms5tp2WEIWZLCIbgwnqgM4GLpBR7Gc2MDfM9DFhQvcDoU+dEH4cIOHBGnPZM8Y3RCTyf0ONEmj3zLBRHdBWboZdtWjTCNNnwaD0OH9Bpnh7+lLRseeD/vzyR2d9LORXqcP3MN1dryrO5N3PX50Yrnq/qFNdLOFAdPdYobItuyyyapUbs29ZOsu+Em4ERE+lIc623l7iAyruQlZYOd6JhHAyCzEjeh7AUXixqPtzIG/HTuBu0UT9AMRfrtsP26fWHXe+2Fcpmpzs/k5g3JRaOjZcSlOXJgaNbpV93HGN8IujYozhldDEbyF9Ymd1zX5zwI2p7tKpiSMyy6K9zcGpGbnLrMk5+m1I4MC60RVH5ndazeHkRKRjvdNrLIzMNeGZzCVzIJqpIaETFn1cE5Nj25cGx60uHY9As/HJv+Lws/xUsnZCe8YoW6oSx6I8t4SB4HLgzdroex6RdaGMvpzWVj0xMO7b5ozNXI5l24KlqTKt4zIn4GEpths4lmB6cjRFVnZN4Ttj6LSsWQJxmRyyubAIeDJx1uqHhYDIKzscZYc00hCfSYSRDSh11zgc6fuXmnJgUK4qyt1/x5AYtF/XWry4IBK5iDNfQAtax5sb+CBgjpHkcWoI0CPD2+E1hTbyewS1y1vc2LbCvtaI2/RpmWqoZM4gM7no/afg7fXFv3+3bCJ2QpDQ8uuxeSliiA402zbnBKKdjkWB6bA7TyljJfpP4HlHMcR2frGGJi4Bpw5gbv6H3L7pA4frQAZKWTG3etcCtmLT7/FBvTTLCLn9ht6b3d/57dFwIs+CvlUrR8cQqPauOxXtm3ERRFGnyNPpYxZ4JGRY+VB/tAkx8fjIl3WT+ypm6Fr6E39/SejmaLJx6nnniUwgVt+8hHKeMwWwOO7eAwqRZNxfzDuczBVBM5EcE9faBcpgtYs4e+R74ZZIaJGs2yJKnCV280Tk4LotE4bc0KvthLCyW/bsqL0hhevZXRH5Sn9TXv3objbEOKaIcvDYSDcZvXnqZWq7u+3ttUOFh5K3Hl05rGP+BtRoncmXP/HFzy8e0RGHt5sa6FKinib4NQ2NrI4BHjpHBkATvlpDAPSoii2jmd1nRx103C/OYBBuMrlYtqAANMokXg782NxgwfTMlQmdzClmrv3l6N2fyAMkmKPW5o+rr6cKFUZc3LTXwBld/25MNRrpqn/p4IPesmi1W7RtKc5IrvcvHzewQm5hjLsS6LQl6H06AZrETeqS4I8lUr76jolsfl5btzOQObHiBqWSqz0a/SzwbkIKMM0XuE79XOZBGcSVD8h1Sap34wIAYBBXBMhn1qccozYU162Fld2tAvqXFQNvld+9WgOaioejrRwZJYqsgyTlw9qgi8ek9qxKv1pDSkesJ790FwhIpDmXAMAIjKEYOPd//Uf3I85w/wawBFgbhMyaG7utBdTrDt9dl9OgxGVe06575NmZ2mdVYgaDS7FWWJ+EeuXqXw3ItGqVC+6yt3+wo61aIGbGoPDs8WSxqD/9ws78JJi+BOMrH/+pYxqaNBJBjusxPwxVbuFfFtBjgA+MriAwCXMrm9/q+0+siJryZXG1SRI78xk+hJjic3Xs2dbBpffFI/cpujaXqpU9XZRrI2BrK8KDKdXe5EWn4A6Q3MqATXQjAIdHAV4+vdj3xvXaEaVLq64lGW82Okffkn3PtqxopHD26cM/Cwp7kkWPsCmQqOBSUK2OmknNQw8DLyQ0rvza1FtyHUcxj0EXI4hbv/J4z09jrJW/dOFjO+zScsdzHrTnXjWYkz46wxxijRfvta4RpGMyVtR8R06Gqh5DtwRufv0MJtJGCANzqAqjct2CBNxRqXknWDew3qI6izs6H0riE4FFQ++tvksQMQ0LIFl+29Ud7zwH+nbIi3gN/u5s/VfL7VG/IHLAPd5MttAnAgDBCwZeAnwM4pB+3LkZDLiHltWsmB/1df/gfcC2lbzKsFBGWDrkW8qqLLWG41UDWVV72pOpcsEfTxW4+aRhYz2ZynbwV9A+k6kbKFvNJKn898Mo6iM0mqQRsjToOJ6oqWQbi5J9j1IGOrmfqYsZWMncXYt0wjY0wRY17i9C/G5jLOVMbhMradqcsCnFksh6U7yfuBe1rMYV7it55jV/CjlzE3gx4CwRvMoDL8IQy8wWe0BwRCMAQo1QIWiAKfj8zah9xnlagsF4C7NI5i9fBOWRNxuILHIDhq0SymiYaXbnE5i8kVlHTPv4KkOzld/sP0o076lUtNfnkI8zvNvVRJ5L3W8sZXUFKcHNykcyow7q21eFn5QLdewI70Lom1+JesQ4V1Pt+xZ85Tmr4izy7u2c4t9wXqE5IzQtJDVRV9TXy6jXvJ3IP2cGrPWozgjkzcNfFy8tvFWndqARHvPWH+gPoOv3epCnDuNp6xwxlaSlU+XYuZ6rLw/0W/kUnCWsWhS/MlTOt7DQXGOb1x2jkMHX5uFo+2ULQEtseZnGPqHOZOZ+o2ri0S1imcW8UoUf6VWyv8O+ZGC9pN4pZdDPjeWk6U5tDUhNAC9208hot4/cgE01UFlKEjbR8Q4L0hiqG5eJnl7BMcwDLoirlW6rlPcKfl6xwk7C0cvMdMtZC+zwiCtWEwXs+pxwFTw72L+9AyQ5q7jM1qsL8JfOuf+SRDuXX7zBFkmcK1D7ootZCgJy5HYJ+NAPttYzh9mIP342WJ1fMQe308zMeMuua7tpLxe19m6ls+TpR6pCCB0HAAp/UZlWoeYk0sAsdQZBTFkacaSxGIMbVckd2I8SfwreewhO8Ye2AE4W+Mo/KgYsPf4jk4fiOEY7g53LGMGVv35iw0ZOhgbBG/tjJ1Fn7vBNOZhNLnC32nsa2KbqzsSoCuW+gJUspTFtu/XW3qAwg8lki28jqyli+NmPEoIuv2F5jLeWbRTw8ZuZps/Onrca+VZBXNmeH0TeQQwvmMRxYZ4fmbGPhyG8ChncyCGOjV8DbGcaVP1j/OjKAa/Z/axG7KOZN6juPE2L8opp9xswVjB+E4+xl1Zn8n6Hrm+TyKp/BGSX3fRy/qb8+ubBB97/ZFHjFSyV7ZDORH0Uzmm+udLAZKTt1A1hTKiVhs++knzzR9tCdiSpsufJ1vUo9RmlsuhkiezOvxLpe22Jp579zaNWOCmD3fmzE+2I1k4yY8io8j9tD1E6wBIwqfj6bu9j6grcfasOCzasSgTcqmKERrlrzP2LbfHTHkvUs6VzDGk3GjgXGe7ufx0e/a5fXM/8ehppGbaPGZ5zjOI/Ial/qRotb+/v26daie4zn1l6oJIZ858p/3sdLkE94m53A2b5ISyoy8OjmMZ5CkGD95NBk3T5LJknp8TOScHTOPemaayQqznmTmSomoWIA/edmPZlbLkpS4S7lz1JFN+aJapcfJky2muC9Gfb9q9nu/GRcVU1w8GES734tRxOwbeVozlFqmRqfl4VAZsrTr5Sr8ZmGxP70/s3qQl4GVhgkuKLDYE3OLHIVKbctNwGGotc9F/5O3WQCpF5P7ifv/4o9LWgmtjXvXusQFJ7wFc3t5/i3eDPif8K4Z65AjgMfClS9Stf7/7WXbdsTBH7PmLSYE5rVyMMxEgwAOAoW+goSAi8u4wKXgdYUDj0UxhBpSw94NdtgaYRfPZHuS/OoALHcdyOS5g4nCdQj7uDlUdQIcRpzrjsDJ63oker5OcTe6KSSXpeBQ5z67ZPjeQNxwBLTZALhzswFxbT2M0zYESztfctHRaMSjRKecQAzbJxdFsAEbo1cEWLy3edjU2yG2kW93cfjsfMEl3XXFw94Nbw5K1uIPBHDObhNFlN7A4LrHRIB6z7BJ8NnrLRDpXrZCxNcPzyJXvRbPOFpeZ2fT9Rx+xIh9r70Y4E68t0kgsQrw8c44ov3+9CIK3zCa2YmtI0E+RvERbnELv5quWtWJurQISSpSBzeqA9BdVHCBdeJ4RHQLUyTNczqibbjtJWPnJ9xGfrGp7lEKjndWgKmzY2U0RIZd5m9TDZudirjopfoBEbCnUASKrq7eN29Y8CAqmYh7rDvzYlyJ29XB35i/+4hl0M5jOhJId7tk7IBGgpycbB2gFwIaHXt5MxWac1DBmeEXqfoCE6bd43j1DgfGDBkXZS9HvY7JwxHlnNederap2s8pfZGDXIj/8dxT4KlpLIGZaQSJrDFRb63ISSavJdmo+l+Jqm3AcX+bCx+9QgBDVrYHwcv/x9s6NtWRFB2E7HKRQ3mLXfOEAdwJM6QcQMpccKubp7Q8qnJE+/3pRa5zFhJ1ryu29LiWdXmWJILQYl68RfmtkClHUsmmSmqWUTAnnR0rkb6ojQOkMqlRQXEUgoi5ZjRWrFbFkPwtFBrLqEe9kPQ17BnNHHoFrtAx5FRz1IicwGE1QoYpkDMgr43a+lCnJ8HQSAUwCs4oGMJiHatyK6ltohMUa1vdyM53Te8LiJlpD6/WBopeAluaEoTtwj3tL73LxoaTdx9I6j0GwTfJ+4M2VO0ltG4xYUPzync+wiW8khER7cTZsIltFTjgjcBUQ03RDswlMq1KzB+CKqEF3iyVd166WawVzmO8CGtF3SnvmRDVMoQq/oau7K68g/nN7zX+mjPaZ+QHSQ8qesqX7KstOFu7SbmNqhWQKkgVrQoCj/sbWwtNoAqyC6W2NlZNjoJItVn9BUpyr8irg0A57uyh0m1Q5COlVShaVawNwicCIZe8a3obW5u3PVrsrdEDgXyUysxcfqCF878ROd+ERPP3gBwUKo3OcEqy6sx0YbFd3ThcnrsHj5546pnnXnj5T7q0PhYUzcD2FjpiULQmQoF4BxBrry3iIDtN3F4bKlye3X+3POZ4hMLx7OfMjgsmmnonnfCnZpecd8Fe++xA2k6JhS1YqFz57IU4GxFKizxvLVGhyjLLbbHV4ogjYWuRJnRhCnB8tNonDeR2W0FGYY21kbpoaZydUmenzVbFJbLI1TinLAq7lGP4fK97oaOrp29giEIbYYxNTM3MQSyuwRAJsQwdBhYKjieEQ4VF29rZOxCcnF1c3YgkMoVKozOYLDaHy+MLhCKxRCorUPQP7IBcAeokKFWRIqs1EbU6vcFoMlustn4+wuHh6YUOUFDR0FNHwcAsPRFWadg4uHj4BIRExCSkZOQUlF37CTVNDFq6mPQMscthjMXEzFKQNS4bOwcnFzcPLx+/QEVBIWGRbvvjf2LiKSUkpaRleosnK5cgoXx8BUUlZRVVNXUNTS1tHV09fQNdPWe90GuZMvQNDLs3atHYRfNAVstac2US2GY5W2bmFpZuWG6trDM46W8H7ZTDtekxqEteCy3Z8VsW2AtFYol7QCrrh1wBQsouVOouW+sX3JUGQTGcILUsNIgBB2NMwKuSmIbpMLoMaC2FbeCOMWXCvbIwG9vCynLgcO0wt7za16H8OlZQpworcqTiSiqtsw69dQEEAREJGQW19923XE4PGkvvoVXyMDCxsOUrwMF170qg/EqJSUjJ+s82is4IUUhF3RvbW9+eNrahbW2yA0hHz8DIxGxAC+2KQLxBcbKkKH9BKFlRUpUFsZ123lOrzoGPhqJdHzyBSCJTqDQ6g4sm2XkXl8e3SA6IpIR9ZXKFkgH1Nq0u2zllBGfn89vsDqcrO1zkk/sDwVA4ElWlyWRGVu/i2Vy+UCyVK1SpjlCTrbyr0+2ZI6uGozHvy+lsvrC4tLyyura+sbm1vbO7t39weMRMtmTn1AUDV+rGqmZr4Ml8eT0Y6uQMQXGc+QvZd3kScxY8XSg0EYl7cFD52hWJzsyctDJVlrO5rU5vMBWefb7kwtLKmbXRxtbOub2DC0eXTq5cu3HrmTv3HV4dRVTrvBrvHTQefnf6uLh21thHJJEpVBqdwWSxOVweXyAUiSVSmTsgVyhVao1WpzcYTWaL1WZ3+P0+Qm8fX0i704jaVVTNnvYnblq243r+T7zNsUNERSyyrwkpafbm5wSL1ljYo055gB7unfxYH254jDhnhQU+Ont7MPVBFAlsGn+8EL1pbk+avyS3H80/A42Qm0w2hPz29h/z4Upr0MqmFKsO1BQIhHKF9ZBJOWiWtMnWpfQc8oF9UFOtSupqNnUhIRhBUjQrzzVCCEqQFPvVKR5Ypmk9FbcWlbrVUR3oq4TYMJ/BTk2SZAwfPSOLa2EZN/PkwmfGdKKAkki2wlEUVHOxtXmGCTDdcop/dMcs3P71ZCEnT9rkEsfLp5Z3Dkr+lDTUIOVzVg02Nik6YsMSheYFmsaNDHf58Ti3v2m61704TGyL444iLSaFrA8vqmJRrETMiRUcl+JbC30b3bifCgPgD+/BXYde5h9wHVvOleN+5KLicGn12Qji+l5ctFDxAYlE5vIEZFkVN1zubRv8ycPl/aiptixVjGIP921eOqeJffJMykAnbVpmh7i9W4ZuYluFVorLsiKddOXZqk+frjpLzHCE/4gsKeDvcvxogv8smwrXw6iNYPMbvGKWc9W2y9tXkj9vXtxP8ImSj/8ZxfmB3A/L3NPf1q3DjxrwA5Aehnpqdl63/9TYYX6/7DwR35TD2P+IVAWjr8OFHz60qhpd6wRXBdVkQROgIiFbFDAoL4M/HMFoJH/0x9CMXxXm2Lgh/elz/3mNljPTIUzcgs6PqCD8JE9g1oGkVmd36mI36+xQmQ++5oF7CLNby80zprC8D6+qj+6TaVQBNcLUIMEsCv5oqPfHvfCPkajcGYw6JXh/xbrmGfy1iagWcF7B36yWor9760vHsZkFe4wcOfY9oslBGGkKkOSUX3Jy1LXzRWlS8aRc3p5LMbLBTBldROmrUPY4UYoKEk0OwvL0bhr3pxW0Ve1go08Mvu4bbg7eK4mBIcZNw0wM8wyi5fgk+KXzMMjNkoU+4psHG3MUEEss3zpxrTQ2YKvmFpEf653t8Wr3fN/2bTgMiQZBShhpNwdHnIIjru/6bij/eeqPN8wLHrWFvneYdGu+u3Pnnt/l7t8pQTgSjeJ0N+HRf1x9lMf+T7ek8JS8W8Kz1WeVkK9Shn8YxsQoJJEIghEUwwmSohmWJ+cEQAhGUAwnSIqW2TEplidXIwCEYATFcIKkaIblyTkCEIIRFMMJkqKTB0IQBNXLsLgbHiNDIiBuRxuqfM2UPV/JxBFAzVZQiWXtUJ0OPUjah24uSesC1smR1iRXqAfJldIKqiTunPNsMlJSn2ldLqrnSfImafDk6sYZFuVcuyTnVDkMJyBp2m663hioegmAyA7UVsGKWpxqlzgCw5ZRC4iMzpbJKugjifoBFJCkdQGlmlMMIG8FUk4CgkEEgiXoAOEBSSOBB0AIghFxVgAAAACwAhTB8OJP6GsHQlAMJyRdAAjBCIrhRJ49qoygGE6QFEAzLC/HboGswqkTAMIQhpMSriGnrkA6qFkVg6pD1KDtmBtBVKEG8bhEW3YMDUHpc7njHQqz34bw4Gzpvhwu0e8hOxU/8+klwAhO0CAAMRgl6ZBQaUcOY4L9YM748h+2/EMhTbfeP31YQ9O75SeWUDjYcqEglrbtsFqFySJOzCtCLOmoPVaX3ufEVxbrb5kKftTteCpF+7EPmMuP47PfYL+qxh4FP3bTcVotZR6KePIfVIhRxOL+rK6MeLvwBHX9730TmwKcgZgMjNS2r+ozOCHCWVdtsB+A+rC6mnechyLOzRWMUl2RXa59E+8jmhShurSjLkKtLpf+ik1Zd+OT7bhEAqWMnzAAISiGE5KWzkGd7sZoc6+UFHIwPBJrneHra7YgzGKJt6SGk8DSXyEe5Xq5sxkM/7dnbVCIOAD06+97Zmcq53tOFJhrZEK28bPw98gTE7KSmSdTfPhNjrXGyGFvD4sbs8tLEr/rCdnMItWEQTE6GvWLhZ5Mc26hlnANXb/fqDEhgzHMjKBi2ltcuhnIUqO98Dy77Vedqsk5+sM9HGPS0Vytpbxow79a/ipk0C7hzFCebx859I+MPzDugzunVtb+D79XVowST95f0oXakP4OAAAA", pme = {
  "page-menu.title": "Pages",
  "tool.note": "Notes",
  "tool.asset": "Upload",
  "style-panel.spline": "Corner Style",
  "tool.rectangle": "Shape",
  "tool.ellipse": "Shape",
  "tool.triangle": "Shape",
  "tool.diamond": "Shape",
  "tool.star": "Shape",
  "tool.pentagon": "Shape",
  "tool.hexagon": "Shape",
  "tool.octagon": "Shape",
  "tool.rhombus": "Shape",
  "tool.rhombus-2": "Shape",
  "tool.oval": "Shape",
  "tool.trapezoid": "Shape",
  "tool.arrow-left": "Shape",
  "tool.arrow-right": "Shape",
  "tool.arrow-up": "Shape",
  "tool.arrow-down": "Shape",
  "tool.cloud": "Shape",
  "tool.x-box": "Shape",
  "tool.check-box": "Shape",
  "tool.heart": "Shape",
  "geo-style.heart": "Heart"
}, fme = (t = {}) => ({
  tldraw: HMe,
  figma: VMe,
  google_maps: KMe,
  val_town: XMe,
  codesandbox: JMe,
  codepen: qMe,
  scratch: _Me,
  youtube: $Me,
  google_calendar: eme,
  google_slides: tme,
  github_gist: nme,
  replit: ime,
  felt: rme,
  spotify: sme,
  vimeo: ome,
  excalidraw: ame,
  observable: cme,
  desmos: lme
}), Mme = {
  en: pme
}, mme = (t = {}) => ({
  draw: W(dme, t),
  monospace: W(ume, t),
  sansSerif: W(hme, t),
  serif: W(gme, t)
}), yme = (t = {}) => ({
  "tool-pointer": "data:image/svg+xml;base64," + W(Fge, t),
  "tool-hand": "data:image/svg+xml;base64," + W(Bge, t),
  "tool-pencil": "data:image/svg+xml;base64," + W(Gge, t),
  "tool-arrow": "data:image/svg+xml;base64," + W(Wge, t),
  "tool-text": "data:image/svg+xml;base64," + W(Kge, t),
  grid: "data:image/svg+xml;base64," + W(Hge, t),
  "grid-empty": "data:image/svg+xml;base64," + W(Vge, t),
  "tool-note": "data:image/svg+xml;base64," + W(Xge, t),
  "tool-floorplanner": `data:image/svg+xml;base64,${W(Jge, t)}`,
  "tool-line": "data:image/svg+xml;base64," + W(qge, t),
  "icon-library": "data:image/svg+xml;base64," + W(_ge, t),
  "image-gallery-icon": `data:image/svg+xml;base64,${W($ge, t)}`,
  "wall-intersect": "data:image/svg+xml;base64," + W(epe, t),
  "tool-eraser": "data:image/svg+xml;base64," + W(tpe, t),
  "colour-palette": "data:image/svg+xml;base64," + W(npe, t),
  menu: `data:image/svg+xml;base64,${W(ipe, t)}`,
  pin: `data:image/svg+xml;base64,${W(rpe, t)}`,
  unpin: `data:image/svg+xml;base64,${W(spe, t)}`,
  "back-arrow": `data:image/svg+xml;base64,${W(ope, t)}`,
  door: `data:image/svg+xml;base64,${W(ape, t)}`,
  window: `data:image/svg+xml;base64,${W(cpe, t)}`,
  wall: `data:image/svg+xml;base64,${W(lpe, t)}`,
  bin: `data:image/svg+xml;base64,${W(dpe, t)}`,
  ruler: `data:image/svg+xml;base64,${W(upe, t)}`,
  save: `data:image/svg+xml;base64,${W(hpe, t)}`,
  cut: `data:image/svg+xml;base64,${W(gpe, t)}`,
  search: `data:image/svg+xml;base64,${W(ppe, t)}`,
  "pest-icon": `data:image/svg+xml;base64,${W(fpe, t)}`,
  "wall-external": `data:image/svg+xml;base64,${W(Mpe, t)}`,
  "wall-internal": `data:image/svg+xml;base64,${W(mpe, t)}`,
  "wall-partition": `data:image/svg+xml;base64,${W(ype, t)}`,
  "align-left": `data:image/svg+xml;base64,${W(Ipe, t)}`,
  "align-center-horizontal": `data:image/svg+xml;base64,${W(xpe, t)}`,
  "align-right": `data:image/svg+xml;base64,${W(Spe, t)}`,
  "align-top": `data:image/svg+xml;base64,${W(jpe, t)}`,
  "align-center-vertical": `data:image/svg+xml;base64,${W(Dpe, t)}`,
  "align-bottom": `data:image/svg+xml;base64,${W(wpe, t)}`,
  ungroup: `data:image/svg+xml;base64,${W(Npe, t)}`,
  group: `data:image/svg+xml;base64,${W(Ape, t)}`,
  duplicate: `data:image/svg+xml;base64,${W(Tpe, t)}`,
  "flip-horizontal": `data:image/svg+xml;base64,${W(bpe, t)}`,
  "flip-vertical": `data:image/svg+xml;base64,${W(vpe, t)}`,
  "bring-to-front": `data:image/svg+xml;base64,${W(Epe, t)}`,
  "bring-forward": `data:image/svg+xml;base64,${W(Cpe, t)}`,
  "send-backward": `data:image/svg+xml;base64,${W(zpe, t)}`,
  "send-to-back": `data:image/svg+xml;base64,${W(Lpe, t)}`,
  settings: `data:image/svg+xml;base64,${W(kpe, t)}`,
  "chevron-down": `data:image/svg+xml;base64,${W(Ope, t)}`,
  "stretch-horizontal": `data:image/svg+xml;base64,${W(Ppe, t)}`,
  "stretch-vertical": `data:image/svg+xml;base64,${W(Upe, t)}`,
  undo: `data:image/svg+xml;base64,${W(Rpe, t)}`,
  redo: `data:image/svg+xml;base64,${W(Ype, t)}`,
  "chevrons-ne": `data:image/svg+xml;base64,${W(Qpe, t)}`,
  "fill-none": `data:image/svg+xml;base64,${W(Zpe, t)}`,
  "dash-draw": `data:image/svg+xml;base64,${W(Fpe, t)}`,
  "size-medium": `data:image/svg+xml;base64,${W(Bpe, t)}`,
  "geo-rectangle": `data:image/svg+xml;base64,${W(Gpe, t)}`,
  "tool-media": `data:image/svg+xml;base64,${W(Wpe, t)}`,
  "arrow-left": `data:image/svg+xml;base64,${W(Hpe, t)}`,
  "arrowhead-arrow": `data:image/svg+xml;base64,${W(Vpe, t)}`,
  "arrowhead-bar": `data:image/svg+xml;base64,${W(Kpe, t)}`,
  "arrowhead-diamond": `data:image/svg+xml;base64,${W(Xpe, t)}`,
  "arrowhead-dot": `data:image/svg+xml;base64,${W(Jpe, t)}`,
  "arrowhead-none": `data:image/svg+xml;base64,${W(qpe, t)}`,
  "arrowhead-square": `data:image/svg+xml;base64,${W(_pe, t)}`,
  "arrowhead-triangle-inverted": `data:image/svg+xml;base64,${W($pe, t)}`,
  "arrowhead-triangle": `data:image/svg+xml;base64,${W(efe, t)}`,
  blob: `data:image/svg+xml;base64,${W(tfe, t)}`,
  broken: `data:image/svg+xml;base64,${W(nfe, t)}`,
  "check-circle": `data:image/svg+xml;base64,${W(ife, t)}`,
  check: `data:image/svg+xml;base64,${W(rfe, t)}`,
  "chevron-left": `data:image/svg+xml;base64,${W(sfe, t)}`,
  "chevron-right": `data:image/svg+xml;base64,${W(ofe, t)}`,
  "chevron-up": `data:image/svg+xml;base64,${W(afe, t)}`,
  "chevrons-sw": `data:image/svg+xml;base64,${W(cfe, t)}`,
  "clipboard-copied": `data:image/svg+xml;base64,${W(lfe, t)}`,
  "clipboard-copy": `data:image/svg+xml;base64,${W(dfe, t)}`,
  color: `data:image/svg+xml;base64,${W(ufe, t)}`,
  "cross-2": `data:image/svg+xml;base64,${W(hfe, t)}`,
  "cross-circle": `data:image/svg+xml;base64,${W(gfe, t)}`,
  "dash-dashed": `data:image/svg+xml;base64,${W(pfe, t)}`,
  "dash-dotted": `data:image/svg+xml;base64,${W(ffe, t)}`,
  "dash-solid": `data:image/svg+xml;base64,${W(Mfe, t)}`,
  disconnected: `data:image/svg+xml;base64,${W(mfe, t)}`,
  discord: `data:image/svg+xml;base64,${W(yfe, t)}`,
  "distribute-horizontal": `data:image/svg+xml;base64,${W(Ife, t)}`,
  "distribute-vertical": `data:image/svg+xml;base64,${W(xfe, t)}`,
  dot: `data:image/svg+xml;base64,${W(Sfe, t)}`,
  "dots-horizontal": `data:image/svg+xml;base64,${W(jfe, t)}`,
  "dots-vertical": `data:image/svg+xml;base64,${W(Dfe, t)}`,
  "drag-handle-dots": `data:image/svg+xml;base64,${W(wfe, t)}`,
  edit: `data:image/svg+xml;base64,${W(Nfe, t)}`,
  "external-link": `data:image/svg+xml;base64,${W(Afe, t)}`,
  "fill-fill": `data:image/svg+xml;base64,${W(Tfe, t)}`,
  "fill-pattern": `data:image/svg+xml;base64,${W(bfe, t)}`,
  "fill-semi": `data:image/svg+xml;base64,${W(vfe, t)}`,
  "fill-solid": `data:image/svg+xml;base64,${W(Efe, t)}`,
  follow: `data:image/svg+xml;base64,${W(Cfe, t)}`,
  following: `data:image/svg+xml;base64,${W(zfe, t)}`,
  "font-draw": `data:image/svg+xml;base64,${W(Lfe, t)}`,
  "font-mono": `data:image/svg+xml;base64,${W(kfe, t)}`,
  "font-sans": `data:image/svg+xml;base64,${W(Ofe, t)}`,
  "font-serif": `data:image/svg+xml;base64,${W(Pfe, t)}`,
  "geo-arrow-down": `data:image/svg+xml;base64,${W(Ufe, t)}`,
  "geo-arrow-left": `data:image/svg+xml;base64,${W(Rfe, t)}`,
  "geo-arrow-right": `data:image/svg+xml;base64,${W(Yfe, t)}`,
  "geo-arrow-up": `data:image/svg+xml;base64,${W(Qfe, t)}`,
  "geo-check-box": `data:image/svg+xml;base64,${W(Zfe, t)}`,
  "geo-cloud": `data:image/svg+xml;base64,${W(Ffe, t)}`,
  "geo-diamond": `data:image/svg+xml;base64,${W(Bfe, t)}`,
  "geo-ellipse": `data:image/svg+xml;base64,${W(Gfe, t)}`,
  "geo-heart": `data:image/svg+xml;base64,${W(Wfe, t)}`,
  "geo-hexagon": `data:image/svg+xml;base64,${W(Hfe, t)}`,
  "geo-octagon": `data:image/svg+xml;base64,${W(Vfe, t)}`,
  "geo-oval": `data:image/svg+xml;base64,${W(Kfe, t)}`,
  "geo-pentagon": `data:image/svg+xml;base64,${W(Xfe, t)}`,
  "geo-rhombus-2": `data:image/svg+xml;base64,${W(Jfe, t)}`,
  "geo-rhombus": `data:image/svg+xml;base64,${W(qfe, t)}`,
  "geo-star": `data:image/svg+xml;base64,${W(_fe, t)}`,
  "geo-trapezoid": `data:image/svg+xml;base64,${W($fe, t)}`,
  "geo-triangle": `data:image/svg+xml;base64,${W(eMe, t)}`,
  "geo-x-box": `data:image/svg+xml;base64,${W(tMe, t)}`,
  github: `data:image/svg+xml;base64,${W(nMe, t)}`,
  "horizontal-align-end": `data:image/svg+xml;base64,${W(iMe, t)}`,
  "horizontal-align-middle": `data:image/svg+xml;base64,${W(rMe, t)}`,
  "horizontal-align-start": `data:image/svg+xml;base64,${W(sMe, t)}`,
  "info-circle": `data:image/svg+xml;base64,${W(oMe, t)}`,
  leading: `data:image/svg+xml;base64,${W(aMe, t)}`,
  link: `data:image/svg+xml;base64,${W(cMe, t)}`,
  lock: `data:image/svg+xml;base64,${W(lMe, t)}`,
  minus: `data:image/svg+xml;base64,${W(dMe, t)}`,
  mixed: `data:image/svg+xml;base64,${W(uMe, t)}`,
  pack: `data:image/svg+xml;base64,${W(hMe, t)}`,
  plus: `data:image/svg+xml;base64,${W(gMe, t)}`,
  "question-mark-circle": `data:image/svg+xml;base64,${W(pMe, t)}`,
  "question-mark": `data:image/svg+xml;base64,${W(fMe, t)}`,
  "reset-zoom": `data:image/svg+xml;base64,${W(MMe, t)}`,
  "rotate-ccw": `data:image/svg+xml;base64,${W(mMe, t)}`,
  "rotate-cw": `data:image/svg+xml;base64,${W(yMe, t)}`,
  "share-1": `data:image/svg+xml;base64,${W(IMe, t)}`,
  "size-extra-large": `data:image/svg+xml;base64,${W(xMe, t)}`,
  "size-large": `data:image/svg+xml;base64,${W(SMe, t)}`,
  "size-small": `data:image/svg+xml;base64,${W(jMe, t)}`,
  "spline-cubic": `data:image/svg+xml;base64,${W(DMe, t)}`,
  "spline-line": `data:image/svg+xml;base64,${W(wMe, t)}`,
  "stack-horizontal": `data:image/svg+xml;base64,${W(NMe, t)}`,
  "stack-vertical": `data:image/svg+xml;base64,${W(AMe, t)}`,
  "status-offline": `data:image/svg+xml;base64,${W(TMe, t)}`,
  "text-align-center": `data:image/svg+xml;base64,${W(bMe, t)}`,
  "text-align-left": `data:image/svg+xml;base64,${W(vMe, t)}`,
  "text-align-right": `data:image/svg+xml;base64,${W(EMe, t)}`,
  "toggle-off": `data:image/svg+xml;base64,${W(CMe, t)}`,
  "toggle-on": `data:image/svg+xml;base64,${W(zMe, t)}`,
  "tool-frame": `data:image/svg+xml;base64,${W(LMe, t)}`,
  "tool-highlight": `data:image/svg+xml;base64,${W(kMe, t)}`,
  "tool-laser": `data:image/svg+xml;base64,${W(OMe, t)}`,
  "tool-screenshot": `data:image/svg+xml;base64,${W(PMe, t)}`,
  trash: `data:image/svg+xml;base64,${W(UMe, t)}`,
  twitter: `data:image/svg+xml;base64,${W(RMe, t)}`,
  unlock: `data:image/svg+xml;base64,${W(YMe, t)}`,
  "vertical-align-end": `data:image/svg+xml;base64,${W(QMe, t)}`,
  "vertical-align-middle": `data:image/svg+xml;base64,${W(ZMe, t)}`,
  "vertical-align-start": `data:image/svg+xml;base64,${W(FMe, t)}`,
  "warning-triangle": `data:image/svg+xml;base64,${W(BMe, t)}`,
  "zoom-in": `data:image/svg+xml;base64,${W(GMe, t)}`,
  "zoom-out": `data:image/svg+xml;base64,${W(WMe, t)}`
});
function Ime(t) {
  return t.startsWith("data:") ? `data:image/svg+xml;base64,${btoa(t)}` : t;
}
function W(t, e = {}) {
  const n = typeof t == "string" ? t : t.src;
  if (typeof e == "function") return e(n);
  const { baseUrl: i = "" } = e;
  return n.startsWith("data:") || n.match(/^https?:\/\//) ? n : `${i.replace(/\/$/, "")}/${n.replace(/^\.?\//, "")}`;
}
function xme(t = {}) {
  return {
    icons: yme(Ime),
    embeddedIcons: fme,
    fonts: mme(),
    translations: Mme
  };
}
const kA = Kd.div`
    background-color: rgb(255, 255, 255);
    position: fixed;
	inset: 0px;
	overflow: hidden;
	overscroll-behavior: none;
    display: flex;
    flex-direction: column;

    font-size: 12px;
	font-family: 'Outfit', sans-serif;
	height: 100%;
	display: flex;
	flex-grow: 1;
	padding: 0px;
	margin: 0px;
`, OA = Kd.div`
    flex-grow: 1
`;
function Sme({
  size: t,
  width: e,
  height: n,
  hideAlternateHandles: i
}) {
  const r = k(t / 3), s = r / 2;
  return /* @__PURE__ */ l.jsxs("svg", { className: "tl-overlays__item", children: [
    /* @__PURE__ */ l.jsx(
      "polyline",
      {
        className: "tl-corner-crop-handle",
        points: `
						${k(0 - s)},${k(t)} 
						${k(0 - s)},${k(0 - s)} 
						${k(t)},${k(0 - s)}`,
        strokeWidth: r,
        "data-testid": "selection.crop.top_left",
        "aria-label": "top_left handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "line",
      {
        className: ce("tl-corner-crop-edge-handle", {
          "tl-hidden": i
        }),
        x1: k(e / 2 - t),
        y1: k(0 - s),
        x2: k(e / 2 + t),
        y2: k(0 - s),
        strokeWidth: r,
        "data-testid": "selection.crop.top",
        "aria-label": "top handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "polyline",
      {
        className: ce("tl-corner-crop-handle", {
          "tl-hidden": i
        }),
        points: `
						${k(e - t)},${k(0 - s)} 
						${k(e + s)},${k(0 - s)} 
						${k(e + s)},${k(t)}`,
        strokeWidth: r,
        "data-testid": "selection.crop.top_right",
        "aria-label": "top_right handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "line",
      {
        className: ce("tl-corner-crop-edge-handle", {
          "tl-hidden": i
        }),
        x1: k(e + s),
        y1: k(n / 2 - t),
        x2: k(e + s),
        y2: k(n / 2 + t),
        strokeWidth: r,
        "data-testid": "selection.crop.right",
        "aria-label": "right handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "polyline",
      {
        className: "tl-corner-crop-handle",
        points: `
						${k(e + s)},${k(n - t)} 
						${k(e + s)},${k(n + s)}
						${k(e - t)},${k(n + s)}`,
        strokeWidth: r,
        "data-testid": "selection.crop.bottom_right",
        "aria-label": "bottom_right handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "line",
      {
        className: ce("tl-corner-crop-edge-handle", {
          "tl-hidden": i
        }),
        x1: k(e / 2 - t),
        y1: k(n + s),
        x2: k(e / 2 + t),
        y2: k(n + s),
        strokeWidth: r,
        "data-testid": "selection.crop.bottom",
        "aria-label": "bottom handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "polyline",
      {
        className: ce("tl-corner-crop-handle", {
          "tl-hidden": i
        }),
        points: `
						${k(0 + t)},${k(n + s)} 
						${k(0 - s)},${k(n + s)}
						${k(0 - s)},${k(n - t)}`,
        strokeWidth: r,
        "data-testid": "selection.crop.bottom_left",
        "aria-label": "bottom_left handle"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "line",
      {
        className: ce("tl-corner-crop-edge-handle", {
          "tl-hidden": i
        }),
        x1: k(0 - s),
        y1: k(n / 2 - t),
        x2: k(0 - s),
        y2: k(n / 2 + t),
        strokeWidth: r,
        "data-testid": "selection.crop.left",
        "aria-label": "left handle"
      }
    )
  ] });
}
const jme = Vt(function({
  bounds: e,
  rotation: n
}) {
  var Dt;
  const i = Q(), r = le(null), s = ji(), o = Kt("top"), a = Kt("right"), c = Kt("bottom"), d = Kt("left"), u = Kt("top_left"), h = Kt("top_right"), g = Kt("bottom_right"), p = Kt("bottom_left"), f = !i.menus.hasAnyOpenMenus() && i.getInstanceState().cursor.type === "default", M = i.getInstanceState().isCoarsePointer, m = i.getOnlySelectedShape(), y = m && i.isShapeOrAncestorLocked(m), I = m ? ((Dt = i.getShapeUtil(m)) == null ? void 0 : Dt.expandSelectionOutlinePx(m)) ?? 0 : 0;
  if (Ko(r, e == null ? void 0 : e.x, e == null ? void 0 : e.y, 1, i.getSelectionRotation(), {
    x: -I,
    y: -I
  }), m && i.isShapeHidden(m) || !e) return null;
  e = e.clone().expandBy(I).zeroFix();
  const D = i.getZoomLevel(), j = i.getInstanceState().isChangingStyle, w = e.width, A = e.height, b = 8 / D, T = w < b * 2, E = A < b * 2, v = w < b * 4, P = A < b * 4, C = w < b * 5, z = A < b * 5, O = 1.75, R = 6 / D * O, U = (v ? R / 2 : R) * (O * 0.75), F = (P ? R / 2 : R) * (O * 0.75), H = (m ? !i.getShapeUtil(m).hideSelectionBoundsFg(m) : !0) && !j;
  let Z = H && i.isInAny(
    "select.idle",
    "select.brushing",
    "select.scribble_brushing",
    "select.pointing_canvas",
    "select.pointing_selection",
    "select.pointing_shape",
    "select.crop.idle",
    "select.crop.pointing_crop",
    "select.crop.pointing_crop_handle",
    "select.pointing_resize_handle"
  ) || H && i.isIn("select.resizing") && m && i.isShapeOfType(m, "text");
  m && Z && mt.isFirefox && i.isShapeOfType(m, "embed") && (Z = !1);
  const te = i.isInAny(
    "select.crop.idle",
    "select.crop.pointing_crop",
    "select.crop.pointing_crop_handle"
  ) && !j && !s, oe = i.isInAny(
    "select.idle",
    "select.pointing_selection",
    "select.pointing_shape",
    "select.crop.idle"
  ) && !j && !s, me = !M && !(T || E) && (oe || te) && (m ? !i.getShapeUtil(m).hideRotateHandle(m) : !0) && !y, he = (!v || !P) && (oe || te) && (m ? !i.getShapeUtil(m).hideRotateHandle(m) : !0) && !y, ve = oe && (m ? i.getShapeUtil(m).canResize(m) && !i.getShapeUtil(m).hideResizeHandles(m) : !0) && !te && !y, ie = T || E, Ue = T && E, ge = C || z, Re = ve || te, ye = !me, Be = !oe || !he, We = !oe || !Re, lt = !oe || !Re || ie, $ = !oe || !Re || ie, X = !oe || !Re || Ue && !te;
  let Ie = !0, je = !0;
  if (te)
    Ie = ge, je = ge;
  else if (ve) {
    Ie = ie || Ue || M;
    const Xr = M && m && m.type === "text";
    je = Ie && !Xr;
  }
  const Oe = Math.min(24 / D, A - F * 3), zt = oe && M && m && i.isShapeOfType(m, "text") && Oe * D >= 4;
  return /* @__PURE__ */ l.jsx("svg", { className: "tl-overlays__item tl-selection__fg", "data-testid": "selection-foreground", children: /* @__PURE__ */ l.jsxs("g", { ref: r, children: [
    Z && /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: "tl-selection__fg__outline",
        width: k(w),
        height: k(A)
      }
    ),
    /* @__PURE__ */ l.jsx(
      ph,
      {
        "data-testid": "selection.rotate.top-left",
        cx: 0,
        cy: 0,
        targetSize: R,
        corner: "top_left_rotate",
        cursor: f ? Et("nwse-rotate", n) : void 0,
        isHidden: ye
      }
    ),
    /* @__PURE__ */ l.jsx(
      ph,
      {
        "data-testid": "selection.rotate.top-right",
        cx: w + R * 3,
        cy: 0,
        targetSize: R,
        corner: "top_right_rotate",
        cursor: f ? Et("nesw-rotate", n) : void 0,
        isHidden: ye
      }
    ),
    /* @__PURE__ */ l.jsx(
      ph,
      {
        "data-testid": "selection.rotate.bottom-left",
        cx: 0,
        cy: A + R * 3,
        targetSize: R,
        corner: "bottom_left_rotate",
        cursor: f ? Et("swne-rotate", n) : void 0,
        isHidden: ye
      }
    ),
    /* @__PURE__ */ l.jsx(
      ph,
      {
        "data-testid": "selection.rotate.bottom-right",
        cx: w + R * 3,
        cy: A + R * 3,
        targetSize: R,
        corner: "bottom_right_rotate",
        cursor: f ? Et("senw-rotate", n) : void 0,
        isHidden: ye
      }
    ),
    /* @__PURE__ */ l.jsx(
      wme,
      {
        "data-testid": "selection.rotate.mobile",
        cx: v ? -R * 1.5 : w / 2,
        cy: v ? A / 2 : -R * 1.5,
        size: b,
        isHidden: Be
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": Ie
        }),
        "data-testid": "selection.resize.top",
        "aria-label": "top target",
        pointerEvents: "all",
        x: 0,
        y: k(0 - (P ? F * 2 : F)),
        width: k(w),
        height: k(Math.max(1, F * 2)),
        style: f ? { cursor: Et("ns-resize", n) } : void 0,
        ...o
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": je
        }),
        "data-testid": "selection.resize.right",
        "aria-label": "right target",
        pointerEvents: "all",
        x: k(w - (v ? 0 : U)),
        y: 0,
        height: k(A),
        width: k(Math.max(1, U * 2)),
        style: f ? { cursor: Et("ew-resize", n) } : void 0,
        ...a
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": Ie
        }),
        "data-testid": "selection.resize.bottom",
        "aria-label": "bottom target",
        pointerEvents: "all",
        x: 0,
        y: k(A - (P ? 0 : F)),
        width: k(w),
        height: k(Math.max(1, F * 2)),
        style: f ? { cursor: Et("ns-resize", n) } : void 0,
        ...c
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": je
        }),
        "data-testid": "selection.resize.left",
        "aria-label": "left target",
        pointerEvents: "all",
        x: k(0 - (v ? U * 2 : U)),
        y: 0,
        height: k(A),
        width: k(Math.max(1, U * 2)),
        style: f ? { cursor: Et("ew-resize", n) } : void 0,
        ...d
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": We
        }),
        "data-testid": "selection.target.top-left",
        "aria-label": "top-left target",
        pointerEvents: "all",
        x: k(0 - (v ? U * 2 : U * 1.5)),
        y: k(0 - (P ? F * 2 : F * 1.5)),
        width: k(U * 3),
        height: k(F * 3),
        style: f ? { cursor: Et("nwse-resize", n) } : void 0,
        ...u
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": lt
        }),
        "data-testid": "selection.target.top-right",
        "aria-label": "top-right target",
        pointerEvents: "all",
        x: k(w - (v ? 0 : U * 1.5)),
        y: k(0 - (P ? F * 2 : F * 1.5)),
        width: k(U * 3),
        height: k(F * 3),
        style: f ? { cursor: Et("nesw-resize", n) } : void 0,
        ...h
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": X
        }),
        "data-testid": "selection.target.bottom-right",
        "aria-label": "bottom-right target",
        pointerEvents: "all",
        x: k(w - (v ? U : U * 1.5)),
        y: k(A - (P ? F : F * 1.5)),
        width: k(U * 3),
        height: k(F * 3),
        style: f ? { cursor: Et("nwse-resize", n) } : void 0,
        ...g
      }
    ),
    /* @__PURE__ */ l.jsx(
      "rect",
      {
        className: ce("tl-transparent", {
          "tl-hidden": $
        }),
        "data-testid": "selection.target.bottom-left",
        "aria-label": "bottom-left target",
        pointerEvents: "all",
        x: k(0 - (v ? U * 3 : U * 1.5)),
        y: k(A - (P ? 0 : F * 1.5)),
        width: k(U * 3),
        height: k(F * 3),
        style: f ? { cursor: Et("nesw-resize", n) } : void 0,
        ...p
      }
    ),
    ve && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.resize.top-left",
          className: ce("tl-corner-handle", {
            "tl-hidden": We
          }),
          "aria-label": "top_left handle",
          x: k(0 - b / 2),
          y: k(0 - b / 2),
          width: k(b),
          height: k(b)
        }
      ),
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.resize.top-right",
          className: ce("tl-corner-handle", {
            "tl-hidden": lt
          }),
          "aria-label": "top_right handle",
          x: k(w - b / 2),
          y: k(0 - b / 2),
          width: k(b),
          height: k(b)
        }
      ),
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.resize.bottom-right",
          className: ce("tl-corner-handle", {
            "tl-hidden": X
          }),
          "aria-label": "bottom_right handle",
          x: k(w - b / 2),
          y: k(A - b / 2),
          width: k(b),
          height: k(b)
        }
      ),
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.resize.bottom-left",
          className: ce("tl-corner-handle", {
            "tl-hidden": $
          }),
          "aria-label": "bottom_left handle",
          x: k(0 - b / 2),
          y: k(A - b / 2),
          width: k(b),
          height: k(b)
        }
      )
    ] }),
    zt && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.text-resize.left.handle",
          className: "tl-text-handle",
          "aria-label": "bottom_left handle",
          x: k(0 - b / 4),
          y: k(A / 2 - Oe / 2),
          rx: b / 4,
          width: k(b / 2),
          height: k(Oe)
        }
      ),
      /* @__PURE__ */ l.jsx(
        "rect",
        {
          "data-testid": "selection.text-resize.right.handle",
          className: "tl-text-handle",
          "aria-label": "bottom_left handle",
          rx: b / 4,
          x: k(w - b / 4),
          y: k(A / 2 - Oe / 2),
          width: k(b / 2),
          height: k(Oe)
        }
      )
    ] }),
    te && /* @__PURE__ */ l.jsx(
      Sme,
      {
        size: b,
        width: w,
        height: A,
        hideAlternateHandles: ge
      }
    )
  ] }) });
}), ph = function({
  cx: e,
  cy: n,
  targetSize: i,
  corner: r,
  cursor: s,
  isHidden: o,
  "data-testid": a
}) {
  const c = Kt(r);
  return /* @__PURE__ */ l.jsx(
    "rect",
    {
      className: ce("tl-transparent", "tl-rotate-corner", { "tl-hidden": o }),
      "data-testid": a,
      "aria-label": `${r} target`,
      pointerEvents: "all",
      x: k(e - i * 3),
      y: k(n - i * 3),
      width: k(Math.max(1, i * 3)),
      height: k(Math.max(1, i * 3)),
      cursor: s,
      ...c
    }
  );
}, Dme = Math.sqrt(Math.PI), wme = function({
  cx: e,
  cy: n,
  size: i,
  isHidden: r,
  "data-testid": s
}) {
  const o = Kt("mobile_rotate"), a = Q(), c = G("zoom level", () => a.getZoomLevel(), [a]), d = Math.max(14 * (1 / c), 20 / Math.max(1, c));
  return /* @__PURE__ */ l.jsxs("g", { children: [
    /* @__PURE__ */ l.jsx(
      "circle",
      {
        "data-testid": s,
        pointerEvents: "all",
        className: ce("tl-transparent", "tl-mobile-rotate__bg", { "tl-hidden": r }),
        cx: e,
        cy: n,
        r: d,
        ...o
      }
    ),
    /* @__PURE__ */ l.jsx(
      "circle",
      {
        className: ce("tl-mobile-rotate__fg", { "tl-hidden": r }),
        cx: e,
        cy: n,
        r: i / Dme
      }
    )
  ] });
}, Nme = new URLSearchParams(window.location.search);
Nme.has("isMobile");
const Ame = 1920, Tme = 1080, bme = {}, vme = (t) => {
  if (!t) return;
  const e = t.getSnapshot(), n = new Blob([JSON.stringify({
    draw: e,
    legend: Zn.get()
  })], { type: "application/json" }), i = URL.createObjectURL(n), r = document.createElement("a");
  r.href = i, r.download = "drawing.json", r.click(), URL.revokeObjectURL(i);
}, ka = async ({ editor: t, page: e = null, format: n = "png", settings: i, quality: r = 1 }) => {
  if (!t) return;
  e == null && (e = t.getCurrentPageId());
  const s = Array.from(
    t.getPageShapeIds(e),
    (d) => t.getShape(d)
  ).filter((d) => d.type == "grid"), o = new ae(
    0,
    0,
    Math.ceil(i.width / i.defaultGridSize) * i.defaultGridSize,
    Math.ceil(i.height / i.defaultGridSize) * i.defaultGridSize
  );
  s.length != 0 && (o.w = s[0].props.w, o.h = s[0].props.h);
  const a = Array.from(t == null ? void 0 : t.getPageShapeIds(e)), c = {
    padding: 0,
    bounds: o
  };
  switch (i.ignoreGridDimensions && (c.bounds = void 0), n) {
    case "svg":
    case "json":
      return Jp({
        editor: t,
        format: n,
        //@ts-ignore
        ids: a,
        opts: c
      });
    case "jpeg":
    case "png":
    case "webp":
    default: {
      const d = await kme(t, a, c);
      if (!d) throw new Error("Could not construct image.");
      const u = await PS(t, d.svg, {
        type: n,
        quality: r,
        scale: 1,
        width: d.width,
        height: d.height
      });
      if (!u)
        throw new Error("Could not construct image.");
      return u;
    }
  }
}, Eme = (t, e) => {
  if (t)
    return t == null || t.getCurrentPageShapes().filter((n) => n.type == "grid"), ka({
      editor: t,
      page: null,
      format: "png",
      settings: e
    }).then((n) => {
      const i = URL.createObjectURL(n), r = document.createElement("a");
      r.href = i, r.download = "drawing.png", r.click(), URL.revokeObjectURL(i);
    });
}, Cme = (t, e) => {
  if (t)
    return t == null || t.getCurrentPageShapes().filter((n) => n.type == "grid"), ka({
      editor: t,
      page: null,
      format: "svg",
      settings: e
    }).then((n) => {
      const i = URL.createObjectURL(n), r = document.createElement("a");
      r.href = i, r.download = "drawing.svg", r.click(), URL.revokeObjectURL(i);
    });
}, zme = dc(function({
  width: e = Ame,
  height: n = Tme,
  gridSize: i = 16,
  canDuplicate: r = !0,
  canCreatePage: s = !0,
  displayGrid: o = !0,
  ScreenComponent: a = kA,
  OnTheCanvasComponent: c = null,
  canExport: d = !1,
  useDebugJson: u = !1,
  canSave: h = !1,
  canvasData: g = null,
  InFrontOfTheCanvasComponent: p = null,
  preferences: f = {},
  showGridOptions: M = !0,
  canExit: m = !1,
  onExitInvoked: y = (b) => Promise.resolve(),
  onSaveInvoked: I = () => {
  },
  onMount: D = (b) => {
  },
  onPreferenceUpdate: j = (b, T) => {
  },
  screenStyle: w = {}
}, A) {
  const b = yt(() => xme(), []);
  ze(() => {
    const $ = _o();
    Fl({
      canExport: d,
      canSave: h,
      canExit: m,
      width: e,
      height: n,
      isMobile: ie,
      initialSettings: {
        ...$,
        canExport: d,
        canSave: h,
        canExit: m,
        width: e,
        height: n,
        isMobile: ie
      }
    });
  }, [d, h, m, e, n]);
  const [T, E] = pe(!1), [v, P] = pe(null), [C, z] = pe(!1), [O, R] = pe(null), U = le(null), F = le(null), H = le(null), Z = le(null), te = le(null), oe = le(null), me = le(null), he = le(null), ve = le(null), [ie, Ue] = pe(!1);
  at(() => {
    const $ = window.matchMedia("(max-width: 660px)");
    Ue($.matches);
    const X = (Ie) => {
      Ue(Ie.matches);
    };
    return $.addEventListener("change", X), () => $.removeEventListener("change", X);
  }, []);
  const ge = {
    width: e,
    height: n,
    defaultGridSize: i
  }, Re = ($) => {
    if (o) {
      const X = Ee();
      if ((v == null ? void 0 : v.getCurrentPageShapes().filter((Dt) => Dt.type == "grid")).length != 0) return;
      v.createShape(
        {
          parentId: $.id,
          id: X,
          type: "grid",
          props: {
            w: Math.ceil(ge.width / ge.defaultGridSize) * ge.defaultGridSize,
            h: Math.ceil(ge.height / ge.defaultGridSize) * ge.defaultGridSize,
            gridSize: ge.defaultGridSize
          }
        }
      );
      const je = Ee();
      v.createShape(
        {
          parentId: o ? X : void 0,
          id: je,
          type: "legend",
          props: {
            legendSize: {
              w: 16,
              h: 16
            },
            legendCount: 1
          }
        }
      );
      const Oe = v.getShapeGeometry(X), zt = v.getShapeGeometry(je);
      v.updateShape({
        type: "legend",
        id: je,
        y: Oe.bounds.h - zt.bounds.h - 10,
        x: Oe.bounds.w - zt.bounds.w - 10
      });
    }
  };
  ze(() => {
    if (!v) return;
    v.store.sideEffects.registerBeforeDeleteHandler("shape", (X) => {
      if (X.type === "grid") return !1;
    });
    const $ = v.store.listen(
      (X) => {
        var je;
        let Ie = !1;
        if (X.changes && X.changes.added) {
          for (const Oe in X.changes.added)
            if (Ie = !0, X.changes.added[Oe].typeName && X.changes.added[Oe].typeName == "page") {
              Re(X.changes.added[Oe]);
              continue;
            }
        }
        if (X.changes && X.changes.updated && (Ie = Ie || Object.keys(X.changes.updated).length > 0), X.changes && X.changes.removed)
          for (const Oe in X.changes.removed) {
            Ie = !0;
            try {
              const zt = v.getShapeUtil(X.changes.removed[Oe]);
              (je = zt.onDelete) == null || je.call(zt, X.changes.removed[Oe]);
            } catch {
            }
          }
        Ie && E(!0);
      },
      {
        scope: "document",
        source: "all"
      }
    );
    return () => {
      $();
    };
  }, [
    v
  ]);
  const ye = yt(
    () => ({
      importJson: ($) => {
        $.legend && Zn.set($.legend), $.draw && v.loadSnapshot($.draw);
      },
      exportJson: () => ({
        draw: v.getSnapshot(),
        legend: Zn.get()
      }),
      exportImage: ({ page: $ = null, _settings: X = null, format: Ie }) => (X === null && (X = ge), ka({
        editor: v,
        page: $,
        format: Ie,
        settings: X
      })),
      exportPng: ({ page: $ = null, _settings: X = null }) => (X === null && (X = ge), ka({
        editor: v,
        page: $,
        format: "png",
        settings: X
      })),
      exportJpeg: ({ page: $ = null, _settings: X = null, quality: Ie = 0.92 }) => (X === null && (X = ge), ka({
        editor: v,
        page: $,
        format: "jpeg",
        settings: X,
        quality: Ie
      })),
      exportSvg: ($) => ka({
        editor: v,
        page: $,
        format: "svg",
        settings: ge
      }),
      getPages: () => v.getPages(),
      getCurrentPage: () => v.getCurrentPage(),
      clear: () => {
        v.store.clear();
      },
      removePage: ($) => {
        v.deletePage($);
      },
      createPage: ({ name: $ = "", meta: X = {} }) => {
        const Ie = kn.createId();
        return v.createPage({
          id: Ie,
          name: $,
          meta: X
        }), Ie;
      },
      updateCamera: () => {
        Fa(v);
      },
      importImages: async ($) => {
        const X = Array.from(ye.getPages());
        let Ie = null;
        for (const je of $) {
          const Oe = ye.createPage({ name: je.imageInfo.name, meta: je.imageInfo.meta ?? {} });
          Ie || (Ie = Oe), await ye.importImage(Oe, je.imageData, je.imageInfo);
        }
        X.forEach((je) => ye.removePage(je.id)), v.setCurrentPage(Ie), Fa(v);
      },
      importImage: async ($, X, Ie) => {
        if (X instanceof HTMLElement) {
          const Dt = document.createElement("canvas");
          Dt.width = X.width, Dt.height = X.height;
          const Xr = Dt.getContext("2d");
          Xr == null || Xr.drawImage(X, 0, 0), X = Dt.toDataURL();
        }
        X instanceof Blob && (X = URL.createObjectURL(X));
        const je = Ee(), Oe = ci.createId(`image-${je}`), zt = Ee();
        v.createShape({
          parentId: $,
          id: zt,
          type: "grid",
          isLocked: !0,
          props: {
            w: Ie.w,
            h: Ie.h,
            renderType: "none",
            showRuler: !1
          }
        }), v.createAssets([
          {
            id: Oe,
            type: "image",
            typeName: "asset",
            props: {
              name: "image",
              src: X,
              w: Ie.w,
              h: Ie.h,
              fileSize: 1,
              mimeType: Ie.mimeType,
              isAnimated: !1
            },
            meta: {
              assetType: "image"
            }
          }
        ]), v.createShape({
          parentId: zt,
          id: je,
          type: "image",
          x: 0,
          y: 0,
          isLocked: !0,
          props: {
            assetId: Oe,
            w: Ie.w,
            h: Ie.h
          }
        });
      }
    }),
    [v]
  );
  q3(A, () => ye, [v, ye]);
  const Be = Zt(), We = a ?? kA, lt = () => {
    if (O) {
      R(null);
      return;
    }
    const $ = v == null ? void 0 : v.getCurrentPageShapes().filter((X) => X.type == "grid");
    Jp({
      editor: v,
      format: "png",
      //@ts-ignore
      ids: $.length != 0 ? Array.from(v.getShapeAndDescendantIds([$[0].id]).values()) : v == null ? void 0 : v.getCurrentPageShapeIds()
    }).then((X) => {
      R(X);
    });
  };
  return ze(
    () => {
      if (!v || C) return;
      if (v.updateInstanceState({
        isGridMode: !1,
        exportBackground: !0
      }), v.user.updateUserPreferences({
        isSnapMode: !0,
        isWrapMode: !0
      }), z(() => !0), new URLSearchParams(window.location.search).has("blank") || (!u || !ra || !ra.draw) && (!g || !g.draw)) {
        const X = Ee("grid-root");
        if (o) {
          v.createShape(
            {
              id: X,
              type: "grid",
              props: {
                w: Math.ceil(ge.width / ge.defaultGridSize) * ge.defaultGridSize,
                h: Math.ceil(ge.height / ge.defaultGridSize) * ge.defaultGridSize,
                gridSize: ge.defaultGridSize
              }
            }
          );
          const Ie = Ee("legend-root");
          v.createShape(
            {
              parentId: o ? X : void 0,
              id: Ie,
              type: "legend",
              props: {
                legendSize: {
                  w: 16,
                  h: 16
                },
                legendCount: 1
              }
            }
          );
          const je = v.getShape(Ie), Oe = v.getShape(X);
          if (je && Oe) {
            const zt = v.getShapeGeometry(X), Dt = v.getShapeGeometry(Ie);
            v.updateShape({
              type: "legend",
              id: Ie,
              y: zt.bounds.h - Dt.bounds.h - 10,
              x: zt.bounds.w - Dt.bounds.w - 10
            });
          }
        }
      }
      Fa(v), D(ye);
    },
    [v, C]
  ), /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(
    Jle,
    {
      value: {
        navigatorRef: U,
        menubarRef: H,
        stylePanelRef: Z,
        iconbarRef: te,
        contextMenuRef: oe,
        legendIconRef: me,
        legendIconMenuRef: he,
        topToolbarRef: F
      },
      children: /* @__PURE__ */ l.jsxs(We, { ref: A, style: w, children: [
        /* @__PURE__ */ l.jsxs("div", { className: "app-toolbar tlui-toolbar__tools__list", ref: ve, children: [
          /* @__PURE__ */ l.jsx("div", { ref: U }),
          /* @__PURE__ */ l.jsx(tr, {}),
          /* @__PURE__ */ l.jsx(OA, { ref: H })
        ] }),
        /* @__PURE__ */ l.jsxs("div", { style: { flexGrow: 1, display: "flex", flexDirection: "row" }, className: ie ? "tlui-layout__mobile" : "", children: [
          /* @__PURE__ */ l.jsx(OA, { children: /* @__PURE__ */ l.jsx(
            Hle,
            {
              licenseKey: "tldraw-formitize-2024-11-05/WyJwTWpCN0NDTyIsWyIqLmZvcm1pdGl6ZS5jb20iXSwyLCIyMDI0LTExLTA1Il0.mkyL0Xi1iN20dTp51ca2PHqHLE2BSzp5sB1IGoUKUEi5mi8gAQJC9fiIbDbmqe+apSpTNXwJiCBjvOgHc6D/8w",
              options: bme,
              onMount: ($) => {
                $ = Rge($), P($), J2.set($);
                const X = new URLSearchParams(window.location.search);
                u && !X.has("blank") && !g && (ra.legend && Zn.set(ra.legend), ra.draw && $.loadSnapshot(ra.draw)), g && (g.legend && Zn.set(g.legend), g.draw && $.loadSnapshot(g.draw)), $.setStyleForNextShapes(Oi, "xl"), $.setStyleForNextShapes($s, "arrow");
              },
              assetUrls: b,
              overrides: {
                actions($, X, Ie) {
                  return X["form-sketch-exit"] = {
                    id: "form-sketch-exit",
                    label: "Exit",
                    readonlyOk: !0,
                    onSelect() {
                      y(T);
                    }
                  }, X["form-sketch-save"] = {
                    id: "form-sketch-save",
                    label: "Save",
                    icon: "save",
                    //@ts-ignore
                    canSave: h,
                    readonlyOk: !0,
                    onSelect() {
                      E(!1), I(ye);
                    }
                  }, X["export-as-svg"] = {
                    id: "export-as-svg",
                    label: {
                      default: "action.export-as-svg",
                      menu: "action.export-as-svg.short",
                      "context-menu": "action.export-as-svg.short"
                    },
                    readonlyOk: !0,
                    onSelect(je) {
                      let Oe = $.getSelectedShapeIds();
                      Oe.length === 0 && (Oe = Array.from($.getCurrentPageShapeIds().values())), Oe.length !== 0 && (Be("export-as", { format: "svg", source: je }), Cme($, ge));
                    }
                  }, X["export-as-png"] = {
                    id: "export-as-png",
                    label: {
                      default: "action.export-as-png",
                      menu: "action.export-as-png.short",
                      "context-menu": "action.export-as-png.short"
                    },
                    readonlyOk: !0,
                    onSelect(je) {
                      let Oe = $.getSelectedShapeIds();
                      Oe.length === 0 && (Oe = Array.from($.getCurrentPageShapeIds().values())), Oe.length !== 0 && (Be("export-as", { format: "png", source: je }), Eme($, ge));
                    }
                  }, X["export-as-json"] = {
                    id: "export-as-json",
                    label: {
                      default: "action.export-as-json",
                      menu: "action.export-as-json.short",
                      "context-menu": "action.export-as-json.short"
                    },
                    readonlyOk: !0,
                    onSelect(je) {
                      let Oe = $.getSelectedShapeIds();
                      Oe.length === 0 && (Oe = Array.from($.getCurrentPageShapeIds().values())), Oe.length !== 0 && (Be("export-as", { format: "json", source: je }), vme($));
                    }
                  }, X;
                },
                translations: b.translations,
                tools($, X, Ie) {
                  return X.eraser = {
                    ...X.eraser,
                    label: "Delete",
                    icon: "bin"
                  }, X.back = {
                    id: "back",
                    icon: "back-arrow",
                    label: "Back",
                    kbd: "",
                    onSelect: () => {
                      $.setCurrentTool("select");
                    }
                  }, X["floor-planner.door-tool"] = {
                    id: "floor-planner.door-tool",
                    icon: "door",
                    label: "Door",
                    kbd: "d",
                    onSelect: () => {
                      $.setCurrentTool("floor-planner.door-tool", {});
                    }
                  }, X["floor-planner.window-tool"] = {
                    id: "floor-planner.window-tool",
                    icon: "window",
                    label: "Window",
                    kbd: "w",
                    onSelect: () => {
                      $.setCurrentTool("floor-planner.window-tool", {});
                    }
                  }, X["floor-planner.wall-tool"] = {
                    id: "floor-planner.wall-tool",
                    icon: "wall",
                    label: "Wall",
                    kbd: "w",
                    onSelect: () => {
                      $.setCurrentTool("floor-planner.wall-tool", {});
                    }
                  }, X["floor-planner.intersect-tool"] = {
                    id: "floor-planner.intersect-tool",
                    icon: "wall-intersect",
                    label: "Intersect Wall",
                    kbd: "s",
                    onSelect: () => {
                      $.setCurrentTool("floor-planner.intersect-tool", {});
                    }
                  }, X["floor-planner.ruler-tool"] = {
                    id: "floor-planner.ruler-tool",
                    icon: "ruler",
                    label: "Measure Wall",
                    kbd: "fr",
                    onSelect: () => {
                      $.setCurrentTool("floor-planner.ruler-tool", {});
                    }
                  }, X["floor-planner.eraser-tool"] = {
                    id: "floor-planner.eraser-tool",
                    icon: "tool-eraser",
                    label: "Erase Wall",
                    kbd: "s",
                    onSelect: () => {
                      $.setCurrentTool("floor-planner.eraser-tool", {});
                    }
                  }, X["eraser-tool"] = {
                    id: "eraser-tool",
                    icon: "tool-eraser",
                    label: "Erase",
                    kbd: "s",
                    onSelect: () => {
                      $.setCurrentTool("eraser-tool", {});
                    }
                  }, X["floor-planner"] = {
                    id: "floor-planner",
                    icon: "tool-floorplanner",
                    label: "Floor Planner",
                    kbd: "c",
                    onSelect: () => {
                      $.setCurrentTool("floor-planner");
                    }
                  }, X["icon-library"] = {
                    id: "icon-library",
                    icon: "icon-library",
                    label: "Icon Library",
                    kbd: "i",
                    onSelect: () => {
                    }
                  }, X["compass-tool"] = {
                    id: "compass-tool",
                    icon: "color",
                    label: "Compass Tool",
                    kbd: "q",
                    onSelect: () => {
                      $.setCurrentTool("compass-tool");
                    }
                  }, X["legend-tool"] = {
                    id: "legend-tool",
                    icon: "icon-library",
                    label: "Icon",
                    kbd: "q",
                    onSelect: () => {
                      var je;
                      $.setCurrentTool("legend-tool"), $.addOpenMenu("menu-icon-bar"), (je = he.current) == null || je.click();
                    }
                  }, X["image-gallery-tool"] = {
                    id: "image-gallery-tool",
                    icon: "image-gallery-icon",
                    label: "Icon",
                    kbd: "q",
                    onSelect: () => {
                      var je;
                      $.setCurrentTool("image-gallery-tool"), $.addOpenMenu("menu-icon-bar"), (je = he.current) == null || je.click();
                    }
                  }, X["door-tool"] = {
                    id: "door-tool",
                    icon: "door",
                    label: "Door Tool",
                    kbd: "d",
                    onSelect: () => {
                      $.setCurrentTool("door-tool");
                    }
                  }, X["window-tool"] = {
                    id: "window-tool",
                    icon: "window",
                    label: "Window Tool",
                    kbd: "w",
                    onSelect: () => {
                      $.setCurrentTool("window-tool");
                    }
                  }, X;
                }
              },
              shapeUtils: [
                p3,
                M3,
                m3,
                I3
              ],
              tools: [
                lg,
                ag,
                cg,
                eg,
                tg
              ],
              components: {
                //ZoomMenu: null,
                //Minimap shows the bottom left minimap for quick-navigation.
                //Minimap: null,
                //ErrorFallback: ErrorFallback,
                MainMenu: Rhe,
                StylePanel: null,
                ShapeIndicators: Lme,
                Handles: yge,
                Handle: mge,
                SelectionForeground: jme,
                InFrontOfTheCanvas: () => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                  /* @__PURE__ */ l.jsx(Zge, {}),
                  /* @__PURE__ */ l.jsx($le, {}),
                  p && /* @__PURE__ */ l.jsx(p, {})
                ] }),
                OnTheCanvas: () => /* @__PURE__ */ l.jsx(l.Fragment, { children: c && /* @__PURE__ */ l.jsx(c, {}) }),
                //NavigationPanel is the bottom left -/+ zoom
                //NavigationPanel: null,
                //Background: myBackground,
                //Grid: myBackground,
                Toolbar: () => /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(
                  che,
                  {
                    canDuplicate: r,
                    canCreatePage: s,
                    showGridOptions: M
                  }
                ) }),
                ContextMenu: null,
                ActionsMenu: null,
                HelpMenu: null,
                QuickActions: null,
                PageMenu: null,
                HelperButtons: null,
                TopPanel: () => {
                  const $ = zue();
                  return /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx("div", { style: { paddingTop: $ ? "40px" : "5px" }, ref: F }) });
                },
                SharePanel: null,
                DebugMenu: null,
                DebugPanel: null
              }
            }
          ) }),
          /* @__PURE__ */ l.jsx("div", { ref: Z }),
          /* @__PURE__ */ l.jsx("div", { ref: oe }),
          O && /* @__PURE__ */ l.jsx("div", { onClick: lt, style: { position: "fixed", zIndex: 9999999999, left: "0", top: "0", width: "100vw", height: "100vh" }, children: /* @__PURE__ */ l.jsx("img", { src: URL.createObjectURL(O), style: {
            width: "100%",
            height: "100%"
          } }) })
        ] })
      ] })
    }
  ) });
}), Lme = () => {
  const t = Q(), e = G("rendering shapes", () => t.getRenderingShapes(), [t]), { ShapeIndicator: n } = At();
  return n ? /* @__PURE__ */ l.jsx(l.Fragment, { children: e.map(({ id: i }) => /* @__PURE__ */ l.jsx(n, { shapeId: i, hidden: !0 }, i + "_indicator")) }) : null;
};
async function kme(t, e, n) {
  const i = await t.getSvgString(e != null && e.length ? e : [...t.getCurrentPageShapeIds()], {
    scale: 1,
    background: t.getInstanceState().exportBackground,
    ...n
  });
  if (!i)
    throw new Error("Could not construct SVG.");
  return i;
}
const Ome = ({}) => /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(
  zme,
  {
    displayGrid: !0,
    onSaveInvoked: async (t) => {
      const e = t.getCurrentPage(), n = await t.exportJpeg({
        page: e.id,
        _settings: {
          ignoreGridDimensions: !0
        },
        quality: 0.92
      });
      var i = URL.createObjectURL(n), r = document.createElement("a");
      r.href = i, r.download = "image.jpg", r.click(), window.URL.revokeObjectURL(i);
    },
    useDebugJson: !0,
    canExport: !0,
    canExit: !1,
    canSave: !0,
    onMount: (t) => {
    }
  }
) });
process.env.NODE_ENV == "development" && document.getElementById("root") && yl.createRoot(document.getElementById("root")).render(
  /* @__PURE__ */ l.jsx(Ye.StrictMode, { children: /* @__PURE__ */ l.jsx(Ome, {}) })
);
export {
  zme as F,
  fpe as a
};
